/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

const RFSettingDefault = {
    //RFSettingDefault start
    form_success_notification : 'Created wholesaler successfully',
    sent_email_success_notification: 'We have sent an email to {email}, please click on the included link to verify your email address',
    form_edit_success_notification: 'Edited wholesaler successfully',
    form_fail_notification: 'Created wholesaler failed',
    form_edit_fail_notification: 'Edited wholesaler failed',
    vat_valid: 'VALID VAT NUMBER',
    vat_not_valid :'EU VAT is not valid. Please re-enter',
    customer_exist : 'Customer email already exists',
    password_too_short : 'Password is too short (minimum is 5 characters)',
    required_field : 'This field is required',
    email_format : 'Must be email format',
    email_contain_invalid_domain : 'Email contains an invalid domain name',
    error_created_account_on_shopify : 'Error when creating account on Shopify',
    loadingForm : 'Loading...',
    phone_is_invalid : 'Phone is invalid',
    email_is_invalid : 'Email is invalid',
    complete_reCapcha_task : 'Please complete reCAPTCHA task',
    complete_privacy_policy : 'Please accept the privacy policy',
    abn_valid : 'This ABN is registered to',
    abn_not_valid : 'ABN is not valid. Please re-enter',
    gst_valid : 'VALID India GST NUMBER',
    gst_not_valid : 'India GST number is not valid. Please re-enter',
    uk_valid : 'VALID UK VAT NUMBER',
    uk_not_valid : 'UK VAT number is not valid. Please re-enter',
    us_ein_valid : 'VALID US EIN NUMBER',
    us_ein_not_valid : 'US EIN number is not valid. Please re-enter',
    text_color_success : '#008000',
    text_color_failed : '#ff0000',
    // RFSettingDefault end
    country_invalid: 'Country is not valid. Please choose country again',
    file_size: 'The following file couldn’t be uploaded: file_name is more than 10mb',
    file_type: 'The following file couldn’t be uploaded: file_name is not supported',
    file_required: 'The following file couldn’t be blank',
    upload_file_to_server: 'Can not upload file to server',
    greater_than: 'This field must be greater than min.',
    less_than: 'This field must be less than max.',
    between: 'This field must be between min and max.',
    confirm_password: 'Passwords do not match!'
};

const status = Object.freeze({
    VAT_NOT_VALID : 'vat_not_valid',
    ABN_NOT_VALID: 'abn_not_valid',
    ABN_VALID: 'abn_valid',
    GST_NOT_VALID: 'gst_not_valid',
    UK_NOT_VALID: 'uk_not_valid',
    US_EIN_NOT_VALID: 'us_ein_not_valid',
    US_EIN_VALID: 'us_ein_valid',
    FILE_NOT_VALID: 'file_not_valid',
    REQUIRED :'required',
    SUCCESS : 'success',
    FAILED : 'failed',
    LOADING : 'loading',
    NUMBER_IS_GREATER_THAN: 'greater_than',
    NUMBER_IS_LESS_THAN: 'less_than',
    NUMBER_IS_BETWEEN: 'between'
});

const FILT_TYPE = ['text/csv', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
'image/gif', 'image/jpeg', 'image/png', 'application/pdf', 'audio/wav', 
'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
'application/zip', 'video/mp4', 'text/plain', 'application/x-zip-compressed']

const checkRFGeneralSettings = key => {
    if (BSS_B2B.storeId === 15246 && key === 'Number already exists') {
        return 'Number already exists';
    }
    if (BSS_B2B.storeId === 14842) {
        if (key === "Confirm password must match the Password field" || key === "6文字以上で入力してください。" || key === "Confirm email must match the Email address" || key === "Must be in katakana style!"
            || key === "Must be 13 digit number!" || key === "PostCode can be seven number (1234567) or three number + '-' + four number (123-4567)!") {
            return key;
        }
    }
    if (BSS_B2B.storeId === 15546) RFSettingDefault["file_required"] = 'Please complete the form';
    if (BSS_B2B.integrate && BSS_B2B.integrate.langShop && BSS_B2B.integrate.langShop.rfTranslations) {
        const rfTranslations = BSS_B2B.integrate.langShop.rfTranslations;
        const rfTranslationsExist = (typeof rfTranslations === 'object' &&
                                    Object.keys(rfTranslations).length > 0 &&
                                    Object.hasOwn(rfTranslations, key));
        if (rfTranslationsExist) {
            return BSS_B2B.integrate.langShop.rfTranslations[key];
        }
    } else if (BSS_B2B.rfGeneralSettings && BSS_B2B.rfGeneralSettings[key] && BSS_B2B.rfGeneralSettings[key] !== '') {
        return BSS_B2B.rfGeneralSettings[key];
    } else {
        return RFSettingDefault[key];
    }
}

const iconEye = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16"> <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/> <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/> </svg>'
const iconEyeSlash = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16"> <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/> <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/> <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/> </svg>'

module.exports = {
    /**
     * Get HTMLElement RF message translation setting
     * @param {string} key
     * @param {string} statusMessage
     * @param {string} fileName - This is a optional params when RF has a file_field or number_field
     * @param {(string | Object)} responseMessage - This is a optional params
     * @returns {HTMLElement}
     */
    getMessageRFSetting: function(key, statusMessage, fileName, responseMessage) {
        const textColorSuccess = BSS_B2B.rfGeneralSettings.text_color_success
            ? BSS_B2B.rfGeneralSettings.text_color_success
            : RFSettingDefault.text_color_success

        const textColorFail = BSS_B2B.rfGeneralSettings.text_color_failed
            ? BSS_B2B.rfGeneralSettings.text_color_failed
            : RFSettingDefault.text_color_failed

        const message = responseMessage ? responseMessage : checkRFGeneralSettings(key);

        let messageElement = '';
        switch (statusMessage) {
            case status.VAT_NOT_VALID :
                messageElement = `
                <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                    <span class="bss-b2b-translation-rf-vat_not_valid">${message}</span>
                </p>`;
                break;
            case status.ABN_NOT_VALID :
                messageElement = `
                <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                    <span class="bss-b2b-translation-rf-abn_not_valid">${message}</span>
                </p>`;
                break;
            case status.ABN_VALID:
                messageElement = `
                <p class="bss-success-msg" style="color: ${textColorSuccess}!important;font-size: 1.4rem;text-align: center;">
                    <span id="bss-abn-status" style="background-color: ${responseMessage.status ? '#43c358' : '#b9b7b7'}"></span>
                    ${responseMessage.status ? 'Active' : 'Cancelled'} - ${responseMessage.message}
                    ${responseMessage.name}
                </p>`
                break;
            case status.GST_NOT_VALID :
                messageElement = `
                <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                    <span class="bss-b2b-translation-rf-gst_not_valid">${message}</span>
                </p>`;
                break;
            case status.UK_NOT_VALID :
                messageElement = `
                <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                    <span class="bss-b2b-translation-rf-uk_not_valid">${message}</span>
                </p>`;
                break;
            case status.US_EIN_NOT_VALID :
                messageElement = `
                <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                    <span class="bss-b2b-translation-rf-us_ein_not_valid">${message}</span>
                </p>`;
                break;
            case status.US_EIN_VALID :
                messageElement = `
                <p class="bss-success-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorSuccess}!important;">
                    <span class="bss-b2b-translation-rf-us_ein_not_valid">${checkRFGeneralSettings(key)} (${responseMessage.data.company})</span>
                </p>`;
                break;
            case status.REQUIRED :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-translation-rf-required_field">${message}</span>
                    </p>`;
                break;
            case status.FAILED :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-failed">${message}</span>
                    </p>`;
                break;
            case status.SUCCESS :
                messageElement = `
                    <p class="bss-success-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorSuccess}!important;">
                        <span>${message}</span>
                    </p>`;
                break;
            case status.LOADING :
                messageElement = `
                    <p class="bss-loading-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorSuccess}!important;">
                        <span class="bss-b2b-translation-rf-loadingForm">${message}</span>
                    </p>`;
                break;
            case status.FILE_NOT_VALID :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-file-invalid">${message.replace('file_name', fileName)}</span>
                    </p>`;
                break;
            case status.NUMBER_IS_GREATER_THAN :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-number-field-invalid">${message.replace('min', fileName)}</span>
                    </p>`;
                break;
            case status.NUMBER_IS_LESS_THAN :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-number-field-invalid">${message.replace('max', fileName)}</span>
                    </p>`;
                break;
            case status.NUMBER_IS_BETWEEN :
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span class="bss-b2b-number-field-invalid">${message.replace('min', fileName.min).replace('max', fileName.max)}</span>
                    </p>`;
                break;
            default: 
                messageElement = `
                    <p class="bss-error-msg" style="text-align: center;font-size: 1.4rem;color: ${textColorFail}!important;">
                        <span>Invalid Field</span>
                    </p>`;
                break;
        }
        return messageElement;
    },

    rfCssStyles: function() {
        let styles = `
            #state-field, label[for='state-field'] {
                display: none;
            }
            .state-field-show {
                display: block !important;
            }
            .password-field {
                display: flex;
                position: relative!important;
            }
            .RegisterForm-password.password-field {
                flex-direction: column;
            }
            .password-field input {
                padding-right: 32px!important
            }
            .icon-show-hide-password {
                display: flex;
                align-items: center;
                cursor: pointer;
                position: absolute;
                padding-right: 10px;
                right: 0;
            }
            .icon-show-hide-password {
                height: 100%;
            }
            .RegisterForm-password::after, .RegisterForm-password::before  {
                display:none;
            }
            #RegisterForm input:not([type="checkbox"]):not([type="radio"]) {
                background-color: rgb(var(--color-background));
                color: rgb(var(--color-foreground));
                width: 100%;
                margin-bottom: 16px!important;
            }
            .field > input {
                margin-bottom: 0px!important;
            }
            .bss-b2b-rf-conditional-logic-hide {
                display: none !important;
            }
            label[for='accepts-marketing-0'] {
                display: none
            }
            .formbuilder-checkbox-group.form-group.field-accepts-marketing {
                display: flex
            }
            .formbuilder-checkbox-group.form-group.field-accepts-marketing .checkbox-group {
                order: -1;
                margin-top: 6px;
                margin-right: 2px;
            }
            input.form-control.accepts-marketing-field {
                height: auto;
                width: auto;
            }
        `;

        let rfStyles = document.createElement("style");
        rfStyles.type = "text/css";
        rfStyles.id = "bss-b2b-rf-country-styles"
        rfStyles.innerText = styles;
        document.head.appendChild(rfStyles);
    },

    getStatusMessage: function() {
        return status
    },

    getKeyRFSettingObject: function() {
        let listKeyRFSetting = { ...RFSettingDefault };
        for (const key in listKeyRFSetting) {
            listKeyRFSetting[key] = key;
        }
        return listKeyRFSetting;
    },

    removeAllMessage: function($, form) {
        const allMessageSelector = ['.bss-error-msg', '#bss-error-msg', '.bss-success-msg', '.reCAPCHA-err', '.bss-loading-msg'];
        if (form) {
            $(form).find(allMessageSelector.join(',')).remove();
        } else {
            $(allMessageSelector.join(',')).remove();
        }

    },

    getFileTypes: function() {
        return FILT_TYPE;
    },

    /**
     * Display message after validate
     * @param {Array} keysValidateField
     * @param {Array} keysValidateVat
     * @param {HTMLElement} submitBtn
     * @param {HTMLElement} form
     */
    displayValidateMessage: function(keysValidateField, keysValidateVat, submitBtn, form) {
        if(keysValidateField.length) {
            keysValidateField.map(key => {
                if (key.includes('checkbox-group-') || key === 'accepts-marketing') {
                    const parentElement =  $(form).find(`label[for="${key}"]`).parent();
                    parentElement.after(BSS_B2B.RF.validateFieldMessages.get(key));
                } else {
                    let parentElement = '';
                    //eslint-disable-next-line
                    if ($(form).find(`input[name="${key.replace(/[\[\]]/g, '\\$&')}"]`).length) {
                        // has mini form
                        // eslint-disable-next-line
                        parentElement = $(form).find(`input[name="${key.replace(/[\[\]]/g, '\\$&')}"]`).parent();
                    } else {
                        // no mini form
                        parentElement = $(form).find(`#${key}`).parent();
                        if (BSS_B2B.storeId === 14842 && key === "RegisterForm-password") {
                            parentElement = $(form).find(`#${key}`).parent().parent();
                        }
                    }
                    parentElement.after(BSS_B2B.RF.validateFieldMessages.get(key));
                }
            });
        }

        if(keysValidateVat.length) {
            keysValidateVat.map(v => $(form).find(`${v}`).parent().after(BSS_B2B.RF.validateVATMessages.get(v)));
        }

        if($(submitBtn).attr("disabled")) {
            submitBtn.removeAttr('disabled', 'disabled');
        }
    },

    /**
     * Set invalid message
     * @param {*} $ 
     * @param {string} idSelector 
     * @param {HTMLElement} required_element 
     * @param {HTMLElement} form - using display on theme has mini form
     */
    setValidateMessage: function($, idSelector, required_element, form) {
        let value = $(form).find(`#${idSelector}`).val();
        if (idSelector === 'country-field') {
            if (!value) {
                BSS_B2B.RF.validateFieldMessages.delete(idSelector);
                BSS_B2B.RF.validateFieldMessages.delete("country-field-input");
                BSS_B2B.RF.validateFieldMessages.set(idSelector, required_element);
            }
        } else if (idSelector.includes('checkbox-group-')) {
            const containerCheckboxGroup = $(form).find(`label[for="${idSelector}"]`).parent();
            const countChecked = containerCheckboxGroup.find('input:checked').length;
            if (!countChecked) {
                BSS_B2B.RF.validateFieldMessages.set(idSelector, required_element);
            } else {
                BSS_B2B.RF.validateFieldMessages.delete(idSelector);
            }
        } else if (idSelector === 'accepts-marketing') {
            const isChecked = $(form).find(`input[class*="${idSelector}"]`).is(":checked");;
            if (!isChecked) {
                BSS_B2B.RF.validateFieldMessages.set(idSelector, required_element);
            } else {
                BSS_B2B.RF.validateFieldMessages.delete(idSelector);
            }
        } else if (value !== '') {
            BSS_B2B.RF.validateFieldMessages.delete(idSelector);
        } else {
            BSS_B2B.RF.validateFieldMessages.set(idSelector, required_element);
        }
    },

    renderIconTogglePassword: function($) {
        const inputPasswordElements = $("#bss-b2b-registration-form-render, .bss-b2b-registration-form-render").closest("form").find('input[type="password"]');
        let passwordFields = inputPasswordElements.parent();
        const iconShowHidePassword = $('<div>').addClass('icon-show-hide-password');
        const toggleIcon = $(iconEye);

        // const firstNameLabel = [
        //     'label[for="RegisterForm-FirstName"]',
        //     'label[for="customer[first_name]"]'
        // ];
        // const emailLabel = [
        //     'label[for="RegisterForm-email"]',
        //     'label[for="customer[email]"]'
        // ];
        // const passwordLabel = [
        //     'label[for="RegisterForm-password"]',
        //     'label[for="customer[password]"]'
        // ];
        // const required_star_element = `<span class="required_star" style="color: #c10000">*</span>`;
        
        // $(firstNameLabel.join(',')).append(required_star_element);
        // $(emailLabel.join(',')).append(required_star_element);
        // $(passwordLabel.join(',')).append(required_star_element);

        if (passwordFields.length === 0) {
            passwordFields = $("<div>");
            inputPasswordElements.wrap(passwordFields);
            passwordFields = inputPasswordElements.parent();
            iconShowHidePassword.css("padding-bottom","16px");
        }
        passwordFields.each((index, element) => {
            const passwordField = $(element);
            const inputPasswordElement = passwordField.find('input[type="password"]');
            passwordField.addClass("password-field");
            iconShowHidePassword.appendTo(passwordField);
            toggleIcon.appendTo(iconShowHidePassword);
            if (passwordField.hasClass("RegisterForm-password") || passwordField.hasClass("customer[password]")) {
                const passwordContainer = $("<div class='password-container'></div>");
                passwordContainer.append(inputPasswordElement);
                passwordContainer.append(iconShowHidePassword);
                passwordField.find("label").after(passwordContainer);
                passwordContainer.css({"position":"relative", "display": "flex", "flex-direction": "column" });
                iconShowHidePassword.css("padding-bottom","16px");
            }
            toggleIcon.click(function() {
                if (inputPasswordElement.attr("type") === "password") {
                    inputPasswordElement.attr("type", "text");
                    toggleIcon.html(iconEyeSlash);
                } else {
                    inputPasswordElement.attr("type", "password");
                    toggleIcon.html(iconEye);
                }
            });
        });
       
       
       
    },

    /**
     * Sent api update customer by domain
     * @param {*} $ 
     * @param {string} domain 
     * @param {Object} data 
     * @param {HTMLElement} submitBtn 
     * @param {Object} keyRFSettingObject 
     * @param {Object} statusMessage 
     */
    updateWholesalerRegistration: function($, domain, data, submitBtn, keyRFSettingObject, statusMessage) {
        $.ajax({
            type: "PUT",
            url: `${bssB2bApiServer}/wholesaler/registration/update?domain=${domain}`,
            dataType: 'JSON',
            data: data,
            success: function (result) {
                module.exports.removeAllMessage($);
                submitBtn.removeAttr('disabled');
                if (result.success) {
                    const form_edit_success_notification_element = module.exports.getMessageRFSetting(keyRFSettingObject.form_edit_success_notification, statusMessage.SUCCESS, '', result.message);
                    $('form[action*="/account"]').prepend(form_edit_success_notification_element);
                    window.location.href = window.location.origin + "/account";
                } else {
                    const form_edit_fail_notification_element = module.exports.getMessageRFSetting(keyRFSettingObject.form_edit_fail_notification, statusMessage.FAILED, '', result.message);
                    $('form[action*="/account"]').prepend(form_edit_fail_notification_element);
                    BSS_B2B.integrate.langShop.handleAllTranslation('rf', ['phone_is_invalid', 'error_created_account_on_shopify', 'form_edit_fail_notification']);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                module.exports.removeAllMessage($);
                const form_edit_fail_notification_element = module.exports.getMessageRFSetting(keyRFSettingObject.form_edit_fail_notification, statusMessage.FAILED, '', errorThrown);
                $('form[action*="/account"]').prepend(form_edit_fail_notification_element);
            }
        });
    },

    /**
     * Sent api create customer by domain
     * @param {*} $ 
     * @param {string} domain 
     * @param {Object} data 
     * @param {HTMLElement} submitBtn 
     * @param {Object} keyRFSettingObject 
     * @param {Object} statusMessage 
     */
    createWholesalerRegistration: function($, domain, data, submitBtn, keyRFSettingObject, statusMessage) {
        const isCreateAccountOnBoth = BSS_B2B.created_account === 1 ? true : false;
        $.ajax({
            type: "POST",
            url: `${bssB2bApiServer}/wholesaler/registration/${(BSS_B2B.created_account !== 1 ? 'b2b' : 'b2b-and-shopify')}?domain=${domain}`,
            dataType: 'JSON',
            data: data,
            success: function (result) {
                module.exports.removeAllMessage($);
                submitBtn.removeAttr('disabled');
                sessionStorage.removeItem("verifyCaptcha");
                if (result.success) {
                    const form_success_notification_element = module.exports.getMessageRFSetting(keyRFSettingObject.form_success_notification, statusMessage.SUCCESS, '', result.message);
                    let form = $('form[action*="/account"]');
                    if(BSS_B2B.storeId === 13145){
                        form.append(form_success_notification_element);
                    } else if (BSS_B2B.storeId !== 9726) {
                        form.prepend(form_success_notification_element);
                    }
                    let successMessageTimeout = 0;
                    if ([3369].includes(BSS_B2B.storeId)) {
                        BSS_B2B.customize.rf.handleCustomRF();
                        successMessageTimeout = 5000;
                    }
                    if ([9726].includes(BSS_B2B.storeId)) {
                        successMessageTimeout = 2000;
                    }
                    setTimeout(function () {
                        if (BSS_B2B.created_account === 1) {
                            window.localStorage.setItem('bssEmail', BSS_B2B.RF.data.wholesaler.email);
                            if (BSS_B2B.storeId === 5892) {
                                window.location.href = 'https://mydiysupplies.com/' + BSS_B2B.redirect_url;
                            } else if ([8184, 9849, 7207, 8927, 11143, 12079, 13614, 14319, 14320, 14387, 14378, 14244, 14392, 3879, 15123, 15071, 15117, 6699, 15776].includes(BSS_B2B.storeId)) {
                                window.location.href = BSS_B2B.redirect_url;
                            } else if (BSS_B2B.storeId === 8841) {
                                let countCart = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
                                let BSS_redirect_url = sessionStorage.getItem('BSS_redirect_url');
                                if (countCart && countCart.textContent && parseInt(countCart.textContent) && BSS_redirect_url) {
                                    window.location.href = BSS_redirect_url;
                                } else {
                                    window.location.href = window.location.origin + '/account/login';
                                }
                            } else if (BSS_B2B.storeId === 14081) {
                                window.location.href = window.location.origin + '/collections/wholesale';
                            } else if ([10829, 5437].includes(BSS_B2B.storeId)) {
                                window.BSS_B2B.executeAction({tag: `login_after_registration`, storeId: 5437, rfData: BSS_B2B.RF.data.wholesaler, redirectUrl: BSS_B2B.redirect_url});
                                window.BSS_B2B.executeAction({tag: `login_after_registration`, storeId: 10829, rfData: BSS_B2B.RF.data.wholesaler, redirectUrl: BSS_B2B.redirect_url});
                            } else {
                                window.location.href = window.location.origin + '/account/login' + '?return_url=' + encodeURI(BSS_B2B.redirect_url) + '&&isBssLogin=true';
                            }
                        } else {
                            // fix for miamata by ThaBi
                            if (BSS_B2B.storeId === 1023 && BSS_B2B.created_account === 3) {
                                let pathnameRedirect = BSS_B2B.redirect_url.includes("/thank-you-page") ? "/thankyoupage" : BSS_B2B.redirect_url;
                                window.location.href = 'https://miamata.it' + pathnameRedirect;
                            } else if (BSS_B2B.storeId === 7440 && BSS_B2B.created_account === 3) {
                                window.location.href = 'https://ens-nutrition-3419.myshopify.com/' + BSS_B2B.redirect_url;
                            } else if ((BSS_B2B.storeId === 2629 || BSS_B2B.storeId === 1123) && BSS_B2B.created_account === 0) {
                                let domain = window.location.origin;
                                if (window.location.pathname.split('/').length > 3) {
                                    domain = window.location.origin + '/' + window.location.pathname.split('/')[1];
                                }
                                window.location.href = domain + BSS_B2B.redirect_url;
                            } else if ( BSS_B2B.storeId === 12158 &&  window.location.pathname === BSS_B2B.redirect_url) {
                                const headerCustomPage = document.querySelector(".section-header.text-center");
                                if(headerCustomPage) {
                                    setTimeout(()=>{
                                        window.scroll({
                                            behavior: 'smooth',
                                            left: 0,
                                            top: headerCustomPage.offsetTop - 100
                                        });
                                    }, 500);
                                }   
                                const form = document.getElementById("RegisterForm");
                                if(form) {
                                    form.reset();
                                }
                            } else {
                                window.location.href = window.location.origin + BSS_B2B.redirect_url;
                            }
                        }
                    }, successMessageTimeout);
                } else {
                    const form_fail_notification_element = module.exports.getMessageRFSetting(keyRFSettingObject.form_fail_notification, statusMessage.FAILED);
                    const formSelectorDefault = ['form[action*="/account"]'];
                    const formSelectorCustomize = [
                        // BSS_B2B.storeId === 6579
                        '.account-page-content form[action*="/contact#contact_form"]',
                        // BSS_B2B.storeId === 6747
                        'form[action*="/account"]#RegisterForm'
                    ]
                    const formSelector = formSelectorDefault.concat(formSelectorCustomize).join(",");
                    if (isCreateAccountOnBoth) {
                        //form auto approved
                        const keyRFSetting = null;
                        const response_message = module.exports.getMessageRFSetting(keyRFSetting, status.FAILED, '', result.message)
                        $(formSelector).prepend(response_message);
                    } else {
                        //form manual approved
                        $(formSelector).prepend(form_fail_notification_element);
                    }
                    BSS_B2B.integrate.langShop.handleAllTranslation(
                        'rf', ['password_too_short', 'customer_exist', 'form_fail_notification', 'email_contain_invalid_domain', 'email_is_invalid', 'phone_is_invalid', 'country_not_valid', 'error_created_account_on_shopify']
                    );
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                // eslint-disable-next-line no-console
                console.log("Could not create registration from in function initRegistrationForm.BSS_B2B.RF.handleSubmitFormDefault:", errorThrown);
                module.exports.removeAllMessage($);
                submitBtn.removeAttr('disabled');
                const error_element = module.exports.getMessageRFSetting(keyRFSettingObject.error_created_account_on_shopify, statusMessage.FAILED, '', errorThrown);
                $('form[action*="/account"]').prepend(error_element);
            }
        });
    },

    validationAllFieldBeforeSubmitForm: async function ($, form, isMiniForm) {
        const keyRFSettingObject = module.exports.getKeyRFSettingObject();
        const statusMessage = module.exports.getStatusMessage();
        const required_element = module.exports.getMessageRFSetting(keyRFSettingObject.required_field, statusMessage.REQUIRED);
        let disabledField = $(form).find(':input:disabled').removeAttr('disabled');
        let inputArr = $(form).serializeArray();
        let indexCountryField = 0;
        for (let i = 0; i < inputArr.length; i++) {
            if (inputArr[i].name === 'country-field') {
                indexCountryField = i;
                break;
            }
        }
        if (typeof bssB2BArrayCountry !== 'undefined') {
            for (let i = 0; i < bssB2BArrayCountry.length; i++) {
                if (inputArr[indexCountryField].value === bssB2BArrayCountry[i].label) {
                    inputArr[indexCountryField].value = bssB2BArrayCountry[i].value;
                    break;
                }
            }
        }
        disabledField.attr('disabled', 'disabled');
        let checkboxFields = isMiniForm ? BSS_B2B.RF.getAllCheckBoxField(form) : BSS_B2B.RF.getAllCheckBoxField();

        if ([13637].includes(BSS_B2B.storeId) && window.location.href.includes("/pages/registratie")) {
            const result = window.BSS_B2B.executeFilter({tag: "check_password_confirm", storeId: 13637, val: true, inputArr});
            if (!result.success) {
                const confirm_password_element = module.exports.getMessageRFSetting(keyRFSettingObject.confirm_password, statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(result.idElement, confirm_password_element)
            }
        }
        if ([14842].includes(BSS_B2B.storeId) && window.location.href.includes("/pages/register")) {
            //password
            const resultPassword = window.BSS_B2B.executeFilter({ tag: "check_password_confirm", storeId: 14842, val: true, inputArr });
            if (!resultPassword.success) {
                const confirm_password_element = module.exports.getMessageRFSetting("Confirm password must match the Password field", statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(resultPassword.idElement, confirm_password_element)
            }

            //email
            const resultEmail = window.BSS_B2B.executeFilter({ tag: "check_email_confirm", storeId: 14842, val: true, inputArr });
            if (!resultEmail.success) {
                const confirm_email_element = module.exports.getMessageRFSetting("Confirm email must match the Email address", statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(resultEmail.idElement, confirm_email_element)
            }
            //check company name 
            const resultCompanyName = window.BSS_B2B.executeFilter({ tag: "check_company_name", storeId: 14842, val: true });
            if (!resultCompanyName.success) {
                const confirm_company_element = module.exports.getMessageRFSetting("Must be in katakana style!", statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(resultCompanyName.idElement, confirm_company_element)
            }
            //check postcode number
            const resultPostCode = window.BSS_B2B.executeFilter({ tag: "check_post_code", storeId: 14842, val: true });
            if (!resultPostCode.success) {
                const confirm_postcode_element = module.exports.getMessageRFSetting("PostCode can be seven number (1234567) or three number + '-' + four number (123-4567)!", statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(resultPostCode.idElement, confirm_postcode_element)
            }
            //check invoice registration number
            const resultInvoiceNumberCode = window.BSS_B2B.executeFilter({ tag: "check_invoice_registration_number", storeId: 14842, val: true });
            if (!resultInvoiceNumberCode.success) {
                const confirm_postcode_element = module.exports.getMessageRFSetting("Must be 13 digit number!", statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(resultInvoiceNumberCode.idElement, confirm_postcode_element)
            }
        }

        // check required field and value of all field before sent request
        if (isMiniForm) {
            BSS_B2B.RF.getRequireField(form);
        } else {
            BSS_B2B.RF.getRequireField();
        }

        if (BSS_B2B.RF.requireFields.includes("country-field") || ($(form).find('.country-field').length !== 0 && !BSS_B2B.RF.requireFields.includes("country-field") && (inputArr[indexCountryField].value !== ""))) {
            if (!($(form).find('.field-country-field').hasClass("bss-b2b-rf-conditional-logic-hide"))) {
                let isValidCountry = (bssB2BArrayCountry.filter((el) => el.value == inputArr[indexCountryField].value));
                if (isValidCountry.length === 0) {
                    const countryInvalidElement = module.exports.getMessageRFSetting(keyRFSettingObject.country_invalid, statusMessage.FAILED);
                    BSS_B2B.RF.validateFieldMessages.set('country-field-input', countryInvalidElement)
                }
            }
        }
        BSS_B2B.RF.requireFields.map(item => module.exports.setValidateMessage($, item, required_element, form));
        let correctInputArr = '';
        if(isMiniForm) {
            correctInputArr = await BSS_B2B.RF.getAllFieldValue(inputArr, checkboxFields, form)
        } else {
            correctInputArr = await BSS_B2B.RF.getAllFieldValue(inputArr, checkboxFields)
        } 
        let fileInputArr = BSS_B2B.RF.getAllFileValue(form);
        // end check

        return {correctInputArr, fileInputArr}
    }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

const taxDisplayRules = __webpack_require__(2);
BSS_B2B.taxDisplay = {};

BSS_B2B.taxDisplay.productPageContainer = '.product__info-container,' +
    //fix for orcaretail by hoaduong
    '.product-main,' +
    //fix for vapemindssuperstorewholesale by CuongNVM
    '.tp-product-content,' +
    '.product-single__meta,' + '.sf-prod__info,' + '.product__page--info,' +
    '.product-actions'
    
module.exports = {
    clientValidateVat: function(vatExemptSelected, vatNumber) {
        let isValidVat = true;
        let rex = /^.+$/; // not empty
        if (vatExemptSelected == 0) {
            rex = /^[A-Za-z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/;
        }
        else if (vatExemptSelected == 4) {
            rex = /^(\d{2}-\d{7})$/; //ex: 41-0417775
        }

        isValidVat = rex.test(vatNumber);
        return isValidVat;
    },

    showProductPriceIncludedVat: function(BSS_B2B, shopData, customPrice = false) {
        if (BSS_B2B && BSS_B2B.shopModules) {
            let bssB2BProductVat = document.querySelectorAll('.bss-b2b-product-vat');

            if (bssB2BProductVat && bssB2BProductVat.length) {
                if (BSS_B2B.storeId === 10270) {
                    bssB2BProductVat = bssB2BProductVat[1];
                }
                else {
                    bssB2BProductVat = bssB2BProductVat[0];
                }
                let bssB2BProductVatClosestForm = bssB2BProductVat.closest('form[action*="/cart/add"]');
                if (BSS_B2B.storeId === 6605) {
                    bssB2BProductVatClosestForm = document.querySelector('.product__info .product-form');
                }
                if (BSS_B2B.storeId === 8736) {
                    bssB2BProductVatClosestForm = bssB2BProductVat.closest('.product-form.theme-init');
                }
                if (BSS_B2B.storeId === 10969) {
                    bssB2BProductVatClosestForm = bssB2BProductVat.closest('.form__wrapper[data-form-wrapper]');
                }
                if (BSS_B2B.storeId === 10104) {
                    bssB2BProductVatClosestForm = document.querySelector('.tt-product-single-info');
                }
                if (BSS_B2B.storeId === 14653) {
                    bssB2BProductVatClosestForm = document.querySelector('safe-sticky.product-info');
                }
                if (BSS_B2B.storeId === 14972) {
                    bssB2BProductVatClosestForm = document.querySelector('.productView-container');
                }
                if (BSS_B2B.storeId === 6895) {
                    bssB2BProductVatClosestForm = document.querySelector('.product-template_wrapper');
                }
                if (BSS_B2B.storeId === 5508) {
                    bssB2BProductVatClosestForm = document.querySelector('form[action*="/cart/add"]');
                }
                if (bssB2BProductVatClosestForm) {
                    let bssLoginToSeePriceEle = bssB2BProductVatClosestForm.querySelectorAll(
                        '.bsscommerce-ltsp-message');
                    let bssLoginToSeePriceWrapperEle = bssB2BProductVatClosestForm.querySelectorAll(
                        '.bss-ltsp-price-wrapper');
                    if ((bssLoginToSeePriceEle && bssLoginToSeePriceEle.length) ||
                        (bssLoginToSeePriceWrapperEle && bssLoginToSeePriceWrapperEle.length)) {
                        // compare with rule type Login to see price of B2B Login/Lock & Hide Price APP
                        let productVatStyles = document.querySelectorAll('#bss-b2b-tax-inc-excl');
                        if (productVatStyles) {
                            productVatStyles.forEach(e => {
                                e.remove();
                            });
                        }
                        return;
                    }
                    else {
                        module.exports.handleVariantChangeEvents(bssB2BProductVatClosestForm, shopData, customPrice);
                        let bssVariantSelector = bssB2BProductVatClosestForm.querySelectorAll(
                            'select, input.single-option-selector__radio, input.product-form__single-selector, .block-swatch');
                        if (bssVariantSelector.length) {
                            bssVariantSelector.forEach(function(item) {
                                item.addEventListener('change', () => {
                                    // No custom price if there is no CP rule
                                    module.exports.handleVariantChangeEvents(bssB2BProductVatClosestForm, shopData, customPrice);
                                });
                                if (BSS_B2B.storeId === 10104) {
                                    setTimeout(() => {
                                        module.exports.showProductPriceIncludedVat(BSS_B2B, shopData);
                                    }, 500)
                                }
                            });
                            if ([2447, 5819, 3849, 5821, 6605, 8125, 13923].indexOf(BSS_B2B.storeId) !== -1) {
                                let changeVariantElement = $(
                                    '.variant-input,' + '.product-form__input>label,' + '.swatch-element,' +
                                    '.select-wrapper,' + '.options-selection__option-value-name,' +
                                    '.swatch-group.variants-selection input[type="radio"],' + '.swatch_pr_item');
                                if (changeVariantElement.length) {
                                    changeVariantElement.on('click', function() {
                                        module.exports.handleVariantChangeEvents(bssB2BProductVatClosestForm, shopData, customPrice);
                                    });
                                }
                            }
                        }
                    }
                }else {
                    let bssB2BProductVatClosestCustom = bssB2BProductVat.closest(
                        BSS_B2B.taxDisplay.productPageContainer);
                    if (bssB2BProductVatClosestCustom) {
                        let bssVariantSelector = bssB2BProductVatClosestCustom.querySelectorAll(
                            'select, input.single-option-selector__radio, input.product-form__single-selector, variant-radios input[type="radio"]');
                        if (bssVariantSelector) {
                            module.exports.handleVariantChangeEvents(bssB2BProductVatClosestCustom, shopData, customPrice);
                            bssVariantSelector.forEach(function(item) {
                                item.addEventListener('change', () => {
                                    // No custom price if there is no CP rule
                                    module.exports.handleVariantChangeEvents(bssB2BProductVatClosestCustom, shopData, customPrice);
                                });
                            });
                        }
                    }
                }
            }
        }
        //fix show tax display product recommend in cart
        if (BSS_B2B.storeId === 9605 && BSS_B2B.page.isCartPage()) {
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
        }
    },

    handleVariantChangeEvents: function(bssB2BProductVatClosestForm, shopData, customPrice) {
        setTimeout(function() {
            // Find input or select or any element that can changed variant id
            let bssVariantInput = bssB2BProductVatClosestForm.querySelector('select[name="id"], input[name="id"], select[data-variant-input], .option-lists');
            if (bssVariantInput) {
                let variantId = bssVariantInput.value;
                if ([6054, 11946].includes(BSS_B2B.storeId)) {
                    variantId = window.location.href.split('=')[1];
                    if (!variantId || (BSS_B2B.storeId === 11946 && variantId && isNaN(variantId))) {
                        variantId = bssVariantInput.value || bssVariantInput.getAttribute('value');
                    }
                }
                module.exports.bssB2BChangeVatPrice(variantId, shopData, customPrice);
            }
        }, 200);
    },

    /**
     * Get tax rate
     * @param collectionList : {string|null} - is the list of collection id of item, separated by comma
     * @returns {number}
     */
    bssB2BGetAppliedTaxRate: function(collectionList) {
        let appliedTax = parseFloat(BSS_B2B.countryTax);
        let changed = false;
        if (collectionList) {
            let collections = collectionList.split(',');
            if (collections.length > 0 &&
                ((BSS_B2B.taxOverridesByCountryCode && BSS_B2B.taxOverridesByCountryCode.length > 0) ||
                    (BSS_B2B.taxOverridesRestOfWorld && BSS_B2B.taxOverridesRestOfWorld.length > 0))) {
                BSS_B2B.taxOverridesByCountryCode.every((taxOverride) => {
                    for (let i = 0; i < collections.length; i++) {
                        let collection = collections[i];
                        if (collection === taxOverride.collection_id) {
                            appliedTax = parseFloat(taxOverride.value / 100);
                            changed = true;
                            return false;
                        }
                    }
                    return true;
                });
                if (!changed) { // check rest of world
                    BSS_B2B.taxOverridesRestOfWorld.every((taxOverride) => {
                        for (let i = 0; i < collections.length; i++) {
                            let collection = collections[i];
                            if (collection === taxOverride.collection_id) {
                                appliedTax = parseFloat(taxOverride.value / 100);
                                return false;
                            }
                        }
                        return true;
                    });
                }
            }
        }
        return appliedTax;
    },

    /**
     * Get tax rate for QB/AB
     * @param keyOrId
     * @returns {*|number|number}
     */
    bssB2BGetAppliedTaxRateForABQB: function(keyOrId, template) {
        let appliedTax = parseFloat(BSS_B2B.countryTax);
        if (keyOrId) {
            let bssB2BItemCollectionList = null;
            let bssB2BItemCollectionListElement = null;
            if (template === 'product') {
                bssB2BItemCollectionListElement = document.querySelector(
                    '.bss-b2b-product-vat[data-product-id="' + keyOrId + '"]');
                if (bssB2BItemCollectionListElement) {
                    bssB2BItemCollectionList = bssB2BItemCollectionListElement.getAttribute('data-product-collections');
                }
            }
            else if (template === 'cart') {
                bssB2BItemCollectionListElement = document.querySelector(
                    '.bss-b2b-cart-vat[data-cart-vat-item-key="' + keyOrId + '"]');
                if (bssB2BItemCollectionListElement) {
                    bssB2BItemCollectionList = bssB2BItemCollectionListElement.getAttribute(
                        'data-cart-item-collections');
                }
            }
            appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
        }
        return appliedTax;
    },

    bssB2BCustomVatPrice: function(
        bssB2BPriceNoVat, bssB2BPriceHasVat, variant, planPriceInfo, appliedTax, shopData, itemTaxable) {
        if (bssB2BPriceNoVat || bssB2BPriceHasVat) {
            let includedVatText = bssB2BPriceHasVat.getAttribute('data-included-vat-text');
            let excludedVatText = bssB2BPriceNoVat.getAttribute('data-excluded-vat-text');
            let priceNoVat = document.createElement('span');
            priceNoVat.className = 'price-no-vat';
            bssB2BPriceNoVat.appendChild(priceNoVat);
            let priceHasVat = document.createElement('span');
            priceHasVat.className = 'price-has-vat';
            bssB2BPriceHasVat.appendChild(priceHasVat);
            let textNoVat = document.createElement('span');
            textNoVat.className = 'text-no-vat';
            bssB2BPriceNoVat.appendChild(textNoVat);
            let textHasVat = document.createElement('span');
            textHasVat.className = 'text-has-vat';
            bssB2BPriceHasVat.appendChild(textHasVat);
            excludedVatText = '<span class="bss-b2b-translation-td-excluded_vat_text">' + '&nbsp;' + excludedVatText +
                '</span>';
            includedVatText = '<span class="bss-b2b-translation-td-included_vat_text">' + '&nbsp;' + includedVatText +
                '</span>';

            if (shopData.taxes_included) {
                if ((variant && variant.taxable) || itemTaxable) {
                    priceNoVat.innerHTML = module.exports.formatMoney(planPriceInfo.price * (1 / (1 + appliedTax)),
                        shopData);
                    textNoVat.innerHTML = excludedVatText;

                    priceHasVat.innerHTML = planPriceInfo.price_formatted;
                    textHasVat.innerHTML = includedVatText;

                }
                else {
                    priceNoVat.innerHTML = planPriceInfo.price_formatted;
                    textNoVat.innerHTML = excludedVatText;

                    priceHasVat.innerHTML = planPriceInfo.price_formatted;
                    textHasVat.innerHTML = includedVatText;
                }
            }
            else {
                if ((variant && variant.taxable) || itemTaxable) {
                    priceNoVat.innerHTML = planPriceInfo.price_formatted;
                    textNoVat.innerHTML = excludedVatText;

                    priceHasVat.innerHTML = module.exports.formatMoney(planPriceInfo.price * (1 + appliedTax),
                        shopData);
                    textHasVat.innerHTML = includedVatText;
                }
                else {
                    priceNoVat.innerHTML = planPriceInfo.price_formatted;
                    textNoVat.innerHTML = excludedVatText;

                    priceHasVat.innerHTML = planPriceInfo.price_formatted;
                    textHasVat.innerHTML = includedVatText;
                }
            }

            BSS_B2B.integrate.langShop.handleAllTranslation('td');
        }
    },
    bssB2BChangeVatPrice: function(variantId, shopData, customPrice, priceJ = false) {
        let appliedDisplayRule = taxDisplayRules.getAppliedRule(BSS_B2B, shopData);
        let includedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.included_vat_text;
        let excludedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.excluded_vat_text;
        let customerTags = (shopData.customer && shopData.customer.tags) ? shopData.customer.tags.map(
            (tag) => tag.toLowerCase()) : [];
        if (BSS_B2B.storeId === 6579 && (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage())) {
            appliedDisplayRule = taxDisplayRules.getAppliedRuleCollectionPage(BSS_B2B, shopData);
        }
        if (BSS_B2B.storeId === 2896) {
            let taxStyles = document.getElementById('bss-b2b-tax-inc-excl');
            if (taxStyles) {
                taxStyles.remove();
            }
        }
        if (typeof bssB2BProduct === 'undefined') {
            if (([2087, 5302].includes(BSS_B2B.storeId) && shopData.quickview)) {
                // skip
            }
            else {
                return;
            }
        }
        if (BSS_B2B.storeId === 7691) {
            includedVat_Text = document.querySelector('[data-included-vat-text]').getAttribute('data-included-vat-text');
        }
        let variant;
        if (BSS_B2B.storeId === 2087 && shopData.quickview) {
            let bssB2BProduct_2087 = JSON.parse(
                document.querySelector('.modal.modal--is-active #bss-b2b-custom-quickview-product').innerText);
            variant = bssB2BProduct_2087.variantIdArrayMap[variantId];
        }
        else if (BSS_B2B.storeId === 5302 && shopData.quickview) {
            let bssB2BProduct_5302 = JSON.parse(
                document.querySelector(`#bss-b2b-custom-quickview-product-${shopData.nowProductId}`).innerText);
            variant = bssB2BProduct_5302.variantIdArrayMap[variantId];
        }
        else if (BSS_B2B.storeId === 3794 && window.location.pathname === '/') {
            let bssB2BProduct_3794 = JSON.parse(document.querySelector('#bss-b2b-custom-feature-product').innerText);
            variant = bssB2BProduct_3794.variantIdArrayMap[variantId];
        }
        else {
            variant = bssB2BProduct.variantIdArrayMap[variantId];
        }
        let planPriceInfo = variant;
        if (planPriceInfo) {
            if (customPrice || parseFloat(customPrice) === 0) {
                planPriceInfo.price_formatted = module.exports.formatMoney(customPrice, shopData);
                planPriceInfo.price = customPrice;
            }

            if([13760].includes(BSS_B2B.storeId)) {
                planPriceInfo.price_formatted = module.exports.formatMoney(planPriceInfo.price, shopData);
            } 
            
            if (BSS_B2B.storeId === 7959) {
                const isChangeFormatPrice = window.BSS_B2B.executeAction({tag: 'customize_td', shopData, isProductDetail: true});
                if (isChangeFormatPrice) {
                    planPriceInfo.price_formatted = module.exports.formatMoney(planPriceInfo.price, shopData);
                }
            }

            let priceElements = document.querySelectorAll(
                '.bss-b2b-product-vat[data-product-id="' + variant.product_id + '"]');
            if (priceJ) {
                if (priceJ.variants && priceJ.variants === undefined) {
                    return;
                }
            }
            for (let priceElement of priceElements) {
                let bssB2BItemCollectionList = priceElement.getAttribute('data-product-collections');
                let bssB2BPriceNoVat = priceElement.querySelector('.bss-b2b-product-vat-price-no-vat');
                let bssB2BPriceHasVat = priceElement.querySelector('.bss-b2b-product-vat-price-has-vat');
                // custom VAT price for folieshoppen by CuongNM
                if (BSS_B2B.storeId === 11501) {
                    if (customerTags.includes('b2b')) {
                        Object.assign(priceElement.style, {
                            display: 'flex', flexDirection: 'column', lineHeight: '30px',
                        });
                        excludedVat_Text = '';
                    }
                    else {
                        Object.assign(priceElement.style, {
                            display: 'flex', flexDirection: 'column-reverse', lineHeight: '30px',
                        });
                        includedVat_Text = '';
                    }
                }
                let includedVatText = '<span class="bss-b2b-translation-td-included_vat_text">' + includedVat_Text +
                    '</span>';
                let excludedVatText = '<span class="bss-b2b-translation-td-excluded_vat_text">' + excludedVat_Text +
                    '</span>';

                if (BSS_B2B.storeId === 3879) {
                    BSS_B2B.shopModules.forEach((e) => {
                        if (e.code == 'mc' && e.status == 1) {
                            priceElement.style.display = 'none';
                        }
                    });
                }
                if (appliedDisplayRule) {
                    switch (appliedDisplayRule.display_price_type) {
                        case 0:
                            break;
                        case 1:
                            bssB2BPriceNoVat.style.display = 'none';
                            break;
                        case 2:
                            bssB2BPriceHasVat.style.display = 'none';
                            excludedVatText = excludedVatText.replace('|', '');
                            break;
                    }

                    let incTextColor = appliedDisplayRule.inc_text_color;
                    let excTextColor = appliedDisplayRule.exc_text_color;
                    bssB2BPriceNoVat.style.color = excTextColor;
                    bssB2BPriceHasVat.style.color = incTextColor;

                    let ratio = appliedDisplayRule.ratio_type;
                    // custom VAT price for folieshoppen by CuongNM
                    if (BSS_B2B.storeId === 11501) {
                        if (customerTags.includes('b2b')) {
                            ratio = 6;
                        }
                        else {
                            ratio = 0;
                        }
                    }
                    let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);

                    bssB2BPriceHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
                    bssB2BPriceNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;
                }
                else {
                    let productVatStyles = document.querySelectorAll('#bss-b2b-tax-inc-excl');
                    if (productVatStyles) {
                        productVatStyles.forEach(e => {
                            e.remove();
                        });
                    }
                    return;
                }

                let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);

                if (BSS_B2B.storeId !== 5010) {
                    if (shopData.taxes_included) {
                        if (variant.taxable) {
                            bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(
                                planPriceInfo.price * (1 / (1 + appliedTax)), shopData) + ' ' + excludedVatText;

                            bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                        }
                        else {
                            bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                            bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                        }
                    }
                    else {
                        if (variant.taxable) {
                            bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                            bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(
                                planPriceInfo.price * (1 + appliedTax), shopData) + ' ' + includedVatText;
                        }
                        else {
                            bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                            bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                        }
                    }
                    //custom compare price VAT for ciaobrow.myshopify.com by quyenpv
                    window.BSS_B2B.executeAction({
                        tag: 'price_all', storeId: 2896, BSS_B2B, priceElement,
                        shopData, appliedDisplayRule, appliedTax,
                        parentClassName: 'bss-b2b-product-compare-price-vat', 
                        productId: variant.product_id
                    });

                    // custom VAT price for folieshoppen by CuongNM
                    if (BSS_B2B.storeId === 11501) {
                        if (customerTags.includes('b2b')) {
                            bssB2BPriceHasVat.innerHTML = '(' + bssB2BPriceHasVat.innerHTML + ')';
                        }
                        else {
                            bssB2BPriceNoVat.innerHTML = '(' + bssB2BPriceNoVat.innerHTML + ')';
                        }
                    }
                    BSS_B2B.integrate.langShop.handleAllTranslation('td');
                }
                else {
                    module.exports.bssB2BCustomVatPrice(bssB2BPriceNoVat, bssB2BPriceHasVat, variant, planPriceInfo,
                        appliedTax, shopData, null);
                }
            }
            if (BSS_B2B.storeId === 14972 && BSS_B2B.page.isProductPage()) {
                document.dispatchEvent(new Event("doneCalcVatPriceOnProductPage"));
            }
        }
    },

    bssB2BChangeVatPriceOnQBABTable: function(keyOrId, price, appliedTaxDisplayRule, taxable, shopData) {
        let bssB2BPriceNoVat = '';
        let bssB2BPriceHasVat = '';
        let combinePrice = '';
        let includedVatText = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.included_vat_text;
        let excludedVatText = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.excluded_vat_text;

        let appliedTax = module.exports.bssB2BGetAppliedTaxRateForABQB(keyOrId, shopData.template);

        let priceNoVat = price * (1 / (1 + appliedTax));
        let priceHasVat = price * (1 + appliedTax);

        if (shopData.taxes_included) {
            if (taxable) {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnQBABTable(priceNoVat, excludedVatText, shopData,
                    'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnQBABTable(price, includedVatText, shopData,
                    'included');
            }
            else {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnQBABTable(price, excludedVatText, shopData,
                    'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnQBABTable(price, includedVatText, shopData,
                    'included');
            }
        }
        else {
            if (taxable) {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnQBABTable(price, excludedVatText, shopData,
                    'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnQBABTable(priceHasVat, includedVatText, shopData,
                    'included');
            }
            else {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnQBABTable(price, excludedVatText, shopData,
                    'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnQBABTable(price, includedVatText, shopData,
                    'included');
            }
        }
        BSS_B2B.integrate.langShop.handleAllTranslation('td');

        switch (appliedTaxDisplayRule.display_price_type) {
            case 0:
                if (BSS_B2B.storeId === 8915) {
                    combinePrice = '<div>' + bssB2BPriceNoVat + '</div>';
                }
                else {
                    combinePrice = '<div>' + bssB2BPriceNoVat + '</div>' + '<div>' + bssB2BPriceHasVat + '</div>';
                }
                break;
            case 1:
                combinePrice = bssB2BPriceHasVat;
                break;
            case 2:
                combinePrice = bssB2BPriceNoVat;
                break;
        }

        return combinePrice;
    },

    bssB2BChangeVatPriceOnABRange: function(keyOrId, amount_from, amount_to, appliedTaxDisplayRule, taxable, shopData) {
        let bssB2BPriceNoVat = '';
        let bssB2BPriceHasVat = '';
        let combinePrice = '';
        let includedVatText = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.included_vat_text;
        let excludedVatText = BSS_B2B.taxDisplayTranslations &&
            BSS_B2B.taxDisplayTranslations.excluded_vat_text.replace('|', '');

        let appliedTax = module.exports.bssB2BGetAppliedTaxRateForABQB(keyOrId, shopData.template);

        let amountFromNoVat = amount_from * (1 / (1 + appliedTax));
        let amountToNoVat = amount_to * (1 / (1 + appliedTax));
        let amountFromHasVat = amount_from * (1 + appliedTax);
        let amountToHasVat = amount_to * (1 + appliedTax);
        if (shopData.taxes_included) {
            if (taxable) {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnABRange(amountFromNoVat, amountToNoVat,
                    excludedVatText, shopData, 'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, includedVatText,
                    shopData, 'included');
            }
            else {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, excludedVatText,
                    shopData, 'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, includedVatText,
                    shopData, 'included');
            }
        }
        else {
            if (taxable) {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, excludedVatText,
                    shopData, 'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnABRange(amountFromHasVat, amountToHasVat,
                    includedVatText, shopData, 'included');
            }
            else {
                bssB2BPriceNoVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, excludedVatText,
                    shopData, 'excluded');
                bssB2BPriceHasVat = module.exports.calculateVatPriceOnABRange(amount_from, amount_to, includedVatText,
                    shopData, 'included');
            }
        }
        BSS_B2B.integrate.langShop.handleAllTranslation('td');

        switch (appliedTaxDisplayRule.display_price_type) {
            case 0:
                combinePrice = '<div>' + bssB2BPriceNoVat + '</div>' + '<div>' + bssB2BPriceHasVat + '</div>';
                break;
            case 1:
                combinePrice = bssB2BPriceHasVat;
                break;
            case 2:
                combinePrice = bssB2BPriceNoVat;
                break;
        }
        return combinePrice;
    },

    bssB2BChangeCollectionItemVatPrice: function (productId, shopData, customPrice, appliedDisplayRule, priceJ = false, variantPriceInfo) {
        if (!appliedDisplayRule) {
            let collectionVatItems = document.querySelectorAll('.bss-b2b-collection-item-vat');
            let collectionVatItemsStyle = document.querySelectorAll('[class^="bss-b2b-collection-item-vat-style"]');
            if (collectionVatItems) {
                collectionVatItems.forEach(e => {
                    e.remove();
                });
            }
            // remove style for each item in collection page if this item was not applied display rule
            if (collectionVatItemsStyle) {
                collectionVatItemsStyle.forEach(e => {
                    e.remove();
                });
            }
            return;
        }
        let priceElement = document.querySelector(
            '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId + '"]');
        if (priceJ) {
            if (priceJ.isFeatured) {
                priceElement = document.querySelector(
                    '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                    '"][data-collection-item-is-featured-product="true"]');
                    
            } else {
                priceElement = document.querySelector(
                    '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                    '"][data-collection-item-is-featured-product="false"]');
            }
        }
        if( appliedDisplayRule.product_condition_type === 1){
            if(appliedDisplayRule.product_ids.indexOf(productId) !== -1){
                module.exports.bssB2BChangePriceWithCP(productId, shopData, customPrice, appliedDisplayRule, priceJ, variantPriceInfo)
            }
            else if(!BSS_B2B.page.isProductPage() && priceElement){
                priceElement.innerHTML = module.exports.formatMoney(customPrice, shopData)
            }
        }else if(appliedDisplayRule.product_condition_type === 0){
            module.exports.bssB2BChangePriceWithCP(productId, shopData, customPrice, appliedDisplayRule, priceJ,variantPriceInfo)
        }
        else {
            let encodeUrl = encodeURI('/search?q=id:' + productId + '&view=bss.b2b');
            $.get(encodeUrl, function(data) {
                let responseProducts = [];
                try {
                    responseProducts = JSON.parse(data);
                    let isAppliedProduct = false;
                    if (appliedDisplayRule.product_condition_type === 2) {
                        let appliedCollection = appliedDisplayRule.product_collections.split(',');
                        responseProducts[0].collections.forEach(collection => {
                            (appliedCollection.indexOf(`${collection}`) !== -1) && (isAppliedProduct = true);
                        });
                    }
                    if(isAppliedProduct){
                        module.exports.bssB2BChangePriceWithCP(productId, shopData, customPrice, appliedDisplayRule, priceJ,variantPriceInfo);
                    }
                    else{
                        priceElement.innerHTML = module.exports.formatMoney(customPrice, shopData);
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('B2B could not parse data: JSON parse returns no item');
                }
            });
        }

    },

    bssB2BChangePriceWithCP: function(productId, shopData, customPrice, appliedDisplayRule, priceJ = false,variantPriceInfo){
        let planPriceInfo = {};
        if (planPriceInfo) {
            let parentSelector = '';
            if (shopData.section && shopData.section === 'featured-product') {
                parentSelector = shopData.parentSelector ? shopData.parentSelector + ' ' : '';
            }
            let priceElements = document.querySelectorAll(
                parentSelector + '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId + '"]');
            if (priceJ) {
                if (priceJ.isFeatured) {
                    priceElements = document.querySelectorAll(
                        '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                        '"][data-collection-item-is-featured-product="true"]');
                    if ( !priceElements.length ) {
                        priceElements = document.querySelectorAll(
                            '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                            '"][data-collection-item-is-featured-product="false"]');
                    }
                } else {
                    priceElements = document.querySelectorAll(
                        '.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                        '"][data-collection-item-is-featured-product="false"]');
                }
            }
            
            if (customPrice || parseFloat(customPrice) === 0) {
                customPrice = parseFloat(customPrice);
                planPriceInfo.price_formatted = module.exports.formatMoney(customPrice, shopData);
                planPriceInfo.price = customPrice;
            }

            let isCustom7959 = false;
            if (BSS_B2B.storeId === 7959) {
                const isChangeFormatPrice = window.BSS_B2B.executeAction({tag: 'customize_td', shopData, isProductDetail: false});
                if (isChangeFormatPrice) {
                    planPriceInfo.price_formatted = module.exports.formatMoney(planPriceInfo.price, shopData);
                    isCustom7959 = isChangeFormatPrice;
                }
            }

            if (priceElements && priceElements.length) {
                priceElements.forEach(priceElement => {
                    priceElement.setAttribute("bss-b2b-cp", "true");
                    if(appliedDisplayRule.apply_to_page === 2 && BSS_B2B.page.isProductPage()){
                        if(priceElement.parentNode.parentNode.tagName === "PRODUCT-INFO"){
                            return;
                        }
                    }
                    let bssB2BItemCollectionList = priceElement.getAttribute('data-collection-item-collections');
                    let bssB2BPriceNoVat = priceElement.querySelector('.bss-b2b-product-vat-price-no-vat');
                    let bssB2BPriceHasVat = priceElement.querySelector('.bss-b2b-product-vat-price-has-vat');
                    let includedVatText = '<span class="bss-b2b-translation-td-included_vat_text">' +
                        bssB2BPriceHasVat.getAttribute('data-included-vat-text') + '</span>';
                    let excludedVatText = '<span class="bss-b2b-translation-td-excluded_vat_text">' +
                        bssB2BPriceNoVat.getAttribute('data-excluded-vat-text') + '</span>';
                    let itemTaxable = priceElement.getAttribute('data-collection-item-variant-taxable');
                    let isFeaturedProduct = priceElement.getAttribute('data-collection-item-is-featured-product');
                    itemTaxable = (itemTaxable === 'true');
                    isFeaturedProduct = (isFeaturedProduct === 'true');
                    if (isFeaturedProduct && shopData.variant) {
                        let bssB2BFeaturedProduct = JSON.parse(
                            priceElement.querySelector('#bss-b2b-product-data').innerText);
                        let variant = bssB2BFeaturedProduct.variantIdArrayMap[shopData.variant];
                        itemTaxable = variant.taxable;
                    }
                    if (appliedDisplayRule) {
                        switch (appliedDisplayRule.display_price_type) {

                            case 0:
                                break;
                            case 1:
                                bssB2BPriceNoVat.style.display = 'none';
                                break;
                            case 2:
                                bssB2BPriceHasVat.style.display = 'none';
                                excludedVatText = excludedVatText.replace('|', '');
                                break;
                        }

                        let incTextColor = appliedDisplayRule.inc_text_color;
                        let excTextColor = appliedDisplayRule.exc_text_color;
                        bssB2BPriceNoVat.style.color = excTextColor;
                        bssB2BPriceHasVat.style.color = incTextColor;

                        let ratio = appliedDisplayRule.ratio_type;
                        let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);

                        bssB2BPriceHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
                        bssB2BPriceNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;
                    }
                    else {
                        let collectionVatItems = document.querySelectorAll('.bss-b2b-collection-item-vat');
                        let collectionVatItemsStyle = document.querySelectorAll(
                            '[class^="bss-b2b-collection-item-vat-style"]');
                        if (collectionVatItems) {
                            collectionVatItems.forEach(e => {
                                e.remove();
                            });
                        }
                        if (collectionVatItemsStyle) {
                            collectionVatItemsStyle.forEach(e => {
                                e.remove();
                            });
                        }
                        return;
                    }
                     // region Loop through each variant to revalue planPriceInfo corresponding with each variant of a product
                     if ( variantPriceInfo && variantPriceInfo.length){
                        let variantCorrespondingProduct = priceElement.getAttribute('data-collection-item-variant-id');
                        variantPriceInfo.forEach((variant) => {
                            if (variant.variantId == variantCorrespondingProduct) {
                                planPriceInfo.price = variant.price;
                                planPriceInfo.price_formatted = module.exports.formatMoney(variant.price, shopData);
                            }
                        })
                        // endregion
                    }

                    if (isCustom7959 && BSS_B2B.storeId === 7959) {
                        excludedVatText = '';
                    }

                    let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
                    if (BSS_B2B.storeId !== 5010) {
                        if (shopData.taxes_included) {
                            if (itemTaxable) {
                                bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(
                                    planPriceInfo.price * (1 / (1 + appliedTax)), shopData) + ' ' + excludedVatText;

                                bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                            }
                            else {
                                bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                                bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                            }
                        }
                        else {
                            if (itemTaxable) {
                                bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                                bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(
                                    planPriceInfo.price * (1 + appliedTax), shopData) + ' ' + includedVatText;
                            }
                            else {
                                bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                                bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                            }
                        }

                        if (BSS_B2B.storeId === 9396) {
                            bssB2BPriceNoVat.innerHTML = 'ab ' + bssB2BPriceNoVat.textContent;
                        }
                        if ([6613].includes(BSS_B2B.storeId) &&
                            (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage())) {
                            let customPriceVat = bssB2BPriceNoVat.innerHTML.split(' ');
                            let firstPart = customPriceVat[0];
                            let secondPart = customPriceVat.slice(1).join(' ');
                            let parts = firstPart.split(',');
                            let mainPricePart = parts[0];
                            let subPricePart = parts[1];
                            let newPrice = '<b>' + mainPricePart + '<sup>' + subPricePart + '</sup></b>';
                            bssB2BPriceNoVat.innerHTML = newPrice + ' ' + secondPart;
                        }
                        BSS_B2B.integrate.langShop.handleAllTranslation('td');
                    }
                    else {
                        module.exports.bssB2BCustomVatPrice(bssB2BPriceNoVat, bssB2BPriceHasVat, null, planPriceInfo,
                            appliedTax, shopData, itemTaxable);
                    }
                });
            }

        }
    },

    bssB2BChangeCollectionItemVatPriceWithoutCP: function(shopData, appliedDisplayRule) {
        let parentSelector = '';
        if (shopData.section && shopData.section === 'featured-product') {
            parentSelector = shopData.parentSelector ? shopData.parentSelector + ' ' : '';
        }
        let priceElements = document.querySelectorAll(
            parentSelector + '.bss-b2b-collection-item-vat:not([bss-b2b-cp="true"])');
        if (shopData.quickview && shopData.storeId && shopData.storeId === 2087) {
            priceElements = document.querySelectorAll('.modal.modal--quick-shop.modal--is-active .bss-b2b-product-vat');
        }
        if (priceElements.length || [13069, 994].includes(BSS_B2B.storeId)) {
            if (!appliedDisplayRule) {
                let collectionVatItems = document.querySelectorAll(".bss-b2b-collection-item-vat, #bss-b2b-cart-vat-style");
                let collectionVatItemsStyle = document.querySelectorAll('[class^="bss-b2b-collection-item-vat-style"]');
                if (collectionVatItems) {
                    collectionVatItems.forEach(e => {
                        e.remove();
                    });
                }
                if (collectionVatItemsStyle) {
                    collectionVatItemsStyle.forEach(e => {
                        e.remove();
                    });
                }

                return;
            }
            priceElements.forEach(priceElement => {
                let productId = priceElement.getAttribute('data-collection-item-id');
                if (appliedDisplayRule.product_condition_type === 1) {
                    if (appliedDisplayRule.product_ids.indexOf(productId) !== -1) {
                        module.exports.bssB2BChangeElementPrice(priceElement, shopData, appliedDisplayRule);
                    }
                    else if (!BSS_B2B.page.isProductPage()) {
                        let customPrice = priceElement.getAttribute('data-collection-item-variant-price');
                        priceElement.innerHTML = module.exports.formatMoney(customPrice, shopData);
                    }
                }
                else if (appliedDisplayRule.product_condition_type === 0) {
                    module.exports.bssB2BChangeElementPrice(priceElement, shopData, appliedDisplayRule);
                }
                else {
                    let encodeUrl = encodeURI('/search?q=id:' + productId + '&view=bss.b2b');
                    $.get(encodeUrl, function(data) {
                        let responseProducts = [];
                        try {
                            responseProducts = JSON.parse(data);
                            let isAppliedProduct = false;
                            if (appliedDisplayRule.product_condition_type === 2) {
                                let appliedCollection = appliedDisplayRule.product_collections.split(',');
                                responseProducts[0].collections.forEach(collection => {
                                    (appliedCollection.indexOf(`${collection}`) !== -1) && (isAppliedProduct = true);
                                });
                            }
                            else if (appliedDisplayRule.product_condition_type === 3) {
                                let appliedTags = appliedDisplayRule.product_tags.split(',');
                                responseProducts[0].tags.forEach(tag => {
                                    (appliedTags.indexOf(`${tag}`) !== -1) && (isAppliedProduct = true);
                                });
                            }
                            if (isAppliedProduct) {
                                module.exports.bssB2BChangeElementPrice(priceElement, shopData, appliedDisplayRule);
                            }
                            else {
                                let customPrice = priceElement.getAttribute('data-collection-item-variant-price');
                                priceElement.innerHTML = module.exports.formatMoney(customPrice, shopData);
                            }
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.log('B2B could not parse data: JSON parse returns no item');
                        }
                    });
                }

                //custom compare price VAT for ciaobrow.myshopify.com by quyenpv
                if (BSS_B2B.storeId === 2896) {
                    let bssB2BItemCollectionList = priceElement.getAttribute('data-product-collections');
                    let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
                    window.BSS_B2B.executeAction({
                        tag: 'price_all', storeId: 2896,
                        BSS_B2B, priceElement, shopData, appliedDisplayRule, appliedTax, 
                        parentClassName: 'bss-b2b-product-compare-price-vat', productId
                    });
                }
            });
        }
    },

    bssB2BChangeElementPrice: function(priceElement, shopData, appliedDisplayRule) {
        if (appliedDisplayRule.apply_to_page === 2 && BSS_B2B.page.isProductPage()) {
            if (priceElement.parentNode.parentNode.tagName === 'PRODUCT-INFO') {
                return;
            }
        }
        let includedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.included_vat_text;
        let excludedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.excluded_vat_text;
        if (BSS_B2B.storeId === 7691) {
            includedVat_Text = document.querySelector('[data-included-vat-text]').getAttribute('data-included-vat-text');
        }
        let bssB2BItemCollectionList = priceElement.getAttribute('data-collection-item-collections');
        let bssB2BPriceNoVat = priceElement.querySelector('.bss-b2b-product-vat-price-no-vat');
        let bssB2BPriceHasVat = priceElement.querySelector('.bss-b2b-product-vat-price-has-vat');
        let includedVatText = '<span class="bss-b2b-translation-td-included_vat_text">' + includedVat_Text + '</span>';
        let excludedVatText = '<span class="bss-b2b-translation-td-excluded_vat_text">' + excludedVat_Text + '</span>';
        let itemTaxable = priceElement.getAttribute('data-collection-item-variant-taxable');
        let customPrice = priceElement.getAttribute('data-collection-item-variant-price');
        let isFeaturedProduct = priceElement.getAttribute('data-collection-item-is-featured-product');
        itemTaxable = (itemTaxable === 'true');
        isFeaturedProduct = (isFeaturedProduct === 'true');
        let customStore = [8125, 8411];
        if (customStore.includes(BSS_B2B.storeId)) {
            let currentVariantPrice;
            let parentPrice = priceElement.closest('.product-varient[productid]');
            if (parentPrice) {
                let currentElement = parentPrice.querySelector('.product-price-custom');
                if (currentElement) {
                    currentVariantPrice = currentElement.getAttribute('variant-price');
                }
                customPrice = currentVariantPrice || customPrice;
            }
        }
        let planPriceInfo = {};
        if (BSS_B2B.storeId === 5284) {
            customPrice = priceElement.parentElement.getAttribute('bss-b2b-customize-product-price-min-5284');
        }
        if (shopData.quickview && shopData.storeId && shopData.storeId === 2087 && !customPrice) {
            customPrice = shopData.product.price;
        }
        if (BSS_B2B.storeId === 5750) {
            let comparePriceCustomize = document.querySelector('[bss-b2b-customize-5750]');
            if (comparePriceCustomize) {
                comparePriceCustomize.remove();
            }
        }
        if (isFeaturedProduct && shopData.variant) {
            let bssB2BFeaturedProduct = JSON.parse(priceElement.querySelector('#bss-b2b-product-data').innerText);
            let variant = bssB2BFeaturedProduct.variantIdArrayMap[shopData.variant];
            customPrice = variant.price;
            itemTaxable = variant.taxable;
        }
        planPriceInfo.price_formatted = module.exports.formatMoney(customPrice, shopData);
        planPriceInfo.price = customPrice;
        if (appliedDisplayRule) {
            switch (appliedDisplayRule.display_price_type) {
                case 0:
                    break;
                case 1:
                    bssB2BPriceNoVat.style.display = 'none';
                    break;
                case 2:
                    bssB2BPriceHasVat.style.display = 'none';
                    excludedVatText = excludedVatText.replace('|', '');
                    break;
            }

            let incTextColor = appliedDisplayRule.inc_text_color;
            let excTextColor = appliedDisplayRule.exc_text_color;
            bssB2BPriceNoVat.style.color = excTextColor;
            bssB2BPriceHasVat.style.color = incTextColor;

            let ratio = appliedDisplayRule.ratio_type;
            let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);

            bssB2BPriceHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
            bssB2BPriceNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;
        }

        if (BSS_B2B.storeId === 7959) {
            const isChangeFormatPrice = BSS_B2B.customize.td.showPriceCustomerTags(BSS_B2B, shopData, false);
            if (isChangeFormatPrice) {
                planPriceInfo.price_formatted = module.exports.formatMoney(planPriceInfo.price, shopData);
                excludedVatText = '';
            }
        }

        let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
        if (BSS_B2B.storeId !== 5010) {
            if (shopData.taxes_included) {
                if (itemTaxable) {
                    bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(
                        planPriceInfo.price * (1 / (1 + appliedTax)), shopData) + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
                else {
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
            }
            else {
                if (itemTaxable) {
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(planPriceInfo.price * (1 + appliedTax),
                        shopData) + ' ' + includedVatText;
                }
                else {
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
            }
            if ([11796, 13755, 14653].includes(BSS_B2B.storeId)) {
                document.dispatchEvent(new Event("doneCalcVatPrice"));
            }
            BSS_B2B.integrate.langShop.handleAllTranslation('td');
        }
        else {
            module.exports.bssB2BCustomVatPrice(bssB2BPriceNoVat, bssB2BPriceHasVat, null, planPriceInfo, appliedTax,
                shopData, itemTaxable);
        }
    },

    bssB2BCartLineItemChangeVatPrice: function(
        cartItemKey, shopData, customPrice, appliedDisplayRule, index, taxableItem = false) {
        let priceWrapperComponent = document.querySelector(
            '.bss-b2b-cart-vat[data-cart-vat-line-item-key="' + cartItemKey + '"]');
        let priceWrapperComponents = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-line-item-key]');
        let priceWrapperComponentAll = document.querySelectorAll(
            '.bss-b2b-cart-vat[data-cart-vat-line-item-key="' + cartItemKey + '"]');
        let isChangeCartItemPrice = true;
        if (priceWrapperComponents && priceWrapperComponents.length) {
            if(BSS_B2B.storeId !== 9629) {
                priceWrapperComponent = priceWrapperComponents[index];
            }
        }
        else if ((!priceWrapperComponents || !priceWrapperComponents.length) &&
            [2896, 8949, 9605, 3879, 10564, 10989, 12292, 10876, 10788, 994, 14730, 14891].includes(BSS_B2B.storeId)
        ) {
            priceWrapperComponent = document.querySelector(
                '.bss-b2b-cart-vat[data-cart-vat-item-key="' + cartItemKey + '"]');
            isChangeCartItemPrice = false;
        }
        if (BSS_B2B.storeId === 14897 && (priceWrapperComponents.length === 0 || priceWrapperComponentAll.length === 0 || !priceWrapperComponent)) {
            priceWrapperComponent = document.querySelector(
                '.bss-b2b-cart-vat[data-cart-vat-item-key="' + cartItemKey + '"]');
            priceWrapperComponents = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-item-key]');
            priceWrapperComponentAll = document.querySelectorAll(
                '.bss-b2b-cart-vat[data-cart-vat-item-key="' + cartItemKey + '"]');
        }
        if (priceWrapperComponentAll.length > 1) {
            priceWrapperComponentAll.forEach(function(element) {
                element.setAttribute('data-cart-variant-taxable', taxableItem);
                module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule, element);
            });
            return module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule,
                priceWrapperComponentAll[0]);
        }
        else {
            if (priceWrapperComponent) {
                priceWrapperComponent.setAttribute('data-cart-variant-taxable', taxableItem);
            }

            return module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule,
                priceWrapperComponent, isChangeCartItemPrice);
        }
    },

    bssB2BCartItemChangeVatPrice: function(
        cartItemKey, shopData, customPrice, appliedDisplayRule, index, taxableItem = false) {
        if (!appliedDisplayRule) {
            let cartVatItems = document.querySelectorAll('.bss-b2b-cart-vat');
            if (cartVatItems) {
                cartVatItems.forEach(e => {
                    e.remove();
                });
            }
            let cartSubtotalVatItems = document.querySelectorAll('.bss-b2b-cart-vat-subtotal');
            if (cartSubtotalVatItems) {
                cartSubtotalVatItems.forEach(e => {
                    e.remove();
                });
            }
            return;
        }

        let priceWrapperComponent = document.querySelector(
            '.bss-b2b-cart-vat[data-cart-vat-item-key="' + cartItemKey + '"]');
        let parentSelector = '';
        if (BSS_B2B.storeId === 4229) parentSelector = '.main-container ';
        if (BSS_B2B.storeId === 10270) parentSelector = '.cart__item ';
        if (BSS_B2B.storeId === 10564) parentSelector = '.cart-order ';
        if (BSS_B2B.storeId === 11499) parentSelector = '#main-cart-items ';
        let priceWrapperComponents = document.querySelectorAll(
            parentSelector + '.bss-b2b-cart-vat[data-cart-vat-item-key]');
        if (priceWrapperComponents && priceWrapperComponents.length) {
            if(BSS_B2B.storeId !== 9629) {
                priceWrapperComponent = priceWrapperComponents[index];
            }
        }

        if (priceWrapperComponent) {
            priceWrapperComponent.setAttribute('data-cart-variant-taxable', taxableItem);
        }

        // fix skippi-ice-pops.myshopify.com for mini cart on cart page by PhuongKD
        if ([13819].includes(BSS_B2B.storeId) !== -1) {
            priceWrapperComponents = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-item-key="' + cartItemKey + '"]');
            priceWrapperComponents.forEach(item =>
                module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule,item)
            )
        } else {
            module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule, priceWrapperComponent);
        }
    },

    bssB2BCartChangePrice: function(priceElement, shopData, planPriceInfo, appliedDisplayRule, isChangeCartItemPrice) {
        let itemNoVat = planPriceInfo.price;
        let itemWithVat = planPriceInfo.price;
        itemWithVat = window.BSS_B2B.executeFilter({tag: 'update_price_per_item', storeId: 13760, val: itemWithVat, price: planPriceInfo.price, isVat: true})
        let includedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.included_vat_text;
        let excludedVat_Text = BSS_B2B.taxDisplayTranslations && BSS_B2B.taxDisplayTranslations.excluded_vat_text;
        if (BSS_B2B.storeId === 7691) {
            includedVat_Text = document.querySelector('[data-included-vat-text]').getAttribute('data-included-vat-text');
        }
        let customerTags = (shopData.customer && shopData.customer.tags) ? shopData.customer.tags.map(
            (tag) => tag.toLowerCase()) : [];
        // custom VAT price for folieshoppen by CuongNM
        if (BSS_B2B.storeId === 11501) {
            if (customerTags.includes('b2b')) {
                Object.assign(priceElement.style, {
                    display: 'flex', flexDirection: 'column', lineHeight: '30px',
                });
                excludedVat_Text = '';
            }
            else {
                Object.assign(priceElement.style, {
                    display: 'flex', flexDirection: 'column-reverse', lineHeight: '30px',
                });
                includedVat_Text = '';
            }
        }
        let bssB2BItemCollectionList = priceElement.getAttribute('data-cart-item-collections');
        let bssB2BPriceNoVat = priceElement.querySelector('.bss-b2b-cart-item-no-vat-price');
        let bssB2BPriceHasVat = priceElement.querySelector('.bss-b2b-cart-item-with-vat-price');
        let includedVatText = '<span class="bss-b2b-translation-td-included_vat_text">' + includedVat_Text + '</span>';
        let excludedVatText = '<span class="bss-b2b-translation-td-excluded_vat_text">' + excludedVat_Text + '</span>';
        let itemTaxable = priceElement.getAttribute('data-cart-variant-taxable');
        itemTaxable = (itemTaxable === 'true');
        if (appliedDisplayRule) {
            switch (appliedDisplayRule.display_price_type) {
                case 0:
                    break;
                case 1:
                    bssB2BPriceNoVat.style.display = 'none';
                    break;
                case 2:
                    bssB2BPriceHasVat.style.display = 'none';
                    excludedVatText = excludedVatText.replace('|', '');
                    break;
            }

            let incTextColor = appliedDisplayRule.inc_text_color;
            let excTextColor = appliedDisplayRule.exc_text_color;
            bssB2BPriceNoVat.style.color = excTextColor;
            bssB2BPriceHasVat.style.color = incTextColor;

            let ratio = appliedDisplayRule.ratio_type;
            // custom VAT price for folieshoppen by CuongNM
            if (BSS_B2B.storeId === 11501) {
                if (customerTags.includes('b2b')) {
                    ratio = 6;
                }
                else {
                    ratio = 0;
                }
            }
            let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);

            bssB2BPriceHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
            bssB2BPriceNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;
        }
        let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
        if (BSS_B2B.storeId !== 5010 && isChangeCartItemPrice) {
            if (shopData.taxes_included) {
                if (itemTaxable) {
                    itemNoVat = planPriceInfo.price * (1 / (1 + appliedTax));
                    itemNoVat = window.BSS_B2B.executeFilter({tag: 'update_price_per_item', storeId: 13760, val: itemNoVat, price: itemNoVat, isVat: true})
                    bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(itemNoVat, shopData) + ' ' +
                        excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
                else {
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
            }
            else {
                if (itemTaxable) {
                    itemWithVat = planPriceInfo.price * (1 + appliedTax);
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(itemWithVat, shopData) + ' ' +
                        includedVatText;
                }
                else {
                    bssB2BPriceNoVat.innerHTML = planPriceInfo.price_formatted + ' ' + excludedVatText;

                    bssB2BPriceHasVat.innerHTML = planPriceInfo.price_formatted + ' ' + includedVatText;
                }
            }

            //Integrate PO and td module
            if (BSS_B2B.storeId === 11378) {
                const cartItemKey = priceElement.getAttribute('data-cart-vat-item-key');
                const cartLineItemKey = priceElement.getAttribute('data-cart-vat-line-item-key');

                if (cartItemKey || cartLineItemKey) {
                    let rawPoCartInfo = null;
                    let cartKey = null;
                    if (cartItemKey) {
                        rawPoCartInfo = window.localStorage.getItem(cartItemKey);
                        cartKey = cartItemKey;
                    }
                    else if (cartLineItemKey) {
                        rawPoCartInfo = window.localStorage.getItem(cartLineItemKey);
                        cartKey = cartLineItemKey;
                    }

                    if (rawPoCartInfo) {
                        const poCartInfo = JSON.parse(rawPoCartInfo);
                        const poExtraPrice = Number(poCartInfo.totalExtraPrice);

                        if (!Number.isNaN(poExtraPrice) && cartKey) {
                            let isChangePrice = false;
                            const cartItem = BSS_B2B.cart.itemsMap.get(cartKey);
                            if (cartItemKey) {
                                itemWithVat += poExtraPrice * 100;
                                itemNoVat += poExtraPrice * 100;
                                isChangePrice = true;
                            }
                            else if (cartLineItemKey) {
                                const quantityElem = document.querySelector(`[id^="updates_${cartLineItemKey}"]`);
                                if (quantityElem) {
                                    const quantity = Number(quantityElem.value);
                                    if (!Number.isNaN(quantity)) {
                                        itemWithVat += poExtraPrice * quantity * 100;
                                        itemNoVat += poExtraPrice * quantity * 100;
                                        isChangePrice = true;
                                    }
                                }
                            }

                            if (isChangePrice) {
                                bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(itemNoVat, shopData) + ' ' +
                                    excludedVatText;

                                bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(itemWithVat, shopData) + ' ' +
                                    includedVatText;

                                // Data for PO check
                                if (!cartItem.appliedTaxDisplayRule && BSS_B2B.cart.itemsMap) {
                                    cartItem.appliedTaxDisplayRule = appliedDisplayRule;
                                    BSS_B2B.cart.itemsMap.set(cartKey, cartItem);
                                }
                            }
                        }
                    }
                }
            }
            // custom VAT price for folieshoppen by CuongNM
            if (BSS_B2B.storeId === 11501) {
                if (customerTags.includes('b2b')) {
                    bssB2BPriceHasVat.innerHTML = '(' + bssB2BPriceHasVat.innerHTML + ')';
                }
                else {
                    bssB2BPriceNoVat.innerHTML = '(' + bssB2BPriceNoVat.innerHTML + ')';
                }
            }
            BSS_B2B.integrate.langShop.handleAllTranslation('td');
        }
        else {
            if (isChangeCartItemPrice) {
                module.exports.bssB2BCustomVatPrice(bssB2BPriceNoVat, bssB2BPriceHasVat, null, planPriceInfo,
                    appliedTax, shopData, itemTaxable);
            }
            if (itemTaxable) {
                if (shopData.taxes_included) {
                    itemNoVat = planPriceInfo.price * (1 / (1 + appliedTax));
                }
                else {
                    itemWithVat = planPriceInfo.price * (1 + appliedTax);
                }
            }
        }
        return {
            itemNoVat, itemWithVat,
        };
    },

    bssB2BCartShowVatPrice: function(
        cartItemKey, shopData, customPrice, appliedDisplayRule, priceWrapperElement, isChangeCartItemPrice = true) {
        let itemNoVatPrice = Number(customPrice);
        let itemWithVatPrice = Number(customPrice);
        let planPriceInfo = {};
        if (customPrice || parseFloat(customPrice) === 0) {
            customPrice = parseFloat(customPrice);
            planPriceInfo.price_formatted = module.exports.formatMoney(customPrice, shopData);
            planPriceInfo.price = customPrice;
        }
        let priceElement = priceWrapperElement;
        if (priceElement) {
            let bssB2BItemCollectionList = priceElement.getAttribute('data-cart-item-collections');
            let itemTaxable = priceElement.getAttribute('data-cart-variant-taxable');
            itemTaxable = (itemTaxable === 'true');
            let appliedTax = module.exports.bssB2BGetAppliedTaxRate(bssB2BItemCollectionList);
            if (shopData.taxes_included) {
                if (itemTaxable) {
                    itemNoVatPrice = planPriceInfo.price * (1 / (1 + appliedTax));
                }
            }
            else {
                if (itemTaxable) {
                    itemWithVatPrice = planPriceInfo.price * (1 + appliedTax);
                }
            }
            if (!appliedDisplayRule && BSS_B2B.page.isCartPage()) {
                let collectionVatItems = document.querySelectorAll('.bss-b2b-collection-item-vat');
                let collectionVatItemsStyle = document.querySelectorAll('[class^="bss-b2b-collection-item-vat-style"]');
                if (collectionVatItems) {
                    collectionVatItems.forEach(e => {
                        e.remove();
                    });
                }
                // remove style for each item in collection page if this item was not applied display rule
                if (collectionVatItemsStyle) {
                    collectionVatItemsStyle.forEach(e => {
                        e.remove();
                    });
                }

                return {
                    itemNoVatPrice, itemWithVatPrice,
                };
            }

            let cartItem = shopData.cart.items.filter(item => (item.key === cartItemKey));
            let productId = cartItem && cartItem.length ? cartItem[0].product_id : parseInt(
                priceElement.getAttribute('data-cart-item-id'));
            let appliedTDCartItem = false;
            let delay = true;
            if (appliedDisplayRule && appliedDisplayRule.product_condition_type === 1) {
                // applied for specific products
                if (appliedDisplayRule.product_ids.indexOf(`${productId}`) !== -1) {
                    appliedTDCartItem = true;
                }
                delay = false;
            }
            else if (appliedDisplayRule && appliedDisplayRule.product_condition_type === 0) {
                //applied for all products
                appliedTDCartItem = true;
                delay = false;
            }
            else if (appliedDisplayRule && productId) {
                if (appliedDisplayRule.product_condition_type === 3) {
                    // applied for product tags
                    let appliedTags = appliedDisplayRule.product_tags.split(',');
                    let lineItemProduct = shopData.line_item_products.filter(item => (item.id === productId));
                    if (lineItemProduct && lineItemProduct.length > 0) {
                        lineItemProduct[0].tags.forEach(tag => {
                            (appliedTags.indexOf(`${tag}`) !== -1) && (appliedTDCartItem = true);
                        });
                        delay = false;
                    }
                    else {
                        let encodeUrl = encodeURI('/search?q=id:' + productId + '&view=bss.b2b');
                        $.get(encodeUrl, function(data) {
                            let responseProducts = [];
                            try {
                                responseProducts = JSON.parse(data);
                                let isAppliedProduct = false;
                                responseProducts[0].tags.forEach(tag => {
                                    (appliedTags.indexOf(`${tag}`) !== -1) && (isAppliedProduct = true);
                                });
                                if (isAppliedProduct) {
                                    const {
                                        itemNoVat, itemWithVat,
                                    } = module.exports.bssB2BCartChangePrice(priceElement, shopData, planPriceInfo,
                                        appliedDisplayRule, isChangeCartItemPrice);
                                    itemNoVatPrice = itemNoVat;
                                    itemWithVatPrice = itemWithVat;
                                }
                                else {
                                    priceElement.innerHTML = planPriceInfo.price_formatted;
                                }
                                delay = false;
                                return {
                                    itemNoVatPrice, itemWithVatPrice,
                                };
                            } catch (e) {
                                // eslint-disable-next-line no-console
                                console.log('B2B could not parse data: JSON parse returns no item');
                            }
                        });
                    }
                }
                else if (appliedDisplayRule.product_condition_type === 2) {
                    //applied for product collection
                    let encodeUrl = encodeURI('/search?q=id:' + productId + '&view=bss.b2b');
                    $.get(encodeUrl, function(data) {
                        let responseProducts = [];
                        try {
                            responseProducts = JSON.parse(data);
                            let isAppliedProduct = false;
                            let appliedCollection = appliedDisplayRule.product_collections.split(',');
                            responseProducts[0].collections.forEach(collection => {
                                (appliedCollection.indexOf(`${collection}`) !== -1) && (isAppliedProduct = true);
                            });
                            if (isAppliedProduct) {
                                const {
                                    itemNoVat, itemWithVat,
                                } = module.exports.bssB2BCartChangePrice(priceElement, shopData, planPriceInfo,
                                    appliedDisplayRule, isChangeCartItemPrice);
                                itemNoVatPrice = itemNoVat;
                                itemWithVatPrice = itemWithVat;
                            }
                            else {
                                priceElement.innerHTML = planPriceInfo.price_formatted;
                            }
                            delay = false;
                            return {
                                itemNoVatPrice, itemWithVatPrice,
                            };
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.log('B2B could not parse data: JSON parse returns no item');
                        }
                    });
                }
            }
            if (appliedTDCartItem) {
                const {
                    itemNoVat, itemWithVat,
                } = module.exports.bssB2BCartChangePrice(priceElement, shopData, planPriceInfo, appliedDisplayRule,
                    isChangeCartItemPrice);
                itemNoVatPrice = itemNoVat;
                itemWithVatPrice = itemWithVat;
            }
            else if (!delay) {
                priceElement.innerHTML = planPriceInfo.price_formatted;
            }
        }
        return {
            itemNoVatPrice, itemWithVatPrice,
        };
    },

    bssB2BCartChangeSubtotalVatPrice: function (shopData, subtotalWithVat, subtotalNoVat, appliedDisplayRule) {
        let customerTags = (shopData.customer && shopData.customer.tags) ? shopData.customer.tags.map(
            (tag) => tag.toLowerCase()) : [];
        if (!appliedDisplayRule) {
            let cartVatStyle = document.querySelector('#bss-b2b-cart-vat-style');
            if (cartVatStyle) {
                cartVatStyle.remove();
            }
            return;
        }
        let appliedTDSubtotal = 0;
        shopData.line_item_products.map(item => {
            if (appliedDisplayRule.product_condition_type === 0) {
                appliedTDSubtotal = shopData.line_item_products.length;
            }
            else if (appliedDisplayRule.product_condition_type === 1) {
                const appliedProduct = appliedDisplayRule.product_ids.split(',');
                if (appliedProduct.indexOf(`${item.id}`) !== -1) {
                    appliedTDSubtotal++;
                }
            }
            else if (appliedDisplayRule.product_condition_type === 3) {
                let appliedTags = appliedDisplayRule.product_tags.split(',');
                item.tags.forEach(tag => {
                    (appliedTags.indexOf(`${tag}`) !== -1) && (appliedTDSubtotal++);
                });
            }
        });

        if (appliedDisplayRule.product_condition_type === 2) {
            let priceTDElements = document.querySelectorAll('.bss-b2b-cart-vat');
            priceTDElements && priceTDElements.length && priceTDElements.forEach(element => {
                let collectionsAttr = element.getAttribute('data-cart-item-collections');
                let collection = collectionsAttr.split(',');
                let appliedCollection = appliedDisplayRule.product_collections.split(',');
                let isAppliedCollectionItem = false;
                appliedCollection.map((item) => {
                    if (collection.indexOf(item) !== -1) {
                        isAppliedCollectionItem = true;
                    }
                });
                isAppliedCollectionItem && appliedTDSubtotal++;
            });
        }
        let priceElements = document.querySelectorAll('.bss-b2b-cart-vat-subtotal');
        if (priceElements && priceElements.length) {
            priceElements.forEach(priceElement => {
                if (priceElement) {
                    if (appliedTDSubtotal === shopData.line_item_products.length ||
                        (appliedDisplayRule.product_condition_type === 2 && appliedTDSubtotal ===
                            shopData.line_item_products.length * 2)) {
                        let bssB2BPriceNoVat = priceElement.querySelector('.bss-b2b-cart-no-vat-price');
                        let bssB2BPriceHasVat = priceElement.querySelector('.bss-b2b-cart-with-vat-price');
                        let includedVatText = BSS_B2B.taxDisplayTranslations &&
                            BSS_B2B.taxDisplayTranslations.included_vat_text;
                        let excludedVatText = BSS_B2B.taxDisplayTranslations &&
                            BSS_B2B.taxDisplayTranslations.excluded_vat_text;
                        if (BSS_B2B.storeId === 7691) {
                            includedVatText = document.querySelector('[data-included-vat-text]').getAttribute('data-included-vat-text');
                        }
                        // custom VAT price for folieshoppen by CuongNM
                        if (BSS_B2B.storeId === 11501) {
                            if (customerTags.includes('b2b')) {
                                Object.assign(priceElement.style, {
                                    display: 'flex', flexDirection: 'column', lineHeight: '30px',
                                });
                                excludedVatText = '';
                            }
                            else {
                                Object.assign(priceElement.style, {
                                    display: 'flex', flexDirection: 'column-reverse', lineHeight: '30px',
                                });
                                includedVatText = '';
                            }
                        }
                        if (appliedDisplayRule) {
                            switch (appliedDisplayRule.display_price_type) {
                                case 0:
                                    break;
                                case 1:
                                    bssB2BPriceNoVat.style.display = 'none';
                                    break;
                                case 2:
                                    bssB2BPriceHasVat.style.display = 'none';
                                    excludedVatText = excludedVatText.replace('|', '');
                                    break;
                            }

                            let incTextColor = appliedDisplayRule.inc_text_color;
                            let excTextColor = appliedDisplayRule.exc_text_color;
                            bssB2BPriceNoVat.style.color = excTextColor;
                            bssB2BPriceHasVat.style.color = incTextColor;

                            let ratio = appliedDisplayRule.ratio_type;
                            // custom VAT price for folieshoppen by CuongNM
                            if (BSS_B2B.storeId === 11501) {
                                if (customerTags.includes('b2b')) {
                                    ratio = 6;
                                }
                                else {
                                    ratio = 0;
                                }
                            }
                            let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);

                            bssB2BPriceHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
                            bssB2BPriceNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;
                        }

                        if (BSS_B2B.storeId !== 5010) {
                            // custom VAT price for pouches-24 by CuongNM
                            if (BSS_B2B.storeId === 12353) {
                                if (BSS_B2B.page.isCartPage()) {
                                    subtotalNoVat = subtotalNoVat / 3;
                                    subtotalWithVat = subtotalWithVat / 3;
                                }
                                else {
                                    subtotalNoVat = subtotalNoVat / 2;
                                    subtotalWithVat = subtotalWithVat / 2;
                                }
                            }
                            if(15849 === BSS_B2B.storeId && BSS_B2B.page.isCartPage()) {
                                subtotalNoVat = subtotalNoVat / 2;
                                subtotalWithVat = subtotalWithVat / 2;
                            }
                            bssB2BPriceNoVat.innerHTML = module.exports.formatMoney(subtotalNoVat, shopData)
                                + ' '
                                + '<span class="bss-b2b-translation-td-excluded_vat_text">' + excludedVatText +
                                '</span>';

                            bssB2BPriceHasVat.innerHTML = module.exports.formatMoney(subtotalWithVat, shopData) + ' ' +
                                '<span class="bss-b2b-translation-td-included_vat_text">' + includedVatText + '</span>';
                            
                            if (BSS_B2B.storeId === 12733) {
                                document.dispatchEvent(new Event("doneCalcVatPrice"));
                            }
                            // custom VAT price for folieshoppen by CuongNM
                            if (BSS_B2B.storeId === 11501) {
                                if (customerTags.includes('b2b')) {
                                    bssB2BPriceHasVat.innerHTML = '(' + bssB2BPriceHasVat.innerHTML + ')';
                                }
                                else {
                                    bssB2BPriceNoVat.innerHTML = '(' + bssB2BPriceNoVat.innerHTML + ')';
                                }
                            }
                            //custom VAT subtotal price for candybig by quyenpv
                            else if (BSS_B2B.storeId === 11610) {
                                bssB2BPriceNoVat.style.display = 'block';
                                let taxesElement = document.createElement('span');
                                let ratio = appliedDisplayRule.ratio_type;
                                let incTextColor = appliedDisplayRule.inc_text_color;
                                let fontSizeOfPriceVatEle = module.exports.changeFontSizeOfPriceVatEle(ratio);
                                taxesElement.style.fontSize = fontSizeOfPriceVatEle.fontSizePriceHasVat;
                                taxesElement.style.color = incTextColor;
                                taxesElement.style.display = 'block';
                                taxesElement.innerHTML = 'Taxes: ' +
                                    module.exports.formatMoney(subtotalWithVat - subtotalNoVat, shopData);
                                bssB2BPriceHasVat.insertAdjacentElement('afterend', taxesElement);
                            }
                            BSS_B2B.integrate.langShop.handleAllTranslation('td');
                        }
                        else {
                            subtotalNoVat = module.exports.formatMoney(subtotalNoVat, shopData);
                            subtotalWithVat = module.exports.formatMoney(subtotalWithVat, shopData);
                            module.exports.bssB2BCustomVatSubtotalPrice(bssB2BPriceNoVat, bssB2BPriceHasVat,
                                subtotalWithVat, subtotalNoVat);
                        }
                    }
                    else {
                        priceElement.innerHTML = module.exports.formatMoney(subtotalWithVat, shopData);
                        priceElement.style.textAlign = 'center';
                    }
                }
            });
        }

    },

    bssB2BCartChangeAllVatPriceWithoutCP: function(shopData, appliedDisplayRule) {
        if (!appliedDisplayRule) {
            let cartVatItems = document.querySelectorAll('.bss-b2b-cart-vat');
            if (cartVatItems) {
                cartVatItems.forEach(e => {
                    e.remove();
                });
            }
            let cartSubtotalVatItems = document.querySelectorAll('.bss-b2b-cart-vat-subtotal');
            if (cartSubtotalVatItems) {
                cartSubtotalVatItems.forEach(e => {
                    e.remove();
                });
            }
            let cartVatStyle = document.querySelector('#bss-b2b-cart-vat-style');
            if (cartVatStyle) {
                cartVatStyle.remove();
            }
            return;
        }
        let priceWrapperElements = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-item-key]');
        if (priceWrapperElements.length) {
            priceWrapperElements.forEach(priceWrapperElement => {
                let cartItemKey = priceWrapperElement.getAttribute('data-cart-vat-item-key');
                let customPrice = priceWrapperElement.getAttribute('data-cart-item-final-price');
                module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule,
                    priceWrapperElement);
            });
        }
        let linePriceWrapperElements = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-line-item-key]');
        if (BSS_B2B.page.isCartPage() && [6511, 7347, 9231, 12117, 9185, 14939].includes(BSS_B2B.storeId)) {
            if (screen.width < 750) {
                linePriceWrapperElements = document.querySelectorAll(
                    '#main-cart-items .medium-hide .bss-b2b-cart-vat[data-cart-vat-line-item-key]');
            }
            else {
                linePriceWrapperElements = document.querySelectorAll(
                    '#main-cart-items .small-hide .bss-b2b-cart-vat[data-cart-vat-line-item-key]');
            }
        }
        if (BSS_B2B.page.isCartPage() && BSS_B2B.storeId === 7552) {
            linePriceWrapperElements = document.querySelectorAll(
                '.main-content form[action="/cart"] .bss-b2b-cart-vat[data-cart-vat-line-item-key]');
        }
        let totalItemWithVat = 0;
        let totalItemNoVat = 0;
        if (linePriceWrapperElements.length) {
            linePriceWrapperElements.forEach(linePriceWrapperElement => {
                let cartItemKey = linePriceWrapperElement.getAttribute('data-cart-vat-line-item-key');
                let customPrice = linePriceWrapperElement.getAttribute('data-cart-item-final-line-price');
                let {
                    itemNoVatPrice, itemWithVatPrice,
                } = module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice, appliedDisplayRule,
                    linePriceWrapperElement);

                if ((BSS_B2B.page.isCartPage() && !linePriceWrapperElement.closest(BSS_B2B.cart.miniCartContainer)) ||
                    !BSS_B2B.page.isCartPage()) {
                    totalItemWithVat += itemWithVatPrice;
                    totalItemNoVat += itemNoVatPrice;
                }
            });
        }
        else if (priceWrapperElements.length) {
            priceWrapperElements.forEach(priceWrapperElement => {
                let cartItemKey = priceWrapperElement.getAttribute('data-cart-vat-item-key');
                let customPrice = priceWrapperElement.getAttribute('data-cart-item-final-price');

                let cartItem = priceWrapperElement.closest(
                    '[data-cart-item-id]:not(.bss-b2b-cart-vat) , [data-cart-item], .cart-item');

                if ([10989].indexOf(BSS_B2B.storeId) !== -1) {
                    cartItem = priceWrapperElement.closest('.CartItem');
                }

                // fix for cherrykurry.com by PhuongKD
                if ([10993, 3321].includes(BSS_B2B.storeId)) {
                    cartItem = priceWrapperElement.closest('.cart__item-sub');
                }
                // fix for
                if ([10876, 14377].includes(BSS_B2B.storeId)) {
                    cartItem = priceWrapperElement.closest('.cart__item');
                }
                if ([15690].includes(BSS_B2B.storeId)) {
                    cartItem = priceWrapperElement.closest('.previewCartItem');
                }

                let inputQty = cartItem.querySelector(BSS_B2B.cart.inputQuantityElement);
                let quantity = parseInt(inputQty.value);
                let {
                    itemNoVatPrice, itemWithVatPrice,
                } = module.exports.bssB2BCartShowVatPrice(cartItemKey, shopData, customPrice * quantity,
                    appliedDisplayRule, priceWrapperElement, false);

                if ((BSS_B2B.page.isCartPage() && !priceWrapperElement.closest(BSS_B2B.cart.miniCartContainer)) ||
                    !BSS_B2B.page.isCartPage()) {
                    totalItemWithVat += itemWithVatPrice;
                    totalItemNoVat += itemNoVatPrice;
                }
            });
        }

        module.exports.bssB2BCartChangeSubtotalVatPrice(shopData, totalItemWithVat, totalItemNoVat, appliedDisplayRule);
    },

    bssB2BCartChangeAllVatPriceQtyChangeWithoutCP: function(shopData, appliedDisplayRule) {
        if (!appliedDisplayRule) {
            let cartVatItems = document.querySelectorAll('.bss-b2b-cart-vat');
            if (cartVatItems) {
                cartVatItems.forEach(e => {
                    e.remove();
                });
            }
            let cartSubtotalVatItems = document.querySelectorAll('.bss-b2b-cart-vat-subtotal');
            if (cartSubtotalVatItems) {
                cartSubtotalVatItems.forEach(e => {
                    e.remove();
                });
            }
            let cartVatStyle = document.querySelector('#bss-b2b-cart-vat-style');
            if (cartVatStyle) {
                cartVatStyle.remove();
            }
            return;
        }
        let qtyInputElements = document.querySelectorAll(BSS_B2B.cart.inputQuantityElement);
        let qtyButtonElements = document.querySelectorAll(BSS_B2B.cart.buttonChangeQuantity);
        let delayTime = 3000;
        if (qtyInputElements.length) {
            qtyInputElements.forEach(qtyInputElement => {
                if (!qtyInputElement.getAttribute('bss-cart-change-all-vat-without-cp-quantity-input-event')) {
                    qtyInputElement.setAttribute('bss-cart-change-all-vat-without-cp-quantity-input-event', true);
                    qtyInputElement.addEventListener('change', function() {
                        setTimeout(function() {
                            module.exports.adjustAllVatPriceFromCartItems(shopData, appliedDisplayRule);

                            // recurring event listener
                            module.exports.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedDisplayRule);

                        }, delayTime);

                    });
                }
            });
        }
        if (qtyButtonElements.length) {
            qtyButtonElements.forEach(qtyButtonElement => {
                if (!qtyButtonElement.getAttribute('bss-cart-change-all-vat-without-cp-quantity-event')) {
                    const debounceFnc = (callback, timeout = 300) => {
                        let timer;

                        return (...args) => {
                            clearTimeout(timer);
                            timer = setTimeout(() => {
                                callback.apply(this, args);
                            }, timeout);
                        };
                    };
                    const handleChangeQuantity = debounceFnc(() => {
                        module.exports.adjustAllVatPriceFromCartItems(shopData, appliedDisplayRule);

                        // recurring event listener
                        module.exports.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedDisplayRule);
                    }, delayTime);
                    qtyButtonElement.setAttribute('bss-cart-change-all-vat-without-cp-quantity-event', true);
                    qtyButtonElement.addEventListener('click', function() {
                        handleChangeQuantity();
                    });
                }
            });
        }
    },

    adjustAllVatPriceFromCartItems: function(shopData, appliedDisplayRule) {
        fetch('/cart.js').then(response => response.json()).then(data => {
            let allItemElements = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-item-key]');
            let allLineItemElements = document.querySelectorAll('.bss-b2b-cart-vat[data-cart-vat-line-item-key]');
            if (allLineItemElements && allItemElements) {
                if (data.items && data.items.length) {
                    data.items.forEach((item, index) => {
                        let itemElement = allItemElements[index];
                        let lineElement = allLineItemElements[index];
                        if (itemElement) {
                            itemElement.setAttribute('data-cart-vat-item-key', item.key);
                            itemElement.setAttribute('data-cart-variant-taxable', item.taxable);
                            itemElement.setAttribute('data-cart-item-final-price', item.final_price);
                        }
                        if (lineElement) {
                            lineElement.setAttribute('data-cart-vat-line-item-key', item.key);
                            lineElement.setAttribute('data-cart-variant-taxable', item.taxable);
                            lineElement.setAttribute('data-cart-item-final-line-price', item.final_line_price);
                        }

                    });
                }
            }
        }).then(() => {
            module.exports.bssB2BCartChangeAllVatPriceWithoutCP(shopData, appliedDisplayRule);
        });
    },

    formatMoney: function(cents, shopData, format) {
        let moneyFormat = shopData.shop.money_format;
        if (shopData.shop.domain === 'euro-trade.com') {
            moneyFormat = `{{ amount_with_comma_separator }} ${shopData.shop.money_format.split('}}')[1]}`;
        }
        if (shopData.shop.domain == "candybig.com" || [13760].includes(BSS_B2B.storeId)) {
            moneyFormat = `{{ amount_with_comma_separator }} ${shopData.shop.money_format.split("{{")[0]}`
        }
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = (format || moneyFormat);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            let parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    },

    checkValidCountries: function(countryCode) {
        if (BSS_B2B.vatSetting && BSS_B2B.vatSetting.enable_select_eu_vat_countries) {
            let availableCountries = BSS_B2B.vatSetting.selected_eu_vat_countries.split(',');
            if (availableCountries.indexOf(countryCode ? countryCode : BSS_B2B.countryCode) === -1) {
                return false;
            }
        }
        return true;
    },

    changeFontSizeOfPriceVatEle: function(ratioType) {
        let fontSizePriceHasVat = '1em';
        let fontSizePriceNoVat = '1em';
        switch (ratioType) {
            case 0:
                fontSizePriceHasVat = '2em';
                break;
            case 1:
                fontSizePriceHasVat = '3em';
                break;
            case 2:
                fontSizePriceHasVat = '4em';
                break;
            case 3:
                break;
            case 4:
                fontSizePriceNoVat = '4em';
                break;
            case 5:
                fontSizePriceNoVat = '3em';
                break;
            case 6:
                fontSizePriceNoVat = '2em';
                break;
        }
        return {fontSizePriceHasVat: fontSizePriceHasVat, fontSizePriceNoVat: fontSizePriceNoVat};
    },

    handleVatExemptSelectedChange: function() {
        $('.bss-b2b-vat-selected').val(BSS_B2B.vatExemptSelectedOriginal);
        $('.bss-b2b-vat-selected').on('change', function(e) {
            $('.bss-b2b-tax-ex-message').html('');
            BSS_B2B.vatExemptSelected = e.target.value != null ? parseInt(e.target.value) : 0;

            let bssVatExemptFormHeaderText = $('.bss-vat-exempt-form-header-text');
            let bssVatExemptFormSubtitleText = $('.bss-vat-exempt-form-subtitle-text');
            if (BSS_B2B.vatExemptSelected === 0) {
                bssVatExemptFormHeaderText.html(
                    `<div class="bss-b2b-translation-vat-form_header_text">${BSS_B2B.vatTranslations.form_header_text}</div>`);
                bssVatExemptFormSubtitleText.html(
                    `<div class="bss-b2b-translation-vat-form_subtitle_text">${BSS_B2B.vatTranslations.form_subtitle_text}</div>`);
            }
            else if (BSS_B2B.vatExemptSelected === 1) {
                bssVatExemptFormHeaderText.html(
                    `<div class="bss-b2b-translation-vat-form_header_text_uk">${BSS_B2B.vatTranslations.form_header_text_uk}</div>`);
                bssVatExemptFormSubtitleText.html(
                    `<div class="bss-b2b-translation-vat-form_subtitle_text_uk">${BSS_B2B.vatTranslations.form_subtitle_text_uk}</div>`);
            }
            else if (BSS_B2B.vatExemptSelected === 2) {
                bssVatExemptFormHeaderText.html(
                    `<div class="bss-b2b-translation-vat-form_header_text_abn">${BSS_B2B.vatTranslations.form_header_text_abn}</div>`);
                bssVatExemptFormSubtitleText.html(
                    `<div class="bss-b2b-translation-vat-form_subtitle_text_abn">${BSS_B2B.vatTranslations.form_subtitle_text_abn}</div>`);
            }
            else if (BSS_B2B.vatExemptSelected === 3) {
                bssVatExemptFormHeaderText.html(
                    `<div class="bss-b2b-translation-vat-form_header_text_gst">${BSS_B2B.vatTranslations.form_header_text_gst}</div>`);
                bssVatExemptFormSubtitleText.html(
                    `<div class="bss-b2b-translation-vat-form_subtitle_text_gst">${BSS_B2B.vatTranslations.form_subtitle_text_gst}</div>`);
            }
            else if (BSS_B2B.vatExemptSelected === 4) {
                bssVatExemptFormHeaderText.html(
                    `<div class="bss-b2b-translation-vat-form_header_text_us_ein">${BSS_B2B.vatTranslations.form_header_text_us_ein}</div>`);
                bssVatExemptFormSubtitleText.html(
                    `<div class="bss-b2b-translation-vat-form_subtitle_text_us_ein">${BSS_B2B.vatTranslations.form_subtitle_text_us_ein}</div>`);
            }

            BSS_B2B.integrate.langShop.translatedModules.vat = false;
            BSS_B2B.integrate.langShop.handleAllTranslation('vat');
        });
    },

    handleVatExemptInputChange: function() {
        $('.bss-b2b-vat-input').on('change', function() {
            $('.bss-b2b-tax-ex-message').html('');
        });
    },

    calculateVatPriceOnQBABTable: function(price, vatText, shopData, includedOrExcluded) {
        const translationElement = '<span class="bss-b2b-translation-td-' + includedOrExcluded + '_vat_text">';

        let bssB2BPrice = module.exports.formatMoney(price, shopData) + ' ' + translationElement + vatText +
            '</span>&nbsp;';

        return bssB2BPrice;
    },

    calculateVatPriceOnABRange: function(amount_from, amount_to, vatText, shopData, includedOrExcluded) {
        let bssB2BPrice = '';
        const translationElement = '<span class="bss-b2b-translation-td-' + includedOrExcluded + '_vat_text">';

        if (amount_to) {
            bssB2BPrice = module.exports.formatMoney(amount_from, shopData) + ' - ' +
                module.exports.formatMoney(amount_to, shopData) + ' ' + translationElement + vatText + '</span>&nbsp;';
        }
        else {
            bssB2BPrice = '≥ ' + module.exports.formatMoney(amount_from, shopData) + ' ' + translationElement +
                vatText + '</span>&nbsp;';
        }

        return bssB2BPrice;
    },
};



/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = {
    getAppliedRule: function (BSS_B2B, shopData) {
        let rules = (BSS_B2B && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length) ? BSS_B2B.taxDisplayRules : [];
        let appliedRule = null;

        let customer = shopData.customer;
        let collections = shopData.collections;
        let product;
        if([13923, 13092].includes(BSS_B2B.storeId) && !BSS_B2B.page.isProductPage()) {
            //nothing
        } else {
            if (!shopData.product) {
                return appliedRule;
            }
            product = shopData.product;
        }
        rules.forEach(rule => {
            if (!appliedRule && (rule.apply_to_page === 0 || rule.apply_to_page === 3)) {
                let isAppliedCustomer = module.exports.checkCustomerCondition(rule, customer);
                let isAppliedProducts = false;
                if (BSS_B2B.page.isProductPage()) {
                    isAppliedProducts = module.exports.checkProductCondition(rule, product, collections);
                } else{
                    isAppliedProducts = true;
                }

                if (isAppliedCustomer && isAppliedProducts) {
                    appliedRule = rule;
                }
            }

        })

        return appliedRule;
    },
    getAppliedRuleCartPage: function (BSS_B2B, shopData) {
        let rules = (BSS_B2B && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length) ? BSS_B2B.taxDisplayRules : [];
        let appliedRule = null;
        let customer = shopData.customer;

        rules.forEach(rule => {
            if (!appliedRule && (rule.apply_to_page === 1 || rule.apply_to_page === 3)) {
                let isAppliedCustomer = module.exports.checkCustomerCondition(rule, customer);
                if (isAppliedCustomer) {
                    appliedRule = rule;
                }
            }
        })
        //fix remove vat style minicart for fancybeans by trungdd
        if ([7691, 10927, 8930, 14675].includes(BSS_B2B.storeId)) {
            if (!appliedRule) {
                if(BSS_B2B.storeId === 14675) {
                    document.querySelectorAll('.bss-b2b-collection-item-vat, [class^="bss-b2b-collection-item-vat-style"]').forEach(e => {
                        e.remove();
                    });
                } else {
                    let cartVatStyle = document.querySelectorAll("#bss-b2b-cart-vat-style");
                    if (cartVatStyle) {
                        cartVatStyle.forEach((item) =>{
                            item.remove()
                        });
                    }
                }
            }
        }

        return appliedRule;
    },
    getAppliedRuleCollectionPage: function (BSS_B2B, shopData, product) {
        let rules = (BSS_B2B && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length) ? BSS_B2B.taxDisplayRules : [];
        let appliedRule = null;
        let customer = shopData.customer;
        rules.forEach(rule => {
            if (!appliedRule && (rule.apply_to_page === 2 || rule.apply_to_page === 3)) {
                let isAppliedCustomer = module.exports.checkCustomerCondition(rule, customer);
                if (isAppliedCustomer) {
                    if(product){
                        const collections = product.collections;
                        const isAppliedProducts = module.exports.checkProductCondition(rule, product, collections);
                        if(isAppliedProducts){
                            appliedRule = rule;
                        }
                    } else {
                        appliedRule = rule;
                    }
                }
            }
        })

        return appliedRule;
    },
    checkCustomerCondition: function (rule, customer) {
        let applyTo = rule.apply_to;
        switch (applyTo) {
            case 0:
                return true;
            case 1:
                if (customer.id) {
                    return true;
                }
                return false;
            case 2:
                if (!customer.id) {
                    return true;
                }
                return false;
            case 3:
                if (!customer.id) {
                    return false;
                }
                if (rule.customer_ids) {
                    let customerIds = rule.customer_ids.split(",");
                    if (customerIds.indexOf(customer.id.toString()) !== -1) {
                        return true;
                    }
                }
                return false;
            case 4:
                if (!customer.id) {
                    return false;
                }
                if (rule.customer_tags) {
                    if (!customer.tags) {
                        return false
                    } else {
                        let customerTags = rule.customer_tags.toLowerCase().split(",");
                        let tag = customer.tags.map(tag => tag.toLowerCase());
                        let matchArr = customerTags.filter(t => tag.indexOf(t) !== -1);
                        if (matchArr && matchArr.length) {
                            return true;
                        }
                    }

                }
                return false;
            default:
                return false;
        }
    },
    checkProductCondition: function (rule, product, collections) {
        let productConditionType = rule.product_condition_type;
        switch (productConditionType) {
            case 0:
                return true;
            case 1:
                if (rule.product_ids) {
                    let productIds = rule.product_ids.split(",");
                    if (productIds.indexOf(product.id.toString()) !== -1) {
                        return true;
                    }
                }
                return false;
            case 2:
                if (rule.product_collections) {
                    let productCollections = rule.product_collections.split(",");
                    if (!collections) {
                        return false;
                    } else {
                        let matchArr = collections.filter(c => productCollections.indexOf(c.toString()) !== -1);
                        if (matchArr && matchArr.length) {
                            return true;
                        }
                    }

                }
                return false;
            case 3:

                if (rule.product_tags) {
                    if (!product.tags) {
                        return false
                    } else {
                        let productTags = rule.product_tags.toLowerCase().split(",");
                        let lowerCaseProductTags = product.tags.map((tag) => tag.toLowerCase());
                        let matchArr = productTags.filter(t => lowerCaseProductTags.indexOf(t) !== -1);
                        if (matchArr && matchArr.length) {
                            return true;
                        }
                    }

                }
                return false;
            default:
                return false;
        }
    },
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ handleQuickView; });

// CONCATENATED MODULE: ./js/src/internal/fix/quickView.js
function handleSingleQuickview(modalButtonSelector, cartFormSelector, BSS_B2B, shopData, customAttribute, limitTimes = 10, needInterval = false) {
    let times = 0;
    let buttonCheck = setInterval(function () {
        let quickviewButtons = document.querySelectorAll(modalButtonSelector);
        if (quickviewButtons.length || times > limitTimes) {
            clearInterval(buttonCheck);
            if (quickviewButtons.length) {
                for (let i = 0; i < quickviewButtons.length; i++) {
                    let quickviewButton = quickviewButtons[i];
                    quickviewButton.addEventListener('click', function () {
                        if (needInterval) {
                            let cartFormCheckTimes = 0;
                            let cartFormCheck = setInterval(function () {
                                let cartForm = document.querySelector(cartFormSelector);
                                if (cartForm || cartFormCheckTimes > limitTimes) {
                                    clearInterval(cartFormCheck);
                                    if (cartForm) {
                                        BSS_B2B.cp.changeProductPrice(shopData, customAttribute, cartForm, true);
                                        if (BSS_B2B.storeId === 5273) {
                                            let variantSelections = cartForm.querySelectorAll(".variant-selection__variants, .options-selection__input-select");
                                            if (variantSelections.length) {
                                                for (let i = 0; i < variantSelections.length; i++){
                                                    let variantSelection = variantSelections[i];
                                                    variantSelection.addEventListener("change", function () {
                                                        BSS_B2B.cp.changeProductPrice(shopData, customAttribute, cartForm, true);
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                                cartFormCheckTimes += 1;
                            }, 500);
                        } else {
                            let cartForm = document.querySelector(cartFormSelector);
                            if (cartForm) {
                                BSS_B2B.cp.changeProductPrice(shopData, customAttribute, cartForm, true);
                            }
                        }
                    });
                }
            }
        }
        times += 1;
    }, 500);
}

function fixQuickView ($, BSS_B2B, shopData) {
    // fix for storeID 7259
    window.BSS_B2B.executeAction({tag: 'price_quick_view', storeId: 7259, shopData})

    if ([4229, 6498].includes(BSS_B2B.storeId)) {
        let quickviewButtonCheckTimes = 0;
        let quickviewButtonCheck = setInterval(function () {
            let quickviewButtons = document.querySelectorAll('.boost-pfs-quickview-btn');
            if (quickviewButtons.length || quickviewButtonCheckTimes > 20) {
                clearInterval(quickviewButtonCheck);
                if (quickviewButtons.length) {
                    for (let i = 0; i < quickviewButtons.length; i++) {
                        let quickviewButton = quickviewButtons[i];
                        quickviewButton.addEventListener('click', function () {
                            setTimeout(function () {
                                let cartForm = document.querySelector('.boost-pfs-modal-content form#boost-pfs-quickview-cart-form');
                                if (cartForm) {
									let customSelector = '.boost-pfs-modal-content #boost-pfs-quickview-current-price .money > span[bss-b2b-product-id]';
									if(BSS_B2B.storeId === 6498) {
										customSelector = "#boost-pfs-quickview-current-price";
									}
                                    BSS_B2B.cp.changeProductPrice(shopData, customSelector, cartForm);
                                }
                            }, 2000);
                        });
                    }
                }
            }
            quickviewButtonCheckTimes += 1;
        }, 500);
    }

    if (BSS_B2B.storeId === 9959) {
        const showQuickView = document.querySelectorAll('.product-card__quick-add-button');
        if (showQuickView.length) {
            showQuickView.forEach(function (item) {
                item.addEventListener('click', function () {
                    const catchQuickView = setInterval(function () {
                        const quickView = document.querySelector('.quick-buy-modal.modal[style*="display: block"]');
                        if (quickView) {
                            clearInterval(catchQuickView);
                            BSS_B2B.cp.changeProductPrice(shopData, false, false);
                            const changeVariantOptionProductPages = document.querySelectorAll('.variant-picker__option-values .block-swatch');
                            if (changeVariantOptionProductPages.length) {
                                changeVariantOptionProductPages.forEach(function(item) {
                                    item.addEventListener('click', function () {
                                        BSS_B2B.cp.changeProductPrice(shopData, '.quick-buy-modal__info-wrapper [bss-b2b-product-price]', 'quick-buy-modal[style*="display: block;"] form.shopify-product-form[action="/cart/add"]');
                                        BSS_B2B.handleAjaxCart();
                                    });
                                });
                            }
                        }
                    }, 1000);
                    setTimeout(function () {
                        clearInterval(catchQuickView);
                    }, 7000);
                });
            });
        }
    }

    //Fix for inglot by donglt
    if (BSS_B2B.storeId == 9048) {
        document.addEventListener('quickview:loaded', () => {
            const quickviewAddToCart = document.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]');
            if(quickviewAddToCart){
                quickviewAddToCart.addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_B2B.cart.fixer(shopData, false, false);
                    }, 2000)
                })
            }
        });
    }
    
    //Fix for troneplumbing by donglt
    if ([9364,6939, 9832, 7795, 4904, 10724, 11520, 10548, 11985, 12167, 2259, 12761,13871, 13821, 14993, 14806].includes(BSS_B2B.storeId)) {
        let openModalEventName = 'quickview:loaded';
        let listenerElem = document;

        if(BSS_B2B.storeId === 11520){
            openModalEventName = "loft:QuickviewModal__Opened2";
            listenerElem = window;
        } else if (BSS_B2B.storeId === 11985){
            openModalEventName = "quick-view:open";
        }

        listenerElem.addEventListener(openModalEventName, () => {
            let customAttr = false;

            if(BSS_B2B.storeId === 7795){
                customAttr = '[data-product-quickview-handle] .bss-b2b-custom-price ';
                BSS_B2B.customize.cp.fixCPSubtotalPrice(BSS_B2B, shopData, true);
            }

            if(BSS_B2B.storeId === 4904){
                customAttr = '.modal-content .price__current ';
            }
            if (BSS_B2B.storeId === 14806) {
                setTimeout(() => {
                    let variantIdsArr = BSS_B2B.getQueryArray();
                    let variantId = variantIdsArr.variant;
                    BSS_B2B.cp.changeProductPrice(shopData, customAttr, false, true, variantId);
                }, 500)
            } else {
                BSS_B2B.cp.changeProductPrice(shopData, customAttr, false, true);
            }
            
            let addToCartQuickViewSelector = '';
            if(BSS_B2B.storeId === 9364){
                addToCartQuickViewSelector = '.add_to_cart[name="add"]';
                let cartForm = $('form[action*="/cart/add"]');
                if (cartForm.length > 0) {
                    $(cartForm).find('.swatch_options div.swatch-element').on('click', function () {
                        BSS_B2B.cp.changeProductPrice(shopData, `.quick-shop__product-description [bss-b2b-product-parent-price]`, cartForm);
                    });
                }
            } else if(BSS_B2B.storeId === 9832){
                addToCartQuickViewSelector = '.quickview-product .product-actions button.btn-addToCart';
                let cartForm = $('form[action*="/cart/add"][id^="product-actions"]');
                if (cartForm.length > 0) {
                    $(cartForm).find('.swatch[data-option-index] [data-value] label').on('click', function () {
                        BSS_B2B.cp.changeProductPrice(shopData, `.popup-quickview [bss-b2b-product-parent-price] `, cartForm, true);
                    });
                }
            } else if(BSS_B2B.storeId === 10548){
                addToCartQuickViewSelector = "quick-view button[type='submit'].product-form__submit";
                const inputVariant = document.querySelector(`quick-view form[action*="/cart/add"] input[name="id"`);
                if(inputVariant){
                    const cartForm = $('quick-view form[action*="/cart/add"]');
                    inputVariant.addEventListener('change', () => {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, "quick-view [bss-b2b-product-parent-price]", cartForm, true);
                        }, 1000);
                    });
                }
            } else if(BSS_B2B.storeId === 12167){
                addToCartQuickViewSelector = `[type="submit"][name="add"][data-add-to-cart]`;
            } 

            if(BSS_B2B.storeId === 10724){
                addToCartQuickViewSelector = "#boost-pfs-quickview-cart-btn";
            } else if(BSS_B2B.storeId === 11985){
                addToCartQuickViewSelector = "#AddToCart";
            }
            window.BSS_B2B.executeAction({tag: 'change_variant', storeId: 13871, shopData});
            window.BSS_B2B.executeAction({tag: 'change_variant', storeId: 14806, shopData, customAttr});
            let addToCartBtn = null;
            if(addToCartQuickViewSelector !== ''){
                addToCartBtn = document.querySelector(addToCartQuickViewSelector);
            }

            if(addToCartBtn){
                addToCartBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_B2B.cart.fixer(shopData, false, false);
                        if(BSS_B2B.storeId === 11985){ 
                            BSS_B2B.cp.changeProductPrice(shopData, customAttr, false, true);
                        }
                    }, 2000);
                });
            }
        });
    }

    if (BSS_B2B.storeId === 9745) {
        ['bssEventModalWishlistShow', 'bssEventModalCompareShow', 'bssEventModalProduct'].forEach((event) => {
            let customAttr = null;
            if(event === 'bssEventModalCompareShow') {
                customAttr = '.product-shop-stock-price ';
            } else if (event === 'bssEventModalWishlistShow') {
                customAttr = '#wishlistTableList .special-price ';
            } else if(event === 'bssEventModalProduct'){
                customAttr = '.product-quick-view ';
            }
            document.addEventListener(event, () => {
                BSS_B2B.cp.changeProductPrice(shopData, customAttr, false);
                const listAddToCartBtn = document.querySelectorAll('.add-cart-compare.btn-button, .btn-button.add-cart.add-cart-wishlist, .btn-cart.add-to-cart');
                listAddToCartBtn.forEach((addToCartBtn) => {
                    addToCartBtn.addEventListener('click', () => {
                        setTimeout(() => {
                            BSS_B2B.cart.fixer(shopData, false, false);
                        }, 2000);
                    });
                });
            });
        });
    }

    if (BSS_B2B.storeId === 8219) {
        const quickView = document.querySelectorAll('button.product-card-quickview');
        if (quickView.length) {
            for (let i = 0; i < quickView.length; i++) {
                quickView[i].addEventListener('click', function () {
                    const catchQuickView = setInterval(() => {
                        const quickViewActive = document.querySelector('#Product-Drawer.side-panel.product-drawer.active');
                        if (quickViewActive) {
                            BSS_B2B.cp.changeProductPrice(shopData, "#Product-Drawer .side-panel-inner #Product-Drawer-Content .product-price-container .amount span", false);
                            const variantBtn = document.querySelectorAll('variant-selects .variations .product-form__input label');
                            if (variantBtn.length) {
                                for (let j = 0; j < variantBtn.length; j++) {
                                    variantBtn[j].addEventListener('click', function () {
                                        setTimeout(() => {
                                            BSS_B2B.cp.changeProductPrice(shopData, "#Product-Drawer .side-panel-inner #Product-Drawer-Content .product-price-container .amount span", false);
                                        }, 1000);
                                    });
                                }
                            }
                            clearInterval(catchQuickView);

                            const addToCartQuickView = document.querySelector('button#AddToCart');
                            if (addToCartQuickView) {
                                addToCartQuickView.addEventListener('click', function () {
                                    setTimeout(function () {
                                        BSS_B2B.cart.fixer(shopData, false, false);
                                        BSS_B2B.handleQuantityChangeAjaxCart(true);
                                    }, 2000);
                                });
                            }
                        }
                    }, 500);
                    setTimeout(() => {
                        clearInterval(catchQuickView);
                    }, 5000);
                });
            }
        }
    }
    if (BSS_B2B.storeId === 9209) {
        const quickView = document.querySelectorAll('.card__content .quick-add button.open-quick-view');
        if(quickView){
            for (let i = 0; i < quickView.length; i++) {
                quickView[i].addEventListener('click', function () {
                    const catchQuickView = setInterval(() => {
                        const quickViewActive = document.querySelector('.product.product--large.product--left');
                        if (quickViewActive) {
                            BSS_B2B.cp.changeProductPrice(shopData, false , false);
                        }
                    }, 500);
                    setTimeout(() => {
                        clearInterval(catchQuickView);
                    }, 5000);
                });
            }
        }
    }
    
    if (BSS_B2B.storeId === 7691) {
        $('.quick-view__summary').on('click', function () {
            let schedule = setInterval(() => {
                let cartForm = document.querySelector('.no-js-hidden .price');
                if (cartForm) {
                    BSS_B2B.cp.changeProductPrice(shopData);
                    clearInterval(schedule);
                }
            }, 1000);
            setTimeout(() => {
                clearInterval(schedule);
            }, 10000)
        });
    }
    if (BSS_B2B.storeId === 5273) {
        handleSingleQuickview(
            'button[data-quickshop-full]',
            '.modal.modal--quickshop-full form[action="/cart/add"]',
            BSS_B2B, shopData,".modal.modal--quickshop-full .modal-content .product-main", 10, true);
        handleSingleQuickview(
            '.productitem--action-trigger[data-variant-id][data-quickshop-slim]',
            '.product-block--form .product-form--regular form[action="/cart/add"]',
            BSS_B2B, shopData,".product-main .product-block--price", 10, true);
    }

    $('a.full-width-link').on("click", function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '[data-product-modal-wrapper] form[action*="/cart/add"],' +
                '.modal.modal--quick-shop.modal--is-active[data-product-id] form[action*="/cart/add"]'
            );
            if (cartForm.length) {
                BSS_B2B.makeCloneBuyItNow(cartForm);
            }
        }, 2000)
    })
    $('.quick-product__btn[data-product-id]').on("click", function () {
        setTimeout(function () {
            $('.shopify-payment-button__button').fadeIn();
        }, 500)
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '.modal.modal--quick-shop.modal--is-active[data-product-id] form[action*="/cart/add"]'
            );
            if (cartForm.length) {
                BSS_B2B.makeCloneBuyItNow(cartForm);
            }
        }, 1500)
    })
    $('.productitem--action-trigger[data-quickshop-full], .productitem--action-trigger[data-quickshop-slim]').on("click", function () {
        setTimeout(function () {
            $('.shopify-payment-button__button').fadeIn();
        }, 500)
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '.modal.modal--quickshop-full[data-modal-container] form[action*="/cart/add"],'
                + '.modal.modal--quickshop-slim[data-modal-container] form[action*="/cart/add"]'
            );

            if (cartForm.length) {
                let closestProductMain = cartForm.closest('.product-main');
                if(BSS_B2B.storeId === 14255) {
                    closestProductMain = cartForm.closest('.product-details');
                    $(closestProductMain).find('[bss-b2b-product-active]').removeAttr('bss-b2b-product-active');
                }
                $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                // fix for top-3-sources
                if ([66, 778].indexOf(BSS_B2B.storeId) !== -1) {
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                } else if([8113].includes(BSS_B2B.storeId)) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false)
                } 
                else {
                    BSS_B2B.cp.changeProductPrice(shopData, "." + $(closestProductMain).attr('class').split(" ")[0] + " [bss-b2b-product-parent-price]", cartForm)
                }
                $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.makeCloneBuyItNow(cartForm);
            }
        }, 1500)
    })
    $('.product-block__inner .cc-quick-buy-btn-container .cc-quick-buy-btn').on('click', function () {
        setTimeout(()=>{
			const productPrice = document.querySelector('.product-detail__form .price-area .current-price.theme-money[bss-b2b-product-id][bss-b2b-product-price]');
            let changeVariantOptionProductPages = document.querySelectorAll('.product-detail__form .clickyboxes [data-value][href="#"]');
			if (productPrice) {
				setTimeout(()=>{
					BSS_B2B.cp.changeProductPrice(shopData, false, '.product-detail__form form[action="/cart/add"]');
				}, 1500)
			}
            if (changeVariantOptionProductPages.length) {
                for (let i = 0; i < changeVariantOptionProductPages.length; i++) {
                    let optionEle = changeVariantOptionProductPages[i];
                    optionEle.onclick = function () {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, '.current-price.theme-money', '.product-detail__form form[action="/cart/add"]');
                        }, 1500);
                    }
                }
            }            
        }, 2000)
    })
    if (BSS_B2B.storeId !== 14806) {
        $('a[data-fancybox].quick').on("click", function () {
            setTimeout(function () {
                $('.shopify-payment-button__button').fadeIn();
            }, 500)
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();
                var cartForm = $(
                    '#product-id-product-template-quick form[action*="/cart/add"]'
                );
    
                if (cartForm.length) {
                    var closestProductMain = cartForm.closest('#product-id-product-template-quick');
                    $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, "." + $(closestProductMain).attr('class').split(" ")[0] + " [bss-b2b-product-parent-price]", cartForm)
                    $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.makeCloneBuyItNow(cartForm);
                }
            }, 1500)
        })
    }

    $('button.product-item__action-button[data-action="open-modal"]').on("click", function () {
        setTimeout(function () {
            $('.shopify-payment-button__button').fadeIn();
        }, 500)
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '#modal-quick-view-collection-template form[action*="/cart/add"]'
            );

            if (cartForm.length) {
                var closestProductMain = cartForm.closest('#modal-quick-view-collection-template');
                $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, "#" + $(closestProductMain).attr('id').split(" ")[0] + " [bss-b2b-product-price]", cartForm)
                $(closestProductMain).find('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.makeCloneBuyItNow(cartForm);
            }
        }, 1500)
    })
    // fix for becue

    //end
    //fix for dollie-wholesale
    $('.product-card__buttons a.js-btn-quickview').on('click', function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '.product-quickview .content_product_detail'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, ".bss-customize-cp", cartForm, true);
                $('.single-option-selector').on("click", function () {
                    $('.product-quickview__price .price-container [bss-b2b-product-price]').css("opacity", "0")
                    BSS_B2B.cp.changeProductPrice(shopData, ".bss-customize-cp", false, true);
                    setTimeout(function () {
                        $('.product-quickview__price .price-container [bss-b2b-product-price]').css("opacity", "1")
                    }, 500)
                })
            }
        }, 2000)
    })

    // fix for moose-creek-screenprint by CuongNVM
    $('.usf-facet-values button,.usf-c-select__btn.usf-btn,.usf-view.usf-btn,.usf-remove').on("click", function() {
        setTimeout(function(){
            BSS_B2B.cp.changeProductPrice(shopData, null, null);
        },1000)
    })

    // fix for southeastedibles2020 (madu)
    if (BSS_B2B.storeId == 243) {
        $('.quick-product__btn').on('click', function () {
            setTimeout(function () {
                BSS_B2B.applyChangePriceForCollectionPage();
            }, 1500)
        })
    }
    //fix for nobby by XuTho
    $('a.quick-view').on("click", function () {//click button quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'form[action*="/cart/add"].productForm'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.makeCloneBuyItNow(cartForm);
                $('button#AddToCart-quickView').on("click", function () {//add to cart from quick view
                    setTimeout(function () {
                        BSS_B2B.applyChangePriceForMultiCartForm();
                        var cartForm = $(
                            'form[action*="/cart"]'
                        );
                        if (cartForm.length) {
                            BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                            BSS_B2B.makeCloneBuyItNow(cartForm);
                            BSS_B2B.applyChangePriceForCollectionPage();
                            BSS_B2B.handleAjaxCart();
                        }
                    }, 1000)
                })
            }
        }, 1000)
    })
    $('a.add-to-cart').on("click", function () {//click quick add to cart
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'form[action*="/cart"]'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.makeCloneBuyItNow(cartForm);
                BSS_B2B.applyChangePriceForCollectionPage();
                BSS_B2B.handleAjaxCart();
            }
        }, 1000)
    })
    //fix for hlh-biopharma-gmbh.myshopify.com by ThaBi
    $('a.quick-add-button-variants').on("click", function () {
        setTimeout(function () {
            var cartForm = $(
                'form[action*="/cart"]'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm[0]);
                setTimeout(function () {
                    BSS_B2B.makeCloneBuyItNow(cartForm[0]);
                }, 2000)
            }
        }, 1000)
    })
    // Fix for dispeldice by Devlin
    $('button.quick-product__btn').on("click", function () {
        const btnQuickView = this;
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            const modalElem = btnQuickView.closest('.grid__item.grid-product').querySelector('.modal.modal--square[data-product-id]')
            if (modalElem) {
                const cardForm = document.querySelectorAll(`#${modalElem.id} form[action*="/cart/add"]`)
                if (cardForm.length) {
                    BSS_B2B.makeCloneBuyItNow(cardForm[0]);
                }
            }
        }, 3000)
    })

    // quickview fix ama-demo-store.myshopify.com
    $('.btn.quick-view-text.product_link').on('click', function () {
        if ($(this).closest('.products').length) {
            let productId = $(this).closest('.products').find('.product-detail [bss-b2b-product-id]').attr('bss-b2b-product-id');
            $(document).find('.price.h6[bss-b2b-product-id]').attr('bss-b2b-product-id', productId)
            $(document).find('.compare-price[bss-b2b-product-id]').attr('bss-b2b-product-id', productId)
            $(document).find('.details.clearfix .total-price[bss-b2b-product-id]').attr('bss-b2b-product-id', productId)
            $(document).find('.details.clearfix .total-price .h5[bss-b2b-product-id]').attr('bss-b2b-product-id', productId)
        }
    });

    //fix for Hi-Lux, caosgear by CuongNVM
    if ([3351, 5908].indexOf(BSS_B2B.storeId) !== -1) {
        $('.quick_shop.button.action_button.js-quick-shop-link').on('click', function () {
            let element = $(this);
            let productId = element.parent().parent().find('.product-thumbnail__price.price').attr('bss-b2b-product-id')
            if (BSS_B2B.storeId == 5908) {
                productId = element.closest('.product-wrap').find('.sale-price.mm4').attr('bss-b2b-product-id');
            }
            var cartForm = $('.quick-shop__text-wrap');
            var parentLevel2 = cartForm.parent();
            $('.swatch-element').on('click', function () {
                setTimeout(function () {
                    $('.quick-shop__text-wrap .current_price .money').css('visibility', 'hidden');
                    $(document).find('.quick-shop__text-wrap .current_price .money').attr('bss-b2b-product-id', productId);
                    $(document).find('.quick-shop__text-wrap .current_price .money').attr('bss-b2b-product-price', '');
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                }, 1000)
            });
            setTimeout(function () {
                $(document).find('.quick-shop__text-wrap .current_price .money').attr('bss-b2b-product-id', productId);
                $(document).find('.quick-shop__text-wrap .current_price .money').attr('bss-b2b-product-price', '');
            }, 1000)
        });
    }
    // fix for test-demo-store11.myshopify by LuanHV
    if (BSS_B2B.storeId === 5969) {
        $('.single-product-wrap .product-image .quick-view').on('click', function () {
            let element = $(this);
            let productId = element.parent().parent().find('.product-content .price-box .new-price').attr('bss-b2b-product-id')
            setTimeout(function () {
                var cartForm = $('.modal-body .quick-view-content');
                $('.quick-view-content .price-part .new-price').css('visibility', 'hidden');
                $(document).find('.quick-view-content .price-part .new-price').attr('bss-b2b-product-id', productId);
                $(document).find('.quick-view-content .price-part .new-price').attr('bss-b2b-product-price', '');
                BSS_B2B.applyChangePriceForMultiCartForm();
                if (cartForm.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    BSS_B2B.applyChangePriceForCollectionPage();
                    BSS_B2B.handleAjaxCart();
                }
            }, 1000)
        });
       $('.modal-content .modal-header .close').on('click', function () {
         $('.modal-body>.quick-view-content>.price-part>.new-price').removeAttr('bss-b2b-product-id');
          $('.modal-body>.quick-view-content>.price-part>.new-price').removeAttr('bss-b2b-product-price');
          $('.modal-body>.quick-view-content>.price-part>.new-price').removeAttr('bss-b2b-product-active');
          $('.modal-body>.quick-view-content>.price-part').removeAttr('bss-b2b-product-id');
          $('.modal-body>.quick-view-content>.price-part').removeAttr('bss-b2b-product-price');
           $('.modal-body>.quick-view-content>.price-part>.bss-b2b-customized-compare-at-price').remove();
      });
    }
    //fix voyage-trade by XuTho support ThaBi
    $('a.qs-button, button.btn-cart').on("click", function () {//click button quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $('form[data-form="cdz-mini-cart"], div.product-info-main');
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.makeCloneBuyItNow(cartForm);
                $('a.btn-cart, button.btn-update-qty').on("click", function () {//add to cart from quick view
                    setTimeout(function () {
                        BSS_B2B.applyChangePriceForMultiCartForm();
                        var cartFormMini = $(
                            'div.block-content'
                        );
                        if (cartFormMini.length) {//show mini cart and price
                            BSS_B2B.handleAjaxCart();
                            BSS_B2B.handleCartCheckoutBtn(shopData)
                        }
                    }, 1200)
                })
            }
        }, 1000)
    })
    $('button.btn-update-qty, a.btn-cart, a.btn-remove.update-cart-btn').on("click", function () {//add to cart from quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartFormMini = $(
                'div.block-content'
            );
            if (cartFormMini.length) {//show mini cart and price
                BSS_B2B.cp.changeProductPrice(shopData, false, cartFormMini);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData)
            }
        }, 1200)
    })
    //fix for packaging by XuTho
    $('a.quick-view-btn').on("click", function () {//click button quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'form[action*="/cart/add"].shopify-product-form'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                $('input#addToCart').on("click", function () {//add to cart from quick view
                    setTimeout(function () {
                        BSS_B2B.applyChangePriceForMultiCartForm();
                        var cartForm = $(
                            'form[action*="/cart"]'
                        );
                        if (cartForm.length) {
                            BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                            BSS_B2B.handleAjaxCart();
                        }
                    }, 1000)
                })
            }
        }, 1000)
    })
    $('input.cart-popup, input#addToCart').on("click", function () {//add to cart from quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'form[action*="/cart"]'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.handleAjaxCart();
            }
        }, 1000)
    })

    $('button[id^="quick-add-template"]').on('click', function() { // add to cart from quick view
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            let modalQuickView = $('div[id^="QuickAddInfo"]');
            let cartForm = $(
            'div[id^="QuickAddInfo"] form[action*="/cart"]'
            );
            if (modalQuickView.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm[0], true);
                BSS_B2B.applyChangePriceForCollectionPage();
                BSS_B2B.handleAjaxCart();
            }
        }, 2000)
    })


    //fix monpetitherbier by vitu
    $('span.quick_shop.ss-icon.js-quick-shop-link').on("click", function () {//click button quick view
        setTimeout(function () {
            var cartForm = $(
                'form[action*="/cart/add"]'
            );
            if (BSS_B2B.storeId == 4094) {
                cartForm = $('.js-quick-shop form[action*="/cart/add"]');
                if (cartForm.length > 0) {
                    $(cartForm).find('.swatch_options div.swatch-element').on('click', function () {
                        BSS_B2B.changeVariantOptionProductPage(cartForm.closest('.quick-shop__text-wrap'), cartForm);
                    });
                }
            }
            BSS_B2B.cp.changeProductPrice(shopData, false, cartForm)
            $('button.ajax-submit.action_button.add_to_cart').on("click", function () {//add to cart from quick view
                setTimeout(function () {
                    if (cartForm.length) {
                        BSS_B2B.handleAjaxCart();
                    }
                }, 500)
            });
        }, 1000)
    })
    //fix for viastara by XuTho
    $('span.quick_shop').on("click", function () {//click quick view
        // fix for treflewholesale (madu)
        if (BSS_B2B.storeId == 1788) {
            let productId = $(this).attr('data-id');
            let priceEl = $('.price__container.price__container--display-price-true .current_price');
            priceEl.hide();
            priceEl.attr('bss-b2b-product-id', productId);
            priceEl.attr('bss-b2b-product-price', '');
            priceEl.removeAttr('bss-b2b-product-active');
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();
                var cartForm = $(
                    'div.quick-shop__text-wrap'
                );
                if (cartForm.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    $('button.button--add-to-cart').on("click", function () {//add to cart from quick view
                        setTimeout(function () {
                            BSS_B2B.applyChangePriceForMultiCartForm();
                            var cartForm = $(
                                'form.ajax-cart__form[action*="/cart"]'
                            );
                            if (cartForm.length) {
                                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                                BSS_B2B.handleAjaxCart();
                                BSS_B2B.handleCartCheckoutBtn(shopData)
                            }
                        }, 2200)
                    });

                    //    handle variant product
                    $(cartForm).find('div.swatch-element').on("click", function () {
                        let productId = $(this).attr('data-id');
                        let priceEl = $('.price__container.price__container--display-price-true .current_price');
                        priceEl.hide();
                        priceEl.attr('bss-b2b-product-id', productId);
                        priceEl.attr('bss-b2b-product-price', '');
                        priceEl.removeAttr('bss-b2b-product-active');
                        BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    })
                }
            }, 1000)
        } else {
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();
                var cartForm = $(
                    'div.quick-shop__text-wrap'
                );
                if (cartForm.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    $('button.button--add-to-cart').on("click", function () {//add to cart from quick view
                        setTimeout(function () {
                            BSS_B2B.applyChangePriceForMultiCartForm();
                            var cartForm = $(
                                'form.ajax-cart__form[action*="/cart"]'
                            );
                            if (cartForm.length) {
                                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                                BSS_B2B.handleAjaxCart();
                                BSS_B2B.handleCartCheckoutBtn(shopData)
                            }
                        }, 2200)
                    })
                }
            }, 1000)
        }
    })
    //fix for purveyd by XuTho
    if (BSS_B2B.storeId !== 14806) {
        $('a.quick.btn.auto-width').on("click", function () {//click quick shop
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();
                var cartForm = $(
                    'div.product-product-template-quick'
                );
                if (cartForm.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    $('input.add-to-cart').on("click", function () {//add to cart from quick view
                        setTimeout(function () {
                            BSS_B2B.applyChangePriceForMultiCartForm();
                            var cartForm = $(
                                'ul.clearfix.account-active'
                            );
                            if (cartForm.length) {
                                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                                BSS_B2B.handleAjaxCart();
                            }
                        }, 1500)
                    })
                }
            }, 1000)
        })
    }
    // fix for easyagores.com by hoaduong
    $('.quick_shop').on("click", function () {
        setTimeout(() => {
            BSS_B2B.cp.changeProductPrice(shopData, false, false)
        }, 1000)
    })
    // fix for www.groomus.dk by hoaduong,cuongnvm
    $('button.btn.btn--circle.btn--icon.quick-product__btn,button.quick-add-btn').on("click", function () {
        if (BSS_B2B.storeId == 4653) {
            let quickViewButtonCheckTimes = 0;
            let productId = $(this).parent().parent().find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
            let checkDisplayQuickView = setInterval(function () {
                let quickViewEle = $('.modal__inner .product-block--price')
                let quickViewWithSameId = false;
                quickViewEle.each(function () {
                    let element = $(this);
                    let quickViewEleProId = element.find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
                    if (productId === quickViewEleProId) {
                        quickViewWithSameId = true;
                    }
                })
                if (quickViewWithSameId || quickViewButtonCheckTimes > 20) {
                    clearInterval(checkDisplayQuickView);
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    BSS_B2B.applyChangePriceForMultiCartForm();
                    $('.variant-input-wrap').on("change", function () {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, '.modal__inner .product-block--price .product__price', false)
                        }, 1000)
                    })
                }
                quickViewButtonCheckTimes += 1;
            }, 500)
        }
    })
    //fix for spiritly.com by LuanHV
    if (BSS_B2B.storeId === 7566) {
        let checkDisplayButtonQuickView = setInterval(() => {
            $('.grid-product__image-mask .quick-product__btn').on("click", function () {
                let productId = $(this).parent().parent().find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
                let checkDisplayQuickView = setInterval(() => {
                    let quickViewEle = $('.modal--square.modal--quick-shop')
                    let quickViewWithSameId = false;
                    quickViewEle.each(function () {
                        let element = $(this);
                        let quickViewEleProId = element.find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
                        if (productId === quickViewEleProId) {
                            quickViewWithSameId = true;
                        }
                    })
                    if (quickViewWithSameId) {
                        clearInterval(checkDisplayQuickView);
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }
                }, 500);
                setTimeout(() =>{
                    clearInterval(checkDisplayQuickView);
                }, 5000)
            });
        }, 500)
        setTimeout(() =>{
            clearInterval(checkDisplayButtonQuickView);
        }, 5000)
    }   
    // fix for repairpartners by ThaBi
    $('a.quick-view-text').on("click", function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                '.quick-view form[action*="/cart/add"]'
            );

            if (cartForm.length) {
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                $('.prices.product_price[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('.price.h2[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData);
                $('.single-option-selector').on("change", function () {
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                    $('.price.h2[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, ".price.h2", cartForm)
                })
            }
        }, 500)
    })

    // fix for sharmusic
    $('.product-item__quick-form > button').on("click", function () {
        if (BSS_B2B.storeId === 10676) {
            let time = 0;
            let checkDisplayQuickView = setInterval(function () {
              time += 2000;
              let priceQuickViewEle = $('.drawer--quick-buy[open] .price-list');
              if (priceQuickViewEle.length > 0) {
                BSS_B2B.cp.changeProductPrice(shopData, ".quick-buy-product__info .price-list .price", false);
                $(".block-swatch").on("click", function () {
                    BSS_B2B.cp.changeProductPrice(shopData, ".quick-buy-product__info .price-list .price", false);
                })

                $(".color-swatch__radio").on("click", function () {
                    BSS_B2B.cp.changeProductPrice(shopData, ".quick-buy-product__info .price-list .price", false);
                })
                clearInterval(checkDisplayQuickView);
             }
            if(time >= 6000) {
              clearInterval(checkDisplayQuickView);
            }
          }, 2000)
        }
    })

    // click quick shop by XuTho or ViTu
    $('button.btn.btn--circle.btn--icon.quick-product__btn').on("click", function () {
        if (BSS_B2B.storeId == 2492) {
            // fix for winecollectiveplus by ThaBi
            let checkDisplayQuickView = setInterval(function () {
                let priceQuickViewEle = $('.modal__inner .product-block--price');
                if (priceQuickViewEle.length > 0) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    clearInterval(checkDisplayQuickView)
                }
            }, 1000)
        } else {
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();

                var cartForm = $(
                    'form[action*="/cart/add"]'
                );
                if (cartForm.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                    BSS_B2B.handleAjaxCart();
                    BSS_B2B.handleCartCheckoutBtn(shopData)
                }
            }, 1000)
        }
    })

    // fix for industrial-athletic (tuli)
    $('.tt-btn-quickview').on('click', function () {
        let parent = $(this).closest('.respimgsize')
        let correctParent = $(parent).find('[bss-b2b-product-id]')
        let correctId = null
        if (correctParent.length) {
            correctId = $(correctParent).attr('bss-b2b-product-id')
        }
        let quickViewModal = $('.modal-dialog.modal-lg').find("[bss-b2b-product-price]")
        $(quickViewModal).removeAttr('bss-b2b-product-active')
        $(quickViewModal).css('visibility', 'hidden')
        $(quickViewModal).attr('bss-b2b-product-id', correctId)
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'form[action*="/cart/add"]#modal_quick_view'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData)
            }
        }, 500)
    })
    // fix for studyphones by ThaBi
    $('a.btn.product-loop__quickview').on("click", function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $('#quick form[action*="/cart/add"]');

            if (cartForm.length) {
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData);

                $(cartForm).find('div.swatch-element').on("click", function () {
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                })

                let buttonChangeQuantity = $('#quantity-plus, #quantity-minus')
                buttonChangeQuantity.on("click", function () {
                    $('#quick form[action*="/cart/add"] [bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                    $('#quick form[action*="/cart/add"] [bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                    $('#quick form[action*="/cart/add"] [bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    $('#quick form[action*="/cart/add"] [bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, null, false, true);
                })
            }
        }, 2000)
    })

    // fix for b2b-reinh-art by ThaBi
    $('a.upsell_qv.js_add_qv.tooltip_left').on('click', function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            BSS_B2B.cp.changeProductPrice(shopData, null, false);
            BSS_B2B.handleAjaxCart();
            BSS_B2B.handleCartCheckoutBtn(shopData)
        }, 2000)
    })
    //fix for sohogirl by XuTho
    $('a.button-quick-view').on("click", function () {//click quick shop
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $(
                'div.product-page-info'
            );
            if (cartForm.length) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                $('button.js-product-button-add-to-cart').on("click", function () {//add to cart from quick view
                    setTimeout(function () {
                        BSS_B2B.applyChangePriceForMultiCartForm();
                        var cartForm = $(
                            'div.popup-cart__content'
                        );
                        if (cartForm.length) {
                            BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                            BSS_B2B.handleAjaxCart();
                        }
                    }, 1500)
                })
                $('div.product-options__value').on("click", function () {
                    setTimeout(function () {
                        BSS_B2B.applyChangePriceForMultiCartForm();
                      
                        var cartForm = $(
                           'div.product-page-info'
                        );
                        if (cartForm.length) {
                            BSS_B2B.cp.changeProductPrice(shopData, ".product-page-info__price .price", cartForm);
                        }
                    }, 1500)
                })
            }
        }, 1000)
    });

    // fix change variant on quickview
    $('[data-secondary-action=open-quick-view]').on("click", function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $('.card__section form[action*="/cart/add"]');

            if (cartForm.length) {
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData);

                $(cartForm).find('.block-swatch__item').on("click", function () {
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                    const formId = $(cartForm).attr('id');
                    if (BSS_B2B.storeId == 4902) {
                        BSS_B2B.cp.changeProductPrice(shopData, '.product-form__info-content .price-list', cartForm, false)
                    } else {
                        BSS_B2B.cp.changeProductPrice(shopData, '#' + formId + ' ', false);
                    }
                })

            }
        }, 2000)
    });
    // fix for baltarugs by mitri
    $('.quick-shop__buttons').on("click", function () {
        setTimeout(function () {
            BSS_B2B.applyChangePriceForMultiCartForm();
            var cartForm = $('.js-quick-shop form[action*="/cart/add"]');

            if (cartForm.length) {
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm, true);
                BSS_B2B.handleAjaxCart();
                BSS_B2B.handleCartCheckoutBtn(shopData);

                $(cartForm).find('.swatch-element').on("click", function () {
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                    $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                    $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm, true);
                })
                if (BSS_B2B.storeId === 3351) {
                    $(cartForm).find('[data-dropdown-form-style]').on("change", function () {
                    
                        $('[bss-b2b-product-id][bss-b2b-product-parent-price]').css("visibility", "hidden");
                        $('[bss-b2b-product-id][bss-b2b-product-price]').css("visibility", "hidden");
                        $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                        $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                        BSS_B2B.cp.changeProductPrice(shopData, null, cartForm, true);
                    })
                }
            }
        }, 2000)
    })
    //fix acomax-de search ajax by vitu
    $('.search-bar__input').keypress(function () {
        setTimeout(function () {
            if ($('.search-bar__result-products') && BSS_B2B.storeId !== 5241) {
                BSS_B2B.cp.changeProductPrice(shopData, false, $('.search-bar__result-products'), true);
            }
        }, 700)
    })

    //fix combatironapparel search ajax by Dikans
    if (BSS_B2B.storeId === 7509) {
        let searchInput = $('input[type="search"].site-header__search-input');
        if (searchInput) {
            searchInput.on('change', function () {
                setTimeout(function () {
                    if ($('#PredictiveWrapper .grid.grid--uniform')) {
                        BSS_B2B.cp.changeProductPrice(shopData, false, $('.search-bar__result-products'), true);
                    }
                }, 1000)
            })
        }
    }

    if (BSS_B2B.storeId == 3966) {
        $('.shop-now-button').on("click", function () {
            setTimeout(function () {
                BSS_B2B.applyChangePriceForMultiCartForm();
                var cartForm = $('.form-vertical form[action*="/cart/add"]');

                if (cartForm.length) {
                    $(cartForm).find('[bss-b2b-current-variant-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                }
            }, 2000)
        })
    }

    if (BSS_B2B.storeId == 4101) {
        $('.product-grid-item .product-button').on('click', function () {
            setTimeout(function () {
                var cartForm = $('.modal.show form[action*="/cart/add"]');
                var parentLevel2 = $(cartForm).parent().parent();
                $('select.single-option-selector[data-option]').on('change', function () {
                    setTimeout(function () {
                        $(parentLevel2).find('.detail-price').removeAttr('bss-b2b-product-active');
                        BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
                    }, 1000);
                });

                if (cartForm.length) {
                    $(cartForm).find('[bss-b2b-current-variant-price]').removeAttr('bss-b2b-product-active');
                    BSS_B2B.cp.changeProductPrice(shopData, false, cartForm);
                }
            }, 1000);
        });
    }
    
    if (BSS_B2B.storeId === 10698) {
        const quickBuyBtn = document.querySelectorAll('.btn.btn--secondary.quickbuy-toggle');
        if (quickBuyBtn.length) {
            quickBuyBtn.forEach((item) => {
                item.addEventListener('click', function() {
                    const handleProductInfoView = setInterval(() => {
                        const quickView = document.querySelector('.product-detail.quickbuy-content');
                        if (quickView) {
                            clearInterval(handleProductInfoView);
                            let cartForm = $('form[action*="/cart/add"]');
                            BSS_B2B.cp.changeProductPrice(shopData, null, false);
                            $('.product-detail .option-selector-fieldset').on("change", function () {
                                setTimeout(function () {
                                    BSS_B2B.cp.changeProductPrice(shopData, '.price-container .price-area', cartForm)
                                }, 1000);
                            });
                        }
                    }, 500);
                    setTimeout(() => {
                        clearInterval(handleProductInfoView);
                    }, 7000)
                });
            });
        }
    }
    if (BSS_B2B.storeId === 3588) {
        let buttonQuickBuy = document.querySelectorAll('li.productgrid--item .productitem--actions button.productitem--action-trigger');
        if (buttonQuickBuy.length) {
            for (let buttonItem of buttonQuickBuy) {
                buttonItem.onclick = function () {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, '.modal--quickshop-slim .product-pricing ', false, true);
                        let variantSelect = document.querySelectorAll('.modal--quickshop-slim select.options-selection__input-select');
                        if (variantSelect.length) {
                            for (let variantSelectOption of variantSelect) {
                                variantSelectOption.onchange = function () {
                                    BSS_B2B.cp.changeProductPrice(shopData, '.modal--quickshop-slim .product-pricing ', false, true);
                                }
                            }
                        }
                    }, 1500);
                }
            }
        }
    }

    if(BSS_B2B.storeId === 6317) {
        const $$ = document.querySelector.bind(document);
        const $$$ = document.querySelectorAll.bind(document);

        const debounceFnc = (callback, timeout = 300) => {
            let timer;

            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { callback.apply(this, args); }, timeout);
            };
        }

        setInterval(() => {            
            const quickViewButtons = $$$('.quickview-button.button');

            quickViewButtons.forEach(btn => {
                const quickViewHandler = () => {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, null, false);

                        const quantityInput = $$('[bss-b2b-quantity-quickview]');

                        const updatePriceWhenChangeQuantity = e => {
                            const cpPriceValue = $$('.productView-price .price-item').textContent.trim();

                            cpPriceValue && ($$('[bss-b2b-price-subtotal-quickview]').textContent = BSS_B2B.formatMoney.call(window, e.target.value * cpPriceValue.slice(1) * 100))
                        }

                        quantityInput.addEventListener('change', updatePriceWhenChangeQuantity) 

                        document.addEventListener('bss_b2b_doneCheckCp', () => {
                            setTimeout(() => {
                                const cpPriceValue = $$('.productView-price .price-item').textContent.trim()
        
                                cpPriceValue && ($$('[bss-b2b-price-subtotal-quickview]').textContent = BSS_B2B.formatMoney.call(window, quantityInput.value * cpPriceValue.slice(1) * 100));
                                $$('[bss-b2b-price-subtotal-quickview]').style.display = ""
                            })
                        })

                        const handleChangeVariant = debounceFnc(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, null, false);
                        }, 2000);
        
                        $$$('.product-form__label').forEach(label => {
                            label.addEventListener('click', () => {
                                $$('[bss-b2b-price-subtotal-quickview]').style.display = "none"
                                handleChangeVariant()
                            })
                        })
                    }, 1000)
                }

                btn.removeEventListener('click', quickViewHandler);
                btn.addEventListener('click', quickViewHandler)
            })

        }, 2000)
    }

    if (BSS_B2B.storeId === 7146) {
        let buttonQuickView = document.querySelectorAll("div.product-grid .grid-item .quick-product__btn");
        if (buttonQuickView.length) {
            for (let buttonItem of buttonQuickView) {
                buttonItem.onclick = function () {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, '.modal__inner .product-grid__container .money-product', false, true);
                    }, 1500);
                }
            }
        }
    }
}
// CONCATENATED MODULE: ./js/src/cp/quickview.js


function handleQuickView($, BSS_B2B, shopData) {
    const storesCloneBuyItNow = [6456,227,181];
    const storesHandleAjaxCart = [227,4856,6765,2262];
    const storesHandleCheckoutBtn = [2262, 12023];
    const delayOpenQuickView = () => {
        let timer = 2000;
        if ([227].includes(BSS_B2B.storeId)) {
            timer = 1500;
        }
        return timer
    }

    const delayAddEventBtn = () => {
        let timer = 0
        if ([8653, 7977].includes(BSS_B2B.storeId)) {
            timer = 1000;
        }
        return timer
    }

    const fixSelectVariantChange = (customAttr, inputEl, cartForms) => {
        inputEl.addEventListener('change', () => {
            $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
            $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
            BSS_B2B.cp.changeProductPrice(shopData, customAttr, cartForms, true)
        })
    }

    setTimeout(() => {
        const buttonQuickView = document.querySelectorAll(BSS_B2B.helper.buttonQuickViewElements);
        buttonQuickView.forEach((element) => {
            element.addEventListener("click", () => {
                setTimeout(function () {
                    const cartForms = document.querySelectorAll(BSS_B2B.helper.cartFormQuickView);
                   
                    if (cartForms && cartForms.length) {
                        if ([13453, 10074, 14101, 14064, 14874, 15023, 16064].includes(BSS_B2B.storeId)) {
                            BSS_B2B.cp.changeProductPrice(shopData, false, false)
                        }else{
                            BSS_B2B.cp.changeProductPrice(shopData, false, cartForms, true)
                        }
                        storesCloneBuyItNow.includes(BSS_B2B.storeId) && BSS_B2B.makeCloneBuyItNow(cartForms);
                        storesHandleAjaxCart.includes(BSS_B2B.storeId) && BSS_B2B.handleAjaxCart();
                        storesHandleCheckoutBtn.includes(BSS_B2B.storeId) && BSS_B2B.handleCartCheckoutBtn(shopData);
                        
                        //filter elements has variantId
                        let childrenEl = [];
                        cartForms.forEach((item) => {
                            const variantEl = item.querySelectorAll(`select[name="id"], input[name="id"], select[data-variant-input], .option-lists`)
                            variantEl.length && childrenEl.push(...variantEl)
                        });
                        childrenEl = childrenEl.flat();
                        if (childrenEl.length) {
                            childrenEl.forEach((item) => {
                                let observer = new MutationObserver(function (mutations) {
                                    mutations.forEach(function (m) {
                                        if (m.attributeName == "value") {
                                            setTimeout(() => {
                                                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                                                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');

                                                let variantId = item.value || item.getAttribute('value');
                                                BSS_B2B.cp.changeProductPrice(shopData, false, m.target, true, variantId);
                                            }, 500)
                                        }
                                    });
                                });
                                observer.observe(item, { attributes: true });

                                if (BSS_B2B.storeId == 10295) {
                                    fixSelectVariantChange(`[data-product-price]`, item, cartForms)
                                }
                            })
                        }
                    }
                }, delayOpenQuickView())
            })
        })
    }, delayAddEventBtn());

    fixQuickView($, BSS_B2B, shopData)
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(17)
var ieee754 = __webpack_require__(18)
var isArray = __webpack_require__(19)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateDateTime; });
function validateDateTime(start_date, end_date, start_time, end_time, enable_end_date) {
  let now = new Date()
  const start = start_date
  const end = end_date
  const [h1, m1] = start_time.split(':')
  const [h2, m2] = end_time.split(':')
  start.setHours(Number(h1), Number(m1), 0, 0)
  end.setHours(Number(h2), Number(m2), 0, 0)
  if(enable_end_date === 0) {
    if(start > now) {
      return true
    } else {
      return false
    }
  } else if(enable_end_date === 1) {
    if(start > now || end < now) {
      return true
    } else {
      return false
    }
  }
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return encode; });
async function encode(data, key){
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(JSON.stringify(data));
    const encodedKey = encoder.encode(key);

    // Mã hóa HMAC-SHA256
    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      encodedKey,
      { name: 'HMAC', hash: { name: 'SHA-256' } },
      false,
      ['sign']
    );

    const signatureBuffer = await crypto.subtle.sign('HMAC', cryptoKey, encodedData);
    // eslint-disable-next-line spellcheck/spell-checker
    const signature = btoa(String.fromCharCode.apply(null, new Uint8Array(signatureBuffer)));
    return signature;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initQb; });
/* harmony import */ var _taxexem_tax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_taxexem_tax__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _qb_feature_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _qb_on_collection_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
/* harmony import */ var _cp_quickview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);






function initQb(
    $, BSS_B2B, shopData, Shopify, isEnableQB, isEnableCP, isEnableMC, isEnabledTD, isEnableBOGO, isEnableAMO) {
    /**
     * For quantity Break
     */
    BSS_B2B.qb = {};
    if (typeof BSS_B2B.calculateModules === 'undefined') {
        BSS_B2B.calculateModules = new Map();
    }
    BSS_B2B.calculateModules.set('QB', {
        enableModule: isEnableQB,
        isDoneCalculate: true,
        priority: 2,
    });
    BSS_B2B.cart.qbPricingList = new Map();
    BSS_B2B.cart.itemsMap = new Map();
    BSS_B2B.qb.appliedQbRuleForOneProduct = false;
    BSS_B2B.qb.appliedQbRuleForCollectionProduct = [];
    BSS_B2B.qb.quantityInputSelectorOnProductPage = [
        'input[type="number"][name="quantity"]',
        'input[type="number"][data-quantity-input]',
        'input[type="number"][class$="quantity"]',
        'input[id^="Quantity"]',
        'input[name="quantity"]',
        'input.quantity-adjuster__input',
        //fix for atacsportswear by CuongNVM
        'input.quantity-selector',
        'input.multivariants_block_qty_input',
        'input[id^="updates_"]',
        'select#product-quantity-select'
    ];
    BSS_B2B.qb.quantityInputSelectorOnQuickView = [
        'div[id^="QuickAddInfo-"] input[type="number"][name="quantity"]',
        'loess-modal-product .modal__inner .quantity__input',
        'form[action="/cart/add"] .quantity-selector__input',
    ];
    BSS_B2B.qb.productTitleSelectorOnProductPage = [
        '.product__title',
        '.product-block-list .product-meta .product-meta__title',
        // fix for ababy-development-store.myshopify.com by quyenpv
        '.productView-meta',
        '.productView-title'
    ];
    BSS_B2B.qb.buttonChangeQuantityOnProductPage = $(
        'form[action="/cart/add"] .qtyminus,' +
        'form[action="/cart/add"] .qtyplus,' +
        // fix for shop-ahika by DangNM
        'form[action="/cart/add"] .quick_view-qty.quick_view-qty-minus,' +
        'form[action="/cart/add"] .quick_view-qty.quick_view-qty-plus,' +
        // fix for watcstudio by DangNM
        'form[action="/cart/add"] button.qty-button.qty-minus,' +
        'form[action="/cart/add"] button.qty-button.qty-plus,' +
        'form[action="/cart/add"] button[type=button].minus,' +
        'form[action="/cart/add"] button[type=button].plus,' +
        //fix for krkcshop by HaiNN
        'form[action="/cart/add"] [data-action="decrease-quantity"].QuantitySelector__Button,' +
        'form[action="/cart/add"] [data-action="increase-quantity"].QuantitySelector__Button,' +
        'form[action="/cart/add"] .quantity a.minus,' +
        'form[action="/cart/add"] .quantity a.plus,' +
        // fix for woodhillboards by Khanh
        '.product__quantity .js-qty__adjust,' +
        //fix for atacsportswear by CuongNVM
        '.quantity-controls .qty-minus,' +
        '.quantity-controls .qty-plus,' +
        '.multivariants_block_qty_box_left, .multivariants_block_qty_box_right,' +
        '.quantity-selector .quantity-selector__wrapper .quantity-selector__button-wrapper .quantity-selector__button,' +
        '.quantity-selector .quantity-selector__button'
    );

    BSS_B2B.qb.buttonChangeQuantityOnQuickView = $(
        'div[id^="QuickAddInfo"] button.quantity__button[name="minus"],' +
        'div[id^="QuickAddInfo"] button.quantity__button[name="plus"]',
    );

    BSS_B2B.qb.modalQuickView = $(
        'div[id^="QuickAddInfo"]',
    );

    if (shopData && shopData.cart) {
        const cartItems = shopData.cart.items;
        if (cartItems && cartItems.length > 0) {
            cartItems.forEach((cartItem) => {
                const { key } = cartItem;
                BSS_B2B.cart.itemsMap.set(key, cartItem);
            });
        }
    }

    BSS_B2B.qb.defaultLineItemCssSelector = function (key) {
        let cssSelector = '[data-cart-item-key="' + key + '"] .product-details';
        if (BSS_B2B.storeId === 4706) {
            cssSelector = '[data-cart-item-key="' + key + '"] .item_price';
        }
        if (BSS_B2B.storeId === 15447) {
            cssSelector = '[data-cart-item-key="' + key + '"] .cart__meta';
        }
        return cssSelector;
    };

    BSS_B2B.qb.lineItemCssSelector = function (key) {
        return '[data-cart-item-key="' + key + '"] .bss-b2b-qb-table';
    };

    BSS_B2B.qb.quantityInputSelectorOnCartPage = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] input[type="number"]',
            '[data-cart-item-key="' + key + '"] input[data-quantity-input]',
            '[data-cart-item-key="' + key + '"] input[data-cart-item-input-quantity]',
            '[data-cart-item-key="' + key + '"] input.js-qty__input',
            '[data-cart-item-key="' + key + '"] input.js-qty__num',
            '[data-cart-item-key="' + key + '"] input.ajaxifyCart--num', // fix panam-decor-and-gift by vitu
            '[data-cart-item-key="' + key + '"] input.cart-item__quantity-input', //fix for contact-hu by khanh
            '[data-cart-item-key="' + key + '"] input[type="text"]', //fix for bingltd
            '[data-cart-item-key="' + key + '"] input.quantity-adjuster__input'];
    };

    /**
     *  cart price element of each item in cart page
     */
    BSS_B2B.qb.priceOfEachItemElement = function (key) {
        let queryArr = [
            '[data-cart-item-key="' + key + '"] .cart__price-wrapper .th_item_price',
            '[data-cart-item-key="' + key + '"] .cart__price.text-right [data-cart-item-regular-price]',
            '[data-cart-item-key="' + key + '"] .cart__table-cell:not(.cart__table-cell--total) .cart__price',
            '[data-cart-item-key="' + key + '"] .cart-drawer__price .cart-item__original-price.cart-item__price',
            '[data-cart-item-key="' + key +
            '"] [data-cart-item-price-container] .cart-item__original-price.cart-item__price',
            '[data-cart-item-key="' + key + '"] .cart__table-cell--price.medium-up--text-right',
            '[data-cart-item-key="' + key + '"] .grid__item.one-half.post-large--text-right .h5',
            '[data-cart-item-key="' + key + '"] .text-right[data-label="Price"]',
            '[data-cart-item-key="' + key + '"] [bss-b2b-item-original-price]',
            // fix drink-this-bev.myshopify.com by vitu
            '[data-cart-item-key="' + key + '"] .CartItem__Price.Price',
            '[data-cart-item-key="' + key + '"] .CartItem__Meta .CartItem__Price.Price',
            // fix for detecton by Leorio
            '[data-cart-item-key="' + key + '"] [data-cart-item-price-container] .cart__item-price',
            '[data-cart-item-key="' + key + '"] [bss-b2b-item-final-price]',
            // fix for genito by XuTho
            '[data-cart-item-key="' + key + '"] [bss-b2b-item-original-price] .money[ls-currency-dkk]',
            // fix for skinartisan.com.au by DangNM
            '[data-cart-item-key="' + key + '"] .cart--item--price .money',
            // fix for enbioitalia by mitri
            '[data-cart-item-key="' + key + '"] .cart-item__original-price.cart-item__price',
            // fix for permitpony by DangNM
            '[data-cart-item-key="' + key + '"] .line-item__price:first-child',
            // fix for allerleiwindeln by mitri
            '[data-cart-item-key="' + key + '"] .price-list.hidden-phone .price .money',
            //fix for ananda-verlag by mitri
            '[data-cart-item-key="' + key + '"] .cart-sale-price--with-discount',
            //fix for goodscollectiveco by dongnv
            '[data-cart-item-key="' + key + '"] .cart-sale-price--with-discount .money',
            // fix for wholesale.thicktails.com by hoaduong
            '[data-cart-item-key="' + key + '"] .cart__price-wrapper .bss-original-price',
            // fix for artipieces by mitri
            '[data-cart-item-key="' + key + '"] .CartItem__PriceList .transcy-money',
            //fix for goodibox.shop by CuongNVM
            '[data-cart-item-key="' + key + '"] .grid__item.one-third.medium-up--text-right .cart__price',
            //fix for newgarden by CuongNVM
            '[data-cart-item-key="' + key + '"] .product-price .saso-cart-item-price',
            '[data-cart-item-key="' + key + '"] .cart_item_info .quantity .shopify-Price-amount',
            // fix for soccerone-dev by DangNM
            '[data-cart-item-key="' + key + '"] .product-cart__price-value .price span:first-child',
            '[data-cart-item-key="' + key + '"] .col.col-sm-4.col-lg-4:first-child .price[data-js-product-price] span',
            //fix for kraeutermax by CuongNVM
            '[data-cart-item-key="' + key + '"] .line-price [data-price]',
            '[data-cart-item-key="' + key + '"] .cart-info [data-item-price]',
            // fix for mearth-e-scooter by DangNM
            '[data-cart-item-key="' + key + '"] .product-price .money > span[bss-b2b-cart-item-key="' + key +
            '"] > .transcy-money',
            '.mini-cart .items .price .amount .money > [bss-b2b-cart-item-key="' + key + '"] > .transcy-money',
            '.mini-cart [data-cart-item-key="' + key + '"] .items .price .amount .money > .transcy-money',
            //fix for elicious by CuongNVM
            '[data-cart-item-key="' + key + '"] .price .conditional-qty strong',
            '[data-cart-item-key="' + key + '"] .price .line-item-price .item-price',
            // fix for bingltd by Leorio
            '[data-cart-item-key="' + key + '"] .cart-column--price.product-price .theme-money',
            //fix for knobs-pulls-things by CuongNVM
            '[data-cart-item-key="' + key + '"] .cart-item__price[rv-html]',
            '[data-cart-item-key="' + key + '"].mini-cart__item .product__price',
            // fix for lonerstonerstore by DangNM
            '[data-cart-item-key="' + key + '"] .cart__item-price-col.text-right .cart__price',
            // fix for quickee by mitri
            '[data-cart-item-key="' + key + '"] .details .cart--price .price-box',
            '[data-cart-item-key="' + key + '"] .product-details .cart-collateral .price',
            //fix for contact-hu by khanh
            '[data-cart-item-key="' + key + '"] .details .cart-details .price-box',
            // fix for thujor-se by CuongNVM
            '.ajaxcart__product[data-cart-item-key="' + key + '"] .media-body .product-price .money',
            '[data-cart-item-key="' + key + '"] .cart__price-wrapper .pplr_item_price .money',
            // fix for colco-connect by DangNM
            '[data-cart-item-key="' + key + '"] .product-info .cart-title + .price strong',
            '[data-cart-item-key="' + key + '"] .pplr_item_price',
            '[data-cart-item-key="' + key + '"] .product-option',
            // fix for polarliquid by HungVP
            '[data-cart-item-key="' + key + '"] .product-option .hide-price-guest',
            // fix for straightcurve-usa by DangNM
            '[data-cart-item-key="' + key + '"] .item-details .two .offers .price.price-field',
            //fix for thepackunderwear by CuongNVM
            '[data-cart-item-key="' + key + '"] .cart-summary-overlay__unit-price .theme-money .money',
            '[data-cart-item-key="' + key + '"] .cart-item__column.cart-item__price .money',
            // fix for padelutstyr by DongNV
            '[data-cart-item-key="' + key + '"] .line-item__price .money',
            '[data-cart-item-key="' + key + '"] .cart_price',
            // fix for wisefood by mitri
            '[data-cart-item-key="' + key + '"] .cart-item--content .cart-item--content-price .money .money',
            // fix for hardcorenutrition by AnhTV
            '[data-cart-item-key="' + key + '"] .cart__price .hidden',
            // fix for vikendistrib. by CuongNVM
            '[data-cart-item-key="' + key + '"] [data-armada-selector="regular-price-container"] .money',
            // fix for lakeside by CuongNVM
            '[data-cart-item-key="' + key + '"] [data-cart-item-regular-price] .qb-price-item',
            '[data-cart-item-key="' + key + '"] .line-item__product .price-list.hidden-phone .price',
            '[data-cart-item-key="' + key + '"] .line-item__price .transcy-money',
            // fix for honeyplaybox.us by HaiNN
            '[data-cart-item-key="' + key + '"] .cart_meta_prices.price > .cart_price > .hidePrice',
            '[data-cart-item-key="' + key + '"] .cart_meta_prices.price > .cart_price > ins > .hidePrice',
            '[data-cart-item-key="' + key + '"] .mini_cart_meta > .cart_meta_price.price > .cart_price > .hidePrice',
            '[data-cart-item-key="' + key +
            '"] .mini_cart_meta > .cart_meta_price.price > .cart_price > ins > .hidePrice',
            '[data-cart-item-key="' + key + '"] .flex_row .cart-price .price-box span',
            // fix for b2b-vapeholster.myshopify.com by LuanHV
            '[data-cart-item-key="' + key + '"] .item-option .money',
            '[data-cart-item-key="' + key + '"] .price-box .new-price',
            // fix for new.naturalcreations925.com by LuanHV
            '[data-cart-item-key="' + key + '"] .previewCartItem-change .price',
            '[data-cart-item-key="' + key + '"] .cart-item-block .cart-item__price-wrapper .price',
            // fix for paintlablimited by AnhTV
            '[data-cart-item-key="' + key + '"] .cart--price.h-mobile .price-box span:not(.bss-qb-price-item)',
            //fix for ravigiftboxes.com quymv
            '[data-cart-item-key="' + key + '"] .item__price .item__price--final',
            //fix for reztaurantdirect.com quymv
            '[data-cart-item-key="' + key + '"] .cart__price span span',
            //  fix krkcwholesale by DongNV
            '[data-cart-item-key="' + key + '"] .cart_price .qb-price-item .hidden',
            '[data-cart-item-key="' + key + '"] .cart_price .qb-price-item .hidePrice',
            //fix for quincaillerie-euroline.myshopify.com by Ducnv
            '[data-cart-item-key="' + key +
            '"] .line-item__product-info .line-item__meta .line-item__price-list .line-item__price .hide-price-guest',
            //fix for theme Refresh
            '[data-cart-item-key="' + key + '"] .cart-item__details .product-option',
            // fix  active-recovery-asia.myshopify.com by ducnv
            '[data-cart-item-key="' + key + '"] .cart-item .product-option .money',
            //fix fo annankee.myshopify.com
            '[data-cart-item-key="' + key + '"] .price:not(.was_price) .money',
            // fix for www.canterburynorthamerica.com by LuanHV
            '[data-cart-item-key="' + key + '"] .cart__info .cart__price .money',
            // fix for kikchoice.com by cuongnq
            '[data-cart-item-key="' + key + '"] .cart-product-info__price .cart-product_price',
            // fix for uniformer.in by anhtd
            '[data-cart-item-key="' + key + '"] span.ymq_item_price',
            // fix for aircrafttag.com by cuongnq
            '[data-cart-item-key="' + key + '"] .product-option span.a_pplr_item_price',
            '[data-cart-item-key="' + key + '"] .right .description .bss-qb',
            // fix for minimoskinessentials.com by HuanNV
            '[data-cart-item-key="' + key + '"] [bss-b2b-item-original-price] .hide-price-guest',
            // fix for https://420z-filters.myshopify.com/ by Tapo
            '[data-cart-item-key="' + key + '"] .element--hide-on-small span:not(.bss-qb-price-item)',
            // fix for coventa-demo.com by Tapo
            '[data-cart-item-key="' + key + '"] .atc--product-details--price-value',
            // fix for onforuleds.com by cuongnq
            '[data-cart-item-key="' + key + '"] .cart__item--price .etrans-money',
            //fix for hiswanstore.com  and froglog by donglt
            '[data-cart-item-key="' + key + '"] .cart-table-columns__price .final-price',
            '[data-cart-item-key="' + key + '"]>.o-layout>.o-layout__item:nth-child(2) .cart-item__price .money',
            '[data-cart-item-key="' + key + '"] [bss-b2b-cart-item-key="' + key + '"][bss-b2b-item-original-price]',
            '.modal_price [bss-b2b-cart-item-key="' + key + '"][bss-b2b-item-original-price]',
            //fix for f1bcb3.myshopify.com by Tapo
            '[data-cart-item-key="' + key + '"] .cart-item__price-wrapper .price.price--end span',
            '[data-cart-item-key="' + key + '"] .previewCartItem-price .price span span',
            // fix for canterburycanada.com by cuongnq
            '[data-cart-item-key="' + key + '"] .previewCartItem-price .price span span',
            '[data-cart-item-key="' + key + '"] .cart__info .cart__price .sale',
            // fix for vape61.myshopify.com by Tapo
            '[data-cart-item-key="' + key + '"] .price-list.hidden-phone .hidePrice',
            // fix for flyinghighcannabis.ca by Tapo
            '[data-cart-item-key="' + key + '"] .cart-price .money',
            '[data-cart-item-key="' + key + '"] .cart-item__prices price-money bdi',
            // fix for vapebase.com.au by cuongnq
            '[data-cart-item-key="' + key + '"] .item__original-price .tt-price',
            '[data-cart-item-key="' + key + '"] .price .amount',
            '[data-cart-item-key="' + key + '"] .previewCartItem-price [data-item-final-price-display]',
            // fix for lagertechnik-direkt.myshopify.com by cuongnq
            '[data-cart-item-key="' + key + '"] .item__original-price .tt-price',
            '[data-cart-item-key="' + key + '"] .price__current.price',
            '[data-cart-item-key="' + key + '"] .cart__punit .jsPrice',
            '[data-cart-item-key="' + key + '"] .minicart__price .jsPrice:nth-child(1)',
            // fix for https://lafablight.com/ by CuongNM
            '[data-cart-item-key="' + key + '"] .pplr_item_final_price',
            '[data-cart-item-key="' + key + '"] .ajaxcart__product-price-wrapper',
            '[data-cart-item-key="' + key + '"] .sf-cart__table-price .sf-cart__item-prices p[data-key]',
            '[data-cart-item-key="' + key + '"] .scd-item__inner .scd-item__prices > span[data-key]',
            '[data-cart-item-key="' + key + '"] .cart-table-price span.money',
            // fix for andandreawholesale.com by devlin
            '[data-cart-item-key="' + key + '"] .item-price .theme-money',
            // fix for perfectshinehair by devlin
            '[data-cart-item-key="' + key + '"] .cart-table-columns__price .ymq_item_final_price .ymq-price-span',
            // fix for volumenodev.myshopify.com
            '.cart-prd-details .yv-product-price',
            // fix for florx.co.nz
            '[data-cart-item-key="' + key + '"] .cart__item-price',
            //fix for packd-new.myshopify.com by quyenpv
            '[data-cart-item-key="' + key + '"] .cart__price span:first-child',
            // fix for carabc.cn by LuongNP
            '[data-cart-item-key="' + key + '"] .cart__items__grid .cart__items__price .line__price mark',
            //fix for crimpingtools.com by khanhTQ
            '[data-cart-item-key="' + key + '"] .cart-item--inner .cart-item--content .cart-item--content-price .money',
            //fix for tawgraphix.com by LongNH2
            '[data-cart-item-key="' + key + '"] .product-price .amount',
            '[data-cart-item-key="' + key + '"] .cart-content .cart-price',
            '[data-cart-item-key="' + key + '"] .col-price > .theme-money',
            '[data-cart-item-key="' + key + '"] .cart__item__content .cart__item__price',
            '[data-cart-item-key="' + key + '"] dd > span > span.money',
            '[data-cart-item-key="' + key + '"] .cart-item__price-item .saso-cart-item-price',
            '[data-cart-item-key="' + key + '"] .cart-item__details .cart-item__info strong.price__current',
            '[data-cart-item-key="' + key + '"] .cart-item__column.cart-item__price .theme-money',
        ];
        if (BSS_B2B.storeId === 4337) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__info .price__current'];
        }
        if ([7039, 12567].includes(BSS_B2B.storeId)) {
            queryArr = [
                '[data-cart-item-key="' + key + '"] .product-quantity price-money',
                '[data-cart-item-key="' + key + '"] .cart-item__prices price-money',
            ];
        }

        if (BSS_B2B.storeId == 9668) {
            queryArr = [
                '[data-cart-item-key="' + key + '"] .cart__item-price-col .cart__price > span > span:nth-child(1)'
            ];
        }

        if (BSS_B2B.storeId == 11694) {
            queryArr = ['[data-cart-item-key="' + key + '"] .price.cart_price'];
        }

        if (BSS_B2B.storeId == 5475) {
            queryArr = [
                '[data-cart-item-key="' + key +
                '"] .cart__price [data-cart-item-regular-price]>span:not(.Bold-theme-hook-DO-NOT-DELETE)'];
        }

        if (BSS_B2B.storeId == 14389) {
            queryArr = ['[data-cart-item-key="' + key + '"] .grid.grid--full .grid__item.medium-up--two-fifths .grid__item.one-third.medium-up--text-right span',
            '[data-cart-item-key="' + key + '"] .grid .grid__item.two-thirds .grid.grid--full.display-table .grid__item.text-right span'];
        }
        if (BSS_B2B.storeId === 8936) {
            queryArr = ['[data-cart-item-key="' + key + '"] .product-option [bss-b2b-item-original-price]'];
        }

        if (BSS_B2B.storeId === 8860) {
            queryArr = ['.cart-item--content-price [data-cart-item-key="' + key + '"] .money'];
        }

        if (BSS_B2B.storeId === 13552) {
            queryArr = ['.line-item__price-list [data-cart-item-key="' + key + '"] span'];
        }
        queryArr = window.BSS_B2B.executeFilter({ tag: "price_all", storeId: 13871, val: queryArr, key });
        queryArr = window.BSS_B2B.executeFilter({ tag: "price_all", storeId: 13534, val: queryArr, key });

        if (BSS_B2B.storeId === 13760) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__details .product-option > span',
            '[data-cart-item-key="' + key + '"] .variant-item__price > span'];
        }
        if (BSS_B2B.storeId === 12453) {
            queryArr = ['[data-cart-item-key="' + key + '"] .pn-price-item']
        }
        if (BSS_B2B.storeId === 13615) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__details .product-option span[bss-b2b-item-original-price]']
        }
        if (BSS_B2B.storeId === 13249) {
            queryArr = ['line-item price-list[data-cart-item-key="' + key + '"]'];
        }
        if (BSS_B2B.storeId === 13877) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__price-wrapper.hide-sp .price > .revy-original-item-price']
        }
        if (BSS_B2B.storeId === 15588) {
            queryArr = ['[data-cart-item-key="' + key + '"].cart-item div.product-option'];
        }
        if (BSS_B2B.storeId === 16067) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item--content-price .cart-item--discount-price'];
        }

        if (BSS_B2B.storeId === 13133) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-details .product-price .price-item .money']
        }
        return queryArr;
    };
    /**
     *  cart total price element of each item in cart page
     */
    BSS_B2B.qb.totalPriceOfItemElement = function (key) {
        let queryArr = [
            '[data-cart-item-key="' + key + '"] .text-right.small--hide .th_item_line_price',
            '[data-cart-item-key="' + key + '"] [data-cart-item-line-price] [data-cart-item-regular-price]',
            '[data-cart-item-key="' + key + '"] [bss-b2b-cart-item-key="' + key +
            '"][bss-b2b-original-line-price]:not(.transcy-money)',
            '[data-cart-item-key="' + key + '"] .cart__table-cell--line-price[data-label="Total"]',
            '[data-cart-item-key="' + key + '"] .text-right[data-label="Total"]',
            '[data-cart-item-key="' + key + '"] .cart__item-total',
            '[data-cart-item-key="' + key + '"] span[bss-b2b-cart-item-key="' + key +
            '"][bss-b2b-ajax-original-line-price]',
            '[data-cart-item-key="' + key + '"] .cart-original-price.order-discount--cart-price',
            '[data-cart-item-id="' + key +
            '"] [data-cart-item-line-price-container] .cart-item__original-price.cart-item__price',
            '[data-cart-item-key="' + key + '"] .grid__item.two-thirds.text-right .cart__price',
            '[data-cart-item-key="' + key +
            '"] .grid__item.two-thirds.text-right .cart__price > :not(.cart__price--bold)',
            '[data-cart-item-key="' + key + '"] .grid--full.cart__row--table-large .grid__item.text-right .h5',
            '[data-cart-item-key="' + key + '"] span.cart__price.cart__price--bold',
            // fix for inotex by Leorio
            '[data-cart-item-key="' + key + '"] .product-price > :not(span,h6,div)',
            // fix for bingltd by Leorio
            '[data-cart-item-key="' + key + '"] .cart-column--total .product-price .theme-money',
            // fix for studyphones by Leorio
            '[data-cart-item-key="' + key + '"] span[bss-b2b-cart-item-key="' + key + '"][bss-b2b-final-line-price]',
            // fix for bestpricepakistan by Leorio
            '[data-cart-item-key="' + key + '"] .cart-item-price,' +
            // fix cra-wellness by vitu
            '[data-cart-item-key="' + key + '"] .price_total .money,' +
            // fix for stbjyoti by Leorio
            '[data-cart-item-key="' + key + '"] .cart-item__totals .price.price--end,' +
            // fix for polarliquid by HungVP
            '[data-cart-item-key="' + key + '"] .cart-item__totals .price.price--end .hide-price-guest,' +
            // fix for detecton by Leorio
            '[data-cart-item-key="' + key + '"] [data-cart-item-line-price-container] .cart__item-price .money,' +
            // fix for clickbeauty by Leorio
            '[data-cart-item-key="' + key + '"] .gt_total.gt_price_total span.bss-custom-show-price-qb,' +
            //fix for snugglebunny by mitri
            '[data-cart-item-key="' + key + '"] .cart__item-price,' +
            '[data-cart-item-key="' + key + '"] .bss-fix-total-price-mini-cart,' +
            '[data-cart-item-key="' + key + '"] .line-item__line-price',
            // fix for https://sinoplasan-ag.myshopify.com/ by DangNM
            '[data-cart-item-key="' + key + '"] .revy-final-item-price',
            // fix for skinartisan.com.au by DangNM
            '[data-cart-item-key="' + key + '"] .cart--item--total .money',
            // fix for enbioitalia by mitri
            '[data-cart-item-key="' + key + '"] .saso-cart-item-line-price',
            // fix for permitpony by DangNM
            '[data-cart-item-key="' + key + '"] .line-item__line-price.table__cell--right span,' +
            '[data-cart-item-key="' + key + '"] .mini-cart__price-list .price:first-child',
            // fix for ananda-verlag by mitri
            '[data-cart-item-key="' + key + '"] .cart-total-label[bss-b2b-final-line-price] .money',
            // fix for wholesale.thicktails.com by hoaduong
            '[data-cart-item-key="' + key + '"] .bss-original-line-price',
            // fix for artipieces by mitri
            '[data-cart-item-key="' + key + '"] .CartItem__LinePriceList .transcy-money',
            // fix for business.metrobrazil by CuongNVM
            '.cart-item__price-wrapper .price.price--end [bss-b2b-cart-item-key="' + key +
            '"][bss-b2b-original-line-price]',
            '.cart-item__price-wrapper .price.price--end [bss-b2b-cart-item-key="' + key +
            '"][bss-b2b-final-line-price]',
            //fix for goodibox.shop by CuongNVM
            '[data-cart-item-key="' + key + '"] .grid__item.one-third.text-right .cart__price',
            //fix for newgarden by CuongNVM
            '[data-cart-item-key="' + key + '"] .product-subtotal[data-key] span',
            // fix for soccerone-dev by DangNM
            '[data-cart-item-key="' + key + '"] .col.col-sm-4.col-lg-4:last-child .price[data-js-product-price] span',
            //fix for kraeutermax by CuongNVM
            '[data-cart-item-key="' + key + '"] .line-subtotal [data-item-line-price]',
            // fix for besspress by HungVP
            '[data-cart-item-key="' + key + '"] .ajaxcart-item__price [data-currency-usd]',
            //fix for goodscollectiveco by dongnv
            '[data-cart-item-key="' + key + '"] .cart-total-label .money',
            '[data-cart-item-key="' + key + '"] .ajaxcart-item__price .money:not(.cart-price .money)',
            '[data-cart-item-key="' + key + '"] [data-cart-item-line-price] [data-cart-item-regular-price]',
            // fix for mearth-e-scooter by DangNM
            '[data-cart-item-key="' + key + '"] .product-subtotal .amount > span[bss-b2b-cart-item-key="' + key +
            '"] > .transcy-money',
            //fix for elicious by CuongNVM
            '[data-cart-item-key="' + key + '"] .price .line-item-price strong',
            //fix for knobs-pulls-things by CuongNVM
            '[data-cart-item-key="' + key + '"] .cart-item__subtotal',
            // fix for quickee by mitri
            '[data-cart-item-key="' + key + '"] .cart--total .price',
            // fix for thujor-se by CuongNVM
            '[data-cart-item-key="' + key + '"] .product-subtotal .pplr_item_line_price',
            // fix for colco-connect by DangNM
            '[data-cart-item-key="' + key + '"] .product-info .price .cart_total ~ strong',
            '[data-cart-item-key="' + key + '"] .product-subtotal .money',
            // fix for straightcurve-usa by DangNM
            '[data-cart-item-key="' + key + '"] .item-details .two .total-item.total-price-item',
            // fix for watc-studio by Leorio
            '[data-cart-item-key="' + key + '"] [bss-b2b-cart-item-key="' + key +
            '"][bss-b2b-original-line-price] [bss-b2b-product-price]',
            '[bss-b2b-bcp-cart-item-key="' + key + '"][bss-b2b-bcp-line-item-price]',
            //fix for thepackunderwear by CuongNVM
            '[data-cart-item-key="' + key + '"] .cart-summary-overlay__line-price .theme-money .money',
            '[data-cart-item-key="' + key + '"] .cart-item__column.cart-item__total .money',
            // fix for watc-studio by CuongNVM
            '[data-cart-item-key="' + key + '"] .item-price.text-size--smaller',
            '[data-cart-item-key="' + key + '"] .item_price',
            // fix for padelutstyr by DongNV
            '.mini-cart__price-list [bss-b2b-cart-item-key="' + key + '"] .money',
            //  fix krkcwholesale by DongNV
            '[data-cart-item-key="' + key + '"] .cart-item-price .hidden',
            '[data-cart-item-key="' + key + '"] .cart-item-price .hidePrice',
            // fix for krkcshop by HaiNN
            '[data-cart-item-key="' + key + '"] .CartItem__LinePriceList > .CartItem__Price.Price',
            // fix for wisefood by mitri
            '[data-cart-item-key="' + key + '"] .cart-item--info .cart-item--total .money .money',
            // fix for hardcorenutrition by AnhTV
            '[data-cart-item-key="' + key + '"] .cart__final-price .hidden',
            // fix for lakeside by CuongNVM
            '[data-cart-item-key="' + key + '"] [data-cart-item-regular-price] .qb-total-line-item',
            // fix for spoview.com by HaiNN
            '[data-cart-item-key="' + key + '"] .cart__item--price > .cart__price > .transcy-money',
            '[data-cart-item-key="' + key + '"] .line-item__price-list-container .price.price--highlight',
            '[data-cart-item-key="' + key + '"] .flex_row .cart-line-price .price-box span',
            //fix for puregrips
            '[data-cart-item-key="' + key + '"] .price-list.price-list--stack .price',
            // fix for b2b-vapeholster.myshopify.com by LuanHV
            '[data-cart-item-key="' + key + '"] .subtotal-titles .cart-total',
            '[data-cart-item-key="' + key + '"] .item-price .full-price .money',
            '[data-cart-item-key="' + key + '"] .item__subtotal-price .subtotal',
            // fix for new.naturalcreations925.com by LuanHV
            '[data-cart-item-key="' + key + '"] .cart-item-total .cart-item-value',
            //fix for brazil-beauty-brands
            '[data-cart-item-key="' + key + '"] .t4s-mini_cart__meta > .t4s-cart_meta_price > .t4s-cart_price',
            //fix for wamdistribution.co.uk by Ducnv
            '[data-cart-item-key="' + key + '"] .sp-price.subtotal',
            //fix for ravigiftboxes.com quymv
            '[data-cart-item-key="' + key + '"] .cart__subtotal span',
            //fix for quincaillerie-euroline.myshopify.com by ducnv
            '[data-cart-item-key="' + key + '"] .line-item__line-price.table__cell--right .hide-price-guest',
            '[data-cart-item-key="' + key + '"] .mini-cart__price-list .hide-price-guest',
            //fix for euro-trade.com by LuanHV
            '[data-cart-item-key="' + key + '"] .product-item-meta .price',
            //fix for active-recovery-asia.myshopify.com by Ducnv
            '[data-cart-item-key="' + key +
            '"] .cart-item__totals.small-hide .cart-item__price-wrapper > .price .money',
            // fix for https://fuzzybrands.com/ by tapo
            '[data-cart-item-key="' + key + '"] .grid__item .text-money .cart__price .money',
            // fix for www.canterburynorthamerica.com by LuanHV
            '[data-cart-item-key="' + key + '"] .cart__info .cart__total .money',
            // fix for kikchoice.com by cuongnq
            '[data-cart-item-key="' + key + '"] .cart-table__price .price-discount.cart__price',
            '[data-cart-item-key="' + key + '"] .ajaxcart__line-item .ajaxcart__price',
            //fix for uniformer.in by anhtd
            '[data-cart-item-key="' + key + '"] .ymq_item_line_price',
            //fix for haircare-uk
            '[data-cart-item-key="' + key + '"] .tt-price.subtotal',
            // fix for belltentvillage by cuongnq
            '[bss-b2b-bcp-cart-item-key="' + key + '"][bss-b2b-bcp-line-item-price] .money',
            '#mini__cart .media-body .yv-prizebox .yv-product-price',
            '[data-cart-item-key="' + key + '"] .price.bss-fix-qb',
            // fix for minimoskinessentials.com by HuanNV
            '[data-cart-item-key="' + key + '"] [bss-b2b-original-line-price] .hide-price-guest',
            // fix for dschinni-shisha.com by cuongnq
            '[data-cart-item-key="' + key + '"] .transcy-money',
            //fix for hiswanstore.com by donglt
            '[data-cart-item-key="' + key + '"] .cart-table-columns__total .final-price',
            // fix for headshop-hero.com by Tapo
            '[data-cart-item-key="' + key + '"] .cart-item__total.text-align--right strong',
            //fix for froglog by donglt
            '[data-cart-item-key="' + key + '"]>.o-layout>.o-layout__item:nth-child(4) .cart-item__price .money',
            //fix for f1bcb3.myshopify.com by Tapo
            '[data-cart-item-key="' + key + '"] .cart-item-block.cart-item-total .cart-item-value span',
            // fix for vape61.myshopify.com by Tapo
            '[data-cart-item-key="' + key + '"] .price-list .price.price--highlight .hidePrice',
            '[data-cart-item-key="' + key + '"] .cart-item__totals price-money bdi',
            '[data-cart-item-key="' + key + '"] .cart-collateral .price',
            '[data-cart-item-key="' + key + '"] .details .cart--total',
            '[data-cart-item-key="' + key + '"] .cart-item-price.js_tt_price_it .money',
            '[data-cart-item-key="' + key + '"] .qb-total-line-item',
            // fix for lagertechnik-direkt.myshopify.com by cuongnq
            '[data-cart-item-key="' + key + '"] > .item__subtotal-price .tt-price.subtotal',
            '[data-cart-item-key="' + key + '"] .cart-item__total .bss-b2b-cart-final-line-price',
            '[data-cart-item-key="' + key + '"] .cart-item__total .price__current',
            '[data-cart-item-key="' + key + '"] .minicart__price .jsPrice:nth-child(2)',
            '[data-cart-item-key="' + key + '"] .cart__ptotal .jsPrice',
            // fix for https://lafablight.com/ by CuongNM
            '[data-cart-item-key="' + key + '"] .pplr_item_line_final_price',
            // fix for amasports.com.au by cuongnq
            '[data-cart-item-key="' + key + '"] .cart-item--inner .cart-item--info .cart-item--total',
            // fix for 6c1a78-3.myshopify.com by HoangNX
            '[data-cart-item-key="' + key + '"] .product-item-price-final',
            // fix for stealth-performance-engineering.myshopify.com by QuyenPV
            '[data-cart-item-key="' + key + '"] .shopify-Price-amount',
            '[data-cart-item-key="' + key + '"] .cart__cell--total .cart__item-total',
            // fix for pritech-health-and-personal-care by CuongNM
            '[data-cart-item-key="' + key + '"] price-list sale-price .price',
            '[data-cart-item-key="' + key + '"] .sf-cart__table-subtotal .scd-item__original_line_price',
            '[data-cart-item-key="' + key + '"] .cart-table-line-price.cart--final-column .money',
            // fix for andandreawholesale.com by devlin
            '[data-cart-item-key="' + key + '"] .line-total .theme-money',
            // fix for perfectshinehair by devlin
            '[data-cart-item-key="' + key + '"] .cart-table-columns__total .final-price .ymq-price-span',
            // fix for volumenodev.myshopify.com
            '.cart-price .yv-product-price',
            '[data-cart-item-key="' + key + '"] .avisplus-cart-item-line-price',
            // fix for asetechnologycom.myshopify.com by khanh TQ
            '[data-cart-item-key="' + key + '"] .cart-item--inner .cart-item__info .cart-item__total div span',
            // fix for timberteq.com by khanh TQ
            '[data-cart-item-key="' + key + '"] .cart-item--inner .cart-item__info .cart-item__total div',
            // fix for carabc.cn
            '[data-cart-item-key="' + key + '"] .cart__items__grid .cart__items__total div',
            //fix for tawgraphix.com by LongNH2
            '[data-cart-item-key="' + key + '"] div[bss-b2b-final-line-price]',
            '[data-cart-item-key="' + key + '"] .product-subtotal div',
            '[data-cart-item-key="' + key + '"] .unicart-price-container span',
            '[data-cart-item-key="' + key + '"] .col-total > .theme-money',
            '[data-cart-item-key="' + key + '"] .total-product-js .tt-price',
            '[data-cart-item-key="' + key + '"] .col-total > .theme-money',
            '[data-cart-item-key="' + key + '"] .drawer__cartitem-content > .cart-item__price-wrapper > .price .money',
            //fix for super-dry.shop
            '[data-cart-item-key="' + key + '"] .price.price--end .pn-total-line-item',
            '[data-cart-item-key="' + key + '"] .ajax-cart__item-line-price.v-center span > span > span.money',
            '[data-cart-item-key="' + key + '"] .item-price.text-size--smaller',
            '[data-cart-item-key="' + key + '"] .cart__item_price .price',
            '[data-cart-item-key="' + key + '"] .saso-cart-item-line-price .cart-item__price-item',
            '[data-cart-item-key="' + key + '"] .cart-item__column.cart-item__total .theme-money'
        ];
        if (BSS_B2B.storeId === 4337) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__total .price__current'];
        }
        // start fix for funeraltrading.com by DucDN
        if (BSS_B2B.storeId == 10663) {
            queryArr.push('[data-cart-item-key="' + key + '"] .mini-cart-item-final-price');
        }
        // end fix for funeraltrading.com by DucDN

        if (BSS_B2B.storeId == 7039) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__totals price-money'];
        }

        if (BSS_B2B.storeId == 12291) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item-value'];
        }

        if (BSS_B2B.storeId == 5475) {
            queryArr = [
                '[data-cart-item-key="' + key +
                '"] .cart__final-price [data-cart-item-regular-price]>span:not(.Bold-theme-hook-DO-NOT-DELETE)'];
        }

        if (BSS_B2B.storeId === 8860) {
            queryArr = ['.cart-item--total [data-cart-item-key="' + key + '"] span'];
        }

        if (BSS_B2B.storeId === 13552) {
            queryArr = ['.line-item__line-price [data-cart-item-key="' + key + '"] span, .mini-cart__price-list [data-cart-item-key="' + key + '"] span'];
        }

        if (BSS_B2B.storeId === 14384) {
            queryArr = ['[data-cart-item-key="' + key + '"] .text-right .transcy-money'];
        }
        queryArr = window.BSS_B2B.executeFilter({ tag: "price_all_totalItem", storeId: 13871, val: queryArr, key });
        if (BSS_B2B.storeId === 13760) {
            queryArr = ['[data-cart-item-key="' + key + '"] .cart-item__totals .cart-item__price-wrapper .price.price--end > span',
            '[data-cart-item-key="' + key + '"] .variant-item__totals .price'];
        }
        if (BSS_B2B.storeId === 14081) {
            queryArr = ['[data-cart-item-key="' + key + '"] td[data-total] .cart-total, [data-cart-item-key="' + key + '"] .bss-b2b-qb-total-item span']
        }

        if (BSS_B2B.storeId === 14608) {
            queryArr = ['[data-cart-item-key="' + key + '"] .line-item__line-price.table__cell--right > span', '[data-cart-item-key="' + key + '"] .mini-cart__item-wrapper .mini-cart__price-list .price.price--highlight']
        }

        return queryArr;
    };

    /**
     * cart subtotal price element in cart page
     */
    BSS_B2B.qb.cartSubtotalPriceElement = function () {
        let queryArr = [
            '.cart__subtotal .th_cart_total_price',
            '.large--one-third .cart__subtotal',
            '.cart-subtotal__price[data-cart-subtotal]',
            '[bss-b2b-cart-total-price]',
            '[bss-b2b-ajax-cart-subtotal]',
            '.cart-subtotal--price small',
            '.cart-subtotal--price',
            '.cart__subtotal .cart__subtotal-price',
            '.cart__totals .cart__subtotal',
            '#ajaxifyModal [bss-b2b-product-handle][bss-b2b-variant-id][bss-b2b-product-sale-price]',
            '#your-shopping-cart [bss-b2b-product-handle][bss-b2b-variant-id][bss-b2b-product-sale-price]',
            // fix for inotex by Leorio
            '.bdr-box .flex.cart-subtotal-row .cart__subtotal.text-right',
            '.minicartTol .product-price',
            // fix for bestpricepakistan by Leorio
            '.subtotal .cart-item-total-price',
            // fix cra-wellness by vitu
            '.cart_subtotal .money',
            // fix for stbjyoti by Leorio
            '.totals__subtotal-value',
            // fix for polarliquid by HungVP
            '.totals__subtotal-value .hide-price-guest',
            // fix for detecton by Leorio
            'span[data-cart-subtotal] .money',
            // fix for clickbeauty by Leorio
            '.gt_subtotal',
            // fix for dravenarchery by mitri
            '.h3.cart__subtotal',
            //fix for goodscollectiveco by dongnv
            '.h3.cart__subtotal .money',
            // fix for detecton by Leorio
            '[data-cart-subtotal]',
            '[data-cart-subtotal] > :not(div)',
            // fix for ticoroasters by Leorio
            '.wh-original-cart-total',
            // fix for https://sinoplasan-ag.myshopify.com/ by DangNM
            '#revy-cart-subtotal-price',
            // fix for skinartisan.com.au by DangNM
            '.cart--form .cart--totals .cart--total .cart--total--price.money',
            // fix for enbioitalia by mitri
            '.cart-subtotal__price.money',
            // fix for ahika by CuongNVM
            '.wcp-original-cart-total',
            // fix for permitpony by DangNM
            '.cart-recap__price-line-price,' +
            '.mini-cart__recap-price-line span:nth-child(2):not([class="bss-qb-cart-subtotal"])',
            // fix for artipieces by mitri
            '.saw-cart-original-total .transcy-money',
            //fix for goodibox.shop by CuongNVM
            // '.grid .cart__row--table .grid__item.one-half .h4:has(span)',
            // fix for claveclub by mitri
            '.cart__total__money',
            //fix for newgarden by CuongNVM
            '.saso-cart-original-total .price',
            '.widget_shopping_cart_footer .total .shopify-Price-amount',
            // fix for soccerone-dev by DangNM
            '.popup-cart__subtotal .price span:first-child',
            '.cart__subtotal h3.mb-0',
            '.ymq_cart_total_price .ymq-price-span',
            //fix for Surrey-Hills-Grocer by Khanh
            // '.cart__item-price-col.text-right .cart__price',
            //fix for kraeutermax by CuongNVM
            '.cart-subtotal [data-cart-total]',
            '.cart-total [data-cart-total]',
            '.cart-foot .cart-row [data-cart-total]',
            //fix for besspress by HungVP
            '.grid__item.ajaxcart__subtotal p [data-currency-usd]',
            //fix for elicious by CuongNVM
            '#CartTotal strong',
            // fix for mearth-e-scooter by DangNM
            '.mini-cart .cart-checkout .subtotal .price .money > .transcy-money',
            // fix for bingltd by Leorio
            '.cart-subtotal .theme-money',
            //fix for knobs-pulls-things by CuongNVM
            '.cart__recap--desktop .cart__total',
            '.mini-cart__total .mini-cart__total-price',
            '[data-subtotal]',
            // fix for
            '.cart-form .right-col .grouped-info .total .price',
            '.cart-form .right-col .grouped-bottom .total .price',
            '#dropdown-cart .summary .total .price',
            // fix for thujor-se by CuongNVM
            '.hulkapps-cart-original-total .pplr_subtotal_price .money',
            '.ajaxcart__footer .money',
            // fix for colco-connect by DangNM
            '.cart_total_price .cart__subtotal',
            '.cart__total.d-flex .price_subtotal .cart__subtotal',
            // fix for straightcurve-usa by DangNM
            '#total-cart-bottom,#total-cart-top',
            //fix for thepackunderwear by CuongNVM
            '.cart-summary-overlay__subtotal .theme-money .money',
            '.subtotal.h2-style .theme-money .money',
            // fix for watc-studio by CuongNVM
            '.AjaxCartSubtotal #CartTotal .text-size--large',
            '#shopMiniCart .totalCartPrice',
            // fix for padelutstyr by DongNV
            '#revy-cart-subtotal-price .money',
            //  fix krkcwholesale by DongNV
            '.cart__footer .cart_tot_price .hidden',
            '.cart__footer .cart_tot_price .hidePrice',
            // fix for krkcshop by HaiNN
            '.Cart__Total > span:nth-child(1)',
            'button[type="submit"].Cart__Checkout > span[data-money-convertible]',
            // fix for honeyplaying by CuongNVM
            '.cart_tot_price',
            // fix for wisefood by mitri
            '.cart-total .cart-final-total .cart-subtotal .money .money',
            '.cart-title-right .cart-title-total .money .money',
            // fix for hardcoreFitness by CuongNVM
            '.wh-original-cart-total .wh-original-price',
            // fix for spoview.com by HaiNN
            '.cart__footer-page > .cart__item-row > .h3 > [data-subtotal] > .transcy-money',
            '#StickySubtotal > .transcy-money',
            '.cart__total-container .heading.h6:last-child',
            '#revy-cart-subtotal-price .transcy-money',
            // fix for honeyplaybox.us by HaiNN
            '.mini_cart_footer .js_cat_ttprice > .cart_tot_price > .hidePrice',
            '.cart-form.wrapper-cart .quick-cart .cart-popup-action .total .price',
            // fix for b2b-vapeholster.myshopify.com by LuanHV
            '.subtotal-titles .subtotal-price',
            '.cart-total-wrap .cart-sub-total .subtotal .money',
            '.cart-total .total-amount .money',
            // fix for new.naturalcreations925.com by LuanHV
            '.previewCart-wrapper .previewCartInfo  .subTotal .previewCartTotals-value:not(.bss-fix)',
            '.previewCart-wrapper .previewCartInfo  .total  .previewCartTotals-value:not(.bss-fix)',
            '.cart-totals .cart-total-value .text',
            //fix for puregrips
            '.mini-cart-subtotal-wrapper .mini-cart-subtotal',
            // fix for paintlab by AnhTV
            '.groued-info .total .price',
            //fix for vitalitytruehealth
            '.totals > p.totals__subtotal-price',
            //fix for wamdistribution.co.uk by Ducnv
            '.sp-shopcart-box.sp-boredr-large table #subtotal td',
            '.sp-shopcart-box.sp-boredr-large table #grandtotal td',
            '.sp-cart-total-price',
            '.sp-total .sp-price.full-total-js',
            // fix for lacasadelreloj.com.mx by LuanHV
            '.tt-cart-box .tt-cart-total-price',
            //fix for Ravi quymv
            '.cart__footer__text .money',
            //fix for reztaurantdirect.com quymv
            '.tdf-cart-total-parent span span',
            // fix for peru-latino.com by Ducnv
            '.cart__total .text-size--heading',
            '.cart-item__price:not(.text-align--right) strong',
            '.cart-item__total:not(.text-align--right) strong:not(.bss-fix)',
            // fix for quincaillerie-euroline.myshopify.com by Ducnv
            '.mini-cart__recap-price-line .hide-price-guest',
            '.cart-recap__price-line-price .hide-price-guest',
            //fix for theme Refresh
            '.drawer__inner form .drawer__contents .drawer__cart-items-wrapper table tbody tr td .cart-item__price-wrapper .price',
            // fix for active-recovery-asia.myshopify.com by Ducnv
            '.totals .totals__subtotal-value .money',
            //fix for nebuleuse-partenaires
            '.mini-cart__drawer-footer button.checkout-button span[bss-b2b-minicart-total]',
            // fix for kpartsholland by cuongnq
            '#CartPageForm .docapp-cart-subtotal .money',
            // fix for fuzzyBrands by tapo
            '.cart__total-price-info .cart__subtotal.text-money .money',
            '[data-cart-total-value].cart-cost .money',
            // fix for www.canterburynorthamerica.com by LuanHV
            '.cart__subtotal-container .cart__subtotal span',
            // fix for kikchoice.com by cuongnq
            '.cart-total .cart-total__subtotal-price',
            '.drawer__inner .ajaxcart__subtotal',
            '.cart-recap__price-line-price .money',
            '.mini-cart__recap-price-line .money',
            //fix for uniform.in
            'span.ymq_cart_total_price',
            '.more .row .value',
            '[bss-b2b-cart-total-price] .hide-price-guest',
            // fix for coventa-demo.myshopify by Tapo
            '.atc-subtotal--price',
            // fix for razor-shopping.com by cuongnq
            '#CartPageForm .cart__item--subtotal div[data-subtotal] span',
            //Fix for hnc-hatworks-studio.myshopify.com
            '[bss-b2b-cart-total-price] span',
            // fix for onforuleds.com by cuongnq
            '.cart__footer .cart__item-sub .etrans-money',
            '#CartDrawerForm .drawer__footer .etrans-money',
            //Fix for hiswanstore and froglog by donglt
            '.cart__subtotal .total-price',
            '.cart__footer .cart__footer-total .money',
            // fix for canterburycanada.com by cuongnq
            '#ajax-cart__content .saw-cart-original-total .money',
            // fix for vape61.myshopify.com by Tapo
            '.cart__recap-block .cart__total-container .hidePrice',
            '.mini-cart__drawer-footer .checkout-button .hidePrice',
            // fix for flyinghighcannabis.ca by Tapo
            '.col-md-12 .totals .totals-content .price .money',
            '.cart-inner-content .cart-checkout .subtotal .price .money',
            '.js_cat_ttprice .cart_tot_price .money',
            '.cart-subtotal .price .amount, .mini-cart__row.mini-cart__total.total .amount',
            '#total-sidecart-js',
            '#mini-cart-subtotal',
            '#cart_drawer_subtotal .money',
            '.cart__summary .totals__subtotal-value',
            '.cart__total .cart__grandtotal .jsPrice',
            '.minicart__bottom .minicart__total .jsPrice',
            '.cart-checkout .cart-price .money',
            // fix for 6c1a78-3.myshopify.com by HoangNX
            '#cart-subtotal span.subtotal',
            '#offcanvas-cart-subtotal span.subtotal',
            // fix for stealth-performance-engineering.myshopify.com by QuyenPV
            '.shopify-Price-amount > .price > .money',
            '.woocommerce-Price-amount > .price > .money',
            // fix for pritech-health-and-personal-care by CuongNM
            'div[slot=\'footer\'] .justify-between>span:last-child',
            '.cart-form__totals .justify-between>span:last-child',
            '.cart-totals--wrapper #cart-total-final-price .money',
            // fix for andandreawholesale.com by devlin
            '.under-cart .subtotal .amount.theme-money',
            // fix for volumenodev.myshopify.com
            '.cart-total-details .cart-total-item strong',
            '.totle-price strong',
            // fix for timberteq.com by khanh TQ
            '.cart-title .cart-title-right .cart-title-total--large .cart-title-total span',
            '#CartDrawer-Checkout > div > strong',
            '#cart .sticky-in-panel .l4tt.m15.form-group .cart-total',
            '#Cart tr.cart-total span.price span.amount',
            // fix for tawgraphix.com by Long NH2
            '.cart-subtotal .amount',
            '.order-total .amount',
            '.cart-footer .price-content .shopping-cart__total',
            '.cart-box .shopping-cart__total',
            '.unicart-foot-value span.money',
            '.saw-cart-original-total',
            '.subtotal.theme-money',
            '.form-group .sb_totll',
            '.cart-drawer__footer .totals .totals__total-value',
            '#main-cart-summary .m-b2b-cart__subtotal',
            "#AjaxCartSubtotal #CartTotal .text-size--large",
            "#cart-notification-subtotal",
            "#Sticky-slidedown-cart > div > div.has-items > div.summary > p > span.price",
            ".subtotal__content-wrap .subtotal__price",
            ".checkout-subtotal-container .subtotal .theme-money"
        ];
        if (BSS_B2B.storeId === 4337) {
            queryArr = ['.cart-drawer__checkout-buttons button span:not([bss-b2b-cart-total-price]), #cart-summary p.mb-0.h6'];
        }
        if ([11946].includes(BSS_B2B.storeId)) {
            queryArr = ['.sf-cart__summary-row.sf-cart-subtotal .wcp-original-cart-total, .scd__summary .scd__subtotal .scd__subtotal-price span, .scd__subtotal .scd__subtotal-price'];
        }
        // fix for carabc.cn
        if ([12691].includes(BSS_B2B.storeId)) {
            queryArr = ['.cart__footer__total p .cart__footer__value'];
        }
        if (BSS_B2B.storeId === 8860) {
            queryArr = ['.cart-subtotal .money, .cart-title-total .money'];
        }
        if (BSS_B2B.storeId === 13552) {
            queryArr = ['.ot-subtotal span, .alpha-cart-total-price span'];
        }
        if (BSS_B2B.storeId === 13890) {
            queryArr = ['.totals .totals__total-value']
        }
        if (BSS_B2B.storeId === 14389) {
            queryArr = ['.ajaxcart__price [bss-b2b-ajax-cart-subtotal]', '#revy-cart-subtotal-price [bss-b2b-cart-total-price]']
        }
        if ([14184].includes(BSS_B2B.storeId)) {
            queryArr = ['.limoniapps-discountninja-cart-subtotal-price > span']
        }
        if (BSS_B2B.storeId === 13615) {
            queryArr = ['#main-cart-footer .docapp-cart-subtotal .money']
        }
        if (BSS_B2B.storeId === 16257) {
            queryArr = ['button.btn.btn--primary.btn--icon-with-text.w-full > span', '.cart__summary div > p.mb-0.h6']
        }
        if (BSS_B2B.storeId === 14608) {
            queryArr = ['.docapp-cart-subtotal .docapp-right .buckscc-money', '.docapp-est-total .docapp-right .buckscc-money']
        }
        return queryArr;
    };

    BSS_B2B.qb.buttonShowQuickViewElement = $(
        'button[id^="quick-add-template"],' +
        '.productitem--actions .quickshop-button button.productitem--action-trigger,' +
        '.productitem--actions .atc--button button.productitem--action-trigger,' +
        'loess-product-card button[is="loess-button"]',
    );

    BSS_B2B.qb.checkCustomer = function (rule, customer) {
        let applyTo = rule.apply_to;
        let customerIds = rule.customer_ids;
        let customerTags = rule.customer_tags;
        let excludeCustomerTags = rule.exc_customer_tags;
        let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
        let exclude_customers = rule.exc_customers;

        if (excludeFrom === 1) {
            if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                excludeCustomerTags = excludeCustomerTags.split(',').map((tag) => tag.toLowerCase());
                let checkArray = excludeCustomerTags.filter(tag => customer.tags.includes(tag + ''));
                if (checkArray.length > 0) {
                    return true;
                }
            }
        }
        else if (excludeFrom === 2) {
            if (exclude_customers) {
                if (exclude_customers.includes(`${customer.id}`)) {
                    return true;
                }
            }
        }
        if (applyTo === 0) {
            // do nothing
        }
        else if (applyTo === 1) {
            if (customer.id == null) {
                return true;
            }
        }
        else if (applyTo === 2) {
            if (customer.id !== null) {
                return true;
            }
        }
        else if (applyTo === 3) {
            if (customer.id == null) {
                return true;
            }
            else {
                customerIds = customerIds ? customerIds.split(',') : [];
                if (customerIds.indexOf(customer.id + '') === -1) {
                    return true;
                }
            }
        }
        else if (applyTo === 4) {
            if (customer.tags == null) {
                return true;
            }
            else {
                customerTags = customerTags.split(',').map((tag) => tag.toLowerCase().trim());
                let tagsOfCustomer = customer.tags.map((tag) => {
                    return tag.toLowerCase().trim();
                });
                let checkArray = customerTags.filter((tag) => tagsOfCustomer.includes(tag));
                if (checkArray.length === 0) {
                    return true;
                }
            }
        }

        return false;
    };

    BSS_B2B.qb.filterRule = function (rule, productId, collections, tags) {
        let appliedQbRule = false;
        let conditionType = rule.product_condition_type;
        let ruleTags = rule.product_tags ? rule.product_tags.split(',').map((tag) => tag.toLowerCase()) : [];
        let specificProductIds = rule.product_ids ? rule.product_ids.split(',') : [];
        let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(',') : [];

        if (conditionType === 0) {
            appliedQbRule = rule;
        }
        else if (conditionType === 1) {
            if (specificProductIds.indexOf(productId + '') !== -1) {
                appliedQbRule = rule;
            }
        }
        else if (conditionType === 2) {
            let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ''));
            if (checkArray.length > 0) {
                appliedQbRule = rule;
            }
        }
        else if (conditionType === 3) {
            let checkArray = ruleTags.filter(tag => tags.includes(tag + ''));
            if (checkArray.length > 0) {
                appliedQbRule = rule;
            }
        }
        return appliedQbRule;
    };

    /**
     * Insert each qty table applied to each line item on cart page
     */
    BSS_B2B.qb.insertQtyTableToCartItemBlock = async function (newCartData = false, isAjaxCart) {
        BSS_B2B.calculateModules.get('QB').isDoneCalculate = false;
        try {
            let appliedTaxDisplayRule = null;
            if (isEnabledTD && BSS_B2B.taxDisplayRules && (BSS_B2B.taxDisplayRules.length > 0)) {
                appliedTaxDisplayRule = _taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1___default.a.getAppliedRuleCartPage(BSS_B2B, shopData);
            }

            let cartData = shopData.cart;
            if (newCartData) {
                cartData = newCartData;
            }

            if ([10052, 8640, 15588].includes(BSS_B2B.storeId)) {
                await BSS_B2B.getItemCartMetaField();
            }

            if (cartData.items && cartData.items.length > 0) {
                let handleURLs = [];
                let handles = [];
                let keyIdMap = new Map();
                let cartItemProductMap = new Map();
                let cartItemProductMapByKey = new Map();
                let cartItemProductMapByKeyGenerateQbTable = new Map();
                cartData.items.forEach(function (item, index) {
                    let proId = item.product_id;
                    if (handles.indexOf(proId) === -1) {
                        handles.push(proId);
                        handleURLs.push('id:"' + proId + '"');
                        keyIdMap.set(proId, []);
                    }
                    let productItemKeys = keyIdMap.get(proId);
                    productItemKeys.push(item.key);
                    keyIdMap.set(proId, productItemKeys);

                    /* Show price  when use QB */
                    let productVariants = cartItemProductMap.get(proId);
                    if (!productVariants || productVariants === undefined) {
                        cartItemProductMap.set(proId, []);
                        productVariants = [];
                    }
                    let cartItem = {
                        key: item.key,
                        quantity: item.quantity,
                        id: item.variant_id,
                        price: item.price,
                        index: index,
                        product_id: proId,
                        properties: item.properties ? item.properties : null,
                        taxable: item.taxable,
                        selling_plan_allocation: item.selling_plan_allocation ? item.selling_plan_allocation : null,
                    };
                    // fix wrong dataItemKey

                    if (BSS_B2B.storeId === 2311) {
                        let productId = item.id
                        let linePriceElement = document.querySelector('[bss-b2b-product-id="' + productId + '"][data-cart-item-key]')
                        let newCartItemKey = linePriceElement.getAttribute('data-cart-item-key')
                        if (newCartItemKey !== item.key) {
                            cartItem.key = newCartItemKey
                        }
                    }
                    productVariants.push(cartItem);
                    cartItemProductMap.set(proId, productVariants);
                    cartItemProductMapByKey.set(item.key, cartItem);
                    cartItemProductMapByKeyGenerateQbTable.set(item.key, cartItem);
                });
                let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
                let encodeUrlData = encodeURI(urlData);
                $.get(encodeUrlData, function (data) {
                    let responseProducts = [];
                    let productIdNoMetaField = [];
                    try {
                        responseProducts = JSON.parse(data);
                        responseProducts.map(item => productIdNoMetaField.push(item.id));
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.log('B2B: JSON parse returns no item');
                    }

                    if ([10052, 8640, 15588, 621].includes(BSS_B2B.storeId)) {
                        if (shopData.line_item_products) {
                            shopData.line_item_products.map(item => {
                                if (!productIdNoMetaField.includes(item.id) && handles.includes(item.id)) {
                                    responseProducts.push(item);
                                }
                            });
                        }
                    }

                    if (responseProducts.length > 0) {
                        let productMap = [];
                        let checkUnique = [];
                        for (let i = 0; i < responseProducts.length; i++) {
                            let pro = responseProducts[i];

                            if (checkUnique.indexOf(pro.id) === -1) {
                                checkUnique.push(pro.id);
                                keyIdMap.get(pro.id).forEach(function (key) {
                                    productMap.push({
                                        id: pro.id,
                                        tags: pro.tags,
                                        collections: pro.collections,
                                        key: key,
                                        price: pro.price,
                                    });
                                });
                            }
                        }
                        let timeoutLoadPriceQB = 0;
                        if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                            (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0)) {
                            timeoutLoadPriceQB = 1000;
                        }
                        if (BSS_B2B.storeId === 7211) {
                            timeoutLoadPriceQB = 400;
                        }
                        if (BSS_B2B.storeId === 11805) {
                            timeoutLoadPriceQB = 1500;
                        }
                        if (BSS_B2B.storeId === 13129 && isEnableQB && BSS_B2B.page.isCartPage()) {
                            timeoutLoadPriceQB = 2700;
                        }
                        setTimeout(() => {
                            let getPriceListAppliedQBOrAB = BSS_B2B.qb.getPriceList(productMap, cartItemProductMap,
                                cartItemProductMapByKey);
                            let qbPricingList = new Map();
                            getPriceListAppliedQBOrAB.priceLists.forEach(item => {
                                qbPricingList.set(item.key, item);
                            });
                            let newCartItemProductMapByKey = getPriceListAppliedQBOrAB.newCartItemProductMapByKey;
                            BSS_B2B.cart.qbPricingList = qbPricingList;
                            BSS_B2B.calculateModules.get('QB').isDoneCalculate = true;
                            let ruleMap = getPriceListAppliedQBOrAB.appliedRulesForCartItemsByKey;
                            if (qbPricingList && (qbPricingList.size > 0)) {
                                BSS_B2B.qb.showPriceWhenUseQB(qbPricingList, BSS_B2B.cart.cpPricingList, cartData,
                                    shopData, appliedTaxDisplayRule, cartItemProductMapByKey, ruleMap);
                            }
                            else {
                                if (appliedTaxDisplayRule) {
                                    let cartSubtotalNoVat = 0;
                                    let cartSubtotalWithVat = 0;
                                    newCartItemProductMapByKey.forEach(item => {
                                        let pricePerItem = item.price;
                                        if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                                            (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                                            let itemCP = BSS_B2B.cart.cpPricingList.get(item.key);
                                            if (itemCP) {
                                                pricePerItem = itemCP.modifiedItemPrice;
                                            }
                                        }

                                        pricePerItem = window.BSS_B2B.executeFilter({ tag: 'update_price_per_item', storeId: 13760, val: pricePerItem, price: pricePerItem, isVat: false })
                                        _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartItemChangeVatPrice(item.key, shopData, pricePerItem,
                                            appliedTaxDisplayRule, item.index, item.taxable);
                                        let {
                                            itemNoVatPrice, itemWithVatPrice,
                                        } = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartLineItemChangeVatPrice(item.key, shopData,
                                            (pricePerItem) * item.quantity, appliedTaxDisplayRule, item.index,
                                            item.taxable);
                                        cartSubtotalNoVat += itemNoVatPrice;
                                        cartSubtotalWithVat += itemWithVatPrice;
                                    });

                                    _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartChangeSubtotalVatPrice(shopData, cartSubtotalWithVat,
                                        cartSubtotalNoVat, appliedTaxDisplayRule);
                                }
                                else {
                                    newCartItemProductMapByKey.forEach(item => {
                                        _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartItemChangeVatPrice(item.key, shopData, null, null, item.index,
                                            item.taxable);
                                        _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartLineItemChangeVatPrice(item.key, shopData, null,
                                            appliedTaxDisplayRule, item.index, item.taxable);
                                    });
                                    _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartChangeSubtotalVatPrice(shopData, null, null, appliedTaxDisplayRule);
                                }

                                let cartSubtotalPriceElement = BSS_B2B.qb.cartSubtotalPriceElement().join(',');
                                if ($(cartSubtotalPriceElement).length) {
                                    $(cartSubtotalPriceElement).css('text-decoration', 'none');
                                    if ($('.bss-qb-cart-subtotal').length) {
                                        $('.bss-qb-cart-subtotal').remove();
                                    }
                                }

                                if ([2933, 4441, 5980, 8927, 14806].indexOf(BSS_B2B.storeId) !== -1) {
                                    if (BSS_B2B.storeId === 4441) {
                                        $('.hulkapps-cart-item-price .pplr_item_price').css('text-decoration', 'none');
                                        $('.product-subtotal .money').css('text-decoration', 'none');
                                    }
                                    if (BSS_B2B.storeId === 5980) {
                                        $('.cart--total > .price').css('text-decoration', 'none');
                                        $('.cart--price > .price-box').css('text-decoration', 'none');
                                    }

                                    if (BSS_B2B.storeId === 8927) {
                                        $('.cart_price > .th_item_price, .mini_cart_meta .cart_price').
                                            css('text-decoration', 'none');
                                        $('.mini_cart_wrap .js_cat_ttprice').css('display', 'block');
                                    }

                                    if ($('.bss-qb-price-item').length) {
                                        $('.bss-qb-price-item').remove();
                                    }
                                    if ($('.bss-qb-total-price-item').length) {
                                        $('.bss-qb-total-price-item').remove();
                                    }
                                    if (BSS_B2B.storeId === 14806) {
                                        $(".cart-table .item-details .price-preview span[bss-b2b-item-original-price]").css('text-decoration', 'none');
                                    }
                                }
                                if (isEnableMC) {
                                    // init convert currency function
                                    BSS_B2B.MC.changeCurrencyCartPageQB();
                                }
                                // for compare with purchase-late of bcp by Leorio
                                if (window.location.pathname === '/apps/customer-portal/purchase-late') {
                                    $('[bss-b2b-bcp-cart-subtotal-price],' + '[bss-b2b-bcp-cart-total-price],' +
                                        '.bss-b2b-bcp-new-line-item-price').css('visibility', 'visible');
                                }
                            }

                            let event = new CustomEvent('bss_b2b_doneCheckQb', {
                                detail: { shopData, cartData },
                            });
                            document.dispatchEvent(event);

                            ruleMap.forEach(function (value, key) {
                                cartItemProductMapByKeyGenerateQbTable.forEach(item => {
                                    if (item.key === key) {
                                        value.price = item.price;
                                    }
                                    // fix for shop-ahika by DangNM
                                    if (BSS_B2B.storeId === 2933) {
                                        let exist = item.key;
                                        let arrayQbPricingList = Array.from(qbPricingList.values());
                                        arrayQbPricingList.every(p => {
                                            if (item.key === p.key) {
                                                exist = false;
                                                return false;
                                            }
                                            return true;
                                        });
                                        if (exist) {
                                            $('[data-cart-item-key="' + exist + '"] .bss-qb-price-item').remove();
                                            $('[data-cart-item-key="' + exist + '"] [bss-b2b-item-original-price]').
                                                css({ 'text-decoration': 'none' });
                                            $('[data-cart-item-key="' + exist + '"] .bss-qb-total-price-item').remove();
                                            $('[data-cart-item-key="' + exist + '"] [bss-b2b-original-line-price]').
                                                css({ 'text-decoration': 'none' });
                                        }
                                    }
                                });

                                if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                                    (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0)) {
                                    let itemCP = BSS_B2B.cart.cpPricingList.get(key);
                                    if (itemCP) {
                                        value.price = itemCP.modifiedItemPrice;
                                    }
                                }
                                BSS_B2B.qb.generateTableOnCartPage(key, value, isAjaxCart, productMap);
                            });
                            /**
                             * Slide Toggle qty table
                             */
                            if (window.location.pathname != '/apps/customer-portal/quick-order') {
                                let toggleQBCartButton = $('.bss-b2b-up-down-qb-btn');
                                if (toggleQBCartButton.length) {
                                    toggleQBCartButton.each(function () {
                                        if (!$(this).attr('bss-qb-toggle-table-event')) {
                                            $(this).attr('bss-qb-toggle-table-event', true);
                                            $(this).on('click', function (e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if ($(this).text() === 'â†“') {
                                                    $(this).html(`â†‘`);
                                                }
                                                else if ($(this).text() === 'â†‘') {
                                                    $(this).html(`â†“`);
                                                }
                                                $(this).
                                                    closest('.bss-b2b-cart-item-qty-table').
                                                    find('.bss-b2b-qty-table-wrapper').
                                                    toggle();
                                            });
                                        }
                                    });
                                }

                            }

                            // fix for clickbeauty by mitri
                            if (BSS_B2B.storeId === 1967) {
                                $('.bss-b2b-qty-table-wrapper').attr('style', 'display: block !important');
                            }
                            else if (BSS_B2B.storeId === 7719 && appliedTaxDisplayRule) {
                                $('[bss-b2b-cart-total-price]').css('text-decoration', 'line-through');
                            }

                        }, timeoutLoadPriceQB);
                    }
                });

                if (!(isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                    (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0))) {
                    $(BSS_B2B.cart.removeButtons).on('click', function () {
                        BSS_B2B.cart.cartQtyOnChange(1200, 2000, true);
                    });
                }
            }
            else {
                // eslint-disable-next-line no-console
                console.log('Could not get cart data ');
                // fix for shop-ahika by DangNM
                if (BSS_B2B.storeId === 2933) {
                    if ($('.bss-qb-cart-subtotal').length) {
                        $('.bss-qb-cart-subtotal').remove();
                        $('.cart__popup-stotal .amount.cart__subtotal').css({ 'text-decoration': 'none' });
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log('Could not get shop data');
        }
    };

    /**
     * Get product by Id
     * @param {*} productId
     * @returns
     */
    BSS_B2B.qb.getProductById = async function (productId) {
        const urlData = '/search?q=' + 'id:"' + productId + '"' + '&view=bss.b2b';
        const encodeUrlData = encodeURI(urlData);
        let data = await fetch(encodeUrlData);
        data = await data.json();
        if (data && data.length > 0) {
            return data[0];
        }
        else {
            return {};
        }
    };

    /**
     * Get all rule for product on product page
     * @param formProductId
     * @returns {boolean}
     */
    BSS_B2B.qb.getAllRuleApplyForProduct = function (formProductId, productTags = null, isQuickView = null) {
        let currentVariant = false;
        let currentVariantId = false;
        let queryArray = BSS_B2B.getQueryArray();
        let queryVariant = 'form[action*="/cart/add"]';
        if (isQuickView) {
            queryVariant = 'div[id^="QuickAddInfo"] form[action*="/cart/add"]';
        }
        let variantSelector = $(queryVariant).find('select[name="id"]');
        // fix for theme Dawn by mitri
        if (!variantSelector.length) {
            variantSelector = $(queryVariant).find('input[name="id"]');
        }

        if (variantSelector.length) {
            currentVariantId = variantSelector.val();
        }

        if (queryArray.indexOf('variant') !== -1) {
            currentVariantId = queryArray['variant'];
        }
        // fix krkcwholesale by DongNV 5515
        window.BSS_B2B.executeAction({ tag: `get_variant`, storeId: false });
        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        let product = shopData.product;
        let listVariants = product.variants;
        listVariants.forEach(variant => {
            let variantId = variant.id.toString();
            if (variantId === currentVariantId) {
                currentVariant = variant;

            }
        });

        let productId = product ? product.id : '';

        if (formProductId) {
            productId = formProductId;
        }
        let appliedRuleList = [];
        BSS_B2B.qbRules.forEach(function (rule) {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (checkCustomer) {
                return;
            }
            let collections = [];
            if (isQuickView) {
                collections = product.collections;
            }
            else {
                collections = shopData.collections;
            }

            let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';
            if (productTags) {
                tags = productTags;
            }
            let appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);
            if (appliedQbRule) {
                if (BSS_B2B.cp.productAfterUseCP.length > 0) {
                    BSS_B2B.cp.productAfterUseCP.forEach(item => {
                        if (item.id === productId) {
                            appliedQbRule.price = item.price;
                        }
                    });
                    window.BSS_B2B.executeAction({ tag: 'fix_add_price_on_qb_rule', storeId: 12294, appliedQbRule, currentVariantId, currentVariant, product });
                }
                else if (currentVariantId) {
                    appliedQbRule.price = currentVariant.price;
                }
                else {
                    appliedQbRule.price = product.price;
                }
                // fix for storeID 2524
                window.BSS_B2B.executeAction({ tag: 'get_applied_tax', storeId: false, appliedQbRule, tags: product.tags });

                if (currentVariantId) {
                    appliedQbRule.taxable = false;
                    if (isEnabledTD && BSS_B2B.taxDisplayRules && (BSS_B2B.taxDisplayRules.length > 0) &&
                        BSS_B2B.page.isProductPage()) {
                        product.variants.map((variantItem) => {
                            if (variantItem.id == currentVariantId) {
                                appliedQbRule.taxable = variantItem.taxable;
                            }
                        });
                    }
                }
                appliedRuleList.push(appliedQbRule);
            }
        });

        return appliedRuleList;
    };

    /**
     * Get applied rule for given product
     * @param product
     * @param variantId
     */
    BSS_B2B.qb.getAppliedRuleForEachProduct = function (product, variantId) {

        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        let productId = product.id;
        let variant = null;
        product.variants.every((item) => {
            if (item.id === variantId) {
                variant = item;
                return false;
            }
            return true;
        });
        let appliedQbRule = false;
        BSS_B2B.qbRules.every((rule) => {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (checkCustomer) {
                return true;
            }

            let collections = product.collections;
            let tags = product.tags.map((tag) => tag.toLowerCase());
            appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

            if (appliedQbRule) {
                return false;
            }
            else {
                return true;
            }
        });
        if (appliedQbRule) {
            if (BSS_B2B.cp.productAfterUseCP.length > 0) {
                BSS_B2B.cp.productAfterUseCP.forEach(item => {
                    if (item.id === productId) {
                        appliedQbRule.price = item.price;
                    }
                });
            }
            else if (variant) {
                appliedQbRule.price = variant.price;
            }
            else {
                appliedQbRule.price = product.price;
            }
            // fix for storeID 2524
            window.BSS_B2B.executeAction({ tag: 'get_applied_tax', storeId: false, appliedQbRule, tags: product.tags });
        }
        BSS_B2B.qb.appliedQbRuleForOneProduct = appliedQbRule;
        return appliedQbRule;
    };

    BSS_B2B.qb.getQBProductPrice = function (appliedQbRule, selectedVariantId, product, quantity) {
        let qtyTable = appliedQbRule.qty_table;
        let pricePerProduct = appliedQbRule.price;
        let totalPriceOfProduct = parseFloat(pricePerProduct) * quantity;
        if (!qtyTable || qtyTable == undefined) {
            qtyTable = [];
        }
        let amountTable = appliedQbRule.amount_table;
        if (!amountTable || amountTable == undefined) {
            amountTable = [];
        }
        let discountValue = -1;
        let discountType = -1;
        if (appliedQbRule.rule_setting === 0) {
            qtyTable.forEach(function (qtyRow) {
                let qtyFrom = parseInt(qtyRow.qty_from);
                let qtyTo = qtyRow.qty_to;
                if (qtyTo != null && qtyTo.toString().length > 0) {
                    qtyTo = parseInt(qtyRow.qty_to);
                    if (quantity >= qtyFrom && quantity <= qtyTo) {
                        discountValue = parseFloat(qtyRow.discount_value);
                        discountType = parseInt(qtyRow.discount_type);
                    }
                }
                else {
                    if (quantity >= qtyFrom) {
                        discountValue = parseFloat(qtyRow.discount_value);
                        discountType = parseInt(qtyRow.discount_type);
                    }
                }
            });
        }
        else {
            amountTable.forEach(function (amountRow) {
                let amountFrom = parseFloat(amountRow.amount_from) * 100;
                let amountTo = amountRow.amount_to;

                if (amountTo != null && amountTo.toString().length > 0) {
                    amountTo = parseFloat(amountRow.amount_to) * 100;
                    if (totalPriceOfProduct >= amountFrom && amountTo >= totalPriceOfProduct) {
                        discountValue = parseFloat(amountRow.discount_value);
                        discountType = parseInt(amountRow.discount_type);
                    }
                }
                else {
                    if (totalPriceOfProduct >= amountFrom) {
                        discountValue = parseFloat(amountRow.discount_value);
                        discountType = parseInt(amountRow.discount_type);
                    }
                }
            });
        }
        let currentVariantPrice = product.price;
        if (discountType != -1 && discountValue != -1) {
            let variants = product.variants;
            if (variants && Object.keys(variants).length) {
                Object.keys(variants).map(key => {
                    if (variants[key].id == selectedVariantId) {
                        currentVariantPrice = variants[key].price;
                    }
                });
            }
            currentVariantPrice = parseFloat(currentVariantPrice);

            if (discountType == 0) {
                discountValue = discountValue * 100;
                if (discountValue < currentVariantPrice) {
                    return discountValue;
                }
                else {
                    return currentVariantPrice;
                }
            }
            else if (discountType == 1) {
                discountValue = discountValue * 100;
                if (discountValue < currentVariantPrice) {
                    return currentVariantPrice - discountValue;
                }
                else {
                    return currentVariantPrice;
                }
            }
            else if (discountType == 2) {
                let correctDiscount = 1 - discountValue / 100;
                correctDiscount = parseFloat(correctDiscount.toFixed(2));
                return currentVariantPrice * correctDiscount;
            }
        }

        return currentVariantPrice;
    },

        /**
         * Get applied rule for product on product page
         * @param formProductId
         * @returns {boolean}
         */
        BSS_B2B.qb.getAppliedRuleOnProductPage = function (formProductId, productTags = null) {
            let currentVariant = false;
            let currentVariantId = false;
            let queryArray = BSS_B2B.getQueryArray();

            let variantSelector = $('form[action*="/cart/add"]').find('select[name="id"]');

            //fix for smartmovemedical by HaiNN
            if (BSS_B2B.storeId != 5980) {
                // fix for theme Dawn by mitri
                if (!variantSelector.length || BSS_B2B.storeId === 9835) {
                    variantSelector = $('form[action*="/cart/add"]').find('input[name="id"]');
                }
                else if (BSS_B2B.storeId === 1825) {
                    variantSelector = $('.quantity form[action*="/cart/add"]').find('select[name="id"]');
                }
            }
            if (BSS_B2B.storeId === 13871) {
                variantSelector = $('form[action*="/cart/add"]').find('input[name="id"]');
            }
            if (variantSelector.length) {
                currentVariantId = variantSelector.val();
            }

            if (queryArray.indexOf('variant') !== -1) {
                currentVariantId = queryArray['variant'];
            }
            // fix krkcwholesale by DongNV 5515
            window.BSS_B2B.executeAction({ tag: `get_variant`, storeId: false });
            // fix euro-trade.com by LuanHV
            if ([6605, 8827, 9854].includes(BSS_B2B.storeId)) {
                variantSelector = $('.product-meta form[action="/cart/add"] input[name="id"]');
                currentVariantId = variantSelector.val();
            }
            if (!currentVariantId) {
                let variantSelector = $('form[action*="/cart/add"]').find('input[name="id"], select[name="id"], select[data-variant-input], .option-lists');
                currentVariantId = variantSelector.val() || variantSelector.attr('value');
            }
            let customer = shopData.customer;
            if (customer.id != null && customer.tags != null) {
                customer.tags = customer.tags.map((tag) => tag.toLowerCase());
            }
            let product = shopData.product;
            let listVariants = product.variants;
            listVariants.forEach(variant => {
                let variantId = variant.id.toString();
                if (variantId === currentVariantId) {
                    currentVariant = variant;

                }
            });

            let productId = product ? product.id : '';
            if (formProductId) {
                productId = formProductId;
            }
            let appliedQbRule = false;
            BSS_B2B.qbRules.forEach(function (rule) {
                let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
                if (appliedQbRule || checkCustomer) {
                    return;
                }

                let collections = shopData.collections;
                let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';
                if (productTags) {
                    tags = productTags;
                }
                appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

                if (appliedQbRule) {
                    appliedQbRule = JSON.parse(JSON.stringify(appliedQbRule));
                }
            });
            if (appliedQbRule) {
                if (BSS_B2B.cp.productAfterUseCP.length > 0) {
                    BSS_B2B.cp.productAfterUseCP.forEach((item) => {
                        if (item.id === productId) {
                            appliedQbRule.price = item.price;
                        }
                    });
                    window.BSS_B2B.executeAction({ tag: 'fix_add_price_on_qb_rule', storeId: 12294, appliedQbRule, currentVariantId, currentVariant, product });
                    if ([9451, 9854, 8243, 621, 15486].includes(BSS_B2B.storeId) && !appliedQbRule.price) {
                        if (currentVariantId && currentVariant && currentVariant.price) {
                            appliedQbRule.price = currentVariant.price;
                        }
                        else {
                            appliedQbRule.price = product.price;
                        }
                    }
                }
                else if (currentVariantId && currentVariant && currentVariant.price) {
                    appliedQbRule.price = currentVariant.price;
                }
                else {
                    appliedQbRule.price = product.price;
                }
                // fix for storeID 2524
                window.BSS_B2B.executeAction({ tag: 'get_applied_tax', storeId: false, appliedQbRule, tags: product.tags });

                if (currentVariantId) {
                    appliedQbRule.taxable = false;
                    if (isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length > 0 &&
                        BSS_B2B.page.isProductPage()) {
                        product.variants.map((variantItem) => {
                            if (variantItem.id == currentVariantId) {
                                appliedQbRule.taxable = variantItem.taxable;
                            }
                        });
                    }
                }
            }
            BSS_B2B.qb.appliedQbRuleForOneProduct = appliedQbRule;

            return appliedQbRule;
        };

    /**
     * Get applied rule for product quick view on collection page
     * @param formProductId
     * @param productTags
     */
    BSS_B2B.qb.getAppliedRuleOnQuickView = function (formProductId, productTags = null) {
        let currentVariant = false;
        let currentVariantId = false;
        let queryArray = BSS_B2B.getQueryArray();

        let variantSelector = $('div[id^="QuickAddInfo"]').find('select[name="id"]');

        if (variantSelector.length) {
            currentVariantId = variantSelector.val();
        }

        if (queryArray.indexOf('variant') !== -1) {
            currentVariantId = queryArray['variant'];
        }

        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        let product = shopData.product;
        let listVariants = product.variants;
        listVariants.forEach(variant => {
            let variantId = variant.id.toString();
            if (variantId === currentVariantId) {
                currentVariant = variant;

            }
        });

        let productId = product ? product.id : '';

        if (formProductId) {
            productId = formProductId;
        }
        let appliedQbRule = false;
        BSS_B2B.qbRules.forEach(function (rule) {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (appliedQbRule || checkCustomer) {
                return;
            }

            let collections = product.collections;
            let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';
            if (productTags) {
                tags = productTags;
            }
            appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

            if (appliedQbRule) {
                appliedQbRule = JSON.parse(JSON.stringify(appliedQbRule));
            }
        });
        if (appliedQbRule) {
            if (BSS_B2B.cp.productAfterUseCP.length > 0) {
                BSS_B2B.cp.productAfterUseCP.forEach((item) => {
                    if (item.id === productId) {
                        appliedQbRule.price = item.price;
                    }
                });
            }
            else if (currentVariantId) {
                appliedQbRule.price = currentVariant.price;
            }
            else {
                appliedQbRule.price = product.price;
            }
            if (currentVariantId) {
                appliedQbRule.taxable = false;
                if (isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length > 0 &&
                    BSS_B2B.page.isCollectionPage()) {
                    product.variants.map((variantItem) => {
                        if (variantItem.id == currentVariantId) {
                            appliedQbRule.taxable = variantItem.taxable;
                        }
                    });
                }
            }
        }
        BSS_B2B.qb.appliedQbRuleForOneProduct = appliedQbRule;

        return appliedQbRule;
    };

    /**
     * Get applied rule for product on product listing page
     * @param formProductId
     * @returns {boolean}
     */
    BSS_B2B.qb.getAppliedRuleOnProductListingPage = function (formProductId, productTags) {

        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        let product = shopData.product;
        let productId = product ? product.id : '';
        if (formProductId) {
            productId = formProductId;
        }
        let appliedQbRule = false;
        BSS_B2B.qbRules.forEach(function (rule) {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (appliedQbRule || checkCustomer) {
                return;
            }

            let collections = shopData.collections;
            let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';
            if (productTags) {
                tags = productTags;
            }
            appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

            if (appliedQbRule) {
                appliedQbRule = JSON.parse(JSON.stringify(appliedQbRule));
            }
        });
        if (appliedQbRule) {
            if (BSS_B2B.cp.productAfterUseCP.length > 0) {
                BSS_B2B.cp.productAfterUseCP.forEach(item => {
                    if (item.id === productId) {
                        appliedQbRule.price = item.price;
                    }
                });
            }
            // fix for storeID 2524
            window.BSS_B2B.executeAction({ tag: 'get_applied_tax', storeId: 2524, appliedQbRule, tags: product.tags });
        }

        BSS_B2B.qb.appliedQbRuleForOneProduct = appliedQbRule;

        return appliedQbRule;
    };

    /**
     * Get applied rule map for products in cart
     * @param productsInCart
     * @returns {boolean}
     */
    BSS_B2B.qb.getAppliedRulesForCartItems = function (productMap) {

        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        let ruleMapForId = new Map();
        let ruleMapForKey = new Map();

        BSS_B2B.qbRules.forEach(function (rule) {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (checkCustomer) {
                return;
            }

            productMap.forEach(function (item) {
                if (ruleMapForId.get(item.id) && ruleMapForKey.get(item.key)) {
                    return;
                }

                let collections = item.collections;
                let tags = item.tags.map((tag) => tag.toLowerCase());
                let productId = item.id;
                let appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

                if (appliedQbRule) {
                    let newAppliedQbRule = { ...appliedQbRule };
                    newAppliedQbRule.price = item.price;
                    ruleMapForId.set(item.id, newAppliedQbRule);
                    ruleMapForKey.set(item.key, newAppliedQbRule);
                    item.appliedQbRule = true;

                }
            });
        });

        return {
            ruleMapForId: ruleMapForId, ruleMapForKey: ruleMapForKey,
        };
    };

    BSS_B2B.qb.discountCalculation = function (table, ruleSetting, totalValue) {
        let discountType = -1;
        let discountValue = -1;
        let appliedTableRowId = null;
        let rateMarket = Shopify.currency.rate;
        if (ruleSetting === 0) {
            let totalQuantity = totalValue;
            table.forEach(function (qtyRow) {
                let qtyFrom = parseInt(qtyRow.qty_from);
                let qtyTo = qtyRow.qty_to;
                if (qtyTo != null && qtyTo.toString().length > 0) {
                    qtyTo = parseInt(qtyRow.qty_to);
                    if (totalQuantity >= qtyFrom && totalQuantity <= qtyTo) {
                        discountValue = parseFloat(qtyRow.discount_value);
                        discountType = parseInt(qtyRow.discount_type);
                        appliedTableRowId = qtyRow.id;
                    }
                }
                else {
                    if (totalQuantity >= qtyFrom) {
                        discountValue = parseFloat(qtyRow.discount_value);
                        discountType = parseInt(qtyRow.discount_type);
                        appliedTableRowId = qtyRow.id;
                    }
                }
            });
        }
        else {
            let totalAmount = totalValue;
            table.forEach(function (amountRow) {
                let amountFrom = parseFloat(amountRow.amount_from) * rateMarket;
                let amountTo = amountRow.amount_to != null ? parseFloat(amountRow.amount_to) * rateMarket : null;
                if (amountTo != null && amountTo.toString().length > 0) {
                    if (totalAmount >= amountFrom && totalAmount <= amountTo) {
                        discountValue = parseFloat(amountRow.discount_value);
                        discountType = parseInt(amountRow.discount_type);
                        appliedTableRowId = amountRow.id;
                    }
                }
                else {
                    if (totalAmount >= amountFrom) {
                        discountValue = parseFloat(amountRow.discount_value);
                        discountType = parseInt(amountRow.discount_type);
                        appliedTableRowId = amountRow.id;
                    }
                }
            });
        }

        return {
            discountType: discountType, discountValue: discountValue, appliedTableRowId: appliedTableRowId,
        };
    };

    /**
     * Get QB Price List
     */
    BSS_B2B.qb.getPriceList = function (productMap, cartItemProductMap, cartItemProductMapByKey) {
        if (isEnableQB === 0) {
            return [];
        }
        let newCartItemProductMapByKey = cartItemProductMapByKey;
        let appliedRulesForCartItems = BSS_B2B.qb.getAppliedRulesForCartItems(productMap, cartItemProductMap);
        let appliedRulesForCartItemsByKey = appliedRulesForCartItems.ruleMapForKey;
        let appliedRulesForCartItemsById = appliedRulesForCartItems.ruleMapForId;

        let productRuleType2 = new Map();
        appliedRulesForCartItemsById.forEach(function (value, key) {
            if (value.rule_type === 1) {
                let prods = productRuleType2.get(value.id);
                if (!prods || prods === undefined) {
                    prods = [];
                    productRuleType2.set(value.id, []);
                }
                prods.push(key);
                productRuleType2.set(value.id, prods);
            }
        });
        let priceLists = [];

        appliedRulesForCartItemsById.forEach(function (value, key) {
            let ruleSetting = value.rule_setting;
            let ruleType = value.rule_type;
            if (ruleSetting === 0) {
                if (ruleType === 0) {
                    let variants = cartItemProductMap.get(key);
                    let totalQuantity = 0;
                    variants.forEach(function (item) {
                        totalQuantity += item.quantity;
                    });
                    let qtyTable = value.qty_table;
                    let discountCalculation = BSS_B2B.qb.discountCalculation(qtyTable, ruleSetting, totalQuantity);
                    let discountType = discountCalculation.discountType;
                    let discountValue = discountCalculation.discountValue;
                    let appliedTableRowId = discountCalculation.appliedTableRowId;

                    if (discountValue !== -1 && discountType !== -1) {
                        variants.forEach(function (item) {
                            let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                discountValue, appliedTableRowId, totalQuantity);
                            // fix for storeID 2524
                            window.BSS_B2B.executeAction({
                                tag: 'get_applied_tax', storeId: 2524, appliedQbRule: valueOfQBPricing,
                                tags: productMap.filter(product => product.id === key)[0].tags
                            });

                            priceLists.push(valueOfQBPricing);
                            newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                        });
                    }
                }
                else if (ruleType === 1) {
                    let appliedProducts = productRuleType2.get(value.id);
                    if (appliedProducts && appliedProducts !== undefined) {
                        let totalQuantity = 0;
                        let variants = cartItemProductMap.get(key);
                        appliedProducts.forEach(function (pro) {
                            let proVariants = cartItemProductMap.get(pro);
                            proVariants.forEach(function (variant) {
                                totalQuantity += variant.quantity;
                            });
                        });

                        let qtyTable = value.qty_table;
                        let discountCalculation = BSS_B2B.qb.discountCalculation(qtyTable, ruleSetting, totalQuantity);
                        let discountType = discountCalculation.discountType;
                        let discountValue = discountCalculation.discountValue;
                        let appliedTableRowId = discountCalculation.appliedTableRowId;

                        if (discountValue !== -1 && discountType !== -1) {
                            variants.forEach(function (item) {
                                let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                    discountValue, appliedTableRowId, totalQuantity);
                                // fix for storeID 2524
                                window.BSS_B2B.executeAction({
                                    tag: 'get_applied_tax', storeId: 2524, valueOfQBPricing,
                                    tags: productMap.filter(product => product.id === key)[0].tags
                                });

                                priceLists.push(valueOfQBPricing);
                                newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                            });
                        }
                    }
                }
                else {
                    let variants = cartItemProductMap.get(key);
                    let qtyTable = value.qty_table;
                    variants.forEach(function (item) {
                        let variantQuantity = item.quantity;
                        let discountCalculation = BSS_B2B.qb.discountCalculation(qtyTable, ruleSetting,
                            variantQuantity);
                        let discountType = discountCalculation.discountType;
                        let discountValue = discountCalculation.discountValue;
                        let appliedTableRowId = discountCalculation.appliedTableRowId;

                        if (discountValue !== -1 && discountType !== -1) {
                            let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                discountValue, appliedTableRowId, variantQuantity);
                            // fix for storeID 2524
                            window.BSS_B2B.executeAction({
                                tag: 'get_applied_tax', storeId: 2524, valueOfQBPricing,
                                tags: productMap.filter(product => product.id === key)[0].tags
                            });

                            priceLists.push(valueOfQBPricing);
                            newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                        }
                    });
                }
            }
            else { // Amount break
                let cpPricingList = BSS_B2B.cart.cpPricingList;
                if (ruleType === 0) {
                    let variants = cartItemProductMap.get(key);
                    let totalAmount = 0;
                    if (cpPricingList.size > 0) {
                        variants.forEach(function (item) {
                            let itemCP = cpPricingList.get(item.key);
                            let checkAppliedCPAndAB = false;
                            if (itemCP) {
                                totalAmount += itemCP.modifiedLineItemPriceWithMarket * 0.01;
                                checkAppliedCPAndAB = true;
                            }
                            if (!checkAppliedCPAndAB) {
                                totalAmount += (item.quantity) * (item.price) * 0.01;
                            }
                        });
                    }
                    else {
                        variants.forEach(function (item) {
                            totalAmount += (item.quantity) * (item.price) * 0.01;
                        });
                    }

                    let amountTable = value.amount_table;
                    let discountCalculation = BSS_B2B.qb.discountCalculation(amountTable, ruleSetting, totalAmount);
                    let discountType = discountCalculation.discountType;
                    let discountValue = discountCalculation.discountValue;
                    let appliedTableRowId = discountCalculation.appliedTableRowId;

                    if (discountValue !== -1 && discountType !== -1) {
                        variants.forEach(function (item) {
                            let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                discountValue, appliedTableRowId, totalAmount);
                            // fix for storeID 2524
                            window.BSS_B2B.executeAction({
                                tag: 'get_applied_tax', storeId: 2524, valueOfQBPricing,
                                tags: productMap.filter(product => product.id === key)[0].tags
                            });

                            priceLists.push(valueOfQBPricing);
                            newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                        });
                    }
                }
                else if (ruleType === 1) {
                    let appliedProducts = productRuleType2.get(value.id);
                    if (appliedProducts && appliedProducts !== undefined) {
                        let totalAmount = 0;
                        let variants = cartItemProductMap.get(key);
                        appliedProducts.forEach(function (pro) {
                            let proVariants = cartItemProductMap.get(pro);
                            proVariants.forEach(function (variant) {
                                if (cpPricingList.size > 0) {
                                    let itemCP = cpPricingList.get(variant.key);
                                    let checkAppliedCPAndAB = false;
                                    if (itemCP) {
                                        totalAmount += itemCP.modifiedLineItemPriceWithMarket * 0.01;
                                        checkAppliedCPAndAB = true;
                                    }
                                    if (!checkAppliedCPAndAB) {
                                        totalAmount += (variant.quantity) * (variant.price) * 0.01;
                                    }
                                }
                                else {
                                    totalAmount += (variant.quantity) * (variant.price) * 0.01;
                                }
                            });
                        });

                        if (BSS_B2B.storeId === 8452) {
                            if (BSS_B2B.cart.modifiedItemsSubtotalPrice) {
                                totalAmount = BSS_B2B.cart.modifiedItemsSubtotalPrice / 100;
                            }
                            else {
                                totalAmount = shopData.cart.total_price / 100;
                            }
                        }

                        let amountTable = value.amount_table;
                        let discountCalculation = BSS_B2B.qb.discountCalculation(amountTable, ruleSetting, totalAmount);
                        let discountType = discountCalculation.discountType;
                        let discountValue = discountCalculation.discountValue;
                        let appliedTableRowId = discountCalculation.appliedTableRowId;

                        if (discountValue !== -1 && discountType !== -1) {
                            variants.forEach(function (item) {
                                let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                    discountValue, appliedTableRowId, totalAmount);
                                // fix for storeID 2524
                                window.BSS_B2B.executeAction({
                                    tag: 'get_applied_tax', storeId: 2524, valueOfQBPricing,
                                    tags: productMap.filter(product => product.id === key)[0].tags
                                });

                                priceLists.push(valueOfQBPricing);
                                newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                            });
                        }
                    }
                }
                else {
                    let variants = cartItemProductMap.get(key);
                    let amountTable = value.amount_table;
                    variants.forEach(function (item) {
                        let variantAmount = 0;
                        if (cpPricingList.size > 0) {
                            let itemCP = cpPricingList.get(item.key);
                            let checkAppliedCPAndAB = false;
                            if (itemCP) {
                                variantAmount = itemCP.modifiedLineItemPriceWithMarket * 0.01;
                                checkAppliedCPAndAB = true;
                            }
                            if (!checkAppliedCPAndAB) {
                                variantAmount = (item.price) * (item.quantity) * 0.01;
                            }
                        }
                        else {
                            variantAmount = (item.price) * (item.quantity) * 0.01;
                        }

                        let discountCalculation = BSS_B2B.qb.discountCalculation(amountTable, ruleSetting,
                            variantAmount);
                        let discountType = discountCalculation.discountType;
                        let discountValue = discountCalculation.discountValue;
                        let appliedTableRowId = discountCalculation.appliedTableRowId;

                        if (discountValue !== -1 && discountType !== -1) {
                            let valueOfQBPricing = BSS_B2B.qb.defineValueOfQBPricing(item, value, discountType,
                                discountValue, appliedTableRowId, variantAmount);
                            // fix for storeID 2524
                            window.BSS_B2B.executeAction({
                                tag: 'get_applied_tax', storeId: 2524, valueOfQBPricing,
                                tags: productMap.filter(product => product.id === key)[0].tags
                            });

                            priceLists.push(valueOfQBPricing);
                            newCartItemProductMapByKey.set(item.key, valueOfQBPricing);
                        }
                    });
                }
            }
        });
        return {
            priceLists: priceLists,
            appliedRulesForCartItemsByKey: appliedRulesForCartItemsByKey,
            newCartItemProductMapByKey: newCartItemProductMapByKey,
        };
    };

    /**
     * Get qty table html
     */
    BSS_B2B.qb.getQtyTableHtml = function (appliedRule, isShow = true, quantityValue, isShowForCart, isQOPage = false) {
        let qbTableType = appliedRule.qb_table_type;
        let buttonUpDownQuantity = '<button class="bss-b2b-up-down-qb-btn" style="background: transparent; border: none; float: right; width: 100%; height: 100%; color: ' +
            BSS_B2B.designTables.text_header_table_color + '">&#x2193;</button>';
        if (BSS_B2B.page.isProductPage() && !isShowForCart || BSS_B2B.page.isCollectionPage()) {
            buttonUpDownQuantity = '';
        }
        let rateMarket = Shopify.currency.rate;
        let productPrice = appliedRule.price;
        let taxable = appliedRule.taxable ? appliedRule.taxable : false;
        let appliedTaxDisplayRule = null;
        if (isEnabledTD && BSS_B2B.taxDisplayRules && (BSS_B2B.taxDisplayRules.length > 0)) {
            if (BSS_B2B.page.isProductPage()) {
                appliedTaxDisplayRule = _taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1___default.a.getAppliedRule(BSS_B2B, shopData);
            }
            else {
                appliedTaxDisplayRule = _taxexem_taxDisplayRules__WEBPACK_IMPORTED_MODULE_1___default.a.getAppliedRuleCartPage(BSS_B2B, shopData);
            }
        }
        let buyText = BSS_B2B.qbTranslations.buy;
        let taxDisplayConditions = appliedTaxDisplayRule && !isQOPage;
        const checkLength = (i, qtyTableLength) => {
            if (i === qtyTableLength - 1) {
                return true;
            }
            return false;
        };
        // Quantity Break
        if (appliedRule.rule_setting === 0) {
            let qtyTable = appliedRule.qty_table;
            qtyTable.sort((a, b) => {
                return a.id - b.id;
            });
            const appliedSpecificPriceRule = qtyTable.filter((item) => {
                return item.discount_type === 0;
            });
            const decreasePriceRule = qtyTable.filter((item) => {
                return item.discount_type !== 0;
            });
            let table = '<table class="quantity_break_table">';
            let tableDiscountText = BSS_B2B.qbTranslations.table_discount_text;
            let tableAppliedPriceText = BSS_B2B.qbTranslations.price_applied;
            let tableMinimumQuantity = BSS_B2B.qbTranslations.minimum_quantity;
            let tableMaximumQuantity = BSS_B2B.qbTranslations.maximum_quantity;
            let textOff = BSS_B2B.qbTranslations.off;
            let textFor = BSS_B2B.qbTranslations.for;
            let textTotal = BSS_B2B.qbTranslations.total || 'Total';
            let perItemTxtSpan = '<span class="bss-b2b-translation-qb-flat_price_suffix">' +
                BSS_B2B.qbTranslations.flat_price_suffix + '</span>';
            let blankCell = '<td class=\'bss-qty-blank-cell\' style=\'text-align:center;\'>---</td>';
            if (qbTableType !== null && !isQOPage) {
                switch (qbTableType) {
                    case 0:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_qty_range_text + '</th><th>' +
                            tableDiscountText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 1:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th>' + '<th>' + tableDiscountText + '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 2:
                        table += '<thead><tr><th>' + tableMinimumQuantity + '</th><th>' + tableMaximumQuantity +
                            '</th>' + '<th>' + tableAppliedPriceText + '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    case 3:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 4:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 5:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableDiscountText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 6:
                        table += '<tbody>';
                        break;
                    case 7:
                        if ((appliedSpecificPriceRule.length && decreasePriceRule.length)) {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                '</th>' + '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th>' + '</tr></thead>';
                            table += '<tbody>';
                        }
                        else if (decreasePriceRule.length) {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                '</th></tr></thead>';
                            table += '<tbody>';
                        }
                        else {
                            table += '<thead><tr><th class="bss-b2b-translation-qb-table_qty_range_text">' +
                                BSS_B2B.qbTranslations.table_qty_range_text + '</th>' +
                                '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                '</th></tr></thead>';
                            table += '<tbody>';
                        }
                        break;
                    case 8:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_qty_range_text + '</th><th>' +
                            tableAppliedPriceText + '</th></tr></thead>';
                        table += '<tbody>';
                        break;
                    case 9:
                        table += '<thead><tr><th>' + BSS_B2B.qbTranslations.quantity_text + '</th><th>' +
                            tableAppliedPriceText + '</th>' + '<th>' + textTotal + '</th>' + '</tr></thead>';
                        table += '<tbody>';
                        break;
                    default:
                        break;
                }
            }
            let tblBodyCustom = ''
            for (let i = 0; i < qtyTable.length; i++) {
                let discountValue = qtyTable[i].discount_value;
                let quantityFrom = qtyTable[i].qty_from;
                let priceValue = null;
                let finalPriceAfterPercentageDiscount = 0;
                let newProductPrice = productPrice;
                let realDiscount = 0;
                let isShowTextPerItem = qtyTable[i].discount_type === 0 || !isQOPage;
                let discountRuleType = qtyTable[i].discount_type;
                let total = null;
                switch (qtyTable[i].discount_type) {
                    case 0:
                        realDiscount = (productPrice / (100 * rateMarket) - discountValue).toFixed(2);
                        realDiscount = (realDiscount * rateMarket).toFixed(2);
                        realDiscount = realDiscount > 0 ? realDiscount : 0;
                        discountValue = productPrice / 100 - realDiscount;
                        if (BSS_B2B.storeId === 2524 && appliedRule.override_tax &&
                            !(appliedRule.apply_to === 4 && appliedRule.customer_tags.includes('Händler'))) {
                            discountValue = parseFloat(
                                (discountValue * (100 + appliedRule.override_tax) / 100).toFixed(2));
                        }

                        if (taxDisplayConditions) {
                            priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue * 100,
                                appliedTaxDisplayRule, taxable, shopData);
                            total = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                discountValue * quantityFrom * 100, appliedTaxDisplayRule, taxable, shopData);
                            discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                appliedRule.price - discountValue * 100, appliedTaxDisplayRule, taxable, shopData);

                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                total = BSS_B2B.MC.convertPriceByMc(discountValue * quantityFrom * 100, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(discountValue * 100);
                                total = BSS_B2B.formatMoney(discountValue * 100 * quantityFrom);
                                discountValue = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? appliedRule.price - discountValue *
                                        100 : discountValue * 100 - appliedRule.price);
                            }
                        }
                        break;
                    case 1:
                        if (!isQOPage) {
                            discountValue = BSS_B2B.helper.convertPriceWithRate(discountValue);
                            discountValue = appliedRule.price - discountValue * 100;
                            if (BSS_B2B.storeId === 2524 && appliedRule.override_tax &&
                                !(appliedRule.apply_to === 4 && appliedRule.customer_tags.includes('Händler'))) {
                                discountValue = discountValue * (1 + appliedRule.override_tax / 100);
                            }
                            if (discountValue > 0) {
                                if (taxDisplayConditions) {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    total = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        discountValue * quantityFrom, appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        qtyTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(discountValue, false);
                                        total = BSS_B2B.MC.convertPriceByMc(discountValue * quantityFrom, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(qtyTable[i].discount_value * 100,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(discountValue);
                                        total = BSS_B2B.formatMoney(discountValue * quantityFrom);
                                        discountValue = BSS_B2B.formatMoney(
                                            qtyTable[i].discount_value * 100 * rateMarket);
                                    }
                                }
                            }
                            else {
                                if (taxDisplayConditions) {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    total = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(0, false);
                                        total = BSS_B2B.MC.convertPriceByMc(0, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price, false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(0);
                                        total = BSS_B2B.formatMoney(0);
                                        discountValue = BSS_B2B.formatMoney(appliedRule.price);
                                    }
                                }
                            }
                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                                total = BSS_B2B.MC.convertPriceByMc(
                                    (appliedRule.price - discountValue * 100) * quantityFrom, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? appliedRule.price - discountValue *
                                        100 : discountValue * 100 - appliedRule.price);
                                total = BSS_B2B.formatMoney(
                                    appliedRule.price - discountValue * 100 > 0 ? (appliedRule.price - discountValue *
                                        100) * quantityFrom : (discountValue * 100 - appliedRule.price) * quantityFrom);
                                discountValue = BSS_B2B.formatMoney(discountValue * 100);
                            }
                        }
                        break;
                    case 2:
                        realDiscount = ((productPrice / rateMarket) * ((discountValue) / 100)).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newProductPrice = productPrice - realDiscount;
                        if (taxDisplayConditions) {
                            finalPriceAfterPercentageDiscount = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice, appliedTaxDisplayRule, taxable, shopData);
                            total = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice * quantityFrom, appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                finalPriceAfterPercentageDiscount = BSS_B2B.MC.convertPriceByMc((newProductPrice),
                                    false);
                                total = BSS_B2B.MC.convertPriceByMc((newProductPrice) * quantityFrom, false);
                            }
                            else {
                                finalPriceAfterPercentageDiscount = BSS_B2B.formatMoney(newProductPrice);
                                total = BSS_B2B.formatMoney((newProductPrice) * quantityFrom);
                            }
                        }
                        if (!isQOPage) {
                            priceValue = finalPriceAfterPercentageDiscount;
                            discountValue = discountValue + '%';
                        }
                        break;
                    default:
                        break;
                }

                let rowIsApplyRule = false;
                if (quantityValue) {
                    if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                        if (quantityValue >= qtyTable[i].qty_from) {
                            rowIsApplyRule = true;
                        }
                    }
                    else {
                        if (quantityValue >= qtyTable[i].qty_from && qtyTable[i].qty_to >= quantityValue) {
                            rowIsApplyRule = true;
                        }
                    }
                }

                let qtyRange = '<td>' + qtyTable[i].qty_from + ' - ' + qtyTable[i].qty_to + '</td>';
                let qtyTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (rowIsApplyRule ? ('qty-row-active') : '') +
                    '\' data-min=\'' + qtyTable[i].qty_from + '\' data-max=\'' + qtyTable[i].qty_to + '\'>';
                let qtyTo = `${qtyTable[i].qty_to}`;
                if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                    if (BSS_B2B.storeId === 2502) {
                        qtyRange = '<td>' + qtyTable[i].qty_from + '+</td>';
                    }
                    else {
                        qtyRange = '<td> ≥ ' + qtyTable[i].qty_from + '</td>';
                    }
                    qtyTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (rowIsApplyRule ? ('qty-row-active') : '') +
                        '\' data-min=\'' + qtyTable[i].qty_from + '\' data-max=\'' + qtyTable[i].qty_from + '\'>';
                    if ([0, 2, 7, 8].indexOf(qbTableType) !== -1) {
                        if (qbTableType === 2) {
                            qtyTo = qtyTable[i].qty_from + '+';
                        }
                        else {
                            qtyTo = '≥' + qtyTable[i].qty_from;
                        }
                    }
                }
                if ([1, 4, 5, 9].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + buyText + ' ' + qtyTable[i].qty_from +
                            '</td>';
                    }
                    else {
                        qtyRange = '<td>' + buyText + ' ' + qtyTable[i].qty_from + '</td>';
                    }

                }
                else if ([2, 3].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTable[i].qty_from + '</td>';
                    }
                    else {
                        qtyRange = '<td>' + qtyTable[i].qty_from + '</td>';
                    }
                }
                else if ([6].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' +
                            qtyTable[i].qty_from + ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' +
                            textOff + ')' + '</td>';
                    }
                    else {
                        qtyRange = '<td>' + buyText + ' ' + qtyTable[i].qty_from + ' ' + textFor + ' ' + priceValue +
                            ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                    }
                }
                else {
                    qtyRange = '<td>' + qtyTable[i].qty_from + ' - ' + qtyTo + '</td>';
                    if (checkLength(i, qtyTable.length)) {
                        qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTable[i].qty_from + ' - ' + qtyTo +
                            '</td>';
                        if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                            qtyRange = '<td class=\'border-radius-left-table-qb\'>' + qtyTo + '</td>';
                        }
                    }
                }
                // customize for panam-decor-and-gift by mitri
                if (BSS_B2B.storeId === 2499) {
                    qtyRange = '<td>' + buyText + ' ' + qtyTable[i].qty_from + ' or more ' + '</td>';
                }
                table += qtyTableRow;
                table += qtyRange;
                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 1:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 2:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + qtyTo + '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + qtyTable[i].qty_to + '</td>';
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 3:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + '</td>';
                            }
                            break;
                        case 4:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 5:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        // case 6:
                        //     if (checkLength(i, qtyTable.length)) {
                        //         table += "<td class='border-radius-left-right-table-qb'>" + buyText + " " +
                        // qtyTable[i].qty_from + " " + priceValue + "(" + discountValue + " off!" + ")" + "</td>"; }
                        // else { table += "<td>" + buyText + " " + qtyTable[i].qty_from + " " + priceValue + "(" +
                        // discountValue + " off!" + ")" + "</td>" } break;
                        case 7:
                            if ((appliedSpecificPriceRule.length && decreasePriceRule.length) || BSS_B2B.storeId ===
                                4088) {
                                if (discountRuleType === 0) {
                                    table += blankCell;
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                }
                                else {
                                    table += '<td>' + discountValue + '</td>';
                                    if (BSS_B2B.storeId === 4088) {
                                        table += '<td>' + finalPriceAfterPercentageDiscount +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        if (checkLength(i, qtyTable.length)) {
                                            table += '<td class=\'bss-qty-blank-cell border-radius-right-table-qb\' style=\'text-align:center;\'>---</td>';
                                        }
                                        else {
                                            table += blankCell;
                                        }
                                    }
                                }
                            }
                            else {
                                if (discountRuleType === 0) {
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                }
                                else {
                                    if (checkLength(i, qtyTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + discountValue +
                                            '</td>';
                                    }
                                    else {
                                        table += '<td>' + discountValue + '</td>';
                                    }
                                }
                            }
                            break;
                        case 8:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                            }
                            break;
                        case 9:
                            if (checkLength(i, qtyTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + total + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td>' + total + '</td>';
                            }
                            break;
                        default:
                            break;
                    }
                }
                else if (BSS_B2B.storeId === 8927) {
                    let quantityRange = `${qtyTable[i].qty_from + ' to ' + qtyTable[i].qty_to}`;
                    if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length === 0) {
                        quantityRange = `${qtyTable[i].qty_from}`;
                    }
                    table += `<td>Flat ${discountValue +
                        (isShowTextPerItem ? (' ' + perItemTxtSpan) : '')} Off on ${quantityRange} quantities</td>`;
                }
                else {
                    table += '<td>' + discountValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                }
                table += '</tr>';

                if (BSS_B2B.storeId === 8014 && BSS_B2B.page.isProductPage() && i === 2) {
                    table += window.BSS_B2B.executeAction({
                        tag: 'qb_generate_table',
                        storeId: 8014,
                        isQBOrAB: true, tableAppliedPriceText, tableDiscountText,
                        appliedSpecificPriceRule, decreasePriceRule, isQOPage
                    });
                }
                // fix for udcrops by Devlin
                if (BSS_B2B.storeId === 13932 && qbTableType !== null) {
                    if (qtyTable[i].qty_to) {
                        tblBodyCustom += `<div>Buy ${qtyTable[i].qty_from}  - ${qtyTable[i].qty_to} <b>Save ${discountValue}</b></div>`
                    } else {
                        tblBodyCustom += `<div>Buy ${qtyTable[i].qty_from} & more - <b>Save ${discountValue}</b></div>`
                    }
                }
            }
            table += '</tbody>';
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table">';
            if (BSS_B2B.storeId !== 2650 || (BSS_B2B.storeId === 2650 && BSS_B2B.page.isProductPage())) {
                details += '<p class="bss-b2b-cart-item-qty-table-header-title" style="margin-top: 1rem; margin-bottom: 0.2rem;"><span style="width: 95%; font-weight: 700; font-size: 1.2rem;">' +
                    appliedRule.name + '</span></p>';
                if (buttonUpDownQuantity) {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 95%;">' +
                        BSS_B2B.qbTranslations.table_header_text + '</span>';
                    details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
                }
                else {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 100%;">' +
                        BSS_B2B.qbTranslations.table_header_text + '</span>';
                }
                // fix for detecton by Leorio
                if (BSS_B2B.storeId === 1778 && BSS_B2B.page.isCartPage()) {
                    details += '<img class="bss-b2b-custom-icon-up-down" src="https://cdn.shopify.com/s/files/1/0577/0402/2176/files/view.png?v=1631600584"/></p>';
                }
                else {
                    details += '</p>';
                }
                details += '<div class="bss-b2b-qty-table-wrapper"' +
                    (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            }
            details += '</div>';
            // fix for tech-wholesalers by XuTho
            if (BSS_B2B.storeId === 1746 && BSS_B2B.page.isProductPage() && $('.bss-b2b-cart-item-qty-table').length) {
                details = '';
            }
            // fix for udcrops by Devlin
            if (BSS_B2B.storeId === 13932) {
                const check = $('.tbl-body').length
                if (check < 1) {
                    details = `<div style="
                        margin-top: 1rem;
                        border: 1px solid #3F3014;
                        background-color: rgba(23, 158, 73, 0.30);
                        max-width: 360px;
                        padding: 0.5rem 1rem;
                        border-radius: 10px;"
                    >
                        <div style="display: flex; justify-content: space-between; margin-bottom: 4px; color: #3F3014;">
                            <h4 style="font-weight: bold; font-size: 16px; margin-bottom: 0;">View Bulk Pricing</h4>
                            <span class="icon-show-hide" style="font-size: 28px; line-height: 28px; cursor: pointer;">+</span>
                        </div>
                        <div class="tbl-body" style="font-size: 16px; color: #3F3014; line-height: 24px;">
                            ${tblBodyCustom}
                        </div>
                    </div>`
                }
            }
            setTimeout(() => {
                BSS_B2B.integrate.langShop.handleAllTranslation('qb', ['rule_name'], appliedRule.name);
            }, 100);
            return details;
        }
        // Amount Break
        else {
            let amountTable = appliedRule.amount_table;
            amountTable.sort((a, b) => {
                return a.id - b.id;
            });
            const appliedSpecificPriceRule = amountTable.filter((item) => {
                return item.discount_type === 0;
            });
            const decreasePriceRule = amountTable.filter((item) => {
                return item.discount_type !== 0;
            });
            let table = '<table class="quantity_break_table">';

            let tableDiscountText = BSS_B2B.qbTranslations.table_discount_text;
            let tableAppliedPriceText = BSS_B2B.qbTranslations.price_applied;
            let tableMinimumAmount = BSS_B2B.qbTranslations.minimum_amount;
            let tableMaximumAmount = BSS_B2B.qbTranslations.maximum_amount;
            let textOff = BSS_B2B.qbTranslations.off;
            let textFor = BSS_B2B.qbTranslations.for;
            let perItemTxtSpan = '<span class="bss-b2b-translation-qb-flat_price_suffix">' +
                BSS_B2B.qbTranslations.flat_price_suffix + '</span>';
            if (!isQOPage) {
                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_amount_range_text + '</th><th>' +
                                tableDiscountText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 1:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '<th>' + tableDiscountText + '</th>' +
                                '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 2:
                            table += '<thead><tr><th>' + tableMinimumAmount + '</th><th>' + tableMaximumAmount +
                                '</th>' + '<th>' + tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 3:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 4:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 5:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.amount_text + '</th><th>' +
                                tableDiscountText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        case 7:
                            if ((appliedSpecificPriceRule.length && decreasePriceRule.length) || BSS_B2B.storeId ===
                                4088) {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text +
                                    '</th><th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                    '</th>' + '<th class="bss-b2b-translation-qb-price_applied">' +
                                    tableAppliedPriceText + '</th>' + '</tr></thead>';
                                table += '<tbody>';
                            }
                            else if (decreasePriceRule.length) {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text +
                                    '</th><th class="bss-b2b-translation-qb-table_discount_text">' + tableDiscountText +
                                    '</th></tr></thead>';
                                table += '<tbody>';
                            }
                            else {
                                table += '<thead><tr><th class="bss-b2b-translation-qb-table_amount_range_text">' +
                                    BSS_B2B.qbTranslations.table_amount_range_text + '</th>' +
                                    '<th class="bss-b2b-translation-qb-price_applied">' + tableAppliedPriceText +
                                    '</th></tr></thead>';
                                table += '<tbody>';
                            }
                            break;
                        case 8:
                            table += '<thead><tr><th>' + BSS_B2B.qbTranslations.table_amount_range_text + '</th><th>' +
                                tableAppliedPriceText + '</th>' + '</tr></thead>';
                            table += '<tbody>';
                            break;
                        default:
                            break;
                    }
                }
                else {
                    //do thing
                }
            }
            for (let i = 0; i < amountTable.length; i++) {
                let discountValue = amountTable[i].discount_value;
                let priceValue = null;
                let finalPriceAfterPercentageDiscount = 0;
                let newProductPrice = productPrice;
                let realDiscount = 0;
                let isShowTextPerItem = amountTable[i].discount_type === 0 ||
                    ([7, 8].indexOf(qbTableType) !== -1 && !isQOPage);
                let discountRuleType = amountTable[i].discount_type;
                let blankCell = '<td class=\'bss-qty-blank-cell\' style=\'text-align:center;\'>---</td>';
                switch (amountTable[i].discount_type) {
                    case 0:
                        realDiscount = (productPrice / (100 * rateMarket) - discountValue).toFixed(2);
                        realDiscount = (realDiscount * rateMarket).toFixed(2);
                        discountValue = productPrice / 100 - realDiscount;
                        if (taxDisplayConditions) {
                            priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue * 100,
                                appliedTaxDisplayRule, taxable, shopData);
                            discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                (appliedRule.price - discountValue * 100), appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                priceValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price - discountValue * 100,
                                    false);
                            }
                            else {
                                priceValue = BSS_B2B.formatMoney(discountValue * 100);
                                discountValue = BSS_B2B.formatMoney(appliedRule.price - discountValue * 100);
                            }
                        }
                        break;
                    case 1:
                        if (!isQOPage) {
                            discountValue = BSS_B2B.helper.convertPriceWithRate(discountValue);
                            discountValue = appliedRule.price - discountValue * 100;
                            if (discountValue > 0) {
                                if (taxDisplayConditions) {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        amountTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = BSS_B2B.MC.convertPriceByMc(discountValue, false);
                                        discountValue = BSS_B2B.MC.convertPriceByMc(amountTable[i].discount_value * 100,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(discountValue);
                                        discountValue = BSS_B2B.formatMoney(amountTable[i].discount_value * 100);
                                    }
                                }
                            }
                            else {
                                if (taxDisplayConditions) {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    if (isEnableMC) {
                                        priceValue = discountValue = BSS_B2B.MC.convertPriceByMc(0, false);
                                        discountValue = discountValue = BSS_B2B.MC.convertPriceByMc(appliedRule.price,
                                            false);
                                    }
                                    else {
                                        priceValue = BSS_B2B.formatMoney(0);
                                        discountValue = BSS_B2B.formatMoney(appliedRule.price);
                                    }
                                }
                            }
                        }
                        else {
                            if (taxDisplayConditions) {
                                discountValue = appliedRule.price - discountValue * 100;
                                if (discountValue) {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, discountValue,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        amountTable[i].discount_value * 100, appliedTaxDisplayRule, taxable, shopData);
                                }
                                else {
                                    priceValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId, 0,
                                        appliedTaxDisplayRule, taxable, shopData);
                                    discountValue = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                        appliedRule.price, appliedTaxDisplayRule, taxable, shopData);
                                }
                            }
                            else {
                                if (isEnableMC) {
                                    priceValue = BSS_B2B.MC.convertPriceByMc(
                                        appliedRule.price - amountTable[i].discount_value * 100, false);
                                    discountValue = BSS_B2B.MC.convertPriceByMc(discountValue * 100, false);
                                }
                                else {
                                    priceValue = BSS_B2B.formatMoney(appliedRule.price - discountValue * 100);
                                    discountValue = BSS_B2B.formatMoney(discountValue * 100);
                                }
                            }
                        }
                        break;
                    case 2:
                        realDiscount = ((productPrice / rateMarket) * ((discountValue) / 100)).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newProductPrice = productPrice - realDiscount;
                        if (taxDisplayConditions) {
                            finalPriceAfterPercentageDiscount = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                newProductPrice, appliedTaxDisplayRule, taxable, shopData);
                        }
                        else {
                            if (isEnableMC) {
                                finalPriceAfterPercentageDiscount = BSS_B2B.MC.convertPriceByMc(newProductPrice, false);
                            }
                            else {
                                finalPriceAfterPercentageDiscount = BSS_B2B.formatMoney(newProductPrice);
                            }
                        }
                        if (!isQOPage) {
                            discountValue = discountValue + '%';
                            priceValue = finalPriceAfterPercentageDiscount;
                        }
                        break;
                    default:
                        break;
                }
                // fix for b2b-vapeholster.myshopify.com by LuanHV
                let activeRow = false;
                if (quantityValue) {
                    if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                        if (quantityValue * appliedRule.price >= amountTable[i].amount_from * 100) {
                            activeRow = true;
                        }
                    }
                    else {
                        if (quantityValue * appliedRule.price >= amountTable[i].amount_from * 100 &&
                            amountTable[i].amount_to * 100 >= quantityValue * appliedRule.price) {
                            activeRow = true;
                        }
                    }
                }
                if (BSS_B2B.storeId === 7363) {
                    activeRow = false;
                }

                let amountFrom = isEnableMC ? BSS_B2B.MC.convertPriceByMc((Number(amountTable[i].amount_from) * 100),
                    false) : BSS_B2B.formatMoney(Number(amountTable[i].amount_from * rateMarket) * 100);
                let amountTo = isEnableMC
                    ? BSS_B2B.MC.convertPriceByMc((Number(amountTable[i].amount_to) * 100), false)
                    : BSS_B2B.formatMoney(Number(amountTable[i].amount_to * rateMarket) * 100);

                let amountRange = '<td>' + amountFrom + ' - ' + amountTo + '</td>';
                let amountTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (activeRow ? ('qty-row-active') : '') +
                    '\' data-min=\'' + amountTable[i].amount_from + '\' data-max=\'' + amountTable[i].amount_to + '\'>';
                if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                    if (qbTableType === 2) {
                        amountTo = amountFrom + '+';
                    }
                    amountRange = '<td> ≥ ' + amountFrom + '</td>';
                    amountTableRow = '<tr class=\'bss-b2b-qty-table-row ' + (activeRow ? ('qty-row-active') : '') +
                        '\' data-min=\'' + amountTable[i].amount_from + '\' data-max=\'' + amountTable[i].amount_from +
                        '\'>';
                }
                if ([1, 4, 5].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-table-qb\'>' + buyText + ' ' + amountFrom +
                            '</td>';
                    }
                    else {
                        amountRange = '<td>' + buyText + ' ' + amountFrom + '</td>';
                    }
                }
                else if ([2, 3].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-table-qb\'>' + amountFrom + '</td>';
                    }
                    else {
                        amountRange = '<td>' + amountFrom + '</td>';
                    }
                }
                else if ([6].indexOf(qbTableType) !== -1) {
                    if (checkLength(i, amountTable.length)) {
                        amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' + amountFrom +
                            ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                    }
                    else {
                        amountRange = '<td>' + buyText + ' ' + amountFrom + ' ' + textFor + ' ' + priceValue + ' (' +
                            discountValue + ' ' + textOff + ')' + '</td>';
                    }
                }
                else {
                    if (checkLength(i, amountTable.length)) {
                        if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + '≥' + amountFrom +
                                '</td>';
                        }
                        else {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + amountFrom + ' - ' +
                                amountTo + '</td>';
                        }

                    }
                }

                if (taxDisplayConditions) {
                    amountRange = '<td>' +
                        _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnABRange(appliedRule.keyOrId, Number(amountTable[i].amount_from * 100),
                            Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    if ([1, 4, 5].indexOf(qbTableType) !== -1) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText +
                                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable,
                                    shopData) + '</td>';
                        }
                        else {
                            amountRange = '<td>' + buyText + _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable, shopData) +
                                '</td>';
                        }
                    }
                    else if ([2, 3].indexOf(qbTableType) !== -1) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' +
                                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable,
                                    shopData) + '</td>';
                        }
                        else {
                            amountRange = '<td>' + _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                Number(amountTable[i].amount_from * 100), appliedTaxDisplayRule, taxable, shopData) +
                                '</td>';
                        }
                    }
                    else if (qbTableType === 6) {
                        if (checkLength(i, amountTable.length)) {
                            amountRange = '<td class=\'border-radius-left-right-table-qb\'>' + buyText + ' ' +
                                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) +
                                ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                        }
                        else {
                            amountRange = '<td>' + buyText + ' ' +
                                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                                    Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) +
                                ' ' + textFor + ' ' + priceValue + ' (' + discountValue + ' ' + textOff + ')' + '</td>';
                        }
                    }
                }
                table += amountTableRow;
                table += amountRange;
                if (qbTableType === 2 && taxDisplayConditions) {
                    if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length === 0) {
                        table += '<td>' + _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnABRange(appliedRule.keyOrId,
                            Number(amountTable[i].amount_from * 100), Number(amountTable[i].amount_to * 100),
                            appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    }
                    else {
                        table += '<td>' + _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BChangeVatPriceOnQBABTable(appliedRule.keyOrId,
                            Number(amountTable[i].amount_to * 100), appliedTaxDisplayRule, taxable, shopData) + '</td>';
                    }
                }

                if (qbTableType !== null) {
                    switch (qbTableType) {
                        case 0:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 1:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 2:
                            if (checkLength(i, amountTable.length)) {
                                if (!taxDisplayConditions) {
                                    table += '<td>' + amountTo + '</td>';
                                }
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue + '</td>';
                            }
                            else {
                                if (!taxDisplayConditions) {
                                    table += '<td>' + amountTo + '</td>';
                                }
                                table += '<td>' + priceValue + '</td>';
                            }

                            break;
                        case 3:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }

                            break;
                        case 4:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (' ' + BSS_B2B.qbTranslations.flat_price_suffix) + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (' ' + BSS_B2B.qbTranslations.flat_price_suffix) +
                                    '</td>';
                            }
                            break;
                        case 5:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + discountValue + '</td>';
                            }
                            else {
                                table += '<td>' + discountValue + '</td>';
                            }
                            break;
                        case 7:
                            if ((appliedSpecificPriceRule.length && decreasePriceRule.length) || BSS_B2B.storeId ===
                                4088) {
                                if (discountRuleType === 0) {
                                    table += blankCell;
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                }
                                else {
                                    table += '<td>' + discountValue + '</td>';
                                    if (BSS_B2B.storeId === 4088) {
                                        table += '<td>' + finalPriceAfterPercentageDiscount +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        if (checkLength(i, amountTable.length)) {
                                            table += '<td class=\'bss-qty-blank-cell border-radius-right-table-qb\' style=\'text-align:center;\'>---</td>';
                                        }
                                        else {
                                            table += blankCell;
                                        }
                                    }
                                }

                            }
                            else {
                                if (discountRuleType === 0) {
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                    else {
                                        table += '<td>' + priceValue +
                                            (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                                    }
                                }
                                else {
                                    if (checkLength(i, amountTable.length)) {
                                        table += '<td class=\'border-radius-right-table-qb\'>' + discountValue +
                                            '</td>';
                                    }
                                    else {
                                        table += '<td>' + discountValue + '</td>';
                                    }
                                }
                            }
                            break;
                        case 8:
                            if (checkLength(i, amountTable.length)) {
                                table += '<td class=\'border-radius-right-table-qb\'>' + priceValue +
                                    (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') + '</td>';
                            }
                            else {
                                table += '<td>' + priceValue + (isShowTextPerItem ? (' ' + perItemTxtSpan) : '') +
                                    '</td>';
                            }
                            break;
                        default:
                            break;
                    }
                }

                table += '</tr>';

                if (BSS_B2B.storeId === 8014 && BSS_B2B.page.isProductPage() && i === 2) {
                    table += window.BSS_B2B.executeAction({
                        tag: 'qb_generate_table',
                        storeId: 8014,
                        isQBOrAB: false, tableAppliedPriceText, tableDiscountText,
                        appliedSpecificPriceRule, decreasePriceRule, isQOPage
                    });
                }
            }
            table += '</tbody>';
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table">';
            if (BSS_B2B.storeId !== 2650 || (BSS_B2B.storeId === 2650 && BSS_B2B.page.isProductPage())) {
                details += '<p class="bss-b2b-cart-item-qty-table-header-title" style="margin-top: 1rem; margin-bottom: 0.2rem;"><span style="width: 95%; font-weight: 700; font-size: 1.2rem;">' +
                    appliedRule.name + '</span></p>';
                if (buttonUpDownQuantity) {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 95%;" class="bss-b2b-translation-qb-table_header_text_ab">' +
                        BSS_B2B.qbTranslations.table_header_text_ab + '</span>';
                    details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
                }
                else {
                    details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 100%;" class="bss-b2b-translation-qb-table_header_text_ab">' +
                        BSS_B2B.qbTranslations.table_header_text_ab + '</span>';
                }
                details += '<div class="bss-b2b-qty-table-wrapper"' +
                    (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            }
            details += '</div>';
            setTimeout(() => {
                BSS_B2B.integrate.langShop.handleAllTranslation('qb', ['rule_name'], appliedRule.name);
            }, 100);
            return details;
        }
    };

    /**
     * Create qty-table on product listing page
     */
    BSS_B2B.qb.generateTableOnProductListingPage = function (productId, productTags) {
        let appliedRule = BSS_B2B.qb.getAppliedRuleOnProductListingPage(productId, productTags);
        if (appliedRule) {
            appliedRule.keyOrId = productId;
            let qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(appliedRule);
            let productModal = $(`.screen-layer.screen-layer--product[data-product-id=${productId}]`);
            if (productModal.length) {
                // Insert to first form element. DAWN theme has two form element on product page.
                let productHeader = $(productModal).find('.product-single__meta .product-single__header');
                if (productHeader.length && !$(productHeader).find('.bss-b2b-cart-item-qty-table').length) {
                    $(productHeader).append(qtyTableHtml);
                }
            }
            $('.bss-b2b-up-down-qb-btn').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if ($(this).text() === 'â†“') {
                    $(this).html(`â†‘`);
                }
                else if ($(this).text() === 'â†‘') {
                    $(this).html(`â†“`);
                }
                $(this).closest('.bss-b2b-cart-item-qty-table').find('.bss-b2b-qty-table-wrapper').toggle();
            });

            $('.bss-b2b-qty-table-row').on('click', function (e) {
                e.preventDefault();
                let quantitySelector = BSS_B2B.qb.quantityInputSelectorOnProductPage.join(',');
                // Custom quantity when click qb table for storeId = 2985 ( by tuli )
                if ([2985, 9139].includes(BSS_B2B.storeId)) {
                    $(quantitySelector).val($(this).attr('data-min'));
                }
                else {
                    if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).val($(this).attr('data-max')); else $(
                        quantitySelector).val($(this).attr('data-min'));
                }

                $('.bss-b2b-qty-table-row').removeClass('qty-row-active');
                $(this).addClass('qty-row-active');
            });
        }
    };

    /**
     * Create qty-table on front-end
     */

    Object(_qb_on_collection_page__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(BSS_B2B, shopData, isEnabledTD);

    /***/

    /**
     * Create qty-table on feature product
     */

    Object(_qb_feature_product__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BSS_B2B, shopData, isEnabledTD);

    /***/

    /**
     * Create qty-table on front end
     */
    BSS_B2B.qb.generateTableOnProductPage = function () {
        let appliedRule = BSS_B2B.qb.getAppliedRuleOnProductPage(false);
        let allRuleForThisProduct = BSS_B2B.qb.getAllRuleApplyForProduct(false);
        let quantityValue = false;
        let quantitySelector = BSS_B2B.qb.quantityInputSelectorOnProductPage.join(',');

        if ($(quantitySelector).length > 0) {
            quantityValue = $(quantitySelector).val();
        }

        //fix for smartmovemedical by HaiNN
        if (BSS_B2B.storeId === 5980 && BSS_B2B.page.isProductPage()) {
            let inputQty = document.querySelector('#add-to-cart-form .quantity .qty-group input[name="quantity"]');
            if (inputQty) {
                quantityValue = inputQty.value;
            }
        }

        if (BSS_B2B.storeId === 8860 && BSS_B2B.page.isProductPage()) {
            let inputQty = document.querySelector('#product-quantity-input');
            if (inputQty) {
                quantityValue = inputQty.value;
            }
        }

        let applyMultipleRule = BSS_B2B.qbSettings.show_multiple_table ? BSS_B2B.qbSettings.show_multiple_table : 0;
        let elementAppendTableAfterVat = document.querySelector('form[action*="/cart/add"] .bss-b2b-product-vat');
        let elementQty = document.querySelector('.product-form__quantity');

        if (BSS_B2B.storeId === 8446) {
            elementAppendTableAfterVat = document.querySelector(
                'form[action*="/cart/add"] .bss-b2b-collection-item-vat');
        }

        if (appliedRule) {
            if (!applyMultipleRule) {
                appliedRule.keyOrId = shopData.product ? shopData.product.id : null;
                let qtyTableHtml = '';

                if ([2851].indexOf(BSS_B2B.storeId) !== -1) {
                    // fix for bingltd by Leorio
                    qtyTableHtml = window.BSS_B2B.executeFilter({ tag: 'qb_generate_table', storeId: 2851, appliedRule, quantityValue });
                } else if (BSS_B2B.storeId === 1651) {
                    qtyTableHtml = window.BSS_B2B.executeFilter({ tag: 'qb_generate_table', storeId: 1651, val: 1, shopData, appliedRule, quantityValue, isEnableMC, isEnabledTD });
                }
                else if ([10808].includes(BSS_B2B.storeId)) {
                    qtyTableHtml = window.BSS_B2B.executeAction({
                        tag: 'qb_generate_table', storeId: false, shopData, appliedRule,
                        quantityValue, isEnableMC, isEnabledTD
                    });
                }
                else if (BSS_B2B.storeId === 9139 && BSS_B2B.page.isProductPage() && appliedRule.qb_table_type === 3) {
                    qtyTableHtml = window.BSS_B2B.executeAction({
                        tag: 'qb_generate_table',
                        storeId: 9139,
                        shopData, appliedRule, quantityValue, isEnableMC, isEnabledTD, isEnableAMO
                    });
                }
                else if ([4999, 9455].includes(BSS_B2B.storeId)) {
                    // fix for aupisen.myshopify.com by AnhTV
                    appliedRule.price = shopData.product ? shopData.product.price : null;
                    qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue, false);
                }
                else if (BSS_B2B.storeId === 1489) {
                    //default hide table for datrib2b (madu)
                    qtyTableHtml = qtyTableHtml.replace('display: block', 'display: none');
                }
                else {
                    qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue, false);
                }

                let elementAppendTableSelector = document.querySelector('form[action*="/cart/add"] .bss-b2b-qb-table');
                if (BSS_B2B.storeId === 1825) {
                    elementAppendTableSelector = document.querySelector(
                        '.quantity form[action*="/cart/add"] .bss-b2b-qb-table');
                } else if (BSS_B2B.storeId === 15856) {
                    elementAppendTableSelector = document.querySelector('form#multi-product-form .bss-b2b-qb-table');
                }

                if (elementAppendTableAfterVat && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length &&
                    isEnabledTD && !elementAppendTableSelector) {
                    if (BSS_B2B.storeId === 9781) {
                        $('form[action="/cart/add"] .buyinoneclick').after(qtyTableHtml);
                    }
                    else {
                        BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableAfterVat, 'afterend',
                            qtyTableHtml);
                    }
                    if (elementQty && BSS_B2B.qbSettings.position_qb_table === '1') {
                        let elementQbTable = document.getElementsByClassName('bss-b2b-cart-item-qty-table');
                        elementQbTable[elementQbTable.length - 1].insertAdjacentElement('afterend', elementQty);
                    }
                }
                else if (elementAppendTableSelector) {
                    BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableSelector, 'beforebegin',
                        qtyTableHtml);
                    window.BSS_B2B.executeAction({ tag: `customize_Qb_table`, storeId: 14384, isCollectionPage: false })
                }
                else if (BSS_B2B.storeId === 546) {
                    $('button[data-checkout="same"][data-pf-type="ProductATC"]').parent().parent().before(qtyTableHtml);

                    let insertTable = setInterval(function () {
                        let price = $('div[data-intro="Product Price"]');
                        let qbQuantityTable = $('.bss-b2b-cart-item-qty-table');
                        if (qbQuantityTable.length) {
                            clearInterval(insertTable);
                        }
                        else {
                            price.closest('.cpb-product-actions').prepend(qtyTableHtml);
                        }
                    }, 500);
                }
                else {
                    //fix for screenshelf
                    if (BSS_B2B.storeId === 918) {
                        $('.price_top').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 1967) {
                        $('.gf_product-prices').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 2187) {
                        $('.product-form__info-item.product-form__info-item--quantity').before(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 2434) {
                        $('.product-info #cart-form--product-template').before(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 2502) {
                        $('.product-form__payment-container').after(qtyTableHtml);
                    }
                    else if ([4730, 6526, 7860, 13871, 15013].indexOf(BSS_B2B.storeId) !== -1) {
                        $('.bss-b2b-qb-table').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId == 5283) {
                        $('#price-field').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 7323) {
                        $('.product-form__info-list').before(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 10438) {
                        $('.quantity-atc').before(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 6761) {
                        let elementAppendTable = document.querySelector('.product-main .bss-b2b-qb-table');
                        if (elementAppendTable) {
                            elementAppendTable.insertAdjacentHTML('beforebegin', qtyTableHtml);
                        }
                    }
                    else if (BSS_B2B.storeId === 9781) {
                        $('form[action="/cart/add"] .buyinoneclick').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 9817) {
                        $('.product-form .custom_bss_table').before(qtyTableHtml);
                    } else if (BSS_B2B.storeId === 15693) {
                        if (shopData.customer.id) {
                            $('.toggle.opened').before(qtyTableHtml);
                        } else {
                            $('.buttons-holder-fix').after(qtyTableHtml);
                        }
                    }
                    else if (BSS_B2B.storeId === 11805) {
                        if (BSS_B2B.page.isProductPage()) {
                            const cartForm = document.querySelector(
                                '.Product__Info .Container form[action="/cart/add"]');
                            const buttonInTheme = document.querySelectorAll('.bss-b2b-button-show-qb-table');
                            if (cartForm) {
                                const qbButton = document.createElement('button');
                                qbButton.innerText = 'See wholesale price';
                                qbButton.classList = 'bss-b2b-button-show-qb-table';
                                if (!buttonInTheme.length) {
                                    cartForm.before(qbButton);
                                }
                                qbButton.addEventListener('click', function () {
                                    let qbTable = document.querySelector('div.bss-b2b-cart-item-qty-table');
                                    if (!qbTable) {
                                        qbButton.insertAdjacentHTML('afterend', qtyTableHtml);
                                    }
                                });
                            }
                        }
                    }
                    else if (BSS_B2B.storeId === 12299 && BSS_B2B.qbSettings.position_qb_table === '1') {
                        $('.product-block--price .product__price').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 12526) {
                        $('.product-single__form-price').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 12879) {
                        $('.f8pr-price.s1pr.price').after(qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 13614) {
                        $('.bss-b2b-qb-table-custom').after(qtyTableHtml);
                    }
                    else if ([14291, 13535].includes(BSS_B2B.storeId)) {
                        $(".bss-b2b-qb-table").after(qtyTableHtml)
                    }
                    else {
                        const bssB2bQbTable = document.createElement('div');
                        bssB2bQbTable.classList.add('bss-b2b-qb-table');
                        if ($('form[action*="/cart/add"]').length > 1) {
                            if (BSS_B2B.qbSettings.position_qb_table === '1') {
                                $('form[action*="/cart/add"]').first().prepend(qtyTableHtml);
                            }
                            else {
                                $('form[action*="/cart/add"]').prepend(bssB2bQbTable);
                                let elementAppendTableSelector = document.querySelector(
                                    'form[action*="/cart/add"] .bss-b2b-qb-table');
                                BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableSelector, 'beforebegin',
                                    qtyTableHtml);
                            }
                        }
                        else if (BSS_B2B.storeId === 7173) {
                            let bssTableQb = document.querySelectorAll('.bss-b2b-cart-item-qty-table');
                            if (!bssTableQb.length) {
                                $('form[action*="/cart/add"]:not(.product-item__action-list)').prepend(qtyTableHtml);
                            }
                            else {
                                $('form[action*="/cart/add"]:not(.product-item__action-list)').prepend(qtyTableHtml);
                            }
                        }
                        else {
                            if (BSS_B2B.qbSettings.position_qb_table === '1') {
                                $('form[action*="/cart/add"]:not(.product-item__action-list)').prepend(qtyTableHtml);
                            }
                            else {
                                $('form[action*="/cart/add"]:not(.product-item__action-list)').prepend(bssB2bQbTable);
                                let elementAppendTableSelector = document.querySelector(
                                    'form[action*="/cart/add"]:not(.product-item__action-list .bss-b2b-qb-table');
                                BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableSelector, 'beforebegin',
                                    qtyTableHtml);
                            }
                        }
                    }
                }

                if (appliedRule.rule_setting === 0) {
                    $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                        on('click', function (e) {
                            e.preventDefault();
                            // Custom quantity when click qb table for storeId = 2985 ( by tuli )
                            if ([2985, 9139].includes(BSS_B2B.storeId)) {
                                $(quantitySelector).val($(this).attr('data-min'));
                            }
                            else {
                                ///check qty when click on table row
                                if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).
                                    not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                    val($(this).attr('data-max')); else $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val($(this).attr('data-min'));
                                // fix for bingltd by Leorio
                                if (BSS_B2B.storeId === 2851) {
                                    if ($('.bss-b2b-cart-item-qty-table').length) {
                                        $('.bss-b2b-cart-item-qty-table').remove();
                                    }

                                    BSS_B2B.qb.generateTableOnProductPage();

                                    $('#select2-quantity-proxy-container').html($(this).attr('data-max').toString());
                                }
                                if (BSS_B2B.storeId === 8860 && $(this).attr('data-min') === $(this).attr('data-max')) {
                                    const select_elm = document.querySelector('.form-field.form-field--qty-select');
                                    select_elm.style = "z-index:0;opacity:0;visibility:hidden"
                                    const input_elm = document.querySelector('.form-field.form-field--qty-input');
                                    input_elm.style = "z-index:1;opacity:1;visibility:visible"
                                    $('#product-quantity-input').not('[bss-b2b-qb-featured-product-id] input[type="number"]').val($(this).attr("data-max"))
                                }
                                if (BSS_B2B.storeId === 13552) {
                                    if (parseInt($(this).attr("data-max")) > 10 && document.querySelector('.product-form__info-content .select-wrapper')) {
                                        $('.product-form__quantity').val(10)
                                        if (parseInt($('.product-form__quantity').val()) >= 10) {
                                            var selectWrapper = document.querySelector('.product-form__info-content .select-wrapper'),
                                                inputElement = document.createElement('input');
                                            if (selectWrapper) {
                                                inputElement.id = selectWrapper.querySelector('.product-form__quantity').id;
                                                inputElement.className = 'product-form__quantity form__field form__field--small form__field--text';
                                                inputElement.pattern = '[0-9]*';
                                                inputElement.name = 'quantity';
                                                selectWrapper.parentNode.replaceChild(inputElement, selectWrapper);
                                                inputElement.focus(); // We need to start listening to the event now
                                                inputElement.value = parseInt($(this).attr("data-max"));

                                                inputElement.addEventListener('keyup', () => {
                                                    if (inputElement.value !== '' && isNaN(inputElement.value)) {
                                                        inputElement.value.value = Math.max(1, parseInt(inputElement.value) || 1);
                                                    }
                                                });
                                                inputElement.addEventListener('focusout', () => {
                                                    inputElement.value.value = Math.max(1, parseInt(inputElement.value.value) || 1);
                                                });
                                                BSS_B2B.qb.generateTableOnProductPage();
                                                if ($('.bss-b2b-cart-item-qty-table').length > 1) {
                                                    $('.bss-b2b-cart-item-qty-table').eq(0).remove();
                                                }
                                            }
                                        }

                                    }
                                }

                                // eslint-disable-next-line no-undef
                                if (BSS_B2B.storeId === 10085 && quantityChanged && typeof quantityChanged ===
                                    'function') {
                                    const quantityInputElem = document.querySelector(quantitySelector);
                                    if (quantityInputElem) {
                                        // eslint-disable-next-line no-undef
                                        quantityChanged(quantityInputElem);
                                    }
                                }
                            }
                            if (BSS_B2B.storeId === 2851 && BSS_B2B.page.isProductPage()) {
                                // do nothing
                            }
                            else {
                                $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                    removeClass('qty-row-active');
                            }
                            // fix for tech-wholesalers by Leorio
                            if (BSS_B2B.storeId === 1746) {
                                $('.bss-b2b-qty-table-row').css('background-color', '#fff');
                                $('.bss-b2b-qty-table-row').css('color', '#000');
                                $(this).css('color', '#fff');
                                $(this).css({
                                    'border-color': '#000', 'border-width': '1px', 'border-style': 'solid',
                                });
                                $(this).css('background-color', '#03baad');
                            }
                            else {
                                $(this).addClass('qty-row-active');
                            }
                            window.BSS_B2B.executeAction({ tag: "customQBOnPDP", storeId: 13871 });
                            // fix for storeID 9225
                            window.BSS_B2B.executeAction({ tag: 'qb_customize_price', storeId: 9225 });
                        });
                }
                else {
                    $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                        on('click', function (e) {
                            e.preventDefault();
                            $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                removeClass('qty-row-active');
                            let quantityAmount = parseInt(
                                parseFloat($(this).attr('data-max')) * 100 * parseFloat(Shopify.currency.rate) / appliedRule.price);
                            if (quantityAmount >= 1) {
                                if (![10700, 13511].includes(BSS_B2B.storeId)) {
                                    $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val(quantityAmount);
                                } else if (BSS_B2B.storeId === 13511) {
                                    let inventoryQuantity = 9999;
                                    let inventoryText = $("[id^='Inventory']").text()
                                    var match = inventoryText.match(/\d+/);
                                    if (match) {
                                        inventoryQuantity = parseInt(match[0]);
                                    }
                                    $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val(Math.min(quantityAmount, inventoryQuantity));
                                }
                            }
                            $(this).addClass('qty-row-active');
                        });
                }
            }
            else {
                allRuleForThisProduct.forEach(function (rule) {
                    let quantityTableValue = 0;
                    if (rule.id === appliedRule.id) {
                        quantityTableValue = quantityValue;
                    }
                    rule.keyOrId = shopData.product ? shopData.product.id : null;
                    let qtyTableHtml;
                    if (BSS_B2B.storeId === 1651) {
                        // fix for must-technologie.myshopify.com by huydt
                        qtyTableHtml = window.BSS_B2B.executeAction({
                            tag: 'qb_generate_table',
                            storeId: 1651, shopData,
                            appliedRule: rule,
                            quantityValue: quantityTableValue,
                            isEnableMC, isEnabledTD
                        });
                    }
                    else if (BSS_B2B.storeId === 1489) {
                        //default hide table for datrib2b (madu)
                        qtyTableHtml = qtyTableHtml.replace('display: block', 'display: none');
                    }
                    else {
                        qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(rule, true, quantityTableValue, false);
                    }
                    if (BSS_B2B.storeId === 13186) {
                        let qbTableBefore = $(".bss-b2b-cart-item-qty-table")
                        if (qbTableBefore) {
                            qbTableBefore.remove()
                        }
                    }

                    if (elementAppendTableAfterVat && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length &&
                        isEnabledTD) {
                        BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableAfterVat, 'afterend',
                            qtyTableHtml);
                        if (elementQty && BSS_B2B.qbSettings.position_qb_table === '1') {
                            let elementQbTable = document.getElementsByClassName('bss-b2b-cart-item-qty-table');
                            elementQbTable[elementQbTable.length - 1].insertAdjacentElement('beforeend', elementQty);
                        }
                    }
                    else if ($('form[action*="/cart/add"] .bss-b2b-qb-table').length > 0) {
                        BSS_B2B.qb.handlePositionQbTableOnProductPage(
                            document.querySelector('form[action*="/cart/add"] .bss-b2b-qb-table'), 'beforebegin',
                            qtyTableHtml);
                    }
                    else if (BSS_B2B.storeId === 546) {
                        $('button[data-checkout="same"][data-pf-type="ProductATC"]').
                            parent().
                            parent().
                            before(qtyTableHtml);

                        let insertTable = setInterval(function () {
                            let price = $('div[data-intro="Product Price"]');
                            let qbQuantityTable = $('.bss-b2b-cart-item-qty-table');
                            if (qbQuantityTable.length) {
                                clearInterval(insertTable);
                            }
                            else {
                                price.closest('.cpb-product-actions').prepend(qtyTableHtml);
                            }
                        }, 500);
                    }
                    else {
                        //fix for screenshelf
                        if (BSS_B2B.storeId === 918) {
                            $('.price_top').after(qtyTableHtml);
                        }
                        else if (BSS_B2B.storeId === 1967) {
                            $('.gf_product-prices').after(qtyTableHtml);
                        }
                        else if (BSS_B2B.storeId === 2187) {
                            $('.product-form__info-item.product-form__info-item--quantity').before(qtyTableHtml);
                        }
                        else if (BSS_B2B.storeId === 2434) {
                            $('.product-info #cart-form--product-template').before(qtyTableHtml);
                        }
                        else {
                            const bssB2bQbTable = document.createElement('div');
                            bssB2bQbTable.classList.add('bss-b2b-qb-table');
                            if ($('form[action*="/cart/add"]').length > 1) {
                                if (BSS_B2B.qbSettings.position_qb_table === '1') {
                                    $('form[action*="/cart/add"]').first().prepend(qtyTableHtml);
                                }
                                else {
                                    $('form[action*="/cart/add"]').prepend(bssB2bQbTable);
                                    let elementAppendTableSelector = document.querySelector(
                                        'form[action*="/cart/add"] .bss-b2b-qb-table');
                                    BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableSelector,
                                        'beforebegin', qtyTableHtml);
                                }
                            }
                            else {
                                if (BSS_B2B.qbSettings.position_qb_table === '1') {
                                    $('form[action*="/cart/add"]:not(.product-item__action-list)').
                                        prepend(qtyTableHtml);
                                }
                                else {
                                    $('form[action*="/cart/add"]:not(.product-item__action-list)').
                                        prepend(bssB2bQbTable);
                                    let elementAppendTableSelector = document.querySelector(
                                        'form[action*="/cart/add"]:not(.product-item__action-list .bss-b2b-qb-table');
                                    BSS_B2B.qb.handlePositionQbTableOnProductPage(elementAppendTableSelector,
                                        'beforebegin', qtyTableHtml);
                                }
                            }
                        }
                    }
                    //set value of quantity_input
                    if (rule.rule_setting === 0) {
                        $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                            on('click', function (e) {
                                e.preventDefault();
                                // Custom quantity when click qb table for storeId = 2985 ( by tuli )
                                if ([2985, 9139].includes(BSS_B2B.storeId)) {
                                    $(quantitySelector).val($(this).attr('data-min'));
                                }
                                else {
                                    if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val($(this).attr('data-max')); else $(quantitySelector).
                                            not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                            val($(this).attr('data-min'));
                                    // fix for bingltd by Leorio
                                    if (BSS_B2B.storeId === 2851) {
                                        $('#select2-quantity-proxy-container').
                                            html($(this).attr('data-max').toString());
                                    }
                                }
                                $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                    removeClass('qty-row-active');

                                // fix for tech-wholesalers by Leorio
                                if (BSS_B2B.storeId === 1746) {
                                    $('.bss-b2b-qty-table-row').css('background-color', '#fff');
                                    $('.bss-b2b-qty-table-row').css('color', '#000');
                                    $(this).css('color', '#fff');
                                    $(this).css({
                                        'border-color': '#000', 'border-width': '1px', 'border-style': 'solid',
                                    });
                                    $(this).css('background-color', '#03baad');
                                }
                                else {
                                    $(this).addClass('qty-row-active');
                                }
                            });
                    }
                    else {
                        $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                            on('click', function (e) {
                                e.preventDefault();
                                $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                    removeClass('qty-row-active');
                                let quantityAmount = parseInt(
                                    parseFloat($(this).attr('data-max')) * 100 / appliedRule.price);
                                if (quantityAmount >= 1) {
                                    if (![10700, 13511].includes(BSS_B2B.storeId)) {
                                        $(quantitySelector).
                                            not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                            val(quantityAmount);
                                    } else if (BSS_B2B.storeId === 13511) {
                                        let inventoryQuantity = 9999;
                                        let inventoryText = $("[id^='Inventory']").text()
                                        var match = inventoryText.match(/\d+/);
                                        if (match) {
                                            inventoryQuantity = parseInt(match[0]);
                                        }
                                        $(quantitySelector).
                                            not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                            val(Math.min(quantityAmount, inventoryQuantity));
                                    }
                                }

                                $(this).addClass('qty-row-active');
                            });
                    }
                });

            }
        }

        // re-generate qb table after change variant
        // fix for bingltd by Leorio
        if ([2851, 14384].includes(BSS_B2B.storeId)) {
            window.BSS_B2B.executeAction({ tag: 'change_quantity', storeId: 2851 });
        }
        else {
            let cartForm = $('form[action*="/cart/add"],' + 'form[action*="/checkout"]' +
                BSS_B2B.getCssSelector('product_cart_form'));

            if (cartForm.length) {
                for (let i = 0; i < cartForm.length; i++) {
                    let cartFormI = $(cartForm[i]);
                    let id = cartFormI.attr('id');
                    let variantSelector = cartFormI.find(
                        'select, ' + 'input.single-option-selector__radio, ' + 'input[name=\'id\']' +
                        BSS_B2B.getCssSelector('product_variant_option_input'));
                    if (variantSelector.length) {
                        for (let k = 0; k < variantSelector.length; k++) {
                            let element = $(variantSelector[k]);
                            element.attr('data-cart-form', id);
                            element.on('change', function () {
                                setTimeout(function () {
                                    if (BSS_B2B.storeId === 11805) {
                                        $('.bss-b2b-button-show-qb-table').remove();
                                        $('.bss-b2b-cart-item-qty-table').remove();
                                        element.off();
                                    }
                                    $(document).
                                        find(
                                            '.bss-b2b-cart-item-qty-table:not([bss-b2b-qb-featured-product-id] .bss-b2b-cart-item-qty-table)').
                                        remove();
                                    BSS_B2B.qb.generateTableOnProductPage();
                                }, 2000);
                            });
                        }
                    }

                    let variantSelectorClickItem = cartFormI.find(
                        '.block-swatch-list .block-swatch__item,' + // fix for knobs-pulls-things by CuongNVM
                        '.gf_column .gf_swatch,' + // fix krkcwholesale by DongNV
                        '.nt-swatch,' + //fix for krkcshop by HaiNN
                        '.SizeSwatchList');
                    if (variantSelectorClickItem.length && BSS_B2B.storeId !== 621) {
                        for (let k = 0; k < variantSelectorClickItem.length; k++) {
                            let element = $(variantSelectorClickItem[k]);
                            element.attr('data-cart-form', id);
                            element.on('click', function () {
                                setTimeout(function () {
                                    $(document).find('.bss-b2b-cart-item-qty-table').remove();
                                    BSS_B2B.qb.generateTableOnProductPage();
                                }, 2000);
                            });
                        }
                    }
                }
            }

            if ($(quantitySelector).length) {
                const debounceFnc = (callback, timeout = 1000) => {
                    let timer;
                    return (...args) => {
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            callback.apply(this, args);
                        }, timeout);
                    };
                };
                // re-generate qb table after change quantity
                $(quantitySelector).each(function () {
                    if (!$(this).attr('bss-qb-change-quantity-event')) {
                        $(this).attr('bss-qb-change-quantity-event', true);
                        $(this).on('change', debounceFnc(function () {
                            if ([2462, 5101, 5835, 6318].indexOf(BSS_B2B.storeId) !== -1) {
                                $(quantitySelector).off();
                                buttonChangeQuantity.off();
                            }
                            if ([5515, 5527, 5980, 5263, 6533].indexOf(BSS_B2B.storeId) !== -1) {
                                setTimeout(function () {
                                    $('.bss-b2b-cart-item-qty-table').remove();
                                    BSS_B2B.qb.generateTableOnProductPage();
                                }, 2000);
                            }
                            else {
                                $('.bss-b2b-cart-item-qty-table:not([bss-b2b-qb-featured-product-id] .bss-b2b-cart-item-qty-table)').
                                    remove();
                                BSS_B2B.qb.generateTableOnProductPage();
                                window.BSS_B2B.executeAction({ tag: "customQBOnPDP", storeId: 13871 });
                            }
                        }));
                    }
                });

                let buttonChangeQuantity = BSS_B2B.qb.buttonChangeQuantityOnProductPage;
                if (buttonChangeQuantity.length > 0) {
                    buttonChangeQuantity.on('click', function () {
                        window.BSS_B2B.executeAction({ tag: 'off_button_change_quantity', storeId: 13499, quantitySelector, buttonChangeQuantity });
                        if ([2462, 3879, 5515, 5527, 9225, 7795, 10438].indexOf(BSS_B2B.storeId) !== -1) {
                            $(quantitySelector).off();
                            buttonChangeQuantity.off();
                        }
                        if ([5515, 5527, 5980].indexOf(BSS_B2B.storeId) !== -1) {
                            setTimeout(function () {
                                $('.bss-b2b-cart-item-qty-table').remove();
                                BSS_B2B.qb.generateTableOnProductPage();
                            }, 2000);
                        }
                        else if (BSS_B2B.storeId === 11805) {
                            const buttonQbPrice = $('.bss-b2b-button-show-qb-table');
                            if (buttonQbPrice && !buttonQbPrice.length) {
                                $('.bss-b2b-cart-item-qty-table').remove();
                                BSS_B2B.qb.generateTableOnProductPage();
                            }
                        }
                        else if (BSS_B2B.storeId === 2311) {
                            $(this).off()
                            if ($('.Product__Info .bss-b2b-cart-item-qty-table').length) $('.Product__Info .bss-b2b-cart-item-qty-table')[0].remove();
                            BSS_B2B.qb.generateTableOnProductPage();
                            BSS_B2B.qb.generateTableOnFeatureProduct();
                        }
                        else {
                            $('.bss-b2b-cart-item-qty-table').remove();
                            BSS_B2B.qb.generateTableOnProductPage();
                        }

                        // fix for storeID 9225
                        window.BSS_B2B.executeAction({ tag: 'qb_customize_price', storeId: 9225 });
                    });
                }
            }
        }

        // currency
        if (isEnableMC && BSS_B2B.MC.preConvertCurrency) {
            let sessionCurrencyCode = window.localStorage.getItem('currentCurrency');
            let sessionCurrencyFormat = window.localStorage.getItem('currentCurrencyFormat');
            BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
        }
    };

    BSS_B2B.qb.generateTableOnQuickView = async function () {
        let appliedRule = BSS_B2B.qb.getAppliedRuleOnQuickView(false);
        let allRuleForThisProduct = BSS_B2B.qb.getAllRuleApplyForProduct(false, null, true);
        let quantityValue = false;
        let quantitySelector = BSS_B2B.qb.quantityInputSelectorOnQuickView.join(',');

        if ($(quantitySelector).length > 0) {
            quantityValue = $(quantitySelector).val();
        }

        let applyMultipleRule = BSS_B2B.qbSettings.show_multiple_table ? BSS_B2B.qbSettings.show_multiple_table : 0;
        let elementAppendTableAfterVat = document.querySelector(
            'div[id^="QuickAddInfo"] .bss-b2b-product-vat, .product-form--regular .bss-b2b-product-vat');
        let elementQty = document.querySelector('div[id^=\'QuickAddInfo\'] > .product .product-form__quantity');
        if (appliedRule) {
            if (!applyMultipleRule) {
                appliedRule.keyOrId = shopData.line_item_products[0] ? shopData.line_item_products.id : null;
                let qtyTableHtml = '';

                qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue, false);

                let elementAppendTableSelector = document.querySelector(
                    'div[id^="QuickAddInfo"] > .product form[action*="/cart/add"] .bss-b2b-qb-table-on-quick-view, loess-modal-product .modal__inner form[action*="/cart/add"] .bss-b2b-qb-table-on-quick-view');
                if (BSS_B2B.storeId === 12551) {
                    elementAppendTableSelector = document.querySelector(
                        '.product-details .bss-b2b-qb-table-on-quick-view');
                }
                if (BSS_B2B.storeId === 16067) {
                    elementAppendTableSelector = document.querySelector(
                        '.modal-content .bss-b2b-qb-table-on-quick-view');
                }
                if (elementAppendTableAfterVat && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length &&
                    isEnabledTD && !elementAppendTableSelector) {
                    elementAppendTableAfterVat.insertAdjacentHTML('afterend', qtyTableHtml);
                    if (elementQty) {
                        let elementQbTable = document.getElementsByClassName('bss-b2b-cart-item-qty-table');
                        elementQbTable[elementQbTable.length - 1].insertAdjacentElement('beforeend', elementQty);
                    }
                }
                else if (elementAppendTableSelector) {
                    elementAppendTableSelector.insertAdjacentHTML('beforebegin', qtyTableHtml);
                }
                else {
                    if ($('div[id^="QuickAddInfo"] form[action*="/cart/add"]').length > 1) {
                        $('div[id^="QuickAddInfo"] form[action*="/cart/add"]').first().prepend(qtyTableHtml);
                    }
                    else {
                        $('div[id^="QuickAddInfo"] form[action*="/cart/add"]:not(.product-item__action-list)').
                            prepend(qtyTableHtml);
                    }
                }

                if (appliedRule.rule_setting === 0) {
                    $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                        on('click', function (e) {
                            setTimeout(() => {
                                e.preventDefault();
                                if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).
                                    not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                    val($(this).attr('data-max')); else $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val($(this).attr('data-min'));
                                $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                    removeClass('qty-row-active');
                                $(this).addClass('qty-row-active');
                            }, 1000);
                        });
                }
                else {
                    $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                        on('click', function (e) {
                            e.preventDefault();
                            $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row)').
                                removeClass('qty-row-active');
                            $(this).addClass('qty-row-active');
                        });
                }
            }
            else {
                allRuleForThisProduct.forEach(function (rule) {
                    let quantityTableValue = 0;
                    if (rule.id === appliedRule.id) {
                        quantityTableValue = quantityValue;
                    }
                    rule.keyOrId = shopData.product ? shopData.product.id : null;
                    let qtyTableHtml;

                    qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(rule, true, quantityTableValue, false);

                    if (elementAppendTableAfterVat && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length &&
                        isEnabledTD) {
                        elementAppendTableAfterVat.insertAdjacentHTML('afterend', qtyTableHtml);
                        if (elementQty) {
                            let elementQbTable = document.getElementsByClassName('bss-b2b-cart-item-qty-table');
                            elementQbTable[elementQbTable.length - 1].insertAdjacentElement('beforeend', elementQty);
                        }
                    }
                    else if ($(
                        'div[id^="QuickAddInfo"] form[action*="/cart/add"] .bss-b2b-qb-table-on-quick-view').length >
                        0) {
                        $('div[id^="QuickAddInfo"] form[action*="/cart/add"] .bss-b2b-qb-table-on-quick-view').
                            prepend(qtyTableHtml);
                    }
                    else {
                        if ($('div[id^="QuickAddInfo"] form[action*="/cart/add"]').length > 1) {
                            $('div[id^="QuickAddInfo"] form[action*="/cart/add"]').first().prepend(qtyTableHtml);
                        }
                        else {
                            $('div[id^="QuickAddInfo"] form[action*="/cart/add"]:not(.product-item__action-list)').
                                prepend(qtyTableHtml);
                        }
                    }

                    if (rule.rule_setting === 0) {
                        $('.bss-b2b-qty-table-row:not([bss-b2b-qb-featured-product-id] .bss-b2b-qty-table-row').
                            on('click', function (e) {
                                e.preventDefault();
                                if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).
                                    not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                    val($(this).attr('data-max')); else $(quantitySelector).
                                        not('[bss-b2b-qb-featured-product-id] input[type="number"]').
                                        val($(this).attr('data-min'));
                                $('.bss-b2b-qty-table-row').removeClass('qty-row-active');
                                $(this).addClass('qty-row-active');
                            });
                    }
                });

            }
        }

        // re-generate qb table after change variant
        let cartForm = $(
            'form[action*="/cart/add"],' + 'form[action*="/checkout"]' + BSS_B2B.getCssSelector('product_cart_form'));

        if (cartForm.length) {
            for (let i = 0; i < cartForm.length; i++) {
                let cartFormI = $(cartForm[i]);
                let id = cartFormI.attr('id');
                let variantSelector = cartFormI.find(
                    'select, ' + 'input.single-option-selector__radio, ' + 'input[name=\'id\']' +
                    BSS_B2B.getCssSelector('product_variant_option_input'));
                if (variantSelector.length) {
                    for (let k = 0; k < variantSelector.length; k++) {
                        let element = $(variantSelector[k]);
                        element.attr('data-cart-form', id);
                        element.on('change', function () {
                            setTimeout(function () {
                                BSS_B2B.qb.modalQuickView.find('.bss-b2b-cart-item-qty-table').remove();
                                BSS_B2B.qb.generateTableOnQuickView();
                            }, 1000);
                        });
                    }
                }

                let variantSelectorClickItem = cartFormI.find(
                    '.block-swatch-list .block-swatch__item,' + '.gf_column .gf_swatch,' + '.nt-swatch,' +
                    '.SizeSwatchList');
                if (variantSelectorClickItem.length) {
                    for (let k = 0; k < variantSelectorClickItem.length; k++) {
                        let element = $(variantSelectorClickItem[k]);
                        element.attr('data-cart-form', id);
                        element.on('click', function () {
                            setTimeout(function () {
                                BSS_B2B.qb.modalQuickView.find('.bss-b2b-cart-item-qty-table').remove();
                                BSS_B2B.qb.generateTableOnQuickView();
                            }, 1000);
                        });
                    }
                }
            }
        }

        if ($(quantitySelector).length) {
            if (BSS_B2B.storeId === 16067) {
                BSS_B2B.qb.modalQuickView = $('div[id^="QuickAddInfo"]');
            }
            // re-generate qb table after change quantity
            $(quantitySelector).each(function () {
                if (!$(this).attr('bss-qb-change-quantity-event')) {
                    $(this).attr('bss-qb-change-quantity-event', true);
                    $(this).on('change', function () {
                        BSS_B2B.qb.modalQuickView.find('.bss-b2b-cart-item-qty-table').remove();
                        BSS_B2B.qb.generateTableOnQuickView();
                    });
                }
            });

            let buttonChangeQuantity = BSS_B2B.qb.buttonChangeQuantityOnQuickView;
            if (buttonChangeQuantity.length > 0) {
                buttonChangeQuantity.on('click', function () {
                    BSS_B2B.qb.modalQuickView.find('.bss-b2b-cart-item-qty-table').remove();
                    BSS_B2B.qb.generateTableOnQuickView();
                });
            }
        }

        // currency
        if (isEnableMC && BSS_B2B.MC.preConvertCurrency) {
            let sessionCurrencyCode = window.localStorage.getItem('currentCurrency');
            let sessionCurrencyFormat = window.localStorage.getItem('currentCurrencyFormat');
            BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
        }
    };

    /**
     * show prices have not decreased and decreased when used qb
     */
    BSS_B2B.qb.showPriceWhenUseQB = function (
        qbPricingList, cpPricingList, cartData, shopData = null, appliedTaxDisplayRule, cartItemProductMapByKey,
        ruleMap = false) {
      console.trace()
        let cartSubtotalPrice = cartData.original_total_price;
        if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
            (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
            cartSubtotalPrice = BSS_B2B.cart.modifiedItemsSubtotalPrice;
        }
        let newCartItemProductMapByKey = cartItemProductMapByKey;

        let newQBPricingList = new Map();
        let cartSubtotalNoVat = 0;
        let cartSubtotalWithVat = 0;
        let rateMarket = Shopify.currency.rate;
        let arrayQbPricingList = Array.from(qbPricingList.values());
        let totalDiscount = 0;
        for (let i = 0; i < qbPricingList.size; i++) {
            let itemQB = arrayQbPricingList[i];
            // fix for bingltd by Leorio
            if (BSS_B2B.storeId === 2851) {
                let discountEle_2851 = $('[data-cart-item-key="' + itemQB.key + '"] .product-price__reduced');
                if (discountEle_2851.length) {
                    discountEle_2851.remove();
                }
            }

            newCartItemProductMapByKey.delete(itemQB.key);
            let newTotalPriceOfItem = false;
            let offsetPriceOfItem = 0;
            let newPricePerItem = false;
            let totalPriceItem = (itemQB.price * itemQB.quantity);
            let quantity = itemQB.quantity;
            let pricePerItem = itemQB.price;
            let discountValue = itemQB.discount_value * 100;
            let itemAppliedCP = false;
            let totalPriceItemSelectors = document.querySelectorAll(
                BSS_B2B.qb.totalPriceOfItemElement(itemQB.key).join(','));
            if (BSS_B2B.storeId === 15447) {
                totalPriceItemSelectors = null;
            }
            let isExistQBTotalPriceItem = false;
            if (totalPriceItemSelectors) {
                totalPriceItemSelectors.forEach(totalPriceItem => {
                    if (!isExistQBTotalPriceItem) {
                        if (totalPriceItem.parentNode.querySelector('.bss-qb-total-price-item')) {
                            isExistQBTotalPriceItem = true;
                            // fix for shop-ahika by DangNM
                        }
                    }
                });
            }

            if (isExistQBTotalPriceItem && [2933, 1976, 3891, 4117, 4441].indexOf(BSS_B2B.storeId) !== -1) {
                // do nothing
            }
            else {
                let itemCPDiscountType = false;
                let itemCPDiscountValue = false;
                if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                    (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                    let itemCP = cpPricingList.get(itemQB.key);
                    if (itemCP) {
                        totalPriceItem = itemCP.modifiedLineItemPriceWithMarket.toFixed(0);
                        pricePerItem = itemCP.modifiedItemPrice.toFixed(0);
                        itemCPDiscountType = itemCP.discountType;
                        itemCPDiscountValue = itemCP.discountValue;
                        itemAppliedCP = true;
                    }
                }

                if (itemQB.override_tax && !itemAppliedCP) {
                    let addition = parseFloat((pricePerItem * itemQB.override_tax / 10000.00).toFixed(2)) * 100;
                    cartSubtotalPrice += quantity * addition;
                    totalPriceItem += quantity * addition;
                    cartData.original_total_price += quantity * addition;
                }

                if (itemQB.discount_type === 0) {
                    let discountValueWithRate = BSS_B2B.helper.convertPriceWithRate(discountValue);
                    if (pricePerItem < discountValueWithRate) {
                        newPricePerItem = pricePerItem;
                        newTotalPriceOfItem = (newPricePerItem) * quantity;
                    }
                    else {
                        let realDiscount = (pricePerItem / rateMarket - discountValue).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newPricePerItem = (pricePerItem - realDiscount);
                        newTotalPriceOfItem = newPricePerItem * quantity;

                        if (BSS_B2B.storeId === 2524 && !itemAppliedCP && itemQB.override_tax) {
                            newPricePerItem = parseFloat(
                                (newPricePerItem * (1 + itemQB.override_tax / 100) / 100).toFixed(2)) * 100;
                            newTotalPriceOfItem = newPricePerItem * quantity;
                        }
                    }
                }
                else if (itemQB.discount_type === 1) {
                    let discountValueWithRate = parseFloat(
                        (BSS_B2B.helper.convertPriceWithRate(discountValue)).toFixed(0));
                    if (pricePerItem < discountValueWithRate) {
                        newPricePerItem = 0;
                        newTotalPriceOfItem = 0;
                    }
                    else {
                        newPricePerItem = pricePerItem - discountValueWithRate;
                        newTotalPriceOfItem = newPricePerItem * quantity;
                    }
                }
                else {
                    if (itemCPDiscountType === 2) {
                        let itemPriceAfterCP = parseFloat(
                            (itemQB.price - itemQB.price * (itemCPDiscountValue / 100)).toFixed(0));
                        let realDiscount = ((itemPriceAfterCP / rateMarket) * ((itemQB.discount_value) / 100)).toFixed(
                            0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newPricePerItem = itemPriceAfterCP - realDiscount;
                    }
                    else {
                        let realDiscount = ((pricePerItem / rateMarket) * ((itemQB.discount_value) / 100)).toFixed(0);
                        realDiscount = (realDiscount * rateMarket).toFixed(0);
                        newPricePerItem = pricePerItem - realDiscount;
                    }
                    newTotalPriceOfItem = parseFloat(newPricePerItem * itemQB.quantity);
                }

                offsetPriceOfItem = totalPriceItem - newTotalPriceOfItem;
                cartSubtotalPrice = cartSubtotalPrice - offsetPriceOfItem;
                totalDiscount += offsetPriceOfItem;
            }

            BSS_B2B.cart.modifiedItemsSubtotalPriceQb = cartSubtotalPrice;

            if (newPricePerItem !== pricePerItem) {
                let priceItemSelectors = document.querySelectorAll(
                    BSS_B2B.qb.priceOfEachItemElement(itemQB.key).join(','));
                if (BSS_B2B.storeId === 15447) {
                    priceItemSelectors = '';
                }
                if (priceItemSelectors.length > 0) {
                    for (let i = 0; i < priceItemSelectors.length; i++) {
                        if (i > 0 && [2822, 15624, 14608, 16356].includes(BSS_B2B.storeId)) break;
                        let priceItemEle = priceItemSelectors[i];
                        if (!priceItemEle.parentNode) {
                            continue;
                        }
                        if (priceItemEle.querySelector('p, div, span, dt, dd') && ![14608, 13877, 5890, 5980, 5184, 2822, 6491, 6526, 2050, 7319, 8051, 8452, 9557, 9568, 7039, 10674, 10808, 10700, 12156, 5475, 11332, 13249, 13499, 13871, 15624, 15693, 14938, 14962, 16067, 16356].includes(BSS_B2B.storeId)) {
                            continue;
                        }
                        else if (priceItemEle.querySelector('dt, dd') && [7319, 10808, 15693].includes(BSS_B2B.storeId)) {
                            continue;
                        }
                        else if (!priceItemEle.querySelector('div') && [8452].includes(BSS_B2B.storeId)) {
                            continue;
                        }
                        else if ([9568].includes(BSS_B2B.storeId) &&
                            priceItemEle.classList.contains('product-option')) {
                            continue;
                        }
                        else if ([8927].includes(BSS_B2B.storeId)) {
                            if (priceItemEle.closest('del') && priceItemEle.closest('del').nextSibling ===
                                priceItemEle.closest('del').parentNode.querySelector('ins')) {
                                priceItemEle.remove();
                                continue;
                            }

                            if (!priceItemEle.classList.contains('bss-qb-price-item')) {
                                priceItemEle.classList.add('bss-b2b-custom-compare-price');
                            }
                            else {
                                continue;
                            }
                        }
                        else if ([9139].includes(BSS_B2B.storeId) &&
                            priceItemEle.classList.contains('cart-item__subtotal')) {
                            continue;
                        }
                        priceItemEle.style.textDecoration = 'line-through';

                        if (priceItemEle.parentNode.querySelector('.bss-b2b-compare-at-price') &&
                            !priceItemEle.classList.contains('bss-b2b-compare-at-price')) {
                            priceItemEle.style.display = 'none';
                            if (BSS_B2B.storeId === 5885) {
                                priceItemEle.classList.add('bss-hide-5885');
                            }
                        }
                        else {
                            if ([9557].includes(BSS_B2B.storeId)) {
                                priceItemEle.setAttribute('style', 'text-decoration: line-through');
                            } else if (BSS_B2B.storeId === 7455 && priceItemEle.classList.contains('bss-b2b-cart-item-no-vat-price')) {
                                priceItemEle.setAttribute('style', 'text-decoration: auto !important');
                            } else if ([13552, 13760].includes(BSS_B2B.storeId) && priceItemEle.classList.contains('bss-qb-price-item')) {
                                priceItemEle.setAttribute('style', 'text-decoration: auto !important;margin-left:5px');
                            } else if ([14389].includes(BSS_B2B.storeId) && priceItemEle.classList.contains('bss-qb-price-item')) {
                                priceItemEle.setAttribute('style', 'text-decoration: auto !important; display: block');
                            }
                            else {
                                priceItemEle.setAttribute('style', 'text-decoration: line-through !important');
                            }
                        }
                        if (priceItemEle.parentNode.querySelector('.bss-qb-price-item') &&
                            ([2933, 1976, 4117, 5515, 5527, 5980, 6631, 8014, 8640, 8927].indexOf(BSS_B2B.storeId) ===
                                -1)) {
                            if (BSS_B2B.storeId === 10700) {
                                priceItemEle.parentNode.querySelector(
                                    '.bss-qb-price-item').innerText = BSS_B2B.formatMoney(newPricePerItem);
                            }
                            // fix for shop-ahika by DangNM
                            // fix for fabvoguestudio by madu
                            // fix bug checkout qb (madu)
                            // return;
                        }
                        else {
                            let priceItemApplyQBHTML = '<span class="bss-qb-price-item" bss-shop-base-currency="' +
                                newPricePerItem + '" style="display: block;">' + BSS_B2B.formatMoney(newPricePerItem) +
                                '</span>';

                            // fix for straightcurve-usa by DangNM
                            if (BSS_B2B.storeId === 4558 && priceItemEle.tagName === 'H6') {
                                priceItemEle.style.display = 'inline-block';
                                priceItemApplyQBHTML = '<h6 class="bss-qb-price-item" bss-shop-base-currency="' +
                                    newPricePerItem + '" style="display: inline-block;margin-left: 6px">' +
                                    BSS_B2B.formatMoney(newPricePerItem) + '</h6>';
                            }
                            // fix for shop-ahika by DangNM
                            if (priceItemEle.parentNode.querySelector('.bss-qb-price-item')) {
                                priceItemEle.parentNode.querySelector('.bss-qb-price-item').remove();
                            }

                            if (BSS_B2B.storeId === 2851) {
                                priceItemEle.parentNode.style.display = '-webkit-inline-box';
                            }

                            // Fix for herbcience-com.myshopify.com add class money to integrate with app auto curency
                            // swithcher
                            if ([8927, 10700].indexOf(BSS_B2B.storeId) !== -1) {
                                priceItemApplyQBHTML = '<span class="bss-qb-price-item money" bss-shop-base-currency="' +
                                    newPricePerItem + '" style="display: block;">' +
                                    BSS_B2B.formatMoney(newPricePerItem) + '</span>';
                            }
                            //fix for knobs-pulls-things by CuongNVM
                            if (BSS_B2B.storeId === 4117) {
                                let priceItemHtml = $(priceItemEle).html();
                                if ($('[data-cart-item-key="' + itemQB.key + '"] .item_price').length > 0) {
                                    priceItemHtml = $('[data-cart-item-key="' + itemQB.key + '"] .item_price').html();
                                }
                                priceItemEle.style.textDecoration = 'none';
                                priceItemEle.innerHTML = '';
                                let oldPriceHtml = `<span class='item_price' style="text-decoration:line-through">` +
                                    priceItemHtml + `</span>`;
                                priceItemEle.insertAdjacentHTML('beforeend',
                                    oldPriceHtml + '<br/>' + priceItemApplyQBHTML);
                            }
                            // custom for florx.co.nz by cuongcx
                            else if (BSS_B2B.storeId === 12156) {
                                priceItemApplyQBHTML = '<span class="bss-qb-price-item" bss-shop-base-currency="' +
                                    newPricePerItem + '" style="display: inline-block;">' +
                                    BSS_B2B.formatMoney(newPricePerItem) + '</span>';
                                let priceItemHtml = priceItemEle.querySelector('.revy-line-item-unit-price__old') ||
                                    priceItemEle.querySelector('.revy-original-item-price') || '';
                                if (priceItemHtml) {
                                    priceItemHtml = priceItemHtml.innerText;
                                }
                                priceItemEle.style.textDecoration = 'none';
                                priceItemEle.innerHTML = '';
                                let oldPriceHtml = `<span class='revy-line-item-unit-price__old' style="text-decoration:line-through">` +
                                    priceItemHtml + `</span>`;
                                priceItemEle.insertAdjacentHTML('beforeend',
                                    oldPriceHtml + '&nbsp;&nbsp;&nbsp;' + priceItemApplyQBHTML);
                            }
                            // custom for 9d1d52-2.myshopify.com by quyen pv
                            else if (BSS_B2B.storeId === 11776) {
                                priceItemApplyQBHTML = '<span class="bss-qb-price-item" bss-shop-base-currency="' +
                                    newPricePerItem + '" style="display: inline;">' +
                                    BSS_B2B.formatMoney(newPricePerItem) + '</span>';
                                if (priceItemEle.nextSibling && priceItemEle.nextSibling.className ==
                                    'bss-b2b-custom-cp-rule') {
                                    priceItemEle.nextSibling.insertAdjacentHTML('afterEnd',
                                        '<br/>' + priceItemApplyQBHTML +
                                        `&nbsp;&nbsp;&nbsp;${itemQB.discount_value}%&nbsp;${ruleMap.get(
                                            itemQB.key).name}`);
                                }
                                else {
                                    if (priceItemEle.hasAttribute('bss-b2b-item-original-price')) {
                                        priceItemEle.insertAdjacentHTML('afterEnd', priceItemApplyQBHTML);
                                    }
                                }
                            }
                            else {
                                priceItemEle.insertAdjacentHTML('afterEnd', priceItemApplyQBHTML);
                                if (BSS_B2B.storeId === 16356) {
                                    priceItemEle.setAttribute('style', 'display: none !important');
                                }
                            }
                        }
                        if ([13852].includes(BSS_B2B.storeId)) {
                            if (priceItemEle.querySelector('ins') && priceItemEle.querySelector('ins').nextSibling ===
                                priceItemEle.querySelector('ins').parentNode.querySelector('del')) {
                                priceItemEle.style.visibility = "hidden";
                                continue
                            }
                        }
                        //
                        // fix for detecton by Leorio
                        if (BSS_B2B.storeId === 1778) {
                            priceItemEle.style.color = '#ff0505';
                            let priceItemCustom1778 = document.getElementsByClassName('bss-qb-price-item');
                            if (priceItemCustom1778) {
                                priceItemCustom1778.style.fontWeight = 'bold';
                                priceItemCustom1778.style.fontSize = '18px';
                            }
                            // }
                            // fix for permitpony by DangNM
                            if (BSS_B2B.storeId === 2982) {
                                let lineItemCustom2982 = document.querySelector('[data-cart-item-key="' + itemQB.key +
                                    '"] .line-item__price.line-item__price--compare');
                                if (lineItemCustom2982) {
                                    lineItemCustom2982.style.display = 'none';
                                }
                            }
                        }
                        // fix for renewaball by hoaduong
                        if (BSS_B2B.storeId === 4001 &&
                            priceItemEle.parentNode.querySelector('.bss-qb-price-item').length > 0) {
                            document.querySelector(
                                '[bss-b2b-cart-item-key],[bss-b2b-cart-total-price]').style.display = 'none';
                        }
                    }
                }
            }
            else if (newPricePerItem === pricePerItem) {
                // fix for detecton by Leorio
                let priceItemSelectors = document.querySelectorAll(
                    BSS_B2B.qb.priceOfEachItemElement(itemQB.key).join(','));
                if (priceItemSelectors.length > 0) {
                    priceItemSelectors.forEach(priceItem => {
                        if (BSS_B2B.storeId === 1778) {
                            priceItem.style.fontSize = '18px';
                            priceItem.style.fontWeight = 'bold';
                        }
                        //fix for knobs-pulls-things by CuongNVM
                        if (BSS_B2B.storeId === 4117) {
                            priceItem.style.textDecoration = 'none';
                        }
                    });
                }
            }

            if (totalPriceItemSelectors) {
                for (let i = 0; i < totalPriceItemSelectors.length; i++) {
                    let totalPriceItemEle = totalPriceItemSelectors[i];
                    if (!totalPriceItemEle.parentNode) {
                        continue;
                    }
                    if (totalPriceItemEle.querySelector('p, div, span') && ![13877, 12291, 5890, 5980, 5184, 2822, 3940, 6526, 2050, 7319, 2314, 9568, 7039, 10438, 10674, 10808, 10700, 12156, 5475, 11332, 13249, 15624, 15693, 6556].includes(BSS_B2B.storeId)) {
                        continue;
                    }
                    else if ([12156].includes(BSS_B2B.storeId) &&
                        totalPriceItemEle.classList.contains('cart__item-price')) {
                        continue;
                    }
                    else if (totalPriceItemEle.querySelector('bdi') && [7319, 9568].includes(BSS_B2B.storeId)) {
                        continue;
                    }
                    else if ([9139].includes(BSS_B2B.storeId) && totalPriceItemEle.classList.contains('item_price')) {
                        continue;
                    }
                    if ([3628, 3940, 7731, 10104].includes(BSS_B2B.storeId)) {
                        totalPriceItemEle.setAttribute('style', 'text-decoration: line-through');
                    }
                    if (BSS_B2B.storeId === 5184) {
                        totalPriceItemEle.style.display = 'table-cell';
                        totalPriceItemEle.setAttribute('style', 'text-decoration: line-through');
                    }
                    if (window.location.pathname === '/apps/customer-portal/purchase-late') {
                        if ($(
                            '.bss-b2b-bcp-new-line-item-price[bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').length >
                            0) {
                            $('.bss-b2b-bcp-new-line-item-price[bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').
                                attr('bss-shop-base-currency', newTotalPriceOfItem);
                            $('.bss-b2b-bcp-new-line-item-price[bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').
                                html(BSS_B2B.formatMoney(newTotalPriceOfItem, shopData.shop.money_format));
                        }
                        else {
                            let priceLineItemHTML = '<span class="bss-b2b-bcp-new-line-item-price" bss-b2b-bcp-cart-item-key="' +
                                itemQB.key + '" bss-shop-base-currency="' + newTotalPriceOfItem +
                                '" style="display: block;">' +
                                BSS_B2B.formatMoney(newTotalPriceOfItem, shopData.shop.money_format) + '</span>';
                            $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').
                                css('text-decoration', 'line-through');
                            if (BSS_B2B.storeId === 2314) {
                                let originalPriceItem = $(
                                    '[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + itemQB.key +
                                    '"] .money').attr('data-currency-gbp');
                                let originalPriceHTML = '<b class="new_money" style="text-decoration: line-through;" data-currency-gbp="' +
                                    originalPriceItem + '">' + originalPriceItem + '</b>';
                                $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + itemQB.key +
                                    '"] .money').remove();
                                $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').
                                    before(originalPriceHTML);
                            }
                            $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + itemQB.key + '"]').
                                after(priceLineItemHTML);
                        }
                    }
                    else {
                        let totalPriceHTML = '';
                        if (parseFloat(newTotalPriceOfItem) < parseFloat(totalPriceItem)) {
                            totalPriceHTML = '<span class="bss-qb-total-price-item" bss-shop-base-currency="' +
                                newTotalPriceOfItem + '" style="display: block;">' +
                                BSS_B2B.formatMoney(newTotalPriceOfItem) + '</span>';
                            if ((totalPriceItemEle.parentNode.querySelector('.bss-b2b-compare-at-price') &&
                                !totalPriceItemEle.classList.contains('bss-b2b-compare-at-price')) || (isEnableCP &&
                                    ((BSS_B2B.configData && BSS_B2B.configData.length > 0) ||
                                        (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length > 0)))) {
                                totalPriceItemEle.style.display = 'none';
                            }
                            else {
                                totalPriceItemEle.setAttribute('style', 'text-decoration: line-through !important');
                            }
                        }
                        else {
                            if ([2707, 2982].indexOf(BSS_B2B.storeId) === -1) {
                                totalPriceItemEle.style.textDecoration = 'none';
                            }
                        }
                        if (BSS_B2B.storeId === 4558 && totalPriceItemEle.closest('.vendors')) {
                            totalPriceHTML = '<span' + ' class="bss-qb-total-price-item" bss-shop-base-currency="' +
                                newTotalPriceOfItem + '" style="display: inline-block;">' +
                                BSS_B2B.formatMoney(newTotalPriceOfItem) + '</span>';
                        }
                        else if (BSS_B2B.storeId === 14389 && totalPriceItemEle.closest('.ajaxcart__price')) {
                            totalPriceHTML = '';
                        }
                        else if ([8927, 10700].indexOf(BSS_B2B.storeId) !== -1) {
                            totalPriceHTML = '<span class="bss-qb-total-price-item money" bss-shop-base-currency="' +
                                newTotalPriceOfItem + '" style="display: block;">' +
                                BSS_B2B.formatMoney(newTotalPriceOfItem) + '</span>';
                        }
                        if (BSS_B2B.storeId === 5885) {
                            if (totalPriceHTML) {
                                totalPriceItemEle.classList.add('bss-hide-5885');
                            }
                            else {
                                totalPriceItemEle.style.display = 'block';
                            }
                        }
                        if ([10808].includes(BSS_B2B.storeId)) {
                            const itemPriceQB = totalPriceItemEle.querySelector('.bss-qb-price-item');
                            if (itemPriceQB) {
                                itemPriceQB.style.display = 'none';
                            }
                        }
                        // fix for shop-ahika by DangNM, fix for us.sextoysupply by HungVP
                        if (totalPriceItemEle.parentNode.querySelector('.bss-qb-total-price-item')) {
                            totalPriceItemEle.parentNode.querySelector('.bss-qb-total-price-item').remove();
                        }
                        //fix for knobs-pulls-things by CuongNVM
                        if (BSS_B2B.storeId === 4117) {
                            let priceLineItemHtml = $(totalPriceItemEle).html();
                            if ($('[data-cart-item-key="' + itemQB.key + '"] .line_item_price').length > 0) {
                                priceLineItemHtml = $('[data-cart-item-key="' + itemQB.key + '"] .line_item_price').
                                    html();
                            }
                            totalPriceItemEle.style.textDecoration = 'none';
                            totalPriceItemEle.innerHTML = '';
                            let oldTotalPriceHtml = `<span class='line_item_price' style="text-decoration:line-through">` +
                                priceLineItemHtml + `</span>`;
                            totalPriceItemEle.insertAdjacentHTML('beforeend',
                                oldTotalPriceHtml + '<br/>' + totalPriceHTML);
                        }
                        else if (BSS_B2B.storeId === 2314) {
                            setTimeout(function () {
                                let removePrice = totalPriceItemEle.querySelector('.bss-qb-price-item');
                                if (removePrice) removePrice.remove();
                                totalPriceItemEle.insertAdjacentHTML('afterEnd', totalPriceHTML);
                            }, 1000);
                        }
                        //fix for florx.co.nz by CuongCX
                        else if (BSS_B2B.storeId === 12156) {
                            let priceItemHtml = totalPriceItemEle.querySelector('.revy-line-item-price__old') ||
                                totalPriceItemEle.querySelector('.revy-final-item-price') || '';
                            if (priceItemHtml) {
                                priceItemHtml = priceItemHtml.innerText;
                            }
                            totalPriceItemEle.style.textDecoration = 'none';
                            totalPriceItemEle.innerHTML = '';
                            let oldTotalPriceHtml = `<span class='revy-line-item-price__old' style="text-decoration:line-through">` +
                                priceItemHtml + `</span>`;
                            totalPriceItemEle.insertAdjacentHTML('beforeend',
                                oldTotalPriceHtml + '<br/>' + totalPriceHTML);
                        }
                        else {
                            totalPriceItemEle.insertAdjacentHTML('afterEnd', totalPriceHTML);
                        }
                        if (BSS_B2B.storeId === 2851) {
                            totalPriceItemEle.parentNode.style.display = 'inline-flex';
                        }

                        // fix for detecton by Leorio
                        if (BSS_B2B.storeId === 1778) {
                            totalPriceItemEle.style.color = '#ff0505';
                            let totalPriceItemCustom1778 = document.getElementsByClassName('bss-qb-price-item');
                            if (totalPriceItemCustom1778) {
                                totalPriceItemCustom1778.style.fontWeight = 'bold';
                                totalPriceItemCustom1778.style.fontSize = '18px';
                            }
                        }
                        // fix for permitpony by DangNM
                        if (BSS_B2B.storeId === 2982) {
                            let comparePriceItemCustom2982 = document.querySelector(
                                '[data-cart-item-key="' + itemQB.key +
                                '"] .mini-cart__price-list .price.price--compare');
                            if (comparePriceItemCustom2982) {
                                comparePriceItemCustom2982.style.display = 'none';
                            }

                            let priceMiniCart2982 = document.querySelector('.mini-cart__price-list .price:first-child');
                            if (priceMiniCart2982) {
                                priceMiniCart2982.style.setProperty('text-decoration', 'line-through', 'important');
                            }
                        }
                        if (BSS_B2B.storeId === 5671 && isEnabledTD &&
                            ['bss-b2b-cart-item-no-vat-price', 'bss-b2b-cart-item-with-vat-price'].includes(
                                totalPriceItemEle.className)) {
                            totalPriceItemEle.setAttribute('style', 'text-decoration: unset !important');
                        }
                        else if (BSS_B2B.storeId === 5671 && !isEnabledTD) {
                            totalPriceHTML = '<span' + ' class="bss-qb-total-price-item" bss-shop-base-currency="' +
                                newTotalPriceOfItem + '" style="display: inline-block;">' +
                                BSS_B2B.formatMoney(newTotalPriceOfItem) + '</span>';
                            if (totalPriceHTML) {
                                totalPriceItemEle.style.display = 'none';
                            }
                        }
                    }
                }
            }

            itemQB.pricePerItemAfterApplyQB = newPricePerItem;
            newQBPricingList.set(itemQB.key, itemQB);

            if (appliedTaxDisplayRule) {
                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartItemChangeVatPrice(itemQB.key, shopData, newPricePerItem, appliedTaxDisplayRule,
                    itemQB.index, itemQB.taxable);
                let {
                    itemNoVatPrice, itemWithVatPrice,
                } = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartLineItemChangeVatPrice(itemQB.key, shopData, newTotalPriceOfItem,
                    appliedTaxDisplayRule, itemQB.index, itemQB.taxable);

                cartSubtotalNoVat += itemNoVatPrice;
                cartSubtotalWithVat += itemWithVatPrice;
            }
        }

        if (appliedTaxDisplayRule) {
            newCartItemProductMapByKey.forEach((value, key) => {
                let pricePerItem = value.price;
                let totalPriceItem = value.price * value.quantity;
                if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                    (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                    let itemCP = cpPricingList.get(key);
                    if (itemCP) {
                        totalPriceItem = itemCP.modifiedLineItemPriceWithMarket;
                        pricePerItem = itemCP.modifiedItemPrice;
                    }
                }

                _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartItemChangeVatPrice(value.key, shopData, pricePerItem, appliedTaxDisplayRule, value.index,
                    value.taxable);
                let {
                    itemNoVatPrice, itemWithVatPrice,
                } = _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartLineItemChangeVatPrice(value.key, shopData, totalPriceItem, appliedTaxDisplayRule,
                    value.index, value.taxable);

                cartSubtotalNoVat += itemNoVatPrice;
                cartSubtotalWithVat += itemWithVatPrice;
            });
        }

        BSS_B2B.cart.qbPricingList = newQBPricingList;

        cartSubtotalPrice = (parseFloat(cartSubtotalPrice / 100)).toFixed(2);
        let originalCartSubtotalPrice = (parseFloat(cartData.original_total_price / 100)).toFixed(2);
        // fix for ms-diffusions.myshopify.com by Hungvp

        let checkTaxDisplayRule = true;
        if ([9139, 4798].includes(BSS_B2B.storeId)) {
            if (appliedTaxDisplayRule.display_price_type === 2 && !BSS_B2B.page.isCartPage()) {
                checkTaxDisplayRule = false;
            }
        }

        if (appliedTaxDisplayRule && ![5686, 4739, 7321, 8606, 3903].includes(BSS_B2B.storeId) && checkTaxDisplayRule) {
            if (window.location.pathname === '/apps/customer-portal/purchase-late') {
                $('[bss-b2b-bcp-cart-subtotal-price]').
                    html(BSS_B2B.formatMoney(cartSubtotalPrice, shopData.shop.money_format));
                $('[bss-b2b-bcp-cart-subtotal-price]').attr('bss-shop-base-currency', cartSubtotalPrice);
                $('[bss-b2b-bcp-cart-total-price]').
                    html(BSS_B2B.formatMoney(cartSubtotalPrice, shopData.shop.money_format));
                $('[bss-b2b-bcp-cart-total-price]').attr('bss-shop-base-currency', cartSubtotalPrice);

                $('[bss-b2b-bcp-cart-subtotal-price],' + '[bss-b2b-bcp-cart-total-price],' +
                    '.bss-b2b-bcp-new-line-item-price').css('visibility', 'visible');
            }
            _taxexem_tax__WEBPACK_IMPORTED_MODULE_0___default.a.bssB2BCartChangeSubtotalVatPrice(shopData, cartSubtotalWithVat, cartSubtotalNoVat,
                appliedTaxDisplayRule);
        }
        else {
            // for compare with purchase-late of bcp by Leorio
            if (window.location.pathname === '/apps/customer-portal/purchase-late') {
                $('[bss-b2b-bcp-cart-subtotal-price]').
                    html(BSS_B2B.formatMoney(cartSubtotalPrice, shopData.shop.money_format));
                $('[bss-b2b-bcp-cart-subtotal-price]').attr('bss-shop-base-currency', cartSubtotalPrice);
                $('[bss-b2b-bcp-cart-total-price]').
                    html(BSS_B2B.formatMoney(cartSubtotalPrice, shopData.shop.money_format));
                $('[bss-b2b-bcp-cart-total-price]').attr('bss-shop-base-currency', cartSubtotalPrice);

                $('[bss-b2b-bcp-cart-subtotal-price],' + '[bss-b2b-bcp-cart-total-price],' +
                    '.bss-b2b-bcp-new-line-item-price').css('visibility', 'visible');
            }
            else {
                let cartSubtotalPriceSelectors = document.querySelectorAll(
                    BSS_B2B.qb.cartSubtotalPriceElement().join(','));
                let newCartSubtotalPriceHtml = '';

                if (parseFloat(cartSubtotalPrice) < parseFloat(originalCartSubtotalPrice)) {
                    let customClass = '';
                    if (BSS_B2B.storeId === 8927) {
                        customClass = ' money';
                    }

                    newCartSubtotalPriceHtml = '<span' + ` class="bss-qb-cart-subtotal${customClass}"` +
                        ' bss-shop-base-currency="' + cartSubtotalPrice + '"' + ' style="display: block;"' + '>' +
                        BSS_B2B.formatMoney(cartSubtotalPrice) + '</span>';
                    //fix change span to div subtotal for fancybeans by trungdd
                    if (BSS_B2B.storeId === 10927) {
                        newCartSubtotalPriceHtml = '<div' + ` class="bss-qb-cart-subtotal${customClass}"` +
                            ' bss-shop-base-currency="' + cartSubtotalPrice + '"' + ' style="display: block;"' + '>' +
                            BSS_B2B.formatMoney(cartSubtotalPrice) + '</div>';
                    }
                    if (cartSubtotalPriceSelectors) {
                        for (let i = 0; i < cartSubtotalPriceSelectors.length; i++) {
                            let cartSubtotalEle = cartSubtotalPriceSelectors[i];
                            if (cartSubtotalEle.querySelector('p, div, span') && ![12291, 5890, 5980, 5184, 3940, 6491, 7319, 10438, 10674, 10808, 11332, 13249, 13762, 15624, 15693].includes(BSS_B2B.storeId)) {
                                continue;
                            }
                            if ((cartSubtotalEle.parentNode.querySelector('.bss-b2b-compare-at-price') &&
                                !cartSubtotalEle.classList.contains('bss-b2b-compare-at-price')) || (isEnableCP &&
                                    ((BSS_B2B.configData && BSS_B2B.configData.length > 0) ||
                                        (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length > 0))) && ![8927, 13552].includes(BSS_B2B.storeId)) {
                                cartSubtotalEle.style.display = 'none';
                                if (BSS_B2B.storeId === 5885) {
                                    cartSubtotalEle.classList.add('bss-hide-5885');
                                }
                            }
                            else {
                                if (!cartSubtotalEle.getAttribute('bss-shop-base-currency')) {
                                    cartSubtotalEle.setAttribute('style', 'text-decoration: line-through !important');
                                }
                            }
                            if (BSS_B2B.storeId === 6491 && cartSubtotalEle.className.includes('cart__items')) {
                                cartSubtotalEle.setAttribute('style', 'text-decoration: none !important');
                            }
                            if (BSS_B2B.storeId === 14389 && cartSubtotalEle.className.includes('ajaxcart__subtotal')) {
                                cartSubtotalEle.setAttribute('style', 'text-decoration: none !important');
                            }
                            if ([5184, 5671, 7731, 12670].indexOf(BSS_B2B.storeId) !== -1) {
                                cartSubtotalEle.style.display = 'block';
                                cartSubtotalEle.setAttribute('style', 'text-decoration: line-through !important');
                            }
                            // fix by DangNM
                            if (BSS_B2B.storeId === 2524 && !BSS_B2B.cart.updatedLineItems.length) {
                                cartSubtotalEle.innerHTML = BSS_B2B.formatMoney(cartData.original_total_price);
                            }
                            // fix for enbioitalia by mitri
                            if (BSS_B2B.storeId === 3007) {
                                cartSubtotalEle.style.setProperty('text-decoration', 'line-through', 'important');
                            }

                            // fix for razor-shopping.com by cuongnq
                            if ([8014, 8638].indexOf(BSS_B2B.storeId) !== -1 &&
                                cartSubtotalEle.className.includes('bss-qb-cart-subtotal')) {
                                cartSubtotalEle.setAttribute('style', 'text-decoration: none !important');
                            }

                            if (BSS_B2B.storeId === 3339) {
                                document.querySelector('[data-cart-subtotal]').style.textDecoration = 'none';
                                document.querySelector(
                                    '.cart__item-price-col.text-right .cart__price').style.textDecoration = 'none';

                                if (BSS_B2B.page.isCartPage()) {
                                    cartSubtotalEle.insertAdjacentHTML('afterEnd', newCartSubtotalPriceHtml);
                                }
                            }

                            if (BSS_B2B.storeId === 621 && BSS_B2B.page.isCartPage() && !cartSubtotalEle.parentNode.querySelector('.bss-qb-cart-subtotal:nth-child(n+3)')) {
                                cartSubtotalEle.insertAdjacentHTML('afterend', newCartSubtotalPriceHtml);
                            }

                            if ([7323].includes(BSS_B2B.storeId)) {
                                let subtotalCustomQB = cartSubtotalEle.closest('.wholesale-cart-total');
                                if (subtotalCustomQB) {
                                    subtotalCustomQB.setAttribute('style', 'text-decoration: line-through !important');
                                }
                            }

                            // fix for littlesaints.com by cuongnq
                            if ([10438, 13762, 15693].includes(BSS_B2B.storeId) &&
                                !document.querySelector('#cart_drawer_subtotal .bss-qb-cart-subtotal')) {
                                cartSubtotalEle.insertAdjacentHTML('afterEnd', newCartSubtotalPriceHtml);
                            }
                        }
                    }
                }
                else {
                    if ([2707, 2982].indexOf(BSS_B2B.storeId) === -1) {
                        cartSubtotalPriceSelectors.forEach(cartSubtotalEle => {
                            cartSubtotalEle.style.textDecoration = 'none';
                        });
                    }
                }

                for (let i = 0; i < cartSubtotalPriceSelectors.length; i++) {
                    let cartSubtotalEle = cartSubtotalPriceSelectors[i]
                    if (i > 0 && [15624].includes(BSS_B2B.storeId)) break;
                    if (cartSubtotalEle.querySelector('p, div, span') && ![12291, 13129, 5890, 5980, 5184, 6491, 7319, 8640, 10674, 10808, 11332, 13249, 15624].includes(BSS_B2B.storeId)) {
                        continue;
                    }
                    if ([8640].includes(BSS_B2B.storeId)) {
                        if (BSS_B2B.page.isCartPage()) {
                            if (cartSubtotalEle.closest('#CartDrawerForm')) {
                                continue;
                            }
                            if (cartSubtotalEle.querySelector('span')) {
                                continue;
                            }
                        }
                        else if (cartSubtotalEle.querySelector('div, span')) {
                            continue;
                        }
                    }
                    if (BSS_B2B.storeId == 13129 && isEnableQB && BSS_B2B.page.isCartPage()) {
                        cartSubtotalEle.style.display = "none";
                    }
                    if (cartSubtotalEle.parentNode.querySelector('.bss-qb-cart-subtotal')) {
                        if ([2707, 2982].indexOf(BSS_B2B.storeId) === -1) {
                            let arrayElementSubtotalQb = document.querySelectorAll('.bss-qb-cart-subtotal');
                            for (let i = 0; i < arrayElementSubtotalQb.length; i++) {
                                arrayElementSubtotalQb[i].innerHTML = BSS_B2B.formatMoney(cartSubtotalPrice);
                            }
                        }
                    }
                    else {
                        if (BSS_B2B.storeId === 15111) {
                            cartSubtotalEle.insertAdjacentHTML('afterEnd', `<div style="color: #dc3545!important; font-size: 17px;">Your saved ${BSS_B2B.formatMoney(totalDiscount)}</div>`);
                        }
                        cartSubtotalEle.insertAdjacentHTML('afterEnd', newCartSubtotalPriceHtml);
                        if (BSS_B2B.storeId === 2851) {
                            cartSubtotalEle.parentNode.style.display = 'inline-flex';
                        }

                    }
                    // fix for detecton by Leorio
                    if (BSS_B2B.storeId === 1778) {
                        cartSubtotalEle.style.color = '#ff0505';
                        let subTotalCustom1778 = document.getElementsByClassName('bss-qb-cart-subtotal');
                        if (subTotalCustom1778) {
                            subTotalCustom1778.style.fontWeight = 'bold';
                            subTotalCustom1778.style.fontSize = '18px';
                        }
                    }
                    // fix for karenfrancois by DucDN
                    if (BSS_B2B.storeId == 3903 && isEnableQB && BSS_B2B.page.isCartPage()) {
                        $(".bss-qb-cart-subtotal").css('display', 'block').css('text-align', 'right')
                    }
                }
            }
        }

        if (isEnableMC) {
            // init convert currency function
            BSS_B2B.MC.changeCurrencyCartPageQB();
        }

        $('[bss-b2b-cart-item-key],' + '[bss-b2b-product-id],' + '[bss-b2b-product-qb-id]' + '[bss-b2b-variant-id],' +
            '[bss-b2b-cart-item-key],' + '[bss-b2b-cart-total-price],' + '[bss-b2b-cart-total-discount],' +
            '[data-cart-item-regular-price],' + '[data-cart-subtotal]').css({
                'visibility': 'visible',
            });

        if (shopData && [13129, 1318].includes(BSS_B2B.storeId)) {
            BSS_B2B.handleCartCheckoutBtn(shopData);
        }
        // quy fix for ravigiftboxes.com
        window.BSS_B2B.executeAction({ tag: `qb_customize_price`, storeId: 6808 });
    };

    document.addEventListener('bss_b2b_doneCheckQb', function (evt) {
        if (isEnableBOGO && BSS_B2B.bogoRule && BSS_B2B.bogoRule.length > 0) {
            BSS_B2B.bogo.appliedRuleOnCartPage(evt.detail.shopData, evt.detail.cartData);
        }
    });

    BSS_B2B.qb.generateTableOnCartPage = function (key, qbRuleForCartItem, isAjaxCart) {
        let quantitySelector = BSS_B2B.qb.quantityInputSelectorOnCartPage(key).join(',');
        let elementAppendQBTables = document.querySelectorAll(BSS_B2B.qb.lineItemCssSelector(key));
        if (elementAppendQBTables.length === 0) {
            elementAppendQBTables = document.querySelectorAll(BSS_B2B.qb.defaultLineItemCssSelector(key));
        }
        if (elementAppendQBTables && elementAppendQBTables.length > 0) {
            elementAppendQBTables.forEach(elementAppendQBTable => {
                if (elementAppendQBTable) {
                    if (!elementAppendQBTable.parentNode.querySelector('.bss-b2b-cart-item-qty-table')) {
                        let quantityELe = BSS_B2B.cart.quantityInputSelectorWithKeyItem(key).join(',');
                        let quantityValue = false;

                        if ($(quantityELe).length > 0) {
                            quantityValue = parseInt($(quantityELe).val());
                        }
                        if ([15284].includes(BSS_B2B.storeId)) {
                            quantityValue = parseInt($(quantityELe)[0].size);
                        }
                        // fix skippi-ice-pops.myshopify.com for display qb table when change qty by PhuongKD
                        if ([13819, 15284].includes(BSS_B2B.storeId)) {
                            isAjaxCart = true
                        }
                        if ((isAjaxCart && BSS_B2B.qbSettings.page_show_qb_table.includes('2') &&
                            !BSS_B2B.page.isCartPage()) ||
                            (BSS_B2B.qbSettings.page_show_qb_table.includes('1') && BSS_B2B.page.isCartPage())) {
                            if (isEnabledTD && BSS_B2B.taxDisplayRules && (BSS_B2B.taxDisplayRules.length > 0)) {
                                let itemQB = BSS_B2B.cart.itemsMap.get(key);
                                if (itemQB) {
                                    qbRuleForCartItem.taxable = itemQB.taxable ? itemQB.taxable : false;
                                    qbRuleForCartItem.keyOrId = itemQB.key;
                                }
                            }

                            let qtyTableHtml = '';

                            if (BSS_B2B.storeId === 2851) {
                                // fix for bingltd by Leorio
                                qtyTableHtml = window.BSS_B2B.executeAction({
                                    tag: 'qb_generate_table', storeId: 2851,
                                    appliedRule: qbRuleForCartItem, quantityValue, isEnableMC, isEnabledTD
                                });
                            }
                            else if (BSS_B2B.storeId === 1651) {
                                // fix for must-technologie.myshopify.com by huydt
                                qtyTableHtml = window.BSS_B2B.executeFilter({ tag: 'qb_generate_table', storeId: 1651, val: 1, shopData, appliedRule: qbRuleForCartItem, quantityValue, isEnableMC, isEnabledTD });
                            }
                            else if ([10808].includes(BSS_B2B.storeId)) {
                                // fix for 4caa72-3.myshopify.com by cuongnq
                                qtyTableHtml = window.BSS_B2B.executeAction({
                                    tag: 'qb_generate_table', storeId: 10808, shopData,
                                    appliedRule: qbRuleForCartItem, quantityValue, isEnableMC, isEnabledTD
                                });
                            }
                            else if (BSS_B2B.storeId === 15284) {
                                qtyTableHtml = window.BSS_B2B.executeFilter({ tag: 'qb_generate_table', storeId: 15284, appliedRule: qbRuleForCartItem, quantityValue });
                            }
                            else {
                                qtyTableHtml = BSS_B2B.qb.getQtyTableHtml(qbRuleForCartItem, false, quantityValue,
                                    true);
                            }
                            //fix for knobs-pulls-things by CuongNVM
                            if (BSS_B2B.storeId === 4117) {
                                elementAppendQBTable = document.querySelectorAll(BSS_B2B.qb.lineItemCssSelector(key));
                                if (elementAppendQBTable.length > 0) {
                                    elementAppendQBTable.forEach(function (element) {
                                        element.insertAdjacentHTML('afterend', qtyTableHtml);
                                    });
                                }
                            }
                            else {
                                elementAppendQBTable.insertAdjacentHTML('afterend', qtyTableHtml);
                            }
                            // for compare with nt of Portal by Leorio
                            let event = new Event('bss.b2b.qb.doneCheckQB');
                            document.dispatchEvent(event);
                            // end
                            /**
                             * Click to row, change quantity of line item
                             */
                            if (BSS_B2B.storeId === 2851) {
                                // fix for bingltd by Leorio
                            }
                            else {
                                if (qbRuleForCartItem.rule_setting === 0) {
                                    $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row').
                                        on('click', function (e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (BSS_B2B.qbSettings.max_or_min_qty) $(quantitySelector).
                                                val($(this).attr('data-max')).
                                                trigger('change'); else $(quantitySelector).
                                                    val($(this).attr('data-min')).
                                                    trigger('change');
                                            /**
                                             * Update cart quantity
                                             */
                                            $.post('/cart/change.js', {
                                                quantity: parseInt($(this).attr('data-max')), id: key,
                                            }, 'json').done(function () {
                                                if (BSS_B2B.storeId === 5671) {
                                                    $('form[action*=\'/cart\'].cart-recap').submit();
                                                }
                                                else if (BSS_B2B.storeId === 8446) {
                                                    if (BSS_B2B.page.isCartPage()) {
                                                        $('form[action*=\'/cart\'].cart-form').submit();
                                                    }
                                                    else {
                                                        $('form[action*=\'/cart\'].buy-buttons').submit();
                                                    }
                                                }
                                                else {
                                                    $('form[action*=\'/cart\']#cart').submit();
                                                }
                                            });

                                            $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row').
                                                removeClass('qty-row-active');

                                            if ([8640, 10438].includes(BSS_B2B.storeId)) {
                                                $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row').css({
                                                    'background-color': 'unset', 'color': 'unset',
                                                });

                                                let cartSubtotalPriceElement = BSS_B2B.qb.cartSubtotalPriceElement().
                                                    join(',');
                                                if ($(cartSubtotalPriceElement).length) {
                                                    $(cartSubtotalPriceElement).css('text-decoration', 'none');
                                                    if ($('.bss-qb-cart-subtotal').length) {
                                                        $('.bss-qb-cart-subtotal').remove();
                                                    }
                                                }
                                            }

                                            // fix for vapebase.com.au
                                            if ([9781].includes(BSS_B2B.storeId)) {
                                                $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row').css({
                                                    'background-color': 'unset', 'color': 'unset',
                                                });
                                            }

                                            // fix for tech-wholesalers by Leorio
                                            if (BSS_B2B.storeId === 1746) {
                                                $('.bss-b2b-qty-table-row').css('background-color', '#fff');
                                                $('.bss-b2b-qty-table-row').css('color', '#000');
                                                $(this).css('color', '#fff');
                                                $(this).css({
                                                    'border-color': '#000', 'border-width': '1px', 'border-style': 'solid',
                                                });
                                                $(this).css('background-color', '#03baad');
                                            }
                                            else {
                                                $(this).css({
                                                    'background-color': BSS_B2B.qbSettings.row_hover_background_color,
                                                    'color': BSS_B2B.qbSettings.row_hover_text_color,
                                                });
                                            }

                                            if (BSS_B2B.storeId === 621 && (window.location.pathname.includes('/cart') || (!window.location.pathname.includes('/cart') && isAjaxCart))) {
                                                window.location.reload();
                                            }
                                        });
                                }
                            }
                        }
                    }
                }
            });
        }
    };

    BSS_B2B.qb.settingTableQBOrAB = function () {
        let styles = `
            .bss-b2b-cart-item-qty-table-header {` +

            `background-color:` + BSS_B2B.designTables.header_table_background + `;` + `color:` +
            BSS_B2B.designTables.text_header_table_color + `;` + `width: 100%;` + `display: flex;` + `width: 100%;` +
            `border-top-right-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` +
            `border-top-left-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` + `text-align:` +
            BSS_B2B.designTables.text_align_herder_table + `;` + `font-size:` + BSS_B2B.designTables.header_text_size +
            'px' + `;` + `padding:` + BSS_B2B.designTables.config_inner_padding_text_header + 'px' + `;` +
            `border-style:` + BSS_B2B.designTables.border_style_table + `;` + `border-width:` +
            BSS_B2B.designTables.border_width_table + 'px' + `;` + `border-color:` +
            BSS_B2B.designTables.border_color_table + `;` + `}` + `.bss-b2b-qty-table-wrapper {` + `background-color:` +
            BSS_B2B.designTables.table_background_color + `;` + `color:` + BSS_B2B.designTables.text_table_color + `;` +
            `border-bottom-right-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` +
            `border-bottom-left-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` + `border-style:` +
            BSS_B2B.designTables.border_style_table + `;` + `border-width:` + BSS_B2B.designTables.border_width_table +
            'px' + `;` + `border-color:` + BSS_B2B.designTables.border_color_table + `;` + `}` +
            `.bss-b2b-qty-table-wrapper th {` + `background:` + BSS_B2B.designTables.title_table_background +
            ` !important;` + `color:` + BSS_B2B.designTables.text_title_table_color + `;` + `border:` +
            BSS_B2B.designTables.border_width_table + 'px' + ' ' + BSS_B2B.designTables.border_style_table + ' ' +
            BSS_B2B.designTables.border_color_table + `;` + `}` + `.cart-items th {
                text-align: center !important;
            }` + `.bss-b2b-cart-item-qty-table table td {` + `border:` + BSS_B2B.designTables.border_width_table +
            'px' + ' ' + BSS_B2B.designTables.border_style_table + ' ' + BSS_B2B.designTables.border_color_table + `;` +
            `}` + `.bss-b2b-qty-table-row.qty-row-active {` + `background-color:` +
            BSS_B2B.designTables.row_click_background_color + `;` + `color:` +
            BSS_B2B.designTables.row_click_text_color + `;` + `border-color:` +
            BSS_B2B.designTables.row_click_text_color + `;` + `}` +
            `.bss-b2b-qty-table-row:not(.qty-row-active):not(:hover) {` + `background-color:` +
            BSS_B2B.designTables.table_background_color + `;` + `color:` + BSS_B2B.designTables.text_table_color + `;` +
            `}` + `.bss-b2b-qty-table-wrapper thead, .bss-b2b-qty-table-wrapper tbody {
                display: table-row-group !important;
            }` + `.bss-b2b-qty-table-wrapper tr {
                display: table-row !important;
            }` + `.border-radius-right-table-qb {` + `border-bottom-right-radius:` +
            BSS_B2B.designTables.border_radius_table + 'px' + `;` + `}` + `.bss-b2b-qty-table-wrapper {` +
            `border-bottom-right-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` +
            `border-bottom-left-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` + `}` +
            `.border-radius-left-table-qb {` + `border-bottom-left-radius:` + BSS_B2B.designTables.border_radius_table +
            'px' + `;` + `}` + `.border-radius-left-right-table-qb {` + `border-bottom-left-radius:` +
            BSS_B2B.designTables.border_radius_table + 'px' + `;` + `}` + `.bss-b2b-cart-item-qty-table table {` +
            `border-bottom-right-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` +
            `border-bottom-left-radius:` + BSS_B2B.designTables.border_radius_table + 'px' + `;` + `}` + `.bss-b2b-cart-item-qty-table table {
                border-spacing: inherit !important;
            }`;

        let styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);
    };

    BSS_B2B.qb.defineValueOfQBPricing = function (
        item, value, discountType, discountValue, appliedTableRowId, totalValue) {
        return {
            'id': item.id,
            'discount_type': discountType,
            'discount_value': discountValue,
            'price': item.price,
            'quantity': item.quantity,
            'key': item.key,
            'qty_table': value.qty_table ? value.qty_table : false,
            'amount_table': value.amount_table ? value.amount_table : false,
            'rule_setting': value.rule_setting,
            'index': item.index,
            'taxable': item.taxable,
            'product_id': item.product_id,
            'properties': item.properties,
            'selling_plan_allocation': item.selling_plan_allocation,
            'rule_type': value.rule_type,
            'rule_id': value.id,
            'sid': `${value.token}.${Buffer.from(`${item.key}-${totalValue}-${appliedTableRowId}`).toString('base64')}`,
        };
    };

    if (window.location.pathname === '/apps/customer-portal/quick-order') {
        document.addEventListener('bss.bcp.qo.doneLoadingPrice', function () {
            $('.bss-b2b-up-down-qb-btn').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if ($(this).text() === 'â†“') {
                    $(this).html(`â†‘`);
                }
                else if ($(this).text() === 'â†‘') {
                    $(this).html(`â†“`);
                }
                $(this).closest('.bss-b2b-cart-item-qty-table').find('.bss-b2b-qty-table-wrapper').toggle();
            });
            if (BSS_B2B.storeId === 11917) {
                $('.bss-b2b-up-down-qb-btn').trigger('click');
            }
        });
    }

    BSS_B2B.qb.handleRunQbOnQuickView = function () {
        let showQuickView = setInterval(function () {
            let buttonShowQuickViewElement = BSS_B2B.qb.buttonShowQuickViewElement;
            if (buttonShowQuickViewElement.length > 0) {
                clearInterval(showQuickView);
                Object(_cp_quickview__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])($, BSS_B2B, shopData);
                buttonShowQuickViewElement.on('click', async function () {
                    let productId = $(this).attr('bss-b2b-product-qb-id');
                    if (!productId) {
                        productId = $(this).attr('id').match(/grid(\d+)/)[1];
                    }
                    let data = await BSS_B2B.qb.getProductById(productId);
                    shopData.product = data;

                    let waitQuickView = setInterval(function () {
                        const quickViewEle = $(
                            'div[id^="QuickAddInfo"]:has(> .product), .modal[data-modal-container], loess-modal-product .modal__inner form[action*="/cart/add"] .bss-b2b-qb-table-on-quick-view');
                        if (quickViewEle.length > 0) {
                            BSS_B2B.qb.generateTableOnQuickView();
                            clearInterval(waitQuickView);
                            BSS_B2B.handleAjaxCart();
                        }
                    }, 500);

                    setTimeout(function () {
                        clearInterval(waitQuickView);
                    }, 5000);
                });
            }
        }, 500);
        setTimeout(function () {
            clearInterval(showQuickView);
        }, 5000);
    };

    BSS_B2B.qb.handlePositionQbTableOnProductPage = function (postitionQbTableSelector, positionQBTable, qtyTableHtml) {
        if (BSS_B2B.qbSettings.position_qb_table === '0') {
            let productTitleSelector = BSS_B2B.qb.productTitleSelectorOnProductPage.join(',');
            let productTitle = document.querySelector(productTitleSelector);
            if (BSS_B2B.storeId === 15856) {
                productTitle = document.querySelector('.product__info > .product-general-info-block')
            }
            if (productTitle) {
                productTitle.insertAdjacentHTML('afterend', qtyTableHtml);
            }
        }
        else {
            let quantitySelector = BSS_B2B.qb.quantityInputSelectorOnProductPage.join(',');
            const quantityInput = document.querySelector(quantitySelector);

            if (BSS_B2B.storeId == 10941) {
                quantitySelector = $(".selector-wrapper");
                quantitySelector.after(qtyTableHtml);;
            } else if (BSS_B2B.storeId == 1651) {
                quantitySelector = document.querySelector(".product-form__add-button");
                quantitySelector.parentNode.parentNode.insertAdjacentHTML('afterend', qtyTableHtml);
            } else if (BSS_B2B.storeId == 13422) {
                quantitySelector = document.querySelector("product-form .productView-group");
                quantitySelector.parentNode.parentNode.insertAdjacentHTML('afterend', qtyTableHtml);
            } else if (BSS_B2B.qbSettings.position_qb_table === '2') {
                quantityInput.parentNode.parentNode.insertAdjacentHTML('beforebegin', qtyTableHtml);
            }
            else if (BSS_B2B.qbSettings.position_qb_table === '3') {
                quantityInput.parentNode.parentNode.insertAdjacentHTML('afterend', qtyTableHtml);
            }
            else {
                postitionQbTableSelector.insertAdjacentHTML(positionQBTable, qtyTableHtml);
            }
        }
    };
}



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateTableOnFeatureProduct; });
function generateTableOnFeatureProduct(BSS_B2B, shopData, isEnabledTD) {
    BSS_B2B.qb.getItemIdOnFeatureProduct = async () => {
        const productIds = document.querySelectorAll(".featured-product [bss-b2b-qb-featured-product-id]");
        if (productIds.length > 0) {
            let handles = new Map();
            let handleURLs = [];
            let productId = [];
            let sectionId = new Map();
            for (let i = 0; i < productIds.length; i++) {
                let elementProductId = $(productIds[i]).attr('bss-b2b-qb-featured-product-id');
                let elementSectionId = $(productIds[i]).attr('bss-b2b-section-id');
                sectionId.set(elementSectionId, productIds[i])
                if (elementProductId && elementProductId !== "" && !handles.has(elementProductId)) {
                    handles.set(elementProductId, productIds[i]);
                    handleURLs.push('id:"' + elementProductId + '"');
                    productId.push(parseInt(elementProductId));
                }
            }
            const urlData = "/search?q=" + handleURLs.join(" OR ") + "&view=bss.b2b";
            const encodeUrlData = encodeURI(urlData);
            let data = await fetch(encodeUrlData);
            let featureProducts = await data.json();
            return {
                products: featureProducts,
                handles,
                sectionId
            }
        }
        return null;
    }

    BSS_B2B.qb.getAppliedRuleOnFeatureProduct = (products) => {
        let productAppliedAllQbRules = new Map();
        let customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }

        BSS_B2B.qbRules.forEach(function (rule) {
            let checkCustomer = BSS_B2B.qb.checkCustomer(rule, customer);
            if (checkCustomer) {
                return;
            }
            products.forEach((product) => {
                let collections = product.collections;
                let tags = product.tags;
                let productId = product.id;
                let appliedQbRule = false;
                appliedQbRule = BSS_B2B.qb.filterRule(rule, productId, collections, tags);

                if (appliedQbRule) {
                    if (productAppliedAllQbRules.has(product.id)) {
                        let appliedRules = productAppliedAllQbRules.get(product.id);
                        if (Array.isArray(appliedRules)) {
                            productAppliedAllQbRules.set(product.id, [...appliedRules, rule]);
                        } else {
                            productAppliedAllQbRules.set(product.id, [appliedRules, rule]);
                        }
                    } else {
                        productAppliedAllQbRules.set(product.id, JSON.parse(JSON.stringify(appliedQbRule)));
                    }

                    if (
                        isEnabledTD &&
                        BSS_B2B.taxDisplayRules &&
                        BSS_B2B.taxDisplayRules.length > 0 &&
                        document.querySelectorAll(".featured-product")
                    ) {
                        let appliedRulesAfterTax = productAppliedAllQbRules.get(product.id);
                        if (Array.isArray(appliedRulesAfterTax)) {
                            appliedRulesAfterTax.forEach(rule => rule.taxable = true);
                        } else {
                            appliedRulesAfterTax.taxable = true;
                        }
                        productAppliedAllQbRules.set(product.id, appliedRulesAfterTax);
                    }
                }
            });
        });

        if (productAppliedAllQbRules.size > 0) {
            const productAfterUseCP = BSS_B2B.cp.productAfterUseCP;
            let productIdAfterUseCP = [];
            productAfterUseCP.map((item) => {
                if (productAppliedAllQbRules.has(item.id)) {
                    productIdAfterUseCP.push(item.id);
                    let appliedRule = productAppliedAllQbRules.get(item.id);
                    if (Array.isArray(appliedRule)) {
                        appliedRule.forEach(rule => rule.price = item.price);
                    } else {
                        appliedRule.price = item.price;
                    }
                    productAppliedAllQbRules.set(item.id, appliedRule);
                }
            });

            products.map((item) => {
                if (!productIdAfterUseCP.includes(item.id) && productAppliedAllQbRules.has(item.id)) {
                    let appliedRule = productAppliedAllQbRules.get(item.id);
                    if (Array.isArray(appliedRule)) {
                        appliedRule.forEach(rule => rule.price = item.price);
                    } else {
                        appliedRule.price = item.price;
                    }
                    productAppliedAllQbRules.set(item.id, appliedRule);
                }
            });
        }
        return {
            appliedAllRules: productAppliedAllQbRules
        };
    }

    BSS_B2B.qb.generateTableOnFeatureProduct = async () => {
        const buttonChangeQuantityElement = [
            '[bss-b2b-qb-featured-product-id] button[name="plus"].quantity__button',
            '[bss-b2b-qb-featured-product-id] button[name="minus"].quantity__button',
            '[bss-b2b-qb-featured-product-id] form[action="/cart/add"] .qtyminus',
            '[bss-b2b-qb-featured-product-id] form[action="/cart/add"] .qtyplus'
        ];
        const variantSelector = [
            '[bss-b2b-qb-featured-product-id] variant-radios.no-js-hidden .product-form__input label'
        ];
        const featureProducts = await BSS_B2B.qb.getItemIdOnFeatureProduct();
        if (featureProducts === null) {
            return;
        }
        const { products, handles, sectionId } = featureProducts;
        if (products && products.length > 0) {
            let appliedRule = {};
            const { appliedAllRules } = BSS_B2B.qb.getAppliedRuleOnFeatureProduct(products);
            const applyMultipleRule = BSS_B2B.qbSettings.show_multiple_table ? BSS_B2B.qbSettings.show_multiple_table : 0;
            products.map(item => {
                let tableQB = "";
                let quantityValue = false;
                let timeDelayShowTable = BSS_B2B.page.isProductPage() ? 500 : 0;

                const idProduct = handles.get(item.id + "");
                const elementFeature = document.querySelector(`.featured-product [bss-b2b-qb-featured-product-id="${item.id}"]`);
                const quantitySelector = BSS_B2B.qb.quantityInputSelectorOnProductPage.join(",");
                const buttonChangeQuantity = $(buttonChangeQuantityElement.join(","));
                const variantElement = $(variantSelector.join(","));
                const inputQuantityElement = elementFeature.querySelector(quantitySelector);

                if (applyMultipleRule) {
                    appliedRule = appliedAllRules.get(item.id);
                } else {
                    let allRuleChoices = appliedAllRules.get(item.id);
                    if (Array.isArray(allRuleChoices)) {
                        let ruleChoice = allRuleChoices[0];
                        for (let i = 1; i < allRuleChoices.length; i++) {
                            let currentRule = allRuleChoices[i];
                            if (ruleChoice.priority > currentRule.priority) {
                                ruleChoice = currentRule;
                            } else if (ruleChoice.priority === currentRule.priority) {
                                if (Date.parse(ruleChoice.createdAt) > Date.parse(currentRule.createdAt)) {
                                    ruleChoice = currentRule;
                                }
                            }
                        }
                        appliedRule = ruleChoice;
                    } else {
                        appliedRule = allRuleChoices;
                    }
                }
                if (variantElement.length > 0 && idProduct) {
                    for (let i = 0; i < variantElement.length; i++) {
                        const variantItem = variantElement[i];
                        if (!$(variantItem).attr("bss-qb-featured-product-change-variant-event")) {
                            $(variantItem).on("click", (e) => {
                                $(variantItem).attr("bss-qb-featured-product-change-variant-event", true);
                                const elementVariantParent = $(e.target.parentElement);
                                const idSection = elementVariantParent.closest('[bss-b2b-qb-featured-product-id]').attr('bss-b2b-section-id');
                                if (idSection) {
                                    quantityValue = parseInt(inputQuantityElement.value);
                                    if (applyMultipleRule) {
                                        let multipleQBTable = [];
                                        appliedRule.map(rule => {
                                            multipleQBTable.push(BSS_B2B.qb.getQtyTableHtml(rule, true, quantityValue));
                                        });
                                        tableQB = multipleQBTable;
                                    } else {
                                        tableQB = BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue);
                                    }
                                    setTimeout(() => {
                                        showTableQB(BSS_B2B, tableQB, isEnabledTD, idProduct, item.id, false, idSection);
                                        if (!appliedRule.rule_setting) {
                                            changeCurrentRow(item.id, quantitySelector, 500, appliedRule, sectionId);
                                        }
                                    }, 1000);
                                }
                            });
                        }
                    }
                }
                if (buttonChangeQuantity.length > 0 && idProduct) {
                    changeQtyInputFeaturedProduct(BSS_B2B, quantitySelector, sectionId, appliedRule, item.id);
                }
                if (appliedRule && !appliedRule.rule_setting) {
                    changeCurrentRow(item.id, quantitySelector, 2000 + timeDelayShowTable, appliedRule, sectionId);
                }

                if ($(inputQuantityElement).length > 0) {
                    quantityValue = parseInt($(inputQuantityElement).val());
                }
                if (appliedRule) {
                    if (applyMultipleRule) {
                        let multipleQBTable = [];
                        if (Array.isArray(appliedRule)) {
                            appliedRule.map(rule => {
                                multipleQBTable.push(BSS_B2B.qb.getQtyTableHtml(rule, true, quantityValue));
                            });
                        } else {
                            multipleQBTable.push(BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue));
                        }
                        tableQB = multipleQBTable;
                    } else {
                        tableQB = BSS_B2B.qb.getQtyTableHtml(appliedRule, true, quantityValue);
                    }
                }
                if (idProduct) {
                    showTableQB(BSS_B2B, tableQB, isEnabledTD, idProduct, item.id, true);
                }
            });
        }
    }
}

const changeQtyInputFeaturedProduct = (BSS_B2B, quantitySelector, sectionId, rule, id) => {
    const inputQuantityElement = `[bss-b2b-qb-featured-product-id=${id}] ` + BSS_B2B.qb.quantityInputSelectorOnProductPage.join(`, [bss-b2b-qb-featured-product-id=${id}] `);
    if (!$(inputQuantityElement).attr("bss-qb-featured-product-change-quantity-event")) {
        $(inputQuantityElement).on("change", (e) => {
            e.preventDefault();
            const elementChangeQty = $(e.target.parentElement);
            const elementInputQty = elementChangeQty.find('input[type="number"]');
            elementInputQty.attr("bss-qb-featured-product-change-quantity-event", true)
            const newEle = elementChangeQty.closest('[bss-b2b-qb-featured-product-id]').attr('bss-b2b-section-id');
            if (newEle) {
                const productFeaturedInfo = sectionId.get(newEle);
                const quantityValue = parseInt(productFeaturedInfo.querySelector(quantitySelector).value);
                const newElementRowTable = productFeaturedInfo.querySelectorAll('.bss-b2b-qty-table-row');
                if (newElementRowTable.length > 0) {
                    newElementRowTable.forEach(element => {
                        element.classList.remove("qty-row-active");
                    });
                    if (!rule.rule_setting) {
                        newElementRowTable.forEach(element => {
                            const dataMin = parseInt(element.getAttribute("data-min"));
                            const dataMax = parseInt(element.getAttribute("data-max"));
                            if (dataMin <= quantityValue && dataMax >= quantityValue) {
                                element.classList.add("qty-row-active");
                            }
                        });
                    }
                }
            }
        });
    }
}

const changeCurrentRow = (idProduct, quantitySelector, timeDelay, rule, sectionId) => {
    setTimeout(() => {
        $(`.featured-product [bss-b2b-qb-featured-product-id="${idProduct}"] .bss-b2b-cart-item-qty-table .bss-b2b-qty-table-row`).on("click", (e) => {
            e.preventDefault();
            const elementRowTable = $(e.target.parentElement);
            const newEle = elementRowTable.closest('[bss-b2b-qb-featured-product-id]').attr('bss-b2b-section-id');
            if (newEle) {
                const productFeaturedInfo = sectionId.get(newEle);
                const newElementRowTable = productFeaturedInfo.querySelectorAll('.bss-b2b-qty-table-row');
                if (newElementRowTable.length > 1) {
                    newElementRowTable.forEach(element => {
                        element.classList.remove("qty-row-active");
                    });
                }
                const dataMaxQuantity = elementRowTable.attr('data-max');
                if (!rule.rule_setting) {
                    const inputQuantityElement = productFeaturedInfo.querySelector(quantitySelector);
                    inputQuantityElement.value = dataMaxQuantity;
                }
                elementRowTable.addClass('qty-row-active');
            }
        });
    }, timeDelay);
}

const showTableQB = (BSS_B2B, tableQB, isEnabledTD, idProduct, id, isFirstLoad, idSection = "") => {
    if (isFirstLoad) {
        let selectorProductsFeature = `.featured-product [bss-b2b-qb-featured-product-id="${id}"] .price-item`;
        if(BSS_B2B.storeId === 12500) {
            selectorProductsFeature = `.featured-product [bss-b2b-qb-featured-product-id="${id}"]`;
        }
        let elementProductsFeature = document.querySelectorAll(selectorProductsFeature);
        if (elementProductsFeature.length > 0) {
            elementProductsFeature.forEach((element) => {
                let _element = element.closest(`.featured-product`);
                if (idSection) {
                    _element = element.closest(`[bss-b2b-section-id="${idSection}"] .featured-product `);
                }
                generateTable(BSS_B2B, isEnabledTD, tableQB, _element);
            })
        }
    } else {
        let elementProductFeature = document.querySelector(`.featured-product [bss-b2b-qb-featured-product-id="${id}"] .price-item`).closest('.featured-product');
        if (elementProductFeature) {
            if (idSection) {
                elementProductFeature = document.querySelector(`.featured-product [bss-b2b-qb-featured-product-id="${id}"][bss-b2b-section-id="${idSection}"] .price-item`).closest('.featured-product');
            }
            generateTable(BSS_B2B, isEnabledTD, tableQB, elementProductFeature);
        }
    }
}

const generateTable = (BSS_B2B, isEnabledTD, tableQB, elementProductFeature) => {
    if (elementProductFeature.querySelector('.bss-b2b-cart-item-qty-table')) {
        elementProductFeature.querySelectorAll('.bss-b2b-cart-item-qty-table').forEach(item => item.remove());
    }
    const elementPriceVat = elementProductFeature.querySelector('form[action*="/cart/add"] .bss-b2b-product-vat');
    const elementQty = elementProductFeature.querySelector(".product-form__quantity");
    const elementAppendTableSelector = elementProductFeature.querySelector('form[action*="/cart/add"] .bss-b2b-qb-table');
    const applyMultipleRule = BSS_B2B.qbSettings.show_multiple_table ? BSS_B2B.qbSettings.show_multiple_table : 0;

    if (elementPriceVat && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length && isEnabledTD && !elementAppendTableSelector) {
        if (applyMultipleRule) {
            tableQB.map(table => elementPriceVat.insertAdjacentHTML('afterend', table));
        } else {
            elementPriceVat.insertAdjacentHTML('afterend', tableQB);
        }
        if (elementQty) {
            const elementQbTable = document.getElementsByClassName("bss-b2b-cart-item-qty-table");
            elementQbTable[elementQbTable.length - 1].insertAdjacentElement('beforeend', elementQty);
        }
    } else {
        const elementPrice = elementProductFeature.querySelector(".price");
        if (applyMultipleRule) {
            tableQB.map(table => elementPrice.insertAdjacentHTML('afterend', table));
        } else {
            elementPrice.insertAdjacentHTML('afterend', tableQB);
        }
    }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateTableOnCollectionPage; });
function addCSS(css) {
    const cssFile = document.head.appendChild(document.createElement("style"));
    cssFile.innerHTML = css;
    return cssFile;
}
function delayFn(fn, delay) {
    let timer;
    return function (...args) {
        const context = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}
function getElementHeight(el) {
    let height = el.offsetHeight;
    const style = window.getComputedStyle(el);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
}

function getNumPerRow(selector) {
    let itemList = document.querySelector(selector);
    if (itemList !== null) {
        itemList = itemList.children;
    } else {
        return null;
    }
    const grid = Array.from(itemList);
    const baseOffset = grid[0].offsetTop;
    const breakIndex = grid.findIndex((item) => item.offsetTop > baseOffset);
    return breakIndex === -1 ? grid.length : breakIndex;
}
function setHeightForItemInRow(
    listSelector,
    tableFillBottomSpaceSelector,
    productFillSpaceSelector,
    tableFillTopSpaceSelector
) {
    const numPerRow = getNumPerRow(listSelector);
    if (numPerRow === null) {
        return;
    }
    const items = document.querySelector(listSelector).children;
    const itemNum = items.length;
    let maxTableHeight = 0;
    const heightMap = {};
    let startRowIndex;
    for (let itemIndex = 0; itemIndex < itemNum; itemIndex++) {
        const qbTable = items[itemIndex].querySelector(".bss-b2b-cart-item-qty-table");
        const posInRow = itemIndex % numPerRow;
        if (qbTable) {
            const eleFillTableBottomSpace = items[itemIndex].querySelector(tableFillBottomSpaceSelector);
            const eleFillTableTopSpace = items[itemIndex].querySelector(tableFillTopSpaceSelector);
            if (eleFillTableBottomSpace) {
                eleFillTableBottomSpace.style.height = "0px";
            }
            if (eleFillTableTopSpace) {
                eleFillTableTopSpace.style.height = "0px";
            }
        } else {
            const productFillSpace = items[itemIndex].querySelector(productFillSpaceSelector);
            if (productFillSpace) {
                productFillSpace.style.height = "0px";
            }
        }
        const qbTableHeight = qbTable ? getElementHeight(qbTable) : 0;
        heightMap[itemIndex] = {
            productCardHeight: getElementHeight(items[itemIndex]),
            tableHeight: qbTableHeight,
        };
        if (posInRow !== 0) {
            if (qbTableHeight > maxTableHeight) {
                maxTableHeight = qbTableHeight;
            }
        }
        if (posInRow === 0) {
            maxTableHeight = qbTableHeight;
            startRowIndex = itemIndex;
        } else if (posInRow === numPerRow - 1) {
            let maxProductCardHeight = -Infinity;
            for (let itemIndexInRow = startRowIndex; itemIndexInRow <= itemIndex; itemIndexInRow++) {
                if (heightMap[itemIndexInRow].tableHeight > 0) {
                    const eleFillTableBottomSpace = items[itemIndexInRow].querySelector(tableFillBottomSpaceSelector);
                    if (eleFillTableBottomSpace) {
                        if (heightMap[itemIndexInRow].tableHeight < maxTableHeight) {
                            eleFillTableBottomSpace.style.height = `${
                                maxTableHeight - heightMap[itemIndexInRow].tableHeight
                            }px`;
                        }
                        const productCardHeight = heightMap[itemIndexInRow].productCardHeight;
                        if (productCardHeight > maxProductCardHeight) {
                            maxProductCardHeight = productCardHeight;
                        }
                    }
                } else {
                    const productFillSpace = items[itemIndexInRow].querySelector(productFillSpaceSelector);
                    if (productFillSpace) {
                        productFillSpace.style.height = maxTableHeight + "px";
                    }
                }
            }
            if (maxProductCardHeight > -Infinity) {
                for (let itemIndexInRow = startRowIndex; itemIndexInRow <= itemIndex; itemIndexInRow++) {
                    if (heightMap[itemIndexInRow].productCardHeight) {
                        if (heightMap[itemIndexInRow].productCardHeight < maxProductCardHeight) {
                            const eleFillTableTopSpace = items[itemIndexInRow].querySelector(tableFillTopSpaceSelector);
                            if (eleFillTableTopSpace) {
                                eleFillTableTopSpace.style.height = `${
                                    maxProductCardHeight - heightMap[itemIndexInRow].productCardHeight
                                }px`;
                            }
                        }
                    }
                }
            }
        }
    }
}
const cssText = `.bss-b2b-qty-table-wrapper {
    overflow-x: auto;
}
.bss-b2b-qty-table-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.bss-b2b-qty-table-wrapper::-webkit-scrollbar-track {
    border-radius: 8px;
    background: rgba(0,0,0,0.1);
}
.bss-b2b-qty-table-wrapper::-webkit-scrollbar-thumb{
    border-radius: 8px;
    background: rgba(0,0,0,0.2);
}
.bss-b2b-qty-table-wrapper::-webkit-scrollbar-thumb:hover {
      background: rgba(0,0,0,0.4);
}
.bss-b2b-qty-table-wrapper::-webkit-scrollbar-thumb:active {
      background: rgba(0,0,0,.9);
}
#product-grid li,
#product-grid .product-item,
.grid.grid--uniform.grid--view-items li,
.grid.grid--uniform.grid--view-items .product-item,
.featured-collections__products li,
.featured-collections__products .product-item,
.collection-grid li,
.collection-grid .product-item,
.grid--uniform li,
.grid--uniform .product-item,
.grid-uniform li,
.grid-uniform .product-item {
    display: flex; 
    flex-direction: column;
}
.card-wrapper, .product-card { 
    flex-grow:1;
    height: auto !important;
    min-height: auto !important; 
}
.product-card.grid-view-item {
    margin: 0 0 35px 0; 
}
.BSS_fill_table_bottom_space, .BSS_fill_table_top_space, .BSS_fill_item_space { 
        display:block !important; 
}
.bss-b2b-cart-item-qty-table{
    font-size: 1.1rem;
}
.bss-b2b-cart-item-qty-table table {
    font-size: 1.1rem;
}
.bss-b2b-cart-item-qty-table-header-title > span {
    font-size:1.2rem !important;
}
@media only screen and (max-width: 600px) {
    .bss-b2b-cart-item-qty-table{
      font-size: 9.5px;
    }
    .bss-b2b-cart-item-qty-table table {
        font-size: 9.5px;
    }
    .bss-b2b-cart-item-qty-table-header-title > span {
        font-size:0.8rem !important;
    }
}
@media only screen and (max-width: 950px) {
    .bss-b2b-cart-item-qty-table {
        font-size: 11.5px;
    }
    .bss-b2b-cart-item-qty-table table {
        font-size: 11.5px;
    }
    .bss-b2b-cart-item-qty-table-header-title > span {
        font-size:1rem !important;
    }
}
`;
function generateTableOnCollectionPage(BSS_B2B, shopData, isEnabledTD) {
    BSS_B2B.qb.getItemsIdOnCollectionPage = async () => {
        let productIdArray = Array.from(document.querySelectorAll("[bss-b2b-product-qb-id],[bss-b2b-product-id]"));
        productIdArray = window.BSS_B2B.executeFilter({tag: "qb_design_table", storeId: 13534, val: productIdArray});
        if (productIdArray.length > 0) {
            const isDuplicated = {};
            const itemsId = [];
            const idElements = new Map();
            for (let i = 0; i < productIdArray.length; i++) {
                let productId =
                    productIdArray[i].getAttribute("bss-b2b-product-qb-id") ||
                    productIdArray[i].getAttribute("bss-b2b-product-id");
                if (isDuplicated[productId] || productId === "" || !productId) {
                    continue;
                } else {
                    itemsId.push("id:" + '"' + productId + '"');
                    idElements.set(productId, productIdArray[i]);
                    isDuplicated[productId] = true;
                }
            }
            if (itemsId.length > 0) {
                const urlData = "/search?q=" + itemsId.join(" OR ") + "&view=bss.b2b";
                const encodeUrlData = encodeURI(urlData);
                let data = await fetch(encodeUrlData);
                data = await data.json();
                let productSearch = [];
                data.map(item => productSearch.push(item.id));

                if ([8640].includes(BSS_B2B.storeId)) {
                    const productsHasMetaField = BSS_B2B.getProductMetaField();
                    productsHasMetaField.map(item => {
                        if (!productSearch.includes(item.id)) {
                            data.push(item);
                        }
                    });
                }

                if (data) {
                    return { itemDetails: data, itemElements: idElements };
                }
            }
        }
        return null;
    };

    BSS_B2B.qb.getAppliedRuleOnCollectionPage = function (products) {
        // firstly, sort by priority if priorities are equal => sort by id
        const customer = shopData.customer;
        if (customer.id != null && customer.tags != null) {
            customer.tags = customer.tags.map((tag) => tag.toLowerCase());
        }
        // finalAppliedQbRule map for all product on the collection page
        const finalAppliedQbRule = new Map();
        // iterating through rules list
        BSS_B2B.qbRules.forEach(function (rule) {
            const applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let customerTags = rule.customer_tags;
            let excludeCustomerTags = rule.exc_customer_tags;
            const excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let exclude_customers= rule.exc_customers;
    
            if (excludeFrom === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.split(",").map((tag) => tag.toLowerCase());
                    const checkArray = excludeCustomerTags.filter((tag) => customer.tags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        return;
                    }
                }
               
            }
            else if( excludeFrom === 2) {
                if(exclude_customers) {
                    if(exclude_customers.includes(`${customer.id}`)) {
                        return true;
                    }
                }
            }

            if (applyTo === 0) {
                // do nothing
            } else if (applyTo === 1) {
                if (customer.id == null) {
                    return;
                }
            } else if (applyTo === 2) {
                if (customer.id !== null) {
                    return;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return;
                } else {
                    customerIds = customerIds.split(",");
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return;
                    }
                }
            } else if (applyTo === 4) {
                if (customer.tags === null) {
                    return;
                } else {
                    customerTags = customerTags.split(",").map((tag) => tag.toLowerCase().trim());
                    let tagsOfCustomer = customer.tags.map((tag) => {
                        return tag.toLowerCase().trim();
                    });
                    let checkArray = customerTags.filter((tag) => tagsOfCustomer.includes(tag));
                    if (checkArray.length === 0) {
                        return;
                    }
                }
            }
            //if this rule can be applied to this customer
            const conditionType = rule.product_condition_type;
            const ruleTags = rule.product_tags ? rule.product_tags.split(",") : [];
            const specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            const ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            products.forEach((product) => {
                let appliedQbRule = false;
                if (finalAppliedQbRule.has(product.id)) {
                    return;
                }
                const collections = product.collections;
                const tags = product.tags;
                const productId = product.id;
                if (conditionType === 0) {
                    appliedQbRule = rule;
                } else if (conditionType === 1) {
                    if (specificProductIds.indexOf(productId + "") !== -1) {
                        appliedQbRule = rule;
                    }
                } else if (conditionType === 2) {
                    let checkArray = collections.filter((collection) => ruleCollectionIds.includes(collection + ""));
                    if (checkArray.length > 0) {
                        appliedQbRule = rule;
                    }
                } else if (conditionType === 3) {
                    let checkArray = [];
                    ruleTags.forEach((tag) => {
                        tags.forEach((productTag) => {
                            if (productTag.toLowerCase().trim() === tag.toLowerCase().trim()) {
                                checkArray.push(productTag.toLowerCase());
                            }
                        });
                    });
                    if (checkArray.length > 0) {
                        appliedQbRule = rule;
                    }
                }
                // if appliedQbRule isn't false => binding to the productId (deep clone)
                if (appliedQbRule) {
                    finalAppliedQbRule.set(product.id, JSON.parse(JSON.stringify(appliedQbRule)));
                    if (
                        isEnabledTD &&
                        BSS_B2B.taxDisplayRules &&
                        BSS_B2B.taxDisplayRules.length > 0 &&
                        BSS_B2B.page.isCollectionPage()
                    ) {
                        const appliedRule = finalAppliedQbRule.get(product.id);
                        appliedRule.taxable = true;
                        finalAppliedQbRule.set(product.id, appliedRule);
                    }
                }
            });
        });

        if (finalAppliedQbRule.size > 0) {
            // get all price after use Cp
            const productAfterUseCP = BSS_B2B.cp.productAfterUseCP;
            // applying that price to the product's rule which has same productId as productId in cprule
            const usedIds = [];
            productAfterUseCP.forEach((item) => {
                if (finalAppliedQbRule.has(item.id)) {
                    usedIds.push(item.id);
                    const appliedRule = finalAppliedQbRule.get(item.id);
                    appliedRule.price = item.price;
                    finalAppliedQbRule.set(item.id, appliedRule);
                }
            });
            // applying original price to the other products
            products.forEach((product) => {
                if (!usedIds.includes(product.id)) {
                    if (finalAppliedQbRule.has(product.id)) {
                        const appliedRule = finalAppliedQbRule.get(product.id);
                        appliedRule.price = product.price;
                        finalAppliedQbRule.set(product.id, appliedRule);
                    }
                }
            });
            BSS_B2B.qb.appliedQbRuleForCollectionProduct = Array.from(finalAppliedQbRule, ([key, value]) => ({collectionProductId: key, rule: value}));
        }
        return finalAppliedQbRule;
    };

    BSS_B2B.qb.generateTableOnCollectionPage = async () => {
        let isQbTableOnCollection = false;
        const itemsOnPage = await BSS_B2B.qb.getItemsIdOnCollectionPage();
        if (itemsOnPage === null) {
            return;
        }
        const { itemDetails, itemElements } = itemsOnPage;

        if (itemDetails && itemDetails.length > 0) {
            const appliedRules = BSS_B2B.qb.getAppliedRuleOnCollectionPage(itemDetails);
            const productCardSelector = "li," + ".product-item," + ".grid__item," + ".grid-item," + ".grid > .card," + ".max-w-full.block.w-full";
            //get item card on page and generate table
            itemDetails.forEach((item) => {
                let table = "";
                const id = item.id;
                if (appliedRules.has(id)) {
                    table = BSS_B2B.qb.getQtyTableHtml(appliedRules.get(id), true, false);
                    isQbTableOnCollection = true;
                } else {
                    table = `<div class = "BSS_fill_item_space"> </div>`;
                }
                const itemIdOnPage = itemElements.get(id.toString());
                if (itemIdOnPage) {
                    let gridItem = itemIdOnPage.closest(productCardSelector);
                    if ([9781, 13129, 14384, 12670].includes(BSS_B2B.storeId)) {
                        gridItem = itemIdOnPage;
                    }
                    if (gridItem) {
                        // gridItem.style.cssText =
                        //     "display: flex; flex-direction: column;";
                        const tableContainer = gridItem.querySelector(".bss-qb-collection-table");
                        if (tableContainer) {
                            tableContainer.insertAdjacentHTML("beforeend", table);
                            const tableOnDom = tableContainer.querySelector(".bss-b2b-cart-item-qty-table");
                            if (tableOnDom) {
                                tableOnDom.insertAdjacentHTML(
                                    "beforeend",
                                    `<div class = "BSS_fill_table_bottom_space"></div>`
                                );
                                tableOnDom.insertAdjacentHTML(
                                    "afterbegin",
                                    `<div class = "BSS_fill_table_top_space"></div>`
                                );
                            }
                        } else {
                            gridItem.insertAdjacentHTML("beforeend", table);
                            const tableOnDom = gridItem.querySelector(".bss-b2b-cart-item-qty-table");
                            if (tableOnDom) {
                                if (BSS_B2B.storeId == 13129) {
                                    const headerElement = tableOnDom.querySelector('p.bss-b2b-cart-item-qty-table-header');
                                    const existingSpanElement = headerElement.querySelector('span');
                                    existingSpanElement.insertAdjacentHTML(
                                        'afterend',
                                        `<span style="width: 5%;"><button style="background: transparent; border: none; float: right; width: 100%; height: 100%; color: #ffffff">↓</button></span>`
                                    );
                                }
                                tableOnDom.insertAdjacentHTML(
                                    "beforeend",
                                    `<div class = "BSS_fill_table_bottom_space"></div>`
                                );
                                tableOnDom.insertAdjacentHTML(
                                    "afterbegin",
                                    `<div class = "BSS_fill_table_top_space"></div>`
                                );
                            }
                        }
                    }
                }
            });
            // if there are qb tables on collection page
            if (appliedRules.size > 0) {
                // for free theme
                const setHeightForItemInRowDelay = delayFn(setHeightForItemInRow, 200);
                /*
                collection list's selector: 
                theme debut .grid.grid--uniform.grid--view-items, 
                theme express .featured-collections__products,
                theme bounderless .collection-grid
                theme supply .grid-uniform
                most of collection list's class in free theme are product-grid
                run only if there are tables on collection page
                */
                if (isQbTableOnCollection) {
                    const collectionSelector =
                        "#product-grid," +
                        ".grid.grid--uniform.grid--view-items," +
                        ".featured-collections__products," +
                        ".collection-grid," +
                        ".grid--uniform," +
                        ".grid-uniform," +
                        ".new-grid," +
                        ".product-grid";
                    addCSS(cssText);
                    setHeightForItemInRow(
                        collectionSelector,
                        ".BSS_fill_table_bottom_space",
                        ".BSS_fill_item_space",
                        ".BSS_fill_table_top_space"
                    );
                    window.addEventListener("resize", () => {
                        setHeightForItemInRowDelay(
                            collectionSelector,
                            ".BSS_fill_table_bottom_space",
                            ".BSS_fill_item_space",
                            ".BSS_fill_table_top_space"
                        );
                    });
                }
            }
            window.BSS_B2B.executeAction({tag: `customize_Qb_table`, storeId: 14384, isCollectionPage: true})
        }
    };
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helper; });
/* harmony import */ var _validate_date_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _convert_money_with_rate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);



function helper($, BSS_B2B, shopData, isEnableCP, Shopify) {
    window.Buffer = Buffer;
    BSS_B2B.helper = {};
    BSS_B2B.getCssSelector = function (selector) {
        if (BSS_B2B.customPricingSettings != null) {
            if (BSS_B2B.customPricingSettings[selector] != null && selector.indexOf('_time_delay_') !== -1) {
                return BSS_B2B.customPricingSettings[selector];
            }
            else {
                if (BSS_B2B.customPricingSettings[selector] != null && BSS_B2B.customPricingSettings[selector].length) {
                    return ',' + BSS_B2B.customPricingSettings[selector];
                }
            }
        }
        return '';
    };
    BSS_B2B.getQueryArray = function () {
        let vars = [], hash;
        let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    };

    BSS_B2B.helper.detectCorrectCartForm = (variantElement) => {
        const cartFormQuery = 'form[action*="/cart/add"], [data-options-selection], .product__controls-group.product__block,' +
            '.product-variants, .rio-options, .product-info__variant-picker, .variants-selection, .product__infor.col-6,'
            + 'variant-picker,' + '.halo-productView-right .productView-product.clearfix';

        let cartFormClick = $(variantElement).closest(cartFormQuery);
        if (!cartFormClick.length) {
            let parent = variantElement;
            const parentLevel = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            for (i of parentLevel) { // eslint-disable-line
                parent = $(parent).parent()
                if (!parent.length) {
                    break // highest parent
                }
                // cart form inside
                cartFormClick = parent.find(cartFormQuery);
                if (cartFormClick.length) {
                    break;
                }
            }
        }

        return cartFormClick
    }

    BSS_B2B.helper.detectCorrectParentLevel2 = (input) => {
        const cartFormQuery = 'form[action*="/cart/add"], [data-options-selection], .product__controls-group.product__block,' +
            '.product-variants, .rio-options, .product-info__variant-picker, .variants-selection, .product__infor.col-6,'
            + 'variant-picker,' + '.halo-productView-right .productView-product.clearfix';

        let parentLevel2 = input.closest(cartFormQuery);
        if (!parentLevel2.querySelector('[bss-b2b-product-parent-price]')) {
            const parentLevel = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            for (i of parentLevel) { // eslint-disable-line
                parentLevel2 = parentLevel2.parentNode;
                if (!parentLevel2) {
                    break
                }
                // cart form inside
                const hasPriceElement = parentLevel2.querySelector('[bss-b2b-product-parent-price]');
                if (hasPriceElement) {
                    break;
                }
            }
        }

        return parentLevel2
    }

    //note: add end-of-line space
    BSS_B2B.helper.buttonQuickViewElements = '.quick-add__submit.button.button--full-width.button--secondary ,' +
        'a.full-width-link ,' +
        'a.quickview-button[title="Quick View"] ,' +
        'a.t4s-pr-item-btn ,' +
        'a[data-original-title].quickview-icon.quickview.open-quick-view.woodmart-tltp ,' +
        'a.btn-action.quick_view ,' +
        '.quick-buy.btn ,' +
        '.page-collection .product .quickview_btn ,' +
        '.productitem__container .quickshop-button button.productitem--action-trigger ,' +
        '.product-item__link.link.text--subdued ,' +
        'input.cart__submit.btn.btn--small-wide ,' +
        'button.btn-update-qty , a.btn-cart , a.btn-remove.update-cart-btn ,' +
        'input.cart-popup input#addToCart ,' +
        '.my-cart-link-container ,' +
        '.productitem--action.quickshop-button .productitem--action-trigger.productitem--action-atc ,' +
        '.open-quick-view ,' +
        '.grid-product__content .quick-product__btn ,' +
        'button.show-product-quickview ,' +
        '.card .card__quick-view-icon[is="loess-button"] ,' +
        'a[data-target="#quickViewModal"] ,' +
        'a.quick-action-button ,' +
        'a.action-quickview ,' +
        '.cc-quick-buy-btn-container ,' +
        '.quick-add__holder,' +
        '.quickbuy-toggle,' +
        '.Sd_addProduct,' +
        '#CollectionProductGrid .m-product-card__media .m-product-card__action .m-product-quickview-button,' +
        '.product-card .product-card__quick-buy .button'
        ;

    // add end-of-line space
    BSS_B2B.helper.cartFormQuickView = '.quick-add-modal__content-info ,' +
        '[data-product-modal-wrapper] form[action*="/cart/add"] ,' +
        '.modal.modal--quick-shop.modal--is-active[data-product-id] form[action*="/cart/add"] ,' +
        '.quickview-tpl form[action*="/cart/add"] ,' +
        '.t4s-product__policies form[action*="/cart/add"] ,' +
        '.t4s-product-form__variants form[action*="/cart/add"] ,' +
        'form[action*="/cart/add"]#product-form ,' +
        '.product-focus form[action*="/cart/add"]#product-form ,' +
        'form[action*="/cart/add"].product-form.half.column ,' +
        '.product-single__bottom form[action*="/cart/add"] ,' +
        '.modal-content form[action*="/cart/add"] ,' +
        'form[action*="/cart/add"].shopify-product-form ,' +
        'form[action*="/cart"].cart ,' +
        'div.block-content ,' + // mini form
        'form[action*="/cart"] ,' +
        'form[action*="/cart"].js-cart-form ,' +
        'form[action*="/cart"].smart-payment-enabled ,' +
        'form[action*="/cart"].product_form ,' +
        '#gfqv-modal ,' +
        '.modal__centered-content ,' +
        '.quick-view-modal__content form[action*="/cart/add"] ,' +
        '.product-modal.modal ,' +
        '.cc-popup-content ,' +
        '.product-quick-view, ' + 
        '.quick-buy-drawer__info form[action="/cart/add"]'
        ;

    BSS_B2B.helper.buttonChangeVariantQuickView = '.js.product-form__input > label ,' +
        '.variant-input-wrap > .variant-input label ,' +
        '.modal__inner .main-product__blocks .js .small-caption';

    BSS_B2B.helper.checkoutElements = 'form[action*="/cart"] [name="checkout"],' +
        '#dropdown-cart button.btn.btn-checkout.show,' +
        'a.button.checkout-button[href="/checkout"],' +
        'form[action*="/checkout"] .add_to_cart,' +
        'form[action*="/cart"]#cart_form #checkout,' +
        'form[action*="/cart"] button.Cart__Checkout,' +
        'form[action*="/cart"] button.cart__checkout,' +
        'a.btn.disabled.ttmodalbtn[href="/checkout"],' +
        'form[action*="/cart"] [name="checkout"][type="submit"],' +
        // fix for o3plus-btob by Devlin
        'form[action*="/cart"] #custom-button,' +
        // fix for coobiewholesale by Devlin
        'form[action*="/cart"] button.mini-cart-button.button-cart-custom,' +
        // Allow purchase late as a "checkout button" to check QI module
        'input[value="Purchase Late"],' +
        'button[value="Purchase Late"],' +
        // fix for wdw by ThaBi
        'button.Cart__Checkout.Button.Button--primary.Button--full,' +
        // fix for epair-partners-wholesale-retail by ThaBi
        '.baskettop button.mini-cart-checkout,' +
        '.tt-dropdown-menu .btn.itemCheckout,' +
        // fix for shop.repairpartners by ThaBi
        '.bss-btn-checkout-mini-cart,' +
        // fix for theme Boundless by XuTho
        'button[name="checkout"].btn,' +
        // fix korresshop-greece by vitu
        'form[action*="/checkout"] [name="checkout"],' +
        // fix for aelia-duty-free-private-staff-sales by ThaBi
        '.cart__footer .cart__checkout-button.button:not(.bss-b2b-customer-portal-btn-quote-default),' +
        // fix for rubiconsa by XuTho
        '#cartform #checkout,' +
        // fix for r3wholesale by XuTho
        `#slidedown-cart button[onclick="window.location='/checkout'"],` +
        '#dropdown-cart button.btn.btn-checkout,' +
        '.popup-cart__buttons a[href="/checkout"],' +
        '.shopping-cart-footer a[href="/checkout"],' +
        'button.check-out.btn ,' +
        'button.btn-order.btn ,' +
        '.sp-proceed-to-checkout a[href="/checkout/"],' +
        '.cart-checkout .actions a[href="/checkout"],' +
        '.btn.btn-checkout,' +
        '.bss-b2b-customer-portal-nt-checkout-btn,' +
        // fix wilberrys by vitu
        'input[type="submit"][name="checkout"],' +
        //fix for wholesale.thicktails by hoaduong
        '.cart-drawer__footer a[href="/checkout"],' +
        // fix for venum-testing by DangNM
        'button[type="submit"][name="checkout"],' +
        // fix for yamazakihome-eu.myshopify.com by DangNM
        '.cart-footer a.button[role="button"][href="/checkout"],' +
        // fix for yamazakihome by mitri
        '.button.rel.y.no-ajax.body2.medium.body2,' +
        // fix for newgarden by CuongNVM
        '.buttons.form_jas_agree .button.checkout.wc-forward,' +
        // fix for Hi-Lux by CuongNVM
        '.ajax-cart__button.button--add-to-cart.button,' +
        // fix for woodenplayroom by DangNM
        '.atc-banner--container .atc-button--checkout,' +
        // fix for korresshop-greece by LinhLT
        'form[action*="/checkout"] a.primary-btn.checkout,' +
        // fix for laduora by mitri
        'form[action*="/checkout"] .mm-action_buttons input[value="Checkout"],' +
        // fix for provisionswholesale by mitri
        '.proceed-to-checkout,' +
        '.mini-cart .mini-cart-btns .cart-btns a[href="/checkout"],' +
        // fix for wilder-land-b2b by DangNM
        '.cart__options .cart__options__row.cart__options__row--buttons button.button.js-checkout-button[type="submit"],' +
        // fix for high-5-vape by mitri
        '.cart--checkout-button,' +
        // fix for uniform-ware-house by hainguyen
        'a[href="/checkout"],' +
        //fix for cookingpal by HaiNN
        '.pdp-buy-now[data-checkout="checkout"],' +
        //fix for cafecanal by Huydt
        '#cart-overlay > div.cart-overlay-content > div > div.cart-product-wrapper > div.cart-buttons > a.checkout_btn,' +
        // fix for stealth-performance-engineering by AnhTV
        '.cart-wrapper .cart-checkout .actions .btn-button,' +
        'button[type="submit"].btn.btn--full.cart__checkout,' +
        // fix for test-demo-store11 by LuanHV
        '.product-actions > .pro-detail-button > .btn-cart,' +
        '.popup_cart .cart-popup-action .btn.btn-danger,' +
        '#cart-checkout, #cart-sidebar-checkout,' +
        'button[form="cart"].fs-checkout-btn-custom.fs-checkout-btn,' +
        //fix for openhagen.dk by anhtd
        '.Cart__Recap .Cart__Checkout.Button.Button--primary.Button--full.customizer_nods,' +
        '.checkout-buttons #update-cart,' +
        '.cart-wrapper button.cart-recap__checkout[name="checkout"][type="submit"],' +
        'input.ajax-cart__button-submit,' +
        '.btn.cart-modal__btn.cart-modal__btn--checkout,' +
        // fix for aviationtag.com by Tapo
        'form[action*="/cart"] .cart__footer .cart__checkout-wrapper,' +
        'form[action="/cart/add"] div[data-shopify="payment-button"],' +
        '#multivariants_add_to_checkout_button,' +
        '.rebuy-cart__checkout-button,' +
        '.btn-1.side-cart__footer__button,' +
        '#depo-checkout, .checkout-btn,' +
        '.btn-1.cartpage__footer__button.cartpage-checkout-js,' +
        '.Cart__Recap .Cart__Checkout.Button.Button--primary,' +
        'a.quick-cart__buy-now,' +
        //fix for idshoesonline.myshopify.com
        'form[action*="/cart"] .drawer__inner .cart__checkout-wrapper button,' +
        '.frm_cart_page .cart__footer .gokwik-checkout a,' +
        'form[action="/cart"] .action_buttons button[name="checkout"],' +
        '#bss-checkout';

    // element wrapper product form in PDP, quickview, featured product
    BSS_B2B.helper.productFormElement = [
        'product-info',
        '.gf_column.gf_col-lg-6.gf_col-md-6.gf_col-sm-6.gf_col-xs-12',
        '.gf_column.gf_col-lg-4.gf_col-md-4.gf_col-sm-12.gf_col-xs-12',
        ".col-12.col-lg-6",
        ".one-third.column",
        ".quick-shop__product-description",
        ".card__section",
        '.product-details_price-inner',
        '.gf_column.gf_col-lg-6.gf_col-md-6.gf_col-sm-6.gf_col-xs-12',
        ".product__price",
        "#quickshop",
        ".product-block--price .modal_price.subtitle",
        "#content_quickview .product-single__meta",
        "form:has(.gf_column.gf_col_no_tools.gf_col-md-12.gf_swatches-selector)",
        ".product-form-holder"
    ].join(',');

    BSS_B2B.helper.getPriceElement = function (productId, suffix) {
        return $(
            `[bss-b2b-product-id="${productId}"][bss-b2b-product-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-current-variant-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-sale-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-featured-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-variant-price]${suffix}`,
        );
    };
    BSS_B2B.helper.getLowestPriceElement = function (productId, suffix) {
        return $(
            `[bss-b2b-product-id="${productId}"][bss-b2b-product-lowest-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-from-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-now-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-min-price]${suffix}`,
        );
    };
    BSS_B2B.helper.getHighestPriceElement = function (productId, suffix) {
        return $(
            `[bss-b2b-product-id="${productId}"][bss-b2b-product-highest-price]${suffix},`
            + `[bss-b2b-product-id="${productId}"][bss-b2b-product-max-price]${suffix}`,
        );
    };
    BSS_B2B.helper.getUnitPriceElement = function (productId, suffix) {
        return $(
            `[bss-b2b-product-id="${productId}"][bss-b2b-variant-id][bss-b2b-variant-unit-price]${suffix},` +
            `[bss-b2b-product-parent-price][bss-b2b-product-id="${productId}"][data-unit-price]${suffix},` +
            `[bss-b2b-product-id="${productId}"][bss-b2b-variant-unit-price]${suffix}`,
        );
    };
    BSS_B2B.helper.getButtonPriceElement = function (productId, suffix) {
        let result = $(
            `[bss-b2b-product-id="${productId}"][bss-b2b-button-price]${suffix}`,
        );
        if (BSS_B2B.storeId === 13943) return $(`[bss-b2b-product-id="${productId}"][bss-b2b-button-price]`);
        return result;
    };

    // function fix orantek by vitu
    BSS_B2B.printSaveTo = function (shopData) {
        let ruleApplies = [];
        let price = 0;
        if (shopData.product) {
            let variantIdSelected = false;
            if ((BSS_B2B.storeId === 918 || BSS_B2B.storeId === 3918) && $('.product-form__variants').length) {
                variantIdSelected = $('.product-form__variants .no-js.product-form__option select[name=id]').val();
            }
            //fix orantek use ecomposer page builder
            if (BSS_B2B.storeId === 918 && !variantIdSelected) {
                variantIdSelected = $('select[name="id"]').val()
            }
            if (shopData.product) {
                price = parseFloat(shopData.product.price);
            }
            if (variantIdSelected && shopData.product.variants) {
                for (let i = 0; i < shopData.product.variants.length; i++) {
                    let variant = shopData.product.variants[i];
                    if (variant.available && variantIdSelected && variant.id == variantIdSelected) {
                        price = variant.price;
                        break;
                    }
                }
            }
            let element = $('.bss-save-to-cp');
            for (let i = 0; i < BSS_B2B.configData.length; i++) {
                let rule = BSS_B2B.configData[i];
                if (rule.product_condition_type === 0) {
                    ruleApplies.push(rule);
                }
                else if (rule.product_condition_type === 1) {
                    if (rule.product_ids.split(',').includes((shopData.product.id).toString())) {
                        ruleApplies.push(rule);
                    }
                }
                else if (rule.product_condition_type === 2) {
                    if (shopData.collections.filter(
                        item => rule.product_collections.split(',').includes(item.toString())).length) {
                        ruleApplies.push(rule);
                    }
                }
                else if (rule.product_condition_type === 3) {
                    if (shopData.product.tags.filter(
                        item => rule.product_tags.split(',').includes(item.toString())).length) {
                        ruleApplies.push(rule);
                    }
                }
            }
            let priceApplies = [];
            if (ruleApplies.length) {
                let priceApply;
                for (let i = 0; i < ruleApplies.length; i++) {
                    if (ruleApplies[i].discount_type === 0) {
                        priceApply = parseFloat(ruleApplies[i].discount_value);
                        priceApplies.push(priceApply * 100);
                    }
                    else if (ruleApplies[i].discount_type === 1) {
                        priceApply = price - parseFloat(ruleApplies[i].discount_value) * 100;
                        priceApplies.push(priceApply);
                    }
                    else if (ruleApplies[i].discount_type === 2) {
                        priceApply = price - price * parseFloat(ruleApplies[i].discount_value) / 100;
                        priceApplies.push(priceApply);
                    }
                }

                let bestPrice = Math.min.apply(Math, priceApplies);
                element.html(BSS_B2B.formatMoney(bestPrice));
                $('.bss-custom').css({ 'visibility': 'visible' });
            }
        }
    };

    BSS_B2B.checkExcludeCustomer = function (rule) {
        let excludeCustomerTags = rule.exc_customer_tags;
        let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
        let excludeCustomers = rule.exc_customers;
        if (excludeFrom === 1) {
            if (excludeCustomerTags && excludeCustomerTags.length && shopData.customer.tags !== null) {
                excludeCustomerTags = excludeCustomerTags.split(',');
                let checkArray = excludeCustomerTags.filter(tag => shopData.customer.tags.includes(tag.toLowerCase() + ''));
                if (checkArray.length > 0) {
                    return true;
                }
            }
        }
        else if (excludeFrom === 2) {
            if (excludeCustomers) {
                if (excludeCustomers.includes(`${shopData.customer.id}`)) {
                    return true;
                }
            }
        }
        return false;
    }

    BSS_B2B.checkAppliedTo = function (rule) {
        let applyTo = rule.apply_to;
        let customerIds = rule.customer_ids;
        let customerTags = rule.customer_tags;
        let listStoreId = [918, 2709, 3918];
        if (applyTo === 1) {
            if (shopData.customer.id == null) {
                if (listStoreId.indexOf(BSS_B2B.storeId) !== -1) {
                    //fix orantek and wilberrys by vitu
                    BSS_B2B.printSaveTo(shopData);
                }
                return false;
            }
        }
        else if (applyTo === 2) {
            if (shopData.customer.id !== null) {
                return false;
            }
            else {
                if (listStoreId.indexOf(BSS_B2B.storeId) !== -1) {
                    //fix orantek and wilberrys by vitu
                    BSS_B2B.printSaveTo(shopData);
                }
            }
        }
        else if (applyTo === 3) {
            if (shopData.customer.id == null) {
                if (listStoreId.indexOf(BSS_B2B.storeId) !== -1) {
                    //fix orantek and wilberrys by vitu
                    BSS_B2B.printSaveTo(shopData);
                }
                return false;
            }
            else {
                customerIds = customerIds ? customerIds.split(',') : [];
                if (customerIds.indexOf(shopData.customer.id + '') === -1) {
                    return false;
                }
            }
        }
        else if (applyTo === 4) {
            if (shopData.customer.tags == null) {
                if (listStoreId.indexOf(BSS_B2B.storeId) !== -1) {
                    //fix orantek and wilberrys by vitu
                    BSS_B2B.printSaveTo(shopData);
                }
                return false;
            }
            else {
                customerTags = customerTags.split(',');
                // to lower case
                shopData.customer.tags = shopData.customer.tags.map((tag) => tag.toLowerCase());
                customerTags = customerTags.map((tag) => tag.toLowerCase());
                let checkArray = customerTags.filter((tag) => shopData.customer.tags.includes(tag + ''));
                if (checkArray.length === 0) {
                    if (listStoreId.indexOf(BSS_B2B.storeId) !== -1) {
                        //fix orantek and wilberrys by vitu
                        BSS_B2B.printSaveTo(shopData);
                    }
                    return false;
                }
            }
        }
        return true
    }

    BSS_B2B.checkAppliedDate = function (rule) {
        let startDate = rule.start_date;
        let endDate = rule.end_date;
        let currentDate = new Date();

        if (!(rule.start_time || rule.end_time)) {
            if (startDate && currentDate < new Date(startDate)) {
                return false;
            }
            if (endDate && currentDate > new Date(endDate)) {
                return false;
            }
        } else {
            const failDate = Object(_validate_date_time__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(new Date(startDate), new Date(endDate), rule.start_time, rule.end_time, rule.enable_end_date)
            if (failDate) {
                return false
            }
        }
        return true
    }

    BSS_B2B.checkAppliedMarket = function (rule) {
        let marketConditionType = rule.market_condition_type;
        let allowedRegions = rule.allowed_regions;

        if (marketConditionType === 1) {
            if (allowedRegions && allowedRegions.length && !allowedRegions.includes(Shopify.country)) {
                return false;
            }
        }
        return true;
    }

    BSS_B2B.checkAppliedPLRule = function (rule) {
        if (BSS_B2B.checkExcludeCustomer(rule)) {
            return false;
        }

        if (!BSS_B2B.checkAppliedTo(rule)) {
            return false;
        }

        if (!BSS_B2B.checkAppliedDate(rule)) {
            return false;
        }
        return true;
    }

    BSS_B2B.checkAppliedCPRule = function (rule) {
        if (!BSS_B2B.checkAppliedMarket(rule)) {
            return false;
        }

        if (!BSS_B2B.checkAppliedTo(rule)) {
            return false;
        }

        if (!BSS_B2B.checkAppliedDate(rule)) {
            return false;
        }

        if (BSS_B2B.checkExcludeCustomer(rule)) {
            return false;
        }

        return true;
    }

    BSS_B2B.getPriceList = function (shopData, productMap, isCartItem, productPrices) {
        if (
            !isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData)
            || (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)
        ) {
            return [];
        }

        const sampleSubId = window.BSS_SUB && window.BSS_SUB.sampleSubProduct && window.BSS_SUB.sampleSubProduct.product_id;
        if (sampleSubId) {
            productMap = productMap.filter(item => !sampleSubId.includes(item.id));
        }

        let productPriceListMap = new Map();
        let variantPriceListMap = new Map();
        let cartItemPriceListMap = new Map();
        let priceMinMap = new Map()
        let ruleList = BSS_B2B.configData;
        let plRuleList = BSS_B2B.plConfigData;
        let checkAppliedProduct = [];
        let checkAppliedVariant = [];
        let productApplied;
        const ruleTypes = {
            CP: 'CP',
            PL: 'PL',
        };

        plRuleList && plRuleList.forEach((rule) => {
            if (!BSS_B2B.checkAppliedPLRule(rule)) {
                return;
            }

            for (let i = 0; i < productMap.length; i++) {
                const productId = productMap[i].id;
                const cartKey = isCartItem ? productMap[i].key : false;
                const isFeatured = productMap[i].isFeatured ? true : false
                const variantSelectedId = productMap[i].variantsApplied ? productMap[i].variantsApplied : null;



                if (rule.apply_at) {
                    let selectedVariants = rule.selected_variants;
                    let priceList = {
                        'id': productId,
                        'rule_id': rule.id,
                        'key': cartKey,
                        'name': rule.name,
                        'ruleType': ruleTypes.PL,
                    }
                    if (variantSelectedId) {
                        if (isFeatured) {
                            let variantAppliedPL = selectedVariants.find((item) => parseInt(item.variant_id) === variantSelectedId)
                            if (variantAppliedPL) {
                                let variantAppliedId = variantAppliedPL.variant_id;
                                priceList = {
                                    ...priceList,
                                    'discount_type': variantAppliedPL.discount_type,
                                    'value': variantAppliedPL.discount_value,
                                    'pid': variantAppliedPL.id,
                                    'sid': `${variantAppliedPL.token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                                }

                                if (!variantPriceListMap.get(parseInt(variantAppliedId))) {
                                    variantPriceListMap.set(parseInt(variantAppliedId), {
                                        ...priceList,
                                        'isFeatured': true,
                                        'variantSelected': parseInt(variantAppliedId),
                                    })
                                }
                            } else {
                                let productVariantApplied = selectedVariants.find((item) => parseInt(item.product_id) === productId)
                                if (productVariantApplied) {
                                    checkAppliedProduct.push(parseInt(productVariantApplied.product_id));
                                }
                            }
                        } if (isCartItem) {
                            let appliedCartItem = selectedVariants.filter((item) => variantSelectedId.includes(parseInt(item.variant_id)) && parseInt(item.product_id) === productId);
                            if (appliedCartItem.length > 0) {
                                for (const item of appliedCartItem) {
                                    if (!cartItemPriceListMap.get(parseInt(item.variant_id))) {
                                        if (!checkAppliedProduct.includes(parseInt(item.product_id))) {
                                            checkAppliedProduct.push(parseInt(item.product_id))
                                        }
                                        cartItemPriceListMap.set(parseInt(item.variant_id), {
                                            ...priceList,
                                            'discount_type': item.discount_type,
                                            'value': item.discount_value,
                                            'pid': item.id,
                                            'sid': `${item.token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                                            'variants': [item.variant_id]
                                        })
                                    }
                                }
                            }
                        }
                        if (checkAppliedProduct.length > 0) {
                            checkAppliedProduct.forEach((item) => {
                                if (!productPriceListMap.get(item)) {
                                    productPriceListMap.set(item, true)
                                }
                            })
                        }
                    } else {
                        const productData = productPrices[productId];
                        if (!priceMinMap.get(productId)) {
                            priceMinMap.set(productId, {
                                priceMinProductAfterApplyPL: productData.price,
                                selectedVariant: null
                            })
                        }
                        productApplied = selectedVariants.reduce((priceMinMapApplied, product) => {
                            let proId = parseInt(product.product_id);
                            let variantId = parseInt(product.variant_id);
                            if (proId == productId && !checkAppliedVariant.includes(variantId)) {
                                let priceMin = priceMinMapApplied.get(productId);
                                checkAppliedVariant.push(variantId);
                                let variantData = productData.variants.find((item) => item.id === variantId)
                                let priceAppliedPL = BSS_B2B.getModifiedPrice(
                                    variantData.price,
                                    product.discount_type,
                                    parseFloat(product.discount_value)
                                )
                                if (priceAppliedPL < priceMin.priceMinProductAfterApplyPL) {
                                    priceMinMapApplied.set(productId, {
                                        priceMinProductAfterApplyPL: priceAppliedPL,
                                        selectedVariant: {
                                            'id': productId,
                                            'rule_id': rule.id,
                                            'discount_type': product.discount_type,
                                            'value': product.discount_value,
                                            'key': cartKey,
                                            'name': rule.name,
                                            'ruleType': ruleTypes.PL,
                                            'pid': product.id,
                                            'sid': `${product.token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                                            'variants': parseInt(product.variant_id),
                                        }
                                    })
                                }
                            }
                            return priceMinMapApplied;
                        }, priceMinMap)

                        if (productApplied && productApplied.size > 0) {
                            productApplied.forEach((priceList, key) => {
                                if (priceList.selectedVariant && !productPriceListMap.get(key)) {
                                    productPriceListMap.set(key, priceList.selectedVariant)
                                }
                            })
                        }
                    }
                } else {
                    let prods = rule.selected_products.filter(product => {
                        let prodId = parseInt(product.product_id);
                        return productId === prodId
                    });
                    if (prods.length > 0) {
                        let priceList = {
                            'id': productId,
                            'rule_id': rule.id,
                            'discount_type': prods[0].discount_type,
                            'value': prods[0].discount_value,
                            'key': cartKey,
                            'name': rule.name,
                            'ruleType': ruleTypes.PL,
                            'pid': prods[0].id,
                            'sid': `${prods[0].token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                        }
                        if (variantSelectedId) {
                            if (isFeatured) {
                                if (!variantPriceListMap.get(parseInt(variantSelectedId))) {
                                    variantPriceListMap.set(parseInt(variantSelectedId), {
                                        ...priceList,
                                        'isFeatured': true,
                                        'variantSelected': variantSelectedId,
                                    })
                                }
                            } else if (isCartItem) {
                                if (!cartItemPriceListMap.get(cartKey)) {
                                    cartItemPriceListMap.set(cartKey, priceList);
                                }
                            }
                        } else {
                            const productData = productPrices && productPrices[productId];
                            if (productData) {
                                let priceProduct = productData.variants.reduce((oldValue, currentValue) => (
                                    currentValue < oldValue ? currentValue : oldValue
                                ), productData.variants[0].price)
                                const priceMin = priceMinMap.get(productId) ? priceMinMap.get(productId).priceMinProductAfterApplyPL : null;
                                const priceApplyPLProduct = BSS_B2B.getModifiedPrice(
                                    priceProduct,
                                    prods[0].discount_type,
                                    parseFloat(prods[0].discount_value)
                                )
                                if (priceMin && priceApplyPLProduct < priceMin) {
                                    productPriceListMap.set(productId, priceList);
                                } else {
                                    if (!productPriceListMap.get(productId)) {
                                        productPriceListMap.set(productId, priceList);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })

        // for(const id of productPriceListMap.keys()){
        //     if(productPrices){
        //         let productData = productPrices[parseInt(id)];
        //         if(productData) {
        //             let variants = productData.variants.map((item) => item.id);
        //             variants.forEach(variant => {
        //                 if(!variantPriceListMap.get(variant)) {
        //                     variantPriceListMap.set(variant, true)
        //                 }
        //             })
        //         }
        //     }
        // }
        //end check PL rules

        checkAppliedProduct = [];
        productApplied = null;
        // priceMinMap = new Map();

        //start check CP rule

        ruleList && ruleList.forEach(function (rule) {
            if (!BSS_B2B.checkAppliedCPRule(rule)) {
                return
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(',').map((tag) => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(',') : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(',') : [];
            let productVariantIds = rule.product_variants ? rule.product_variants.split(',') : [];
            let listVariants = rule.product_variants? rule.product_variants.split(',') : []
            for (let i = 0; i < productMap.length; i++) {
                const productId = productMap[i].id;
                const variantSelectedId = productMap[i].variantsApplied;
                const productTitle = productMap[i].product_name;
                const isFeatured = productMap[i].isFeatured;
                const cartKey = isCartItem ? productMap[i].key : false;
                const collections = productMap[i].collections || [];
                const tags = productMap[i].tags ? productMap[i].tags.map((tag) => tag.toLowerCase()) : [];
                let isApplied = false;

                let priceList = {
                    'id': productId,
                    'discount_type': rule.discount_type,
                    'value': rule.discount_value,
                    'key': cartKey,
                    'name': rule.name,
                    'product_name': productTitle,
                    'ruleType': ruleTypes.CP,
                    'rule_id': rule.id,
                    'sid': `${rule.token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                }

                if (conditionType === 4 && BSS_B2B.planCode === "platinum") {
                    if (variantSelectedId) {
                        if (isFeatured) {
                            let checkArray = productVariantIds.find((item) => parseInt(item) === variantSelectedId)
                            if (checkArray && !variantPriceListMap.get(parseInt(checkArray))) {
                                variantPriceListMap.set(parseInt(checkArray), {
                                    ...priceList,
                                    'isFeatured': true,
                                    'variantSelected': variantSelectedId,
                                })
                            } else {
                                const selectedVariants = productPrices[productId].variants;
                                const productVariantApplied = selectedVariants.find((item) => productVariantIds.includes(item.toString()))
                                if (productVariantApplied) {
                                    checkAppliedProduct.push(productId);
                                }
                            }
                        } else if (isCartItem) {
                            let checkArray = productVariantIds.filter((variant) => variantSelectedId.includes(parseInt(variant)));
                            if (checkArray && checkArray.length > 0) {
                                for (const item of checkArray) {
                                    if (!cartItemPriceListMap.get(parseInt(item))) {
                                        cartItemPriceListMap.set(parseInt(item), {
                                            ...priceList,
                                            "variants": [item]
                                        })
                                    }

                                }
                            }
                        }
                        if (checkAppliedProduct.length > 0) {
                            checkAppliedProduct.forEach((item) => {
                                if (!productPriceListMap.get(item)) {
                                    productPriceListMap.set(item, true)
                                }
                            })
                        }
                    } else {
                        //Handle apply price to selected variant in card product
                        const productData = productPrices[productId];
                        if (!priceMinMap.get(productId)) {
                            priceMinMap.set(productId, {
                                priceMinProductAfterApplyPL: productData.price,
                                selectedVariant: null
                            })
                        }
                        productApplied = productVariantIds.reduce((priceMinMapApplied, variants) => {
                            let variantId = parseInt(variants);
                            let variantsProduct = productData.variants.find((item) => item.id === variantId && !checkAppliedVariant.includes(item.id))
                            if (variantsProduct) {
                                let priceMin = priceMinMapApplied.get(productId);
                                checkAppliedVariant.push(variantId);
                                let variantData = productData.variants.find((item) => item.id === variantId)
                                let priceAppliedPL = BSS_B2B.getModifiedPrice(
                                    variantData.price,
                                    rule.discount_type,
                                    parseFloat(rule.discount_value)
                                )
                                if (priceAppliedPL < priceMin.priceMinProductAfterApplyPL) {
                                    priceMinMapApplied.set(productId, {
                                        priceMinProductAfterApplyPL: priceAppliedPL,
                                        selectedVariant: {
                                            'id': productId,
                                            'rule_id': rule.id,
                                            'discount_type': rule.discount_type,
                                            'value': rule.discount_value,
                                            'key': cartKey,
                                            'name': rule.name,
                                            'ruleType': ruleTypes.CP,
                                            'pid': rule.id,
                                            'sid': `${rule.token}.${Buffer.from(String(cartKey)).toString('base64')}`,
                                            'variants': parseInt(variantId),
                                        }
                                    })
                                }
                            }
                            return priceMinMapApplied;
                        }, priceMinMap)

                        if (productApplied && productApplied.size > 0) {
                            productApplied.forEach((priceList, key) => {
                                if(priceList.selectedVariant&& !productPriceListMap.get(key)) {
                                    priceList.selectedVariant = {...priceList.selectedVariant, "listVariants": listVariants }
                                    productPriceListMap.set(key, priceList.selectedVariant)
                                }
                            })
                        }
                    }
                } else {
                    if (conditionType === 0) {
                        isApplied = true;
                    }
                    else if (conditionType === 1) {
                        if (specificProductIds.indexOf(productId + '') !== -1) {
                            isApplied = true;
                        }
                    }
                    else if (conditionType === 2) {
                        let checkArray = collections ? collections.filter(
                            collection => ruleCollectionIds.includes(collection + '')) : [];
                        if (checkArray.length > 0) {
                            isApplied = true;
                        }
                    }
                    else if (conditionType === 3) {
                        let checkArray = ruleTags.filter(tag => tags.includes(tag));
                        if (checkArray.length > 0) {
                            isApplied = true;
                        }

                    }
                    if (isApplied) {
                        if (variantSelectedId) {
                            if (productMap[i].isFeatured) {
                                if (!variantPriceListMap.get(variantSelectedId)) {
                                    variantPriceListMap.set(variantSelectedId, {
                                        ...priceList,
                                        'isFeatured': true,
                                        'variantSelected': variantSelectedId,
                                    })
                                }
                            } else if (isCartItem) {
                                if (!cartItemPriceListMap.get(cartKey)) {
                                    cartItemPriceListMap.set(cartKey, priceList)
                                }
                            }
                        } else {
                            const productData = productPrices[productId];
                            if (productData) {
                                let priceProduct = productData.variants.reduce((oldValue, currentValue) => (
                                    currentValue < oldValue ? currentValue : oldValue
                                ), productData.variants[0].price)
                                const priceMin = priceMinMap.get(productId) ? priceMinMap.get(productId).priceMinProductAfterApplyPL : null;
                                const priceApplyPLProduct = BSS_B2B.getModifiedPrice(
                                    priceProduct,
                                    rule.discount_type,
                                    parseFloat(rule.discount_value)
                                )
                                if (priceMin && priceApplyPLProduct < priceMin) {
                                    productPriceListMap.set(productId, priceList);
                                } else {
                                    if (!productPriceListMap.get(productId)) {
                                        productPriceListMap.set(productId, priceList);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });

        // for(const id of productPriceListMap.keys()){
        //     if(productPrices){
        //         let productData = productPrices[parseInt(id)];
        //         if(productData) {
        //             let variants = productData.variants.map((item) => item.id);
        //             variants.forEach(variant => {
        //                 if(!variantPriceListMap.get(variant)) {
        //                     variantPriceListMap.set(variant, true)
        //                 }
        //             })
        //         }
        //     }
        // }

        // end check CP rules

        let priceLists = [];
        if (!isCartItem) {
            for (const value of [...productPriceListMap.values(), ...variantPriceListMap.values()]) {
                if (!(value === true)) {
                    priceLists.push(value);
                }
            }
        } else {
            priceLists = [...cartItemPriceListMap.values()]
        }
        return priceLists;
    };

    BSS_B2B.getModifiedPrice = function (price, type, discountValueOfRule) {
        let modifiedPrice = price;
        let rateMarket = Shopify.currency.rate;
        let discountValueWithMarket = BSS_B2B.helper.convertPriceWithRate(discountValueOfRule) * 100;
        if (type === 0) {
            let priceWithStoreCurrency = price / rateMarket;

            discountValueOfRule = discountValueOfRule * 100;
            if (priceWithStoreCurrency > discountValueOfRule) {
                let realDiscount = (priceWithStoreCurrency - discountValueOfRule) / 100;
                realDiscount = realDiscount.toFixed(2);
                realDiscount = (realDiscount * rateMarket);
                realDiscount = realDiscount.toFixed(2);
                realDiscount = realDiscount * 100;

                modifiedPrice = Math.round((price - realDiscount) * 100) / 100;
            }
            else {
                modifiedPrice = price;
            }
        }
        else if (type === 1) {
            modifiedPrice = discountValueWithMarket > price ? 0 : (price - discountValueWithMarket);
        }
        else if (type === 2) {
            let realDiscountValueItem = (price / rateMarket) * (discountValueOfRule / 100);
            realDiscountValueItem = realDiscountValueItem.toFixed(0);
            realDiscountValueItem = (realDiscountValueItem * rateMarket).toFixed(0);

            modifiedPrice = price - realDiscountValueItem;

            // fix for canicoolhq by Leorio
            // if (BSS_B2B.storeId === 1508 && BSS_B2B.page.isCartPage()) {
            //     if (modifiedItemPrice % 0.5 === 0) {
            //         modifiedPrice = Math.round(modifiedPrice);
            //     }
            // }
        }

        return modifiedPrice;
    };

    BSS_B2B.checkVariantExist = function (cartFormElement, variant) {
        let cartFormId = $(cartFormElement).attr('id');
        let cartFormIdNumber = '';
        if (cartFormId !== undefined) {
            cartFormIdNumber = cartFormId.replace(/\W/g, '');
        }
        let selectedVariant = $(cartFormElement).find('select#ProductSelect--product-template :selected, ' +
            'select#ProductSelect--featured-product :selected, ' +
            'select[name="id"] :selected, ' +
            'select[id$="' + cartFormIdNumber + '"] :selected'
            + BSS_B2B.getCssSelector('product_select_variant_input'),
        );
        if (selectedVariant.length) {
            let selectedVariantId = selectedVariant.val();
            if (selectedVariantId == variant.id) {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    };

    BSS_B2B.getCartPriceClass = function (cssClass) {

        let cssSelector = BSS_B2B.getCssSelector(cssClass);

        if (cssSelector.indexOf('=itemKey') !== -1) {
            cssSelector = cssSelector.replace(/=itemkey/g, '');
        }

        return cssSelector;

    };

    BSS_B2B.page = {};

    BSS_B2B.page.getPage = function () {
        let hrefArr = window.location.href.split('/');
        return hrefArr;
    };
    BSS_B2B.page.isCartPage = function () {
        let hrefArr = BSS_B2B.page.getPage();
        let isCart = (hrefArr[hrefArr.length - 1] === 'cart' ||
            (hrefArr[hrefArr.length - 1].includes('cart') && hrefArr[hrefArr.length - 2] !== 'products') &&
            hrefArr[hrefArr.length - 2] !== 'collections');
        return isCart;
    };
    BSS_B2B.page.isCollectionPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            (BSS_B2B.storeId === 7355 || window.ShopifyAnalytics.meta.page.pageType)) {
            return window.ShopifyAnalytics.meta.page.pageType === 'collection';
        }
        else {
            let hrefArr = BSS_B2B.page.getPage();
            let isCollectionPage = hrefArr[hrefArr.length - 2] === 'collections';
            return isCollectionPage;
        }
    };
    BSS_B2B.page.isSearchPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'searchresults';
        }
        else {
            let hrefArr = BSS_B2B.page.getPage();
            let isSearchPage = hrefArr[hrefArr.length - 1] === 'search' ||
                hrefArr[hrefArr.length - 1].includes('search');
            return isSearchPage;
        }
    };
    BSS_B2B.page.isLoginPage = function () {
        let hrefArr = BSS_B2B.page.getPage();
        let isLoginPage = (hrefArr[hrefArr.length - 1] === 'login' || hrefArr[hrefArr.length - 1].includes('login')) &&
            hrefArr[hrefArr.length - 2] === 'account';
        return isLoginPage;
    };
    BSS_B2B.page.isRegisterPage = function () {
        let hrefArr = BSS_B2B.page.getPage();
        let isRegisterPage = (hrefArr[hrefArr.length - 1] === 'register' ||
            hrefArr[hrefArr.length - 1].includes('register')) && hrefArr[hrefArr.length - 2] === 'account';
        return isRegisterPage;
    };
    BSS_B2B.page.isProductPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            (BSS_B2B.storeId === 7355 || window.ShopifyAnalytics.meta.page.pageType)) {
            return window.ShopifyAnalytics.meta.page.pageType === 'product';
        }
        else {
            let hrefArr = BSS_B2B.page.getPage();
            let isProductPage = hrefArr[hrefArr.length - 2] === 'products';
            return isProductPage;
        }
    };
    BSS_B2B.page.isQuickOrderPage = function () {
        let hrefArr = BSS_B2B.page.getPage();
        let isQuickOrderPage = (hrefArr[hrefArr.length - 1] === 'quick-order' && hrefArr[hrefArr.length - 2] !==
            'customer-portal');
        return isQuickOrderPage;
    };

    BSS_B2B.page.isCustomPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'page';
        }
        else {
            let hrefArr = BSS_B2B.page.getPage();
            let isCustomPage = (hrefArr[hrefArr.length - 2] === 'pages');
            return isCustomPage;
        }
    };

    BSS_B2B.page.isHomePage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'home';
        }
        else {
            let hrefArr = BSS_B2B.page.getPage();
            let isHomePage = (hrefArr[hrefArr.length - 1] === '');
            return isHomePage;
        }
    };

    BSS_B2B.quantityInputSelectorOnProductPage = [
        'input[type="number"][name="quantity"]',
        'input[type="number"][data-quantity-input]',
        'input[type="number"][class$="quantity"]',
        'input[id^="Quantity"]',
        'input[name="quantity"]',
    ];
    BSS_B2B.buttonChangeQuantityOnProductPage =
        // fix add selector button by bacdv
        '.product-form__quantity button[name="plus"],' +
        '.product-form__quantity button[name="minus"],' +
        'form[action="/cart/add"] .qtyminus,' +
        'form[action="/cart/add"] .qtyplus,' +
        // fix for shop-ahika by DangNM
        'form[action="/cart/add"] .quick_view-qty.quick_view-qty-minus,' +
        'form[action="/cart/add"] .quick_view-qty.quick_view-qty-plus,' +
        // fix for watcstudio by DangNM
        'form[action="/cart/add"] button.qty-button.qty-minus,' +
        'form[action="/cart/add"] button.qty-button.qty-plus,' +
        'form[action="/cart/add"] button[type=button].minus,' +
        'form[action="/cart/add"] button[type=button].plus,' +
        //fix for krkcshop by HaiNN
        'form[action="/cart/add"] [data-action="decrease-quantity"].QuantitySelector__Button,' +
        'form[action="/cart/add"] [data-action="increase-quantity"].QuantitySelector__Button';
    BSS_B2B.buttonAddToCart = 'form[action="/cart/add"] button.product-form__submit[name="add"], form[action="/cart/add"] button#addToCartButton';
    BSS_B2B.buttonIncreaseQuantity =
        '[bss-b2b-card-information] button[name="plus"],' +
        '.product__info-container button[name="plus"],' +
        'form[action="/cart/add"] .incr,' +
        'button[data-action="increase-picker-quantity"],' +
        '.ecom-product-single__quantity-controls-plus,' +
        '.product-quantity-block button[type="button"]:has(.icon-plus),' +
        '.quantity__wrapper button.quantity__button[name="increment"],' +
        '.product-quantity-picker.qty .product-quantity-picker__plus.qty-plus,' + '.selector-wrapper.selector-wrapper--qty .quantity__btn.quantity__btn--increase';
    
        BSS_B2B.buttonDecreaseQuantity =
        '[bss-b2b-card-information] button[name="minus"],' +
        '.product__info-container button[name="minus"],' +
        'form[action="/cart/add"] .decr,' +
        'button[data-action="decrease-picker-quantity"],' +
        '.ecom-product-single__quantity-controls-minus,' +
        '.product-quantity-block button[type="button"]:has(.icon-minus),' +
        '.quantity__wrapper button.quantity__button[name="decrement"],' +
        '.product-quantity-picker.qty .product-quantity-picker__minus.qty-minus,' + '.selector-wrapper.selector-wrapper--qty .quantity__btn.quantity__btn--decrease';
    /**
     * Get applied rule
     * @param rule - rule{apply_to,customer_ids,customer_tags,exc_customer_tags,exclude_from,start_date,end_date}
     */
    BSS_B2B.filterRule = function (rule, customer) {
        let applyTo = rule.apply_to;
        let customerIds = rule.customer_ids;
        let customerTags = rule.customer_tags;
        let excludeCustomerTags = rule.exc_customer_tags;
        let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
        let exc_customers = rule.exc_customers;
        // if (applyTo == 0) {
        //
        // } else 
        if (applyTo === 1) {
            if (customer.id == null) {
                return false;
            }
        }
        else if (applyTo === 2) {
            if (customer.id !== null) return false;
        }
        else if (applyTo === 3) {
            if (customer.id == null) return false;
            else {
                customerIds = customerIds ? customerIds.split(',') : [];
                if (customerIds.indexOf(customer.id + '') === -1) return false;
            }
        }
        else if (applyTo === 4) {
            if (customer.tags == null) return false;
            else {
                customerTags = customerTags.split(',');
                let checkArray = customerTags.filter(tag => customer.tags.includes(tag + ''));
                if (checkArray.length === 0) return false;
            }
        }

        let startDate = rule.start_date;
        let endDate = rule.end_date;
        let currentDate = new Date();
        if (startDate && currentDate < new Date(startDate)) return false;
        if (endDate && currentDate > new Date(endDate)) return false;

        if (excludeFrom === 1) {
            if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                excludeCustomerTags = excludeCustomerTags.split(',');
                let checkArray = excludeCustomerTags.filter(tag => customer.tags.includes(tag + ''));
                if (checkArray.length > 0) return false;
            }
        }
        else if (excludeFrom === 2) {
            if (exc_customers) {
                if (exc_customers.includes(`${customer.id}`)) {
                    return false;
                }
            }
        }
        return true;
    };

    /**
     * Get element selector path
     * @param elem
     * @returns {string}
     */
    BSS_B2B.getCSSPath = function (elem) {
        if (!(elem instanceof Element)) return;
        let path = [];
        while (elem.nodeType === Node.ELEMENT_NODE) {
            let selector = elem.nodeName.toLowerCase();
            if (selector === 'html') {
                // do nothing
            }
            else if (elem.id) {
                selector += '#' + elem.id;
            }
            else {
                let sib = elem, nth = 1;
                while (sib.nodeType === Node.ELEMENT_NODE && (sib = sib.previousSibling) &&
                    (sib.nodeName.toLowerCase() === selector) && nth++);
                selector += ':nth-of-type(' + nth + ')';
            }
            path.unshift(selector);
            elem = elem.parentNode;
        }
        return path.join(' > ');
    };

    BSS_B2B.getCPRulesByCustomer = function (appliedCP, customer) {
        let cpRules = [];
        let plRules = [];
        if (appliedCP) {
            cpRules = BSS_B2B.configData.filter((rule) => BSS_B2B.filterRule(rule, customer));
            plRules = BSS_B2B.plConfigData.filter((rule) => BSS_B2B.filterRule(rule, customer));
        }
        BSS_B2B.plRules = plRules;
        BSS_B2B.cpRules = cpRules;
    };

    BSS_B2B.getCPRuleByProduct = function (appliedCP, product, variantId) {
        let rule = null;
        if (appliedCP) {
            let productApplyPL = false;
            let variantApplyPL = false;
            BSS_B2B.plRules.length > 0 && BSS_B2B.plRules.every((plRule) => {
                if (plRule.selected_products && plRule.selected_products.length > 0) {
                    plRule.selected_products.every((selected_product) => {
                        if (product.id === parseInt(selected_product.product_id) && !productApplyPL) {
                            rule = {
                                'id': product.id,
                                'discount_type': selected_product.discount_type,
                                'value': selected_product.discount_value,
                                'name': plRule.name,
                            };
                            return false;
                        }
                        return true;
                    });
                } else if (plRule.selected_variants && plRule.selected_variants.length > 0) {
                    plRule.selected_variants.every((selected_variant) => {
                        if (product.id === parseInt(selected_variant.product_id) && parseInt(selected_variant.variant_id) === parseInt(variantId) && !variantApplyPL) {
                            rule = {
                                'id': product.id,
                                'discount_type': selected_variant.discount_type,
                                'value': selected_variant.discount_value,
                                'name': plRule.name,
                            };
                            variantApplyPL = true;
                            productApplyPL = true;
                            return false;
                        }
                        return true;
                    });
                    if (!rule) {
                        plRule.selected_variants.every((selected_variant) => {
                            if (Object.keys(product.variantIdArrayMap).find((variant) => variant == selected_variant.variant_id)) {
                                productApplyPL = true;
                                return false;
                            }
                            return true;
                        });
                    }
                }
                return true;
            });

            let productApplyCP = false;
            (rule === null && productApplyPL === false) && BSS_B2B.cpRules.length > 0 && BSS_B2B.cpRules.every((cpRule) => {
                let productConditionType = cpRule.product_condition_type;
                let productIds = cpRule.product_ids ? cpRule.product_ids.split(',') : [];
                let productCollections = cpRule.product_collections ? cpRule.product_collections.split(',') : [];
                let productVariants = cpRule.product_variants ? cpRule.product_variants.split(',') : [];
                let tags = product.tags;

                if (productConditionType === 0 && !productApplyCP) {
                    rule = {
                        'id': product.id,
                        'discount_type': cpRule.discount_type,
                        'value': cpRule.discount_value,
                        'name': cpRule.name,
                    };
                    return false;
                }
                else if (productConditionType === 1) {
                    if (productIds.indexOf(product.id + '') !== -1 && !productApplyCP) {
                        rule = {
                            'id': product.id,
                            'discount_type': cpRule.discount_type,
                            'value': cpRule.discount_value,
                            'name': cpRule.name,
                        };
                        return false;
                    }
                }
                else if (productConditionType === 2) {
                    let checkArray = product.collections.filter(
                        (collection) => productCollections.includes(collection + ''));
                    if (checkArray.length > 0 && !productApplyCP) {
                        rule = {
                            'id': product.id,
                            'discount_type': cpRule.discount_type,
                            'value': cpRule.discount_value,
                            'name': cpRule.name,
                        };
                        return false;
                    }
                }
                else if (productConditionType === 3) {
                    let checkArray = product.tags.filter((tag) => tags.includes(tag + ''));
                    if (checkArray.length > 0 && !productApplyCP) {
                        rule = {
                            'id': product.id,
                            'discount_type': cpRule.discount_type,
                            'value': cpRule.discount_value,
                            'name': cpRule.name,
                        };
                        return false;
                    }
                }
                else if (productConditionType === 4) {
                    let checkArray = productVariants.includes(variantId + '');
                    if (checkArray) {
                        rule = {
                            'id': product.id,
                            'discount_type': cpRule.discount_type,
                            'value': cpRule.discount_value,
                            'name': cpRule.name,
                        };
                        return false;
                    } else {
                        productApplyCP = Object.keys(product.variantIdArrayMap).find((variant) => productVariants.includes(variant + ''))
                    }
                }
                return true;
            });
        }
        return rule;
    };

    BSS_B2B.onChangeVariant = function (modules) {
        const Tax = __webpack_require__(1);
        const taxDisplayRules = __webpack_require__(2);
        const checkTimesLimit = 50;

        let parentSelector = '';
        const changeParentSelector = function (selector, ...storeIds) {
            if (storeIds.indexOf(BSS_B2B.storeId) !== -1) {
                parentSelector = selector;
            }
        };
        // add parent selector if nessessary, e.g. changeParentSelector('.parent-selector', 2998)
        // or changeParentSelector('.parent-selector', 2998, 3000)
        // or changeParentSelector('.parent-selector', [2998, 3000])
        changeParentSelector('.bss-b2b-example', 0);
        // end add
        const productContainerSelectors = [
            '.product__info-container',
            '#ProductSection[data-section-id="product-template"]',
        ].map((selector) => parentSelector + selector).join(',');

        const variantSelectors = [
            '.product-form input[name="id"]',
            'select[name="id"]',
            'select#productSelect-product-template-option-0.single-option-selector',
        ].join(',');

        const handleProductContainerFound = (productContainers) => {
            for (let i = 0; i < productContainers.length; i++) {
                let productContainer = productContainers[i];
                let variantCheckTimes = 0;
                let variantCheck = setInterval(() => {
                    let variant = productContainer.querySelector(variantSelectors);
                    if (variant || variantCheckTimes >= checkTimesLimit) {
                        clearInterval(variantCheck);
                    }
                    if (variant) {
                        let event = new CustomEvent('bss_b2b_variant_found', {
                            detail: { productContainer, variant },
                        });
                        window.dispatchEvent(event);
                    }
                    variantCheckTimes += 1;
                }, 500);
            }
        };

        const handleVariantFound = (productContainer, variant) => {
            let variantChangeTimeout = 1500;
            if (BSS_B2B.storeId === 9209) {
                variantChangeTimeout = 0;
            }
            if (BSS_B2B.storeId === 15312) {
                variantChangeTimeout = 200;
            }
            variantChangeTimeout = window.BSS_B2B.executeFilter({ tag: "change_variant", storeId: 13913, val: variantChangeTimeout })
            variant.addEventListener('change', function () {
                if (modules.appliedCP) {
                    const styleVatElement = document.getElementById('hidden-style-vat');
                    if (!styleVatElement && [14891].includes(BSS_B2B.storeId) === -1) {
                        let stylesVatPrice = `
                            .bss-b2b-product-compare-price-vat, 
                            .bss-b2b-product-vat {                     
                                visibility: hidden;                 
                            };`;
                        let styleSheet = document.createElement('style');
                        styleSheet.id = 'hidden-style-vat';
                        styleSheet.type = 'text/css';
                        styleSheet.innerText = stylesVatPrice;
                        document.head.appendChild(styleSheet);
                    }
                    if (BSS_B2B.storeId === 15312) {
                        let stylesVatPrice = `[bss-b2b-variant-id][bss-b2b-product-id] {
                                visibility: hidden !important;  
                            }`
                        let styleSheet = document.createElement('style');
                        styleSheet.id = 'hidden-style-when-change-variant';
                        styleSheet.type = 'text/css';
                        styleSheet.innerText = stylesVatPrice;
                        document.head.appendChild(styleSheet);
                    }
                }
                setTimeout(function () {
                    let variantId = variant.getAttribute('value');
                    if (BSS_B2B.storeId === 2525) {
                        variantId = document.getElementById('productSelect-product-template').value;
                    }
                    if (!variantId) {
                        // another way to retrieve variant id
                    }
                    if (variantId) {
                        let price = productContainer.querySelector('.price__regular .price-item span');
                        if (!price) {
                            // another way to retrieve variant price element
                            if (BSS_B2B.storeId === 2525) price = productContainer.querySelector(
                                '#main_price_product-template span.h1 > span.money > span.money');
                        }
                        if (price) {
                            price = price.innerHTML.replace(/\D/g, '');
                            // re-calculate price if nessessary
                            price = parseFloat(price) * 100;
                        }
                        // another way to retrieve variant price value

                        if (price || price === 0) {
                            if (modules.appliedCP) {
                                // not handle yet in present
                                // fix for spill-safety-by-myrins by DongNV, fix yotreasure.myshopify.com by PhuongKD
                                if ([4615, 10829].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false, false, variantId);
                                }
                                if (BSS_B2B.storeId === 2525 && !modules.appliedTD) {
                                    let productId = productContainer.querySelector(
                                        '#main_price_product-template span.h1').getAttribute('bss-b2b-product-id');
                                    productContainer.querySelector('#main_price_product-template span.h1 > span.money').
                                        setAttribute('bss-b2b-product-id', productId);
                                    productContainer.querySelector('#main_price_product-template span.h1 > span.money').
                                        setAttribute('bss-b2b-product-price', '');
                                    productContainer.querySelector('#main_price_product-template span.h1 > span.money').
                                        setAttribute('bss-b2b-variant-price', '');
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false, false, variantId);
                                }
                                else {
                                    if (BSS_B2B.storeId === 15312) {
                                        window.BSS_B2B.executeAction({ tag: "change_variant", storeId: 15312, BSS_B2B: window.BSS_B2B, shopData, variantId })
                                    } else {
                                        BSS_B2B.cp.changeProductPrice(shopData, false, false, true, variantId);
                                    }
                                }
                            }

                            if (modules.appliedTD) {
                                let bssB2BTaxDisplayElement = null;
                                if (BSS_B2B.page.isProductPage()) {
                                    BSS_B2B.removeCartVatStyleWhenNotApplicable();
                                    bssB2BTaxDisplayElement = productContainer.querySelector('.bss-b2b-product-vat');
                                    if (bssB2BTaxDisplayElement &&
                                        bssB2BTaxDisplayElement.querySelector('#bss-b2b-product-data')) {
                                        let bssB2BProductData = JSON.parse(
                                            bssB2BTaxDisplayElement.querySelector('#bss-b2b-product-data').innerText);
                                        let appliedCPRule = BSS_B2B.getCPRuleByProduct(modules.appliedCP,
                                            bssB2BProductData, variantId);
                                        price = bssB2BProductData.variantIdArrayMap[variantId].price;
                                        if (modules.appliedCP && appliedCPRule) {
                                            price = BSS_B2B.getModifiedPrice(price, appliedCPRule.discount_type,
                                                appliedCPRule.value);
                                        }
                                        if (!appliedCPRule) {
                                            $(`.bss-b2b-product-compare-price-vat[data-product-id="${bssB2BProductData.id}"]`).hide()
                                        }
                                        // show product vat price
                                        Tax.bssB2BChangeVatPrice(variantId, shopData, price);
                                    }
                                }
                                else {
                                    // check if featured product, using field "section" and "parentSelector" to show
                                    // only prices with this selector
                                    let isFeaturedProductSelectors = [
                                        '.featured-product',
                                        // add more featured selectors

                                        // or add bss-b2b-custom-featured-product attribute
                                        '[bss-b2b-custom-featured-product]',
                                    ].join(',');
                                    let isFeaturedProduct = productContainer.closest(isFeaturedProductSelectors);

                                    if (isFeaturedProduct) {
                                        shopData.section = 'featured-product';
                                        shopData.parentSelector = BSS_B2B.getCSSPath(isFeaturedProduct);
                                        shopData.variant = variantId;

                                        // show collection item vat price
                                        let appliedDisplayRule = taxDisplayRules.getAppliedRuleCollectionPage(BSS_B2B,
                                            shopData);
                                        BSS_B2B.removeCartVatStyleWhenNotApplicable();
                                        if (modules.appliedCP) {
                                            bssB2BTaxDisplayElement = productContainer.querySelector(
                                                '.bss-b2b-collection-item-vat');
                                            if (bssB2BTaxDisplayElement &&
                                                bssB2BTaxDisplayElement.querySelector('#bss-b2b-product-data')) {
                                                let bssB2BProductData = JSON.parse(
                                                    bssB2BTaxDisplayElement.querySelector(
                                                        '#bss-b2b-product-data').innerText);
                                                let appliedCPRule = BSS_B2B.getCPRuleByProduct(modules.appliedCP,
                                                    bssB2BProductData, variantId);
                                                price = bssB2BProductData.variantIdArrayMap[variantId].price;
                                                if (appliedCPRule) {
                                                    price = BSS_B2B.getModifiedPrice(price, appliedCPRule.discount_type,
                                                        appliedCPRule.value);
                                                }
                                                if (!appliedCPRule) {
                                                    $(`.bss-b2b-product-compare-price-vat[data-product-id="${bssB2BProductData.id}"]`).hide()
                                                }
                                                setTimeout(() => {
                                                    Tax.bssB2BChangeCollectionItemVatPrice(bssB2BProductData.id,
                                                        shopData, price, appliedDisplayRule);
                                                }, 300);
                                            }
                                        }
                                        else {
                                            Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData,
                                                appliedDisplayRule);
                                        }
                                    }
                                }
                                let stylesVatPrice = document.getElementById('hidden-style-vat');
                                if (stylesVatPrice) {
                                    setTimeout(() => {
                                        document.head.removeChild(stylesVatPrice);
                                    }, 300);
                                }
                            }
                        }
                    }
                }, variantChangeTimeout);
            });
        };

        window.addEventListener('bss_b2b_product_container_found', function (evt) {
            handleProductContainerFound(evt.detail.productContainers);
        });
        window.addEventListener('bss_b2b_variant_found', function (evt) {
            handleVariantFound(evt.detail.productContainer, evt.detail.variant);
        });

        let productContainerCheckTimes = 0;
        let productContainerCheck = setInterval(() => {
            let productContainers = document.querySelectorAll(productContainerSelectors);
            if (productContainers.length > 0 || productContainerCheckTimes >= checkTimesLimit) {
                clearInterval(productContainerCheck);
            }
            if (productContainers.length > 0) {
                let event = new CustomEvent('bss_b2b_product_container_found', {
                    detail: { productContainers },
                });
                window.dispatchEvent(event);
            }
            productContainerCheckTimes += 1;
        }, 500);
    };

    BSS_B2B.onDiscountCodeSubmit = function () {
        const handleApplyDiscountCode = () => {
            let hrefArr = window.location.href.split('/');
            let isCart = (hrefArr[hrefArr.length - 1] === 'cart' || hrefArr[hrefArr.length - 1].includes('cart'));
            if (BSS_B2B.storeId === 2631 && isCart) {
                let documentWidth = window.innerWidth;
                if (documentWidth > 766) {
                    let mobileWrapper = document.querySelector(
                        '.cart--root[data-view=mobile] .bss-b2b-discount-code-wrapper');
                    if (mobileWrapper) {
                        mobileWrapper.remove();
                    }
                }
                else {
                    let unusualMobileEl = document.querySelector(
                        '.off-canvas--right-sidebar .cart--root[data-view=mobile] .bss-b2b-discount-code-wrapper');
                    let desktopWrapper = document.querySelector(
                        '.cart--root[data-view=desktop] .bss-b2b-discount-code-wrapper');
                    if (unusualMobileEl) {
                        unusualMobileEl.remove();
                    }
                    if (desktopWrapper) {
                        desktopWrapper.remove();
                    }
                }
            }

            if (BSS_B2B.storeId === 4258 && isCart) {
                let cartDrawerDCForm = document.querySelector('#CartDrawerForm .bss-b2b-discount-code-wrapper');
                if (cartDrawerDCForm) {
                    cartDrawerDCForm.remove();
                }
            }

            let btnApplyDiscountCodes = document.querySelectorAll('#bss-b2b-discount-code-submit');
            let messageDiscountCodes = document.querySelectorAll('#bss-b2b-discount-code-message');
            let discountCodeInputs = document.querySelectorAll('#bss-b2b-discount-code-input');
            let discountCodesApplied = document.querySelectorAll('#bss-b2b-discount-code-applied-wrapper');

            if (btnApplyDiscountCodes.length && messageDiscountCodes.length && discountCodeInputs.length && discountCodesApplied.length) {
                for (let j = 0; j < btnApplyDiscountCodes.length; j++) {
                    let btnApplyDiscountCode = btnApplyDiscountCodes[j];
                    let messageDiscountCode = messageDiscountCodes[j];
                    let discountCodeInput = discountCodeInputs[j];

                    btnApplyDiscountCode && btnApplyDiscountCode.addEventListener('click', async (event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        btnApplyDiscountCode.classList.add('loading');
                        btnApplyDiscountCode.disabled = true;
                        messageDiscountCode.innerHTML = '';
                        let discountCode = discountCodeInput.value;

                        if (discountCode == null || discountCode.trim() === '') {
                            let messageNull = BSS_B2B.dcTranslations.message_discount_code_null;
                            if (BSS_B2B.integrate && BSS_B2B.integrate.langShop &&
                                BSS_B2B.integrate.langShop.dcTranslations
                                && BSS_B2B.integrate.langShop.dcTranslations.message_discount_code_null
                            ) {
                                messageNull = BSS_B2B.integrate.langShop.dcTranslations.message_discount_code_null;
                            }
                            messageDiscountCode.style.color = 'red';
                            messageDiscountCode.innerHTML = '<span class="bss-b2b-translation-dc-message_discount_code_null">' +
                                messageNull + '</span>';
                        }
                        else {
                            let today = new Date();
                            let moment = today.toLocaleTimeString(undefined,
                                { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
                            today.setUTCHours(0, 0, 0, 0);
                            let shopDataHTML = JSON.parse(document.getElementById('bss-b2b-store-data').innerHTML);
                            let shopDataRes = await fetch(encodeURI('/cart.js'));
                            let shopData = await shopDataRes.json();
                            let handleUrls = [];
                            let handles = [];
                            let cartItemsMap = new Map();
                            for (let i = 0; i < shopData.items.length; i++) {
                                let item = shopData.items[i];
                                let proId = item.product_id;
                                if (handles.indexOf(proId) === -1) {
                                    handles.push(proId);
                                    handleUrls.push('id:"' + proId + '"');
                                    cartItemsMap.set(proId, []);
                                }
                                let cartItems = cartItemsMap.get(proId);
                                cartItems.push(item);
                                cartItemsMap.set(proId, cartItems);
                            }
                            let urlData = '/search?q=' + handleUrls.join(' OR ') + '&view=bss.b2b';
                            const encodeUrlData = encodeURI(urlData);
                            let productCartPage = await fetch(encodeUrlData);
                            let responseProducts = await productCartPage.json();
                            if (BSS_B2B.storeId === 3576) {
                                if (responseProducts.length != handleUrls.length) {
                                    handleUrls.forEach((item) => {
                                        if (!responseProducts.some((product) => item.includes(product.id))) {
                                            let productId = +(item.match(/\d/g).join(''));
                                            responseProducts.push({
                                                id: productId,
                                            });
                                        }
                                    });
                                }
                            }
                            if (responseProducts.length > 0) {
                                let productMap = [];
                                let checkUnique = [];
                                for (let i = 0; i < responseProducts.length; i++) {
                                    let pro = responseProducts[i];
                                    if (checkUnique.indexOf(pro.id) === -1) {
                                        checkUnique.push(pro.id);
                                        cartItemsMap.get(pro.id).forEach(function (cartItem) {
                                            productMap.push({
                                                id: pro.id,
                                                tags: pro.tags,
                                                collections: pro.collections,
                                                key: cartItem.key,
                                                price: parseFloat(cartItem.price),
                                                title: pro.title,
                                                quantity: parseInt(cartItem.quantity)
                                            });
                                        });
                                    }
                                }
                                let cpPricingList = [];
                                let qbPricingList = [];
                                for (const [key, value] of BSS_B2B.cart.cpPricingList) {
                                    cpPricingList.push({
                                        key: key,
                                        modifiedItemPrice: value.modifiedItemPrice
                                    })
                                }
                                for (const [key, value] of BSS_B2B.cart.qbPricingList) {
                                    qbPricingList.push({
                                        key: key,
                                        modifiedItemPrice: value.pricePerItemAfterApplyQB
                                    })
                                }
                                let data = {
                                    today: today,
                                    moment: moment,
                                    customer: shopDataHTML.customer,
                                    cart_items: productMap,
                                    domain: shopDataHTML.shop.permanent_domain,
                                    discount_code: discountCode,
                                    cpPricingList: cpPricingList,
                                    qbPricingList: qbPricingList,
                                }
                                await fetch(bssB2bApiServer + "/dc/rules/get-applied-rule?domain=" + shopDataHTML.shop.permanent_domain, {
                                    method: "POST",
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(data)
                                })
                                    .then(response => response.json())
                                    .then(async function (data) {
                                        if (data.success) {
                                            const dcContent = "<div id=\"bss-b2b-discount-code-applied\">" +
                                                "<span>"
                                                + discountCode +
                                                "</span>" +
                                                "<div id=\"bss-b2b-clear-discount-code\">\n" +
                                                "&#x2716;\n" +
                                                "</div>" +
                                                "</div>";

                                            const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                                            if (dcWrapperElements && dcWrapperElements.length > 0) {
                                                dcWrapperElements.forEach((element) => {
                                                    const dcInputElement = element.querySelector('#bss-b2b-discount-code-input');
                                                    const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');
                                                    const dcAppliedWrapperElements = element.querySelector("#bss-b2b-discount-code-applied-wrapper");

                                                    dcInputElement.value = discountCode;
                                                    dcInputElement.setAttribute('discount-code', 'true');
                                                    dcMessagesElement.style.color = 'green';
                                                    dcAppliedWrapperElements.innerHTML = dcContent;

                                                    if (BSS_B2B.storeId === 7056) {
                                                        // fix on safari for 'decibelacoustics.myshopify.com'
                                                        setTimeout(() => {
                                                            dcMessagesElement.innerHTML = 'Success! Click on "Check out" to see the discounted price.';
                                                        }, 300);
                                                        setTimeout(() => {
                                                            dcMessagesElement.innerHTML = 'Success! Click on "Check out" to see the discounted price.';
                                                        }, 1000);
                                                        dcMessagesElement.innerHTML = 'Success! Click on "Check out" to see the discounted price.';
                                                    } else if (BSS_B2B.storeId === 9220) {
                                                        dcMessagesElement.innerHTML = data.message + '. Your price will be discounted in checkout page.';
                                                    } else {
                                                        dcMessagesElement.innerHTML = data.message;
                                                    }
                                                })
                                            }
                                            BSS_B2B.integrate.langShop.handleAllTranslation('dc', ['message_success_discount_code']);

                                            handleRemoveDiscountCodeApplied();
                                            const { token, ...res } = data.data;
                                            const infoUpdate = {
                                                dc_keys: res.listKeysItemAppliedDC,
                                                dc_products: res.listProductIdsAppliedDC,
                                                rule_id: res.ruleId,
                                                discount_value: res.discountValue,
                                                discount_type: res.discountType,
                                                discount_code: res.discountCode,
                                                discount_code_type: res.discountCodeType,
                                                token: token
                                            }
                                            let dataUpdate = {
                                                attributes: {
                                                    discountCodeRule: JSON.stringify(infoUpdate)
                                                }
                                            };
                                            const cartDataRes = await fetch("/cart/update.js", {
                                                method: "POST",
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify(dataUpdate)
                                            })

                                            const cartData = await cartDataRes.json();
                                            window.BSS_B2B.executeAction({
                                                tag: 'customize_dc',
                                                storeId: 7597,
                                                BSS_B2B, cartData,
                                                dcRule: infoUpdate,
                                                isRemove: false
                                            });
                                        } else {
                                            if (data.errorMinimumPurchase) {
                                                const { minimumPurchaseType, minimumPurchaseValue, translationTexts, discountCode, listItemAppliedDc } = data.errorMinimumPurchase
                                                if (BSS_B2B.storeId === 3793 && minimumPurchaseType === 1) {
                                                    BSS_B2B.customizeShowModalMessageErrorMinimumPurchase(data)
                                                } else {
                                                    let textErrorMinimumPurchase = ""
                                                    if (minimumPurchaseType === 1) {
                                                        textErrorMinimumPurchase = translationTexts.text_warning_amount_discount_code.replace("{{discount_code}}", discountCode)
                                                            + `: ${BSS_B2B.formatMoney(minimumPurchaseValue * 100)}`
                                                    } else {
                                                        textErrorMinimumPurchase = translationTexts.text_warning_quantity_discount_code.replace("{{discount_code}}", discountCode)
                                                            + `: ${minimumPurchaseValue} ${translationTexts.warning_products_discount_code}`;
                                                    }

                                                    const messageErrorMinimumPurchase = `
                                                        <p class="header_warning_appliedRule">${textErrorMinimumPurchase}</p>
                                                        <ul class="list_product_appliedRule">
                                                            ${listItemAppliedDc.map(item => {
                                                        return `
                                                                <li>
                                                                    ${item.title}
                                                                </li>
                                                            `
                                                    }).join(" ")}
                                                        </ul>
                                                    `;
                                                    const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                                                    if (dcWrapperElements && dcWrapperElements.length > 0) {
                                                        dcWrapperElements.forEach((element) => {
                                                            const dcInputElement = element.querySelector('#bss-b2b-discount-code-input');
                                                            const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');
                                                            dcInputElement.value = discountCode;
                                                            dcMessagesElement.innerHTML = messageErrorMinimumPurchase;
                                                            dcMessagesElement.style.color = 'red';
                                                        })
                                                    }
                                                }
                                            } else {
                                                const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                                                if (dcWrapperElements && dcWrapperElements.length > 0) {
                                                    dcWrapperElements.forEach((element) => {
                                                        const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');
                                                        dcMessagesElement.innerHTML = data.message
                                                        dcMessagesElement.style.color = 'red'
                                                    })
                                                }
                                            }
                                            BSS_B2B.integrate.langShop.handleAllTranslation('dc', ['message_error_discount_code']);
                                        }
                                    }).catch((error) => {
                                        // eslint-disable-next-line no-console
                                        console.error('Error:', error);
                                    });
                            }
                        }
                        const customEvent = new Event('BSS_DC_doneCheck');
                        document.dispatchEvent(customEvent);
                        btnApplyDiscountCode.classList.remove('loading');
                        btnApplyDiscountCode.disabled = false;
                    })
                }
            }
        };

        const handleRemoveDiscountCodeApplied = () => {
            const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
            if (dcWrapperElements && dcWrapperElements.length > 0) {
                dcWrapperElements.forEach((element) => {
                    const clearDiscountCodeBtn = element.querySelector('#bss-b2b-clear-discount-code');
                    clearDiscountCodeBtn.addEventListener('click', async (event) => {
                        event.preventDefault();

                        dcWrapperElements.forEach((ele) => {
                            const dcInputElement = ele.querySelector('#bss-b2b-discount-code-input');
                            const dcMessagesElement = ele.querySelector('#bss-b2b-discount-code-message');
                            const dcAppliedWrapperElements = ele.querySelector("#bss-b2b-discount-code-applied-wrapper");

                            dcInputElement.value = '';
                            dcInputElement.removeAttribute('discount-code');
                            dcMessagesElement.innerHTML = '';
                            dcAppliedWrapperElements.innerHTML = '';
                        })

                        let dataUpdateJSON = JSON.stringify({});
                        let dataUpdate = {
                            attributes: {
                                discountCodeRule: dataUpdateJSON,
                            },
                        };
                        const cartDataRes = await fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(dataUpdate),
                        });

                        if (BSS_B2B.storeId === 7597) {
                            const cartData = await cartDataRes.json();
                            window.BSS_B2B.executeAction({
                                tag: 'customize_dc',
                                storeId: 7597,
                                BSS_B2B, cartData,
                                dcRule: JSON.parse(dataUpdateJSON),
                                isRemove: false
                            });
                        }

                        if (BSS_B2B.storeId === 4339) {
                            setTimeout(function () {
                                handleApplyDiscountCode();
                            }, 1000);
                        }
                    });
                })
            }
        };

        if (BSS_B2B.storeId !== 2631) {
            handleApplyDiscountCode();
        }
        else {
            setTimeout(function () {
                handleApplyDiscountCode();
            }, 1000);
        }
    };

    BSS_B2B.customizeShowModalMessageErrorMinimumPurchase = async (data) => {
        const { minimumPurchaseValue, translationTexts, discountCode, listItemAppliedDc } = data.errorMinimumPurchase
        $("#modalWarningDc").remove();
        let textErrorMinimumPurchase = translationTexts.text_warning_amount_discount_code.replace("{{discount_code}}", discountCode)
        let warningsModalDc = "<div id='modalWarningDc'>\n" +
            "<div class='bss-modal-warning-dc-wrap' tabindex='-1'>" +
            "<div class='bss-modal-dc activeDc'>" +
            "<div class='bss-modal-dc-container'>" +
            "<div class='bss-modal-dc-header'>" +
            "<button title='Close (Esc)' type='button' class='bss-modal-dc-button-close'>×</button>" +
            "<b class='bss-modal-dc-title'>" + `Warning` + "</b>\n" +
            "</div>" +
            "<div class='bss-modal-dc-body'>" +
            "<div class='bss-dc-list-warning'>" +
            "<span class='bss-warning-dc-minimum-quantity-title'>" + `${textErrorMinimumPurchase}` + `: ${BSS_B2B.formatMoney(minimumPurchaseValue * 100)}`;

        warningsModalDc += "</span>";
        warningsModalDc += "<ol class='bss-dc-list-warning-amount'>\n" +
            "</ol>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>"
        if (!$('#modalWarningDc').length) {
            $("body").prepend(warningsModalDc);
            if ($("body").hasClass("gradient")) {
                $("body.gradient").css("pointer-events", "none");
            }
        }
        let listWarningDc = $('.bss-dc-list-warning-amount');
        if (listWarningDc && listItemAppliedDc.length) {
            listItemAppliedDc.map(item => {
                let itemElement = "<li class='bss-amo-text-warning' data-warning-dc-minimum-amount  style='display: block'>" + item.title + "</li>";
                listWarningDc.prepend(itemElement);
            });
            $(".bss-modal-dc-button-close").on("click", function () {
                $("#modalWarningDc").remove();
                if ($("body").hasClass("gradient")) {
                    $("body.gradient").css("pointer-events", "auto");
                }
            })
        }
    }

    BSS_B2B.changeProductPriceWithInterval = function () {
        let elementSelectors = [
            '[bss-b2b-product-id][bss-b2b-product-price]:not([bss-b2b-product-active])',
        ].join(',');
        let elementCheckTimes = 0;
        let elementCheck = setInterval(function () {
            let elements = document.querySelectorAll(elementSelectors);
            if (elements || elementCheckTimes > 50) {
                clearInterval(elementCheck);
                if (elements.length) {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                }
                return;
            }
            elementCheckTimes += 1;
        }, 500);
    };
    BSS_B2B.getAppliedRuleQbForItemDiscountCode = function (product, customer, qbRules, isEnableQb) {
        isEnableQb === 1 ? true : false;
        if (!isEnableQb) {
            return false;
        }
        qbRules.sort((a, b) => {
            return a.priority - b.priority;
        });
        let appliedRule = false;
        qbRules.length > 0 && qbRules.forEach(rule => {
            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids ? rule.customer_ids.split(',') : [];
            let customerTags = rule.customer_tags ? rule.customer_tags.split(',') : [];
            let excludeCustomerTags = rule.exc_customer_tags ? rule.exc_customer_tags.split(',') : [];
            let excludeFrom = rule.exclude_from;
            if (excludeFrom) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.map((tag) => tag.toLowerCase());
                    let checkArray = excludeCustomerTags.filter(tag => customer.tags.includes(tag + ''));
                    if (checkArray.length > 0) {
                        return;
                    }
                }
            }
            if (applyTo === 0) {
                // no thing
            }
            else if (applyTo === 1) {
                if (customer.id === null) {
                    return;
                }
            }
            else if (applyTo === 2) {
                if (customer.id !== null) {
                    return;
                }
            }
            else if (applyTo === 3) {
                if (customer.id === null) {
                    return;
                }
                else {
                    if (customerIds.indexOf(customer.id + '') === -1) {
                        return;
                    }
                }
            }
            else if (applyTo === 4) {
                if (customer.tags === null) {
                    return;
                }
                else {
                    customerTags = customerTags.map(tag => tag.toLowerCase().trim());
                    let tagsOfCustomer = customer.tags.map(tag => tag.toLowerCase().trim());
                    let checkArray = customerTags.filter(tag => tagsOfCustomer.includes(tag));
                    if (checkArray === 0) {
                        return;
                    }
                }
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(',') : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(',') : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(',') : [];

            if (conditionType === 0) {
                appliedRule = rule;
            }
            else if (conditionType === 1) {
                if (specificProductIds.includes(product.id + '') !== -1) {
                    appliedRule = rule;
                }
            }
            else if (conditionType === 2) {
                let collections = product.collections;
                let checkArray = ruleCollectionIds.filter(collection => collections.includes(collection + ''));
                if (checkArray.length) {
                    appliedRule = rule;
                }
            }
            else if (conditionType === 3) {
                let productTags = product.tags.map(tag => tag.toLowerCase().trim());
                ruleTags.map(tag => tag.toLowerCase().trim());
                let checkArray = ruleTags.filter(tag => productTags.includes(tag));
                if (checkArray.length) {
                    appliedRule = rule;
                }

            }
        });
        return appliedRule;
    };
    BSS_B2B.getPriceApplyQbForDiscountCode = function (appliedQbRule, price, quantity) {
        appliedQbRule.qty_table.every(item => {
            let quantityFrom = item.qty_from;
            let quantityTo = item.qty_to;
            if (quantityFrom && quantity < quantityFrom) return true;
            if (quantityTo && quantity > quantityTo) return true;
            let discountType = item.discount_type;
            let discountValue = item.discount_value;
            if (discountType === 0) {
                price = discountValue * 100 > price ? price : discountValue * 100;
            }
            else if (discountType === 1) {
                price = discountValue * 100 > price ? 0 : (price - discountValue * 100);
            }
            else if (discountType === 2) {
                price = price * (1.0 - discountValue / 100);
            }
            return false;
        });
        return price;
    };

    BSS_B2B.getItemCartMetaField = async () => {
        if (BSS_B2B.page.isCartPage() || window.location.pathname.includes("customer-portal/purchase-late") || (window.location.pathname.includes("/products") && BSS_B2B.storeId === 15588)) {
            let cartJson = {};
            if ($('.bss-b2b-cart-metafield').length) {
                cartJson = JSON.parse($('.bss-b2b-cart-metafield').html());
            }
            if (cartJson.cart) {
                await Promise.all(
                    cartJson.cart.map(async item => {
                        try {
                            const res = await fetch(item.url, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            });
                            const data = await res.text();
                            const parser = new DOMParser();
                            const htmlDoc = parser.parseFromString(data, 'text/html');
                            const storeDataInProductPage = JSON.parse(
                                $(htmlDoc.querySelector('#bss-b2b-store-data')).html());
                            if (storeDataInProductPage.collections) {
                                shopData.line_item_products.map(lineItem => {
                                    if (item.product_id === lineItem.id) {
                                        lineItem.collections = storeDataInProductPage.collections;
                                    }

                                });
                            }
                        } catch (error) {
                            // eslint-disable-next-line no-console
                            console.log('Error:', error);
                        }
                    }),
                );
            }
        }
    };

    BSS_B2B.getFeaturedProductMetaField = () => {
        let featuredProduct = {};
        if ($('.bss-b2b-featured-product-metafield').length) {
            featuredProduct = JSON.parse($('.bss-b2b-featured-product-metafield').html());
        }
        return featuredProduct;
    };

    BSS_B2B.getProductMetaField = () => {
        let productsHasMetaField = [];
        let productsJson = {};
        let featuredCollection = {};

        if ($('.bss-b2b-collection-metafield').length) {
            productsJson = JSON.parse($('.bss-b2b-collection-metafield').html());
        }
        if ($('.bss-b2b-feature-collection-metafield').length) {
            featuredCollection = JSON.parse($('.bss-b2b-feature-collection-metafield').html());
        }

        if (featuredCollection.feature_collection) {
            if (featuredCollection.id_collection) {
                for (const [key, value] of Object.entries(featuredCollection.id_collection)) {
                    featuredCollection.feature_collection.map(item => {
                        if (value.includes(item.id)) {
                            if (item.collections) {
                                item.collections = [...item.collections, +key];
                            }
                            else {
                                item.collections = [+key];
                            }
                        }
                    });
                }
            }
            productsHasMetaField = [...featuredCollection.feature_collection];
        }
        if (BSS_B2B.page.isCollectionPage() && productsJson.collection) {
            if (productsJson.id_collection) {
                for (const [key, value] of Object.entries(productsJson.id_collection)) {
                    productsJson.collection.map(item => {
                        if (value.includes(item.id)) {
                            if (item.collections) {
                                item.collections = [...item.collections, +key];
                            }
                            else {
                                item.collections = [+key];
                            }
                        }
                    });
                }
            }
            productsHasMetaField = [...productsJson.collection];
        }
        return productsHasMetaField;
    };

    BSS_B2B.removeCartVatStyleWhenNotApplicable = () => {
        const taxDisplayRules = __webpack_require__(2);
        let appliedDisplayRule = taxDisplayRules.getAppliedRuleCollectionPage(BSS_B2B, shopData);
        if (!appliedDisplayRule) {
            const cartVatStyle = document.querySelector('#bss-b2b-cart-vat-style');
            if (cartVatStyle) {
                cartVatStyle.remove();
            }
        }
    };

    Object(_convert_money_with_rate__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BSS_B2B, Shopify);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertMoneyWithRate; });
function convertMoneyWithRate(BSS_B2B, Shopify) {
    BSS_B2B.helper.convertPriceWithRate = function (priceWithOriginMarket) {
        priceWithOriginMarket = parseFloat(priceWithOriginMarket);
        return priceWithOriginMarket * Shopify.currency.rate;
    }
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modifyCheckout; });
/* harmony import */ var _helper_encode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
const Tax = __webpack_require__(1);


function modifyCheckout($, BSS_B2B, shopData, isEnableAMO, isEnableDC, isEnableQB) {
    BSS_B2B.handleCartCheckoutBtn = function (shopData) {
        window.BSS_B2B.executeAction({
            tag: `customize_checkout`,
            storeId: 15791,
            BSS_B2B
        });
        let checkoutButton = $(BSS_B2B.helper.checkoutElements);
        if ($('#dropdown-cart button.btn.btn-checkout').length) {
            $('#dropdown-cart button.btn.btn-checkout').removeAttr('onclick');
        }
        if (BSS_B2B.storeId === 7584) {
            checkoutButton = $('#shopping-cart input#checkout[type="submit"]');
        } else if(BSS_B2B.storeId === 15284){
            checkoutButton = $('button#checkout2[name="checkout2"]');
        }

        let isDone = false;
        BSS_B2B.fix.checkout.fixHandleCartCheckoutBtn(shopData, checkoutButton);

        // fix for lnccabinetry.com by cuongnq
        if ([9907, 10769, 11151, 14976].includes(BSS_B2B.storeId)) {
            setTimeout(() => {
                $(BSS_B2B.helper.checkoutElements).css({ 'pointer-events': 'unset', 'opacity': '1' });
            }, 500);
        }

        if ([10989, 13186].includes(BSS_B2B.storeId)) {
            setTimeout(() => {
                $(BSS_B2B.helper.checkoutElements).css({ 'pointer-events': 'unset', 'opacity': '1' });
            }, 3000);
        }

        if ([12023].includes(BSS_B2B.storeId)) {
            setTimeout(() => {
                $(BSS_B2B.helper.checkoutElements).css({ 'pointer-events': 'unset', 'opacity': '1' });
            }, 1500);
        }

        BSS_B2B.addEventCheckoutBTN = true;

        if ([9398].includes(BSS_B2B.storeId)) {
            const button = document.getElementById('cart-sidebar-checkout');
            button && button.removeAttribute('onclick');
        }

        if ([11586].includes(BSS_B2B.storeId)) {
            const spinner = $('.btn-checkout .spinner-border.spinner-border-sm');
            spinner.removeClass('spinner-border spinner-border-sm');
            const btnCheckout = document.querySelector('.btn-checkout');
            if (btnCheckout) {
                btnCheckout.textContent = 'Checkout';
            }
        }

        if (BSS_B2B.storeId === 5686 && checkoutButton.length) {
            let buttonCheckout = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
            if (buttonCheckout.length) {
                buttonCheckout.forEach((button) => {
                    button.removeAttribute('onclick');
                });
            }
        }

        if ([8113].includes(BSS_B2B.storeId)) {
            localStorage.removeItem('bss_handling_checkout');
        }
        if (BSS_B2B.storeId === 12911 && checkoutButton.length) {
            let buttonCheckout = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
            if (buttonCheckout.length) {
                buttonCheckout.forEach((button) => {
                    button.removeAttribute('href');
                });
            }
        }

        if ([13794, 12886, 13573, 13790, 4856, 6289, 6412, 6365, 6366].includes(BSS_B2B.storeId)) {
            $(BSS_B2B.helper.checkoutElements).attr('bss-b2b-checkout-button', 'true')
        }

        window.BSS_B2B.executeAction({ tag: `setup_qi_cart_page`, storeId: 9220, shopData });

        // Integration App BSS Subscription
        if (window.BSS_SUB && window.BSS_SUB.isHasSampleSubInCart) { // remove checkout event to add payment method by checkout default
            return
        }

        if ([14921, 14939, 11857, 15241, 12849, 12567, 14724, 15486, 15165, 15813, 15951, 6556, 15856].includes(BSS_B2B.storeId)) {
            const defaultBtnCheckout = $(checkoutButton).parent().find("button[name='checkout'], #checkout")
            if (defaultBtnCheckout.length > 0) {
                defaultBtnCheckout.css("display", "none")
                $("#bss-checkout").css("display", "block")
            }
            const handleDuplicateCheckoutData = { Tax }
            window.BSS_B2B.executeAction({ tag: `handle_duplicate_checkout`, storeId: false, checkoutButton, ...handleDuplicateCheckoutData });
        }
        checkoutButton.on('click', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            e.stopPropagation();
            $(this).off();

            // Integration App Zapiet
            if (BSS_B2B.integration && BSS_B2B.integration.Zapiet) {
                if (window && window.ZapietCheckoutEnabled === false) {
                    checkoutButton.css({ 'pointer-events': 'none' });
                    setTimeout(() => {
                        const pickupElement = document.querySelector('#storePickupApp');
                        if (pickupElement) {
                            const checkoutMethod = pickupElement.querySelector('.checkoutMethodContainer');
                            let textMessage = '';
                            if (checkoutMethod) {
                                if (checkoutMethod.classList.contains('shipping')) {
                                    textMessage = 'Please choose a date for shipping.';
                                }
                                else if (checkoutMethod.classList.contains('delivery')) {
                                    textMessage = 'Please enter a valid zipcode and select your preferred date and time for delivery.';
                                }
                                else if (checkoutMethod.classList.contains('pickup')) {
                                    textMessage = 'Please select a date and time for pickup.';
                                }
                            }
                            const errorMessage = pickupElement.querySelector('p.error[role="alert"]');
                            if (!errorMessage) {
                                const customMessage = document.createElement('p');
                                customMessage.classList.add('error');
                                customMessage.setAttribute('role', 'alert');
                                customMessage.innerText = textMessage;
                                pickupElement.appendChild(customMessage);
                            }
                        }
                    }, 200);
                    return false;
                }
            }

            //fix for flyinghighcannabis.ca
            // fix for mybioma by Devlin
            if ([13842, 9237, 4150, 6526, 3562, 3051, 11001, 6932, 9331, 11265, 8718, 621, 12294, 8005, 7567, 12879, 12829, 8553, 6579, 14810, 12806, 14511, 10876, 13249, 16352, 12875].includes(
                BSS_B2B.storeId)) {
                checkoutButton.css({ 'pointer-events': 'none', 'opacity': '0.6' });
            }

            // fix for valera-prod.myshopify.com
            if ([7691].includes(BSS_B2B.storeId)) {
                let termsOfServiceEle = document.querySelector('.cart__footer .terms-relentless > input');
                if (termsOfServiceEle && !termsOfServiceEle.checked) {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                    return;
                }
            }

            // fix for luxuryskincarebrands.co.uk by cuongnq
            if ([986].includes(BSS_B2B.storeId)) {
                BSS_B2B.handleCartCheckoutBtn(shopData);
            }

            //fix for pisen
            if ([4999, 6932, 13831].includes(BSS_B2B.storeId)) {
                checkoutButton.hide();
            }
            if ([3787, 5273, 621, 12875].includes(BSS_B2B.storeId)) {
                checkoutButton.off();
            }
            // fix for euro-trade.com by LuanHV
            if (BSS_B2B.storeId == 6605) {
                let span = document.createElement('span');
                span.classList.add('bss-custom-loading');
                $(this).append(span);
            }
            let self = this;
            let parentForm = $(this).closest('form');
            let isEnabledVatValidate = false;
            let isEnableCartNote = false;

            let invalidIncrementProduct = BSS_B2B.qi.invalidIncrementProducts;
            if (invalidIncrementProduct) {
                BSS_B2B.qi.renderWarningMessage(invalidIncrementProduct);
                return;
            }

            if (BSS_B2B.shopModules && BSS_B2B.shopModules.length) {
                BSS_B2B.shopModules.forEach(function (md) {
                    if (md.code === 'tax_exempt') {
                        isEnabledVatValidate = md.status;
                    }
                    else if (md.code === 'cart_note') {
                        isEnableCartNote = md.status;
                    }
                });
            }
            // add custom field
            let customFieldValue = [];
            // add cart note default
            let cartNotesDefault = $(this).closest(`form[action="/cart"]`).find(
                '.cart-footer__note-input,'
                + '.cart-note__input,'
                + '[name^="attributes"],'
                + 'textarea[name="note"]',
            );

            if ([4856, 6289, 6412, 6365, 6366].includes(BSS_B2B.storeId) && cartNotesDefault.length === 0) {
                cartNotesDefault = $(this).closest(`#mini-cart.mini-cart`).find('textarea[name="note"]');
            }
            if ([4651, 6672, 6250, 7811, 6873].includes(BSS_B2B.storeId) && cartNotesDefault.length === 0) {
                cartNotesDefault = $(this).closest(`#main-cart-footer`).find('textarea[name="note"]');
            }
            if (BSS_B2B.storeId === 9605) {
                cartNotesDefault = $(this).closest(`#AjaxCartSubtotal`).find(
                    '#cartSpecialInstructions',
                );
            }
            if (BSS_B2B.storeId === 9041) {
                cartNotesDefault = $('#CartSpecialInstructions');
            }
            if (BSS_B2B.storeId === 9605) {
                cartNotesDefault = $('#cartSpecialInstructions');
            }
            if (BSS_B2B.storeId === 3787) {
                cartNotesDefault = $(this).closest(`form[action="/cart"]`).find(
                    '.cart__meta--desktop textarea[name="note"]',
                );
            }
            if (BSS_B2B.storeId === 4927) {
                cartNotesDefault = $(this).closest(`#shopify-section-static-cart`).find(
                    '.cart-ordernote textarea[name="note"]',
                );
            }
            if (BSS_B2B.storeId === 10233) {
                cartNotesDefault = $(this).closest(`.shopify-section`).find(
                    '#order-note textarea[name="note"]',
                );
            }
            if (BSS_B2B.storeId === 9907) {
                cartNotesDefault = $(this).closest(`.\\#cart-sidebar-wrapper`).find(
                    '.\\#cart-sidebar-order-notes textarea[name="note"]',
                );
            }
            if (BSS_B2B.storeId === 12500) {
                cartNotesDefault = $(this).closest(`#main-cart-footer`).find(
                    '#resale-number, #company-name, #roleposition',
                );
            }
            if (BSS_B2B.storeId === 12314) {
                cartNotesDefault = $('#Cart-note');
            }
            if (BSS_B2B.storeId === 5686) {
                cartNotesDefault = $(this).closest(`#main-cart-items`).find(
                    'textarea[name="note"]',
                );
            }
            if (BSS_B2B.storeId === 2851 && !shopData.customer.id) {
                isEnableCartNote = false;
            }
            if (isEnableCartNote && cartNotesDefault.length) {
                if ([2995, 3562, 4150, 12500].indexOf(BSS_B2B.storeId) !== -1) {
                    window.BSS_B2B.executeAction({ tag: 'add_cart_notes', storeId: false, customFieldValue, cartNotes: cartNotesDefault });
                }
                else {
                    let notes = '';
                    let labelCustom = '';
                    for (let i = 0; i < cartNotesDefault.length; i++) {
                        if (cartNotesDefault[i].value) {
                            notes += cartNotesDefault[i].value;
                            notes += '\n';
                        }
                    }
                    if (notes != '') {
                        customFieldValue.push({
                            key: labelCustom || 'cart note',
                            value: notes,
                        });
                    }
                    if (BSS_B2B.storeId === 6250) {
                        let deliveryDateNote = (this).closest(`#MainContent`).
                            querySelector('cart-items form[action="/cart"] input#date.hasDatepicker');
                        let pickupDate = (this).closest(`#MainContent`).
                            querySelector('cart-items form[action="/cart"] input#date:not(.hasDatepicker)');
                        if (deliveryDateNote && deliveryDateNote.value) {
                            customFieldValue.push({
                                key: 'delivery date',
                                value: deliveryDateNote.value,
                            });
                        }
                        if (pickupDate && pickupDate.value) {
                            customFieldValue.push({
                                key: 'ship date',
                                value: pickupDate.value,
                            });
                        }
                    }
                }
            }
            // fix bug datePicker cart page for https://folk-kombucha.myshopify.com/
            if (BSS_B2B.storeId === 7199) {
                let deliveryDateNote = (this).closest(`.wlm-content`).
                    querySelector('form[action="/cart"] input#date.hasDatepicker');
                if (deliveryDateNote && deliveryDateNote.value) {
                    customFieldValue.push({
                        key: 'delivery date',
                        value: deliveryDateNote.value,
                    });
                }
            }
            if (isEnableCartNote && $('.bss-b2b-custom-fields').length) {
                let customFields = $('.bss-b2b-custom-fields textarea,'
                    + `.bss-b2b-custom-fields input[name=bss-radio-button]:checked`);
                // fix for fr-sylvania by Khanh
                if ([3428, 12314].includes(BSS_B2B.storeId)) {
                    customFields = $('.bss-b2b-custom-fields input,'
                        + `.bss-b2b-custom-fields input[name=bss-radio-button]:checked`);
                }
                if (BSS_B2B.page.isCartPage() && [6602].includes(BSS_B2B.storeId)) {
                    customFields = $('#MainContent .bss-b2b-custom-fields textarea');
                }
                if (customFields.length) {
                    let labelCustom = '';
                    for (let i = 0; i < customFields.length; i++) {
                        let element = {
                            key: labelCustom || customFields[i].className,
                            value: customFields[i].value,
                        };
                        customFieldValue.push(element);
                    }
                }

                // add checkbox
                let customerCheckbox = $(`.bss-b2b-custom-fields [type="checkbox"]:checked`);
                if (customerCheckbox.length) {
                    let valueCheckbox = '';
                    for (let i = 0; i < customerCheckbox.length; i++) {
                        valueCheckbox += ' ,' + customerCheckbox[i].value;
                    }
                    if (valueCheckbox.length) {
                        valueCheckbox = valueCheckbox.slice(2, valueCheckbox.length);
                    }
                    let element = {
                        key: customerCheckbox[0].className,
                        value: valueCheckbox,
                    };
                    customFieldValue.push(element);
                }
                // add selector
                let selectorElement = $('#bss-select-cart');
                if (selectorElement.length) {
                    let valueSelect = $('#bss-select-cart option').filter(':selected').val();
                    let elementSelect = {
                        key: $(selectorElement).attr('class'),
                        value: valueSelect,
                    };
                    customFieldValue.push(elementSelect);
                }
                // fix support
                if (BSS_B2B.storeId === 1792) {
                    // Change "Le lieu de retrait de votre commande" to "Pickup_Store" - SAB2B-588 -madu
                    let elementPickUp = {
                        key: 'Pickup_Store',
                        value: $('input#pickup-store').attr('value') ? $('input#pickup-store').
                            attr('value').
                            replace(/<[^>]+>/g, '') : '',
                    };
                    customFieldValue.push(elementPickUp);
                }
            }
            let oldCheckoutBtn = self;

            let vatNumber = '';
            let inputTaxElement = $('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
            let taxExMessage = $('.bss-b2b-tax-ex-message');

            if (BSS_B2B.storeId === 8653) {
                inputTaxElement = $('#sufio-form-vat .input__field');
            }

            let discountCodeEle = $('#bss-b2b-discount-code-input');
            let isApplyDC = false;

            if (parentForm.length) {
                if ($(parentForm).find('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]').length) {
                    inputTaxElement = $(parentForm).find('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
                }
                if ($(parentForm).find('.bss-b2b-tax-ex-message').length) {
                    taxExMessage = $(parentForm).find('.bss-b2b-tax-ex-message');
                }
            }
            //fix for wholesale.thicktails by hoaduong
            if ([2681].indexOf(BSS_B2B.storeId) !== -1) {
                if ($(this).closest('.content-for-layout').length) {
                    inputTaxElement = $(this).
                        closest('.content-for-layout').
                        find('cart-items ~ .bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
                }
                if ($(this).closest('.cart-drawer-wrapper').length) {
                    inputTaxElement = $(this).
                        closest('.cart-drawer-wrapper').
                        find('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
                }
            }

            if ($(inputTaxElement).length) {
                if ([6902, 4720].includes(BSS_B2B.storeId) && BSS_B2B.page.isCartPage()) {
                    vatNumber = $(inputTaxElement[1]).val();
                }
                else {
                    vatNumber = $(inputTaxElement).val();
                }
            }
            if (($(discountCodeEle).length > 0) && isEnableDC) {
                if ($(discountCodeEle).is('[discount-code]')) {
                    isApplyDC = true;
                }
            }

            if ([3501, 6932, 986, 11407].includes(BSS_B2B.storeId)) {
                $("#bss-b2b-discount-code-applied").has("#bss-b2b-clear-discount-code").length && isEnableDC && (isApplyDC = true)
            }
            let validateVat = Tax.clientValidateVat(BSS_B2B.vatExemptSelected, vatNumber);

            let timeDelayToReCalculate = 500;
            if (BSS_B2B.storeId === 13753) {
                timeDelayToReCalculate = 3000;
            }
            if (BSS_B2B.storeId === 8718) {
                timeDelayToReCalculate = 2500;
            }
            else if ([12294, 8005, 12879, 6579, 14511].includes(BSS_B2B.storeId)) {
                timeDelayToReCalculate = 4500;
            }
            else if ([12879, 12875].includes(BSS_B2B.storeId)) {
                timeDelayToReCalculate = 8000;
            }
            setTimeout(() => {
                checkoutButton.css({ 'pointer-events': 'unset', 'opacity': '1' });
            }, timeDelayToReCalculate);

            if (isEnableAMO && BSS_B2B.amo.warning.length > 0) {
                BSS_B2B.amo.showWarningsModal();
            }
            else {
                if (BSS_B2B.storeId === 4557) {
                    BSS_B2B.modifyCartDataAndCreateCheckout(shopData, vatNumber, oldCheckoutBtn, self, isDone,
                        isEnabledVatValidate, customFieldValue, isApplyDC, isEnableCartNote);
                }
                else {
                    let isRequiredVat = BSS_B2B.vatSetting && BSS_B2B.vatSetting.is_required_vat;
                    if ((isEnabledVatValidate && isRequiredVat && inputTaxElement.length) ||
                        (isEnabledVatValidate && !isRequiredVat && validateVat)) {
                        BSS_B2B.vatCheckerForCheckoutBtn(shopData, vatNumber, oldCheckoutBtn, self, isDone,
                            customFieldValue, isApplyDC, validateVat, taxExMessage, inputTaxElement);
                    }
                    else {
                        BSS_B2B.modifyCartDataAndCreateCheckout(shopData, vatNumber, oldCheckoutBtn, self, isDone,
                            false, customFieldValue, isApplyDC, isEnableCartNote);
                    }
                }
            }
            if ([13447].includes(BSS_B2B.storeId)) {
                checkoutButton.hide();
            }
        });
    };

    /**
     *
     * @param shopData
     * @param vatNumber includes country code
     * @param oldCheckoutBtn
     * @param self point to checkout button
     * @param isDone
     * @param isEnabledVatValidate  whether or not TaxExempt is enabled.
     * @param isApplyDC  whether or not Discount Code is applied.
     */
    BSS_B2B.modifyCartDataAndCreateCheckout = function (
        shopData, vatNumber, oldCheckoutBtn, self, isDone, isEnabledVatValidate, customFieldValue, isApplyDC,
        isEnableCartNote) {
        let oldInputVal = null;
        let oldHtml = null;

        if ($(self).is('input')) {
            oldInputVal = $(self).val();
        }
        else {
            oldHtml = $(self).html();
        }
        if (isDone) {
            return;
        }

        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function (cartData) {
                BSS_B2B.createCheckoutWithModifyCartData(
                    cartData,
                    shopData,
                    vatNumber,
                    oldCheckoutBtn,
                    self,
                    isDone,
                    isEnabledVatValidate,
                    customFieldValue,
                    isApplyDC,
                    isEnableCartNote,
                    oldHtml,
                    oldInputVal,
                );
            },
            error: function (err) {
                // eslint-disable-next-line no-console
                console.log('Could not get cart data:', err);
                $(oldCheckoutBtn).removeAttr('disabled');
                if (oldHtml == null) {
                    $(oldCheckoutBtn).val(oldInputVal);
                }
                else {
                    $(oldCheckoutBtn).html(oldHtml);
                }
            },
        });
    };

    BSS_B2B.vatCheckerForCheckoutBtn = function (
        shopData, vatNumber, oldCheckoutBtn, self, isDone, customFieldValue, isApplyDC, validateVat, taxExMessage,
        inputTaxElement) {
        BSS_B2B.integrate.langShop.handleAllTranslation('vat');
        let errorMessage = '';
        let successMessage = '';
        let validateCountryCodeMessage = BSS_B2B.vatTranslations.form_validate_country_code_message;
        if (BSS_B2B.vatExemptSelected === 0) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message">' +
                BSS_B2B.vatTranslations.form_error_message + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message">' +
                BSS_B2B.vatTranslations.form_success_message + '</span>';
        }
        else if (BSS_B2B.vatExemptSelected === 1) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_uk">' +
                BSS_B2B.vatTranslations.form_error_message_uk + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_uk">' +
                BSS_B2B.vatTranslations.form_success_message_uk + '</span>';
        }
        else if (BSS_B2B.vatExemptSelected === 2) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_abn">' +
                BSS_B2B.vatTranslations.form_error_message_abn + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_abn">' +
                BSS_B2B.vatTranslations.form_success_message_abn + '</span>';
        }
        else if (BSS_B2B.vatExemptSelected === 3) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_gst">' +
                BSS_B2B.vatTranslations.form_error_message_gst + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_gst">' +
                BSS_B2B.vatTranslations.form_success_message_gst + '</span>';
        }
        else if (BSS_B2B.vatExemptSelected === 4) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_us_ein">' +
                BSS_B2B.vatTranslations.form_error_message_us_ein + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_us_ein">' +
                BSS_B2B.vatTranslations.form_success_message_us_ein + '</span>';
        }
        let errorMessageHTML = '<p class=\'bss-b2b-tax-invalid\' style=\'color: orangered; margin-top: 5px\'>'
            +
            '<span style=\'font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px\'>&#10005;</span> '
            + errorMessage
            + '</p>';
        let successMessageHTML = '<p class=\'bss-b2b-tax-valid\' style=\'color: green; margin-top: 5px\'>'
            +
            '<span style=\'font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px\'>&#10003;</span> '
            + successMessage
            + '</p>';
        let validateCountryCodeMessageHTML = '<p class=\'bss-b2b-tax-invalid\' style=\'color: orangered; margin-top: 5px\'>'
            +
            '<span style=\'font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px\'>&#10005;</span> '
            + '<span class="bss-b2b-translation-vat-form_validate_country_code_message">' + validateCountryCodeMessage +
            '</span>'
            + '</p>';
        if (!validateVat) {
            $(taxExMessage).html(errorMessageHTML);
            BSS_B2B.integrate.langShop.handleAllTranslation('vat', [
                'form_error_message',
                'form_error_message_uk',
                'form_error_message_abn',
                'form_error_message_gst',
                'form_error_message_us_ein']);
            BSS_B2B.handleCartCheckoutBtn(shopData);

        }
        else {
            $(self).attr('disabled', 'true');
            vatNumber = vatNumber ? vatNumber.trim() : '';
            let countryCode = BSS_B2B.vatExemptSelected === 0 ? vatNumber.substr(0, 2) : '';
            let data = {
                domain: shopData.shop.permanent_domain,
            };
            if (BSS_B2B.vatExemptSelected === 0) {
                vatNumber = vatNumber.toUpperCase();
                countryCode = countryCode.toUpperCase();
                data.vatNumber = vatNumber;
                data.countryCode = countryCode;
            }
            else if (BSS_B2B.vatExemptSelected === 1) {
                data.ukVatNumber = vatNumber;
            }
            else if (BSS_B2B.vatExemptSelected === 2) {
                data.abn = vatNumber;
            }
            else if (BSS_B2B.vatExemptSelected === 3) {
                data.gstNumber = vatNumber;
            }
            else if (BSS_B2B.vatExemptSelected === 4) {
                data.usEinNumber = vatNumber;
            }
            if (!BSS_B2B.validateVatSuccess) {
                let router = '';
                if (BSS_B2B.vatExemptSelected === 0) {
                    router = '/wholesaler/valid/vat';
                }
                else if (BSS_B2B.vatExemptSelected === 1) {
                    router = '/wholesaler/valid/uk-vat';
                }
                else if (BSS_B2B.vatExemptSelected === 2) {
                    router = '/wholesaler/valid/abn';
                }
                else if (BSS_B2B.vatExemptSelected === 3) {
                    router = '/wholesaler/valid/uk-gst';
                }
                else if (BSS_B2B.vatExemptSelected === 4) {
                    router = '/wholesaler/valid/us-ein-vat';
                }
                fetch(`${bssB2bApiServer}${router}?domain=${shopData.shop.permanent_domain}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                }).then(response => response.json()).then(function (data) {
                    if (data.success) {
                        const isEUVATCountry = BSS_B2B.vatSetting && BSS_B2B.vatSetting.selected_eu_vat_countries &&
                            BSS_B2B.vatSetting.selected_eu_vat_countries.includes(countryCode);
                        if (BSS_B2B.vatExemptSelected !== 0 || (BSS_B2B.vatExemptSelected === 0 && isEUVATCountry)) {
                            if (BSS_B2B.vatExemptSelected === 4) {
                                successMessageHTML = '<p class=\'bss-b2b-tax-valid\' style=\'color: green; margin-top: 5px\'>'
                                    +
                                    '<span style=\'font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px\'>&#10003;</span> '
                                    + successMessage + ` (${data.data.company})`
                                    + '</p>';
                            }
                            $(taxExMessage).html(successMessageHTML);
                            BSS_B2B.integrate.langShop.handleAllTranslation('vat', [
                                'form_success_message',
                                'form_success_message_uk',
                                'form_success_message_abn',
                                'form_success_message_gst',
                                'form_success_message_us_ein']);
                            BSS_B2B.validateVatSuccess = true;
                            let validateVat = true;
                            let event = new CustomEvent('bss.b2b.vat.validateVatByBSS', {
                                detail: { validateVat, vatNumber },
                            });
                            document.dispatchEvent(event);

                        }
                        else {
                            $(taxExMessage).html(validateCountryCodeMessageHTML);
                            BSS_B2B.integrate.langShop.handleAllTranslation('vat',
                                ['form_validate_country_code_message']);
                            let validateVat = false;
                            let event = new CustomEvent('bss.b2b.vat.validateVatByBSS', {
                                detail: { validateVat, vatNumber },
                            });
                            document.dispatchEvent(event);
                        }

                        if (BSS_B2B.vatSetting && BSS_B2B.vatSetting.auto_redirect_to_checkout) {
                            BSS_B2B.modifyCartDataAndCreateCheckout(shopData, vatNumber, oldCheckoutBtn, self, isDone,
                                true, customFieldValue, isApplyDC);

                        }
                        else {
                            $(self).removeAttr('disabled');
                            BSS_B2B.validateVatSuccess = true;
                            $(inputTaxElement).on('change', function () {
                                let newVatNumber = $('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]').val();
                                if (newVatNumber !== vatNumber) {
                                    BSS_B2B.validateVatSuccess = false;
                                }
                            });
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                        }
                    }
                    else {
                        $(taxExMessage).html(errorMessageHTML);
                        BSS_B2B.integrate.langShop.handleAllTranslation('vat', [
                            'form_error_message',
                            'form_error_message_uk',
                            'form_error_message_abn',
                            'form_error_message_gst',
                            'form_error_message_us_ein']);
                        $(self).removeAttr('disabled');
                        let validateVat = false;
                        let event = new CustomEvent('bss.b2b.vat.validateVatByBSS', {
                            detail: { validateVat, vatNumber },
                        });
                        document.dispatchEvent(event);
                        BSS_B2B.handleCartCheckoutBtn(shopData);
                        if (BSS_B2B.vatSetting &&
                            (BSS_B2B.vatSetting.auto_redirect_to_checkout && !BSS_B2B.vatSetting.is_required_vat)) {
                            BSS_B2B.modifyCartDataAndCreateCheckout(shopData, vatNumber, oldCheckoutBtn, self, isDone,
                                true, customFieldValue, isApplyDC);
                        }

                    }
                });
            }
            else {
                BSS_B2B.modifyCartDataAndCreateCheckout(shopData, vatNumber, oldCheckoutBtn, self, isDone, true,
                    customFieldValue, isApplyDC);

            }
        }
    };

    BSS_B2B.createCheckoutWithModifyCartData = function (
        cartData,
        shopData,
        vatNumber,
        oldCheckoutBtn,
        self,
        isDone,
        isEnabledVatValidate,
        customFieldValue,
        isApplyDC,
        isEnableCartNote,
        oldHtml,
        oldInputVal,
    ) {
        let cartAttributes = cartData.attributes;
        let dcRules = false;
        let countryCode = null;
        let dcRuleData = false;
        let newArrayKeyDC = [];

        // for comparing with appProduct Option
        if (typeof BSS_PO !== 'undefined' && BSS_PO.enable && BSS_PO.enableInCart) {
            let isProductOptionApplied = false;
            if (BSS_B2B.cart.qbPricingList
                && BSS_B2B.cart.qbPricingList.size == 0
                && BSS_B2B.cart.cpPricingList
                && BSS_B2B.cart.cpPricingList.size == 0
            ) {
                cartData.items.every((item) => {
                    Object.keys(localStorage).every((key) => {
                        if (item.key == key) {
                            isProductOptionApplied = true;
                            return false;
                        }
                        return true;
                    });
                    if (isProductOptionApplied) {
                        return false;
                    }
                    return true;
                });
            }

            if (isProductOptionApplied) {
                return;
            }
        }
        // End for comparing with appProduct Option

        if (BSS_B2B.vatAutoExempt && vatNumber && vatNumber !== '') {
            cartAttributes['vat-exempt-check'] = BSS_B2B.vatExemptSelected;
            cartAttributes['vat-id'] = vatNumber;
            if (BSS_B2B.validateVatSuccess) {
                if (BSS_B2B.vatExemptSelected === 0) {
                    countryCode = vatNumber.substr(0, 2);
                    let validCountry = Tax.checkValidCountries(countryCode);
                    cartAttributes['taxExempt'] = validCountry;
                }
                else {
                    cartAttributes['taxExempt'] = true;
                }
            }
            else {
                cartAttributes['taxExempt'] = false;
            }
        } else if (!BSS_B2B.vatAutoExempt && vatNumber && vatNumber !== '') {
            cartAttributes['vat-exempt-check'] = BSS_B2B.vatExemptSelected;
            cartAttributes['vat-id'] = vatNumber;
            cartAttributes['taxExempt'] = false;
        }
        cartData.attributes = cartAttributes;
        if (isApplyDC && isEnableDC) {
            dcRules = cartData.attributes.discountCodeRule;
        }
        else {
            dcRules = [];
        }

        if (cartData.items && cartData.items.length > 0) {
            let domain = shopData.shop.permanent_domain;

            let handleURLs = [];
            let handles = [];
            let keyIdMap = [];
            let keyQuantityMap = [];
            let keyPriceMap = [];
            let cartItemProductMap = new Map();
            let qbPricingListById = new Map();
            let qbPricingListAfterZapiet = new Map();
            if (BSS_B2B.cart.qbPricingList && BSS_B2B.cart.qbPricingList.size) {
                const arrayQbPricingList = Array.from(BSS_B2B.cart.qbPricingList.values());
                if (arrayQbPricingList.length) {
                    qbPricingListById = new Map(arrayQbPricingList.map((item) => [item.id, item]));
                }
            }
            cartData.items.forEach(function (item) {
                let proId = item.product_id;
                if (handles.indexOf(proId) === -1) {
                    handles.push(proId);
                    handleURLs.push('id:"' + proId + '"');
                    keyIdMap[proId] = item.key;
                    keyQuantityMap[proId] = item.quantity,
                        keyPriceMap[proId] = item.price;
                }

                let productVariants = cartItemProductMap.get(proId);
                if (!productVariants || productVariants === undefined) {
                    cartItemProductMap.set(proId, []);
                    productVariants = [];
                }

                productVariants.push({
                    key: item.key,
                    quantity: item.quantity,
                    id: item.variant_id,
                    price: item.price,
                });
                cartItemProductMap.set(proId, productVariants);

                const qbItem = qbPricingListById.get(item.id);
                if (BSS_B2B.integration.Zapiet) {
                    if (qbItem && qbItem.product_id === proId) {
                        qbItem.key = item.key;
                        qbPricingListAfterZapiet.set(qbItem.key, qbItem);
                    }
                    if (dcRules && dcRules.length && JSON.parse(dcRules)) {
                        dcRuleData = JSON.parse(dcRules);
                        if (dcRuleData.dc_products && dcRuleData.dc_keys && dcRuleData.dc_products.length &&
                            dcRuleData.dc_keys.length) {
                            if (dcRuleData.dc_products.includes(proId)) {
                                newArrayKeyDC.push(item.key);
                            }
                        }
                    }
                }
            });
            let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
            let encodeUrlData = encodeURI(urlData);
            fetch(encodeUrlData, { method: 'GET' }).then(async (data) => {
                let responseProducts = [];
                let productIdNoMetaField = [];
                try {
                    responseProducts = await data.json();
                    responseProducts.map(item => productIdNoMetaField.push(item.id));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('B2B: JSON parse returns no item');
                }

                if (shopData.line_item_products) {
                    shopData.line_item_products.map(item => {
                        if (item && item.id && !productIdNoMetaField.includes(item.id) && handles.includes(item.id)) {
                            responseProducts.push(item);
                        }
                    });
                }

                if (BSS_B2B.storeId === 3576) {
                    let itemList = [];
                    if (document.getElementById('bss-b2b-cp-custom-items-metafields')) {
                        let itemsData = JSON.parse(
                            document.getElementById('bss-b2b-cp-custom-items-metafields').innerText);
                        itemList = itemList.concat(itemsData.collection);
                    }
                    if (itemList.length > 0) {
                        responseProducts = itemList;
                    }
                }

                if (responseProducts.length > 0) {
                    let productMap = [];
                    let checkUnique = [];
                    let productVariantsMap = [];

                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            const productVariant = cartData.items.filter(item => item.product_id === pro.id).map((variant) => (variant.id));
                            productMap.push({
                                id: pro.id,
                                tags: pro.tags,
                                collections: pro.collections,
                                key: keyIdMap[pro.id],
                                quantity: keyQuantityMap[pro.id],
                                price: keyPriceMap[pro.id],
                                variantsApplied: productVariant,
                            });

                            // Get variant product check DC
                            cartItemProductMap.get(pro.id).forEach(function (cartItem) {
                                productVariantsMap.push({
                                    id: pro.id,
                                    tags: pro.tags,
                                    collections: pro.collections,
                                    key: cartItem.key,
                                    price: parseFloat(cartItem.price),
                                    title: pro.title,
                                    quantity: parseInt(cartItem.quantity),
                                });
                            });
                        }
                    }

                    // Start - checkMinimumPurchaseDC
                    if (isApplyDC && isEnableDC && cartAttributes.discountCodeRule && cartAttributes.discountCodeRule.length > 0) {
                        const discountCodeRule = JSON.parse(cartAttributes.discountCodeRule)
                        const discountCode = discountCodeRule.discount_code;
                        const discountCodeType = discountCodeRule.discount_code_type;
                        let today = new Date();
                        let moment = today.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
                        today.setUTCHours(0, 0, 0, 0);
                        let cpPricingList = [];
                        let qbPricingList = [];
                        for (const [key, value] of BSS_B2B.cart.cpPricingList) {
                            cpPricingList.push({
                                key: key,
                                modifiedItemPrice: value.modifiedItemPrice
                            })
                        }
                        for (const [key, value] of BSS_B2B.cart.qbPricingList) {
                            qbPricingList.push({
                                key: key,
                                modifiedItemPrice: value.pricePerItemAfterApplyQB
                            })
                        }
                        const data = {
                            today: today,
                            moment: moment,
                            customer: shopData.customer,
                            cart_items: productVariantsMap,
                            domain: shopData.shop.permanent_domain,
                            discount_code: discountCode,
                            cpPricingList: cpPricingList,
                            qbPricingList: qbPricingList,
                        };
                        dcRules = BSS_B2B.dc.checkMinimumPurchaseDC(discountCodeType, discountCodeRule.rule_id, data).success && discountCode ? cartAttributes.discountCodeRule : [];
                    }
                    // End - checkMinimumPurchaseDC

                    let eventName = "";
                    const listEvent = {
                        EF: 'bss.b2b.ef.doneCalculateEF',
                        QB: 'bss_b2b_doneCheckQb',
                    };

                    let moduleArray = Array.from(BSS_B2B.calculateModules.entries());
                    moduleArray.sort((a, b) => b[1].priority - a[1].priority);
                    BSS_B2B.calculateModules = new Map(moduleArray);

                    for (let [module, moduleValue] of BSS_B2B.calculateModules) {
                        if (!moduleValue.enableModule || moduleValue.isDoneCalculate) continue;
                        eventName = listEvent[module];
                        break;
                    }

                    if (eventName) {
                        let timeoutFinishedListenerModule = async () => {
                            document.removeEventListener(eventName, timeoutFinishedListenerModule);
                            await processingBeforeRedirectCheckoutPage(productMap, qbPricingListAfterZapiet,
                                cartItemProductMap, cartData, oldCheckoutBtn, domain, shopData, oldHtml, oldInputVal,
                                customFieldValue, dcRules, dcRuleData, newArrayKeyDC, isDone, isEnabledVatValidate,
                                isEnableCartNote);
                        };
                        document.addEventListener(eventName, timeoutFinishedListenerModule);
                    }
                    else {
                        await processingBeforeRedirectCheckoutPage(productMap, qbPricingListAfterZapiet,
                            cartItemProductMap, cartData, oldCheckoutBtn, domain, shopData, oldHtml, oldInputVal,
                            customFieldValue, dcRules, dcRuleData, newArrayKeyDC, isDone, isEnabledVatValidate,
                            isEnableCartNote);
                    }

                }
            });

        }
        else {
            // eslint-disable-next-line no-console
            console.log('Could not get cart data');
            $(oldCheckoutBtn).removeAttr('disabled');
            if (oldHtml == null) {
                $(oldCheckoutBtn).val(oldInputVal);
            }
            else {
                $(oldCheckoutBtn).html(oldHtml);
            }
        }
    };

    const processingBeforeRedirectCheckoutPage = async (
        productMap, qbPricingListAfterZapiet, cartItemProductMap, cartData, oldCheckoutBtn, domain, shopData, oldHtml,
        oldInputVal, customFieldValue, dcRules, dcRuleData, newArrayKeyDC, isDone, isEnabledVatValidate,
        isEnableCartNote,
    ) => {
        let rateMarket = Shopify.currency.rate;
        let qbPricingList = BSS_B2B.cart.qbPricingList;
        if (BSS_B2B.integration.Zapiet && (isEnableQB || isEnableDC)) {
            if (isEnableQB) {
                qbPricingList = qbPricingListAfterZapiet;
            }
            if (isEnableDC && dcRuleData) {
                dcRuleData.dc_keys = newArrayKeyDC;
                dcRules = JSON.stringify(dcRuleData);
            }
        }
        let efList = BSS_B2B.cart.efList;
        let updatedLineItems = BSS_B2B.getPriceList(shopData, productMap, true);
        let updatedLineItemsByBogo = BSS_B2B.cart.updatedLineItemsByBogo;
        let shippingRate = await BSS_B2B.sr.calculateShippingRate(BSS_B2B.srRules, productMap, shopData.customer,
            BSS_B2B.cart.cpPricingList, qbPricingList, cartItemProductMap, cartData.original_total_price,
            cartData.total_weight, rateMarket);
        if (updatedLineItems.length > 0) {
            let items = [];
            let uniqueItem = [];
            for (let l = 0; l < updatedLineItems.length; l++) {
                let updatedLineItem = updatedLineItems[l];
                for (let k = 0; k < cartData.items.length; k++) {
                    // check variant applied variant price in checkout
                    let cartItem = cartData.items[k];
                    if (updatedLineItem.variants && updatedLineItem.variants.length > 0) {
                        if (cartItem.product_id === updatedLineItem.id) {
                            if (updatedLineItem.variants.includes(cartItem.variant_id + '') &&
                                uniqueItem.indexOf(cartItem.variant_id) === -1) {
                                uniqueItem.push(cartItem.variant_id);
                                let cloneItem = {
                                    id: updatedLineItem.id,
                                    discount_type: updatedLineItem.discount_type,
                                    value: updatedLineItem.value,
                                    key: cartItem.key,
                                    ruleType: updatedLineItem.ruleType,
                                    rule_id: updatedLineItem.rule_id,
                                    sid: `${updatedLineItem.sid.split('.')[0]}.${Buffer.from(String(cartItem.key)).
                                        toString('base64')}`,
                                };
                                if (updatedLineItem.ruleType === 'PL') {
                                    cloneItem.pid = updatedLineItem.pid;
                                }
                                items.push(cloneItem);
                            }
                        }
                    }
                    else {
                        if (cartItem.product_id === updatedLineItem.id) {
                            if (
                                uniqueItem.indexOf(cartItem.variant_id) === -1 || [11612, 15486].includes(BSS_B2B.storeId)
                            ) {
                                uniqueItem.push(cartItem.variant_id);
                                let cloneItem = {
                                    id: updatedLineItem.id,
                                    discount_type: updatedLineItem.discount_type,
                                    value: updatedLineItem.value,
                                    key: cartItem.key,
                                    ruleType: updatedLineItem.ruleType,
                                    rule_id: updatedLineItem.rule_id,
                                    sid: `${updatedLineItem.sid.split('.')[0]}.${Buffer.from(String(cartItem.key)).
                                        toString('base64')}`,
                                };
                                if (updatedLineItem.ruleType === 'PL') {
                                    cloneItem.pid = updatedLineItem.pid;
                                }

                                items.push(cloneItem);
                            }
                        }
                    }
                }
            }
            updatedLineItems = [];

            for (let m = 0; m < items.length; m++) {
                updatedLineItems.push(items[m]);
            }
        }

        if (updatedLineItems.length > 0 || qbPricingList.size > 0 || isEnabledVatValidate ||
            (dcRules && dcRules.length > 0) || shippingRate || efList.length > 0 || updatedLineItemsByBogo.length > 0 ||
            (BSS_B2B.storeId === 12294 && isEnableDC)) {
            if ($(oldCheckoutBtn).hasClass('bss-b2b-customer-portal-nt-checkout-btn')) {
                $(oldCheckoutBtn).trigger('click');
            }
            else if ($(oldCheckoutBtn).hasClass('bss-b2b-customer-portal-share-cart-btn')) {
                window.location.href = '/apps/customer-portal/company-account/share-cart';
            }
            else {
                if (![9220].includes(BSS_B2B.storeId)) {
                    $(oldCheckoutBtn).attr('disabled', 'disable');
                    if ($(oldCheckoutBtn).is('input')) {
                        $(oldCheckoutBtn).val('Processing');
                    }
                    else {
                        $(oldCheckoutBtn).
                            html(
                                '<div style="display: flex;"><span style="visibility: hidden;width: 0;">sdad</span><div class="bss-loader"></div></div>');
                    }
                }
                BSS_B2B.createCheckout(domain, shopData, cartData, updatedLineItems, updatedLineItemsByBogo,
                    qbPricingList, efList, oldCheckoutBtn, oldHtml, oldInputVal, customFieldValue, dcRules,
                    shippingRate);
            }
        }
        else {
            // for compare with nt of Portal
            if ($(oldCheckoutBtn).hasClass('bss-b2b-customer-portal-nt-checkout-btn')) {
                $(oldCheckoutBtn).trigger('click');
            }
            else if ($(oldCheckoutBtn).hasClass('bss-b2b-customer-portal-share-cart-btn')) {
                window.location.href = '/apps/customer-portal/company-account/share-cart';
            }
            else {
                // not use rule CP, QP but have cart note or shipping rate
                $(oldCheckoutBtn).attr('disabled', 'disable');
                isDone = true;
                if ((customFieldValue.length && isEnableCartNote) || shippingRate) {
                    BSS_B2B.createCheckout(domain, shopData, cartData, updatedLineItems, updatedLineItemsByBogo,
                        qbPricingList, efList, oldCheckoutBtn, oldHtml, oldInputVal, customFieldValue, undefined,
                        shippingRate);
                }
                else {
                    $(oldCheckoutBtn).removeAttr('disabled');
                    if (oldHtml == null) {
                        $(oldCheckoutBtn).val(oldInputVal);
                    } else {
                        $(oldCheckoutBtn).html(oldHtml);
                    }
                    let checkoutBtn = $(
                        'form[action*="/cart"] [name="checkout"]:not(.bss-b2b-customer-portal-nt-checkout-btn)');
                    //fix for wholesalesnacks
                    if (BSS_B2B.storeId === 6011) {
                        checkoutBtn = $('form[action*="/cart"] [name="checkout"] [type="submit]');
                    }
                    // fix for oskarswoodenark.myshopify.com by hung
                    if (BSS_B2B.storeId === 5273) {
                        checkoutBtn = $(
                            'form[action*="/cart"] [name="checkout"]:not(.bss-b2b-customer-portal-nt-checkout-btn)');
                    }
                    // fix for dynamo-b2b.myshopify.com by DucDN
                    if (BSS_B2B.storeId === 12570) {
                        checkoutBtn = $(`[form='mini-cart-form'].checkout-button`);
                    }
                    if (checkoutBtn.length === 0) {
                        //fix for Hi-Lux, earfab by CuongNVM
                        if ([9211, 3351].indexOf(BSS_B2B.storeId) !== -1) {
                            checkoutBtn = $(
                                '.ajax-cart__button.button--add-to-cart.button, .button.button--solid[name="checkout"]',
                            );
                            $(checkoutBtn).trigger('click');
                        } else {
                            // fix for laduora by mitri, balance-your-buz, korrosionsgruppen-direkt by hoaduong
                            window.location = '/checkout';
                            // document.getElementById("checkout").click()
                        }
                    }
                    else {
                        if (([6605, 2050, 6526, 12886, 13573, 13790, 4856, 6289, 6412, 6365, 6366].includes(BSS_B2B.storeId) && !BSS_B2B.page.isCartPage()) ||
                            ([5077,8912, 12886, 13573, 13790, 4856, 6289, 6412, 6365, 6366].includes(BSS_B2B.storeId)) && BSS_B2B.page.isCartPage() &&
                            !$(checkoutBtn).hasClass('fade-it')) {
                            window.location = '/checkout';
                        } else {
                            if (BSS_B2B.storeId === 15791) {
                                let defaultCheckoutBtn = document.querySelector('.cart-recap__checkout');
                                defaultCheckoutBtn.click()
                            }
                            $(checkoutBtn).trigger('click');
                        }
                    }
                }
            }
        }
    };

    BSS_B2B.createCheckout = function (
        domain,
        shopData,
        cartData,
        updatedLineItems,
        updatedLineItemsByBogo,
        qbPricingList,
        efList,
        oldCheckoutBtn,
        oldHtml,
        oldInputVal,
        customFieldValue,
        dcRules,
        shippingRate,
    ) {
        const key = Buffer.from(domain).toString('base64');
        let cData = BSS_B2B.optimizeCartData(cartData);

        let createData = {};
        let poList = [];
        // for comparing with appProduct Option
        // fix for atacsportwear-com.myshopify.com by CuongNVM and Leorio
        if (typeof BSS_PO !== 'undefined' && BSS_PO.enable) {
            poList = BSS_B2B.integrate.productOption.getPoListCartPage(cData);
        }

        if ([4856, 6289, 6365, 6366, 6412, 9605, 5686].includes(BSS_B2B.storeId)) {
            cData.note = '';
        }

        if (window.BSS_SUB && Object.keys(window.BSS_SUB.subItems).length) {
            BSS_B2B.integration.BSS_SUB.subItems = window.BSS_SUB.subItems;
        }
        const arrayQbPricingList = Array.from(qbPricingList.values());
        createData = {
            domain: domain,
            customerInfo: shopData.customer,
            order: cData,
            updatedLineItems,
            updatedLineItemsByBogo,
            qbPricingList: arrayQbPricingList,
            efList: efList,
            poList: poList,
            customFieldValue: customFieldValue,
            dcRules: dcRules,
            shippingRate: shippingRate,
            countryCode: Shopify.country,
            currencyMarket: Shopify.currency,
            integration: BSS_B2B.integration
        };

        if ([9907].includes(BSS_B2B.storeId)) {
            createData['tags'] = [];
            let dateTag = document.querySelector('.tbtDeliveryDateVal');
            let dayTag = document.querySelector('.tbtDeliveryDayVal');
            if (dateTag || dayTag) {
                if (dateTag.value) {
                    createData['tags'] = [...createData['tags'], dateTag.value];
                }
                if (dayTag.value) {
                    createData['tags'] = [...createData['tags'], dayTag.value];
                }
            }
        }

        if ([8113].includes(BSS_B2B.storeId)) {
            if (localStorage.getItem('bss_handling_checkout')) {
                return;
            }
            localStorage.setItem('bss_handling_checkout', 'loading....');
        }
        Object(_helper_encode__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(createData, key).then((createDataEncoded) => {
            createData.id = createDataEncoded;
            $.ajax({
                url: bssB2bCheckoutUrl + '/checkout/create',
                data: {
                    checkoutData: JSON.stringify(createData),
                },
                dataType: 'json',
                type: 'POST',
                success: function (data) {
                    if (data.success) {
                        let localeParams = '';
                        if (typeof Shopify !== 'undefined' && Shopify && Shopify.locale) {
                            localeParams = '?locale=' + Shopify.locale;
                        }
                        window.location = data.orderData.invoiceUrl + localeParams;
                        if (oldHtml == null) {
                            $(oldCheckoutBtn).val(oldInputVal)
                        } else {
                            $(oldCheckoutBtn).html(oldHtml)
                        }
                    } else {
                        $(oldCheckoutBtn).removeAttr('disabled');
                        if (oldHtml == null) {
                            $(oldCheckoutBtn).val(oldInputVal);
                        }
                        else {
                            $(oldCheckoutBtn).html(oldHtml);
                        }
                    }
                },
                error: function (err) {
                    $(oldCheckoutBtn).removeAttr('disabled');
                    if (oldHtml == null) {
                        $(oldCheckoutBtn).val(oldInputVal);
                    }
                    else {
                        $(oldCheckoutBtn).html(oldHtml);
                    }
                    // eslint-disable-next-line no-console
                    console.log('Could not create checkout:', err);
                },
            });
        });
    };

    BSS_B2B.optimizeCartData = function (cartData) {
        let newCartData = cartData;
        //delete newCartData.attributes;
        delete newCartData.cart_level_discount_applications;
        delete cartData.currency;
        let newItems = [];
        cartData.items.forEach(function (item) {
            newItems.push({
                id: item.id,
                key: item.key,
                price: item.price,
                total_discount: item.total_discount,
                quantity: item.quantity,
                handle: item.title,
                variant_id: item.variant_id,
                product_id: item.product_id,
                taxable: item.taxable,
                properties: item.properties ? item.properties : null,
                selling_plan_allocation: item.selling_plan_allocation ? item.selling_plan_allocation : null,
                discounts: item.discounts ? item.discounts : null
            });
        });
        newCartData.items = newItems;
        return newCartData;
    };
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleBuyItNow; });
/* harmony import */ var _helper_encode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
const Tax = __webpack_require__(1);


function handleBuyItNow($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableAMO, isEnabledQI) {
    BSS_B2B.redirectWithInvoiceUrl = function (domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, poList) {
        let vatAttributes = {};
        // if (shopData.customer.tax_exempt) {
        //     vatAttributes["vat-exempt-check"] = BSS_B2B.vatExemptSelected;
        //     vatAttributes["taxExempt"] = true;
        //     vatAttributes["vat-id"] = "";
        // }

        if (vatNumber && vatNumber !== "") {
            vatAttributes["vat-exempt-check"] = BSS_B2B.vatExemptSelected;
            vatAttributes["vat-id"] = vatNumber;
            if (BSS_B2B.validateVatSuccess) {
                if (BSS_B2B.vatExemptSelected === 0) {
                    let countryCode = vatNumber.substr(0, 2);
                    vatAttributes["taxExempt"] = Tax.checkValidCountries(countryCode);
                } else {
                    vatAttributes["taxExempt"] = true;
                }
            } else {
                vatAttributes["taxExempt"] = false;
            }
        }

        const key = Buffer.from(domain).toString('base64');

        const checkoutData = {
            domain: domain,
            product: product ? product : shopData.product,
            variant: variant,
            priceLists: priceLists,
            quantity: quantity,
            efList: efList,
            poList: poList,
            appliedQbRule: appliedQbRule,
            vatAttributes: vatAttributes,
            shippingRate: shippingRate,
            countryCode: Shopify.country,
            currencyMarket: Shopify.currency,
            customerInfo: shopData.customer
        }

        Object(_helper_encode__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(checkoutData, key).then((createDataEncoded) => {
            checkoutData.id = createDataEncoded;
            $.ajax({
                url: bssB2bCheckoutUrl + '/checkout/redirect',
                data: {
                    checkoutData: JSON.stringify(checkoutData)
                },
                dataType: "json",
                type: 'POST',
                success: function (data) {
                    if (data.success) {
                        let localeParams = "";
                        if (typeof Shopify !== 'undefined' && Shopify && Shopify.locale) {
                            localeParams = "?locale=" + Shopify.locale;
                        }
                        window.location = data.orderData.invoiceUrl + localeParams;
                    } else {
                        $(oldBuyItNowBtn).removeAttr('disabled');
                        if (oldHtml == null) {
                            $(oldBuyItNowBtn).val(oldInputVal)
                        }
                        else {
                            $(oldBuyItNowBtn).html(oldHtml)
                        }
                        // eslint-disable-next-line no-console
                        console.log("Could not create checkout, redirect and error in function handleBuyItNow.BSS_B2B.redirectWithInvoiceUrl:", data.message)
                    }
                },
                error: function (err) {
                    $(oldBuyItNowBtn).removeAttr('disabled');
                    if (oldHtml == null) {
                        $(oldBuyItNowBtn).val(oldInputVal)
                    }
                    else {
                        $(oldBuyItNowBtn).html(oldHtml)
                    }
                    // eslint-disable-next-line no-console
                    console.log("Could not create checkout and redirect:", err)
                }
            })
        });
    };

    BSS_B2B.handleBuyItNowBtn = async function (priceLists, variant, product, parentElement, appliedQbRule, targetElement, appliedEFRule, poList, isUseDefaultCheckout, originalButton) {
        //$(targetElement).off();

        $(targetElement).attr('disabled', 'disable');
        let self = targetElement;
        let parentForm = $(targetElement).closest("form");
        let oldBuyItNowBtn = targetElement;
        let oldInputVal = null;
        let oldHtml = null;

        if ($(targetElement).is('input')) {
            oldInputVal = $(targetElement).val();
            $(targetElement).val('Processing');
        }
        else if (![12879, 13923, 5686, 9570].includes(BSS_B2B.storeId)) {
            oldHtml = $(targetElement).html();
            $(targetElement).html('<div style="display: flex;"><span style="visibility: hidden;width: 0;">sdad</span><div class="bss-loader"></div></div>');
        } else if ([13923, 5686, 9570].includes(BSS_B2B.storeId)) {
            oldHtml = [];
            $(targetElement).each((index, item) => {
              oldHtml.push($(item).html());
            })
            $(targetElement).html('<div style="display: flex;"><span style="visibility: hidden;width: 0;">sdad</span><div class="bss-loader"></div></div>');
        }
        if(BSS_B2B.storeId === 12023) {
            parentElement = '.quantity';
        }
        if(BSS_B2B.storeId === 12503) {
            parentElement = ".quantity-with-unit";
        }
        let domain = shopData.shop.permanent_domain;
        let quantity = 1;
        let quantitySelector = $(parentElement).find(
            'input[type="number"][name="quantity"],'
            + 'input[type="number"][data-quantity-input],'
            + 'input[type="number"][class$="quantity"],'
            + 'input[id^="Quantity"],'
            + 'input[name="quantity"],'
            + 'select[name="quantity"],'
            + 'input.js-qty__num[name="quantity"]'
            + BSS_B2B.getCartPriceClass('cart_quantity_input')
        );

        if (quantitySelector.length) {
            quantity = parseInt(quantitySelector.val());
        } else {
            // fix for theme Dawn
            let correctParent = $(parentElement).closest('.product__info-container, .product-single__meta');
            if (correctParent.length) {
                let correctForm = correctParent.find('.product-form__quantity, .product__quantity');
                if (correctForm.length) {
                    quantity = parseInt($(correctForm).find('.quantity__input, input.js-qty__num[name="quantity"]').val());
                }
            }
        }

        // QUANTITY INCREMENT
        if (isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length > 0) {
            BSS_B2B.qi.validateQIBuyItNow(product, quantity);
            let invalidProductIncrementData = BSS_B2B.qi.invalidIncrementProducts;
            if (invalidProductIncrementData.isInvalid) {
                BSS_B2B.qi.renderWarningMessageBuyItNow(invalidProductIncrementData);
                $(self).removeAttr('disabled');
                $(targetElement).html(oldHtml);
                return;
            }
        }
        // END QUANTITY INCREMENT

        // ORDER LIMITS
        if (isEnableAMO && BSS_B2B.amoRules.length > 0 && product && variant) {
            let appliedAmoRules = BSS_B2B.amo.getAppliedRulesForEachProduct(product, variant);
            BSS_B2B.amo.checkAmoRulesForEachProduct(appliedAmoRules, appliedQbRule, quantity);
            let event = new Event("bss.b2b.amo.doneCheckAMOByBSS");
            document.dispatchEvent(event);
            if (BSS_B2B.amo.warning.length > 0) {
                BSS_B2B.amo.showWarningsModal();
                $(self).removeAttr('disabled');
                if ([13923, 5686, 9570].includes(BSS_B2B.storeId)) {
                  $(targetElement).each((index, item) => {
                    $(item).html(oldHtml[index]);
                  });
                } else {
                  $(targetElement).html(oldHtml);
                }
                return;
            }
        }
        // END ORDER LIMITS

        // SHIPPING RATE
        let totalPrice = BSS_B2B.sr.getTotalPriceWhenClickBuyItNow(priceLists, appliedQbRule, product, variant, quantity);
        let rateMarket = Shopify.currency.rate
        let shippingRate = await BSS_B2B.sr.calculateShippingRateForBuyItNow(BSS_B2B.srRules, shopData.customer, product, variant, totalPrice, quantity, rateMarket);
        let efList = appliedEFRule;
        // END SHIPPING RATE

        // VAT VALIDATE
        let isEnabledVatValidate = false;

        if (BSS_B2B.shopModules && BSS_B2B.shopModules.length) {
            BSS_B2B.shopModules.forEach(function (md) {
                if (md.code === "tax_exempt") {
                    isEnabledVatValidate = md.status;
                }
            })
        }
        let vatNumber = "";
        let inputTaxElement = $('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
        let taxExMessage = $('.bss-b2b-tax-ex-message');
        if (parentForm.length) {
            inputTaxElement = $(parentForm).find('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
            taxExMessage = $(parentForm).find('.bss-b2b-tax-ex-message');
        }

        if ($(inputTaxElement).length) {
            vatNumber = $(inputTaxElement).val();
        }
        let validateVat = Tax.clientValidateVat(BSS_B2B.vatExemptSelected, vatNumber);

        if (isUseDefaultCheckout && BSS_B2B.storeId === 15588 && BSS_B2B.page.isProductPage()) {
            $(originalButton).trigger('click');
            return;
        }

        let isRequiredVat = BSS_B2B.vatSetting && BSS_B2B.vatSetting.is_required_vat;
        if ((isEnabledVatValidate && isRequiredVat && inputTaxElement.length) || (isEnabledVatValidate && !isRequiredVat && validateVat)) {
            BSS_B2B.vatCheckerForBuyItNow(domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, taxExMessage, inputTaxElement, targetElement, validateVat, poList);
        } else {
            BSS_B2B.redirectWithInvoiceUrl(domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, false, shippingRate, efList, poList);
        }
    };

    BSS_B2B.vatCheckerForBuyItNow = function (domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, taxExMessage, inputTaxElement, targetElement, validateVat, poList) {
        let errorMessage = '';
        let successMessage = '';
        let validateCountryCodeMessage = BSS_B2B.vatTranslations.form_validate_country_code_message;
        if (BSS_B2B.vatExemptSelected === 0) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message">' + BSS_B2B.vatTranslations.form_error_message + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message">' + BSS_B2B.vatTranslations.form_success_message + '</span>';
        } else if (BSS_B2B.vatExemptSelected === 1) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_uk">' + BSS_B2B.vatTranslations.form_error_message_uk + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_uk">' + BSS_B2B.vatTranslations.form_success_message_uk + '</span>';
        } else if (BSS_B2B.vatExemptSelected === 2) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_abn">' + BSS_B2B.vatTranslations.form_error_message_abn + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_abn">' + BSS_B2B.vatTranslations.form_success_message_abn + '</span>';
        } else if (BSS_B2B.vatExemptSelected === 3) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_gst">' + BSS_B2B.vatTranslations.form_error_message_gst + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_gst">' + BSS_B2B.vatTranslations.form_success_message_gst + '</span>';
        } else if (BSS_B2B.vatExemptSelected === 4) {
            errorMessage = '<span class="bss-b2b-translation-vat-form_error_message_us_ein">' + BSS_B2B.vatTranslations.form_error_message_us_ein + '</span>';
            successMessage = '<span class="bss-b2b-translation-vat-form_success_message_us_ein">' + BSS_B2B.vatTranslations.form_success_message_us_ein + '</span>';
        }
        let errorMessageHTML = "<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
            + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
            + errorMessage
            + "</p>";
        let successMessageHTML = "<p class='bss-b2b-tax-valid' style='color: green; margin-top: 5px'>"
            + "<span style='font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10003;</span> "
            + successMessage
            + "</p>";
        let validateCountryCodeMessageHTML = "<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
            + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
            + '<span class="bss-b2b-translation-vat-form_validate_country_code_message">' + validateCountryCodeMessage + '</span>'
            + "</p>";
        if (!validateVat) {
            $(taxExMessage).html(errorMessageHTML);
            BSS_B2B.integrate.langShop.handleAllTranslation('vat', ['form_error_message', 'form_error_message_uk', 'form_error_message_abn', 'form_error_message_gst', 'form_error_message_us_ein'])
            $(self).removeAttr('disabled');
            $(targetElement).html(oldHtml);
        } else {
            $(self).attr('disabled', "true");
            let countryCode = BSS_B2B.vatExemptSelected === 0 ? vatNumber.substr(0, 2) : '';
            let data = {
                domain: shopData.shop.permanent_domain
            };
            if (BSS_B2B.vatExemptSelected === 0) {
                vatNumber = vatNumber.toUpperCase();
                countryCode = countryCode.toUpperCase();
                data.vatNumber = vatNumber;
                data.countryCode = countryCode
            } else if (BSS_B2B.vatExemptSelected === 1) {
                data.ukVatNumber = vatNumber
            } else if (BSS_B2B.vatExemptSelected === 2) {
                data.abn = vatNumber
            } else if (BSS_B2B.vatExemptSelected === 3) {
                data.gstNumber = vatNumber
            } else if (BSS_B2B.vatExemptSelected === 4) {
                data.usEinNumber = vatNumber
            }
            if (!BSS_B2B.validateVatSuccess) {
                let router = '';
                if (BSS_B2B.vatExemptSelected === 0) {
                    router = "/wholesaler/valid/vat"
                } else if (BSS_B2B.vatExemptSelected === 1) {
                    router = "/wholesaler/valid/gst"
                } else if (BSS_B2B.vatExemptSelected === 2) {
                    router = "/wholesaler/valid/abn"
                } else if (BSS_B2B.vatExemptSelected === 3) {
                    router = "/wholesaler/valid/uk-vat"
                } else if (BSS_B2B.vatExemptSelected === 4) {
                    router = "/wholesaler/valid/us-ein-vat"
                }

                fetch(`${bssB2bApiServer}${router}?domain=${shopData.shop.permanent_domain}`, {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(function (data) {
                        if (data.success) {
                            const isEUVATCountry = BSS_B2B.vatSetting && BSS_B2B.vatSetting.selected_eu_vat_countries && BSS_B2B.vatSetting.selected_eu_vat_countries.includes(countryCode);
                            if (BSS_B2B.vatExemptSelected !== 0 || (BSS_B2B.vatExemptSelected === 0 && isEUVATCountry)) {
                                if (BSS_B2B.vatExemptSelected === 4) {
                                    successMessageHTML = "<p class='bss-b2b-tax-valid' style='color: green; margin-top: 5px'>"
                                        + "<span style='font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10003;</span> "
                                        + successMessage + ` (${data.data.company})`
                                        + "</p>"
                                }
                                $(taxExMessage).html(successMessageHTML);
                                BSS_B2B.integrate.langShop.handleAllTranslation('vat', ['form_success_message', 'form_success_message_uk', 'form_success_message_abn', 'form_success_message_gst', 'form_success_message_us_ein'])
                                BSS_B2B.validateVatSuccess = true;
                            } else {
                                $(taxExMessage).html(validateCountryCodeMessageHTML)
                                BSS_B2B.integrate.langShop.handleAllTranslation('vat', ['form_validate_country_code_message'])
                            }
                            if (BSS_B2B.vatSetting && BSS_B2B.vatSetting.auto_redirect_to_checkout) {
                                BSS_B2B.redirectWithInvoiceUrl(domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, poList);
                            } else {
                                $(self).removeAttr('disabled');
                                BSS_B2B.validateVatSuccess = true;
                                $(inputTaxElement).on("change", function () {
                                    let newVatNumber = $(inputTaxElement).val();
                                    if (newVatNumber !== vatNumber) {
                                        BSS_B2B.validateVatSuccess = false;
                                    }
                                });
                                $(targetElement).html(oldHtml)
                            }
                        } else {
                            $(taxExMessage).html(errorMessageHTML);
                            BSS_B2B.integrate.langShop.handleAllTranslation('vat', ['form_error_message', 'form_error_message_uk', 'form_error_message_abn', 'form_error_message_gst', 'form_error_message_us_ein'])
                            $(self).removeAttr('disabled');
                            $(targetElement).html(oldHtml);
                            if (BSS_B2B.vatSetting && (BSS_B2B.vatSetting.auto_redirect_to_checkout && !BSS_B2B.vatSetting.is_required_vat)) {
                                BSS_B2B.redirectWithInvoiceUrl(domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, poList);
                            }
                        }
                    });
            } else {
                BSS_B2B.redirectWithInvoiceUrl(domain, product, variant, priceLists, quantity, appliedQbRule, oldBuyItNowBtn, oldHtml, oldInputVal, vatNumber, shippingRate, efList, poList);
            }
        }

        BSS_B2B.integrate.langShop.handleAllTranslation('vat')
    };

    BSS_B2B.makeCloneBuyItNow = function (cartForm) {
        if(BSS_B2B.storeId === 9139){
            cartForm = $('.product safe-sticky.product-info');
        }

        let buyItNowBtn = $(cartForm).find('.shopify-payment-button__button:not([disabled]):not(.bss-b2b-cp-dynamic),'
            + '.shopify-payment-button__more-options:not([disabled]):not(.bss-b2b-cp-dynamic),'
            + '.shopify-payment-button__button.shopify-payment-button__button--unbranded:not([disabled]):not(.bss-b2b-cp-dynamic),'
            + '.button.button--primary.ctm-buynow_et:not([disabled]):not(.bss-b2b-cp-dynamic)'
            + (BSS_B2B.getCssSelector('product_buy_it_now_btn') !== '' ? (BSS_B2B.getCssSelector('product_buy_it_now_btn') + ":not([disabled]):not(.bss-b2b-cp-dynamic)") : '')
        );
        // fix smokeeraser by vitu
        if (BSS_B2B.storeId === 2433) {
            buyItNowBtn = $(cartForm).find('.shopify-payment-button__button:not([disabled]):not(.bss-b2b-cp-dynamic),.shopify-payment-button__more-options:not([disabled]):not(.bss-b2b-cp-dynamic):not(.shopify-payment-button__button--hidden),'
                + '.shopify-payment-button__button.shopify-payment-button__button--unbranded:not([disabled]):not(.bss-b2b-cp-dynamic)'
                + (BSS_B2B.getCssSelector('product_buy_it_now_btn') !== '' ? (BSS_B2B.getCssSelector('product_buy_it_now_btn') + ":not([disabled]):not(.bss-b2b-cp-dynamic)") : '')
            );
        }
        if (BSS_B2B.storeId === 3628) {
            buyItNowBtn = $(cartForm).find('.shopify-payment-button__button:not([disabled]):not(.bss-b2b-cp-dynamic),.shopify-payment-button__more-options:not([disabled]):not(.bss-b2b-cp-dynamic):not(.shopify-payment-button__button--hidden),' + '.btn-cart,'
                + '.shopify-payment-button__button.shopify-payment-button__button--unbranded:not([disabled]):not(.bss-b2b-cp-dynamic)'
                + (BSS_B2B.getCssSelector('product_buy_it_now_btn') !== '' ? (BSS_B2B.getCssSelector('product_buy_it_now_btn') + ":not([disabled]):not(.bss-b2b-cp-dynamic)") : '')
            );
        }
        // fix for acesefi by mitri
        if (BSS_B2B.storeId === 5065) {
            buyItNowBtn = $(cartForm).find('button[data-checkout="checkout"]');
        }
        let customBuyItNowBtn = $(cartForm).find('.shopify-payment-button__button.bss-b2b-cp-dynamic, .shopify-payment-button__more-options.bss-b2b-cp-dynamic');
        //+  (BSS_B2B.getCssSelector('product_buy_it_now_btn') != '' ?   (BSS_B2B.getCssSelector('product_buy_it_now_btn') + ".bss-b2b-cp-dynamic") : '')
        // fix for erlebe-naturseife.de by mitri
        if (buyItNowBtn.length && ![3849, 8553].includes(BSS_B2B.storeId)) {
            if (BSS_B2B.storeId === 621 && !BSS_B2B.page.isHomePage()) {
                return;
            }
            let cloneBuyItNow = $(buyItNowBtn).clone();
            if (customBuyItNowBtn.length === 0) {
                cloneBuyItNow.addClass("bss-b2b-cp-dynamic");
                cloneBuyItNow.css("margin-left", 0);
                cloneBuyItNow.css("display", "block");
                $(cloneBuyItNow).addClass("bss-b2b-btn-buyitnow");
                let parentElement = $(cartForm).find('.shopify-payment-button[data-shopify="payment-button"]');
                if (parentElement.length) {
                    parentElement.prepend(cloneBuyItNow);
                } else {
                    buyItNowBtn.before(cloneBuyItNow);
                }
                if ([5184, 2933, 12349, 13903].includes(BSS_B2B.storeId)) {
                    $(buyItNowBtn).hide();
                } else {
                    $(buyItNowBtn).remove();
                }
            } else {
                $(customBuyItNowBtn).addClass("bss-b2b-btn-buyitnow");
                if ([5184, 2933].includes(BSS_B2B.storeId)) {
                    $(buyItNowBtn).hide();
                } else {
                    $(buyItNowBtn).remove();
                }
                $(customBuyItNowBtn).show();
            }

            let cartFormId = $(cartForm).attr('id')
            let cartFormIdSplit = [];
            if (cartFormId) {
                cartFormIdSplit = cartFormId.split("_");
            }
            let productId = cartFormIdSplit[cartFormIdSplit.length - 1];

            if (BSS_B2B.page.isProductPage()) {
                productId = shopData.product ? shopData.product.id : 0;
            }
            if (BSS_B2B.storeId === 8653 && !BSS_B2B.page.isProductPage()) {
                const getElement = document.querySelector('.vertical-spacer [bss-b2b-product-id]')
                if (getElement) {
                    let getAttribute = getElement.getAttribute("bss-b2b-product-id")
                    productId = getAttribute
                }
            }
            // Check whether BuyItNow belongs to Featured Product section
            let featuredProduct = $(cartForm).closest(
                '.featured-product'
            );
            if (featuredProduct.length) {
                let hiddenForm = $(featuredProduct).find(
                    'form.shopify-product-form'
                );
                let hiddenFormId = $(hiddenForm).attr("id");
                if (hiddenFormId && hiddenFormId.length) {
                    var hiddenFormIdSplit = hiddenFormId.split("_");
                    productId = hiddenFormIdSplit[2];
                }
            }

            if ($(cartForm).parent().find("#ProductPrice").length > 0) {
                productId = $(cartForm).parent().find("#ProductPrice").attr('bss-b2b-product-id');
            }
            if (isNaN(productId)) {
                productId = $(cartForm).find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
            }
            if(isNaN(productId)) {
                productId = $(cartForm).closest("product-info").find('[bss-b2b-product-id]').attr('bss-b2b-product-id');
            }
            if (isNaN(productId)) {
                cartFormIdSplit = $(cartForm).attr('id').split("-");
                productId = cartFormIdSplit[1];
                if (isNaN(productId)) {
                    if (cartFormIdSplit.length > 1) {
                        var jsonSectionId = "#ProductJson-" + cartFormIdSplit[1];
                        try {
                            productId = JSON.parse($(jsonSectionId).html()).id;
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.log("Could not parse JSON of product section")
                        }
                    }
                }
            }
            if (isNaN(productId)) {
                let quickShopTemplateId = $(cartForm).closest('#product-id-product-template-quick');
                if (quickShopTemplateId.length) {
                    productId = $(quickShopTemplateId).attr('data-product-id');
                }
            }

            BSS_B2B.redirectToCheckoutPage(
                $(cartForm).find('.shopify-payment-button__button.bss-b2b-cp-dynamic,'
                    + '.shopify-payment-button__more-options.bss-b2b-cp-dynamic,'
                    + '.button.button--primary.ctm-buynow_et.bss-b2b-cp-dynamic'),
                productId,
                cartForm,
                buyItNowBtn
            );
        }
    }

    BSS_B2B.redirectToCheckoutPage = function (element, productId, parentElement, oldBuyItNowBtn) {
        let id = shopData.product ? shopData.product.id : 0;
        if (productId) {
            id = productId;
        }
        let query = 'id:"' + id + '"';
        let urlData = '/search?q=' + query + '&view=bss.b2b';
        let encodeUrlData = encodeURI(urlData);

        let productsHasMetaField = [];
        productsHasMetaField = BSS_B2B.getProductMetaField();

        let isEnabledVatValidate = false;
        let isEnableSR = false;
        let isEnableEF = false;

        if (BSS_B2B.shopModules && BSS_B2B.shopModules.length) {
            BSS_B2B.shopModules.forEach(function (md) {
                if (md.code === "tax_exempt") {
                    isEnabledVatValidate = md.status;
                }
                if (md.code === "sr") {
                    isEnableSR = md.status;
                }
                if (md.code === "ef") {
                    isEnableEF = md.status;
                }
            })
        }

        $.get(encodeUrlData, function (data) {
            let responseProducts = [];
            let productIdResponse = [];
            try {
                responseProducts = JSON.parse(data);
                responseProducts.map(item => productIdResponse.push(item.id));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log('B2B: JSON parse returns no item')
            }


            if (BSS_B2B.page.isProductPage() && shopData.product.id && !productIdResponse.includes(shopData.product.id)) {
                if (!shopData.product.collections) {
                    const _product = { ...shopData.product, collections: shopData.collections };
                    responseProducts.push(_product);
                } else {
                    responseProducts.push(shopData.product);
                }
                productIdResponse.push(shopData.product.id);
            } else if (BSS_B2B.page.isCartPage() && shopData.line_item_products.length > 0) {
                shopData.line_item_products.map(item => {
                    if (!productIdResponse.includes(item.id)) {
                        responseProducts.push(item);
                        productIdResponse.push(item.id);
                    }
                })
            } else if (productsHasMetaField.length > 0) {
                productsHasMetaField.map(item => {
                    if (!productIdResponse.includes(item.id)) {
                        responseProducts.push(item);
                        productIdResponse.push(item.id);
                    }
                });
            }

            let featuredProduct = BSS_B2B.getFeaturedProductMetaField();
            if (Object.keys(featuredProduct).length > 0 && !productIdResponse.includes(featuredProduct.id)) {
                responseProducts.push(featuredProduct);
            }

            if (responseProducts.length > 0) {
                // let productMap = [];
                // let productPrices = [];
                // let checkUnique = [];
                // for (let i = 0; i < responseProducts.length; i++) {
                //     let pro = responseProducts[i];
                //     if (checkUnique.indexOf(pro.id) === -1) {
                //         checkUnique.push(pro.id);
                //         const priceElement = document.querySelector(`[bss-b2b-product-id='${productId}'][bss-b2b-variant-id]`)
                //         let variant = priceElement.getAttribute('bss-b2b-variant-id');
                //         if(variant == productId || variant === ""){
                //             variant = priceElement.getAttribute('bss-b2b-variant-id-selected');
                //         }
                //         productMap.push({
                //             id: pro.id,
                //             tags: pro.tags,
                //             collections: pro.collections,
                //             variantsApplied: parseInt(variant)
                //         });
                //         productPrices[pro.id] = {
                //             price: pro.price,
                //             priceMin: pro.price_min,
                //             priceMax: pro.price_min,
                //             compareAtPriceMin: pro.compare_at_price_min,
                //             compareAtPriceMax: pro.compare_at_price_max,
                //             variantSelected: parseInt(variant)
                //         }
                //     }
                // }

                // let priceLists = BSS_B2B.getPriceList(shopData, productMap, false);
                let targetElement = $(".shopify-payment-button__button.bss-b2b-cp-dynamic,.shopify-payment-button__more-options.bss-b2b-cp-dynamic,.bss-b2b-btn-buyitnow"
                    + (BSS_B2B.getCssSelector('product_buy_it_now_btn') !== '' ? (BSS_B2B.getCssSelector('product_buy_it_now_btn') + '.bss-b2b-cp-dynamic') : '')
                );
                // fix for acesefi by mitri
                if (element && [3628, 5065].indexOf(BSS_B2B.storeId) === -1) {
                    targetElement = element;
                }
                let isDone = false;
                targetElement.off();
                targetElement.on("click", async function (e) {
                    if (isDone) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    let variant = false;
                    let queryArray = BSS_B2B.getQueryArray();
                    if (queryArray.indexOf("variant") !== -1) {
                        variant = queryArray["variant"];
                    }
                    if (parentElement) {
                        let variantSelector = $(parentElement).find(
                            'select#ProductSelect--product-template :selected, ' +
                            'select#ProductSelect--featured-product :selected, ' +
                            'select[name="id"] :selected, ' +
                            'input[name="id"]'
                            + BSS_B2B.getCssSelector('product_select_variant_input')
                        );
                        if (variantSelector.length) {
                            variant = variantSelector.val()
                        }
                    }
                    if (!variant && [12879, 11576, 13762].includes(BSS_B2B.storeId)) {
                        variant = $("input[name='id']").val()
                    }
                    if (productId && variant && isEnableQB) {
                        BSS_B2B.qb.getAppliedRuleForEachProduct(responseProducts[0], variant);
                    }
                    let productMap = [];
                    let productPrices = [];
                    let checkUnique = [];
                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            const priceElement = document.querySelector(`[bss-b2b-product-id='${productId}'][bss-b2b-variant-id]`)
                            let variant = priceElement && priceElement.getAttribute('bss-b2b-variant-id');
                            if (variant) {
                                productMap.push({
                                    id: pro.id,
                                    tags: pro.tags,
                                    collections: pro.collections,
                                    isFeatured: true,
                                    variantsApplied: parseInt(variant),
                                });
                                productPrices[pro.id] = {
                                    price: pro.price,
                                    priceMin: pro.price_min,
                                    priceMax: pro.price_min,
                                    compareAtPriceMin: pro.compare_at_price_min,
                                    compareAtPriceMax: pro.compare_at_price_max,
                                    variants: pro.variants
                                }
                            } else {
                                productMap.push({
                                    id: pro.id,
                                    tags: pro.tags,
                                    collections: pro.collections
                                });
                                productPrices[pro.id] = {
                                    price: pro.price,
                                    priceMin: pro.price_min,
                                    priceMax: pro.price_min,
                                    compareAtPriceMin: pro.compare_at_price_min,
                                    compareAtPriceMax: pro.compare_at_price_max
                                }
                            }
                        }
                    }
                    let priceLists = BSS_B2B.getPriceList(shopData, productMap, false, productPrices);

                    let poList = [];
                    if (typeof BSS_PO !== 'undefined' && BSS_PO.enable) {
                        poList = BSS_B2B.integrate.productOption.getPoListProductPage();
                    }
                    let vatValue = "";
                    const vatInput = document.querySelector(`.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]`);
                    if (vatInput) {
                        vatValue = vatInput.value;
                    }
                    let ruleOLForEachProduct = BSS_B2B.amo.getAppliedRulesForEachProduct(productId ? responseProducts[0] : false, variant);
                    let appliedRulesSr = await BSS_B2B.sr.getAppliedRules(BSS_B2B.srRules, productMap, shopData.customer);
                    let isUseDefaultCheckout = (
                        priceLists.length === 0
                        && !BSS_B2B.qb.appliedQbRuleForOneProduct
                        && (!isEnabledVatValidate || (isEnabledVatValidate && !vatValue))
                        && (!isEnableSR || (isEnableSR && appliedRulesSr.length === 0))
                        && !isEnabledQI
                        && !isEnableEF
                        && poList.length === 0
                    )

                    if (priceLists.length === 0
                        && !BSS_B2B.qb.appliedQbRuleForOneProduct
                        && (!isEnabledVatValidate || (isEnabledVatValidate && !vatValue))
                        && (!isEnableSR || (isEnableSR && appliedRulesSr.length === 0))
                        && !isEnabledQI
                        && !isEnableEF
                        && (BSS_B2B.amo.warning && BSS_B2B.amo.warning.length === 0 && ruleOLForEachProduct.length === 0)
                        && poList.length === 0
                    ) {
                        //Need to handle case which pricelists is empty
                        isDone = true;
                        let originalButton = oldBuyItNowBtn;
                        $(targetElement).remove();
                        originalButton.show();
                        if (BSS_B2B.storeId === 5184) {
                            originalButton.click(function () {
                                e.stopPropagation();
                                window.location = originalButton[0].href;
                            })
                        }
                        $(originalButton).trigger('click');
                    } else {
                        let appliedQbRule = BSS_B2B.qb.appliedQbRuleForOneProduct;
                        let appliedEFRule = BSS_B2B.ef.appliedEFRuleForOneProduct;
                        if (BSS_B2B.cp.productAfterUseCP.length > 0 && appliedQbRule) {
                            BSS_B2B.cp.productAfterUseCP.forEach(item => {
                                if (item.id == productId) {
                                    appliedQbRule.price = item.price;
                                    return;
                                }
                            })
                        }

                        BSS_B2B.handleBuyItNowBtn(priceLists, variant, productId ? responseProducts[0] : false, parentElement, appliedQbRule, targetElement, appliedEFRule, poList, isUseDefaultCheckout, oldBuyItNowBtn);
                    }
                })
            }
        })
    }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initBogo; });
/* harmony import */ var _helper_validate_date_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);

const taxDisplayRules = __webpack_require__(2)
function initBogo($, BSS_B2B, shopData, isEnableBOGO, isEnableCP, isEnabledTD) {
    BSS_B2B.bogo = {};
    BSS_B2B.bogo.loading = true;
    BSS_B2B.cart.bogoPricingList = [];
    BSS_B2B.bogo.isloaded = false;
    BSS_B2B.bogo.priceOfEachItemElement = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] .cart__price.text-right [data-cart-item-regular-price]',
            '[data-cart-item-key="' + key + '"] .cart__table-cell:not(.cart__table-cell--total) .cart__price:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .cart-drawer__price .cart-item__original-price.cart-item__price:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] [data-cart-item-price-container] .cart-item__original-price.cart-item__price:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .cart__table-cell--price.medium-up--text-right:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .grid__item.one-half.post-large--text-right .h5:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .text-right[data-label="Price"]:not(:has(>span))',
            //fix for AlemaProShop by Khanh
            '[data-cart-item-key="' + key + '"] .sf-cart__item--regular-price [bss-b2b-item-original-price]',
            //fix for wisefood by mitri
            '[data-cart-item-key="' + key + '"] .cart-item--content-price .money',
            //fix for simonstoreuk by cuongnvm
            '[data-cart-item-key="' + key + '"] .line-item__price',
            //fix for kellysultimatesports.myshopify by haipd
            '[data-cart-item-key="' + key + '"] .bss-discount-name-bogo ~ div.product-option',
            // fix for new.naturalcreations925.com by LuanHV
            '[data-cart-item-key="' + key + '"] .cart-item-block .price--end',
            '[data-cart-item-key="' + key + '"] .previewCartItem-price .price',
            //fix for nohem-dev
            '[data-cart-item-key="' + key + '"] .product-price .amount',
            //fix for b2b-vapeholster.myshopify.com bye LuanHV
            '[data-cart-item-key="' + key + '"] .item-info .item-price .money',
            '[data-cart-item-key="' + key + '"] .line-item__price-list .bss-b2b-cart-vat .money',
            //fix for mazzei.it by anhtd
            '[data-cart-item-key="' + key + '"] .cart-item__content .cart__price',
            // fix for misencil.fr by cuongnq
            '[data-cart-item-key="' + key + '"] .cart-item__details .bss-b2b-cart-vat',
            '[data-cart-item-key="' + key + '"] .CartItem__PriceList .CartItem__Price.Price',
            '[data-cart-item-key="' + key + '"] .bss-b2b-cart-vat',
            '[data-cart-item-key="' + key + '"] [data-js-product-price]',
            '[data-cart-item-key="' + key + '"] .cart__item-price-col',
            '[data-cart-item-key="' + key + '"] .price-box span:nth-child(2)',
            //fix for nnjdesigns.com by namtp
            '[data-cart-item-key="' + key + '"] .cart__item__content .cart__price',
            //fix for o3plus-btob by Devlin
            '[data-cart-item-key="' + key + '"] .mini-cart-product-price',
            '[data-cart-item-key="' + key + '"] .cart-price .revy-original-item-price, [data-cart-item-key="' + key + '"] .minicart-price .price',
        ]
    };
    BSS_B2B.bogo.titleOfEachItemElement = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] .cart__product-information .product-details',
            //fix for AlemaProShop by Khanh
            '[data-cart-item-key="' + key + '"] .sf-cart__item-product-title',
            //fix for wisefood by mitri
            '[data-cart-item-key="' + key + '"] .cart-item--content-title',
            //fix for watc-studio
            '[data-cart-item-key="' + key + '"] .item-title',
            //fix for simonstoreuk by cuongnvm
            '[data-cart-item-key="' + key + '"] .line-item__title.link.text--strong',
            //fix for kellysultimatesports.myshopify by haipd
            '[data-cart-item-key="' + key + '"] .cart-item__details .cart-item__name',
            //fix for nohem-dev
            '[data-cart-item-key="' + key + '"] .product-name-thumb > a',
            '[data-cart-item-key="' + key + '"] .mini-cart__product-info a.mini-cart__product-title',
            //fix for mazzei.it by anhtd
            '[data-cart-item-key="' + key + '"] .cart-item__content .cart-item__content-inner .cart-item__title a',
            '[data-cart-item-key="' + key + '"] .CartItem__Info .CartItem__Title.Heading',
            '[data-cart-item-key="' + key + '"] .cart-item-title item-title',
            // fix for thesera.ch by LongNH2
            '[data-cart-item-key="' + key + '"] .cart-item__details .cart-item__title',
            '[data-cart-item-key="' + key + '"] .cart__price-wrapper.cart-flex-item .t4s-cart_price',
            //fix for o3plus-btob by Devlin
            '[data-cart-item-key="' + key + '"] .mini-cart-product-title',
            '[data-cart-item-key="' + key + '"] .cart-product-title a',
            '[data-cart-item-key="' + key + '"] .product-item-details .product-item-name',
        ]
    };
    BSS_B2B.bogo.totalPriceOfItemElement = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] [data-cart-item-line-price] [data-cart-item-regular-price]',
            '[data-cart-item-key="' + key + '"] .cart__table-cell--line-price[data-label="Total"]:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .text-right[data-label="Total"]:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .cart__item-total:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .cart-original-price.order-discount--cart-price:not(:has(>span))',
            '[data-cart-item-id="' + key + '"] [data-cart-item-line-price-container] .cart-item__original-price.cart-item__price:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] .grid__item.two-thirds.text-right .cart__price:not(:has(>span)):not(".cart__price--bold")',
            '[data-cart-item-key="' + key + '"] .grid--full.cart__row--table-large .grid__item.text-right .h5:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] span.cart__price.cart__price--bold:not(:has(>span))',
            '[data-cart-item-key="' + key + '"] [bss-b2b-final-line-price] .money',
            //fix for AlemaProShop by Khanh
            '[data-cart-item-key="' + key + '"] .sf-cart__item--regular-price [bss-b2b-item-original-price]',
            //fix for wisefood by mitri
            '[data-cart-item-key="' + key + '"] .cart-item--total',
            //fix for watc-studio
            '[data-cart-item-key="' + key + '"] .item-price.text-size--smaller',
            //fix for kellysultimatesports.myshopify by haipd
            '[data-cart-item-key="' + key + '"] .cart-item__totals .price .money',
            // fix for new.naturalcreations925.com by LuanHV
            '[data-cart-item-key="' + key + '"] .cart-item-block .cart-item-value',
            //fix for nohem-dev
            '[data-cart-item-key="' + key + '"] .product-subtotal .amount',
            //fix for b2b-vapeholster.myshopify.com by LuanHV
            '[data-cart-item-key="' + key + '"] .item-price .full-price .money',
            '[data-cart-item-key="' + key + '"] .line-item__line-price .money',
            '[data-cart-item-key="' + key + '"] .line-item__line-price .bss-b2b-cart-vat .money',
            '[data-cart-item-key="' + key + '"] .mini-cart__price-list .bss-b2b-cart-vat .money',
            // fix for misencil.fr by cuongnq
            '[data-cart-item-key="' + key + '"] .cart-item__price-wrapper .bss-b2b-cart-vat',
            '[data-cart-item-key="' + key + '"] .price.price--end',
            // fix for wo-we-shop by cuongnvm
            '[data-cart-item-key="' + key + '"] .mini-cart__price-list .price',
            '[data-cart-item-key="' + key + '"] .cart-item__price-wrapper .price',
            // fix for thesera.ch by LongNH2
            '[data-cart-item-key="' + key + '"] .cart-item__details .cart-item__price',
            '[data-cart-item-key="' + key + '"] .cart--total.h-mobile .price',
            '[data-cart-item-key="' + key + '"] .cart-price .revy-final-item-price',
        ]
    };
    BSS_B2B.bogo.cartSubtotalPriceElement = function () {
        return [
            '.cart-subtotal .cart-subtotal__price',
            '.large--one-third .cart__subtotal > :not(span)',
            '.cart-subtotal--price small > :not(span)',
            '.cart-subtotal--price > :not(span)',
            '.cart__subtotal .cart__subtotal-price > :not(span)',
            '.cart__totals .cart__subtotal > :not(span)',
            //fix for AlemaProShop by Khanh
            '.sf-cart-subtotal__price [bss-b2b-cart-total-price]',
            //fix for wisefood by mitri
            '.cart-title-total .money',
            '.cart-final-total .cart-subtotal .money',
            //fix for watc-studio
            '#CartTotal span',
            //fix for simonstoreuk by cuongnvm
            '.cart-recap__price-line-price',
            //fix for kellysultimatesports.myshopify by haipd
            // fix for new.naturalcreations925.com by LuanHV
            '.cart-total-subtotal .cart-total-value .text',
            '.cart-total-grandtotal .cart-total-value',
            '.previewCartTotals .previewCartTotals-value',
            //fix for nohem-dev
            '.total-checkout .cart-amount .amount',
            //fix for b2b-vapeholster.myshopify.com bye LuanHV
            '.cart-total-wrap .cart-sub-total .money',
            '.mini-cart__recap-price-line .money',
            '.cart-recap__price-line-price .money',
            '.cart-recap__price-line-price .bss-b2b-cart-vat-subtotal .money',
            //fix for haircare-uk
            '[bss-b2b-cart-total-price]:not(.totals__subtotal-value)',
            //fix for mazzei.it by anhtd
            '.cart__inner .cart__aside .cart__total .cart__total__money',
            // fix for misencil.fr by cuongnq
            '.totals .bss-b2b-cart-vat-subtotal',
            // fix for wo-we-shop by cuongnvm
            '.mini-cart__recap-price-line .subtotal-price',
            '.cart__blocks .totals .totals__subtotal-value',
            ".cart__sidebar .cart__subtotal h3",
            ".cart__page .cart__page-col .cart__item--subtotal div[data-subtotal]",
            ".cart__item-sub.cart__item-row.cart__item--subtotal > div:nth-child(2)"
        ]
    };

    BSS_B2B.bogo.getPriceList = function (rule, productMap, isCartItem, checkUniquePriceLists, itemCart) {
        let customerGetDiscountValue = rule.customer_getting_discount_value;
        let specificProductIds = rule.customer_getting_product_ids ? rule.customer_getting_product_ids.split(",") : [];
        let ruleCollectionIds = rule.customer_getting_product_collections ? rule.customer_getting_product_collections.split(",") : [];

        for (let i = 0; i < productMap.length; i++) {
            let productId = productMap[i].id;
            if (itemCart.product_id == productId) {
                let collections = productMap[i].collections;
                if (specificProductIds.length > 0) {
                    if (specificProductIds.indexOf(productId + "") !== -1 && checkUniquePriceLists.indexOf(productId) === -1) {
                        checkUniquePriceLists.push(productId);
                        const key = isCartItem ? productMap[i].key : false;
                        return {
                            "id": productId,
                            "discount_type": 2,
                            "value": customerGetDiscountValue,
                            "key": key,
                            'name': rule.name,
                            'rule_id': rule.id,
                            'sid': `${rule.token}.${Buffer.from(key).toString('base64')}`
                        };
                    }
                }
                if (ruleCollectionIds.length > 0) {
                    let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                    if (checkArray.length > 0 && checkUniquePriceLists.indexOf(productId) === -1) {
                        checkUniquePriceLists.push(productId);
                        const key = isCartItem ? productMap[i].key : false;
                        return {
                            "id": productId,
                            "discount_type": 2,
                            "value": customerGetDiscountValue,
                            "key": key,
                            'name': rule.name,
                            'rule_id': rule.id,
                            'sid': `${rule.token}.${Buffer.from(key).toString('base64')}`
                        };
                    }
                }
            }
        }
    };
    BSS_B2B.bogo.updateQuantityItemsCart = function (indexBuy, quantityBuy, itemBuy, indexGet, quantityGet, isExist) {
        let stringUrl = '';
        let lineItemBuy = {};
        if (!isExist) {
            stringUrl = '/cart/add.js';
            lineItemBuy = {
                'items': [{
                    'id': itemBuy.variant_id,
                    'quantity': quantityBuy,
                    'properties': {
                        'Bogo': "Not Applied"
                    }
                }]
            };
        } else if (isExist) {
            stringUrl = '/cart/change.js';
            lineItemBuy = {
                "line": indexBuy + 1,
                "quantity": quantityBuy
            };
        }

        let lineItemGet = {
            "line": indexGet + 1,
            "quantity": quantityGet
        };
        if (!BSS_B2B.bogo.isloaded) {
            BSS_B2B.bogo.isloaded = true;
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(lineItemGet)
            }).then(() => {
                let timeDelay = 0;
                if (BSS_B2B.storeId === 12158) {
                    timeDelay = 1000;
                }
                setTimeout(function () {
                    fetch(stringUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(lineItemBuy)
                    }).then(() => {
                        if (window.location.pathname == "/cart") {
                            $(location).attr('href', `${shopData.shop.url}/cart`);
                        } else if (BSS_B2B.storeId === 10989) {
                            if (!localStorage.getItem("bogo-customize-10989-isloaded")) {
                                localStorage.setItem("bogo-customize-10989-isloaded", true)
                                setTimeout(() => {
                                    location.reload();
                                }, 1000)
                            } else {
                                localStorage.removeItem("bogo-customize-10989-isloaded")
                            }
                        }
                    }).catch((error) => {
                        // eslint-disable-next-line no-console
                        console.error('Error: BSS_B2B.bogo.isloaded = true;', error);
                    });
                }, timeDelay)
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.error('Error:', error);
            });
            return;
        }

    };

    BSS_B2B.bogo.quantityBuyNotMeetRequirement = function (cartData, specificProductIdsGet) {
        for (let i = 0; i < cartData.items.length; i++) {
            if (cartData.items[i].properties !== null
                && Object.keys(cartData.items[i].properties).length > 0
                && specificProductIdsGet.indexOf(cartData.items[i].product_id + "") !== -1) {
                let customCheck = true
                if (BSS_B2B.storeId === 4250 && Object.keys(cartData.items[i].properties).length === 1 && cartData.items[i].properties[' Business name addition']) {
                    customCheck = false
                }
                if (customCheck) {
                    cartData.items.forEach(function (item, indexGet) {
                        let countExist = 0;
                        if ([8605].includes(BSS_B2B.storeId)) {
                            cartData.items.forEach(function (itemExist) {
                                if (item.product_id == itemExist.product_id) {
                                    countExist++;
                                }
                            });
                        }

                        if ((
                            (item.properties !== null && !item.properties["Bogo"])
                            || item.properties == null
                        )
                            && item.product_id == cartData.items[i].product_id
                            && specificProductIdsGet.indexOf(item.product_id + "") !== -1) {
                            let indexBuy = i;
                            let quantityGet = cartData.items[i].quantity + item.quantity;

                            if (countExist == 2 && [8605].includes(BSS_B2B.storeId)) {
                                BSS_B2B.bogo.updateQuantityItemsCart(indexBuy, 0, cartData.items[i], indexGet, quantityGet, true);
                            } else if (![8605, 12294, 5686].includes(BSS_B2B.storeId)) {
                                BSS_B2B.bogo.updateQuantityItemsCart(indexBuy, 0, cartData.items[i], indexGet, quantityGet, true);
                            }
                        }
                    });
                }
                break;
            }
        }
    };

    BSS_B2B.bogo.resetItemAppliedPropertiesBogo = async function (cartData, checkReset) {
        let lineItemKeys = [];
        let updateLineItems = {};
        let addLineItems = [];

        cartData.items.forEach(function (item) {
            let countExist = 0;
            cartData.items.forEach(function (itemExist) {
                if (item.product_id == itemExist.product_id) {
                    countExist++;
                }
            });
            if (item.properties !== null && item.properties['Bogo']) {
                if (checkReset) {
                    let lineItem = {
                        id: item.variant_id,
                        key: item.key,
                        quantity: item.quantity
                    };
                    lineItemKeys.push(lineItem)
                } else if (!isEnableBOGO || (BSS_B2B.bogoRule && BSS_B2B.bogoRule.length === 0) || (countExist === 1)) {
                    let lineItem = {
                        id: item.variant_id,
                        key: item.key,
                        quantity: item.quantity
                    };
                    lineItemKeys.push(lineItem)
                }
            }
        });

        if (lineItemKeys.length > 0) {
            for (let i = 0; i < lineItemKeys.length; i++) {
                let lineItemAdd = {
                    'id': lineItemKeys[i].id,
                    'quantity': lineItemKeys[i].quantity
                };
                addLineItems.push(lineItemAdd);
                updateLineItems[lineItemKeys[i].key] = 0
            }
        }

        if (Object.keys(updateLineItems).length > 0) {
            BSS_B2B.bogo.loading = false;
            let updates = {
                'updates': updateLineItems
            };
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updates)
            });
            let lineItemsAdd = {
                'items': addLineItems
            };
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(lineItemsAdd)
            });
            if (BSS_B2B.storeId === 10989) {
                if (!localStorage.getItem("bogo-customize-10989-isloaded")) {
                    localStorage.setItem("bogo-customize-10989-isloaded", true)
                    setTimeout(() => {
                        location.reload();
                    }, 1000)
                } else {
                    localStorage.removeItem("bogo-customize-10989-isloaded")
                }
            } else {
                $(location).attr('href', `${shopData.shop.url}/cart`);
            }
        }
    };

    BSS_B2B.bogo.addDiscountProduct = function (rule, item, totalQuantityCustomerCanGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap) {
        let quantityCustomerGet = rule.customer_getting_quantity_products;
        let totalPriceItem = item.original_line_price;
        let pricePerItem = item.original_price;

        if (((BSS_B2B.configData && BSS_B2B.configData.length) || (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length)) && BSS_B2B.cart.cpPricingList.size > 0) {
            let itemCP = BSS_B2B.cart.cpPricingList.get(item.key);
            if (itemCP) {
                totalPriceItem = itemCP.modifiedLineItemPrice;
                pricePerItem = itemCP.modifiedItemPrice;
            }
        }

        if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
            let itemQB = BSS_B2B.cart.qbPricingList.get(item.key);
            if (itemQB) {
                totalPriceItem = itemQB.pricePerItemAfterApplyQB * itemQB.quantity;
                pricePerItem = itemQB.pricePerItemAfterApplyQB;
            }
        }
        let customerGetDiscountType = rule.customer_getting_discount_type;
        let customerGetDiscountValue = rule.customer_getting_discount_value;

        for (let i = quantityCustomerGet; i <= totalQuantityCustomerCanGet; i = i + quantityCustomerGet) {
            let quantityCustomerGetLowerGap = i;
            let quantityCustomerGetUpperGap = i + quantityCustomerGet;
            if (quantityCustomerGetUpperGap < item.quantity) {
                continue;
            }
            //quantity product is suitable to apply bogo
            let checkQuantityEnoughToGetDiscount = false;
            let checkQuantityLeftEnough = false;

            // let anotherQuantityItemsGet = totalQuantityGetLeft - item.quantity;
            for (let i = 1; i <= totalQuantityGetLeft; i++) {
                let quantityGetMeetRequirement = item.quantity + i;
                if (quantityGetMeetRequirement % quantityCustomerGet === 0) {
                    checkQuantityLeftEnough = true;
                    break;
                }
            }
            if (BSS_B2B.storeId === 1123) {
                if (item.quantity <= totalQuantityGetLeft) {
                    checkQuantityLeftEnough = true;
                }
            }

            if (checkQuantityLeftEnough
                || item.quantity === quantityCustomerGetLowerGap
                || item.quantity === quantityCustomerGetUpperGap
            ) {
                checkQuantityEnoughToGetDiscount = true;
            }
            if (checkQuantityEnoughToGetDiscount && item.quantity <= totalQuantityCustomerCanGet) {
                itemsCheckedBogo.push(item.key);
                if (customerGetDiscountType === 1) {
                    BSS_B2B.cart.modifiedSubtotalPriceBogo = BSS_B2B.cart.modifiedSubtotalPriceBogo - totalPriceItem;
                } else {
                    BSS_B2B.cart.modifiedSubtotalPriceBogo = BSS_B2B.cart.modifiedSubtotalPriceBogo - item.quantity * (pricePerItem / 100 * customerGetDiscountValue);
                }

                let priceBogo = BSS_B2B.bogo.getPriceList(rule, productMap, true, checkUniquePriceLists, item);

                if (BSS_B2B.cart.itemKeysAppliedBogo.indexOf(priceBogo.key) === -1) {
                    BSS_B2B.cart.itemKeysAppliedBogo.push(priceBogo.key);
                    BSS_B2B.cart.updatedLineItemsByBogo = [...BSS_B2B.cart.updatedLineItemsByBogo, priceBogo];
                }

                let discountNameElement = $(BSS_B2B.bogo.titleOfEachItemElement(item.key).join(','));
                if (discountNameElement.length > 0) {
                    let discountText = rule.name;
                    if (BSS_B2B.storeId === 2741 && customerGetDiscountType === 1) {
                        discountText = "FREE"
                    }
                    let elementDiscount = '<span class="bss-discount-name-bogo" style="display: block; color:red">'
                        + discountText + ' : ' + parseFloat(customerGetDiscountValue) + '% Discount' +
                        '</span>';
                    $('[data-cart-item-key="' + item.key + '"] .bss-discount-name-bogo').remove();
                    discountNameElement.after(elementDiscount);
                }

                let priceOfEachItemElement = $(BSS_B2B.bogo.priceOfEachItemElement(item.key).join(','));
                let totalPriceOfItemElement = $(BSS_B2B.bogo.totalPriceOfItemElement(item.key).join(','));
                let cartSubtotalPriceElement = $(BSS_B2B.bogo.cartSubtotalPriceElement().join(','));


                if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
                    let cartItemElement = $('[data-cart-item-key="' + item.key + '"]');
                    let qbElementPrice = $('.bss-qb-price-item,.bss-qb-total-price-item,.bss-qb-cart-subtotal');
                    if (qbElementPrice && qbElementPrice.length > 0) {
                        cartItemElement.find('.bss-qb-price-item').css('text-decoration', 'line-through');
                        cartItemElement.find('.bss-qb-total-price-item').css('text-decoration', 'line-through');
                        cartItemElement.find('.bss-qb-cart-subtotal').css('text-decoration', 'line-through');
                    }
                }

                let priceAfterDiscount = pricePerItem - (pricePerItem / 100 * customerGetDiscountValue);
                let priceItemTotalAfterDiscount = priceAfterDiscount * item.quantity;

                if (customerGetDiscountType === 1) {
                    priceAfterDiscount = 0;
                    priceItemTotalAfterDiscount = 0;
                }

                BSS_B2B.cart.bogoPricingList.push({
                    nameRule: rule.name,
                    modifiedLineItemPrice: priceItemTotalAfterDiscount,
                    modifiedItemPrice: priceAfterDiscount,
                    key: item.key,
                    id: item.id,
                    quantity: item.quantity
                });

                let qbPriceItem = $('[data-cart-item-key="' + item.key + '"] .bss-qb-price-item');
                let qbTotalPriceItem = $('[data-cart-item-key="' + item.key + '"] .bss-qb-total-price-item');
                let qbCartSubtotal = $('.bss-qb-cart-subtotal');
                let text = "";
                const shopRawData = $('#bss-b2b-store-data');
                if (shopRawData.length > 0) {
                    const shopData = JSON.parse(shopRawData.html())
                    if (shopData) {
                        const tdRule = taxDisplayRules.getAppliedRuleCartPage(BSS_B2B, shopData);
                        if (BSS_B2B.storeId === 12528 && tdRule) {
                            priceOfEachItemElement = $('[data-cart-item-key="' + item.key + '"] .bss-discount-name-bogo ~ div.product-option');
                            totalPriceOfItemElement = $('[data-cart-item-key="' + item.key + '"] .cart-item__price-wrapper .bss-b2b-cart-vat');
                            cartSubtotalPriceElement = $('.totals .bss-b2b-cart-vat-subtotal')
                            let cartSubtotalWrapper = $("#main-cart-footer .js-contents .totals")
                            if (cartSubtotalWrapper.length > 0) {
                                cartSubtotalWrapper.css("flex-direction", "column");
                            }
                        }
                        if (BSS_B2B.storeId === 8930 && tdRule) {
                            cartSubtotalPriceElement = $('.cart_border .bss-b2b-cart-vat-subtotal')
                        }
                        if (tdRule) {
                            switch (tdRule.display_price_type) {
                                case 0:
                                    break;
                                case 1:
                                    text = " " + BSS_B2B.taxDisplayTranslations.included_vat_text.replace("|", "")
                                    break;
                                case 2:
                                    text = " " + BSS_B2B.taxDisplayTranslations.excluded_vat_text.replace("|", "")
                                    break;
                            }
                        }
                    }
                }
                if (priceOfEachItemElement.length > 0) {
                    let priceItemHTML = '<span class="bss-bogo-price-item" style="display: block;">'
                        + BSS_B2B.formatMoney(priceAfterDiscount) + text
                    '</span>';
                    if (qbPriceItem.length > 0) {
                        qbPriceItem.css('text-decoration', 'line-through');
                        $('[data-cart-item-key="' + item.key + '"] .bss-bogo-price-item').remove();
                        qbPriceItem.after(priceItemHTML)
                    } else {
                        priceOfEachItemElement.css('text-decoration', 'line-through');
                        $('[data-cart-item-key="' + item.key + '"] .bss-bogo-price-item').remove();
                        priceOfEachItemElement.after(priceItemHTML);
                    }
                }

                if (totalPriceOfItemElement.length > 0) {
                    let priceItemTotalHTML = '<span class="bss-bogo-total-price-item" style="display: block;">'
                        + BSS_B2B.formatMoney(priceItemTotalAfterDiscount) + text
                    '</span>';
                    if (qbTotalPriceItem.length > 0) {
                        qbTotalPriceItem.css('text-decoration', 'line-through');
                        $('[data-cart-item-key="' + item.key + '"] .bss-bogo-total-price-item').remove();
                        qbTotalPriceItem.after(priceItemTotalHTML)
                    } else {
                        totalPriceOfItemElement.css('text-decoration', 'line-through');
                        totalPriceOfItemElement.css('display', 'inline-flex');
                        if (BSS_B2B.storeId === 5671) {
                            totalPriceOfItemElement.attr('style', 'text-decoration: line-through !important;')
                        }
                        $('[data-cart-item-key="' + item.key + '"] .bss-bogo-total-price-item').remove();
                        totalPriceOfItemElement.after(priceItemTotalHTML);
                    }
                }
                if (cartSubtotalPriceElement.length > 0) {
                    let subTotalPriceHTML = '<span class="bss-bogo-cart-subtotal" style="display: block !important;">'
                        + BSS_B2B.formatMoney(BSS_B2B.cart.modifiedSubtotalPriceBogo) + text
                    '</span>';
                    if (BSS_B2B.storeId === 13614) {
                        qbCartSubtotal = $('.cart__item--subtotal .bss-qb-cart-subtotal');
                    }
                    if (qbCartSubtotal.length > 0) {
                        qbCartSubtotal.css('text-decoration', 'line-through');
                        $('.bss-bogo-cart-subtotal').remove();
                        qbCartSubtotal.after(subTotalPriceHTML)
                    } else {
                        if (BSS_B2B.storeId !== 5671 || !isEnabledTD) {
                            cartSubtotalPriceElement.css('text-decoration', 'line-through');
                        }
                        $('.bss-bogo-cart-subtotal').remove();
                        cartSubtotalPriceElement.after(subTotalPriceHTML)
                    }
                }
                break;
            }
        }
    };

    BSS_B2B.bogo.appliedRuleOnCartPage = async function (shopData, cartData) {
        BSS_B2B.cart.modifiedSubtotalPriceBogo = false;
        BSS_B2B.cart.updatedLineItemsByBogo = [];
        BSS_B2B.cart.itemKeysAppliedBogo = [];
        let productMap = [];
        let handleURLs = [];
        let handles = [];
        let keyIdMap = [];

        BSS_B2B.bogo.resetItemAppliedPropertiesBogo(cartData);

        cartData.items.forEach(function (item) {
            let proId = item.product_id;
            if (proId !== null
                && handles.indexOf(proId) === -1
                && (((item.properties !== null && !item.properties["Bogo"]) || item.properties == null) || [8605].includes(BSS_B2B.storeId) && item.properties !== null && item.properties["Livraison estim�e"])
            ) {
                handles.push(proId);
                handleURLs.push('id:"' + proId + '"');
                keyIdMap[proId] = item.key;
            }
        });

        if (BSS_B2B.storeId === 8605) {
            await BSS_B2B.getItemCartMetaField();
        }

        //end check
        let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
        let encodeUrlData = encodeURI(urlData);
        $.get(encodeUrlData, function (data) {
            let responseProducts = [];
            let productIdNoMetaField = [];
            try {
                responseProducts = JSON.parse(data);
                responseProducts.map(item => productIdNoMetaField.push(item.id));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log('B2B: JSON parse returns no item')
            }

            if (BSS_B2B.storeId === 8605) {
                if (shopData.line_item_products) {
                    shopData.line_item_products.map(item => {
                        if (!productIdNoMetaField.includes(item.id)) {
                            responseProducts.push(item);
                        }
                    })
                }
            }

            if (responseProducts.length > 0) {
                let checkUnique = [];
                for (let i = 0; i < responseProducts.length; i++) {
                    let pro = responseProducts[i];
                    if (checkUnique.indexOf(pro.id) === -1) {
                        checkUnique.push(pro.id);
                        productMap.push({
                            id: pro.id,
                            tags: pro.tags,
                            collections: pro.collections,
                            key: keyIdMap[pro.id]
                        });
                    }
                }
            }

            let itemsCheckedBogo = [];
            let checkUniquePriceLists = [];

            BSS_B2B.cart.modifiedSubtotalPriceBogo = cartData.original_total_price;

            let timeoutLoadPriceBogo = 0;
            if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0)) {
                timeoutLoadPriceBogo = 1000;
            }

            let bogoSubtotalElement = $('.bss-bogo-cart-subtotal');
            if (bogoSubtotalElement.length > 0) {
                bogoSubtotalElement.remove()
            }
            let cartSubtotalPriceElement = $(BSS_B2B.bogo.cartSubtotalPriceElement().join(','));
            if (cartSubtotalPriceElement.length > 0 && $('.bss-qb-cart-subtotal').length === 0) {
                cartSubtotalPriceElement.css('text-decoration', 'none');
            }

            setTimeout(() => {
                if (((BSS_B2B.configData && BSS_B2B.configData.length) || (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length)) && BSS_B2B.cart.cpPricingList.size > 0) {
                    BSS_B2B.cart.modifiedSubtotalPriceBogo = BSS_B2B.cart.modifiedItemsSubtotalPrice;
                }
                if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
                    BSS_B2B.cart.modifiedSubtotalPriceBogo = BSS_B2B.cart.modifiedItemsSubtotalPriceQb;
                }
                let ruleList = BSS_B2B.bogoRule;
                if (ruleList && ruleList.length > 0) {
                    let checkProductBuyApplied = [];
                    let checkProductGetApplied = [];
                    ruleList.forEach(function (rule) {
                        let customerIds = rule.customer_ids;
                        let customerTagsInRule = rule.customer_tags;
                        let customer = shopData.customer;
                        let applyTo = rule.apply_to;
                        if (applyTo === 0) {
                            // do nothing
                        } else if (applyTo === 1) {
                            if (customer.id === null) {
                                return;
                            }
                        } else if (applyTo === 2) {
                            if (customer.id !== null) {
                                return;
                            }
                        } else if (applyTo === 3) {
                            if (customer.id == null) {
                                return;
                            } else {
                                customerIds = customerIds.split(',');
                                if (customerIds.indexOf(customer.id + "") === -1) {
                                    return;
                                }
                            }
                        } else if (applyTo === 4) {
                            if (customer.tags == null) {
                                return;
                            } else {
                                customerTagsInRule = customerTagsInRule.split(",").map((tag) => tag.toLowerCase());
                                let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                                let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag));
                                if (checkArray.length === 0) {
                                    return;
                                }
                            }
                        }

                        let checkDate = true;
                        let startDate = rule.start_date;
                        let endDate = rule.end_date;
                        const startTime = rule.start_time
                        const endTime = rule.end_time
                        const enableEndDate = rule.enable_end_date
                        let currentDate = new Date();


                        if (!(startTime || endTime)) {

                            if (startDate && currentDate < new Date(startDate)) {
                                checkDate = false;
                            }
                            if (endDate && currentDate > new Date(endDate)) {
                                checkDate = false;
                            }

                        } else {
                            checkDate = !Object(_helper_validate_date_time__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(new Date(startDate), new Date(endDate), startTime, endTime, enableEndDate)
                        }

                        if (checkDate) {
                            let specificProductIdsBuy = [];
                            let specificProductIdsGet = [];
                            if (rule.product_collections) {
                                let collectionCustomerBuy = rule.product_collections.split(",");
                                productMap.forEach(function (product) {
                                    product.collections.forEach(function (collection) {
                                        if (collectionCustomerBuy.indexOf(collection + "") !== -1) {
                                            if (BSS_B2B.storeId === 5686) {
                                                if (!checkProductBuyApplied.includes(`${product.id}`)) {
                                                    specificProductIdsBuy.push(product.id + "")
                                                    checkProductBuyApplied.push(product.id + "")
                                                }
                                            } else {
                                                specificProductIdsBuy.push(product.id + "")
                                            }
                                        }
                                    })
                                })
                            } else {
                                specificProductIdsBuy = rule.product_ids ? rule.product_ids.split(",") : [];
                            }
                            if (rule.customer_getting_product_collections) {
                                let collectionCustomerGet = rule.customer_getting_product_collections.split(",");
                                productMap.forEach(function (product) {
                                    product.collections.forEach(function (collection) {
                                        if (collectionCustomerGet.indexOf(collection + "") !== -1) {
                                            if (BSS_B2B.storeId === 5686) {
                                                if (!checkProductGetApplied.includes(`${product.id}`)) {
                                                    specificProductIdsGet.push(product.id + "")
                                                    checkProductGetApplied.push(product.id + "")
                                                }
                                            } else {
                                                specificProductIdsGet.push(product.id + "")
                                            }
                                        }
                                    })
                                })
                            } else {
                                specificProductIdsGet = rule.customer_getting_product_ids ? rule.customer_getting_product_ids.split(",") : [];
                            }
                            BSS_B2B.bogo.appliedRuleOnEachItem(rule, cartData, productMap, specificProductIdsBuy, specificProductIdsGet, itemsCheckedBogo, checkUniquePriceLists)
                        }
                    })
                }
            }, timeoutLoadPriceBogo)

        })
    };

    BSS_B2B.bogo.appliedRuleOnEachItem = function (rule, cartData, productMap, specificProductIdsBuy, specificProductIdsGet, itemsCheckedBogo, checkUniquePriceLists) {
        let totalQuantityBuyItems = 0;
        let totalAmountBuyItems = 0;
        let totalQuantityGet = 0;
        let totalQuantityCart = 0;
        let totalQuantityCartGetAndBuy = 0;
        let totalQuantityCartGetNotBuy = 0
        let multipleProductBuyQuantity = 0;
        let itemsBuyChecked = [];
        let itemsGetChecked = [];
        let discountType = rule.discount_minimum_type;
        let quantityDiscountMinimum = parseInt(rule.discount_value_minimum);
        let amountDiscountMinimum = parseFloat(rule.discount_value_minimum) * 100;
        let quantityCustomerGet = parseInt(rule.customer_getting_quantity_products);
        let maximumGetUses = parseInt(rule.customer_getting_maximum_uses)
        let totalQuantityGetBackUp = 0;

        cartData.items.forEach(function (item) {
            let totalPriceItem = item.final_line_price;

            if (specificProductIdsBuy.indexOf(item.product_id + "") !== -1) {
                totalQuantityCart = totalQuantityCart + item.quantity;
            }

            if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && specificProductIdsBuy.indexOf(item.product_id + "") !== -1) {
                totalQuantityCartGetAndBuy = totalQuantityCartGetAndBuy + item.quantity;
            }

            if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && item.properties !== null && !item.properties["Bogo"]) {
                totalQuantityGetBackUp = totalQuantityGetBackUp + item.quantity;
            }

            if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && specificProductIdsBuy.indexOf(item.product_id + "") === -1) {
                totalQuantityCartGetNotBuy = totalQuantityCartGetNotBuy + item.quantity;
            }

            if (((BSS_B2B.configData && BSS_B2B.configData.length) || (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length > 0)) && BSS_B2B.cart.cpPricingList.size > 0) {
                let itemCP = BSS_B2B.cart.cpPricingList.get(item.key);
                if (itemCP) {
                    totalPriceItem = itemCP.modifiedLineItemPrice;
                }
            }

            if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
                let itemQB = BSS_B2B.cart.qbPricingList.get(item.key);
                if (itemQB) {
                    totalPriceItem = itemQB.pricePerItemAfterApplyQB * itemQB.quantity;
                }
            }

            if (
                (item.properties !== null && item.properties["Bogo"] && specificProductIdsBuy.indexOf(item.product_id + "") !== -1)
                || specificProductIdsBuy.indexOf(item.product_id + "") !== -1) {
                if (itemsBuyChecked.indexOf(item.id) === -1) {
                    itemsBuyChecked.push(item.id);
                    if (discountType === 0) totalQuantityBuyItems = totalQuantityBuyItems + item.quantity;
                    if (discountType === 1) totalAmountBuyItems = totalAmountBuyItems + totalPriceItem;
                }
            }
            if (((item.properties !== null && !item.properties["Bogo"]) || item.properties == null)
                && specificProductIdsGet.indexOf(item.product_id + "") !== -1
                && itemsGetChecked.indexOf(item.product_id) === -1
                && itemsCheckedBogo.indexOf(item.key) === -1) {
                itemsGetChecked.push(item.product_id);
                totalQuantityGet = totalQuantityGet + item.quantity;
            }
        });

        if (discountType === 0) multipleProductBuyQuantity = Math.floor(totalQuantityBuyItems / quantityDiscountMinimum);
        if (discountType === 1) multipleProductBuyQuantity = Math.floor(totalAmountBuyItems / amountDiscountMinimum);

        let totalQuantityCustomerCanGet = multipleProductBuyQuantity * quantityCustomerGet;
        let totalQuantityGetLeft = totalQuantityGet;
        let totalQuantityAlreadyGet = 0;
        let totalAmountOrQuantityBuying = 0;
        let valueDiscountMinimum = 0;
        if (totalQuantityBuyItems !== 0) {
            totalAmountOrQuantityBuying = totalQuantityBuyItems;
            valueDiscountMinimum = quantityDiscountMinimum;
        } else {
            totalAmountOrQuantityBuying = totalAmountBuyItems;
            valueDiscountMinimum = amountDiscountMinimum;
        }

        if (totalAmountOrQuantityBuying < valueDiscountMinimum) {
            BSS_B2B.bogo.quantityBuyNotMeetRequirement(cartData, specificProductIdsGet);
        } else {
            if (rule.product_condition_type === 3 && discountType == 0) {
                let totalMaxQuantityGet = 0;
                if (totalQuantityCart == totalQuantityCartGetAndBuy) {
                    totalMaxQuantityGet = Math.floor(totalQuantityCart / (quantityDiscountMinimum + quantityCustomerGet)) * quantityCustomerGet;
                } else if (totalQuantityCartGetAndBuy == 0) {
                    totalMaxQuantityGet = Math.floor(totalQuantityCart / quantityDiscountMinimum) * quantityCustomerGet;
                    if (totalQuantityCartGetNotBuy < totalMaxQuantityGet) totalMaxQuantityGet = Math.floor(totalQuantityCartGetNotBuy / quantityCustomerGet) * quantityCustomerGet;
                } else if (totalQuantityCartGetAndBuy < totalQuantityCart) {
                    let totalMaxQuantityCanGet = Math.floor(totalQuantityCart / quantityDiscountMinimum) * quantityCustomerGet;
                    let totalQuantityCustomerBackUp = totalQuantityCart - Math.floor(totalQuantityCart / quantityDiscountMinimum) * quantityDiscountMinimum;
                    let totalQuantityCustomerCanGetBackUp = (totalQuantityCustomerBackUp <= totalQuantityCartGetAndBuy) ? totalQuantityCustomerBackUp : totalQuantityCartGetAndBuy;
                    if (totalQuantityCartGetNotBuy < totalMaxQuantityCanGet) {
                        if (totalQuantityCartGetNotBuy + totalQuantityCustomerCanGetBackUp >= totalMaxQuantityCanGet) {
                            totalMaxQuantityGet = totalMaxQuantityCanGet
                        } else {
                            totalMaxQuantityGet = Math.floor(totalQuantityCart / (quantityDiscountMinimum + quantityCustomerGet)) * quantityCustomerGet;
                            if (totalMaxQuantityGet > totalQuantityCartGetAndBuy) totalMaxQuantityGet = totalQuantityCartGetAndBuy;
                        }
                    } else {
                        totalMaxQuantityGet = totalMaxQuantityCanGet
                    }
                }

                if (maximumGetUses * quantityCustomerGet < totalMaxQuantityGet) totalMaxQuantityGet = maximumGetUses * quantityCustomerGet;

                cartData.items.forEach(function (item, indexGet) {
                    let checkIfProductGetBogo = false;
                    if ((item.properties !== null && !item.properties["Bogo"]) || item.properties == null) {
                        checkIfProductGetBogo = true;
                    }
                    if (checkIfProductGetBogo) {
                        let quantityBuy = 0;
                        let quantityGet = 0;
                        if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && totalMaxQuantityGet > 0) {
                            if (item.quantity <= totalMaxQuantityGet - totalQuantityAlreadyGet && totalQuantityAlreadyGet < totalMaxQuantityGet) {
                                BSS_B2B.bogo.addDiscountProduct(rule, item, totalMaxQuantityGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap);
                                totalQuantityAlreadyGet = totalQuantityAlreadyGet + item.quantity;
                                return;
                            } else if (item.quantity > totalMaxQuantityGet - totalQuantityAlreadyGet && totalQuantityAlreadyGet < totalMaxQuantityGet) {
                                quantityGet = totalMaxQuantityGet - totalQuantityAlreadyGet;
                                quantityBuy = item.quantity - quantityGet
                                if (quantityBuy > 0) {
                                    BSS_B2B.bogo.updateQuantityItemsCart(false, quantityBuy, item, indexGet, quantityGet, false)
                                }
                            }
                        }
                    }
                })
                if (totalMaxQuantityGet > totalQuantityGetBackUp && BSS_B2B.bogo.loading) {
                    BSS_B2B.bogo.resetItemAppliedPropertiesBogo(cartData, true)
                }
            } else {
                cartData.items.forEach(function (item, indexGet) {
                    let checkIfProductGetBogo = false;
                    if ((item.properties !== null && !item.properties["Bogo"]) || item.properties == null) {
                        checkIfProductGetBogo = true;
                    }
                    if (checkIfProductGetBogo) {
                        if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && itemsCheckedBogo.indexOf(item.key) === -1) {
                            let totalQuantityAnotherItemsGet = totalQuantityGet - item.quantity;
                            let quantityBuy = 0;
                            let quantityGet = 0;
                            let itemExistWithSameId = null;
                            let indexBuy = 0;
                            let isExist = false;
                            let totalQuantity = item.quantity;
                            let totalAmount = item.original_line_price;
                            let pricePerItem = item.original_price;

                            if (((BSS_B2B.configData && BSS_B2B.configData.length) || (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length)) && BSS_B2B.cart.cpPricingList.size > 0) {
                                let itemCP = BSS_B2B.cart.cpPricingList.get(item.key);
                                if (itemCP) {
                                    totalAmount = itemCP.modifiedLineItemPrice;
                                    pricePerItem = itemCP.modifiedItemPrice;
                                }
                            }

                            if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
                                let itemQB = BSS_B2B.cart.qbPricingList.get(item.key);
                                if (itemQB) {
                                    totalAmount = itemQB.pricePerItemAfterApplyQB * itemQB.quantity;
                                    pricePerItem = itemQB.pricePerItemAfterApplyQB;
                                }
                            }

                            let quantityAnotherItemsBuyAppliedBogo = totalQuantityBuyItems - item.quantity;
                            let amountAnotherItemsBuyAppliedBogo = totalAmountBuyItems - totalAmount;

                            for (let i = 0; i < cartData.items.length; i++) {
                                let checkSameIdProductExist = false;
                                let itemWithSameId = cartData.items[i];
                                if ((itemWithSameId.properties !== null && itemWithSameId.properties["Bogo"])) {
                                    checkSameIdProductExist = true;
                                }
                                if (checkSameIdProductExist) {
                                    let totalAmountSameIdProductExist = itemWithSameId.original_line_price;
                                    if (((BSS_B2B.configData && BSS_B2B.configData.length) || (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length)) && BSS_B2B.cart.cpPricingList.size > 0) {
                                        let itemCP = BSS_B2B.cart.cpPricingList.get(item.key);
                                        if (itemCP) {
                                            totalAmountSameIdProductExist = itemCP.modifiedLineItemPrice;
                                        }
                                    }

                                    if (BSS_B2B.qbRules && BSS_B2B.qbRules.length && BSS_B2B.cart.qbPricingList.size > 0) {
                                        let itemQB = BSS_B2B.cart.qbPricingList.get(item.key);
                                        if (itemQB) {
                                            totalAmountSameIdProductExist = itemQB.pricePerItemAfterApplyQB * itemQB.quantity;
                                        }
                                    }

                                    if (itemWithSameId.product_id == item.product_id) {
                                        //product quantity and amount of money with same id
                                        totalQuantity = totalQuantity + itemWithSameId.quantity;
                                        totalAmount = totalAmount + totalAmountSameIdProductExist;
                                        //total quantity and amount of all product within specific ids buy
                                        quantityAnotherItemsBuyAppliedBogo = totalQuantityBuyItems - itemWithSameId.quantity;
                                        amountAnotherItemsBuyAppliedBogo = totalAmountBuyItems - totalAmountSameIdProductExist;
                                        isExist = true;
                                        indexBuy = i;
                                        itemExistWithSameId = itemWithSameId;
                                        break;
                                    }
                                }
                            }

                            //check if that product belong both to ids get and ids buy
                            if (specificProductIdsGet.indexOf(item.product_id + "") !== -1 && specificProductIdsBuy.indexOf(item.product_id + "") !== -1) {
                                if (!isExist) {
                                    if (discountType === 0) {
                                        if (item.quantity + totalQuantityAnotherItemsGet >= quantityDiscountMinimum + quantityCustomerGet) {
                                            for (let i = 1; i <= totalQuantity; i++) {
                                                let totalQuantityBuy = i;
                                                if (totalQuantityBuy % quantityDiscountMinimum === 0) {
                                                    quantityBuy = i;
                                                    quantityGet = totalQuantityBuy / quantityDiscountMinimum * quantityCustomerGet
                                                }
                                                if (totalQuantity - quantityBuy - quantityGet < quantityDiscountMinimum + quantityCustomerGet) break;
                                            }
                                        }
                                    } else if (discountType === 1) {
                                        if (item.quantity * pricePerItem >= amountDiscountMinimum + quantityCustomerGet * pricePerItem) {
                                            for (let i = 1; i <= totalQuantity; i++) {
                                                let moneyToAppliedBogoLowerGap = i * amountDiscountMinimum;
                                                let moneyToAppliedBogoUpperGap = (i + 1) * amountDiscountMinimum;
                                                for (let j = i; j <= totalQuantity; j++) {
                                                    if (totalQuantity - quantityBuy - quantityGet <= quantityCustomerGet) break;
                                                    let moneyMeetRequirement = j * pricePerItem;
                                                    if (moneyMeetRequirement >= moneyToAppliedBogoUpperGap || quantityBuy + quantityGet === totalQuantity) break;
                                                    if (moneyMeetRequirement >= moneyToAppliedBogoLowerGap
                                                        && moneyMeetRequirement < moneyToAppliedBogoUpperGap
                                                        && quantityBuy + quantityGet <= totalQuantity) {
                                                        quantityBuy = j;
                                                        quantityGet = i * quantityCustomerGet;
                                                        totalQuantityGet = totalQuantityGet + quantityGet;
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if (quantityBuy + quantityGet < totalQuantity) {
                                        let quantityLeft = totalQuantity - quantityBuy - quantityGet;
                                        quantityBuy = quantityBuy + quantityLeft;
                                    }
                                    if (quantityGet % quantityCustomerGet === 0 && quantityGet !== 0 && quantityBuy + quantityGet === totalQuantity) {
                                        BSS_B2B.bogo.updateQuantityItemsCart(false, quantityBuy, item, indexGet, quantityGet, isExist);
                                        return;
                                    }
                                }
                            }
                            //when total quantity get still below max product quantity which that product can get
                            if (totalQuantityGetLeft < totalQuantityCustomerCanGet && totalQuantityGetLeft < quantityCustomerGet * rule.customer_getting_maximum_uses) {
                                if (itemExistWithSameId != null) {
                                    if (specificProductIdsBuy.indexOf(item.product_id + "") === -1) {
                                        let maxQuantityGet = multipleProductBuyQuantity * quantityCustomerGet - totalQuantityAnotherItemsGet;
                                        if (item.quantity <= maxQuantityGet) {
                                            if (item.quantity + itemExistWithSameId.quantity <= maxQuantityGet) {
                                                for (let i = 1; i <= itemExistWithSameId.quantity; i++) {
                                                    if ((item.quantity + i + totalQuantityAnotherItemsGet) % quantityCustomerGet === 0) quantityGet = item.quantity + i
                                                }
                                                quantityBuy = item.quantity + itemExistWithSameId.quantity - quantityGet;
                                            } else {
                                                let quantityChange = maxQuantityGet - item.quantity;
                                                if (itemExistWithSameId.quantity > quantityChange) {
                                                    quantityGet = item.quantity + quantityChange;
                                                    quantityBuy = itemExistWithSameId.quantity - quantityChange;
                                                }
                                            }
                                            if (quantityGet <= quantityCustomerGet * multipleProductBuyQuantity
                                                && (quantityGet + totalQuantityAnotherItemsGet) % quantityCustomerGet === 0
                                                && quantityGet !== 0) {
                                                BSS_B2B.bogo.updateQuantityItemsCart(indexBuy, quantityBuy, itemExistWithSameId, indexGet, quantityGet, true)
                                            }
                                        }
                                    }
                                }
                            }
                            //if total quantity get above maximum uses that allow
                            if (totalQuantityGet > quantityCustomerGet * rule.customer_getting_maximum_uses && totalQuantityGet > valueDiscountMinimum) {
                                if (item.quantity >= quantityCustomerGet * rule.customer_getting_maximum_uses) {
                                    quantityGet = quantityCustomerGet * rule.customer_getting_maximum_uses - totalQuantityAnotherItemsGet;
                                    quantityBuy = item.quantity - quantityGet;
                                    if (quantityGet + quantityBuy === item.quantity) {
                                        BSS_B2B.bogo.updateQuantityItemsCart(false, quantityBuy, item, indexGet, quantityGet, false)
                                        return;
                                    }
                                }
                            }
                            //if total quantity get is between min and max product can get
                            if (totalQuantityGet % quantityCustomerGet !== 0 && totalQuantityGet >= quantityCustomerGet && totalQuantityGet <= totalQuantityCustomerCanGet) {
                                let multipleProductQuantityGet = Math.floor(totalQuantityGet / quantityCustomerGet);
                                let maxQuantityCanGet = multipleProductQuantityGet * quantityCustomerGet;
                                let totalQuantityNeedToMeet = totalQuantityGet - maxQuantityCanGet;
                                if (item.quantity > totalQuantityNeedToMeet) {
                                    quantityGet = item.quantity - totalQuantityNeedToMeet;
                                    quantityBuy = item.quantity - quantityGet;
                                    BSS_B2B.bogo.updateQuantityItemsCart(false, quantityBuy, item, indexGet, quantityGet, false);
                                    return;
                                }
                            }
                            //when total quantity get is above max product quantity which that product can get
                            if (totalQuantityGet > totalQuantityCustomerCanGet && totalQuantityCustomerCanGet > 0) {
                                let quantityGetToAppliedBogo = 0;
                                if ((item.quantity % quantityCustomerGet === 0
                                    && item.quantity <= totalQuantityCustomerCanGet)
                                    || item.quantity <= totalQuantityCustomerCanGet) {
                                    if (specificProductIdsBuy.indexOf(item.product_id + "") !== -1 && !isExist) {
                                        let totalQuantityBuyItemsBackUp = totalQuantityBuyItems - item.quantity;
                                        let multipleProductBuyQuantityBackup = Math.floor(totalQuantityBuyItemsBackUp / quantityDiscountMinimum);
                                        if (discountType === 1) {
                                            totalQuantityBuyItemsBackUp = totalAmountBuyItems - totalAmount;
                                            multipleProductBuyQuantityBackup = Math.floor(totalQuantityBuyItemsBackUp / amountDiscountMinimum);
                                        }
                                        let totalQuantityCustomerCanGetBackUp = multipleProductBuyQuantityBackup * quantityCustomerGet;
                                        if (totalQuantityAlreadyGet < totalQuantityCustomerCanGetBackUp && totalQuantityCustomerCanGetBackUp !== 0) {
                                            BSS_B2B.bogo.addDiscountProduct(rule, item, totalQuantityCustomerCanGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap);
                                            totalQuantityAlreadyGet = totalQuantityAlreadyGet + item.quantity;
                                            totalQuantityCustomerCanGet = totalQuantityCustomerCanGetBackUp - item.quantity;
                                            totalQuantityGetLeft = totalQuantityGetLeft - item.quantity;
                                        }
                                    } else {
                                        BSS_B2B.bogo.addDiscountProduct(rule, item, totalQuantityCustomerCanGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap);
                                        totalQuantityCustomerCanGet = totalQuantityCustomerCanGet - item.quantity;
                                        totalQuantityAlreadyGet = totalQuantityAlreadyGet + item.quantity;
                                        totalQuantityGetLeft = totalQuantityGetLeft - item.quantity;
                                    }
                                } else {
                                    if (item.quantity > totalQuantityCustomerCanGet) {
                                        if (discountType === 0) {
                                            if (specificProductIdsBuy.indexOf(item.product_id + "") === -1) {
                                                for (let i = 1; i <= totalQuantity; i++) {
                                                    if (quantityGet === totalQuantityCustomerCanGet) break;
                                                    if (quantityGetToAppliedBogo <= totalQuantityGet) {
                                                        quantityGetToAppliedBogo = i + totalQuantityAnotherItemsGet;
                                                        quantityGet = i;
                                                        quantityBuy = totalQuantity - i;
                                                    }
                                                }
                                            } else {
                                                for (let i = 1; i <= totalQuantity; i++) {
                                                    let totalQuantityBuy = i + quantityAnotherItemsBuyAppliedBogo;
                                                    if (totalQuantityBuy % quantityDiscountMinimum === 0) {
                                                        quantityBuy = i;
                                                        quantityGet = totalQuantityBuy / quantityDiscountMinimum * quantityCustomerGet - totalQuantityAnotherItemsGet
                                                    }
                                                    if (totalQuantity - quantityBuy - quantityGet < quantityDiscountMinimum + quantityCustomerGet) break;
                                                }
                                                if (quantityBuy + quantityGet < totalQuantity) {
                                                    let quantityLeft = totalQuantity - quantityBuy - quantityGet;
                                                    quantityBuy = quantityBuy + quantityLeft;
                                                }
                                            }
                                            if (quantityGet !== 0) {
                                                BSS_B2B.bogo.updateQuantityItemsCart(indexBuy, quantityBuy, item, indexGet, quantityGet, isExist)
                                            }
                                            return;
                                        } else if (discountType === 1) {
                                            if (specificProductIdsBuy.indexOf(item.product_id + "") === -1) {
                                                for (let i = 1; i <= totalQuantity; i++) {
                                                    if (quantityGet === totalQuantityCustomerCanGet) break;
                                                    if (quantityGetToAppliedBogo <= totalQuantityGet) {
                                                        quantityGetToAppliedBogo = i + totalQuantityAnotherItemsGet;
                                                        quantityGet = i;
                                                        quantityBuy = totalQuantity - i;
                                                    }
                                                }
                                            } else {
                                                for (let i = 1; i <= totalQuantity; i++) {
                                                    let moneyToAppliedBogoLowerGap = i * amountDiscountMinimum;
                                                    let moneyToAppliedBogoUpperGap = (i + 1) * amountDiscountMinimum;
                                                    for (let j = i; j <= totalQuantity; j++) {
                                                        if (totalQuantity - quantityBuy - quantityGet <= quantityCustomerGet) break;
                                                        let moneyMeetRequirement = j * pricePerItem + amountAnotherItemsBuyAppliedBogo;
                                                        if (moneyMeetRequirement >= moneyToAppliedBogoUpperGap || totalQuantityAnotherItemsGet + quantityGet === totalQuantityCustomerCanGet) break;
                                                        if (moneyMeetRequirement >= moneyToAppliedBogoLowerGap
                                                            && moneyMeetRequirement < moneyToAppliedBogoUpperGap
                                                            && quantityBuy + quantityGet <= totalQuantity) {
                                                            quantityBuy = j;
                                                            quantityGet = i * quantityCustomerGet - totalQuantityAnotherItemsGet;
                                                        }
                                                    }
                                                }
                                                if (quantityBuy + quantityGet < totalQuantity) {
                                                    let quantityLeft = totalQuantity - quantityBuy - quantityGet;
                                                    quantityBuy = quantityBuy + quantityLeft;
                                                }
                                            }
                                            if (quantityGet !== 0) {
                                                BSS_B2B.bogo.updateQuantityItemsCart(indexBuy, quantityBuy, item, indexGet, quantityGet, isExist)
                                            }
                                            return;
                                        }
                                    }
                                }
                            }
                            //when total quantity get is not exceed max product quantity which that product can get
                            else {
                                if (specificProductIdsBuy.indexOf(item.product_id + "") !== -1 && !isExist) {
                                    let totalQuantityBuyItemsBackUp = totalQuantityBuyItems - item.quantity;
                                    let multipleProductBuyQuantityBackup = Math.floor(totalQuantityBuyItemsBackUp / quantityDiscountMinimum);
                                    if (discountType === 1) {
                                        totalQuantityBuyItemsBackUp = totalAmountBuyItems - totalAmount;
                                        multipleProductBuyQuantityBackup = Math.floor(totalQuantityBuyItemsBackUp / amountDiscountMinimum);
                                    }
                                    let totalQuantityCustomerCanGetBackUp = multipleProductBuyQuantityBackup * quantityCustomerGet;
                                    if (totalQuantityAlreadyGet < totalQuantityCustomerCanGetBackUp && totalQuantityCustomerCanGetBackUp !== 0) {
                                        BSS_B2B.bogo.addDiscountProduct(rule, item, totalQuantityCustomerCanGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap);
                                        totalQuantityAlreadyGet = totalQuantityAlreadyGet + item.quantity;
                                        totalQuantityCustomerCanGet = totalQuantityCustomerCanGetBackUp - item.quantity;
                                        totalQuantityGetLeft = totalQuantityGetLeft - item.quantity;
                                    }
                                } else {
                                    BSS_B2B.bogo.addDiscountProduct(rule, item, totalQuantityCustomerCanGet, totalQuantityGetLeft, itemsCheckedBogo, checkUniquePriceLists, productMap);
                                    totalQuantityCustomerCanGet = totalQuantityCustomerCanGet - item.quantity;
                                    totalQuantityAlreadyGet = totalQuantityAlreadyGet + item.quantity;
                                    totalQuantityGetLeft = totalQuantityGetLeft - item.quantity;
                                }
                            }
                        }
                    }
                })
            }
        }
    }
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initExtraFee; });
function initExtraFee($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableEF) {
    /**
     * For extra fee
     */
    BSS_B2B.ef = {};
    if(typeof BSS_B2B.calculateModules === "undefined") {
        BSS_B2B.calculateModules = new Map();
    }
    BSS_B2B.calculateModules.set("EF", {
        enableModule: isEnableEF,
        isDoneCalculate: true,
        priority: 3
    });
    BSS_B2B.cart.efList = [];
    BSS_B2B.ef.appliedEFRuleForOneProduct = false;
    const eventCalculateEF = new Event('bss.b2b.ef.doneCalculateEF');

    BSS_B2B.ef.defaultLineItemCssSelector = function (key) {
        let cssSelector = '[data-cart-item-key="' + key + '"] .product-details';
        return cssSelector;
    };

    BSS_B2B.ef.lineItemCssSelector = function (key) {
        let cssSelector = '[data-cart-item-key="' + key + '"] .bss-b2b-ef-table';
        return cssSelector;
    };

    BSS_B2B.ef.getAppliedRulesForCartItems = function (productMap) {
        let ruleList = BSS_B2B.efRules;
        let customer = shopData.customer;
        let ruleMapForId = new Map();
        let ruleMapForKey = new Map();
        let customerTags = (shopData.customer && shopData.customer.tags) ? shopData.customer.tags.map((tag) => tag.toLowerCase()) : [];
        if (ruleList) {
            ruleList.forEach(function (rule) {
                let applyTo = rule.apply_to;
                let customerIds = rule.customer_ids;
                let customerTagsInRule = rule.customer_tags;
                // if (applyTo == 0) {
                //
                // } else
                if (applyTo === 1) {
                    if (customer.id === null) {
                        return;
                    }
                } else if (applyTo === 2) {
                    if (customer.id !== null) {
                        return;
                    }
                } else if (applyTo === 3) {
                    if (customer.id === null) {
                        return;
                    } else {
                        customerIds = customerIds.split(',');
                        if (customerIds.indexOf(customer.id + "") === -1) {
                            return;
                        }
                    }
                } else if (applyTo === 4) {
                    if (customer.tags === null) {
                        return;
                    } else {
                        customerTagsInRule = customerTagsInRule.split(",").map((tag) => tag.toLowerCase());
                        let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag + ""));
                        if (checkArray.length === 0) {
                            return
                        }
                    }
                }

                let conditionType = rule.product_condition_type;
                let ruleTags = rule.product_tags ? rule.product_tags.split(",").map((tag) => tag.toLowerCase()) : [];
                let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
                let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];

                productMap.forEach(function (item) {
                    if (ruleMapForId.get(item.id) && ruleMapForKey.get(item.key)) {
                        return;
                    }

                    let collections = item.collections;
                    let tags = item.tags.map((tag) => tag.toLowerCase());
                    let productId = item.id;
                    let appliedEFRule = false;
                    if (conditionType === 0) {

                        appliedEFRule = rule;

                    } else if (conditionType === 1) {

                        if (specificProductIds.indexOf(productId + "") !== -1) {
                            appliedEFRule = rule;

                        }

                    } else if (conditionType === 2) {
                        let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                        if (checkArray.length > 0) {
                            appliedEFRule = rule;
                        }

                    } else if (conditionType === 3) {

                        let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));

                        if (checkArray.length > 0) {
                            appliedEFRule = rule
                        }

                    }

                    if (appliedEFRule) {
                        appliedEFRule.price = item.price;
                        ruleMapForId.set(item.id, appliedEFRule);
                        ruleMapForKey.set(item.key, appliedEFRule);
                        item.appliedEFRule = true;
                    }
                })
            });
        }
        return {
            ruleMapForId: ruleMapForId,
            ruleMapForKey: ruleMapForKey
        };
    };
    BSS_B2B.ef.getRuleApplyQty = function (qtyTable, totalQuantity) {
        let appliedQtyItem = { free_ship: 0, fee: 0 };
        qtyTable.forEach(function (qtyRow) {
            let qtyFrom = parseInt(qtyRow.qty_from);

            let qtyTo = qtyRow.qty_to;
            if (qtyTo != null && qtyTo.toString().length > 0) {
                qtyTo = parseInt(qtyRow.qty_to);
                if (totalQuantity >= qtyFrom && totalQuantity <= qtyTo) {
                    appliedQtyItem = qtyRow;
                }
            } else {
                if (totalQuantity >= qtyFrom) {
                    appliedQtyItem = qtyRow;
                }
            }
        });
        return appliedQtyItem;
    };
    BSS_B2B.ef.getRuleApplyAmt = function (amountTable, totalAmount) {
        let appliedAmountItem = {fee: 0, free_ship: 0};
        amountTable.forEach(function (amountRow) {
            let amountFrom = parseFloat(amountRow.amount_from);

            let amountTo = amountRow.amount_to;
            if (amountTo != null && amountTo.toString().length > 0) {
                amountTo = parseFloat(amountRow.amount_to);
                if (totalAmount >= amountFrom && totalAmount <= amountTo) {
                    appliedAmountItem = amountRow;
                }
            } else {
                if (totalAmount >= amountFrom) {
                    appliedAmountItem = amountRow;
                }
            }
        });
        return appliedAmountItem;
    };

    BSS_B2B.ef.getPriceList = function (productMap, cartItemProductMap, cartItemProductMapByKey) {
        if (isEnableEF === 0 || !BSS_B2B.efRules || (BSS_B2B.efRules.length === 0)) {
            return [];
        }
        let newCartItemProductMapByKey = cartItemProductMapByKey;

        let appliedRulesForCartItems = BSS_B2B.ef.getAppliedRulesForCartItems(productMap, cartItemProductMap);
        let appliedRulesForCartItemsByKey = appliedRulesForCartItems.ruleMapForKey;
        let appliedRulesForCartItemsById = appliedRulesForCartItems.ruleMapForId;
        let productRuleType2 = new Map();
        appliedRulesForCartItemsById.forEach(function (value, key) {
            if (value.rule_type === 0) {
                let prods = productRuleType2.get(value.id);
                if (!prods || prods === undefined) {
                    prods = [];
                    productRuleType2.set(value.id, [])
                }
                prods.push(key);
                productRuleType2.set(value.id, prods)
            }
        });
        let priceLists = [];
        let hasProductExceptRule = false;
        let freeShippingCalculation = BSS_B2B.efSettings.ef_freeship_type;
        productMap.forEach(function (product) {
            let key = product.key;
            if (appliedRulesForCartItemsByKey.get(key) === undefined) {
                hasProductExceptRule = true;
            }
        });
        appliedRulesForCartItemsById.forEach(function (value, key) {
            if (value.rule_setting === 0) {
                //Quantity
                if (value.rule_type === 1) {
                    //Per product
                    let variants = cartItemProductMap.get(key);
                    variants.forEach(function (item) {
                        let quantity = item.quantity
                        let {
                            fee,
                            free_ship,
                            fee_type,
                            id: appliedId
                        } = BSS_B2B.ef.getRuleApplyQty(value.qty_options, quantity);
                        if (fee !== 0) {
                                let EFItem = BSS_B2B.ef.defineValueOfEF(item, value, fee, free_ship, quantity, appliedId);
                                priceLists.push({...EFItem, keys: [item.key], fee_type});
                                newCartItemProductMapByKey.set(item.key, EFItem);
                        } else {
                            hasProductExceptRule = true
                        }
                    });
                } else if (value.rule_type === 0) {
                    //All product
                    let appliedProducts = productRuleType2.get(value.id);
                    if (appliedProducts && appliedProducts !== undefined) {
                        let totalQuantity = 0;
                        let variants = cartItemProductMap.get(key);
                        let listKeysVariant = []
                        appliedProducts.forEach(function (pro) {
                            let proVariants = cartItemProductMap.get(pro);
                            proVariants.forEach(function (variant) {
                                listKeysVariant.push(variant.key)
                                totalQuantity += variant.quantity
                            });
                        });
                        let {
                            fee,
                            free_ship,
                            fee_type,
                            id: appliedId
                        }
                            = BSS_B2B.ef.getRuleApplyQty(value.qty_options, totalQuantity);
                        let ruleExist = false;
                        priceLists.forEach(function (item) {
                            if (item.qty_options && item.qty_options[0] && item.qty_options[0].rule_id === value.id) {
                                ruleExist = true;
                            }
                        });
                        if (fee !== 0) {
                            if (!ruleExist) {
                                variants.forEach(function (item) {
                                    let EFItem = BSS_B2B.ef.defineValueOfEF(item, value, fee, free_ship, totalQuantity, appliedId);
                                    const isExistEFItem = priceLists.filter((element) => element.rule_id === EFItem.rule_id);
                                    if (!isExistEFItem.length) {
                                        priceLists.push({...EFItem, keys: listKeysVariant, fee_type});
                                    }
                                    newCartItemProductMapByKey.set(item.key, EFItem);
                                });
                            }
                        } else {
                            hasProductExceptRule = true
                        }
                    }
                }
            } else {
                // Amount
                let cpPricingList = BSS_B2B.cart.cpPricingList
                let qbPricingList = BSS_B2B.cart.qbPricingList
                if (value.rule_type === 1) {
                    //Per product
                    let variants = cartItemProductMap.get(key);
                    variants.forEach(function (item) {
                        let itemCP = cpPricingList.get(item.key)
                        let itemQB = qbPricingList.get(item.key)
                        let linePriceItem = (item.quantity) * (item.price) * 0.01
                        if (itemCP) {
                            linePriceItem = itemCP.modifiedLineItemPrice * 0.01;
                        }
                        if (itemQB) {
                            linePriceItem = itemQB.pricePerItemAfterApplyQB * itemQB.quantity * 0.01;
                        }

                        let {
                            fee: fee,
                            free_ship: free_ship,
                            fee_type: fee_type,
                            id: appliedId
                        } = BSS_B2B.ef.getRuleApplyAmt(value.amount_options, linePriceItem);
                        if (fee !== 0) {
                            let EFItem = BSS_B2B.ef.defineValueOfEF(item, value, fee, free_ship, linePriceItem, appliedId);
                            priceLists.push({...EFItem, keys: [item.key],fee_type});
                            newCartItemProductMapByKey.set(item.key, EFItem);
                        } else {
                            hasProductExceptRule = true
                        }
                    });
                } else if (value.rule_type === 0) {
                    //All product
                    let appliedProducts = productRuleType2.get(value.id);
                    if (appliedProducts && appliedProducts !== undefined) {
                        let totalAmount = 0;
                        let variants = cartItemProductMap.get(key);
                        let listKeysVariant = []
                        appliedProducts.forEach(function (pro) {
                            let proVariants = cartItemProductMap.get(pro);
                            proVariants.forEach(function (item) {
                                let itemCP = cpPricingList.get(item.key)
                                let itemQB = qbPricingList.get(item.key)
                                let linePriceItem = (item.quantity) * (item.price) * 0.01
                                if (itemCP) {
                                    linePriceItem = itemCP.modifiedLineItemPrice * 0.01;
                                }
                                if (itemQB) {
                                    linePriceItem = itemQB.pricePerItemAfterApplyQB * itemQB.quantity * 0.01;
                                }
                                listKeysVariant.push(item.key)
                                totalAmount += linePriceItem
                            });
                        });
                        let {
                            fee: fee,
                            free_ship: free_ship,
                            fee_type: fee_type,
                            id: appliedId
                        } = BSS_B2B.ef.getRuleApplyAmt(value.amount_options, totalAmount);

                        let ruleExist = false;
                        priceLists.forEach(function (item) {
                            if (item.amount_options && item.amount_options[0] && item.amount_options[0].rule_id === value.id) {
                                ruleExist = true;
                            }
                        });
                        if (fee !== 0) {
                            if (!ruleExist) {
                                variants.forEach(function (item) {
                                    let EFItem = BSS_B2B.ef.defineValueOfEF(item, value, fee, free_ship, totalAmount, appliedId);
                                    const isExistEFItem = priceLists.filter((element) => element.rule_id === EFItem.rule_id);
                                    if (!isExistEFItem.length) {
                                        priceLists.push({...EFItem, keys: listKeysVariant, fee_type});
                                    }
                                    newCartItemProductMapByKey.set(item.key, EFItem);
                                });
                            }
                        } else {
                            hasProductExceptRule = true
                        }
                    }
                }
            }
        });
        priceLists = BSS_B2B.ef.calculateFreeship(priceLists, hasProductExceptRule, freeShippingCalculation);
        return {
            priceLists: priceLists,
            appliedRulesForCartItemsByKey: appliedRulesForCartItemsByKey,
            newCartItemProductMapByKey: newCartItemProductMapByKey,
            hasProductExceptRule: hasProductExceptRule
        };
    };
    BSS_B2B.ef.generateTableOnCartPage = function (key, efRuleForCartItem, isAjaxCart) {
        let quantitySelector = BSS_B2B.cart.quantityInputSelectorWithKeyItem(key).join(",");
        let element = $(BSS_B2B.ef.lineItemCssSelector(key));
        if (element.length === 0) {
            element = $(BSS_B2B.ef.defaultLineItemCssSelector(key));
        }

        if (element.length && element.parent().find(".bss-b2b-cart-item-qty-table-ef").length === 0) {
            let quantityELe = BSS_B2B.cart.quantityInputSelectorWithKeyItem(key).join(",");
            let quantityValue = false;

            if ($(quantityELe).length > 0) {
                quantityValue = parseInt($(quantityELe).val());
            }
            let linePriceElement = $(BSS_B2B.qb.totalPriceOfItemElement(key).join(","));
            let amountValue = false;
            if (linePriceElement.length) {
                if (linePriceElement.find('[bss-b2b-cart-item-key="' + key + '"').length) {
                    linePriceElement = linePriceElement.find('[bss-b2b-cart-item-key="' + key + '"')
                }
                if (linePriceElement.find('[bss-b2b-product-price]').length) {
                    linePriceElement = linePriceElement.find('[bss-b2b-product-price]')
                }
                if (linePriceElement.parent().find('.bss-qb-total-price-item').length) {
                    linePriceElement = linePriceElement.parent().find('.bss-qb-total-price-item')
                }
                amountValue = parseFloat(linePriceElement.html().replace(/\D/g, ""))
            }
            if ((isAjaxCart && BSS_B2B.efSettings.page_show_table.includes("2") && !BSS_B2B.page.isCartPage())
                || (BSS_B2B.efSettings.page_show_table.includes("1") && BSS_B2B.page.isCartPage())) {
                let qtyTableHtml = BSS_B2B.ef.getQtyTableHtml(efRuleForCartItem, false, quantityValue, true, amountValue);
                element.after(qtyTableHtml);
                /**
                 * Click to row, change quantity of line item
                 */
                if (efRuleForCartItem.rule_setting === 0) {
                    $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row-ef').on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        $(quantitySelector).val($(this).attr("data-max")).trigger('change');
                        /**
                         * Update cart quantity
                         */
                        $.post(
                            '/cart/change.js',
                            {
                                quantity: parseInt($(this).attr("data-max")),
                                id: key
                            },
                            "json"
                        ).done(
                            function () {
                                $("form[action*='/cart']").submit();
                            }
                        );

                        $('[data-cart-item-key="' + key + '"] .bss-b2b-qty-table-row-ef').removeClass("qty-row-active");

                        $(this).css({
                            "background-color": BSS_B2B.efSettings.row_hover_background_color,
                            "color": BSS_B2B.efSettings.row_hover_text_color
                        });
                    })
                }
            }
        }
    };
    BSS_B2B.ef.insertQtyTableToCartItemBlock = function (newCartData = false, isAjaxCart) {
        try {
            BSS_B2B.calculateModules.get("EF").isDoneCalculate = false;
            let cartData = shopData.cart;
            if (newCartData) {
                cartData = newCartData;
            }
            if (cartData.items && cartData.items.length > 0) {
                let handleURLs = [];
                let handles = [];
                let keyIdMap = new Map();
                let cartItemProductMap = new Map();
                let cartItemProductMapByKey = new Map();
                let cartItemProductMapByKeyGenerateEFTable = new Map();
                cartData.items.forEach(function (item, index) {
                    let proId = item.product_id;
                    if (handles.indexOf(proId) === -1) {
                        handles.push(proId);
                        handleURLs.push('id:"' + proId + '"');
                        keyIdMap.set(proId, []);
                    }
                    let productItemKeys = keyIdMap.get(proId);
                    productItemKeys.push(item.key);
                    keyIdMap.set(proId, productItemKeys);

                    /* Show price */
                    let productVariants = cartItemProductMap.get(proId);
                    if (!productVariants || productVariants === undefined) {
                        cartItemProductMap.set(proId, []);
                        productVariants = [];
                    }
                    let cartItem = {
                        key: item.key,
                        quantity: item.quantity,
                        id: item.variant_id,
                        price: item.price,
                        index: index,
                        product_id: proId
                    };

                    productVariants.push(cartItem);
                    cartItemProductMap.set(proId, productVariants);
                    cartItemProductMapByKey.set(item.key, cartItem);
                    cartItemProductMapByKeyGenerateEFTable.set(item.key, cartItem);
                });
                let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
                let encodeUrlData = encodeURI(urlData);
                $.get(encodeUrlData, function (data) {
                    let responseProducts = [];
                    try {
                        responseProducts = JSON.parse(data);
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.log('product label: JSON parse returns no item')
                    }

                    if (responseProducts.length > 0) {
                        let productMap = [];
                        let checkUnique = [];
                        for (let i = 0; i < responseProducts.length; i++) {
                            let pro = responseProducts[i];

                            if (checkUnique.indexOf(pro.id) === -1) {
                                checkUnique.push(pro.id);
                                keyIdMap.get(pro.id).forEach(function (key) {
                                    productMap.push({
                                        id: pro.id,
                                        tags: pro.tags,
                                        collections: pro.collections,
                                        key: key
                                    });
                                })
                            }
                        }
                        let timeoutLoadPriceCP = 0;
                        if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0)) {
                            timeoutLoadPriceCP = 1000;
                        }
                        let timeoutLoadPriceQB = 0;
                        if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length > 0) {
                            timeoutLoadPriceQB = 1000;
                        }
                        setTimeout(() => {
                            let getPriceListAppliedEF = BSS_B2B.ef.getPriceList(productMap, cartItemProductMap, cartItemProductMapByKey);
                            let efPricingList = getPriceListAppliedEF.priceLists;
                            BSS_B2B.cart.efList = efPricingList;
                            BSS_B2B.calculateModules.get("EF").isDoneCalculate = true;
                            document.dispatchEvent(eventCalculateEF);
                            let ruleMap = getPriceListAppliedEF.appliedRulesForCartItemsByKey;
                            ruleMap.forEach(function (value, key) {
                                cartItemProductMapByKeyGenerateEFTable.forEach(item => {
                                    if (item.key === key) {
                                        value.price = item.price;
                                    }
                                });
                                BSS_B2B.ef.generateTableOnCartPage(key, value, isAjaxCart);
                            });

                            /**
                             * Slide Toggle qty table
                             */
                            $('.bss-b2b-up-down-btn-ef').unbind("click", null);
                            $('.bss-b2b-up-down-btn-ef').on("click", function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if ($(this).text() == "↓") {
                                    $(this).html(`↑`)
                                } else if ($(this).text() == "↑") {
                                    $(this).html(`↓`)
                                }
                                $(this).closest('.bss-b2b-cart-item-qty-table-ef').find('.bss-b2b-qty-table-wrapper-ef').toggle();
                            })
                        }, timeoutLoadPriceCP || timeoutLoadPriceQB)
                    }
                })

            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("Could not get shop data and not insert quantity table in cart page");
        }
    };
    BSS_B2B.ef.getAppliedRuleOnProductPage = function (formProductId, productTags = null) {
        let currentVariant = false;
        let currentVariantId = false;
        let queryArray = BSS_B2B.getQueryArray();
        let variantSelector = $('form[action*="/cart/add"]').find('select[name="id"]');

        if (variantSelector.length) {
            currentVariantId = variantSelector.val();
        }

        if (queryArray.indexOf("variant") !== -1) {
            currentVariantId = queryArray["variant"];
        }
        let quantity = 1;
        let quantitySelector = document.querySelector(BSS_B2B.quantityInputSelectorOnProductPage.join(","));
        if (quantitySelector) {
            quantity = parseInt(quantitySelector.value);
        }
        let ruleList = BSS_B2B.efRules;
        let customer = shopData.customer;
        let product = shopData.product;
        let listVariants = product.variants;
        listVariants.forEach(variant => {
            if (variant.id === Number(currentVariantId)) {
                currentVariant = variant;
                return;
            }
        });

        let productId = product ? product.id : '';
        if (formProductId) {
            productId = formProductId;
        }
        let appliedEFRule = false;
        ruleList.forEach(function (rule) {
            if (appliedEFRule) {
                return;
            }
            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let customerTagsInRule = rule.customer_tags;
            let excludeCustomerTags = rule.exc_customer_tags;
            let excludeFrom = rule.exclude_from;
            // if (applyTo == 0) {
            //
            // } else
            if (applyTo === 1) {
                if (customer.id === null) {
                    return;
                }
            } else if (applyTo === 2) {
                if (customer.id !== null) {
                    return;
                }
            } else if (applyTo === 3) {
                if (customer.id === null) {
                    return;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return;
                    }
                }
            } else if (applyTo === 4) {
                if (customer.tags === null) {
                    return;
                } else {
                    customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                    let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag + ""));
                    if (checkArray.length === 0) {
                        return
                    }
                }
            }

            if (excludeFrom) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        return
                    }
                }
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(",").map((tag) => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];


            let collections = shopData.collections;
            let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';
            if (productTags) {
                tags = productTags;
            }
            if (conditionType === 0) {

                appliedEFRule = rule;

            } else if (conditionType === 1) {

                if (specificProductIds.indexOf(productId + "") !== -1) {
                    appliedEFRule = rule;
                }

            } else if (conditionType === 2) {
                let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                if (checkArray.length > 0) {
                    appliedEFRule = rule;
                }

            } else if (conditionType === 3) {

                let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));

                if (checkArray.length > 0) {
                    appliedEFRule = rule
                }

            }
        });
        if (appliedEFRule) {
            if (currentVariant) {
                appliedEFRule.price = currentVariant.price;
            } else {
                appliedEFRule.price = product.price;
            }
            let productId = product.id
            let productAfterUseCP = BSS_B2B.cp.productAfterUseCP.length > 0 ? BSS_B2B.cp.productAfterUseCP : [];
            if (productAfterUseCP.length) {
                let productCP = productAfterUseCP.find(item => item.id === productId)
                if (productCP) {
                    appliedEFRule.price = productCP.price;
                }
            }
            let appliedQbRule = BSS_B2B.qb.appliedQbRuleForOneProduct
            let priceAfterQB = BSS_B2B.qb.getQBProductPrice(appliedQbRule, currentVariantId, product, quantity)
            if (appliedQbRule) {
                appliedEFRule = {...appliedEFRule, price: priceAfterQB}
            }

        }

        BSS_B2B.ef.appliedEFRuleForOneProduct = appliedEFRule;

        return appliedEFRule;
    };
    /**
     * Create qty-table on product listing page
     */
    BSS_B2B.ef.generateTableOnProductListingPage = function (productId, productTags) {
        let appliedRule = BSS_B2B.ef.getAppliedRuleOnProductListingPage(productId, productTags);
        if (appliedRule) {
            let qtyTableHtml = BSS_B2B.ef.getQtyTableHtml(appliedRule);
            let productModal = $(`.screen-layer.screen-layer--product[data-product-id=${productId}]`);
            if (productModal.length) {
                // Insert to first form element. DAWN theme has two form element on product page.
                let productHeader = $(productModal).find('.product-single__meta .product-single__header');
                if (productHeader.length && !$(productHeader).find('.bss-b2b-cart-item-qty-table-ef').length) {
                    $(productHeader).append(qtyTableHtml);
                }
            }

            $('.bss-b2b-qty-table-row-ef').on("click", function (e) {
                e.preventDefault();
                $('.bss-b2b-qty-table-row-ef').removeClass("qty-row-active");
                $(this).addClass('qty-row-active');
            })
        }
    };

    BSS_B2B.ef.generateTableOnProductPage = function () {
        let appliedRule = BSS_B2B.ef.getAppliedRuleOnProductPage(false);
        let quantityValue = false;
        let quantitySelector = BSS_B2B.quantityInputSelectorOnProductPage.join(",");
        let buttonSelector = BSS_B2B.buttonChangeQuantityOnProductPage;
        if ($(quantitySelector).length > 0) {
            quantityValue = $(quantitySelector).val();
        }

        if (appliedRule) {
            let qtyTableHtml = BSS_B2B.ef.getQtyTableHtml(appliedRule, true, quantityValue, false);

            if ($('form[action*="/cart/add"] .bss-b2b-ef-table').length > 0) {  
                $('form[action*="/cart/add"] .bss-b2b-ef-table').prepend(qtyTableHtml)
            }
            if ($('form[action*="/cart/add"]').length > 1) {
                $('form[action*="/cart/add"]').first().prepend(qtyTableHtml);
            } else {
                $('form[action*="/cart/add"]:not(".product-item__action-list")').prepend(qtyTableHtml);
            }
            if (appliedRule.rule_setting === 0) {
                $('.bss-b2b-qty-table-row-ef').on("click", function (e) {
                    e.preventDefault();
                    $(quantitySelector).val($(this).attr("data-max"));
                    if ($(quantitySelector).val() > 1) {
                        $(buttonSelector)[0].classList.remove("disabled");
                    }
                    $('.bss-b2b-qty-table-row-ef').removeClass("qty-row-active");

                    $(this).addClass('qty-row-active');
                })
            }
        }

        // re-generate ef table after change variant
        let cartForm = $(
            'form[action*="/cart/add"],'
            + 'form[action*="/checkout"]'
            + BSS_B2B.getCssSelector('product_cart_form')
        );

        if (cartForm.length) {
            for (let i = 0; i < cartForm.length; i++) {
                let cartFormI = $(cartForm[i]);
                let id = cartFormI.attr("id");
                let variantSelector = cartFormI.find("select, " +
                    "input.single-option-selector__radio"
                    + BSS_B2B.getCssSelector('product_variant_option_input'));
                if (variantSelector.length) {
                    for (let k = 0; k < variantSelector.length; k++) {
                        let element = $(variantSelector[k]);
                        element.attr('data-cart-form', id);
                        element.on("change", function () {
                            setTimeout(function () {
                                $(document).find('.bss-b2b-cart-item-qty-table-ef').remove();
                                BSS_B2B.ef.generateTableOnProductPage();
                            }, 1000)
                        })
                    }
                }

                let variantSelectorClickItem = cartFormI.find(".block-swatch-list .block-swatch__item");
                if (variantSelectorClickItem.length) {
                    for (let k = 0; k < variantSelectorClickItem.length; k++) {
                        let element = $(variantSelectorClickItem[k]);
                        element.attr('data-cart-form', id);
                        element.on("click", function () {
                            setTimeout(function () {
                                $(document).find('.bss-b2b-cart-item-qty-table-ef').remove();
                                BSS_B2B.ef.generateTableOnProductPage();
                            }, 1000)
                        })
                    }
                }
            }
        }

        if ($(quantitySelector).length) {
            // re-generate ef table after change quantity
            const debounceFnc = (callback, timeout = 1000) => {
                let timer;
                return (...args) => {
                    clearTimeout(timer);
                    timer = setTimeout(() => { callback.apply(this, args); }, timeout);
                };
            }
          $(quantitySelector).on("change", debounceFnc(function () {
              $('.bss-b2b-cart-item-qty-table-ef').remove();
              BSS_B2B.ef.generateTableOnProductPage();
          }));
        }
    };
    BSS_B2B.ef.settingTableEF = function () {
        let styles = `
            .bss-b2b-cart-item-qty-table-header-ef {` +
            `background-color:` + BSS_B2B.efSettings.header_table_background + `;` +
            `color:` + BSS_B2B.efSettings.text_header_table_color + `;` +
            `}` +
            `.bss-b2b-qty-table-wrapper-ef {` +
            `background-color:` + BSS_B2B.efSettings.table_background_color + `;` +
            `color:` + BSS_B2B.efSettings.text_table_color + `;` +
            `}` +
            `.bss-b2b-qty-table-wrapper-ef th, .bss-b2b-qty-table-wrapper-ef td {` +
            `border: 1px solid ` + BSS_B2B.efSettings.header_table_background + ` !important;` +
            `}` +
            `.bss-b2b-qty-table-row-ef.qty-row-active {` +
            `background-color:` + BSS_B2B.efSettings.row_hover_background_color + `;` +
            `color:` + BSS_B2B.efSettings.row_hover_text_color + `;` +
            `border-color:` + BSS_B2B.efSettings.row_hover_background_color + `;` +
            `}` +
            `.bss-b2b-qty-table-row-ef:not(.qty-row-active):not(:hover) {` +
            `background-color:` + BSS_B2B.efSettings.table_background_color + `;` +
            `color:` + BSS_B2B.efSettings.text_table_color + `;` +
            `}`;
        let styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet)
    };

    BSS_B2B.ef.getQtyTableHtml = function (appliedRule, isShow = true, quantityValue, isShowForCart, amountValue) {
        let buttonUpDownQuantity = '<button class="bss-b2b-up-down-btn-ef" style="background: transparent; border: none; float: right; color: ' + BSS_B2B.efSettings.text_header_table_color + '">&#x2193;</button>';
        if (BSS_B2B.page.isProductPage() && !isShowForCart) {
            buttonUpDownQuantity = '';
        }

        // Quantity
        if (appliedRule.rule_setting === 0) {
            let qtyTable = appliedRule.qty_options;
            qtyTable.sort((rule1, rule2) => {
                return rule1.id - rule2.id;
            });

            let table = '<table>';
            let tableAppliedPriceText = BSS_B2B.efTranslations.fee_applied;

            table += '<thead><tr><th class="bss-b2b-translation-ef-table_qty_range_text">' + BSS_B2B.efTranslations.table_qty_range_text + '</th><th class="bss-b2b-translation-ef-fee_applied">' + tableAppliedPriceText + '</th><th class="bss-b2b-translation-ef-free_ship">' + BSS_B2B.efTranslations.free_ship + '</th></tr></thead>';
            table += '<tbody>';

            for (let i = 0; i < qtyTable.length; i++) {

                let rowIsApplyRule = false;
                if (quantityValue) {
                    if (qtyTable[i].qty_to === null || qtyTable[i].qty_to.toString().length === 0) {
                        if (quantityValue >= qtyTable[i].qty_from) {
                            rowIsApplyRule = true;
                        }
                    } else {
                        if (quantityValue >= qtyTable[i].qty_from && qtyTable[i].qty_to >= quantityValue) {
                            rowIsApplyRule = true;
                        }
                    }
                }

                let qtyRange = "<td>" + qtyTable[i].qty_from + " - " + qtyTable[i].qty_to + "</td>";
                let qtyTableRow = "<tr class='bss-b2b-qty-table-row-ef " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + qtyTable[i].qty_from + "' data-max='" + qtyTable[i].qty_to + "'>";
                if (qtyTable[i].qty_to === null || qtyTable[i].qty_to.toString().length === 0) {
                    qtyRange = "<td> ≥ " + qtyTable[i].qty_from + "</td>";
                    qtyTableRow = "<tr class='bss-b2b-qty-table-row-ef " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + qtyTable[i].qty_from + "' data-max='" + qtyTable[i].qty_from + "'>";
                }

                table += qtyTableRow;
                table += qtyRange;

                let finalFee = 0
                const fee = Number(qtyTable[i].fee)
                if(qtyTable[i].fee_type === 0){
                    const calculateFee = fee  * 100
                    finalFee = BSS_B2B.formatMoney(calculateFee) 
                }else{
                    finalFee = `${fee} %`
                }
                table += "<td>" + finalFee + "</td>";
                table += "<td>" + (qtyTable[i].free_ship === 0 ? "No" : "Yes") + "</td>";
                table += "</tr>";
            }
            table += '</tbody>';
            table += '</table>';


            let details = '<div class="bss-b2b-cart-item-qty-table-ef">';

            details += '<p class="bss-b2b-cart-item-qty-table-header-title-ef" style="margin-top: 1rem; margin-bottom: 0.2rem;">';
            details += '<span class="bss-b2b-translation-ef-rule_name" style="width: 95%; font-weight: 700; font-size: 1.2rem;">' + appliedRule.name + '</span></p>';
            details += '<p class="bss-b2b-cart-item-qty-table-header-ef"><span style="width: 95%;" class="bss-b2b-translation-ef-table_header_text">' + BSS_B2B.efTranslations.table_header_text + '</span>';
            details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
            details += '</p>';
            details += '<div class="bss-b2b-qty-table-wrapper-ef"' + (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            details += '</div>';
            setTimeout(()=>{
                BSS_B2B.integrate.langShop.handleAllTranslation('ef', ['rule_name'], appliedRule.name);
            }, 100)
            return details;
        }
        // Amount
        else {
            let amountTable = appliedRule.amount_options;
            amountTable.sort((a, b) => {
                return a.id - b.id;
            });

            let table = '<table>';

            let tableAppliedPriceText = BSS_B2B.efTranslations.fee_applied;

            table += '<thead><tr><th class="bss-b2b-translation-ef-table_amount_range_text">' + BSS_B2B.efTranslations.table_amount_range_text + '</th><th class="bss-b2b-translation-ef-fee_applied">' + tableAppliedPriceText + '</th><th class="bss-b2b-translation-ef-free_ship">' + BSS_B2B.efTranslations.free_ship + '</th></tr></thead>';
            table += '<tbody>';

            for (let i = 0; i < amountTable.length; i++) {
                let rowIsApplyRule = false;
                if (amountValue) {
                    if (amountTable[i].amount_to === null || amountTable[i].amount_to.toString().length === 0) {
                        if (amountValue >= amountTable[i].amount_from) {
                            rowIsApplyRule = true;
                        }
                    } else {
                        if (amountValue >= amountTable[i].amount_from && amountTable[i].amount_to >= amountValue) {
                            rowIsApplyRule = true;
                        }
                    }
                }
                let amountRange = "<td>" + BSS_B2B.formatMoney(Number(amountTable[i].amount_from) * 100) + " - " + BSS_B2B.formatMoney(Number(amountTable[i].amount_to) * 100) + "</td>";
                let amountTableRow = "<tr class='bss-b2b-qty-table-row-ef " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + amountTable[i].amount_from + "' data-max='" + amountTable[i].amount_to + "'>";
                if (amountTable[i].amount_to === null || amountTable[i].amount_to.toString().length === 0) {
                    amountRange = "<td> ≥ " + BSS_B2B.formatMoney(Number(amountTable[i].amount_from) * 100) + "</td>";
                    amountTableRow = "<tr class='bss-b2b-qty-table-row-ef " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + amountTable[i].amount_from + "' data-max='" + amountTable[i].amount_from + "'>";
                }

                table += amountTableRow;
                table += amountRange;

                let finalFee = 0
                const fee = Number(amountTable[i].fee)
                if(amountTable[i].fee_type === 0){
                    const calculateFee = fee  * 100
                    finalFee = BSS_B2B.formatMoney(calculateFee) 
                }else{
                    finalFee = `${fee} %`
                }
                table += "<td>" + finalFee + "</td>";
                table += "<td>" + (amountTable[i].free_ship === 0 ? "No" : "Yes") + "</td>";
                table += "</tr>";
                table += "</tr>";
            }
            table += '</tbody>';
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table-ef">';
            details += '<p class="bss-b2b-cart-item-qty-table-header-title-ef" style="margin-top: 1rem; margin-bottom: 0.2rem;">';
            details += '<span class="bss-b2b-translation-ef-rule_name" style="width: 95%; font-weight: 700; font-size: 1.2rem;">' + appliedRule.name + '</span></p>';
            details += '<p class="bss-b2b-cart-item-qty-table-header-ef"><span style="width: 95%;" class="bss-b2b-translation-ef-table_header_text_ab">' + BSS_B2B.efTranslations.table_header_text_ab + '</span>';
            details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
            details += '<div class="bss-b2b-qty-table-wrapper-ef"' + (isShow ? 'style="display: block">' : 'style="display: none">') + table + '</div>';
            details += '</div>';
            setTimeout(()=>{
                BSS_B2B.integrate.langShop.handleAllTranslation('ef', ['rule_name'], appliedRule.name);
            }, 100)
            return details;
        }
    };

    BSS_B2B.ef.calculateFreeship = function (priceList, hasProductNonAppliesRule, freeShippingCalculation) {
        if (freeShippingCalculation === 0) {
            let free_ship = 1;
            priceList.forEach(item => {
                free_ship = free_ship && item.free_ship
            });
            if (free_ship === 0 || hasProductNonAppliesRule) {
                priceList.forEach(item => {
                    item.free_ship = 0
                })
            }
        }
        return priceList
    };

    BSS_B2B.ef.defineValueOfEF = function (item, value, fee, free_ship, totalValue, appliedId) {
        return {
            "price": item.price,
            "quantity": item.quantity,
            "fee": fee,
            "free_ship": free_ship,
            "name": value.name,
            "qty_options": value.qty_options ? value.qty_options : false,
            "amount_options": value.amount_options ? value.amount_options : false,
            "rule_setting": value.rule_setting,
            "rule_id": value.id,
            "rule_type": value.rule_type,
            "sid": `${value.token}.${Buffer.from(`${totalValue}-${appliedId}`).toString('base64')}`
        }
    };

    BSS_B2B.ef.getAppliedRulesForBuyItNow = function (ruleList, customer, product) {
        let appliedRuleList = [];
        if (isEnableEF) {
            ruleList.forEach(function (rule) {
                let appliedEFRule = false;
                let applyTo = rule.apply_to;
                let customerIds = rule.customer_ids;
                let customerTagsInRule = rule.customer_tags;
                let excludeCustomerTags = rule.exc_customer_tags;
                let excludeFrom = rule.exclude_from;
                // if (applyTo == 0) {
                //
                // } else 
                if (applyTo === 1) {
                    if (customer.id === null) {
                        return;
                    }
                } else if (applyTo === 2) {
                    if (customer.id !== null) {
                        return;
                    }
                } else if (applyTo === 3) {
                    if (customer.id === null) {
                        return;
                    } else {
                        customerIds = customerIds.split(',');
                        if (customerIds.indexOf(customer.id + "") === -1) {
                            return;
                        }
                    }
                } else if (applyTo === 4) {
                    if (customer.tags === null) {
                        return;
                    } else {
                        customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                        let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                        let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag + ""));
                        if (checkArray.length === 0) {
                            return
                        }
                    }
                }

                if (excludeFrom) {
                    if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                        excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                        let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                        let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag + ""));
                        if (checkArray.length > 0) {
                            return
                        }
                    }
                }
                let conditionType = rule.product_condition_type;
                let ruleTags = rule.product_tags ? rule.product_tags.split(",").map((tag) => tag.toLowerCase()) : [];
                let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
                let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];


                let collections = product.collections;
                let tags = product ? product.tags.map((tag) => tag.toLowerCase()) : '';

                if (conditionType === 0) {
                    appliedEFRule = rule;
                } else if (conditionType === 1) {
                    if (specificProductIds.indexOf(product.id + "") !== -1) {
                        appliedEFRule = rule;
                    }
                } else if (conditionType === 2) {
                    let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                    if (checkArray.length > 0) {
                        appliedEFRule = rule;
                    }
                } else if (conditionType === 3) {
                    let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        appliedEFRule = rule
                    }
                }

                if (appliedEFRule) {
                    appliedRuleList.push(appliedEFRule);
                }
            })
        }

        return appliedRuleList;
    }

}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./js/src/custom/qb/stores/2524.js
let getAppliedTax = function(appliedQbRule, tags) {
    let appliedTax = false;
    let everyCheck = function (tag) {
        let continueEvery = true;
        if (tag.startsWith("tax:")) {
            let stringTax = tag.replace(/tax:/g, "");
            appliedTax = parseFloat(stringTax);
            continueEvery = false;
        }
        return continueEvery;
    };
    tags.every(everyCheck);
    appliedQbRule.override_tax = appliedTax;
};

function customize(app) {
    app.custom = {
        qb: {
            getAppliedTax,
        },
    };
}

const _2524_storeId = 2524;

const custom = {
    storeId: _2524_storeId,
    customize,
};

/* harmony default export */ var _2524 = (custom);

// CONCATENATED MODULE: ./js/src/custom/qb/stores/2851.js
function customForStoreId_2851(BSS_B2B) {
    BSS_B2B.customQb.customForStoreId_2851 = {};

    BSS_B2B.customQb.customForStoreId_2851.getQtyTableHtml = function (appliedRule, quantityValue, isShowForCart) {
        let priceProductPageEle = $('.product-price.product-price--large');
        let originTotalPrice = quantityValue * appliedRule.price;
        let originProductPrice = appliedRule.price;
        let buttonUpDownQuantity = '<button class="bss-b2b-up-down-qb-btn" style="background: transparent; border: none; float: right; color: ' + BSS_B2B.qbSettings.text_header_table_color + '">&#x2193;</button>';
        if (BSS_B2B.page.isProductPage() && !isShowForCart) {
            buttonUpDownQuantity = '';
        }

        if (priceProductPageEle.parent().find('.bss-b2b-custom-qb-price-qb-wrapper').length) {
            $('.bss-b2b-custom-qb-price-qb-wrapper').remove();
        }
        // Quantity Break
        if (appliedRule.rule_setting == 0) {
            var qtyTable = appliedRule.qty_table;
            qtyTable.sort((a, b) => {
                return a.id - b.id;
            });

            let table = '<table>';

            table += '<thead><tr><th>Pieces</th><th>Discounted Price per piece</th><th>Savings per piece</th></tr></thead>';

            let priceAfterQB = originProductPrice;
            let isApplyQB = false;

            for (let i = 0; i < qtyTable.length; i++) {
                let discountValue = qtyTable[i].discount_value;
                let percentageDiscount = 0;
                switch (qtyTable[i].discount_type) {
                    case 0:
                        percentageDiscount = ((originProductPrice - discountValue * 100) / (originProductPrice)) * 100;
                        if (percentageDiscount > 0) {
                            percentageDiscount = (parseFloat(percentageDiscount)).toFixed(0);
                        } else {
                            percentageDiscount = 0;
                        }
                        priceAfterQB = discountValue * 100;
                        discountValue = BSS_B2B.formatMoney(discountValue * 100);
                        break;
                    case 1:
                        discountValue = originProductPrice - discountValue * 100;
                        if (discountValue > 0) {
                            percentageDiscount = ((originProductPrice - discountValue) / originProductPrice) * 100;
                            priceAfterQB = discountValue;
                            discountValue = BSS_B2B.formatMoney(discountValue);
                        } else {
                            percentageDiscount = 0;
                            priceAfterQB = originProductPrice;
                            discountValue = BSS_B2B.formatMoney(originProductPrice);
                        }
                        percentageDiscount = (parseFloat(percentageDiscount)).toFixed(0);
                        break;
                    case 2:
                        priceAfterQB = originProductPrice - originProductPrice * (discountValue / 100);
                        percentageDiscount = (parseFloat(discountValue)).toFixed(0);
                        discountValue = BSS_B2B.formatMoney(originProductPrice - originProductPrice * (discountValue / 100));
                        break;
                    default:
                        break;
                }

                let rowIsApplyRule = false;
                if (quantityValue) {
                    if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length == 0) {
                        if (quantityValue >= qtyTable[i].qty_from) {
                            rowIsApplyRule = true;
                            isApplyQB = true;
                        }
                    } else {
                        if (quantityValue >= qtyTable[i].qty_from && qtyTable[i].qty_to >= quantityValue) {
                            rowIsApplyRule = true;
                            isApplyQB = true;
                        }
                    }
                }

                let qtyRange = "<td>" + qtyTable[i].qty_from + " - " + qtyTable[i].qty_to + "</td>";
                let qtyTableRow = "<tr class='bss-b2b-qty-table-row " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + qtyTable[i].qty_from + "' data-max='" + qtyTable[i].qty_to + "'>";
                if (qtyTable[i].qty_to == null || qtyTable[i].qty_to.toString().length == 0) {
                    qtyRange = "<td> ≥ " + qtyTable[i].qty_from + "</td>";
                    qtyTableRow = "<tr class='bss-b2b-qty-table-row " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + qtyTable[i].qty_from + "' data-max='" + qtyTable[i].qty_from + "'>";
                }
                table += qtyTableRow;
                table += qtyRange;
                table += "<td>" + discountValue + "</td>"
                table += "<td>save " + percentageDiscount + " %</td>";
                table += "</tr>";

                if (rowIsApplyRule && BSS_B2B.page.isProductPage() && priceProductPageEle.length) {
                    BSS_B2B.customQb.customForStoreId_2851.showPriceAfterQBInProductPage(quantityValue, priceAfterQB, priceProductPageEle, originProductPrice, originTotalPrice);
                }
            }
            table += '</tbody>'
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table">'
            details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 95%;">Volume Discount Table</span>';
            details += '<span style="width: 5%;">' + buttonUpDownQuantity + '</span>';
            details += '</p>'
            details += '<div class="bss-b2b-qty-table-wrapper" style="display: block">' + table + '</div>';
            details += '</div>';

            if (!isApplyQB) {
                priceProductPageEle.css("display", "block");
            }

            return details;
        }
        // Amount Break
        else {
            var amountTable = appliedRule.amount_table;
            amountTable.sort((a, b) => {
                return a.id - b.id;
            });

            let table = '<table>';
            table += '<thead><tr><th>Pieces</th><th>Discounted Price per piece</th><th>Savings per piece</th></tr></thead>';

            let priceAfterAB = originProductPrice;

            for (let i = 0; i < amountTable.length; i++) {
                let discountValue = amountTable[i].discount_value;
                let percentageDiscount = 0;
                switch (amountTable[i].discount_type) {
                    case 0:
                        percentageDiscount = ((originProductPrice - discountValue * 100) / (originProductPrice)) * 100;
                        if (percentageDiscount > 0) {
                            percentageDiscount = (parseFloat(percentageDiscount)).toFixed(0);
                        } else {
                            percentageDiscount = 0;
                        }

                        priceAfterAB = discountValue * 100;
                        discountValue = BSS_B2B.formatMoney(discountValue * 100);
                        break;
                    case 1:
                        discountValue = originProductPrice - discountValue * 100;
                        if (discountValue > 0) {
                            percentageDiscount = ((originProductPrice - discountValue) / originProductPrice) * 100;
                            priceAfterAB = discountValue;
                            discountValue = BSS_B2B.formatMoney(discountValue);
                        } else {
                            percentageDiscount = 0;
                            priceAfterAB = originProductPrice;
                            discountValue = BSS_B2B.formatMoney(originProductPrice);
                        }
                        percentageDiscount = (parseFloat(percentageDiscount)).toFixed(0);
                        break;
                    case 2:
                        priceAfterAB = originProductPrice - originProductPrice * (discountValue / 100);
                        percentageDiscount = (parseFloat(discountValue)).toFixed(0);
                        discountValue = BSS_B2B.formatMoney(originProductPrice - originProductPrice * (discountValue / 100));
                        break;
                    default:
                        break;
                }

                let rowIsApplyRule = false;
                if (quantityValue) {
                    if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length == 0) {
                        if (originTotalPrice >= amountTable[i].amount_from * 100) {
                            rowIsApplyRule = true;
                        }
                    } else {
                        if (originTotalPrice >= (amountTable[i].amount_from * 100)
                            && (amountTable[i].amount_to * 100) >= originTotalPrice) {
                            rowIsApplyRule = true;
                        }
                    }
                }

                let amountRange = "<td>" + BSS_B2B.formatMoney(Number(amountTable[i].amount_from) * 100) + " - " + BSS_B2B.formatMoney(Number(amountTable[i].amount_to) * 100) + "</td>";
                let amountTableRow = "<tr class='bss-b2b-qty-table-row " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + amountTable[i].amount_from + "' data-max='" + amountTable[i].amount_to + "'>";
                if (amountTable[i].amount_to == null || amountTable[i].amount_to.toString().length == 0) {
                    amountRange = "<td> ≥ " + BSS_B2B.formatMoney(Number(amountTable[i].amount_from) * 100) + "</td>";
                    amountTableRow = "<tr class='bss-b2b-qty-table-row " + (rowIsApplyRule ? ("qty-row-active") : "") + "' data-min='" + amountTable[i].amount_from + "' data-max='" + amountTable[i].amount_from + "'>";
                }
                table += amountTableRow;
                table += amountRange;
                table += "<td>" + discountValue + "</td>"
                table += "<td>save " + percentageDiscount + " %</td>"
                table += "</tr>";

                if (rowIsApplyRule && BSS_B2B.page.isProductPage() && priceProductPageEle.length) {
                    BSS_B2B.customQb.customForStoreId_2851.showPriceAfterQBInProductPage(quantityValue, priceAfterAB, priceProductPageEle, originProductPrice, originTotalPrice);
                }
            }
            table += '</tbody>'
            table += '</table>';

            let details = '<div class="bss-b2b-cart-item-qty-table">'
            details += '<p class="bss-b2b-cart-item-qty-table-header"><span style="width: 98%;">Volumn Discount Table</span>';
            details += '<span style="width: 2%;">' + buttonUpDownQuantity + '</span>';
            details += '<div class="bss-b2b-qty-table-wrapper" style="display: block">' + table + '</div>';
            details += '</div>';
            return details;
        }
    }

    BSS_B2B.customQb.customForStoreId_2851.changeQuantityInProductPage = function () {
        var cartForm = $(
            'form[action*="/cart/add"],'
            + 'form[action*="/checkout"]'
            + BSS_B2B.getCssSelector('product_cart_form')
        );

        if (cartForm.length) {
            for (let i = 0; i < cartForm.length; i++) {
                var cartFormI = $(cartForm[i]);
                var variantSelector = cartFormI.find("select, " +
                    "input.single-option-selector__radio," +
                    "input.quantity-actual#Quantity"
                    + BSS_B2B.getCssSelector('product_variant_option_input'));
                if (variantSelector.length) {
                    for (let k = 0; k < variantSelector.length; k++) {
                        var element = $(variantSelector[k]);
                        element.on("change", function () {
                            if (BSS_B2B.qb.appliedQbRuleForOneProduct) {
                                setTimeout(function () {
                                    $(document).find('.bss-b2b-cart-item-qty-table').remove();
                                    BSS_B2B.qb.generateTableOnProductPage();
                                }, 1000)
                            }
                        })
                    }
                }

                var variantSelectorClickItem = cartFormI.find(".block-swatch-list .block-swatch__item");
                if (variantSelectorClickItem.length) {
                    for (let k = 0; k < variantSelectorClickItem.length; k++) {
                        let element = $(variantSelectorClickItem[k]);
                        element.on("click", function () {
                            setTimeout(function () {
                                $(document).find('.bss-b2b-cart-item-qty-table').remove();
                                BSS_B2B.qb.generateTableOnProductPage();
                            }, 1000)
                        })
                    }
                }
            }
        }
    }

    BSS_B2B.customQb.customForStoreId_2851.showPriceAfterQBInProductPage = function (quantityValue, priceAfterQB, priceProductPageEle, originProductPrice, originTotalPrice) {
        priceProductPageEle.css("display", "none");
        let totalPriceAfterQB = quantityValue * priceAfterQB;
        totalPriceAfterQB = BSS_B2B.formatMoney(totalPriceAfterQB);
        let percentageTotalDiscount = (originProductPrice - priceAfterQB) / originProductPrice;
        percentageTotalDiscount = (percentageTotalDiscount * 100).toFixed(0);
        let priceAfterQBHTML = '<span class="bss-b2b-custom-qb-price-qb-wrapper">';
        priceAfterQBHTML += '<span class="bss-b2b-custom-qb-price-after-qb">' + totalPriceAfterQB + ' (' + BSS_B2B.formatMoney(priceAfterQB) + ' per piece)</span> ';
        priceAfterQBHTML += '<span class="bss-b2b-custom-qb-origin-price">' + BSS_B2B.formatMoney(originTotalPrice) + ' (' + BSS_B2B.formatMoney(originProductPrice) + ' per piece)</span>';
        priceAfterQBHTML += '<span class="bss-b2b-custom-qb-percentage-discount">Save ' + ~~percentageTotalDiscount + '%</span>';
        priceAfterQBHTML += '</span>';

        priceProductPageEle.after(priceAfterQBHTML);
    }

    BSS_B2B.customQb.customForStoreId_2851.settingTableQBOrAB = function () {
        let styles = `
            .bss-b2b-cart-item-qty-table {` +
            `font-family: Poppins, sans-serif !important;` +
            `font-size: 18px !important;` +
            `width: max-content;` +
            `}` +
            `.bss-b2b-cart-item-qty-table  table {` +
            `width: max-content;` +
            `}` +
            `.cart-column .bss-b2b-cart-item-qty-table-header {` +
            `background-color:` + BSS_B2B.qbSettings.header_table_background + `;` +
            `color:` + BSS_B2B.qbSettings.text_header_table_color + `;` +
            `text-align: center;` +
            `border: 1px solid;` +
            `}` +
            `.product-form .bss-b2b-cart-item-qty-table-header {` +
            `background-color:` + BSS_B2B.qbSettings.header_table_background + `;` +
            `color:` + BSS_B2B.qbSettings.text_header_table_color + `;` +
            `text-align: center;` +
            `border-top: 1px solid;` +
            `border-left: 1px solid;` +
            `border-right: 1px solid;` +
            `}` +
            `.bss-b2b-qty-table-wrapper {` +
            `background-color:` + BSS_B2B.qbSettings.table_background_color + `;` +
            `color:` + BSS_B2B.qbSettings.text_table_color + `;` +
            `}` +
            `.bss-b2b-qty-table-wrapper th, .bss-b2b-qty-table-wrapper td {` +
            `border: 1px solid ` + BSS_B2B.qbSettings.text_table_color + ` !important;` +
            `font-weight: unset !important;` +
            `}` +
            `.cart-column .bss-b2b-qty-table-wrapper th {` +
            `border-top: unset !important;` +
            `}` +
            `.bss-b2b-qty-table-row.qty-row-active {` +
            `background-color:` + BSS_B2B.qbSettings.row_hover_background_color + `;` +
            `color:` + BSS_B2B.qbSettings.row_hover_text_color + `;` +
            `border-color:` + BSS_B2B.qbSettings.row_hover_background_color + `;` +
            `font-weight: unset !important;` +
            `}` +
            `.bss-b2b-qty-table-row:not(.qty-row-active):not(:hover) {` +
            `background-color:` + BSS_B2B.qbSettings.table_background_color + `;` +
            `color:` + BSS_B2B.qbSettings.text_table_color + `;` +
            `}` +
            `.bss-b2b-custom-qb-origin-price {` +
            `text-decoration: line-through;` +
            `margin-right: 3px;` +
            `}` +
            `.bss-b2b-custom-qb-percentage-discount {` +
            `border-radius: 15px;` +
            `background-color:` + BSS_B2B.qbSettings.row_hover_text_color + `;` +
            `padding: 4px;` +
            `color: white;` +
            `}` +
            `p.bss-b2b-cart-item-qty-table-header span {` +
            `margin: auto;` +
            `}` +
            `.bss-b2b-up-down-qb-btn {` +
            `font-size: 30px;` +
            `min-width: unset !important;` +
            `}` +
            `.bss-qb-price-item, .bss-qb-total-price-item, .bss-qb-cart-subtotal {` +
            `margin-left: 6px;` +
            `}` +
            `.cart-column.cart-column--price.product-price {` +
            `width: unset !important;` +
            `}` +
            `@media only screen and (max-width: 1400px) {` +
                `.bss-b2b-cart-item-qty-table {` +
                    `width: 100% !important;` +
                `}` +
                `.bss-b2b-cart-item-qty-table  table {` +
                    `width: 100% !important;` +
                `}`+
            `}`;

        var styleSheet = document.createElement("style");
        styleSheet.id = "bss-b2b-custom-qb-style-2851"
        styleSheet.type = "text/css";
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);
    }
}
// CONCATENATED MODULE: ./js/src/custom/qb/index.js



function initCustomQb(BSS_B2B) {
    BSS_B2B.customQb = {};

    if (BSS_B2B.storeId == 2524) _2524(BSS_B2B);
    if (BSS_B2B.storeId == 2851) customForStoreId_2851(BSS_B2B);
}

// CONCATENATED MODULE: ./js/src/custom/vat_exempt/stores/4576.js
const Tax = __webpack_require__(1);

function customForStoreId_4576(BSS_B2B, shopData) {

    BSS_B2B.customVatExempt = {
        validateVat: function () {
            $('.bss-b2b-vat-input').on("change", function () {
                let vatNumber = $(this).val()
                let taxExMessage = $('.bss-b2b-tax-ex-message');
                let validateVat = Tax.clientValidateVat(BSS_B2B.vatExemptSelected, vatNumber);
                let errorMessage = '';
                let successMessage = '';
                let validateCountryCodeMessage = BSS_B2B.vatTranslations.form_validate_country_code_message;
                if (BSS_B2B.vatExemptSelected == 0) {
                    errorMessage = BSS_B2B.vatTranslations.form_error_message;
                    successMessage = BSS_B2B.vatTranslations.form_success_message;
                } else if (BSS_B2B.vatExemptSelected == 1) {
                    errorMessage = BSS_B2B.vatTranslations.form_error_message_uk;
                    successMessage = BSS_B2B.vatTranslations.form_success_message_uk;
                } else if (BSS_B2B.vatExemptSelected == 2) {
                    errorMessage = BSS_B2B.vatTranslations.form_error_message_abn;
                    successMessage = BSS_B2B.vatTranslations.form_success_message_abn;
                } else if (BSS_B2B.vatExemptSelected == 3) {
                    errorMessage = BSS_B2B.vatTranslations.form_error_message_gst;
                    successMessage = BSS_B2B.vatTranslations.form_success_message_gst;
                } else if (BSS_B2B.vatExemptSelected == 4) {
                    errorMessage = BSS_B2B.vatTranslations.form_error_message_us_ein;
                    successMessage = BSS_B2B.vatTranslations.form_success_message_us_ein;
                }
                if (validateVat) {
                    let countryCode = BSS_B2B.vatExemptSelected == 0 ? vatNumber.substr(0, 2) : '';
                    let data = {
                        domain: shopData.shop.permanent_domain,
                    };
                    if (BSS_B2B.vatExemptSelected == 0) {
                        vatNumber = vatNumber.toUpperCase()
                        countryCode = countryCode.toUpperCase()
                        data.vatNumber = vatNumber
                        data.countryCode = countryCode
                    } else if (BSS_B2B.vatExemptSelected == 1) {
                        data.ukVatNumber = vatNumber
                    } else if (BSS_B2B.vatExemptSelected == 2) {
                        data.abn = vatNumber
                    } else {
                        data.gstNumber = vatNumber
                    }
                    let router = '';
                    if (BSS_B2B.vatExemptSelected == 0) {
                        router = "/wholesaler/valid/vat"
                    } else if (BSS_B2B.vatExemptSelected == 1) {
                        router = "/wholesaler/valid/uk-vat"
                    } else if (BSS_B2B.vatExemptSelected == 2) {
                        router = "/wholesaler/valid/abn"
                    } else {
                        router = "/wholesaler/valid/gst"
                    }
                    fetch(`${bssB2bApiServer}${router}?domain=${shopData.shop.permanent_domain}`, {
                        method: "POST",
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then(function (data) {
                            if (data.success) {
                                const isEUVATCountry = BSS_B2B.vatSetting && BSS_B2B.vatSetting.selected_eu_vat_countries && BSS_B2B.vatSetting.selected_eu_vat_countries.includes(countryCode);
                                if (BSS_B2B.vatExemptSelected != 0 || (BSS_B2B.vatExemptSelected == 0 && isEUVATCountry)) {
                                    $(taxExMessage).html(
                                        "<p class='bss-b2b-tax-valid' style='color: green; margin-top: 5px'>"
                                        + "<span style='font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10003;</span> "
                                        + successMessage
                                        + "</p>")
                                    BSS_B2B.validateVatSuccess = true;
                                    let validateVat = true;
                                    let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                        detail: {validateVat, vatNumber}
                                    });
                                    document.dispatchEvent(event);

                                } else {
                                    $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                        + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                        + validateCountryCodeMessage
                                        + "</p>"
                                    )
                                    BSS_B2B.validateVatSuccess = false;
                                    let validateVat = false;
                                    let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                        detail: {validateVat, vatNumber}
                                    });
                                    document.dispatchEvent(event);
                                }
                            } else {
                                $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                    + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                    + errorMessage
                                    + "</p>"
                                )
                                BSS_B2B.validateVatSuccess = false;
                                let validateVat = false;
                                let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                    detail: {validateVat, vatNumber}
                                });
                                document.dispatchEvent(event);
                            }
                        });
                }

            })
        }
    };

}

// CONCATENATED MODULE: ./js/src/custom/vat_exempt/stores/4557.js
const _4557_Tax = __webpack_require__(1);

function customForStoreId_4557(BSS_B2B, shopData) {
    BSS_B2B.customVatExempt = {
        handleValidateButton: function (checkoutBtn) {
            let validateButton = document.getElementById('bss-b2b-custom-tax-exempt-submit');
            if (validateButton) {
                validateButton.addEventListener("click", async (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    let isEnabledVatValidate = false;

                    if (BSS_B2B.shopModules && BSS_B2B.shopModules.length) {
                        BSS_B2B.shopModules.forEach(function (md) {
                            if (md.code == "tax_exempt") {
                                isEnabledVatValidate = md.status;
                            }
                        })
                    }

                    let vatNumber = "";
                    let inputTaxElement = $('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]');
                    let taxExMessage = $('.bss-b2b-tax-ex-message');

                    if ($(inputTaxElement).length) {
                        vatNumber = $(inputTaxElement).val();
                    }

                    let validateVat = _4557_Tax.clientValidateVat(BSS_B2B.vatExemptSelected, vatNumber);

                    if ($(inputTaxElement).length) {
                        vatNumber = $(inputTaxElement).val();
                    }

                    if (isEnabledVatValidate) {
                        let errorMessage = '';
                        let successMessage = '';
                        let validateCountryCodeMessage = BSS_B2B.vatTranslations.form_validate_country_code_message;
                        if (BSS_B2B.vatExemptSelected == 0) {
                            errorMessage = BSS_B2B.vatTranslations.form_error_message;
                            successMessage = BSS_B2B.vatTranslations.form_success_message;
                        } else if (BSS_B2B.vatExemptSelected == 1) {
                            errorMessage = BSS_B2B.vatTranslations.form_error_message_uk;
                            successMessage = BSS_B2B.vatTranslations.form_success_message_uk;
                        } else if (BSS_B2B.vatExemptSelected == 2) {
                            errorMessage = BSS_B2B.vatTranslations.form_error_message_abn;
                            successMessage = BSS_B2B.vatTranslations.form_success_message_abn;
                        } else if (BSS_B2B.vatExemptSelected == 3){
                            errorMessage = BSS_B2B.vatTranslations.form_error_message_gst;
                            successMessage = BSS_B2B.vatTranslations.form_success_message_gst;
                        } else if (BSS_B2B.vatExemptSelected == 4) {
                            errorMessage = BSS_B2B.vatTranslations.form_error_message_us_ein;
                            successMessage = BSS_B2B.vatTranslations.form_success_message_us_ein;
                        }
                        if (BSS_B2B.vatSetting && BSS_B2B.vatSetting.is_required_vat) {
                            if (vatNumber.length === 0 || !validateVat) {
                                $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                    + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                    + errorMessage
                                    + "</p>"
                                )
                                return;
                            }
                        } else {
                            if (vatNumber.length === 0) {
                                return;
                            } else if (!validateVat) {
                                $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                    + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                    + errorMessage
                                    + "</p>"
                                )
                                return;
                            }
                        }
                        $(checkoutBtn).attr('disabled', "true");
                        let countryCode = BSS_B2B.vatExemptSelected == 0 ? vatNumber.substr(0, 2) : '';
                        let data = {
                            domain: shopData.shop.permanent_domain,
                        };
                        if (BSS_B2B.vatExemptSelected == 0) {
                            vatNumber = vatNumber.toUpperCase()
                            countryCode = countryCode.toUpperCase()
                            data.vatNumber = vatNumber
                            data.countryCode = countryCode
                        } else if (BSS_B2B.vatExemptSelected == 1) {
                            data.ukVatNumber = vatNumber
                        } else if (BSS_B2B.vatExemptSelected == 2) {
                            data.abn = vatNumber
                        } else {
                            data.gstNumber = vatNumber
                        }
                        if (!BSS_B2B.validateVatSuccess) {
                            let router = '';
                            if (BSS_B2B.vatExemptSelected == 0) {
                                router = "/wholesaler/valid/vat"
                            } else if (BSS_B2B.vatExemptSelected == 1) {
                                router = "/wholesaler/valid/uk-vat"
                            } else if (BSS_B2B.vatExemptSelected == 2) {
                                router = "/wholesaler/valid/abn"
                            } else {
                                router = "/wholesaler/valid/gst"
                            }
                            fetch(`${bssB2bApiServer}${router}?domain=${shopData.shop.permanent_domain}`, {
                                method: "POST",
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify(data)
                            })
                                .then(response => response.json())
                                .then(function (data) {
                                    if (data.success) {
                                        const isEUVATCountry = BSS_B2B.vatSetting && BSS_B2B.vatSetting.selected_eu_vat_countries && BSS_B2B.vatSetting.selected_eu_vat_countries.includes(countryCode);
                                        if (BSS_B2B.vatExemptSelected != 0 || (BSS_B2B.vatExemptSelected == 0 && isEUVATCountry)) {
                                            $(taxExMessage).html(
                                                "<p class='bss-b2b-tax-valid' style='color: green; margin-top: 5px'>"
                                                + "<span style='font-size: 20px; color: green; border: 1px green solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10003;</span> "
                                                + successMessage
                                                + "</p>")
                                            BSS_B2B.validateVatSuccess = true;
                                            let validateVat = true;
                                            let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                                detail: { validateVat, vatNumber }
                                            });
                                            document.dispatchEvent(event);

                                        } else {
                                            $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                                + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                                + validateCountryCodeMessage
                                                + "</p>"
                                            )
                                            let validateVat = false;
                                            let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                                detail: { validateVat, vatNumber }
                                            });
                                            document.dispatchEvent(event);
                                        }

                                        $(checkoutBtn).removeAttr('disabled');
                                        BSS_B2B.validateVatSuccess = true;
                                        $(inputTaxElement).on("change", function () {
                                            let newVatNumber = $('.bss-b2b-tax-ex-wrapper input[name="bss-b2b-eu-tax"]').val();
                                            if (newVatNumber != vatNumber) {
                                                BSS_B2B.validateVatSuccess = false;
                                            }
                                        })
                                    } else {
                                        $(taxExMessage).html("<p class='bss-b2b-tax-invalid' style='color: orangered; margin-top: 5px'>"
                                            + "<span style='font-size: 20px; color: orangered; border: 1px orangered solid; border-radius: 50%; width: 40px; height: 40px; padding: 0 4px'>&#10005;</span> "
                                            + errorMessage
                                            + "</p>"
                                        )
                                        $(checkoutBtn).removeAttr('disabled');
                                        let validateVat = false;
                                        let event = new CustomEvent("bss.b2b.vat.validateVatByBSS", {
                                            detail: { validateVat, vatNumber }
                                        });
                                        document.dispatchEvent(event);
                                        return;
                                    }
                                });
                        }
                    }
                }, false);
            }
        },
    };
}

// CONCATENATED MODULE: ./js/src/custom/vat_exempt/index.js



function initCustomVatExempt(BSS_B2B, shopData) {
    BSS_B2B.customVatExempt = {};

    if (BSS_B2B.storeId == 4576) customForStoreId_4576(BSS_B2B, shopData);
    if (BSS_B2B.storeId == 4557) customForStoreId_4557(BSS_B2B, shopData);
}

// CONCATENATED MODULE: ./js/src/custom/cart_note/stores/2995.js
function customForStoreId_2995(BSS_B2B) {

    BSS_B2B.customCartNote = {
        // custom
        addCartNotes: function (customFieldValue, cartNotes) {
            for (var i = 0; i < cartNotes.length; i++) {
                const regex = cartNotes[i].getAttribute("name").match(/attributes\[(.*?)\]/);
                if (regex.length < 2) return;
                const key = regex[1];
                const value = cartNotes[i].value;

                customFieldValue.push({
                    key: key,
                    value: value
                });
            }
        },
    };

}

// CONCATENATED MODULE: ./js/src/custom/cart_note/index.js


function initCustomCartNote(BSS_B2B) {
    BSS_B2B.customCartNote = {};

    if ([2995, 3562, 12500].includes(BSS_B2B.storeId)) customForStoreId_2995(BSS_B2B);
}

// CONCATENATED MODULE: ./js/src/custom/cp/stores/3041_3402.js
function customForStoreId_3041_3402(BSS_B2B) {
    BSS_B2B.customCp.customForStoreId_3041_3402 = {};
    BSS_B2B.customCp.customForStoreId_3041_3402.showPriceWhenUseCPAfterSorting = function (shopData) {
        let sortProductPicker = $('.value-picker__choice-item.link');
        if (sortProductPicker.length > 0) {
            sortProductPicker.click(function () {
                setTimeout(function () {
                    BSS_B2B.customCp.customForStoreId_3041_3402.showPriceWhenUseCPAfterSorting(shopData);
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                }, 2000);
            })
        }
    }
}

// CONCATENATED MODULE: ./js/src/custom/cp/index.js


function initCustomCp(BSS_B2B, shopData) {
    BSS_B2B.customCp = {};
    if ([3041,3402].indexOf(BSS_B2B.storeId) !== -1) customForStoreId_3041_3402(BSS_B2B, shopData);
}

// CONCATENATED MODULE: ./js/src/custom/index.js





/**
 * Customize for specific merchants
 */
function initCustom(BSS_B2B, shopData) {
    // init support for QB
    initCustomQb(BSS_B2B);
    initCustomCp(BSS_B2B, shopData);
    initCustomVatExempt(BSS_B2B, shopData);
    // init support for Add Fields to Order/Draft Order
    initCustomCartNote(BSS_B2B);
    // custom for specific case
    if (BSS_B2B.storeId == 2087) {
        BSS_B2B.handleQuickview_2087 = function () {
            let bssVatDisplayCheckTimes = 0;
            let bssVatDisplayCheck = setInterval(function () {
                let bssVatDisplayElement = document.querySelector('div.modal.modal--quick-shop.modal--is-active .bss-b2b-product-vat[data-product-id]');
                if (bssVatDisplayElement || bssVatDisplayCheckTimes > 20) {
                    clearInterval(bssVatDisplayCheck);
                    if (bssVatDisplayElement) {
                        let bssVatDisplayInnerCheckTimes = 0;
                        let bssVatDisplayInnerCheck = setInterval(function () {
                            let bssVatDisplaySpans = bssVatDisplayElement.querySelectorAll('span[class^="bss-b2b-product-vat-price"]');
                            if ((bssVatDisplaySpans.length == 2 && (bssVatDisplaySpans[0].innerHTML.trim().length > 0 || bssVatDisplaySpans[1].innerHTML.trim().length > 0)) || bssVatDisplayInnerCheckTimes > 20) {
                                clearInterval(bssVatDisplayInnerCheck);
                                if (bssVatDisplaySpans.length == 2 && (bssVatDisplaySpans[0].innerHTML.trim().length > 0 || bssVatDisplaySpans[1].innerHTML.trim().length > 0)) {
                                    let cloned = bssVatDisplayElement.cloneNode(true);
                                    document.querySelector("div.modal.modal--quick-shop.modal--is-active .product-block.product-block--price").prepend(cloned);
                                    bssVatDisplayElement.remove();
                                }
                            }
                            bssVatDisplayInnerCheckTimes++;
                        }, 500);
                    }
                    return;
                }
                bssVatDisplayCheckTimes++;
            }, 500);
        }
    }
}

// CONCATENATED MODULE: ./js/src/internal/fix/cp.js
function fixModules(app) {

    const fixShowPrice = function (price, variant, productId, productPrices, priceElement, currentItemPrices) {
        //Hide save amount for supply theme
        if (app.storeId === 5195) {
            let savingText = 'Spar';
            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-saved-amount]').html(savingText + " " + app.formatMoney(currentItemPrices.compareAtPriceMax - price));
        } else if (app.storeId === 6245) {
            let savingText = 'Save';
            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-saved-amount]').html(savingText + " " + app.formatMoney(currentItemPrices.compareAtPriceMax - price));
        } else {
            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-saved-amount]').parent().hide();
            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').parent().find('.sale-tag').hide();
        }
        if ([3643, 3795].indexOf(app.storeId) !== -1) {
            priceElement.attr('bss-b2b-cp-price', price);
        }
        // fix for www.hps1source.com by hoaduong
        if (app.storeId === 4730) {
            let cpPrice = $('.product-single__meta .product-block--price[bss-b2b-product-id="' + productId + '"]');
            let comparePrice = $('.product-single__meta .bss-b2b-customized-compare-at-price[data-product-id="' + productId + '"]');
            if (cpPrice.length) {
                cpPrice.html(cpPrice.html().replace('.', '<sup>').replace(',', '<sup>').concat('</sup>'));
            }
            if (comparePrice.length) {
                comparePrice.html(comparePrice.html().replace('.', '<sup>').replace(',', '<sup>').concat('</sup>'));
            }
        }
        if (app.storeId === 1889) {
            if (BSS_B2B.page.isCartPage()) {
                $('[data-price-grid][bss-b2b-product-id="' + productId + '"]').html(app.formatMoney(price));
            }
            if (BSS_B2B.page.isProductPage()) {
                if (priceElement.attr('bss-b2b-variant-id')) {
                    variant = priceElement.attr('bss-b2b-variant-id')
                }
            }
        }

        if (app.storeId === 2312 && priceElement) {
            let customStylePrice = $(`[custom-line-through-price][product-id=${productId}]`);
            if (customStylePrice) {
                let originPriceHtml = customStylePrice.html();
                if (originPriceHtml) {
                    let amount = originPriceHtml.replace(/[^0-9-]+/g, "");
                    let currentVariantPrices = productPrices[productId].variants;
                    if (currentVariantPrices.length) {
                        currentVariantPrices.map((item) => {
                            if (item.id === variant) {
                                amount = item.price;
                                customStylePrice.html(app.formatMoney(amount))
                            }
                        });
                        if (BSS_B2B.page.isProductPage()) {
                            $('.custom-discount-badge').remove();
                        }
                    }

                    let discountPercent = (parseFloat(amount) - parseFloat(price)) * 100 / amount;
                    discountPercent = Math.round(discountPercent);
                    let discountBadge = `<span class="custom-discount-badge"> Sie sparen <span class="custom-discount-price">${discountPercent}%</span></span>`;
                    customStylePrice.after(discountBadge);
                    customStylePrice.show();
                }
            }
        }
        if (app.storeId === 2525) {
            let args = { productId: productId, counter: 20 };
            args.intervalId = setInterval(function (args) {
                return function () {
                    args.counter--;
                    let productPriceElem = $('span.h1[bss-b2b-product-id="' + args.productId + '"]').find('span.money:not([data-gbp])');
                    if ((productPriceElem && !productPriceElem.text().includes('GBP')) || args.counter === 0) {
                        clearInterval(args.intervalId);
                        if (productPriceElem && !productPriceElem.text().includes('GBP')) {
                            productPriceElem.text(function (index, curContent) {
                                return curContent + ' GBP';
                            });
                        }
                    }
                };
            }(args), 500);
        }
        if (app.storeId === 4618 && priceElement.length === 0) {
            priceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
        }
        if (app.storeId === 5885) {
            priceElement.html(app.formatMoney(price) + 'Ex GST');
        }
        if ([826, 1033, 1138].indexOf(app.storeId) !== -1) {
            let customProductPriceElement = $('.bss-b2b-custom[data-product-id="' + productId + '"]');
            if (customProductPriceElement.length) {
                customProductPriceElement.html(app.formatMoney(currentItemPrices.price));
                if (app.storeId === 826) {
                    $('.ProductItem__Price').addClass("bss-custom-price-color")
                }
            }
        }
        if (app.storeId === 1358) {
            let originalPrice = currentItemPrices.price;
            if (currentItemPrices.variants) {
                for (let i = 0; i < currentItemPrices.variants.length; i++) {
                    if (currentItemPrices.variants[i].id === variant) {
                        originalPrice = currentItemPrices.variants[i].price;
                        break;
                    }
                }
            }
            let customProductPriceElement = $('.bss-b2b-custom-origin-price-1358[data-product-id="' + productId + '"]');
            customProductPriceElement.html(app.formatMoney(originalPrice));
            customProductPriceElement.css("visibility", "visible");
        }
        if ([3787].indexOf(app.storeId) !== -1) {
            let priceNewOriginEle = $('[data-product=' + productId + '] span.product-meta__price.product-meta__price--new');
            let priceOldOriginEle = $('[data-product=' + productId + '] span.product-meta__price.product-meta__price--old');
            if (priceNewOriginEle.length) {
                priceNewOriginEle.css('display', 'none');
            }
            if (priceOldOriginEle.length) {
                priceOldOriginEle.css('display', 'none');
            }
            let originalPrice = currentItemPrices.price;
            if (currentItemPrices.variants) {
                for (let i = 0; i < currentItemPrices.variants.length; i++) {
                    if (currentItemPrices.variants[i].id === variant) {
                        originalPrice = currentItemPrices.variants[i].price;
                        break;
                    }
                }
            }
            $('.bss-price-original[bss-b2b-product-id="' + productId + '"]').show();
            $('.bss-price-original[bss-b2b-product-id="' + productId + '"] .bss-price').html(app.formatMoney(originalPrice));
            $('.bss-price-original[bss-b2b-product-id="' + productId + '"] .bss-price-original, ' +
                '.collection__item.product-item .product-item__price[bss-b2b-product-price][bss-b2b-product-id="' + productId + '"]').css("color", "#1473fb");
            $('.collection__item.product-item .product-item__price[bss-b2b-product-price][bss-b2b-product-id="' + productId + '"]').css("flex-direction", "row-reverse");
            $('.collection__item.product-item [bss-b2b-product-id="' + productId + '"][bss-b2b-product-price], ' +
                '#shopify-section-product-template .product-meta [bss-b2b-product-parent-price][bss-b2b-product-id="' + productId + '"], ' +
                '.collection__item.product-item [bss-b2b-product-id="' + productId + '"][bss-b2b-product-from-price]').css("color", "#da2929");
        }
        if (app.storeId === 664) {
            let productPriceElement = $('.bss-b2b-wdw-vechta-origin-price[data-product-id="' + productId + '"]');
            if (productPriceElement.length) {
                productPriceElement.html(app.formatMoney(currentItemPrices.price));
                productPriceElement.css('visibility', 'visible');
                productPriceElement.css('text-decoration', 'line-through');
            }
        }
        if ([2492, 2709].indexOf(app.storeId) !== -1) {
            let productPriceElement = $('[bss-b2b-origin-price][bss-b2b-product-id="' + productId + '"]');
            if (productPriceElement.length) {
                productPriceElement.html(app.formatMoney(currentItemPrices.price));
                productPriceElement.css('visibility', 'visible');
                productPriceElement.css('text-decoration', 'line-through');
            }
        }
        if (app.storeId === 1737) {
            let productPriceElement = $('[bss-b2b-unit-1737][bss-b2b-product-id="' + productId + '"]');
            if (productPriceElement.length) {
                productPriceElement.html(app.formatMoney(price / 24));
                productPriceElement.css('visibility', 'visible');
            }
        }
        if (app.storeId === 1548) {
            let taxRateElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-custom-taxrate]');
            if (taxRateElement.length) {
                let taxRate = taxRateElement.attr('bss-b2b-custom-taxrate');
                taxRateElement.html(app.formatMoney(price * taxRate))
            }
        }
        if (app.storeId === 2162) {
            let textElement = $('[bss-b2b-product-id="' + productId + '"][bss-product-text-whosale]');
            if (textElement.length) {
                textElement.html('Wholesale')
            }
        }
    };

    const fixResponseProducts = function (initial, isCart) {
        let productList = [];
        if (app.storeId === 3576) {
            if (!app.page.isCartPage() && !isCart) {
                if (document.getElementById('bss-b2b-cp-custom-products-metafields')) {
                    let productsData = JSON.parse(document.getElementById('bss-b2b-cp-custom-products-metafields').innerText);
                    productList = productList.concat(productsData.collection);
                }
                if (document.getElementById('bss-b2b-cp-custom-product-metafields')) {
                    let productData = JSON.parse(document.getElementById('bss-b2b-cp-custom-product-metafields').innerText);
                    productList.push(productData);
                }
            } else {
                if (document.getElementById('bss-b2b-cp-custom-items-metafields')) {
                    let itemsData = JSON.parse(document.getElementById('bss-b2b-cp-custom-items-metafields').innerText);
                    productList = productList.concat(itemsData.collection);
                }
            }
        }
        if (productList.length === 0) {
            productList = initial;
        }
        return productList;
    };

    const fixQuickView = function (customAttr, shopData, cartFormElem, product) {
        if (app.storeId === 2087 && customAttr && customAttr.includes('.modal.modal--quick-shop.modal--is-active') && cartFormElem) {
            shopData.product = product;
            shopData.quickview = true;
            shopData.storeId = app.storeId;
        }
    };

    const fixTaxChange = function (shopData, product, handleChange) {
        if ([2988, 3794].indexOf(app.storeId) !== -1 && window.location.pathname === '/') {
            shopData.product = product;
            handleChange(shopData.product.variants[0].id, shopData, false);
        }
    };

    const fixEmptyPriceElement = function (customAttr, priceElement, productId, variant) {
        if (typeof $ === 'undefined' && typeof jQuery !== 'undefined') {
            window.$ = jQuery;
        }
        let customSelector = customAttr;
        let fixedPriceElement = priceElement;
        let fixedVariant = variant;
        if (priceElement.length === 0) {
            if ([2693, 2896, 2589, 4094, 4229, 7321, 7795, 9605, 10548].indexOf(app.storeId) === -1) {
                fixedPriceElement = $(
                    customSelector + '[data-sale-price][bss-b2b-product-id="' + productId + '"]'
                );
            } else if (app.storeId === 7321) {
                fixedPriceElement = $(customSelector);
            } else if ([7795, 9605, 10548].includes(app.storeId) && customSelector) {
                fixedPriceElement = $(customSelector + '[bss-b2b-product-id="' + productId + '"]');
            } else {
                if (app.storeId === 2589) {
                    customSelector += ' [bss-b2b-product-id]:last-child';
                }
                fixedPriceElement = $(customSelector);
                if (priceElement.closest('[data-product-variant-id]') && (app.storeId === 2589 || app.storeId === 2896)) {
                    fixedVariant = fixedPriceElement.closest('[data-product-variant-id]').attr('data-product-variant-id');
                }
            }
        }
        return {
            priceElement: fixedPriceElement,
            variant: fixedVariant,
        };
    };

    const fixPriceElementAndUnitPriceElement = function (customAttr, variant, productId, currentVariant, priceElement, unitPriceElement, isQuickView) {
        let newPriceElement = priceElement;
        let newUnitPriceElement = unitPriceElement;
        if (typeof $ === 'undefined' && typeof jQuery !== 'undefined') {
            window.$ = jQuery;
        }
        if (customAttr) {
            if (variant) {
                if (currentVariant.price >= currentVariant.compare_at_price) {
                    if ([181, 1283, 1138, 1289, 2896, 2589, 4229, 3787, 3223, 4927, 9461, 10353].indexOf(app.storeId) !== -1) {
                        // do nothing
                    }
                    // fix nimbus-focal by dongnv
                    else if ([4856, 537, 6171, 6289, 6412, 6366, 6365, 7121, 7332, 9730, 7795, 9605, 8510].indexOf(app.storeId) !== -1) {
                        newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                    } else if (app.storeId === 5273) {
                        newPriceElement = $(
                            '[data-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                        newUnitPriceElement = $(
                            '[bss-b2b-product-parent-price][bss-b2b-product-id="' + productId + '"][data-unit-price]'
                        );
                    } else if (app.storeId === 4423) {
                        newPriceElement = $('.current-price[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
                    } else if (app.storeId === 7355 && isQuickView) {
                        newPriceElement = $('#Product-Drawer-Content .product-price-container .amount[bss-b2b-product-id="' + productId + '"]')
                        newUnitPriceElement = $('[bss-b2b-product-parent-price][bss-b2b-product-id="' + productId + '"][data-unit-price]');
                    } else if (app.storeId === 9959) {
                        newPriceElement = $(
                            '[data-regular-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                        newUnitPriceElement = $(
                            '[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-unit-price]:not(.cart-drawer__items [bss-b2b-product-id="' + productId + '"][bss-b2b-variant-unit-price])'
                        );
                    } else {
                        newPriceElement = $(
                            '[data-regular-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                        newUnitPriceElement = $(
                            '[bss-b2b-product-parent-price][bss-b2b-product-id="' + productId + '"][data-unit-price]'
                        );
                    }

                } else {
                    if ([181, 1283, 1183, 1289, 2589, 3787, 3223, 6171, 4927, 2933, 10353].indexOf(app.storeId) !== -1) {
                        // do nothing
                    } else if ([9730].indexOf(app.storeId) !== -1) {
                        newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                    } else if ([15002].indexOf(app.storeId) !== -1) {
                        newPriceElement = $('[bss-b2b-product-id="' + productId + '"]:not(.productitem--info [bss-b2b-product-id])');
                    } else {
                        newPriceElement = $(
                            '[data-sale-price][bss-b2b-product-id="' + productId + '"]:not(meta),'
                            + '.product__current-price[bss-b2b-product-id="' + productId + '"]:not(meta),'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]:not(meta)'
                        );
                        newUnitPriceElement = $(
                            '[bss-b2b-product-parent-price][bss-b2b-product-id="' + productId + '"][data-unit-price]'
                        );
                    }

                }
                if (([5892, 6128, 2933].indexOf(app.storeId) !== -1 && isQuickView) || ([4927].includes(app.storeId))) {
                    newPriceElement = $(customAttr + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]');
                }
            }
        } else {
            if (variant) {
                if (currentVariant.price >= currentVariant.compare_at_price) {
                    if ([181, 1283, 1138, 1289, 2896, 2589, 4342, 3223, 5273, 6171].indexOf(app.storeId) !== -1) {
                        // do nothing
                    }
                    // fix nimbus-focal by dongnv
                    else if ([4856, 6289, 6412, 6366, 6365].includes(app.storeId)) {
                        newPriceElement = $(
                            '[bss-b2b-product-price][bss-b2b-product-id="' + productId + '"]:not([bss-b2b-variant-price])'
                        );
                    } else if ([4423].includes(app.storeId)) {
                        newPriceElement = $('.current-price[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
                    } else if (app.storeId === 9959) {
                        newPriceElement = $(
                            '[data-regular-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                        newUnitPriceElement = $(
                            '[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-unit-price]:not(.cart-drawer__items [bss-b2b-product-id="' + productId + '"][bss-b2b-variant-unit-price])'
                        );
                    } else {
                        newPriceElement = $(
                            '[data-regular-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                    }

                } else {
                    if ([181, 1138, 2589, 537, 3223, 4856].indexOf(app.storeId) !== -1) {
                        // do nothing
                    } else if ([4856, 6289, 6412, 6366, 6365].includes(app.storeId)) {
                        newPriceElement = $(
                            '[bss-b2b-product-price][bss-b2b-product-id="' + productId + '"]:not([bss-b2b-variant-price])'
                        );
                    } else if ([2254].indexOf(app.storeId) !== -1) {
                        //fix for plankindustry
                        newPriceElement = $(
                            '[data-product-price][bss-b2b-product-price][bss-b2b-product-id="' + productId + '"]'
                        );
                    } else {
                        newPriceElement = $(
                            '[data-sale-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-current-variant-price][bss-b2b-product-id="' + productId + '"],'
                            + '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]'
                        );
                    }
                }
            }
        }

        return {
            priceElement: newPriceElement,
            unitPriceElement: newUnitPriceElement
        }
    };

    const fixPriceElementAndGetVariant = function (customAttr, priceElement, productId, variant, isQuickView) {
        let newPriceElement = priceElement;
        let newVariant = variant;

        // fix deutsche-cannabis-manufaktur by hoaduong
        if (app.storeId === 4618) {
            if (!priceElement.length) {
                newPriceElement = $('[bss-b2b-product-id="' + productId + '"]');
            }
            let variantId = priceElement.closest('.product-main').find('.variant-selection').attr('variant');
            if (variantId) {
                newVariant = variantId;
            }
        }
        // fix rojodistro by dongnv
        else if (app.storeId === 537) {
            newPriceElement = $(customAttr);
            if (customAttr.includes("#price")) {
                let selectOptions = document.querySelector(customAttr).closest(".product-details").querySelector(".product-section select[name=id]");
                if (selectOptions) {
                    newVariant = selectOptions.value;
                }
            }
        }
        else if (app.storeId === 4927) {
            if (app.page.isProductPage() && customAttr.includes("product-main [bss-b2b-custom-unit-price-4927]")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                newVariant = false;
            }
        }

        else if (app.storeId === 10676) {
            if (customAttr.includes("quick-buy-product__info")) {
                newVariant = document.querySelector('.drawer--quick-buy[open] [bss-b2b-variant-id]').getAttribute("bss-b2b-variant-id");
            }
        }

        else if ([5252, 6095, 7207].indexOf(app.storeId) !== -1) {
            if (customAttr.includes("search-bar__item-price")) {
                newVariant = false;
            }
        }
        else if (app.storeId === 6699) {
            if (customAttr.includes("main-search__results")) {
                newVariant = false;
            }
        }
        // fix nimbus-focal by dongnv
        else if ([4856, 6289, 6412, 6366, 6365, 7332].includes(app.storeId)) {
            if (customAttr.includes("bss-b2b-variant-id")) {
                newVariant = document.querySelector(customAttr + '[bss-b2b-product-id]').getAttribute("bss-b2b-variant-id");
            }
            if (customAttr.includes("predictive-search__results")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
            }
        }
        else if (app.storeId === 5880 && isQuickView) {
            newVariant = document.querySelector('quick-add-modal[open] form[action*="/cart/add"] input[name="id"]').value;
        }
        else if (app.storeId === 5892 && isQuickView) {
            if (customAttr.includes("modal-inner .product--outer")) {
                let variantSelector = document.querySelector('.modal .modal-inner .product--outer variant-selection select[name=id]');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        }
        else if (app.storeId === 6128 && isQuickView) {
            let variantSelector = document.querySelector('.quickbuy-container form[action*="/cart/add"] select[name="id"]');
            if (variantSelector) {
                newVariant = variantSelector.value;
            }
        }
        else if (app.storeId === 6171 && isQuickView) {
            if (customAttr.includes("cboxContent")) {
                let variantSelector = document.querySelector('#cboxContent .product-details select[name="id"].original-selector.theme-init');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        }
        else if (app.storeId === 3588 && isQuickView) {
            if (customAttr.includes("modal--quickshop-slim")) {
                let variantSelector = document.querySelector('.modal--quickshop-slim select[name=id]');
                if (variantSelector && variantSelector.value !== 'not-selected') {
                    newVariant = variantSelector.value;
                }
            }
        }
        else if (app.storeId === 2933 && isQuickView) {
            if (customAttr.includes("popup-quick-view")) {
                let variantSelector = document.querySelector('.popup-quick-view select#productSelect');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 6765) {
            newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
            if (customAttr.includes("product-quick-view")) {
                let variantSelector = document.querySelector('#product-quick-view select[name=id].product-id');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            } else if (customAttr.includes("bss-b2b-product-parent-price")) {
                let variantSelector = document.querySelector('[data-product-container] select[name=id].product-id');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 6644) {
            if (customAttr.includes("product-sections__block .product__information")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-price]');
                let variantSelector = document.querySelector('.product-sections__block variant-selection select.variant-selection__variants');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            } else if (customAttr.includes("#quickshop.js-quick-shop")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-price]');
                let variantSelector = document.querySelector('#quickshop.js-quick-shop variant-selection select.variant-selection__variants');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            } else if (customAttr.includes("search__results-wrapper")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                newVariant = false;
            }
        } else if (app.storeId === 3820) {
            newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
            if (customAttr.includes("product-quick-view")) {
                let variantSelector = document.querySelector('.product-quick-view #product-actual-select');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 6708) {
            if (customAttr.includes("customize-price-quick-view")) {
                let variantSelector = document.querySelector('#modal_quick_view .input_variant');
                if (variantSelector && variantSelector.value !== 'not-selected') {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 5130) {
            if (customAttr.includes("bss-customize-cp")) {
                let variantSelector = document.querySelector('.bss-customize-cp');
                if (variantSelector && variantSelector.getAttribute('bss-b2b-variant-id')) {
                    newVariant = variantSelector.getAttribute('bss-b2b-variant-id');
                }
                if (isQuickView) {
                    let variantID = document.querySelector(".product-quickview__price #form-simple-addtocart input[data-quickview-variant]").value
                    if (variantID) {
                        newVariant = variantID
                    }
                }
            }
        } else if (app.storeId === 7121) {
            newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
            if (customAttr.includes("product-main .price.product__price")) {
                let variantSelector = document.querySelector('.product-main variant-selection');
                if (variantSelector) {
                    newVariant = variantSelector.attributes.variant.value;
                }
            } else if (customAttr.includes("modal--quickshop-full .price.product__price")) {
                let variantSelector = document.querySelector('.modal--quickshop-full variant-selection');
                if (variantSelector) {
                    newVariant = variantSelector.attributes.variant.value;
                }
            } else if (customAttr.includes("product-recently-viewed--section .product-section--content") || customAttr.includes("search-flydown--results")) {
                newVariant = false;
            }
        } else if (app.storeId === 5284) {
            if (customAttr.includes("customize-price-variant")) {
                let variantSelector = document.querySelector('.product-form input[name="id"]');
                if (variantSelector && variantSelector.value !== 'not-selected') {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 7668) {
            if (customAttr.includes("#product-quick-view .yv-product-price.h1")) {
                let variantSelector = document.querySelector('#product-quick-view form[action="/cart/add"] input[name="id"]');
                if (variantSelector && variantSelector.value !== 'not-selected') {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 571) {
            if (customAttr.includes("#ShopNowContainer #ProductPrice")) {
                let variantSelector = document.querySelector('#ShopNowContainer #productSelect-template--product');
                if (variantSelector && variantSelector.value !== 'not-selected') {
                    newVariant = variantSelector.value;
                }
            }
        } else if (app.storeId === 5302) {
            let variantSelector;
            newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
            if (customAttr === "[bss-b2b-variant-price]") {
                variantSelector = document.querySelector('#main product-payment-terms input[name=id]');
            } else if (customAttr === "quick-buy-drawer[open] [bss-b2b-variant-price]") {
                variantSelector = document.querySelector('quick-buy-drawer[open] [is=product-form] input[name=id]');
            } else if (customAttr === "quick-buy-popover[open] [bss-b2b-variant-price]") {
                variantSelector = document.querySelector('quick-buy-popover[open] [is=product-form] input[name=id]');
            } else if (customAttr.includes("predictive-search-drawer")) {
                variantSelector = false;
                newVariant = false;
            }
            if (variantSelector) {
                newVariant = variantSelector.value;
            }
        } else if (app.storeId === 7321 && isQuickView) {
            newVariant = document.querySelector(customAttr + '[bss-b2b-product-id]').getAttribute("bss-b2b-variant-id");
        } else if (app.storeId === 9173) {
            if (customAttr.includes("predictive-search")) {
                newVariant = false;
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
            }
        } else if (app.storeId === 10353) {
            newPriceElement = $(customAttr + '[bss-b2b-product-id]');
        } else if ([12634, 10788].includes(app.storeId)) {
            newVariant = $(".ecom-product-single-select-id, .product__form_variant_id").val();
            if (BSS_B2B.page.isSearchPage()) {
                const productId = (document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]') &&
                    document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id'))
                    ? +document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id')
                    : "";
                newVariant = $(`.product-details[bss-b2b-product-id="${productId}"] .product__form_variant_id`).val();
            }
        } else if (app.storeId === 12349) {
            if (document.querySelector('quick-add-drawer').hasAttribute('open')) {
                newVariant = document.querySelector('quick-add-drawer .quick-add__content .quick-add-info  .product-price form[action="/cart/add"] input[name="id"]').value
            }
            else if (document.querySelector('.product-info__block form[action="/cart/add"] input[name="id"]')) {
                newVariant = document.querySelector('.product-info__block form[action="/cart/add"] input[name="id"]').value
            }
            else {
                newVariant = window.localStorage.getItem('variantIdOnSearchPage')
            }
        } else if (app.storeId === 14373) {
            if (customAttr.includes(".price.body-2")) {
                newPriceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                let variantSelector = document.querySelector('#CartDrawerForm select.acc-select');
                if (variantSelector) {
                    newVariant = variantSelector.value;
                }
            }
        }

        return {
            priceElement: newPriceElement,
            variant: newVariant
        }
    };

    const fixDefineCartFormAndParent = function (cartForm, parentLevel2) {
        if ([4101, 4999, 2933, 6171, 3223, 8572].includes(app.storeId)) {
            switch (app.storeId) {
                case 4101:
                    cartForm = $('.page-product form[action*="/cart/add"]');
                    parentLevel2 = $(cartForm).parent().parent();
                    break;
                case 4999:
                    cartForm = $('form[action*="/cart/add"]');
                    parentLevel2 = $(cartForm).parent().parent();
                    break;
                case 2933:
                    cartForm = $('.product-template__container form[action*="/cart/add"]');
                    parentLevel2 = $(cartForm).parent().parent();
                    break;
                case 6171:
                    cartForm = $('form[action*="/cart/add"] .option-selectors');
                    parentLevel2 = $(cartForm).parent().parent();
                    break;
                case 3223:
                    cartForm = $(cartForm).parent().parent();
                    parentLevel2 = $(cartForm).parent();
                    break;
                case 8572:
                    cartForm = $(".product-form");
                    parentLevel2 = $(cartForm).parent();
                    break;
            }
        }

        return { cartForm, parentLevel2 };
    }

    // fix change variant on product page (not sure can fix collection page) and on ajax cart
    const fixChangeVariantAndAjaxCart = function (cartForm, parentLevel2, shopData) {
        //fix for thepackunderwear by CuongNVM
        $(cartForm).find(
            '.bcpo-front-button-option,'
            + '.product-single__swatch__input'
            + 'input[type="radio"],'
            + 'div.swatch-element,'
            + '.variant-input-wrap .variant-input,'
            + 'li.azx-swatch span.swatch__value,'
            + '.option-selectors .option-selector .opt-label'
        ).on("click", debounce(function () {
            BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
        }, 100));

        let addToCartElement = $('.Product__Wrapper .Product__InfoWrapper form[action*="/cart/add"]');
        if (addToCartElement) {
            let variantSelector = addToCartElement.closest('.Product__Wrapper').parent().find('.Popover__Value.Heading');
            if (variantSelector) {
                variantSelector.on("click", function () {
                    ($('.bss-b2b-customized-compare-at-price').parent()).css('display', 'none');
                    setTimeout(function () {
                        BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                        ($('.bss-b2b-customized-compare-at-price').parent()).css('display', 'block');
                        if (app.storeId === 6932) {
                            $('button.ProductForm__AddToCart.Button.Button--primary.Button--full').on('click', function () {
                                BSS_B2B.makeChangesAfterClickAjaxCart(1200);
                            });
                        }
                    }, 500)
                });
            }
        }

        //fix ixcor by XuTho/ add event click change varian and add to cart in product page
        $(cartForm).find('li.HorizontalList__Item').on("click", function () {
            BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm.parent());
            setTimeout(function () {
                $('span[data-money-convertible]').hide();
            }, 50);
            setTimeout(function () {
                BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                BSS_B2B.makeChangesAfterClickAjaxCart(2000)
            }, 2000)
        });

        $(cartForm).find('input#addToCart').on("click", function () {
            setTimeout(function () {
                BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                BSS_B2B.makeChangesAfterClickAjaxCart(2200)
            }, 2200)
        });

        //fix voyage-trade by XuTho support Leorio
        $(cartForm).find('a.btn-cart').on("click", function () {
            setTimeout(function () {
                BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                BSS_B2B.makeChangesAfterClickAjaxCart(1200)
            }, 1200)
        });

        //fix croyez-jewelry by vitu
        if (![7619, 11946].includes(BSS_B2B.storeId)) {
            $(cartForm).find('button[name="add"]:not(button.button.button-add-to-cart)').on("click", function () {
                setTimeout(function () {
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm);
                    BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                    BSS_B2B.makeChangesAfterClickAjaxCart(1200)
                }, 1000)
            });
        }
        let ajaxCartDelayTime = 1200;
        let customAjaxCartDelayTime = BSS_B2B.getCssSelector('ajax_cart_time_delay_opening_cart');
        if (customAjaxCartDelayTime !== '' && !isNaN(customAjaxCartDelayTime)) {
            ajaxCartDelayTime = parseInt(customAjaxCartDelayTime)
        }

        $(cartForm).find('[data-cart-submit]').on("click", function () {
            setTimeout(function () {
                $('button.ajax-cart__toggle').on("click", function () {
                    BSS_B2B.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
                })
            }, ajaxCartDelayTime)
        });

        //Fixed for gemtheme
        let variantButtons = $(cartForm).find(".gt_swatches--select");
        if (variantButtons.length) {
            let sectionId = $(cartForm).attr("id").split('_');
            let sectionElement = $('script[data-id="' + sectionId[sectionId.length - 1] + '"]').parent();
            variantButtons = $(sectionElement).find(".gt_swatches--select, .item.gt_product-carousel--item, .gt_product-quantity--minus, .gt_product-quantity--plus");
            $(variantButtons).on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            })
        }

        // Fixed for pure-cosmetica
        variantButtons = $(cartForm).find("input[data-product-option]");
        if (variantButtons.length) {
            $(variantButtons).on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            })
        }

        // fix deutsche-cannabis-manufaktur by DongNV
        if (app.storeId === 4618) {
            $(cartForm).find('.options-selection__option-values').on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            })
        }

        // fix trone-plumbing by Dikans
        if (app.storeId === 6939) {
            cartForm = $(".product-single__meta [data-product-blocks]");
            parentLevel2 = cartForm.parent();
            let parentPriceElement = $(".product-block.product-block--price");
            let productId = "";
            let variantId = "";
            if (parentPriceElement) {
                productId = parseInt($(".product-block.product-block--price").attr("bss-data-product-id"));
                variantId = parseInt($(".product-block.product-block--price").attr("bss-data-variant-id"));
            }
            if (BSS_B2B.page.isProductPage()) {
                BSS_B2B.cp.changeProductPrice(shopData, null, cartForm);
            }
            $(cartForm).find('.variant-input input[type="radio"]').on("click", function () {
                setTimeout(function () {
                    if (parentPriceElement) {
                        let priceElement = $(parentPriceElement).find("[data-product-price].product__price");
                        if (priceElement) {
                            priceElement.attr("bss-b2b-product-id", productId);
                            priceElement.attr("bss-b2b-product-price", "");
                            priceElement.attr("bss-b2b-variant-id", variantId);
                            priceElement.attr("bss-b2b-variant-price", "");
                        }
                        BSS_B2B.cp.changeProductPrice(shopData, null, cartForm);
                    }
                }, 1000);
            });
        }

        if (app.storeId === 7321) {
            cartForm = $(".main-product__block.main-product__block-variant_picker");
            parentLevel2 = cartForm.parent();
            $(cartForm).find('.variant-picker__option input[type="radio"]').on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            })
        }

        if (app.storeId === 7321) {
            cartForm = $(".main-product__block.main-product__block-variant_picker");
            parentLevel2 = cartForm.parent();
            $(cartForm).find('.variant-picker__option input[type="radio"]').on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            })
        }

        if (app.storeId === 4257) {
            $(cartForm).find('.ProductForm__Variants .swatch-view-item').on('click', function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
            });
        }

        window.BSS_B2B.executeAction({ tag: 'change_variant', storeId: 10911, cartForm, parentLevel2 })

        if (app.storeId === 2238) {
            setTimeout(() => {
                cartForm = $(cartForm).closest('.product-form--regular');
                let variantSelector = document.querySelector('.product--container form[action*="/cart/add"] variant-selection')
                if (variantSelector) {
                    variantSelector.addEventListener('change', function () {
                        BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    })
                }
            }, 1500)
        }

        //fix for nui-retail
        if (app.storeId === 4726) {
            $(cartForm).closest('.product__info-container.product__info-container--sticky').find('input[type="radio"]').on("click", function () {
                $(cartForm).closest('.product__info-container.product__info-container--sticky').find('#price-template--14582531129480__main').hide();
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
                setTimeout(function () {
                    $(cartForm).closest('.product__info-container').find('#price-template--14582531129480__main').show()
                }, 1000)
            });
        }

        // fix for boutique-l214 by AnhTV
        if (app.storeId === 6108) {
            $(cartForm).closest('.product__info-container.product__info-container--sticky').find('variant-radios.no-js-hidden').on("change", function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
            });
        }

        // fix for rojodistro by Khanh
        if (app.storeId === 537) {
            $(cartForm).closest('.container.product-container').find('#option-nicotine-strength').on("change", function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
            });
        }

        // fix for smartx.bg by Khanh
        if (app.storeId === 3787) {
            $(cartForm).find('.single-option-selector').on("change", function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
            });
        }

        // fix for thetelecomspot by Khanh
        if (app.storeId === 6095) {
            let productId = parseInt($(".product-form__info-list .product-form__info-content").attr("bss-data-product-id"));
            let variantId = parseInt($(".product-form__info-list .product-form__info-content").attr("bss-data-variant-id"));
            $(cartForm).find('.block-swatch-list .block-swatch__item').on("click", function () {
                let parentSalePriceElement = $(".product-form__info-list .product-form__info-content[bss-data-product-id]");
                parentSalePriceElement.css("display", "none");
                setTimeout(function () {
                    if (parentSalePriceElement) {
                        let priceSaleElement = $(cartForm).find(".product-form__info-content .price");
                        if (priceSaleElement.length) {
                            priceSaleElement.attr("bss-b2b-product-id", productId);
                            priceSaleElement.attr("bss-b2b-product-price", "");
                            priceSaleElement.attr("bss-b2b-variant-id", variantId);
                            priceSaleElement.attr("bss-b2b-variant-price", "");
                        }
                        BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                        BSS_B2B.cp.changeProductPrice(shopData, null, cartForm);
                        parentSalePriceElement.css("display", "block");
                    }
                }, 1000);
            });
        }

        if (app.storeId === 8297) {
            cartForm = '.option-selector[data-selector-type="dropdown"], fieldset.option-selector';
            parentLevel2 = $(cartForm).parent();
            $(cartForm).find('ul.cc-select__listbox').on('click', 'li', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
            });
            $(cartForm).find('.option-selector__btns input').on('change', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 1000);
            });
        }

        // fix for ventesprivees by XuTho
        if (app.storeId === 1792) {
            $(cartForm).closest('.product__info-container').find('.product-form__input input[type="radio"]').on("click", function () {
                $(cartForm).closest('.product__info-container').find('#price-template--14998906011807__main').hide();
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 700);
                setTimeout(function () {
                    $(cartForm).closest('.product__info-container').find('#price-template--14998906011807__main').show();
                }, 1600)
            });
        }

        if (app.storeId === 4999) {
            $(cartForm).find('#product-variants li.swatch-element').on("click", function () {
                $(cartForm).find('.price').hide();
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 700);
                setTimeout(function () {
                    $(cartForm).find('.price').show();
                }, 700);
            });
            $(cartForm).find('.quantity .qty-group input[name="quantity"]').on("change", function () {
                $('[bss-b2b-button-price]').hide();
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                    BSS_B2B.cp.changeProductPrice(shopData, null, cartForm)
                }, 700);
                setTimeout(function () {
                    $('[bss-b2b-button-price]').show();
                }, 1500);
            });
        }

        if (app.storeId === 1123) {
            $(parentLevel2).find('variant-radios fieldset label').on("click", function () {
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
            });
        }
        
        if (app.storeId === 15884) {
            $(parentLevel2).find('.prd-option-list .label-radio').on("click", function () {
              setTimeout(()=>{
                BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)  
              },500)
            });
        }

        // fix for SAB2B-587
        if (app.storeId === 1868) {
            $('input.single-option-selector[type="radio"]').on('click', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
                }, 200)
            })
        }

        // fix for justingempages by Leorio
        if (app.storeId === 1031) {
            $('.gf_swatch').on('click', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
                }, 200)
            })
        }

        // fix for business by XuTho
        if (app.storeId === 1587) {
            $('.product-variant__label').on('click', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
                }, 500)
            })
        }

        // fix for artchibald-me by DangNM
        // fix for ciaobrow by DangNM
        if ([3512, 2896, 2589].indexOf(app.storeId) !== -1) {
            $('.product-options__value').on('click', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                }, 500)
            })
        }

        if (app.storeId === 4101) {
            let optionSelectorCheck = setInterval(function () {
                let optionSelector = document.querySelector('select.single-option-selector[data-option]');
                if (optionSelector) {
                    clearInterval(optionSelectorCheck);
                    $('select.single-option-selector[data-option]').on('change', function () {
                        setTimeout(function () {
                            BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm)
                        }, 500);
                    });
                }
            }, 500);
        }

        if (app.storeId === 8927) {
            $('.swatch__list_pr .swatch_pr_item').on('click', function () {
                setTimeout(function () {
                    BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                }, 500);
            });
        }

        // fix for bitsnbob by DucDN
        window.BSS_B2B.executeAction({ tag: 'price_product_page', storeId: 13655, BSS_B2B, parentLevel2, cartForm })
        window.BSS_B2B.executeAction({ tag: 'change_variant_product_page', storeId: 11968, cartForm })
    };

    const fixCartItem = function (item, modifiedItemPrice, modifiedLineItemPrice, isAjaxCart) {
        let isChanged = {
            itemPrice: false,
            lineItemPrice: false
        }
        let originalPrice = item.original_price;
        let originalLinePrice = item.original_line_price;

        if (app.storeId === 664) {
            let itemPriceElement = $('.bss-b2b-wdw-vechta-origin-price[data-product-key="' + item.key + '"]');
            if (itemPriceElement.length) {
                itemPriceElement.html(app.formatMoney(originalPrice));
                itemPriceElement.css('visibility', 'visible');
                itemPriceElement.css('text-decoration', 'line-through');
            }
            isChanged.itemPrice = true;
        } else if (app.storeId === 826) {
            let itemPriceElement = $('.bss-b2b-custom-cart[data-item-key="' + item.key + '"]');
            if (itemPriceElement.length) {
                itemPriceElement.html(app.formatMoney(originalPrice));
                $('.CartItem__Price').addClass("bss-custom-price-color")
                isChanged.itemPrice = true;
            }
        } else if (app.storeId === 918) {
            let itemPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
            let itemFinalPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]');
            if (itemFinalPriceElement && itemPriceElement) {
                itemPriceElement.css('display', 'none');
                itemFinalPriceElement.css('display', 'none');
                document.addEventListener('bss_b2b_doneCheckCp', function () {
                    itemPriceElement.html(app.formatMoney(modifiedItemPrice));
                    itemFinalPriceElement.html(app.formatMoney(modifiedLineItemPrice));
                    itemPriceElement.css('display', 'inline-block');
                    itemFinalPriceElement.css('display', 'block');
                })
            }
            isChanged.itemPrice = true;
            isChanged.lineItemPrice = true;
        } else if (app.storeId === 1283) {
            setTimeout(() => {
                let itemPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                itemPriceElement.html(app.formatMoney(modifiedItemPrice));
            }, 1000);
            $('.product-price[id="' + item.variant_id + '"]').html(app.formatMoney(modifiedItemPrice));
            isChanged.itemPrice = true;
        } else if (app.storeId === 1358) {
            $('.bss-b2b-item-origin-price-1358[bss-b2b-cart-item-key="' + item.key + '"]').html(app.formatMoney(originalPrice));
            $('.bss-b2b-item-final-line-price-1358[bss-b2b-cart-item-key="' + item.key + '"]').html(app.formatMoney(originalLinePrice));
            isChanged.itemPrice = true;
            isChanged.lineItemPrice = true;
        } else if (app.storeId === 1548) {
            let itemOriginalPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price][bss-b2b-custom-taxrate]');
            let lineItemFinalPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price][bss-b2b-custom-taxrate]');

            if (itemOriginalPriceElement.length) {
                let taxRate = itemOriginalPriceElement.attr('bss-b2b-custom-taxrate');
                itemOriginalPriceElement.html(app.formatMoney(modifiedItemPrice * taxRate))
            }
            if (lineItemFinalPriceElement.length) {
                let taxRate = lineItemFinalPriceElement.attr('bss-b2b-custom-taxrate');
                lineItemFinalPriceElement.html(app.formatMoney(modifiedLineItemPrice * taxRate))
            }
            isChanged.itemPrice = true;
            isChanged.lineItemPrice = true;
        } else if (app.storeId === 1778) {
            $('[bss-b2b-cart-item-key] .cart__item-price').css('visibility', 'visible');
        } else if (app.storeId === 1792) {
            let itemPriceElement = $('[data-cart-item-key="' + item.key + '"][bss-b2b-item-compare-price]');
            itemPriceElement.css("visibility", "visible");
        } else if ([2492, 2709].indexOf(app.storeId) !== -1) {
            let itemPriceElement = $('[bss-b2b-cart-item-origin-price][bss-b2b-cart-item-key="' + item.key + '"]');
            if (itemPriceElement.length) {
                itemPriceElement.html(app.formatMoney(originalPrice));
                itemPriceElement.css('visibility', 'visible');
                itemPriceElement.css('text-decoration', 'line-through');
                isChanged.itemPrice = true;
            }
        } else if (app.storeId === 2595) {
            let itemPriceElement = $('[data-cart-item-key="' + item.key + '"]');
            itemPriceElement.find('.cart__price').find('[data-cart-item-regular-price]').html(app.formatMoney(modifiedItemPrice));
            itemPriceElement.find('.cart__final-price').find('[data-cart-item-regular-price]').html(app.formatMoney(modifiedLineItemPrice));
            isChanged.itemPrice = true;
            isChanged.lineItemPrice = true;
        } else if ([3633, 3643, 3795, 4229, 4325].indexOf(app.storeId) !== -1 && isAjaxCart) {
            let itemPriceElement = $(".mini-products-list #cart-item-" + item.variant_id + " .price");
            itemPriceElement.html(app.formatMoney(modifiedItemPrice));
            isChanged.isChangePriced = true;
        } else if (app.storeId === 3787) {
            let itemPriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"]');
            itemPriceElement.addClass("bss-custom-price-color");
        }
        // fix for massmarcas by khanh
        else if (app.storeId === 5249) {
            let itemPriceElement = $('[bss-b2b-item-original-price][bss-b2b-cart-item-key="' + item.key + '"]');
            if (itemPriceElement.length) {
                itemPriceElement.addClass("bss-b2b-custom-item-element");
            }
        } else if (app.storeId === 3740) {
            let itemPriceElement = $('[bss-b2b-item-original-price][bss-b2b-cart-item-key="' + item.key + '"]');
            let finalLinePriceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]');
            if (itemPriceElement.length) {
                let comparePrice = itemPriceElement.closest('.cart-item__price').find('del');
                if (comparePrice) {
                    comparePrice.remove();
                }
            }
            if (finalLinePriceElement.length) {
                let comparePrice = finalLinePriceElement.closest('.cart-item__total, .cart-item__price').find('del');
                if (comparePrice) {
                    comparePrice.remove();
                }
            }
        }
        return isChanged;
    };

    const fixCartSubtotal = function (cartData, modifiedSubtotalPrice) {
        let isChangedPrice = false;
        let itemsSubtotalPrice = cartData.items_subtotal_price;
        if (app.storeId === 1358) {
            let cartSubtotalPrice = cartData.original_total_price;
            if (cartSubtotalPrice !== modifiedSubtotalPrice) {
                let cartSubtotalPriceElement = $('[bss-b2b-custom-cart-total-price-1358]');
                cartSubtotalPriceElement.html(app.formatMoney(cartSubtotalPrice));
                cartSubtotalPriceElement.css("visibility", "visible");
                isChangedPrice = true;
            }
        } else if (app.storeId == 1548) {
            let cartSubtotalPriceElement = $('.saso-cart-original-total');
            let priceElement = document.querySelectorAll('.tdf-cart-item-lp-p');
            let totalCartPrice = 0;
            priceElement.forEach(function (element) {
                let price = $(element).html().substring(1).replace(',', '');
                totalCartPrice += parseInt(price);
            });
            cartSubtotalPriceElement.html(app.formatMoney(totalCartPrice * 100));
            isChangedPrice = true;
        } else if (app.storeId === 2492) {
            let cartSubtotalPriceElement = $('[bss-b2b-cart-origin-total-price]');
            cartSubtotalPriceElement.html(app.formatMoney(itemsSubtotalPrice));
            isChangedPrice = true;
            if (app.cart.cpPricingList.length > 0) {
                cartSubtotalPriceElement.css("visibility", "visible");
                cartSubtotalPriceElement.css('text-decoration', 'line-through');
            }
        } else if (app.storeId === 2595) {
            $('[data-cart-subtotal]').html(app.formatMoney(modifiedSubtotalPrice));
            isChangedPrice = true;
        } else if (app.storeId === 3633) {
            let cartSubtotalPriceElement = $('.total .price');
            cartSubtotalPriceElement.html("");
            cartSubtotalPriceElement.append("<span bss-b2b-cart-total-price></span>");
        } else if (app.storeId === 3795) {
            let priceChangeInterval = setInterval(function () {
                $('[bss-b2b-cart-total-price]').html(app.formatMoney(modifiedSubtotalPrice));
            }, 400);
            isChangedPrice = true;
            setTimeout(function () {
                clearInterval(priceChangeInterval);
            }, 2000)
        } else if ([10829, 14373].includes(app.storeId)) {
            let priceSubtotalWithBxBy = modifiedSubtotalPrice - cartData.total_discount;
            let priceSubtotalElement = $('[bss-cart-subtotal-custom]');
            priceSubtotalElement.html(app.formatMoney(priceSubtotalWithBxBy));
        }
        return isChangedPrice;
    };

    const fixCartQuantityOnChange = function (inputQtyElement, buttonQtyElement, timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad) {
        let timeDelayForStore = 0;
        //fix nationalmurphybeds by DongNV
        if (app.storeId === 4651) {
            timeDelayForStore = 1500;
        }
        if ([4999, 5284, 3698, 7323, 6579, 15270].indexOf(app.storeId) !== 0) {
            timeDelayForStore = 1000;
        }
        if (app.storeId === 8553) {
            timeDelayForStore = 0;
        }
        //fix deutsche-cannabis-manufaktur by DongNV
        if ([3903, 3633, 3795, 4618, 4325, 5273, 4346, 3588, 5273, 6171, 2238, 5892, 7121, 6457, 8927, 5077, 7848].indexOf(app.storeId) === -1) {
            inputQtyElement.off();
            inputQtyElement.on("change", function () {
                setTimeout(function () {
                    app.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                }, timeDelayForStore)
            });
        }

        //Question: side effect when enable off()
        if ([1138, 4101, 3628, 4999, 6147].indexOf(app.storeId) === -1) {
            buttonQtyElement.off();
        }

        // fix for preprod-la-boutique-du-pilote by mitri
        if ([4017, 6171, 6147, 8927, 5077, 9424, 9762].indexOf(app.storeId) === -1) {
            buttonQtyElement.on("click", function () {
                if ([1138, 13120].indexOf(app.storeId) !== -1) {
                    let finalPriceElement = $('[bss-b2b-final-line-price]');
                    finalPriceElement.css("visibility", "hidden");
                    finalPriceElement.css("display", "none");
                    let cartTotalPriceElement = $('[bss-b2b-cart-total-price]');
                    cartTotalPriceElement.css("visibility", "hidden");
                    cartTotalPriceElement.css("display", "none");
                }
                if (app.storeId === 2157) {
                    timeDelayToReCalculate = 2500;
                }
                if (BSS_B2B.isDisableCP) {
                    $("[data-cart-subtotal]").css("visibility", "visible")
                    return;
                }
                setTimeout(function () {
                    app.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad)
                }, timeDelayForStore)
            })
        }

        // fix estetikashop-calicantus by DongNV
        if ([6171].indexOf(app.storeId) !== -1) {
            let inputQtyElement = $(app.cart.inputQuantityElement);
            if (inputQtyElement.length) {
                inputQtyElement.on("change", function () {
                    setTimeout(function () {
                        app.cart.cartQtyOnChange(2000, 2000, isFirstLoad);
                    }, timeDelayForStore)
                });
            }
        }
    };

    const fixCartQuantity = function (inputQtyElement, buttonQtyElement, shopData, timeDelayToChangeQuantity) {
        // fix for winecollectiveplus by ThaBi
        // fix for ciaobrow by ThaBi
        if ([2492, 2896, 2989, 4257, 4324, 4370, 4649, 5908, 4653, 9177, 15872].indexOf(app.storeId) !== -1) {
            inputQtyElement.off();
            inputQtyElement.on("change", function () {
                $('[bss-b2b-cart-total-price]').css("visibility", "hidden");
                setTimeout(function () {
                    app.cart.fixer(shopData, false, true);
                }, timeDelayToChangeQuantity)
            });

            buttonQtyElement.on("click", function () {
                $('[bss-b2b-cart-total-price]').css("visibility", "hidden");
                setTimeout(function () {
                    app.cart.fixer(shopData, false, true);
                    if( app.storeId === 15872 ){
                        window.BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }
                }, timeDelayToChangeQuantity)
            })
        } else if ([3588, 5273, 4346].indexOf(app.storeId) !== -1) {
            // fix for woodenplayroom
            if ([3588, 5273].indexOf(app.storeId) === -1) {
                inputQtyElement.on("change", function () {
                    $('[bss-b2b-cart-total-price]').css("visibility", "hidden");
                    setTimeout(function () {
                        app.cart.fixer(shopData, false, true);
                    }, timeDelayToChangeQuantity)
                });

                buttonQtyElement.on("click", function () {
                    $('[bss-b2b-cart-total-price]').css("visibility", "hidden");
                    setTimeout(function () {
                        app.cart.fixer(shopData, false, true);
                    }, timeDelayToChangeQuantity)
                });
            }
        }

        // fix for ciaobrow by DangNM
        if (app.storeId === 2896) {
            inputQtyElement.off();
            inputQtyElement.on("change custom.change keyup", function () {
                $('[bss-b2b-cart-total-price]').css("visibility", "hidden");
                setTimeout(function () {
                    app.cart.fixer(shopData, false, true);
                }, 3500);
            });
        }
    };

    const fixShowPriceWhenUseCPAfterSorting = function (shopData) {
        let sortProductPicker = $('.value-picker__choice-item.link');
        if (sortProductPicker.length > 0) {
            sortProductPicker.click(function () {
                setTimeout(function () {
                    app.fix.cp.fixShowPriceWhenUseCPAfterSorting(shopData);
                    app.cp.changeProductPrice(shopData, false, false);
                }, 2000);
            });
        }
    };

    function fixShowPriceSearchProduct(shopData, tax, taxDisplayRules, isTDApplied) {
        //Fix search bar with mutation by donglt
        let searchResultSelector = '.bss-b2b-search-bar';
        let customAttribute = false;
        let options = { childList: true, subtree: true };
        if ([4337, 16352].includes(app.storeId)) {
            searchResultSelector = ".js-search-results"
        } else if ([9364, 9156].includes(app.storeId)) {
            searchResultSelector = '.search__results-wrapper';
        } else if (app.storeId === 9722) {
            searchResultSelector = '.Search__Results';
        } else if (app.storeId === 8297) {
            searchResultSelector = '.header-search__results-wrapper';
        } else if (app.storeId === 9745) {
            searchResultSelector = '.shopify-search-results';
        } else if (app.storeId === 9832) {
            searchResultSelector = '.result_prod.js_productSearchResults';
        } else if (app.storeId === 9738) {
            searchResultSelector = '.search-bar__results-inner'
        } else if ([9451, 6793].includes(app.storeId)) {
            searchResultSelector = '#site-search-sidebar #search-results'
        } else if (app.storeId === 9177) {
            searchResultSelector = '.search-results-panel';
        } else if ([6719, 7995].includes(app.storeId)) {
            searchResultSelector = '#search #livesearch'
        } else if (app.storeId === 9534) {
            searchResultSelector = '#ui-id-1'
        } else if (app.storeId === 9730) {
            searchResultSelector = '.search-bar__inner .search-bar__results .search-bar__results-inner';
            customAttribute = '.search-bar__item-price';
            options = { childList: true };
        } else if ([10128, 9954, 12886, 13573, 13790].includes(app.storeId)) {
            searchResultSelector = '.predictive-search__content-wrapper';
        } else if (app.storeId === 7795) {
            searchResultSelector = '.halo-popup-wrapper .header__search-full .quickSearchResultsWrap';
            customAttribute = '#predictive-search-results .bss-b2b-custom-price ';
            options = { childList: true };
        } else if (app.storeId === 9629) {
            searchResultSelector = '.search-flydown--results';
        } else if (app.storeId === 9461) {
            searchResultSelector = '.search.search-modal__form + .predictive-search.predictive-search--header';
        } else if (app.storeId === 8510) {
            searchResultSelector = 'search-form #search-results.predictive-search';
            customAttribute = '.sidebar__search-results .search-item .caption .item-price '
            options = { childList: true };
        } else if (app.storeId === 10370) {
            searchResultSelector = 'search-drawer predictive-search';
        } else if (app.storeId === 9715) {
            searchResultSelector = '#Collection .grid--view-items';
        } else if (app.storeId === 10539) {
            searchResultSelector = 'predictive-search #predictive-search';
        } else if (app.storeId === 10172) {
            searchResultSelector = 'predictive-search-drawer .predictive-search__results';
            options = { childList: true };
        } else if (app.storeId === 10204) {
            searchResultSelector = 'main-search .field';
        } else if (app.storeId === 10676) {
            searchResultSelector = '.predictive-search__results';
        } else if ([10348, 16119].includes(app.storeId)) {
            searchResultSelector = '#searchPopup';
        } else if (app.storeId === 10829) {
            searchResultSelector = '.header__desktop .predictive-search';
        } else if (app.storeId === 10911) {
            searchResultSelector = '#shopify-section-top-bar .search-form.search-box-fixed .result-container';
        } else if ([11128, 14101].includes(app.storeId)) {
            searchResultSelector = '.quick-search__container';
        } else if ([8418, 10548].includes(app.storeId)) {
            searchResultSelector = '.search-modal__content'; // Drawn theme
        } else if ([11271, 12292].includes(app.storeId)) {
            searchResultSelector = '.predictive-results';
        } else if (app.storeId === 11339) {
            searchResultSelector = '.v-stack .predictive-search';
        } else if ([2896, 12966].includes(app.storeId)) {
            searchResultSelector = '.search__content .search__result';
        } else if ([6809, 11164, 994].indexOf(app.storeId) !== -1) {
            searchResultSelector = '.search_details';
        } else if ([11501, 14915].includes(app.storeId)) {
            searchResultSelector = '.search-bar__inner';
        } else if (app.storeId === 11520) {
            searchResultSelector = '#predictive-search-product-container';
        } else if ([11378, 14255, 16067].includes(app.storeId)) {
            searchResultSelector = '.search-flydown';
        } else if (app.storeId === 11643) {
            searchResultSelector = 'search-form';
        } else if (app.storeId === 11757) {
            searchResultSelector = '.search-bar__results';
        } else if (app.storeId === 11184) {
            searchResultSelector = '.Search__Results';
        } else if ([11782, 14132].includes(app.storeId)) {
            searchResultSelector = '.main-search__results';
        } else if (app.storeId === 10969) {
            searchResultSelector = '.header__desktop .predictive-search';
        } else if (app.storeId === 10623) {
            searchResultSelector = "#predictive-search-list";
        } else if (app.storeId === 11985) {
            searchResultSelector = `.header__search predictive-search`;
        } else if ([11878, 1056].includes(app.storeId)) {
            searchResultSelector = ".search__results";
        } else if (app.storeId === 10353) {
            searchResultSelector = "form.search.search-modal__form";
        } else if (app.storeId === 12498) {
            searchResultSelector = ".search-modal__content .search-modal__form";
        } else if ([11776, 9568, 13634, 14213, 14445].includes(app.storeId)) {
            searchResultSelector = ".predictive-search";
        } else if ([12514, 12570].includes(app.storeId)) {
            searchResultSelector = ".predictive-search__content-wrapper";
        } else if (app.storeId === 12579) {
            searchResultSelector = ".search-header";
        } else if ([11460, 13449, 13814].includes(app.storeId)) {
            searchResultSelector = "#search-drawer";
        } else if ([8250, 13093].includes(app.storeId)) {
            searchResultSelector = ".search-bar__results-inner";
        } else if ([11477, 9596, 10029, 14675, 15469, 15658, 15915, 11975].includes(app.storeId)) {
            searchResultSelector = "predictive-search";
        } else if (app.storeId === 10989) {
            searchResultSelector = "#Search .Search__Inner";
        } else if (app.storeId === 13069) {
            searchResultSelector = "div.right-drawer-vue";
        } else if (app.storeId === 10334) {
            searchResultSelector = ".t4s-frm-search__content";
        } else if (app.storeId === 11081) {
            searchResultSelector = "search-form";
        } else if ([13433, 14593].includes(app.storeId)) {
            searchResultSelector = 'predictive-search';
        } else if (app.storeId === 13552) {
            searchResultSelector = '.header__search-bar-wrapper'
        } else if (app.storeId === 13092) {
            searchResultSelector = '.header__search__wrapper'
        } else if (app.storeId === 13677) {
            searchResultSelector = '.search-popdown.search__predictive'
        } else if (app.storeId === 11517) {
            searchResultSelector = '.toolbar-links'
        } else if (app.storeId === 12641) {
            searchResultSelector = '.header__icons predictive-search .predictive-search';
        } else if (app.storeId === 13655) {
            searchResultSelector = '.header__search.search';
        } else if (app.storeId === 12700) {
            searchResultSelector = '.search-form__results-container';
        } else if (app.storeId === 13871) {
            searchResultSelector = '.search_details';
        } else if (app.storeId === 5986) {
            searchResultSelector = '.header__search-full .predictive-search';
        } else if (app.storeId === 13943) {
            searchResultSelector = '.header__search__results';
        } else if (app.storeId === 13817) {
            searchResultSelector = '.side-panel.search-drawer';
        } else if (app.storeId === 4798) {
            searchResultSelector = '.site-header-main-content .search-flydown';
        } else if (app.storeId === 13435) {
            searchResultSelector = "#site-search-sidebar"
        } else if (app.storeId === 12733) {
            searchResultSelector = ".header__search predictive-search";
        } else if (app.storeId === 12303) {
            searchResultSelector = ".predictive-search.predictive-search--header";
        } else if ([14064, 15002].includes(app.storeId)) {
            searchResultSelector = ".search-flydown";
        } else if (app.storeId === 14317) {
            searchResultSelector = "predictive-search-drawer .drawer__content";
        } else if (app.storeId === 14378) {
            searchResultSelector = "#header-predictive-search";
        } else if (app.storeId === 13344) {
            searchResultSelector = ".predictive-search.predictive-search--header.quickSearchResultsWrap";
        } else if (app.storeId === 14703) {
            searchResultSelector = "#main-search";
        } else if (app.storeId === 14874) {
            searchResultSelector = ".m-search-popup[data-search-popup]";
        } else if (app.storeId === 11857) {
            searchResultSelector = ".predictive-search"
        } else if (app.storeId === 14962) {
            searchResultSelector = ".predictive-search__content"
        } else if (app.storeId === 13774) {
            searchResultSelector = "#search"
        } else if (app.storeId === 14993) {
            searchResultSelector = ".search-results"
        } else if (app.storeId === 11612) {
            searchResultSelector = "#searchResultSelector"
        } else if (app.storeId === 15278) {
            searchResultSelector = "predictive-search.search-modal__form1"
        } else if (app.storeId === 15077) {
            searchResultSelector = "predictive-search"
        } else if (app.storeId === 15285) {
            searchResultSelector = "#search-popdown"
        } else if (app.storeId === 10402) {
            searchResultSelector = ".search-extended"
        } else if (app.storeId === 11481) {
            searchResultSelector = ".js-predictive-search-results"
        } else if (app.storeId === 9874) {
            searchResultSelector = "search-drawer"
        } else if (app.storeId === 1347) {
            searchResultSelector = ".search-bar__inner"
        } else if (app.storeId === 11576) {
            searchResultSelector = "#search"
        } else if (app.storeId === 15563) {
            searchResultSelector = ".predictive-search-wrapper"
        } else if (app.storeId === 15872) {
            searchResultSelector = ".predictive-search__list"
        } else if (app.storeId === 14081) {
            searchResultSelector = "#predictiveSearchResults"
        }else if (app.storeId === 8412) {
            searchResultSelector = ".search-flydown--product-items"
        } else if (app.storeId === 15968) {
            searchResultSelector = ".search-modal .page-width .search-modal__inner predictive-search"
        } else if (app.storeId === 16064) {
            searchResultSelector = "predictive-search.predictive-search"
        } else if (app.storeId === 15965) {
            searchResultSelector = ".header__desktop predictive-search"
        } else if (app.storeId === 16244) {
            searchResultSelector = ".header-search__content"
        }
        let searchResultElem = null;

        if (searchResultSelector !== '') {
            searchResultElem = document.querySelector(searchResultSelector)
            if ([13634, 13943].includes(app.storeId)) {
                searchResultElem = document.querySelectorAll(searchResultSelector)[1];
            }
            if([15658].includes(app.storeId)){
                searchResultElem = document.querySelectorAll(searchResultSelector)
            }
        }
        if (searchResultElem) {
            const observer = new MutationObserver(() => {
                if (app.storeId === 13433) {
                    let dataSearchItem = document.querySelectorAll("[data-search-item]");
                    dataSearchItem.forEach(item => {
                        let pID = item.querySelector("a[data-product-id]")
                        if (pID) {
                            pID = pID.getAttribute("data-product-id");
                            let priceEle = item.querySelector(".sf-currency");
                            priceEle.setAttribute("bss-b2b-product-id", pID);
                            priceEle.setAttribute("bss-b2b-product-price", "true");
                        }
                    })
                }
                if(app.storeId === 11576){
                    setTimeout(() => {
                       app.cp.changeProductPrice(shopData, customAttribute, false);
                    }, 500)
                } else{
                    app.cp.changeProductPrice(shopData, customAttribute, false);
                }
                if (app.storeId === 10172 && isTDApplied) {
                    const appliedRule = taxDisplayRules.getAppliedRuleCollectionPage(BSS_B2B, shopData);
                    tax.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedRule);
                }
            });
            if([15658].includes(app.storeId)){
                searchResultElem.forEach(elm => {
                  observer.observe(elm, options);
                  
                })
            } else{
                observer.observe(searchResultElem, options);
            }
        }
    }

    function debounce(functionRun, delayTime) {
        let functionTimeout;

        return function () {
            // Receive arguments
            const args = arguments;
            const context = this;

            if (functionTimeout) clearTimeout(functionTimeout);

            functionTimeout = setTimeout(() => {
                functionRun.apply(context, args);
            }, delayTime)
        }
    }


    app.fix.cp = {
        fixShowPrice,
        fixResponseProducts,
        fixQuickView,
        fixTaxChange,
        fixEmptyPriceElement,
        fixPriceElementAndUnitPriceElement,
        fixPriceElementAndGetVariant,
        fixDefineCartFormAndParent,
        fixChangeVariantAndAjaxCart,
        fixCartItem,
        fixCartSubtotal,
        fixCartQuantityOnChange,
        fixCartQuantity,
        fixShowPriceWhenUseCPAfterSorting,
        fixShowPriceSearchProduct
    };
}

/* harmony default export */ var cp = (fixModules);

// CONCATENATED MODULE: ./js/src/internal/fix/checkout.js
function checkout_fixModules(app) {
    const fixHandleCartCheckoutBtn = (shopData, checkoutButton) => {
        // fix for storeID 4576
        window.BSS_B2B.executeAction({tag: 'customize_validate_te', storeId: 4576, shopData})

        if (BSS_B2B.storeId === 2709) {
            // fix wilberrys by vitu
            $(this).off();
        }
        if (BSS_B2B.storeId === 3787) {
            if (shopData.customer.id == null) {
                return;
            }
        }

        if (BSS_B2B.storeId === 6767) {
            $(this).off();
            let checkOutPopupButton = document.querySelector('.popup_cart .cart-popup-action .btn.btn-danger');
            if (checkOutPopupButton) {
                checkOutPopupButton.removeAttribute('onclick');
            }
        }
        // fix for storeID 4324
        window.BSS_B2B.executeAction({tag: 'customize_validate_te', storeId: 4324, checkoutButton, shopData})
        if (BSS_B2B.storeId === 4945) {
            $(document).on('submit', 'form.js-cart-form', function () {
                return false;
            });
        }
        if (BSS_B2B.storeId === 7056) {
            checkoutButton.css({
                'pointer-events': 'auto',
                'opacity': '1'
            })
            checkoutButton.removeAttr('disabled')
        }
        if ([7795, 7259].includes(BSS_B2B.storeId)) {
            checkoutButton.addClass("bss-checkout-event");
        }

        if ([9568, 10085, 9461, 7259, 13344].includes(BSS_B2B.storeId)) {
            if (checkoutButton && jQuery && checkoutButton instanceof jQuery) {
                checkoutButton.off();
                checkoutButton.removeAttr('onclick');
            }
        }
        if ([13344].includes(BSS_B2B.storeId)) {
            checkoutButton.attr("bss-b2b-custom-checkout-btn", "")
        }
        //fix ichi store by trung dd
        if (BSS_B2B.storeId === 11149) {
            setTimeout(() => {
                checkoutButton.removeClass("bss-b2b-custom-checkout-disable");
            }, 1000)
        }

        if(BSS_B2B.storeId === 10989){
            if (checkoutButton && jQuery && checkoutButton instanceof jQuery && BSS_B2B.cpSettings) {
                checkoutButton.removeAttr('name');
            }
        }
        if(BSS_B2B.storeId === 11378) {
            setTimeout(() =>{
                const isAddedEvent = checkoutButton.attr(`bss-b2b-added-event`);
                if(!isAddedEvent) {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                }
                let buttonCheckouts = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
                buttonCheckouts.forEach((buttonCheckoutElem) => {
                    buttonCheckoutElem.setAttribute('bss-b2b-added-event', 'true');
                    buttonCheckoutElem.style.display = 'inline-block';
                });
            }, 2000);
        }
    }

    app.fix.checkout = {
        fixHandleCartCheckoutBtn
    };
}

/* harmony default export */ var checkout = (checkout_fixModules);
// CONCATENATED MODULE: ./js/src/internal/fix/handleAjaxCart.js
function fixAjaxCart(app) {

    //This function will re-run some function to fix some error that may caused by re-render from customer's theme
    const fixCustomEvent = function (shopData, ajaxCartDelayTime, ajaxCartElement, taxDisplayRules, ajaxAddCartElement4696) {
        //fix for sextoysupplycn by DongNV
        if (app.storeId === 4696 || app.storeId === 4661) {
            if (ajaxAddCartElement4696.length) {
                ajaxAddCartElement4696.on("click", function () {
                    setTimeout(function () {
                        app.cart.fixer(shopData, false, false);
                    }, ajaxCartDelayTime)
                });
            }
        }
        // fix for boutique3.l214 by AnhTV
        if (app.storeId === 6108) {
            $('.quick-view__summary').on("click", function () {
                setTimeout(function () {
                    $('.product__info-container .product-form__input.variant-input-wrapper label').on("click", function () {
                        setTimeout(function () {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1000);
                    });
                    $('.product-form .form .product-form__buttons .product-form__submit').on("click", function () {
                        setTimeout(function () {
                            app.cart.fixer(shopData, false, false);
                            app.handleQuantityChangeAjaxCart(true);
                        }, 2000);
                    });
                }, 2000);
            });
        }
        if (app.storeId === 1629) {
            //fix cra-wellness by vitu
            ajaxCartElement.on("hover", function () {
                app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
            });
        }

        if (app.storeId === 5574) {
            ajaxCartElement.on('mouseenter', function () {
                app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
            });
        }

        //fix for preprod-la-boutique-du-pilote by mitri
        if ([4017].indexOf(app.storeId) !== -1) {
            app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
        }

        // fix for provisionswholesale by mitri
        if ([3628, 6456, 9673, 10435].indexOf(app.storeId) !== -1) {
            $(app.cart.buttonChangeQuantity).on("click", function () {
                app.cart.fixer(shopData, false, false);
                app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
            })
        }

        if ([1609, 1788, 3351, 4337, 4334].indexOf(app.storeId) !== -1) {
            ajaxCartElement.on('mouseover', function () {
                app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
            })
        }

        // if (app.storeId === 7321) {
        //     let appliedTaxDisplayRule = taxDisplayRules.getAppliedRuleCartPage(app, shopData);
        //     let isTDApplied = appliedTaxDisplayRule ? true : false;
        //     document.addEventListener("bss.b2b.cart.doneClickCart", function () {
        //         setTimeout(app.customize.cp.fixTaxDisplayAndCP(isTDApplied), 2000);
        //     });
        // }

        if (app.storeId === 10435) {
            ajaxCartElement.on('click', function () {
                app.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
            })
        }
    }

    app.fix.ajaxCart = {
        fixCustomEvent,
    };
}

/* harmony default export */ var handleAjaxCart = (fixAjaxCart);
// EXTERNAL MODULE: ./js/src/taxexem/tax.js
var tax = __webpack_require__(1);
var tax_default = /*#__PURE__*/__webpack_require__.n(tax);

// EXTERNAL MODULE: ./js/src/taxexem/taxDisplayRules.js
var taxDisplayRules = __webpack_require__(2);
var taxDisplayRules_default = /*#__PURE__*/__webpack_require__.n(taxDisplayRules);

// EXTERNAL MODULE: ./js/src/cp/quickview.js + 1 modules
var quickview = __webpack_require__(3);

// CONCATENATED MODULE: ./js/src/internal/fix/index.js







const fix_Tax = __webpack_require__(1);

const initHandleChangeQuantity = function(app) {
    return function() {
        if (app.page.isProductPage()) {
            // fix for repairpartners,elizawilliam by Leorio, CuongNVM
            if ([1283, 3633].indexOf(app.storeId) !== -1) {
                let qtyButtonChange = $('.inc.button,' + '.dec.button,' +
                    '.quantity .qty-group input[type="number"]');
                const changeQuantity = () => {
                    let priceElement = $(
                        '.product_single_price .product_price[bss-b2b-product-id],' +
                        '.prices .price, .prices .price on-sale');
                    let priceElementHtml = priceElement.html();
                    priceElementHtml = priceElementHtml.replace(/\D/g, '');
                    let price = parseFloat(priceElementHtml);
                    let qty;
                    if (app.storeId === 1283) {
                        qty = $('#quantity').val();
                    }
                    else {
                        qty = qtyButtonChange.val();
                    }
                    let newPrice = qty * price;
                    let totalPriceElement = $(
                        '.total-price span,' + '.total-price .total-money');
                    totalPriceElement.html(BSS_B2B.formatMoney(newPrice));
                };
                if (app.storeId === 1283) {
                    $(qtyButtonChange).on('click', changeQuantity);
                }
                else {
                    $(qtyButtonChange).on('change', changeQuantity);
                }
            }
        }
        // fix for stealth-performance-engineering by AnhTV
        if ([5813, 6256].includes(app.storeId)) {
            let vatInput = document.querySelector('.sp-cart-form .bss-b2b-vat-input-wrapper .bss-b2b-vat-input');
            vatInput = vatInput ? vatInput : document.querySelector('.bss-b2b-vat-input-wrapper .bss-b2b-vat-input');
            let checkoutButton = document.querySelector(
                '.sp-cart-form .card-default .card-body .sp-proceed-to-checkout .btn, .giftbox-checkout');
            checkoutButton = checkoutButton ? checkoutButton : document.querySelector(
                '.cart-wrapper .cart-inner-content .cart-checkout .actions .btn-button');
            vatInput.addEventListener('keypress', function(e) {
                let key = e.which;
                if (key === 13) {
                    checkoutButton.click();
                    e.preventDefault();
                    return false;
                }
            });
        }
    };
};

const initHandleSomething = function(app) {
    return function(modules, shopData) {
        const isPortalPage = window.location.pathname ===
            '/apps/customer-portal/purchase-late';
        const isCartPage = app.page.isCartPage();
        const {
            cpStatus, qbStatus, bogoStatus, teStatus, srStatus, dcStatus, efStatus, mcStatus, olStatus, tdStatus, // qiStatus
        } = modules;
        const isCPApplied = cpStatus &&
            ((app.configData && app.configData.length > 0) || (app.plConfigData && app.plConfigData.length > 0));
        const isQBApplied = qbStatus && (app.qbRules && app.qbRules.length > 0);
        const isBOGOApplied = bogoStatus && (app.bogoRule && app.bogoRule.length);
        const isEFApplied = efStatus && (app.efRules && app.efRules.length);
        const isOLApplied = olStatus && (app.amoRules && app.amoRules.length);
        const isTDApplied = tdStatus && (app.taxDisplayRules && app.taxDisplayRules.length);
        const isDCApplied = dcStatus && (app.dcRules && app.dcRules.length);

        /** start to customize **/
        const listStoreCustomizeCPAndTD = [5130, 5320, 5880, 5885, 6036, 6579, 6813, 6888, 7445, 7566, 12349, 12528, 14377];
        const listStoreCustomizeTD = [5671, 6521, 6605, 6631];

        // customize price when using CP or TD
        if (listStoreCustomizeCPAndTD.indexOf(window.BSS_B2B.storeId) !== -1) {
            if (isCPApplied || isTDApplied) {
                // fix for storeID 5130, 5885, 6036, 6813, 7445, 7566
                window.BSS_B2B.executeAction({tag: `price_search_bar`, storeId: false, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
                // fix for storeID 5302
                window.BSS_B2B.executeAction({tag: `price_all`, storeId: 5302, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
                // fix for storeID 5880, 6579
                window.BSS_B2B.executeAction({tag: `price_quick_view`, storeId: false, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
                // fix for storeID 6888
                window.BSS_B2B.executeAction({tag: `change_variant`, storeId: 6888, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
                // fix for storeID 5130
                window.BSS_B2B.executeAction({tag: `price_collection_page`, storeId: 5130, shopData});
                //fix for storeID 12528
                window.BSS_B2B.executeAction({tag: `price_all`, storeId: 12528, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
                // fix for storeID 12349
                window.BSS_B2B.executeAction({tag: 'price_ajax_cart', storeId: 12349, shopData, isCPApplied})
                window.BSS_B2B.executeAction({tag: 'price_collection_page', storeId: 12349, shopData, isCPApplied})
                window.BSS_B2B.executeAction({tag: 'price_quick_add_drawer', storeId: 12349, shopData, isCPApplied})
            }

            // for storeId 7566
            window.BSS_B2B.executeAction({tag: `price_collection_page`, storeId: false, shopData});

            // for storeId 14377
            window.BSS_B2B.executeAction({tag: `price_all`, storeId: 14377})

        }
        else if (listStoreCustomizeTD.indexOf(window.BSS_B2B.storeId) !== -1) {
            if (isTDApplied) {
                // fix for storeID 5671, 6605
                window.BSS_B2B.executeAction({tag: `price_search_bar`, storeId: false, BSS_B2B: window.BSS_B2B, shopData});
                // fix for storeID 5671, 6521
                window.BSS_B2B.executeAction({tag: `price_feature_product`, storeId: false, BSS_B2B: window.BSS_B2B, shopData});
                // fix for storeID 6605
                window.BSS_B2B.executeAction({tag: `price_search_bar`, storeId: 6605, BSS_B2B: window.BSS_B2B, shopData});
                // fix for storeID 6631
                window.BSS_B2B.executeAction({tag: `price_all`, storeId: 6631, BSS_B2B: window.BSS_B2B, shopData});
            }
        }
        else {
            if (isCPApplied) {
                // fix for store 2933, 5241, 6874, 7095, 7342, 7668, 9173, 9596, 11164, 6765
                window.BSS_B2B.executeAction({tag: 'price_all', storeId: false, shopData});

                if (window.BSS_B2B.page.isCollectionPage()) {
                    // fix for storeId 97, 6939, 7332, 7359, 8125
                    window.BSS_B2B.executeAction({tag: `price_collection_page`, storeId: false, shopData});
                    // fix for storeID 7359
                    window.BSS_B2B.executeAction({tag: 'change_variant', storeId: 7359, shopData});
                }

                /**
                 * fix for storeId
                 * 5252, 1651, 6095, 7207, 6699, 7577
                 * 2833, 6011, 6602, 7259, 6171, 7095, 7303, 8219, 8776, 12158, 9673
                 **/
                window.BSS_B2B.executeAction({tag: `price_search_bar`, storeId: false, shopData});
                // fix for storeID 6708, 3820, 5892, 6128, 6171, 7355, 12158
                window.BSS_B2B.executeAction({tag: 'price_quick_view', storeId: false, shopData});

                if (app.page.isCartPage()) {
                    // do nothing
                }
                else {
                    // fix for store 4856, 7303, 7332, 7355, 6289, 6412, 6366, 6365
                    window.BSS_B2B.executeAction({tag: 'change_variant', storeId: false, shopData});
                    // fix for storeID 4856, 8356, 7795
                    // fix for storeID 7795: Fix for get subtotal price when change quantity at a product form
                    if ((window.BSS_B2B.storeId === 7795 && srStatus) || window.BSS_B2B.storeId !== 7795) {
                        window.BSS_B2B.executeAction({tag: 'ajax_cart', storeId: false, shopData});
                    }

                    // fix for storeID 7259
                    window.BSS_B2B.executeAction({tag: 'customize_total_price', storeId: 7259, elementCheck: '.productView-details', shopData});
                }
            }
        }
        window.BSS_B2B.executeAction({tag: "ajax_cart", storeId: 14993, shopData})
        window.BSS_B2B.executeAction({tag: "ajax_cart", storeId: 12433, BSS_B2B: window.BSS_B2B, shopData})
        // fix for store 3351
        window.BSS_B2B.executeAction({tag: 'quick_view_change_variant', storeId: 3351, shopData});
        // fix for woodenplayroom.com by cuongnq
        window.BSS_B2B.executeAction({tag: 'change_variant', storeId: 3588, shopData});
        window.BSS_B2B.executeAction({tag: `change_variant`, storeId: 13921, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
        window.BSS_B2B.executeAction({tag: `change_variant`, storeId: 13435, BSS_B2B: window.BSS_B2B, shopData});
        window.BSS_B2B.executeAction({tag: `change_variant`, storeId: 15480, BSS_B2B: window.BSS_B2B, shopData});
        // fix for uooyaahair.myshopify.com
        window.BSS_B2B.executeAction({tag: `change_variant`, storeId: 13922, shopData});
        /**
         * fix for storeID 4927: customize for mc and cp
         * fix for storeID 7321: customize mini cart of product page
         */
        window.BSS_B2B.executeAction({tag: `price_product_page`, storeId: 15480, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
        window.BSS_B2B.executeAction({tag: `price_product_page`, storeId: 4927, shopData, isCPApplied, mcStatus});
        window.BSS_B2B.executeAction({tag: `price_product_page`, storeId: 7321, shopData});
        window.BSS_B2B.executeAction({tag: `price_product_page`, storeId: 9854});
        window.BSS_B2B.executeAction({tag: `customize_total_price_product_page`, storeId: 12158, shopData});

        // fix for storeID 7577
        window.BSS_B2B.executeAction({tag: `price_cart_page`, storeId: 7577, shopData, isCPApplied, isQBApplied});
        window.BSS_B2B.executeAction({tag: `price_cart_page`, storeId: 13922, BSS_B2B: window.BSS_B2B});
        window.BSS_B2B.executeAction({tag: `price_cart_page`, storeId: 13615, isQBApplied, shopData});
        // fix for storeID 10424
        window.BSS_B2B.executeAction({tag: `price_cart_page`, storeId: 10424});
        // fix for storeID 7056
        window.BSS_B2B.executeAction({tag: 'price_feature_product', storeId: 7056});
        // fix for storeID 7319
        window.BSS_B2B.executeAction({tag: 'price_feature_product', storeId: 7319, shopData});
        // fix for storeID 7321
        window.BSS_B2B.executeAction({tag: 'customize_cp_td', storeId: 7321, shopData, isCartPage: app.page.isCartPage(), isCPApplied});
        // fix for storeID 7445
        window.BSS_B2B.executeAction({tag: 'ol_customize_cart_page', storeId: 7445, shopData, isOLApplied});
        // fix for storeID 7146
        window.BSS_B2B.executeAction({tag: `customize_total_price`, storeId: 7146, isQBApplied});
        // fix for storeId 621
        window.BSS_B2B.executeAction({tag: 'change_variant_on_collection', storeId: 621, BSS_B2B: window.BSS_B2B, shopData, isCPApplied});
        // fix for storeId 13250 by Tapo
        window.BSS_B2B.executeAction({tag: `price_search_bar`, storeId: 13250, shopData, isCPApplied});
        window.BSS_B2B.executeAction({tag: `price_collection_page`, storeId: 13250, shopData});
        /** end customize **/

        if (app.storeId === 7259) {
            if (BSS_B2B.page.isProductPage() || BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage()) {
                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }
        }

        // fix for storeID 7355
        if (app.storeId === 7355 && isCPApplied && app.page.isCartPage()) {
            app.cp.changeProductPrice(shopData, false, false, false);
        }

        if (app.storeId === 13951 && isCPApplied) {
            let searchDrawer = document.querySelector('[search-collections]');
            if (searchDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, false, true);
                        }
                    });
                });
                observer.observe(searchDrawer, {childList: true});
            }
        }
        if (app.storeId === 14417 && isCPApplied) {
            let searchDrawer = document.querySelector('.Search__Results');
            if (searchDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(searchDrawer, {childList: true});
            }
        }
        // Disable checkout button when using OL
        if (BSS_B2B.amoRules && BSS_B2B.amoRules.length > 0) {
            // fix for www.wlexperts.com by hoaduong
            if (
                [3287, 5109, 1548, 4972, 5997, 6044, 6011, 5686, 5045, 7567, 6306, 7259].indexOf(BSS_B2B.storeId) !== -1
            ) {
                document.addEventListener('bss.b2b.amo.doneCheckAMOByBSS',
                    function() {
                        $('form.cart-form button[name="checkout"]').attr('disabled', false);
                        $('button[name="checkout"].checkout-button--lower').css('pointer-events', 'all');
                        $('button[name="checkout"].checkout-button--upper').css('pointer-events', 'all');
                        $('input[name="checkout"].btn.btn--small-wide').css('pointer-events', 'all');
                        $('button[name="checkout"].btn.cart__checkout').css('pointer-events', 'all');
                        $('.checkout-col .checkout-buttons input[type="submit"]').css({'pointer-events': 'auto'});
                        $('form[action="/cart"] button[name="checkout"]').css({'pointer-events': 'auto'});
                        $('form[action="/cart"] #cart-checkout').css({'pointer-events': 'auto'});
                        $('.previewCartGroup .cart-sidebar-checkout').css({'pointer-events': 'auto'});
                        $('input.ajax-cart__button-submit[id="checkout"]').css({'pointer-events': 'auto'});
                        $('.popup-cart__buttons.mt-15 a.btn.btn--full.btn--secondary').css({'pointer-events': 'auto'});
                        $('.pt-15 input.btn.btn--full.btn--secondary').css({'pointer-events': 'auto'});
                        $('.cart__footer .cart__blocks button[type="submit"]').css({
                            'pointer-events': 'auto', 'cursor': 'pointer',
                        });
                        $('#cart-notification-form button').css({'pointer-events': 'auto', 'cursor': 'pointer'});
                        $('.button.button-1.button-checkout').css({'pointer-events': 'auto', 'cursor': 'pointer'});
                    },
                );
            }
            // for greystones-imports, curlysecret by CuongNVM
            else if ([4180, 621].indexOf(BSS_B2B.storeId) !== -1) {
                if (window.location.pathname === '/cart') {
                    $('.cart__footer .cart__blocks button[name="checkout"]').attr('disabled', true);
                    $('.cart--footer .cart--checkout-button button[name="checkout"]').attr('disabled', true);
                }
            }
            else if (BSS_B2B.storeId === 6873) {
                if (window.location.pathname === '/cart') {
                    setTimeout(() => $('#checkout').css({'pointer-events': 'auto', 'cursor': 'pointer'}),
                        1000,
                    );
                }
                setTimeout(
                    () => $('.button.button--primary.button--full-width').css({
                        'pointer-events': 'auto', 'cursor': 'pointer',
                    }), 1000);
            }

            if (app.storeId === 5997) {
                $('form[action*="/cart"] input.cart-item__quantity-input').on('change', function() {
                    window.location.reload();
                });
                $('form[action*="/cart"] #updates_inc_1,' +
                    'form[action*="/cart"] #updates_dec_1').on('click', function() {
                    window.location.reload();
                });
            }
            if (app.storeId === 6044) {
                const handleChangeQty = function() {
                    let inputElement = $('.js-qty input.js-qty__input');
                    let qtyButton = $('.js-qty__adjust.js-qty__adjust--plus,' +
                        '.js-qty__adjust.js-qty__adjust--minus');
                    inputElement.on('change', function() {
                        $('form[action="/cart"] button[name="checkout"]').prop('disabled', true);
                        setTimeout(function() {
                            handleChangeQty();
                        }, 2000);
                        setTimeout(function() {
                            $('form[action="/cart"] button[name="checkout"]').prop('disabled', false);
                        }, 3000);
                    });
                    qtyButton.on('click', function() {
                        $('form[action="/cart"] button[name="checkout"]').prop('disabled', true);
                        setTimeout(function() {
                            handleChangeQty();
                        }, 2000);
                        setTimeout(function() {
                            $('form[action="/cart"] button[name="checkout"]').prop('disabled', false);
                        }, 3000);
                    });
                };
                handleChangeQty();
            }
            if (app.storeId === 12023) {
                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }
        }

        if (BSS_B2B.storeId === 7597 && BSS_B2B.page.isCartPage() && isDCApplied) {
            document.addEventListener('theme:cartchanged', () => {
                BSS_B2B.handleCartCheckoutBtn(shopData);
                setTimeout(() => {
                    BSS_B2B.dc.getDiscountCodeApplied();
                }, 100);
            });

            document.addEventListener(
                'theme:refreshCartDependentContent:success',
                () => {
                    setTimeout(() => {
                        BSS_B2B.handleCartCheckoutBtn(shopData);
                    }, 100);
                },
            );
        }
        //Fix for gsdmarket by donglt
        if (BSS_B2B.storeId == 8741) {
            // eslint-disable-next-line spellcheck/spell-checker
            document.addEventListener('closeFlyouts', () => {
                BSS_B2B.cart.fixer(shopData, false, false);
            });
        }

        if (BSS_B2B.storeId == 11001) {
            let searchDrawer = document.querySelector('.quick-search__results')
            if (searchDrawer) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false)
                        }
                    });
                });
                observer.observe(searchDrawer, { childList: true });
            }
        }

        if (BSS_B2B.storeId == 11332) {
            document.addEventListener('addtocart-modal:open', () => {
                app.cart.fixer(shopData, false, false);
                app.handleCartCheckoutBtn(shopData);
            });
        }

        if ([437].indexOf(BSS_B2B.storeId) !== -1) {
            let doneCheckEvent;
            if (isCPApplied && !isOLApplied) {
                doneCheckEvent = 'bss_b2b_doneCheckCp';
            }
            else if (isOLApplied) {
                doneCheckEvent = 'bss.b2b.amo.doneCheckAMOByBSS';
            }
            document.addEventListener(doneCheckEvent, function() {
                let checkoutElement = BSS_B2B.cart.checkoutBtnElement();
                let disableCheckout = false;
                BSS_B2B.cart.handleDelayCheckout(checkoutElement,
                    disableCheckout,
                );
            });

        }

        if ([7238, 4515].indexOf(BSS_B2B.storeId) !== -1) {
            let doneCheckEvent;
            if (isCPApplied) {
                doneCheckEvent = 'bss_b2b_doneCheckCp';
            }
            if(isQBApplied) {
                doneCheckEvent = 'bss_b2b_doneCheckQb';
            }
            document.addEventListener(doneCheckEvent, function() {
                let checkoutElement = BSS_B2B.cart.checkoutBtnElement();
                let disableCheckout = false;
                setTimeout(() =>{
                    BSS_B2B.cart.handleDelayCheckout(checkoutElement,disableCheckout);
                }, 1000)
            });
        }

        if (app.storeId === 7778) {
            app.handleCartCheckoutBtn(shopData);
            const handleChange = () => {
                $('.QuantitySelector__CurrentQuantity').on('change', () => {
                    setTimeout(() => {
                        app.handleCartCheckoutBtn(shopData);
                        handleChange();
                    }, 2000);
                });
                $('.QuantitySelector__Button.Link.Link--primary').on('click', () => {
                    setTimeout(() => {
                        app.handleCartCheckoutBtn(shopData);
                        handleChange();
                    }, 2000);
                });
            };
            handleChange();
        }

        if (app.storeId === 8572 && isCPApplied) {
            // eslint-disable-next-line spellcheck/spell-checker
            const eventList = [
                'bss:theme:cartchanged',
                'theme:cartchanged',
                'bss:cart:totalchange'];
            eventList.forEach((eventName) => {
                document.addEventListener(eventName, () => {
                    let isAjaxCart = false;
                    if (eventName === 'bss:theme:cartchanged') {
                        isAjaxCart = true;
                    }
                    BSS_B2B.cart.fixer(shopData, true, isAjaxCart);
                });
            });
        }

        if (app.storeId === 11378 && app.page.isCartPage()) {
            window.addEventListener('message', function(event) {
                const appFrame = document.getElementById('appIframe');
                if (appFrame && event.source === appFrame.contentWindow) {
                    if (event.data === 'loaded') {
                        app.cart.fixer(shopData, true, false);
                    }
                }
            });
        }
        if (app.storeId === 13997 && isCPApplied && app.page.isProductPage()) {
            let variantElement = document.querySelectorAll('.swatch-element')
            if (variantElement && variantElement.length) {
                variantElement.forEach(item => {
                    item.addEventListener('click', () => {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, null, null, false, item.getAttribute('data-id'))
                        },250)
                    })
                })
            }
        }
        if (app.storeId === 13597 && isCPApplied) {
            let ajaxCart = document.querySelector('.Drawer__Main-wrap')
            if (ajaxCart) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, null, true);
                        }
                    });
                });
                observer.observe(ajaxCart, { childList: true });
            }
            let searchResult = document.querySelector('.search-form.search-popup__form .search__results-wrapper .search__results')
            if (searchResult) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(searchResult, { childList: true });
            }
        }
        if (app.storeId === 12879 && app.page.isProductPage()) {
            let productForm = document.querySelector('.f8pr')
            if (productForm) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(productForm, { childList: true });
            }
        }
        if (app.storeId === 12966 && app.page.isCartPage()) {
            window.addEventListener("change-quantity-in-cart", function() {
                app.cart.fixer(shopData, true, true);
            });
        }
        if (app.storeId === 14389) {
            const cloneCheckoutBtn = () => {
                let checkoutBtn = document.querySelectorAll(".btn.cart__checkout");
                checkoutBtn.forEach(item => {
                    let newCheckoutBtn = document.createElement(item.tagName);
                    newCheckoutBtn.className = item.className;
                    newCheckoutBtn.innerHTML = 'Check out';
                    item.parentElement.replaceChild(newCheckoutBtn, item);
                })
            }
            let ajaxCart = document.querySelector('#CartContainer')
            if (ajaxCart) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, null, true);
                            setTimeout(cloneCheckoutBtn(),1000)
                        }
                    });
                });
                observer.observe(ajaxCart, { childList: true });
            }
            cloneCheckoutBtn()
            setTimeout(()=>$('.shopify-payment-button__more-options').next().css({'display':'none'}),1000)
        }
        if (app.storeId === 14730) {
            let searchResult = document.querySelector('.search-results-container')
            if (searchResult) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((m) => {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(searchResult, { childList: true });
            }
        }
        if ([11985, 15968].includes(app.storeId)) {
            document.addEventListener('product:variant-change', function() {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false,
                        false,
                    );
                }, 1000);
            });
        }

        if (app.storeId === 10548 && !app.page.isCartPage()) {
            document.addEventListener('minicart:init', function() {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData,
                        'mini-cart .mini-cart__navigation ', false, false,
                    );
                }, 1000);
            });
        }

        if (app.storeId === 6526) {
            const addToCartBtn = document.querySelector('#AddToCart');
            if (addToCartBtn) {
                addToCartBtn.addEventListener('click', () => {
                    const catchMiniCartAfterAddToCart = setInterval(() => {
                        const miniCart = document.querySelector('#mini-cart');
                        if (miniCart) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                            clearInterval(catchMiniCartAfterAddToCart);
                        }
                    }, 200);
                    setTimeout(() => {
                        clearInterval(catchMiniCartAfterAddToCart);
                    }, 7000);
                });
            }
        }

        if (app.storeId === 5263) {
            document.addEventListener('bss_b2b_doneCheckQb', function() {
                let comparePriceCartPage = document.querySelector(
                    '.bss-qb-cart-subtotal');
                if (comparePriceCartPage) {
                    let parentElement = comparePriceCartPage.closest(
                        '.cart__item-sub');
                    if (parentElement) {
                        let subtotalDefault = parentElement.querySelector(
                            '[data-subtotal]');
                        if (subtotalDefault) {
                            subtotalDefault.remove();
                        }
                    }
                }
            });
        }

        if (app.storeId === 8337) {
            const searchIcon = document.querySelector(
                '#shopify-section-header > div > header > div > div.site-header__wrapper__right.top-links > ul > li:nth-child(1) > a');
            searchIcon.addEventListener('click', () => {
                setTimeout(() => {
                    $('#SearchContainer #search-input').keyup(function() {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, null,
                                false,
                            );
                        }, 1500);
                    });
                }, 500);
            });
        }

        // fix for sunarhome by ducnv
        if (app.storeId === 5889 && app.page.isProductPage() && isQBApplied) {
            const insertAfterQB = (newNode, existingNode) => {
                existingNode.parentNode.insertBefore(newNode,
                    existingNode.nextSibling,
                );
            };
            let timerFixQB = setInterval(() => {
                let tableQB = document.querySelector(
                    '.bss-b2b-cart-item-qty-table');
                let beforeTableQB = document.querySelector(
                    '.card__section .product-form .product-form__info-list');
                if (tableQB) {
                    insertAfterQB(tableQB, beforeTableQB);
                    clearInterval(timerFixQB);
                }
            }, 200);
        }

        // fix for vonboie.com by Ducnv
        if (app.storeId === 8606) {
            const searchInput = document.querySelector(
                '.Search__Input.Heading');
            searchInput.addEventListener('change', () => {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            });
        }

        // fix for dollie-wholesale.com
        if (app.storeId === 5130 && app.page.isCartPage() && isCPApplied) {
            const updateCartBtn = document.querySelectorAll(
                '.cart-product-info__btn');
            if (updateCartBtn.length) {
                updateCartBtn.forEach(item => {
                    item.addEventListener('click', () => {
                        const checkoutBtn = document.querySelector(
                            '.btn.cart-modal__btn');
                        if (checkoutBtn) {
                            checkoutBtn.setAttribute('disabled', true);
                        }
                    });
                });
            }
        }
        // fix for https://onyx-tattoo-supply.myshopify.com by Ducnv
        if (BSS_B2B.storeId === 8433 && app.page.isProductPage()) {
            setTimeout(() => {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }, 1500);
            let buttonModal = document.querySelector(`#b-buttons > div`);
            let buttonQuickView = document.querySelectorAll(
                `modal-trigger[target="#ProductQuickView"]`);

            if (buttonModal) {
                buttonModal.addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, null, false);
                    }, 5000);
                });
            }
            buttonQuickView.forEach(e => {
                e.addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, null, false);
                    }, 2000);
                });
            });
        }
        else if (BSS_B2B.storeId === 10700 && app.page.isProductPage()) {
            let buttonVariants = document.querySelectorAll(
                '.rio-options .rio-hide-scrollbar .PwzrGrid-root-111');
            if (buttonVariants.length) {
                buttonVariants.forEach(e => {
                    e.addEventListener('click', () => {
                        setTimeout(() => {
                            let productPriceElement = document.querySelector(
                                '.container-indent .tt-price [bss-b2b-variant-id]');
                            if (productPriceElement) {
                                let sizeVariantElement = e.querySelector(
                                    '.PwzrGrid-root-111.PwzrGrid-container-112.PwzrGrid-item-113.PwzrGrid-direction-xs-column-115 .PwzrGrid-root-111.PwzrGrid-item-113 div');
                                if (sizeVariantElement) {
                                    let sizeVariantText = sizeVariantElement.innerText;
                                    let priceVariant = shopData.product.variants.filter(
                                        variant => variant.title ===
                                            sizeVariantText);
                                    if (priceVariant.length &&
                                        !productPriceElement.innerHTML) {
                                        productPriceElement.innerText = BSS_B2B.formatMoney(
                                            priceVariant[0].price);
                                    }
                                }
                            }
                        }, 200);
                    });
                });
            }
        }
        if (app.storeId === 7188 && app.page.isProductPage() && isCPApplied) {
            let changeVariantOptionProductPages = document.querySelectorAll(
                '.js.product-form__input.clearfix');
            if (changeVariantOptionProductPages.length) {
                for (let i = 0; i <
                changeVariantOptionProductPages.length; i++) {
                    changeVariantOptionProductPages[i].onchange = function() {
                        setTimeout(() => {
                            $(changeVariantOptionProductPages[i]).
                                parent().
                                parent().
                                find('.bss-b2b-customized-compare-at-price').
                                remove();
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1000);
                    };
                }
            }
        }

        if (app.storeId === 3051 && app.page.isProductPage() && isCPApplied) {
            let changeVariantOptionProductPages = document.querySelectorAll(
                '.ProductForm__Variants .SizeSwatch');
            if (changeVariantOptionProductPages.length) {
                for (let i = 0; i <
                changeVariantOptionProductPages.length; i++) {
                    changeVariantOptionProductPages[i].addEventListener('click',
                        function() {
                            setTimeout(() => {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }, 1000);
                        },
                    );
                }
            }
        }

        if (app.storeId === 10676 && app.page.isProductPage() && isCPApplied) {
            let changeVariantOptionProductPages = document.querySelectorAll(
                '.color-swatch-list .color-swatch');
            if (changeVariantOptionProductPages.length) {
                for (let i = 0; i <
                changeVariantOptionProductPages.length; i++) {
                    changeVariantOptionProductPages[i].addEventListener('click',
                        function() {
                            setTimeout(() => {
                                app.cp.changeProductPrice(shopData,
                                    '.price-list .price',
                                    false,
                                );
                            }, 1000);
                        },
                    );
                }
            }

            let changeVariantComboBoxPDP = document.querySelectorAll(
                '.combo-box__option-item');
            if (changeVariantComboBoxPDP) {
                for (let i = 0; i < changeVariantComboBoxPDP.length; i++) {
                    changeVariantComboBoxPDP[i].addEventListener('click',
                        function() {
                            setTimeout(() => {
                                app.cp.changeProductPrice(shopData,
                                    '.price-list .price', false,
                                );
                            }, 1000);
                        },
                    );
                }
            }
        }

        if (app.storeId === 6708) {
            const addToCartButton = document.querySelectorAll(
                'button.addtocart-item-js, button.btn-addtocart.addtocart-js');
            if (addToCartButton.length) {
                for (let i = 0; i < addToCartButton.length; i++) {
                    addToCartButton[i].addEventListener('click', function() {
                        const checkoutBtn = $('a[href=\'/checkout\']');
                        if (checkoutBtn.length) {
                            checkoutBtn.hide();
                            setTimeout(function() {
                                checkoutBtn.show();
                            }, 2000);
                        }
                    });
                }
            }
        }
        if (app.storeId === 3849) {
            if (app.page.isCollectionPage()) {
                const filterSelect = document.querySelector('.dT_SortBy');
                if (filterSelect) {
                    filterSelect.onchange = function() {
                        const myInterval = setInterval(function() {
                            const getPreLoad = document.querySelector(
                                '.dT_VProdWrapper.collectionListPreload');
                            if (!getPreLoad) {
                                clearInterval(myInterval);
                                app.cp.changeProductPrice(shopData, null,
                                    false,
                                );
                            }
                        }, 500);
                    };
                }
            }
            let productListingElem = document.querySelector(
                '.dT_PredictiveSearchResult_Section ul.dt-sc-ProductSugesstions');
            if (productListingElem) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(productListingElem, {childList: true});
            }
        }

        if (app.storeId === 7369 && isCPApplied) {
            const catchFilter = function() {
                const handleChangeFilter = document.querySelector(
                    '#CollectionFilterForm');
                if (handleChangeFilter) {
                    handleChangeFilter.addEventListener('change', function() {
                        setTimeout(function() {
                            app.cp.changeProductPrice(shopData, null, false);
                            catchFilter();
                        }, 3000);
                    });
                }
            };
            catchFilter();
        }

        if (app.storeId === 7271 && app.page.isCartPage() && isOLApplied) {
            $('button#checkout').hide();
            setTimeout(function() {
                $('button#checkout').show();
            }, 3000);
            const handleHideCheckoutBtnWhenChangeQty = function() {
                const qtyBtn = document.querySelectorAll(
                    '.quantity__button.no-js-hidden');
                const qtyInput = document.querySelectorAll('.quantity__input');
                if (qtyBtn.length && qtyInput.length) {
                    for (let i = 0; i < qtyBtn.length; i++) {
                        qtyBtn[i].onclick = function() {
                            $('button#checkout').hide();
                            setTimeout(function() {
                                $('button#checkout').show();
                                handleHideCheckoutBtnWhenChangeQty();
                            }, 3000);
                        };
                    }
                    for (let i = 0; i < qtyInput.length; i++) {
                        qtyInput[i].onchange = function() {
                            $('button#checkout').hide();
                            setTimeout(function() {
                                $('button#checkout').show();
                                handleHideCheckoutBtnWhenChangeQty();
                            }, 3000);
                        };
                    }
                }
            };
            handleHideCheckoutBtnWhenChangeQty();
        }

        if (app.storeId === 6498 && isCPApplied) {
            if (BSS_B2B.page.isProductPage()) {
                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }

            if (BSS_B2B.page.isCartPage()) {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }
        }

        if (app.storeId === 8282) {
            const searchBar = document.querySelector('.search-bar__results');
            if (searchBar) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            BSS_B2B.cp.changeProductPrice(shopData, null,
                                false,
                            );
                        }
                    });
                });
                observer.observe(searchBar, {childList: true});
            }

            const buttonQuickView = $('.btn--primary.js-quickbuy-button');
            buttonQuickView.on('click', () => {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                }, 1000);
            });
        }
        // fix for dschinni-shisha.com by cuongnq
        if (app.storeId === 8446) {
            if (isCPApplied) {
                BSS_B2B.cart.visibleElementAfterUpdateQuantity(true, false);
            }
        }

        if (app.storeId === 10724 && isCPApplied) {
            document.addEventListener('cart:render', () => {
                setTimeout(() => {
                    app.cart.fixer(shopData, false, true);
                }, 200);
            });
        }

        // fix for ordercart.ohmpharma.com, topguyshoes.com, didierlabpartner.eu by cuongnq
        if (([
                77,
                7303,
                8920,
                7332,
                5077,
                8653,
                8537,
                10027,
                9424,
                10946,
                7323,
                986,
                10788,
                1794,
                9762,
                6613,
                12634, 12384, 12204, 7691, 6579,14646].includes(app.storeId) && app.page.isCartPage()) ||
            [ 11001, 6932, 9331, 8250, 11265, 11036, 11101, 11586, 11612, 10522, 2312, 7619, 4824, 8927, 12204, 986, 11946, 15109, 5686, 621, 14646].includes(app.storeId)) {
            let timeDelayQueryElement = 0;
            if ([10027, 7323].includes(app.storeId)) {
                timeDelayQueryElement = 1000;
                setTimeout(() => {
                    app.cart.fixer(shopData, false, true);
                }, 1000);
            }
            else if ([5077].includes(app.storeId)) {
                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                timeDelayQueryElement = 2500;
            }
            else if ([621].includes(app.storeId)) {
                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                timeDelayQueryElement = 2500;
                setTimeout(() => {
                    app.cart.fixer(shopData, false, true);
                }, 4000);
            }
            else if ([12204].includes(app.storeId)) {
                timeDelayQueryElement = 4000;
            }
            else if ([2312].includes(app.storeId)) {
                timeDelayQueryElement = 1000;
            }
            const handleChangeQty = () => {
                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});

                if ((isCPApplied && isQBApplied) || isQBApplied) {
                    document.addEventListener('bss_b2b_doneCheckQb', () => {
                        $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'unset', 'opacity': '1'});
                    });
                }
                else if (isCPApplied) {
                    let timeoutShowButton = 0;
                    if (BSS_B2B.storeId === 621) {
                        timeoutShowButton = 2000;
                    }
                    document.addEventListener('bss_b2b_doneCheckCp', () => {
                        setTimeout(() => {
                            $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'unset', 'opacity': '1'});
                        }, timeoutShowButton)
                    });
                    if ([5077].includes(app.storeId)) {
                        let interval = setInterval(() => {
                            $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                        }, 50);
                        setTimeout(() => {
                            clearInterval(interval);
                            $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'unset', 'opacity': '1'});
                        }, timeDelayQueryElement);
                    }
                    if (app.storeId === 8653) {
                        $(BSS_B2B.helper.checkoutElements).on('click', () => {
                            let interval = setInterval(() => {
                                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                            }, 50);
                            setTimeout(() => {
                                clearInterval(interval);
                            }, 3500);
                        });
                    }
                }
                else {
                    setTimeout(() => {
                        $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'unset', 'opacity': '1'});
                    }, 1000);
                }
                if (isDCApplied && [8537, 12384, 5686].includes(app.storeId)) {
                    setTimeout(function() {
                        BSS_B2B.dc.showDiscountBox();
                        BSS_B2B.dc.getDiscountCodeApplied();
                        BSS_B2B.onDiscountCodeSubmit()
                        if ([12384].includes(app.storeId)) {
                            document.querySelector('#bss-b2b-discount-code-submit').innerText = BSS_B2B.dcTranslations.button_apply;
                        }
                    }, 1000);
                }
                const buttonChangeQuantity = document.querySelectorAll(
                    '.cart__form .quantity-input__button, .cart__quantity button[type="button"], .CartItem__QuantitySelector .QuantitySelector .QuantitySelector__Button, .quantity .quantity__button, button.quantity-selector__button, button.cart-item-quantity-button, .cart--quantity--container a.cart--minus, .cart--quantity--container a.cart--plus,.product-quantity quantity-selector button,.product-cart-item-info quantity-selector button,.t4s-quantity-selector, button.cart-quantity-select, .ajaxcart__quantity button.js-qty__adjust, #cart .quantity button.no-js-hidden[name="minus"], #cart .quantity button.no-js-hidden[name="plus"], .mini-cart__sidebar .quantity button.no-js-hidden[name="minus"], .mini-cart__sidebar .quantity button.no-js-hidden[name="plus"],.m-quantity__button,' +
                    '.ajax-cart__qty-control--up.mb0.v-center,.ajax-cart__qty-control--down.mb0.v-center, .cart__cell--quantity .js-qty .js-qty__adjust, .cart__item-sub .js-qty__wrapper button.js-qty__adjust, .cart__item--qty .js-qty__wrapper button.js-qty__adjust, .unicart-grid .unicart__qty .unicart__qty-adjust, .scd-item__quantity .scd-item__btn, .qty-input.qty-input--combined .qty-input__btn.btn, cart-update-quantity a.btn-quantity, .btn.btn-decrease, .btn.btn-increase');
                const inputQuantity = document.querySelectorAll(
                    '.cart__form .quantity-input__input, .cart__quantity .cart__quantity-field, .CartItem__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity, .quantity .quantity__input, input.quantity-selector__value, input.cart-item-quantity, .cart--quantity--container input.cart--quantity--input,.product-quantity quantity-selector input,.product-cart-item-info quantity-selector input,.t4s-quantity-input, input.cart__qty-input, .ajaxcart__quantity input.js-qty__num, #cart .quantity input[name="quantity"], .mini-cart__sidebar input[name="quantity"],.m-quantity__input,.ajax-cart__qty-input.v-center.a-center, .cart__cell--quantity .js-qty .js-qty__input' +
                    '.cart__item-sub .js-qty__wrapper input.js-qty__num, .cart__item--qty .js-qty__wrapper input.js-qty__num, .unicart-grid .unicart__qty .unicart__qty-num, .quantity-selector__wrapper .quantity-selector__input, .py-1.scd-item__qty_input.w-9.text-center, .qty-input.qty-input--combined .qty-input__input.input, cart-update-quantity input[name="quantity"].form-input, .form-input.quantity-field');
                const removeItem = document.querySelectorAll(
                    '.cart__form .cart__form-item-remove, .cart-item__content a.cart-item__remove, .CartItem .CartItem__Actions .CartItem__Remove.Link, loess-cart-remove-button.remove__button.small-text, .CartItem__RemoveWrapper a, a.line-item__quantity-remove.link, button#cart-item-remove-button, .cart--item--remove a.remove, .mini-cart__quantity a.mini-cart__quantity-remove.link,.t4s-page_cart__remove, .cart__row a.remove.la-close, #cart button.cart-item__remove, .mini-cart__sidebar button.cart-item-delete,.m-cart-item__remove, .m-cart-drawer-item__remove, .cart-item__quantity cart-remove-button a.button--tertiary' +
                    '.cart__item-sub .cart__remove a, .unicart-grid .unicart-grid__item a.unicart-remove, .ajax-cart__cart-form .ajax-cart__cart-items .ajax-cart__cart-item .ajax-cart__item-remove--js, .cart-item__totals cart-remove-button, .cart-item__remove .cart-item__remove-link, .scd-item__remove.underline.p-2.ml-2, .cart-item__remove.btn.btn--icon.text-current.tap-target.js-remove-item, button[data-cart-remove].previewCartItem-remove, .btn.remove-item') ;
                const buttonShowCart = document.querySelectorAll(
                    '.product-page--submit-action #purchase, button.icons--inline.slide-menu-cart, .product-form__payment-container button.product-form__add-button, .header__action-item--cart a.header__action-item-link.header__cart-toggle, .product-converter__add-to-cart form[action="/cart/add"] button.button--add-to-cart--secondary, #cart-open, button.btn-atc[type="submit"], #sidebar-minicart, #cart-icon-bubble, .single_add_to_cart_button, .icon_cart .push_side, .ProductForm__AddToCart.Button, .add-to-cart.sf__btn.flex-grow, .sf__tooltip-item.block.sf__tooltip-bottom, .header__icons .header__icon.has-motion.relative.text-current, .product-info__add-to-cart .product-info__add-button button, a[href="/cart"].header__icon--cart, .type__nav.show-cart-btn');
                let timeout = 1800;
                if ([5077, 11612, 621].includes(app.storeId)) {
                    timeout = 2500;
                }
                if ([10522, 1794, 15109].includes(app.storeId)) {
                    timeout = 5000;
                }
                if ([9762].includes(app.storeId)) {
                    for (let i = 0; i < buttonChangeQuantity.length; i++) {
                        buttonChangeQuantity[i].style.pointerEvents = 'unset';
                        buttonChangeQuantity[i].style.opacity = '1';
                    }
                    for (let i = 0; i < inputQuantity.length; i++) {
                        inputQuantity[i].style.pointerEvents = 'unset';
                        inputQuantity[i].style.opacity = '1';
                    }
                }

                if (inputQuantity.length && buttonChangeQuantity.length) {
                    for (let i = 0; i < buttonChangeQuantity.length; i++) {
                        buttonChangeQuantity[i].onclick = () => {
                            let interval = setInterval(() => {
                                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                                if ([9762].includes(app.storeId)) {
                                    buttonChangeQuantity[i].style.pointerEvents = 'none';
                                    buttonChangeQuantity[i].style.opacity = '0.6';
                                }
                            }, 50);
                            setTimeout(() => {
                                clearInterval(interval);
                                app.cart.fixer(shopData, false, true);
                                app.handleCartCheckoutBtn(shopData);
                                handleChangeQty();

                                if ([8927].includes(BSS_B2B.storeId)) {
                                    const sideCartButton = document.querySelector('button.unicart-checkout-btn.cart__checkout');
                                    const check = document.querySelector('.unicart-checkout-btn-container > div.gokwik-checkout');
                                    if (check === null) {
                                        // eslint-disable-next-line
                                        sideCartButton.after(parsedBtnCode);
                                    }
                                }

                            }, timeout);
                        };
                    }
                    for (let i = 0; i < inputQuantity.length; i++) {
                        inputQuantity[i].onchange = () => {
                            let interval = setInterval(() => {
                                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                                if ([9762].includes(app.storeId)) {
                                    inputQuantity[i].style.pointerEvents = 'none';
                                    inputQuantity[i].style.opacity = '0.6';
                                }
                            }, 50);
                            setTimeout(() => {
                                clearInterval(interval);
                                app.cart.fixer(shopData, false, true);
                                app.handleCartCheckoutBtn(shopData);
                                handleChangeQty();

                                if ([8927].includes(BSS_B2B.storeId)) {
                                    const sideCartButton = document.querySelector('button.unicart-checkout-btn.cart__checkout');
                                    const check = document.querySelector('.unicart-checkout-btn-container > div.gokwik-checkout');
                                    if (check === null) {
                                        // eslint-disable-next-line
                                        sideCartButton.after(parsedBtnCode);
                                    }
                                }

                            }, timeout);
                        };
                    }
                    for (let i = 0; i < removeItem.length; i++) {
                        removeItem[i].onclick = () => {
                            let interval = setInterval(() => {
                                $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                            }, 50);
                            setTimeout(() => {
                                clearInterval(interval);
                                app.cart.fixer(shopData, false, true);
                                app.handleCartCheckoutBtn(shopData);
                                handleChangeQty();
                            }, timeout);
                        };
                    }
                }
                if ([8250, 11101, 11586, 7619, 8927, 986, 11946, 15109, 5686].includes(app.storeId)) {
                    if (buttonShowCart.length) {
                        for (let i = 0; i < buttonShowCart.length; i++) {
                            buttonShowCart[i].onclick = () => {
                                let interval = setInterval(() => {
                                    $(BSS_B2B.helper.checkoutElements).css({
                                        'pointer-events': 'none', 'opacity': '0.6',
                                    });
                                }, 50);
                                setTimeout(() => {
                                    clearInterval(interval);
                                    app.cart.fixer(shopData, false, true);
                                    app.handleCartCheckoutBtn(shopData);
                                    handleChangeQty();
                                }, timeout);
                            };
                        }
                    }
                }
            };
            setTimeout(() => {
                handleChangeQty();
            }, timeDelayQueryElement);
            if (BSS_B2B.storeId == 14646) {
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(record => {
                    if (record.type === 'attributes') {
                        BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML), true, true)
                        handleChangeQty()
                    }
                    });
                });

                const cartDrawer = document.querySelector('.fixed.inset-0.z-50.overflow-hidden.cart-drawer');
                observer.observe(cartDrawer, {
                    attributes: true
                });
            }
        }
        if ([9006].includes(app.storeId)) {
            const input = document.querySelector('#ajax-cart__content');
            const observer = new MutationObserver(() => {
                app.cart.fixer(shopData, false, false);
            });
            observer.observe(input, {childList: true, subtree: true});
        }
        // fix mini cart checkout by cuongnq
        if ([7619].includes(app.storeId) && isCPApplied) {
            setTimeout(() => {
                const buttonCheckoutMiniCart = document.querySelector(
                    '#cart > div.l-minicart__footer.u-bg-light-grey.u-full-width > div:nth-child(3) > button');
                const sectionCheckout = document.querySelector(
                    '#cart > div.l-minicart__footer.u-bg-light-grey.u-full-width');
                if (sectionCheckout && buttonCheckoutMiniCart) {
                    const newButtonCheckout = buttonCheckoutMiniCart.cloneNode(
                        true);
                    sectionCheckout.appendChild(newButtonCheckout);
                    buttonCheckoutMiniCart.style.display = 'none';
                }
            }, 500);

            const buttonShowMiniCarts = document.querySelectorAll(
                'button#sidebar-minicart, button#cart-icon-bubble');
            if (buttonShowMiniCarts.length) {
                for (let buttonShowMiniCart of buttonShowMiniCarts) {
                    buttonShowMiniCart.addEventListener('click', function() {
                        app.cart.fixer(shopData, false, true);
                    });
                }
            }
        }

        if ([6809].includes(BSS_B2B.storeId) && isCPApplied && isCartPage) {
            setTimeout(() => {
                app.cp.changeProductPrice(shopData, null, false);
            }, 2000)
        }

        // fix for razor-shopping.com by cuongnq
        if (app.storeId === 8014 && isCPApplied && app.page.isSearchPage()) {
            let searchResult = document.querySelector('#gf-grid');
            if (searchResult) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(searchResult,
                    {childList: true, subtree: true},
                );
            }

            document.addEventListener('bss_b2b_doneCheckCp', () => {
                let productItemPrice = document.querySelectorAll(
                    '.grid-product__price');
                productItemPrice.forEach(item => {
                    let originalPrice = parseFloat(item.querySelector(
                        '.grid-product__price--original span[aria-hidden="true"]').textContent.trim().substring(1));
                    let priceCP = parseFloat(item.querySelector(
                        '.grid-product__price--current span[aria-hidden="true"][bss-b2b-product-price]').
                        textContent.
                        trim().
                        substring(1));
                    let priceSaving = item.querySelector(
                        '.grid-product__price--savings');
                    priceSaving.innerHTML = `Save ${BSS_B2B.formatMoney(
                        (originalPrice - priceCP) * 100)}`;
                });
            });
        }

        // fix for by cuongnq
        if (app.storeId === 10438 && isQBApplied) {
            let buttonAddToCarts = document.querySelectorAll(
                '#header-icons button.slide-menu-cart');
            for (let buttonAddToCart of buttonAddToCarts) {
                buttonAddToCart.addEventListener('click', function() {
                    setTimeout(function() {
                        BSS_B2B.cart.fixer(shopData, false, true);
                    }, 1000);
                });
            }

            let miniCart = document.querySelector('#cartSlideoutWrapper .cart-items');
            if (miniCart) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            setTimeout(() => {
                                app.cart.fixer(shopData, false, true);
                            }, 200);
                        }
                    });
                });
                observer.observe(miniCart, {childList: true});
            }
        }

        // fix for amasports.com.au, itilhenger21.myshopify.com by cuongnq
        if ([7676, 9232].includes(app.storeId) && isCPApplied && app.page.isCollectionPage()) {
            let filterProducts = document.querySelector(
                '.boost-pfs-filter-products');
            if (filterProducts) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(filterProducts,
                    {childList: true, subtree: true},
                );
            }
        }

        // fix for adro.com by cuongnq
        if ([7727, 6095].includes(app.storeId) && isCPApplied) {
            if (app.page.isCartPage()) {
                setTimeout(() => {
                    app.cart.fixer(shopData, false, false);
                    app.handleCartCheckoutBtn(shopData);
                }, 500);
            }

            if (app.storeId === 7727) {
                window.BSS_B2B.executeAction({tag: 'change_quantity_cart', storeId: 7727, shopData});
            }
        }

        if ([15109].includes(app.storeId) && isCPApplied) {
            if (app.page.isCartPage()) {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML), '.price__default .price__current',false);
                    app.cart.fixer(shopData, false, false);
                    app.handleCartCheckoutBtn(shopData);
                }, 4000);
            }
        }

        // fix for bloomgrove.com.au by cuongnq
        if ([9139].includes(app.storeId) && isQBApplied) {
            const cartDrawer = document.querySelector(
                'cart-drawer.cart-drawer.drawer');
            if (cartDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, true, true);
                        }
                    });
                });
                observer.observe(cartDrawer, {childList: true});
            }
        }

        if ([9232].includes(app.storeId) && isCPApplied) {
            const handleShowQuickView = setInterval(function() {
                let buttonQuickView = document.querySelectorAll(
                    '.boost-pfs-quickview-btn.boost-pfs-filter-button[aria-label="Quick View"]');
                if (buttonQuickView.length > 0) {
                    clearInterval(handleShowQuickView);
                    buttonQuickView.forEach(item => {
                        item.addEventListener('click', function() {
                            let waitQuickView = setInterval(function() {
                                const quickViewEle = document.querySelector(
                                    '.boost-pfs-quickview-wrapper');
                                if (quickViewEle) {
                                    app.cp.changeProductPrice(shopData, null,
                                        false,
                                    );
                                    clearInterval(waitQuickView);
                                }
                            }, 500);

                            setTimeout(function() {
                                clearInterval(waitQuickView);
                            }, 5000);
                        });
                    });
                }
            }, 500);
            setTimeout(() => {
                clearInterval(handleShowQuickView);
            }, 5000);
        }
        window.BSS_B2B.executeAction({tag: 'price_all', storeId: 13344, BSS_B2B: window.BSS_B2B, shopData});
        window.BSS_B2B.executeAction({tag: 'handle_click_update_price', storeId: 15243, BSS_B2B: window.BSS_B2B});
        // fix show quickview for amasports.com.au by cuongnq
        if ([7676].includes(app.storeId) && isCPApplied) {
            const handleShowQuickView = setInterval(function() {
                let buttonQuickView = document.querySelectorAll(
                    '.boost-pfs-quickview-btn.boost-pfs-filter-button[aria-label="Quick View"]');
                if (buttonQuickView.length > 0) {
                    clearInterval(handleShowQuickView);
                    buttonQuickView.forEach(item => {
                        item.addEventListener('click', function() {
                            let waitQuickView = setInterval(function() {
                                const quickViewEle = document.querySelector(
                                    '.boost-pfs-quickview-wrapper');
                                const variantQuickView = document.querySelectorAll(
                                    '.boost-pfs-swatch-element label');
                                if (quickViewEle && variantQuickView.length) {
                                    app.cp.changeProductPrice(shopData, null,
                                        false,
                                    );
                                    variantQuickView.forEach(variantItem => {
                                        variantItem.addEventListener('click',
                                            function() {
                                                app.cp.changeProductPrice(
                                                    shopData, false, false);
                                            },
                                        );
                                    });
                                    clearInterval(waitQuickView);
                                }
                            }, 500);

                            setTimeout(function() {
                                clearInterval(waitQuickView);
                            }, 3000);
                        });
                    });
                }
            }, 500);
            setTimeout(() => {
                clearInterval(handleShowQuickView);
            }, 3000);
        }

        if ([12634, 10788].includes(app.storeId) && isCPApplied && BSS_B2B.page.isSearchPage()) {
            const selectVariant = document.querySelectorAll('.form-control.single-option-selector.single-option-selector-item');
            if (selectVariant && selectVariant.length) {
                selectVariant.forEach(item => {
                    item.setAttribute('selected', 'false');
                    item.onchange = function () {
                        const productId = $(this).attr('data-product-id');
                        selectVariant.forEach(item => item.setAttribute('selected', 'false'));
                        item.setAttribute('selected', 'true');
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, `.product-details[bss-b2b-product-id="${productId}"] .product-price`, false);
                        }, 500)
                    }
                })
            }

            let miniCart = document.querySelector('.dropdown.cart-dropdown');
            if (miniCart) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, false, false);
                        }
                    });
                });

                observer.observe(miniCart, { childList: true });
            }
        }

        // fix for bomajewelry.com by cuongnq
        if ([9928].includes(app.storeId) && isCPApplied) {
            if (app.page.isProductPage()) {
                let allVariants = document.querySelectorAll(
                    '.radio__button, .swatch__button label');
                allVariants.forEach(item => {
                    item.addEventListener('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData,
                                '[bss-b2b-product-price]',
                                false,
                            );
                        }, 1250);
                    });
                });
            }

            let searchResult = document.querySelector(
                '#search-popdown-results');
            if (searchResult) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(searchResult,
                    {childList: true, subtree: true},
                );
            }
        }

        // fix for aquanextech.com by cuongnq
        if ([9424].includes(app.storeId) && isCPApplied) {
            let quickView = document.querySelector('.modal__inner');
            if (quickView) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    });
                });
                observer.observe(quickView, {childList: true});
            }
        }

        // fix for lnccabinetry.com by cuongnq
        if ([9907].includes(app.storeId) && isCPApplied) {
            let cartDrawer = document.querySelector('.\\#modal-popup-content');
            if (cartDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, false, true);
                        }
                    });
                });
                observer.observe(cartDrawer, {childList: true});
            }
        }
        
        // fix for snack-et-moi.myshopify.com by hoangnx1
        if ([9959].includes(app.storeId) && isCPApplied) {
            const variantWrapper = document.querySelector(
                '.variant-picker__option-values');
            if (variantWrapper) {
                const variants = variantWrapper.querySelectorAll('input');
                if (variants && variants.length > 0) {
                    variants.forEach(function(variant) {
                        variant.addEventListener('change', function() {
                            app.cp.changeProductPrice(shopData,
                                '.product-info sale-price',
                                false,
                            );
                        });
                    });
                }
            }
        }

        // fix for 6c1a78-3.myshopify.com by HoangNX1
        if ([11586].includes(app.storeId) && isQBApplied) {
            const handleAddEvent = () => {
                const qtyInputs = document.querySelectorAll(
                    '.quantity-wrapper, .quantity-wrapper input');
                if (qtyInputs && qtyInputs.length > 0) {
                    qtyInputs.forEach(input => {
                        input.onChange = function() {
                            setTimeout(function() {
                                BSS_B2B.cart.fixer(shopData, true, true);
                            }, 2000);
                        };
                    });
                }
                const buttonRemoveItem = document.querySelectorAll(
                    'button.btn[data-remove-line-item]');
                if (buttonRemoveItem && buttonRemoveItem.length > 0) {
                    buttonRemoveItem.forEach(item => {
                        item.onClick = function() {
                            setTimeout(function() {
                                BSS_B2B.cart.fixer(shopData, true, true);
                            }, 2000);
                        };
                    });
                }
            };

            handleAddEvent();

            let miniCart = document.querySelector('#offcanvas-cart, #cart');
            if (miniCart) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            BSS_B2B.cart.fixer(shopData, true, true);
                            handleAddEvent();
                        }
                    });
                });
                observer.observe(miniCart, {childList: true, subtree: false});
            }

        }
        // fix for nnjdesigns.com by namtp
        if ([13280].includes(app.storeId) && isBOGOApplied) {
            let cartDrawer = document.querySelector('.drawer__items');
            if (cartDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            setTimeout(()=>app.cart.fixer(shopData, null, false),3000);
                        }
                    });
                });
                observer.observe(cartDrawer, {childList: true});
            }
        }
        // fir for wexfords.myshopify.com by HoangNX1
        if([9364].includes(app.storeId) && isCPApplied) {
            setTimeout(() => {
                const variantUl = document.querySelector('form[action="/cart/add"] .swatch-view.swatch-view-button')
                if (variantUl) {
                    const variantList = variantUl.querySelectorAll("li");
                    if (variantList && variantList.length > 0) {
                        variantList.forEach(function(variant) {
                            variant.onclick = function() {
                                setTimeout(function() {app.cp.changeProductPrice(shopData, false, false);}, 200);
                            }
                        })
                    }
                }
            }, 500)

            if (app.page.isCollectionPage()) {
                setTimeout(() => {
                    const variants = document.querySelectorAll('li.swatch-view-item');
                    if (variants && variants.length > 0) {
                        variants.forEach(variant => {
                            variant.onclick = function() {
                                $('[bss-b2b-product-id][bss-b2b-product-active]').removeAttr('bss-b2b-product-active');
                                setTimeout(function() {app.cp.changeProductPrice(shopData, false, false);}, 200);
                            }
                        })
                    }
                }, 3000)
            }
        }
        // fix for 3881d8.myshopify.com by NamTP
        if ([13215].includes(app.storeId) && isCPApplied) {
            let cartItems = document.querySelector('#cart-items')
            if(cartItems){
                let observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, null, false);
                        }
                    });
                });
                observer.observe(cartItems, { childList: true });
            }
        }
        if ([14721].includes(app.storeId) && isCPApplied) {
            if (app.page.isProductPage()) {
                let variantOptions = document.querySelectorAll('.option-selector-fieldset .option-selector__btns .opt-label');
                if (variantOptions) {
                    variantOptions.forEach(i=>{
                        i.addEventListener("click", () => {
                            setTimeout(()=>{
                                app.cp.changeProductPrice(shopData, null, false);
                            },500)
                        });
                    })
                }
            }
        }
        // fix for 958572-2.myshopify.com by NamTP
        if ([15262].includes(app.storeId)) {
            let cartItems = document.querySelector('.yv-side-drawer-container.yv_cart-poroduct-container')
            if(cartItems){
                let observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, null, false);
                        }
                    });
                });
                observer.observe(cartItems, { childList: true });
            }
            let cartTable = document.querySelector('.yv-cart-table tbody')
            if (cartTable) {
                    let observer = new MutationObserver(function (mutations) {
                        mutations.forEach(function (m) {
                            if (m.type === "attributes") {
                              setTimeout(()=>{
                                app.cart.fixer(shopData, null, false);
                              },1500)
                            }
                        });
                    });
                    observer.observe(cartTable, { attributes: true });
            }
        }
        if ([2718, 3740, 8163, 11407, 12191, 8250, 9605, 12561, 12384, 13514, 11420, 13574, 14274, 14377, 14897, 16400].includes(app.storeId)) {
            let searchList = document.querySelectorAll(
                '#Search .Search__Results,' +
                ' .search-results-container,' +
                ' #search-popdown predictive-search,' +
                ' .drawer.drawer--right.upsell__modal,' +
                ' #search-popdown,' +
                ' .drawer__content,' +
                ' .card__section form,' +
                ' .search-results_list,' +
                ' .quick-search__results,' +
                '.search__predictive__main,' +
                '.btn-state-ready,' +
                '.product-form,' +
                '.main-search__results,' +
                '.product__info-wrapper.grid__item,' +
                '.quick-view,' +
                '.predictive-search.predictive-search--header,' +
                '.cart-recommendations,' +
                '.cart-drawer.focus-inset,' +
                '.header-sections,' +
                '.container-fluid.m-search-wrapper,' +
                '#predictive-search-toggle'
            );
            if (searchList && searchList.length > 0) {
                searchList.forEach((node) => {
                    let observer = new MutationObserver(function (mutations) {
                        mutations.forEach(function (m) {
                            if (m.addedNodes.length) {
                                BSS_B2B.cp.changeProductPrice(shopData, null,
                                    false,
                                );
                            }
                        });
                    });
                    observer.observe(node, { childList: true, subtree: true });
                });
            }
        }

        window.BSS_B2B.executeAction({ tag: `handle_compatible_with_third`, storeId: 16356, shopData });

        if ([13514, 12433, 11500].includes(app.storeId)) {
            const fixCollectionPage = () => {
                let count = 0;
                const itv = setInterval(() => {
                    count++
                    const itemCollectionGrid = $('.boost-sd__product-item.boost-sd__product-item--no-border.boost-sd__product-item-grid-view-layout')

                    const itemCollectionList = $('.boost-sd__product-item-list-view-layout')
                    if (itemCollectionGrid.length) {
                        clearInterval(itv)
                        Array.from(itemCollectionGrid).map((i) => {
                            const id = i.getAttribute('id')
                            const price = i.querySelector('.boost-sd__product-price')
                            if (price && id) {
                                price.setAttribute('bss-b2b-product-price', '')
                                price.setAttribute('bss-b2b-product-id', `${id}`)
                            }
                            if(app.storeId === 11500){
                                const selectOptionBtn = i.querySelector('.boost-sd__button.boost-sd__button--square.boost-sd__btn-quick-view')
                                selectOptionBtn.addEventListener('click', () => btnQuickView(id))
                            }
                        })

                        BSS_B2B.cp.changeProductPrice(shopData, false, false)
                    }

                    if (itemCollectionList.length) {
                        clearInterval(itv)
                        Array.from(itemCollectionList).map((i) => {
                            const id = i.getAttribute('id')
                            const btn = i.querySelector('.boost-sd__button.boost-sd__button--secondary.boost-sd__button--full-width.boost-sd__button--large.boost-sd__btn-quick-view')
                            const price = i.querySelector('.boost-sd__product-item-list-view-layout-price')
                            const selectOptionBtn = i.querySelector('.boost-sd__button.boost-sd__button--primary.boost-sd__button--full-width.boost-sd__button--large')
                            if (price && id) {
                                price.setAttribute('bss-b2b-product-price', '')
                                price.setAttribute('bss-b2b-product-id', `${id}`)
                                btn.addEventListener('click', () => btnQuickView(id))
                                selectOptionBtn.addEventListener('click', () => btnQuickView(id))
                            }
                        })

                        BSS_B2B.cp.changeProductPrice(shopData, false, false)
                    }

                    if (count > 10) {
                        count = 0;
                        clearInterval(itv)
                    }

                }, 500)
            }

            const btnQuickView = (id) => {
                setTimeout(() => {
                    const priceQV = document.querySelector('.boost-sd__quick-view-price')
                    if (priceQV) {
                        priceQV.setAttribute('bss-b2b-product-price', '')
                        priceQV.setAttribute('bss-b2b-product-id', `${id}`)
                        BSS_B2B.cp.changeProductPrice(shopData, null, false);
                    }
                }, 1000)
            }
            if ([12433, 11500].includes(app.storeId)) {
                fixCollectionPage();
            }
            let searchList = document.querySelectorAll('.wrapper.section-padding');
            if (searchList && searchList.length > 0 && (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage())) {
                searchList.forEach((node) => {
                    let observer = new MutationObserver(function (mutations) {
                        mutations.forEach(function (m) {
                            if (m.addedNodes.length) {
                                fixCollectionPage()
                            }
                        });
                    });
                    observer.observe(node, { childList: true, subtree: true });
                });
            }
        }

        if ([12388, 12433].includes(app.storeId)) {
            // fix CP on PDP
            if(app.storeId === 12388) {
                if (BSS_B2B.page.isProductPage()) {
                    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');

                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.target === sellingPlanInput && mutation.type === 'attributes' && mutation.attributeName === 'value') {
                                if (sellingPlanInput.value !== '') {
                                    const productBlock = document.querySelector('.product__price');
                                    if (productBlock) {
                                        productBlock.classList.add('hide');
                                    }
                                } else {
                                    const productBlock = document.querySelector('.product__price');
                                    if (productBlock) {
                                        productBlock.classList.remove('hide');
                                    }
                                }
                            }
                        });
                    });

                    observer.observe(sellingPlanInput, { attributes: true });

                    let isChangedPrice = false;
                    const itv = setInterval(() => {
                        const itemCollectionList = $(".rebuy-product-block");
                        if (itemCollectionList.length > 0) {
                            Array.from(itemCollectionList).map((i) => {

                                const classes = i.className.split(" ");
                                let productId = "";
                                classes.forEach((className) => {
                                    if (className.startsWith("product-id-")) {
                                        productId = className.replace("product-id-", "");
                                    }
                                });
                                const price = i.querySelector(".rebuy-money");
                                if (price && productId) {
                                    price.setAttribute("bss-b2b-product-price", "");
                                    price.setAttribute("bss-b2b-product-id", `${productId}`);
                                }

                                BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                isChangedPrice = true
                            });
                        }
                        if (isChangedPrice) {
                            clearInterval(itv);
                        }
                    }, 500);
                }

                // add event checkout 
                const addEventCheckout = () => {
                    const button = document.querySelector(".btn.cart__checkout")
                    const clonedButton = button.cloneNode(true);
                    button.parentNode.replaceChild(clonedButton, button);
                    setTimeout(() => {
                        BSS_B2B.handleCartCheckoutBtn(shopData)
                    }, 2000)
                }

                setTimeout(() => addEventCheckout(), 3000)

                const qtyInputButtons = document.querySelectorAll(".js-qty__adjust");
                qtyInputButtons.forEach((btn) => {
                    btn.addEventListener("click", () => {
                        addEventCheckout();
                    })
                });
            }
            
            // fix CP on search bar 

            const fixSearchBar = () => {
                const itemCollectionGrid = $(".boost-sd__suggestion-queries-item.boost-sd__suggestion-queries-item.boost-sd__suggestion-queries-item--product");
                if (itemCollectionGrid.length) {
                    Array.from(itemCollectionGrid).map((i) => {
                        const id = i.getAttribute("data-id");
                        const price = i.querySelector(".boost-sd__format-currency");
                        if (price && id) {
                            price.setAttribute("bss-b2b-product-price", "");
                            price.setAttribute("bss-b2b-product-id", `${id}`);
                        }
                    });
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                }
            }

            setTimeout(function () {
                let searchList = document.querySelectorAll('.boost-sd__instant-search-results');
                if (searchList && searchList.length > 0) {
                    searchList.forEach((node) => {
                        let observer = new MutationObserver(function (mutations) {
                            mutations.forEach(function (m) {
                                if (m.addedNodes.length) {
                                    fixSearchBar();
                                }
                            });
                        });
                        observer.observe(node, { childList: true, subtree: true });
                    });
                }
            }, 3000);

            // fix CP on search page
            if (BSS_B2B.page.isSearchPage()) {
                let isChangePriced = false;
                const itv = setInterval(() => {
                    const itemCollectionGrid = $(".boost-sd__product-item.boost-sd__product-item--no-border.boost-sd__product-item-grid-view-layout");
                    if (itemCollectionGrid.length) {
                        clearInterval(itv);
                        Array.from(itemCollectionGrid).map((i) => {
                            const id = i.getAttribute("id");
                            const price = i.querySelector(".boost-sd__product-price");
                            if (price && id) {
                                price.setAttribute("bss-b2b-product-price", "");
                                price.setAttribute("bss-b2b-product-id", `${id}`);
                            }
                        });
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                        isChangePriced = true;
                    }
                    if (isChangePriced) {
                        clearInterval(itv);
                    }
                }, 500);
            } 
        }

        if ([12191].includes(app.storeId)) {
            let searchList = document.querySelectorAll(
                '.product-add-popdown, .drawer__content');
            const handleCartFix = () => {
                setTimeout(function() {
                    BSS_B2B.cart.fixer(shopData, true, true);
                }, 2000);
            };

            const cartHeader = document.querySelector(
                'header.theme__header .header__mobile__right .header__mobile__button');
            if (cartHeader) {
                cartHeader.addEventListener('click', handleCartFix);
            }

            if (searchList && searchList.length > 0) {
                searchList.forEach((node) => {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes.length) {
                                const showCart = node.querySelector(
                                    '.product__popdown__cart.text-link.uppercase');
                                if (showCart) {
                                    showCart.addEventListener('click',
                                        handleCartFix,
                                    );
                                }
                                const removeItem = document.querySelectorAll(
                                    'nav#drawer-cart .drawer__content .drawer__body .cart__items .cart__items__grid a.cart__items__remove');
                                if (removeItem && removeItem.length) {
                                    removeItem.forEach((i) => {
                                        i.addEventListener('click',
                                            handleCartFix,
                                        );
                                    });
                                }
                                const btnChangeQty = document.querySelectorAll(
                                    'nav#drawer-cart .drawer__content .drawer__body .cart__items .cart__items__grid .cart__items__quantity button.quantity__button');
                                if (btnChangeQty && btnChangeQty.length) {
                                    btnChangeQty.forEach((i) => {
                                        i.addEventListener('click',
                                            handleCartFix,
                                        );
                                    });
                                }
                            }
                        });
                    });
                    observer.observe(node, {childList: true, subtree: true});
                });
            }
        }

        if ([12561].includes(app.storeId)) {
            let searchList = document.querySelectorAll('#cart-line-items');
            const handleCartFix = () => {
                setTimeout(function() {
                    BSS_B2B.cart.fixer(shopData, true, true);
                }, 500);
            };

            if (searchList && searchList.length > 0) {
                searchList.forEach((node) => {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes.length) {
                                const removeItem = document.querySelectorAll('.cart-table_column-5.line-item_remove');
                                if (removeItem && removeItem.length) {
                                    removeItem.forEach((i) => {
                                        i.addEventListener('click', handleCartFix);
                                    });
                                }
                            }
                        });
                    });
                    observer.observe(node, {childList: true, subtree: true});
                });
            }
        }

        if ([7977].includes(app.storeId)) {
            const searchIcons = document.querySelectorAll(
                '.show-search-link, .main-search__input');
            if (searchIcons.length) {
                searchIcons.forEach(function(icon) {
                    icon.addEventListener('mousedown', function() {
                        setTimeout(function() {
                            const searchResult = document.querySelector(
                                '.gl-fullscreen-initial-content');

                            if (searchResult) {
                                let observer = new MutationObserver(
                                    function(mutations) {
                                        mutations.forEach(function(m) {
                                            if (m.addedNodes.length) {
                                                BSS_B2B.cp.changeProductPrice(
                                                    shopData, null, false);
                                            }
                                        });
                                    });
                                observer.observe(searchResult,
                                    {childList: true, subtree: true},
                                );
                            }
                        }, 1000);
                    });
                });
            }
        }

        if (app.storeId === 7719 && document.getElementById('bss-b2b-cart-vat-style')) {
            let appliedDisplayRuleCart = null;
            if (isTDApplied) {
                appliedDisplayRuleCart = taxDisplayRules_default.a.getAppliedRuleCartPage(
                    BSS_B2B,
                    shopData,
                );
            }
            if ((qbStatus && tdStatus) || (qbStatus && !tdStatus)) {
                if (appliedDisplayRuleCart ||
                    (!appliedDisplayRuleCart && isQBApplied)) {
                    document.getElementById('bss-b2b-cart-vat-style').remove();
                }
            }
        }

        if (app.storeId === 9878 && isCPApplied) {
            const catchAndHidePriceWhenLoadPage = setInterval(() => {
                const price = document.querySelectorAll(
                    '#cart-drawer [bss-b2b-cart-item-key], [bss-b2b-cart-total-price]');
                if (price.length) {
                    let flag = 0;
                    price.forEach((item) => {
                        if (item.style.visibility === 'visible') {
                            item.style.visibility = 'hidden';
                            flag++;
                        }
                        if (flag === price.length) {
                            clearInterval(catchAndHidePriceWhenLoadPage);
                        }
                    });
                }
            }, 50);
            setTimeout(() => {
                clearInterval(catchAndHidePriceWhenLoadPage);
            }, 7000);
        }

        // fix for smartmovemedical by huydt
        if (app.storeId === 5980 && app.page.isProductPage() && isQBApplied) {
            try {
                const form = document.querySelector('#add-to-cart-form');
                const qbPosition = document.querySelector(
                    '.bss-b2b-qb-custom-position');
                if (qbPosition && form) {
                    const handleProductFormChange = (changes) => {
                        for (let change of changes) {
                            if (change.type === 'childList') {
                                const qbTable = form.querySelector(
                                    '.bss-b2b-cart-item-qty-table');
                                if (qbTable) {
                                    qbPosition.appendChild(qbTable);
                                }
                            }
                        }
                    };

                    const observer = new MutationObserver(
                        handleProductFormChange);
                    observer.observe(form, {
                        childList: true,
                    });
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e.message);
            }
        }
        else if (BSS_B2B.storeId === 6605) {
            const miniCart = document.querySelectorAll('#mini-cart');
            miniCart.forEach(item => {
                if (item) {
                    const handleMiniCart = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                setTimeout(() => {
                                    app.cart.fixer(shopData, false, true);
                                }, 2000);
                            }
                        }
                    };
                    const observer = new MutationObserver(handleMiniCart);
                    observer.observe(item, {
                        childList: true,
                    });
                }
            });
            $('.header__icon-list a[href="/cart"]').on('click', () => {
                setTimeout(() => {
                    app.cart.fixer(shopData, false, true);
                }, 3000);
            });
            const handleMiniCart = document.querySelector('#mini-cart');
            if (handleMiniCart) {
                const changeMiniCart = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            app.handleCartCheckoutBtn(shopData);
                        }
                    }
                };
                const observer = new MutationObserver(changeMiniCart);
                observer.observe(handleMiniCart, {
                    childList: true,
                });
            }
        }
        else if (app.storeId === 6317 && isCPApplied) {
            const $$ = document.querySelector.bind(document);
            const $$$ = document.querySelectorAll.bind(document);

            const debounceFnc = (callback, timeout = 300) => {
                let timer;

                return (...args) => {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        callback.apply(this, args);
                    }, timeout);
                };
            };

            if (app.page.isProductPage()) {
                $$('[bss-b2b-quantity-selector] input').addEventListener('change', e => {
                    const cpPriceValue = $$(
                        '.productView-price .price-item').textContent.trim();

                    cpPriceValue &&
                    ($$('[bss-b2b-price-subtotal]').textContent = BSS_B2B.formatMoney.call(
                        window,
                        e.target.value * cpPriceValue.slice(1) * 100,
                    ));
                });

                document.addEventListener('bss_b2b_doneCheckCp', () => {
                    setTimeout(() => {
                        const cpPriceValue = $$(
                            '.productView-price .price-item').textContent.trim();

                        cpPriceValue &&
                        ($$('[bss-b2b-price-subtotal]').textContent = BSS_B2B.formatMoney.call(
                            window,
                            $$('[bss-b2b-quantity-selector] input').value *
                            cpPriceValue.slice(1) * 100,
                        ));
                        $$('[bss-b2b-price-subtotal]').style.display = '';
                    });
                });

                const handleChangeVariant = debounceFnc(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                }, 800);

                $$$('.product-form__label[data-variant-id]').forEach(label => {
                    label.addEventListener('click', () => {
                        $$('[bss-b2b-price-subtotal]').style.display = 'none';
                        handleChangeVariant();
                    });
                });
            }

            const handleSearch = debounceFnc(() => {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }, 1500);

            $$('.search__input.field__input.form-input-placeholder').addEventListener('input', () => handleSearch());
            // fix for sim-usa-inc.myshopify.com by LuanHV
            const listProductCollection = document.querySelector(
                '#main-collection-product-grid');
            if (listProductCollection) {
                const handleShowMore = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            BSS_B2B.cp.changeProductPrice(shopData, null,
                                false,
                            );
                        }
                    }
                };
                const observer = new MutationObserver(handleShowMore);
                observer.observe(listProductCollection, {
                    childList: true,
                });
            }
            const listProductHomePage = document.querySelectorAll(
                '.shopify-section.sections-product-block');
            listProductHomePage.forEach(item => {
                if (item) {
                    const handleShowProduct = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                BSS_B2B.cp.changeProductPrice(shopData, null,
                                    false,
                                );
                            }
                        }
                    };
                    const observer = new MutationObserver(handleShowProduct);
                    observer.observe(item, {
                        childList: true, subtree: true,
                    });
                }
            });
        }
        // fix by Tapo searchbar for precommande-legend-stuff.myshopify
        else if (BSS_B2B.storeId === 6306 && isCPApplied) {
            let inputSearchBar = document.querySelector(
                '.search-modal__form .search__input.field__input');
            if (inputSearchBar) {
                inputSearchBar.addEventListener('keyup', function() {
                    setTimeout(function() {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }, 2000);
                });
            }
        }
        else if (BSS_B2B.storeId === 8173 && isCPApplied) {
            let inputSearchBar = document.querySelector(
                '.main-search__form .main-search__input');
            if (inputSearchBar) {
                inputSearchBar.addEventListener('keyup', function() {
                    setTimeout(function() {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }, 2000);
                });
            }
        }
        //fix for earfab.myshopify.com and nailberry-london.myshopify and 96e191.myshopify.com, aupisen.myshopify.com
        else if ([9211, 9353, 10029, 4999, 11001, 11265, 10115, 11510, 8005, 13755, 14106, 11946, 14626, 15196].indexOf(BSS_B2B.storeId) !== -1 &&
            isCPApplied) {
            let searchField = $(
                '#search-form-sidebarm,' +
                'form .search__input.field__input,' +
                '.search-input.input-group-field,' +
                '#searchbox-,' +
                'input.search--textbox,' +
                '.t4s-mini-search__input,' +
                '.form-field-input.live-search-form-field,' +
                '.search__predictive__form input,' +
                '.header-search__input.input__field,' +
                'input.w-full.h-11,' +
                'input.form-field.form-field--input[type=search]'
            );
            let searchBtn = $('#Search-drawer-button-header')
            if (searchBtn && BSS_B2B.storeId == 15196) {
                searchBtn.on('click', () => {
                  searchField = $('input#search-desktop')
                  if (searchField) {
                    searchField.on('keyup', () => {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, false, false);
                        }, 1500);
                    });
                }
                });
            }
            if (searchField) {
                searchField.on('keyup', () => {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }, 1500);
                });
            }
        }
        if (BSS_B2B.storeId === 8005) {
            if (!BSS_B2B.page.isCartPage()) {
                let handleCart = () => {
                    $('.quantity__wrapper .quantity__button,.cart__items__grid .cart__items__remove').
                        on('click', () => {
                            setTimeout(() => {
                                BSS_B2B.cart.fixer(shopData, false, true);
                                handleCart();
                            }, 2000);
                        });
                    $('.quantity__wrapper .quantity__input').on('change', () => {
                        setTimeout(() => {
                            BSS_B2B.cart.fixer(shopData, false, true);
                            handleCart();
                        }, 2000);
                    });
                };
                setTimeout(() => {
                    handleCart();
                }, 1500);
            }
        }
        if (BSS_B2B.storeId === 10115 && isQBApplied && isCPApplied) {
            let handleChangeQty = () => {
                $('.ajaxcart__qty-adjust').on('click', () => {
                    let interval = setInterval(() => {
                        if ($('.bss-qb-cart-subtotal').length) {
                            $('.cart-total__subtotal .cart-total__subtotal-price').css('display', 'none');
                        }
                    }, 300);
                    setTimeout(() => clearInterval(interval), 7000);
                    let intervalAddEvent = setInterval(() => {
                        if ($('.ajaxcart__qty-adjust').length) {
                            handleChangeQty();
                            clearInterval(intervalAddEvent);
                        }
                    }, 300);
                });
            };
            handleChangeQty();
        }
        //fix for arcticmed.myshopify.com
        else if (app.storeId === 10270) {
            let buttonCart = $(
                '.minicart__button.minicart__button--shopping-cart');
            if (buttonCart && buttonCart.length) {
                buttonCart.on('click', () => {
                    setTimeout(function() {
                        BSS_B2B.cart.fixer(shopData, false, true);
                    }, 1000);
                });
            }
            setTimeout(() => {
                app.cart.fixer(shopData, false, false);
                app.handleCartCheckoutBtn(shopData);
            }, 3000);
        }
        //fix for group-tsa-ltd.myshopify.com
        else if ([994, 13525, 13923, 15204, 13092].includes(app.storeId)) {
            if (isTDApplied) {
                const debounceFnc = (callback, timeout = 1000) => {
                    let timer;
                    return (...args) => {
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            callback.apply(this, args);
                        }, timeout);
                    };
                };
                let flag = true;
                let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(BSS_B2B, shopData);
                let collectionProduct = $('.card-information__wrapper.text-left, .price_range, .carousel.block');
                if (app.storeId === 13525) {
                    collectionProduct = $(".product-recommendations-placeholder")
                }
                if (collectionProduct.length) {
                    const mutationObserver = new MutationObserver(() => {
                        (debounceFnc(() => {
                            if (flag) {
                                fix_Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                            }
                            flag = !flag;
                        }))();
                    });
                    mutationObserver.observe(document.body, {childList: true, subtree: true});
                }
                window.BSS_B2B.executeAction({tag: 'handle_search_bar_with_TD', storeId: 13923, Tax: fix_Tax, appliedDisplayRule, shopData});
                window.BSS_B2B.executeAction({tag: 'handle_quickview_with_TD', storeId: 13923, Tax: fix_Tax, BSS_B2B, shopData});
                window.BSS_B2B.executeAction({tag: 'handle_quickview_with_TD', storeId: 13092, Tax: fix_Tax, appliedDisplayRule, BSS_B2B, shopData});
                window.BSS_B2B.executeAction({tag: 'handle_quickview_with_TD', storeId: 15690, Tax: fix_Tax, appliedDisplayRule, shopData});
            }
        }
        //fix for paloffner-shop.myshopify.com
        else if ([4264, 9605].includes(BSS_B2B.storeId)) {
            if (isTDApplied) {
                let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                    BSS_B2B, shopData);
                let searchField = $(
                    'input.quick-search__input,input[name="q"]');
                if (searchField) {
                    searchField.on('keyup', () => {
                        setTimeout(() => {
                            fix_Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                shopData,
                                appliedDisplayRule,
                            );
                            BSS_B2B.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1000);
                    });
                }
            }
            if (BSS_B2B.storeId === 9605) {
                const cartForm = document.querySelector(
                    '.cart-section cart-form');
                if (cartForm) {
                    const handleShowProduct = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                app.cart.fixer(shopData, false, false);
                            }
                        }
                    };
                    const observer = new MutationObserver(handleShowProduct);
                    observer.observe(cartForm, {
                        childList: true,
                    });
                }
            }
        }
        else if (BSS_B2B.storeId === 12691) {
            setTimeout(() => {
                const subTotalPrice = document.querySelector(
                    '.bss-qb-cart-subtotal');
                subTotalPrice.classList.add('cart__footer__value');
            }, 1500);
        }
        else if (BSS_B2B.storeId === 11605 && isCPApplied) {
            //quickview
            const quickView = document.querySelector('body');
            if (quickView) {
                const observerQV = new MutationObserver(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                });
                observerQV.observe(quickView, {childList: true});
            }
            //searchbar
            const searchBar = document.querySelector('.predictive-search');
            if (searchBar) {
                const observerSB = new MutationObserver(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                });
                observerSB.observe(searchBar, {childList: true, subtree: true});
            }
        }
        else if (BSS_B2B.storeId === 9006 && isCPApplied &&
            (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isProductPage())) {
            const observer = new MutationObserver(() => {
                app.cp.changeProductPrice(shopData, false, false);
            });
            observer.observe(document, {childList: true, subtree: true});
        }
        else if (BSS_B2B.page.isCollectionPage() && BSS_B2B.storeId === 10623) {
            let btnQuickView = document.querySelectorAll(
                '.btn-5.button-card.btn--regular.quickshop-btn-js');
            if (btnQuickView.length) {
                btnQuickView.forEach((item) => {
                    item.addEventListener('click', () => {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, false,
                                false, true,
                            );
                        }, 1000);
                    });
                });
            }
        }
        else if (BSS_B2B.storeId === 11769 && isCPApplied) {
            const quickViewWrapper = document.querySelector(
                '#Product-Drawer-Content');
            if (quickViewWrapper) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                            app.cp.changeProductPrice(shopData, false, false);
                            app.handleAjaxCart();
                        }
                    });
                });
                observer.observe(quickViewWrapper, {childList: true});
            }
        }
        else if (BSS_B2B.storeId === 9907 && isCPApplied) {
            const variantOption = document.querySelector(
                'div[aria-haspopup="listbox"]');
            if (variantOption) {
                variantOption.addEventListener('mousedown', () => {
                    setTimeout(() => {
                        let listVariants = document.querySelectorAll(
                            'div[role=\'presentation\'] ul li');
                        if (listVariants.length) {
                            listVariants.forEach((item) => {
                                item.addEventListener('click', () => {
                                    setTimeout(() => {
                                        app.cp.changeProductPrice(shopData,
                                            false, false,
                                        );
                                    }, 1000);
                                });
                            });
                        }
                    }, 500);
                });
            }
        }
        else if (BSS_B2B.storeId === 9207 && isCPApplied) {
            const buttonQuickBuy = document.querySelectorAll(
                '.quickbuy-container .inner');
            if (buttonQuickBuy.length) {
                buttonQuickBuy.forEach((item) => {
                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'childList') {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                                const buttonChangeVariant = document.querySelectorAll(
                                    '.option-selector-fieldset .option-selector__btns');
                                if (buttonChangeVariant.length) {
                                    buttonChangeVariant.forEach((item) => {
                                        item.addEventListener('change', () => {
                                            setTimeout(() => {
                                                app.cp.changeProductPrice(
                                                    shopData, false, false);
                                            }, 1500);
                                        });
                                    });
                                }
                                const buttonAdToCart = document.querySelectorAll(
                                    'button.button.button--large');
                                if (buttonAdToCart.length) {
                                    buttonAdToCart.forEach((item) => {
                                        item.addEventListener('click', () => {
                                            setTimeout(() => {
                                                app.handleAjaxCart($, BSS_B2B,
                                                    shopData,
                                                );
                                                app.cart.fixer(shopData, false,
                                                    true,
                                                );
                                            }, 1000);
                                        });
                                    });
                                }
                            }
                        });
                    });
                    observer.observe(item, {childList: true});
                });
            }
        }
        else if (app.storeId === 9342 && isCPApplied) {
            const priceWrapper = document.querySelector(
                '.main-search__container .main-search__results');
            if (priceWrapper) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                            app.cp.changeProductPrice(shopData, false, false);
                        }
                    });
                });
                observer.observe(priceWrapper,
                    {childList: true, subtree: true},
                );
            }
        }
        else if (app.storeId === 8553 && isCPApplied) {
            app.cart.fixer(shopData, false, false);
            const priceWrapper = document.querySelector(
                '.product__details .product__price-container');
            if (priceWrapper) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                            app.cp.changeProductPrice(shopData, false, false);
                        }
                    });
                });
                observer.observe(priceWrapper,
                    {childList: true, subtree: true},
                );
            }
        }
        else if (BSS_B2B.storeId === 9124 && isCPApplied) {
            let searchBar = document.querySelector(
                '.search-bar__container .search-bar__results');
            if (searchBar) {
                const handleSearch = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            setTimeout(() => {
                                BSS_B2B.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }, 1000);
                        }
                    }
                };
                const observer = new MutationObserver(handleSearch);
                observer.observe(searchBar, {
                    childList: true,
                });
            }
        }
        else if (BSS_B2B.storeId === 8856 && isCPApplied) {
            let searchBar = document.querySelector(
                'search-form .search-results-container');
            if (searchBar) {
                const handleSearch = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            setTimeout(() => {
                                BSS_B2B.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }, 1000);
                        }
                    }
                };
                const observer = new MutationObserver(handleSearch);
                observer.observe(searchBar, {
                    childList: true,
                });
            }
        }
        else if (BSS_B2B.storeId === 8694 && isCPApplied) {
            let searchBar = document.querySelector(
                '.search-bar__results .search-bar__results-inner');
            if (searchBar) {
                const handleSearch = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            setTimeout(() => {
                                BSS_B2B.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }, 1000);
                        }
                    }
                };
                const observer = new MutationObserver(handleSearch);
                observer.observe(searchBar, {
                    childList: true,
                });
            }
        }
        // fix by Tapo
        else if (BSS_B2B.storeId === 8537 && isCPApplied) {
            const changePriceCart = () => {
                let buttonQuantity = document.querySelectorAll(
                    '.cart__form-item-quantity-wrapper .quantity-input__button,' +
                    '.quick-cart__item-bottom .quantity-input__button');
                if (buttonQuantity.length) {
                    for (let i = 0; i < buttonQuantity.length; i++) {
                        buttonQuantity[i].addEventListener('click', () => {
                            setTimeout(() => {
                                changePriceCart();
                                app.cart.fixer(shopData, false, true);
                            }, 1500);
                        });
                    }
                }
            };
            changePriceCart();
            let inputInSearchBar = document.querySelector(
                '.quick-search__bar .quick-search__input');
            if (inputInSearchBar) {
                inputInSearchBar.addEventListener('keyup', function() {
                    setTimeout(function() {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }, 2000);
                });
            }
        }
        else if (BSS_B2B.storeId === 8653 && isCPApplied) {
            //Fix product recommendation for
            // https://house-raccoon.myshopify.com in cart page
            if (app.page.isCartPage()) {
                BSS_B2B.cp.changeProductPrice(shopData, false, false);
            }

            if (app.page.isProductPage()) {
                const handleChangeVariant = () => {
                    const variantsSelector = document.querySelectorAll(
                        '.js .input__list,' + '.card-swatches li');
                    if (variantsSelector.length) {
                        for (let i = 0; i < variantsSelector.length; i++) {
                            variantsSelector[i].addEventListener('click',
                                () => {
                                    setTimeout(() => {
                                        BSS_B2B.cp.changeProductPrice(shopData,
                                            false, false,
                                        );
                                        handleChangeVariant();
                                    }, 1500);
                                },
                            );
                        }
                    }
                };
                handleChangeVariant();
            }
            let inputInSearchBar = document.querySelector(
                '.header-search__input-group .header-search__input');
            if (inputInSearchBar) {
                inputInSearchBar.addEventListener('keyup', function() {
                    setTimeout(function() {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }, 2000);
                });
            }
        }
        else if ([4285, 9793].includes(BSS_B2B.storeId) && isCPApplied) {
            let miniCart = document.querySelector(
                '.halo-modal-content .halo-modal-body .cart-popup-content');
            if (BSS_B2B.storeId === 9793) {
                miniCart = document.querySelector(
                    '.bt-dropdown__content.bt-dropdown__content--right.bt-dropdown__content--right-fluid');
            }
            if (miniCart) {
                const showMiniCart = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            app.cart.fixer(shopData, false, true);
                            if (BSS_B2B.storeId === 9793) {
                                BSS_B2B.handleCartCheckoutBtn(shopData);
                            }
                        }
                    }
                };
                const observer = new MutationObserver(showMiniCart);
                observer.observe(miniCart, {
                    childList: true,
                });
            }
        }
        else if (BSS_B2B.storeId === 7860) {
            let miniCart = document.querySelector(
                '#CartDrawerForm .drawer__scrollable');
            if (miniCart) {
                const showMiniCart = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            app.cart.fixer(shopData, false, true);
                        }
                    }
                };
                const observer = new MutationObserver(showMiniCart);
                observer.observe(miniCart, {
                    childList: true, subtree: true,
                });
            }
        }
        else if (app.storeId === 7567 && isCPApplied) {
            $('.d-flex.flex-center.rounded-circle.cursor-pointer').on('click', () => {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                }, 500);
            });
        }
        else if (BSS_B2B.storeId === 7332 && isCPApplied) {
            const handleSearchBar = document.querySelector(
                '.search__results__products__list.search__results__products__list--borderless');
            if (handleSearchBar) {
                const renderListProduct = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    }
                };
                const observer = new MutationObserver(renderListProduct);
                observer.observe(handleSearchBar, {
                    childList: true,
                });
            }
        }
        else if (BSS_B2B.storeId === 7823 && isCPApplied) {
            const showQuickView = document.querySelectorAll(
                '#modal-quick-view-collection-template .modal__inner, .container .boost-pfs-filter-wrapper .collection .card .product-list--collection');
            if (showQuickView.length > 0) {
                showQuickView.forEach((item) => {
                    const renderListProduct = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                app.cp.changeProductPrice(shopData, null,
                                    false,
                                );
                            }
                        }
                    };
                    const observer = new MutationObserver(renderListProduct);
                    observer.observe(item, {
                        childList: true, subtree: true,
                    });

                });
            }
        }
        else if (BSS_B2B.storeId === 4279 && isCPApplied) {
            const listProduct = document.querySelector(
                '.boost-pfs-filter-products');
            if (listProduct) {
                const renderListProduct = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            app.cp.changeProductPrice(shopData, null, false);
                        }
                    }
                };
                const observer = new MutationObserver(renderListProduct);
                observer.observe(listProduct, {
                    childList: true,
                });
            }
        }
        // fix for hlh-biopharma-gmbh.myshopify.com
        else if (BSS_B2B.storeId === 571 && isCPApplied) {
            let buttonQuickView = $(
                '.grid-view-item  a.quick-add-button-variants');
            if (buttonQuickView.length) {
                buttonQuickView.on('click', () => {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData,
                            '#ShopNowContainer #ProductPrice ', false, true,
                        );
                        addChangeVariantEvent();
                    }, 3000);
                    const addChangeVariantEvent = () => {
                        document.querySelectorAll(
                            '#ShopNowContainer .swatch.clearfix .swatch-element.available').forEach((item) => {
                            item.onclick = function() {
                                app.cp.changeProductPrice(shopData,
                                    '#ShopNowContainer #ProductPrice ',
                                    false, true,
                                );
                            };
                        });
                    };
                });
            }
        }
        // fix for www.cheekychain-business.com by LuanHV
        else if (BSS_B2B.storeId === 5284 && isCPApplied) {
            const buttonVariant = document.querySelectorAll(
                '.radio__fieldset>span');
            buttonVariant.forEach((e) => {
                e.addEventListener('click', () => {
                    app.cp.changeProductPrice(shopData,
                        '.customize-price-variant',
                        false,
                    );
                });
            });
        }
        // fix for marketing-879.myshopify.com by LuanHV
        else if (BSS_B2B.storeId === 6958 && isCPApplied) {
            setTimeout(() => {
                const addToCart = document.querySelector(
                    'input.w-commerce-commerceaddtocartbutton[type="submit"]');
                addToCart.addEventListener('click', () => {
                    setTimeout(() => {
                        app.cart.fixer(shopData, false, true);
                    }, 3000);
                }, 2000);
            });
        }
        // fix for en.vintega.eu by LuanHV
        else if (app.storeId === 6812 && isCPApplied) {
            if (app.page.isCartPage()) {
                const changeCart = setInterval(() => {
                    app.cart.fixer(shopData, false, false);
                    app.handleCartCheckoutBtn(shopData);
                }, 2000);
                setTimeout(() => {
                    clearInterval(changeCart);
                }, 10000);
            }
        }
        // fix for new.naturalcreations925.com by LuanHV
        else if (app.storeId === 5686) {
            if (isCPApplied) {
                const searchProduct = document.querySelector(
                    '.predictive-search');
                const quickView = $('.quickview-icon');
                if (searchProduct) {
                    const handleSearch = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                app.cp.changeProductPrice(shopData, null,
                                    false,
                                );
                            }
                        }
                    };
                    const observer = new MutationObserver(handleSearch);
                    observer.observe(searchProduct, {
                        childList: true,
                    });
                }
                quickView.on('click', () => {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData, null, false);
                    }, 2000);
                });
            }
            if (screen.width < 1025) {
                setTimeout(() => {
                    app.handleCartCheckoutBtn(shopData);
                    app.cart.fixer(shopData, false, true);
                }, 3500);
            }
        }
        else if (app.storeId === 9436) {
            if (isTDApplied) {
                let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                    BSS_B2B, shopData);
                let searchInput = document.querySelector(
                    '.search__input.field__input');
                if (searchInput) {
                    searchInput.addEventListener('input', function() {
                        let searchResult = document.querySelector(
                            '.predictive-search.predictive-search--header');
                        if (searchResult) {
                            let observer = new MutationObserver(
                                function(mutations) {
                                    mutations.forEach(function(m) {
                                        if (m.addedNodes.length) {
                                            tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                                shopData,
                                                appliedDisplayRule,
                                            );
                                        }
                                    });
                                });
                            observer.observe(searchResult, {childList: true});
                        }
                    });
                }
            }
        }
        else if (BSS_B2B.storeId === 9726) {
            if (app.page.isCartPage()) {
                const cartForm = document.querySelector('div[data-cart-form]');
                if (cartForm) {
                    const observer = new MutationObserver((mutationsList) => {
                        for (const mutation of mutationsList) {
                            if (mutation.type === 'attributes' &&
                                mutation.attributeName ===
                                'class') {
                                app.cart.fixer(shopData, false, false);
                            }
                        }
                    });
                    observer.observe(cartForm,
                        {attributes: true, attributeFilter: ['class']},
                    );
                }
            }
            else {
                const qtyInput = document.querySelectorAll(
                    '.quantity-selector #Quantity, .product__block__quantity .quantity__input');
                qtyInput.forEach((element) => {
                    element.addEventListener('change', function() {
                        app.cp.changeProductPrice(shopData, false, false);
                    });
                });
                const addToCart = document.querySelectorAll(
                    '.quantity-add-to-cart-wrapper input.add-to-cart');
                addToCart.forEach((element) => {
                    element.addEventListener('click', function() {
                        app.cp.changeProductPrice(shopData, false, false);
                    });
                });
            }
        }
        // fix for cadenzashop.myshopify.com by LuanHV
        else if (app.storeId === 6249 && isCPApplied) {
            $('.nt_action .iccl-search').on('click', () => {
                const inputSearch = document.querySelector(
                    '.frm_search_input .search_header__input');
                if (inputSearch) {
                    const debounceFnc = (callback, timeout = 300) => {
                        let timer;

                        return (...args) => {
                            clearTimeout(timer);
                            timer = setTimeout(() => {
                                callback.apply(this, args);
                            }, timeout);
                        };
                    };
                    const handleSearch = debounceFnc(() => {
                        BSS_B2B.cp.changeProductPrice(shopData, null, false);
                    }, 1500);

                    inputSearch.addEventListener('input', () => handleSearch());
                }
            });
        }
        else if (app.storeId === 6456 && isCPApplied) {
            if (app.page.isCartPage()) {
                const handleChangeQuantity = function() {
                    $('.t4s-quantity-input').on('change', function() {
                        setTimeout(function() {
                            app.cart.cartQtyOnChange(1000, 1000, true);
                            handleChangeQuantity();
                        }, 2000);
                    });
                };
                handleChangeQuantity();
            }
        }
        //fix for pure-grips
        else if (app.storeId === 6526) {
            if (app.page.isCartPage()) {
                app.cp.changeProductPrice(shopData, false, false);
            }
            let searchResult = document.querySelector('#search-drawer');
            if (searchResult) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, false, false);
                        }
                    });
                });
                observer.observe(searchResult,
                    {childList: true, subtree: true},
                );
            }
        }
        //fix for ergonomiafurniture.myshopify.com
        else if (BSS_B2B.storeId === 7354) {
            $('input.add-to-cart').on('click', function() {
                setTimeout(function() {
                    app.cart.fixer(shopData, false, true);
                }, 2000);
            });
        }
        //fix for white-horse-r-d-inc.myshopify.com
        else if (BSS_B2B.storeId === 7584) {
            $('.product-index-inner .product-modal').on('click', function() {
                setTimeout(function() {
                    app.cp.changeProductPrice(shopData, null, false);
                }, 2000);
            });
        }
        //fix for screenshelf
        else if (app.storeId === 918 && isCPApplied) {
            $('.quantity-part .qtyminus, .quantity-part .qtyplus').on('click', function() {
                app.cp.changeProductPrice(shopData, null, false);
            });
            $('.quantity-part input[name="quantity"].quantity').on('change', function() {
                app.cp.changeProductPrice(shopData, null, false);
            });
        }
        //fix for pet-distributor
        else if (app.storeId === 6674 && isCPApplied) {
            if (!app.page.isCartPage()) {
                app.handleCartCheckoutBtn(shopData);
                const handleChangeQuantity = function() {
                    $('quantity-input.quantity').on('change', function() {
                        setTimeout(function() {
                            app.handleCartCheckoutBtn(shopData);
                            app.cart.cartQtyOnChange(1000, 1000, true);
                            handleChangeQuantity();
                        }, 2000);
                    });
                };
                handleChangeQuantity();
            }
        }
        else if (app.storeId === 10748) {
            if (app.page.isCollectionPage()) {
                $('.btn.btn--secondary.quickbuy-toggle').on('click', () => {
                    let interval = setInterval(() => {
                        if ($('button[data-add-to-cart-text="Add to Cart"]').length) {
                            $('button[data-add-to-cart-text="Add to Cart"]').on('click', () => {
                                setTimeout(function() {
                                    app.cart.fixer(shopData, false, true);
                                }, 1000);
                            });
                        }
                        if ($('.option-selector__btns').length) {
                            $('.option-selector__btns').on('click', () => {
                                setTimeout(function() {
                                    app.cp.changeProductPrice(shopData, '[bss-b2b-variant-id]', false, true);
                                }, 500);
                            });
                        }
                    }, 300);
                    setTimeout(() => clearInterval(interval), 5000);
                });
            }
        }
        //fix for brazil-beauty-brands
        else if (app.storeId === 6456) {
            if (!app.page.isCartPage()) {
                if (app.page.isProductPage()) {
                    $('button.t4s-sticky-atc__atc').on('click', function() {
                        setTimeout(function() {
                            app.cart.fixer(shopData, false, true);
                        }, 1000);
                    });
                }
                else {
                    setTimeout(function() {
                        $('.t4s-pr-item-btn').on('click', function() {
                            setTimeout(function() {
                                app.cart.fixer(shopData, false, true);
                                $('button.t4s-product-form__submit').on('click', function() {
                                    setTimeout(function() {
                                        app.cart.fixer(shopData, false,
                                            true,
                                        );
                                    }, 1500);
                                });
                            }, 1500);
                        });
                    }, 500);
                }
            }
        }
        // fix for veevus.com by LuanHV
        else if (app.storeId === 7925 && isCartPage) {
            const handleCartPage = () => {
                let handleCartItem = document.querySelectorAll(
                    'cart-remove-button .button--tertiary');
                if (handleCartItem.length) {
                    handleCartItem.forEach((button) => {
                        button.addEventListener('click', () => {
                            setTimeout(() => {
                                app.handleCartCheckoutBtn(shopData);
                                handleCartPage();
                            }, 2000);
                        });
                    });
                }
                let changeQuantity = document.querySelectorAll(
                    '.quantity .quantity__input');
                if (changeQuantity.length) {
                    changeQuantity.forEach((input) => {
                        input.addEventListener('change', () => {
                            setTimeout(() => {
                                app.handleCartCheckoutBtn(shopData);
                                handleCartPage();
                            }, 2000);
                        });
                    });
                }
            };
            handleCartPage();
        }
        else if (app.storeId === 7619 && app.page.isProductPage()) {
            let selectChangeVariant = $(
                '.product__select-variant.u-full-width.u-blue.js-dataLayer-uxClick');
            if (selectChangeVariant.length) {
                selectChangeVariant.on('click', function() {
                    setTimeout(() => {
                        BSS_B2B.cp.changeProductPrice(shopData,
                            '[bss-b2b-variant-price]',
                            false,
                        );
                    }, 1500);
                });
            }
        }
        else if (app.storeId === 12498 &&
            (app.page.isCollectionPage() || app.page.isSearchPage() || app.page.isProductPage())) {
            let changeVariant = document.querySelectorAll(
                'product-recommendations, .product-grid.grid--4-col-desktop');
            if (changeVariant.length) {
                const mutationObServer = new MutationObserver(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                });
                changeVariant.forEach(target => {
                    mutationObServer.observe(target,
                        {childList: true, subtree: true},
                    );
                });
            }
        }
        // fix for number-a-eyewear by Devlin
        else if (app.storeId === 11407 && app.page.isProductPage()) {
            let selectChangeVariant = $(
                '.product-page .product__block__variants .form__selectors');
            if (selectChangeVariant.length) {
                selectChangeVariant.on('click', function() {
                    BSS_B2B.cp.changeProductPrice(shopData,
                        '[bss-b2b-variant-price]',
                        false,
                    );
                });
            }
        }
        // fix for perfectshinehair by Devlin
        else if (app.storeId === 641 && app.page.isProductPage()) {
            setTimeout(() => {
                BSS_B2B.cp.changeProductPrice(shopData,
                    '[bss-b2b-variant-price]',
                    false,
                );
            })
        }
        // fix for grumpymonkeyofficial by Devlin
        else if (app.storeId === 13453 && isCPApplied) {
            // change variant
            if (app.page.isProductPage()) {
                const priceEle = document.querySelector('.product__info .price-list');
                if (priceEle) {
                    const handleChangeVariant = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'childList') {
                                BSS_B2B.cp.changeProductPrice(shopData, false, false);
                            }
                        }
                    };
                    const observer = new MutationObserver(handleChangeVariant);
                    observer.observe(priceEle, {
                        childList: true,
                    });
                }
            }
            // search bar
            const searchBar = document.querySelector('.drawer__content .predictive-search__content-wrapper .predictive-search__results');
            if (searchBar) {
                const handleSearch = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            BSS_B2B.cp.changeProductPrice(shopData, false, false);
                        }
                    }
                };
                const observer = new MutationObserver(handleSearch);
                observer.observe(searchBar, {
                    childList: true,
                });
            }
        }
        else if(app.storeId === 15109) {
            window.onload = () => {
                let btn_variants = document.querySelectorAll('.option-selector .option-selector__btns input');
                btn_variants.forEach((btn) => {
                    btn.addEventListener("click", () => {
                        BSS_B2B.cp.changeProductPrice(shopData, '.price__default .price__current', false, false);
                    })
                });
            }
        }
        //fix for candybig by QuyenPV
        else if (app.storeId === 11610) {
            if (isTDApplied) {
                let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                    BSS_B2B, shopData);
                let searchInput = document.querySelector('.search__input');
                let buttonChangeVariant = document.querySelectorAll('.option-selector__btns .opt-label--btn');
                let productSectionObserver = document.querySelectorAll(
                    'product-recommendations, .main-products-grid__results.relative');
                if (searchInput) {
                    searchInput.addEventListener('input', function() {
                        let searchResult = document.querySelector(
                            '.js-search-results');
                        if (searchResult) {
                            let observer = new MutationObserver(
                                function(mutations) {
                                    mutations.forEach(function(m) {
                                        if (m.addedNodes.length) {
                                            tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                                shopData,
                                                appliedDisplayRule,
                                            );
                                        }
                                    });
                                });
                            observer.observe(searchResult, {childList: true});
                        }
                    });
                }
                if (productSectionObserver && productSectionObserver.length >
                    0) {
                    productSectionObserver.forEach((productSection) => {
                        let observer = new MutationObserver(
                            function(mutations) {
                                mutations.forEach(function(m) {
                                    if (m.addedNodes.length) {
                                        tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                            shopData,
                                            appliedDisplayRule,
                                        );
                                    }
                                });
                            });
                        observer.observe(productSection, {childList: true});
                    });
                }

                if (buttonChangeVariant && buttonChangeVariant.length > 0) {
                    buttonChangeVariant.forEach(function(btnChangeVariant) {
                        btnChangeVariant.addEventListener('click', function() {
                            setTimeout(() => {
                                const variantId = window.location.href.split('=')[1];
                                tax_default.a.bssB2BChangeVatPrice(variantId, shopData, false);
                            }, 200);
                        });
                    });
                }
            }
        }
        else if (app.storeId === 11946) {
            if(isTDApplied) { 
                setTimeout(() => {
                   let variantId = window.location.href.split('=')[1];
                   BSS_B2B.cp.changeProductPrice(shopData, ".f-price-item.f-price-item--regular", false, false, variantId);
                }, 1500)
                let buttonChangeVariant = document.querySelectorAll('.variant-picker__option');
                if (buttonChangeVariant && buttonChangeVariant.length > 0) {
                    buttonChangeVariant.forEach(function(btnChangeVariant) {
                        btnChangeVariant.addEventListener('click', debounce(function() {
                            let variantId = window.location.href.split('=')[1];
                            BSS_B2B.cp.changeProductPrice(shopData, ".f-price-item.f-price-item--regular", false, false, variantId);
                        }), 1500);
                    });
                }
                window.onload = () => {
                  let buttonAddToCart = document.querySelector('button[bss-ajax-cart-checkout-event]');
                  buttonAddToCart.addEventListener('click',function() {
                       setTimeout(() => {
                         let variantId = window.location.href.split('=')[1];
                         BSS_B2B.cp.changeProductPrice(shopData, ".f-price-item.f-price-item--regular", false, false, variantId);
                      }, 1000)
                  });
                }
            }
        }
        // fix for atmooz-b2b by Khanh
        else if ([6147, 7743, 8927, 3576, 9817, 10482, 10812, 11257].indexOf(app.storeId) !== -1 && isCPApplied) {
            const debounceFnc = (callback, timeout = 300) => {
                let timer;

                return (...args) => {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        callback.apply(this, args);
                    }, timeout);
                };
            };

            const handleSearch = debounceFnc(() => {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }, 1500);

            if ([6147, 9817, 11257].includes(app.storeId)) {
                let searchIcon;
                let searchInput;
                if (app.storeId === 6147) {
                    searchIcon = '.hdicon.searchIco';
                    searchInput = '.input-group__field.search__input';
                }
                else if (app.storeId === 9817) {
                    searchIcon = '.header__linklist-item.search-drawer';
                    searchInput = '.predictive-search__input';
                }
                else if (app.storeId === 11257) {
                    searchIcon = '.header__nav-icon';
                    searchInput = '.header-search__input';
                }
                $(searchIcon).on('click', () => {
                    const inputSearch = document.querySelector(searchInput);
                    if (inputSearch) {
                        inputSearch.addEventListener('input',
                            () => handleSearch(),
                        );
                    }
                });
            }
            //Fix for https://image-first-uniforms-2.myshopify.com by dong lt
            else if ([7743, 10482].includes(app.storeId)) {
                let inputSearch = document.querySelector(
                    '.form-field-input.live-search-form-field.form-field-filled');
                if (app.storeId === 10482) {
                    inputSearch = document.querySelector(
                        '.input-group-field.header-search__input');
                }
                if (inputSearch) {
                    inputSearch.addEventListener('input', () => handleSearch());
                }
            }
            // Fix for https://herbcience.com/ by donglt
            else if (app.storeId === 8927) {
                setTimeout(() => {
                    const inputSearch = document.querySelector(
                        '.js_iput_search');
                    if (inputSearch) {
                        inputSearch.addEventListener('input',
                            () => handleSearch(),
                        );
                    }
                }, 2000);
            }
            // Fix for https://projectxoffroad.com/ by donglt
            else if (app.storeId === 3576) {
                setTimeout(() => {
                    const inputSearch = document.querySelector(
                        '.search__form input[placeholder="Search"]');
                    if (inputSearch) {
                        inputSearch.addEventListener('input', handleSearch);
                    }
                }, 2000);
            }
            else if ([10812].includes(app.storeId)) {
                let searchInputSelector = '.search-bar__input';
                let searchInputElem = document.querySelector(
                    searchInputSelector);

                if (searchInputElem) {
                    let searchResultSelector = '#glFilter-search-popup';
                    let observer = null;
                    let customAttribute = false;
                    let options = {attributes: false, childList: true, subtree: true};
                    searchInputElem.addEventListener('focus', () => {
                        setTimeout(() => {
                            const searchResultElem = document.querySelector(
                                searchResultSelector);
                            observer = new MutationObserver(() => {
                                app.cp.changeProductPrice(shopData,
                                    customAttribute, false,
                                );
                            });
                            observer.observe(searchResultElem, options);
                        }, 100);
                    });
                }
            }
        }
        else if (app.storeId === 6054 && isTDApplied && app.page.isProductPage()) {
            let cartForm = $('form[action="/cart/add"].main-product-form');
            if (cartForm.length) {
                let changeVariantButton = document.querySelectorAll(
                    'div[data-variant-picker] input[type="radio"]');
                let bssB2BProductNoVat = document.querySelectorAll(
                    '.bss-b2b-product-vat-price-no-vat');
                let bssB2BProductHasVat = document.querySelectorAll(
                    '.bss-b2b-product-vat-price-has-vat');
                let bssB2BProductVatClosestForm = document.querySelector(
                    '.product-form.form.main-product');
                if (changeVariantButton.length && bssB2BProductNoVat.length &&
                    bssB2BProductHasVat.length && bssB2BProductVatClosestForm) {
                    fix_Tax.handleVariantChangeEvents(bssB2BProductVatClosestForm,
                        shopData,
                        false,
                    );
                    for (let i = 0; i < changeVariantButton.length; i++) {
                        changeVariantButton[i].addEventListener('click',
                            function() {
                                fix_Tax.handleVariantChangeEvents(
                                    bssB2BProductVatClosestForm,
                                    shopData, false,
                                );
                            },
                        );
                    }
                }
            }
        }
        else if (app.storeId === 6256 && isTDApplied && app.page.isProductPage()) {
            let cartForm = $('form[action="/cart/add"]');
            if (cartForm.length) {
                let changeVariantButton = document.querySelectorAll(
                    'div.product-variant__item input[type="radio"]');
                let bssB2BProductNoVat = document.querySelectorAll(
                    '.bss-b2b-product-vat-price-no-vat');
                let bssB2BProductHasVat = document.querySelectorAll(
                    '.bss-b2b-product-vat-price-has-vat');
                let bssB2BProductVatClosestForm = document.querySelector(
                    'form[action="/cart/add"]');
                if (changeVariantButton.length && bssB2BProductNoVat.length &&
                    bssB2BProductHasVat.length && bssB2BProductVatClosestForm) {
                    fix_Tax.handleVariantChangeEvents(bssB2BProductVatClosestForm,
                        shopData,
                        false,
                    );
                    for (let i = 0; i < changeVariantButton.length; i++) {
                        changeVariantButton[i].addEventListener('click',
                            function() {
                                fix_Tax.handleVariantChangeEvents(
                                    bssB2BProductVatClosestForm,
                                    shopData, false,
                                );
                            },
                        );
                    }
                }
            }
        }

        //Fix for search bar donglt
        if (isCPApplied || isTDApplied) {
            app.fix.cp.fixShowPriceSearchProduct(shopData, tax_default.a, taxDisplayRules_default.a, isTDApplied);
        }

        // Fixed cp in collection and search pages when changing filter and sort
        // product by donglt
        if ([9943, 10812, 10799, 11074].includes(app.storeId) && isCPApplied &&
            (app.page.isSearchPage() || app.page.isCollectionPage())) {
            let productContainerSelector = '#product-grid-ajax';

            if (app.storeId === 10812) {
                productContainerSelector = '#main .collection';
            }
            else if (app.storeId === 10799) {
                productContainerSelector = '.boost-pfs-filter-wrapper .boost-pfs-filter-right';
            }
            else if (app.storeId === 11074) {
                productContainerSelector = '.boost-pfs-filter-right-col';
            }

            let productContainerElems = document.querySelectorAll(
                productContainerSelector);

            productContainerElems.forEach((productContainerElem) => {
                const observer = new MutationObserver(() => {
                    app.cp.changeProductPrice(shopData, null, false, false);
                });
                observer.observe(productContainerElem,
                    {attributes: false, childList: true, subtree: true},
                );
            });
        }

        if (BSS_B2B.storeId === 10172 && isTDApplied) {
            const changeListProduct = document.querySelector('#facet-main');
            const mCallback = (mutations) => {
                for (let mutation of mutations) {
                    if (mutation.type === 'childList') {
                        const appliedRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                            BSS_B2B, shopData);
                        tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(
                            shopData,
                            appliedRule,
                        );
                    }
                }
            };
            if (changeListProduct) {
                const observer = new MutationObserver(mCallback);
                observer.observe(changeListProduct, {
                    childList: true,
                });
            }
        }

        if ((isPortalPage || !isCartPage) && (isCPApplied || isQBApplied || isBOGOApplied || isEFApplied)) {
            if ([1222, 1455].indexOf(app.storeId) !== -1) {
                let addToCartButtonsCheckTimes = 0;
                let addToCartButtonsCheck = setInterval(function() {
                    let addToCartButtons = document.querySelectorAll([
                        'button.button.ajax-submit.action_button.button--add-to-cart',
                        'button.btn.add-to-cart',
                        'form#add-item-form.collection-form .quantity.form button[type="button"]'].join(
                        ','));
                    if (addToCartButtons.length > 0 ||
                        addToCartButtonsCheckTimes > 20) {
                        clearInterval(addToCartButtonsCheck);
                        if (addToCartButtons.length > 0) {
                            for (let i = 0; i < addToCartButtons.length; i++) {
                                let addToCartButton = addToCartButtons[i];
                                addToCartButton.addEventListener('click',
                                    function() {
                                        setTimeout(function() {
                                            if (app.storeId === 1222) {
                                                app.cart.fixer(shopData, false,
                                                    true,
                                                );
                                            }
                                            if (app.storeId === 1445) {
                                                app.cart.fixer(shopData, false,
                                                    false,
                                                );
                                            }
                                        }, 1500);
                                    },
                                );
                            }
                        }
                    }
                    addToCartButtonsCheckTimes++;
                }, 500);
            }
            else if (app.storeId === 1546) {
                const addToCartForm = document.querySelector(
                    'form[action="/cart/add"][data-productid]');
                if (addToCartForm) {
                    const addToCartButton = addToCartForm.querySelector(
                        'button[data-product-id][data-pf-type="ProductATC"]');
                    if (addToCartButton) {
                        addToCartButton.addEventListener('click', function() {
                            setTimeout(function() {
                                app.cart.fixer(shopData, false, false);
                            }, 1500);
                        });
                    }
                }
            }
            else if ([3643, 4229, 3588].indexOf(app.storeId) !== -1) {
                let addToCartFormsCheckTimes = 0;
                let addToCartFormsCheck = setInterval(function() {
                    const addToCartForms = document.querySelectorAll(
                        'form.variants[action="/cart/add"], form.boost-pfs-addtocart-product-form, .productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded');
                    if (addToCartForms.length > 0 || addToCartFormsCheckTimes >
                        20) {
                        clearInterval(addToCartFormsCheck);
                        if (addToCartForms.length > 0) {
                            for (let i = 0; i < addToCartForms.length; i++) {
                                const addToCartButton = addToCartForms[i].querySelector(
                                    'button.btn.add-to-cart-btn[data-btn-addtocart][data-form-id], button.boost-pfs-addtocart-btn.boost-pfs-addtocart-select-options');
                                if (addToCartButton) {
                                    addToCartButton.addEventListener('click',
                                        function() {
                                            setTimeout(function() {
                                                if (app.storeId === 4229) {
                                                    app.cart.fixer(shopData,
                                                        false, true,
                                                    );
                                                }
                                                else {
                                                    app.cart.fixer(shopData,
                                                        false, false,
                                                    );
                                                }
                                            }, 2000);
                                        },
                                    );
                                }
                                let quickViewButton = addToCartForms[i].querySelector(
                                    'button.btn.add-to-cart-btn.sub a.quickview-button[title="Subscribe & save"]');
                                if (app.storeId === 3588) {
                                    quickViewButton = document.querySelectorAll(
                                        'button.productitem--action-trigger.button-secondary.mdc-ripple-surface.mdc-ripple-upgraded');
                                }
                                if (quickViewButton) {
                                    if (app.storeId === 3588) {
                                        for (let i = 0; i <
                                        quickViewButton.length; i++) {
                                            quickViewButton[i].addEventListener(
                                                'click', function() {
                                                    setTimeout(function() {
                                                        let cartForm = $(
                                                            '.quickview-tpl form[action*="/cart/add"],' +
                                                            '.modal-content form[action*="/cart/add"]');
                                                        if (cartForm.length) {
                                                            const quickViewATCButton = cartForm.find(
                                                                'input.btn.product-add-to-cart[data-btn-addtocart], button.product-form--atc-button');
                                                            if (quickViewATCButton) {
                                                                quickViewATCButton.on(
                                                                    'click',
                                                                    function() {
                                                                        setTimeout(
                                                                            function() {
                                                                                app.cart.fixer(
                                                                                    shopData,
                                                                                    false,
                                                                                    false,
                                                                                );
                                                                            },
                                                                            2000,
                                                                        );
                                                                    },
                                                                );
                                                            }
                                                            app.cp.changeProductPrice(
                                                                shopData, false,
                                                                cartForm,
                                                            );
                                                            app.makeCloneBuyItNow(
                                                                cartForm);
                                                        }
                                                    }, 2000);
                                                });
                                        }
                                    }
                                    else {
                                        quickViewButton.addEventListener(
                                            'click', function() {
                                                setTimeout(function() {
                                                    let cartForm = $(
                                                        '.quickview-tpl form[action*="/cart/add"],' +
                                                        '.modal-content form[action*="/cart/add"]');
                                                    if (cartForm.length) {
                                                        const quickViewATCButton = cartForm.find(
                                                            'input.btn.product-add-to-cart[data-btn-addtocart], button.product-form--atc-button');
                                                        if (quickViewATCButton) {
                                                            quickViewATCButton.on(
                                                                'click',
                                                                function() {
                                                                    setTimeout(
                                                                        function() {
                                                                            app.cart.fixer(
                                                                                shopData,
                                                                                false,
                                                                                false,
                                                                            );
                                                                        },
                                                                        2000,
                                                                    );
                                                                },
                                                            );
                                                        }
                                                        app.cp.changeProductPrice(
                                                            shopData, false,
                                                            cartForm,
                                                        );
                                                        app.makeCloneBuyItNow(
                                                            cartForm);
                                                    }
                                                }, 2000);
                                            });
                                    }
                                }
                            }
                        }
                    }
                    addToCartFormsCheckTimes++;
                }, 1000);
            }

            if ([1222, 6011].includes(app.storeId)) {
                app.cart.fixer(shopData, false, true);
            }
            else if ([9450].includes(app.storeId)) {
                setTimeout(() => {
                    app.cart.fixer(shopData, false, true);
                }, 1500);
            }
            else {
                app.cart.fixer(shopData, false, false);
            }
        }

        if (!isCPApplied && !isQBApplied && !teStatus && !dcStatus && !srStatus && !efStatus && !bogoStatus) {
            if (mcStatus) {
                app.handleCartCheckoutBtn(shopData);
            }
            if (isOLApplied && app.page.isCartPage()) {
                app.cart.fixer(shopData, false, true);
            }
            return;
        }

        if ([4856, 6289].includes(app.storeId) && isCPApplied) {
            document.addEventListener('bss_b2b_doneCheckCp', function() {
                $('.cart__checkout-button.checkout-button[name="checkout"], a.header__icon-wrapper[href="/cart"]').css({
                    'pointer-events': 'auto', 'cursor': 'pointer',
                });
            });
        }

        if (app.storeId == 3879) {
            if (mcStatus && app.page.isProductPage()) {
                let sessionCurrencyCode = window.localStorage.getItem(
                    'currentCurrency');
                let sessionCurrencyFormat = window.localStorage.getItem(
                    'currentCurrencyFormat');
                let checkMCInitInterval = setInterval(() => {
                    if (BSS_B2B.MC && BSS_B2B.MC.preConvertCurrency &&
                        typeof BSS_B2B.MC.preConvertCurrency === 'function') {
                        app.MC.preConvertCurrency(sessionCurrencyCode,
                            sessionCurrencyFormat,
                        );
                        clearInterval(checkMCInitInterval);
                    }
                }, 500);
                setTimeout(() => {
                    clearInterval(checkMCInitInterval);
                }, 5000);
            }
        }

        /* --- Fix handleCartCheckoutBtn --- */
        // fix for oilmens-equipment-corp by Leorio
        if (app.storeId === 300) {
            if (app.page.isCartPage()) {
                if ($('#MyShippingOptions').is(':hidden') &&
                    $('#MyPaymentOptions').is(':hidden')) {
                    app.handleCartCheckoutBtn(shopData);
                }

                $('.PO-option-box .cart-attribute__field input[type="checkbox"]').on('change', function() {
                    if ($('#MyPaymentOptions').is(':visible')) {
                        $('button.button-primary[name="checkout"]').off();

                        $('#MyPaymentOptions input').on('change', function() {
                            if ($('#Company_Name').val().length !== 0 &&
                                $('#Purchase_Order_Number').val().length !== 0) {
                                app.handleCartCheckoutBtn(shopData);
                            }
                        });
                    }
                    else {
                        app.handleCartCheckoutBtn(shopData);
                    }
                });

                $('.shipping-options-box .cart-attribute__field input[type="checkbox"]').on('change', function() {
                    if ($('#MyShippingOptions').is(':visible')) {
                        $('button.button-primary[name="checkout"]').off();
                        $('.shipping-options-box input').on('change', function() {
                            if ($('#carrier').val().length !== 0 &&
                                $('#shipping-method').val().length !==
                                0 &&
                                $('#carrier-account-number').val().length !== 0) {
                                app.handleCartCheckoutBtn(shopData);
                            }
                        });
                    }
                    else {
                        app.handleCartCheckoutBtn(shopData);
                    }
                });
            }
        }
        // fix for dragon-fly-brand by Leorio
        else if (app.storeId === 437) {
            if (app.page.isCartPage()) {
                if ($('#CartPageAgree').is(':checked')) {
                    app.handleCartCheckoutBtn(shopData);
                }

                $('#CartPageAgree').on('change', function() {
                    if ($('#CartPageAgree').is(':checked')) {
                        app.handleCartCheckoutBtn(shopData);
                    }
                });
            }
            if (app.page.isProductPage) {
                $('fieldset.variant-input-wrap .variant-input').on('click', function() {
                    $('fieldset.variant-input-wrap .variant-input').hide();
                    setTimeout(function() {
                        app.cp.changeProductPrice(shopData, false, false);
                        $('fieldset.variant-input-wrap .variant-input').show();
                    }, 1500);
                });
            }
        }
        else if ([8659, 11435, 10623, 10969, 13433, 13614, 13871, 13817, 14132, 13831, 15609].includes(app.storeId)) {
            if (app.storeId !== 11435) {
                if (app.page.isCartPage()) {
                    app.handleCartCheckoutBtn(shopData);
                    let cartForm = document.querySelector(
                        '.cart-page .ajax-cart__form-wrapper');
                    if (cartForm) {
                        const debounceFnc = (callback, timeout = 300) => {
                            let timer;
                            return (...args) => {
                                clearTimeout(timer);
                                timer = setTimeout(() => {
                                    callback.apply(this, args);
                                }, timeout);
                            };
                        };
                        const updateCart = (shopData) => {
                            app.cart.fixer(shopData, false, false);
                            app.handleCartCheckoutBtn(shopData);
                        };
                        let observer = new MutationObserver(
                            function(mutations) {
                                mutations.forEach(function(m) {
                                    if (m.addedNodes.length) {
                                        debounceFnc(updateCart(shopData), 200);
                                    }
                                });
                            });
                        observer.observe(cartForm, {childList: true});
                    }
                }
            }
            if (app.page.isProductPage() && isCPApplied) {
                const variantProduct = document.querySelector(
                    'form[action*="/cart/add"] input[name="id"], .product__form__outer, .add-cart-js.add-product-cart input[name="id"]');
                if (variantProduct) {
                    const changeVariant = mutations => {
                        for (let mutation of mutations) {
                            if (mutation.type === 'attributes') {
                                setTimeout(() => {
                                    if(app.storeId === 13817) {
                                        BSS_B2B.cp.changeProductPrice(shopData,false, false,false);
                                    } else {
                                        BSS_B2B.cp.changeProductPrice(shopData,
                                            '[bss-b2b-variant-id]', false,
                                        );
                                    }   
                                }, 1000);
                            }
                        }
                    };
                    const observer = new MutationObserver(changeVariant);
                    observer.observe(variantProduct, {
                        attributes: true,
                    });
                }
            }
        }
        
        // fix for dev-valera by huy dt
        else if (app.storeId === 5940) {
            const searchBox = document.querySelector(
                '.predictive-search.predictive-search--header');
            const mCallback = (mutations) => {
                for (let mutation of mutations) {
                    if (mutation.type === 'childList') {
                        const appliedRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                            BSS_B2B, shopData);
                        tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(
                            shopData,
                            appliedRule,
                        );
                    }
                }
            };
            if (searchBox) {
                const observer = new MutationObserver(mCallback);
                observer.observe(searchBox, {
                    childList: true,
                });
            }
            if (isCartPage) {
                app.handleCartCheckoutBtn(shopData);
            }
        }
        // fix for b2b-reinh-art by Leorio
        else if (app.storeId === 1759) {
            let agreeInput = $('input.js_agree_ck');
            if (agreeInput.length > 0) {
                if (agreeInput.is(':checked')) {
                    app.handleCartCheckoutBtn(shopData);
                }

                agreeInput.on('change', function() {
                    if (agreeInput.is(':checked')) {
                        app.handleCartCheckoutBtn(shopData);
                    }
                    else {
                        $(document).on('click',
                            '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
                            function(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            },
                        );
                    }
                });
            }
        }
        else if ([1973, 4945, 11184, 11805].indexOf(app.storeId) !== -1) {
            setTimeout(function() {
                app.handleCartCheckoutBtn(shopData);
            }, 1000);
        }
        else if ([10805].indexOf(app.storeId) !== -1) {
            setTimeout(function() {
                app.handleCartCheckoutBtn(shopData);
            }, 2000);
        }
        else if (app.storeId === 4557) {
            if (app.page.isCartPage()) {
                app.handleCartCheckoutBtn(shopData);
            }
            else {
                let miniCartButton = document.querySelector(
                    'a.Header__Icon[aria-label="Open cart"]');
                if (miniCartButton) {
                    miniCartButton.addEventListener('click', function() {
                        let sideBarCheckTimes = 0;
                        let sideBarCheck = setInterval(function() {
                            let sideBar = document.querySelector(
                                '#sidebar-cart[aria-hidden="false"]');
                            if (sideBar || sideBarCheckTimes > 50) {
                                clearInterval(sideBarCheck);
                                if (sideBar) {
                                    app.handleCartCheckoutBtn(shopData);
                                }
                            }
                            sideBarCheckTimes += 1;
                        }, 500);
                    });
                }
            }
        }
        else {
            app.handleCartCheckoutBtn(shopData);
        }

        // region Fix changeProductPrice, cartQtyOnChange, handleAjaxCart and
        // something
        if (app.storeId === 1889) {
            $('.input-group-field.header-search__input').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
            if (app.page.isProductPage()) {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, '.price.on-sale',
                        false,
                    );
                }, 1000);
            }
            if (app.page.isCartPage()) {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData,
                        '.price-sale .special-price',
                        false,
                    );
                }, 1000);
            }
        }
        // fix for kick essential by huydt
        else if (app.storeId === 5550) {
            $('.input-group-field.search-field').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        //fix for cafecanal.ca by huydt
        else if (app.storeId === 4884) {
            $(`.weglot-container li.wg-li > a[id^="weglot-language"]`).on('click', () => {
                let productsInMiniCart = document.querySelectorAll(
                    '.single-cart-product [bss-b2b-cart-item-key]');
                let totalPrice = document.querySelector(
                    '.subtotal-amount.shopping-cart__total[bss-b2b-cart-total-price]');
                totalPrice.style.display = 'none';
                productsInMiniCart.forEach((item) => {
                    item.style.display = 'none';
                });
                app.cart.fixer(shopData, false, false);
                setTimeout(() => {
                    productsInMiniCart.forEach((item) => {
                        item.style.display = 'inline-block';
                    });
                    totalPrice.style.display = 'inline-block';
                }, 1000);
            });
        }
        else if (app.storeId === 2589) {
            $('.header__btn-wishlist.js-popup-button').on('click', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData,
                        '.product-store-lists__price',
                        false,
                    );
                }, 1000);
            });
            $('form[action="/search"] input[type="search"]').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData,
                        '.product-search__price', false,
                    );
                }, 1500);
            });
        }
        // fix for boutique-l214 by AnhTV
        else if (app.storeId === 6108) {
            $('.quick-view__summary').on('click', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, null, false);
                }, 2000);
            });
            const recursion = function() {
                $('#FacetFiltersForm li.list-menu__item.facets__item, .active-facets-mobile .active-facets a.active-facets__button').
                    on('click', function() {
                        setTimeout(function() {
                            recursion();
                            app.cp.changeProductPrice(shopData, null, false);
                            $('.quick-view__summary').on('click', function() {
                                setTimeout(function() {
                                    let cartForm = $(
                                        'form[action*="/cart/add"]');
                                    let parentLevel2 = $(
                                        'form[action*="/cart/add"]').parent();
                                    app.cp.changeProductPrice(shopData, null,
                                        false,
                                    );
                                    app.handleAjaxCart();
                                    $(cartForm).
                                        closest(
                                            '.product__info-container.product__info-container--sticky').
                                        find('variant-radios.no-js-hidden').
                                        on('change', function() {
                                            setTimeout(function() {
                                                BSS_B2B.changeVariantOptionProductPage(
                                                    parentLevel2,
                                                    cartForm,
                                                );
                                                BSS_B2B.cp.changeProductPrice(
                                                    shopData, null,
                                                    cartForm,
                                                );
                                            }, 1000);
                                        });
                                }, 1500);
                            });
                        }, 1500);
                    });
                $('#FacetFiltersFormMobile input[type=text], #FacetFiltersFormMobile input[type=checkbox], #FacetFiltersFormMobile input[type=number]').
                    on('change', function() {
                        setTimeout(function() {
                            app.cp.changeProductPrice(shopData, null, false);
                            recursion();
                            $('.quick-view__summary').on('click', function() {
                                setTimeout(function() {
                                    let cartForm = $(
                                        'form[action*="/cart/add"]');
                                    let parentLevel2 = $(
                                        'form[action*="/cart/add"]').parent();
                                    app.cp.changeProductPrice(shopData, null,
                                        false,
                                    );
                                    app.handleAjaxCart();
                                    $(cartForm).
                                        closest(
                                            '.product__info-container.product__info-container--sticky').
                                        find('variant-radios.no-js-hidden').
                                        on('change', function() {
                                            setTimeout(function() {
                                                BSS_B2B.changeVariantOptionProductPage(
                                                    parentLevel2,
                                                    cartForm,
                                                );
                                                BSS_B2B.cp.changeProductPrice(
                                                    shopData, null,
                                                    cartForm,
                                                );
                                            }, 1000);
                                        });
                                }, 2000);
                            });
                        }, 1500);
                    });
            };
            recursion();
        }

        // fix for counterpointmusic.myshopify.com by AnhTV
        if (app.storeId === 97 && BSS_B2B.page.isProductPage()) {
            $('variant-selects.no-js-hidden').on('change', function() {
                setTimeout(function() {
                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                }, 1000);
            });
        }
        // fix for cadenzashop.myshopify.com by LuanHV
        else if (app.storeId === 6249) {
            $('.hover_button .nt_add_qv').on('click', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, null, false);
                }, 2000);
            });
        }
        // fix for flow-amsterdam-dealer by mitri
        else if (app.storeId === 2624) {
            if (app.page.isCartPage()) {
                const handleChangeQuantity = function() {
                    $('.cart-item__quantity .quantity select[name="quantity"]').on('change', function() {
                        app.cart.cartQtyOnChange(1000, 1000, true);
                        setTimeout(function() {
                            handleChangeQuantity();
                        }, 2000);
                    });
                };
                handleChangeQuantity();
            }
        }
        // fix by LuanHV
        else if (app.storeId === 5997) {
            if (app.page.isCartPage()) {
                const handleChangeQuantity = function() {
                    $('.cart-item__column>.buttoned-input>a').on('click', function() {
                        app.cart.cartQtyOnChange(1000, 1000, true);
                        setTimeout(function() {
                            handleChangeQuantity();
                        }, 2000);
                    });
                };
                handleChangeQuantity();
            }
        }
            // fix bug price include tax not display when change page
            // panigation of
        // https://euro-trade.com/collections/sport-freizeit?page=8
        else if (app.storeId === 6605 && isTDApplied) {
            if (app.page.isCollectionPage()) {
                const handleChangeCollectionsPage = function() {
                    let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                        BSS_B2B, shopData);
                    let listPagination_Btn = document.querySelectorAll(
                        '.pagination__nav-item');
                    if (listPagination_Btn.length) {
                        listPagination_Btn.forEach(item => {
                            item.addEventListener('click', function() {
                                setTimeout(() => {
                                    fix_Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                        shopData,
                                        appliedDisplayRule,
                                    );
                                    handleChangeCollectionsPage();
                                }, 1250);
                            });
                        });
                    }

                };
                handleChangeCollectionsPage();
            }
        }
        else if (app.storeId === 8125) {
            $('.header-action-list .header-action-item').on('click', function() {
                setTimeout(() => {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, 500);
            });
            let oldPrice = document.querySelector(
                '.cart-summary_wrapper .cart-summary_footer .cart-summary_total .cart-summary_price');
            const handleChangeQuantity = function() {
                $('.qty-wrapper .cursor-pointer').on('click', function() {
                    setTimeout(() => {
                        app.cart.cartQtyOnChange(1000, 1000, true);
                        handleChangeQuantity();
                        if (isTDApplied && oldPrice) {
                            oldPrice.style.display = 'none';
                        }
                    }, 2000);
                });
            };
            handleChangeQuantity();
        }
        // fix for didierlabpartner by KhanhND
        else if (app.storeId === 5077) {
            let isFirstLoad = false;
            if (app.page.isCartPage()) {
                const handleCheckoutWhenChangeQty = function(isFirstLoad) {
                    if (isFirstLoad) {
                        app.handleCartCheckoutBtn(shopData);
                    }
                    $('.QuantitySelector__Button.Link.Link--primary').on('click', function() {
                        isFirstLoad = true;
                        setTimeout(function() {
                            handleCheckoutWhenChangeQty(isFirstLoad);
                        }, 2500);
                    });
                };
                handleCheckoutWhenChangeQty(isFirstLoad);
            }
            else {
                let collectionFilter = document.querySelector(
                    '.CollectionMain .CollectionInner__Products');
                if (collectionFilter) {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes.length) {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                                app.handleAjaxCart();
                            }
                        });
                    });
                    observer.observe(collectionFilter, {childList: true});
                }
            }
        }
        else if (app.storeId === 10370) {
            let addToCartBtn = document.querySelector(
                'form[action="/cart/add"] button.button.button--xl');
            if (addToCartBtn) {
                addToCartBtn.addEventListener('click', () => {
                    let catchCartBanner = setInterval(() => {
                        let cartBanner = document.querySelector(
                            '.quick-buy-drawer.drawer.show-close-cursor');
                        if (cartBanner) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                            clearInterval(catchCartBanner);
                        }
                    }, 50);
                    setTimeout(() => {
                        clearInterval(catchCartBanner);
                    }, 7000);
                });
            }
        }
        // fix for bien-moves by CuongNVM
        else if (app.storeId === 3592) {
            app.handleAjaxCart($, app, shopData);
            $('.product-form--add-to-cart').on('click', function() {
                setTimeout(function() {
                    app.cart.fixer(shopData, false, true);
                }, 2000);
            });
        }
        // fix for thatsoitaly by mitri
        else if (app.storeId === 3698) {
            if (app.page.isCartPage()) {
                $('.cart__quantity-plus', +'.cart__quantity-minus').on('click', function() {
                    setTimeout(function() {
                        app.cart.cartQtyOnChange(1000, 1000, true);
                    }, 1000);
                });
            }
        }
        else if (app.storeId === 3762) {
            $('.search-bar__input').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        //fix for bingltd
        else if (app.storeId === 2851) {
            if (app.page.isCartPage()) {
                const changeQty = () => {
                    $('.quantity-adjuster__input').on('change', function() {
                        const myInterval = setInterval(function() {
                            $('.cart-column.cart-column--quantity .quantity-adjuster').hide();
                        }, 100);
                        setTimeout(function() {
                            app.cart.fixer(shopData, true, false);
                            changeQty();
                            clearInterval(myInterval);
                            $('.cart-column.cart-column--quantity .quantity-adjuster').show();
                        }, 3500);
                    });
                };
                changeQty();
            }
        }
        // fix for laduora by mitri
        else if (app.storeId === 3798) {
            let quantityElement = $('.icon-plus,' + '.icon-minus');
            $(quantityElement).on('click', function() {
                setTimeout(function() {
                    app.handleAjaxCart($, app, shopData);
                }, 1500);
            });
        }
        else if (app.storeId === 3976) {
            $('.control.header__search-bar.is-relative input').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        else if (app.storeId === 4094) {
            $('header.search-enabled--true form.search__form[action="/search"] input[name="q"]').
                on('input', function() {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData,
                            'header.search-enabled--true form.search__form[action="/search"] .item-result .item-pricing.price .money[bss-b2b-product-price]',
                            false,
                        );
                    }, 1000);
                });
        }
        else if ([9006, 4257].includes(app.storeId)) {
            let swatchItemCheckTimes = 0;
            let swatchItemCheck = setInterval(function() {
                let swatchItems = document.querySelectorAll(
                    '.swatch-view-item');
                if (swatchItems.length || swatchItemCheckTimes > 20) {
                    clearInterval(swatchItemCheck);
                    if (swatchItems.length) {
                        for (let i = 0; i < swatchItems.length; i++) {
                            let swatchItem = swatchItems[i];
                            swatchItem.addEventListener('click', function() {
                                setTimeout(function() {
                                    let productContainer = swatchItem.closest(
                                        '.ProductItem[swatch-current-variant],.js-product_section[swatch-current-variant] ');
                                    if (productContainer) {
                                        let productPriceContainer = productContainer.querySelector(
                                            '.ProductItem__PriceList, .product-thumbnail__price');
                                        if (productPriceContainer) {
                                            let product = productPriceContainer.getAttribute(
                                                'bss-b2b-product-id');
                                            let productPriceElem = productPriceContainer.querySelector(
                                                '.ProductItem__Price:not(.Price--highlight):not(.Price--compareAt), .money');
                                            if (productPriceElem) {
                                                productPriceElem.setAttribute(
                                                    'bss-b2b-product-id',
                                                    product,
                                                );
                                                productPriceElem.setAttribute(
                                                    'bss-b2b-product-price',
                                                    '',
                                                );
                                                if (app.storeId === 9006) {
                                                    app.cp.changeProductPrice(
                                                        shopData, false, false);
                                                }
                                                else {
                                                    app.cp.changeProductPrice(
                                                        shopData,
                                                        `.ProductItem[swatch-current-variant="${productContainer.getAttribute(
                                                            'swatch-current-variant')}"] .ProductItem__Price`,
                                                        false,
                                                    );
                                                }

                                            }
                                        }
                                    }
                                }, 1000);
                            });
                        }
                    }
                    return;
                }
                swatchItemCheckTimes += 1;
            }, 500);
            if (app.page.isCartPage()) {
                app.cp.changeProductPrice(shopData, '.ProductItem__Price',
                    false,
                );
            }
        }
        else if (app.storeId === 4334) {
            $('form[action="/search"] input[type="search"]').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        // fix for locomocean.eu by hoaduong
        else if (app.storeId === 4897) {
            $('.search__predictive__form input[data-predictive-search-input]').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        // fix for vertellav2 by dongnv
        else if (app.storeId === 3340) {
            $('.menu_c.search_menu input[type="search"]').on('keyup', function() {
                setTimeout(() => {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 1500);
            });
        }
        //fix for krkcshop by HaiNN
        else if (app.storeId === 5527) {
            setTimeout(function() {
                $('.QuantitySelector__Button').on('click', function() {
                    app.cart.cartQtyOnChange(1000, 1000, true);
                });
                $('.QuantitySelector__CurrentQuantity').on('change', function() {
                    app.cart.cartQtyOnChange(1000, 1000, true);
                });
            }, 1500);
        }
        // fix for cheekychain-business by dongnv
        else if (app.storeId === 5284) {
            let productListingElem = document.querySelector(
                '.search__results__products__list');
            if (productListingElem) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(searchResults) {
                        if (searchResults.addedNodes.length) {
                            app.cp.changeProductPrice(shopData, false, false);
                        }
                    });
                });
                observer.observe(productListingElem, {childList: true});
            }
        }
        else if (app.storeId === 661 && app.page.isCartPage() && (isCPApplied || isQBApplied)) {
            let btnCheckout = $('form[action*="/cart"] [name="checkout"],' +
                '#dropdown-cart button.btn.btn-checkout.show,' +
                'a.button.checkout-button[href="/checkout"],' +
                'form[action*="/checkout"] .add_to_cart,' +
                'form[action*="/cart"]#cart_form #checkout,' +
                'form[action*="/cart"] button.Cart__Checkout,' +
                'button.trigger-checkout');
            if (btnCheckout.length > 0) {
                let newBtnCheckout = '<input type=\'button\' class=\'action_button add_to_cart\' id=\'checkout\' value=\'Checkout\'></input>';
                btnCheckout.before(newBtnCheckout);
                btnCheckout.remove();
            }
        }
        else if (app.storeId === 7731 && app.page.isCollectionPage() && (isQBApplied || isCPApplied || isOLApplied)) {
            let collectionList = document.querySelector('#AjaxinateContainer');
            if (collectionList) {
                let observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length) {
                            app.handleAjaxCart();
                        }
                    });
                });
                observer.observe(collectionList, {childList: true});
            }
        }
        //fix for wholesale.thirdwavewater by HaiPd
        else if (app.storeId === 2721 && app.page.isCartPage() && isQBApplied) {
            document.addEventListener('bss_b2b_doneCheckQb', function() {
                $('.checkout_button .action_button.add_to_cart').css({'pointer-events': 'auto', 'cursor': 'pointer'});
            });
        }
        // fix for pisen by KhanhND
        else if (app.storeId === 4999) {
            if (isCPApplied || isQBApplied) {
                let cartForm = document.querySelector(
                    '.ajax-cart__form-wrapper');
                if (cartForm) {
                    const handleCheckout = (mutations) => {
                        for (const mutation of mutations) {
                            if (mutation.type === 'childList') {
                                let checkoutButton = cartForm.querySelector(
                                    'input.ajax-cart__button-submit');
                                if (checkoutButton) {
                                    checkoutButton.setAttribute('disabled', '');
                                    if ((isCPApplied && isQBApplied) ||
                                        isQBApplied) {
                                        document.addEventListener(
                                            'bss_b2b_doneCheckQb',
                                            function() {
                                                checkoutButton.removeAttribute(
                                                    'disabled');
                                            },
                                        );
                                    }
                                    else if (isCPApplied) {
                                        document.addEventListener(
                                            'bss_b2b_doneCheckCp',
                                            function() {
                                                checkoutButton.removeAttribute(
                                                    'disabled');
                                            },
                                        );
                                    }
                                    checkoutButton.addEventListener('click',
                                        function(e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            checkoutButton.setAttribute(
                                                'disabled', true);
                                            checkoutButton.style.display = 'none';
                                        },
                                    );
                                }
                            }
                        }
                    };
                    const observer = new MutationObserver(handleCheckout);
                    observer.observe(cartForm, {childList: true});
                }
            }
        }
        //fix for valleys-group by hoaduong
        else if (app.storeId === 3196) {
            setTimeout(() => {
                $('.ajax-cart__item-quantity').on('click', function() {
                    app.cart.cartQtyOnChange(1000, 1000, true);
                });
            }, 3000);
        }
        //fix for locomocean.eu by hoaduong
        else if (BSS_B2B.storeId === 4897 && app.page.isCartPage()) {
            setTimeout(() => {
                $('.quantity__button.quantity__button--plus[data-increase-quantity],.quantity__button.quantity__button--minus[data-decrease-quantity]').
                    on('click', function() {
                        app.cart.cartQtyOnChange(1000, 1000, true);
                    });
            }, 1500);
        }
        // fix for atmooz-b2c-copy by dongnv
        else if (app.storeId === 5350) {
            let buttonChangeQuantity = $(BSS_B2B.cart.buttonChangeQuantity);
            if (buttonChangeQuantity.length) {
                buttonChangeQuantity.on('click', function() {
                    app.cart.cartQtyOnChange(1000, 1000, false);
                });
            }
        }
        else if (app.storeId === 7596 && app.page.isCartPage() && isCPApplied) {
            let cartItem = document.querySelector(
                '#cartform .cart-items.plain');
            if (cartItem) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            app.cart.fixer(shopData, false, false);
                        }
                    });
                });
                observer.observe(cartItem, {childList: true});
            }
        }
        else if (app.storeId === 621 && app.page.isCartPage() && isCPApplied) {
            setTimeout(() => {
                app.cart.fixer(shopData, false, false);
            }, 3500);
        }
        //fix for groomus by mitri
        else if (app.storeId === 4653 && isCPApplied) {
            setTimeout(() => {
                $('.js-qty__adjust--plus,' + '.js-qty__adjust--minus').on('click', function() {
                    app.cart.cartQtyOnChange(1000, 1000, true);
                });
            }, 2000);
        }
        else if (app.storeId === 9673 && isCPApplied && app.page.isCartPage()) {
            setTimeout(() => {
                let buttonChangeQuantity = $(
                    '.QuantitySelector .QuantitySelector__Button');
                let inputChangeQuantity = $('.CartItem__QuantitySelector .QuantitySelector__CurrentQuantity');
                if (buttonChangeQuantity.length) {
                    buttonChangeQuantity.on('click', function() {
                        app.cart.cartQtyOnChange(1000, 1000, false);
                    });
                }
                if (inputChangeQuantity.length) {
                    inputChangeQuantity.on('change', function() {
                        app.cart.cartQtyOnChange(1000, 1000, false);
                    });
                }
            }, 2000);
        }
        // fix for shop-nortec.myshopify.com by hoaduong
        else if (app.storeId === 4852) {
            app.handleAjaxCart($, app, shopData);
        }
        // fix fordacardworld-eu by DongNV
        else if (app.storeId === 6256 && teStatus) {
            app.handleAjaxCart();
        }
        else if (app.storeId === 7668) {
            const changeOption = document.querySelector(
                'select.productOption.dropdown-selected');
            if (changeOption) {
                changeOption.addEventListener('change', function() {
                    setTimeout(function() {
                        app.cp.changeProductPrice(shopData, null, false);
                    }, 1500);
                });
            }
        }
        else if (app.storeId === 7552) {
            if ((isTDApplied || isCPApplied) && app.page.isCollectionPage()) {
                let collectionList = document.querySelector(
                    '.tp-collection-content');
                if (collectionList) {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes.length) {
                                if (isCPApplied) {
                                    app.cp.changeProductPrice(shopData, false,
                                        false,
                                    );
                                }
                                else {
                                    let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                                        BSS_B2B, shopData);
                                    fix_Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(
                                        shopData,
                                        appliedDisplayRule,
                                    );
                                }
                            }
                        });
                    });
                    observer.observe(collectionList, {childList: true});
                }
            }
            if (isTDApplied) {
                let appliedDisplayRuleCart = taxDisplayRules_default.a.getAppliedRuleCartPage(
                    BSS_B2B, shopData);
                fix_Tax.bssB2BCartChangeAllVatPriceWithoutCP(shopData,
                    appliedDisplayRuleCart,
                );
                fix_Tax.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData,
                    appliedDisplayRuleCart,
                );
            }
        }
        else if (app.storeId === 8992) {
            if (isCPApplied) {
                //live search
                let searchResultsWrappers = document.querySelector(
                    '.search-flydown--results[data-live-search-results]');
                if (searchResultsWrappers) {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes && m.addedNodes[0] &&
                                m.addedNodes[0].className ===
                                'search-flydown--product-items') {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }
                        });
                    });
                    observer.observe(searchResultsWrappers, {childList: true});
                }
            }
        }
        else if (app.storeId === 9042) {
            if (isCPApplied) {
                //live search
                let searchResultsWrappers = document.querySelector(
                    'form[action="/search"] div.result-container');
                if (searchResultsWrappers) {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes && m.addedNodes[0]) {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }
                        });
                    });
                    observer.observe(searchResultsWrappers, {childList: true});
                }
            }
        }
        else if (app.storeId === 2865) {
            if (isCPApplied) {
                let searchResultsWrappers = document.querySelector(
                    '#search-results');
                if (searchResultsWrappers) {
                    let observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(m) {
                            if (m.addedNodes && m.addedNodes.length) {
                                setTimeout(() => {
                                    let listResult = document.querySelector(
                                        '#search-results .results__list');
                                    if (listResult) {
                                        app.cp.changeProductPrice(shopData,
                                            false, false,
                                        );
                                    }
                                }, 100);
                            }
                        });
                    });
                    observer.observe(searchResultsWrappers, {childList: true});
                }
                let findBtn = setInterval(() => {
                    let checkoutBtn = document.querySelector(
                        '.hs-checkout-purchase');
                    if (checkoutBtn) {
                        clearInterval(findBtn);
                        let checkoutBtnClone = checkoutBtn.cloneNode(true);
                        let parentEle = checkoutBtn.closest(
                            '.hs-content-checkout-button');
                        if (parentEle) {
                            parentEle.replaceChild(checkoutBtnClone,
                                checkoutBtn,
                            );
                        }
                        checkoutBtnClone.style.cursor = 'pointer';
                    }
                }, 200);
                setTimeout(() => {
                    clearInterval(findBtn);
                }, 3000);
            }
        }
        // fix for https-openhagen-biz.myshopify
        else if (app.storeId === 7911) {
            if (isTDApplied && app.page.isCartPage()) {
                setTimeout(() => {
                    let appliedDisplayRuleCart = taxDisplayRules_default.a.getAppliedRuleCartPage(
                        BSS_B2B, shopData);
                    fix_Tax.bssB2BCartChangeAllVatPriceWithoutCP(shopData,
                        appliedDisplayRuleCart,
                    );
                    fix_Tax.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData,
                        appliedDisplayRuleCart,
                    );
                }, 400);
            }
            if (isTDApplied && app.page.isProductPage()) {
                let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(
                    BSS_B2B, shopData);
                let interval = setInterval(() => {
                    fix_Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData,
                        appliedDisplayRule,
                    );
                }, 300);
                setTimeout(() => {
                    clearInterval(interval);
                }, 3000);
            }
            if (app.page.isCartPage()) {
                setTimeout(() => {
                    app.handleCartCheckoutBtn(shopData);
                    BSS_B2B.onDiscountCodeSubmit();
                }, 2000);
            }
        }
        else if (app.storeId === 10989) {
            if (app.page.isCartPage()) {
                setTimeout(() => {
                    let appliedDisplayRuleCart = taxDisplayRules_default.a.getAppliedRuleCartPage(
                        BSS_B2B, shopData);
                    fix_Tax.bssB2BCartChangeAllVatPriceWithoutCP(shopData,
                        appliedDisplayRuleCart,
                    );
                    fix_Tax.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData,
                        appliedDisplayRuleCart,
                    );
                }, 400);
            }
        }
        else if (app.storeId === 7795) {
            if (srStatus && !app.page.isCartPage()) {
                app.customize.sr.fixSRMiniCart(BSS_B2B, shopData);
            }
        }
        else if (app.storeId === 8880) {
            document.querySelector('.search-modal__form .field .search__input').
                addEventListener('keyup', debounce(function() {
                    app.cp.changeProductPrice(shopData, false, false);
                }, 200));
        }
        else if (app.storeId === 9605) {
            let inputLabel = document.querySelector(
                '.header-actions .button form input[type=search]');
            if (inputLabel) {
                inputLabel.addEventListener('focus', function() {
                    setTimeout(() => {
                        let searchResultSelector = document.querySelector(
                            '#glFilter-search-popup > div.gl-fullscreen-layer.gl-animate-transition > div.gl-fullscreen-initial-content');
                        if (searchResultSelector) {
                            const observer = new MutationObserver(() => {
                                app.cp.changeProductPrice(shopData,
                                    '.gl-card-price', false,
                                );
                            });
                            observer.observe(searchResultSelector,
                                {childList: true, subtree: true},
                            );
                        }
                    }, 200);
                });
            }
        }
        else if (app.storeId === 8123 && isCPApplied) {
            let searchBtn = document.querySelector('.sf-search-form');
            if (searchBtn) {
                searchBtn.addEventListener('click', function() {
                    setTimeout(() => {
                        let input = document.getElementById(
                            'gl-d-searchbox-input');
                        if (input) {
                            input.addEventListener('keyup',
                                debounce(function() {
                                    setTimeout(() => {
                                        app.cp.changeProductPrice(shopData,
                                            false, false,
                                        );
                                    }, 1000);
                                }, 500),
                            );
                        }
                    }, 1000);
                });
            }
        }
        // fix for ominide-shop.myshopify.com by TrungDD
        else if (BSS_B2B.storeId === 11409 && isCPApplied) {
            $('.productView-group .productView-quantity').on('change', async () => {
                $('.productView-group .money-subtotal').hide();
                await app.cp.changeProductPrice(shopData, false, false);
                setTimeout(function() {
                    $('.productView-group .money-subtotal').show();
                }, 400);
            });
        }
        else if (BSS_B2B.storeId === 6809 && isCPApplied) {
            $('.productView-product .productView-quantity').on('change', async () => {
                $('.productView-product .money-subtotal').hide();
                await app.cp.changeProductPrice(shopData, false, false);
                setTimeout(function() {
                    $('.productView-product .money-subtotal').show();
                }, 400);
            });
        }
        // endregion
        if (app.storeId === 12369) {
            window.BSS_B2B.executeAction({tag: 'change_quantity_cart', storeId: 12369, BSS_B2B: window.BSS_B2B, shopData});
        }
        window.BSS_B2B.executeAction({tag: 'change_quantity_cart', storeId: 12303, BSS_B2B: window.BSS_B2B});
        window.BSS_B2B.executeAction({tag: 'change_variant_product_page', storeId: 14874, BSS_B2B: window.BSS_B2B})
        // fix for cart page
        if (app.page.isCartPage()) {
            if (app.storeId === 4339) {
                app.cart.fixer(shopData, false, false);
            }
            else if ([5451, 10597, 10805].includes(app.storeId)) {
                setTimeout(function() {
                    app.cart.fixer(shopData, false, true);
                }, 2000);
            }
            else if (app.storeId === 177) {
                app.cart.fixer(shopData, true, false);
            }
            else if (app.storeId === 5043) {
                setTimeout(function() {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                }, 1000);
            }
            else if (app.storeId === 621) {
                // do nothing
            } 
            else {
                app.cart.fixer(shopData, false, true);
            }

            if (isCPApplied || bogoStatus) {
                // fix for 07eins-testshop.myshopify.com by Leorio
                if ([2629, 2989, 2970, 4017, 4653, 6565, 15872].indexOf(app.storeId) !== -1) {
                    app.cp.changeProductPrice(shopData, false, false);
                }
                else if ([1445].indexOf(app.storeId) !== -1) {
                    app.changeProductPriceWithInterval();
                }
                else if (app.storeId === 10029) {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData, false, false);
                    }, 1000);
                }
                else {
                    app.handleAjaxCart();
                    $('[data-cart-price-bubble][data-cart-price]').hide();

                    let timeDelayToReCalculate = 1500;
                    let customTimeDelayToReCalculate = app.getCssSelector(
                        'cart_time_delay_re_calculate');
                    if (customTimeDelayToReCalculate !== '' &&
                        !isNaN(customTimeDelayToReCalculate)) {
                        timeDelayToReCalculate = parseInt(
                            customTimeDelayToReCalculate);
                    }
                    let timeDelayToChangeQuantity = 2000;
                    let customTimeDelayToChangeQuantity = app.getCssSelector(
                        'cart_time_delay_changing_qty');
                    if (customTimeDelayToChangeQuantity !== '' &&
                        !isNaN(customTimeDelayToChangeQuantity)) {
                        timeDelayToChangeQuantity = parseInt(
                            customTimeDelayToChangeQuantity);
                    }
                    if ([6171, 2238, 4651, 9225].indexOf(app.storeId) !== -1) {
                        timeDelayToReCalculate = 3000;
                        timeDelayToChangeQuantity = 3000;
                    }
                    let isExistedUpdateCartBtn = app.cart.isExistedUpdateCartBtn;
                    if (!isExistedUpdateCartBtn) {
                        if (app.storeId === 6652) {
                            let inputChangeQuantity = $(
                                app.cart.inputQuantityElement);
                            let buttonChangeQuantity = $(
                                app.cart.buttonChangeQuantity);
                            app.customize.cp.fixCartPageChangeQuantity6652(
                                inputChangeQuantity, timeDelayToReCalculate,
                                timeDelayToChangeQuantity, true, 'input',
                            );
                            app.customize.cp.fixCartPageChangeQuantity6652(
                                buttonChangeQuantity, timeDelayToReCalculate,
                                timeDelayToChangeQuantity, true, 'button',
                            );
                        }
                        else if ([3820, 7303, 14962].includes(app.storeId)) {
                            //this store not use change qty in cart
                        }
                        else {
                            $(app.cart.inputQuantityElement).on('change', function() {
                                // fix for winecollectiveplus by Leorio
                                if ([2492, 6765, 6579, 4285, 9554, 5686].includes(
                                    app.storeId)) {
                                    $('[bss-b2b-cart-total-price]').css('visibility', 'hidden');
                                    setTimeout(function() {
                                        app.cart.fixer(shopData, false,
                                            true,
                                        );
                                    }, timeDelayToChangeQuantity);
                                } else if (app.storeId === 6425) {
                                    $('[bss-b2b-cart-total-price]').css('visibility', 'hidden');
                                    setTimeout(function() {
                                        app.cart.fixer(shopData, false,
                                            true,
                                        );
                                    }, 1000);
                                } else if(app.storeId === 8194) {
                                    // do nothing
                                } else if ([2870, 3798, 5671, 8927, 9444].indexOf(app.storeId) === -1) {
                                    app.handleChangeQuantityEventFirstTime(
                                        timeDelayToReCalculate,
                                        timeDelayToChangeQuantity,
                                    );
                                }
                            });

                            const addEventChangeQuantity = () => {
                                let buttonChangeQuantity = $(
                                    app.cart.buttonChangeQuantity);
                                if (buttonChangeQuantity.length) {
                                    buttonChangeQuantity.on('click',
                                        function() {
                                            // fix for winecollectiveplus by
                                            // Leorio
                                            if ([2492, 5686,14703].includes(app.storeId)) {
                                                $('[bss-b2b-cart-total-price]').css('visibility', 'hidden');
                                                setTimeout(function() {
                                                    app.cart.fixer(shopData,
                                                        false, true,
                                                    );
                                                }, timeDelayToChangeQuantity);
                                            }
                                            else if ([6425, 14806].includes(app.storeId)) {
                                                $('[bss-b2b-cart-total-price]').css('visibility', 'hidden');
                                                setTimeout(function() {
                                                    app.cart.fixer(shopData,
                                                        false, true,
                                                    );
                                                }, 1000);
                                            }
                                            else if ([10323, 10337].includes(
                                                app.storeId)) {
                                                setTimeout(function() {
                                                    app.handleChangeQuantityEventFirstTime(
                                                        timeDelayToReCalculate,
                                                        timeDelayToChangeQuantity,
                                                    );
                                                }, 1000);
                                            }
                                            else if ([6171, 8927].indexOf(
                                                app.storeId) === -1) {
                                                window.BSS_B2B.executeAction({tag: 'change_quantity_cart', storeId: 11574, addEventChangeQuantity});
                                                app.handleChangeQuantityEventFirstTime(
                                                    timeDelayToReCalculate,
                                                    timeDelayToChangeQuantity,
                                                );
                                            }
                                        },
                                    );
                                }
                            };

                            // fix for vonboie.com by Ducnv
                            if (app.storeId === 8606) {
                                setTimeout(() => {
                                    addEventChangeQuantity();
                                }, 1000);
                            }
                            else if (app.storeId === 621 &&
                                window.location.pathname.includes('/cart')) {
                                const targetNode = document.querySelector(
                                    'body');
                                const config = {attributes: true, childList: true, subtree: true};
                                const observer = new MutationObserver(
                                    mutationsList => {
                                        for (const mutation of mutationsList) {
                                            try {
                                                if (mutation.type ===
                                                    'childList') {
                                                    // query button with id
                                                    // nextURL
                                                    const target = mutation.target.querySelector(
                                                        '.ajax-cart__item-remove--js');
                                                    if (target) {
                                                        addEventChangeQuantity();
                                                        observer.disconnect();
                                                        return;
                                                    }
                                                }
                                            } catch (e) {
                                                //
                                            }
                                        }
                                    });
                                observer.observe(targetNode, config);
                            }
                            else {
                                addEventChangeQuantity();
                            }

                        }
                    }
                    if ($('.recently-viewed-products-placeholder').length) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                    if ($('#shopify-section-recently-viewed-products').length) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                    if ($('[data-section-type="recently-viewed"]').length) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                    if ($(
                        '.product-recommendations .grid.product-grid .grid__item').length) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                    if ($(
                        '.collection .slider-mobile-gutter .grid.product-grid.contains-card .grid__item').length) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                }
            }

            if (isCPApplied) {
                if ([2238, 957].indexOf(app.storeId) !== -1) {
                    let extraFeeElement = document.querySelector(
                        '.mw-hidden-fees');
                    if (extraFeeElement) {
                        let observer = new MutationObserver(
                            function(mutations) {
                                mutations.forEach(function(m) {
                                    if (m.addedNodes.length) {
                                        app.cart.fixer(shopData, false, false);
                                    }
                                });
                            });
                        observer.observe(extraFeeElement, {childList: true});
                    }
                }
                else if (app.storeId === 6565) {
                    setTimeout(() => {
                        app.cart.fixer(shopData, false, false);
                        app.handleCartCheckoutBtn(shopData);
                    }, 2000);
                    // fix for storeID 6565
                    window.BSS_B2B.executeAction({tag: 'change_quantity_cart', storeId: 6565, shopData});
                }
                else if (app.storeId === 7319) {
                    app.customize.cp.fixRecentlyViewedCP7319(shopData);
                }
                    //fix for thewoofclub-ch.myshopify.com by PhuongKD
                // run first time when redirect cartPage
                else if (BSS_B2B.storeId === 10424) {
                    BSS_B2B.customize.cp.fixShippingPriceOnCartPage10424();
                }

            }
        }
        // fix for all page exclude cart page
        else {
            // just apply CP
            if (isCPApplied) {
                if (app.storeId === 3441) {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData, false, false);
                    }, 3000);
                }
                else if ([4324, 10337].includes(app.storeId)) {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData, false, false);
                    }, 1500);
                }
                else if (app.storeId === 3643) {
                    app.cp.changeProductPrice(shopData,
                        '.product-template .product-shop .prices .price',
                        false,
                    );
                    app.cp.changeProductPrice(shopData,
                        '.sticky_form .sticky-item .sticky-price', false,
                    );
                }
                else if (app.storeId === 8250) {
                    let variantOptionInput = document.querySelectorAll(
                        '.product-form__single-selector');
                    if (variantOptionInput.length) {
                        variantOptionInput.forEach((option) => {
                            option.addEventListener('change', debounce(function() {
                                app.cp.changeProductPrice(shopData, false, false);
                            }, 300));
                        });
                    }

                    if (app.page.isCollectionPage() ||
                        app.page.isSearchPage()) {
                        app.cp.changeProductPrice(shopData, false, false);
                    }
                }
                else if (app.storeId === 621 && BSS_B2B.page.isCollectionPage()) {
                    app.cp.changeProductPrice(shopData, '.module-wrap .module [bss-b2b-product-id]', false);
                }
                else {
                    app.cp.changeProductPrice(shopData, false, false);
                }

                // fix for gracianoltd.com by LuanHV
                if (app.storeId === 5997) {
                    $('.option-selector-fieldset>.option-selector__btns>label').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1600);
                    });
                    $('.quantity-submit-row__submit>.button--large').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1800);
                    });
                }
                // fix for anza.com.tr by LuanHV
                else if (app.storeId === 6123) {
                    $('.option-selector-fieldset>.option-selector__btns>label').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1600);
                    });
                    $('.block-inner-inner>.image-cont>.a').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 3000);
                    });
                }
                // fix petti-artigiani-italiani-1968 by dongnv
                else if (app.storeId === 5880 && app.page.isProductPage()) {
                    let changeVariantOptionProductPage = document.querySelector(
                        '.product__info-container variant-radios.no-js-hidden');
                    if (changeVariantOptionProductPage) {
                        changeVariantOptionProductPage.onchange = function() {
                            setTimeout(() => {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                            }, 1500);
                        };
                    }
                }
                else if (app.storeId === 6598 && app.page.isProductPage()) {
                    let changeVariantOptionProductPages = document.querySelectorAll(
                        '.product__swatches [data-swatch-option]');
                    if (changeVariantOptionProductPages.length) {
                        for (let i = 0; i <
                        changeVariantOptionProductPages.length; i++) {
                            let optionEle = changeVariantOptionProductPages[i];
                            optionEle.onclick = function() {
                                setTimeout(() => {
                                    app.cp.changeProductPrice(shopData,
                                        '.product__price[data-product-price]',
                                        false,
                                    );
                                }, 2000);
                            };
                        }
                    }
                }
                else if (app.storeId === 5252 && app.page.isProductPage()) {
                    let changeVariantOptionProductPages = document.querySelectorAll(
                        '.product-form__variants .product-form__option .block-swatch-list .block-swatch');
                    if (changeVariantOptionProductPages.length) {
                        for (let i = 0; i <
                        changeVariantOptionProductPages.length; i++) {
                            let optionEle = changeVariantOptionProductPages[i];
                            optionEle.onclick = function() {
                                setTimeout(() => {
                                    app.cp.changeProductPrice(shopData,
                                        'form.product-form .product-form__info-item .price-list .price',
                                        '.product-block-list__item--info .card__section form.product-form',
                                    );
                                }, 2000);
                            };
                        }
                    }
                }
                else if (app.storeId === 1651 && app.page.isProductPage()) {
                    let changeVariantOptionProductPages = document.querySelectorAll(
                        '.product-form__variants .product-form__option .block-swatch-list .block-swatch');
                    if (changeVariantOptionProductPages.length) {
                        for (let i = 0; i <
                        changeVariantOptionProductPages.length; i++) {
                            let optionEle = changeVariantOptionProductPages[i];
                            optionEle.onclick = function() {
                                document.querySelectorAll('.block-swatch-list').hide();
                                setTimeout(() => {
                                    document.querySelectorAll(
                                        '.block-swatch-list').show();
                                }, 1000);
                            };
                        }
                    }
                }
                else if (app.storeId === 4423 && app.page.isProductPage()) {
                    let changeVariantOptionProductPages = document.querySelectorAll(
                        '.product-detail__form .clickyboxes [data-value][href="#"]');
                    if (changeVariantOptionProductPages.length) {
                        for (let i = 0; i <
                        changeVariantOptionProductPages.length; i++) {
                            let optionEle = changeVariantOptionProductPages[i];
                            optionEle.onclick = function() {
                                setTimeout(() => {
                                    app.cp.changeProductPrice(shopData,
                                        '.current-price.theme-money', false,
                                    );
                                }, 1500);
                            };
                        }
                    }
                }
                // fix for shop.opdamo
                else if (app.storeId === 2884 && app.page.isProductPage()) {
                    let changeVariantOptionProductPage = document.querySelectorAll(
                        '.product-form__item.product-form__item--zoom');
                    if (changeVariantOptionProductPage) {
                        for (let i = 0; i <
                        changeVariantOptionProductPage.length; i++) {
                            let optionEle = changeVariantOptionProductPage[i];
                            optionEle.onclick = function() {
                                setTimeout(() => {
                                    app.cp.changeProductPrice(shopData, false,
                                        false,
                                    );
                                }, 2000);
                            };
                        }
                    }
                }
                // fix for bvanity by mitri
                else if (app.storeId === 2151) {
                    $('.filter-button').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1600);
                    });
                }
                // fix for kafea-coffee by hoaduong
                else if (app.storeId === 3893) {
                    let customAttr = 'label.price.product-price';
                    $('.engoj_btn_quickview').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, customAttr,
                                false,
                            );
                        }, 1000);
                    });
                    $('.js_engo_autocomplate').on('keyup', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 2000);
                    });
                }
                // fix for shop.renewaball by hoaduong
                else if (app.storeId === 4001) {
                    setTimeout(() => {
                        app.cp.changeProductPrice(shopData,
                            '.price-item.price-item--regular', false,
                        );
                    }, 1000);
                }
                // fix for barhtack by hoaduong
                else if (app.storeId === 3872) {
                    $('#product-add-to-cart').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 3000);
                    });
                    $('.input-group-field.header-search__input').on('change', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 2000);
                    });
                }
                // fix for orcaretail by hoaduong
                else if (app.storeId === 2238) {
                    $('.form-field-input.live-search-form-field').on('keyup', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1500);
                    });
                }
                // fix for deutsche-cannabis-manufaktur by hoaduong
                else if (app.storeId === 4618) {
                    $('.form-field-input.live-search-form-field').on('keyup', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false,
                                false,
                            );
                        }, 1500);
                    });
                    $('.productitem--action-trigger').on('click', function() {
                        let checkDisplayQuickView = setInterval(function() {
                            let priceQuickViewEle = $('.price__current');
                            if (priceQuickViewEle.length > 0) {
                                app.cp.changeProductPrice(shopData, false,
                                    false,
                                );
                                $('.options-selection__option-value').on('click', function() {
                                    setTimeout(() => {
                                        app.cp.changeProductPrice(shopData,
                                            '.price.product__price.price--varies',
                                            false,
                                        );
                                    }, 1000);
                                });
                                clearInterval(checkDisplayQuickView);
                            }
                        }, 1000);
                        setTimeout(function() {
                            clearInterval(checkDisplayQuickView);
                        }, 2000);
                    });
                }
                //fix for annemcdonnell.ie by HaiPd
                else if ([5127,12303].includes(app.storeId)) {
                    $('.no-js-hidden input,.product-form__input label').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1000);
                    });
                }
                // fix for allerleiwindeln by mitri
                else if (app.storeId === 2693 && app.page.isProductPage()) {
                    let customAttr = '.product__info .price-list';
                    $('.block-swatch').on('click', function() {
                        $(customAttr).attr('style', 'visibility: hidden');
                        app.cp.changeProductPrice(shopData, customAttr, false);
                    });
                    $('.variant-swatch__item').on('click', function() {
                        $(customAttr).attr('style', 'visibility: hidden');
                        app.cp.changeProductPrice(shopData, customAttr, false);
                    });
                }
                // fix for b2b.packraftnorge.no bymitri
                else if (app.storeId === 2665) {
                    $('.product-form__input').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1000);
                    });
                }
                // fix fornikkobludesigns bymitri
                else if (app.storeId === 5385) {
                    $('.product-modal').on('click', function() {
                        setTimeout(() => {
                            app.cp.changeProductPrice(shopData, false, false);
                        }, 1000);
                    });
                }
                //fix for sample-shop0621 by CuongNVM
                else if ([3041, 3402].indexOf(app.storeId) !== -1 && app.page.isCollectionPage()) {
                    app.fix.cp.fixShowPriceWhenUseCPAfterSorting(shopData);
                }
                // fix for studyphones by Leorio
                else if (app.storeId === 1138 && app.page.isProductPage()) {
                    let buttonChangeQuantity = $(
                        '#quantity-plus, #quantity-minus');
                    buttonChangeQuantity.on('click', function() {
                        $('.product__price-container [bss-b2b-product-id][bss-b2b-product-parent-price]').
                            css('visibility', 'hidden');
                        $('.product__price-container [bss-b2b-product-id][bss-b2b-product-price]').
                            css('visibility', 'hidden');
                        $('.product__price-container [bss-b2b-product-id][bss-b2b-product-parent-price]').
                            removeAttr('bss-b2b-product-active');
                        $('.product__price-container [bss-b2b-product-id][bss-b2b-product-price]').
                            removeAttr('bss-b2b-product-active');
                        app.cp.changeProductPrice(shopData, null, false, false,
                            true,
                        );
                    });
                }
                else if ([7619, 7654].includes(app.storeId) &&
                    app.page.isProductPage()) {
                    let variantSelectors = document.querySelector(
                        '.product__info-wrapper variant-radios');
                    if (variantSelectors) {
                        variantSelectors.addEventListener('change', function() {
                            const hidePrice = setInterval(() => {
                                $('.no-js-hidden .price.price--large1.price--show-badge').hide();
                            }, 500);
                            setTimeout(() => {
                                app.cp.changeProductPrice(shopData, false,
                                    false, false,
                                );
                                clearInterval(hidePrice);
                                $('.no-js-hidden .price.price--large1.price--show-badge').show();
                            }, 2000);
                        });
                    }
                }
                //fix for sgfloralmarket
                else if (app.storeId === 2157) {
                    app.cart.fixer(shopData, false, true);
                    let buttonChangeQuantity = $(app.cart.buttonChangeQuantity);
                    if (buttonChangeQuantity.length) {
                        buttonChangeQuantity.on('click', function() {
                            app.handleChangeQuantityEventFirstTime(2000, 2000);
                        });
                    }
                }
                // fix for scanasia-as by DangNM
                else if (app.storeId === 1883) {
                    app.cart.fixer(shopData, false, true);
                    let buttonChangeQuantity = $(app.cart.buttonChangeQuantity);
                    if (buttonChangeQuantity.length) {
                        buttonChangeQuantity.on('click', function() {
                            app.handleChangeQuantityEventFirstTime(3000, 3000);
                        });
                    }
                }
                // fix for elizawilliam by CuongNVM
                else if (app.storeId === 3633) {
                    setTimeout(function() {
                        app.cart.fixer(shopData, false, true);
                        app.handleAjaxCart();
                    }, 2000);
                }
                // fix for balance-your-buz by DangNM
                else if ([3643, 3795].indexOf(app.storeId) !== -1 && app.page.isProductPage()) {
                    let customAttr = '.product-template .product-shop .prices .price, .sticky_form .sticky-item .sticky-price';
                    $('.swatch-element').on('click', function() {
                        $(customAttr).removeAttr('bss-b2b-product-active');
                        app.cp.changeProductPrice(shopData,
                            '.product-template .product-shop .prices .price',
                            false,
                        );
                        app.cp.changeProductPrice(shopData,
                            '.sticky_form .sticky-item .sticky-price', false,
                        );
                    });
                    $('.pr-swatch').on('click', function() {
                        $(customAttr).removeAttr('bss-b2b-product-active');
                        app.cp.changeProductPrice(shopData,
                            '.product-template .product-shop .prices .price',
                            false,
                        );
                        app.cp.changeProductPrice(shopData,
                            '.sticky_form .sticky-item .sticky-price', false,
                        );
                    });
                }
                else if (app.storeId === 3955 && app.page.isProductPage()) {
                    let customAttr = 'form[action="/cart/add"] .main-product__block .product-prices .prod__price';
                    $('.main-product__block.main-product__block-variant_picker .product-option-item.sf-po__option-button').
                        on('click', function() {
                            $(customAttr).removeAttr('bss-b2b-product-active');
                            app.cp.changeProductPrice(shopData, null, false);
                        });
                }
                else if (app.storeId === 4342 && app.page.isProductPage()) {
                    let cartForm = document.querySelector(
                        'main section.Product form[action="/cart/add"]');
                    if (cartForm) {
                        let variantOptions = document.querySelectorAll(
                            'main section.Product .OptionSelector .Popover__Content .Popover__Value');
                        for (let i = 0; i < variantOptions.length; i++) {
                            let variantOption = variantOptions[i];
                            variantOption.addEventListener('click', function() {
                                setTimeout(function() {
                                    let priceElem = document.querySelector(
                                        'main .Product__InfoWrapper .ProductMeta__Price.Price');
                                    if (priceElem) {
                                        priceElem.setAttribute(
                                            'bss-b2b-product-id',
                                            ShopifyAnalytics.meta.product.id.toString(),
                                        );
                                        priceElem.setAttribute(
                                            'bss-b2b-product-price', '');
                                    }
                                    app.cp.changeProductPrice(shopData, false,
                                        cartForm,
                                    );
                                }, 1000);
                            });
                        }
                    }
                }
                else if (app.storeId === 5732 && app.page.isProductPage()) {
                    const variantSelectors = document.querySelectorAll(
                        '.form__selectors .radio__fieldset .radio__button');
                    if (variantSelectors.length) {
                        for (let i = 0; i < variantSelectors.length; i++) {
                            const variantSelector = variantSelectors[i];
                            variantSelector.addEventListener('click',
                                function() {
                                    app.cp.changeProductPrice(shopData,
                                        '.product__submit__buttons button[type="submit"] .btn-state-ready [bss-b2b-button-price]',
                                        false,
                                    );
                                },
                            );
                        }
                    }
                }
                else if (app.storeId === 5228) {
                    setTimeout(function() {
                        $('.productitem--action-trigger.productitem--action-qs.button-secondary').
                            on('click', function() {
                                setTimeout(function() {
                                    $('.shopify-payment-button__button').fadeIn();
                                }, 500);
                                setTimeout(function() {
                                    app.applyChangePriceForMultiCartForm();
                                    var cartForm = $(
                                        '.modal.modal--quickshop-full[data-modal-container] form[action*="/cart/add"],' +
                                        'form[action*="/cart/add"],' +
                                        'data-product-form-area form[action*="/cart/add"]');

                                    if (cartForm.length) {
                                        var closestProductMain = cartForm.closest(
                                            '.product-main');
                                        $(closestProductMain).
                                            find(
                                                '.product-block--price .product--price .price--main [bss-b2b-product-id][bss-b2b-product-parent-price]').
                                            removeAttr(
                                                'bss-b2b-product-active');
                                        app.cp.changeProductPrice(shopData,
                                            null, cartForm,
                                        );

                                        $(closestProductMain).find(
                                            '[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr(
                                            'bss-b2b-product-active');
                                        app.makeCloneBuyItNow(cartForm);
                                    }
                                }, 500);
                            });
                    }, 2000);
                }

                // fix deutsche-cannabis-manufaktur, padelutstyr by DongNV
                if (([1990, 4342, 1222, 4618, 5241, 4068, 6317, 6245, 5732, 11481, 11946, 5912].indexOf(app.storeId) === -1) ||
                    (app.storeId === 1990 && !app.page.isCollectionPage()) ||
                    (app.storeId === 5732 && !app.page.isProductPage())) {
                    $(window).scroll(debounce(function() {
                        app.cp.changeProductPrice(shopData, false, false);
                    }, 1000));
                }
            }

            // apply CP or QB
            if (isCPApplied || isQBApplied) {
                if (app.storeId === 3976) {
                    setTimeout(() => {
                        app.handleAjaxCart();
                    }, 3000);
                }
                else if (app.storeId !== 3537) {
                    app.handleAjaxCart();
                }
            }
        }
    };
};

function debounce(fn, ms) {
    let timer;

    return function() {
        const args = arguments;
        const context = this;

        if (timer) clearTimeout(timer);

        timer = setTimeout(() => {
            fn.apply(context, args);
        }, ms);
    };
}

const initInitTimeout = function(app) {
    return function() {
        let timeout = 300;
        if (app.page.isCartPage()) {
            // fix for ellaofficialuk, the-workwear-shed by mitri
            // fix for magiclaze by vitu
            if ([1958, 2477, 2669, 10989].indexOf(app.storeId) !== -1) {
                timeout = 1500;
            }
            // fix for artipieces by mitri
            else if ([2761].indexOf(app.storeId) !== -1) {
                timeout = 4500;
            }
            else if ([7146].indexOf(app.storeId) !== -1) {
                timeout = 2000;
            }
        }
        else if ([6874, 7131].indexOf(app.storeId) !== -1 &&
            app.page.isProductPage()) {
            timeout = 1000;
        }
        // fix for 2w-distribution.myshopify.com (madu SAB2B-102)
        else if (app.storeId === 77) {
            timeout = 100;
        }
        else if (app.storeId === 537) {
            timeout = 30;
        }
        else if ([661, 1283].indexOf(app.storeId) !== -1) {
            timeout = 100;
        }
        // fix for wdw by ThaBi, easyagores.com by hoaduong
        else if ([1031, 1289, 2311, 4561, 5228].indexOf(app.storeId) !== -1) {
            timeout = 2000;
        }
        else if ([1169].indexOf(app.storeId) !== -1) {
            timeout = 5000;
        }
            // fix for b2b-stilform by hoaduong
        // fix for sextoysupplycn by DongNV
        else if ([2970, 4661, 4696, 4739].indexOf(app.storeId) !== -1) {
            timeout = 500;
        }
        else if ([7407].indexOf(app.storeId) !== -1) {
            timeout = 2000;
        }
        else if ([621].indexOf(app.storeId) !== -1 &&
            app.page.isCollectionPage()) {
            timeout = 3000;
        }
        return timeout;
    };
};

function fix_fixModules(app) {
    cp(app);
    checkout(app);
    handleAjaxCart(app);
    // fix mixed modules, run script case
    const handleChangeQuantity = initHandleChangeQuantity(app);
    const handleSomething = initHandleSomething(app);
    const initTimeout = initInitTimeout(app);
    app.fix = {
        ...app.fix, handleChangeQuantity, handleSomething, initTimeout,
    };
}

/* harmony default export */ var fix = (fix_fixModules);
    
// CONCATENATED MODULE: ./js/src/internal/integrate/gem-pages.js
function integrate(app) {

	const isGemPageSelector = function (priceElem, cartFormElem) {
		return cartFormElem && $(priceElem).hasClass("gt_product-price--number");
	};

	const getProductPrice = function (priceElem) {
		let price = $(priceElem).attr("data-currentprice");
		price = parseFloat(price);
		return price;
	};

	const getTotalProductPrice = function (currentPrice, cartFormElem) {
		let quantity = $(cartFormElem).find(".gt_product-quantity--number").val();
		quantity = parseInt(quantity);
		return currentPrice * quantity;
	};

	app.integrate.gemPages = {
		isGemPageSelector,
		getProductPrice,
		getTotalProductPrice,
	};
}

/* harmony default export */ var gem_pages = (integrate);

// CONCATENATED MODULE: ./js/src/internal/integrate/bss-product-option.js
function bss_product_option_integrate(app) {
    const getPoListCartPage = function (cData) {
        let poList = [];
        cData.items.forEach(function (item) {
            Object.keys(localStorage).forEach(function (key) {
                if (item.key == key) {
                    let poItem = {...item};
                    poItem.properties = {...item.properties};
                    let customProperty = JSON.parse(localStorage.getItem(key));
                    poItem['totalExtraPrice'] = customProperty.totalExtraPrice;
                    poItem['titleItem'] = `${BSS_PO.settings.add_ons_text} ${item.handle}`;
                    poList.push(poItem);
                    Object.keys(customProperty).map(keyPo => {
                        Object.keys(item.properties).map(keyCart => {
                            if (customProperty[keyPo] && item.properties[keyCart]) {
                                if (item.properties[keyCart].includes(customProperty[keyPo]) || keyCart.trim().includes(keyPo.trim())) {
                                    if(BSS_B2B.storeId !== 9225) {
                                        delete item.properties[keyCart];
                                    }
                                }
                            }
                        });
                    });
                }
            })
        });
        return poList;
    }

    const getPoListProductPage = function () {
        let poList = [];
        let optionSelectedPO = BSS_PO.po.getOptionsSelected();
        if (optionSelectedPO) {
            let productOption = {};
            optionSelectedPO.forEach(function (option) {
                if (option.customAttributes && option.customAttributes.length > 0) {
                    productOption["customAttributes"] = option.customAttributes;
                }
                if (option.quantity) {
                    productOption["quantity"] = option.quantity;
                }
                if (option.originalUnitPrice) {
                    productOption["originalUnitPrice"] = option.originalUnitPrice;
                }
                if (option.title) {
                    productOption["title"] = option.title;
                }
                if (option.variantId) {
                    productOption["variantId"] = option.variantId;
                }
            })
            if (productOption.customAttributes && productOption.customAttributes.length > 0) {
                poList.push(productOption);
            }
        }
        return poList;
    }

    app.integrate.productOption = {
        getPoListCartPage,
        getPoListProductPage
    };

}
/* harmony default export */ var bss_product_option = (bss_product_option_integrate);
// CONCATENATED MODULE: ./js/src/internal/integrate/bss-subcription.js
function bss_subcription_integrate(app) {
    BSS_B2B.integration.BSS_SUB = {};
    app.integrate.subscription = {}
    if (!window.BSS_SUB) {
        return
    }

    let isEnableCP = false;
    let isEnabledTD = false;
    BSS_B2B.shopModules.forEach(function (sm) {
        if (sm.code === "cp") {
            isEnableCP = sm.status;
        }else if (sm.code === "tax_display") {
            isEnabledTD = sm.status;
        }
    });
    const notCalculatePrice = !isEnableCP && !isEnabledTD;

    const subPriceElement = document.querySelector(".bss-sub-offer-price");
    const getSubPrice = function () {
        const price = subPriceElement && subPriceElement.getAttribute("bss-sub-price");
        return parseFloat(price);
    };

    const subscriptionProductObserver = () => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(() => {
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                
                if (notCalculatePrice) {
                    document.querySelector(`[bss-b2b-product-id="${BSS_SUB.bssSubProduct.product_id}"]`).innerHTML= BSS_B2B.formatMoney(getSubPrice())
                } else {
                    let isFeaturedProductAppliedCP = false;
                    if (isEnableCP) {
                        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
                        isFeaturedProductAppliedCP = BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.some(item => !!item.isFeatured);
                    }

                    if (isEnabledTD && !isFeaturedProductAppliedCP) {
                        BSS_B2B.td.showProductPriceIncludedVat(BSS_B2B, BSS_B2B.shopData, getSubPrice());
                    }
                }
            })
        })
        observer.observe(subPriceElement, { attributes: true })
    }

    const validatePaymentMethod = () => {
        if (Object.keys(window.BSS_SUB.subItems).length) {
            const customerId = BSS_B2B.shopData.customer.id;
            if (!customerId) { // not login
                // window.BSS_SUB.isHasSampleSubInCart = true; // fake to remove checkout_event_b2b and redirect login page
                return;
            }
            if (!window.BSS_SUB.sampleSubProduct) {
                throw new Error ("integrate B2B, SUB: needs to create sample subscription product!")
            }

            fetch(`https://${window.BSS_SUB.apiUrl}/customer/${customerId}/payment-methods?domain=${Shopify.shop}`, {
                method: `GET`,
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(res => res.json())
                .then(data => {
                    if (data.success) {
                        const isHasPaymentMethod = data.paymentMethods && data.paymentMethods.length;
                        if (!isHasPaymentMethod) {
                            $("body").prepend(window.BSS_SUB.sampleSubProduct.modalWarningPaymentMethod);
                            const variantId = window.BSS_SUB.sampleSubProduct.variant_id.replace("gid://shopify/ProductVariant/", '');
                            const planId = window.BSS_SUB.sampleSubProduct.plan_id.replace("gid://shopify/SellingPlan/", '');
                            const btnClose = document.querySelector(".sub-modal-button-close");
                            const btnAdd = document.querySelector(".sub-modal-main-add");
                            btnClose.addEventListener('click', () => {
                                document.querySelector("#bss-sub-modal").remove();
                            })
                            btnAdd.addEventListener('click', () => {
                                fetch('/cart/clear.js', {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    }
                                }).then(res => res.json()).then(data => {
                                    if (!data.message) {
                                        const dataUpdate = {
                                            'items': [{
                                                'id': parseInt(variantId),
                                                'quantity': 1,
                                                'selling_plan': parseInt(planId)
                                            }]
                                        };
                                        fetch('/cart/add.js', {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify(dataUpdate),
                                        }).then(res => res.json()).then(data => {
                                            if (data.items && data.items.length) {
                                                window.location.href = "/cart";
                                            } else { 
                                                console.log(`BSS SUBSCRIPTION ADD CART: ${data.message}`) // eslint-disable-line
                                            }
                                        });
                                    } else {
                                        console.log(`BSS SUBSCRIPTION CLEAR CART: ${data.message}`) // eslint-disable-line
                                    }
                                });
                            })
                        }
                    }
                })
        }
    }

    const convertCartPrice = (items) => {
        items = items.map(item => {
            const plan = item.selling_plan_allocation;
            if (!plan) return item

            const count = plan.price / plan.per_delivery_price;
            const keyPriceCovert = ['price', 'original_price', 'original_line_price', 'line_price', 'final_price', 'final_line_price', 'discounted_price'] ;
            keyPriceCovert.forEach(key => {
                item[key] = item[key] / count
            })

            return item
        })

        return items
    }

    const showSellingPlanDescription = (key, sellingPlanAllocation) => {
        const sellingPlanId = sellingPlanAllocation.selling_plan.id.toString();
        const samplePlanId = window.BSS_SUB.sampleSubProduct && window.BSS_SUB.sampleSubProduct.plan_id;
        const isSampleSub = samplePlanId && samplePlanId.includes(sellingPlanId);

        if (!BSS_B2B.page.isCartPage() || isSampleSub) return

        const interval = new Map();
        interval.set("0", "day");
        interval.set("1", "week");
        interval.set("2", "month");
        interval.set("3", "year");
        let planInterval = null;
        let planIntervalCount = null;
        let planBillEvery = 1;
        const planPayAsYouGo = 0;
        window.BSS_SUB.sellingPlans.forEach(item => {
            if (item['sellingPlans.gid'].includes(sellingPlanId)) {
                planInterval = interval.get(item["sellingPlans.billing_policy_interval"].toString());
                planIntervalCount = item["sellingPlans.billing_policy_interval_count"];
                if (item["selling_plan_type"] != planPayAsYouGo) {
                    planBillEvery = item["sellingPlans.bill_every"];
                }
            }
        })
        let priceElement = document.querySelector(`[bss-b2b-cart-item-key="${key}"][bss-b2b-item-original-price]`);
        
        if (BSS_B2B.cart && BSS_B2B.cart.qbPricingList && BSS_B2B.cart.qbPricingList.size) {
            const parentElement = priceElement.parentNode.parentNode;
            const qbPriceElement = parentElement.querySelector(".bss-qb-price-item");
            if (qbPriceElement) {
                priceElement = qbPriceElement;
            }
        }

        if (priceElement) {
            const parentPriceElement = priceElement.parentNode;
            let descriptionElement = parentPriceElement.querySelector(".bss-sub-description");
            if (!descriptionElement) {
                descriptionElement = document.createElement("p");
                descriptionElement.setAttribute('class', 'bss-sub-description')
            }
    
            const price = priceElement.innerHTML;
            if (planIntervalCount == 1) {
                descriptionElement.innerHTML = `${price} every ${planInterval}`;
            } else {
                descriptionElement.innerHTML = `${BSS_B2B.formatMoney(price.replace(/[^0-9.]/g, '') * planBillEvery*100)} every ${planIntervalCount} ${planInterval}s`;
            }
            parentPriceElement.appendChild(descriptionElement);
        } else {
            console.log(`showSellingPlanDescription: Can not find item'price element `) // eslint-disable-line
        }
    };


    if (window.BSS_B2B.page.isCartPage()) {
        const handleCartChange = () => {
            const cartStorage = localStorage.getItem('cart');
            const data = cartStorage && JSON.parse(cartStorage);
            data && data.items.map(item => {
                if (window.BSS_SUB.sellingPlans && item.selling_plan_allocation) {
                    showSellingPlanDescription(item.key, item.selling_plan_allocation);
                }
            })
        }
        
        if (notCalculatePrice) {
            handleCartChange()
            window.addEventListener("cart_changed", (e) => {
                if (e.detail.isChangedQuantity) {
                    handleCartChange()
                }
            });
        } else {
            window.addEventListener("bss_b2b_cart_fixer_done", () => {
                handleCartChange()
            });
        }
    }


    if (BSS_B2B.page.isProductPage() && subPriceElement) {
        subscriptionProductObserver();
    }


    if (BSS_B2B.page.isCartPage() || BSS_B2B.page.isProductPage()) {
        validatePaymentMethod()
    }

    app.integrate.subscription = {
        subPriceElement,
        getSubPrice,
        subscriptionProductObserver,
        showSellingPlanDescription,
        validatePaymentMethod,
        convertCartPrice
    };
}

/* harmony default export */ var bss_subcription = (bss_subcription_integrate);

// CONCATENATED MODULE: ./js/src/internal/integrate/lang-shop.js
function lang_shop_integrate(app) {
    let defaultLanguage = localStorage.getItem('ls-default-locale') ? localStorage.getItem('ls-default-locale') : 'en';
    const sessionTranslateToDefault = sessionStorage.getItem('BSS_LangShop-translateToDefault');
    let isTranslatingToDefaultLanguage = sessionTranslateToDefault && canUseParseJSON(sessionTranslateToDefault)
        ? JSON.parse(sessionTranslateToDefault)
        : true;
    let isStoreUsingLangShop = false;
    let tooManyRequestTime = 0;
    let findingTranslatedElementsTimes = 0;
    let translateTo = 'en';
    let isTranslatedLanguageDefined = false;
    let translationChangeTimes = localStorage.getItem('BSS_LangShop-retranslation-times') 
        ? localStorage.getItem('BSS_LangShop-retranslation-times') 
        : 0;
    const translatedModules = {
        td : false,
        qb : false,
        dc : false,
        amo : false,
        ef : false,
        qi: false,
        vat: false,
        rf: false
    }

    let integratedApps = BSS_B2B.integrationApp ? BSS_B2B.integrationApp : [];
    if (Array.isArray(integratedApps)) {
        integratedApps.every((app) => {
            if (app.app_id == 1 && app.status) {
                isStoreUsingLangShop = true;
                return false;
            }
            return true;
        })  
    }
    const translationsLengthGreaterThanTen = ['vat', 'rf'];
    const savedTranslatedLanguage = localStorage.getItem('BSS_LangShop-translateTo');

    if (window.Shopify && window.Shopify.locale) {
        translateTo = window.Shopify.locale;
        isTranslatedLanguageDefined = true;
        if (translateTo != savedTranslatedLanguage) {
            if (translatedModules && Object.keys(translatedModules).length) {
                Object.keys(translatedModules).map((module)=>{
                    localStorage.removeItem('BSS_LangShop-' + module + 'Translations')
                })
            }
        }
    } else if (savedTranslatedLanguage) {
        translateTo = savedTranslatedLanguage;
        isTranslatedLanguageDefined = false;
    } else {
        isTranslatedLanguageDefined = false;
    }    

    if (defaultLanguage === translateTo) {
        isTranslatingToDefaultLanguage = true;
        sessionStorage.setItem('BSS_LangShop-translateToDefault', 'true')
    } else {
        isTranslatingToDefaultLanguage = false;
        sessionStorage.setItem('BSS_LangShop-translateToDefault', 'false')
    }

    function handleAllTranslation (moduleName, specificKeys, qbEfRuleName) {
        if (BSS_B2B.integrate.langShop.isStoreUsingLangShop) {
            BSS_B2B.integrate.langShop.translatedModules[moduleName] = true;
            if (BSS_B2B.integrate.langShop.isTranslatedLanguageDefined) {
                if (moduleName === 'qi' || moduleName === 'amo') {
                    localStorage.removeItem('BSS_LangShop-' + moduleName + 'Translations')
                }
                handleTranslateAndStore(moduleName, BSS_B2B.integrate.langShop.translateTo, specificKeys, qbEfRuleName); 
            } else {
                determineTranslatedLanguage(moduleName, specificKeys, qbEfRuleName);
            }
        }
    }

    async function translatingByLangShop (translateTo, query) {
        let data = {
            domain: window.Shopify.shop,
            translateTo: translateTo,
            query: query
        };
        if (isTranslatingToDefaultLanguage) {
            data = {
                ...data,
                defaultLanguage: defaultLanguage
            }
        }     
        let translatedQuery = await fetch(bssB2bApiServer + '/integration/lang-shop/translations?domain=' + window.Shopify.shop,{
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
        return translatedQuery.json();  
    }

    function changeElementInnerText (moduleName, translationsData, translateTo, specificKeys) {
        if (findingTranslatedElementsTimes === 2) {
            findingTranslatedElementsTimes = 0;
            BSS_B2B.integrate.langShop.translatedModules[moduleName] = false;
            return;
        }
        localStorage.setItem('BSS_LangShop-translateTo', translateTo);
        let isTranslated = false;
        const queryElementsStr = 'bss-b2b-translation-' + moduleName;
        const translationElements = document.querySelectorAll('[class*="' + queryElementsStr + '"]');
        let savedTranslatedModule = localStorage.getItem('BSS_LangShop-' + moduleName + 'Translations');
        savedTranslatedModule = savedTranslatedModule && canUseParseJSON(savedTranslatedModule) ? JSON.parse(savedTranslatedModule) : false;

        if (
            specificKeys && specificKeys.length &&
            ( (BSS_B2B.integrate.langShop && BSS_B2B.integrate.langShop[moduleName + 'Translations'])
            || savedTranslatedModule)
        ) {
            specificKeys.map((key) => {
                let specificTranslationsData = BSS_B2B.integrate.langShop[moduleName + 'Translations']
                    ? BSS_B2B.integrate.langShop[moduleName + 'Translations']
                    : savedTranslatedModule;

                const specificElements = document.querySelectorAll('[class*="bss-b2b-translation-'+ moduleName +'-'+ key +'"]')
                if (specificElements.length) {
                    for (const element of specificElements) {
                        element.innerText = specificTranslationsData[key]
                        isTranslated = true;
                    }
                }
            })
        }
        
        if (moduleName === 'rf' && typeof translationsData === 'object' && Object.keys(translationsData).length) {
            Object.keys(translationsData).map((key)=>{
                const rfTranslationLabelWithFor = document.querySelectorAll('label[for="' + key + '"]');
                let rfTranslationElementWithId = document.querySelectorAll('#' + key);

                if (key.includes('control-')) { // header element of RF
                    rfTranslationElementWithId = document.querySelectorAll('.rendered-form [id^="control-"]');
                }

                if (rfTranslationLabelWithFor.length) {
                    for (const label of rfTranslationLabelWithFor) {
                        label.innerText = translationsData[key];
                    }
                    isTranslated = true;
                } else if (rfTranslationElementWithId.length) {
                    let headerCount = 0;
                    for (const element of rfTranslationElementWithId) {
                        if (key.includes('control-')) { // header element of RF
                            headerCount++;
                            const keyIndex = key.substring(key.indexOf('-') + 1)
                            if (headerCount == keyIndex) {
                                element.innerText = translationsData[key];                            
                            }
                        } else {
                            element.innerText = translationsData[key];
                        }
                    }
                    isTranslated = true;
                }
            })
        }

        if (typeof translationsData === 'object' && Object.keys(translationsData).length && translationElements.length) {
            Object.keys(translationsData).map((key)=>{
                const moreSpecificTranslationElements = document.querySelectorAll('.' + queryElementsStr + '-' + key);
                
                if (moreSpecificTranslationElements.length) {
                    for (let i = 0; i < moreSpecificTranslationElements.length; i++) {
                        const ele = moreSpecificTranslationElements[i];
                        ele.innerText = translationsData[key];
                        isTranslated = true;
                    }
                }
            })
        } 
        if ((['td', 'qb'].includes(moduleName) && BSS_B2B.page.isCollectionPage()) || (translationElements.length === 0 && !isTranslated)) {
            setTimeout(()=>{
                ++findingTranslatedElementsTimes;
                changeElementInnerText(moduleName, translationsData, translateTo, specificKeys)
            }, 2000)
        }
        if (isTranslated) {
            findingTranslatedElementsTimes = 0;
            BSS_B2B.integrate.langShop.translatedModules[moduleName] = true;
            return 'BSS LangShop: Translation complete ' + moduleName;
        }
    }

    function handleTranslateAndStore (moduleName, translateTo, specificKeys, qbEfRuleName) {
        const savedTranslatedModuleName = 'BSS_LangShop-' + moduleName + 'Translations';
        const savedTranslatedModule = localStorage.getItem(savedTranslatedModuleName);
        const savedTranslateTo = localStorage.getItem('BSS_LangShop-translateTo');
        
        let b2bModuleTranslation = {...BSS_B2B[moduleName + 'Translations']};
        if (moduleName === 'td') {
            b2bModuleTranslation = BSS_B2B.taxDisplayTranslations && {...BSS_B2B.taxDisplayTranslations}
        }
        if (moduleName === 'dc') {
            b2bModuleTranslation = {...BSS_B2B.dcTranslations}
        }
        if ((['ef', 'qb'].includes(moduleName)) && specificKeys && specificKeys.length && specificKeys[0] === 'rule_name' && qbEfRuleName) {
            b2bModuleTranslation = {
                ...b2bModuleTranslation,
                'rule_name': qbEfRuleName
            }
        }
        if (moduleName === 'rf') {
            const allRFTextLabels = document.querySelectorAll(`.rendered-form .form-group label[class^="formbuilder"]
            , .rendered-form .form-group select.form-control option
            , .rendered-form .form-group .checkbox-group .formbuilder-checkbox label
            , .rendered-form .form-group .radio-group .formbuilder-radio label
            , .rendered-form [id^="control-"]`)
            const labelsTextObj = {};
            const rfGeneralSettings = {};

            if (allRFTextLabels.length) {
                let headerCount = 0;
                for (const label of allRFTextLabels) {
                    const forOfLabel = label.getAttribute('for');
                    const idOfLabel = label.id;

                    if (forOfLabel) {
                        labelsTextObj[forOfLabel] = label.innerText;
                    } else if (idOfLabel) {
                        if (idOfLabel.includes('control-')) { // header element of RF
                            headerCount++;
                            labelsTextObj['control-' + headerCount] = label.innerText;
                        } else {
                            labelsTextObj[idOfLabel] = label.innerText;
                        }
                    }
                }
            }
            if (typeof BSS_B2B.rfGeneralSettings === 'object' && Object.keys(BSS_B2B.rfGeneralSettings).length) {
                Object.keys(BSS_B2B.rfGeneralSettings).map(key => {
                    if (key != 'text_color_success' && key != 'text_color_failed') {
                        rfGeneralSettings[key] = BSS_B2B.rfGeneralSettings[key];
                    }
                })
            }

            b2bModuleTranslation = {...rfGeneralSettings, ...labelsTextObj};
        }

        let checkTranslationItemsChanged = false;
        if (b2bModuleTranslation && typeof b2bModuleTranslation === 'object' && Object.keys(b2bModuleTranslation).length) {
            let storedOriginalTranslations = localStorage.getItem('BSS_LangShop-' + moduleName + '-original-translations');
            
            if (storedOriginalTranslations && canUseParseJSON(storedOriginalTranslations)) {
                const moduleTranslation = Object.keys(b2bModuleTranslation);
                let areItemsDifferent = false;
                storedOriginalTranslations = JSON.parse(storedOriginalTranslations);
                moduleTranslation.map(key => {
                    const storedKey = storedOriginalTranslations[key];
                    const currentKey = b2bModuleTranslation[key];
                    
                    if (!storedKey || currentKey != storedKey) {
                        checkTranslationItemsChanged = true;
                        if (storedKey && currentKey != storedKey) {
                            areItemsDifferent = true;
                        }
                    }
                })
                if (checkTranslationItemsChanged) {
                    localStorage.removeItem(savedTranslatedModuleName)
                    if (areItemsDifferent) {
                        translationChangeTimes++;
                        localStorage.setItem('BSS_LangShop-retranslation-times', translationChangeTimes);
                    }
                }
            } else {
                checkTranslationItemsChanged = false;
            }
            localStorage.setItem('BSS_LangShop-' + moduleName + '-original-translations', JSON.stringify(b2bModuleTranslation));
        }

        if (
            savedTranslatedModule && canUseParseJSON(savedTranslatedModule) && savedTranslateTo && savedTranslateTo === translateTo && !checkTranslationItemsChanged
        ) {
            BSS_B2B.integrate.langShop[moduleName + 'Translations'] = JSON.parse(savedTranslatedModule)
            changeElementInnerText(moduleName, JSON.parse(savedTranslatedModule), translateTo, specificKeys)
        } else {
            if (b2bModuleTranslation && typeof b2bModuleTranslation === 'object' && Object.keys(b2bModuleTranslation).length) {
                let queryTranslate = [];

                for (const prop in b2bModuleTranslation) {
                    if (queryTranslate.length < 10) {
                        const keyName = translationChangeTimes === 0 
                            ? moduleName + '-' + prop
                            : moduleName + '-' + prop + '-_-' + translationChangeTimes
                        queryTranslate.push({
                            "key": keyName,
                            "value": b2bModuleTranslation[prop]
                        })

                        if (queryTranslate.length === 10 && translationsLengthGreaterThanTen.includes(moduleName)) {
                            translateAndStore(moduleName, queryTranslate, translateTo, specificKeys)
                            queryTranslate = [];
                        }
                    }
                }
                translateAndStore(moduleName, queryTranslate, translateTo, specificKeys)
            }
        }
    }

    async function translateAndStore (moduleName, queryTranslate, translateTo, specificKeys) {
        if (tooManyRequestTime === 3) {
            tooManyRequestTime = 0;
            BSS_B2B.integrate.langShop.translatedModules[moduleName] = false;
            return;
        }        
        if (moduleName && queryTranslate.length && translateTo) {
            let translatedQuery = await translatingByLangShop(translateTo, queryTranslate);
            let translationsData = {};
            if (translatedQuery.result.data && !translatedQuery.result.errors) {
                tooManyRequestTime = 0;
                for (let i = 0; i < translatedQuery.result.data.translations.length; i++) {
                    const item = translatedQuery.result.data.translations[i];
                    let originalKeyName = item.key;
                    if (originalKeyName.indexOf(moduleName + '-') === 0) {
                        originalKeyName = originalKeyName.substring(originalKeyName.indexOf('-') + 1);
                    }
                    if (originalKeyName.includes('-_-')) {
                        originalKeyName = originalKeyName.substring(0, originalKeyName.indexOf('-_-'))
                    }
                    translationsData[originalKeyName] = item.value;
                }
                if (typeof translationsData === 'object' && Object.keys(translationsData).length) {
                    const savedTranslatedModuleName = 'BSS_LangShop-' + moduleName + 'Translations';
                    let moduleTranslation = BSS_B2B.integrate.langShop[moduleName + 'Translations'];

                    if (
                        translationsLengthGreaterThanTen.includes(moduleName)
                        && moduleTranslation && Object.keys(moduleTranslation).length
                    ) {
                        translationsData = {...moduleTranslation, ...translationsData}
                    }

                    BSS_B2B.integrate.langShop[moduleName + 'Translations'] = translationsData
                    localStorage.setItem(savedTranslatedModuleName, JSON.stringify(translationsData));

                    changeElementInnerText(moduleName, translationsData, translateTo, specificKeys)
                }
            } 
            else if (translatedQuery.result.errors && translatedQuery.result.code === 429 && translatedQuery.result.message === 'Too many requests') {
                tooManyRequestTime++;
                setTimeout(()=>{
                    translateAndStore (moduleName, queryTranslate, translateTo, specificKeys)
                }, 25000)
            } 
            else if (translatedQuery.result.errors || !translatedQuery.result) {
                BSS_B2B.integrate.langShop.translatedModules[moduleName] = false;
            }
        }        
    }

    function determineTranslatedLanguage (moduleName, specificKeys, qbEfRuleName) {
        const intervalId = window.setInterval(()=>{
            const languageSwitcher = document.querySelectorAll('shadow-root, .lsn-switcher');
            if (languageSwitcher && languageSwitcher.length) {
                window.clearInterval(intervalId);
                window.clearTimeout(timeoutId);

                let translatedLanguage = '';
                let langShopSelectors = [];
                languageSwitcher.forEach((ele)=>{
                    if (ele.className.includes('lsn-switcher')) {
                        const langShopEle = ele.querySelector('.lsn-select .lsn-select__input')
                        
                        if (langShopEle) {
                            translatedLanguage = langShopEle.value
                            langShopSelectors = ele.querySelectorAll(
                                '.lsn-select .lsn-select__list .lsn-select__item[data-value]:not([data-value="'+translatedLanguage+'"])'
                            );
                        }
                    } else { // old lang shop switcher
                        const langShopEle = ele.shadowRoot.querySelector('[translate] .active[data-code]')
                        
                        if (langShopEle) {
                            translatedLanguage = langShopEle.getAttribute('data-code')
                            langShopSelectors = ele.shadowRoot.querySelectorAll(
                                '[translate] ul li[data-code]:not([data-code="'+translatedLanguage+'"])'
                            );
                        }                        
                    }
                })

                if (translatedLanguage) {
                    defaultLanguage = localStorage.getItem('ls-default-locale')
                    if (translatedLanguage === defaultLanguage) {
                        isTranslatingToDefaultLanguage = true
                        sessionStorage.setItem('BSS_LangShop-translateToDefault', 'true')
                    } else {
                        isTranslatingToDefaultLanguage = false
                        sessionStorage.setItem('BSS_LangShop-translateToDefault', 'false')                        
                    }
                    BSS_B2B.integrate.langShop.translateTo = translatedLanguage;
                    BSS_B2B.integrate.langShop.isTranslatedLanguageDefined = true;

                    if (moduleName) {
                        handleTranslateAndStore(moduleName, translatedLanguage, specificKeys, qbEfRuleName)
                    }
                }

                if (langShopSelectors.length) {
                    for (let i = 0; i < langShopSelectors.length; i++) {
                        const languageSelector = langShopSelectors[i];
                        
                        languageSelector.onclick = function () {
                            let newTranslateTo = '';
                            const dataValue = languageSelector.getAttribute('data-value');
                            const dataCode = languageSelector.getAttribute('data-code');
                            if (dataValue) {
                                newTranslateTo = dataValue
                            }
                            if (dataCode) {
                                newTranslateTo = dataCode
                            }

                            if (newTranslateTo) {
                                localStorage.setItem('BSS_LangShop-translateTo', newTranslateTo)
                                if (newTranslateTo === defaultLanguage) {
                                    sessionStorage.setItem('BSS_LangShop-translateToDefault', 'true')
                                } else {
                                    sessionStorage.setItem('BSS_LangShop-translateToDefault', 'false')
                                }
                            }
                            if (translatedModules && Object.keys(translatedModules).length) {
                                Object.keys(translatedModules).map((module)=>{
                                    localStorage.removeItem('BSS_LangShop-' + module + 'Translations')
                                })
                            }
                        }
                    }
                }                    
            }
        }, 1000)

        const timeoutId = window.setTimeout(()=>{
            if (moduleName) {
                BSS_B2B.integrate.langShop.translatedModules[moduleName] = false;
            }
            window.clearInterval(intervalId);
        }, 10000)
    }

    function canUseParseJSON (param) {
        try {
            JSON.parse(param);
        } catch (e) {
            return false;
        }
        return true;
    }

	app.integrate.langShop = {
        isStoreUsingLangShop,
        translateTo,
        isTranslatedLanguageDefined,
        translatedModules,
        handleAllTranslation,
		translatingByLangShop,
        changeElementInnerText,
        handleTranslateAndStore,
        determineTranslatedLanguage,
        canUseParseJSON
	};
}

/* harmony default export */ var lang_shop = (lang_shop_integrate);

// CONCATENATED MODULE: ./js/src/internal/integrate/zapiet.js
function zapiet_integrate(app) {
	// Integration App Zapiet
	BSS_B2B.integration.Zapiet = false;
	if (BSS_B2B.integrationApp && BSS_B2B.integrationApp.length) {
		for (let integrationApp of BSS_B2B.integrationApp) {
			if (integrationApp.app_id === 2 && integrationApp.status === 1 && window.Zapiet && window.ZapietCachedSettings) {
				BSS_B2B.integration.Zapiet = true;
				break;
			}
		}
	}

	const handleCart = function (shopData) {
		const pickupElement = document.querySelector('#storePickupApp');
		if (pickupElement) {
			const observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (m) {
					if (m.removedNodes && m.removedNodes.length) {
						const errorMessage = pickupElement.querySelector('p.error');
						if (errorMessage) {
							errorMessage.remove();
						}
						BSS_B2B.cart.fixer(shopData, false, false);
						const checkoutButton = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
						if (checkoutButton && checkoutButton.length) {
							let interval = setInterval(() => {
								if (window.ZapietCheckoutEnabled === true) {
									window.clearInterval(interval);
									checkoutButton.forEach((button) => {
										button.setAttribute("disabled", "")
										if(BSS_B2B.storeId === 12371){
											button.setAttribute('style', 'pointer-events:none');
										}
									});
									const buttonArray = [];
									setTimeout(() => {
										checkoutButton.forEach((button) => {
											if(BSS_B2B.storeId === 12371){
												button.setAttribute('style', 'pointer-events:auto');
											}
											const cloneBtn = button.cloneNode(true);
											if (button.parentNode) {
												button.parentNode.replaceChild(cloneBtn, button);
											}
											buttonArray.push(cloneBtn);
										})
										BSS_B2B.handleCartCheckoutBtn(shopData);
										buttonArray.forEach((button) => button.removeAttribute("disabled"));
									}, 1000)
								}
							}, 100)
							setTimeout(() => {
								window.clearInterval(interval);
							}, 3000)
						}
					}
				})
			})
			observer.observe(pickupElement, {childList: true, subtree: true});
		}
	};

	app.integrate.zapiet = {
		handleCart
	};
}

/* harmony default export */ var zapiet = (zapiet_integrate);

// CONCATENATED MODULE: ./js/src/internal/integrate/index.js





const handleError = (callback, app) => {
	try {
		callback(app)
	} catch (error) {
		// eslint-disable-next-line no-console
		console.log(error); 
	}
}
function integrate_fixModules(app) {
	if (!BSS_B2B.integration) {
		BSS_B2B.integration = {};
	}

	handleError(gem_pages, app);
	handleError(bss_product_option, app);
	handleError(lang_shop, app);
	handleError(zapiet, app);
	handleError(bss_subcription, app);
}

/* harmony default export */ var internal_integrate = (integrate_fixModules);

// CONCATENATED MODULE: ./js/src/internal/index.js
// import customize from "./customize";



function initFunctions(app, callback) {
	callback(app);
}

function initInternalFunctions(app) {
	app.customize = {};
	app.fix = {};
	app.integrate = {};
	// const customizedStoreIds = Object.keys(customize);
	initFunctions(app, internal_integrate);
	initFunctions(app, fix);
	// const currentStoreId = app.storeId.toString();
	// if (customizedStoreIds.indexOf(currentStoreId) !== -1) {
	// 	initFunctions(app, customize[currentStoreId]);
	// }
}

/* harmony default export */ var internal = (initInternalFunctions);

// CONCATENATED MODULE: ./js/src/helper/get-element-dom.js

const getQuantityElement = () => {
    const quantitySelector = [
        '.product-form__quantity',
        '.product-form__quantity-selector',
        '.product-single__quantity',
        'quantity-selector',
        '.product-qty',
        '.product-quantity',
        '.has-quantity-box',
        '.quantity',
        '.clickyboxes.options-clothing-size',
        '.ecom-product-single__quantity',
        '.quantity-selector',
        '.product-quantity-block'
    ];

    let quantityElement;
    for (let i = 0; i < quantitySelector.length; i++) {
        quantityElement = document.querySelector(quantitySelector[i]);
        if (quantityElement) {
            break;
        }
    };

    return quantityElement;
}

const getQuantityInputElement = () => {
    const quantityInput = [
        '.product-form__quantity .quantity__input',
        `input[id^='product-quantity-product']`,
        'form[action="/cart/add"] input#quantity[name="quantity"]',
        `input[name='quantity']`
    ];

    let quantityInputElement;
    for (let i = 0; i < quantityInput.length; i++) {
        quantityInputElement = document.querySelector(quantityInput[i]);
        if (quantityInputElement) {
            break;
        }
    };

    return quantityInputElement;
}

const getQuantityPlusElement = () => {
    const quantityPlus = [
        '.product-form__quantity .quantity__button[name="plus"]',
        '.quantity .quantity-up',
        'form[action="/cart/add"] .decr',
        '.ecom-product-single__quantity-controls-plus',
        'button[data-action="increase-picker-quantity"]',
        'form[action="/cart/add"] .qty-plus',
        '.quantity__wrapper button.quantity__button[name="increment"]',
        '.product-quantity-block button[type="button"]:has(.icon-plus)'
    ];

    let quantityPlusElement;
    for (let i = 0; i < quantityPlus.length; i++) {
        quantityPlusElement = document.querySelector(quantityPlus[i]);
        if (quantityPlusElement) {
            break;
        }
    };

    return quantityPlusElement;
}

const getQuantityMinusElement = () => {
    const quantityMinus = [
        '.product-form__quantity .quantity__button[name="minus"]',
        '.quantity .quantity-down',
        'form[action="/cart/add"] .decr',
        '.ecom-product-single__quantity-controls-minus',
        'button[data-action="decrease-picker-quantity"]',
        'form[action="/cart/add"] .qty-minus',
        '.quantity__wrapper button.quantity__button[name="decrement"]',
        '.product-quantity-block button[type="button"]:has(.icon-minus)',
        '.qty-input__btn.btn.btn--minus', '.quantity__btn.quantity__btn--decrease'
    ];

    let quantityMinusElement;
    for (let i = 0; i < quantityMinus.length; i++) {
        quantityMinusElement = document.querySelector(quantityMinus[i]);
        if (quantityMinusElement) {
            break;
        }
    };

    return quantityMinusElement;
}

const getBuyNowButton = () => {
    const buynowSelector = [
        '.shopify-payment-button',
        '.product-add'
    ];

    let buynowElement;
    for (let i = 0; i < buynowSelector.length; i++) {
        buynowElement = document.querySelector(buynowSelector[i]);
        if (buynowElement) {
            break;
        }
    };

    return buynowElement;
}
// CONCATENATED MODULE: ./js/src/helper/format-money-support.js
function formatMoneySupport(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    decimalCount = Math.abs(decimalCount) || 2;
    const negativeSign = amount < 0 ? "-" : "";
    let absAmount = Math.abs(amount);
    let formattedAmount = absAmount.toFixed(decimalCount);
    let [integer, fraction] = formattedAmount.split(".");
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return negativeSign + integer + (decimalCount ? decimal + fraction : "");
}
// CONCATENATED MODULE: ./js/src/ol/ol-support.js


function formatMoneyWithDomain(domain, amount) {
    if (!amount) return;
    // Check domain format

    return formatMoneySupport(amount);
}
// CONCATENATED MODULE: ./js/src/ol/init-order-limits.js



function initAMO($, BSS_B2B, shopData, isEnableAMO, isEnableCP, isEnableQB, Shopify) {
    /**
     * For advanced minimum order
     */
    BSS_B2B.amo = {};
    BSS_B2B.amo.warning = [];

    BSS_B2B.amo.warningsModal = "";
    let checkoutButton = document.querySelectorAll(BSS_B2B.helper.checkoutElements);

    let rateMarket = 1;
    if (Shopify.currency && Shopify.currency.rate) {
        rateMarket = Shopify.currency.rate;
    }

    if (isEnableAMO && BSS_B2B.amoSettings) {
        /**
         * AMO warnings modal
         */
        BSS_B2B.amo.warningsModal = "<div id='modalWarningAMO'>\n" +
            "<div class='bss-modal-warning-amo-wrap' tabindex='-1'>" +
            "<div>" +
            "<div class='bss-modal-amo active'>" +
            "<div class='bss-modal-amo-header' style='padding: 10px; background: " + BSS_B2B.amoSettings.headerBackgroundColor + ";'>" +
            "<button title='Close (Esc)' type='button' class='bss-modal-button-close'>×</button>" +
            "<b class='bss-modal-amo-title bss-b2b-translation-amo-warning_text' style='margin-left: 12px; color: " + BSS_B2B.amoSettings.headerTextColor + "'>"
            + BSS_B2B.amoTranslations.warning_text + "</b>\n" +
            "</div>" +
            "<div class='bss-modal-amo-body' style='padding: 18px; background: " + BSS_B2B.amoSettings.contentBackgroundColor + "; color: "
            + BSS_B2B.amoSettings.contentTextColor + "'>" +
            "<div class='bss-amo-list-warning'>" +
            "<span class='bss-warning-minimum-quantity-title bss-b2b-translation-amo-at_least_text'>" + BSS_B2B.amoTranslations.at_least_text;

        if ([4726, 437, 2296, 7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
            BSS_B2B.amo.warningsModal += "</span>"
        } else if ([5671].indexOf(BSS_B2B.storeId) !== -1) {
            BSS_B2B.amo.warningsModal += "<div id='modalWarningAMO'>\n" +
                "<div class='bss-modal-warning-amo-wrap' tabindex='-1'>" +
                "<div>" +
                "<div class='bss-modal-amo active'>" +
                "<div class='bss-modal-amo-header' style='padding: 10px; background: " + BSS_B2B.amoSettings.headerBackgroundColor + ";'>" +
                "<button title='Close (Esc)' type='button' class='bss-modal-button-close'>×</button>" +
                "<b class='bss-modal-amo-title' style='margin-left: 12px; color: " + BSS_B2B.amoSettings.headerTextColor + "'>" + BSS_B2B.amoTranslations.warning_text + "</b>\n" +
                "</div>" +
                "<div class='bss-modal-amo-body' style='padding: 18px; background: " + BSS_B2B.amoSettings.contentBackgroundColor + "; color: " + BSS_B2B.amoSettings.contentTextColor + "'>" +
                "<div class='bss-amo-list-warning'>"
        } else {
            BSS_B2B.amo.warningsModal += ": </span>"
        }

        BSS_B2B.amo.warningsModal += "<ol class='bss-amo-list-warning-minimum-quantity'>\n" +
            "</ol>\n";

        BSS_B2B.amo.warningsModal += "<span class='bss-warning-maximum-quantity-title bss-b2b-translation-amo-up_to_text'>" + BSS_B2B.amoTranslations.up_to_text;
        if ([4726, 437, 2296, 7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
            BSS_B2B.amo.warningsModal += "</span>"
        } else {
            BSS_B2B.amo.warningsModal += ": </span>"
        }

        BSS_B2B.amo.warningsModal += "<ol class='bss-amo-list-warning-maximum-quantity'>\n" +
            "</ol>\n";

        if (BSS_B2B.storeId !== 2409) {
            BSS_B2B.amo.warningsModal += "<span class='bss-warning-minimum-amount-title bss-b2b-translation-amo-warning_minimum_order_text'>"
                + BSS_B2B.amoTranslations.warning_minimum_order_text;
            if ([4726, 437, 2296, 7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                BSS_B2B.amo.warningsModal += "</span>"
            } else {
                BSS_B2B.amo.warningsModal += ": </span>"
            }
        }
        BSS_B2B.amo.warningsModal += "<ol class='bss-amo-list-warning-minimum-amount'>\n" +
            "</ol>\n";
        if (BSS_B2B.storeId !== 2409) {
            BSS_B2B.amo.warningsModal += "<span class='bss-warning-maximum-amount-title bss-b2b-translation-amo-warning_maximum_order_text'>"
                + BSS_B2B.amoTranslations.warning_maximum_order_text;
            if ([4726, 437, 2296, 7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                BSS_B2B.amo.warningsModal += "</span>"
            } else {
                BSS_B2B.amo.warningsModal += ": </span>"
            }
        }
        // Fix for nicolajoyeria by Devlin
        if (BSS_B2B.storeId === 13614 && BSS_B2B.amoSettings.show_btn_redirect) {
            const customerTags = shopData.customer.tags ? shopData.customer.tags : [];
            let url = BSS_B2B.amoSettings.url_redirect;
            let isApplyUrl = customerTags.some(tag => BSS_B2B.amoSettings.apply_button_to_customer_tags.includes(tag));
            if (!isApplyUrl && BSS_B2B.amoSettings.urlByCustomers) {
                const arrayUrlByCustomerTags = BSS_B2B.amoSettings.urlByCustomers.filter((item) => customerTags.some(tag => item.customerTags.includes(tag)));
                if (arrayUrlByCustomerTags.length) {
                    url = arrayUrlByCustomerTags[0].url;
                    isApplyUrl = true;
                }
            }
            if (isApplyUrl) {
                BSS_B2B.amo.warningsModal += '<a href="' + url + '" class="bss-btn-redirect-ol btn" target="_blank">SIN COMPRA MINIMA</a>'
            }
        }
        BSS_B2B.amo.warningsModal += "<ol class='bss-amo-list-warning-maximum-amount'>\n" +
            "</ol>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>\n" +
            "<div class='bss-amo-modal-bg active' style='display: block !important'></div>\n" +
            "</div>\n" +
            "</div>\n" +
            "</div>"
    }

    BSS_B2B.amo.showWarningsModal = function () {
        if (!$("#modalWarningAMO").length) {
            $("body").prepend(BSS_B2B.amo.warningsModal);
            // fix for theme Dawn by ThaBi
            if ($("body").hasClass("gradient")) {
                let mainContent = $("body").find("#MainContent.content-for-layout.focus-none");
                if (mainContent.length) {
                    mainContent.css("pointer-events", "none");
                }
            }

            if ($(".bss-amo-list-warning").length) {
                BSS_B2B.amo.warning.forEach(item => {
                    if (item.includes("data-warning-minimum-quantity")) {
                        BSS_B2B.amo.hideShowProductMessage("bss-warning-minimum-quantity-title", "bss-amo-list-warning-minimum-quantity", item)
                    } else if (item.includes("data-warning-minimum-amount")) {
                        BSS_B2B.amo.hideShowProductMessage("bss-warning-minimum-amount-title", "bss-amo-list-warning-minimum-amount", item)
                    } else if (item.includes("data-warning-maximum-quantity")) {
                        BSS_B2B.amo.hideShowProductMessage("bss-warning-maximum-quantity-title", "bss-amo-list-warning-maximum-quantity", item)
                    } else if (item.includes("data-warning-maximum-amount")) {
                        BSS_B2B.amo.hideShowProductMessage("bss-warning-maximum-amount-title", "bss-amo-list-warning-maximum-amount", item)
                    }
                })
            }
            $(".bss-modal-button-close, .bss-amo-modal-bg").on("click", function () {
                $("#modalWarningAMO").remove();
                // fix for theme Dawn by ThaBi
                if ($("body").hasClass("gradient")) {
                    let mainContent = $("body").find("#MainContent.content-for-layout.focus-none");
                    if (mainContent.length) {
                        mainContent.css("pointer-events", "unset");
                    }
                }
                BSS_B2B.integrate.langShop.translatedModules.amo = false;
                BSS_B2B.handleCartCheckoutBtn(shopData);
            })

            setTimeout(() => {
                BSS_B2B.integrate.langShop.handleAllTranslation('amo');
            }, 500)
        }
    };

    BSS_B2B.amo.quantityInputSelectorOnCartPage = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] input[type="number"][data-quantity-input]',
            '[data-cart-item-key="' + key + '"] input[data-quantity-input]',
            '[data-cart-item-key="' + key + '"] input[data-cart-item-input-quantity]',
            '[data-cart-item-key="' + key + '"] input.js-qty__input',
            '[data-cart-item-key="' + key + '"] input.js-qty__num',
            '[data-cart-item-key="' + key + '"] input.quantity-selector',
            '[data-cart-item-key="' + key + '"] input.cart__quantity-selector',
            '[data-cart-item-key="' + key + '"] input.js--num',
            '[data-cart-item-id="' + key + '"] input.cart-item__qty-input',
            '[data-cart-item-key="' + key + '"] input.cart__product-qty',
            '[data-cart-item-key="' + key + '"] input.form__input.cart__quantity',
            'input.js-qty__num[data-id="' + key + '"]',
            'input.ajaxcart__qty-num[data-id="' + key + '"]',
            '[data-cart-item-key="' + key + '"] input.quantity__input',
            'input.quantity__input[data-id="' + key + '"]'
        ]
    };

    BSS_B2B.amo.amountItemOfProductOnCartPage = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] [data-cart-item-line-price] [data-cart-item-regular-price]',
            '[data-cart-item-key="' + key + '"] .cart__item-total',
            '[data-cart-item-key="' + key + '"] [data-label="Total"]',
            '.price.price--end[data-id="' + key + '"]'
        ]
    };

    BSS_B2B.amo.listItemApplyAMO = function (lineItemsApplyAMO) {
        let listItem = [...lineItemsApplyAMO];

        lineItemsApplyAMO.map(item1 => {
            lineItemsApplyAMO.map(item2 => {
                if ((item1.type === item2.type) && (item1.id === item2.id) && (item1.ruleId !== item2.ruleId)) {
                    if (item1.priority > item2.priority) {
                        listItem = listItem.filter(item => item.ruleId !== item1.ruleId);
                    } else if (item1.priority === item2.priority) {
                        //type === 0 is minimum amount, type === 1 is minimum quantity
                        if ([0, 1].includes(item1.type)) {
                            if (Number(item1.minimum_quantity) < Number(item2.minimum_quantity)) {
                                listItem = listItem.filter(item => item.ruleId !== item1.ruleId);
                            }
                        }
                        //type === 2 is maximum amount, type === 3 is maximum quantity
                        else if ([2, 3].includes(item1.type)) {
                            if (Number(item1.maximum_quantity) > Number(item2.maximum_quantity)) {
                                listItem = listItem.filter(item => item.ruleId !== item1.ruleId);
                            }
                        }
                    }
                }
            })
        });

        return listItem;
    };

    BSS_B2B.amo.renderWarningHTML = function (warningType, warningId, innerText) {
        if (innerText.includes('(Title-Default Title)')) {
            innerText = innerText.replaceAll('(Title-Default Title)', '');
        }
         if (BSS_B2B.storeId === 8788 ) {
             return "<li " + warningType + " data-warning-id='" + warningId + "' style='display: block'>" + innerText + " </li>";
         } else if (BSS_B2B.storeId === 11332 ) {
            return "<li " + warningType + " data-warning-id='" + warningId + "' style='display: block'>" + innerText + "</li>";
        } else {
             return "<li class='bss-amo-text-warning' " + warningType + " data-warning-id='" + warningId + "' style='display: block'>" + innerText + " </li>";
         }
    }

    /**
     * Check when AMO Setting is "Apply to Per Variants"
     * Compare the quantity or amount of the product with the rule
     */
    BSS_B2B.amo.checkAMORuleForPerVariantOfCartPage = function (lineItemsApplyAMO) {
        if (BSS_B2B.amo.warning.length > 0) {
            BSS_B2B.amo.warning = [];
        }

        let list = BSS_B2B.amo.listItemApplyAMO(lineItemsApplyAMO);

        for (let l = 0; l < list.length; l++) {
            let rule = list[l];
            let quantityEle = BSS_B2B.amo.quantityInputSelectorOnCartPage(rule.key).join(",");
            let quantityMinimumRule = parseFloat(rule.minimum_quantity);
            let amountMinimumRule = quantityMinimumRule * 100;
            let quantityMaximumRule = parseFloat(rule.maximum_quantity);
            let amountMaximumRule = quantityMaximumRule * 100;
            let variants = BSS_B2B.amo.getTitleVariantProduct(rule)

            if (rule.type === 0) {
                // rule type is minimum amount
                let originalLinePrice = rule.original_line_price;
                let minimumPrice = BSS_B2B.formatMoney(parseFloat(rule.minimum_quantity) * 100 * rateMarket);
                let warningInnerText = rule.title + "(" + variants + ")" + ": " + minimumPrice;
                const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-amount", rule.id, warningInnerText);
                let price = rule.price;

                originalLinePrice = BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB(rule, isEnableCP, isEnableQB, price, originalLinePrice);

                if (originalLinePrice < amountMinimumRule * rateMarket) {
                    if (!BSS_B2B.amo.warning.includes(warningAmount)) {
                        BSS_B2B.amo.warning.push(warningAmount)
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningAmount)) {
                        let index = BSS_B2B.amo.warning.indexOf(warningAmount);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else if (rule.type === 1) {
                // rule type is minimum quantity
                let quantity = rule.quantity;
                let warningInnerText = rule.title + "(" + variants + ")" + ": " + parseFloat(rule.minimum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                if ([5671].indexOf(BSS_B2B.storeId) !== -1) {
                    warningInnerText = "Minimum order quantity for " + rule.title + " is " + parseFloat(rule.minimum_quantity);
                } else if ([8505].indexOf(BSS_B2B.storeId) !== -1) {
                    warningInnerText = rule.title + ": " + parseFloat(rule.minimum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                }
                const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-quantity", rule.id, warningInnerText);
                if (quantity < quantityMinimumRule) {
                    if (!BSS_B2B.amo.warning.includes(warningQuantity)) {
                        BSS_B2B.amo.warning.push(warningQuantity);
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningQuantity)) {
                        let index = BSS_B2B.amo.warning.indexOf(warningQuantity);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else if (rule.type === 2) {
                // rule type is maximum amount
                let originalLinePrice = rule.original_line_price;
                let maximumPrice = BSS_B2B.formatMoney(parseFloat(rule.maximum_quantity) * 100 * rateMarket);
                let warningInnerText = rule.title + "(" + variants + ")" + ": " + maximumPrice;
                const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-amount", rule.id, warningInnerText);
                let price = rule.price;

                originalLinePrice = BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB(rule, isEnableCP, isEnableQB, price, originalLinePrice);

                if (originalLinePrice > amountMaximumRule * rateMarket) {
                    if (!BSS_B2B.amo.warning.includes(warningAmount)) {
                        BSS_B2B.amo.warning.push(warningAmount)
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningAmount)) {
                        let index = BSS_B2B.amo.warning.indexOf(warningAmount);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else {
                // rule type is maximum quantity
                let quantity = rule.quantity;
                let warningInnerText = rule.title + "(" + variants + ")" + ": " + parseFloat(rule.maximum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-quantity", rule.id, warningInnerText);

                if (quantity > quantityMaximumRule) {
                    if (!BSS_B2B.amo.warning.includes(warningQuantity)) {
                        BSS_B2B.amo.warning.push(warningQuantity);
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningQuantity)) {
                        let index = BSS_B2B.amo.warning.indexOf(warningQuantity);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            }

            if (!isEnableCP || !isEnableQB) {
                if ($(quantityEle).length) {
                    $(quantityEle).off();
                    $(quantityEle).change(function () {
                        checkoutButton.forEach(elementButton => {
                            elementButton.style.cssText = "pointer-events: none; opacity: 0.6;";
                        });
                        setTimeout(function () {
                            BSS_B2B.cart.fixer(shopData, true);
                        }, 1000)
                    });
                }
            }
        }

        // fix for boutique-du-pilote by mitri
        if ([4337, 4209].indexOf(BSS_B2B.storeId) !== -1 && (isEnableCP || isEnableQB)) {
            // do nothing
        } else {
            BSS_B2B.handleCartCheckoutBtn(shopData)
        }

        if ((isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0))
            || (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData > 0 || BSS_B2B.plConfigData > 0))
        ) {
            // eslint-disable-next-line no-console
            console.log('Enable Both QB and CP');
        } else {
            let amoRemoveButtons = $(BSS_B2B.cart.removeButtons);
            if (amoRemoveButtons.length) {
                $(amoRemoveButtons).off();
                $(BSS_B2B.cart.removeButtons).on("click", function () {
                    BSS_B2B.cart.cartQtyOnChange(1200, 2000, true)
                })
            }

        }

        $(".cart-subtotal__price").css("display", "");
    };

    /**
     * Check when AMO Setting is "Apply to Per Products"
     * @param lineItemsApplyAMO
     */
    BSS_B2B.amo.checkAMORuleForPerProductOfCartPage = function (lineItemsApplyAMO, removeTitleProduct) {
        if (BSS_B2B.amo.warning.length > 0) {
            BSS_B2B.amo.warning = [];
        }

        let list = BSS_B2B.amo.listItemApplyAMO(lineItemsApplyAMO);

        const listApplyQbCp = [];
        list.forEach((item) => {
            const linePriceApplyQbCp = BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB(item, isEnableCP, isEnableQB, item.price, item.original_line_price);
            listApplyQbCp.push({ ...item, linePriceApplyQbCp: linePriceApplyQbCp });
        })

        const products = [];
        listApplyQbCp.forEach((item) => {
            const isExist = products.some((obj) => (obj.productId === item.product_id) && (obj.type === item.type));
            if (isExist) {
                return;
            } else {
                let productQty = Number(item.quantity);
                let productTotalPrice = Number(item.linePriceApplyQbCp);
                const otherVariant = listApplyQbCp.filter((elem) => (elem.product_id === item.product_id) && (elem.variant_id !== item.variant_id));
                if (otherVariant.length) {
                    const existKeys = [];
                    otherVariant.forEach((variant) => {
                        if (!existKeys.includes(variant.key)) {
                            existKeys.push(variant.key);
                            productQty += Number(variant.quantity);
                            productTotalPrice += Number(variant.linePriceApplyQbCp)
                        }
                    });
                }
                products.push({
                    title: item.product_title,
                    productId: item.product_id,
                    variantId: item.variant_id,
                    type: item.type,
                    productQty: productQty,
                    productTotalPrice: productTotalPrice,
                    minimumValue: item.minimum_quantity,
                    maximumValue: item.maximum_quantity,

                })
            }
        })

        products.forEach((product) => {
            const minimumQuantity = parseFloat(product.minimumValue);
            const minimumAmount = product.minimumValue * 100;
            const maximumQuantity = parseFloat(product.maximumValue);
            const maximumAmount = product.maximumValue * 100;
            if (product.type === 0) {
                const minimumAmountFormat = BSS_B2B.formatMoney(minimumAmount * rateMarket);
                let warningInnerText = product.title + ": " + minimumAmountFormat;
                if(removeTitleProduct){
                    warningInnerText =  "" + minimumAmountFormat;
                }
                const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-amount", product.productId, warningInnerText);
                if (product.productTotalPrice < minimumAmount * rateMarket) {
                    if (!BSS_B2B.amo.warning.includes(warningAmount)) {
                        BSS_B2B.amo.warning.push(warningAmount)
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningAmount)) {
                        const index = BSS_B2B.amo.warning.indexOf(warningAmount);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else if (product.type === 1) {
                let warningInnerText = product.title + ": " + minimumQuantity + " " + BSS_B2B.amoTranslations.product_text;
                if(removeTitleProduct){
                    warningInnerText =   "" + minimumQuantity + " " + BSS_B2B.amoTranslations.product_text;
                }
                const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-quantity", product.productId, warningInnerText);
                if (product.productQty < minimumQuantity) {
                    if (!BSS_B2B.amo.warning.includes(warningQuantity)) {
                        BSS_B2B.amo.warning.push(warningQuantity);
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningQuantity)) {
                        const index = BSS_B2B.amo.warning.indexOf(warningQuantity);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else if (product.type === 2) {
                const maximumAmountFormat = BSS_B2B.formatMoney(maximumAmount * rateMarket);
                let warningInnerText = product.title + ": " + maximumAmountFormat;
                if(removeTitleProduct){
                    warningInnerText =   "" + maximumAmountFormat;
                }
                const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-amount", product.productId, warningInnerText);
                if (product.productTotalPrice > maximumAmount * rateMarket) {
                    if (!BSS_B2B.amo.warning.includes(warningAmount)) {
                        BSS_B2B.amo.warning.push(warningAmount)
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningAmount)) {
                        const index = BSS_B2B.amo.warning.indexOf(warningAmount);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            } else {
                let warningInnerText = product.title + ": " + maximumQuantity + " " + BSS_B2B.amoTranslations.product_text;
                if(removeTitleProduct){
                    warningInnerText =   "" + maximumQuantity + " " + BSS_B2B.amoTranslations.product_text;
                }
                const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-quantity", product.productId, warningInnerText);
                if (product.productQty > maximumQuantity) {
                    if (!BSS_B2B.amo.warning.includes(warningQuantity)) {
                        BSS_B2B.amo.warning.push(warningQuantity);
                    }
                } else {
                    if (BSS_B2B.amo.warning.includes(warningQuantity)) {
                        const index = BSS_B2B.amo.warning.indexOf(warningQuantity);
                        BSS_B2B.amo.warning.splice(index, 1);
                    }
                }
            }
        })

        if ((isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0))
            || (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData > 0 || BSS_B2B.plConfigData > 0))
        ) {
            // eslint-disable-next-line no-console
            console.log('Enable Both QB and CP');
        } else {
            let amoRemoveButtons = $(BSS_B2B.cart.removeButtons);
            if (amoRemoveButtons.length) {
                $(amoRemoveButtons).off();
                $(BSS_B2B.cart.removeButtons).on("click", function () {
                    BSS_B2B.cart.cartQtyOnChange(1200, 2000, true)
                })
            }

        }

        $(".cart-subtotal__price").css("display", "");
    }

    /**
     * Check when AMO Setting is "Apply to All Products"
     * @param lineItemsApplyAMO
     */
    BSS_B2B.amo.checkAMORuleForAllProductsOfCartPage = function (lineItemsApplyAMO, removeTitleProduct) {
        if (BSS_B2B.amo.warning.length > 0) {
            BSS_B2B.amo.warning = [];
        }
        let listRulesAMO = BSS_B2B.amoRules;
        let list = BSS_B2B.amo.listItemApplyAMO(lineItemsApplyAMO);

        for (let i = 0; i < listRulesAMO.length; i++) {
            let rule = listRulesAMO[i];
            rule.minimumAmountItemApplyRule = 0;
            rule.minimumQuantityItemApplyRule = 0;
            rule.maximumAmountItemApplyRule = 0;
            rule.maximumQuantityItemApplyRule = 0;
            rule.titleProductApplyRule = [];
            for (let j = 0; j < list.length; j++) {
                let item = list[j];
                let quantityEle = BSS_B2B.amo.quantityInputSelectorOnCartPage(item.key).join(",");
                if (rule.id === item.ruleId) {
                    let variants = BSS_B2B.amo.getTitleVariantProduct(item);
                    if (BSS_B2B.storeId === 7567) {
                        rule.titleProductApplyRule.push(item.product_title);
                    } else {
                        rule.titleProductApplyRule.push(item.product_title + "(" + variants + ")");
                    }
                    if (item.type === 0) {
                        let originalLinePrice = item.original_line_price;
                        let price = item.price;
                        originalLinePrice = BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB(item, isEnableCP, isEnableQB, price, originalLinePrice);
                        rule.minimumAmountItemApplyRule += originalLinePrice;
                    } else if (item.type === 1) {
                        rule.minimumQuantityItemApplyRule += item.quantity;
                    } else if (item.type === 2) {
                        let originalLinePrice = item.original_line_price;
                        let price = item.price;
                        originalLinePrice = BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB(item, isEnableCP, isEnableQB, price, originalLinePrice);
                        rule.maximumAmountItemApplyRule += originalLinePrice;
                    } else {
                        rule.maximumQuantityItemApplyRule += item.quantity;
                    }

                    // custom show OL collection title for shop.gsdmarket.com
                    if([8741].includes(BSS_B2B.storeId) && rule.product_condition_type === 2){
                        // find collection title in bss_b2b_shop_collections
                        // eslint-disable-next-line no-undef
                        if(typeof bss_b2b_shop_collections !== 'undefined' && bss_b2b_shop_collections) {
                            try {
                                // eslint-disable-next-line no-undef
                                const collectionTitle = bss_b2b_shop_collections[rule.product_collections] || '';
                                rule.titleProductApplyRule = [collectionTitle];
                            } catch(e) {
                                // eslint-disable-next-line no-console
                                console.error(e);
                            }
                        }
                    }
                }

                if (!isEnableCP || !isEnableQB) {
                    if ($(quantityEle).length) {
                        $(quantityEle).off();
                        $(quantityEle).change(function () {
                            setTimeout(function () {
                                BSS_B2B.cart.fixer(shopData, true);
                            }, 1000)
                        });
                    }
                }
            }

            if (rule.type === 0) {
                // rule type is minimum amount
                let ruleMinimumAmount = parseFloat(rule.minimum_quantity * rateMarket * 100);

                if ((rule.minimumAmountItemApplyRule < ruleMinimumAmount) && (rule.titleProductApplyRule.length > 0)) {
                    let minimumPrice = BSS_B2B.formatMoney(ruleMinimumAmount * rateMarket);
                    if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                        rule.titleProductApplyRule = []
                    }
                    let warningInnerText = rule.titleProductApplyRule.join(', ') + ": " + minimumPrice;
                    if (BSS_B2B.storeId === 2409) {
                        warningInnerText = "Your account has a minimum order amount of " + minimumPrice;
                    } else if ([6306, 8788].indexOf(BSS_B2B.storeId) !== -1 || removeTitleProduct) {
                        warningInnerText = minimumPrice;
                    }
                    const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-amount", rule.id, warningInnerText);
                    BSS_B2B.amo.warning.push(warningAmount);
                }
            } else if (rule.type === 1) {
                // rule type is minimum quantity
                if ((rule.minimumQuantityItemApplyRule < parseFloat(rule.minimum_quantity)) && (rule.titleProductApplyRule.length > 0)) {
                    if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                        rule.titleProductApplyRule = []
                    }
                    if (BSS_B2B.storeId == 7788) {
                        rule.titleProductApplyRule = [`Minimum Order Quantity – A Combined Total of`];
                    }
                    let warningInnerText = rule.titleProductApplyRule.join(', ') + ": " + parseFloat(rule.minimum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                    if (BSS_B2B.storeId === 5671) {
                        warningInnerText = "Minimum order quantity for all products is: " + parseFloat(rule.minimum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                    }
                    if (removeTitleProduct) {
                        warningInnerText = parseFloat(rule.minimum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                    }

                    const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-minimum-quantity", rule.id, warningInnerText);
                    BSS_B2B.amo.warning.push(warningQuantity);
                }
            } else if (rule.type === 2) {
                // rule type is maximum amount
                let ruleMaximumAmount = parseFloat(rule.maximum_quantity * rateMarket * 100);

                if ((rule.maximumAmountItemApplyRule > ruleMaximumAmount) && (rule.titleProductApplyRule.length > 0)) {
                    let maximumPrice = BSS_B2B.formatMoney(ruleMaximumAmount * rateMarket);
                    if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                        rule.titleProductApplyRule = []
                    }
                    let warningInnerText = rule.titleProductApplyRule.join(', ') + ": " + maximumPrice;
                    if (BSS_B2B.storeId === 2409) {
                        warningInnerText = "Your account has a minimum order amount of " + maximumPrice;
                    }
                    if ([6306, 8788].indexOf(BSS_B2B.storeId) !== -1 || removeTitleProduct) {
                        warningInnerText = maximumPrice;
                    }
                    const warningAmount = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-amount", rule.id, warningInnerText);
                    BSS_B2B.amo.warning.push(warningAmount);
                }
            } else {
                // rule type is maximum quantity
                if ((rule.maximumQuantityItemApplyRule > parseFloat(rule.maximum_quantity)) && (rule.titleProductApplyRule.length > 0)) {
                    if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                        rule.titleProductApplyRule = []
                    }
                    let warningInnerText = rule.titleProductApplyRule.join(', ') + ": " + parseFloat(rule.maximum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                    if (removeTitleProduct) {
                        warningInnerText = parseFloat(rule.maximum_quantity) + " " + BSS_B2B.amoTranslations.product_text;
                    }
                    const warningQuantity = BSS_B2B.amo.renderWarningHTML("data-warning-maximum-quantity", rule.id, warningInnerText);
                    BSS_B2B.amo.warning.push(warningQuantity);
                }
            }
            if ([6407, 6011, 6708].includes(BSS_B2B.storeId)) {
                BSS_B2B.amo.warning.pop()
                let arrayWarning = window.BSS_B2B.executeAction({tag: 'ol_customize_cart_page', storeId: false, rule})
                arrayWarning.forEach(message => message !== "" ? BSS_B2B.amo.warning.push(message) : "")
            }
        }

        // fix for boutique-du-pilote by mitri
        if ([4337, 4209, 3588].indexOf(BSS_B2B.storeId) !== -1 && (isEnableCP || isEnableQB)) {
            // do nothing
        } else {
            BSS_B2B.handleCartCheckoutBtn(shopData)
        }

        if ((isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0))
            || (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData > 0 || BSS_B2B.plConfigData > 0))
        ) {
            // eslint-disable-next-line no-console
            console.log('Enable both QB and CP');
        } else {
            let amoRemoveButtons = $(BSS_B2B.cart.removeButtons);
            if (amoRemoveButtons.length) {
                $(amoRemoveButtons).off();
                $(BSS_B2B.cart.removeButtons).on("click", function () {
                    BSS_B2B.cart.cartQtyOnChange(1200, 2000, true)
                })
            }

        }

        $(".cart-subtotal__price").css("display", "");
    };

    /**
     * Each amo rule - each product of cart page
     */
    BSS_B2B.amo.getAppliedRulesForCartItems = function (productMap, isCartItem, cartData) {
        let ruleList = BSS_B2B.amoRules;
        let customer = shopData.customer;
        let ruleLists = [];

        ruleList.forEach(function (rule) {
            let customerTagsInRule = rule.customer_tags;
            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let excludeCustomerTags = rule.exc_customer_tags;
            let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let exc_customers = rule.exc_customers;
            if (applyTo == 0) {
                //
            }
            if (applyTo === 1) {
                if (customer.id !== null) {
                    return;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return;
                    }
                }
            } else if (applyTo === 2) {
                if (customerTagsInRule === "" || customerTagsInRule == null) {
                    return;
                } else {
                    if (customer.tags == null) {
                        return;
                    } else {
                        customerTagsInRule = customerTagsInRule.toLowerCase().split(",");
                        let lowerCaseCustomerTags = customer.tags.map(tag => tag.toLowerCase());
                        let checkArray = customerTagsInRule.filter(tag => lowerCaseCustomerTags.includes(tag + ""));
                        if (checkArray.length === 0) {
                            return
                        }
                    }
                }
            }

            if (excludeFrom === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.toLowerCase().split(",");
                    let customerTags = customer.tags.map((tag) => tag.toLowerCase());
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        return
                    }
                }
            }
            else if (excludeFrom === 2) {
                if (exc_customers) {
                    if (exc_customers.includes(`${customer.id}`)) {
                        return
                    }
                }
            }

            // set product of rule
            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(",").map((tag) => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            let specificVariantIds = rule.product_variants ? rule.product_variants.split(",") : [];

            for (let i = 0; i < productMap.length; i++) {
                let productId = productMap[i].id;
                let collections = productMap[i].collections;
                let tags = productMap[i].tags.map((tag) => tag.toLowerCase());

                if (conditionType === 0) {
                    // all product
                    ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, productId, false, false, isCartItem, productMap[i], ruleLists, false);
                } else if (conditionType === 1) {
                    if (specificProductIds.indexOf(productId + "") !== -1) {
                        ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, productId, false, false, isCartItem, productMap[i], ruleLists, false);
                    }
                } else if (conditionType === 2) {
                    let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                    if (checkArray.length > 0) {
                        ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, productId, false, false, isCartItem, productMap[i], ruleLists, false);
                    }
                } else if (conditionType === 3) {
                    let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, productId, false, false, isCartItem, productMap[i], ruleLists, false);
                    }
                } else if (conditionType === 4) {
                    cartData.items.forEach((e) => {
                        if (e.product_id == productId) {
                            let variantIdCart = e.variant_id
                            if (specificVariantIds.indexOf(variantIdCart + "") !== -1) {
                                ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, productId, false, variantIdCart, isCartItem, productMap[i], ruleLists, false);
                            }
                        }
                    })
                }
            }
        });

        return ruleLists;
    };

    BSS_B2B.amo.pushItemAppliedAmo = function (rule, productId, variantTitle, variantIdCart, isCartItem, productMap, ruleLists, variant) {
        const obj = {
            "ruleId": rule.id,
            "productId": productId,
            "variantID": variantIdCart,
            "type": rule.type,
            "minimum_quantity": rule.minimum_quantity,
            "maximum_quantity": rule.maximum_quantity,
            "priority": rule.priority,
            "key": isCartItem ? productMap.key : false,
        }
        if (variantTitle) {
            obj.title = variantTitle
        }
        if (variant && (variant.price || variant.price === 0)) {
            obj.price = variant.price;
        }
        return [...ruleLists, obj]
    };

    BSS_B2B.amo.getTitleVariantProduct = function (item) {
        let variants = ""
        item.options_with_values.forEach((e, index) => {
            if (index) {
                variants = variants + ", " + e.name + "-" + e.value
            } else {
                variants = variants + e.name + "-" + e.value
            }
        })
        return variants
    }

    /**
     * Get applied rules for given product
     * @param product
     */
    BSS_B2B.amo.getAppliedRulesForEachProduct = function (product, variantId) {
        let ruleList = BSS_B2B.amoRules ? BSS_B2B.amoRules : [];
        let customer = shopData.customer;
        let variant = null;
        let ruleLists = [];
        const amoTypeSetting = BSS_B2B.amoSettings ? BSS_B2B.amoSettings.amoType : null;
        product.variants.every((item) => {
            if (item.id == variantId) {
                variant = item;
                return false;
            }
            return true;
        });
        let variantTitle = variant.title === "Default Title" ? product.title : `${product.title} (${variant.title})`;
        if (amoTypeSetting === 2) {
            variantTitle = product.title;
        }
        ruleList.forEach(function (rule) {
            let customerTags = rule.customer_tags;
            let excludeCustomerTags = rule.exc_customer_tags;
            let applyTo = rule.apply_to;
            let exclude_from = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let exc_customers = rule.exc_customers;
            let customerIds = rule.customer_ids;

            if (exclude_from === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.toLowerCase().split(",");
                    let customerTags = customer.tags.map((tag) => tag.toLowerCase())
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        return
                    }
                }
            }
            else if (exclude_from === 2) {
                if (exc_customers) {
                    if (exc_customers.includes(`${customer.id}`)) {
                        return
                    }
                }
            }
            if (applyTo == 0) {
                //
            }
            if (applyTo === 1) {
                if (customer.id !== null) {
                    return;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return;
                    }
                }
            } else if (applyTo === 2) {
                if (customerTags === "" || customerTags == null) {
                    if (customer.tags == null) {
                        return;
                    }
                } else {
                    if (customer.tags == null) {
                        return;
                    } else {
                        customerTags = customerTags.toLowerCase().split(",");
                        let lowerCaseCustomerTags = customer.tags.map((tag) => tag.toLowerCase());
                        let checkArray = customerTags.filter(tag => lowerCaseCustomerTags.includes(tag + ""));
                        if (checkArray.length === 0) {
                            return
                        }
                    }
                }
            }

            // set product of rule
            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.toLowerCase().split(",") : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            let specificVariantIds = rule.product_variants ? rule.product_variants.split(",") : [];


            let collections = product.collections;
            let tags = product.tags.map(tag => tag.toLowerCase());
            if (conditionType === 0) {
                // all product
                ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, product.id, variantTitle, false, false, false, ruleLists, variant);
            } else if (conditionType === 1) {
                //specific product
                if (specificProductIds.indexOf(product.id + "") !== -1) {
                    ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, product.id, variantTitle, false, false, false, ruleLists, variant);
                }
            } else if (conditionType === 2) {
                // product collections
                let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                if (checkArray.length > 0) {
                    ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, product.id, variantTitle, false, false, false, ruleLists, variant);
                }
            } else if (conditionType === 3) {
                // product tag
                let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                if (checkArray.length > 0) {
                    ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, product.id, variantTitle, false, false, false, ruleLists, variant);
                }
            } else if (conditionType === 4) {
                if (specificVariantIds.indexOf(variantId + "") !== -1) {
                    ruleLists = BSS_B2B.amo.pushItemAppliedAmo(rule, product.id, variantTitle, false, false, false, ruleLists, variant);
                }
            }
        });

        return ruleLists;
    };

    /**
     * Check
     * @param appliedAmoRules
     * @param quantity
     */
    BSS_B2B.amo.checkAmoRulesForEachProduct = function (appliedAmoRules, appliedQbRule, quantity) {
        if (BSS_B2B.amo.warning.length > 0) {
            BSS_B2B.amo.warning = [];
        }
        let removed = Array(appliedAmoRules.length).fill(0);

        for (let i = 0; i < appliedAmoRules.length; i++) {
            for (let j = 0; j < appliedAmoRules.length; j++) {
                if (i !== j && removed[i] === 0 && removed[j] === 0) {
                    let ruleI = appliedAmoRules[i];
                    let ruleJ = appliedAmoRules[j];
                    // If 2 different rules have the same type, product id
                    if (ruleI.type === ruleJ.type && ruleI.productId === ruleJ.productId && ruleI.ruleId !== ruleJ.ruleId) {
                        let rule_type = ruleI.type;
                        if (
                            ruleI.priority > ruleJ.priority
                            || (ruleI.priority === ruleJ.priority && (
                                // Minimum amount/quantity
                                ((rule_type === 0 || rule_type === 1) && Number(ruleI.minimum_quantity) < Number(ruleJ.minimum_quantity))
                                // Maximum amount/quantity
                                || ((rule_type === 2 || rule_type === 3) && Number(ruleI.maximum_quantity) > Number(ruleJ.maximum_quantity))
                            ))
                        ) {
                            removed[i] = 1;
                        }
                    }
                }
            }
        }

        // "All products" and "Per products" settings have the same logic with only 1 product
        for (let i = 0; i < appliedAmoRules.length; i++) {
            if (removed[i] === 1) continue;
            let rule = appliedAmoRules[i];
            let ruleMinQuantity = parseFloat(rule.minimum_quantity);
            let ruleMinAmount = ruleMinQuantity * 100 * rateMarket;
            let ruleMaxQuantity = parseFloat(rule.maximum_quantity);
            let ruleMaxAmount = ruleMaxQuantity * 100 * rateMarket;
            let price, totalPrice, warningMessage, isViolated = false;
            if (rule.type === 0) {
                // rule type is minimum amount
                price = BSS_B2B.amo.calculatePriceWhenUseCPQB(rule, appliedQbRule, quantity);
                totalPrice = price * quantity;
                if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                    rule.title = []
                }
                let warningInnerText = rule.title + ": " + BSS_B2B.formatMoney(ruleMinAmount);
                warningMessage = BSS_B2B.amo.renderWarningHTML('data-warning-minimum-amount', rule.productId, warningInnerText);
                isViolated = totalPrice < ruleMinAmount;
            } else if (rule.type === 1) {
                // rule type is minimum quantity
                if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                    rule.title = []
                }
                let warningInnerText = rule.title + ": " + ruleMinQuantity + " " + BSS_B2B.amoTranslations.product_text;
                warningMessage = BSS_B2B.amo.renderWarningHTML('data-warning-minimum-quantity', rule.productId, warningInnerText);
                isViolated = quantity < ruleMinQuantity;
            } else if (rule.type === 2) {
                // rule type is maximum amount
                if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                    rule.title = []
                }
                price = BSS_B2B.amo.calculatePriceWhenUseCPQB(rule, appliedQbRule, quantity);
                totalPrice = price * quantity;
                let warningInnerText = rule.title + ": " + BSS_B2B.formatMoney(ruleMaxAmount)
                warningMessage = BSS_B2B.amo.renderWarningHTML('data-warning-maximum-amount', rule.productId, warningInnerText);
                isViolated = totalPrice > ruleMaxAmount;
            } else if (rule.type === 3) {
                // rule type is maximum quantity
                if ([7111, 8788].indexOf(BSS_B2B.storeId) !== -1) {
                    rule.title = []
                }
                let warningInnerText = rule.title + ": " + ruleMaxQuantity + " " + BSS_B2B.amoTranslations.product_text;
                warningMessage = BSS_B2B.amo.renderWarningHTML('data-warning-maximum-quantity', rule.productId, warningInnerText);
                isViolated = quantity > ruleMaxQuantity;
            }

            // fix for storeID 6011, 6407, 6708
            if ([6407, 6011, 6708].includes(BSS_B2B.storeId)) {
                warningMessage = window.BSS_B2B.executeAction({
                    tag: `ol_customize_product_page`,
                    storeId: false, rule, warningMessage, ruleMinAmount,
                    ruleMaxAmount, ruleMinQuantity, ruleMaxQuantity
                });
            }


            let index = BSS_B2B.amo.warning.indexOf(warningMessage);
            if (isViolated) {
                if (index === -1) BSS_B2B.amo.warning.push(warningMessage);
            } else {
                if (index !== -1) BSS_B2B.amo.warning.splice(index, 1);
            }
        }

        // free up
        removed = null;
    };

    // fix for 2W theme Button Checkout after click Add to cart on quick view
    if ($('button.product-item__action-button[data-secondary-action="open-quick-view"]').length > 0) {
        $('button.product-item__action-button[data-secondary-action="open-quick-view"]').on("click", function () {
            setTimeout(function () {
                $('button[data-action="add-to-cart"]').on("click", function () {
                    setTimeout(function () {
                        BSS_B2B.cart.fixer(shopData, true, true);
                    }, 1000)
                })
            }, 1000)
        })
    }

    BSS_B2B.amo.calculatePriceWhenUseCPQB = function (rule, appliedQbRule, quantity) {
        let isCPApplied = isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0);
        let price = rule.price;
        if (isCPApplied && BSS_B2B.cp.productAfterUseCP) {
            BSS_B2B.cp.productAfterUseCP.every((itemCP) => {
                if (itemCP.id == rule.productId) {
                    price = itemCP.price;
                    return false;
                }
                return true;
            })
        }
        if (appliedQbRule) {
            price = appliedQbRule.price;
            appliedQbRule.qty_table.every((item) => {
                let from = item.qty_from;
                let to = item.qty_to;
                if (from && quantity < from) return true;
                if (to && quantity > to) return true;
                let discount_type = item.discount_type;
                let discount_value = item.discount_value * rateMarket;
                if (discount_type === 0) {
                    price = discount_value * 100 > price ? price : discount_value * 100;
                } else if (discount_type === 1) {
                    price = discount_value * 100 > price ? 0 : (price - discount_value * 100);
                } else if (discount_type === 2) {
                    price = price * (1.0 - item.discount_value / 100);
                }
                return false;
            });
        }

        return price;
    };

    BSS_B2B.amo.calculateOriginalLinePriceWhenUseCPQB = function (rule, isEnableCP, isEnableQB, price, originalLinePrice) {
        if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0)) {
            let itemCP = BSS_B2B.cart.cpPricingList.get(rule.key);
            if (itemCP) {
                let taxRate = 1;
                // fix for storeID 1548
                if(BSS_B2B.storeId === 1548) {
                    taxRate = window.BSS_B2B.executeAction({tag: 'get_tax_rate', storeId: 1548});
                }
                price = itemCP.modifiedItemPrice * taxRate;
                originalLinePrice = itemCP.modifiedLineItemPriceWithMarket * taxRate;
            }          
        }

        if (isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0)) {
            let itemQB = BSS_B2B.cart.qbPricingList.get(rule.key);

            if (itemQB) {
                originalLinePrice = price * itemQB.quantity;
                let discountValue = itemQB.discount_value * rateMarket * 100;
                let quantity = itemQB.quantity;
    
                if (itemQB.discount_type === 0) {
                    if (price > discountValue) {
                        originalLinePrice = discountValue * itemQB.quantity;
                    }
                } else if (itemQB.discount_type === 1) {
                    if (price < discountValue) {
                        originalLinePrice = 0;
                    } else {
                        originalLinePrice = (price - discountValue) * quantity;
                    }
                } else {
                    originalLinePrice = BSS_B2B.getModifiedPrice(originalLinePrice, 2, itemQB.discount_value);
                }
            }
        }
        
        return originalLinePrice;
    }

    BSS_B2B.amo.showNotifyMessage = function (variantId) {
        if (!shopData || !shopData.product) return;
        variantId = variantId || shopData.product.variants[0].id;
        let item = shopData.product;
        if (shopData.collections) {
            item.collections = shopData.collections;
        }
        let appliedAmoRules = BSS_B2B.amo.getAppliedRulesForEachProduct(item, variantId);
        if (!appliedAmoRules) {
            const olMsgElement = document.querySelector('#olNotifyMessageBSS');
            if (olMsgElement) {
                olMsgElement.remove();
            }
            return;
        }

        let minAmountRule, minQuantityRule, maxAmountRule, maxQuantityRule = null;
        appliedAmoRules.forEach((rule) => {
            switch (rule.type) {
                case 0:
                    if (!minAmountRule || minAmountRule.priority > rule.priority
                        || (minAmountRule.priority === rule.priority && Number(minAmountRule.minimum_quantity) < Number(rule.minimum_quantity))) {
                        minAmountRule = rule;
                    }
                    break;
                case 1:
                    if (!minQuantityRule || minQuantityRule.priority > rule.priority
                        || (minQuantityRule.priority === rule.priority && Number(minQuantityRule.minimum_quantity) < Number(rule.minimum_quantity))) {
                        minQuantityRule = rule;
                    }
                    break;
                case 2:
                    if (!maxAmountRule || maxAmountRule.priority > rule.priority
                        || (maxAmountRule.priority === rule.priority && Number(maxAmountRule.maximum_quantity) > Number(rule.maximum_quantity))) {
                        maxAmountRule = rule;
                    }
                    break;
                case 3:
                    if (!maxQuantityRule || maxQuantityRule.priority > rule.priority
                        || (maxQuantityRule.priority === rule.priority && Number(maxQuantityRule.maximum_quantity) > Number(rule.maximum_quantity))) {
                        maxQuantityRule = rule;
                    }
                    break;
                default:
                    break;
            }
        });

        const subTextQuantity = BSS_B2B.amoTranslations.product_text;
        const shopCurrency = shopData.shop.currency;
        let minAmountMessage = minAmountRule
            ? `\n<div id="minAmountBSS">${BSS_B2B.amoTranslations.min_amount_product} \
        <span>${formatMoneyWithDomain(shopData.shop.domain, minAmountRule.minimum_quantity)}</span> <span>${shopCurrency}</span></div>`
            : '';
        let minQuantityMessage = minQuantityRule
            ? `\n<div id="minQuantityBSS">${BSS_B2B.amoTranslations.min_quantity_product} \
        <span>${parseInt(minQuantityRule.minimum_quantity)}</span> <span>${subTextQuantity}</span></div>`
            : '';
        let maxAmountMessage = maxAmountRule
            ? `\n<div id="maxAmountBSS">${BSS_B2B.amoTranslations.max_amount_product} \
        <span>${formatMoneyWithDomain(shopData.shop.domain, maxAmountRule.maximum_quantity)}</span> <span>${shopCurrency}</span></div>`
            : '';
        let maxQuantityMessage = maxQuantityRule
            ? `\n<div id="maxQuantityBSS">${BSS_B2B.amoTranslations.max_quantity_product} \
        <span>${parseInt(maxQuantityRule.maximum_quantity)}</span> <span>${subTextQuantity}</span></div>`
            : '';
        let notifyMessage = '<div id="olNotifyMessageBSS">' + minAmountMessage + maxAmountMessage + minQuantityMessage
            + maxQuantityMessage + '\n</div>';

        if (BSS_B2B.amoSettings.popup_position === 0) {
            let quantityElement = getQuantityElement();

            if(BSS_B2B.storeId === 9483){
                quantityElement = document.querySelector(".product-quantity-action");
            }

            if(BSS_B2B.storeId === 9738){
                quantityElement = document.querySelector(".quantity-selector--product");
            }

            let timeDelay = 0
            if (BSS_B2B.storeId === 12503) {
                quantityElement = document.querySelector("product-quantity-root");
                timeDelay = 3000
            }

            if (BSS_B2B.storeId === 9570) {
                quantityElement = document.querySelector('.product-add-to-cart-container')
                timeDelay = 2000
            }
            
            if (BSS_B2B.storeId === 15292) {
                quantityElement = document.querySelector(".product__atc.margin__bottom--reduced");
                timeDelay = 2000
            }

            if (quantityElement) {
                setTimeout(() => {
                    if ([7234, 9570].includes(BSS_B2B.storeId)) {
                        quantityElement.insertAdjacentHTML("afterend", notifyMessage)
                    } else {
                        quantityElement.outerHTML += notifyMessage;
                    }
                }, timeDelay);
            }
        } else if (BSS_B2B.amoSettings.popup_position === 1) {
            let isTimeout = false;
            let paymentInterval = setInterval(() => {
                let paymentBtn = getBuyNowButton();
                if (paymentBtn) {
                    $('#olNotifyMessageBSS').remove();
                    paymentBtn.insertAdjacentHTML('afterend', notifyMessage);
                    clearInterval(paymentInterval);
                    isTimeout = true;
                }
            }, 500);
            setTimeout(() => {
                if (!isTimeout) clearInterval(paymentInterval);
            }, 5000);
        }
    },

    BSS_B2B.amo.hideShowProductMessage = function(elementWarningTitle, elementListWarning, productMessage){
        let messageTitleElement = document.querySelector(`.${elementWarningTitle}`);
        if((BSS_B2B.amoSettings.show_products === 0 && BSS_B2B.amoSettings.amoType === 1) || (BSS_B2B.storeId === 15112 && elementWarningTitle === "bss-warning-minimum-amount-title")){
            let titleMessage = messageTitleElement.innerText;
            let textWarningSplit = productMessage.split(":");
            let quantityOrAmount = textWarningSplit[textWarningSplit.length - 1];
            messageTitleElement.innerHTML = titleMessage.indexOf(":") ? titleMessage.replace(":", quantityOrAmount) : titleMessage + quantityOrAmount;
            messageTitleElement.style.display = "block";
        } else {
            messageTitleElement.style.display = "block";
            if (BSS_B2B.storeId !== 437) {
                $(`.${elementListWarning}`).prepend(productMessage);
            }
        }
    } 
}
// EXTERNAL MODULE: ./js/src/qb/qb.js
var qb = __webpack_require__(7);

// EXTERNAL MODULE: ./js/src/helper/helper.js
var helper = __webpack_require__(10);

// CONCATENATED MODULE: ./js/src/cp/change-product-price.js



function changeProductPrice(
    $, BSS_B2B, shopData, firstLoadProduct, isEnableMC, isEnableAMO, isEnableQB) {
    BSS_B2B.cp = {};
    BSS_B2B.cp.productAfterUseCP = [];
    BSS_B2B.cp.productMapAfterUseCP = new Map();

    BSS_B2B.cp.changeProductPrice = function (shopData, customAttr, cartFormElement, isQuickView, variantId) {
        let elements = $('[bss-b2b-product-id][bss-b2b-product-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-current-variant-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-sale-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-featured-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-lowest-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-from-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-now-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-min-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-max-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-variant-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-product-price]:not([bss-b2b-product-active]),'
            + '[bss-b2b-product-id][bss-b2b-variant-unit-price]:not([bss-b2b-product-active]),'
            + '[data-atc-banner-product-price],'
            + '.t4s-product-price[bss-b2b-product-id][bss-b2b-product-price],'
            + '[bss-b2b-product-id][bss-b2b-button-price],'
            + '.product-details_price-inner [bss-b2b-variant-price]'
            + BSS_B2B.getCssSelector('product_sale_price')
            + BSS_B2B.getCssSelector('product_regular_price')
            + BSS_B2B.getCssSelector('product_featured_price')
            + BSS_B2B.getCssSelector('product_compare_price')
            + BSS_B2B.getCssSelector('product_from_price')
            + BSS_B2B.getCssSelector('product_now_price')
            + BSS_B2B.getCssSelector('product_min_price')
            + BSS_B2B.getCssSelector('product_variant_price')
            + BSS_B2B.getCssSelector('product_lowest_price')
            + BSS_B2B.getCssSelector('product_current_variant_price')
            + BSS_B2B.getCssSelector('product_unit_price'),
        );
        if (customAttr) {
            if ((BSS_B2B.storeId === 2693 || BSS_B2B.storeId === 4342) && BSS_B2B.page.isProductPage()) {
                elements = $(customAttr + '[bss-b2b-product-id]');
            }
            else if ([2896].indexOf(BSS_B2B.storeId) !== -1) {
                elements = $(customAttr + ' [bss-b2b-product-id]:not([bss-b2b-product-active])');
            }
            else if ([5273].indexOf(BSS_B2B.storeId) !== -1) {
                elements = $(customAttr + ' [bss-b2b-product-id]');
            }
            else if ([6888, 7321, 8337, 2589, 621].includes(BSS_B2B.storeId)) {
                elements = $(customAttr);
            }
            else if ([11574].includes(BSS_B2B.storeId)) {
                // do nothing
            }
            else if ([12553].includes(BSS_B2B.storeId)) {
                elements = $(
                    document.querySelector(customAttr).shadowRoot.querySelectorAll('[bss-b2b-product-id]'));
            }
            else if ([9207].includes(BSS_B2B.storeId)) {
                elements = $(`${customAttr} [bss-b2b-product-id]`);
            }
            else {
                elements = $(customAttr + '[bss-b2b-product-id]');
            }
        }
        if (BSS_B2B.storeId === 1222) {
            if (elements && elements.closest('.ajax-cart__price')) return;
        }
        else if (BSS_B2B.storeId === 12158) {
            if (elements && elements.length === 1 && elements.closest('.total-price') && !customAttr) return;
        }
        if (elements.length > 0 || firstLoadProduct) {
            firstLoadProduct = false;
        }
        else {
            if (BSS_B2B.storeId === 11946) {
                firstLoadProduct = true;
            }
            else {
                return;
            }

        }
        elements.attr('bss-b2b-product-active', true);
        let priceElementFeaturedProducts = elements.filter(function () {
            return $(this).closest(BSS_B2B.helper.productFormElement).length > 0;
        });
        if (BSS_B2B.storeId === 15743 && !BSS_B2B.page.isProductPage()) {
            priceElementFeaturedProducts = []
        }
        if (priceElementFeaturedProducts.length > 0 && priceElementFeaturedProducts.attr('bss-b2b-featured-product') === undefined) {
            priceElementFeaturedProducts.attr('bss-b2b-featured-product', '');
        }
        if (BSS_B2B.storeId === 6579 && (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage())) {
            priceElementFeaturedProducts.removeAttr('bss-b2b-featured-product');
        }

        let handleURLs = [];
        let handles = [];
        let productIds = [];
        for (let i = 0; i < elements.length; i++) {
            let isLoginPattern = $(elements[i]).find('.bsscommerce-ltsp-message').length;
            if (isLoginPattern) {
                if ([2984, 4999, 9737].includes(BSS_B2B.storeId) && !__st.cid) {
                    // do nothing
                }
                else {
                    continue;
                }
            }
            let elementProductId = $(elements[i]).attr('bss-b2b-product-id');
            if (!customAttr) {
                if ($(elements[i]).attr('itemprop') === 'price') {
                    // do nothing
                }
                else {
                    $(elements[i]).parent().attr('bss-b2b-product-id', elementProductId);

                    if ([6638].includes(BSS_B2B.storeId)) {
                        $(elements[i]).attr('bss-b2b-product-parent-price', 'true');
                    }
                    else {
                        $(elements[i]).parent().attr('bss-b2b-product-parent-price', 'true');
                    }

                    if ($(elements[i]).attr('bss-b2b-product-max-price') !== undefined) {
                        $(elements[i]).parent().parent().attr('bss-b2b-product-max-price', 'true');
                    }
                    if ($(elements[i]).attr('bss-b2b-product-min-price') !== undefined) {
                        $(elements[i]).parent().parent().attr('bss-b2b-product-min-price', 'true');
                    }
                }
                //    fix for benki-brewingtools show max min price when change
                // variant options
            }
            else {
                if ($(elements[i]).attr('bss-b2b-product-max-price') !== undefined) {
                    $(elements[i]).parent().parent().attr('bss-b2b-product-max-price', 'true');
                }
                if ($(elements[i]).attr('bss-b2b-product-min-price') !== undefined) {
                    $(elements[i]).parent().parent().attr('bss-b2b-product-min-price', 'true');
                }
            }
            if (elementProductId && elementProductId !== '' && handles.indexOf(elementProductId) === -1) {
                handles.push(elementProductId);
                handleURLs.push('id:"' + elementProductId + '"');
                productIds.push(+elementProductId);
            }

        }
        let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
        let encodeUrlData = encodeURI(urlData);

        let productsHasMetaField = [];
        productsHasMetaField = BSS_B2B.getProductMetaField();
        if (BSS_B2B.storeId === 7332) {
            document.querySelectorAll("#bss-custom-metafield-script").forEach(item => {
                if (item.innerText) productsHasMetaField.push(JSON.parse(item.innerText))
            })
        }

        // fix korresshop-greece by vitu
        if (BSS_B2B.storeId === 1676 || BSS_B2B.storeId === 5882) {
            let splitIndex = Math.round(handleURLs.length / 2);
            let max = handleURLs.length;
            let firstHalf = encodeURI(
                '/search?q=' + handleURLs.splice(splitIndex, max - splitIndex + 1).join(' OR ') + '&view=bss.b2b');
            let secondHalf = encodeURI(
                '/search?q=' + handleURLs.splice(0, max - splitIndex + 1).join(' OR ') + '&view=bss.b2b');

            BSS_B2B.cp.changePrice(firstHalf, shopData, customAttr, cartFormElement, isQuickView, null, variantId);
            BSS_B2B.cp.changePrice(secondHalf, shopData, customAttr, cartFormElement, isQuickView, null, variantId);
        }
        else {
            BSS_B2B.cp.changePrice(encodeUrlData, shopData, customAttr, cartFormElement, isQuickView,
                productsHasMetaField, variantId);
        }
        window.BSS_B2B.executeAction({ tag: 'custom_style_price', storeId: 13753, BSS_B2B })
    };

    BSS_B2B.cp.changePrice = function (
        encodeUrlData, shopData, customAttr, cartFormElement, isQuickView, productsHasMetaField, variantId) {
        let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(BSS_B2B, shopData);
        $.get(encodeUrlData, function (data) {
            let responseProducts = [];
            let productIdResponse = [];
            try {
                responseProducts = JSON.parse(data);
                responseProducts.map(item => productIdResponse.push(item.id));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log('B2B could not parse data: JSON parse returns no item');
            }
            if (!responseProducts.length) {
                tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
            }

            if (BSS_B2B.page.isProductPage() && shopData.product.id && !isQuickView &&
                !productIdResponse.includes(shopData.product.id)) {
                if (!shopData.product.collections) {
                    const _product = {
                        ...shopData.product, collections: shopData.collections,
                    };
                    responseProducts.push(_product);
                }
                else {
                    responseProducts.push(shopData.product);
                }
                productIdResponse.push(shopData.product.id);
            }
            else if (BSS_B2B.page.isCartPage() && shopData.line_item_products.length > 0) {
                shopData.line_item_products.map(item => {
                    if (!productIdResponse.includes(item.id)) {
                        responseProducts.push(item);
                        productIdResponse.push(item.id);
                    }
                });
            }
            else if (productsHasMetaField && productsHasMetaField.length > 0) {
                productsHasMetaField.map(item => {
                    if (!productIdResponse.includes(item.id)) {
                        responseProducts.push(item);
                        productIdResponse.push(item.id);
                    }
                });
            }

            let featuredProduct = BSS_B2B.getFeaturedProductMetaField();
            if (featuredProduct && featuredProduct.id && !productIdResponse.includes(featuredProduct.id)) {
                responseProducts.push(featuredProduct);
            }

            BSS_B2B.fix.cp.fixResponseProducts(responseProducts);
            if (responseProducts.length > 0) {
                let productMap = [];
                let productPrices = [];
                let checkUnique = [];
                for (let i = 0; i < responseProducts.length; i++) {
                    let product = responseProducts[i];
                    if (checkUnique.indexOf(product.id) === -1) {
                        checkUnique.push(product.id);
                        //check variant selected in first load
                        let variantSelected = "";
                        let priceElementFeaturedCollections = document.querySelectorAll(`[bss-b2b-product-id='${product.id}'][bss-b2b-product-price]:not([bss-b2b-featured-product])`);
                        let priceElementFeaturedProducts = document.querySelectorAll(`[bss-b2b-product-id='${product.id}'][bss-b2b-product-price][bss-b2b-featured-product]`);
                        if (BSS_B2B.storeId === 621) {
                            priceElementFeaturedProducts = document.querySelectorAll(`[bss-b2b-product-id='${product.id}'][bss-b2b-featured-product]`);
                        }

                        priceElementFeaturedProducts = window.BSS_B2B.executeFilter({ tag: 'get_price_element_featured_product', storeId: 5912, val: priceElementFeaturedProducts, product });
                        if (variantId && !isNaN(parseInt(variantId))) {
                            variantSelected = variantId;
                        }
                        else {
                            if (cartFormElement) {
                                if (BSS_B2B.storeId === 8708 && BSS_B2B.page.isCollectionPage()) {
                                    cartFormElement.forEach(item => {
                                        if (item.closest('.quick-buy-drawer__info')) {
                                            variantSelected = item.querySelector('input[name="id"]');
                                        }
                                    })
                                } else {
                                    if ([15551, 8412].includes(BSS_B2B.storeId) && cartFormElement.length > 1) {
                                        cartFormElement = $(cartFormElement[1])
                                    }
                                    if (BSS_B2B.storeId === 16064 && cartFormElement.length > 1) {
                                        cartFormElement = $(cartFormElement[length-1])
                                    }
                                    let priceElement = cartFormElement.closest(BSS_B2B.helper.productFormElement);
                                    if (priceElement && priceElement.length > 0) {
                                        let cartFormEle = priceElement[0].querySelector(
                                            `[bss-b2b-product-id='${product.id}'][bss-b2b-variant-id]`);
                                        if (cartFormEle) {
                                            variantSelected = cartFormEle.getAttribute('bss-b2b-variant-id');
                                        }
                                        if (BSS_B2B.storeId === 3351 && isQuickView) {
                                            const input = priceElement[0].querySelector('.variant-selection__variants');
                                            if (input) {
                                                variantSelected = input.value;
                                            }
                                        }
                                    } else if (priceElement.length) {
                                        let cartFormEle = priceElement.querySelector(
                                            `[bss-b2b-product-id='${product.id}'][bss-b2b-variant-id]`);
                                        if (cartFormEle) {
                                            variantSelected = cartFormEle.getAttribute('bss-b2b-variant-id');
                                        }
                                    }
                                }
                            } else {
                                let priceElement = document.querySelector(`[bss-b2b-product-id='${product.id}'][bss-b2b-variant-id]`);
                                if (priceElement) {
                                    variantSelected = priceElement.getAttribute('bss-b2b-variant-id');
                                    if([15884].includes(BSS_B2B.storeId) && BSS_B2B.page.isProductPage()) variantSelected = $("#product-form-installment input[type='hidden'][name='id']").eq(0).val();
                                }
                                if (BSS_B2B.storeId === 9364 && BSS_B2B.page.isCollectionPage()) {
                                    let priceElement = $(`.info[bss-b2b-product-id='${product.id}']`);
                                    if (priceElement && priceElement[0]) {
                                        const input = priceElement[0].querySelector('input[type=\'hidden\'][name=\'id\']');
                                        if (input) {
                                            variantSelected = input.value;
                                        }
                                    }
                                }
                                if (BSS_B2B.storeId === 3351) {
                                    const input = document.querySelector('.variant-selection__variants');
                                    if (input) {
                                        variantSelected = input.value;
                                    }
                                }
                                if (BSS_B2B.storeId === 11946) {
                                    variantSelected = BSS_B2B.getQueryArray();
                                }
                                if ([13435, 13831].includes(BSS_B2B.storeId)) {
                                    let priceElement = $(`[bss-b2b-product-id='${product.id}']`);
                                    if (priceElement && priceElement[0]) {
                                        const input = priceElement[0].parentElement.querySelector("input[type='hidden'][name='id']");
                                        if (input) {
                                            variantSelected = input.value;
                                        }
                                    }
                                }
                            }
                        }
                        let productMapItem = {
                            id: product.id,
                            product_name: product.title,
                            tags: product.tags,
                            collections: product.collections,
                        }
                        let productInfo = {
                            id: product.id,
                            product_name: product.title,
                            tags: product.tags,
                            collections: product.collections,
                            price: product.price,
                            priceMin: product.price_min,
                            priceMax: product.price_max,
                            compareAtPriceMin: product.compare_at_price_min,
                            compareAtPriceMax: product.compare_at_price_max,
                            variants: product.variants,
                        }

                        if (!variantSelected && isNaN(parseInt(variantSelected))) {
                            productMap.push(productMapItem)
                            productPrices[product.id] = productInfo;
                        } else {
                            let checkVariantId = variantId;
                            if (BSS_B2B.storeId === 621 && (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isHomePage())) {
                                checkVariantId = null;
                                if (BSS_B2B.page.isHomePage() && customAttr) {
                                    priceElementFeaturedCollections = document.querySelectorAll(`[bss-b2b-product-id='${product.id}'][bss-b2b-product-parent-price]`);
                                }
                            }
                            if (BSS_B2B.storeId === 11941 && BSS_B2B.page.isProductPage()) {
                                priceElementFeaturedCollections = document.querySelectorAll(`[bss-b2b-product-id='${product.id}'][bss-b2b-product-parent-price]`);
                            }

                            let checkVariant = product.variants.filter((variant) => variant.id == variantSelected);
                            if (checkVariant && checkVariant.length > 0 && priceElementFeaturedCollections && priceElementFeaturedCollections.length > 0 && !checkVariantId) {
                                productMap.push(productMapItem);

                                productPrices[product.id] = {
                                    ...productInfo,
                                    variantSelected: parseInt(variantSelected),
                                };
                            }
                            if (
                                priceElementFeaturedProducts
                                && priceElementFeaturedProducts.length > 0
                            ) {
                                productMap.push({
                                    ...productMapItem,
                                    isFeatured: true,
                                    variantsApplied: parseInt(variantSelected),
                                });

                                productPrices[product.id] = {
                                    ...productInfo,
                                    variantSelected: parseInt(variantSelected)
                                };
                            }
                        }
                    }
                }
                let priceLists = BSS_B2B.getPriceList(shopData, productMap, false, productPrices);
                if (BSS_B2B.storeId === 7067) {
                    BSS_B2B.customize.cp.hideCustomElement7067(BSS_B2B, priceLists);
                }
                BSS_B2B.cpRuleChoice = priceLists;
                if (BSS_B2B.cpRuleChoice.length === 0) {
                    if (BSS_B2B.storeId === 14806) {
                        $(".bss-b2b-customized-compare-at-price").remove()
                    }
                }
                const isAppliedTD = taxDisplayRules_default.a.getAppliedRuleCollectionPage(BSS_B2B, shopData);
                if ((BSS_B2B.cpRuleChoice.length === 0 && !isAppliedTD)) {
                    BSS_B2B.addFallbackStylePrice(isEnableQB);
                }
                if (BSS_B2B.storeId === 9854 && BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length) {
                    window.BSS_B2B.executeAction({ tag: "change_quantity", storeId: 9854, shopData });
                }
                if ([8553].includes(BSS_B2B.storeId)) {
                    let customer = shopData.customer;
                    let productPrice = document.querySelectorAll('[product-id-customize]');
                    if (productPrice && productPrice.length && customer && customer.tags &&
                        customer.tags.includes('wholesale')) {
                        productPrice.forEach((item) => {
                            let productPriceCheck = item.closest('div:not([product-id-customize])').
                                querySelector('.bss-wholesale');
                            let productId = item.getAttribute('product-id-customize');
                            if (!BSS_B2B.cpRuleChoice.some(obj => obj.id === +productId) && !productPriceCheck) {
                                item.insertAdjacentHTML('afterend',
                                    '<div class = "bss-wholesale">N/A FOR WHOLESALE</div>');
                            }
                        });
                    }
                }

                if (BSS_B2B.storeId === 2087 && customAttr &&
                    customAttr.includes('.modal.modal--quick-shop.modal--is-active') && cartFormElement) {
                    shopData.product = responseProducts[0];
                    shopData.quickview = true;
                    shopData.storeId = BSS_B2B.storeId;
                }
                if ([10700].indexOf(BSS_B2B.storeId) !== -1) {
                    shopData.product = responseProducts[0];
                }
                if ([2988, 3794].indexOf(BSS_B2B.storeId) !== -1 && window.location.pathname === '/') {
                    shopData.product = responseProducts[0];
                    tax_default.a.bssB2BChangeVatPrice(shopData.product.variants[0].id, shopData, false);
                }
                if (BSS_B2B.storeId === 9605 && BSS_B2B.page.isProductPage()) {
                    tax_default.a.bssB2BChangeVatPrice(shopData.product.variants[0].id, shopData, false);
                }
                if ([11378].includes(BSS_B2B.storeId) && BSS_B2B.page.isProductPage() && ((priceLists && !priceLists.length) || !priceLists)) {
                    tax_default.a.bssB2BChangeVatPrice(shopData.product.variants[0].id, shopData, false);
                }
                tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                if (!priceLists.length) {
                    tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                }
                let variant = false;
                if (variantId) {
                    variant = variantId;
                }
                let queryArray = BSS_B2B.getQueryArray();
                if (cartFormElement) {
                    let variantSelector = $(cartFormElement).find('select[name="id"], input[name="id"]');
                    if (variantSelector.length) {
                        variant = variantSelector.val();
                    }
                    // variant = cartFormElement.value
                }
                else if (BSS_B2B.page.isHomePage() && isQuickView && ShopifyAnalytics.meta.selectedVariantId) {
                    // get variant featured product by ShopifyAnalytics.meta
                    variant = ShopifyAnalytics.meta.selectedVariantId;
                }
                let isProductPage = BSS_B2B.page.isProductPage();
                let checkQuickView = document.querySelector(
                    '.modal-container.shopify-section.loaded, .modal .modal-inner, .side-panel.product-drawer.active .thb-product-detail.product, #Product-Drawer.side-panel.product-drawer.active, .quick-shop, #quickshop, .sf-modal');
                let variantIdForVat = '';

                if (isProductPage ||
                    (checkQuickView && [7131, 6579, 7355, 8219, 9364, 11985, 12411, 1056].includes(BSS_B2B.storeId)) ||
                    (BSS_B2B.page.isHomePage() && [9817].includes(BSS_B2B.storeId))
                ) {
                    let variantSelector = $('form[action*="/cart/add"]').find('select[name="id"]');

                    if (BSS_B2B.storeId === 5302) {
                        variantSelector = $('#main product-payment-terms input[name=id]');
                    }
                    else if (BSS_B2B.storeId === 8219) {
                        variantSelector = $('#product-form-installment input[name=id]');
                    }
                    if (variantSelector.length) {
                        variant = variantSelector.val();
                        variantIdForVat = variant;
                    }

                    if (queryArray.indexOf('variant') !== -1) {
                        variant = queryArray['variant'];
                        variantIdForVat = variant;
                    }
                    if ([6579].indexOf(BSS_B2B.storeId) !== -1 && isQuickView) {
                        variantSelector = $('.modal .modal-inner form[action*="/cart/add"]').
                            find('input[name="id"], select[name="id"]');
                        if (variantSelector.length) {
                            variant = variantSelector.val();
                            variantIdForVat = variant;
                        }
                    }
                    else if ([7131].indexOf(BSS_B2B.storeId) !== -1 && checkQuickView) {
                        variantSelector = $('.modal-container.shopify-section.loaded form[action*="/cart/add"]').
                            find('select[name="id"]');
                        if (variantSelector.length) {
                            variant = variantSelector.val();
                            variantIdForVat = variant;
                        }
                    }
                    if (!variant || !variantSelector.length) {
                        //Fix for dawn theme
                        variantSelector = $('form[action*="/cart/add"]').find('input[name="id"]');
                        // fix for allerleiwindeln by mitri
                        if (BSS_B2B.storeId === 2693) {
                            variantSelector = $('.product__info form[action*="/cart/add"]').find('input[name="id"]');
                        }
                        if (BSS_B2B.storeId === 13433) {
                            variantSelector = $(".sf-modal__content-inner form[action*='/cart/add']").find('input[name="id"]');
                        }
                        if (BSS_B2B.storeId === 7355 && checkQuickView) {
                            variantSelector = $(
                                '#Product-Drawer-Content .product-form input[name="id"][type="hidden"]');
                        }
                        if (BSS_B2B.storeId === 14451) {
                            var bssB2BCustomVariant = document.getElementById('bss-b2b-custom-variant');
                            if(bssB2BCustomVariant) {
                                variant = bssB2BCustomVariant.getAttribute('variant');
                                variantIdForVat = variant;
                            }
                        }
                        if (variantSelector.length && ![9461, 10325, 14451].includes(BSS_B2B.storeId)) {
                            variant = variantSelector.val();
                            variantIdForVat = variant;
                        }
                    }
                }
                if ([4856, 6289, 6365, 7332, 9817].includes(BSS_B2B.storeId) && customAttr) {
                    if (customAttr.includes('quick-buy-product__info')) {
                        let productContainer = $(customAttr).closest('quick-buy-drawer');
                        if (productContainer) {
                            let variantSelector = productContainer.find('form[action*="/cart/add"] input[name="id"]');
                            if (variantSelector.length) {
                                variant = variantSelector.val();
                                variantIdForVat = variant;
                            }
                        }
                    }
                }
                else if (BSS_B2B.storeId === 7359 && customAttr) {
                    let variantSelector = $('.featured-product__add-to-cart[data-id]');
                    if (variantSelector.length) {
                        variant = variantSelector.attr('data-id');
                        variantIdForVat = variant;
                    }
                }
                else if ([10700, 10748].includes(BSS_B2B.storeId) && customAttr) {
                    let variantSelector;
                    if (BSS_B2B.storeId === 10748) {
                        variantSelector = $(
                            '.quickbuy-container .price-area .current-price.theme-money[bss-b2b-variant-price]');
                    }
                    else {
                        variantSelector = $('.tt-modal-quickview .tt-price .new-price');
                    }
                    if (variantSelector.length) {
                        variant = variantSelector.attr('bss-b2b-variant-id');
                        variantIdForVat = variant;
                    }
                }
                else if (BSS_B2B.storeId === 12292) {
                    let variantSelector = $('.modal--is-active .product-single__variants');
                    if (variantSelector.length) {
                        variant = variantSelector.val();
                        variantIdForVat = variant;
                    }
                }
                // Custom to avoid override BSS_B2B.cp.productAfterUseCP
                if (BSS_B2B.storeId !== 10868) {
                    BSS_B2B.cp.productAfterUseCP = [];
                }

                for (let j = 0; j < priceLists.length; j++) {
                    let priceJ = priceLists[j];
                    if (priceJ.variantSelected) {
                        variant = priceJ.variantSelected
                    }
                    let productId = priceJ.id;
                    let discountType = priceJ.discount_type;
                    let discountValueOfRule = parseFloat(priceJ.value);
                    if (BSS_B2B.storeId === 621 && (BSS_B2B.page.isCollectionPage() && !window.location.pathname.includes('collections/b2b-collection')) && priceJ.variants && priceJ.conditionType && priceJ.conditionType === 4) {
                        discountValueOfRule = window.BSS_B2B.executeFilter({
                            tag: 'update_discount_rule_cp', storeId: 621,
                            val: discountValueOfRule, priceJ,
                            productPrices, productId, discountValueOfRule
                        });
                    }

                    let realDiscountValue = BSS_B2B.helper.convertPriceWithRate(discountValueOfRule) * 100;
                    let priceElement = BSS_B2B.helper.getPriceElement(productId, ":not([bss-b2b-featured-product])");
                    let lowestPriceElement = BSS_B2B.helper.getLowestPriceElement(productId, ":not([bss-b2b-featured-product])");
                    let highestPriceElement = BSS_B2B.helper.getHighestPriceElement(productId, ":not([bss-b2b-featured-product])");
                    let unitPriceElement = BSS_B2B.helper.getUnitPriceElement(productId, ":not([bss-b2b-featured-product])");
                    let buttonPriceElement = BSS_B2B.helper.getButtonPriceElement(productId, ":not([bss-b2b-featured-product])");
                    if (priceJ.isFeatured) {
                        priceElement = BSS_B2B.helper.getPriceElement(productId, "[bss-b2b-featured-product]");
                        lowestPriceElement = BSS_B2B.helper.getLowestPriceElement(productId, "[bss-b2b-featured-product]");
                        highestPriceElement = BSS_B2B.helper.getHighestPriceElement(productId, "[bss-b2b-featured-product]");
                        unitPriceElement = BSS_B2B.helper.getUnitPriceElement(productId, "[bss-b2b-featured-product]");
                        buttonPriceElement = BSS_B2B.helper.getButtonPriceElement(productId, "[bss-b2b-featured-product]");
                    }

                    let lowestPriceHtmlArr = [];
                    if (lowestPriceElement.length > 0) {
                        lowestPriceHtmlArr = lowestPriceElement.html();
                    }

                    let highestPriceHtmlArr = [];
                    if (highestPriceElement.length > 0) {
                        highestPriceHtmlArr = highestPriceElement.html();
                    }

                    let price = parseFloat(productPrices[productId].price);
                    if (priceJ.variants) {
                        if (priceJ.variants.length) {
                            let variants = productMap.filter(item => item.id === productId && item.variantsApplied);
                            if (priceJ.variants.includes(variants[0].variantsApplied + '')) {
                                let variantPrice = productPrices[productId].variants.filter(
                                    (variant) => variant.id === variants[0].variantsApplied);
                                if (variantPrice.length > 0) {
                                    price = parseFloat(variantPrice[0].price);
                                }
                            }
                        }
                        else if (!isNaN(priceJ.variants)) {
                            let variantPrice = productPrices[productId].variants.filter(
                                (variant) => variant.id === priceJ.variants);
                            if (variantPrice.length > 0) {
                                price = parseFloat(variantPrice[0].price);
                            }
                        }
                    }
                    else if (priceJ.variantSelected) {
                        let variantPrice = productPrices[productId].variants.filter(
                            (variant) => variant.id === parseInt(priceJ.variantSelected));
                        if (variantPrice.length > 0) {
                            price = parseFloat(variantPrice[0].price);
                        }
                    }

                    let currentItemPrices = productPrices[productId];
                    let currentProductVariant = currentItemPrices.variants.length > 0 ? currentItemPrices.variants : [];

                    if (BSS_B2B.storeId === 4618) {
                        if (isProductPage && priceElement.closest('.productitem__price').length &&
                            priceElement.closest('.product-recommendations--container').length) {
                            variant = priceElement.closest('.productitem__price').attr('[bss-b2b-variant-id]');
                        }
                        if (isProductPage && priceElement.closest('.product--container').length) {
                            let variantId = priceElement.closest('.product-details').
                                find('[bss-b2b-variant-id]').
                                attr('bss-b2b-variant-id');
                            if (variantId) {
                                variant = variantId;
                            }
                        }
                    }

                    if (BSS_B2B.storeId === 11769) {
                        setTimeout(
                            () =>
                                $(`span[bss-b2b-product-id="${productId}"][bss-b2b-product-parent-price]`)
                                    .eq(0)
                                    .append('<span>&nbsp;AUD (Inc GST)</span>'),
                            500
                        );
                    }

                    // fix for store 5598, 6590
                    if (BSS_B2B.storeId === 12303) {
                        window.BSS_B2B.executeAction({
                            tag: `customize_discount_rate`,
                            storeId: 12303,
                            BSS_B2B: window.BSS_B2B,
                            productId, price, discountType,
                            discountValueOfRule, key: null
                        });
                    } else {
                        window.BSS_B2B.executeAction({
                            tag: `customize_discount_rate`,
                            storeId: false,
                            isProductPage: BSS_B2B.page.isProductPage(),
                            isCartPage: BSS_B2B.page.isCartPage(),
                            productId, discountType,
                            discountValueOfRule, key: null
                        });
                    }
                    if (customAttr) {
                        if (currentItemPrices.compareAtPriceMin === 0) {
                            priceElement = $(
                                customAttr + '[data-regular-price][bss-b2b-product-id="' + productId + '"]');
                            if (BSS_B2B.storeId === 5273) {
                                priceElement = $(customAttr + ' [data-price][bss-b2b-product-id="' + productId + '"]');
                            }
                        }
                        else {
                            priceElement = $(
                                customAttr + '[data-sale-price][bss-b2b-product-id="' + productId + '"]',
                            );

                        }
                        if ([12553].includes(BSS_B2B.storeId)) {
                            priceElement = $(document.querySelector(customAttr).
                                shadowRoot.
                                querySelector('[bss-b2b-product-id="' + productId + '"]'));
                        }

                        if (priceElement.length === 0) {
                            let fixedResult = BSS_B2B.fix.cp.fixEmptyPriceElement(customAttr, priceElement, productId);
                            if (fixedResult.priceElement && fixedResult.priceElement.length > 0) {
                                priceElement = fixedResult.priceElement;
                            }
                            if (fixedResult.variant && fixedResult.variant !== undefined) {
                                variant = fixedResult.variant;
                            }
                        }

                        let fixedResult = BSS_B2B.fix.cp.fixPriceElementAndGetVariant(customAttr, priceElement,
                            productId, variant, isQuickView);
                        priceElement = fixedResult.priceElement;
                        variant = fixedResult.variant;
                        // Need to implement select option instead of url
                        if (variant) {
                            let variants = currentItemPrices.variants;
                            if (variants && variants.length) {
                                for (let k = 0; k < variants.length; k++) {
                                    let currentVariant = variants[k];
                                    if (currentVariant.id === parseInt(variant)) {
                                        let fixPriceElementResult = BSS_B2B.fix.cp.fixPriceElementAndUnitPriceElement(
                                            customAttr, variant, productId, currentVariant, priceElement,
                                            unitPriceElement, isQuickView);
                                        priceElement = fixPriceElementResult.priceElement;
                                        unitPriceElement = fixPriceElementResult.unitPriceElement;

                                        let currentCartForm = 'form[action*="/cart/add"]';
                                        if (cartFormElement) {
                                            currentCartForm = $(cartFormElement);
                                        }

                                        let isExistVariant = BSS_B2B.checkVariantExist(currentCartForm, currentVariant);
                                        if (isExistVariant) {
                                            if (priceElement.length && BSS_B2B.storeId === 181) {
                                                Object.keys(priceElement).forEach(function (key) {
                                                    if ($(priceElement[key]).attr('class') === 'product-item-content') {
                                                        delete priceElement[key];
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if ([
                                                13,
                                                181,
                                                1138,
                                                2589,
                                                2896,
                                                537,
                                                5892,
                                                2933,
                                                6644,
                                                7121,
                                                7795,
                                                9483, 10353, 14132, 14373].indexOf(BSS_B2B.storeId) !== -1) {
                                                // do nothing
                                            }
                                            else {
                                                priceElement = $(
                                                    '[data-regular-price][bss-b2b-product-id="' + productId + '"]');
                                            }
                                        }

                                        let priceElem = $(
                                            '#ProductPrice.product-single__price[data-sale-price][bss-b2b-product-id="' +
                                            productId + '"]');
                                        if (priceElem.length) {
                                            priceElement = priceElem;
                                        }
                                        //fix ixcor by XuTho add button show
                                        // price total
                                        if (priceElement && $(priceElement).
                                            closest('.Product__Info').
                                            find('form span[data-money-convertible]').length) {
                                            let nextPriceElement = $(priceElement).
                                                closest('.Product__Info').
                                                find('form span[data-money-convertible]');
                                            priceElement.push(nextPriceElement[0]);
                                        }
                                        price = parseFloat(variants[k].price);
                                    }
                                }

                            }
                        }
                        else {
                            if (priceElement.length) {
                                if (BSS_B2B.integrate.gemPages.isGemPageSelector(priceElement, cartFormElement)) {
                                    price = BSS_B2B.integrate.gemPages.getProductPrice(priceElement);
                                    price = BSS_B2B.integrate.gemPages.getTotalProductPrice(price, cartFormElement);
                                }
                                else {
                                    if (priceElement.find('[bss-b2b-product-id="' + productId + '"]').length) {
                                        priceElement = priceElement.find('[bss-b2b-product-id="' + productId + '"]');
                                    }
                                    let priceElementHtml = priceElement.html();
                                    priceElementHtml = priceElementHtml.replace(/\D/g, '');

                                    if (BSS_B2B.storeId === 78) {
                                        price = parseFloat(priceElementHtml);
                                    } else if (BSS_B2B.storeId !== 3588) {
                                        if ([
                                            77,
                                            2589,
                                            2896,
                                            4094,
                                            4904,
                                            4856,
                                            6289,
                                            6412,
                                            6366,
                                            6365,
                                            5273,
                                            6765,
                                            6644,
                                            3820,
                                            6932,
                                            7121,
                                            5302,
                                            9173,
                                            9959,
                                            12553].indexOf(BSS_B2B.storeId) !== -1) {
                                            // do nothing
                                        }
                                        else if ([2086].indexOf(BSS_B2B.storeId) !== -1) {
                                            price = parseFloat(priceElementHtml) / 10000;
                                        }
                                        else {
                                            price = parseFloat(priceElementHtml) * 100;
                                        }
                                    }
                                }
                                // fix for benki-brewingtools
                            }
                            else if (BSS_B2B.storeId === 181 || BSS_B2B.storeId === 13) {
                                priceElement = $('[data-regular-price][bss-b2b-product-id="' + productId + '"],' +
                                    '[bss-b2b-variant-price][bss-b2b-product-id="' + productId + '"]');
                                if (priceElement.length) {
                                    Object.keys(priceElement).forEach(function (key) {
                                        if ($(priceElement[key]).attr('class') === 'product-item-content') {
                                            delete priceElement[key];
                                        }
                                    });
                                }
                                let dataId = '#ProductItemJson-' + productId;
                                let currentProductSelector = ('[data-id="' + dataId + '"]');
                                if (priceElement.length && $(cartFormElement).find(currentProductSelector).length) {
                                    let priceElementHtml = priceElement.html();
                                    priceElementHtml = priceElementHtml.replace(/\D/g, '');
                                    price = parseFloat(priceElementHtml) * 100;
                                }
                            }
                        }
                        if (priceElement.length === 0) {
                            priceElement = $(customAttr + '[data-sale-price][bss-b2b-product-id="' + productId + '"]');
                        }
                        if (priceElement.length === 0 &&
                            [4257, 5252, 6699, 1651, 6095, 7207, 7359, 9730].includes(BSS_B2B.storeId)) {
                            priceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                        }
                        if (BSS_B2B.page.isProductPage() && customAttr.includes('[bss-b2b-custom-unit-price-4927]') &&
                            BSS_B2B.storeId === 4927) {
                            price = parseFloat(document.querySelector(
                                '[bss-b2b-product-id="' + productId + '"][bss-b2b-custom-unit-price-4927]').
                                getAttribute('bss-b2b-custom-unit-price-4927')) * 100;
                        }
                    }
                    else {
                        if (priceElement.closest('[data-product-variant-id]') &&
                            (BSS_B2B.storeId === 2589 || BSS_B2B.storeId === 2896)) {
                            variant = priceElement.closest('[data-product-variant-id]').attr('data-product-variant-id');
                        }
                        if (BSS_B2B.storeId === 5130) {
                            let variantId = priceElement.attr('bss-b2b-variant-id');
                            if (variantId) {
                                variant = variantId;
                            }
                        }
                        if (BSS_B2B.storeId === 8505) {
                            if (priceElement.length >= 2) {
                                let variantId = priceElement[1].getAttribute('bss-b2b-variant-id');
                                if (variantId) {
                                    variant = variantId;
                                }
                            }
                        }
                        // fix product template on home page for 7668
                        if (BSS_B2B.storeId === 7668 && BSS_B2B.page.isHomePage()) {
                            variant = document.querySelector('.yv-product-price[bss-b2b-variant-id]').
                                getAttribute('bss-b2b-variant-id');
                        }
                        if ((variant && isProductPage && shopData.product && (shopData.product.id === productId)) ||
                            ([7668].includes(BSS_B2B.storeId) && BSS_B2B.page.isHomePage()) ||
                            ([8505].includes(BSS_B2B.storeId)) || isQuickView) {
                            let variants = currentItemPrices.variants;
                            if (priceJ.isFeatured) {
                                //nothing
                            }
                            else {
                                if (variants && variants.length) {
                                    for (let k = 0; k < variants.length; k++) {
                                        let currentVariant = variants[k];
                                        if (currentVariant.id === parseInt(variant)) {
                                            let fixPriceElementResult = BSS_B2B.fix.cp.fixPriceElementAndUnitPriceElement(customAttr, variant, productId, currentVariant, priceElement, unitPriceElement, isQuickView);
                                            priceElement = fixPriceElementResult.priceElement.filter(function () {
                                                if ([3051, 5077, 8331, 9668, 12886, 13573, 13790, 14064, 11460, 15770].includes(BSS_B2B.storeId)) {
                                                    //show all variant in table, not have button to select each variant
                                                    return true
                                                } else {
                                                    return $(this).attr('bss-b2b-featured-product')
                                                }
                                            });
                                            if ([12388, 10989, 10911, 11612, 12567, 15292, 15284, 15658, 11576, 15968, 15884].includes(BSS_B2B.storeId)) {
                                                priceElement = BSS_B2B.helper.getPriceElement(productId, ":not([bss-b2b-featured-product])")
                                            }
                                            unitPriceElement = fixPriceElementResult.unitPriceElement;

                                            let currentCartForm = 'form[action*="/cart/add"]';
                                            if (cartFormElement) {
                                                currentCartForm = $(cartFormElement);
                                            }

                                            let isExistVariant = BSS_B2B.checkVariantExist(currentCartForm,
                                                currentVariant);
                                            if (!isExistVariant) {
                                                // fix for benki-brewingtools
                                                if ([181, 1138, 7795].indexOf(BSS_B2B.storeId) !== -1) {
                                                    // do nothing
                                                }
                                                else if (BSS_B2B.storeId === 2254) {
                                                    //fix for plankindustry
                                                    priceElement = $(
                                                        '[data-product-price][bss-b2b-product-price][bss-b2b-product-id="' +
                                                        productId + '"]',
                                                    );
                                                }
                                                else {
                                                    priceElement = $(
                                                        '[data-regular-price][bss-b2b-product-id="' + productId + '"]',
                                                    );
                                                }
                                            }
                                            price = parseFloat(variants[k].price);
                                        }
                                    }
                                }
                            }
                        }

                        if (variant && !isProductPage && (BSS_B2B.storeId === 2589 || BSS_B2B.storeId === 2896)) {
                            price = parseFloat(
                                priceElement.closest('[data-product-variant-price]').
                                    attr('data-product-variant-price'));
                        }

                        if ((BSS_B2B.storeId === 4927) &&
                            (BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isHomePage())) {
                            price = parseFloat(priceElement.closest('[bss-b2b-custom-unit-price-4927]').
                                attr('bss-b2b-custom-unit-price-4927')) * 100;
                        }
                        // fix for storeID 537
                        if (variant && BSS_B2B.page.isProductPage()) {
                            priceElement = window.BSS_B2B.executeFilter({ tag: 'price_element', storeId: 537, val: priceElement, productId });
                        }

                        // fix for storeId 9668
                        if (!variant && BSS_B2B.page.isProductPage() && BSS_B2B.storeId === 9668) {
                            priceElement = $('.b2b-price')
                        }
                    }

                    if (BSS_B2B.storeId === 1654 && !BSS_B2B.page.isProductPage()) {
                        let variants = productPrices[productId].variants;
                        if (variants.length) {
                            variants.map((item) => {
                                if (item.title === 'per paar') {
                                    price = parseFloat(item.price);
                                }
                            });
                        }
                    }
                    if (BSS_B2B.storeId === 5302 && appliedDisplayRule) {
                        variantIdForVat = variant;
                        shopData.quickview = isQuickView && (productId === responseProducts[0].id);
                        shopData.nowProductId = productId;
                        shopData.product = responseProducts[0];
                    }

                    if (BSS_B2B.storeId == 8337 && $('#ShopNowContainer #ProductPrice').length) {
                        price = $('#ShopNowContainer #ProductPrice').attr('content') * 100;
                        priceElement = $('#ShopNowContainer #ProductPrice');
                    }

                    if ([9745, 621].includes(BSS_B2B.storeId) && customAttr) {
                        priceElement = $(customAttr + '[bss-b2b-product-id="' + productId + '"]');
                    }

                    if (BSS_B2B.storeId == 11481 && customAttr) {
                        priceElement = $(customAttr + ' [bss-b2b-product-id="' + productId + '"]');
                    }

                    let lowestPrice = parseFloat(productPrices[productId].priceMin);
                    let highestPrice = parseFloat(productPrices[productId].priceMax);

                    const discountTypes = [0, 1, 2];

                    if (discountTypes.indexOf(discountType) !== -1) {
                        const appliedProduct = productPrices[productId];
                        calculateAndShowDiscountPrice(shopData, price, priceJ, variant, productId, productPrices,
                            priceElement, cartFormElement, currentItemPrices, unitPriceElement, discountType,
                            discountValueOfRule, realDiscountValue, lowestPrice, lowestPriceElement, lowestPriceHtmlArr,
                            highestPrice, highestPriceElement, highestPriceHtmlArr, buttonPriceElement, variantIdForVat,
                            appliedDisplayRule, appliedProduct, isQuickView, isProductPage, isEnableMC, currentProductVariant);
                    }
                }

                // multi currency app
                // check if enable multi currency then waiting for currency
                // change then show price
                $('[bss-b2b-product-id]').css('visibility', 'visible');
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').show();
                if (BSS_B2B.storeId === 14897) {
                    window.BSS_B2B.executeAction({ tag: 'customize_cp_td', storeId: 14897, BSS_B2B })
                }
                if (BSS_B2B.storeId === 9668) {
                    const priceWrapper = $('[bss-b2b-product-id]').closest('.bss-b2b-is-loading');
                    if (priceWrapper) {
                        priceWrapper.removeClass('bss-b2b-is-loading');
                    }
                }
                if (isEnableMC) {
                    let sessionCurrencyCode = window.localStorage.getItem('currentCurrency');
                    let sessionCurrencyFormat = window.localStorage.getItem('currentCurrencyFormat');
                    let checkMCInitInterval = setInterval(() => {
                        if (BSS_B2B.MC && BSS_B2B.MC.preConvertCurrency && typeof BSS_B2B.MC.preConvertCurrency ===
                            'function') {
                            BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
                            clearInterval(checkMCInitInterval);
                        }
                    }, 500);
                    setTimeout(() => {
                        clearInterval(checkMCInitInterval);
                    }, 5000);
                    if (BSS_B2B.storeId === 3879) {
                        let checkTimes = 0;
                        let check = setInterval(function () {
                            let bssTD = document.querySelector('.bss-b2b-product-vat [bss-b2b-product-price]');
                            if (bssTD || checkTimes > 20) {
                                clearInterval(check);
                                if (bssTD && BSS_B2B.MC.preConvertCurrency) {
                                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
                                }
                            }
                            checkTimes++;
                        }, 500);
                    }
                }

                if ([324, 2669, 4608].indexOf(BSS_B2B.storeId) !== -1) {
                    $('span[data-money-convertible]').show();
                }
                if (BSS_B2B.storeId === 778) {
                    $('span[bss-b2b-product-parent-price]').show();
                }
                if ([1283, 1932, 2589, 2896, 3512, 8337].indexOf(BSS_B2B.storeId) !== -1) {
                    $('[bss-b2b-product-price]').show();
                }
                if (BSS_B2B.storeId === 2525) {
                    let productPriceElement = $('.large--three-fifths [bss-b2b-product-active]');
                    let productPrice = productPriceElement.html();
                    if (!isNaN(productPrice)) {
                        productPriceElement.html(BSS_B2B.formatMoney(productPrice));
                    }
                }

                window.BSS_B2B.executeAction({ tag: 'show_price_with_product_not_apply', storeId: 621, priceLists, customAttr, productPrices });

                if ([10868, 14064, 14384, 14810, 10351, 15292, 15551, 10876, 13880].includes(BSS_B2B.storeId)) {
                    document.dispatchEvent(new Event('bss.b2b.done_CP_ChangePrice', { bubbles: true }));
                }
            }
        });
    };

    BSS_B2B.showUnitPrice = function (
        unitPriceElement, variants, productId, priceModifiedByCp, priceOrigin, currentVariant) {
        //start unit price
        if (variants && variants.length) {
            for (let i = 0; i < variants.length; i++) {
                let variant = variants[i];
                let unitPrice = variant.unit_price;
                unitPrice = window.BSS_B2B.executeFilter({ tag: 'unit_price_custom', storeId: 14317, val: unitPrice, unitPriceElement });
                if (unitPrice) {
                    unitPriceElement.html(
                        BSS_B2B.formatMoney((priceModifiedByCp * parseFloat(unitPrice) / variant.price)));
                    if (currentVariant) {
                        if (currentVariant === variant.id.toString()) {
                            unitPriceElement = unitPriceElement.html(
                                BSS_B2B.formatMoney((priceModifiedByCp * parseFloat(unitPrice) / variant.price)));
                        }
                    }
                }

            }
        }
        //end unit price
    };

    BSS_B2B.applyChangePriceForMultiCartForm = function () {
        //Apply to multiple cart page at here
        let cartForm = $(
            'form[action*="/cart/add"],' + 'form[action*="/checkout"]' + BSS_B2B.getCssSelector('product_cart_form'));

        if (cartForm.length) {
            let delayTime = 300;
            let productSelectVariantDelayTime = BSS_B2B.getCssSelector('product_time_delay_change_variant');
            if (productSelectVariantDelayTime !== '' && !isNaN(productSelectVariantDelayTime)) {
                delayTime = parseInt(productSelectVariantDelayTime);
            }
            for (let i = 0; i < cartForm.length; i++) {
                let cartFormI = $(cartForm[i]);
                let id = cartFormI.attr('id');
                let selectElement = cartFormI.find('select, ' +
                    'input.single-option-selector__radio'
                    + BSS_B2B.getCssSelector('product_variant_option_input'),
                );
                //selectElement.off()
                if (selectElement.length) {
                    for (let k = 0; k < selectElement.length; k++) {
                        let element = $(selectElement[k]);
                        element.attr('data-cart-form', id);

                        element.on('change', function () {
                            const currentVariantId = $(this).closest('.variant-selection') ? $(this).closest('.variant-selection').attr('variant') : null;

                            // fix for sesoignernature by Leorio
                            if (BSS_B2B.storeId === 1608) {
                                $('.money[data-sale-price][bss-b2b-product-price]').css('visibility', 'hidden');
                            }
                            let currentCartForm = $('#' + $(this).attr('data-cart-form'));
                            let correctParent = currentCartForm.parent().parent();
                            if (currentCartForm.closest('.product-main').length) {
                                correctParent = $(currentCartForm.closest('.product-main'));
                            }
                            currentCartForm.parent().
                                parent().
                                find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                hide();
                            setTimeout(function () {
                                correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                    removeAttr('bss-b2b-product-active');
                                correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                if ([778, 6456, 12634, 10788].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.cp.changeProductPrice(shopData, null, currentCartForm);
                                }
                                else if ([621].includes(BSS_B2B.storeId) && BSS_B2B.page.isHomePage()) {
                                    // Do nothing
                                }
                                else if (BSS_B2B.storeId === 6579) {
                                    if (BSS_B2B.page.isProductPage()) {
                                        BSS_B2B.cp.changeProductPrice(shopData, ".modal-content .price.product__price .price__current", null, true, currentVariantId);
                                    } else {
                                        BSS_B2B.cp.changeProductPrice(shopData,
                                            '.' + correctParent.attr('class').split(' ')[0] +
                                            ' [bss-b2b-product-parent-price]', null, true);
                                    }
                                }
                                else if (BSS_B2B.storeId !== 537) {
                                    BSS_B2B.cp.changeProductPrice(shopData,
                                        '.' + correctParent.attr('class').split(' ')[0] +
                                        ' [bss-b2b-product-parent-price]', currentCartForm);
                                }
                            }, delayTime);

                            setTimeout(function () {
                                BSS_B2B.makeCloneBuyItNow(currentCartForm);
                            }, delayTime * 3);
                        });
                    }
                }

                let ajaxCartButton = cartFormI.find(
                    '[id^="AddToCart"]:not(form),' + 'button[aria-controls="CartDrawer"],' +
                    'a[aria-controls="CartDrawer"], ' + 'button[name="add"].product-form__add-to-cart,' +
                    'button[name="add"].product__add-to-cart-button,' + 'button[name="add"].add-to-cart,' +
                    'a.ajax-cart__toggle,' + 'a.cart-toggle,' + 'button.product-form--atc-button,' +
                    'button.productitem--action-atc,' + '#add-to-cart-product-template-quick,' +
                    'form[action*="/cart/add"] .ProductForm__AddToCart.Button' +
                    BSS_B2B.getCssSelector('ajax_cart_action_button'));
                if (ajaxCartButton.length) {
                    ajaxCartButton.attr('data-cart-form', id);
                    $(ajaxCartButton).on('click', function () {
                        let ajaxCartDelayTime = 1500;
                        let customAjaxCartDelayTime = BSS_B2B.getCssSelector('ajax_cart_time_delay_opening_cart');
                        if (customAjaxCartDelayTime !== '' && !isNaN(customAjaxCartDelayTime)) {
                            ajaxCartDelayTime = parseInt(customAjaxCartDelayTime);
                        }
                        BSS_B2B.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
                        let currentCartForm = $('#' + $(this).attr('data-cart-form'));
                        setTimeout(function () {
                            BSS_B2B.makeCloneBuyItNow(currentCartForm);
                        }, delayTime * 3);
                    });
                }
                //Fixed for gemtheme
                let variantButtons = cartFormI.find('.gt_swatches--select');
                if (variantButtons.length) {

                    let sectionId = id.split('_');
                    let sectionElement = $('script[data-id="' + sectionId[sectionId.length - 1] + '"]').parent();
                    variantButtons = $(sectionElement).
                        find('.gt_swatches--select, ' + '.item.gt_product-carousel--item, ' +
                            '.gt_product-quantity--minus, ' + '.gt_product-quantity--plus');
                    for (let k = 0; k < variantButtons.length; k++) {
                        let element = $(variantButtons[k]);
                        element.attr('data-cart-form', id);
                        element.on('click', function () {
                            let currentCartForm = $('#' + $(this).attr('data-cart-form'));
                            currentCartForm.parent().
                                parent().
                                find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                hide();
                            setTimeout(function () {
                                currentCartForm.parent().
                                    parent().
                                    find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                    removeAttr('bss-b2b-product-active');
                                BSS_B2B.cp.changeProductPrice(shopData,
                                    '.' + currentCartForm.parent().parent().attr('class').split(' ')[0] +
                                    ' [bss-b2b-product-parent-price]', currentCartForm);
                            }, delayTime);

                            setTimeout(function () {
                                BSS_B2B.makeCloneBuyItNow(currentCartForm);
                            }, delayTime * 3);
                        });
                    }

                }
                //    end
            }
        }
    };

    BSS_B2B.applyChangePriceForCollectionPage = function () {
        //Apply to multiple product variant
        let cartForm = $('form[action*="/cart/add"]' + BSS_B2B.getCssSelector('product_cart_form'));
        if (cartForm.length) {
            let delayTime = 300;
            let productSelectVariantDelayTime = BSS_B2B.getCssSelector('product_time_delay_change_variant');
            if (productSelectVariantDelayTime !== '' && !isNaN(productSelectVariantDelayTime)) {
                delayTime = parseInt(productSelectVariantDelayTime);
            }
            for (let i = 0; i < cartForm.length; i++) {
                let productItem = $(cartForm[i]).closest('.product-item-content');

                if (!productItem.length) {
                    productItem = $(cartForm[i]);
                }

                let variantProduct = $(productItem).find('.product-item-option');

                if (BSS_B2B.storeId === 2086) {
                    variantProduct = $(productItem).find('.selector-wrapper');
                }

                if (!variantProduct.length) {
                    variantProduct = $(productItem).find('.select');
                }

                if (BSS_B2B.storeId === 243) {
                    variantProduct = $(productItem).find('.variant-input-wrap .variant-input input');
                }

                if (BSS_B2B.storeId === 8505) {
                    variantProduct = $(productItem).find(
                        'div[data-node-type=\'add-to-cart-option-list\'] div[data-node-type=\'add-to-cart-option-pill\']');
                }

                if (productItem.length && variantProduct.length) {
                    //shop purefemale-add event change variant in collection
                    // page
                    if (BSS_B2B.storeId === 181) {
                        let selectElement = $(variantProduct).find('select.single-option-selector');
                        let hasSwatchElements = $(variantProduct).find('.wrapper-swatches-product-item');

                        if (selectElement.length) {

                            selectElement.on('change', function () {
                                let currentCartForm = $(productItem);
                                currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                setTimeout(function () {
                                    currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                        removeAttr('bss-b2b-product-active');
                                    currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                    BSS_B2B.cp.changeProductPrice(shopData,
                                        '.' + currentCartForm.attr('class').split(' ')[0] +
                                        ' [bss-b2b-product-parent-price]', currentCartForm);//call function show new
                                    // price
                                }, 1000);
                            });
                        }

                        if (hasSwatchElements.length) {
                            let swatchElements = $(hasSwatchElements).find('.swatch-element');
                            if (swatchElements.length) {
                                swatchElements.on('click', function () {
                                    let currentCartForm = $(productItem);
                                    currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                    setTimeout(function () {
                                        currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                            removeAttr('bss-b2b-product-active');
                                        currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                            hide();
                                        BSS_B2B.cp.changeProductPrice(shopData,
                                            '.' + currentCartForm.attr('class').split(' ')[0] +
                                            ' [bss-b2b-product-parent-price]', currentCartForm);//call function show new
                                        // price
                                    }, 1000);
                                });
                            }

                        }
                    }
                    // fix for southeastedibles2020 (madu)
                    else if (BSS_B2B.storeId === 243) {
                        let selectElement = $(variantProduct);
                        if (selectElement.length) {
                            selectElement.on('change', function () {
                                let currentCartForm = $(productItem);
                                let correctParent = currentCartForm.closest('.product-single__meta');
                                currentCartForm.closest('.product-single__meta').
                                    find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                    hide();
                                setTimeout(function () {
                                    correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                        removeAttr('bss-b2b-product-active');
                                    correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                    BSS_B2B.cp.changeProductPrice(shopData,
                                        '.' + correctParent.attr('class').split(' ')[0] +
                                        ' [bss-b2b-product-parent-price]', currentCartForm);//call function show new
                                    // price
                                }, delayTime);
                            });
                        }
                    }
                    else if (BSS_B2B.storeId === 8505 && !BSS_B2B.page.isProductPage()) {
                        let selectElement = $(variantProduct);
                        if (selectElement.length) {
                            selectElement.on('click', function (e) {
                                let gridItem = e.target.closest('.product-container');
                                if (gridItem) {
                                    let variantItem = gridItem.querySelector('input[name=\'id\']').
                                        getAttribute('value');
                                    let priceItem = gridItem.querySelector('.text-size-medium.text-weight-medium');
                                    if (priceItem) {
                                        priceItem.setAttribute('bss-b2b-variant-id', variantItem);
                                        priceItem.removeAttribute('bss-b2b-product-active');
                                        $('[bss-b2b-product-id]').css('visibility', 'hidden');
                                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                    }
                                }
                            });
                        }
                    }
                    else {
                        let selectElement = $(variantProduct).find('select.single-option-selector-item');

                        if (BSS_B2B.storeId === 2086) {
                            // fix for organicthenewbeauty by vitu
                            selectElement = $(variantProduct).find('.single-option-selector');
                        }
                        if (selectElement.length) {
                            selectElement.on('change', function () {
                                let currentItem = $(this).closest('.product-item-content');

                                if (BSS_B2B.storeId === 2086) {
                                    // fix for organicthenewbeauty by vitu
                                    currentItem = $(this).closest('.quick-shop-style--inline').find('.price');
                                }
                                let currentCartForm = $(currentItem);
                                let correctParent = $(currentItem);
                                currentCartForm.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                setTimeout(function () {
                                    correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').
                                        removeAttr('bss-b2b-product-active');
                                    correctParent.find('[bss-b2b-product-id][bss-b2b-product-parent-price]').hide();
                                    BSS_B2B.cp.changeProductPrice(shopData,
                                        '.' + correctParent.attr('class').split(' ')[0] +
                                        ' [bss-b2b-product-parent-price]', currentCartForm);
                                }, delayTime);
                            });
                        }
                    }
                }
            }
        }
    };

    BSS_B2B.handleChangeQuantityEventFirstTime = function (timeDelayToReCalculate, timeDelayToChangeQuantity) {
        $('[bss-b2b-item-price],' + '[bss-b2b-cart-item-key],' + '[data-cart-item-regular-price], ' +
            +'[data-cart-subtotal],' + '[bss-b2b-ajax-cart-subtotal]' + BSS_B2B.getCartPriceClass('cart_total') +
            BSS_B2B.getCartPriceClass('cart_subtotal') + BSS_B2B.getCartPriceClass('cart_item_regular_price') +
            BSS_B2B.getCartPriceClass('cart_item_original_price')).hide();
        if (![9207, 8572, 12911, 11574, 7323].includes(BSS_B2B.storeId)) {
            $('form[action*="/cart"] input[type="number"], ' + 'form[action*="/cart"] input[data-quantity-input],' +
                'form[action*="/cart"] input[data-cart-item-input-quantity],' +
                'form[action*="/cart"] input.js-qty__input,' + '.cart-wrapper input.quantity-selector__value' +
                BSS_B2B.getCartPriceClass('cart_quantity_input')).prop('disabled', true);
        }

        //fix for sample-shop0621
        if (BSS_B2B.storeId === 3041) {
            $('.cart-wrapper input.quantity-selector__value').prop('disabled', false);
        }

        if (typeof BSS_PO !== 'undefined' && BSS_PO.enable && BSS_PO.enableInCart) {
            BSS_PO.changeQuantity = 0;
            document.querySelectorAll('.bss-qb-cart-subtotal,' + '.bss-qb-price-item,' + '.bss-qb-total-price-item,' +
                '[bss-b2b-item-final-price],' + '[bss-b2b-item-original-price],' + '[bss-b2b-final-line-price],' +
                '[bss-b2b-original-line-price], ' + '[bss-b2b-cart-total-price]').forEach(element => {
                    element.style.opacity = '0';
                });
        }

        if ([437].indexOf(BSS_B2B.storeId) !== -1) {
            let checkoutElement = BSS_B2B.cart.checkoutBtnElement();
            let disableCheckout = true;
            BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
        }

        let isAjaxCart = false;
        if (BSS_B2B.storeId == 6011 && !BSS_B2B.page.isCartPage()) {
            isAjaxCart = true;
        }
        //Fix for dnd-dice
        let checkoutButton = $('.cart-wrapper button.cart-recap__checkout[name="checkout"][type="submit"]');
        if (checkoutButton.length > 0) {
            setTimeout(function () {
                BSS_B2B.cart.fixer(shopData, true);
                BSS_B2B.handleCartCheckoutBtn(shopData);
            }, 4000);
        }
        if ((BSS_B2B.configData || BSS_B2B.plConfigData) &&
            (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
            $('[bss-b2b-item-price],' + '[bss-b2b-cart-item-key],' + '[data-cart-item-regular-price], ' +
                +'[data-cart-subtotal],' + '[bss-b2b-ajax-cart-subtotal]' + BSS_B2B.getCartPriceClass('cart_total') +
                BSS_B2B.getCartPriceClass('cart_subtotal') + BSS_B2B.getCartPriceClass('cart_item_regular_price') +
                BSS_B2B.getCartPriceClass('cart_item_original_price')).hide();
            if (![9207, 8572, 12911, 11574].includes(BSS_B2B.storeId)) {
                $('form[action="/cart"] input[type="number"], ' + 'form[action="/cart"] input[data-quantity-input],' +
                    'form[action="/cart"] input[data-cart-item-input-quantity],' +
                    'form[action="/cart"] input.js-qty__input' + BSS_B2B.getCartPriceClass('cart_quantity_input')).
                    prop('disabled', true);
            }

            setTimeout(function () {
                BSS_B2B.cart.fixer(shopData, true, isAjaxCart);
            }, timeDelayToReCalculate);

            $('[bss-b2b-item-price], ' + '[bss-b2b-cart-item-key], ' + '[bss-b2b-ajax-cart-subtotal] ' +
                BSS_B2B.getCartPriceClass('cart_item_regular_price') +
                BSS_B2B.getCartPriceClass('cart_item_original_price')).fadeIn(timeDelayToChangeQuantity);
        }

        if (BSS_B2B.amoRules && isEnableAMO && BSS_B2B.amoRules.length) {
            setTimeout(function () {
                BSS_B2B.cart.fixer(shopData, true);
            }, timeDelayToReCalculate);
        }

        setTimeout(function () {
            $('form[action*="/cart"] input[type="number"], ' + 'form[action*="/cart"] input[data-quantity-input],' +
                'form[action*="/cart"] input[data-cart-item-input-quantity],' +
                'form[action*="/cart"] input.js-qty__input,' + '.cart-wrapper input.quantity-selector__value' +
                BSS_B2B.getCartPriceClass('cart_quantity_input')).prop('disabled', false);
        }, timeDelayToChangeQuantity);
    };

    BSS_B2B.changeVariantOptionProductPage = function (parentLevel2, cartForm, cartFormClick, variantId = false) {
        if (cartFormClick) {
            const variantElement = cartFormClick.find(`select[name="id"], input[name="id"], select[data-variant-input], .option-lists`);
            if (variantElement) {
                variantId = variantElement.val() || variantElement.attr('value');
            }
        }
        let priceInCartForm = $(parentLevel2).find('' + '[bss-b2b-product-id][bss-b2b-product-parent-price]');
        // fix for magiclaze by vitu-2669
        if (BSS_B2B.storeId === 324 || BSS_B2B.storeId === 2669) {
            priceInCartForm = $(parentLevel2).
                find('' + '[bss-b2b-product-id][bss-b2b-product-parent-price],' + '[data-money-convertible]');
        }

        if ([778, 9363].includes(BSS_B2B.storeId)) {
            priceInCartForm = $(parentLevel2).parent().find('' + '[bss-b2b-product-id][bss-b2b-product-parent-price]');
        }

        if (BSS_B2B.storeId === 1283) {
            priceInCartForm = $(parentLevel2).
                closest('.product_single_detail_section').
                find('[bss-b2b-product-id][bss-b2b-product-price]');
        }

        if (BSS_B2B.storeId === 8337) {
            priceInCartForm = $(parentLevel2).find('[bss-b2b-product-id][bss-b2b-product-price]');
        }

        // fix for magiclaze by vitu
        if (BSS_B2B.storeId === 2669) {
            priceInCartForm = $(parentLevel2).find('[data-money-convertible]');
        }
        // fix for baltarugs by CuongNM
        if (BSS_B2B.storeId === 1056) {
            priceInCartForm = $(parentLevel2).
                parent().
                parent().
                prev().
                prev().
                find('[bss-b2b-product-id][bss-b2b-product-parent-price]');
        }
        // fix for ciaobrow by DangNM
        if ([2896, 2589, 4257].indexOf(BSS_B2B.storeId) !== -1) {
            priceInCartForm = $(parentLevel2).
                find('.product-page-info__price .price[data-js-product-price]:not([bss-ltsp-active]) span,' +
                    '.ProductMeta__PriceList .ProductItem__Price:not(.Price--highlight):not(.Price--compareAt)');
            if (!priceInCartForm.length && BSS_B2B.storeId === 2589) {
                priceInCartForm = $(parentLevel2).closest('.product-page__main').find('.product-page-info__price');
            }
            if (priceInCartForm) {
                priceInCartForm.attr('bss-b2b-product-id', ShopifyAnalytics.meta.product.id);
                priceInCartForm.attr('bss-b2b-product-price', '');
                priceInCartForm.parent().attr('bss-b2b-product-parent-price', '');
                priceInCartForm.parent().removeAttr('bss-b2b-product-price');
                priceInCartForm.parent().removeAttr('bss-b2b-product-id');
            }
        }
        if (priceInCartForm.length === 0) {
            parentLevel2 = $(parentLevel2).parent().parent();
            priceInCartForm = parentLevel2.find('' + '[bss-b2b-product-id][bss-b2b-product-parent-price]');
        }
        if (BSS_B2B.storeId !== 3787) {
            priceInCartForm.hide();
            priceInCartForm.css('visibility', 'hidden');
        }
        let delayTime = 200;

        if ([8356, 7995].includes(BSS_B2B.storeId)) {
            delayTime = 500;
        }

        let productSelectVariantDelayTime = BSS_B2B.getCssSelector('product_time_delay_change_variant');
        if (productSelectVariantDelayTime !== '' && !isNaN(productSelectVariantDelayTime)) {
            delayTime = parseInt(productSelectVariantDelayTime);
        }
        if ([621].includes(BSS_B2B.storeId)) {
            delayTime = 800;
        }
        if ([14962, 15884].includes(BSS_B2B.storeId)) variantId = new URLSearchParams(new URL(window.location.href).search).get('variant');
        setTimeout(function () {
            if (BSS_B2B.storeId === 9041) {
                priceInCartForm.find('' + '[bss-b2b-product-id][bss-b2b-product-price]').
                    removeAttr('bss-b2b-product-active');
            }
            priceInCartForm.removeAttr('bss-b2b-product-active');
            if ([778, 1283, 2589, 6590, 8356, 9041, 8337, 9363, 10128, 10748, 11074, 1056].indexOf(
                BSS_B2B.storeId) !== -1) {
                BSS_B2B.cp.changeProductPrice(shopData, false, false);
            }
            else if ([1138, 1123, 3512, 3787, 2627, 3223, 7584].indexOf(BSS_B2B.storeId) !== -1) {
                // fix for studyphones by Leorio
                $('[bss-b2b-product-id][bss-b2b-product-parent-price]').removeAttr('bss-b2b-product-active');
                $('[bss-b2b-product-id][bss-b2b-product-price]').removeAttr('bss-b2b-product-active');
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }
            else if (BSS_B2B.storeId === 4101 || BSS_B2B.storeId === 4094) {
                BSS_B2B.cp.changeProductPrice(shopData,
                    '.' + parentLevel2.attr('class').split(' ')[0] + ' [bss-b2b-product-parent-price]', cartForm);
            }
            else if (BSS_B2B.storeId === 4884) {
                BSS_B2B.cp.changeProductPrice(shopData,
                    parentLevel2.attr('class').split(' ').join('.') + ' [bss-b2b-product-parent-price]', false);
            }
            else if (BSS_B2B.storeId === 4999) {
                setTimeout(function () {
                    BSS_B2B.cp.changeProductPrice(shopData,
                        '.' + parentLevel2.attr('class').split(' ')[0] + ' [bss-b2b-product-parent-price]', false);
                }, 1200);
            }
            else if (BSS_B2B.storeId === 9364) {
                BSS_B2B.cp.changeProductPrice(shopData,
                    '.' + parentLevel2.attr('class').trim().split(/\s+/)[0] + ' [bss-b2b-product-parent-price]', false);
            }
            else if (BSS_B2B.storeId === 4945) {
                //fix for adertek.com
                BSS_B2B.cp.changeProductPrice(shopData, '[bss-b2b-product-parent-price]', false);
            }
            else if ([537, 4927].includes(BSS_B2B.storeId)) {
                // do nothing
            }
            else if (BSS_B2B.storeId === 6579) {
                let variantId = $('variant-selection.variant-selection').attr('variant');
                BSS_B2B.cp.changeProductPrice(shopData, '.price.product__price', false, false, variantId);
            }
            else if (BSS_B2B.storeId === 2610) { //For stores just need to re-call BSS_B2B.cp.changeProductPrice
                BSS_B2B.cp.changeProductPrice(shopData, false, false);
            }
            else if (BSS_B2B.storeId === 7795) {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, '.productView-price .bss-b2b-custom-price ',
                        $('.productView-product.clearfix'), false);
                }, 1000);
            }
            else if (BSS_B2B.storeId === 9461) {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, '.productView-product ', $('.productView-product'), false);
                }, 1000);
            }
            else if ([8572, 9207].includes(BSS_B2B.storeId)) {
                BSS_B2B.cp.changeProductPrice(shopData, false, cartForm, false);
            }
            else if (BSS_B2B.storeId === 11968) {
                BSS_B2B.cp.changeProductPrice(shopData,
                    '.' + parentLevel2.attr('class').split(' ')[0] + ' [bss-b2b-product-parent-price]', false, false, window.location.href.replace(/\D/g, ''));
            }
            else if (BSS_B2B.storeId === 3351) {
                BSS_B2B.cp.changeProductPrice(shopData, '.modal_price.subtitle', false);
            } 
            else if ([621, 14833].includes(BSS_B2B.storeId)) {
                variantId = new URLSearchParams(new URL(window.location.href).search).get('variant');
                BSS_B2B.cp.changeProductPrice(shopData,
                    '.' + parentLevel2.attr('class').split(' ')[0] + ' [bss-b2b-product-parent-price]', false, false, variantId);
            }
            else {
                if(BSS_B2B.storeId === 6699) {
                    shopData = JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML);
                }
                if (!parentLevel2.attr('class')) {
                    parentLevel2.addClass('bss-b2b-product-parentLevel2');
                }
                BSS_B2B.cp.changeProductPrice(shopData,
                    '.' + parentLevel2.attr('class').split(' ')[0] + ' [bss-b2b-product-parent-price]', false, false, variantId);
            }
        }, delayTime);
        setTimeout(function () {
            BSS_B2B.makeCloneBuyItNow(cartForm);
        }, delayTime * 2);

        // fix for https://screenshelf.ie/ by Tuli and Leorio
        if (BSS_B2B.storeId === 918 || BSS_B2B.storeId === 3918) {
            setTimeout(function () {
                let priceElem = $('.tot_price');
                if (priceElem.length) {
                    let newPrice = priceElem.html();
                    let newPriceFormat = newPrice.replace(/^\D+/g, '');

                    BSS_B2B.printSaveTo(shopData, newPriceFormat);
                }
            }, delayTime * 5);
        }
    };
}

function calculateAndShowDiscountPrice(
    shopData, price, priceJ, variant, productId, productPrices, priceElement, cartFormElement, currentItemPrices,
    unitPriceElement, discountType, discountValueOfRule, realDiscountValue, lowestPrice, lowestPriceElement,
    lowestPriceHtmlArr, highestPrice, highestPriceElement, highestPriceHtmlArr, buttonPriceElement, variantIdForVat,
    appliedDisplayRule, appliedProduct, isQuickView, isProductPage, isEnableMC, currentProductVariant) {

    let reDefinedPriceElement;
    let variantPriceObject = {};
    let variantPriceInfo = [];
    if (BSS_B2B.integrate.subscription.subPriceElement) {
        if (priceJ.isFeatured) { // main product
            price = BSS_B2B.integrate.subscription.getSubPrice();
            const event = new Event("b2b_sub_integrate_main_product_change");
            event.cpApplied = priceJ;
            document.dispatchEvent(event);
        }
    }
    price = BSS_B2B.getModifiedPrice(price, discountType, discountValueOfRule);
    // STP-12
    if (BSS_B2B.storeId === 6699 && BSS_B2B.page.isProductPage() && document.querySelector('#typeProd')) {
        let {
            newPrice, newCurrentItemPrices,
        } = window.BSS_B2B.executeFilter({ tag: 'price_product_page', storeId: 6699, val: null, price, currentItemPrices, shopData });
        price = newPrice;
        currentItemPrices = newCurrentItemPrices;
    }

    if (BSS_B2B.storeId === 11067) {
        price = window.BSS_B2B.executeFilter({ tag: 'price_feature_product', storeId: 11067, val: null, price, discountType, discountValueOfRule, highestPrice })
    }

    if (BSS_B2B.storeId === 15968) {
        window.BSS_B2B.executeAction({ tag: 'customize_price', storeId: 15968, BSS_B2B, lowestPrice, highestPrice, discountType, discountValueOfRule });
    }

    if (BSS_B2B.storeId === 1138) {
        price = window.BSS_B2B.executeAction({ tag: 'change_quantity', storeId: 1138, currentPrice: price, priceElement, isQuickView });
    }
    else {
        window.BSS_B2B.executeAction({ tag: 'customize_total_price', storeId: 13569, elementCheck: '.productView-details', shopData, price, isProductPage });
        window.BSS_B2B.executeAction({ tag: 'change_quantity', storeId: 13871, shopData, price, isQuickView });
        window.BSS_B2B.executeAction({ tag: 'change_quantity', storeId: 13344, shopData, price, isQuickView });
        if (BSS_B2B.integrate.gemPages.isGemPageSelector(priceElement, cartFormElement)) {
            price = BSS_B2B.integrate.gemPages.getTotalProductPrice(price, cartFormElement);
        }

        if (BSS_B2B.storeId === 1548) {
            let taxRateElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-custom-taxrate]');
            if (taxRateElement.length) {
                let taxRate = taxRateElement.attr('bss-b2b-custom-taxrate');
                taxRateElement.html(BSS_B2B.formatMoney(price * taxRate));
            }
        }
        else if (BSS_B2B.storeId === 2709) {
            priceElement.html('</br> Private Club: ' + BSS_B2B.formatMoney(price));
        }
        else if (BSS_B2B.storeId === 3441) {
            let productPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
            productPriceElement.html(BSS_B2B.formatMoney(price));
            productPriceElement.css('color', '#d21625');
        }
        else if ([3893, 3955].indexOf(BSS_B2B.storeId) !== -1) {
            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').html(BSS_B2B.formatMoney(price));
        }
        else {
            if (BSS_B2B.storeId === 1508) {
                if (price % 0.5 === 0) {
                    price = Math.round(price);
                }
            }
            if (BSS_B2B.storeId === 1934) {
                price = Math.round(price);
            }
            if (BSS_B2B.storeId === 2254) {
                if ($(priceElement).find('[data-compare-price]').length &&
                    $(priceElement).find('[bss-b2b-product-price][bss-b2b-product-id]').length) {
                    priceElement = $(priceElement).find('[bss-b2b-product-price][bss-b2b-product-id]');
                    $('.product__unit-price').hide();
                }
            }
            let cardElementVariant = $(
                '[bss-b2b-product-id="' + productId + '"][bss-b2b-card-information]'
            )
            if (cardElementVariant && cardElementVariant.length) {
                // region Redefine price element
                /* Old price element just contain product id, element also need variant id to check since every product have variants of responseProduct although it might have none option (variant) in Shopify admin */
                currentProductVariant.forEach((variant) => {
                    if(priceJ.listVariants && priceJ.listVariants.length){
                        if(priceJ.listVariants.includes(variant.id.toString())){
                            for (let k = 0; k < priceJ.listVariants.length; k++) {
                                if (priceJ.listVariants[k] === variant.id.toString()) {
                                    reDefinedPriceElement = $(
                                        '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price][bss-b2b-variant-id="' + priceJ.listVariants[k] + '"],'
                                        + '[bss-b2b-product-id="' + productId + '"][bss-b2b-card-information][bss-b2b-variant-id="' + priceJ.listVariants[k] + '"]'
                                    );
                                    let newProductVariantPrice = BSS_B2B.getModifiedPrice(variant.price, discountType, discountValueOfRule);
                                    reDefinedPriceElement.html(BSS_B2B.formatMoney(newProductVariantPrice));
                                }
                            }
                        }
                       
                    } else {
                        reDefinedPriceElement = $(
                            '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price][bss-b2b-variant-id="' + variant.id + '"],'
                            + '[bss-b2b-product-id="' + productId + '"][bss-b2b-card-information][bss-b2b-variant-id="' + variant.id + '"]'
                        );
                        let newProductVariantPrice = BSS_B2B.getModifiedPrice(variant.price, discountType, discountValueOfRule);
                        reDefinedPriceElement.html(BSS_B2B.formatMoney(newProductVariantPrice));
                    }
                })
                // endregion
                currentProductVariant.forEach((variant) => {
                    if(priceJ.listVariants && priceJ.listVariants.length){
                        if(priceJ.listVariants.includes(variant.id.toString())){
                            for (let k = 0; k < priceJ.listVariants.length; k++) {
                                if (priceJ.listVariants[k] === variant.id.toString()) {
                                    variantPriceObject = {
                                        variantId: variant.id,
                                        price: BSS_B2B.getModifiedPrice(variant.price, discountType, discountValueOfRule),
                                        comparePrice : variant.compare_at_price,
                                        originPrice : variant.price
                                    }
                                    variantPriceInfo.push(variantPriceObject);
                                }
                            }
                        } else {
                            variantPriceObject = {
                                variantId: variant.id,
                                price: variant.price,
                                comparePrice : variant.compare_at_price,
                                originPrice : variant.price
                            }
                            variantPriceInfo.push(variantPriceObject);
                        } 
                    } else {
                        variantPriceObject = {
                            variantId: variant.id,
                            price: BSS_B2B.getModifiedPrice(variant.price, discountType, discountValueOfRule),
                            comparePrice : variant.compare_at_price,
                            originPrice : variant.price
                        }
                        variantPriceInfo.push(variantPriceObject);
                    }
                })
            } else {
                priceElement.html(BSS_B2B.formatMoney(price));
            }

            if (BSS_B2B.storeId === 11420) {
                if (BSS_B2B.page.isProductPage()) {
                    priceElement = $(`.price.price--large[bss-b2b-product-id="${productId}"], .price.bss-b2b-customer[bss-b2b-product-id="${productId}"]`);
                }

                if (BSS_B2B.page.isHomePage()) {
                    priceElement = $(`.price.bss-b2b-customer[bss-b2b-product-id="${productId}"]`);
                }
            }

            if (BSS_B2B.storeId === 7676) {
                if (BSS_B2B.page.isProductPage()) {
                    priceElement = $(`.product-pricing .price__current[bss-b2b-product-id="${productId}"]`);
                }
            }

            if (BSS_B2B.storeId === 8553) {
                const discountElement = priceElement.closest('.product__price-container').find('.price__savings');
                if (discountElement) {
                    discountElement.remove();
                }
            }

            if (BSS_B2B.storeId === 2259) {
                const discountElement = priceElement.closest('.product__price-savings, .grid-product__price--original');
                const productSaving = priceElement.closest('.grid-item__content').find('.grid-product__price--savings');
                if (discountElement && discountElement.length) {
                    discountElement.remove();
                }
                if (productSaving && productSaving.length) {
                    productSaving.remove();
                }
            }
            priceElement.html(BSS_B2B.formatMoney(price));
            //custom store display both price and discount value % by PhuongKD
            if ([11776].includes(BSS_B2B.storeId) && discountType === 2) {
                if (BSS_B2B.page.isProductPage()) {
                    priceElement.append(`&nbsp;${discountValueOfRule}%&nbsp;`);
                }
                if (BSS_B2B.page.isCollectionPage()) {
                    const convertPriceElement = Array.from(priceElement);
                    setTimeout(() => {
                        convertPriceElement.forEach(
                            v => $(v).find('span').append(`&nbsp;${discountValueOfRule}%&nbsp;`));
                    }, 30);
                }
            }
            //custom store display text price cp by PhuongKD
            if ([12385].includes(BSS_B2B.storeId)) {
                if (BSS_B2B.page.isProductPage()) {
                    const convertPriceElement = Array.from(priceElement);
                    convertPriceElement.forEach(v => {
                        const textCustom = `<span bss-custom-cp-product-id=${productId}>Wholesale Price </span>`;
                        $(v).prepend(textCustom);
                    });
                }
            }
        }
        BSS_B2B.showUnitPrice(unitPriceElement, currentItemPrices.variants, productId, price,
            productPrices[productId].price, variant);
    }

    let checkMCInitInterval = setInterval(() => {
        if (BSS_B2B.MC && BSS_B2B.MC.preConvertCurrency && typeof BSS_B2B.MC.preConvertCurrency === 'function' &&
            isEnableMC) {
            if ([5986, 16067].includes(BSS_B2B.storeId)) {
                let sessionCurrencyCode = window.localStorage.getItem('currentCurrency');
                let sessionCurrencyFormat = window.localStorage.getItem('currentCurrencyFormat');
                BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
            } else {
                let priceModifiedByCurrencyApp = BSS_B2B.MC.convertPriceByMc(price, priceElement);
                if (priceElement.length === 0 && BSS_B2B.storeId === 3879) {
                    priceElement = $('form[action="/cart/add"] .bss-b2b-product-vat');
                }
                if (priceElement) {
                    priceElement.html(priceModifiedByCurrencyApp);
                    clearInterval(checkMCInitInterval);
                }
            }
        }
    }, 500);
    setTimeout(() => {
        clearInterval(checkMCInitInterval);
    }, 5000);

    showLowestPrice(discountType, discountValueOfRule, realDiscountValue, lowestPriceElement, lowestPriceHtmlArr,
        lowestPrice, isEnableMC);

    showHighestPrice(discountType, discountValueOfRule, realDiscountValue, highestPriceElement, highestPriceHtmlArr,
        highestPrice);

    showPriceOnSale(discountType, discountValueOfRule, productId, realDiscountValue, priceJ);

    window.BSS_B2B.executeAction({
        tag: 'price_feature_product',
        storeId: 14274,
        discountType, discountValueOfRule,
        lowestPriceElement, lowestPriceHtmlArr, lowestPrice,
        highestPriceElement, highestPriceHtmlArr, highestPrice
    })
    if ([14113, 14886].includes(BSS_B2B.storeId)) {
        window.BSS_B2B.executeAction({
            tag: 'show_custom_CP',
            storeId: false,
            BSS_B2B, priceElement: lowestPriceElement, originPrice: currentItemPrices.price,
            finalPrice: BSS_B2B.getModifiedPrice(lowestPrice, discountType, discountValueOfRule),
            shopData, appliedProduct
        })
    }
    if (!(BSS_B2B.storeId == 8337 && $('#ShopNowContainer #ProductPrice').length)) {
        if (!variantIdForVat) {
            variantIdForVat = priceJ.variants;
        }
        changePriceWhenUseCPAndTD(productId, variantIdForVat, shopData, price, appliedDisplayRule, isProductPage,
            isQuickView, priceJ,variantPriceInfo);
    }

    let productAfterUseCP = {
        id: productId, price: price, rule_name: priceJ.name, product_name: priceJ.product_name, variantId: variant
    };

    if (BSS_B2B.storeId === 10868) {
        productAfterUseCP = {
            ...productAfterUseCP, discount_type: priceJ.discount_type, discount_value: priceJ.value,
        };
    }

    if (BSS_B2B.cp.productMapAfterUseCP && BSS_B2B.storeId === 10868) {
        if (!BSS_B2B.cp.productMapAfterUseCP.has(productAfterUseCP.id)) {
            BSS_B2B.cp.productAfterUseCP.push(productAfterUseCP);
            BSS_B2B.cp.productMapAfterUseCP.set(productAfterUseCP.id, productAfterUseCP);
        }
    }
    else {
        BSS_B2B.cp.productAfterUseCP.push(productAfterUseCP);
    }

    //fix change quantity quick view for driftparadiz store by trung DD 
    if (BSS_B2B.page.isCollectionPage() && BSS_B2B.storeId === 10623) {
        if (buttonPriceElement.length && isQuickView) {
            const quantityQuickView = document.querySelector('#quantity');
            if (quantityQuickView) {
                quantityQuickView.onchange = function () {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false, true);
                };
                const quantity = parseInt(quantityQuickView.value);
                buttonPriceElement.html(BSS_B2B.formatMoney(price * quantity));
            }

        }
    }

    window.BSS_B2B.executeAction({ tag: 'change_quantity_product_page', storeId: 13943, buttonPriceElement, price, shopData })
    window.BSS_B2B.executeAction({ tag: 'subtotal_product_page', storeId: 13794, price, productId, shopData })

    if (BSS_B2B.storeId === 994 && buttonPriceElement.length && isQuickView) {
        const quantityQuickView = document.querySelector('.quantity_selector .quantity__input');
        if (quantityQuickView) {
            quantityQuickView.onchange = function () {
                BSS_B2B.cp.changeProductPrice(shopData, false, false, true);
            };
            const quantity = parseInt(quantityQuickView.value);
            buttonPriceElement.html(BSS_B2B.formatMoney(price * quantity));
        }
    }

    // Fix for price in add to cart button by DuongHX
    if (buttonPriceElement.length && BSS_B2B.page.isProductPage()) {
        let quantity = $(
            '.quantity__input,form[action*="/cart/add"] .qty-group input, .quantity-part input.quantity[name="quantity"], #quantity').
            val();

        if (BSS_B2B.storeId === 7795 && isQuickView) {
            quantity = $('.productView.quickView .quantity_selector .form-input.quantity__input').val();
        }
        buttonPriceElement.html(BSS_B2B.formatMoney(price * quantity));
    }
    else if (BSS_B2B.storeId === 9726) {
        let quantity = buttonPriceElement.closest('.add-to-cart-form').find('.quantity-selector #Quantity').val();
        buttonPriceElement.val('Add To Cart • ' + BSS_B2B.formatMoney(price * quantity));
    }

    // Handle CP Settingset
    if (BSS_B2B.cpSettings) {
        if (BSS_B2B.storeId === 3787) {
            // This store doesn't use cp settings
        }
        else {
            if (BSS_B2B.storeId === 7332 && BSS_B2B.page.isCollectionPage()) priceJ.variantSelected = variant;
            BSS_B2B.changeCPSetting(currentItemPrices, price, priceElement, productId, variant, isEnableMC,
                discountType, discountValueOfRule, isQuickView, shopData, appliedProduct, priceJ);
            if(BSS_B2B.storeId === 9943){
                let priceCPCustom =  document.querySelectorAll('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]')
                if (priceCPCustom && priceCPCustom.length) {
                    priceCPCustom.forEach((e)=>{
                        let priceCompare = e.querySelector('.bss-b2b-customized-original-price, .bss-b2b-customized-compare-at-price')
                        if (priceCompare && !priceCompare.innerHTML.includes("RRP:")) {
                         e.appendChild(priceCompare) 
                            priceCompare.innerHTML = "RRP:" + priceCompare.innerHTML
                        }
                    })
                     
                }
            }
            const event = new Event('bss_b2b_doneCheckCp', { bubbles: true });
            document.dispatchEvent(event);
        }
    }

    BSS_B2B.fix.cp.fixShowPrice(price, variant, productId, productPrices, priceElement, currentItemPrices);
}

function showLowestPrice(
    discountType, discountValueOfRule, realDiscountValue, lowestPriceElement, lowestPriceHtmlArr, lowestPrice,
    isEnableMC) {
    if (BSS_B2B.storeId === 181) {
        // This theme doesn't use the lowest price, but it contains "min_price"
        // attribute This affects to child elements of price wrapper, lost all
        // event listener
    }
    else {
        if (lowestPriceElement.length > 0 && lowestPriceHtmlArr.length > 0) {
            let newLowestPrice = BSS_B2B.getModifiedPrice(lowestPrice, discountType, discountValueOfRule);

            let supNewPrice = BSS_B2B.formatMoney(newLowestPrice).
                replace('.', '<sup>').
                replace(',', '<sup>').
                concat('</sup>');
            let supPrice = BSS_B2B.formatMoney(lowestPrice).
                replace('.', '<sup>').
                replace(',', '<sup>').
                concat('</sup>');

            if (lowestPriceHtmlArr.includes(BSS_B2B.formatMoney(lowestPrice)) ||
                BSS_B2B.formatMoney(lowestPrice).includes(lowestPriceHtmlArr)) {
                lowestPriceHtmlArr = lowestPriceHtmlArr.replace(BSS_B2B.formatMoney(lowestPrice),
                    BSS_B2B.formatMoney(newLowestPrice));
                if (BSS_B2B.formatMoney(lowestPrice).includes(lowestPriceHtmlArr)) {
                    lowestPriceHtmlArr = BSS_B2B.formatMoney(newLowestPrice);
                }
                // fix for www.hps1source.com by hoaduong
                if (BSS_B2B.storeId === 4730) {
                    lowestPriceHtmlArr = lowestPriceHtmlArr.replace(supPrice, supNewPrice);
                }
            }
            else if (discountType === 0) {
                let amountNumber = lowestPriceHtmlArr.replace(/\D/g, '');
                let newLowestPriceRegex = (BSS_B2B.formatMoney(newLowestPrice)).replace(/[^\d.,]/g, '');
                lowestPriceHtmlArr = lowestPriceHtmlArr.replace(amountNumber, newLowestPriceRegex);
            }
            if (isEnableMC) {
                $.each(lowestPriceElement, function (index, priceElem) {
                    let priceElement = $(priceElem);
                    if (priceElement.children().length > 0) {
                        return true;
                    }
                    let priceModifiedByCurrencyApp = BSS_B2B.MC.convertPriceByMc(newLowestPrice, priceElement);
                    lowestPriceHtmlArr = lowestPriceHtmlArr.replace(BSS_B2B.formatMoney(newLowestPrice),
                        priceModifiedByCurrencyApp);
                    lowestPriceHtmlArr = lowestPriceHtmlArr.replace('bss-b2b-product-lowest-price',
                        'bss-shop-base-currency="' + newLowestPrice + '" bss-b2b-product-lowest-price');
                });
            }
            lowestPriceElement.html(lowestPriceHtmlArr);
        }
    }
}

function showHighestPrice(
    discountType, discountValueOfRule, realDiscountValue, highestPriceElement, highestPriceHtmlArr, highestPrice) {
    // Handle max price
    if (highestPriceElement.length > 0 && highestPriceHtmlArr.length > 0) {
        let newHighestPrice = BSS_B2B.getModifiedPrice(highestPrice, discountType, discountValueOfRule);

        if (highestPriceHtmlArr.includes(BSS_B2B.formatMoney(highestPrice)) ||
            BSS_B2B.formatMoney(highestPrice).includes(highestPriceHtmlArr)) {
            highestPriceHtmlArr = highestPriceHtmlArr.replace(BSS_B2B.formatMoney(highestPrice),
                BSS_B2B.formatMoney(newHighestPrice));
            if (BSS_B2B.formatMoney(highestPrice).includes(highestPriceHtmlArr)) {
                highestPriceHtmlArr = BSS_B2B.formatMoney(newHighestPrice);
            }
        }
        else if (discountType === 0) {
            let amountNumber = highestPriceHtmlArr.replace(/\D/g, '');
            highestPriceHtmlArr = highestPriceHtmlArr.replace(amountNumber, newHighestPrice / 100);
        }
        highestPriceElement.html(highestPriceHtmlArr);
    }
}

function showPriceOnSale(discountType, discountValueOfRule, productId, realDiscountValue, priceJ) {
    // on sale
    if ([1, 2].indexOf(discountType) !== -1) {
        let salePriceElement = $('.bss-b2b--on-sale[on-sale-product-id="' + productId + '"]');
        if (salePriceElement.length) {
            let labelName = 'Save ';
            let labelColor = '#ee0000';
            if (priceJ.name.match(/\{([^}]+)\}/)) {
                labelName = priceJ.name.match(/\{([^}]+)\}/)[1] + ' ';
            }
            if (priceJ.name.match(/\[([^}]+)\]/)) {
                labelColor = priceJ.name.match(/\[([^}]+)\]/)[1];
            }
            let htmlContent;
            if (discountType === 1) {
                htmlContent = labelName + BSS_B2B.formatMoney(realDiscountValue);
            }
            if (discountType === 2) {
                htmlContent = labelName + discountValueOfRule + '%';
            }
            salePriceElement.css('background', labelColor).html(htmlContent).fadeIn(300);
        }
    }
}

function changePriceWhenUseCPAndTD(
    productId, variantIdForVat, shopData, price, appliedDisplayRule, isProductPage, isQuickView, priceJ,variantPriceInfo) {
    if (isProductPage && (typeof bssB2BProduct !== 'undefined') && bssB2BProduct) {
        if (bssB2BProduct.id === productId) {
            if (BSS_B2B.storeId === 2884) {
                $('#bss-b2b-tax-inc-excl').remove();
            }
            else if (BSS_B2B.storeId === 7321) {
                document.addEventListener('bss_b2b_doneCheckCp', function () {
                    $('.f-price-item.f-price-item--regular[bss-b2b-product-id][is_product_page="true"][bss-b2b-product-price]').
                        remove();
                    $('[bss-b2b-final-line-price]').remove();
                    $('[bss-b2b-cart-total-price]').remove();
                });
            }
            tax_default.a.bssB2BChangeVatPrice(variantIdForVat, shopData, price, priceJ);
        }
        tax_default.a.bssB2BChangeCollectionItemVatPrice(productId, shopData, price, appliedDisplayRule, priceJ,variantPriceInfo);
    }
    else {
        if (BSS_B2B.storeId === 6579 && isQuickView) {
            tax_default.a.bssB2BChangeVatPrice(variantIdForVat, shopData, price);
        }
        else {
            tax_default.a.bssB2BChangeCollectionItemVatPrice(productId, shopData, price, appliedDisplayRule, priceJ,variantPriceInfo);
        }
    }

    if (BSS_B2B.storeId === 5880 && isQuickView && appliedDisplayRule) {
        variantIdForVat = document.querySelector(
            'quick-add-modal[open] form[action*="/cart/add"] input[name="id"]').value;
        tax_default.a.bssB2BChangeVatPrice(variantIdForVat, shopData, price);
    }
    if (BSS_B2B.storeId === 5302 && shopData.quickview && appliedDisplayRule) {
        tax_default.a.bssB2BChangeVatPrice(variantIdForVat, shopData, price);
    }
}

// CONCATENATED MODULE: ./js/src/cp/change-cp-setting.js



function changeCPSetting($, BSS_B2B) {
    const customForStore = [
        4608, 4272, 4522, 4945, 5885, 4927, 5912, 6717, 2933, 6954, 6363, 8014, 5065, 8356, 3740, 541,
    ];

    BSS_B2B.createComparePriceElement = function(
        elementTag,
        className,
        variantId,
        productId,
        price,
        textDecorationCss,
        marginCss,
        colorCss,
    ) {
        let newComparePriceElem = document.createElement(elementTag);
        newComparePriceElem.classList.add(className);
        newComparePriceElem.setAttribute('data-variant-id', variantId);
        newComparePriceElem.setAttribute('data-product-id', productId);
        // fix padelutstyr by dongnv
        if ([2627, 5241, 5255, 5273, 5749, 4972, 1651, 15246].indexOf(BSS_B2B.storeId) !== -1) {
            newComparePriceElem.innerHTML = BSS_B2B.formatMoney(price);
        }
        else if ([4856, 6289, 6412, 6366, 6365].includes(BSS_B2B.storeId)) {
            // customize compare price  nimbus-focal by DongNV
            newComparePriceElem.innerText = '(' + BSS_B2B.formatMoney(price) + ')';
            textDecorationCss = 'none';
        }
        else if (BSS_B2B.storeId === 6652) {
            newComparePriceElem.innerText = BSS_B2B.formatMoney(price);
            textDecorationCss = 'none';
        }
        else if (BSS_B2B.storeId === 8258) {
            // Fix for house-of-bikes-no by Devlin
            newComparePriceElem.innerText = BSS_B2B.formatMoney(price).replace("</span>", "");
        }
        else {
            newComparePriceElem.innerText = BSS_B2B.formatMoney(price);
        }
        newComparePriceElem.style.textDecoration = textDecorationCss;
        newComparePriceElem.style.margin = marginCss;
        newComparePriceElem.style.color = colorCss;
        return newComparePriceElem;
    };

    BSS_B2B.createCompareElementVat = function(
        productVatElement, shopData, appliedDisplayRule, appliedTax, comparePrice, itemTaxAble, parentClassName,
        productId, cartItemKey) {
        let includedVatText = $('[data-included-vat-text]').attr('data-included-vat-text');
        let excludedVatText = $('[data-excluded-vat-text]').attr('data-excluded-vat-text');
        excludedVatText = excludedVatText.replace('|', '');
        let incTextColor = appliedDisplayRule.inc_text_color;
        let excTextColor = appliedDisplayRule.exc_text_color;
        let newCompareElemParent = document.createElement('span');
        newCompareElemParent.classList.add(parentClassName);
        if (productId) {
            newCompareElemParent.setAttribute('data-product-id', productId);
        }
        if (cartItemKey) {
            newCompareElemParent.setAttribute('data-cart-vat-item-key', cartItemKey);
        }
        let newCompareElemNoVat = document.createElement('span');
        newCompareElemNoVat.classList.add(`${parentClassName}-no-vat`);
        newCompareElemNoVat.style.color = excTextColor;
        let newCompareElemHasVat = document.createElement('span');
        newCompareElemHasVat.classList.add(`${parentClassName}-has-vat`);
        newCompareElemHasVat.style.color = incTextColor;

        let ratio = appliedDisplayRule.ratio_type;
        let fontSizeOfPriceVatEle = tax_default.a.changeFontSizeOfPriceVatEle(ratio);

        newCompareElemHasVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceHasVat;
        newCompareElemNoVat.style['font-size'] = fontSizeOfPriceVatEle.fontSizePriceNoVat;

        let priceElementIncVat = document.createElement('span');
        let priceElementExcVat = document.createElement('span');
        let delimiterElement = document.createElement('span');
        delimiterElement.innerHTML = ' | ';

        if (shopData.taxes_included) {
            if (itemTaxAble) {
                priceElementExcVat.innerHTML = BSS_B2B.formatMoney(comparePrice * (1 / (1 + appliedTax))) + ' ' +
                    excludedVatText;
                priceElementIncVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + includedVatText;
            }
            else {
                priceElementExcVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + excludedVatText;
                priceElementIncVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + includedVatText;
            }
        }
        else {
            if (itemTaxAble) {
                priceElementExcVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + excludedVatText;
                priceElementIncVat.innerHTML = BSS_B2B.formatMoney(comparePrice * (1 + appliedTax)) + ' ' +
                    includedVatText;
            }
            else {
                priceElementExcVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + excludedVatText;
                priceElementIncVat.innerHTML = BSS_B2B.formatMoney(comparePrice) + ' ' + includedVatText;
            }
        }

        if (BSS_B2B.storeId === 9396 && !BSS_B2B.page.isProductPage() && !BSS_B2B.page.isCartPage()) {
            priceElementExcVat.innerHTML = 'ab ' + priceElementExcVat.textContent;
        }

        switch (appliedDisplayRule.display_price_type) {
            case 0:
                newCompareElemNoVat.appendChild(priceElementExcVat);
                newCompareElemNoVat.appendChild(delimiterElement);
                newCompareElemHasVat.appendChild(priceElementIncVat);
                newCompareElemNoVat.style.textDecoration = 'line-through';
                newCompareElemHasVat.style.textDecoration = 'line-through';
                break;
            case 1:
                newCompareElemNoVat.style.display = 'none';
                priceElementIncVat.style.textDecoration = 'line-through';
                newCompareElemHasVat.appendChild(priceElementIncVat);
                newCompareElemHasVat.appendChild(delimiterElement);
                productVatElement.css('display', 'inline');
                break;
            case 2:
                newCompareElemHasVat.style.display = 'none';
                priceElementExcVat.style.textDecoration = 'line-through';
                newCompareElemNoVat.appendChild(priceElementExcVat);
                newCompareElemNoVat.appendChild(delimiterElement);
                productVatElement.css('display', 'inline');
                break;
        }

        newCompareElemParent.appendChild(newCompareElemNoVat);
        newCompareElemParent.appendChild(newCompareElemHasVat);
        return newCompareElemParent;
    };

    BSS_B2B.changeCPSetting = function(
        customPrice,
        finalPrice,
        priceElement,
        productId,
        variant,
        isEnableMC,
        discountType,
        discountValue,
        isQuickView,
        shopData,
        appliedProduct,
        priceJ,
        variantPriceInfo 
    ) {
        // Custom element to hide price in cp setting
        let hideElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]:not([bss-b2b-featured-product]),'
            + '.product__price-savings,'
            + '.product__price.product__price--compare,'
            + '.product-card .price__sale .price__compare,'
            + '[bss-b2b-item-compare-price]',
        );

        if ((isQuickView && BSS_B2B.storeId != 1056) || BSS_B2B.storeId == 6699) {
            $(`[bss-b2b-product-id="${productId}"] .bss-b2b-customized-compare-at-price`).remove();
        }
        $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`).hide()

        let comparePriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]:not([bss-b2b-featured-product])');
        if(priceJ.isFeatured) {
            comparePriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price][bss-b2b-featured-product]')
            hideElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price][bss-b2b-featured-product],'
                + '.product__price-savings,'
                + '.product__price.product__price--compare,'
                + '.product-card .price__sale .price__compare,'
                + '[bss-b2b-item-compare-price],'
                + '.module-wrap .gf_product-prices'
            );
        }
        let variantElement = $('.product__price.product__price--compare').text();
        let originPrice = customPrice.price;
        let comparePrice = customPrice.compareAtPriceMin;


        if ([11420, 15884].includes(BSS_B2B.storeId) && BSS_B2B.page.isProductPage()) {
            customPrice.variants.map(item => {
                if (item.id === customPrice.variantSelected) {
                    originPrice = item.price;
                }
            })
        }

        // if (priceJ.variants) {
        //     let priceVariant = null;
        //     if (priceJ.variants.length > 0) {
        //         priceVariant = customPrice.variants.find((variant) => (variant.id == priceJ.variants[0]));
        //     }
        //     else if (!isNaN(priceJ.variants)) {
        //         priceVariant = customPrice.variants.find((variant) => (variant.id === priceJ.variants));
        //     }
        //     if (priceVariant) {
        //         if (priceJ.isFeatured === undefined) {
        //             comparePrice = priceVariant.compare_at_price
        //                 ? priceVariant.compare_at_price
        //                 : priceVariant.price;
        //             originPrice = priceVariant.price;
        //         }
        //     }
        // }

        if(priceJ && priceJ.variantSelected) {
            if ([7332, 9364].includes(BSS_B2B.storeId)) {
                if (customPrice && customPrice.variants && customPrice.variants.length > 0) {
                    const selectedVariant = customPrice.variants.find(variant => Number(variant.id) === Number(priceJ.variantSelected));
                    if (selectedVariant) {
                        originPrice = selectedVariant.price;
                    }
                }
            }
        }

        if ([12634, 10788].includes(BSS_B2B.storeId)) {
            const currentVariant = document.querySelector('.ecom-product-single__picker-radio-list li.ecom-box-active');
            let currentVariantId = currentVariant && currentVariant.getAttribute('bss-variant-id') ? currentVariant.getAttribute('bss-variant-id') : false;
            if (BSS_B2B.page.isSearchPage()) {
                const productId = (document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]') &&
                    document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id'))
                    ? +document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id')
                    : "";
                currentVariantId = document.querySelector(`.product-details[bss-b2b-product-id="${productId}"] .product__form_variant_id`) ? document.querySelector(`.product-details[bss-b2b-product-id="${productId}"] .product__form_variant_id`).value : false;
            }
            if (currentVariantId) {
                customPrice.variants.map(item => {
                    if (Number(item.id) === Number(currentVariantId)) {
                        originPrice = item.price;
                    }
                })
            }
        }


        let defaultPriceColor = BSS_B2B.cpSettings.default_price_color
            ? BSS_B2B.cpSettings.default_price_color
            : '#000000';
        let priceAppliedCPColor = BSS_B2B.cpSettings.price_applied_cp_color
            ? BSS_B2B.cpSettings.price_applied_cp_color
            : '#000000';
        let originalPriceHTML = BSS_B2B.cp.priceHTML(priceElement, variantElement, defaultPriceColor, originPrice,
            comparePrice, isEnableMC).originalPriceHTML;
        let comparePriceHTML = BSS_B2B.cp.priceHTML(priceElement, variantElement, defaultPriceColor, originPrice,
            comparePrice, isEnableMC).comparePriceHTML;

        let parentPriceElement = priceElement.parent().find('.bss-b2b-customized-compare-at-price');
        let productVatElement = $('.bss-b2b-product-vat[data-product-id="' + productId + '"]');
        let collectionVatElement = $('.bss-b2b-collection-item-vat[data-collection-item-id="' + productId + '"]');
        if (priceJ.isFeatured) {
            collectionVatElement = $('.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
                '"][data-collection-item-is-featured-product="true"]');
        } else {
            collectionVatElement = $('.bss-b2b-collection-item-vat[data-collection-item-id="' + productId +
            '"][data-collection-item-is-featured-product="false"]'); 
        }
        let appliedTax = null;
        let itemCollectionTaxAble = null;
        let appliedDisplayRule = null;

        if (productVatElement.length) {
            appliedTax = tax_default.a.bssB2BGetAppliedTaxRate(productVatElement.attr('data-product-collections'));
            appliedDisplayRule = taxDisplayRules_default.a.getAppliedRule(BSS_B2B, shopData);
        }
        if (collectionVatElement.length) {
            variant = false;
            if(priceJ.isFeatured) {
                variant = priceJ.variantSelected;
            }
            appliedTax = tax_default.a.bssB2BGetAppliedTaxRate(collectionVatElement.attr('data-collection-item-collections'));
            itemCollectionTaxAble = collectionVatElement.attr('data-collection-item-variant-taxable');
            itemCollectionTaxAble = (itemCollectionTaxAble === 'true');
            appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(BSS_B2B, shopData, appliedProduct);
        }

        priceElement.css('color', priceAppliedCPColor);

        let cpType = BSS_B2B.cpSettings.cpType ? BSS_B2B.cpSettings.cpType : 0;
        if (BSS_B2B.storeId === 7207) {
            if (hideElement) {
                hideElement.hide();
            }
        }
        if (BSS_B2B.storeId === 6613) {
            const unitPriceCollection = document.querySelectorAll('.grid-item__content .product__unit-price');
            if (unitPriceCollection && unitPriceCollection.length) {
                unitPriceCollection.forEach(item => item.remove());
            }
        }
        if (cpType === 0) {
            if (customForStore.includes(BSS_B2B.storeId)) {
                BSS_B2B.cp.customForStoreWithCPType(cpType, customPrice, finalPrice, originPrice, priceElement, productId, variant, defaultPriceColor, priceAppliedCPColor, originalPriceHTML, comparePriceHTML, hideElement, isEnableMC, parentPriceElement, comparePriceElement, discountType, discountValue);
            } else {
                if (variantPriceInfo && variantPriceInfo.length) {
                    let variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-card-information]');
                    for (let i = 0; i < variantPriceElement.length; i++) {
                        let variantOriginPrice = 0;
                        let variantId = variantPriceElement[i].getAttribute("bss-b2b-variant-id")
                        let finalPrice = 0
                        variantPriceInfo.forEach((item)=>{
                            if (variantId == item.variantId.toString()) {
                                finalPrice = item.price
                                variantOriginPrice = item.originPrice;
                            }
                        })
                        if (hideElement) {
                            hideElement.hide();
                        }
                        if (parentPriceElement) {
                            parentPriceElement.hide();
                        }
                        if ($('[bss-b2b-product-id="' + productId + '"]').parent().find('.bss-b2b-customized-compare-at-price').length === 0) {
                            $('[bss-b2b-product-id="' + productId + '"]').css("color", priceAppliedCPColor);
                        }
                        if(finalPrice < variantOriginPrice ){
                            $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                            $(variantPriceElement[i]).css("color", priceAppliedCPColor);
                        }else {
                            $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                        }
                    }
                } else {
                    if (variant && priceJ.isFeatured) {
                        if (hideElement) {
                            hideElement.hide();
                        }
                        if (parentPriceElement) {
                            parentPriceElement.hide();
                        }
                        let variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-product-price]:not([bss-b2b-featured-product])');
                        if(priceJ.isFeatured) {
                            if ($('[bss-b2b-product-id="' + productId + '"][bss-b2b-featured-product]').parent().find('.bss-b2b-customized-compare-at-price').length === 0) {
                                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-featured-product]').css("color", priceAppliedCPColor);
                            }
                            variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-product-price][bss-b2b-featured-product]');
                        } else {
                            if ($('[bss-b2b-product-id="' + productId + '"]:not([bss-b2b-featured-product])').parent().find('.bss-b2b-customized-compare-at-price').length === 0) {
                                $('[bss-b2b-product-id="' + productId + '"]:not([bss-b2b-featured-product])').css("color", priceAppliedCPColor);
                            }
                        }
                        if (BSS_B2B.storeId == 10295) {
                            variantPriceElement = $(
                                '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]');
                        }
                        variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                        variantPriceElement.css('color', priceAppliedCPColor);
                    }
                    else if (finalPrice < customPrice.price && customPrice.price < customPrice.compareAtPriceMin) {
                        hideElement.hide();
                    }
                    else if (customPrice.compareAtPriceMin === 0) {
                        if (customPrice.price <= finalPrice) {
                            priceElement.css('color', defaultPriceColor);
                        }
                        else if (BSS_B2B.storeId === 621) {
                            window.BSS_B2B.executeAction('show_price_with_cp_on_collection', 621, BSS_B2B, customPrice.variants, variant, productId, finalPrice);
                        }
                    }
                    else {
                        hideElement.hide();
                    }
                }
            }
        }
        else if (cpType === 1) {
            if (customForStore.includes(BSS_B2B.storeId)) {
                BSS_B2B.cp.customForStoreWithCPType(cpType, customPrice, finalPrice, originPrice, priceElement, productId, variant, defaultPriceColor, priceAppliedCPColor, originalPriceHTML, comparePriceHTML, hideElement, isEnableMC, parentPriceElement, comparePriceElement, discountType, discountValue);
            } else {
                if( variantPriceInfo && variantPriceInfo.length){
                    let variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-card-information]');
                    for (let i = 0; i < variantPriceElement.length; i++) {
                        let variantOriginPrice = 0;
                        let variantId = variantPriceElement[i].getAttribute("bss-b2b-variant-id")
                        let finalPrice = 0
                        let comparePrice = 0
                        variantPriceInfo.forEach((item)=>{
                            if (variantId == item.variantId.toString()) {
                                finalPrice = item.price
                                if (item.comparePrice) {
                                    comparePrice = item.comparePrice
                                }
                                variantOriginPrice = item.originPrice;
                            }
                        })
                        if (comparePrice) {
                            if (variantOriginPrice < comparePrice) {
                                let comparePriceElem = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, comparePrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                let oldComparePriceElem = $(variantPriceElement[i]).find('.bss-b2b-customized-compare-at-price')
                                $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length !== 0) {
                                        parentPriceElement.html(BSS_B2B.formatMoney(comparePrice));
                                    } else {
                                        if (oldComparePriceElem.length) {
                                            oldComparePriceElem.remove();
                                            $(variantPriceElement[i]).before(comparePriceElem);
                                        } else {
                                            $(variantPriceElement[i]).before(comparePriceElem);
                                        }
                                    }
                                    if (oldComparePriceElem.length) {
                                        oldComparePriceElem.html(BSS_B2B.formatMoney(comparePrice));
                                    } else {
                                        comparePriceElement.html(BSS_B2B.formatMoney(comparePrice));
                                        comparePriceElement.css({
                                            "color": defaultPriceColor,
                                            "text-decoration": "line-through"
                                        });
                                    }
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                                    $(variantPriceElement[i]).css("color", priceAppliedCPColor);
                                   
                                }
                            } else if (variantOriginPrice === comparePrice) {
                                if (finalPrice < variantOriginPrice) {
                                    let comparePriceEl = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                    if (parentPriceElement.length === 0) {
                                        $(variantPriceElement[i]).before(comparePriceEl);
                                    } else {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                                }else{
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                                }
                            } else if(variantOriginPrice > comparePrice) {
                                if (finalPrice < variantOriginPrice) {
                                      let comparePriceEl = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, comparePrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                      if (parentPriceElement.length === 0) {
                                        $(variantPriceElement[i]).before(comparePriceEl);
                                      } else {
                                          parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                      }
                                      $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                                } else {
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                                }
                            }
                        } else {
                            hideElement.hide();
                            if (finalPrice < variantOriginPrice ) {
                                let comparePriceElem = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                $(variantPriceElement[i]).before(comparePriceElem)
                                $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                            } else  { 
                                $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                            }
                        }
                    }
                } else {
                if (variant && priceJ.isFeatured) {
                    let variantOriginPrice = 0;
                    let variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-product-price][bss-b2b-featured-product],' + '.price__pricing-group .price__sale [bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]');
                    if ([9568].includes(BSS_B2B.storeId) && BSS_B2B.page.isProductPage()) {
                        variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-product-price]');
                    }
                    // fix padelutstyr by dongnv // fix rojodistro by dongnv
                    if ([5241, 5273, 537].indexOf(BSS_B2B.storeId) !== -1) {
                        variantPriceElement = $('[bss-b2b-product-id="' + productId +
                            '"][bss-b2b-product-parent-price], [bss-b2b-product-id="' + productId +
                            '"][bss-b2b-product-parent-price]');
                    }
                    //fix for oskarswoodenark by CuongNVM
                    if (BSS_B2B.storeId === 5273) {
                        parentPriceElement = variantPriceElement.parent().find('.bss-b2b-customized-compare-at-price');
                    }
                    if (customPrice && customPrice.variants && customPrice.variants.length > 0) {
                        let itemTaxAble = null;
                        let comparePrice = customPrice.compareAtPriceMin;

                        if (priceJ.variants !== undefined) {
                            customPrice.variants.every((item) => {
                                if (item.id.toString() === priceJ.variants[0] ||
                                    (priceJ.isFeatured && item.id === priceJ.variants)) {
                                    variantOriginPrice = item.price;
                                    itemTaxAble = item.taxable;
                                    if (priceJ.isFeatured) {
                                        comparePrice = item.compare_at_price ? item.compare_at_price : item.price;
                                    }
                                    return false;
                                }
                                return true;
                            });
                        }
                        else {
                            customPrice.variants.every((item) => {
                                if (item.id.toString() === variant.toString()) {
                                    variantOriginPrice = item.price;
                                    comparePrice = item.compare_at_price;
                                    itemTaxAble = item.taxable;
                                    if (item.compare_at_price) {
                                        comparePrice = item.compare_at_price;
                                    }
                                    return false;
                                }
                                return true;
                            });
                        }
                        if (comparePrice) {
                            let comparePriceVat = 0;
                            if ((BSS_B2B.storeId !== 5255) && hideElement) {
                                hideElement.hide();
                            }
                            if (variantOriginPrice < comparePrice) { //O < CAP
                                let comparePriceElem = BSS_B2B.createComparePriceElement('span',
                                    'bss-b2b-customized-compare-at-price', variant, productId, comparePrice,
                                    'line-through', '0 1rem 0 0', defaultPriceColor);
                                if (BSS_B2B.storeId === 12706) {
                                    comparePriceElem = BSS_B2B.createComparePriceElement('span',
                                    'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                    'line-through', '0 1rem 0 0', defaultPriceColor);
                                }
                                let oldComparePriceElem = $(
                                    '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price][bss-b2b-featured-product]');
                                if (finalPrice <= variantOriginPrice) {
                                    if (parentPriceElement.length !== 0) {
                                        parentPriceElement.html(BSS_B2B.formatMoney(comparePrice));
                                        if (BSS_B2B.storeId === 12706) {
                                            parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                        }
                                    }
                                    else {
                                        if ([5241].indexOf(BSS_B2B.storeId) !== -1) {
                                            let oldComparePrice = $('[data-product-id="' + productId +
                                                '"].bss-b2b-customized-compare-at-price');
                                            oldComparePrice.remove();
                                            variantPriceElement.after(comparePriceElem);
                                        }
                                        else if ([537].indexOf(BSS_B2B.storeId) !== -1) {
                                            let oldComparePrice = $('[data-product-id="' + productId +
                                                '"].bss-b2b-customized-compare-at-price');
                                            oldComparePrice.remove();
                                            variantPriceElement.before(comparePriceElem);
                                        }
                                        else if (oldComparePriceElem.length) {
                                            oldComparePriceElem.show();
                                        }
                                        else {
                                            variantPriceElement.before(comparePriceElem);
                                        }
                                    }
                                    if (oldComparePriceElem.length) {
                                        oldComparePriceElem.html(BSS_B2B.formatMoney(comparePrice));
                                        oldComparePriceElem.map((_key, compareElement) => {
                                            compareElement.setAttribute('style',
                                                `color: ${defaultPriceColor}; text-decoration: line-through`);
                                        });
                                    }
                                    else {
                                        comparePriceElement.html(BSS_B2B.formatMoney(comparePrice));
                                        comparePriceElement.css({
                                            'color': defaultPriceColor,
                                            'text-decoration': 'line-through',
                                        });
                                    }
                                    variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                                    variantPriceElement.css('color', priceAppliedCPColor);
                                    comparePriceVat = comparePrice;
                                }
                            }
                            else if (variantOriginPrice === comparePrice) {
                                if (finalPrice < variantOriginPrice) {
                                    let comparePriceEl = BSS_B2B.createComparePriceElement('span',
                                        'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                        'line-through', '0 1rem 0 0', defaultPriceColor);
                                    if (parentPriceElement.length === 0) {
                                        priceElement.before(comparePriceEl);
                                    }
                                    else {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    comparePriceVat = variantOriginPrice;
                                }
                            }
                            else if (variantOriginPrice > comparePrice) { //O > CAP
                                if (finalPrice < variantOriginPrice) { // CP < O
                                    let comparePriceEl = BSS_B2B.createComparePriceElement('span',
                                        'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                        'line-through', '0 1rem 0 0', defaultPriceColor);
                                    if (parentPriceElement.length === 0) {
                                        priceElement.before(comparePriceEl);
                                    }
                                    else {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    comparePriceVat = variantOriginPrice;
                                }
                            }

                            if (appliedTax !== null && appliedDisplayRule && comparePriceVat !== 0 &&
                                BSS_B2B.storeId !== 8537) {
                                let comparePriceVatElement = BSS_B2B.createCompareElementVat(productVatElement,
                                    shopData, appliedDisplayRule, appliedTax, comparePriceVat, itemTaxAble,
                                    'bss-b2b-product-compare-price-vat', productId);
                                let oldComparePriceVatElement = $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`);
                                if (oldComparePriceVatElement.length) {
                                    oldComparePriceVatElement.remove();
                                }
                                if(productVatElement.length > 0) {
                                    productVatElement.before(comparePriceVatElement);
                                } else if(collectionVatElement.length > 0) {
                                    collectionVatElement.before(comparePriceVatElement);
                                }
                            } else {
                                $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`).hide()
                            }
                        }
                        else {
                            hideElement.hide();
                            let newComparePriceElem = BSS_B2B.createComparePriceElement('span',
                                'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                'line-through', '0 1rem 0 0', defaultPriceColor);
                            //fix for oskarswoodenark by CuongNVM
                            if (BSS_B2B.storeId === 5273 && parentPriceElement.length == 1) {
                                let clone = parentPriceElement.clone()[0];
                                if (priceElement[1]) {
                                    priceElement[1].before(clone);
                                }
                            }
                            //fix for padelutstyr by DongNV
                            if (BSS_B2B.storeId === 5241) {
                                priceElement.each(function() {
                                    var element = $(this);
                                    let comparePrice = element.parent().find('.bss-b2b-customized-compare-at-price');
                                    if (comparePrice.length === 0) {
                                        element.before(newComparePriceElem);
                                    }
                                    else {
                                        comparePrice.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                });
                            }
                            if (parentPriceElement.length === 0) {
                                if (BSS_B2B.storeId === 5273) {
                                    let qvPrice = document.querySelector(
                                        '.modal.modal--quickshop-full .modal-content .product-main [bss-b2b-product-id="' +
                                        productId + '"][bss-b2b-variant-id][bss-b2b-product-price]');
                                    if (qvPrice) {
                                        let qvCompareAtPrice = qvPrice.parentNode.querySelector(
                                            '.bss-b2b-customized-compare-at-price');
                                        if (qvCompareAtPrice) {
                                            qvCompareAtPrice.innerHTML = BSS_B2B.formatMoney(variantOriginPrice);
                                        }
                                        else {
                                            priceElement.before(newComparePriceElem);
                                        }
                                    }
                                    else {
                                        priceElement.before(newComparePriceElem);
                                    }
                                }
                                else if (BSS_B2B.storeId === 7321) {
                                    priceElement.before(newComparePriceElem);
                                    let dropdownCart = $('.sf-product-variant-option-dropdown.combined-variant');
                                    if (dropdownCart) {
                                        let dropdownPriceElement = document.querySelectorAll(
                                            'option[bss-b2b-cart-dropdown]');
                                        if (dropdownPriceElement) {
                                            dropdownPriceElement.forEach(element => {
                                                let variantTitle = element.getAttribute('title');
                                                element.innerHTML = variantTitle + ' - ' +
                                                    BSS_B2B.formatMoney(finalPrice);
                                            });
                                        }
                                    }
                                }
                                else if (BSS_B2B.storeId === 7727) {
                                    if (priceElement.length > 1) {
                                        priceElement[0].before(newComparePriceElem);
                                    }
                                    else {
                                        priceElement.before(newComparePriceElem);
                                    }
                                }
                                else {
                                    if(finalPrice < variantOriginPrice){
                                        priceElement.before(newComparePriceElem);
                                    } else {
                                        // do nothing
                                    }
                                }
                            }
                            else {
                                if (BSS_B2B.storeId === 7188) {
                                    let compareElement = $(
                                        '.productView-price .price__regular .price__last .bss-b2b-customized-compare-at-price');
                                    if (!compareElement.length) {
                                        priceElement.before(newComparePriceElem);
                                    }
                                } else if (finalPrice >= variantOriginPrice){
                                    // do nothing 
                                }
                                else {
                                    parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                }
                            }                
                            if (appliedTax !== null && appliedDisplayRule && variantOriginPrice !== 0 &&
                                BSS_B2B.storeId !== 8537) {
                                let comparePriceVatElement = BSS_B2B.createCompareElementVat(productVatElement,
                                    shopData, appliedDisplayRule, appliedTax, variantOriginPrice, itemTaxAble,
                                    'bss-b2b-product-compare-price-vat', productId);
                                let oldComparePriceVatElement = $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`);
                                if (oldComparePriceVatElement.length) {
                                    oldComparePriceVatElement.remove();
                                }
                                if(productVatElement.length > 0) {
                                    productVatElement.before(comparePriceVatElement);
                                } else if(collectionVatElement.length > 0) {
                                    collectionVatElement.before(comparePriceVatElement);
                                }
                            } else {
                                $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`).hide()
                            }
                        }
                    }
                }else {
                    let comparePriceVat = 0;
                    if (customPrice.compareAtPriceMin === 0 || BSS_B2B.storeId === 12498) {
                        if (customPrice.price <= finalPrice) {
                            priceElement.css('color', defaultPriceColor);
                        }
                        else {
                            if (BSS_B2B.storeId === 4339) {
                                if (comparePrice) {
                                    priceElement.html(comparePriceHTML + '<span style="margin-left: 10px; color: ' +
                                        priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                                }
                            }
                            else {
                                priceElement.html(originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                            }
                        }
                        if (BSS_B2B.storeId === 9364 && BSS_B2B.page.isCollectionPage()) {
                            priceElement.html(originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                        }
                        // if (priceJ.variants) {
                        //     comparePriceElement.length
                        //         ? comparePriceElement.html(comparePriceHTML)
                        //         : priceElement.before(comparePriceHTML);
                        // }
                        comparePriceVat = customPrice.price;
                    }
                    else if (customPrice.compareAtPriceMin > finalPrice && finalPrice > customPrice.price) { //O < CP < CAP
                        comparePriceElement.length ? comparePriceElement.html(comparePriceHTML) : priceElement.before(
                            comparePriceHTML);
                    }
                    else if (customPrice.compareAtPriceMin === finalPrice ||
                        (finalPrice > customPrice.compareAtPriceMin && finalPrice > customPrice.price)) { 
                        // CAP = CP || CP > CAP && CP > O
                        if (customPrice.price < customPrice.compareAtPriceMin) {
                            // O < CAP < CP
                            // O < CAP = CP
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                        }
                        else {
                            // O > CAP = CP
                            // CP > O > CAP
                            if(finalPrice > customPrice.compareAtPriceMin) {
                                priceElement.html(originalPriceHTML);
                            } else {
                                if(parentPriceElement.length > 0) {
                                    parentPriceElement.html(BSS_B2B.formatMoney(customPrice.price))
                                } else {
                                    priceElement.html(originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                                }
                            }
                            // priceElement.html(BSS_B2B.formatMoney(customPrice.compareAtPriceMin));
                            // priceElement.css('color', defaultPriceColor);
                        }
                        comparePriceVat = customPrice.compareAtPriceMin;
                    }
                    else if ((finalPrice > customPrice.compareAtPriceMin && finalPrice < customPrice.price) ||
                        (finalPrice > customPrice.compareAtPriceMin && finalPrice === customPrice.price)) {
                        //    do nothing
                        // 0 = CP > CAP
                        // 0 > CP > CAP
                        if (BSS_B2B.storeId === 6103) {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                        } else {
                            if(finalPrice >= customPrice.price) {
                                priceElement.html(originalPriceHTML);
                            } else {
                                if(parentPriceElement.length > 0) {
                                    parentPriceElement.html(BSS_B2B.formatMoney(customPrice.price))
                                } else {
                                    priceElement.html(originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                                }
                            }
                        }
                        
                    }
                    else if (customPrice.compareAtPriceMin < customPrice.price && finalPrice < customPrice.price &&
                        finalPrice < customPrice.compareAtPriceMin) {
                            //CP < CAP < O
                        comparePriceElement.length ? comparePriceElement.html(comparePriceHTML) : priceElement.before(
                            comparePriceHTML);
                        comparePriceVat = comparePrice;
                        if (![6103, 12498].includes(BSS_B2B.storeId)) {
                            let priceElement = document.querySelector('[bss-b2b-product-id="'+productId+'"][bss-b2b-product-price]:not([bss-b2b-featured-product])').closest('div');
                            let priceCompareElement = document.querySelector('[bss-b2b-product-id="'+productId+'"][bss-b2b-product-compare-price]:not([bss-b2b-featured-product])');
                            priceElement.prepend(priceCompareElement);
                            priceCompareElement.style.marginRight = '10px';
                        }
                    }
                    else if (finalPrice < customPrice.compareAtPriceMin && customPrice.compareAtPriceMin <
                        customPrice.price) {
                        priceElement.html(BSS_B2B.formatMoney(customPrice.price));
                        priceElement.css('color', defaultPriceColor);
                        comparePriceVat = customPrice.price;
                    }
                    else {
                        if (BSS_B2B.storeId === 5195) {
                            let comparePriceElem = BSS_B2B.createComparePriceElement('span',
                                'bss-b2b-customized-compare-at-price', variant, productId, comparePrice, 'line-through',
                                '0 1rem 0 0', defaultPriceColor);
                            priceElement.before(comparePriceElem);
                        }
                        else if ([4279, 7814].includes(BSS_B2B.storeId)) {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.after(comparePriceHTML);
                        }
                        else {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                            comparePriceVat = customPrice.compareAtPriceMin;
                        }
                    }

                    if (appliedTax !== null && appliedDisplayRule && comparePriceVat !== 0 && BSS_B2B.storeId !==
                        8537) {
                        let comparePriceCollectionVatElement = BSS_B2B.createCompareElementVat(collectionVatElement,
                            shopData, appliedDisplayRule, appliedTax, comparePriceVat, itemCollectionTaxAble,
                            'bss-b2b-collection-compare-price-vat', productId);
                        let oldComparePriceVatElement = $(`.bss-b2b-collection-compare-price-vat[data-product-id=${productId}]`);
                        if (oldComparePriceVatElement.length) {
                            oldComparePriceVatElement.remove();
                        }
                        if (BSS_B2B.storeId === 5750) {
                            let comparePriceCustomize = document.querySelector('[bss-b2b-customize-5750]');
                            if (comparePriceCustomize) {
                                comparePriceCustomize.remove();
                            }
                        }
                        collectionVatElement.before(comparePriceCollectionVatElement);
                    } else {
                        $(`.bss-b2b-collection-compare-price-vat[data-product-id=${productId}]`).hide()
                    }
                    if (BSS_B2B.storeId === 12498) {
                        window.BSS_B2B.executeAction({ tag: 'custom_price_amount', storeId: 12498, productId, originPrice, finalPrice });
                    }
                }
            }
        }
        } else if (cpType === 2) {
            if (BSS_B2B.storeId === 3879) {
                priceElement = $('[data-product-id="' + productId + '"] [bss-b2b-product-price]');
            }
            else if (BSS_B2B.storeId === 3740) {
                let productPriceElement = $(priceElement).closest('.product-price');
                productPriceElement.find('.product-price--compare').remove();
            }
            if (customForStore.includes(BSS_B2B.storeId) || (BSS_B2B.storeId === 6809 && BSS_B2B.page.isProductPage())) {
                BSS_B2B.cp.customForStoreWithCPType(cpType, customPrice, finalPrice, originPrice, priceElement,
                    productId, variant, defaultPriceColor, priceAppliedCPColor, originalPriceHTML, comparePriceHTML,
                    hideElement, isEnableMC, parentPriceElement, comparePriceElement, discountType, discountValue);
            }
            else {
                if (hideElement) {
                    hideElement.hide();
                }
                if (variantPriceInfo && variantPriceInfo.length ){
                    let variantPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-card-information]');
                    for (let i = 0; i < variantPriceElement.length; i++) {
                        let variantOriginPrice = 0;
                        let variantId = variantPriceElement[i].getAttribute("bss-b2b-variant-id")
                        let finalPrice = 0
                        let comparePrice = 0
                        variantPriceInfo.forEach((item)=>{
                            if (variantId == item.variantId.toString()) {
                                finalPrice = item.price
                                if (item.comparePrice) {
                                    comparePrice = item.comparePrice
                                }else{
                                    comparePrice = item.originPrice
                                }
                                variantOriginPrice = item.originPrice;
                            }
                        })
                        if (comparePrice) {
                            if (variantOriginPrice !== comparePrice) {
                                let originPriceElement = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length !== 0) {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    } else {
                                        $(variantPriceElement[i]).before(originPriceElement);
                                    }
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                                    comparePriceElement.css({
                                        "color": defaultPriceColor,
                                        "text-decoration": "line-through"
                                    });
                                    $(variantPriceElement[i]).css("color", priceAppliedCPColor);
                                } else {
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice))
                                }
                            } else if (variantOriginPrice === comparePrice) {
                                let originPriceEl = BSS_B2B.createComparePriceElement('span', 'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice, 'line-through', '0 1rem 0 0', defaultPriceColor);
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length === 0) {
                                        priceElement[i].before(originPriceEl);
                                        $(variantPriceElement[i]).html(BSS_B2B.formatMoney(finalPrice));
                                    } else {
                                        $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                } else {
                                    $(variantPriceElement[i]).html(BSS_B2B.formatMoney(variantOriginPrice));
                                }
                            }
                        }
                    }
                } else if(variant && priceJ.isFeatured) {
                    let variantOriginPrice = 0;
                    let variantPriceElement = $('[bss-b2b-product-id="' + productId +
                        '"][bss-b2b-variant-id][bss-b2b-product-price][bss-b2b-featured-product],' +
                        '.price__pricing-group .price__sale [bss-b2b-product-id="' + productId +
                        '"][bss-b2b-product-parent-price]');

                    if (customPrice && customPrice.variants && customPrice.variants.length > 0) {
                        let itemTaxAble = null;
                        let comparePrice = customPrice.compareAtPriceMin;
                        if (priceJ.variants !== undefined) {
                            customPrice.variants.every((item) => {
                                if (item.id.toString() === priceJ.variants[0] ||
                                    (priceJ.isFeatured && item.id === priceJ.variants)) {
                                    variantOriginPrice = item.price;
                                    comparePrice = item.compare_at_price;
                                    itemTaxAble = item.taxable;
                                    if (item.compare_at_price) {
                                        comparePrice = item.compare_at_price;
                                    }
                                    return false;
                                }
                                return true;
                            });
                        }
                        else {
                            customPrice.variants.every((item) => {
                                if (item.id.toString() === variant.toString()) {
                                    variantOriginPrice = item.price;
                                    comparePrice = item.compare_at_price;
                                    itemTaxAble = item.taxable;
                                    if (item.compare_at_price) {
                                        comparePrice = item.compare_at_price;
                                    }
                                    return false;
                                }
                                return true;
                            });
                        }
                        if (comparePrice) {
                            let comparePriceVat = 0;
                            if (variantOriginPrice !== comparePrice) {
                                let originPriceElement = BSS_B2B.createComparePriceElement('span',
                                    'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                    'line-through', '0 1rem 0 0', defaultPriceColor);
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length !== 0) {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    else {
                                        variantPriceElement.before(originPriceElement);
                                    }
                                    variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                                    comparePriceElement.css({
                                        'color': defaultPriceColor,
                                        'text-decoration': 'line-through',
                                    });
                                    variantPriceElement.css('color', priceAppliedCPColor);
                                    comparePriceVat = variantOriginPrice;
                                }
                            }
                            else if (variantOriginPrice === comparePrice) {
                                let originPriceEl = BSS_B2B.createComparePriceElement('span',
                                    'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                    'line-through', '0 1rem 0 0', defaultPriceColor);
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length === 0) {
                                        priceElement.before(originPriceEl);
                                    }
                                    else {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    comparePriceVat = variantOriginPrice;
                                }

                            }
                            else if ([7332, 7355].includes(BSS_B2B.storeId)) {
                                window.BSS_B2B.executeAction({
                                    tag: 'price_cp_setting',
                                    storeId: 7355,
                                    variant, priceElement, originalPriceHTML, customPrice, finalPrice,
                                    variantOriginPrice, productId, defaultPriceColor
                                });
                            }
                            if (appliedTax !== null && comparePriceVat !== 0 && appliedDisplayRule &&
                                BSS_B2B.storeId !== 8537) {
                                let comparePriceVatElement = BSS_B2B.createCompareElementVat(productVatElement,
                                    shopData, appliedDisplayRule, appliedTax, comparePriceVat, itemTaxAble,
                                    'bss-b2b-product-compare-price-vat', productId);

                                let oldComparePriceVatElement = $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`);
                                if (oldComparePriceVatElement.length) {
                                    oldComparePriceVatElement.remove();
                                }
                                if(productVatElement.length > 0) {
                                    productVatElement.before(comparePriceVatElement);
                                } else if(collectionVatElement.length > 0) {
                                    collectionVatElement.before(comparePriceVatElement)
                                }
                            } else {
                                $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`).hide()
                            }
                        }
                        else {
                            let newOriginPriceEl = BSS_B2B.createComparePriceElement('span',
                                'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                'line-through', '0 1rem 0 0', defaultPriceColor);
                            if ([3879, 7619].includes(BSS_B2B.storeId)) {
                                let newOriginalPriceHTML = '<span class="bss-b2b-customized-compare-at-price-3879" style="text-decoration: line-through; color: ' +
                                    defaultPriceColor + '">' + BSS_B2B.formatMoney(variantOriginPrice) + '</span>';
                                priceElement.before(newOriginalPriceHTML);
                            }
                            else if ([14113, 14886].includes(BSS_B2B.storeId)) {
                                window.BSS_B2B.executeAction({
                                    tag: 'show_custom_CP_product_page',
                                    storeId: false,
                                    BSS_B2B, priceElement, originPrice: variantOriginPrice, finalPrice, shopData
                                })
                            }
                            else if ([8219].includes(BSS_B2B.storeId)) {
                                let newOriginalPriceHTML = '<span class="bss-b2b-customized-compare-at-price" style="text-decoration: line-through; margin-right: 5px; color: ' +
                                    defaultPriceColor + '">' + BSS_B2B.formatMoney(variantOriginPrice) + '</span>';
                                let comparePrice = priceElement.parent().find('.bss-b2b-customized-compare-at-price');
                                if (comparePrice.length === 0) {
                                    priceElement.before(newOriginalPriceHTML);
                                }
                                else {
                                    let compareProductPrice = $(
                                        '.product-title-container .amount .bss-b2b-customized-compare-at-price');
                                    if (compareProductPrice.length === 0) {
                                        $('.product-title-container .amount [bss-b2b-product-price]').
                                            before(newOriginalPriceHTML);
                                    }
                                    comparePrice.html(BSS_B2B.formatMoney(variantOriginPrice));
                                }
                            }
                            else if (BSS_B2B.storeId === 4618 && BSS_B2B.page.isProductPage() &&
                                priceElement.closest('.modal-inner').length) {
                                priceElement = $(
                                    '.modal-inner [bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
                                if (parentPriceElement.length === 0) {
                                    priceElement.before(newOriginPriceEl);
                                    priceElement.html(BSS_B2B.formatMoney(finalPrice));
                                }
                                else {
                                    parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    priceElement.html(BSS_B2B.formatMoney(finalPrice));
                                }
                            }
                            else if (finalPrice < variantOriginPrice) {
                                //fix for groomus.dk, bam-rental-results by CuongNVM
                                if ([4653, 4902, 6652, 7131, 3762, 12303, 13569, 13817, 6699, 11857].indexOf(BSS_B2B.storeId) !== -1) {
                                    priceElement.each(function() {
                                        var element = $(this);
                                        let comparePrice = element.parent().
                                            find('.bss-b2b-customized-compare-at-price');
                                        if (BSS_B2B.storeId === 6652) {
                                            window.BSS_B2B.executeAction('price_product_page', 6652, element,
                                                comparePrice, newOriginPriceEl, variantOriginPrice);
                                        }
                                        else {
                                            if (comparePrice.length === 0) {
                                                element.before(newOriginPriceEl.outerHTML);
                                            }
                                            else {
                                                comparePrice.html(BSS_B2B.formatMoney(variantOriginPrice));
                                            }
                                        }
                                    });
                                }
                                else if ([12349].indexOf(BSS_B2B.storeId) !== -1) {
                                    if (parentPriceElement.length === 0) {
                                        priceElement.before(newOriginPriceEl);
                                    }
                                    else {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    let quickAddDrawer = document.querySelector('.quick-add__product-details')
                                    if (quickAddDrawer) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                                if (m.addedNodes.length) {
                                                    let priceInQuickAddDrawer = document.querySelector('.quick-add__product-details .price .price__default')
                                                    if (!priceInQuickAddDrawer.parentElement.querySelector('span.bss-b2b-customized-compare-at-price')) {
                                                        priceInQuickAddDrawer.before(newOriginPriceEl);
                                                    } else {
                                                        priceInQuickAddDrawer.parentElement.querySelector('span.bss-b2b-customized-compare-at-price').outerHTML = newOriginPriceEl.outerHTML
                                                    }
                                                }
                                            });
                                        });
                                        observer.observe(quickAddDrawer, {childList: true});
                                    }
                                }
                                else {
                                    if (parentPriceElement.length === 0) {
                                        priceElement.before(newOriginPriceEl);
                                    } else if ([16236].includes(BSS_B2B.storeId)) {
                                        $('.bss-b2b-customized-compare-at-price').remove();
                                        priceElement.before(newOriginPriceEl);
                                    } else {
                                        if ([16067, 16064].includes(BSS_B2B.storeId)) {
                                            const checkSearchDrawer = document.querySelector("search-drawer[open], .search-flydown[data-animation-state='open']")
                                            if (priceElement && priceElement.length && checkSearchDrawer) {
                                                priceElement.each(function() {
                                                    let element = $(this);
                                                    const checkComparePrice = element.parent().find('.bss-b2b-customized-compare-at-price');
                                                    const checkPriceElemSearch = element.closest(".search-drawer, .search-flydown--product__price")
                                                    if (checkComparePrice && !checkComparePrice.length && checkPriceElemSearch && checkPriceElemSearch.length) {
                                                        element.before(newOriginPriceEl);
                                                    }
                                                });
                                            }
                                        }
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                }

                                if (appliedTax !== null && appliedDisplayRule && variantOriginPrice !== 0 &&
                                    BSS_B2B.storeId !== 8537) {
                                    let comparePriceVatElement = BSS_B2B.createCompareElementVat(productVatElement,
                                        shopData, appliedDisplayRule, appliedTax, variantOriginPrice, itemTaxAble,
                                        'bss-b2b-product-compare-price-vat', productId);
                                    let oldComparePriceVatElement = $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`);
                                    if (oldComparePriceVatElement.length) {
                                        oldComparePriceVatElement.remove();
                                    }
                                    if(productVatElement.length > 0) {
                                        productVatElement.before(comparePriceVatElement);
                                    } else if(collectionVatElement.length > 0) {
                                        collectionVatElement.before(comparePriceVatElement)
                                    }
                                } else {
                                    $(`.bss-b2b-product-compare-price-vat[data-product-id=${productId}]`).hide()
                                }
                            }
                        }
                    }
                } else {
                    if (hideElement) {
                        hideElement.show();
                    }

                    if (BSS_B2B.storeId === 10829) {
                        const oldOriginalPriceElement = priceElement.parent().
                            find('.bss-b2b-customized-original-price');
                        if (oldOriginalPriceElement.length) {
                            oldOriginalPriceElement.remove();
                        }
                    }

                    if ([12634, 10788].includes(BSS_B2B.storeId)) {
                        const oldOriginalPriceElement = document.querySelectorAll('.ecom-product-single.ecom-product-single__price--prices .bss-b2b-customized-original-price');
                        if (oldOriginalPriceElement && oldOriginalPriceElement.length) {
                            oldOriginalPriceElement.forEach(item => item.remove());
                        } 
                    }

                    if (customPrice.compareAtPriceMin > customPrice.price) {
                        if (customPrice.price > finalPrice) {
                            comparePriceElement.length
                                ? comparePriceElement.html(originalPriceHTML)
                                : priceElement.before(originalPriceHTML);
                        }
                        else if (customPrice.price === finalPrice) {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                        }
                        else if (customPrice.price < finalPrice) {
                            //    do nothing
                        }
                        if (!priceJ.variants && priceJ.isFeatured === undefined && comparePrice > finalPrice) {
                            comparePriceElement.length
                                ? comparePriceElement.html(originalPriceHTML)
                                : priceElement.before(originalPriceHTML);
                        }
                    }
                    else if (customPrice.compareAtPriceMin === 0 && customPrice.price > finalPrice) {
                        if (BSS_B2B.storeId === 6652) {
                            priceElement.html('<span style="font-weight: bold; color: ' + priceAppliedCPColor + '">' +
                                BSS_B2B.formatMoney(finalPrice) + ' WSP </span>' + originalPriceHTML);
                        }
                        else if (BSS_B2B.storeId === 8928) {
                            priceElement.html(
                                '<span style="font-weight: bold; display:block; color: #bb0000; line-height: 1; margin-top:4px"> ' +
                                'WSP ' + BSS_B2B.formatMoney(finalPrice) + '</span>' + originalPriceHTML);
                        } else if ([12634, 10788].includes(BSS_B2B.storeId)) {
                            priceElement.html('<span style="margin-left: 10px; color: ' + priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                            const priceElementWrapper = document.querySelector('.ecom-product-single.ecom-product-single__price--prices');
                            const oldOriginalPriceElement = document.querySelectorAll('.ecom-product-single.ecom-product-single__price--prices .bss-b2b-customized-original-price');

                            if (priceElementWrapper && oldOriginalPriceElement.length === 0) {
                                priceElementWrapper.insertAdjacentHTML('afterbegin', originalPriceHTML);
                            }
                        } else {
                            priceElement.html(
                                originalPriceHTML + '<span style="margin-left: 10px; color: ' + priceAppliedCPColor +
                                '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                        }
                    }
                    else {
                        if ((customPrice.price > customPrice.compareAtPriceMin && customPrice.compareAtPriceMin ===
                                finalPrice) || customPrice.compareAtPriceMin === 0 || customPrice.price >
                            customPrice.compareAtPriceMin) {
                            let existCompare = priceElement.parent().find('.bss-b2b-customized-original-price');
                            if (!existCompare.length) {
                                priceElement.css('color', priceAppliedCPColor);
                                priceElement.css('margin-left', '10px');
                                priceElement.before(originalPriceHTML);
                            }
                        }
                        else {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                        }
                        if ([4784, 8553].includes(BSS_B2B.storeId)) {
                            let existCompare = priceElement.parent().find('.bss-b2b-customized-original-price');
                            if (!existCompare.length) {
                                priceElement.css('margin-left', '10px');
                                priceElement.before(originalPriceHTML);
                            }
                        } else if ([12634, 10788].includes(BSS_B2B.storeId)) {
                            priceElement.html('<span style="margin-left: 10px; color: ' + priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>');
                            const priceElementWrapper = document.querySelector('.ecom-product-single.ecom-product-single__price--prices');
                            const oldOriginalPriceElement = document.querySelectorAll('.ecom-product-single.ecom-product-single__price--prices .bss-b2b-customized-original-price');

                            if (priceElementWrapper && oldOriginalPriceElement.length === 0) {
                                priceElementWrapper.insertAdjacentHTML('afterbegin', originalPriceHTML);
                            }
                        }

                        window.BSS_B2B.executeAction({
                            tag: 'price_cp_setting',
                            storeId: 7355,
                            variant, priceElement, originalPriceHTML, customPrice, finalPrice,
                            variantOriginPrice: false, productId, defaultPriceColor
                        });

                    }
                    if (appliedTax !== null && customPrice.price !== 0 && appliedDisplayRule && BSS_B2B.storeId !==
                        8537) {
                        let originalPriceForVat = customPrice.price;
                        let _productId = productId;
                        if ([12634, 10788].includes(BSS_B2B.storeId) && BSS_B2B.page.isSearchPage()) {
                            originalPriceForVat = originPrice;
                            _productId = (document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]') &&
                                document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id'))
                                ? +document.querySelector('.single-option-selector.single-option-selector-item.product-form__input[selected="true"]').getAttribute('data-product-id')
                                : productId;
                            collectionVatElement = $('.bss-b2b-collection-item-vat[data-collection-item-id="' + _productId + '"]');
                        }

                        let comparePriceCollectionVatElement = BSS_B2B.createCompareElementVat(collectionVatElement,
                            shopData, appliedDisplayRule, appliedTax, originalPriceForVat, itemCollectionTaxAble,
                            'bss-b2b-collection-compare-price-vat', _productId);
                        let oldComparePriceVatElement = $(`.bss-b2b-collection-compare-price-vat[data-product-id=${_productId}]`);
                        if (oldComparePriceVatElement.length) {
                            oldComparePriceVatElement.remove();
                        }
                        collectionVatElement.before(comparePriceCollectionVatElement);
                    } else {
                        $(`.bss-b2b-collection-compare-price-vat[data-product-id=${productId}]`).hide()
                    }
                }
                // temporarily add blank span element before and after cpPrice and originalPrice
                // until the features for customize CP text go live
                if ([5732, 6497].includes(BSS_B2B.storeId)) {
                    window.BSS_B2B.executeAction({ tag: 'customize_cp_td', storeId: false, priceElement, productId });
                }
                if (BSS_B2B.storeId === 11454) {
                    const customPriceRecommendMiniCart = $(
                        'div.t4s-minicart-recommendations__item--price:has(.bss-b2b-customized-original-price) > span');
                    if (customPriceRecommendMiniCart) {
                        customPriceRecommendMiniCart.css('color', priceAppliedCPColor);
                    }
                    if (BSS_B2B.page.isHomePage() || BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage()) {
                        const customPriceElement = $(
                            'div.t4s-product-price:has(.bss-b2b-customized-original-price) > span');
                        if (customPriceElement) {
                            customPriceElement.css('color', priceAppliedCPColor);
                        }
                    }
                }
                else if ([12803].includes(BSS_B2B.storeId)) {
                    if (BSS_B2B.page.isProductPage()) {
                        let comparePriceDefault = document.querySelectorAll(".product__price .price__pricing-group .price__sale .price-item.price-item--regular");
                        let originalPriceDefault = document.querySelectorAll(".price__regular .bss-b2b-customized-compare-at-price");
                        if (comparePriceDefault && comparePriceDefault.length) {
                            comparePriceDefault.forEach(item => item.remove());
                        }
                        if (originalPriceDefault && originalPriceDefault.length) {
                            originalPriceDefault.forEach(item => item.remove());
                        }
                        priceElement.before(originalPriceHTML);
                    }
                } 
                window.BSS_B2B.executeAction({ tag: 'price_all', storeId: 14993, productId, priceElement, originalPriceHTML });
            }
        }
    };

    BSS_B2B.cp.priceHTML = function(
        priceElement,
        variantElement,
        defaultPriceColor,
        originPrice,
        comparePrice,
        isEnableMC,
    ) {

        let originalPriceHTML = '<del class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
            '"> ' + BSS_B2B.formatMoney(originPrice) + ' </del>';
        let comparePriceHTML = '<del class="bss-b2b-customized-compare-at-price" style="color: ' + defaultPriceColor +
            '"> ' + BSS_B2B.formatMoney(comparePrice) + ' </del>';

        // fix for store ID 4927, 8356
        window.BSS_B2B.executeAction({
            tag: `price_cp_setting`,
            storeId: false,
            BSS_B2B, priceElement, defaultPriceColor, isEnableMC, originPrice
        });

        if (BSS_B2B.storeId === 4272) {
            comparePriceHTML = '<span class="bss-b2b-customized-compare-at-price" style="color: ' + defaultPriceColor +
                '"> ' + variantElement + ' </span>';
        }
        else if (BSS_B2B.storeId === 3588) {
            comparePriceHTML = '<span style="color: ' + defaultPriceColor + '"> RRP&nbsp;' +
                '</span><span class="bss-b2b-customized-compare-at-price" style="color: ' + defaultPriceColor + '">' +
                BSS_B2B.formatMoney(comparePrice) + '</span>' + '</span>';
        }
        else if ([4856, 6289, 6412, 6366, 6365].includes(BSS_B2B.storeId)) { // custom for nimbus-focal by DongNV
            originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> (' + BSS_B2B.formatMoney(originPrice) + ') </span>';
            comparePriceHTML = '<span class="bss-b2b-customized-compare-at-price" style="color: ' + defaultPriceColor +
                '"> (' + BSS_B2B.formatMoney(comparePrice) + ') </span>';
        }
        else if (BSS_B2B.storeId === 5912) {
            originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> MSRP: ' + BSS_B2B.formatMoney(originPrice) + '</span>';
        }
        else if ([5885].includes(BSS_B2B.storeId)) { // custom for mouser-pet-supplies by DongNV
            originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> RRP ' + BSS_B2B.formatMoney(originPrice) + ' </span>';
            // comparePriceHTML = '<span class="bss-b2b-customized-compare-at-price" style="color: ' +
            // defaultPriceColor + '"> (' + BSS_B2B.formatMoney(comparePrice) + ') </span>';
        }
        else if (BSS_B2B.storeId === 6652) {
            originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> | ' + BSS_B2B.formatMoney(originPrice) + ' MSRP</span>';
        }
        else if (BSS_B2B.storeId === 8928) {
            originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> MSRP ' + BSS_B2B.formatMoney(originPrice) + '</span>';
            comparePriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' + defaultPriceColor +
                '"> MSRP ' + BSS_B2B.formatMoney(comparePrice) + '</span>';
        }

        return {
            originalPriceHTML: originalPriceHTML,
            comparePriceHTML: comparePriceHTML,
        };
    };

    BSS_B2B.cp.customForStoreWithCPType = function(
        cpType,
        customPrice,
        finalPrice,
        originPrice,
        priceElement,
        productId,
        variant,
        defaultPriceColor,
        priceAppliedCPColor,
        originalPriceHTML,
        comparePriceHTML,
        hideElement,
        isEnableMC,
        parentPriceElement,
        comparePriceElement,
        discountType,
        discountValue,
    ) {
        if (cpType === 0) {
            if (BSS_B2B.storeId === 4608) {
                if (customPrice.variants) {
                    for (let i = 0; i < customPrice.variants.length; i++) {
                        if (customPrice.variants[i].id === variant) {
                            let variantPriceElement = $('[bss-b2b-variant-id="' + variant + '"]');
                            variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                            hideElement.parent().hide();
                            variantPriceElement.css({
                                'color': priceAppliedCPColor,
                                'font-size': '15px',
                            });
                            break;
                        }
                    }
                }
                hideElement.parent().hide();
                priceElement.css('color', 'black');
            }
            else if ([6363].indexOf(BSS_B2B.storeId) !== -1) {
                if (customPrice.variants) {
                    for (let i = 0; i < customPrice.variants.length; i++) {
                        let variantPriceElement = $(
                            '[bss-b2b-variant-id="' + customPrice.variants[i].id + '"][bss-b2b-variant-price]');
                        if (customPrice.variants[i].id && variantPriceElement) {
                            finalPrice = BSS_B2B.getModifiedPrice(customPrice.variants[i].price, discountType,
                                discountValue);
                            variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                            hideElement.parent().hide();
                            variantPriceElement.css({
                                'color': priceAppliedCPColor,
                                'font-size': '15px',
                            });
                        }
                    }
                }
            }
            else if ([6717].indexOf(BSS_B2B.storeId) !== -1) {
                if (customPrice.variants) {
                    for (let i = 0; i < customPrice.variants.length; i++) {
                        if (customPrice.variants[i].id === variant) {
                            let variantPriceElement = $('.price__regular [bss-b2b-variant-id="' + variant + '"]');
                            variantPriceElement.html((finalPrice / 100.0).toFixed(2) + ' SEK');
                            hideElement.parent().hide();
                            variantPriceElement.css({
                                'color': priceAppliedCPColor,
                                'font-size': '15px',
                            });
                        }
                        else {
                            let variantPriceElement = $(
                                '.price__regular [bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id]');
                            variantPriceElement.html((finalPrice / 100.0).toFixed(2) + ' SEK');
                        }
                    }
                }
            }
            else if ([6954].indexOf(BSS_B2B.storeId) !== -1) {
                if (customPrice.variants) {
                    for (let i = 0; i < customPrice.variants.length; i++) {
                        if (customPrice.variants[i].id === variant) {
                            let variantPriceElement = $('[bss-b2b-variant-id="' + variant + '"]');
                            variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                            hideElement.parent().hide();
                            variantPriceElement.css({
                                'color': priceAppliedCPColor,
                                'font-size': '15px',
                            });
                            break;
                        }
                    }
                    if (BSS_B2B.page.isProductPage()) {
                        const variantOptions = $('select.product-variants option[bss-b2b-custom-price-6954]');
                        if (variantOptions.length === customPrice.variants.length) {
                            for (let i = 0; i < customPrice.variants.length; i++) {
                                $(variantOptions[i]).html(customPrice.variants[i].title + ' - ' + '<p>' +
                                    BSS_B2B.formatMoney(finalPrice) + '</p>');
                            }
                        }
                    }
                }
            }
            else if (BSS_B2B.storeId === 8014) {
                if (BSS_B2B.page.isProductPage()) {
                    let originalPriceElement = $('.product-block--price .compare-price .product__price--compare');
                    originalPriceElement.css('text-decoration', 'unset');
                    let originalPrice = parseFloat(
                        $('.product-block--price .compare-price .product__price--compare span[aria-hidden="true"]').
                            html().
                            trim().
                            substring(1));
                    let priceCPElement = parseFloat(
                        $('.product-block--price .offer-price .product__price.on-sale span[aria-hidden="true"] [bss-b2b-product-price]').
                            html().
                            trim().
                            substring(1));
                    if (originalPrice && priceCPElement) {
                        $('.product-block--price .save-price .product__price-savings').
                            html(BSS_B2B.formatMoney((originalPrice - priceCPElement) * 100));
                        $('.product-block--price .save-price .save-percentage').
                            html(`(${Math.round((originalPrice - priceCPElement) / originalPrice * 100)}%)`);
                    }
                }
            }
            else if (BSS_B2B.storeId === 541) {
                let productPriceElements = document.querySelectorAll(
                    '.aprice[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');

                if (productPriceElements && productPriceElements.length) {
                    productPriceElements.forEach(priceElement => {
                        // let priceOfFirstVariant = BSS_B2B.getModifiedPrice(customPrice.variants[0].price,
                        // discountType, discountValue);
                        let priceOfFirstVariant = customPrice.variants[0].price;
                        priceElement.textContent = BSS_B2B.formatMoney(priceOfFirstVariant);
                        let firstPriceValue = priceElement.getAttribute('first-price');
                        let priceSampleElement = priceElement.parentNode.querySelector(
                            '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-sample-price]');

                        if (priceSampleElement && firstPriceValue) {
                            firstPriceValue = parseFloat(firstPriceValue);

                            let priceSampleOfFirstVariant = priceOfFirstVariant / firstPriceValue;
                            priceSampleElement.innerHTML = BSS_B2B.formatMoney(priceSampleOfFirstVariant);

                            let comparePriceElement = priceElement.parentNode.querySelector(
                                '.dprice[bss-b2b-product-id="' + productId + '"]');
                            if (comparePriceElement) {
                                comparePriceElement.remove();
                            }
                        }
                    });
                }

                if (BSS_B2B.page.isProductPage()) {
                    let comparePriceElements = document.querySelectorAll(
                        '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]');
                    if (comparePriceElements && comparePriceElements.length) {
                        comparePriceElements.forEach(comparePriceElement => {
                            comparePriceElement.remove();
                        });
                    }
                }
            }
        }
        else if (cpType === 1) {
            if (BSS_B2B.storeId === 4272) {
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').
                    html(comparePriceHTML + '<span style="margin-left: 10px; color: ' + priceAppliedCPColor + '">' +
                        BSS_B2B.formatMoney(finalPrice) + '</span>');
            }
            else if ([4522, 4945].indexOf(BSS_B2B.storeId) !== -1) {
                let newComparePriceHTML = comparePriceHTML + '<span style="margin-left: 5px; color: ' +
                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>';
                let productPriceParentElement = $(
                    '[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]');
                let productPriceElement = $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]');
                productPriceParentElement.html(newComparePriceHTML);
                productPriceParentElement.css('visibility', 'visible');
                productPriceElement.html(newComparePriceHTML);
                productPriceElement.css('visibility', 'visible');
            }
            else if ([3740].includes(BSS_B2B.storeId)) {
                let productPriceElement = $(priceElement).closest('.product-price');
                productPriceElement.prepend(originalPriceHTML);
            }
        }
        else if (cpType === 2) {
            if (isEnableMC) {
                // fix for storeID 8356, 4927
                window.BSS_B2B.executeAction({
                    tag: 'customize_cp_mc',
                    storeId: false,
                    BSS_B2B, variant, priceElement, originalPriceHTML,
                    priceAppliedCPColor, defaultPriceColor, finalPrice, customPrice
                });
            }
            if (BSS_B2B.storeId === 4272) {
                hideElement.hide();
                if (variant) {
                    if (customPrice.variants) {
                        for (let i = 0; i < customPrice.variants.length; i++) {
                            if (customPrice.variants[i].id === variant) {
                                originPrice = customPrice.variants[i].price;
                                originalPriceHTML = '<del class="bss-b2b-customized-original-price" style="color: ' +
                                    defaultPriceColor + '"> ' + BSS_B2B.formatMoney(originPrice) + ' </del>';

                                break;
                            }
                        }
                    }
                }
                let newOriginalPriceHTML = originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>';
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]').hide();
                if (!$('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').length &&
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]')) {
                    if ($('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').length) {
                        $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').
                            html(newOriginalPriceHTML);
                    }
                }
            }
            else if (BSS_B2B.storeId === 5065) {
                hideElement.hide();
                if (variant) {
                    if (customPrice.variants) {
                        for (let i = 0; i < customPrice.variants.length; i++) {
                            if (customPrice.variants[i].id == variant) {
                                originPrice = customPrice.variants[i].price;
                                originalPriceHTML = '<del class="bss-b2b-customized-original-price" style="color: ' +
                                    defaultPriceColor + '"> ' + BSS_B2B.formatMoney(originPrice) + ' </del>';
                                break;
                            }
                        }
                    }
                }
                let newOriginalPriceHTML = originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>';
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]').hide();
                if (!$('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').length &&
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]')) {
                    if ($('[bss-b2b-product-id="' + productId +
                        '"][bss-b2b-product-parent-price]:not([bss-b2b-custom-option-5065])').length) {
                        $('[bss-b2b-product-id="' + productId +
                            '"][bss-b2b-product-parent-price]:not([bss-b2b-custom-option-5065])').
                            html(newOriginalPriceHTML);
                    }
                }
                if (BSS_B2B.page.isProductPage()) {
                    const variantOptions = $('select.pf-variant-select option');
                    if (variantOptions.length === customPrice.variants.length) {
                        for (let i = 0; i < customPrice.variants.length; i++) {
                            let finalPriceOption = BSS_B2B.getModifiedPrice(customPrice.variants[i].price, discountType,
                                discountValue);
                            $(variantOptions[i]).html(customPrice.variants[i].title + ' - ' + '<p>' +
                                BSS_B2B.formatMoney(finalPriceOption) + '</p>');
                        }
                    }
                }
            }
            else if ([4522].indexOf(BSS_B2B.storeId) !== -1) {
                let newOriginalPriceHTML = originalPriceHTML + '<span style="margin-left: 5px; color: ' +
                    priceAppliedCPColor + '">' + BSS_B2B.formatMoney(finalPrice) + '</span>';
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]').css('display', 'none');
                if ($('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-lowest-price]')) {
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-lowest-price]').
                        css('color', priceAppliedCPColor);
                }
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').html(newOriginalPriceHTML);
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').css('visibility', 'visible');
                $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').
                    css('visibility', 'visible');
            }
            else if ([5912].indexOf(BSS_B2B.storeId) !== -1) {
                hideElement.hide();
                let savePriceHTML = false;
                if (variant) {
                    if (customPrice.variants.length) {
                        for (let i = 0; i < customPrice.variants.length; i++) {
                            if (customPrice.variants[i].id == variant) {
                                originPrice = customPrice.variants[i].price;
                                let savePrice = originPrice - finalPrice;
                                savePriceHTML = '<span class="bss-b2b-customized-save-price" style="background: #e00102; border-radius: 3px; font-weight: 600; font-size:14px; padding: 2px 10px; color:#ffffff">Save ' +
                                    BSS_B2B.formatMoney(-savePrice) + ' </span>';
                                originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' +
                                    defaultPriceColor + '">MSRP: ' + BSS_B2B.formatMoney(originPrice) + ' </span>';
                                break;
                            }
                        }
                    }
                }
                else {
                    let savePrice = originPrice - finalPrice;
                    savePriceHTML = '<span class="bss-b2b-customized-save-price" style="background: #e00102; border-radius: 3px; font-weight: 600; font-size:14px; padding: 2px 10px; color:#ffffff">Save ' +
                        BSS_B2B.formatMoney(-savePrice) + ' </span>';
                    originalPriceHTML = '<span class="bss-b2b-customized-original-price" style="color: ' +
                        defaultPriceColor + '">MSRP: ' + BSS_B2B.formatMoney(originPrice) + ' </span>';
                }
                let newOriginalPriceHTML = originalPriceHTML + '<span style="margin-left: 10px; color: ' +
                    priceAppliedCPColor + '"> Reseller Cost: ' + BSS_B2B.formatMoney(finalPrice) + '</span>';
                if (savePriceHTML) {
                    $('.product-meta .product-meta__label-list').html(savePriceHTML);
                }
                const checkElmCustomTheme = $('[bss-b2b-custom-5912-product-price]');
                if (checkElmCustomTheme.length && BSS_B2B.page.isProductPage()) {
                    originalPriceHTML = '<del class="bss-b2b-customized-original-price" style="color: ' +
                        defaultPriceColor + '">' + BSS_B2B.formatMoney(originPrice) + ' </del>';
                    newOriginalPriceHTML = '<span style="margin-left: 10px; color: ' + priceAppliedCPColor + '">' +
                        BSS_B2B.formatMoney(finalPrice) + '</span>';
                    $('[bss-b2b-custom-5912-product-price]').html(newOriginalPriceHTML);
                }
                else {
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').
                        html(newOriginalPriceHTML);
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]').html(newOriginalPriceHTML);
                    $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-compare-price]').hide();
                    if (!$('[bss-b2b-product-id="' + productId + '"][bss-b2b-current-variant-price]').length &&
                        $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-price]')) {
                        if ($('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').length) {
                            $('[bss-b2b-product-id="' + productId + '"][bss-b2b-product-parent-price]').
                                html(newOriginalPriceHTML);
                        }
                    }
                }
            }
            else if ([5885, 3762].includes(BSS_B2B.storeId)) {
                priceElement.before(originalPriceHTML);
            }
            else if ([2933].includes(BSS_B2B.storeId)) {
                if (hideElement) {
                    hideElement.hide();
                }
                if (variant) {
                    let variantOriginPrice = 0;
                    let variantPriceElement = $(
                        '[bss-b2b-product-id="' + productId + '"][bss-b2b-variant-id][bss-b2b-product-price],' +
                        '.price__pricing-group .price__sale [bss-b2b-product-id="' + productId +
                        '"][bss-b2b-product-parent-price]');
                    if (customPrice && customPrice.variants && customPrice.variants.length > 0) {
                        let comparePrice = customPrice.compareAtPriceMin;
                        customPrice.variants.every((item) => {
                            variantOriginPrice = item.price;
                            if (item.id.toString() === variant) {
                                comparePrice = item.compare_at_price;
                                return false;
                            }
                            return true;
                        });
                        if (comparePrice) {
                            if (variantOriginPrice < comparePrice) {
                                let originPriceElement = BSS_B2B.createComparePriceElement('span',
                                    'bss-b2b-customized-compare-at-price', variant, productId, variantOriginPrice,
                                    'line-through', '0 1rem 0 0', defaultPriceColor);
                                let variantParentEle = variantPriceElement.parent();
                                let variantPriceHTML = variantPriceElement.prop('outerHTML');
                                if (finalPrice < variantOriginPrice) {
                                    if (parentPriceElement.length !== 0) {
                                        parentPriceElement.html(BSS_B2B.formatMoney(variantOriginPrice));
                                    }
                                    else {
                                        variantParentEle.empty();
                                        variantParentEle.append(variantPriceHTML);
                                        variantPriceElement = $('[bss-b2b-product-id="' + productId +
                                            '"][bss-b2b-variant-id][bss-b2b-product-price],' +
                                            '.price__pricing-group .price__sale [bss-b2b-product-id="' + productId +
                                            '"][bss-b2b-product-parent-price]');
                                        variantPriceElement.before(originPriceElement);
                                    }
                                    variantPriceElement.html(BSS_B2B.formatMoney(finalPrice));
                                    comparePriceElement.css({
                                        'color': defaultPriceColor,
                                        'text-decoration': 'line-through',
                                    });
                                    variantPriceElement.css('color', priceAppliedCPColor);
                                    if (discountType === 2) {
                                        if (variantParentEle.length
                                            &&
                                            variantParentEle.parent().parent().find('.bss-b2b-cp-customize-text').length
                                        ) {
                                            variantParentEle.parent().
                                                parent().
                                                find('.bss-b2b-cp-customize-text').
                                                remove();
                                        }
                                        variantPriceElement.after(
                                            '<span class="bss-b2b-cp-customize-text">(' + discountValue +
                                            '% OFF)</span>');
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    if (hideElement) {
                        hideElement.show();
                    }
                    if (customPrice.compareAtPriceMin > customPrice.price) {
                        if (customPrice.price > finalPrice) {
                            let priceParentEle = priceElement.parent();
                            if (priceParentEle.find('.bss-b2b-customized-original-price').length) {
                                priceParentEle.find('.bss-b2b-customized-original-price').remove();
                            }
                            if (comparePriceElement.length) {
                                comparePriceElement.html(originalPriceHTML);
                            }
                            else {
                                priceElement.before(originalPriceHTML);
                            }
                            if (discountType === 2) {
                                if (window.location.pathname === '/search' || window.location.pathname === '/') {
                                    comparePriceElement = $('del.bss-b2b-customized-original-price');
                                    if (comparePriceElement.parent().
                                        parent().
                                        find('.bss-b2b-cp-customize-text').length) {
                                        comparePriceElement.parent().
                                            parent().
                                            find('.bss-b2b-cp-customize-text').
                                            remove();
                                    }
                                    comparePriceElement.parent().
                                        after('<span class="bss-b2b-cp-customize-text" style="display: inline;">(' +
                                            discountValue + '% OFF)</span>');
                                    comparePriceElement.parent().parent().find('span').last().css('display', 'none');
                                }
                                else {
                                    if (priceParentEle.find('.bss-b2b-cp-customize-text').length) {
                                        priceParentEle.find('.bss-b2b-cp-customize-text').remove();
                                    }
                                    priceElement.after(
                                        '<span class="bss-b2b-cp-customize-text">(' + discountValue + '% OFF)</span>');
                                }
                            }
                        }
                        else if (customPrice.price === finalPrice) {
                            comparePriceElement.length
                                ? comparePriceElement.html(comparePriceHTML)
                                : priceElement.before(comparePriceHTML);
                        }
                        else if (customPrice.price < finalPrice) {
                            //    do nothing
                        }
                    }
                }
            } else if ([6809].includes(BSS_B2B.storeId)) {
                const comparePriceDefault = document.querySelectorAll(".price__last .price-item .bss-b2b-customized-original-price, .price__compare .price-item");
                if (comparePriceDefault && comparePriceDefault.length) {
                    comparePriceDefault.forEach(item => item.remove());
                }
                priceElement.before(originalPriceHTML);
            }
        }
    };
}
// CONCATENATED MODULE: ./js/src/cp/init-custom-pricing.js


function initCp($, BSS_B2B, shopData, firstLoadProduct, isEnableAMO, isEnableMc, isEnableQB) {
    changeProductPrice($, BSS_B2B, shopData, firstLoadProduct, isEnableMc, isEnableAMO, isEnableQB);
    changeCPSetting($, BSS_B2B);
}

// CONCATENATED MODULE: ./js/src/taxexem/initTD.js



function initTD(BSS_B2B) {
    BSS_B2B.td = BSS_B2B.td || {};

    BSS_B2B.td.getAppliedRule = taxDisplayRules_default.a.getAppliedRule;
    BSS_B2B.td.getAppliedRuleCartPage = taxDisplayRules_default.a.getAppliedRuleCartPage;
    BSS_B2B.td.getAppliedRuleCollectionPage = taxDisplayRules_default.a.getAppliedRuleCollectionPage;
    BSS_B2B.td.clientValidateVat = tax_default.a.clientValidateVat;
    BSS_B2B.td.changeVatPriceOnQBABTable = tax_default.a.bssB2BChangeVatPriceOnQBABTable;
    BSS_B2B.td.changeVatPriceOnABRange = tax_default.a.bssB2BChangeVatPriceOnABRange;
    BSS_B2B.td.changeCollectionItemVatPriceWithoutCP = tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP;
    BSS_B2B.td.showProductPriceIncludedVat = tax_default.a.showProductPriceIncludedVat;
    BSS_B2B.td.handleVariantChangeEvents = tax_default.a.handleVariantChangeEvents;
    BSS_B2B.td.changeAllVatPriceQtyChangeWithoutCPOnCart = tax_default.a.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP;
}

// EXTERNAL MODULE: ./js/src/checkout/modify-checkout.js
var modify_checkout = __webpack_require__(12);

// EXTERNAL MODULE: ./js/src/checkout/handle-buy-it-now.js
var handle_buy_it_now = __webpack_require__(13);

// CONCATENATED MODULE: ./js/src/checkout/init-checkout.js


function initCheckout($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableAMO, isEnableDC, isEnabledQI) {
    Object(modify_checkout["a" /* default */])($, BSS_B2B, shopData, isEnableAMO, isEnableDC, isEnableQB);
    Object(handle_buy_it_now["a" /* default */])($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableAMO, isEnabledQI);
}

// CONCATENATED MODULE: ./js/src/cart/handle-cart-price.js



function handleCartPrice(
    $, BSS_B2B, shopData, isEnableQB, isEnableCP, isEnableAMO, isEnableMc, isEnabledTD, isEnableEF, isEnabledTE,
    isEnableDC, isEnabledQI, isEnableBOGO,
) {
    BSS_B2B.cart.isExistedUpdateCartBtn = $('form[action*="/cart"] button[type="submit"][name="update"]:visible, ' +
        'form[action*="/cart"] input[type="submit"][name="update"]:visible,form[action*="/cart"] .update.btn.item' +
        BSS_B2B.getCartPriceClass('cart_update_cart_btn')).length > 0;

    const debounceStore = {};

    BSS_B2B.cart.cartQtyOnChange = function (timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad) {
        if ([3903].includes(BSS_B2B.storeId)) return;
        if (BSS_B2B.amo.warning && (BSS_B2B.amo.warning.length > 0)) {
            BSS_B2B.amo.warning = [];
        }
        if (![8741, 13069, 11574].includes(BSS_B2B.storeId)) {
            $(BSS_B2B.cart.inputQuantityElement).prop('disabled', true);
        }

        if (typeof BSS_PO !== 'undefined' && BSS_PO.enable && BSS_PO.enableInCart) {
            BSS_PO.changeQuantity = 0;
            document.querySelectorAll('.bss-qb-cart-subtotal,' + '.bss-qb-price-item,' + '.bss-qb-total-price-item,' +
                '[bss-b2b-item-final-price],' + '[bss-b2b-item-original-price],' + '[bss-b2b-final-line-price],' +
                '[bss-b2b-original-line-price], ' + '[bss-b2b-cart-total-price]').forEach(element => {
                    element.style.opacity = '0';
                });
        }
        if ([437].indexOf(BSS_B2B.storeId) !== -1) {
            const checkoutElement = BSS_B2B.cart.checkoutBtnElement();
            let disableCheckout = true;
            BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
        }
        if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
            $('[data-cart-item-regular-price],' + '[bss-b2b-item-price],' + '[data-cart-subtotal],' +
                '[bss-b2b-ajax-cart-subtotal],' +
                '[data-cart-item-id]  [data-cart-item-price-container] .cart-item__original-price,' +
                '[data-cart-item-id]  [data-cart-item-line-price-container] .cart-item__original-price,' +
                '.cartTotalSelector,' + '.cart_subtotal' + BSS_B2B.getCartPriceClass('cart_total') +
                BSS_B2B.getCartPriceClass('cart_subtotal') + BSS_B2B.getCartPriceClass('cart_item_regular_price') +
                BSS_B2B.getCartPriceClass('cart_item_original_price')).hide();
        }
        //Fix for dnd-dice
        let checkoutButton = $(BSS_B2B.helper.checkoutElements);
        if (checkoutButton.length > 0) {
            let timeDelay = 4000;

            if ([177, 7211, 5686, 2756].indexOf(BSS_B2B.storeId) !== -1) {
                timeDelay = 2000;
            }
            if ([7788, 9225, 13913, 12303, 8194, 15270].indexOf(BSS_B2B.storeId) !== -1) {
                timeDelay = 1000;
            }

            if([13186].includes(BSS_B2B.storeId)) {
                timeDelay = 5000;
            }

            if (BSS_B2B.storeId !== 8741) {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, true, false);
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                }, timeDelay);
            }
            else {
                const handleCart = function () {
                    BSS_B2B.cart.fixer(shopData, true, false);
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                };

                if (!debounceStore['handleCart']) {
                    debounceStore['handleCart'] = BSS_B2B.debounce(handleCart, timeDelay);
                }
                debounceStore['handleCart']();
            }
        }
        else {
            // fix for hibacart by CuongNVM
            if ([4649, 6598, 5077, 6652].includes(BSS_B2B.storeId)) {
                timeDelayToReCalculate = 2000;
            }

            if (BSS_B2B.storeId !== 8741) {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, true, false);
                }, timeDelayToReCalculate);
            }
            else {
                if (!debounceStore['cartQtyOnChange_cart-fixer']) {
                    debounceStore['cartQtyOnChange_cart-fixer'] = BSS_B2B.debounce(BSS_B2B.cart.fixer,
                        timeDelayToReCalculate);
                }
                debounceStore['cartQtyOnChange_cart-fixer'](shopData, true, false);
            }
        }

        if (BSS_B2B.storeId !== 8741) {
            setTimeout(function () {
                $(BSS_B2B.cart.inputQuantityElement).prop('disabled', false);
            }, isFirstLoad ? 2500 : timeDelayToChangeQuantity);
        }
    };

    BSS_B2B.cart.updateWhenItemQuantityChange = function (
        shopData, cartData, isChangeQuantity, isAjaxCart, productMap, updatedLineItems, isFirstLoad) {
        if (BSS_B2B.storeId === 1055) {
            $('.ajax-cart__button-submit').attr('disabled', true);
        }
        let originalTotalPrice = cartData.original_total_price;
        let itemsSubtotalPrice = cartData.items_subtotal_price;
        let totalDiscount = 0;

        let timeDelayToReCalculate = 1200;
        let customTimeDelayToReCalculate = BSS_B2B.getCssSelector('cart_time_delay_re_calculate');
        if (customTimeDelayToReCalculate !== '' && !isNaN(customTimeDelayToReCalculate)) {
            timeDelayToReCalculate = parseInt(customTimeDelayToReCalculate);
        }
        let timeDelayToChangeQuantity = 2000;
        let customTimeDelayToChangeQuantity = BSS_B2B.getCssSelector('cart_time_delay_changing_qty');
        if (customTimeDelayToChangeQuantity !== '' && !isNaN(customTimeDelayToChangeQuantity)) {
            timeDelayToChangeQuantity = parseInt(customTimeDelayToChangeQuantity);
        }
        let inputQuantityElement = $(BSS_B2B.cart.inputQuantityElement);

        let buttonChangeQuantity = $(BSS_B2B.cart.buttonChangeQuantity);
        let cpPricingList = new Map();
        let totalItemWithVat = 0;
        let totalItemNoVat = 0;
        let appliedDisplayRule = null;
        if (isEnabledTD && BSS_B2B.taxDisplayRules && (BSS_B2B.taxDisplayRules.length > 0)) {
            appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCartPage(BSS_B2B, shopData);
        }

        // fix cart item order tax display for birkdale-smart-home (madu)
        if (BSS_B2B.storeId === 2833) {
            updatedLineItems.reverse();
        }
        if (appliedDisplayRule && BSS_B2B.storeId === 2896 && document.getElementById('bss-b2b-cart-vat-style')) {
            document.getElementById('bss-b2b-cart-vat-style').remove();
        }

        // fix for dschinni-shisha.com by cuongnq
        if (!appliedDisplayRule && document.getElementById('bss-b2b-cart-vat-style') &&
            [8446].includes(BSS_B2B.storeId)) {
            document.getElementById('bss-b2b-cart-vat-style').remove();
        }

        for (let i = 0; i < cartData.items.length; i++) {
            let item = cartData.items[i];
            let originalPrice = item.original_price;
            let originalLinePrice = item.original_line_price;
            let unitPrice = item.unit_price;
            let modifiedItemPrice = originalPrice;
            let modifiedLineItemPrice = originalLinePrice;
            let comparePrice = item.original_price;
            let priceItemForTaxDisplay = item.original_price;
            let priceLineItemForTaxDisplay = item.original_line_price;
            let comparePriceForTaxDisplay = null;
            let appliedTax = null;
            let itemKeyUnique = [];
            let cartVatElement = $('.bss-b2b-cart-vat[data-cart-vat-item-key="' + item.key + '"]');
            if (cartVatElement.length) {
                appliedTax = tax_default.a.bssB2BGetAppliedTaxRate(cartVatElement.attr('data-cart-item-collections'));

            }

            for (let j = 0; j < productMap.length; j++) {
                if (item.product_id === productMap[j].id) {
                    for (let m = 0; m < productMap[j].variants.length; m++) {
                        if (item.variant_id === productMap[j].variants[m].id) {
                            comparePrice = productMap[j].variants[m].compare_at_price;
                            break;
                        }
                    }
                    break;
                }
            }
            for (let k = 0; k < updatedLineItems.length; k++) {
                if (item.product_id === updatedLineItems[k].id
                    &&
                    (updatedLineItems[k].variants ? updatedLineItems[k].variants.includes(item.variant_id + '') : true)
                    && !itemKeyUnique.includes(item.key)
                ) {
                    itemKeyUnique.push(item.key);
                    let discountValueOfRule = parseFloat(updatedLineItems[k].value);
                    let type = updatedLineItems[k].discount_type;

                    if (type === 0) {
                        let flatPrice = parseFloat(updatedLineItems[k].value) * 100;
                        modifiedItemPrice = flatPrice > originalPrice ? originalPrice : flatPrice;
                        modifiedLineItemPrice = modifiedItemPrice * item.quantity;
                    }
                    else if (type === 1) {
                        modifiedItemPrice = (discountValueOfRule * 100 > originalPrice) ? 0 : (originalPrice -
                            discountValueOfRule * 100);
                        modifiedLineItemPrice = modifiedItemPrice * item.quantity;
                    }
                    else if (type === 2) {
                        //fix for discount is odd orr price is odd
                        modifiedLineItemPrice = modifiedItemPrice * item.quantity;
                        modifiedItemPrice = originalPrice -
                            ((((originalPrice * (discountValueOfRule / 100)).toFixed(2)) / 100).toFixed(2) * 100);
                        // fix for canicoolhq by Leorio
                        if (BSS_B2B.storeId === 1508) {
                            if (modifiedItemPrice % 0.5 === 0) {
                                modifiedItemPrice = Math.round(modifiedItemPrice);
                            }
                        }
                        modifiedLineItemPrice = originalLinePrice -
                            ((((originalPrice * (discountValueOfRule / 100)).toFixed(2)) / 100).toFixed(2) * 100) *
                            item.quantity;
                    }

                    modifiedItemPrice = BSS_B2B.getModifiedPrice(originalPrice, type, discountValueOfRule);

                    let modifiedLineItemPriceWithMarket = parseFloat(modifiedItemPrice).toFixed(0) * item.quantity;
                    totalDiscount += originalLinePrice - modifiedLineItemPriceWithMarket;

                    if (item.unit_price) {
                        unitPrice = (modifiedItemPrice * parseFloat(item.unit_price)) / parseFloat(item.original_price);
                    }

                    let cartItemProductMap = new Map();
                    if (cartData.items && cartData.items.length > 0) {
                        let handles = [];

                        cartData.items.forEach(function (item) {
                            let proId = item.product_id;
                            if (handles.indexOf(proId) === -1) {
                                handles.push(proId);
                            }
                            let productVariants = cartItemProductMap.get(proId);
                            if (!productVariants || productVariants === undefined) {
                                cartItemProductMap.set(proId, []);
                                productVariants = [];
                            }
                            productVariants.push({
                                key: item.key, quantity: item.quantity, id: item.variant_id, price: item.price,
                            });
                            cartItemProductMap.set(proId, productVariants);
                        });
                    }

                    cpPricingList.set(item.key, {
                        modifiedLineItemPrice: modifiedLineItemPrice,
                        modifiedLineItemPriceWithMarket: modifiedLineItemPriceWithMarket,
                        modifiedItemPrice: modifiedItemPrice,
                        key: item.key,
                        id: item.id,
                        quantity: item.quantity,
                        discountType: type,
                        discountValue: discountValueOfRule,
                    });

                    // add cpRule and origin price to subscription
                    if (window.BSS_SUB
                        && Object.keys(window.BSS_SUB.subItems).length
                        && item.selling_plan_allocation
                    ) {
                        const planId = item.selling_plan_allocation.selling_plan.id;
                        let variants = window.BSS_SUB.subItems[planId].variants;
                        variants = variants.map(sub_item => {
                            sub_item.originPrice = BSS_B2B.cart.variantStorage.get(item.id).price;
                            if (sub_item.key == item.key) {
                                sub_item.cpRule = {
                                    discountType: type,
                                    discountValue: discountValueOfRule
                                }
                            }
                            return sub_item
                        })
                        window.BSS_SUB.subItems[planId].variants = variants;
                    }

                    // for compare with purchase-late of bcp by Leorio
                    if (window.location.pathname === '/apps/customer-portal/purchase-late' &&
                        ![7848, 15411].includes(BSS_B2B.storeId)) {
                        $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + item.key + '"]').
                            css('text-decoration', 'line-through');
                        let priceLineItemHTML = '<span class="bss-b2b-bcp-new-line-item-price"' +
                            ' bss-b2b-bcp-cart-item-key= "' + item.key + '"' + ' bss-shop-base-currency="' +
                            modifiedLineItemPrice + '"' + ' style="display: block;">' +
                            BSS_B2B.formatMoney(modifiedLineItemPrice) + '</span>';
                        if ($('[bss-b2b-bcp-cart-item-key="' + item.key + '"][bss-b2b-bcp-line-item-price]').
                            parent().
                            find('[bss-b2b-bcp-cart-item-key="' + item.key +
                                '"].bss-b2b-bcp-new-line-item-price').length === 0) {
                            $('[bss-b2b-bcp-line-item-price][bss-b2b-bcp-cart-item-key="' + item.key + '"]').
                                after(priceLineItemHTML);
                        }
                        if (BSS_B2B.storeId === 8713) {
                            let itemPrice = $(
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                            if (itemPrice) {
                                itemPrice.html(BSS_B2B.formatMoney(modifiedLineItemPrice, shopData.shop.money_format));
                            }
                        }
                    }
                    else {
                        let isChanged = BSS_B2B.fix.cp.fixCartItem(item, modifiedItemPrice, modifiedLineItemPrice);

                        // item
                        if (!isChanged.itemPrice) {
                            let itemPriceSelectors = [
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]',
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-final-price]',
                                '[data-cart-item-id="' + item.key +
                                '"]  [data-cart-item-price-container] .cart-item__original-price',
                                '[bss-b2b-cart-item-key="' + item.key + '"] .cart__item-price'].join(',');
                            if (BSS_B2B.storeId === 8928) {
                                $(itemPriceSelectors).html('WSP ' + BSS_B2B.formatMoney(modifiedItemPrice));
                            }
                            // custom for 9d1d52-2.myshopify.com by quyen pv
                            else if (BSS_B2B.storeId === 11776) {
                                $(itemPriceSelectors).html(BSS_B2B.formatMoney(modifiedItemPrice));
                                let customizeCPElement = document.querySelector(
                                    '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                                if (!customizeCPElement.nextSibling || customizeCPElement.nextSibling.className !=
                                    'bss-b2b-custom-cp-rule') {
                                    let appendElement = document.createElement('span');
                                    appendElement.innerHTML = `&nbsp;&nbsp;&nbsp;${updatedLineItems[k].name}`;
                                    appendElement.classList.add('bss-b2b-custom-cp-rule');
                                    $(itemPriceSelectors).after(appendElement);
                                }
                            }
                            else {
                                $(itemPriceSelectors).html(BSS_B2B.formatMoney(modifiedItemPrice));
                            }
                        }
                        // line item
                        if (!isChanged.lineItemPrice) {
                            let lineItemPriceSelectors = [
                                '[bss-b2b-original-line-price][bss-b2b-cart-item-key="' + item.key + '"]',
                                '[bss-b2b-final-line-price][bss-b2b-cart-item-key="' + item.key + '"]',
                                '[bss-b2b-ajax-cart-line-price][bss-b2b-cart-item-key="' + item.key + '"]',
                                '[bss-b2b-ajax-original-line-price][bss-b2b-cart-item-key="' + item.key + '"]',
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-ajax-original-line-price]',
                                '[bss-b2b-cart-item-key="' + item.product_id + '"][bss-b2b-ajax-cart-line-price]',
                                '[data-cart-item-id="' + item.key +
                                '"]  [data-cart-item-line-price-container] .cart-item__original-price',
                                '[bss-b2b-cart-item-key="' + item.id + '"][bss-b2b-ajax-original-line-price]',
                                '.mini-products-list #cart-item-' + item.variant_id + ' .price'].join(',');

                            if ([12385].includes(BSS_B2B.storeId)) {
                                let lineItemPriceSelectors = [
                                    '[bss-b2b-original-line-price][bss-b2b-cart-item-key="' + item.key +
                                    '"][bss-custom="false"]',
                                    '[bss-b2b-final-line-price][bss-b2b-cart-item-key="' + item.key +
                                    '"][bss-custom="false"]'].join(',');
                                let originalPriceElement = $(lineItemPriceSelectors).eq(0);
                                let finalPriceElement = $(lineItemPriceSelectors).eq(1);
                                originalPriceElement.html(BSS_B2B.formatMoney(modifiedLineItemPriceWithMarket));
                                originalPriceElement.attr('bss-custom', 'true');
                                finalPriceElement.html(BSS_B2B.formatMoney(modifiedLineItemPriceWithMarket));
                                finalPriceElement.attr('bss-custom', 'true');
                            }
                            else {
                                $(lineItemPriceSelectors).html(BSS_B2B.formatMoney(modifiedLineItemPriceWithMarket));
                            }
                            if (BSS_B2B.storeId === 437) {
                                setTimeout(function () {
                                    $(lineItemPriceSelectors).html(BSS_B2B.formatMoney(modifiedLineItemPrice));
                                }, 4500);
                            }
                        }
                        // unit price
                        if (BSS_B2B.storeId === 1676 && typeof unitPrice == 'undefined') {
                            $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-cart-item-unit-price]').
                                html(BSS_B2B.formatMoney(modifiedItemPrice));
                        }
                        else {
                            $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-cart-item-unit-price]').
                                html(BSS_B2B.formatMoney(unitPrice));
                        }
                        if ([3576, 4094].indexOf(BSS_B2B.storeId) === -1) {
                            $('[data-cart-item][data-variant-id="' + item.variant_id + '"] .money').
                                html(BSS_B2B.formatMoney(modifiedItemPrice));
                            $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-unit-1737]').
                                html(BSS_B2B.formatMoney(modifiedItemPrice / 24));
                            let itemPriceElement = $('[data-cart-item][data-variant-id="' + item.variant_id + '"]');
                            if (itemPriceElement.closest('form[action*="/checkout"]').find('.cart_subtotal')) {
                                let parent = itemPriceElement.closest('form[action*="/checkout"]').
                                    find('.cart_subtotal');
                                if (parent.find('.money').length > 0) {
                                    parent.find('.money').html(BSS_B2B.formatMoney(itemsSubtotalPrice - totalDiscount));
                                }
                            }
                        }
                        // fix for imageexchange
                        let parentImageExchangeAjaxItemLinePrice = $(
                            'a[href*="variant=' + item.variant_id + '"].cart-image').closest('.cart-row');
                        if (parentImageExchangeAjaxItemLinePrice.length) {
                            let imageExchangeAjaxItemLinePrice = $(parentImageExchangeAjaxItemLinePrice[0]).
                                find('[bss-b2b-product-id][bss-b2b-product-handle][bss-b2b-variant-id]');
                            $(imageExchangeAjaxItemLinePrice).html(BSS_B2B.formatMoney(modifiedLineItemPrice));
                            $('[bss-b2b-product-id][bss-b2b-product-handle][bss-b2b-variant-id]').
                                css('visibility', 'visible');
                        }
                        // end

                        // fix for industrial-athletic (vitu)
                        let variantIds = [];
                        $.each($('.tt-cart-list .tt-item .tt-item-close a:first-child'), function () {
                            let hrefProducts = [];
                            hrefProducts.push(this.getAttribute('href'));
                            hrefProducts.forEach(v => {
                                variantIds.push(v.substring(v.indexOf('id='), v.indexOf('&')).replace('id=', ''));
                            });
                        });
                        $.each($('.tt-cart-list .tt-item [data-cart-item][data-variant-id].tt-price'), function (i) {
                            this.setAttribute('data-variant-id', variantIds[i]);
                        });
                        $('[data-cart-item][data-variant-id="' + item.variant_id + '"].tt-price').
                            html(BSS_B2B.formatMoney(modifiedItemPrice));
                        // end fix for industrial-athletic (vitu)

                        let customCartOriginalPrice = BSS_B2B.getCssSelector('ajax_cart_item_original_price');
                        if (customCartOriginalPrice !== '') {
                            if (isAjaxCart) {
                                customCartOriginalPrice = customCartOriginalPrice.replace(/itemkey/g, item.key);
                                customCartOriginalPrice = customCartOriginalPrice.replace(',', '');
                                $(customCartOriginalPrice).html(BSS_B2B.formatMoney(modifiedItemPrice));
                            }
                        }

                        // SHOW VAT PRICE
                        priceItemForTaxDisplay = modifiedItemPrice;
                        priceLineItemForTaxDisplay = modifiedLineItemPrice;
                    }

                    let itemPriceEl = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                    let hideElement = $('[bss-b2b-cart-item-key="' + item.key + '"] [bss-b2b-item-compare-price]');
                    let cpType = BSS_B2B.cpSettings.cpType ? BSS_B2B.cpSettings.cpType : 0;
                    let defaultPriceColor = BSS_B2B.cpSettings.default_price_color
                        ? BSS_B2B.cpSettings.default_price_color
                        : '#000000';
                    let priceAppliedCPColor = BSS_B2B.cpSettings.price_applied_cp_color
                        ? BSS_B2B.cpSettings.price_applied_cp_color
                        : '#000000';
                    let comparePriceHTML = '<span class="bss-b2b-compare-at-price" bss-b2b-compare-price style="text-decoration: line-through; color: ' +
                        defaultPriceColor + '">' + BSS_B2B.formatMoney(comparePrice) + '</span>';
                    let originalPriceHTML = '<span class="bss-b2b-compare-at-price" bss-b2b-compare-price style="text-decoration: line-through; color: ' +
                        defaultPriceColor + '">' + BSS_B2B.formatMoney(originalPrice) + '</span>';
                    itemPriceEl.css('color', priceAppliedCPColor);
                    if (BSS_B2B.storeId === 1792) {
                        if (hideElement) {
                            hideElement.hide();
                        }
                        $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]').
                            css('color', 'red');
                    }
                    // fix for woodenplayroom.myshopify.com by hoaduong
                    if ([3588, 5273].indexOf(BSS_B2B.storeId) !== -1) {
                        if (hideElement) {
                            hideElement.hide();
                        }
                    }
                    if ([4856, 6289, 6412, 6366, 6365].includes(BSS_B2B.storeId)) { // custom for nimbus-focal by DongNV
                        originalPriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price"' +
                            ' style="color: ' + defaultPriceColor + ';margin-right: 10px;"> (' +
                            BSS_B2B.formatMoney(originalPrice) + ') </span>';
                        comparePriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price"' +
                            ' style="color: ' + defaultPriceColor + ';margin-right: 10px;"> (' +
                            BSS_B2B.formatMoney(comparePrice) + ') </span>';
                    }
                    if (BSS_B2B.storeId === 6652) {
                        originalPriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price"' +
                            ' style="color: ' + defaultPriceColor + ';"> | ' + BSS_B2B.formatMoney(originalPrice) +
                            ' MSRP</span>';
                    }
                    if (BSS_B2B.storeId === 8928) {
                        originalPriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price"' +
                            ' style="color: ' + defaultPriceColor + ';"> MSRP ' + BSS_B2B.formatMoney(originalPrice) +
                            '</span>';
                        comparePriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price"' +
                            ' style="color: ' + defaultPriceColor + ';"> MSRP ' + BSS_B2B.formatMoney(comparePrice) +
                            '</span>';
                    }
                    if ([6171, 6699].indexOf(BSS_B2B.storeId) !== -1) {
                        $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-compare-price]').remove();
                    }
                    if (cpType === 0) {
                        //    do nothing
                    }
                    else if (cpType === 1) {
                        if (BSS_B2B.storeId === 4522) {
                            let newComparePriceHTML = '<span class="bss-b2b-compare-at-price bss-b2b-compare-price' +
                                ' style="text-decoration: line-through">' + BSS_B2B.formatMoney(comparePrice) +
                                '</span>';
                            $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]').
                                html(newComparePriceHTML + BSS_B2B.formatMoney(modifiedLineItemPrice));
                        }
                        else if (!comparePrice) {
                            let cartPriceElement = $(
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                            let parentCartLineItem = cartPriceElement.parent().find('.bss-b2b-compare-at-price');
                            if (!parentCartLineItem.length) {
                                cartPriceElement.before(originalPriceHTML);
                            }
                            comparePriceForTaxDisplay = originalPrice;
                        }
                        else if (modifiedItemPrice === comparePrice || originalPrice > comparePrice) {
                            // do nothing
                            if (originalPrice > modifiedItemPrice) {
                                let cartPriceElement = $(
                                    '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                                let parentCartLineItem = cartPriceElement.parent().find('.bss-b2b-compare-at-price');
                                if (!parentCartLineItem.length) {
                                    cartPriceElement.before(originalPriceHTML);
                                }
                                comparePriceForTaxDisplay = originalPrice;
                            }
                        }
                        else {
                            let cartPriceElement = $(
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                            let parentCartLineItem = cartPriceElement.parent().find('.bss-b2b-compare-at-price');
                            if (!parentCartLineItem.length) {
                                cartPriceElement.before(comparePriceHTML);
                            }
                            comparePriceForTaxDisplay = comparePrice;
                        }
                        if (BSS_B2B.storeId === 12498) {
                            window.BSS_B2B.executeAction({
                                tag: 'custom_price_amount',
                                storeId: 12498,
                                productId: 0,
                                originPrice: originalPrice,
                                finalPrice: modifiedItemPrice
                            });
                        }
                    }
                    else if (cpType === 2) {
                        if (BSS_B2B.storeId === 4522 || BSS_B2B.storeId === 5969) {
                            let newOriginalPriceHTML = '<span class="bss-b2b-compare-at-price" bss-b2b-compare-price style="text-decoration: line-through">' +
                                BSS_B2B.formatMoney(originalPrice * item.quantity) + '</span>';
                            $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]').
                                html(newOriginalPriceHTML + BSS_B2B.formatMoney(modifiedLineItemPrice));
                        }

                        let cartPriceElement = $(
                            '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-item-original-price]');
                        let customizePrice = cartPriceElement.parent().find('.bss-b2b-compare-at-price');
                        if (BSS_B2B.storeId === 6497) {
                            cartPriceElement = $(
                                '[data-cart-item-key="' + item.key + '"] .cart__price [data-cart-item-regular-price]');
                        }

                        // fix for storeID 6652
                        window.BSS_B2B.executeAction({
                            tag: `price_cart_page`,
                            storeId: 6652,
                            cartPriceElement,
                            customizePrice,
                            originalPriceHTML,
                            originalPrice
                        });
                        // fix for https://bike-shop.com.au by ducdn
                        window.BSS_B2B.executeAction({ tag: `compare_price_mini_cart`, storeId: 11857, originalPrice, item, modifiedLineItemPrice });

                        if (BSS_B2B.storeId === 2933 && type === 2) {
                            if (!customizePrice.length) {
                                cartPriceElement.before(originalPriceHTML);
                                cartPriceElement.after(
                                    '<span class="bss-b2b-cp-customize-text">(' + discountValueOfRule + '% OFF)</span>');
                            }
                        }
                        else if (BSS_B2B.storeId === 7619 && !BSS_B2B.page.isCartPage()) {
                            cartPriceElement = $(
                                '[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]');
                            let _originalPriceHTML = '<span class="bss-b2b-compare-at-price" bss-b2b-compare-price style="color: ' +
                                defaultPriceColor + ';text-decoration: line-through">' +
                                BSS_B2B.formatMoney(originalPrice * item.quantity) + '</span>';
                            if ($('.bss-b2b-compare-at-price[bss-b2b-compare-price]').length < cartData.items.length) {
                                cartPriceElement.before(_originalPriceHTML);
                            }
                            cartPriceElement.css({ 'color': priceAppliedCPColor });
                        }
                        else if ([14113, 14886].includes(BSS_B2B.storeId)) {
                            let originPrice = originalPrice * item.quantity;
                            let finalPrice = modifiedLineItemPrice;
                            let priceElement = $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]')
                            window.BSS_B2B.executeAction({
                                tag: 'show_custom_CP_product_page',
                                storeId: false,
                                BSS_B2B, priceElement, originPrice, finalPrice, shopData
                            })
                        }
                        else {
                            if (!customizePrice.length) {
                                if (modifiedItemPrice < originalPrice) {
                                    cartPriceElement.before(originalPriceHTML);
                                }
                            }
                            else {
                                if (BSS_B2B.storeId === 8928) {
                                    customizePrice.html('MSRP ' + BSS_B2B.formatMoney(originalPrice));
                                }
                                else {
                                    customizePrice.html(BSS_B2B.formatMoney(originalPrice));
                                }
                            }
                            comparePriceForTaxDisplay = originalPrice;
                        }
                    }
                    // fix for Debut theme and any theme using the same logic when change quantity at cart page
                    let cartPriceElementDebut = $('[data-cart-item-line-price] [bss-b2b-cart-item-key="' + item.key +
                        '"][bss-b2b-item-original-price][bss-b2b-disable-line-price]');
                    let cartLinePriceElementDebut = $('[data-cart-item-line-price] .bss-b2b-compare-at-price');
                    if (cartPriceElementDebut.length && cartLinePriceElementDebut.length) {
                        cartLinePriceElementDebut.css('display', 'none');
                        cartPriceElementDebut.css('color', 'inherit');
                    }

                    // fix for store 5598, 6590
                    if (BSS_B2B.storeId === 12303) {
                        window.BSS_B2B.executeAction({
                            tag: `customize_discount_rate`,
                            storeId: 12303,
                            BSS_B2B: window.BSS_B2B,
                            productId: null,
                            price: item.price,
                            discountType: type,
                            discountValueOfRule,
                            key: item.key
                        });
                    } else {
                        window.BSS_B2B.executeAction({
                            tag: `customize_discount_rate`,
                            storeId: false,
                            isProductPage: BSS_B2B.page.isProductPage(),
                            isCartPage: BSS_B2B.page.isCartPage(),
                            productId: null,
                            discountType: type,
                            discountValue: discountValueOfRule,
                            key: item.key,
                        });
                    }
                }
            }

            if (comparePriceForTaxDisplay && appliedTax !== null && appliedDisplayRule) {
                let compareCartItemVatElem = BSS_B2B.createCompareElementVat(cartVatElement, shopData,
                    appliedDisplayRule, appliedTax, comparePriceForTaxDisplay, item.taxable,
                    'bss-b2b-cart-compare-price-vat', null, item.key);
                let oldComparePriceElem = $(
                    '.bss-b2b-cart-compare-price-vat[data-cart-vat-item-key="' + item.key + '"]');
                if (oldComparePriceElem.length) {
                    oldComparePriceElem.remove();
                }
                cartVatElement.before(compareCartItemVatElem);
            }

            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                // SHOW VAT PRICE
                tax_default.a.bssB2BCartItemChangeVatPrice(item.key, shopData, priceItemForTaxDisplay, appliedDisplayRule, i,
                    item.taxable);
                let {
                    itemNoVatPrice, itemWithVatPrice,
                } = tax_default.a.bssB2BCartLineItemChangeVatPrice(item.key, shopData, priceLineItemForTaxDisplay,
                    appliedDisplayRule, i, item.taxable);
                totalItemNoVat += itemNoVatPrice;
                totalItemWithVat += itemWithVatPrice;

                if (isChangeQuantity) {
                    $('[data-cart-item-key="' + item.key + '"] [data-cart-item-regular-price]').
                        html(BSS_B2B.formatMoney(modifiedItemPrice));
                    $('[data-cart-item-key="' + item.key + '"] [bss-b2b-item-final-price]').
                        html(BSS_B2B.formatMoney(modifiedItemPrice));
                    $('[data-cart-item-id="' + item.key +
                        '"]  [data-cart-item-price-container] .cart-item__original-price').
                        html(BSS_B2B.formatMoney(modifiedItemPrice));

                    $('[data-cart-item-key="' + item.key +
                        '"] [data-cart-item-line-price] [data-cart-item-regular-price]').
                        html(BSS_B2B.formatMoney(modifiedLineItemPrice));
                    $('[data-cart-item-id="' + item.key +
                        '"]  [data-cart-item-line-price-container] .cart-item__original-price').
                        html(BSS_B2B.formatMoney(modifiedLineItemPrice));
                    $('[data-cart-item-id="' + item.key + '"]  [bss-b2b-ajax-original-line-price]').
                        html(BSS_B2B.formatMoney(modifiedLineItemPrice));
                    $('[data-cart-item-id="' + item.key + '"]  [bss-b2b-final-line-price]').
                        html(BSS_B2B.formatMoney(modifiedLineItemPrice));

                    // unit price
                    if ($('[data-cart-item]').length) {
                        [...$('[data-cart-item]')].forEach(function (i) {
                            let key = i.getAttribute('data-cart-item-key');
                            if (item.key === key) {
                                let childUp = i.querySelector('[data-unit-price]');

                                if (item.unit_price) {
                                    unitPrice = (modifiedItemPrice * parseFloat(item.unit_price)) /
                                        parseFloat(item.original_price);
                                    childUp.innerHTML = BSS_B2B.formatMoney(unitPrice);
                                }
                            }
                        });
                    }
                }
            }
        }
        BSS_B2B.cart.cpPricingList = cpPricingList;

        if ([8553].includes(BSS_B2B.storeId)) {
            let customer = shopData.customer;
            let productPrice = document.querySelectorAll('[item-key-customize]');
            if (productPrice && productPrice.length && customer && customer.tags &&
                customer.tags.includes('wholesale')) {
                productPrice.forEach((item) => {
                    let productPriceCheck = item.closest('div:not([item-key-customize])').
                        querySelector('.bss-wholesale');
                    let productId = item.getAttribute('item-key-customize');
                    if (!BSS_B2B.cart.cpPricingList.get(productId) && !productPriceCheck) {
                        item.insertAdjacentHTML('afterend', '<div class = "bss-wholesale">N/A FOR WHOLESALE</div>');
                    }
                });
            }
        }

        let event = new Event('bss_b2b_doneCheckCp', { bubbles: true });
        document.dispatchEvent(event);

        if (BSS_B2B.storeId === 13922) {
            let event = new Event('bss_b2b_doneCheckCpCart', { bubbles: true });
            document.dispatchEvent(event);
        }
        if (isChangeQuantity) {
            if (isAjaxCart) {
                BSS_B2B.handleQuantityChangeAjaxCart(false);
            }
            else {
                BSS_B2B.fix.cp.fixCartQuantityOnChange(inputQuantityElement, buttonChangeQuantity,
                    timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                if (!isEnableAMO) {
                    $(BSS_B2B.cart.removeButtons).on('click', function () {
                        BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                    });
                }
            }
        }
        else {
            BSS_B2B.fix.cp.fixCartQuantity(inputQuantityElement, buttonChangeQuantity, shopData,
                timeDelayToChangeQuantity);
            $(BSS_B2B.cart.removeButtons).on('click', function () {
                BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
            });
        }
        let modifiedItemsSubtotalPrice = originalTotalPrice - totalDiscount;
        BSS_B2B.cart.modifiedItemsSubtotalPrice = modifiedItemsSubtotalPrice;

        // for compare with purchase-late of bcp by Leorio
        if (window.location.pathname === '/apps/customer-portal/purchase-late' && ![7848, 15411].includes(BSS_B2B.storeId)) {
            $('[bss-b2b-bcp-cart-subtotal-price]').
                html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice, shopData.shop.money_format));
            $('[bss-b2b-bcp-cart-total-price]').
                html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice, shopData.shop.money_format));
            if (BSS_B2B.storeId === 8713) {
                let subtotalPrice = $('#CartDrawer [data-cart-subtotal]');
                if (subtotalPrice) {
                    subtotalPrice.html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice, shopData.shop.money_format));
                }
            }
        }
        else {
            let isChangedTotalCartPrice = BSS_B2B.fix.cp.fixCartSubtotal(cartData, modifiedItemsSubtotalPrice);
            if (!isChangedTotalCartPrice) {
                let cartSubtotalPriceSelectors = [
                    '[bss-b2b-cart-total-price]',
                    '[bss-b2b-ajax-cart-subtotal]',
                    '[bss-b2b-total-discount]',
                    '.cart-subtotal--price',
                    '#cart-total',
                    '#total-cart-bottom',
                    '.cartTotalSelector',
                    '.tt-cart-total-price',
                    '.tt-product-total .total-product-js',
                    '.tt-price.full-total-js',
                    '.cart__item-sub.cart__item-row.cart__item--subtotal [data-subtotal]',
                    '.header-actions.header-actions--show-search .button[data-js-sidebar-handle] [data-header-cart-total]',
                    '[bss-b2b-cart-total-price] > span'].join(',');

                if (BSS_B2B.storeId === 12433) {
                    cartSubtotalPriceSelectors = [
                        '[bss-b2b-cart-total-price]',
                        '[bss-b2b-ajax-cart-subtotal]',
                        '[bss-b2b-total-discount]',
                        '.cart-subtotal--price',
                        '#cart-total',
                        '#total-cart-bottom',
                        '.cartTotalSelector',
                        '.tt-cart-total-price',
                        '.tt-price.full-total-js',
                        '.cart__item-sub.cart__item-row.cart__item--subtotal [data-subtotal]',
                        '[bss-b2b-cart-total-price] > span'].join(',');
                }
                if (modifiedItemsSubtotalPrice !== originalTotalPrice) {
                    $(cartSubtotalPriceSelectors).html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice));
                }
                if (BSS_B2B.storeId === 437) {
                    setTimeout(function () {
                        $(cartSubtotalPriceSelectors).html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice));
                        $('[data-cart-subtotal]').css('visibility', 'visible');
                        $('[bss-b2b-cart-item-key]').css('visibility', 'visible');
                    }, 4500);
                }
                if ([14113, 14886].includes(BSS_B2B.storeId) && BSS_B2B.cart.cpPricingList.size > 0) {
                    window.BSS_B2B.executeAction({
                        tag: 'show_custom_CP_product_page',
                        storeId: false,
                        BSS_B2B, priceElement: $(cartSubtotalPriceSelectors), originPrice: originalTotalPrice, finalPrice: modifiedItemsSubtotalPrice
                    })
                }
            }
            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                tax_default.a.bssB2BCartChangeSubtotalVatPrice(shopData, totalItemWithVat, totalItemNoVat, appliedDisplayRule);
            }
        }

        if (isAjaxCart) {
            if (modifiedItemsSubtotalPrice !== originalTotalPrice) {
                $('[bss-b2b-ajax-cart-subtotal], ' + '.cart-drawer__subtotal-value, ' +
                    '[data-cart-price-bubble][data-cart-price],' + '[data-section-id="cart-drawer"] [data-cart-subtotal],' +
                    '#ajaxifyCart .cart-subtotal--price,' + '.cartTotalSelector,' + '.nav-cart-dialog-total-amount').
                    html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice));
            }
            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                tax_default.a.bssB2BCartChangeSubtotalVatPrice(shopData, totalItemWithVat, totalItemNoVat, appliedDisplayRule);
            }
        }

        if (isChangeQuantity) {
            if ([1240, 2106].indexOf(BSS_B2B.storeId) !== -1) {
                $('[data-cart-subtotal]').html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice));
            }
            if (modifiedItemsSubtotalPrice !== originalTotalPrice) {
                $('.cart__item-sub.cart__item-row.cart__item--subtotal [data-subtotal]').
                    html(BSS_B2B.formatMoney(modifiedItemsSubtotalPrice));
            }

            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                tax_default.a.bssB2BCartChangeSubtotalVatPrice(shopData, totalItemWithVat, totalItemNoVat, appliedDisplayRule);
            }
        }

        // fix for curlysecret by Leorio
        // fix for chamaye by mitri
        // fix for magiclaze by vitu
        if (isChangeQuantity && BSS_B2B.page.isCartPage()) {
            if ([621, 2068, 2669, 6598, 5077].indexOf(BSS_B2B.storeId) !== -1) {
                BSS_B2B.handleCartCheckoutBtn(shopData);
            }
        }
        if (BSS_B2B.storeId === 6699) {
            BSS_B2B.handleCartCheckoutBtn(shopData);
        }

        //    fix for lashesview.myshopify.com

        if ([2447, 5028, 14703, 14869].includes(BSS_B2B.storeId)) {
            $(BSS_B2B.cart.inputQuantityElement).off();
            $(BSS_B2B.cart.inputQuantityElement).on('change', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, 1500);
            });
            $(BSS_B2B.cart.buttonChangeQuantity).off();
            $(BSS_B2B.cart.buttonChangeQuantity).on('click', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, 1500);
            });
        }

        // fix for https://atmooz-b2b.myshopify.com/ by tapo
        if ([6147, 14993].includes(BSS_B2B.storeId)) {
            let buttonChangeQuantity = $('[rv-data-cart-quantity]');
            buttonChangeQuantity.off();
            buttonChangeQuantity.on('click', function () {
                let totalPrice = $('[bss-b2b-cart-total-price]');
                if (totalPrice.length) {
                    setTimeout(() => {
                        totalPrice.hide();
                    }, 200);
                    setTimeout(() => {
                        totalPrice.show();
                    }, 2000);
                }
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, true, true);
                }, 700);
            });
        }

        if ([6598, 9781].includes(BSS_B2B.storeId)) {
            $(BSS_B2B.cart.inputQuantityElement).off();
            $(BSS_B2B.cart.inputQuantityElement).on('change', function () {
                BSS_B2B.cart.cartQtyOnChange(2000, 2000, false);
            });
            $(BSS_B2B.cart.buttonChangeQuantity).off();
            $(BSS_B2B.cart.buttonChangeQuantity).on('click', function () {
                BSS_B2B.cart.cartQtyOnChange(2000, 2000, false);
            });
        }

        // for compare with purchase-late of bcp by Leorio
        if (window.location.pathname === '/apps/customer-portal/purchase-late') {
            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                $('[bss-b2b-bcp-cart-subtotal-price],' + '[bss-b2b-bcp-cart-total-price],' +
                    '.bss-b2b-bcp-new-line-item-price').css('visibility', 'visible');
            }
        }

        BSS_B2B.cart.visibleElementAfterUpdateQuantity(isAjaxCart, isChangeQuantity);
        if (BSS_B2B.storeId === 3041 && BSS_B2B.page.isCartPage()) {
            $('.cart-wrapper__inner .card__section button[name="checkout"]').attr('disabled', false);
        }
        if ([4017, 5130, 7795, 8776].indexOf(BSS_B2B.storeId) === -1) {
            BSS_B2B.cart.hoverMiniCart(shopData, cartData, isChangeQuantity, isAjaxCart, productMap, updatedLineItems,
                isFirstLoad);
        }
        if (updatedLineItems.length === 0) {
            tax_default.a.bssB2BCartChangeAllVatPriceWithoutCP(shopData, appliedDisplayRule);
            tax_default.a.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedDisplayRule);
        }
        if (BSS_B2B.storeId === 1055) {
            $('.ajax-cart__button-submit').attr('disabled', false);
        }
    };

    //add event hover mini cart show product-purefemale-XuTho
    BSS_B2B.cart.hoverMiniCart = function (
        shopData, cartData, isChangeQuantity, isAjaxCart, productMap, updatedLineItems) {
        let classMiniCart = $('.cart_container.clearfix,' + '.header__action-item-link.header__cart-toggle,'
            //fix monpetitherbier by vitu
            + '.cart-container:not(.bss-custom-5686),' + '.halo-cart-sidebar,' + '#t4s-mini_cart,' + '.js-popup-cart-ajax,' +
            'mini-cart#mini-cart__v2,' + '.js-drawer,' + '.minicart.minicart-sidebar,' + '#cart-summary,' +
            '#CartDrawerForm,' + '#CartDrawer-CartItems,' + '.mini-cart-wrap,' + '#cart-drawer,' +
            '.quick-cart__container,' + 'mini-cart#mini-cart,' + '#site-cart-sidebar,' + '.shopping-cart.mini-cart,' +
            '.bt-dropdown__content form[action="/cart"],' + '#cart-dropdown,' + '.ajax-cart-wrap,' + '.cart-drawer,' +
            '#dropdown-cart,' + '#sidebar-cart,' +
            '.boost-pfs-minicart-container .boost-pfs-minicart-container-inner,' + '.cart-drawer__items,' +
            '#cart-drawer-form,' + '.dropdown-box,' + '.side-cart__items.side-cart__margins-inline,' +
            'form.cart.cart-content'); //class mini cart
        for (let i = 0; i < classMiniCart.length; i++) {
            // add event click change quantity on minicart
            classMiniCart[i].querySelectorAll(
                '.js-change-quantity, .t4s-quantity-selector, .custom-selector-qty--add, .custom-selector-qty--minus, .ajaxcart__qty-adjust, .item__content .item__qty button, .qty-adjuster__inner button, .quantity-input__button, button.qty-button, button.cart__quantity-minus, button.cart__quantity-plus, .QuantitySelector a.QuantitySelector__Button, button.boost-pfs-minicart-item-quantity-plus, button.boost-pfs-minicart-item-quantity-minus, a.quantity-selector__button, button.scd-item__btn, .input-quantity.item-cart-js').
                forEach(function (element) {
                    if (!element.getAttribute('bss-ajax-cart-change-quantity-event')) {
                        element.setAttribute('bss-ajax-cart-change-quantity-event', true);
                        let timeDelayForMiniCart = 3000;
                        if ([8920, 3740, 9928, 9424, 9232, 9959, 10691].includes(BSS_B2B.storeId)) {
                            timeDelayForMiniCart = 1500;
                        }

                        element.addEventListener('click', function () {
                            //fix for thewoofclub-ch.myshopify.com by PhuongKD
                            if (BSS_B2B.storeId === 10424) {
                                // reset content when qty change
                                let subTextShippingElement = document.querySelector(
                                    '.Cart.Drawer__Content .Cart__ShippingNotice.Text--subdued p');
                                subTextShippingElement.textContent = '';
                            }

                            if (BSS_B2B.storeId === 1655) {
                                setTimeout(function () {
                                    $('.header .money.sale,' + '.header .cart_subtotal.js-cart_subtotal').
                                        css('visibility', 'hidden');
                                    BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity,
                                        isAjaxCart, productMap, updatedLineItems, false);
                                    BSS_B2B.handleChangeQuantityEventFirstTime(1000, 1000);
                                }, 1500);
                            }
                            else {
                                setTimeout(function () {
                                    BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity,
                                        isAjaxCart, productMap, updatedLineItems, false);
                                    BSS_B2B.handleChangeQuantityEventFirstTime(1500, 1500);
                                    if (BSS_B2B.storeId === 9793) {
                                        BSS_B2B.handleCartCheckoutBtn(shopData);
                                    }
                                    else if ([7596, 7761, 8920, 3740, 9928, 9424, 9232].indexOf(BSS_B2B.storeId) !==
                                        -1) {
                                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                    }
                                    if ([9232].includes(BSS_B2B.storeId)) {
                                        BSS_B2B.handleCartCheckoutBtn(shopData);
                                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                    }
                                    if ([10691].includes(BSS_B2B.storeId)) {
                                        BSS_B2B.dc.showDiscountBox();
                                    }
                                }, timeDelayForMiniCart);
                            }
                        });
                    }
                });
            // add event change input quantity mini cart
            classMiniCart[i].querySelectorAll(
                '.quantity, .t4s-quantity-input, input#qty, .ajaxcart__qty-num, .qty-adjuster__inner .qty-adjuster__value, .js-qty__num, .quantity-input, .quantity-input__input, input.product__quantity, input.cart__quantity-field, input.cart-drawer__item-quantity, input.item-quantity, input.QuantitySelector__CurrentQuantity, input.boost-pfs-minicart-item-quantity, input.quantity-selector__input, input.scd-item__qty_input').
                forEach(function (element) {
                    if (!element.getAttribute('bss-ajax-cart-change-quantity-event')) {
                        element.setAttribute('bss-ajax-cart-change-quantity-event', true);
                        let timeDelayForMiniCart = 3000;
                        if ([3740, 9928, 10234, 9424, 9232, 10691, 11790].includes(BSS_B2B.storeId)) {
                            timeDelayForMiniCart = 1500;
                        }
                        if (BSS_B2B.isDisableCP) {
                            timeDelayForMiniCart = 0;
                        }

                        element.addEventListener('change', function () {
                            setTimeout(function () {
                                BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity,
                                    isAjaxCart, productMap, updatedLineItems, false);
                                BSS_B2B.handleChangeQuantityEventFirstTime(1000, 1000);
                                if ([5686, 9793].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.handleCartCheckoutBtn(shopData);
                                }
                                else if ([7596, 7812, 7761, 8920, 3740, 9928, 9424].indexOf(BSS_B2B.storeId) !== -1) {
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                }
                                else if ([7848].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.cart.fixer(shopData, true, true);
                                }

                                if ([10234, 9232, 10623].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                    BSS_B2B.handleCartCheckoutBtn(shopData);
                                }
                                if ([10691].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.dc.showDiscountBox();
                                }
                            }, timeDelayForMiniCart);
                        });
                    }
                });
            // add event click remove item on minicart
            classMiniCart[i].querySelectorAll(
                'span[data-remove-cart-item], .cart-drawer__remove-item, .remove-icon, .previewCartItem-remove, .t4s-mini_cart__remove, .js-product-button-remove-from-cart, .qty-adjuster__remove, .button--tertiary, .quick-cart__item-remove, a.remove, .cart-list a, a.cart-item__remove, .cart-remove-item, .cart-drawer__item-delete, a.btn-remove, a.CartItem__Remove, button.boost-pfs-minicart-item-remove, button.scd-item__remove, button.cart__remove, .item-delete, .cart__item__remove, line-item-quantity a.link').
                forEach(function (element) {
                    if (!element.getAttribute('bss-ajax-cart-change-quantity-event')) {
                        element.setAttribute('bss-ajax-cart-change-quantity-event', true);
                        element.addEventListener('click', function () {
                            setTimeout(function () {
                                if (BSS_B2B.storeId !== 15077) {
                                    BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity,
                                        isAjaxCart, productMap, updatedLineItems, false);
                                } else {
                                    BSS_B2B.cart.fixer(shopData, false, true);
                                }
                                BSS_B2B.handleChangeQuantityEventFirstTime(1500, 1500);
                                if ([5686, 9793].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.handleCartCheckoutBtn(shopData);
                                }
                                else if ([7596, 8605, 8920, 3740, 9444, 9928, 9424, 10788, 12634].includes(
                                    BSS_B2B.storeId)) {
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                }
                                else if ([7848, 11074].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.cart.fixer(shopData, true, true);
                                }

                                if ([10234, 9232, 10623].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.handleCartCheckoutBtn(shopData);
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                }
                                if ([10691].includes(BSS_B2B.storeId)) {
                                    BSS_B2B.dc.showDiscountBox();
                                }
                            }, 3000);
                        });
                    }
                });
        }
        // add event click add to cart show minicart from collection page
        let buttonAddToCarts = document.querySelectorAll(
            'button.ajax-submit.action_button.add_to_cart,' + 'button.js-product-button-add-to-cart,' +
            '.btn.addcart_btn.product_btn,' + 'button.btn.product-add,' + '.current-cart-icon--cart,' +
            'button.button.button--xl[is="custom-button"],' +
            '.product-card__quick-buy button.button[is="custom-button"],' + '.icon-button-header-shopping-cart,' +
            'add-to-cart.button,' + '#AddToCart,' + '#header-wrapper .header-action-item.header-cart a,' +
            '#HeaderCart,' +
            'button.ProductForm__AddToCart, #section-header a.Link.Heading[data-drawer-id="sidebar-cart"],' +
            'button#sidebar-minicart, button#cart-icon-bubble,' + 'buy-buttons button,' +
            '.btn-get-your-now .btn-custom,' + 'button.boost-sd__button,' + '#new-cart-icon-bubble,' + '[action="/cart"] [data-submit]');
        let defaultTimeDelayShowMiniCart = 3000;
        if ([9232, 9424, 986].includes(BSS_B2B.storeId)) {
            defaultTimeDelayShowMiniCart = 1000;
        }
        for (let buttonAddToCart of buttonAddToCarts) {
            if (!buttonAddToCart.getAttribute('bss-add-to-cart-event')) {
                buttonAddToCart.setAttribute('bss-add-to-cart-event', true);
                buttonAddToCart.addEventListener('click', function () {
                    setTimeout(function () {
                        BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity, isAjaxCart,
                            productMap, updatedLineItems, false);
                        BSS_B2B.handleChangeQuantityEventFirstTime(1500, 1500);
                        if ([7596, 8446, 8920, 9444, 9424].includes(BSS_B2B.storeId)) {
                            BSS_B2B.cp.changeProductPrice(shopData, false, false);
                        }
                        else if ([9232, 986].includes(BSS_B2B.storeId)) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                            BSS_B2B.cp.changeProductPrice(shopData, false, false);
                        }
                        else if ([11872, 11913].includes(BSS_B2B.storeId)) {
                            BSS_B2B.cart.fixer(shopData, false, true);
                        }
                        else if (BSS_B2B.storeId === 12209) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                        }
                    }, defaultTimeDelayShowMiniCart);
                });
            }
        }
    };

    BSS_B2B.cart.getLineItemsPrice = async function (shopData, cartData, isChangeQuantity, isAjaxCart) {
        let isExistedUpdateCartBtn = BSS_B2B.cart.isExistedUpdateCartBtn;

        // fix saborati-us.myshopify.com by DangNM
        if ([2707, 2896, 6147, 12966].indexOf(BSS_B2B.storeId) !== -1 && BSS_B2B.page.isCartPage() && isAjaxCart) {
            // do nothing
        }
        else {
            if (isChangeQuantity && isExistedUpdateCartBtn) {
                return;
            }
        }
        let handleURLs = [];
        let handles = [];
        let keyIdMap = [];
        cartData.items.forEach(function (item) {
            let proId = item.product_id;
            if (handles.indexOf(proId) === -1 && proId !== null) {
                handles.push(proId);
                handleURLs.push('id:"' + proId + '"');
                keyIdMap[proId] = item.key;
            }
        });

        await BSS_B2B.getItemCartMetaField();
        if (BSS_B2B.storeId == 14646) {
            BSS_B2B.cart.updatedLineItems = []
        }
        if (BSS_B2B.cart.updatedLineItems.length && BSS_B2B.cart.productMap.length && BSS_B2B.page.isCartPage()) {
            //fix for thewoofclub-ch.myshopify.com by PhuongKD
            window.BSS_B2B.executeAction({ tag: 'price_cart_page', storeId: 10424 });
            BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity, isAjaxCart,
                BSS_B2B.cart.productMap, BSS_B2B.cart.updatedLineItems, false);
        }
        else if (BSS_B2B.cart.updatedLineItems.length && BSS_B2B.cart.productMap.length && isAjaxCart &&
            isChangeQuantity) {
            BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity, isAjaxCart,
                BSS_B2B.cart.productMap, BSS_B2B.cart.updatedLineItems, false);
        }
        else {
            let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
            let encodeUrlData = encodeURI(urlData);
            let productIdNoMetaField = [];

            $.get(encodeUrlData, function (data) {
                let responseProducts = [];
                try {
                    responseProducts = JSON.parse(data);
                    responseProducts.map(item => productIdNoMetaField.push(item.id));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('B2B: JSON parse returns no item');
                }

                if (shopData.line_item_products) {
                    shopData.line_item_products.map(item => {
                        if (item && item.id && !productIdNoMetaField.includes(item.id)) {
                            responseProducts.push(item);
                        }
                    });
                }

                responseProducts = BSS_B2B.fix.cp.fixResponseProducts(responseProducts, true);

                if ([4339, 1222, 4370, 5451, 6598, 7211, 9722, 13831].indexOf(BSS_B2B.storeId) !== -1) {
                    setTimeout(function () {
                        if (isEnableDC && BSS_B2B.page.isCartPage()) {
                            BSS_B2B.dc.showDiscountBox();
                            BSS_B2B.dc.getDiscountCodeApplied();
                        }
                        BSS_B2B.handleCartCheckoutBtn(shopData);
                    }, 1000);
                }

                if (responseProducts.length > 0) {
                    let productMap = [];
                    let checkUnique = [];
                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            pro.variants.map((variant) => { BSS_B2B.cart.variantStorage.set(variant.id, variant) });
                            const productVariant = cartData.items.filter(item => item.product_id === pro.id).map((item) => (item.id));
                            productMap.push({
                                id: pro.id,
                                tags: pro.tags,
                                collections: pro.collections,
                                price: pro.price_min,
                                compareAtPriceMin: pro.compare_at_price_min,
                                variants: pro.variants,
                                key: keyIdMap[pro.id],
                                product_name: pro.title,
                                variantsApplied: productVariant,
                            });
                        }
                    }
                    let updatedLineItems = BSS_B2B.getPriceList(shopData, productMap, true);
                    BSS_B2B.cart.updatedLineItems = updatedLineItems;
                    BSS_B2B.cart.productMap = productMap;
                    BSS_B2B.cart.updateWhenItemQuantityChange(shopData, cartData, isChangeQuantity, isAjaxCart,
                        productMap, updatedLineItems, true);

                    //fix for thewoofclub-ch.myshopify.com by PhuongKD
                    window.BSS_B2B.executeAction({ tag: 'price_ajax_cart', storeId: 10424 });
                } else {
                    BSS_B2B.cart.updatedLineItems = []
                }
            });
        }
    };

    BSS_B2B.cart.getLineItemsPriceWhenUseAMO = function (
        shopData, cartData, isChangeQuantity, isAjaxCart, isCheckoutQO = false) {
        let isExistedUpdateCartBtn = BSS_B2B.cart.isExistedUpdateCartBtn;
        if (isChangeQuantity && isExistedUpdateCartBtn) {
            return;
        }
        let handleURLs = [];
        let handles = [];
        let keyIdMap = [];
        cartData.items.forEach(function (item) {
            let proId = item.product_id;
            if (handles.indexOf(proId) === -1 && proId !== null) {
                handles.push(proId);
                handleURLs.push('id:"' + proId + '"');
                keyIdMap[proId] = item.key;
            }
        });
        if (BSS_B2B.cart.updatedLineItemsAndUseAMO.length && BSS_B2B.cart.productMap.length && !isCheckoutQO) {
            BSS_B2B.cart.updateWhenItemQuantityChangeAndUseAMO(shopData, cartData, isChangeQuantity, isAjaxCart,
                BSS_B2B.cart.productMap, BSS_B2B.cart.updatedLineItemsAndUseAMO, false);
        } else if ([621, 10052, 15588].includes(BSS_B2B.storeId)) {
            window.BSS_B2B.executeAction({
                tag: `update_product_metafilelddata_on_cart`,
                storeId: 10052,
                BSS_B2B, shopData, cartData, handleURLs, isChangeQuantity, isAjaxCart, isCheckoutQO, keyIdMap
            });

            window.BSS_B2B.executeAction({
                tag: `update_product_metadata_on_cart`,
                storeId: 621,
                BSS_B2B, shopData, cartData, handleURLs, isChangeQuantity, isAjaxCart, isCheckoutQO, keyIdMap
            });

            window.BSS_B2B.executeAction({
                tag: `update_product_metadata_on_cart`,
                storeId: 15588,
                BSS_B2B, shopData, cartData, handleURLs, isChangeQuantity, isAjaxCart, isCheckoutQO, keyIdMap
            });
        }
        else {
            let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
            let encodeUrlData = encodeURI(urlData);

            $.get(encodeUrlData, function (data) {
                let responseProducts = [];
                let productIdResponse = [];
                try {
                    responseProducts = JSON.parse(data);
                    responseProducts.map(item => productIdResponse.push(item.id));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('B2B: JSON parse returns no item');
                }

                if (responseProducts.length > 0) {
                    let productMap = [];
                    let checkUnique = [];
                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            productMap.push({
                                id: pro.id,
                                tags: pro.tags,
                                collections: pro.collections,
                                price: pro.price_min,
                                compareAtPriceMin: pro.compare_at_price_min,
                                variants: pro.variants,
                                key: keyIdMap[pro.id],
                            });
                        }
                    }

                    let updatedLineItems = BSS_B2B.amo.getAppliedRulesForCartItems(productMap, true, cartData);
                    if (BSS_B2B.page.isCartPage() || isCheckoutQO) {
                        BSS_B2B.cart.updatedLineItemsAndUseAMO = updatedLineItems;
                    }
                    BSS_B2B.cart.updateWhenItemQuantityChangeAndUseAMO(shopData, cartData, isChangeQuantity, isAjaxCart,
                        productMap, updatedLineItems, true, isCheckoutQO);
                }
            });
        }
    };

    BSS_B2B.cart.fixer = function (shopData, isChangeQuantity, isAjaxCart) {
        if (BSS_B2B.storeId === 13004) {
            $(".cart__punit ").css({ "opacity": "0" })
            $(".cart__ptotal ").css({ "opacity": "0" })
        }
        if (BSS_B2B.storeId === 8553) {
            if (BSS_B2B.isCartFixerCalled) return;
            BSS_B2B.isCartFixerCalled = true;
        }
        let url = '/cart.js';
        if(BSS_B2B.storeId === 15165){
            url = '/cart'
        }
        $.ajax({
            url, type: 'GET', dataType: 'json', success: function (data) {
                if (data) {
                    if (BSS_B2B.storeId == 14213 && BSS_B2B.page.isCartPage()) {
                        if (shopData && shopData.shop) {
                            if (shopData.shop.cart_current_currency != data.currency) {
                                window.location.reload();
                            }
                        }
                    }

                    if (window.BSS_SUB && Object.keys(window.BSS_SUB.subItems).length) {
                        data.items = BSS_B2B.integrate.subscription.convertCartPrice(data.items);
                    }
                    /**
                     * Insert qty table to correct cart item, update correct qty
                     * table if item qty is changed
                     */
                    if (!isEnableBOGO || (BSS_B2B.bogoRule && BSS_B2B.bogoRule.length === 0)) {
                        BSS_B2B.bogo.resetItemAppliedPropertiesBogo(data);
                    }
                    if (isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length) {
                        BSS_B2B.qi.validateQtyIncrement(data, isAjaxCart);
                    }
                    if (isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0)) {
                        BSS_B2B.qb.insertQtyTableToCartItemBlock(data, isAjaxCart);
                        if (!isAjaxCart || BSS_B2B.page.isCartPage()) {
                            BSS_B2B.cart.reRenderQtyTable();
                        }
                    }

                    if (isEnableBOGO && BSS_B2B.bogoRule && BSS_B2B.bogoRule.length > 0) {
                        if (!isAjaxCart || BSS_B2B.page.isCartPage() || (BSS_B2B.storeId === 10989 && isAjaxCart)) {
                            BSS_B2B.cart.updateWhenItemQuantityChangeAndUseBogo();
                        }
                        if (!isEnableQB || (isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length === 0))) {
                            BSS_B2B.bogo.appliedRuleOnCartPage(shopData, data);
                        }
                    }

                    if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                        (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                        BSS_B2B.cart.getLineItemsPrice(shopData, data, isChangeQuantity, isAjaxCart);
                    }

                    if (isEnableAMO && BSS_B2B.amoRules && (BSS_B2B.amoRules.length > 0)) {
                        if ((BSS_B2B.storeId !== 7788) && isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                            (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                            setTimeout(function () {
                                BSS_B2B.cart.getLineItemsPriceWhenUseAMO(shopData, data, isChangeQuantity, isAjaxCart);
                            }, 1000);
                        }
                        else {
                            BSS_B2B.cart.getLineItemsPriceWhenUseAMO(shopData, data, isChangeQuantity, isAjaxCart);
                        }
                    }
                    if (isEnableEF && BSS_B2B.efRules && (BSS_B2B.efRules.length > 0)) {
                        BSS_B2B.ef.insertQtyTableToCartItemBlock(data, isAjaxCart);
                        if (!isAjaxCart || BSS_B2B.page.isCartPage()) {
                            BSS_B2B.cart.reRenderEFTable();
                        }
                        if (isAjaxCart && isChangeQuantity && (!isEnableCP || BSS_B2B.configData.length === 0)) {
                            BSS_B2B.handleQuantityChangeAjaxCart(false);
                        }
                    }
                    if (isEnableMc) {
                        let cartCurrencyTimeout = 1000;
                        if (BSS_B2B.storeId === 2558) {
                            cartCurrencyTimeout = 2500;
                        }
                        else if (BSS_B2B.storeId === 8356) {
                            cartCurrencyTimeout = 3000;
                        }
                        setTimeout(function () {
                            let customPriceEL = $('[bss-b2b-custom-mc] .money,' + '[data-cart-item-regular-price],' + '[bss-b2b-item-price],' +
                                '[bss-b2b-product-price],' + '[data-cart-subtotal],' + '[bss-b2b-ajax-cart-subtotal],' +
                                '[bss-b2b-cart-item-key],' + '[data-cart-price],' + '[bss-b2b-cart-total-price],'
                                // fix for auto discount
                                + '[bss-b2b-cart-discount-total],' + '[data-cart-discount-amount],' +
                                '[data-cart-price-bubble][data-cart-price],' +
                                '[data-cart-item-id] [data-cart-item-price-container] .cart-item__original-price,' +
                                '[data-cart-item-id] [data-cart-item-line-price-container] .cart-item__original-price,' +
                                '.cartTotalSelector,' + '.cart_subtotal,' + '.cart-item__price,' +
                                '.cart-subtotal--price,' + '.cart-subtotal--price,' + '[bss-b2b-cart-total-price],' +
                                '[bss-b2b-cart-total-price] .hide-price-guest,' + '[bss-b2b-compare-price],' +
                                '[bss-b2b-cart-item-key] .money,' + '[bss-b2b-cart-total-price] .money,' +
                                '[bss-b2b-compare-price] .money,' + '[bss-b2b-cart-item-key] .hide-price-guest,' +
                                '[bss-b2b-cart-total-price] .hide-price-guest,' +
                                '[bss-b2b-compare-price] .hide-price-guest,' + '[bss-b2b-cart-discount-total],' +
                                '.etrans-money' +
                                BSS_B2B.getCartPriceClass('cart_total') + BSS_B2B.getCartPriceClass('cart_subtotal') +
                                BSS_B2B.getCartPriceClass('cart_item_regular_price') +
                                BSS_B2B.getCartPriceClass('cart_item_original_price'));
                            let sessionCurrencyCode = window.localStorage.getItem('currentCurrency');
                            let sessionCurrencyFormat = window.localStorage.getItem('currentCurrencyFormat');
                            BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, customPriceEL);
                        }, cartCurrencyTimeout);
                    }
                    // fix for shop-nortec.myshopify.com by hoaduong
                    // fix for farmaciatreglia.myshopify.com by DangNM
                    if ([4852, 5224].indexOf(BSS_B2B.storeId) !== -1) {
                        BSS_B2B.cart.getLineItemsPrice(shopData, data, isChangeQuantity, isAjaxCart);
                    }
                    if ([12433, 14675, 14993].includes(BSS_B2B.storeId)) {
                        BSS_B2B.cp.changeProductPrice(shopData, false, false);
                    }
                    if ([7995, 13760].includes(BSS_B2B.storeId)) {
                        setTimeout(() => BSS_B2B.handleQuantityChangeAjaxCart(false), 1000);
                    }


                    document.dispatchEvent(new Event('bss_b2b_cart_fixer_done', {bubbles: true}));
                    window.BSS_B2B.executeAction({ tag: "change_quantity_cart", storeId: 13534 });
                } else {
                    // eslint-disable-next-line no-console
                    console.log('Could not get cart data');
                }
                const isQBApplied = isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length > 0;
                // custom cart page (error random) 07eins.myshopify.com by vitu  SAB2B-785
                if ([12514, 1123, 13871, 12733, 13004].includes(BSS_B2B.storeId)) {
                    let checkCalculatedPrice = new Event('BSS_CP_Calculated');
                    document.dispatchEvent(checkCalculatedPrice);
                }
                if (BSS_B2B.storeId === 8553) {
                    BSS_B2B.isCartFixerCalled = false;
                }
                // fix for storeID 7146: customize total price in cart
                window.BSS_B2B.executeAction({ tag: `customize_total_price`, storeId: 7146, isQBApplied });
            }, error: function (err) {
                // eslint-disable-next-line no-console
                console.log('Could not get cart data:', err);
            },
        });

    };
    BSS_B2B.cart.handleDelayCheckout = function (checkoutButton, disableCheckout) {
        if (checkoutButton) {
            let themeCheckoutButton = document.querySelectorAll(checkoutButton.join(','));
            if (themeCheckoutButton.length > 0) {
                themeCheckoutButton.forEach(function (button) {
                    if (disableCheckout) {
                        button.setAttribute('style', 'pointer-events:none;cursor:not-allowed');
                    }
                    else {
                        button.setAttribute('style', 'pointer-events:auto;cursor:pointer');
                    }
                });
            }
        }
    };
    BSS_B2B.cart.reRenderQtyTable = function () {
        /**
         * Fix bugs: If disable CP and enable QB, first time change QTY will not show qty table
         * Element (cart line item) was generated each time change, so need to
         * call event onClick after generate
         */
        if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
            (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
            let isExistedUpdateCartBtn = BSS_B2B.cart.isExistedUpdateCartBtn;
            if (!isExistedUpdateCartBtn) {
                // fix for quickee by mitri
                if ([2322, 4325, 4346, 5980, 6631, 3588].indexOf(BSS_B2B.storeId) === -1) {
                    $(BSS_B2B.cart.inputQuantityElement).off();
                }
                if (BSS_B2B.storeId === 3588) {
                    $(BSS_B2B.cart.inputQuantityElement).off('change');
                }

                if (BSS_B2B.storeId === 2322) {
                    $(BSS_B2B.cart.inputQuantityElement).on('click', function () {
                        BSS_B2B.cart.fixer(shopData, true, false);
                    });
                }

                $(BSS_B2B.cart.inputQuantityElement).on('change', function () {
                    //fix for b2bmetrobrazil by CuongNVM
                    if ([2462, 6318].indexOf(BSS_B2B.storeId) !== -1) {
                        $('.quantity__button').attr('disabled', true);
                    }
                    let appliedQI = isEnabledQI && BSS_B2B.qiRules && (BSS_B2B.qiRules.length > 0);
                    if (appliedQI) {
                        //fix for organicosenlinea by CuongNVM
                        if ([5109, 4999].indexOf(BSS_B2B.storeId) !== -1) {
                            $('button[name="checkout"].checkout-button--lower').css('pointer-events', 'none');
                            $('button[name="checkout"].checkout-button--upper').css('pointer-events', 'none');
                        }
                        else {
                            const checkoutElement = [
                                'form[action*="/cart"] [name="checkout"]',
                                '#dropdown-cart button.btn.btn-checkout.show',
                                'a.button.checkout-button[href="/checkout"]',
                                'form[action*="/checkout"] .add_to_cart',
                                'form[action*="/cart"]#cart_form #checkout',
                                'form[action*="/cart"] button.Cart__Checkout',
                                'form[action*="/cart"] button.cart__checkout',
                                'a.btn.disabled.ttmodalbtn[href="/checkout"]',
                                'button#checkout.cart__checkout-button.button'];
                            let disableCheckout = true;
                            BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
                        }
                    }
                    //fix for sextoysupplycn by DongNV
                    if ([4661, 4696, 4739, 9673].indexOf(BSS_B2B.storeId) === -1) {
                        let delayTime = 1500;
                        if (BSS_B2B.storeId === 10270) {
                            delayTime = 3000;
                        }
                        setTimeout(function () {
                            BSS_B2B.cart.fixer(shopData, false, false);
                            if (BSS_B2B.storeId === 10270) {
                                BSS_B2B.handleCartCheckoutBtn(shopData);
                            }
                        }, delayTime);
                    }
                });

                //Question: side effect when enable off()
                $(BSS_B2B.cart.buttonChangeQuantity).off();

                $(BSS_B2B.cart.buttonChangeQuantity).on('click', function () {
                    let appliedQI = isEnabledQI && BSS_B2B.qiRules && (BSS_B2B.qiRules.length > 0);
                    if (appliedQI) {
                        //fix for organicosenlinea by CuongNVM
                        if (BSS_B2B.storeId == 5109) {
                            $('button[name="checkout"].checkout-button--lower').css('pointer-events', 'none');
                            $('button[name="checkout"].checkout-button--upper').css('pointer-events', 'none');
                        }
                        else {
                            const checkoutElement = [
                                'form[action*="/cart"] [name="checkout"]',
                                '#dropdown-cart button.btn.btn-checkout.show',
                                'a.button.checkout-button[href="/checkout"]',
                                'form[action*="/checkout"] .add_to_cart',
                                'form[action*="/cart"]#cart_form #checkout',
                                'form[action*="/cart"] button.Cart__Checkout',
                                'form[action*="/cart"] button.cart__checkout',
                                'a.btn.disabled.ttmodalbtn[href="/checkout"]',
                                'button#checkout.cart__checkout-button.button'];
                            let disableCheckout = true;
                            BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
                        }
                    }

                    setTimeout(function () {
                        BSS_B2B.cart.fixer(shopData, false, !BSS_B2B.page.isCartPage());
                    }, 1500);
                    if ([10270, 13871, 13615, 8694].includes(BSS_B2B.storeId)) {
                        setTimeout(() => {
                            BSS_B2B.cart.fixer(shopData, false, !BSS_B2B.page.isCartPage());
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                        }, 3000);
                    }
                });
            }
        }
    };

    BSS_B2B.cart.updateWhenItemQuantityChangeAndUseBogo = function () {
        if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
            (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
            let timeDelayToUseBogo = 1500;
            if (isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0)) {
                timeDelayToUseBogo = 2200;
            }
            if ([4346].indexOf(BSS_B2B.storeId) === -1) {
                $(BSS_B2B.cart.inputQuantityElement).off();
            }
            $(BSS_B2B.cart.inputQuantityElement).on('change', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, timeDelayToUseBogo);
            });

            //Question: side effect when enable off()
            if ([4346].indexOf(BSS_B2B.storeId) === -1) {
                $(BSS_B2B.cart.buttonChangeQuantity).off();
            }
            $(BSS_B2B.cart.buttonChangeQuantity).on('click', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, timeDelayToUseBogo);
            });

            $(BSS_B2B.cart.removeButtons).on('click', function () {
                BSS_B2B.cart.cartQtyOnChange(1200, 2000, true);
            });
        }
    };

    BSS_B2B.cart.reRenderEFTable = function () {
        let isAppliedEF = isEnableEF && BSS_B2B.efRules && (BSS_B2B.efRules.length > 0);
        let isAppliedQB = isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0);
        if (isAppliedEF && !isAppliedQB) {
            $(BSS_B2B.cart.inputQuantityElement).on('change', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, true);
                }, 2000);
            });
            $(BSS_B2B.cart.buttonChangeQuantity).on('click', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, 1500);
            });
            $(BSS_B2B.cart.removeButtons).on('click', function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, false, false);
                }, 1500);
            });
        }
    };

    BSS_B2B.cart.updateWhenItemQuantityChangeAndUseAMO = function (
        shopData, cartData, isChangeQuantity, isAjaxCart, productMap, updatedLineItems, isFirstLoad, isCheckoutQO) {
        let checkoutButton = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
        let inputQuantityElement = $(BSS_B2B.cart.inputQuantityElement);
        let buttonChangeQuantity = $(BSS_B2B.cart.buttonChangeQuantity);
        let timeDelayToReCalculate = 1200;
        let timeDelayToChangeQuantity = 2000;
        let items = [];
        let customTimeDelayToChangeQuantity = BSS_B2B.getCssSelector('cart_time_delay_changing_qty');
        if (customTimeDelayToChangeQuantity !== '' && !isNaN(customTimeDelayToChangeQuantity)) {
            timeDelayToChangeQuantity = parseInt(customTimeDelayToChangeQuantity);
        }
        if (customTimeDelayToChangeQuantity !== '' && !isNaN(customTimeDelayToChangeQuantity)) {
            timeDelayToChangeQuantity = parseInt(customTimeDelayToChangeQuantity);
        }

        for (let i = 0; i < updatedLineItems.length; i++) {
            for (let k = 0; k < cartData.items.length; k++) {
                if (updatedLineItems[i].variantID && updatedLineItems[i].variantID === cartData.items[k].variant_id) {
                    cartData.items[k] = {
                        ...cartData.items[k], ...updatedLineItems[i], 'key': cartData.items[k].key,
                    };
                    items.push(cartData.items[k]);
                }
                else if (!updatedLineItems[i].variantID && cartData.items[k].product_id ===
                    updatedLineItems[i].productId) {
                    cartData.items[k] = {
                        ...cartData.items[k], ...updatedLineItems[i], 'key': cartData.items[k].key,
                    };
                    items.push(cartData.items[k]);
                }
            }
        }
        let timeoutCheckAmo = 1000;
        if (BSS_B2B.storeId === 7788) {
            timeoutCheckAmo = 100;
        }

        if (BSS_B2B.storeId === 9605) {
            let itemsCustom = items ? items.filter(item => [6308, 6248, 6310].includes(item.ruleId)) : [];
            let itemsCustomExc = items ? items.filter(item => [6308, 6248, 6310].indexOf(item.ruleId) === -1) : [];
            if (itemsCustomExc.length) {
                setTimeout(function () {
                    if (BSS_B2B.amoSettings.amoType === 0) {
                        BSS_B2B.amo.checkAMORuleForPerVariantOfCartPage(itemsCustomExc);
                    }
                    else if (BSS_B2B.amoSettings.amoType === 1) {
                        BSS_B2B.amo.checkAMORuleForAllProductsOfCartPage(itemsCustomExc);
                    }
                    else {
                        BSS_B2B.amo.checkAMORuleForPerProductOfCartPage(itemsCustomExc);
                    }
                    let event = new Event('bss.b2b.amo.doneCheckAMOByBSS');
                    document.dispatchEvent(event);
                }, timeoutCheckAmo);
            }
            if (itemsCustom.length) {
                setTimeout(function () {
                    let itemsCustomRemoveTitle = itemsCustom ? itemsCustom.filter(
                        item => [6308, 6248].includes(item.ruleId)) : [];
                    let itemsCustomExcRemove = itemsCustom ? itemsCustom.filter(
                        item => [6308, 6248].indexOf(item.ruleId) === -1) : [];
                    if (itemsCustomRemoveTitle.length) {
                        BSS_B2B.amo.checkAMORuleForAllProductsOfCartPage(itemsCustomRemoveTitle, true);
                    }
                    if (itemsCustomExcRemove.length) {
                        if (BSS_B2B.amoSettings.amoType === 0) {
                            BSS_B2B.amo.checkAMORuleForPerVariantOfCartPage(itemsCustomExcRemove);
                        }
                        else if (BSS_B2B.amoSettings.amoType === 1) {
                            BSS_B2B.amo.checkAMORuleForAllProductsOfCartPage(itemsCustomExcRemove, true);
                        }
                        else {
                            BSS_B2B.amo.checkAMORuleForPerProductOfCartPage(itemsCustomExcRemove, true);
                        }
                    }
                    let event = new Event('bss.b2b.amo.doneCheckAMOByBSS');
                    document.dispatchEvent(event);
                }, timeoutCheckAmo);
            }
        } else if (BSS_B2B.storeId === 15112) {
            window.BSS_B2B.executeAction({tag: 'handle_setting_separation_Ol', storeId: 15112, items, timeoutCheckAmo});
        } else {
            setTimeout(function () {
                if (BSS_B2B.amoSettings.amoType === 0) {
                    BSS_B2B.amo.checkAMORuleForPerVariantOfCartPage(items);
                }
                else if (BSS_B2B.amoSettings.amoType === 1) {
                    BSS_B2B.amo.checkAMORuleForAllProductsOfCartPage(items);
                }
                else {
                    BSS_B2B.amo.checkAMORuleForPerProductOfCartPage(items);
                }
                // for compare with nt of Portal
                let event = new Event('bss.b2b.amo.doneCheckAMOByBSS');
                document.dispatchEvent(event);
                // end
            }, timeoutCheckAmo);
        }

        // If checkout at qo => only validate amo rule
        if (isCheckoutQO) {
            return;
        }
        if (BSS_B2B.storeId === 11576) {
            timeDelayToReCalculate = 850;
        }

        if (isChangeQuantity) {
            if (isAjaxCart) {
                BSS_B2B.handleQuantityChangeAjaxCart(false);
            }
            else {
                let timeDelayForStore = 0;
                // fix for thatsoitaly by mitri
                if ([3698, 4649, 4999].indexOf(BSS_B2B.storeId) !== -1) {
                    timeDelayForStore = 1000;
                }
                if (BSS_B2B.storeId === 6652) {
                    inputQuantityElement.off();
                    window.BSS_B2B.executeAction({
                        tag: 'change_quantity_cart',
                        storeId: 6652,
                        changeQuantityEle: inputQuantityElement,
                        timeDelayToReCalculate,
                        timeDelayToChangeQuantity,
                        isFirstLoad,
                        buttonOrInput: 'input'
                    });
                    window.BSS_B2B.executeAction({
                        tag: 'change_quantity_cart',
                        storeId: 6652,
                        changeQuantityEle: buttonChangeQuantity,
                        timeDelayToReCalculate,
                        timeDelayToChangeQuantity,
                        isFirstLoad,
                        buttonOrInput: 'button'
                    });
                } else {
                    // fix for budhagirlwholesale by mitri
                    if ([3588, 5273, 4325, 3903].indexOf(BSS_B2B.storeId) === -1) {
                        inputQuantityElement.off();
                        inputQuantityElement.on('change', function () {
                            // fix css with case re-render button checkout
                            if (BSS_B2B.storeId === 11576) {
                                handleStyleButtonCheckout();
                            } else {
                                checkoutButton.forEach(elementButton => {
                                    elementButton.style.pointerEvents = 'none';
                                    elementButton.style.opacity = '0.6';
                                });
                            }
                            setTimeout(function () {
                                BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity,
                                    isFirstLoad);
                            }, timeDelayForStore);
                        });
                    }

                    //Question: side effect when enable off()
                    if ([4101, 4999, 8741].indexOf(BSS_B2B.storeId) !== -1) {
                        buttonChangeQuantity.off();
                    }
                    if (![7788, 3903].includes(BSS_B2B.storeId)) {
                        buttonChangeQuantity.on('click', function () {
                            // fix css with case re-render button checkout
                            if (BSS_B2B.storeId === 11576) {
                                handleStyleButtonCheckout();
                            } else {
                                checkoutButton.forEach(elementButton => {
                                    elementButton.style.pointerEvents = 'none';
                                    elementButton.style.opacity = '0.6';
                                });
                            }
                            setTimeout(function () {
                                BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity,
                                    isFirstLoad);
                            }, timeDelayForStore);
                        });
                    }
                }

                if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                    (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 9)) {
                    $(BSS_B2B.cart.removeButtons).on('click', function () {
                        BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                    });
                }

                setTimeout(() => {
                    if (BSS_B2B.storeId === 11576) {
                        const existingStyle = document.getElementById("customStyleCheckoutForStore11576");
                        if (existingStyle) {
                            document.head.removeChild(existingStyle);
                        }
                    }
                    checkoutButton.forEach(elementButton => {
                        elementButton.style.pointerEvents = 'unset';
                        elementButton.style.opacity = '1';
                    });
                }, timeDelayToReCalculate);
            }
        }
        else {
            if ((isEnableQB && BSS_B2B.qbRules && (BSS_B2B.qbRules.length > 0)) ||
                (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                    (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0))) {
                // do nothing - applied CP and QB
            }
            else {
                $(BSS_B2B.cart.removeButtons).on('click', function () {
                    BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                });
            }

            // Fix turn on only OL
            let timeDelay = 1000;
            setTimeout(() => {
                checkoutButton.forEach(elementButton => {
                    elementButton.style.pointerEvents = 'unset';
                    elementButton.style.opacity = '1';
                    if (BSS_B2B.storeId === 9461) {
                        elementButton.classList.add('bss-checkout-loaded');
                    }
                });
            }, timeDelay);

            inputQuantityElement.on('change', function () {
                // fix css with case re-render button checkout
                if (BSS_B2B.storeId === 11576) {
                    handleStyleButtonCheckout();
                } else {
                    checkoutButton.forEach(elementButton => {
                        elementButton.style.pointerEvents = 'none';
                        elementButton.style.opacity = '0.6';
                    });
                }
                setTimeout(function () {
                    BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                }, timeDelay);
            });
            if (BSS_B2B.storeId === 5686 && inputQuantityElement.length) {
                // do nothing
            } else {
                buttonChangeQuantity.on('click', function () {
                    // fix css with case re-render button checkout
                    if (BSS_B2B.storeId === 11576) {
                        handleStyleButtonCheckout();
                    } else {
                        checkoutButton.forEach(elementButton => {
                            elementButton.style.pointerEvents = 'none';
                            elementButton.style.opacity = '0.6';
                        });
                    }
                    setTimeout(function () {
                        BSS_B2B.cart.cartQtyOnChange(timeDelayToReCalculate, timeDelayToChangeQuantity, isFirstLoad);
                    }, timeDelay);
                });
            }

            window.BSS_B2B.executeAction({ tag: `enable_checkout_mini_cart`, storeId: 4927, checkoutButton, timeDelayToReCalculate });
        }

        BSS_B2B.cart.visibleElementAfterUpdateQuantity(isAjaxCart, isChangeQuantity);
        // for greystones-imports, curlysecret by CuongNVM
        if ([4180, 621].indexOf(BSS_B2B.storeId) !== -1 && window.location.pathname === '/cart') {
            $('.cart__footer .cart__blocks button[name="checkout"]').attr('disabled', false);
            $('.cart--footer .cart--checkout-button button[name="checkout"]').attr('disabled', false);
        }
        BSS_B2B.cart.hoverMiniCart(shopData, cartData, isChangeQuantity, isAjaxCart, productMap, updatedLineItems,
            isFirstLoad);
    };

    BSS_B2B.cart.visibleElementAfterUpdateQuantity = function (isAjaxCart, isChangeQuantity) {
        if (isAjaxCart) {
            $('[bss-b2b-ajax-cart-subtotal], ' + '.cart-drawer__subtotal-value,' + '[bss-b2b-ajax-cart-line-price], ' +
                '[bss-b2b-ajax-original-line-price],' + '[data-cart-price-bubble][data-cart-price],' +
                '[data-section-id="cart-drawer"] [data-cart-subtotal],' + '#ajaxifyCart .cart-subtotal--price,' +
                '.drawer .cart-item__price,' + '.cartTotalSelector').show();
        }

        if (isChangeQuantity) {
            $('[data-cart-item-regular-price],' +
                '[data-cart-item-id]  [data-cart-item-price-container] .cart-item__original-price,' +
                '[data-cart-item-id]  [data-cart-item-line-price-container] .cart-item__original-price').fadeIn(700);
            $('[data-cart-subtotal],#cart-total,#total-cart-bottom,[bss-b2b-ajax-cart-subtotal], [bss-b2b-ajax-cart-line-price]').
                fadeIn(700);
        }
        else {
            $('[bss-b2b-cart-item-key],' + '[bss-b2b-cart-total-price],' + '[data-cart-item-regular-price],' +
                '[data-cart-subtotal]').css('visibility', 'visible');
        }

        if ((isChangeQuantity || isAjaxCart) && BSS_B2B.storeId !== 6526) {
            $('[bss-b2b-cart-item-key],' + '[data-cart-subtotal],' + '#cart-total,#total-cart-bottom,' +
                '[bss-b2b-ajax-cart-subtotal],' + '[bss-b2b-cart-item-key][bss-b2b-original-line-price], ' +
                '[data-cart-item-regular-price], ' + '[bss-b2b-ajax-original-line-price],' + '[bss-b2b-product-id]:not([bss-b2b-product-compare-price]),' +
                '[bss-b2b-final-line-price],' + '[bss-b2b-item-final-price],' +
                '[bss-b2b-product-id][bss-b2b-product-sale-price],' + //fix for nobby-mexico by XuTho
                '.product-price,' + '[bss-b2b-product-id].priceRow,' + // fix for imageexchange
                '[bss-b2b-product-id][bss-b2b-product-handle][bss-b2b-variant-id],' + //Fix for benki-brewingtools
                '.cart-prod-price .money span,' + //Fix for idoinebio
                '.ajaxcart__price span[bss-b2b-ajax-original-line-price],' + //Fix for epicb2c
                '.atc-banner--container [data-atc-banner-product-price-value],' +
                '.atc-banner--container [data-atc-banner-cart-subtotal],' + '[bss-b2b-cart-total-price]').
                css('visibility', 'visible').
                show();

            if (BSS_B2B.storeId === 1655) {
                $('.header .money.sale,' + '.header .cart_subtotal.js-cart_subtotal').css('visibility', 'visible');
            }
            else if (BSS_B2B.storeId === 8446) {
                document.addEventListener('bss_b2b_doneCheckCp', () => {
                    setTimeout(() => {
                        $('[bss-b2b-final-line-price], [bss-b2b-cart-total-price]').css('visibility', 'unset');
                    }, 1000);
                });
            }
        }
    };

    function handleStyleButtonCheckout() {
        const existingStyle = document.getElementById("customStyleCheckoutForStore11576");
        if (!existingStyle) {
            const customCSS = `
                form[action*='cart'] button[name='checkout'] {
                pointer-events: none !important;
                opacity: 0.6 !important;
                }
            `;
            const styleCustomCheckoutElement = document.createElement('style');
            styleCustomCheckoutElement.type = 'text/css';
            styleCustomCheckoutElement.innerHTML = customCSS;
            styleCustomCheckoutElement.id = "customStyleCheckoutForStore11576";
            document.head.appendChild(styleCustomCheckoutElement);
        }
    }
}
// CONCATENATED MODULE: ./js/src/cart/handle-ajax-cart.js



function handle_ajax_cart_handleAjaxCart($, BSS_B2B, shopData, isEnableQB, isEnableDC, isEnabledTD, isEnableCP, isEnabledQI, isEnableAMO, isEnabledTE, isEnableEF) {
    BSS_B2B.makeChangesAfterClickAjaxCart = function (ajaxCartDelayTime) {
        $('[bss-b2b-ajax-cart-subtotal], ' +
            '.cart-drawer__subtotal-value, ' +
            '[bss-b2b-ajax-cart-line-price], ' +
            '[bss-b2b-ajax-original-line-price],' +
            '[data-cart-price-bubble][data-cart-price], '
            + '[data-section-id="cart-drawer"] [data-cart-subtotal],'
            + '#ajaxifyCart .cart-subtotal--price,'
            + 'header[data-sticky-class="header-mobile-center header-color-dark"] > .money,'
            + '.cartTotalSelector,'
            + '.header-cart[data-ajax-cart-trigger],'
            // fix wilberrys by vitu
            + 'span[x-html="formatMoney(item.line_price)"],'
            + '.sp-cart-total-price,'
            + '.sp-total .sp-price.full-total-js,'
            + '.tt-cart-total-row .tt-cart-total-price'
            + BSS_B2B.getCartPriceClass('ajax_cart_item_original_price')
            + BSS_B2B.getCartPriceClass('ajax_cart_item_regular_price')
            + BSS_B2B.getCartPriceClass('ajax_cart_item_line_price')
            + BSS_B2B.getCartPriceClass('ajax_cart_original_item_line_price')
            + BSS_B2B.getCartPriceClass('ajax_cart_total')
            + BSS_B2B.getCartPriceClass('ajax_cart_subtotal')
        ).hide();

        if (BSS_B2B.storeId === 7609) {
            document.querySelector('.tt-cart-total-price').style.display = 'block';
        }

        if(BSS_B2B.storeId === 12914){
            ajaxCartDelayTime = 500;
        }
        
        if ([10435].indexOf(BSS_B2B.storeId) !== -1) {
            $(BSS_B2B.cart.buttonChangeQuantity).hide();
        }

        //fix for Hi-Lux by CuongNVM
        if ([3351, 3536, 894].indexOf(BSS_B2B.storeId)) {
            $('.header-cart[data-ajax-cart-trigger]').show();
        }

        $('.atc-banner--container [data-atc-banner-product-price-value],'
            + '.atc-banner--container [data-atc-banner-cart-subtotal]').css('visibility', "hidden");
        setTimeout(function () {
            // fix for b2b-reinh-art by ThaBi
            if ([3196, 4856, 6289, 6579, 9342].indexOf(BSS_B2B.storeId) !== -1) {
                BSS_B2B.cp.changeProductPrice(shopData, null, false);
            }
            //fix for valleys-group by hoaduong
            if (BSS_B2B.storeId === 3196) {
                setTimeout(() => {
                    $('.ajax-cart__item-quantity').on('click', function () {
                        BSS_B2B.cart.cartQtyOnChange(1000, 1000, true);
                    })
                }, 3000)
            }
            //fix for sextoysupplycn by DongNV
            if ([3798, 4661, 4696, 4739, 9398].indexOf(BSS_B2B.storeId) === -1) {
                BSS_B2B.cart.fixer(shopData, false, true);
            }

            if ([6809].indexOf(BSS_B2B.storeId) !== -1 && BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length  && !BSS_B2B.page.isCartPage()) {
                let comparePrice = document.querySelectorAll("[bss-b2b-product-compare-price]");
                if(comparePrice.length) {
                    comparePrice.forEach(price => {
                        if(price.offsetHeight === 0){
                            price.remove()
                        }
                    })
                }
            }
            
            if ([6171].indexOf(BSS_B2B.storeId) !== -1) {
                setTimeout(() => {
                    BSS_B2B.cp.changeProductPrice(shopData, '[bss-b2b-product-compare-price]', false);
                }, 1000);
            }
            setTimeout(function () {

                BSS_B2B.handleQuantityChangeAjaxCart(true);
                let miniCart = $(BSS_B2B.cart.miniCartContainer);
                let taxDisplayEleInMiniCart = miniCart.find('.bss-b2b-cart-vat');
                
                if (!BSS_B2B.page.isCartPage() || (BSS_B2B.page.isCartPage() && taxDisplayEleInMiniCart.length)) {
                    if (isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length) {
                        if (
                            (!isEnableCP || ((!BSS_B2B.configData && !BSS_B2B.plConfigData) || (!BSS_B2B.configData.length && !BSS_B2B.plConfigData.length)))
                            && (isEnableQB || BSS_B2B.storeId !== 6605)
                            && (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0))
                        ){
                            let appliedTaxDisplayRule = taxDisplayRules_default.a.getAppliedRuleCartPage(BSS_B2B, shopData);
                            tax_default.a.bssB2BCartChangeAllVatPriceWithoutCP(shopData, appliedTaxDisplayRule);
                            tax_default.a.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedTaxDisplayRule);
                        }
                    }
                }                

                // fix for b2b-reinh-art by ThaBi
                if (BSS_B2B.storeId === 1759) {
                    let agreeInput = $('input.js_agree_ck');
                    if (agreeInput.length > 0) {
                        if (agreeInput.is(':checked')) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                        }

                        agreeInput.on("change", function () {
                            if (agreeInput.is(':checked')) {
                                BSS_B2B.handleCartCheckoutBtn(shopData);
                            } else {
                                $(document).on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                })
                            }
                        })
                    }
                } else if ([10435, 14703].indexOf(BSS_B2B.storeId) !== -1) {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                    $(BSS_B2B.cart.buttonChangeQuantity).show();
                    $(BSS_B2B.cart.buttonChangeQuantity).on("click", function () {
                        BSS_B2B.cart.fixer(shopData, false, false);
                        BSS_B2B.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
                    })
                } else if ([11141].indexOf(BSS_B2B.storeId) !== -1) {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                    $(BSS_B2B.cart.inputQuantityElement).on("change", function () {
                        $('.btn-update-qty.active-update').on("click", function () {
                            setTimeout(function () {
                                BSS_B2B.cart.fixer(shopData, false, false);
                                BSS_B2B.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
                            }, 1500)
                        });
                    })
                } else {
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                }
            }, ajaxCartDelayTime);
        }, ajaxCartDelayTime);
    };

    if ([3976, 11154, 11985].includes(BSS_B2B.storeId)) {
        BSS_B2B.makeChangesAfterClickAjaxCart(true)
    }

    BSS_B2B.handleAjaxCart = function () {
        let checkoutButton = document.querySelectorAll(BSS_B2B.helper.checkoutElements);
        if (!BSS_B2B.page.isCartPage()) {
            if ($('[data-cart-price-bubble][data-cart-price]').length && $('[data-cart-price-bubble][data-cart-price]').html() !== '') {
                $('[data-cart-price-bubble][data-cart-price]').hide();
                BSS_B2B.cart.fixer(shopData, false, true);
            }
        }

        let ajaxCartDelayTime = 1500;
        if ([537, 13871].includes(BSS_B2B.storeId)) {
            ajaxCartDelayTime = 2200;
        }
        if (BSS_B2B.storeId === 2275) {
            // fix girish-757 by vitu
            ajaxCartDelayTime = 1000;
        }
        if (BSS_B2B.storeId === 4334) {
            ajaxCartDelayTime = 0;
        }
        if ([7619].includes(BSS_B2B.storeId)) {
            return;
        }

        let customAjaxCartDelayTime = BSS_B2B.getCssSelector('ajax_cart_time_delay_opening_cart');
        if (customAjaxCartDelayTime !== '' && !isNaN(customAjaxCartDelayTime)) {
            ajaxCartDelayTime = parseInt(customAjaxCartDelayTime)
        }

        let ajaxCartElement = $('[id^="AddToCart"]:not(form), ' +
            '[id^="addToCart"]:not(form):not(span),' +
            'button[aria-controls="CartDrawer"],' +
            'a[aria-controls="CartDrawer"]:not(:has(.cart-link)),' +
            'header.site-header.medium--hide.small--hide a[aria-controls="CartDrawer"],' +
            'nav.nav-bar.mobile-nav-bar-wrapper.large--hide.medium-down--show a[aria-controls="CartDrawer"],' +
            'button[name="add"].product-form__add-to-cart,' +
            'button[name="add"].product__add-to-cart-button,' +
            'button[name="add"].add-to-cart,' +
            'a.ajax-cart__toggle,' +
            'span.icon__fallback-text,'
            + 'button#add-to-cart.add-to-cart,'
            + '.product-form__submit[type="submit"],'
            + 'a.cart-toggle,'
            + '.mini-cart-wrap[data-cart-mini-toggle],'
            + '.addtocart-button-active[data-product-submit],'
            + 'button.product-form--atc-button,'
            + 'button.productitem--action-atc,'
            + '#add-to-cart-product-template,'
            + '.product-form__add-button[data-action="add-to-cart"],'
            + '.header__cart-toggle[data-action="toggle-mini-cart"],'
            + 'button[type="submit"][data-action="add-to-cart"],'
            + 'button.btn-addtocart,'
            + 'form[action*="/cart/add"] input.AddtoCart,'
            + 'a[data-cart-toggle][data-dropdown-menu],'
            + 'input[data-btn-addtocart],'
            + '.cart-block-click,'
            + 'button[data-btn-addtocart],'
            + 'a.js-cart-trigger[href="/cart"],'
            + 'form.js-product-form,'
            //fix for steve-labpro by ThaBi
            + 'form[action*="/cart/add"] button.single_add_to_cart_button.button,'
            + '.Header__Wrapper .Header__FlexItem a[data-drawer-id="sidebar-cart"],'
            + 'button.product-form__cart-submit,'
            + '.add-to-cart-box .add-to-cart,'
            + 'a.header-cart-btn.cart-toggle,'
            //fix biomatrixweb by vitu
            + '.product-page--submit-action .btn,'
            //fix monpetitherbier by vitu
            + '.ajax-submit.action_button.add_to_cart,'
            + '.site-header__cart.cart-modal,'
            + 'form[action*="/cart/add"] button.ajax-submit.button--add-to-cart,'
            + 'form[action*="/cart/add"] div.add-to-cart button.button[type="submit"],'
            // fix for shop.repairpartners by ThaBi
            + 'a.add-cart-btn,'
            + 'button.tt-dropdown-toggle,'
            + '.quick-view button.add-to-cart-btn.btn,'
            + 'button.add.font--secondary-button,'
            + 'button[type="submit"].gf_add-to-cart.product-form-product-template,'
            + 'a.header--cart-link.font--accent,'
            // fix for dugit by tuli
            + '.icon-bag.mini_cart.dropdown_link,'
            // fix for americanbaileyllc by ThaBi
            + 'a.my-cart-link,'
            // fix for curlysecret by ThaBi
            + '.product-form--button-container button.product-form--add-to-cart,'
            // fix korresshop-greece by vitu
            + '.product-form--submit span.price,'
            // fix for b2b-reinh-art by ThaBi
            + 'a.push_side.pr.cb.chp.db,'
            + '.ProductForm__AddToCart,'
            // fix for sopoly by mitri
            + '.slideout__trigger-mobile-menu.js-mini-cart-trigger.js-slideout-open,'
            // fix for nippergr by mitri
            + 'button.btn.btn--full.btn--status.btn--animated.js-product-button-add-to-cart,'
            + 'a.header__btn-cart.js-popup-button,'
            + '.payment-buttons button[data-add-to-cart],'
            + 'a.js-product-button-add-to-cart,'
            // fix for snugglebunny by mitri
            + '.js-drawer-open-cart:not(:has(.cart-link)),'
            + 'button.btn.btn--tertiary.add-to-cart,'
            // fix for meducare by mitri
            + '.cart-link,'
            + '.mini-cart a.icon-link,'
            // fix for lightscanada by mitri
            + '.quick-cart__indicator,'
            + 'button.js-quick-add-btn,'
            // fix for ltdidierlab by mitri
            + '.add-to-cart-box,'
            // fix for locale-beauty
            + '#cartTotal,'
            // fix wilberrys by vitu
            + '.whitespace-nowrap a[href="/cart"],'
            + '.add-to-cart-container > button,'
            // fix for rademakersports by mitri
            + '.btn.add-to-cart,'
            // fix for bleubird by DangNM
            + '[data-shop-url="https://bleubird.com"] .cart .icon-cart.cart-button:first-child,'
            + 'button.button.button--large[type="submit"][data-add-to-cart-text],'
            // fix for claveclub by mitri
            + '.product__submit__item,'
            + '.cart.border-0,'
            // fix for eliza by CuongNVM
            + '.cart-icon.svg-mb a,'
            // fix for bien-moves by CuongNVM
            + '.header--cart .header--cart-link,'
            + '.cart-button,'
            + '.cart-icon svg,'
            + 'button .product__add-to-cart.product--add-to-cart-button.button.button--outline,'
            // fix for watcstudio by mitri
            + '.site-cart-handle .cart-menu,'
            + '.cart-functions.payment-button--false .product__add-to-cart.product--add-to-cart-button,'
            // fix for kafea-coffee by KhanhND
            + '.cart.js-call-minicart,'
            + 'button[type="submit"].shop-button.enj-add-to-cart-btn.engoj-btn-addtocart,'
            // fix for preprod-la-boutique-du-pilote by mitri
            + '.cart_container .cart_count,'
            // fix for elicious by CuongNVM
            + '.sidebar__cart-handle,'
            + '.mini-cart,'
            // fix for thatsoitaly by mitri
            + '.header__desktop__button .cart__icon__content,'
            // fix for kraeutermax by CuongNVM
            + '.header-col.header-col-right .header-icons,'
            // fix for knobs-pulls-things by CuongNVM
            + '.header__item.header__item-cart .icon-cart-full,'
            + '.navlink.navlink--cart,'
            // fix for thepackunderwear by CuongNVM
            + '.quantity-submit-row__submit .button--large,'
            // fix for surfacecart-store by CuongNVM
            + '.current-cart.toggle-cart-summary .current-cart-icon,'
            + '.btn.product-add.mini-form.alt.outline,'
            + '.product-form.product-form--mini .btn.product-add,'
            // fix for high-5-vape by mitri
            + 'button.btn-quick-add,'
            + 'form[action*="/cart/add"] button #atc-custom-custom,'
            // fix for sachajuan-b2b-us by dongnv
            + '.product-info .productForm-buttons,'
            + '.incubate-collections-add-to-cart-add-to-cart-button,'
            + '.buy__now__btn button[type="submit"].cart__menu,'
            + '.shopCartBlock #openminiCart,'
            // fix for provisionswholesale.coop HaiPd
            + '.shopping-cart,'
            // fix for vertellav2 by dongnv
            + '#nav .navbar .dropdown-grid .cart-icon,'
            // fix for caryacademy by mitri
            + '.product-single__add-to-cart,'
            // fix for nimbus-focal by CuongNVM
            + '.header__icon-list .header__icon-wrapper.tap-area,'
            // fix for cookingpalofficial by CuongNVM
            + '.cart_container.button-show-pdp,'
            + '.slideout__trigger-mobile-menu.js-mini-cart-trigger.js-modal-open,'
            // fix for kick-essentials.com by huydt
            + '.product__add-to-cart.button,'
            + '.header .header__icons #cart-icon-bubble,'
            + '#CollectionProductGrid .product-collection button[type="submit"].btn,'
            + '#AddToCart-product-template,'
            + '.site-header__link.site-header__cart.cart-link.js-drawer-open-right.cart-bubble--visible,'
            // fix for test-demo-store11.myshopify by LuanHV                    
            + '.product-image .product-action .add-to-cart,'
            + '.hover_button .pr_atc,'
            //fix for caos-gear by CuongNVM
            + '.purchase-details__buttons.purchase-details__spb--false,'
             //fix for santabarbaralighting.com by Ducnv
            + '[data-name="product-submit-wrapper"] button,'
            // fix for casa-do-ashe by haipd
            + '.t4s-product-form__submit.t4s-btn,'
            + '.t4s-pr.t4s-icon-cart__wrap,'
            + '#header-right-menu .menu-item.header__cart,'
            + '.product-form button.btn.product-add,'
            + '.header-container a.button[aria-controls=site-cart-sidebar],'
            + '.card--default .button--addToCart,'
            + 'form[action="/cart/add"] .button--addToCart,'
            + '.topbar-item a.icon-cart,'
            + '.product-actions button[type="submit"].btn-anm-cart,'
            + '.sp-cart button.sp-dropdown-toggle,'
            + '.single-button button.btn-addtocart.addtocart-js,'
            + 'button.quick-add__submit,'
            + '.add-to-cart-btn[type=submit],'
            + 'button.ProductForm__AddToCart.Button.Button--full.Button--primary,'
            + '#shopify-section-header .thb-secondary-cart,'
            + '.hide-on-mobile a.icon-cart,' 
            + '.push-btn.theme-button,'
            // fix for dollie-wholesale by PhuDV
            +'.header-cart .js-header-cart.header-cart__link,'
            +'.js-btn-addtocart.btn.btn--add-to-cart,'
            // fix for alchemy-jars by PhuDV
            + '.w-commerce-commercecartopenlink.cart_menu_link,'
            + 'button#AddToCart,'
            + 'button.button.button-add-to-cart,'
            + '.header__right .header__icon-touch--cart,'
            + '#mini-cart-toggle,'
            + 'a.site-nav__link.site-nav__link--icon.site-nav__link--cart.js-drawer-open-cart.js-no-transition,'
            + 'button.btn.btn--tertiary.btn--full.add-to-cart,'
            + 'a[aria-controls="cart-drawer"],'
            // fix for cafecanal.ca by PhuDV
            + '.product-cart-action a[data-product-id][data-product-qty],'
            +'button.button--outline.button--regular.button--fullwidth.button--loader,'
            // Fix inglotbenelux by donglt
            + '#cart-icon-bubble,'
            + 'button.btn.action-item.btn-add-cart,'
            + 'span.icon-button.icon-button-header-shopping-cart,'
            + '.js_addtc.Add.to.Cart,'
            + '.single_add_to_cart_button,'
            + '.form__actions .buyButton,'
            + '.payment-and-quantity .payment-and-quantity__add button[data-btn-type="add-to-cart"],'
            + '#AddToCart,'
            + '.info_bottom .add-to-cart:has(form),'
            + '.button--single-cart-main,'
            +'.header-classic__content a[href="/cart"],'
            + '.thb-secondary-item-icon,'
            + '.cart-icon-bubble.header__icon.header__icon--cart,'
            + '.add-to-cart__submit button.btn.btn-contact,'
            + 'form[action="/cart/add"] .\\#products-counter-wrapper .\\#button,'
            + '.btn-add-to-cart.btn-cart-js,'
            + '.action-cart.js-cart-drawer-toggle.p-relative,'
            + 'button.button.button--outline[type="submit"],'
            + 'button.product-card__quick-add-button[type="submit"],'
            + '.header__icon-touch.no-transition:not(.header__icon-touch--search),'
            // Fix ichi by trungdd
            + "#nav-user .cart,"
            + ".overlay-tertiary,"
            + '.button.js-add-to-cart.btn_add-cart.white-text-button,'
            + '.product-infor a.button.btn,'
            + '.product-infor form[action="/cart/add"] .button.js-add-to-cart,'
            + '.quantity-add-to-cart-wrapper input.add-to-cart,'
            + '.button-cart.cart-open-js.button-cart-js,'
            + ".btn-1.button-card.btn--regular.button-card-js.btn-cart-js,"
            + '.ProductForm__BuyButtons .ProductForm__AddToCart.Button.Button--secondary.Button--full[type="submit"],'
            + '.btn-add-to-cart,'
            + 'buy-buttons button[type="submit"],'
            + '.product-form__submit.button.button--primary,'
            + '#MinimogCartDrawer'
            + BSS_B2B.getCssSelector('ajax_cart_action_button'));
        //fix for sextoysupplycn by DongNV
        let ajaxAddCartElement4696 = $('.product-form__add-button[data-action="add-to-cart"]');
        // fix for sachajuan-b2b-us by dongnv
        if ([5001, 5255, 6171, 6699, 6765].indexOf(BSS_B2B.storeId) !== -1) {
            ajaxCartDelayTime = 500;
        }
        if ([8123].includes(BSS_B2B.storeId)) {
            ajaxCartDelayTime = 200;
        }
        if (BSS_B2B.storeId === 6605) {
            ajaxCartElement = $('.header__icon-list a[href="/cart"]');
        }

        // fix for storeID 6011
        window.BSS_B2B.executeAction({tag: `ajax_cart`, storeId: 6011, BSS_B2B, shopData});

        if (ajaxCartElement.length || BSS_B2B.storeId !== 6011) {
            $(ajaxCartElement).each(
                function () {
                    if (!$(this).attr("bss-ajax-cart-checkout-event")) {
                        if (![8713].includes(BSS_B2B.storeId)) {
                            $(this).attr("bss-ajax-cart-checkout-event", true);
                        }
                        $(this).on("click", function () {
                            let isAppliedEF = isEnableEF && BSS_B2B.efRules && BSS_B2B.efRules.length
                            if (isAppliedEF) {
                                BSS_B2B.calculateModules.get("EF").isDoneCalculate = false;
                            }
                            if(BSS_B2B.storeId === 14081 && isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length ){
                                $('button#addToCartButton').addClass('bss-b2b-qi');
                              }
                            if (isEnableAMO && Array.isArray(BSS_B2B.amoRules) && BSS_B2B.amoRules.length > 0) {
                                checkoutButton.forEach(elementButton => {
                                    elementButton.style.cssText = "pointer-events: none; opacity: 0.6;";
                                });
                            }
                            setTimeout(function () {
                                BSS_B2B.handleCartCheckoutBtn(shopData);
                            }, 500);
                            if(BSS_B2B.storeId === 2865) {
                                setTimeout(function () {
                                    BSS_B2B.handleCartCheckoutBtn(shopData);
                                }, 2500);
                            }
                            //fix for sextoysupplycn by DongNV
                            if ([4696, 4661, 4739, 4856, 6289, 8356].indexOf(BSS_B2B.storeId) === -1) {
                                BSS_B2B.makeChangesAfterClickAjaxCart(ajaxCartDelayTime);
                            }
                            if ([10748, 8337].includes(BSS_B2B.storeId)) {
                                let timeDelay = 2000
                                if (BSS_B2B.storeId === 10748) {
                                    timeDelay = 3000
                                }
                                setTimeout(()=>{
                                    BSS_B2B.handleAjaxCart()
                                },timeDelay)
                            }
                            // fix for kick-essentials.com by huydt
                            if ([5550].indexOf(BSS_B2B.storeId) !== -1) {
                                ajaxCartDelayTime = 1500;
                            }
                            // fix for b2b-canada-biosteel by cuongnq
                            if ([7232].indexOf(BSS_B2B.storeId) !== -1) {
                                if (isEnabledQI) {
                                    $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                                }
                            }
                            if ([10989].indexOf(BSS_B2B.storeId) !== -1) {
                                const disableCheckoutMiniCart = setInterval(() => {
                                    const cartSliderShow = $('#sidebar-cart[aria-hidden="false"]')
                                    if (isEnableCP && cartSliderShow) {
                                        $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                                    }
                                }, 100)
                                setTimeout(() => {
                                    clearInterval(disableCheckoutMiniCart)
                                }, 2500)
                            }
                            // fix for lnccabinetry.com by cuongnq
                            if ([9907].includes(BSS_B2B.storeId)) {
                                setTimeout(() => {
                                    $(BSS_B2B.helper.checkoutElements).css({'pointer-events': 'none', 'opacity': '0.6'});
                                }, 1500);
                            }
                            // fix for coventa-demo.myshopify
                            if ([5838, 8234, 8356, 8713].includes(BSS_B2B.storeId)) {
                                let timeDelayCartFixer = 0;
                                if (BSS_B2B.storeId === 5838) {
                                    timeDelayCartFixer = 4000;
                                }
                                if (BSS_B2B.storeId === 8234) {
                                    timeDelayCartFixer = 1000;
                                }
                                if (BSS_B2B.storeId === 8356) {
                                    timeDelayCartFixer = 2000;
                                }
                                if (BSS_B2B.storeId === 8713) {
                                    timeDelayCartFixer = 1500;
                                }
                                setTimeout(() => {
                                    BSS_B2B.cart.fixer(shopData, false, false);
                                }, timeDelayCartFixer)
                            }

                            if ([8446, 9207].includes(BSS_B2B.storeId)) {
                                BSS_B2B.cart.fixer(shopData, true, true);
                                if (isEnabledTD && isEnableQB) {
                                    setTimeout(() => {
                                        let priceQBTableAppliedTD = document.querySelectorAll('.bss-b2b-qty-table-row td .transcy-money');
                                        if (priceQBTableAppliedTD) {
                                            for (let i = 0; i < priceQBTableAppliedTD.length; i++) {
                                                priceQBTableAppliedTD[i].style.display = 'unset';
                                            }
                                        }
                                    }, 5000);
                                }
                            }

                            // fix for onforuleds.com by cuongnq
                            if ([8640].includes(BSS_B2B.storeId)) {
                                let currentProduct = { ...shopData.product, collections: shopData.collections };
                                shopData.line_item_products.push(currentProduct);
                                setTimeout(() => {
                                    BSS_B2B.cart.fixer(shopData, true, true);
                                }, 500)
                            }

                            if ([4856, 6289].indexOf(BSS_B2B.storeId) !== -1) {
                                BSS_B2B.cp.changeProductPrice(shopData, false, false);
                            }
                            if ([6719, 14373].indexOf(BSS_B2B.storeId) !== -1) {
                                setTimeout(function () {
                                    window.BSS_B2B.executeAction({tag: "change_variant_ajax_cart", storeId: 14373, BSS_B2B: window.BSS_B2B, shopData})
                                    window.BSS_B2B.executeAction({tag: "change_ajax_cart", storeId: 14373, BSS_B2B: window.BSS_B2B, shopData})
                                    BSS_B2B.cp.changeProductPrice(shopData, null, false);
                                }, 2000)
                            }
                            if ([8856, 8337, 4266, 9817, 10748, 15872].indexOf(BSS_B2B.storeId) !== -1) {
                                let timeDelay = 2000
                                if (BSS_B2B.storeId === 8337) {
                                    timeDelay = 2500
                                }
                                setTimeout(() => {
                                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                                },timeDelay)
                            }
                            if ([3820,5130].indexOf(BSS_B2B.storeId) !== -1) {
                                BSS_B2B.handleQuantityChangeAjaxCart(true);
                            }
                            setTimeout(()=>{
                                const discountCodeWrapper = document.querySelector('.bss-b2b-discount-code-wrapper');
                                const taxExemptWrapper = document.querySelector('.bss-b2b-tax-ex-wrapper');
                                if (isEnableDC && BSS_B2B.dcRules && BSS_B2B.dcRules.length && discountCodeWrapper) {
                                    BSS_B2B.integrate.langShop.handleAllTranslation('dc');
                                }
                                if (isEnabledTE && taxExemptWrapper) {
                                    BSS_B2B.integrate.langShop.handleAllTranslation('vat');
                                }
                            }, 1500)
                        });
                    }
                }
            )
            let doneClickAjaxCart = new Event("bss.b2b.cart.doneClickCart");
            document.dispatchEvent(doneClickAjaxCart);

            BSS_B2B.fix.ajaxCart.fixCustomEvent(shopData, ajaxCartDelayTime, ajaxCartElement, taxDisplayRules_default.a, ajaxAddCartElement4696);
        }
    };

    BSS_B2B.handleQuantityChangeAjaxCart = function (isFirstLoad) {
        if (isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length) {
            if (!isEnableCP && ((!BSS_B2B.configData && !BSS_B2B.plConfigData) || (!BSS_B2B.configData.length && !BSS_B2B.plConfigData.length))) {
                return;
            }
        }
        if (BSS_B2B.storeId === 6011) {
            return;
        }
        let ajaxCartChangeQtyDelayTime = isFirstLoad ? 2500 : 2000;
        let customAjaxCartChangeQtyDelayTime = BSS_B2B.getCssSelector('ajax_cart_time_delay_changing_qty');
        if (customAjaxCartChangeQtyDelayTime !== '' && !isNaN(customAjaxCartChangeQtyDelayTime)) {
            ajaxCartChangeQtyDelayTime = parseInt(customAjaxCartChangeQtyDelayTime)
        }
        let adjustQuantityButton = $('form[action*="/cart"] .ajaxcart__qty-adjust,'
            + 'form[action*="/cart"] .ajaxifyCart--qty-adjuster,'
            + 'form[action*="/cart"] .js-qty__adjust,'
            + 'form[action*="/cart"] .quantity-selector__button,'
            + 'form[action*="/cart"] a[data-action="update-item-quantity"],'
            + 'form[action*="/cart"] button.quantity-selector__button,'
            + 'form[action*="/cart"] a[data-action="decrease-quantity"],'
            + 'form[action*="/cart"] [aria-label="quantity"],'
            + '.cart-window .cart-prod-qty .qty-btn,'
            + 'form[action*="/cart"] span.ajaxifyCart--qty-adjuster,'
            + 'form[action*="/cart"] a.ajaxifyCart--remove,'
            + 'form[action*="/checkout"] .js-change-quantity,'
            //XuTho fix ixcor
            + 'form[action*="/cart"] a.QuantitySelector__Button,'
            + 'form[action*="/cart"] a.CartItem__Remove,'
            //fix for nobby-mexico by XuTho
            + 'ul.mini-products-list a.remove,'
            //fix biomatrixweb by vitu
            + '.cart-item-quantity-button,'
            //fix monpetitherbier by vitu
            + '.left.product-quantity-box .js-change-quantity,'
            + '#cart-modal .quantity-part input[type="button"],'
            + 'form[action*="/cart"] a.minus,'
            + 'form[action*="/cart"] a.plus,'
            + 'div.mini-cart__item--content span.icon-minus,'
            + 'div.mini-cart__item--content span.icon-plus,'
            + '.btn.qty-adjust,'
            + 'span.ss-icon.js-change-quantity,'
            // fix for lightscanada by mitri
            + '.quick-cart__quantity-button,'
            // fix for locale-beauty by XuTho
            + '.inputCounter__btn,'
            // fix wilberrys by vitu
            + 'button[data-qty-adjust="minus"],'
            + 'button[data-qty-adjust="plus"],'
            // fix for shop-ahika by DangNM
            + '.cart__popup-qty.cart__popup-qty--minus,'
            + '.cart__popup-qty.cart__popup-qty--plus,'
            + '.cart__popup-remove a[data-product-id],'
            + 'form[action="/cart"] .quantity__button,'
            // fix for bleubird by DangNM
            + '[data-shop-name="Bleubird"] .cart__quantity .icon-minus,'
            + '[data-shop-name="Bleubird"] .cart__quantity .icon-plus,'
            // fix for Hi-Lux by CuongNVM
            + '.quantity-element.button.is-inverse,'
            // fix for elizawilliam by CuongNVM
            + '[data-minus-quantity-cart],[data-plus-quantity-cart],'
            + '.cart-quantity .qty-group input,'
            // fix for bien-moves by CuongNVM
            + '.cart--quantity--container .cart--minus,'
            + '.cart--quantity--container .cart--plus,'
            + '.adjust-quantity button,'
            + '.icon-plus.plus,'
            + '.icon-minus.minus,'
            // fix for weedlez-filter by DangNM
            + 'a[data-ajax-qty-decrease], a[data-ajax-qty-increase],'
            // fix for wilberrys by ThaBi
            + '.cart-item .qty-button.qty-plus,'
            + '.cart-item .qty-button.qty-minus,'
            + '.mini_cart_actions .quantity .plus, .mini_cart_actions .quantity .minus,'
            + '.scd-item__quantity .scd-item__btn[data-qty-change="dec"], .scd-item__quantity .scd-item__btn[data-qty-change="inc"],'
            + '.input-quantity.js-product-quantity > div[data-control],'
            + 'div.ajax-cart__right-content.media-right a.ajax-cart__delete,'
            //fix for massmarcas ny khanh
            + '.cart__qty .js-qty__adjust,'
            + '#shopMiniCart .plus-qty,'
            + '#shopMiniCart .minus-qty,'
            + '#shopMiniCart .remove-product,'
            // fix for vertellav2 by dongnv
            + 'form[action="/cart"] .cart_row .minus_btn,'
            + 'form[action="/cart"] .cart_row .plus_btn,'
            + '#mini-cart .line-item__remove-button,'
            + '.ajax-cart__item-remove--js.js-cart-remove,'
            + '.cart-dropdown .cart-dropdown__items .cart__quantity [type=button],'
            + '#cart-summary .cart-summary-item .qty-adjuster__up,'
            + '#cart-summary .cart-summary-item .qty-adjuster__down,'
            + '#cart-summary .cart-summary-item .qty-adjuster__remove,'
            + '.mini-cart-inner .mini-cart-quantity .input-group-label[data-minus],'
            + '.mini-cart-inner .mini-cart-quantity .input-group-label[data-plus],'
            // fix for boutique3.l214 by AnhTV
            + 'form[action="/cart"] a.delete-product,'
            + '.qty-control .reduce,'
            + '.qty-control .increase,'
            + '.site-header-cart .btn-remove-cart,'
            + '.tt-cart-box .tt-cart-list .tt-item .tt-item-close .tt-btn-close,'
            + '.qty_selector.t-text.u-blue,'
            + 'quantity-input.quantity-input button,'
            + 'a.mini-cart-item-remove.link-text,'
            // fix for dollie-wholesale.com
            + '.ajaxcart__inner .ajaxcart__remove,'
            + '.quick-cart__control-top .quick-cart__button,'
            + 'button.cart__remove.text-link,'
            // fix for birkmann-gmbh.myshopify.com
            + '.cart-item__column.cart-item__quantity .notabutton,'
            + 'quantity-selector button.minus, quantity-selector button.plus,'
            + '.variant-item__quantity .quantity-popover-container .cart-quantity .quantity__button'
        );

        // fix ama-demo-store.myshopify.com
        let isProductPage = BSS_B2B.page.isProductPage();
        if (isProductPage && BSS_B2B.storeId === 514) {
            let qtyButtonChange = $('.inc.button,'
                + '.dec.button'
            );
            $(qtyButtonChange).on("click", function () {
                let priceElement = $('.product_single_price .grid-link__org_price[bss-b2b-product-id]');
                let priceElementHtml = priceElement.html();
                priceElementHtml = priceElementHtml.replace(/\D/g, "");
                let price = parseFloat(priceElementHtml);
                let qty = $('#quantity').val();
                let newPrice = qty * price;
                let totalPriceElement = $('.total-price span');
                totalPriceElement.html(BSS_B2B.formatMoney(newPrice));
            });
        }
        if (BSS_B2B.storeId === 77 || BSS_B2B.storeId === 1609 || BSS_B2B.storeId === 2433) {
            $(adjustQuantityButton).off();
        }
        if (BSS_B2B.storeId === 6171 || BSS_B2B.storeId === 6699) {
            ajaxCartChangeQtyDelayTime = 3000;
        }
        $(adjustQuantityButton).each(
            function () {
                if (!$(this).attr("bss-ajax-cart-change-quantity-event")) {
                    $(this).attr("bss-ajax-cart-change-quantity-event", true);
                    $(this).on("click", function () {
                        $('[bss-b2b-ajax-cart-subtotal],'
                            + '[bss-b2b-ajax-cart-line-price],'
                            + '[bss-b2b-ajax-original-line-price],'
                            + '.cart-item--total, .cart-recap__price-line-price,'
                            // fix wilberrys by vitu
                            + 'span[x-html="formatMoney(item.line_price)"],'
                            + '[data-cart-item-key] .item_price,'
                            + '#shopMiniCart .totalCartPrice'
                            + BSS_B2B.getCartPriceClass('ajax_cart_total')
                            + BSS_B2B.getCartPriceClass('ajax_cart_subtotal')
                            + BSS_B2B.getCartPriceClass('ajax_cart_item_line_price')
                            + BSS_B2B.getCartPriceClass('ajax_cart_original_item_line_price').split(" ")[1]
                            + BSS_B2B.getCartPriceClass('ajax_cart_item_original_price')
                            + BSS_B2B.getCartPriceClass('ajax_cart_item_regular_price')
                        ).hide();

                        if ([437,5130].indexOf(BSS_B2B.storeId) !== -1) {
                            const checkoutElement = BSS_B2B.cart.checkoutBtnElement();
                            let disableCheckout = true;
                            BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
                        }

                        // fix smokeeraser by vitu
                        if ([2433, 5255, 8337, 9817].indexOf(BSS_B2B.storeId) !== -1) {
                            ajaxCartChangeQtyDelayTime = 700
                        }
                        
                        // fix for bien-moves by CuongNVM
                        if ([3592, 5980, 6699, 8640, 9835, 10085, 9874, 7995, 12156, 12914, 13871].includes(BSS_B2B.storeId)) {
                            setTimeout(function () {
                                BSS_B2B.handleQuantityChangeAjaxCart(false);
                            }, 2000)
                        }

                        // fix for laduora by mitri
                        if ([3798].indexOf(BSS_B2B.storeId) !== -1) {
                            let quantityElement = $('.icon-plus,' + '.icon-minus');
                            setTimeout(function () {
                                $(quantityElement).on('click', function () {
                                    BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                                })
                            }, 1500)
                        }
                        if ([7619].indexOf(BSS_B2B.storeId) !== -1) {
                            let quantityElement = $('.qty_selector.t-text.u-blue option');
                            setTimeout(function () {
                                $(quantityElement).on('click', function () {
                                    BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                                })
                            }, 1500)
                        }
                        setTimeout(function () {
                            // fix goodscollectiveco by dongnv
                            if ([4017, 4946, 9398].indexOf(BSS_B2B.storeId) === -1) {
                                BSS_B2B.cart.fixer(shopData, true, true);
                            }
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                            // fix show cart price for rojodistro (global as well)
                            setTimeout(function () {
                                $('[bss-b2b-original-line-price]').css('visibility', 'visible');
                            }, 500);
                            // fix dragonflybrand by vitu
                            if (BSS_B2B.storeId === 437) {
                                BSS_B2B.dc.showDiscountBox();
                                BSS_B2B.dc.getDiscountCodeApplied();
                            }
                            // fix nimbus-focal by dongnv
                            if ([4856, 6289, 6699, 8123, 11985].includes(BSS_B2B.storeId)) {
                                BSS_B2B.cp.changeProductPrice(shopData, false, false);
                            }
                            if (BSS_B2B.storeId === 9817) {
                                BSS_B2B.cp.changeProductPrice(shopData, '.quick-buy-product .quick-buy-product__info .price-list', false);
                            }
                        }, ajaxCartChangeQtyDelayTime)

                        if (BSS_B2B.storeId === 8337) {
                            BSS_B2B.cp.changeProductPrice(shopData, ('#ProductPrice'), false);
                        }

                        if (BSS_B2B.storeId == 4706) {
                            setTimeout(function () {
                                document.getElementById('openminiCart').click()
                            }, ajaxCartChangeQtyDelayTime + 1000)
                        }
                    });
                }
            }
        )
        let ajaxCartQuantityInput = $('form[action*="/cart"] .ajaxcart__qty-num,'
            + 'form[action*="/cart"] .cart-drawer__input,'
            + 'form[action*="/cart"] .cart-drawer__item-quantity,'
            + 'form[action*="/cart"] input.QuantitySelector__CurrentQuantity,'
            + '.cart-window .cart-prod-qty input.update-product,'
            + 'form[action*="/cart"] input[aria-label="Quantity"],'
            + 'form[action*="/cart"] input[aria-label="quantity"],'
            + 'form[action*="/cart"] input.ajaxifyCart--num,'
            + 'form[action*="/cart"] .ajaxcart__item-content .cart__quantity ,'
            // fix for surgimac by CuongNM
            + 'form[action*="/cart"] [aria-label="quantity"],'
            // fix for the-curious-brownie-company by ThaBi
            + '#cartSlideoutWrapper .cart-item-quantity,'
            // fix for lenka-testovaci by ThaBi
            + '#CartDrawer .js-qty__num,'
            // fix for ciaobrow by ThaBi
            + '.popup-cart .product-cart__input-quantity,'
            //fix biomatrixweb by vitu
            + 'input[aria-label="Quantity"],'
            // fix for bleubird by DangNM
            + '[data-shop-name="Bleubird"] .cart__quantity .quantity,'
            // fix for Hi-Lux by CuongNVM
            + '.quantity-input.quantity-element.input,'
            // fix for elizawilliam by CuongNVM
            + '.mini-products-list .quantity input,'
            + '.cart-quantity .qty-group input,'
            // fix for bien-moves by CuongNVM
            + '.cart--quantity--container .cart--quantity--input,'
            // fix for weedlez-filter by DangNM
            + 'input[class*="updates_"],'
            + 'input[name="updates[]"],'
            // fix for elicious by CuongNVM
            + '.actions input,'
            //fix for massmarcas ny khanh
            + '.cart__qty .js-qty__num,'
            + '#shopMiniCart .input-qty,'
            // fix for alchemy-jars by PhuDV
            + '.w-commerce-commercecartquantity.cart-quantity,'
            + 'quantity-input.quantity-input input,'
            + 'input.cart__quantity,'
            // fix for birkmann-gmbh.myshopify.com
            + '.cart-item__column .cart-item__quantity-input,'
            + '.variant-item__quantity .quantity-popover-container .cart-quantity .quantity__input'
            + BSS_B2B.getCartPriceClass('ajax_cart_quantity_input')
        );
        if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
            // fix for rojodistro,elizawilliam by ThaBi,CuongNVM
            if ([537, 3633, 3643, 3795, 4325, 4285].indexOf(BSS_B2B.storeId) === -1) {
                ajaxCartQuantityInput.off();
            }
        }

        if([10085].indexOf(BSS_B2B.storeId) !== -1){
            ajaxCartQuantityInput.off('change');
        }

        ajaxCartQuantityInput.on("change", function () {
            $('[bss-b2b-ajax-cart-subtotal],' +
                '[bss-b2b-ajax-cart-line-price],' +
                '[bss-b2b-ajax-original-line-price],' +
                '.cart-drawer__subtotal-value,' +
                '.cart-drawer__subtotal-number,'
                + '.drawer .cart-item__price,'
                + '.cart-item--total, .cart-recap__price-line-price,'
                + '[bss-b2b-cart-item-key] .cart__item-price,'
                //fix biomatrixweb by vitu
                + '.cart-item-price-wrapper .cart-item-price'
                + BSS_B2B.getCartPriceClass('ajax_cart_total')
                + BSS_B2B.getCartPriceClass('ajax_cart_subtotal')
            ).hide();

            if ([437,5130].indexOf(BSS_B2B.storeId) !== -1) {
                const checkoutElement = BSS_B2B.cart.checkoutBtnElement();
                let disableCheckout = true;
                BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
            }

            // fix for bien-moves by CuongNVM
            if ([3592, 5980, 6699, 8640, 9835, 10085, 9874, 7995].includes(BSS_B2B.storeId)) {
                setTimeout(function () {
                    BSS_B2B.handleQuantityChangeAjaxCart(false);
                }, 2000)
            }
            if ([4856, 6289, 6699].includes(BSS_B2B.storeId)) {
                setTimeout(function () {
                    BSS_B2B.cp.changeProductPrice(shopData, false, false);
                }, 1500)
            }

            setTimeout(function () {
                BSS_B2B.cart.fixer(shopData, true, true);
                BSS_B2B.handleCartCheckoutBtn(shopData);
                // fix dragonflybrand by vitu
                if (BSS_B2B.storeId === 437) {
                    BSS_B2B.dc.showDiscountBox();
                    BSS_B2B.dc.getDiscountCodeApplied();
                }
            }, ajaxCartChangeQtyDelayTime);
            if (BSS_B2B.storeId === 4706) {
                setTimeout(function () {
                    document.getElementById('openminiCart').click()
                }, ajaxCartChangeQtyDelayTime + 1000)
            }
        });
        if ([2896, 7995, 12914].includes(BSS_B2B.storeId)) {
            ajaxCartQuantityInput.on("change keyup custom.change", function () {
                setTimeout(function () {
                    BSS_B2B.cart.fixer(shopData, true, true);
                    BSS_B2B.handleCartCheckoutBtn(shopData);
                }, 3500);
            });
        }
    }
}

// CONCATENATED MODULE: ./js/src/helper/format-money.js
function formatMoney(shopData, BSS_B2B) {
    BSS_B2B.money_format = shopData.shop.money_format;
    BSS_B2B.formatMoney = function (cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = (format || BSS_B2B.money_format || this.money_format);
        let formatElement = [
            "<span class=money>",
            "</span>",
            "<div class=dualPrice>",
            "</div>",
            "<span class=dualPrice>",
            "<span class=hidePrice>",
            "<span class=transcy-money>",
            "<span>"
        ];

        for (let i = 0; i < formatElement.length; i++) {
            if (formatString.includes(formatElement[i])) {
                formatString = formatString.replace(formatElement[i], "");
            }
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if ([14113, 14886].includes(BSS_B2B.storeId)) {
                precision = 0;
            }

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            let parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_with_period_separator':
                value = formatWithDelimiters(cents, 2, ',', '.');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'", '.');
                break;
        }
        if ([12691, 15312].includes(BSS_B2B.storeId)) {
            formatString = `${formatString.replace(placeholderRegex, value)} ${Shopify.currency.active} `
          }
        if (BSS_B2B.storeId === 12303) {
            if (Shopify.country === "AU" || Shopify.country === 'NZ') {
                formatString = `A${formatString}`;
            }
            if (parseFloat(value) == parseInt(value)) {
                value = formatWithDelimiters(cents, 0);
            }
        }
        if (BSS_B2B.storeId === 6699) {
            value = `HT ${value}`;
        }
        if (BSS_B2B.storeId === 11668 && String(value).includes(".")) {
            value = String(value).replace('.', '<sup>').concat('</sup>');
        }
        return formatString.replace(placeholderRegex, value);
    };
}

// CONCATENATED MODULE: ./js/src/currency/init-multi-currency.js
function initMultiCurrency($, BSS_B2B, shopData, isEnableCP, isEnableQB) {
    BSS_B2B.MC.data = {};
    const currencyConfig = BSS_B2B.currencyConfig;
    const currencyFormat = BSS_B2B.currencyFormat;
    const currencyList = JSON.parse(BSS_B2B.currencyConfig.currency_list);
    let shopCurrencyCode = [4824, 15797].includes(BSS_B2B.storeId) ? shopData.shop.cart_current_currency: shopData.shop.currency;
    const shopMoneyFormat = shopData.shop.money_format;
    let cartCurrentCurrencyCode = shopData.shop.cart_current_currency;
    const shopMultiCurrencyCode = shopData.shop.multi_currencies;
    
    let Currency = window.Currency;
    let isFirstTime = false;

    let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
    let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");

    if (!sessionCurrencyCode) {
        isFirstTime = true;
        sessionCurrencyCode = shopCurrencyCode;
        window.localStorage.setItem("currentCurrency", sessionCurrencyCode);
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({currency: sessionCurrencyCode})
        }); 
    }


    if (!sessionCurrencyFormat) {
        sessionCurrencyFormat = shopMoneyFormat;
        window.localStorage.setItem("currentCurrencyFormat", sessionCurrencyFormat);
    }

    let isValidCurrencyCode = false;

    currencyList.map((item) => {
        if (sessionCurrencyCode === item.code) {
            isValidCurrencyCode = true;
        }
    });

    if(!isValidCurrencyCode) {
        window.localStorage.setItem("currentCurrency", shopCurrencyCode);
    }

    let $currentCurrencyElement = $('.bss-nice-select span.current-currency');
    let $currentCurrencyFlag = $('.bss-nice-select span.current .flags');
    $('.option.notranslate.selected').removeClass('selected');
    let selectedFlag = $(`.option.notranslate[data-value="${sessionCurrencyCode}"]`).find('.flags').attr('class');
    $(`.option.notranslate[data-value="${sessionCurrencyCode}"]`).addClass('selected');

    $currentCurrencyElement.html(sessionCurrencyCode);
    $currentCurrencyFlag.attr('class', selectedFlag);

    BSS_B2B.MC.convertCurrency = function (lastCurrency, currentCurrency, amountHtml) {
        let mountAfterConvert = BSS_B2B.MC.getBaseCurrency(lastCurrency, amountHtml);
        if (lastCurrency !== currentCurrency) {
            mountAfterConvert = Currency.convert(mountAfterConvert, lastCurrency, currentCurrency);
        }
        return parseFloat(mountAfterConvert).toFixed(2)
    };

    BSS_B2B.MC.convertCurrencyFromCP = function (lastCurrency, currentCurrency, amount) {
        let mountAfterConvert = amount;
        if (lastCurrency !== currentCurrency) {
            mountAfterConvert = Currency.convert(mountAfterConvert, lastCurrency, currentCurrency);
        }
        return parseFloat(mountAfterConvert).toFixed(2);
    };

    BSS_B2B.MC.getBaseCurrency = function (lastCurrency, amountHtml) {
        let amount = amountHtml.replace(/[^0-9.,-]+/g, "");
        if (BSS_B2B.storeId === 11664) {
            while(amount.charAt(0) === '.')
            {
                amount = amount.substring(1);
            }
        }
        let lastFormatString = currencyFormat[lastCurrency].money_with_currency_format;
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        function defaultOption(opt, def) {
            return (typeof opt === 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (thousands === '.' && number.includes('.')) {
                number = number.replace(/\./g, '')
            }
            if (thousands === ',' && number.includes(',')) {
                number = number.replace(/,/g, '')
            }
            if (decimal === ',') {
                number = number.replace(',', '.')
            }
            return number;
        }

        let value = '';
        switch (lastFormatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(amount, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(amount, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(amount, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(amount, 0, '.', ',');
                break;
        }
        let mountAfterConvert = parseFloat(value).toFixed(2);

        return mountAfterConvert;
    };

    BSS_B2B.MC.convertPriceByMc = function (amount, priceElement) {
        let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
        let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
        let selectedCurrencyCode = sessionCurrencyCode;

        let $currentCurrencyElement = $('.bss-nice-select span.current-currency');
        let $currentCurrencyFlag = $('.bss-nice-select span.current .flags');
        $('.option.notranslate.selected').removeClass('selected');
        let selectedFlag = $(`.option.notranslate[data-value="${selectedCurrencyCode}"]`).find('.flags').attr('class');
        $(`.option.notranslate[data-value="${selectedCurrencyCode}"]`).addClass('selected');

        $currentCurrencyElement.html(selectedCurrencyCode);
        $currentCurrencyFlag.attr('class', selectedFlag);

        amount = Number(amount).toFixed();
        if (priceElement) {
            priceElement.attr('bss-shop-base-currency', amount)
        }


        let moneyFormat = currencyFormat[selectedCurrencyCode].money_with_currency_format;

        let currencyFormatString = sessionCurrencyFormat;

        let pattern = /(\{\{.*\}\})/g;
        let validFormatString = currencyFormatString.match(pattern);
        let formatString = currencyFormatString;
        if (validFormatString !== null && validFormatString.length) {
            formatString = validFormatString[0];
        }
        let priceHtml = amount / 100;
        priceHtml = priceHtml.toString();
        let priceAfterChange = BSS_B2B.MC.convertCurrencyFromCP(shopCurrencyCode, selectedCurrencyCode, priceHtml);

        let priceAfterFormat = BSS_B2B.formatMoney(priceAfterChange, formatString);

        let isEnableRoundPrice = currencyConfig.round_price;
        if (isEnableRoundPrice) {
            //do round price
            let roundStyle = currencyConfig.round_style;
            priceAfterChange = Math.round(parseFloat(priceAfterChange)) * 100;
            priceAfterFormat = BSS_B2B.formatMoney(priceAfterChange, formatString);
            //check if remove decial then remove last 3 charactor (.00)
            if (roundStyle === 'remove_decimal') {
                let decimalString = priceAfterFormat.substr(priceAfterFormat.length - 3);
                if (decimalString === '.00' || decimalString === ',00') {
                    priceAfterFormat = priceAfterFormat.slice(0, -3);
                }
            }
        }

        let newPrice = moneyFormat.replace(formatString, priceAfterFormat);
        return newPrice;
    };


    BSS_B2B.MC.preConvertCurrency = function (currentCurrencyCode, currencyFormatString, customPriceEl = false, firstLoad = false) {
        let $currentCurrencyElement = $('.bss-nice-select span.current-currency');
        let $currentCurrencyFlag = $('.bss-nice-select span.current .flags');
        $('.option.notranslate.selected').removeClass('selected');
        let selectedFlag = $(`.option.notranslate[data-value="${currentCurrencyCode}"]`).find('.flags').attr('class');
        $(`.option.notranslate[data-value="${currentCurrencyCode}"]`).addClass('selected');

        $currentCurrencyElement.html(currentCurrencyCode);
        $currentCurrencyFlag.attr('class', selectedFlag);

        let selectedCurrencyCode = currentCurrencyCode;
        let moneyFormat = currencyFormat[currentCurrencyCode].money_with_currency_format;

        let pattern = /(\{\{.*\}\})/g;
        let validFormatString = currencyFormatString.match(pattern);
        let formatString = currencyFormatString;
        if (validFormatString !== null && validFormatString.length) {
            formatString = validFormatString[0];
        }
        if ([9209,11664].indexOf(BSS_B2B.storeId) != -1) {
            formatString = moneyFormat.substring(moneyFormat.indexOf("{"), moneyFormat.indexOf("}}") + 2);
            window.localStorage.setItem("currentCurrency", selectedCurrencyCode);
            window.localStorage.setItem("currentCurrencyFormat", formatString);
        }

        let allPriceElements = $(
            '[bss-b2b-product-price],' +
            '[bss-b2b-product-id],' +
            '[bss-b2b-current-variant-price],' +
            '[bss-b2b-product-compare-price],' +
            '[bss-b2b-product-parent-price], ' +
            '[bss-b2b-item-original-price], ' +
            '[bss-b2b-original-line-price], ' +
            '[data-cart-subtotal], ' +
            '[bss-b2b-cart-total-price], ' +
            '.bss-qb-price-item, ' +
            '.bss-qb-total-price-item, ' +
            '[bss-b2b-product-lowest-price],' +
            '[bss-b2b-product-from-price],' +
            '[bss-b2b-product-now-price],' +
            '[bss-b2b-product-min-price],' +
            '[bss-b2b-variant-unit-price],' +
            '[data-regular-price],' +
            '[data-sale-price],' +
            '[data-product-price],' +
            //fix for cart price element
            '[data-cart-item-discount-amount],' +
            '[data-cart-item-final-price],' +
            '[data-cart-item-original-price],' +
            '[bss-b2b-cart-discount-total], ' +
            //fix theme minimal
            '.product-single__sale-price,' +
            '[data-unit-price],' +
            //fix theme supply
            '#comparePrice-product-template,' +
            '.product-single__price--compare,' +
            // fix for supply theme on vnđ
            '.inline-list.product-meta [bss-b2b-product-price][data-sale-price] span[aria-hidden],' +
            //fix theme Narrative
            '[data-compare-price],' +
            //fix theme Boundless
            '.js-price,' +
            '[bss-b2b-item-final-price],' +
            '[bss-b2b-final-line-price],' +
            '[bss-b2b-cart-discount-amount],' +
            '.bss-b2b-qo-line-price,' +
            '[data-cart-item-regular-price],' +
            '.productitem--info .home_price,' +
            // fix for 3090stock
            '.transcy-money.notranslate,' +
            //fix for wisualarm
            '.etrans-money, .productimg-video-wrapper .price, .productimg-video-wrapper .compare_price,' +
            //fix for acryshield
            '[bss-b2b-product-id][bss-b2b-product-price] del.bss-b2b-customized-original-price,' +  '[bss-b2b-product-id][bss-b2b-product-price] span,' + '.product-pricing .bss-b2b-customized-compare-at-price'
            );

        if (customPriceEl.length) {
            allPriceElements = customPriceEl;
        }

        $.each(allPriceElements, function (index, priceElement) {
            priceElement = $(priceElement);
            // fix sale price for Brooklyn theme
            let isSalePrice = false;
            let isNowPrice = false;
            let preFixDiscount = false;

            if (priceElement.children().length > 0 || $(priceElement).is('meta')) {
                //fix for theme supply
                if (priceElement.closest('ul.inline-list').length && priceElement.children().length > 1) {
                    if (BSS_B2B.page.isProductPage()) {
                        if (!$(priceElement.children()[0]).children().is('sup')) {
                            return true;
                        }
                    }
                } else if (priceElement.children().is('br')) {
                    if (priceElement.html().includes('Save<br>')) {
                        isSalePrice = true;
                    }
                } else if (priceElement.children().is('.txt--emphasis')) {
                    //fix theme Boundless
                    if (priceElement.html().includes('now')) {
                        isNowPrice = true;
                    }
                } else if (priceElement.is('.order-discount--cart') && priceElement.children().is('strong')) {
                    preFixDiscount = true;
                } else if (priceElement.is('[bss-b2b-ajax-cart-subtotal]') && priceElement.children().is('[bss-b2b-ajax-cart-subtotal]')) {
                    // fix theme Venture
                    let tempHtml = priceElement.html();
                    if (tempHtml.includes('{') && tempHtml.includes('}')) {
                        priceElement.html(tempHtml.replace(/{|}/g, ''));
                    }
                    return;
                } else if (!priceElement.children().is('sup')) {
                    return true;
                }
            }
            let priceHtml = priceElement.html();
            // fix for storeId 4927
            window.BSS_B2B.executeAction({tag: 'get_mc_price_html', storeId: false, priceElement})

            //fix for theme supply
            if (priceHtml.includes('<sup')) {
                priceHtml = priceHtml.substring(0, priceHtml.indexOf('<sup')).replace('-', "");
            }
            //fix theme Boundless
            if (priceHtml.includes('-')) {
                priceHtml = priceHtml.replace(/-/g, "");
            }

            function htmlDecode(value) {
                return (typeof value === 'undefined') ? '' : $('<div/>').html(value).text();
            }

            function isSameCurrency(moneyString) {
                let currencyFormatFromHtml = moneyString.replace(/\s*([0-9|.|,]*)[^\S\r\n]/g, "").replace(/\s/g, '');
                let currencyFormatFromFormatString = htmlDecode(moneyFormat.replace(formatString, "")).replace(/\s/g, '');
                
                return currencyFormatFromHtml === currencyFormatFromFormatString;
            }

            // check if is base currency then continua, if has change currency, break
            if (!firstLoad && isSameCurrency(priceHtml)) {
                // fix for debut theme for subtotal price
                if (!(($(priceElement).is('.cart-subtotal__price[data-cart-subtotal]') || $(priceElement).is('span[bss-b2b-product-price]')) &&
                    $(priceElement).closest('.cart__footer').find('.cart-subtotal .cart-subtotal__price[data-cart-subtotal]').length)) {
                    return;
                }
            }

            let amount = BSS_B2B.MC.getBaseCurrency(shopCurrencyCode, priceHtml);
            amount = parseFloat(amount) * 100;

            priceElement.attr('bss-shop-base-currency', amount);

            let priceAfterChange = BSS_B2B.MC.convertCurrency(shopCurrencyCode, selectedCurrencyCode, priceHtml);

            let priceAfterFormat = BSS_B2B.formatMoney(priceAfterChange, formatString);

            let isEnableRoundPrice = currencyConfig.round_price;
            if (isEnableRoundPrice) {
                //do round price
                let roundStyle = currencyConfig.round_style;
                priceAfterChange = Math.round(parseFloat(priceAfterChange)) * 100;
                priceAfterFormat = BSS_B2B.formatMoney(priceAfterChange, formatString);
                //check if remove decial then remove last 3 charactor (.00)
                if (roundStyle === 'remove_decimal') {
                    let decimalString = priceAfterFormat.substr(priceAfterFormat.length - 3);
                    if (decimalString === '.00' || decimalString === ',00') {
                        priceAfterFormat = priceAfterFormat.slice(0, -3);
                    }
                }
            }

            let newPrice = moneyFormat.replace(formatString, priceAfterFormat);
            let lowestPriceAttr = priceElement.attr('bss-b2b-product-lowest-price');
            let fromPriceAttr = priceElement.attr('bss-b2b-product-from-price');
            if ([9209].includes(BSS_B2B.storeId)) {
                newPrice = newPrice.replace('kr ', '');
            }
            if ([5986].includes(BSS_B2B.storeId)) {
                newPrice = newPrice.replace('ALL', '');
                newPrice = newPrice.replace('EUR', '');
            }
            if (typeof lowestPriceAttr !== 'undefined' && lowestPriceAttr !== false) {
                newPrice = 'from ' + newPrice;
            } else if (typeof fromPriceAttr !== 'undefined' && fromPriceAttr !== false) {
                newPrice = 'from ' + newPrice;
            }
            if (isSalePrice) {
                newPrice = `Save<br>${newPrice}`;
            }
            if (isNowPrice) {
                newPrice = `now ${newPrice}`;
            }
            if (preFixDiscount) {
                newPrice = `- ${newPrice}`;
            }

            if (cartCurrentCurrencyCode === sessionCurrencyCode && shopMultiCurrencyCode.includes(sessionCurrencyCode) && BSS_B2B.page.isCartPage() && ![3879, 11332].includes(BSS_B2B.storeId)) {
                // eslint-disable-next-line no-console
                console.log('Multi-currency on Cart Page');
            } else {
                if([5986].includes(BSS_B2B.storeId)) {
                    if(!priceElement.attr('bss-active-custom-mc')) {
                        priceElement.html(newPrice)
                        priceElement.attr('bss-active-custom-mc', "true")
                    }
                } else {
                    priceElement.html(newPrice)
                }
            }
        });
        //show price
        if(BSS_B2B.storeId === 3879 && BSS_B2B.page.isProductPage()){
            let showPriceTax =  document.querySelector('.bss-b2b-product-vat')
            if (showPriceTax) {
                showPriceTax.style.display ='block';
            }
        }
        $('[bss-b2b-product-id]').css('visibility', 'visible');
        $('[bss-b2b-product-id],[bss-b2b-product-parent-price]').show();
        //    show price cart
        $('[bss-b2b-final-line-price],[bss-b2b-item-final-price]').css('visibility', 'visible');
        //Fix for dnd
        //Ajax cart and total price cart
        $('.mini-cart__recap-price-line span[bss-b2b-cart-total-price],[bss-b2b-cart-total-price]').css('visibility', 'visible');
        $('[data-cart-subtotal],#cart-total,#total-cart-bottom,[bss-b2b-ajax-cart-subtotal]').fadeIn(700);
        $('[data-cart-subtotal],#cart-total,#total-cart-bottom,[bss-b2b-ajax-cart-subtotal],[bss-b2b-final-line-price]').css('visibility', 'visible');
        $('[bss-b2b-cart-item-key][bss-b2b-original-line-price]').css('visibility', 'visible');
        $('[data-cart-item-regular-price]').css('visibility', 'visible');
        if (customPriceEl) {
            customPriceEl.css('visibility', 'visible');
            customPriceEl.show();
        }
        allPriceElements.css('visibility', 'visible');
        allPriceElements.show();
    };


    BSS_B2B.MC.initCurrencySwitcher = function () {
        const deviceWidth = $(window).width();
        let positionClass = '';
        const showOnMobile = currencyConfig.show_on_mobile;
        const showOnDesktop = currencyConfig.show_on_desktop;

        const desktopPosition = currencyConfig.desktop_position;
        const mobilePosition = currencyConfig.mobile_position;

        if (deviceWidth > 600 && showOnDesktop) {
            positionClass = desktopPosition;
        } else if (deviceWidth < 600 && showOnMobile) {
            positionClass = mobilePosition;
        } else {
            return;
        }
        $('.bss-currency-wrapper').addClass(positionClass);

        //handle hover action
        $('.currency-switcher .option').on('mouseover', function () {
            $(this).css('background-color', currencyConfig.currency_bar_hover_color);
        });
        $('.currency-switcher .option').on('mouseout', function () {
            $(this).css('background-color', currencyConfig.currency_bar_bg);
        });

        // cart message

        let path = window.location.pathname.split('/');
        let isCartPage = path[1] === 'cart';
        let showMessageOnCartPage = currencyConfig.show_cart_message;
        let cartMessage = currencyConfig.cart_message;
        cartMessage = cartMessage.replace('[checkout_currency]', shopCurrencyCode);
        let cartMessTextColor = currencyConfig.cart_message_color;
        let cartMessTextBgColor = currencyConfig.cart_message_bg;


        if (showMessageOnCartPage && isCartPage) {
            const cartMessageHtml = `<div class="bss-currency-cart-message" style="text-align: center; padding: 1rem; color:${cartMessTextColor}; background-color: ${cartMessTextBgColor};">
                                    ${cartMessage}
                                    </div>`;
            $('#shopify-section-header').after(cartMessageHtml);
        }

        //apply auto convert currency base on IP
        // only check first time
        const euCountryCodes = [
            "AT", "BE", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU",
            "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"
     ];
        if (currencyConfig && currencyConfig.auto_location) {
            if (isFirstTime) {
                let countryCode = BSS_B2B.countryCode;
                if (countryCode !== '' && countryCode !== undefined) {
                    currencyList.map((item) => {
                        if (item.code.includes(countryCode)) {
                            sessionCurrencyCode = item.code;
                          
                            let moneyFormat = currencyFormat[sessionCurrencyCode].money_with_currency_format;
                            let formatString = moneyFormat.substring(moneyFormat.indexOf("{"), moneyFormat.indexOf("}}") + 2);
                            sessionCurrencyFormat = formatString;

                            //set current currency data to session
                            window.localStorage.setItem("currentCurrency", sessionCurrencyCode);
                            window.localStorage.setItem("currentCurrencyFormat", sessionCurrencyFormat)
                          
                        }
                        if(euCountryCodes.includes(countryCode)){
                            window.BSS_B2B.executeAction({tag: 'default_currency_by_location', storeId: 11332, currencyFormat, sessionCurrencyCode, sessionCurrencyFormat})
                       }
                    });
                }
            }
        }

        if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) || (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
            sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
            BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, false, true);
        }

        if (BSS_B2B.page.isQuickOrderPage) {
            sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
            sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
            let intervalChangeCurrency = setInterval(function (){
                let qoLinePriceEl = $('.bss-b2b-qo-line-price');
                let existCurrencyConverter = $('[bss-shop-base-currency]');
                if (existCurrencyConverter.length && !existCurrencyConverter.closest('#shopify-section-header').length && !existCurrencyConverter.closest('#cart-dropdown').length) {
                    clearInterval(intervalChangeCurrency);
                    handleChangeQtyQO();
                    handleQOSearchProduct();
                    return;
                }

                if (qoLinePriceEl.length){
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, false, true);
                    handleChangeQtyQO();
                    handleQOSearchProduct();
                    if (!$(qoLinePriceEl).not('[bss-shop-base-currency]').length) {
                        clearInterval(intervalChangeCurrency);
                        return;
                    }
                }
            }, 500);

            setTimeout(function (){
                if (intervalChangeCurrency) {
                    clearInterval(intervalChangeCurrency);
                }
            }, 10000);

        }

        const handleChangeQtyQO = function (){
            const buttonChangeQtyQO = $('.bss-b2b-qo-price-quantity .Polaris-TextField__Segment[role=button]');
            const inputChangeQtyQO = $('.bss-b2b-qo-price-quantity .Polaris-TextField__Input[type=number]');
            buttonChangeQtyQO.on('click', function (){
                let customPriceEl = $(this).closest('.bss-customer-portal-variant').find('.bss-b2b-qo-line-price');
                sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                let priceEl = false;
                if (customPriceEl) {
                    priceEl = customPriceEl;
                    customPriceEl.hide();
                }
                setTimeout(function (){
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, priceEl, false);
                }, 200)
            });

            inputChangeQtyQO.on('change', function (){
                let customPriceEl = $(this).closest('.bss-customer-portal-variant').find('.bss-b2b-qo-line-price');
                sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                let priceEl = false;
                if (customPriceEl) {
                    priceEl = customPriceEl;
                    customPriceEl.hide();
                }
                setTimeout(function (){
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, priceEl, false);
                }, 200)
            })
        };


        const changeCurrencyOnSearchEvent = function (){
            sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
            sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
            let intervalChangeCurrency = setInterval(function (){
                let qoLinePriceEl = $('.bss-b2b-qo-line-price');
                let isLoading = $('.bss-b2b-qo-line-price .Polaris-Spinner');
                let existCurrencyConverter = $('[bss-shop-base-currency]');
                if (existCurrencyConverter.length && !isLoading.length) {
                    clearInterval(intervalChangeCurrency);
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, false, false);
                    handleQOSearchProduct();
                    return;
                }

                if (qoLinePriceEl.length && !isLoading.length){
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, false, true);
                    clearInterval(intervalChangeCurrency);
                    handleQOSearchProduct();
                    return;
                }
            }, 500);

            setTimeout(function (){
                if (intervalChangeCurrency) {
                    clearInterval(intervalChangeCurrency);
                }
            }, 5000);
        };

        const handleQOSearchProduct = function (){
            const buttonQOSearchProduct = $('.bss-b2b-customer-portal-main .Polaris-Connected .Polaris-Button');
            const selectQOProductDropdown = $('.bss-b2b-customer-portal-main .Polaris-Select .Polaris-Select__Input');
            const textSearchInput = $('.bss-b2b-customer-portal-main .Polaris-TextField__Prefix + .Polaris-TextField__Input');
            const paginationButton = $('.bss-b2b-customer-portal-main .Polaris-Pagination button');
            paginationButton.off();
            textSearchInput.off();
            buttonQOSearchProduct.off();
            selectQOProductDropdown.off();

            selectQOProductDropdown.on('change', function (){
                changeCurrencyOnSearchEvent();
            });
            buttonQOSearchProduct.on('click', function (){
                changeCurrencyOnSearchEvent();
            });
            textSearchInput.on('keyup', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    changeCurrencyOnSearchEvent();
                }
            });
            paginationButton.on('click', function (){
                changeCurrencyOnSearchEvent();
            });
        };

        // fix for nudniklife by mitri
        // remove Tri's code fix by madu
        $('.bss-currency-wrapper').fadeIn(100);

        $('#switcher').on("click", function () {
            $("#switcher").toggleClass("open");
        });

        $('.bss-nice-select li.option').on("click", async function (e) {
            let $currentCurrencyElement = $('.bss-nice-select span.current-currency');
            let $currentCurrencyFlag = $('.bss-nice-select span.current .flags');

            $('.option.notranslate.selected').removeClass('selected');
            const selectedElement = $(e.target).attr('data-value') ? e.target : e.target.parentElement;
            $(selectedElement).addClass('selected');

            const selectedFlag = $(selectedElement).find('.flags').attr('class');
            $currentCurrencyElement.html($(selectedElement).attr('data-value'));
            $currentCurrencyFlag.attr('class', selectedFlag);

            let selectedCurrencyCode = $(selectedElement).attr('data-value');

            if([4824].includes(BSS_B2B.storeId)){
                cartCurrentCurrencyCode = selectedCurrencyCode;
                shopCurrencyCode = selectedCurrencyCode;
            }

            let dataUpdate = [4824].includes(BSS_B2B.storeId) 
            ? {
                currency: cartCurrentCurrencyCode
            }
            :{
                currency: shopCurrencyCode
            }; 

            if (shopMultiCurrencyCode.includes(selectedCurrencyCode)
                && (!isEnableCP || !BSS_B2B.configData || (BSS_B2B.configData.length === 0))
                && (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0))
            ) {
                dataUpdate = {
                    currency: selectedCurrencyCode
                }
            }

            let moneyFormat = currencyFormat[selectedCurrencyCode].money_with_currency_format;
            let formatString = moneyFormat.substring(moneyFormat.indexOf("{"), moneyFormat.indexOf("}}") + 2);

            //set current currency data to session
            window.localStorage.setItem("currentCurrency", selectedCurrencyCode);
            window.localStorage.setItem("currentCurrencyFormat", formatString);
            if (BSS_B2B.storeId === 3663) {
                window.localStorage.setItem("ls-currency", selectedCurrencyCode.toLowerCase());
            }
            let updateCartReq = await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataUpdate)
            });
            let updateCartRes = updateCartReq.json();
            if (updateCartRes) {
                window.location.reload();
            }
            let allPriceElements = $(
                '[bss-b2b-product-price],' +
                '[bss-b2b-product-id],' +
                '[bss-b2b-current-variant-price],' +
                '[bss-b2b-product-compare-price],' +
                '[bss-b2b-product-parent-price], ' +
                '[bss-b2b-item-original-price], ' +
                '[bss-b2b-original-line-price], ' +
                '.bss-qb-price-item, ' +
                '[data-cart-subtotal], ' +
                '[bss-b2b-cart-total-price], ' +
                '[bss-shop-base-currency], ' +
                '[bss-b2b-cart-discount-total], ' +
                '.bss-qb-total-price-item, ' +
                '.bss-b2b-variant-unit-price, ' +
                //fix theme minimal
                '.product-single__sale-price,' +
                //fix theme Narrative
                '[data-compare-price],' +
                //fix theme supply
                '#comparePrice-product-template,' +
                '.product-single__price--compare,' +
                // fix for supply theme on vnđ
                '.inline-list.product-meta [bss-b2b-product-price][data-sale-price] span[aria-hidden],' +
                //fix theme Boundless
                '.js-price,' +
                '[data-cart-item-regular-price]');
            $.each(allPriceElements, function (index, priceElement) {
                priceElement = $(priceElement);
                // fix sale price for Brooklyn theme
                let isSalePrice = false;
                let isNowPrice = false;
                if (priceElement.children().length > 0 || $(priceElement).is('meta')) {
                    //fix for theme supply
                    if (priceElement.closest('ul.inline-list').length && priceElement.children().length > 1) {
                        if (BSS_B2B.page.isProductPage()) {
                            if (!$(priceElement.children()[0]).children().is('sup')) {
                                return true;
                            }
                        }
                    } else if (priceElement.children().is('br')) {
                        if (priceElement.html().includes('Save<br>')) {
                            isSalePrice = true;
                        }
                    } else if (priceElement.children().is('.txt--emphasis')) {
                        //fix theme Boundless
                        if (priceElement.html().includes('now')) {
                            isNowPrice = true;
                        }
                    } else if (!priceElement.children().is('sup')) {
                        return true;
                    }
                }
                let priceHtml = priceElement.html();

                //fix for theme supply
                if (priceHtml.includes('<sup')) {
                    priceHtml = priceHtml.substring(0, priceHtml.indexOf('<sup')).replace('-', "");
                }
                if (priceHtml.includes('now')) {
                    isNowPrice = true;
                }
                //fix theme Boundless
                if (priceHtml.includes('-')) {
                    priceHtml = priceHtml.replace(/-/g, "");
                }
                const shopBaseCurrencyValue = priceElement.attr('bss-shop-base-currency');

                let afterChange = Currency.convert(shopBaseCurrencyValue, shopCurrencyCode, selectedCurrencyCode);
                afterChange = parseFloat(afterChange) / 100;
                afterChange = afterChange.toFixed(2);

                let priceAfterFormat = BSS_B2B.formatMoney(afterChange, formatString);

                let isEnableRoundPrice = currencyConfig.round_price;
                if (isEnableRoundPrice) {
                    //do round price
                    let roundStyle = currencyConfig.round_style;
                    afterChange = Math.round(parseFloat(afterChange)) * 100;
                    priceAfterFormat = BSS_B2B.formatMoney(afterChange, formatString);
                    //check if remove decial then remove last 3 charactor (.00)
                    if (roundStyle === 'remove_decimal') {
                        let decimalString = priceAfterFormat.substr(priceAfterFormat.length - 3);
                        if (decimalString === '.00' || decimalString === ',00') {
                            priceAfterFormat = priceAfterFormat.slice(0, -3);
                        }
                    }
                }

                let newPrice = moneyFormat.replace(formatString, priceAfterFormat);
                let lowestPriceAttr = priceElement.attr('bss-b2b-product-lowest-price');
                let fromPriceAttr = priceElement.attr('bss-b2b-product-from-price');
                if (typeof lowestPriceAttr !== 'undefined' && lowestPriceAttr !== false) {
                    newPrice = 'from ' + newPrice;
                } else if (typeof fromPriceAttr !== 'undefined' && fromPriceAttr !== false) {
                    newPrice = 'from ' + newPrice;
                }
                if (isSalePrice) {
                    newPrice = `Save<br>${newPrice}`;
                }
                if (isNowPrice) {
                    newPrice = `now ${newPrice}`;
                }
                priceElement.html(newPrice)
            })

        });

        if (BSS_B2B.storeId === 3663) {
            let currentCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
            if (currentCurrencyFormat && currentCurrencyFormat.includes("<span bss-b2b-product-price")) {
                $('.bss-nice-select li.option[data-value="SEK"]').click()
            }
        }
    };

    BSS_B2B.MC.changeVariantOptionProductPage = function () {
        let cartForm = $('form[action*="/cart/add"]');
        $(cartForm).find('select, ' +
            'input.single-option-selector__radio,'
            + 'input.product-form__single-selector'
            + BSS_B2B.getCssSelector('product_variant_option_input')
        ).on("change", function () {
            let delayTime = 200;
            $('.product-price-unit').hide();
            setTimeout(function () {
                let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat);
                $('[data-regular-price]').css('visibility', 'visible');
                $('[data-regular-price]').show();
                $('.product-price-unit').show();
            }, delayTime)
        })
        // fix for storeID 7056
        window.BSS_B2B.executeAction({tag: 'change_variant', storeId: 7056, cartForm})
    };

    BSS_B2B.MC.initCurrencySwitcher();

    BSS_B2B.MC.hideCartPriceElements = function () {
        $(BSS_B2B.cart.inputQuantityElement).prop('disabled', true);
        $('[data-cart-item-regular-price],'
            + '[bss-b2b-item-price],'
            + '[data-cart-subtotal],'
            + '[bss-b2b-ajax-cart-subtotal],'
            + '[data-cart-item-id]  [data-cart-item-price-container] .cart-item__original-price,'
            + '[data-cart-item-id]  [data-cart-item-line-price-container] .cart-item__original-price,'
            + '.cartTotalSelector,'
            + '.cart_subtotal'
            + BSS_B2B.getCartPriceClass('cart_total')
            + BSS_B2B.getCartPriceClass('cart_subtotal')
            + BSS_B2B.getCartPriceClass('cart_item_regular_price')
            + BSS_B2B.getCartPriceClass('cart_item_original_price')
        ).hide();
        let cartPriceElement = $(
            '[data-cart-subtotal],' +
            '[bss-b2b-product-price],' +
            '[bss-b2b-product-id],' +
            '[bss-b2b-item-final-price],' +
            '[bss-b2b-final-line-price],' +
            '[bss-b2b-cart-discount-amount],' +
            '[data-cart-item-discount-amount],' +
            '[data-cart-item-final-price],' +
            '[data-cart-item-original-price],' +
            '[data-cart-price],' +
            '[data-unit-price],' +
            '[bss-b2b-cart-item-key],' +
            '[bss-b2b-cart-discount-total],' +
            '[data-cart-discount-amount],' +
            '.cart-item__price,' +
            '.cart-subtotal--price,' +
            '.order-discount--cart,' +
            '[data-cart-item-regular-price]');
        cartPriceElement.hide();
    };
    BSS_B2B.MC.showCartPriceElements = function () {
        $(BSS_B2B.cart.inputQuantityElement).prop('disabled', false);
        $('[data-cart-item-regular-price],'
            + '[bss-b2b-item-price],'
            + '[data-cart-subtotal],'
            + '[bss-b2b-ajax-cart-subtotal],'
            + '[data-cart-item-id]  [data-cart-item-price-container] .cart-item__original-price,'
            + '[data-cart-item-id]  [data-cart-item-line-price-container] .cart-item__original-price,'
            + '.cartTotalSelector,'
            + '.cart_subtotal'
            + BSS_B2B.getCartPriceClass('cart_total')
            + BSS_B2B.getCartPriceClass('cart_subtotal')
            + BSS_B2B.getCartPriceClass('cart_item_regular_price')
            + BSS_B2B.getCartPriceClass('cart_item_original_price')
        ).show();
        let cartPriceElement = $(
            '[data-cart-subtotal],' +
            '[bss-b2b-product-price],' +
            '[bss-b2b-product-id],' +
            '[bss-b2b-item-final-price],' +
            '[bss-b2b-final-line-price],' +
            '[bss-b2b-cart-discount-amount],' +
            '[data-cart-item-discount-amount],' +
            '[data-cart-item-final-price],' +
            '[data-cart-item-original-price],' +
            '[data-cart-price],' +
            '[data-unit-price],' +
            '[bss-b2b-cart-item-key],' +
            '[bss-b2b-cart-discount-total],' +
            '[data-cart-discount-amount],' +
            '.cart-item__price,' +
            '.cart-subtotal--price,' +
            '.order-discount--cart,' +
            '[data-cart-item-regular-price]');
        cartPriceElement.show();
    };


    BSS_B2B.MC.handleCartPrice = function () {
        let isExistedUpdateCartBtn = BSS_B2B.cart.isExistedUpdateCartBtn;
        if (!isExistedUpdateCartBtn) {
            $(BSS_B2B.cart.inputQuantityElement).off();
            $(BSS_B2B.cart.inputQuantityElement).on("change keyup", function () {
                let hideCartPriceInterval = setInterval(function () {
                    BSS_B2B.MC.hideCartPriceElements();
                }, 1);
                let delayTime = 1500;
                setTimeout(function () {
                    let customPriceElement = $(
                        '[data-cart-subtotal],' +
                        '[bss-b2b-product-price],' +
                        '[bss-b2b-product-id],' +
                        '[bss-b2b-item-final-price],' +
                        '[bss-b2b-final-line-price],' +
                        '[bss-b2b-cart-discount-amount],' +
                        '[data-cart-item-discount-amount],' +
                        '[data-cart-item-final-price],' +
                        '[data-cart-item-original-price],' +
                        '[data-cart-price],' +
                        '[data-unit-price],' +
                        '[bss-b2b-cart-item-key],' +
                        '[bss-b2b-cart-discount-total],' +
                        '[data-cart-discount-amount],' +
                        '.cart-item__price,' +
                        '.cart-subtotal--price,' +
                        '.order-discount--cart,' +
                        '[data-cart-item-regular-price]');
                    customPriceElement.hide();
                    customPriceElement.css('visibility', 'hidden');
                    let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                    let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, customPriceElement);
                    clearInterval(hideCartPriceInterval);
                    BSS_B2B.MC.reRenderQtyChangeEvent();
                }, delayTime)
            });
        }

        let changeQtyCartBtn = $(
            '.ajaxifyCart--qty-adjuster,' +
            '.ajaxcart__qty-adjust,' +
            '.js-qty__adjust,' +
            'quantity-input.quantity-input button'
        );
        changeQtyCartBtn.on("click", function () {
            let delayTime = 3000;
            let hideCartPriceInterval = setInterval(function () {
                BSS_B2B.MC.hideCartPriceElements();
            }, 1);
            setTimeout(function () {
                let customPriceElement = $(
                    '[data-cart-subtotal],' +
                    '[bss-b2b-product-id],' +
                    '[bss-b2b-product-price],' +
                    '[bss-b2b-item-final-price],' +
                    '[bss-b2b-final-line-price],' +
                    '[bss-b2b-cart-discount-amount],' +
                    '[data-cart-item-discount-amount],' +
                    '[data-cart-item-final-price],' +
                    '[data-cart-item-original-price],' +
                    '[data-cart-price],' +
                    '[bss-b2b-cart-item-key],' +
                    '[bss-b2b-ajax-cart-subtotal],' +
                    '[bss-b2b-cart-discount-total],' +
                    '[data-cart-discount-amount],' +
                    '.cart-item__price,' +
                    '.cart-subtotal--price,' +
                    '.order-discount--cart,' +
                    '[bss-b2b-product-sale-price]:not([bss-shop-base-currency]),' +
                    '[data-cart-item-regular-price]');
                customPriceElement.hide();
                customPriceElement.css('visibility', 'hidden');
                let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, customPriceElement);
                clearInterval(hideCartPriceInterval);
                BSS_B2B.MC.reRenderQtyChangeEvent();
            }, delayTime);
        })
    };

    BSS_B2B.MC.reRenderQtyChangeEvent = function () {
        BSS_B2B.MC.handleCartPrice();
        BSS_B2B.MC.showCartPriceElements();
    };

    BSS_B2B.MC.handleAjaxCart = function () {
        let ajaxCartDelayTime = 3000;
        let customAjaxCartDelayTime = BSS_B2B.getCssSelector('ajax_cart_time_delay_opening_cart');
        if (customAjaxCartDelayTime !== '' && !isNaN(customAjaxCartDelayTime)) {
            ajaxCartDelayTime = parseInt(customAjaxCartDelayTime)
        }

        let ajaxCartElement = $('[id^="AddToCart"]:not(form), ' +
            '[id^="addToCart"]:not(form):not(span),' +
            'button[aria-controls="CartDrawer"],' +
            'a[aria-controls="CartDrawer"], ' +
            'button[name="add"].product-form__add-to-cart,' +
            'button[name="add"].product__add-to-cart-button,' +
            'button[name="add"].add-to-cart,' +
            'a.ajax-cart__toggle,' +
            'span.icon__fallback-text,'
            + 'button#add-to-cart.add-to-cart,'
            + 'a.cart-toggle,'
            + '.mini-cart-wrap[data-cart-mini-toggle],'
            + '.addtocart-button-active[data-product-submit],'
            + 'button.product-form--atc-button,'
            + 'button.productitem--action-atc,'
            + '#add-to-cart-product-template,'
            + '.product-form__add-button[data-action="add-to-cart"],'
            + '.header__cart-toggle[data-action="toggle-mini-cart"],'
            + 'button[type="submit"][data-action="add-to-cart"],'
            + 'button.btn-addtocart,'
            + 'form[action*="/cart/add"] input.AddtoCart,'
            + 'a[data-cart-toggle][data-dropdown-menu],'
            + 'input[data-btn-addtocart],'
            + '.cart-block-click,'
            + 'button[data-btn-addtocart],'
            + 'a.js-cart-trigger[href="/cart"],'
            + 'form.js-product-form,'
            //fix for steve-labpro by ThaBi
            + 'form[action*="/cart/add"] button.single_add_to_cart_button.button,'
            + '.Header__Wrapper .Header__FlexItem a[data-drawer-id="sidebar-cart"],'
            + 'button.product-form__cart-submit,'
            + '.add-to-cart-box .add-to-cart,'
            + 'a.header-cart-btn.cart-toggle,'
            //fix biomatrixweb by vitu
            + '.product-page--submit-action .btn,'
            //fix monpetitherbier by vitu
            + '.ajax-submit.action_button.add_to_cart,'
            + '.site-header__cart.cart-modal,'
            + 'form[action*="/cart/add"] button.ajax-submit.button--add-to-cart,'
            + 'form[action*="/cart/add"] div.add-to-cart button.button[type="submit"],'
            // fix for shop.repairpartners by ThaBi
            + 'a.add-cart-btn,'
            + 'button.button.button-add-to-cart,'
            + '#mini-cart-toggle'
            + BSS_B2B.getCssSelector('ajax_cart_action_button'));

        if (ajaxCartElement.length) {
            ajaxCartElement.on("click", function () {
                let changeCurrencyInterval = setInterval(function () {
                    let customPriceElement = $(
                        '[data-cart-subtotal],' +
                        '[bss-b2b-product-id],' +
                        '[bss-b2b-product-price],' +
                        '[bss-b2b-item-final-price],' +
                        '[bss-b2b-final-line-price],' +
                        '[bss-b2b-cart-discount-amount],' +
                        '[data-cart-item-discount-amount],' +
                        '[data-cart-item-final-price],' +
                        '[data-cart-item-original-price],' +
                        '[data-cart-price],' +
                        '[bss-b2b-cart-item-key],' +
                        '.cart-item__price,' +
                        '.cart-subtotal--price,' +
                        '[bss-b2b-product-sale-price]:not([bss-shop-base-currency]),' +
                        '[data-cart-item-regular-price]');
                    customPriceElement.hide();
                    customPriceElement.css('visibility', 'hidden');
                    let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
                    let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
                    BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, customPriceElement);
                    // init cart price listener for ajax cart
                    if ($(BSS_B2B.cart.inputQuantityElement).length) {
                        BSS_B2B.MC.handleCartPrice();
                    }
                }, 300);
                setTimeout(function () {
                    clearInterval(changeCurrencyInterval);
                }, ajaxCartDelayTime);
            });
        }
    };

    BSS_B2B.MC.changeCurrencyCartPageQB = function () {
        // init convert currency function
        let priceElSelector = '.bss-qb-cart-subtotal,' +
            '[bss-b2b-product-price],' +
            '.bss-qb-price-item,' +
            '.bss-qb-total-price-item';

        if (!isEnableCP) {
            priceElSelector += ', [data-cart-item-regular-price]'
        }
        let lastCharacter = priceElSelector.substr(priceElSelector.length - 1);
        if (lastCharacter === ',') {
            priceElSelector = priceElSelector.substr(0, priceElSelector.length - 1);
        }

        let customPriceElement = $(priceElSelector);

        customPriceElement.hide();
        customPriceElement.css('visibility', 'hidden');
        let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
        let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
        BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat, customPriceElement)
    };


    function rePreConvertCurrency() {
        let sessionCurrencyCode = window.localStorage.getItem("currentCurrency");
        let sessionCurrencyFormat = window.localStorage.getItem("currentCurrencyFormat");
        BSS_B2B.MC.preConvertCurrency(sessionCurrencyCode, sessionCurrencyFormat)
    }


//     QUICK VIEW
    function handleQuickViewForCurrency() {
        let quickViewBtn = $(
            'a.full-width-link ,' +
            '.quick-product__btn[data-product-id],' +
            '.productitem--action-trigger[data-quickshop-full], .productitem--action-trigger[data-quickshop-slim],' +
            'a[data-fancybox].quick'
        );
        quickViewBtn.on("click", function () {
            setTimeout(function () {
                rePreConvertCurrency();
                // handle variant option for express theme
                BSS_B2B.MC.changeVariantOptionProductPage();
            }, 1500)
        })
    }

    handleQuickViewForCurrency();

    if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) || (!BSS_B2B.configData.length && !BSS_B2B.plConfigData.length)) {
        if (BSS_B2B.page.isProductPage()) {
            BSS_B2B.MC.changeVariantOptionProductPage();
        }
        //check for feature product on homepage Minimal theme
        let hrefArr = BSS_B2B.page.getPage();
        let isHomePage = hrefArr[hrefArr.length - 2] === window.location.host;
        let cartForm = $('form[action*="/cart/add"]');
        if (isHomePage && cartForm.length) {
            BSS_B2B.MC.changeVariantOptionProductPage();
        }

        BSS_B2B.MC.handleAjaxCart();
        BSS_B2B.MC.handleCartPrice();
    }


}

// CONCATENATED MODULE: ./js/src/cart/initCartHelper.js
function initCartHelper() {
    BSS_B2B.cart = {};
    BSS_B2B.cart.updatedLineItems = [];
    BSS_B2B.cart.updatedLineItemsAndUseAMO = [];
    BSS_B2B.cart.productMap = [];
    BSS_B2B.cart.variantStorage = new Map()
    BSS_B2B.cart.cpPricingList = new Map();
    BSS_B2B.cart.updatedLineItemsByBogo = [];
    BSS_B2B.cart.modifiedItemsSubtotalPrice = false;
    BSS_B2B.cart.miniCartContainer = '#CartDrawer,'
        + '.cart-drawer,'
        + 'cart-drawer,'
        + '#dropdown-cart,'
        + '#mini-cart,'
        + '.mini-cart,'
        + '.icon-cart,'
        + '.halo-modal-content,'
        + '#Cart-Drawer,'
        + '.mini-cart-wrap';
    BSS_B2B.cart.inputQuantityElement = 'form[action*="/cart"] input[type="number"], '
        + 'form[action*="/cart"] input[data-quantity-input],'
        + 'form[action*="/cart"] input[data-cart-item-input-quantity],'
        + 'form[action*="/cart"] input.js-qty__input,'
        + 'form[action*="/cart"] input.js-qty__num,'
        + 'form[action*="/cart"] input.quantity-selector__value,'
        + '.cart-wrapper input.quantity-selector__value,'
        + 'form[action*="/cart"] input.ajaxifyCart--num,'
        + 'form[action*="/cart"] input[aria-label="Quantity"],'
        + 'form[action*="/cart"] input[data-qv-qtt-id],'
        + 'form[action*="/cart"] input[name="quantity"],'
        + 'form[action*="/cart"] input[name="updates[]"],'
        //fix biomatrixweb by vitu
        + '.quantity-controls input[aria-label="Quantity"],'
        + 'table.line-item-table .line-item__quantity input,'
        + '.quantity input.input-text.qty,'
        // fix for kanucks-gear-inc by XuTho
        + 'form[action*="/cart"] input.ajax-cart__qty-input,'
        // fix for studiodai by DangNM
        + 'form[action="/cart"] .cart-item__quantity-input,'
        + 'form[action="/cart"] .product-quantity[data-title="Quantity"] .quantity input[type="number"],'
        // fix for scanasia-as by DangNM
        + '.qty-adjuster__inner .qty-adjuster__value,'
        // fix for xblades.com.au by hoaduong
        + '.QuantitySelector__CurrentQuantity,'
        // fix for bien-moves by CuongNVM
        + '.cart--quantity--container .cart--quantity--input,'
        // fix for kafea-coffee by KhanhND
        + '.js-qty__num,'
        // fix for thatsoitaly by mitri
        + '.cart__quantity-field,'
        + '.cart__items input[name="updates[]"],'
        // fix for ydvapestore by DangNM
        + 'form[action*="/cart"] .item-qty .quantity input.input-cart-qty[name="item-quantity"],'
        // fix for furniture by khanh
        + 'input[data-quantity-input].quantity__input,'
        + 'form[action*="/cart"] .js--num,'
        + 'form[action*="/cart"] .ajaxifyCart--num,'
        // fix for the-workwear-shed by mitri
        + 'form[action*="/cart"] .cart-item--inner .form-field-input.form-field-select,'
        // fix for fr.spray.bike by mitri
        + '.cart-item-quantity-display,'
        // fix for rothley by AnhTV
        + '.item__qty .qty,'
        + '#dropdown-cart .mini-products-list .item .quantity input.item-quantity,'
        + 'ul.cart-list li[data-cart-item-key] .cart-quantity input[name="quantity"],'
        + '.js-qty input.js-qty__input,'
        + '.numberinc input[type="text"],'
        + '.minicart__entry .quantity--input .quantity--input__input,'
        + '.cart-form .cart-list .qty-group input[name=quantity],'
        // fix for adertek.com
        + '.ajax-cart__item-quantity.a-left input,'
        + 'quantity-input.quantity-input input,'
        + 'input.cart-item__quantity-input,'
        + 'input[name="updates[]"],'
        + 'input.QuantitySelector__CurrentQuantity,'
        // fix for cherrykurry.com by PhuongKD
        + 'form#CartPageForm .js-qty__wrapper > input,'
        + 'form[action*="/cart"] input[name="updates[]"],'
        + 'input.cart__qty-input,'
        + '.input-quantity.item-cart-js,'
        + '.cart-item-qty .cart-item-qty-input,'
        + 'input.item-qty.cart-item-qty,'
        + 'select.qty--input,'
        + '.quantity-selector__input,'
        + '.form-input.quantity[name="quantity"]'
        + BSS_B2B.getCssSelector('cart_quantity_input');

    BSS_B2B.cart.buttonChangeQuantity = 'form[action*="/cart"] .js-qty__adjust,'
        + 'form[action*="/cart"] .ajaxifyCart--qty-adjuster,'
        + 'form[action*="/cart"] .qty-wrapper .qty-up,'
        + 'form[action*="/cart"] .qty-wrapper .qty-down,'
        + 'form[action*="/cart"] .quantity-selector__button,'
        + '#shopify-section-cart-template [data-section-id="cart-template"] .quantity-selector__button,'
        + 'form[action*="/cart"] .qtybtn,'
        + 'form[action*="/cart"] a[data-action="decrease-quantity"],'
        + '.cart-wrapper button.quantity-selector__button,'
        + '.cart-wrapper a[data-action="decrease-quantity"],'
        + 'form[action*="/cart"] a[data-qv-minus-qtt],'
        + 'form[action*="/cart"] a[data-qv-plus-qtt],'
        + 'form[action*="/cart"] a.minus.button,'
        + 'form[action*="/cart"] a.plus.button,'
        + '.cart-window .cart-prod-qty .qty-btn,'
        + '.tt-input-counter .plus-btn,'
        //fix biomatrixweb by vitu
        + '.tt-input-counter .minus-btn,'
        + '.quantity-controls .alt-focus,'
        //fix monpetitherbier by vitu
        + '.product-quantity-box .js-change-quantity,'
        + 'table.line-item-table .line-item__quantity button,'
        + 'form[action*="/cart"] .quantity-element,'
        + 'form[action*="/cart"].product-single__form button[type="submit"].btn.btn--full.add-to-cart.btn--secondary,'
        // fix for curlysecret by ThaBi
        + 'form[action*="/cart"] a.plus,'
        + 'form[action*="/cart"] a.minus,'
        // fix for kanucks-gear-inc by XuTho
        + 'form[action*="/cart"] a.ajax-cart__qty-control--up,'
        + 'form[action*="/cart"] a.ajax-cart__qty-control--down,'
        + 'form[action*="/cart"] .table-shopping-qty button,'
        // fix for studyphones by ThaBi
        + 'form[action*="/cart"] #quantity-minus,'
        + '.btn.qty-adjust,'
        + 'form[action*="/cart"] #quantity-plus,'
        // fix for chamaye by mitri
        + '.QuantitySelector__Button.Link.Link--primary,'
        // fix for meducare by mitri
        + '.js-qty__adjust--minus,'
        + '.js-qty__adjust--plus,'
        // fix panam-decor-and-gift by vitu
        + '.notabutton.quantity-up,'
        + '.notabutton.quantity-down,'
        + '.qty.tc button,'
        + 'cart-remove-button[id*="Remove"],'
        // fix for studiodai by DangNM
        + 'form[action="/cart"] .notabutton quantity-down,'
        + 'form[action="/cart"] .notabutton quantity-up,'
        + 'form[action="/cart"] .product-quantity[data-title="Quantity"] .quantity input[type="button"],'
        // fix for scanasia-as by DangNM
        + '.qty-adjuster__inner .qty-adjuster__down,'
        + '.qty-adjuster__inner .qty-adjuster__up,'
        // fix for bien-moves by CuongNVM
        + '.cart--quantity--container .cart--minus,'
        + '.cart--quantity--container .cart--plus,'
        // fix for watcstudio by KhanhND
        + '.qty-button.qty-minus,'
        + '.qty-button.qty-plus,'
        // fix for kafea-coffee by KhanhND
        + '.qty_minus.js-qty__adjust.js-qty__adjust--minus.icon-fallback-text,'
        + '.qty_plus.js-qty__adjust.js-qty__adjust--plus.icon-fallback-text,'
        + '.js-qty__adjust.js-qty__adjust--minus,'
        + '.js-qty__adjust.js-qty__adjust--plus,'
        // fix for thatsoitaly by mitri
        + '.cart__quantity-plus,'
        + '.cart__quantity-minus,'
        + '.sf-cart__table-quantity .scd-item__btn[data-qty-change],'
        // fix for bingltd by Leorio
        + 'form[action*="/cart"] span.quantity-adjuster__button.quantity-adjuster__button--down,'
        + 'form[action*="/cart"] span.quantity-adjuster__button.quantity-adjuster__button--up,'
        // fix for ydvapestore by DangNM
        + 'form[action*="/cart"] .item-qty .quantity .qty-up,'
        + 'form[action*="/cart"] .item-qty .quantity .qty-down,'
        + '.sf-cart__table-quantity .scd-item__btn[data-qty-change],'
        // fix for knobs-pulls-things by CuongNVM
        + '.cart-item__quantity .quantity__actions a,'
        // for provisionswholesale by mitri
        + '.product-quantity .qtybutton,'
        // fix for furniture by khanh
        + '.quantity__button.quantity__button--plus[data-increase-quantity],'
        + '.quantity__button.quantity__button--minus[data-decrease-quantity],'
        + '.js--qty-adjuster.js--minus,'
        + '.js--qty-adjuster.js--add,'
        + '.ajaxifyCart--qty-adjuster.ajaxifyCart--add,'
        + '.ajaxifyCart--qty-adjuster.ajaxifyCart--minus,'
        + 'form[action*="/cart"] a[data-action="update-item-quantity"],'
        // fix for hunde.fitness by mitri
        + '.cart-items .quantity__minus,'
        + '.cart-items .quantity__plus,'
        // fix for fr.spray.bike by mitri
        + '.cart-item-quantity .cart-item-increase,'
        + '.cart-item-quantity .cart-item-decrease,'
        // fix for atmooz-b2c-copy by dongnv
        + '#cart-drawer .qtyField .qtyBtn:not([rv-text]),'
        // fix for dudes-factory-b2b by DangNM
        + 'form[action*="/cart"] button[type="submit"][name="plus"],'
        + 'form[action*="/cart"] button[type="submit"][name="minus"],'
        // fix for casa-do-ashe by haipd
        + '.t4s-quantity-selector.is--plus,'
        +'.t4s-quantity-selector.is--minus,'
        // fix for rothley by AnhTV
        + '.item__qty .ri-minus,'
        + '.item__qty .ri-plus,'
        + 'ul.cart-list li[data-cart-item-key] .cart-quantity a.minus.button,'
        + 'ul.cart-list li[data-cart-item-key] .cart-quantity a.plus.button,'
        + '.sho.shoptimized-883,'
        + '.sho.shoptimized-893,'
        + 'form[action*="/cart"] button.quantity__button,'
        + '.cart__item .quantity--input .quantity--input__button,'
        + '.minicart__entry .quantity--input .quantity--input__button,'
        + '.cart-form .cart-list .qty-group .button,'
        + '.qty-control .reduce,'
        + '.qty-control .increase,'
        // fix for kikchoice by cuongnq
        + '.ajaxcart__qty--plus,'
        + '.ajaxcart__qty--minus,'
        + '.qty_selector.t-text.u-blue,'
        // fix for adertek.com
        + '.ajax-cart__item-quantity.a-left button,'
        //fix for santabarbaralighting.com by Ducnv
        + '.text-body.armament-quantity-selector .inline-flex.border button,'
        + 'quantity-input.quantity-input button,'
        //fix for https://produjardin.com/
        + '.input-group .cursor-pointer,'
        + '.js-qty__wrapper .js-qty__adjust,'
        + '.cart-item-quantity-button[type="button"],'
        + 'cart-qty-button,'
        + '.cart-item-qty .minus.btn-quantity,'
        + '.cart-item-qty .plus.btn-quantity,'
        + 'form[action*="/cart"] button.btn.btn-transparent,'
        + '.remove-lines.js-remove-line.mini-cart-remove.close-item-cart,'
        + '.ajax-cart__item-remove--js,'
        + '.cart__item__quantity .cart__item__quantity-minus, .cart__item__quantity .cart__item__quantity-plus';

    BSS_B2B.cart.removeButtons = 'form[action*="/cart"] [data-cart-remove],'
        +'form[action*="/cart"] .cart__remove:not(:has([data-cart-remove])),'
        +'a[rv-data-cart-remove].remove,'
        +'a[data-cartitem-remove].cart-item--remove-link,'
        +'form[action*="/cart"] .remove,'
        // fix for hibacart by CuongNVM
        +'form[action*="/cart"] .qty-adjuster__remove,'
        + '.single-cart-product>.cart-close-icon,'
        + 'ul.cart-list li[data-cart-item-key] .cart-remove a,'
        + '.CartItem__Actions .CartItem__Remove,'
        + 'form[action*="/cart"] .cart__trash span,'
        + '.minicart .minicart__entry .minicart__trash,'
        + '.cart-form .cart-list .cart-remove a,'
        + 'a.btn-remove-cart,'
        + '.product-cart-item-info a.remove,'
        // fix for adertek.com
        + '.ajax-cart__item-remove.mb0.ajax-cart__item-remove--js.js-cart-remove,'
        + 'a.remove-button,'
        + 'a.button.is-cart-utility,'
        + '.product-cart-item-info a.remove,'
        + 'a.mini-cart-item-remove.link-text,'
        + '.button.button--tertiary,'
        + 'a.cart_ac_remove,'
        + '.produc_remove .remove-product,'
        + '#cart-item-remove-button[type="button"], .cart-table-item-remove,'
        + 'cart-remove-button button[type="button"],'
        + '.cart-items__content .item-delete,'
        + '.remove-lines.js-remove-line.mini-cart-remove.close-item-cart,'
        + ".cartpage__items .item-delete,"
        + ".boost-pfs-minicart-item-remove,"
        + ".cart-item-remove .cart-remove,"
        + ".ajaxcart__product__remove,"
        + ".cart-item .cart-item__remove";

    BSS_B2B.cart.quantityInputSelectorWithKeyItem = function (key) {
        return [
            '[data-cart-item-key="' + key + '"] input[type="number"][data-quantity-input]',
            '[data-cart-item-key="' + key + '"] input[data-quantity-input]',
            '[data-cart-item-key="' + key + '"] input[data-cart-item-input-quantity]',
            '[data-cart-item-key="' + key + '"] input.js-qty__input',
            '[data-cart-item-key="' + key + '"] input.js-qty__num',
            '[data-cart-item-key="' + key + '"] input.quantity-selector',
            '[data-cart-item-key="' + key + '"] input.cart__quantity-selector',
            '[data-cart-item-key="' + key + '"] input.js--num',
            '[data-cart-item-id="' + key + '"] input.cart-item__qty-input',
            '[data-cart-item-key="' + key + '"] input.cart__product-qty',
            '[data-cart-item-key="' + key + '"] input.form__input.cart__quantity',
            'input.js-qty__num[data-id="' + key + '"]',
            'input.ajaxcart__qty-num[data-id="' + key + '"]',
            '[data-cart-item-key="' + key + '"] .ajaxifyCart--num',
            '[data-cart-item-key="' + key + '"] .quantity-adjuster__input',
            '[data-cart-item-key="' + key + '"] input.quantity__input',
            '[data-cart-item-key="' + key + '"] input.ajaxifyCart--num',
            '[data-cart-item-key="' + key + '"] input.cart-item__quantity-input',
            '[data-cart-item-key="' + key + '"] input[type="number"]',
            '[data-cart-item-key="' + key + '"] input[type="text"][name="quantity"]',
            '[data-cart-item-key="' + key + '"] input[type="text"][name="updates[]"]'
        ]
    }

    BSS_B2B.cart.checkoutBtnElement = function() {
        return [
            'form[action*="/cart"] [name="checkout"]',
            '#dropdown-cart button.btn.btn-checkout.show',
            'a.button.checkout-button[href="/checkout"]',
            'form[action*="/checkout"] .add_to_cart',
            'form[action*="/cart"]#cart_form #checkout',
            'form[action*="/cart"] button.Cart__Checkout',
            'form[action*="/cart"] button.cart__checkout',
            'a.btn.disabled.ttmodalbtn[href="/checkout"]',
            'button#checkout.cart__checkout-button.button',
            '.cart-summary__buttons .btn.wide',
            '#checkout--button'
        ];
    }
}

// CONCATENATED MODULE: ./js/src/dc/init-discount-code.js
function initDC($, BSS_B2B, shopData) {
    BSS_B2B.dc = {};
    BSS_B2B.dc.getDiscountCodeApplied = function (isChangeQuantity = false) {
        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cartData) {
                let cartAttributes = cartData.attributes;
                if (cartAttributes.discountCodeRule && cartAttributes.discountCodeRule.length > 0) {
                    const discountCodeRule = JSON.parse(cartAttributes.discountCodeRule)
                    let discountCode = discountCodeRule.discount_code;
                    let discountCodeType = discountCodeRule.discount_code_type;
                    let today = new Date();
                    let moment = today.toLocaleTimeString(undefined,
                        {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
                    today.setUTCHours(0, 0, 0, 0);
                    let handles = [];
                    let handleURLs = [];
                    let cartItemsMap = new Map();
                    for (let i = 0; i < cartData.items.length; i++) {
                        let item = cartData.items[i];
                        let proId = item.product_id;
                        if (handles.indexOf(proId) === -1) {
                            handles.push(proId);
                            handleURLs.push('id:"' + proId + '"');
                            cartItemsMap.set(proId, []);
                        }
                        let cartItems = cartItemsMap.get(proId);
                        cartItems.push(item);
                        cartItemsMap.set(proId, cartItems);
                    }
                    let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
                    let encodeUrlData = encodeURI(urlData);
                    $.get(encodeUrlData, function(data) {
                        let responseProducts = [];
                        try {
                            responseProducts = JSON.parse(data);
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.log('B2B: JSON parse returns no item');
                        }

                        if (responseProducts.length > 0) {
                            let productMap = [];
                            let checkUnique = [];
                            for (let i = 0; i < responseProducts.length; i++) {
                                let pro = responseProducts[i];
                                if (checkUnique.indexOf(pro.id) === -1) {
                                    checkUnique.push(pro.id);
                                    cartItemsMap.get(pro.id).forEach(function(cartItem) {
                                        productMap.push({
                                            id: pro.id,
                                            tags: pro.tags,
                                            collections: pro.collections,
                                            key: cartItem.key,
                                            price: parseFloat(cartItem.price),
                                            title: pro.title,
                                            quantity: parseInt(cartItem.quantity),
                                        });
                                    });
                                }
                            }
                            let cpPricingList = [];
                            let qbPricingList = [];
                            for (const [key, value] of BSS_B2B.cart.cpPricingList) {
                                cpPricingList.push({
                                    key: key,
                                    modifiedItemPrice: value.modifiedItemPrice
                                })
                            }
                            for (const [key, value] of BSS_B2B.cart.qbPricingList) {
                                qbPricingList.push({
                                    key: key,
                                    modifiedItemPrice: value.pricePerItemAfterApplyQB
                                })
                            }

                            let data = {
                                today: today,
                                moment: moment,
                                customer: shopData.customer,
                                cart_items: productMap,
                                domain: shopData.shop.permanent_domain,
                                discount_code: discountCode,
                                cpPricingList: cpPricingList,
                                qbPricingList: qbPricingList,
                            };
                            if (!isChangeQuantity) {
                                fetch(bssB2bApiServer + `/dc/rules/get-applied-rule?domain=${Shopify.shop}`, {
                                    method: "POST",
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(data)
                                })
                                .then(response => response.json())
                                .then(async function (data) {
                                    let shareLink = localStorage.getItem("dc_share_link_appied");
                                    if (shareLink !== undefined && shareLink == "true") {
                                        BSS_B2B.dc.showMessageApplyDC(data)
                                        localStorage.removeItem("dc_share_link_appied")
                                    } else {
                                        BSS_B2B.dc.showMessageApplyDC(data, true)
                                    }
                                })
                                .catch((error) => {
                                    // eslint-disable-next-line no-console
                                    console.error('Error:', error);
                                });
                            } else {
                                if (discountCode) {
                                    const dcContent = "<div id=\"bss-b2b-discount-code-applied\">" +
                                        "<span>"
                                        + discountCode +
                                        "</span>" +
                                        "<div id=\"bss-b2b-clear-discount-code\">\n" +
                                        "&#x2716;\n" +
                                        "</div>" +
                                        "</div>";

                                    const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                                    if (dcWrapperElements && dcWrapperElements.length > 0) {
                                        dcWrapperElements.forEach((element) => {
                                            const dcAppliedWrapperElements = element.querySelector("#bss-b2b-discount-code-applied-wrapper");
                                            dcAppliedWrapperElements.innerHTML = dcContent;
                                        })
                                    }
                                    BSS_B2B.dc.handleRemoveDiscountCodeApplied()
                                }
                                const checkApplyDC = BSS_B2B.dc.checkMinimumPurchaseDC(discountCodeType, discountCodeRule.rule_id, data);
                                if (!checkApplyDC.success) {
                                    $('#bss-b2b-clear-discount-code').click();
                                    BSS_B2B.dc.showMessageApplyDC(checkApplyDC);
                                }
                            }
                        }
                    });
                }
            }
        })
    };

    BSS_B2B.dc.handleRemoveDiscountCodeApplied = function() {
        const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
        if (dcWrapperElements && dcWrapperElements.length > 0) {
            dcWrapperElements.forEach((element) => {
                const clearDiscountCodeBtn = element.querySelector('#bss-b2b-clear-discount-code');
                clearDiscountCodeBtn.addEventListener('click', async (event) => {
                    event.preventDefault();

                    dcWrapperElements.forEach((ele) => {
                        const dcInputElement = ele.querySelector('#bss-b2b-discount-code-input');
                        const dcMessagesElement = ele.querySelector('#bss-b2b-discount-code-message');
                        const dcAppliedWrapperElements = ele.querySelector("#bss-b2b-discount-code-applied-wrapper");

                        dcInputElement.value = '';
                        dcInputElement.removeAttribute('discount-code');
                        dcMessagesElement.innerHTML = '';
                        dcAppliedWrapperElements.innerHTML = '';
                    })
                    let dataUpdateJSON = JSON.stringify({});
                    let dataUpdate = {
                        attributes: {
                            discountCodeRule: dataUpdateJSON,
                        },
                    };
                    const cartDataRes = await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(dataUpdate),
                    });

                    const cartData = await cartDataRes.json();
                    window.BSS_B2B.executeAction({
                        tag: 'customize_dc',
                        storeId: 7597,
                        BSS_B2B, cartData,
                        dcRule: JSON.parse(dataUpdateJSON),
                        isRemove: false
                    });
                })
            })
        }
    };

    BSS_B2B.dc.showDiscountBox = function() {
        let dcRules = BSS_B2B.dcRules;
        let isShowDiscountBox = true;
        let customerId = shopData.customer.id;
        let customerTags = (shopData.customer && shopData.customer.tags) ? shopData.customer.tags.map(
            (tag) => tag.toLowerCase()) : [];
        if (dcRules) {
            if (dcRules.length === 0) {
                isShowDiscountBox = false;
            }
            else if (dcRules.length > 0) {
                for (let i = 0; i < dcRules.length; i++) {
                    let rule = dcRules[i];
                    let applyTo = rule.apply_to;
                    if (applyTo === 0) {
                        isShowDiscountBox = true;
                    }
                    else if (applyTo === 1) {
                        if (customerId == null) {
                            isShowDiscountBox = false;
                        }
                        else {
                            isShowDiscountBox = true;
                        }
                    }
                    else if (applyTo === 2) {
                        if (customerId != null) {
                            isShowDiscountBox = false;
                        }
                        else {
                            isShowDiscountBox = true;
                        }
                    }
                    else if (applyTo === 3) {
                        let customerIdsRule = rule.customer_ids.split(',');

                        if (customerIdsRule.includes(customerId + '')) {
                            isShowDiscountBox = true;
                        }
                        else {
                            isShowDiscountBox = false;
                        }
                    }
                    else if (applyTo === 4) {
                        let customerTagsRule = rule.customer_tags.split(',');
                        let checkArray = customerTagsRule.filter(tag => customerTags.includes(tag.toLowerCase()));
                        if (checkArray.length === 0) {
                            isShowDiscountBox = false;
                        }
                        else {
                            isShowDiscountBox = true;
                        }
                    }

                    if (isShowDiscountBox === true) {
                        break;
                    }
                }
            }
        }
        if (isShowDiscountBox) {
            setTimeout(() => {
                $('.bss-b2b-discount-code-wrapper').css('display', 'inline-grid');
                const headerDiscountForm = document.querySelectorAll(".bss-b2b-translation-dc-form_header_text");
                const btnApply = document.querySelectorAll("#bss-b2b-discount-code-submit span");
                if (headerDiscountForm.length && btnApply.length) {
                    headerDiscountForm.forEach((item) => {
                        item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.form_header_text : "Discount Code";
                    });
                    btnApply.forEach((item) => {
                        item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.button_apply : "Apply";
                    });
                }
                if (BSS_B2B.storeId === 3879) {
                    $('.bss-b2b-discount-code-wrapper').attr("discount-box","")
                }
                if (BSS_B2B.storeId === 5686) {
                    const discountCodeDefault = document.querySelector(".cart-total.cart-total-coupon")
                    if (discountCodeDefault) {
                        discountCodeDefault.style.display = "none"
                    }
                }
            }, 500)
            if (BSS_B2B.storeId === 14978) {
                let event = new Event('bss.b2b.dc.doneShowDCBox');
                document.dispatchEvent(event);
            }
        }
        else {
            $('.bss-b2b-discount-code-wrapper').remove();
        }
    };

    BSS_B2B.dc.checkDiscountCodeShareLink = function() {
        let today = new Date();
        let moment = today.toLocaleTimeString();
        const handleRedirectShareableLink = (redirect_link) => {
            if (redirect_link !== '' || redirect_link !== undefined) {
                let redirectUrl = redirect_link;
                if (redirect_link.indexOf('http') === -1 || redirect_link.indexOf('https') === -1) {
                    if (redirect_link[0] !== '/') {
                        redirectUrl = '/' + redirectUrl;
                    }
                    redirectUrl = 'https:/' + redirectUrl;
                }
                window.location.replace(`${redirectUrl}`);
            }
        };
        let shopDataHTML = JSON.parse(document.getElementById('bss-b2b-store-data').innerHTML);
        fetch(`https://${shopDataHTML.shop.domain}/cart.js`)
        .then((shopDataRes) => (shopDataRes.json()))
        .then((shopData) =>{
            let handleUrls = [];
            let handles = [];
            let keyIdMap = new Map();
            let keyPriceMap = new Map();
            let keyQuantityMap = new Map();
            for (let i = 0; i < shopData.items.length; i++) {
                let item = shopData.items[i];
                let proId = item.product_id;
                if (handles.indexOf(proId) === -1) {
                    handles.push(proId);
                    handleUrls.push('id:"' + proId + '"');
                    keyIdMap.set(proId, []);
                    keyPriceMap.set(proId, []);
                    keyQuantityMap.set(proId, []);
                }

                let productItemKeys = keyIdMap.get(proId);
                productItemKeys.push(item.key)
                keyIdMap.set(proId, productItemKeys);
                keyPriceMap.set(proId, item.price);
                keyQuantityMap.set(proId, item.quantity);
            }
            let urlData = '/search.js?q=' + handleUrls.join(' OR ') + '&view=bss.b2b';
            fetch(`https://${shopDataHTML.shop.domain}/${urlData}`)
            .then((productCartPage) => (productCartPage.json()))
            .then((responseProducts) => {
                if (BSS_B2B.storeId === 3576) {
                    if (responseProducts.length != handleUrls.length) {
                        handleUrls.forEach((item) => {
                            if (!responseProducts.some((product) => item.includes(product.id))) {
                                let productId = +(item.match(/\d/g).join(''))
                                responseProducts.push({
                                    id: productId
                                })
                            }
                        })
                    }
                }
                if (responseProducts.length > 0) {
                    let productMap = []
                    let checkUnique = [];
                    for (let i = 0; i < responseProducts.length; i++) {
                        let pro = responseProducts[i];
                        if (checkUnique.indexOf(pro.id) === -1) {
                            checkUnique.push(pro.id);
                            keyIdMap.get(pro.id).forEach(function (key) {
                                productMap.push({
                                    id: pro.id,
                                    tags: pro.tags,
                                    collections: pro.collections,
                                    key: key,
                                    price: parseFloat(keyPriceMap.get(pro.id)),
                                    title: pro.title,
                                    quantity: parseInt(keyQuantityMap.get(pro.id))
                                });
                            })
                        }
                    }

                    let pathName = window.location.pathname.replace('/', '');
                    fetch(bssB2bApiServer + "/dc/rules/get-discount-by-sharelink?domain=" + shopDataHTML.shop.permanent_domain + "&shareLink=" + pathName, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then((dataShareLinkResponse) => (dataShareLinkResponse.json()))
                    .then(async (dataShareLink) =>{
                        if(dataShareLink.success){
                            let cpPricingList = [];
                            let qbPricingList = [];
                            for (const [key, value] of BSS_B2B.cart.cpPricingList) {
                                cpPricingList.push({
                                    key: key,
                                    modifiedItemPrice: value.modifiedItemPrice
                                })
                            }
                            for (const [key, value] of BSS_B2B.cart.qbPricingList) {
                                qbPricingList.push({
                                    key: key,
                                    modifiedItemPrice: value.pricePerItemAfterApplyQB
                                })
                            }
                            let data = {
                                today: today,
                                moment: moment,
                                customer: shopDataHTML.customer,
                                cart_items: productMap,
                                domain: shopDataHTML.shop.permanent_domain,
                                discount_code: dataShareLink.rule.discount_code,
                                cpPricingList: cpPricingList,
                                qbPricingList: qbPricingList,
                            }
                            await fetch(bssB2bApiServer + "/dc/rules/get-applied-rule?domain=" + shopDataHTML.shop.permanent_domain, {
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(data)
                            })
                            .then(response => response.json())
                            .then(async function (data) {
                                if (data.success) {
                                    const {token, ...res} = data.data;
                                    const infoUpdate = {
                                        dc_keys: res.listKeysItemAppliedDC,
                                        dc_products: res.listProductIdsAppliedDC,
                                        rule_id: res.ruleId,
                                        discount_value: res.discountValue,
                                        discount_type: res.discountType,
                                        discount_code: res.discountCode,
                                        discount_code_type: res.discountCodeType,
                                        token: token
                                    }
                                    let dataUpdate = {
                                        attributes: {
                                            discountCodeRule: JSON.stringify(infoUpdate)
                                        }
                                    };
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify(dataUpdate)
                                    })
                                } else {
                                    let dataUpdateJSON = JSON.stringify({discount_code: dataShareLink.rule.discount_code})
                                    let dataUpdate = {
                                        attributes: {
                                            discountCodeRule: dataUpdateJSON
                                        }
                                    };
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify(dataUpdate)
                                    })
                                }
                                localStorage.setItem("dc_share_link_appied", true);
                                handleRedirectShareableLink(dataShareLink.rule.redirect_link)
                            })
                        }else{
                            handleRedirectShareableLink(dataShareLink.rule.redirect_link)
                        }
                    })
                }
            })
        })
    };

    BSS_B2B.dc.checkMinimumPurchaseDC = (discountCodeType, ruleIdDiscountCodeApplied, params) => {
        let result = {
            success: true
        };
        try {
            let translationTexts = BSS_B2B.dcTranslations;
            const rule = BSS_B2B.dcRules.find((item) => item.id === ruleIdDiscountCodeApplied)
            const discountCode = params.discount_code;
            if (rule && discountCode) {
                let listKeysItemAppliedDC = [];
                let listProductIdsAppliedDC = [];
                let isApplyToCustomer = false;
                let isApplyToProduct = false;
                let today = new Date(params.today);
                let start_date = false;
                let end_date = false;
                let start_time = false;
                let end_time = false;
                let moment = params.moment;
                let listItemAppliedDc = [];
                let totalAmountItemAppliedDc = 0;
                let totalQuantityAppliedRule = 0;
                let checkRequiredMinimumPurchase = true;
                let enableMinimumPurchase = rule.minimum_purchase_type != 0 ? true : false;
                if (rule.start_date) {
                    start_date = new Date(rule.start_date);
                }
                if (rule.end_date) {
                    end_date = new Date(rule.end_date);
                }
                if (rule.start_time) {
                    start_time = rule.start_time;
                }
                if (rule.end_time) {
                    end_time = rule.end_time;
                }
                let isExpiredDiscountCode = BSS_B2B.dc.checkExpiredOfDC(today, start_date, end_date, moment, start_time, end_time, rule.enable_end_date);

                if (isExpiredDiscountCode) {
                    let customer = params.customer;
                    let applyTo = rule.apply_to;
                    let customerIds = rule.customer_ids;
                    let customerTags = rule.customer_tags;

                    isApplyToCustomer = BSS_B2B.dc.checkApplyToCustomerOfDC(customer, applyTo, customerIds, customerTags);
                }

                if (isApplyToCustomer) {
                    let conditionType = rule.product_condition_type;
                    let ruleTags = rule.product_tags ? rule.product_tags.split(`,`) : [];
                    let specificProductIds = rule.product_ids ? rule.product_ids.split(`,`) : [];
                    let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(`,`) : [];
                    for (let i = 0; i < params.cart_items.length; i++) {
                        const item = params.cart_items[i];
                        if (conditionType == 0 || discountCodeType == 1 || discountCodeType == 2) {
                            listKeysItemAppliedDC.push(item.key);
                            listProductIdsAppliedDC.push(item.id);
                            isApplyToProduct = true;
                            if (enableMinimumPurchase) {
                                const modifiedItemPrice = BSS_B2B.dc.calculatePriceAppliedCPAndQB(item, params.cpPricingList, params.qbPricingList)
                                totalQuantityAppliedRule += item.quantity
                                totalAmountItemAppliedDc += modifiedItemPrice;
                                listItemAppliedDc.push({ "id": item.id, "title": item.title });
                            }
                        } else if (conditionType == 1) {
                            if (specificProductIds.indexOf(item.id.toString()) !== -1) {
                                isApplyToProduct = true;
                                listKeysItemAppliedDC.push(item.key);
                                listProductIdsAppliedDC.push(item.id);
                                if (enableMinimumPurchase) {
                                    const modifiedItemPrice = BSS_B2B.dc.calculatePriceAppliedCPAndQB(item, params.cpPricingList, params.qbPricingList)
                                    totalQuantityAppliedRule += item.quantity
                                    totalAmountItemAppliedDc += modifiedItemPrice;
                                    listItemAppliedDc.push({ "id": item.id, "title": item.title });
                                }
                            }
                        } else if (conditionType == 2) {
                            let checkArray = item.collections.filter(collection => ruleCollectionIds.includes(collection.toString()));
                            if (checkArray.length > 0) {
                                isApplyToProduct = true;
                                listKeysItemAppliedDC.push(item.key);
                                listProductIdsAppliedDC.push(item.id);
                                if (enableMinimumPurchase) {
                                    const modifiedItemPrice = BSS_B2B.dc.calculatePriceAppliedCPAndQB(item, params.cpPricingList, params.qbPricingList)
                                    totalQuantityAppliedRule += item.quantity
                                    totalAmountItemAppliedDc += modifiedItemPrice;
                                    listItemAppliedDc.push({ "id": item.id, "title": item.title });
                                }
                            }
                        } else if (conditionType == 3) {
                            let productTags = item.tags ? item.tags.map((tag) => tag.toLowerCase()) : [];
                            ruleTags = ruleTags.map((tag) => tag.toLowerCase());
                            let checkArray = ruleTags.filter(tag => productTags.includes(tag.toString()));
                            if (checkArray.length > 0) {
                                isApplyToProduct = true;
                                listKeysItemAppliedDC.push(item.key);
                                listProductIdsAppliedDC.push(item.id);
                                if (enableMinimumPurchase) {
                                    const modifiedItemPrice = BSS_B2B.dc.calculatePriceAppliedCPAndQB(item, params.cpPricingList, params.qbPricingList)
                                    totalQuantityAppliedRule += item.quantity
                                    totalAmountItemAppliedDc += modifiedItemPrice;
                                    listItemAppliedDc.push({ "id": item.id, "title": item.title });
                                }
                            }
                        }
                    }
                }
                let textErrorMinimumPurchase = ""
                if (rule.minimum_purchase_type === 1) {
                    if (totalAmountItemAppliedDc < rule.minimum_purchase_value * 100) {
                        checkRequiredMinimumPurchase = false;
                        textErrorMinimumPurchase = `${translationTexts.text_warning_amount_discount_code.replace("{{discount_code}}", discountCode)}: 
                            ${BSS_B2B.formatMoney(rule.minimumPurchaseValue*100)}`
                    }
                } else if (rule.minimum_purchase_type === 2) {
                    if (totalQuantityAppliedRule < rule.minimum_purchase_value) {
                        checkRequiredMinimumPurchase = false;
                        textErrorMinimumPurchase = `${translationTexts.text_warning_quantity_discount_code.replace("{{discount_code}}", discountCode)}: 
                            ${rule.minimumPurchaseValue} ${translationTexts.warning_products_discount_code}`
                    }
                }
                if (isApplyToCustomer && isExpiredDiscountCode && isApplyToProduct && !checkRequiredMinimumPurchase) {
                    let checkUnique = []
                    let listProductAppliedDc = []
                    listItemAppliedDc.forEach(item => {
                        if (checkUnique.indexOf(item.id) === -1) {
                            checkUnique.push(item.id)
                            listProductAppliedDc.push(item)
                        }
                    })
                    result = {
                        success: false,
                        message: textErrorMinimumPurchase,
                        errorMinimumPurchase: {
                            discountCode: discountCode,
                            listItemAppliedDc: listItemAppliedDc,
                            minimumPurchaseType: rule.minimum_purchase_type,
                            minimumPurchaseValue: rule.minimum_purchase_value,
                            translationTexts: translationTexts,
                        }
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error:', e);
        }
        return result;
    };

    BSS_B2B.dc.datesAreSameDay = (day1, day2) => {
        return day1.getFullYear() == day2.getFullYear() && day1.getMonth() == day2.getMonth() && day1.getDate() == day2.getDate();
    },

        BSS_B2B.dc.checkExpiredOfDC = (today, start_date, end_date, moment, start_time, end_time, enable_end_date) => {
            let isExpiredDiscountCode = false;

            if (start_date) {
                if (!start_time) {
                    start_time = `00:00:00`
                }

                if (enable_end_date) {
                    if (end_date) {
                        if (start_date < end_date) {
                            if (BSS_B2B.dc.datesAreSameDay(today, start_date)) {
                                if (moment > start_time) {
                                    isExpiredDiscountCode = true;
                                }
                            } else if (BSS_B2B.dc.datesAreSameDay(today, end_date)) {
                                if (!end_time || (moment < end_time)) {
                                    isExpiredDiscountCode = true;
                                }
                            } else if (today > start_date && today < end_date) {
                                isExpiredDiscountCode = true;
                            }
                        } else if (BSS_B2B.dc.datesAreSameDay(start_date, end_date)) {

                            if (start_time < moment && moment < end_time) {
                                isExpiredDiscountCode = true;
                            }
                        }
                    } else {
                        if (today > start_date) {
                            isExpiredDiscountCode = true;
                        } else if (BSS_B2B.dc.datesAreSameDay(today, start_date)) {
                            if (moment > start_time) {
                                isExpiredDiscountCode = true;
                            }
                        }
                    }
                } else {
                    if (today > start_date) {
                        isExpiredDiscountCode = true;
                    } else if (BSS_B2B.dc.datesAreSameDay(today, start_date)) {
                        if (moment > start_time) {
                            isExpiredDiscountCode = true;
                        }
                    }
                }
            } else {
                if (!start_time) {
                    start_time = `00:00:00`
                }

                if (enable_end_date) {
                    if (end_date) {
                        if (today < end_date) {
                            isExpiredDiscountCode = true;
                        } else if (BSS_B2B.dc.datesAreSameDay(today, end_date)) {
                            if (!end_time || (moment < end_time)) {
                                isExpiredDiscountCode = true;
                            }
                        }
                    } else {
                        if (!end_time || (moment < end_time)) {
                            isExpiredDiscountCode = true;
                        }
                    }
                } else {
                    isExpiredDiscountCode = true;
                }
            }

            return isExpiredDiscountCode;
        };

    BSS_B2B.dc.checkApplyToCustomerOfDC = (customer, applyTo, customerIds, customerTags) => {
        let isApplyToCustomer = false;
        let customerStoreTags = customer.tags ? customer.tags.map((tag) => tag.toLowerCase()) : [];

        if (applyTo == 0) {
            isApplyToCustomer = true;
        } else if (applyTo == 1) {
            if (customer.id !== null) {
                isApplyToCustomer = true;
            }
        } else if (applyTo == 2) {
            if (customer.id == null) {
                isApplyToCustomer = true;
            }
        } else if (applyTo == 3) {
            if (customer.id !== null) {
                customerIds = customerIds.split(`,`);
                if (customerIds.indexOf(customer.id.toString()) !== -1) {
                    isApplyToCustomer = true;
                }
            }
        } else if (applyTo == 4) {
            if (customer.tags !== null) {
                let customerTagsRule = customerTags.split(`,`).map((tag) => tag.toLowerCase());
                var checkArray = customerTagsRule.filter(tag => customerStoreTags.includes(tag.toString()));
                if (checkArray.length > 0) {
                    isApplyToCustomer = true;
                }
            }
        }

        return isApplyToCustomer;
    };

    BSS_B2B.dc.calculatePriceAppliedCPAndQB = (item, cpPricingList, qbPricingList) => {
        let modifiedItemPrice = item.price;
        const itemAfterAppliedCp = cpPricingList.find((value) => value.key == item.key)
        if (itemAfterAppliedCp) {
            modifiedItemPrice = itemAfterAppliedCp.modifiedItemPrice
        }
        const itemAfterAppliedQb = qbPricingList.find((value) => value.key == item.key)
        if (itemAfterAppliedQb) {
            modifiedItemPrice = itemAfterAppliedQb.modifiedItemPrice
        }

        return modifiedItemPrice * item.quantity;
    }

    BSS_B2B.dc.showMessageApplyDC = async (data, isFirstLoading = false) => {
        let dataUpdate = {
            attributes: {
                discountCodeRule: JSON.stringify({})
            }
        };
        if (data.success) {
            const {token, ...res} = data.data;
            if (!isFirstLoading) {
                const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                if (dcWrapperElements && dcWrapperElements.length > 0) {
                    dcWrapperElements.forEach((element) => {
                        const dcInputElement = element.querySelector('#bss-b2b-discount-code-input');
                        const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');

                        dcInputElement.value = res.discountCode;
                        dcInputElement.setAttribute('discount-code', 'true');
                        dcMessagesElement.innerHTML = data.message;
                        dcMessagesElement.style.color = 'green';
                    })
                }

                const infoUpdate = {
                    dc_keys: res.listKeysItemAppliedDC,
                    dc_products: res.listProductIdsAppliedDC,
                    rule_id: res.ruleId,
                    discount_value: res.discountValue,
                    discount_type: res.discountType,
                    discount_code: res.discountCode,
                    discount_code_type: res.discountCodeType,
                    token: token
                }
                dataUpdate = {
                    attributes: {
                        discountCodeRule: JSON.stringify(infoUpdate)
                    }
                };
                const cartDataRes = await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(dataUpdate)
                })

                if(BSS_B2B.storeId === 7597) {
                    $("#bss-b2b-discount-code-applied-wrapper").html(dcContent);

                    const cartData = await cartDataRes.json();
                    window.BSS_B2B.executeAction({
                        tag: 'customize_dc',
                        storeId: 7597,
                        BSS_B2B, cartData,
                        dcRule: infoUpdate,
                        isRemove: false
                    });
                }
            }
            const dcContent = "<div id=\"bss-b2b-discount-code-applied\">" +
                "<span>"
                + res.discountCode +
                "</span>" +
                "<div id=\"bss-b2b-clear-discount-code\">\n" +
                "&#x2716;\n" +
                "</div>" +
                "</div>";

            const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
            if (dcWrapperElements && dcWrapperElements.length > 0) {
                dcWrapperElements.forEach((element) => {
                    const dcAppliedWrapperElements = element.querySelector("#bss-b2b-discount-code-applied-wrapper");
                    dcAppliedWrapperElements.innerHTML = dcContent;
                })
            }
            BSS_B2B.dc.handleRemoveDiscountCodeApplied()
        } else if (!isFirstLoading) {
            if (data.errorMinimumPurchase) {
                const {minimumPurchaseType, minimumPurchaseValue, translationTexts, discountCode, listItemAppliedDc} = data.errorMinimumPurchase
                if (BSS_B2B.storeId === 3793 && minimumPurchaseType === 1) {
                    $("#bss-b2b-discount-code-input").val(discountCode);
                    await BSS_B2B.customizeShowModalMessageErrorMinimumPurchase(data);
                    $("#bss-b2b-discount-code-applied-wrapper").html("");
                    $("#bss-b2b-discount-code-message").html("");
                    $("#bss-b2b-discount-code-input").removeAttr('discount-code');
                } else {
                    let textErrorMinimumPurchase = ""
                    if (minimumPurchaseType === 1) {
                        textErrorMinimumPurchase = translationTexts.text_warning_amount_discount_code.replace("{{discount_code}}", discountCode)
                            + `: ${BSS_B2B.formatMoney(minimumPurchaseValue*100)}`
                    } else {
                        textErrorMinimumPurchase = translationTexts.text_warning_quantity_discount_code.replace("{{discount_code}}", discountCode)
                            + `: ${minimumPurchaseValue} ${translationTexts.warning_products_discount_code}`;
                    }
                    const messageErrorMinimumPurchase = `
                        <p class="header_warning_appliedRule">${textErrorMinimumPurchase}</p>
                        <ul class="list_product_appliedRule">
                            ${listItemAppliedDc.map(item => {
                        return `
                                <li>
                                    ${item.title}
                                </li>
                            `
                    }).join(" ")}
                        </ul>
                    `;

                    const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                    if (dcWrapperElements && dcWrapperElements.length > 0) {
                        dcWrapperElements.forEach((element) => {
                            const dcInputElement = element.querySelector('#bss-b2b-discount-code-input');
                            const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');
                            dcInputElement.value = discountCode;
                            dcMessagesElement.innerHTML = messageErrorMinimumPurchase;
                            dcMessagesElement.style.color = 'red';
                        })
                    }
                }
            } else {
                const dcWrapperElements = document.querySelectorAll(".bss-b2b-discount-code-wrapper");
                if (dcWrapperElements && dcWrapperElements.length > 0) {
                    dcWrapperElements.forEach((element) => {
                        const dcMessagesElement = element.querySelector('#bss-b2b-discount-code-message');
                        dcMessagesElement.innerHTML = data.message
                        dcMessagesElement.style.color = 'red'
                    })
                }
            }
            await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataUpdate)
            });
        }
    }
}
// CONCATENATED MODULE: ./js/src/cart_field/add_cart_field.js
function addCartField($, BSS_B2B, shopData) {
    let checkoutButton = $('form[action*="/cart"] [name="checkout"],' +
        '#dropdown-cart button.btn.btn-checkout.show,' +
        'a.button.checkout-button[href="/checkout"],' +
        'form[action*="/checkout"] .add_to_cart,' +
        'form[action*="/cart"]#cart_form #checkout,' +
        'form[action*="/cart"] button.Cart__Checkout,' +
        'form[action*="/cart"] button.cart__checkout,' +
        'a.btn.disabled.ttmodalbtn[href="/checkout"],' +
        'form[action*="/cart"] [name="checkout"][type="submit"],' +
        // fix for wdw by ThaBi
        'button.Cart__Checkout.Button.Button--primary.Button--full,' +
        // fix for epair-partners-wholesale-retail by ThaBi
        '.baskettop button.mini-cart-checkout,' +
        '.tt-dropdown-menu .btn.itemCheckout,' +
        // fix for shop.repairpartners by ThaBi
        '.bss-btn-checkout-mini-cart,' +
        // fix for theme Boundless by XuTho
        'button[name="checkout"].btn,' +
        // fix korresshop-greece by vitu
        'form[action*="/checkout"] [name="checkout"],' +
        '.cart__footer button#checkout.cart__checkout-button,' +
        '.drawer__footer #CartDrawer-Checkout'  //fix for theme Refresh
    );

    //fix when minicart rerender
    $('.quantity__input').on('change', () => {
        setTimeout(() => {
            addCartField($, BSS_B2B, shopData);
        }, 2000);
    }); //when quantity input change  
    $('.product-form__submit.button.button--full-width.button--secondary, .quick-add__submit.button.button--full-width.button--secondary').on('click', () => {
        setTimeout(() => {
            addCartField($, BSS_B2B, shopData);
        }, 2000);
    }); //when click add to cart

    let isDone = false;
    checkoutButton.on("click", function (e) {
        $(this).off();
        let self = this;
        e.preventDefault();
        e.stopPropagation();

        // add custom field
      let customFieldValue = [];
        let customFields = $('.bss-b2b-custom-fields textarea,'
            + `.bss-b2b-custom-fields input[name=bss-radio-button]:checked`);
            if (customFields.length) {
                let labelCustom = '';
            for (let i = 0; i < customFields.length; i++) {
                let element = {
                    key: labelCustom || customFields[i].className,
                    value: customFields[i].value
                };
                customFieldValue.push(element)
            }
        }
        // add cart note
        let cartNote = $(this).closest(`form[action="/cart"]`).find('.cart-footer__note-input');
        
        let cartNoteDefault = 'cart note';
        if (cartNote.length) {
            customFieldValue.push({
                key: cartNoteDefault,
                value: cartNote.val()
            })
        }
        // add checkbox
        let customerCheckbox = $(`.bss-b2b-custom-fields [type="checkbox"]:checked`);
        if (customerCheckbox.length) {
            let valueCheckbox = '';
            for (let i = 0; i < customerCheckbox.length; i++) {
                valueCheckbox += ' ,' + customerCheckbox[i].value
            }
            if (valueCheckbox.length) {
                valueCheckbox = valueCheckbox.slice(2, valueCheckbox.length)
            }
            let element = {
                key: customerCheckbox[0].className,
                value: valueCheckbox
            };
            customFieldValue.push(element)
        }
        // add selector
        let selectorElement = $('#bss-select-cart');
        if (selectorElement.length) {
            let valueSelect = $('#bss-select-cart option').filter(':selected').val();
            let elementSelect = {
                key: $(selectorElement).attr('class'),
                value: valueSelect
            };
            customFieldValue.push(elementSelect)
        }
        // fix support
        if (BSS_B2B.storeId === 1792) {
            // Change "Le lieu de retrait de votre commande" to "Pickup_Store" - SAB2B-588 -madu
            let elementPickUp = {
                key: 'Pickup_Store',
                value: $('input#pickup-store').attr('value').replace(/<[^>]+>/g, '')
            };
            customFieldValue.push(elementPickUp)
        }
        let oldCheckoutBtn = self;
        if (customFieldValue.length && customFieldValue !== null && customFieldValue !== undefined) {
            BSS_B2B.modifyCartDataAndCreateCheckout(shopData, "", oldCheckoutBtn, self, isDone, true, customFieldValue);
        }
    })
}
// CONCATENATED MODULE: ./js/src/qi/qi.js


function initQi($, BSS_B2B, shopData, isEnabledQI, isEnableCP) {
    /**
     * For quantity increment
     */
    BSS_B2B.qi = {};
    BSS_B2B.qi.invalidIncrementProducts = false;

    BSS_B2B.qi.renderModalWarning = function () {
        if (isEnabledQI && BSS_B2B.qiSettings) {
            let modalQI = "<div class='modalWarningQI'>\n" +
                "<div class='bss-modal-warning-qi-wrap' tabindex='-1'>" +
                "<div>" +
                "<div class='bss-modal-qi active'>" +
                `<div class='bss-modal-qi-header' style='padding: 10px; background: ${BSS_B2B.qiSettings.headerBackgroundColor}'>` +
                "<button title='Close (Esc)' type='button' class='bss-modal-button-close'>×</button>" +
                `<b class='bss-modal-qi-title bss-b2b-translation-qi-warning_text' style='margin-left: 12px; color: ${BSS_B2B.qiSettings.headerTextColor}' >` + `${BSS_B2B.qiTranslations.warning_text}` + "</b>\n" +
                "</div>" +
                `<div class='bss-modal-qi-body' style='padding: 18px; background: ${BSS_B2B.qiSettings.contentBackgroundColor}; color: ${BSS_B2B.qiSettings.contentTextColor}'>` +
                "<div class='bss-qi-list-warning'>";
            modalQI += "<br/><span class='bss-qi-warning-amount-title bss-b2b-translation-qi-general_message_text'>"
            modalQI += BSS_B2B.qiTranslations.general_message_text;
            modalQI += ": </span>";
            modalQI += "<ol class='bss-qi-list-product-warning-qty' style='display: none'>\n";
            modalQI += `<div class="bss-b2b-translation-qi-general_message_text">${BSS_B2B.qiTranslations.general_message_text}: </div>`; +
                "</ol>\n";
            modalQI += "<ol class='bss-qi-list-item-warning-qty'>\n" +
                "</ol>\n" +
                "</div>\n" +
                "<div class='bss-qi-group-warning'>\n" +
                "</div>\n" +
                "</div>\n" +
                "</div>\n" +
                "</div>\n" +
                "</div>\n" +
                "<div class='bss-qi-modal-bg active'></div>\n" +
                "</div>\n" +
                "</div>\n" +
                "</div>";
            $('body').append(modalQI);
        }
    };

    BSS_B2B.qi.renderModalWarning();

    BSS_B2B.qi.getAppliedRulesForCartItems = function (productMap) {
        let ruleList = BSS_B2B.qiRules;
        ruleList.sort((a, b) => {
            return a.priority - b.priority;
        });
        let customer = shopData.customer;
        let invalidIncrementProductMapKey = new Map();
        let invalidIncrementProductMapId = new Map();
        let validIncrementProductMapKey = new Map();
        let validIncrementProductMapId = new Map();
        let appliedQiRules = new Map();
        let totalInvalidIncrementProductGroupMapKey = new Map();
        let totalInvalidIncrementProductGroup = new Map();


        ruleList.forEach(function (rule) {
            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let customerTagsInRule = rule.customer_tags;
            let excludeCustomerTags = rule.exc_customer_tags;
            let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let exc_customers = rule.exc_customers;

            if (excludeFrom === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase())
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag));
                    if (checkArray.length > 0) {
                        return
                    }
                }
            }
            else if (excludeFrom === 2) {
                if (exc_customers) {
                    if (exc_customers.includes(`${customer.id}`)) {
                        return
                    }
                }
            }

            if (applyTo === 1) {
                if (customer.id == null) {
                    return;
                }
            } else if (applyTo === 2) {
                if (customer.id !== null) {
                    return;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return;
                    }
                }
            } else if (applyTo === 4) {
                if (customer.tags == null) {
                    return;
                } else {
                    customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase())
                    let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag));
                    if (checkArray.length === 0) {
                        return
                    }
                }
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(",").map(tag => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            let specificVariantIds = rule.product_variants ? rule.product_variants.split(",") : [];
            let incrementRuleType = rule.qty_increment_type;
            let totalGroupQty = 0;
            let invalidIncrementProductGroupMapKey = new Map();

            let productMapQuantity = new Map();
            productMap.forEach(function (item) {
                if (productMapQuantity.get(item.id)) {
                    let currentQty = productMapQuantity.get(item.id);
                    productMapQuantity.set(item.id, currentQty + item.qty);
                } else {
                    productMapQuantity.set(item.id, item.qty);
                }
            });

            productMap.forEach(function (item) {
                if ((invalidIncrementProductMapId.get(item.id) && invalidIncrementProductMapKey.get(item.key)) ||
                    validIncrementProductMapKey.get(item.key) ||
                    totalInvalidIncrementProductGroupMapKey.get(item.key)
                ) {
                    return;
                }

                let collections = item.collections;
                let tags = item.tags.map((tag) => tag.toLowerCase());
                let productId = item.id;
                let variantId = item.variant_id;
                let appliedQiRule = false;
                if (conditionType === 0) {
                    appliedQiRule = rule;
                } else if (conditionType === 1) {
                    if (specificProductIds.indexOf(productId + "") !== -1) {
                        appliedQiRule = rule;
                    }
                } else if (conditionType === 2) {
                    let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                    if (checkArray.length > 0) {
                        appliedQiRule = rule;
                    }
                } else if (conditionType === 3) {
                    let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                    if (checkArray.length > 0) {
                        appliedQiRule = rule
                    }
                } else if (conditionType === 4) {
                    if (specificVariantIds.indexOf(variantId + "") !== -1) {
                        appliedQiRule = rule;
                    }
                }
                if (appliedQiRule) {
                    appliedQiRules.set(item.key, appliedQiRule);
                    let variantQty = item.qty;
                    let qtyIncrement = rule.qty_increment;
                    let qtyIncrementMax = rule.qty_increment_max ? rule.qty_increment_max : 999999999999;
                    let qtyIncrementMin = rule.qty_increment_min ? rule.qty_increment_min : 0;
                    if (appliedQiRule.qty_increment_type === 2) {
                        invalidIncrementProductGroupMapKey.set(
                            item.key, {
                            id: item.id,
                            key: item.key,
                            qty: item.qty,
                            title: item.title,
                            product_title: item.product_title,
                            increment: qtyIncrement,
                            increment_max: qtyIncrementMax,
                            increment_min: qtyIncrementMin
                        }
                        );
                        totalInvalidIncrementProductGroupMapKey.set(
                            item.key, {
                            id: item.id,
                            key: item.key,
                            qty: item.qty,
                            title: item.title,
                            product_title: item.product_title,
                            increment: qtyIncrement,
                            increment_max: qtyIncrementMax,
                            increment_min: qtyIncrementMin
                        }
                        );


                        totalGroupQty += item.qty;
                        let isValidIncrement = false;
                        if (totalGroupQty % qtyIncrement === 0) {
                            isValidIncrement = true
                        }
                        totalInvalidIncrementProductGroup.set(
                            appliedQiRule.id, {
                            isValidIncrement: isValidIncrement,
                            incrementRule: appliedQiRule,
                            totalGroupQty: totalGroupQty,
                            groupItem: invalidIncrementProductGroupMapKey,
                            increment: appliedQiRule.qty_increment,
                            increment_max: qtyIncrementMax,
                            increment_min: qtyIncrementMin,
                        });

                    } else {
                        let itemQty = variantQty;
                        if (appliedQiRule.qty_increment_type === 1) {
                            // if rule option is quantity, then itemQty is product quantity, or else it still be separated variant quantity in this productMap.forEach
                            itemQty = productMapQuantity.get(item.id);
                        }
                        if (itemQty % qtyIncrement === 0 && itemQty >= qtyIncrementMin && itemQty <= qtyIncrementMax) {
                            validIncrementProductMapKey.set(
                                item.key, {
                                id: item.id,
                                key: item.key,
                                qty: item.qty,
                                title: item.title,
                                product_title: item.product_title,
                                increment: qtyIncrement,
                                increment_max: qtyIncrementMax,
                                increment_min: qtyIncrementMin,
                            });
                            validIncrementProductMapId.set(
                                item.id, {
                                id: item.id,
                                key: item.key,
                                qty: item.qty,
                                title: item.title,
                                product_title: item.product_title,
                                increment: qtyIncrement,
                                increment_max: qtyIncrementMax,
                                increment_min: qtyIncrementMin,
                            });
                        } else {
                            // if product variant
                            if ((invalidIncrementProductMapId.get(item.id) && incrementRuleType === 1) || (validIncrementProductMapId.get(item.id) && incrementRuleType === 1)) {
                                let preQty = 0;
                                if (invalidIncrementProductMapId.get(item.id)) {
                                    preQty = invalidIncrementProductMapId.get(item.id).qty;
                                } else if (validIncrementProductMapId.get(item.id)) {
                                    preQty = validIncrementProductMapId.get(item.id).qty;
                                }
                                let thisQty = item.qty;
                                let totalQty = parseInt(thisQty + preQty);
                                invalidIncrementProductMapId.set(
                                    item.id, {
                                    id: item.id,
                                    key: item.key,
                                    qty: totalQty,
                                    title: item.title,
                                    product_title: item.product_title,
                                    increment: qtyIncrement,
                                    increment_max: qtyIncrementMax,
                                    increment_min: qtyIncrementMin,
                                    isVariantRule: true
                                }
                                );

                                invalidIncrementProductMapKey.set(
                                    item.key, {
                                    id: item.id,
                                    key: item.key,
                                    qty: item.qty,
                                    title: item.title,
                                    product_title: item.product_title,
                                    increment: qtyIncrement,
                                    increment_max: qtyIncrementMax,
                                    increment_min: qtyIncrementMin,
                                    isVariantRule: true
                                }
                                );

                            } else {
                                invalidIncrementProductMapId.set(
                                    item.id, {
                                    id: item.id,
                                    key: item.key,
                                    qty: item.qty,
                                    title: item.title,
                                    product_title: item.product_title,
                                    increment: qtyIncrement,
                                    increment_max: qtyIncrementMax,
                                    increment_min: qtyIncrementMin,
                                    isVariantRule: false
                                }
                                );

                                invalidIncrementProductMapKey.set(
                                    item.key, {
                                    id: item.id,
                                    key: item.key,
                                    qty: item.qty,
                                    title: item.title,
                                    product_title: item.product_title,
                                    increment: qtyIncrement,
                                    increment_max: qtyIncrementMax,
                                    increment_min: qtyIncrementMin,
                                    isVariantRule: false
                                }
                                );
                            }
                        }
                    }
                }
            })
        });

        return {
            invalidIncrementProductMapKey: invalidIncrementProductMapKey,
            invalidIncrementProductMapId: invalidIncrementProductMapId,
            totalInvalidIncrementProductGroup: totalInvalidIncrementProductGroup,
            appliedQiRules: appliedQiRules,
        };
    };

    BSS_B2B.qi.getAppliedRulesForBuyItNowItem = function (item) {
        let ruleList = BSS_B2B.qiRules;
        ruleList.sort((a, b) => {
            return a.priority - b.priority;
        });
        let customer = shopData.customer;
        let appliedQiRule = false;
        ruleList.every(function (rule) {
            let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
            let excludeCustomerTags = rule.exc_customer_tags;
            let exc_customers = rule.exc_customers;

            if (excludeFrom === 1) {
                if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                    excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase());
                    let checkArray = excludeCustomerTags.filter(tag => customerTags.includes(tag));
                    if (checkArray.length > 0) {
                        return true;
                    }
                }
            } else if (excludeFrom === 2) {
                if (exc_customers) {
                    if (exc_customers.includes(`${customer.id}`)) {
                        return true
                    }
                }
            }

            let applyTo = rule.apply_to;
            let customerIds = rule.customer_ids;
            let customerTagsInRule = rule.customer_tags;

            // if (applyTo == 0) {
            //
            // } else
            if (applyTo === 1) {
                if (customer.id == null) {
                    return true;
                }
            } else if (applyTo === 2) {
                if (customer.id !== null) {
                    return true;
                }
            } else if (applyTo === 3) {
                if (customer.id == null) {
                    return true;
                } else {
                    customerIds = customerIds.split(',');
                    if (customerIds.indexOf(customer.id + "") === -1) {
                        return true;
                    }
                }
            } else if (applyTo === 4) {
                if (customer.tags == null) {
                    return true;
                } else {
                    customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                    let customerTags = customer.tags.map(tag => tag.toLowerCase());
                    let checkArray = customerTagsInRule.filter(tag => customerTags.includes(tag));
                    if (checkArray.length === 0) {
                        return true;
                    }
                }
            }

            let conditionType = rule.product_condition_type;
            let ruleTags = rule.product_tags ? rule.product_tags.split(",").map(tag => tag.toLowerCase()) : [];
            let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
            let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];
            let specificVariantIds = rule.product_variants ? rule.product_variants.split(",") : [];
            let collections = item.collections;
            let tags = item.tags.map(tag => tag.toLowerCase());
            let productId = item.id;
            let variantSelector = $('form[action*="/cart/add"]').find('select[name="id"], input[name="id"], select[data-variant-input], .option-lists');
            let variantId = variantSelector ? variantSelector.val() || variantSelector.attr('value') : null;
            if (conditionType === 0) {
                appliedQiRule = rule;
            } else if (conditionType === 1) {
                if (specificProductIds.indexOf(productId + "") !== -1) {
                    appliedQiRule = rule;
                }
            } else if (conditionType === 2) {
                let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                if (checkArray.length > 0) {
                    appliedQiRule = rule;
                }
            } else if (conditionType === 3) {
                let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
                if (checkArray.length > 0) {
                    appliedQiRule = rule
                }
            } else if (conditionType === 4) {
                if (specificVariantIds.indexOf(variantId + "") !== -1) {
                    appliedQiRule = rule;
                }
            }

            if (appliedQiRule) {
                return false;
            } else {
                return true;
            }
        });

        return appliedQiRule;
    };

    BSS_B2B.qi.validateQIBuyItNow = function (product, quantity) {
        let appliedQiRule = BSS_B2B.qi.getAppliedRulesForBuyItNowItem(product);
        if (appliedQiRule) {
            const INVALID_INCREMENT = "INVALID_INCREMENT";
            const INVALID_INCREMENT_MAX = "INVALID_INCREMENT_MAX";
            const INVALID_INCREMENT_MIN = "INVALID_INCREMENT_MIN";

            let invalidIncrementRule = false;

            let qtyIncrement = appliedQiRule.qty_increment;
            let qtyIncrementMax = appliedQiRule.qty_increment_max;
            let qtyIncrementMin = appliedQiRule.qty_increment_min;

            if (quantity % qtyIncrement === 0) {
                if (qtyIncrementMin != null && quantity < qtyIncrementMin) {
                    invalidIncrementRule = INVALID_INCREMENT_MIN;
                }
                if (qtyIncrementMax != null && quantity > qtyIncrementMax) {
                    invalidIncrementRule = INVALID_INCREMENT_MAX;
                }
            } else {
                invalidIncrementRule = INVALID_INCREMENT;
            }

            BSS_B2B.qi.invalidIncrementProducts = {
                isInvalid: invalidIncrementRule,
                rule: appliedQiRule,
                item: product
            }
        }
    };

    BSS_B2B.qi.validateQtyIncrement = function (newCartData = false) {
        try {
            let cartData = shopData.cart;
            if (newCartData) {
                cartData = newCartData;
            }
            if (cartData.items && cartData.items.length > 0) {
                let handleURLs = [];
                let handles = [];
                let keyIdMap = new Map();
                let cartItemProductMap = new Map();
                let cartItemProductMapByKey = [];
                cartData.items.forEach(function (item) {
                    let proId = item.product_id;
                    if (handles.indexOf(proId) === -1) {
                        handles.push(proId);
                        handleURLs.push('id:"' + proId + '"');
                        keyIdMap.set(proId, []);
                    }
                    let productItemKeys = keyIdMap.get(proId);
                    productItemKeys.push(item.key);
                    keyIdMap.set(proId, productItemKeys);

                    let productVariants = cartItemProductMap.get(proId);
                    if (!productVariants || productVariants === undefined) {
                        cartItemProductMap.set(proId, []);
                        productVariants = [];
                    }

                    productVariants.push({
                        key: item.key,
                        quantity: item.quantity,
                        id: item.variant_id,
                        price: item.price
                    });
                    cartItemProductMap.set(proId, productVariants);
                    cartItemProductMapByKey.push({
                        key: item.key,
                        quantity: item.quantity,
                        title: item.title,
                        product_title: item.product_title,
                        variant_id: item.variant_id
                    })
                });
                let urlData = '/search?q=' + handleURLs.join(' OR ') + '&view=bss.b2b';
                let encodeUrlData = encodeURI(urlData);
                $.get(encodeUrlData, function (data) {
                    let responseProducts = [];
                    try {
                        responseProducts = JSON.parse(data);
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.log('JSON parse returns no item')
                    }

                    if (responseProducts.length > 0) {
                        let productMap = [];
                        let checkUnique = [];
                        for (let i = 0; i < responseProducts.length; i++) {
                            let pro = responseProducts[i];

                            if (checkUnique.indexOf(pro.id) === -1) {
                                checkUnique.push(pro.id);
                                keyIdMap.get(pro.id).forEach(function (key) {
                                    productMap.push({
                                        id: pro.id,
                                        tags: pro.tags,
                                        collections: pro.collections,
                                        key: key
                                    });
                                })
                            }
                        }
                        productMap.forEach(function (value) {
                            cartItemProductMapByKey.forEach(item => {
                                if (item.key === value.key) {
                                    value.qty = item.quantity;
                                    value.title = item.title;
                                    value.product_title = item.product_title;
                                    value.variant_id = item.variant_id;
                                }
                            })
                        });

                        let result = BSS_B2B.qi.getAppliedRulesForCartItems(productMap);
                        let resultMapKey = result.invalidIncrementProductMapKey;
                        let resultMapId = result.invalidIncrementProductMapId;
                        let resultMapGroupKey = result.totalInvalidIncrementProductGroup;
                        let resultInvalidGroupIncrement = [];
                        let variantRule = new Map();
                        const appliedQiRules = result.appliedQiRules;

                        if (window.location.pathname === "/cart") {
                            if ([10090].indexOf(BSS_B2B.storeId) !== -1) {
                                BSS_B2B.qi.showNotifyMessageCartPage(appliedQiRules);
                            }
                        }

                        const INVALID_INCREMENT = "INVALID_INCREMENT";
                        const INVALID_INCREMENT_MAX = "INVALID_INCREMENT_MAX";
                        const INVALID_INCREMENT_MIN = "INVALID_INCREMENT_MIN";

                        resultMapGroupKey.forEach(item => {
                            let invalidIncrementRule = INVALID_INCREMENT;
                            if (item.totalGroupQty % item.increment === 0) {
                                if (item.totalGroupQty > item.increment_max) {
                                    invalidIncrementRule = INVALID_INCREMENT_MAX;
                                }
                                if (item.totalGroupQty < item.increment_min) {
                                    invalidIncrementRule = INVALID_INCREMENT_MIN;
                                }
                            }

                            if (!item.isValidIncrement || (item.isValidIncrement && invalidIncrementRule !== INVALID_INCREMENT)) {
                                if (item.totalGroupQty === productMap.size) {
                                    resultInvalidGroupIncrement.push({
                                        totalGroupQty: item.totalGroupQty,
                                        increment: item.increment,
                                        increment_max: item.increment_max,
                                        increment_min: item.increment_min,
                                        productList: [],
                                        totalOrder: true,
                                        invalidIncrementRule: invalidIncrementRule
                                    });
                                } else {
                                    let productList = [];
                                    item.groupItem.forEach(itemProduct => {
                                        productList.push(itemProduct.title);
                                    });
                                    resultInvalidGroupIncrement.push({
                                        totalGroupQty: item.totalGroupQty,
                                        qty_increment: item.incrementRule.qty_increment,
                                        productList: productList,
                                        totalOrder: false,
                                        increment: item.increment,
                                        increment_max: item.increment_max,
                                        increment_min: item.increment_min,
                                        invalidIncrementRule: invalidIncrementRule
                                    });
                                }
                            }
                        });

                        resultMapId.forEach(item => {
                            if (item.isVariantRule) {
                                if (item.qty === item.increment) {
                                    variantRule.set(
                                        item.id, {
                                        id: item.id,
                                        key: item.key,
                                        qty: item.qty,
                                        title: item.title,
                                        product_title: item.product_title,
                                        increment: item.increment,
                                        increment_max: item.increment_max,
                                        increment_min: item.increment_min,
                                        isValidVariantQty: true
                                    }
                                    );
                                } else {
                                    variantRule.set(
                                        item.id, {
                                        id: item.id,
                                        key: item.key,
                                        qty: item.qty,
                                        title: item.title,
                                        product_title: item.product_title,
                                        increment: item.increment,
                                        increment_max: item.increment_max,
                                        increment_min: item.increment_min,
                                        isValidVariantQty: false
                                    }
                                    );
                                }

                            }
                        });

                        let resultMap = new Map();
                        if (resultMapKey.size) {
                            resultMapKey.forEach(item => {
                                let invalidIncrementRule = INVALID_INCREMENT;
                                if (item.qty % item.increment === 0) {
                                    if (item.qty > item.increment_max) {
                                        invalidIncrementRule = INVALID_INCREMENT_MAX;
                                    }
                                    if (item.qty < item.increment_min) {
                                        invalidIncrementRule = INVALID_INCREMENT_MIN;
                                    }
                                }

                                if (variantRule.size) {
                                    variantRule.forEach(variantItem => {
                                        if (variantItem.id == item.id) {
                                            if (variantItem.isValidVariantQty) {
                                                resultMap.delete(item.id)
                                            } else {
                                                if (variantItem.qty % variantItem.increment === 0) {
                                                    if (variantItem.qty > variantItem.increment_max) {
                                                        invalidIncrementRule = INVALID_INCREMENT_MAX;
                                                    }
                                                    if (variantItem.qty < variantItem.increment_min) {
                                                        invalidIncrementRule = INVALID_INCREMENT_MIN;
                                                    }
                                                }
                                                resultMap.set(
                                                    item.id, {
                                                    id: item.id,
                                                    key: item.key,
                                                    qty: variantItem.qty,
                                                    title: item.title,
                                                    product_title: item.product_title,
                                                    increment: variantItem.increment,
                                                    increment_max: variantItem.increment_max,
                                                    increment_min: variantItem.increment_min,
                                                    isVariantRule: true,
                                                    invalidIncrementRule: invalidIncrementRule
                                                }
                                                )
                                            }
                                        } else {
                                            resultMap.set(
                                                item.id, {
                                                id: item.id,
                                                key: item.key,
                                                qty: item.qty,
                                                title: item.title,
                                                product_title: item.product_title,
                                                increment: item.increment,
                                                increment_max: item.increment_max,
                                                increment_min: item.increment_min,
                                                isVariantRule: false,
                                                invalidIncrementRule
                                            }
                                            )
                                        }
                                    })
                                } else {
                                    resultMap.set(
                                        item.key, {
                                        id: item.id,
                                        key: item.key,
                                        qty: item.qty,
                                        title: item.title,
                                        product_title: item.product_title,
                                        increment: item.increment,
                                        increment_max: item.increment_max,
                                        increment_min: item.increment_min,
                                        isVariantRule: false,
                                        invalidIncrementRule
                                    }
                                    )
                                }
                            });
                        }
                        let invalidIncrementData = false;
                        if (resultInvalidGroupIncrement.length || resultMap.size) {
                            invalidIncrementData = {
                                invalidGroup: resultInvalidGroupIncrement,
                                invalidProductMap: resultMap
                            }
                        }
                        BSS_B2B.qi.invalidIncrementProducts = invalidIncrementData;
                        const excludeStores = [3588];
                        if (excludeStores.indexOf(BSS_B2B.storeId) === -1) {
                            BSS_B2B.handleCartCheckoutBtn(shopData);
                        }
                        // Create event check after done QI
                        let event = new Event("bss.b2b.qi.doneCheckQIByBSS");
                        document.dispatchEvent(event);
                        BSS_B2B.cart.reRenderQtyTable();
                    }

                    if (!(isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0))) {
                        $(BSS_B2B.cart.removeButtons).on("click", function () {
                            BSS_B2B.cart.cartQtyOnChange(1200, 2000, true)
                        })
                    }
                })
            } else {
                // eslint-disable-next-line no-console
                console.log("Could not get cart data")
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("Could not get shop data");
        }
    };

    BSS_B2B.qi.renderWarningMessage = function (invalidProductIncrementData) {
        $(".bss-qi-group-warning").html('');
        $(".bss-qi-list-product-warning-qty").html('');
        $(".bss-qi-list-warning").hide();

        let invalidProductIncrement = invalidProductIncrementData.invalidProductMap;
        let invalidGroupIncrement = invalidProductIncrementData.invalidGroup;

        invalidProductIncrement.forEach(item => {
            $(".bss-qi-list-warning").show();
            let message = '';
            let messageHtml = '';
            let afterFix = ''

            if (item.increment_min > 0 && item.increment_max < 999999999999) {
                afterFix = `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${item.increment_min}`
                + `, <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${item.increment_max}`
            } else if (item.increment_max < 999999999999) {
                afterFix = ` <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${item.increment_max}`
            } else if (item.increment_min > 0) {
                if([8603].includes(BSS_B2B.storeId) !== -1) {
                    afterFix = "<br><span>There are not enough units in stock to fulfill this quantity.</span>"
                }
                else {
                    afterFix = `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${item.increment_min}`
                }
            }
        
            if (item.isVariantRule) {
                message = `"${item.product_title}" <span class="bss-b2b-translation-qi-product_message_text">${BSS_B2B.qiTranslations.product_message_text}</span> ${item.increment}`;
                // fix for lakeside-clothing-online by mitri
                if (BSS_B2B.storeId === 5153) {
                    message = `"${item.product_title}" <span class="bss-b2b-translation-qi-product_message_text">${BSS_B2B.qiTranslations.product_message_text}</span>`;
                }
            }
            if (!item.isVariantRule) {
                message = `"${item.title}" <span class="bss-b2b-translation-qi-product_message_text">${BSS_B2B.qiTranslations.product_message_text}</span> ${item.increment}`;
                // fix for lakeside-clothing-online by mitri
                if (BSS_B2B.storeId === 5153) {
                    message = `"${item.product_title}" <span class="bss-b2b-translation-qi-product_message_text">${BSS_B2B.qiTranslations.product_message_text}</span>`;
                }
                if (BSS_B2B.storeId === 8603) {
                    message = `"${item.title}" <span class="bss-b2b-translation-qi-product_message_text">${BSS_B2B.qiTranslations.product_message_text} ${item.increment}</span>`;
                }
            }
            messageHtml = `<li class='bss-qi-text-warning'  style='display: block'> ${message}${afterFix}</li>`;

            $(".bss-qi-list-product-warning-qty").prepend(messageHtml);
            $(".bss-qi-list-product-warning-qty").show();
        });

        invalidGroupIncrement.forEach(item => {
            let message = '';
            let messageHtml = '';
            let afterFix = '';

            if (item.increment_min > 0 && item.increment_max < 999999999999) {
                afterFix = `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${item.increment_min}`
                    + `, <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${item.increment_max}`;
            } else if (item.increment_max < 999999999999) {
                afterFix = ` <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${item.increment_max}`;
            } else if (item.increment_min > 0) {
                afterFix = `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${item.increment_min}`;
            }
        
            if (item.totalOrder) {
                message = `${BSS_B2B.qiTranslations.order_total_message_text} ${item.qty_increment}`;
                messageHtml = `<li class='bss-qi-text-warning'  style='display: block'> `
                    + `<span class="bss-b2b-translation-qi-order_total_message_text">${message}</span>${afterFix}</li>`;
            }
            if (!item.totalOrder) {
                messageHtml = "<ol class='bss-qi-list-group-warning-quantity'>\n";
                messageHtml += `<br/><div class='bss-qi-error-text'><span class="bss-b2b-translation-qi-group_total_message_text">${BSS_B2B.qiTranslations.group_total_message_text}</span> <span class="bss-qi-quantity-text">${item.qty_increment}</span> <span class="bss-qi-quantity-text-afterFix">${afterFix}:</span> </div>`;
                item.productList.map(item => {
                    messageHtml += `<li class='bss-qi-text-warning'  style='display: block'> ${item} </li>`;
                });

                messageHtml += "</ol>\n";
            }
            messageHtml += "<br/>";
            $(".bss-qi-group-warning").prepend(messageHtml);
        });

        $('.modalWarningQI').show();
        $('.bss-modal-button-close').on('click', function () {
            $('.modalWarningQI').hide();
            window.BSS_B2B.executeAction({tag: "handle_ui_checkout", storeId: 13495});
            BSS_B2B.integrate.langShop.translatedModules.qi = false;
        });

        BSS_B2B.integrate.langShop.handleAllTranslation('qi');
        BSS_B2B.handleCartCheckoutBtn(shopData);
    };

    BSS_B2B.qi.renderWarningMessageBuyItNow = function (invalidProductIncrementData) {
        $(".bss-qi-group-warning").html('');
        $(".bss-qi-list-product-warning-qty").html('');
        $(".bss-qi-list-warning").hide();

        $(".bss-qi-list-warning").show();

        let { rule ,item } = invalidProductIncrementData;
        let message = `"${item.title}" ${BSS_B2B.qiTranslations.product_message_text} ${rule.qty_increment}`;
        let messageHtml = '';
        let afterFix = '';
    
        if (rule.qty_increment_min && rule.qty_increment_max) {
             afterFix =  `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${rule.qty_increment_min}` +
            `, <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${rule.qty_increment_max}`;
        } else if (rule.qty_increment_min) {
            afterFix = `, <span class="bss-b2b-translation-qi-validate_min_message_text">${BSS_B2B.qiTranslations.validate_min_message_text}</span> ${rule.qty_increment_min}`;
        } else if (rule.qty_increment_max) {
            afterFix = ` <span class="bss-b2b-translation-qi-validate_max_message_text">${BSS_B2B.qiTranslations.validate_max_message_text}</span> ${rule.qty_increment_max}`;
        }
        
        
        messageHtml = `<li class='bss-qi-text-warning'  style='display: block'> ${message}${afterFix}</li>`;

        $(".bss-qi-list-product-warning-qty").prepend(messageHtml);
        $(".bss-qi-list-product-warning-qty").show();

        $('.modalWarningQI').show();
        $('.bss-modal-button-close').on('click', function () {
            $('.modalWarningQI').hide();
            BSS_B2B.integrate.langShop.translatedModules.qi = false;
        })

        BSS_B2B.integrate.langShop.handleAllTranslation('qi')
    }

    BSS_B2B.qi.handleAddToCart = function (element, currentQtyValue, realQtyValue, defaultQuantityValue) {
        let item = shopData.product;
        if (shopData.collections) {
            item.collections = shopData.collections;
        }
        let quantityMinusElement = getQuantityMinusElement();
        let quantityPlusElement = getQuantityPlusElement();
        let quantityInputElement = getQuantityInputElement();
        let appliedQiRule = BSS_B2B.qi.getAppliedRulesForBuyItNowItem(item);
        let quantity = currentQtyValue ? currentQtyValue : parseInt(quantityInputElement.value);
        realQtyValue = parseInt(realQtyValue);
        let afterChangeQtyValue = 0;

        if (appliedQiRule) {
            const INVALID_INCREMENT = "INVALID_INCREMENT";
            const INVALID_INCREMENT_MAX = "INVALID_INCREMENT_MAX";
            const INVALID_INCREMENT_MIN = "INVALID_INCREMENT_MIN";
            const INVALID_ACTION = "INVALID_ACTION";

            let invalidIncrementRule = false;
            let invalidAction = false;

            let qtyIncrement = appliedQiRule.qty_increment;
            let qtyIncrementMax = appliedQiRule.qty_increment_max;
            let qtyIncrementMin = appliedQiRule.qty_increment_min;

            if (qtyIncrementMin != null && qtyIncrementMax == null) {
                if (element == quantityMinusElement && realQtyValue < defaultQuantityValue) {
                    invalidAction = INVALID_ACTION;
                }
            }

            if (qtyIncrementMax != null && qtyIncrementMin == null) {
                if (element == quantityMinusElement && realQtyValue < qtyIncrement) {
                    invalidAction = INVALID_ACTION;
                }
                if (element == quantityPlusElement) {
                    afterChangeQtyValue = closestGreaterThanMin(qtyIncrement, qtyIncrementMin, quantity);
                    if (realQtyValue === defaultQuantityValue) {
                        invalidAction = false;
                    } else if (realQtyValue > defaultQuantityValue) {
                        invalidAction = INVALID_ACTION;
                    } else if (afterChangeQtyValue > qtyIncrementMax) {
                        invalidAction = INVALID_ACTION;
                    }
                }
            }

            if (qtyIncrementMax != null && qtyIncrementMin != null) {
                if (element == quantityMinusElement && realQtyValue < defaultQuantityValue) {
                    invalidAction = INVALID_ACTION;
                }
                if (element == quantityPlusElement) {
                    afterChangeQtyValue = closestGreaterThanMin(qtyIncrement, qtyIncrementMin, quantity);
                    if (realQtyValue > qtyIncrementMax) {
                        invalidAction = INVALID_ACTION;
                    } else if (afterChangeQtyValue > qtyIncrementMax) {
                        invalidAction = INVALID_ACTION;
                    }
                }
            }

            if (qtyIncrementMin == null && qtyIncrementMax == null && realQtyValue < qtyIncrement) {
                invalidAction = INVALID_ACTION;
            }

            if (quantity % qtyIncrement === 0) {
                if (qtyIncrementMin != null && quantity < qtyIncrementMin) {
                    invalidIncrementRule = INVALID_INCREMENT_MIN;
                }
                if (qtyIncrementMax != null && quantity > qtyIncrementMax) {
                    invalidIncrementRule = INVALID_INCREMENT_MAX;
                }
            } else {
                invalidIncrementRule = INVALID_INCREMENT;
            }

            if (invalidAction === false && invalidIncrementRule && (element == quantityMinusElement || element == quantityPlusElement)) {
                invalidIncrementRule = false;
            }

            BSS_B2B.qi.invalidIncrementProducts = {
                isInvalid: invalidIncrementRule,
                currentValue: quantity,
                isActionInvalid: invalidAction
            }

            let qiMsgElement = document.querySelector('#qiNotifyMessageBSS');
            BSS_B2B.qi.showNotifyMessage(invalidIncrementRule, invalidAction);
            if (qiMsgElement) {
                if (invalidIncrementRule !== false || invalidAction !== false) {
                    qiMsgElement.style.color = "red";
                } else {
                    qiMsgElement.style.color = "unset";
                }
            }
        }
    }

    BSS_B2B.qi.showNotifyMessage = function (invalidIncrementRule, invalidAction) {
        if (!shopData || !shopData.product) return;
        let item = shopData.product;
        if (shopData.collections) {
            item.collections = shopData.collections;
        }
        let appliedQiRule = BSS_B2B.qi.getAppliedRulesForBuyItNowItem(item);
        if (!appliedQiRule) {
            const qiMsgElement = document.querySelector('#qiNotifyMessageBSS');
            if (qiMsgElement) {
                qiMsgElement.remove();
            }
            return;
        }

        const { need_product_text, less_product_text, greater_product_text, and_product_text, not_satisfied_text } = BSS_B2B.qiTranslations;

        let lessMsg = '';
        let greaterMsg = '';
        let qiProductMsg = '<div id="qiNotifyMessageBSS">';
        let needMsg = `<div id="needProductBSS">${need_product_text}<span> ${appliedQiRule.qty_increment}</span>`;
        let warningMsg = `<div id="notSatisfiedProduct" style="color: red">(*) ${not_satisfied_text}</div>`

        if (appliedQiRule.qty_increment_max && appliedQiRule.qty_increment_max > 0) {
            lessMsg = `<span id="lessProductBSS"> ${less_product_text}<span> ${appliedQiRule.qty_increment_max}</span></span>`;
        }
        if (appliedQiRule.qty_increment_min && appliedQiRule.qty_increment_min > 0) {
            greaterMsg = `<span id="greaterProductBSS"> ${greater_product_text}<span> ${appliedQiRule.qty_increment_min}</span></span>`;
        }
        if (greaterMsg && lessMsg) {
            if (BSS_B2B.storeId === 14081) {
                needMsg = needMsg + '.' + greaterMsg + and_product_text;
            } else {
                needMsg = needMsg + ',' + greaterMsg + ', ' + and_product_text + lessMsg;
            }
        } else if (greaterMsg || lessMsg) {
            needMsg = needMsg + ', ' + and_product_text + greaterMsg + lessMsg;
        }
        let qiErrorMessage = document.querySelector("#qiNotifyMessageBSS");
        let quantityElement = getQuantityElement();
        if(BSS_B2B.storeId === 15196) {
            quantityElement = document.querySelector("div.product-selector__quantity");
        }
        if(BSS_B2B.storeId === 15972) {
            quantityElement = document.querySelector("div.product-summary__action");
        }
        if (BSS_B2B.qiSettings.display_notify_message === 1) {
            qiProductMsg = qiProductMsg + needMsg + "</div></div>";
            if (BSS_B2B.qiSettings.popup_position === 0) {
                if (quantityElement) {
                    if (qiErrorMessage) {
                        qiErrorMessage.innerHTML = qiProductMsg;
                    } else {
                        quantityElement.insertAdjacentHTML('beforeend', qiProductMsg);
                    }
                }
            } else if (BSS_B2B.qiSettings.popup_position === 1) {
                let isTimeout = false;
                let paymentInterval = setInterval(() => {
                    let paymentBtn = getBuyNowButton();
                    if (paymentBtn) {
                        if (qiErrorMessage) {
                            qiErrorMessage.innerHTML = qiProductMsg;
                        } else {
                            paymentBtn.insertAdjacentHTML('afterend', qiProductMsg);
                            clearInterval(paymentInterval);
                            isTimeout = true;
                        }
                    }
                }, 500);
                setTimeout(() => {
                    if (!isTimeout) clearInterval(paymentInterval);
                }, 5000);
            }
        } else {
            qiProductMsg = qiProductMsg + warningMsg + "</div>";
            if (quantityElement && invalidIncrementRule) {
                if (invalidIncrementRule !== false && invalidIncrementRule !== null) {
                    if (qiErrorMessage) {
                        qiErrorMessage.innerHTML = qiProductMsg;
                    } else {
                        quantityElement.insertAdjacentHTML('beforeend', qiProductMsg);
                    }
                } else {
                    if (qiErrorMessage) {
                        qiErrorMessage.remove();
                    }
                }
            } else if (invalidAction) {
                if (qiErrorMessage) {
                    qiErrorMessage.innerHTML = qiProductMsg;
                } else {
                    quantityElement.insertAdjacentHTML('beforeend', qiProductMsg);
                }
            } else {
                if (qiErrorMessage) {
                    qiErrorMessage.remove();
                }
            }
        }
    };

    BSS_B2B.qi.showNotifyMessageCartPage = function (appliedQiRules) {
        if (!appliedQiRules || !appliedQiRules.size) return;
        if (document.querySelector('#qiNotifyCartMessageBSS')) return;
        const { need_product_text, less_product_text, greater_product_text, and_product_text } = BSS_B2B.qiTranslations;

        let lineItemInfoSelector = '.cart-items .product-name';

        appliedQiRules.forEach((rule, key) => {
            let lessMsg = '';
            let greaterMsg = '';
            let qiProductMsg = '<div id="qiNotifyCartMessageBSS">';
            let needMsg = `<div id="needProductBSS">${need_product_text}<span> ${rule.qty_increment}</span>`;

            if (rule.qty_increment_max && rule.qty_increment_max > 0) {
                lessMsg = `<span id="lessProductBSS"> ${less_product_text}<span> ${rule.qty_increment_max}</span></span>`;
            }
            if (rule.qty_increment_min && rule.qty_increment_min > 0) {
                greaterMsg = `<span id="greaterProductBSS"> ${greater_product_text}<span> ${rule.qty_increment_min}</span></span>`;
            }
            if (greaterMsg && lessMsg) {
                needMsg = needMsg + ',' + greaterMsg + ', ' + and_product_text + lessMsg;
            } else if (greaterMsg || lessMsg) {
                needMsg = needMsg + ', ' + and_product_text + greaterMsg + lessMsg;
            }
            qiProductMsg = qiProductMsg + needMsg + "</div></div>";

            let cartLineItemWrapper = document.querySelector(`[data-product-id="${key}"]`);
            if (cartLineItemWrapper) {
                let lineItemInfo = cartLineItemWrapper.querySelector(lineItemInfoSelector);
                if (lineItemInfo) {
                    lineItemInfo.insertAdjacentHTML('beforeend', qiProductMsg);
                }
            }
        });
    };

    BSS_B2B.qi.handleSetupQuantity = function () {
        let incQtyButton = $(BSS_B2B.buttonIncreaseQuantity);
        let decQtyButton = $(BSS_B2B.buttonDecreaseQuantity);
        incQtyButton.css("pointer-events", "unset");
        decQtyButton.css("pointer-events", "unset");
        let item = shopData.product;
        if (shopData.collections) {
            item.collections = shopData.collections;
        }
        let appliedQiRule = BSS_B2B.qi.getAppliedRulesForBuyItNowItem(item);
        let quantityInputElement = getQuantityInputElement();
        let quantityMinusElement = getQuantityMinusElement();
        let quantityPlusElement = getQuantityPlusElement();
        let currentQtyValue = parseInt(quantityInputElement.value) - 1;

        if (appliedQiRule) {
            let incrementType = appliedQiRule.qty_increment_type;
            let incrementQuantity = appliedQiRule.qty_increment;
            let minQuantity = appliedQiRule.qty_increment_min ? appliedQiRule.qty_increment_min : 0;
            let maxQuantity = appliedQiRule.qty_increment_max ? appliedQiRule.qty_increment_max : 0;
            let compareCase = maxQuantity - minQuantity;
            let newValue = incrementQuantity;
            let defaultQuantityValue = 0;

            if (incrementType === 0 && quantityInputElement) {
                switch (true) {
                    case compareCase < 0:
                        newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                        break;
                    case compareCase > 0:
                        if (minQuantity === 0) {
                            newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                        } else {
                            newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                        }
                        break;
                }
                quantityInputElement.value = newValue;
                defaultQuantityValue = newValue;
            }
            let trackQtyChange = 0;

            if (quantityInputElement) {
                if (quantityInputElement.value > 1) {
                    quantityMinusElement && quantityMinusElement.classList.remove("disabled");
                }

                quantityInputElement.addEventListener("change", function () {
                    trackQtyChange = parseInt(quantityInputElement.value);
                    if (trackQtyChange === 1) {
                        decQtyButton.css("pointer-events", "none");
                    } else {
                        decQtyButton.css("pointer-events", "auto");
                    }
                })
            }

            BSS_B2B.qi.handleAddToCart(quantityPlusElement, currentQtyValue, quantityInputElement.value, defaultQuantityValue);
            newValue = calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, "plus");
            quantityInputElement.value = newValue;

            if (incQtyButton && incQtyButton.length) {
                let events = $._data(incQtyButton[0], 'events');
                if (events && events.click && events.click.length > 0) {
                    incQtyButton.off('click');
                }
                if (!quantityInputElement) return;
                incQtyButton.on("click", function incQty() {
                    if(BSS_B2B.storeId === 14081) {
                        incQtyButton.addClass("bss-b2b-qi")
                    }
                    let isStore14915 = [14915, 14081].includes(BSS_B2B.storeId);
                    currentQtyValue = isStore14915 ? parseInt(quantityInputElement.value) : parseInt(quantityInputElement.value) - 1;
                    BSS_B2B.qi.handleAddToCart(quantityPlusElement, currentQtyValue, quantityInputElement.value, defaultQuantityValue);
                    newValue = calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, "plus");
                    quantityInputElement.value = isStore14915 ? newValue - 1 : newValue;
                })
            }

            if (decQtyButton && decQtyButton.length) {
                let events = $._data(decQtyButton[0], 'events');
                if (events && events.click && events.click.length > 0) {
                    decQtyButton.off('click');
                }
                if (!quantityInputElement) return;
                decQtyButton.on("click", function decQty() {
                    let isStore14915 = [14915, 14081].includes(BSS_B2B.storeId);
                    currentQtyValue = isStore14915 ? parseInt(quantityInputElement.value) : parseInt(quantityInputElement.value) + 1;
                    BSS_B2B.qi.handleAddToCart(quantityMinusElement, currentQtyValue, quantityInputElement.value, defaultQuantityValue);
                    newValue = calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, "minus");
                    quantityInputElement.value = isStore14915 ? newValue + 1 : newValue;
                })
            }
        } else {
            BSS_B2B.qi.showNotifyMessage(false, false)

            if (incQtyButton && incQtyButton.length) {
                let events = $._data(incQtyButton[0], 'events');
                if (events && events.click && events.click.length > 0) {
                    incQtyButton.off('click');
                }
            }
    
            if (decQtyButton && decQtyButton.length) {
                let events = $._data(decQtyButton[0], 'events');
                if (events && events.click && events.click.length > 0) {
                    decQtyButton.off('click');
                }
            }
        }
    };

    function calculateFinalQty(defaultQuantityValue, quantityPlusElement, quantityMinusElement, currentQtyValue, maxQuantity, minQuantity, incrementQuantity, compareCase, changeType) {
        let newValue = incrementQuantity;
        if (!maxQuantity && !minQuantity) {
            if (changeType === "plus") {
                if (currentQtyValue % incrementQuantity !== 0) {
                    newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
                } else {
                    newValue = currentQtyValue + incrementQuantity;
                }
            } else {
                if (currentQtyValue <= defaultQuantityValue) {
                    newValue = currentQtyValue;
                } else {
                    if (currentQtyValue % incrementQuantity !== 0) {
                        newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                    } else {
                        if (currentQtyValue / incrementQuantity === 1) {
                            newValue = incrementQuantity
                        } else {
                            newValue = currentQtyValue - incrementQuantity;
                        }
                    }
                }
            }
        } else {
            switch (true) {
                case compareCase < 0:
                    if (changeType === "plus") {
                        if (currentQtyValue < minQuantity) {
                            newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                        } else {
                            if (currentQtyValue % incrementQuantity !== 0) {
                                newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
                            } else {
                                newValue = currentQtyValue + incrementQuantity;
                            }
                        }
                    } else {
                        if (currentQtyValue <= defaultQuantityValue) {
                            newValue = currentQtyValue;
                        } else {
                            if (currentQtyValue % incrementQuantity !== 0) {
                                newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                            } else {
                                if (currentQtyValue / incrementQuantity === 1) {
                                    newValue = incrementQuantity
                                } else {
                                    newValue = currentQtyValue - incrementQuantity;
                                    if (newValue < minQuantity) {
                                        newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                                    }
                                }
                            }
                        }
                    }
                    break;
                case compareCase > 0:
                    if (minQuantity === 0) {
                        if (changeType === "plus") {
                            if (currentQtyValue >= defaultQuantityValue) {
                                newValue = currentQtyValue;
                            } else {
                                if (currentQtyValue % incrementQuantity !== 0) {
                                    newValue = closestGreaterOrEqualMultiple(incrementQuantity, currentQtyValue);
                                } else {
                                    newValue = currentQtyValue + incrementQuantity;
                                    if (newValue > maxQuantity) {
                                        newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                                    }
                                }
                            }
                        } else {
                            if (currentQtyValue > maxQuantity) {
                                newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                            } else {
                                if (currentQtyValue < incrementQuantity) {
                                    newValue = currentQtyValue;
                                } else {
                                    if (currentQtyValue % incrementQuantity !== 0) {
                                        newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                                    } else {
                                        if (currentQtyValue / incrementQuantity === 1) {
                                            newValue = incrementQuantity
                                        } else {
                                            newValue = currentQtyValue - incrementQuantity;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if (minQuantity < currentQtyValue && currentQtyValue < maxQuantity) {
                            if (changeType === "plus") {
                                if (currentQtyValue % incrementQuantity !== 0) {
                                    newValue = closestFitRangeInc(incrementQuantity, minQuantity, maxQuantity, currentQtyValue);
                                } else {
                                    newValue = currentQtyValue + incrementQuantity;
                                    if (newValue > maxQuantity) {
                                        newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                                    }
                                }
                            } else {
                                if (currentQtyValue % incrementQuantity !== 0) {
                                    newValue = closestLessOrEqualMultiple(incrementQuantity, currentQtyValue);
                                } else {
                                    if (currentQtyValue / incrementQuantity === 1) {
                                        newValue = incrementQuantity
                                    } else {
                                        newValue = currentQtyValue - incrementQuantity;
                                        if (newValue < minQuantity) {
                                            newValue = closestGreaterOrEqualMultiple(incrementQuantity, minQuantity);
                                        }
                                    }
                                }
                            }
                        } else if (currentQtyValue >= maxQuantity) {
                            if (changeType === "plus") {
                                newValue = currentQtyValue;
                            } else {
                                if (currentQtyValue === maxQuantity) {
                                    newValue = maxQuantity - incrementQuantity;
                                } else {
                                    newValue = closestLessOrEqualMultiple(incrementQuantity, maxQuantity);
                                }
                            }
                        } else if (currentQtyValue <= minQuantity) {
                            if (changeType === "plus") {
                                newValue = closestGreaterThanMin(incrementQuantity, minQuantity, currentQtyValue);
                            } else {
                                newValue = currentQtyValue;
                            }
                        }
                    }
                    break;
            }
        }

        if (newValue > 1) {
            quantityMinusElement.classList.remove("disabled");
        }

        return newValue;
    }

    function closestGreaterOrEqualMultiple(a, b) {
        return Math.ceil(b / a) * a;
    }

    function closestLessOrEqualMultiple(a, b) {
        return Math.floor(b / a) * a;
    }

    function closestGreaterThanMin(a, b, c) {
        let d = Math.ceil(b / a) * a;
        while (d <= c) {
            d += a;
        }
        return d;
    }

    function closestFitRangeInc(a, b, c, d) {
        let dMultiplier = Math.ceil(d / a);
        let closestD = dMultiplier * a;

        let bMultiplier = Math.ceil(b / a);
        let closestB = bMultiplier * a;

        let cMultiplier = Math.floor(c / a);
        let closestC = cMultiplier * a;

        let e = closestD;
        if (closestD < closestB) {
            e = closestB;
        } else if (closestD > closestC) {
            e = closestC;
        }

        return e;
    }
}

// EXTERNAL MODULE: ./js/src/bogo/bogo.js
var bogo = __webpack_require__(14);

// CONCATENATED MODULE: ./js/src/sr/init-sr.js
function initSr(shopData, isEnableSr) {
    BSS_B2B.sr = {};

    BSS_B2B.sr.getTotalPriceWhenClickBuyItNow = function (cpRule, qbRule, product, variant, quantity) {
        const currentVariant = product.variants.filter(item => item.id == variant)[0]
        let totalPrice = (currentVariant.price ) * quantity;
        let itemPrice = currentVariant.price ;
        let productPrice = currentVariant.price;
        if (cpRule.length) {
            if ((cpRule[0].discount_type === 0) && (parseFloat(cpRule[0].value * 100) < productPrice)) {
                totalPrice = cpRule[0].value * 100 * quantity;
                itemPrice = cpRule[0].value * 100;
            } else if (cpRule[0].discount_type === 1) {
                if (parseFloat(cpRule[0].value * 100) <= productPrice) {
                    totalPrice = (productPrice - cpRule[0].value * 100) * quantity;
                    itemPrice = productPrice - cpRule[0].value * 100;
                } else {
                    totalPrice = 0;
                    itemPrice = 0;
                }
            } else if (cpRule[0].discount_type === 2 && parseFloat(cpRule[0].value)) {
                totalPrice = productPrice * (1 - parseFloat(cpRule[0].value) / 100) * quantity;
                itemPrice = productPrice * (1 - parseFloat(cpRule[0].value) / 100)
            }
        }
        if (qbRule && qbRule.amount_table.length && qbRule.rule_setting === 1) {
            let newItemPrice = itemPrice;
            qbRule.amount_table.map(rule => {
                if (quantity !== 0 && quantity >= rule.amount_from && quantity <= rule.amount_to) {
                    if (rule.discount_type === 0 && parseFloat(rule.discount_value * 100) <= itemPrice) {
                        totalPrice = parseFloat(rule.discount_value * 100) * quantity;
                        newItemPrice = parseFloat(rule.discount_value * 100);
                    }
                    else if (rule.discount_type === 1 ) {
                        if (parseFloat(rule.discount_value * 100) <= newItemPrice) {
                            totalPrice = (itemPrice - parseFloat(rule.discount_value * 100)) * quantity;
                            newItemPrice = itemPrice - parseFloat(rule.discount_value * 100);
                        } else {
                            totalPrice = 0;
                            newItemPrice = 0;
                        }
                    }
                    else if (rule.discount_type === 2) {
                        totalPrice = itemPrice * (1 - parseFloat(rule.discount_value) / 100) * quantity;
                        newItemPrice = itemPrice * (1 - parseFloat(rule.discount_value) / 100);
                    }
                }
            })
        }
        if(qbRule && qbRule.qty_table.length && qbRule.rule_setting === 0) {
            const changeFixedPrice = (price, fixedPrice, qty) => {
                price = Number(price);
                if (Number(fixedPrice) < price) {
                    return Number(fixedPrice) * qty;
                } else {
                    return price * qty;
                }
            };
            const changeFixedAmount = (price, fixValue, qty) => {
                price = Number(price);
                if (Number(fixValue) < price) {
                    return (price - Number(fixValue)) * qty;
                } else {
                    return 0;
                }
            };
            const changeFixedPercent = (price, fixValue, qty) => {
                price = Number(price);
                return price*(1 - Number(fixValue)/100)*qty
            };
            if(quantity) {
                qbRule.qty_table.forEach((rule, index) => {
                    if (Number(rule.discount_type) === 0) {
                        if (quantity >= rule.qty_from) {
                            totalPrice = changeFixedPrice(itemPrice, rule.discount_value, quantity);
                        }
                        if (index == (qbRule.qty_table.length - 1) && rule.qty_to && (quantity > rule.qty_to)) {
                            totalPrice = itemPrice * quantity;
                        }
                    }
                    if (Number(rule.discount_type) === 1) {
                        if (quantity >= rule.qty_from) {
                            totalPrice = changeFixedAmount(itemPrice, rule.discount_value, quantity);
                        }
                        if (index == (qbRule.qty_table.length - 1) && rule.qty_to && (quantity > rule.qty_to)) {
                            totalPrice = itemPrice * quantity;
                        }
                    }
                    if (Number(rule.discount_type) === 2) {
                        if (quantity >= rule.qty_from) {
                            totalPrice = changeFixedPercent(itemPrice, rule.discount_value, quantity);
                        }
                        if (index == (qbRule.qty_table.length - 1) && rule.qty_to && (quantity > rule.qty_to)) {
                            totalPrice = itemPrice * quantity;
                        }
                    }
                });    
            }
        }
        return totalPrice;
    };

    BSS_B2B.sr.checkEcxProduct = function (product, excProductType, excProducts, excProductCollections, excProductTag) {
        let productCollections = product.collections ? product.collections : [];
        let productTags = product.tags ? product.tags : [];
        if (excProductType) {
            if (excProductType === 1) {
                return excProducts.includes(`${product.id}`);
            }
            else if (excProductType === 2) {
                return excProductCollections.some(e => productCollections.includes(Number(e)))
            }
            else if (excProductType === 3) {
                return excProductTag.some(tag => productTags.includes(tag))
            }
            else return false
        }
    };

    BSS_B2B.sr.getCheapestShippingRate = async function (ruleList, totalCartPrice, quantity, product, variant) {
        let shippingRatePrice = null;
        let shippingRateTitle = null;
        let productWeightGrams;
        let totalWeightKG = 0;
        let productResponse = await fetch(`https://${shopData.shop.domain}/search?q=id:"${product.id}"&view=bss.b2b`);
        let productInfo = await productResponse.json()
        if(productInfo && productInfo.length) {
            let variantInfo = productInfo[0].variants.find(variantItem => variantItem.id === parseInt(variant));
            productWeightGrams = variantInfo ? variantInfo.weight : 0;
            totalWeightKG = productWeightGrams * 0.001;
        }

        if (ruleList.length) {
            ruleList.map(rule => {
                let qtyTables = rule.qty_table;
                let amountTables = rule.amount_table;
                let weightTables = rule.weight_table;
                let ruleSetting = rule.rule_setting;
                let excProductType = rule.exc_product_type ? Number(rule.exc_product_type) : 0;
                let excProducts = rule.exc_specific_products;
                let excProductCollections = rule.exc_product_collections ? rule.exc_product_collections.split(",") : [];
                let excProductTag = rule.exc_product_tags ? rule.exc_product_tags.split(",") : [];
                let isExcProduct = BSS_B2B.sr.checkEcxProduct(product, excProductType, excProducts, excProductCollections, excProductTag);
                if (!isExcProduct) {
                    if (ruleSetting === 0) {
                        if (qtyTables.length) {
                            qtyTables.map(table => {
                                let shippingRateValue = 0;
                                if (shippingRatePrice != null) {
                                    if (quantity >= table.qty_from && (!table.qty_to || quantity <= table.qty_to)) {
                                        if (table.discount_type === 0) {
                                            shippingRateValue = totalCartPrice * table.discount_value / 10000;
                                        }
                                        else {
                                            shippingRateValue = table.discount_value;
                                        }
                                        if (shippingRatePrice > shippingRateValue) {
                                            shippingRatePrice = shippingRateValue;
                                            shippingRateTitle = rule.name
                                        }
                                    }
                                } else {
                                    if (quantity >= table.qty_from && (!table.qty_to || quantity <= table.qty_to)) {
                                        if (table.discount_type === 0) {
                                            shippingRatePrice = totalCartPrice * table.discount_value / 10000;
                                            shippingRateTitle = rule.name
                                        } else {
                                            shippingRatePrice = table.discount_value;
                                            shippingRateTitle = rule.name
                                        }
                                    }
                                }
                            })
                        }
                    } else if (ruleSetting === 1) {
                        if (amountTables.length) {
                            amountTables.map(table => {
                                const charge = table.charge ? table.charge : 0;
                                const sub_charge = table.sub_charge ? table.sub_charge : 0;
                                const max_weight = table.max_weight ? table.max_weight : 0;
                                let shippingRateValue = 0;
                                if (shippingRatePrice != null) {
                                    if (totalCartPrice >= table.amount_from * 100 &&( !table.amount_to || totalCartPrice <= table.amount_to * 100)) {
                                        if (table.discount_type === 0) {
                                            shippingRateValue = totalCartPrice * table.discount_value / 10000;
                                        }
                                        else {
                                            shippingRateValue = table.discount_value;
                                        }
                                        if (shippingRatePrice > shippingRateValue) {
                                            shippingRatePrice = shippingRateValue;
                                            shippingRateTitle = rule.name;
                                        }
                                        if (parseFloat(max_weight) && totalWeightKG > max_weight) {
                                            shippingRatePrice = parseFloat(charge) + parseFloat(sub_charge) * (totalWeightKG - max_weight)
                                        }
                                    }
                                } else {
                                    if (totalCartPrice >= table.amount_from * 100 &&( !table.amount_to || totalCartPrice <= table.amount_to * 100)) {
                                        if (table.discount_type === 0) {
                                            shippingRatePrice = totalCartPrice * table.discount_value / 10000;
                                            shippingRateTitle = rule.name;
                                        } else {
                                            shippingRatePrice = table.discount_value;
                                            shippingRateTitle = rule.name;
                                        }
                                        if (parseFloat(max_weight) && totalWeightKG > max_weight) {
                                            shippingRatePrice = parseFloat(charge) + parseFloat(sub_charge) * (totalWeightKG - max_weight)
                                        }
                                    }
                                }
                            })
                        }
                    } else if (ruleSetting === 2) {
                        if (weightTables.length) {
                            weightTables.map(table => {
                                const charge = table.charge ? table.charge : 0;
                                const sub_charge = table.sub_charge ? table.sub_charge : 0;
                                const max_weight = table.max_weight ? table.max_weight : 0;
                                const conversionTable = {
                                    "g": 1,
                                    "kg": 1000,
                                    "lb": 453.59237,
                                    "oz": 28.34952
                                };
                                let weightFromGrams = table.weight_from * Object.values(conversionTable)[table.unit_type];
                                let weightToGrams = table.weight_to ? table.weight_to * Object.values(conversionTable)[table.unit_type] : null;
                                let shippingRateValue = 0;
                                if (shippingRatePrice != null) {
                                    if (productWeightGrams >= weightFromGrams && (!weightToGrams || productWeightGrams <= weightToGrams)) {
                                        if (table.discount_type === 0) {
                                            shippingRateValue = totalCartPrice * parseFloat(table.discount_value) / 10000;
                                        }
                                        else {
                                            shippingRateValue = parseFloat(table.discount_value);
                                        }
                                        if (shippingRatePrice > shippingRateValue) {
                                            shippingRatePrice = shippingRateValue;
                                            shippingRateTitle = rule.name
                                        }
                                        if (parseFloat(max_weight) && totalWeightKG > max_weight) {
                                            shippingRatePrice = parseFloat(charge) + parseFloat(sub_charge) * (totalWeightKG - max_weight)
                                        }
                                    }
                                } else {
                                    if (productWeightGrams >= weightFromGrams && (!weightToGrams || productWeightGrams <= weightToGrams)) {
                                        if (table.discount_type === 0) {
                                            shippingRatePrice = totalCartPrice * parseFloat(table.discount_value) / 10000;
                                            shippingRateTitle = rule.name;
                                        } else {
                                            shippingRatePrice = parseFloat(table.discount_value);
                                            shippingRateTitle = rule.name;
                                        }
                                    }
                                }
                            })
                        }
                    }
                } else {
                    shippingRatePrice = null;
                    shippingRateTitle = "Default Shopify shipping rate";
                }
            })
        }
        let finalShippingRate = null;
        if (shippingRatePrice || shippingRatePrice === 0) {
            finalShippingRate = {
                value: shippingRatePrice,
                title: shippingRateTitle
            };
        }
        BSS_B2B.sr.shippingRate = finalShippingRate;
        return finalShippingRate;
    };

    BSS_B2B.sr.getCheapestShippingRateInCart = function (ruleList, totalCartPrice, cartTotalWeight, productMap, cartItem) {
        productMap = productMap.length ? productMap.filter(product => product.quantity) : productMap;
        let shippingRatePrice = null;
        let shippingRateTitle = null;
        let totalItems = 0;
        productMap.forEach(item => {
            let productVariantsArr = cartItem.get(item.id);
            if (productVariantsArr && productVariantsArr.length) {
                productVariantsArr.forEach(variant => {
                    totalItems += variant.quantity;
                })
            }
         })
        productMap.map(item => {
            if (ruleList.length) {
                ruleList.map(rule => {
                    let qtyTables = rule.qty_table;
                    let amountTables = rule.amount_table;
                    let weightTables = rule.weight_table;
                    let ruleSetting = rule.rule_setting;
                    let excProductType = rule.exc_product_type ? Number(rule.exc_product_type) : 0;
                    let excProducts = rule.exc_specific_products;
                    let excProductCollections = rule.exc_product_collections ? rule.exc_product_collections.split(",") : [];
                    let excProductTag = rule.exc_product_tags ? rule.exc_product_tags.split(",") : [];
                    let isExcProduct = BSS_B2B.sr.checkEcxProduct(item, excProductType, excProducts, excProductCollections, excProductTag)
                    if (!isExcProduct) {
                        if (ruleSetting === 0) {
                            if (qtyTables.length) {
                                qtyTables.map(table => {
                                    let shippingRateValue = 0;
                                    if (shippingRatePrice != null) {
                                        if (totalItems >= table.qty_from && (!table.qty_to || totalItems <= table.qty_to)) {
                                            if (table.discount_type === 0) {
                                                shippingRateValue = totalCartPrice * table.discount_value / 10000;
                                            }
                                            else {
                                                shippingRateValue = table.discount_value;
                                            }
                                            if (shippingRatePrice > shippingRateValue) {
                                                shippingRatePrice = shippingRateValue;
                                                shippingRateTitle = rule.name;
                                            }
                                        }
                                    } else {
                                        if (totalItems >= table.qty_from && (!table.qty_to || totalItems <= table.qty_to)) {
                                            if (table.discount_type === 0) {
                                                shippingRatePrice = totalCartPrice * table.discount_value / 10000;
                                                shippingRateTitle = rule.name;
                                            } else {
                                                shippingRatePrice = table.discount_value;
                                                shippingRateTitle = rule.name;
                                            }
                                        }
                                    }
                                })
                            }
                        } else if (ruleSetting === 1) {
                            if (amountTables.length) {
                                amountTables.map(table => {
                                    const charge = table.charge ? table.charge : 0;
                                    const sub_charge = table.sub_charge ? table.sub_charge : 0;
                                    const max_weight = table.max_weight ? table.max_weight : 0;
                                    const totalWeightKG = cartTotalWeight / 1000;
                                    let shippingRateValue = 0;
                                    if (shippingRatePrice != null) {
                                        if (totalCartPrice >= table.amount_from * 100 && (!table.amount_to || totalCartPrice <= table.amount_to * 100)) {
                                            if (table.discount_type === 0) {
                                                shippingRateValue = totalCartPrice * table.discount_value / 10000;
                                            }
                                            else {
                                                shippingRateValue = table.discount_value;
                                            }
                                            if (shippingRatePrice > shippingRateValue) {
                                                shippingRatePrice = shippingRateValue;
                                                shippingRateTitle = rule.name
                                            }
                                            if (parseFloat(max_weight) && totalWeightKG > max_weight) {
                                                shippingRatePrice = parseFloat(charge) + parseFloat(sub_charge) * (totalWeightKG - max_weight)
                                            }
                                        }
                                    } else {
                                        if (totalCartPrice >= table.amount_from * 100 && (!table.amount_to || totalCartPrice <= table.amount_to * 100)) {
                                            if (table.discount_type === 0) {
                                                shippingRatePrice = totalCartPrice * table.discount_value / 10000;
                                                shippingRateTitle = rule.name;
                                            } else {
                                                shippingRatePrice = table.discount_value;
                                                shippingRateTitle = rule.name;
                                            }
                                            if (parseFloat(max_weight) && totalWeightKG > max_weight) {
                                                shippingRatePrice = parseFloat(charge) + parseFloat(sub_charge) * (totalWeightKG - max_weight)
                                            }
                                        }
                                    }
                                })
                            }
                        } else if (ruleSetting === 2) {
                            if (weightTables.length) {
                                weightTables.map(table => {
                                    const conversionTable = {
                                        "g": 1,
                                        "kg": 1000,
                                        "lb": 453.59237,
                                        "oz": 28.34952
                                    };
                                    let weightFromGrams = table.weight_from * Object.values(conversionTable)[table.unit_type];
                                    let weightToGrams = table.weight_to ? table.weight_to * Object.values(conversionTable)[table.unit_type] : null;
                                    let shippingRateValue = 0;
                                    if (shippingRatePrice != null) {
                                        if (cartTotalWeight >= weightFromGrams && (!weightToGrams || cartTotalWeight <= weightToGrams)) {
                                            if (table.discount_type === 0) {
                                                shippingRateValue = totalCartPrice * parseFloat(table.discount_value) / 10000;
                                            }
                                            else {
                                                shippingRateValue = parseFloat(table.discount_value);
                                            }
                                            if (shippingRatePrice > shippingRateValue) {
                                                shippingRatePrice = shippingRateValue;
                                                shippingRateTitle = rule.name
                                            }
                                        }
                                    } else {
                                        if (cartTotalWeight >= weightFromGrams && (!weightToGrams || cartTotalWeight <= weightToGrams)) {
                                            if (table.discount_type === 0) {
                                                shippingRatePrice = totalCartPrice * parseFloat(table.discount_value) / 10000;
                                                shippingRateTitle = rule.name;
                                            } else {
                                                shippingRatePrice = parseFloat(table.discount_value);
                                                shippingRateTitle = rule.name;
                                            }
                                        }
                                    }
                                })
                            }
                        }
                    }
                })
            }
        })
        let finalShippingRate = null;
        if (shippingRatePrice || shippingRatePrice === 0) {
            finalShippingRate = {
                value: shippingRatePrice,
                title: shippingRateTitle
            };
        }
        BSS_B2B.sr.shippingRate = finalShippingRate;
        return finalShippingRate;
    };

    BSS_B2B.sr.getAppliedRules = async function (ruleList, productMap, customer) {
        if(productMap.length) {
            productMap = productMap.filter(e => e.id);
        }
        let appliedRuleList = [];
        if (isEnableSr) {
            let data = {
                domain: shopData.shop.permanent_domain,
                app: "B2B Solution",
                customer: customer
            };

            let listCheckSrRes = await fetch(bssB2bApiServer + `/sr/rules/check-shipping-rate?domain=${shopData.shop.permanent_domain}`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json()).then((data) => data)

            ruleList.forEach(function (rule, index) {
                let appliedSrRule = false;
                let applyTo = rule.apply_to;
                let customerIds = rule.customer_ids;
                let customerTagsInRule = rule.customer_tags;
                let excludeCustomerTags = rule.exc_customer_tags;
                let excludeFrom = rule.exclude_from ? parseInt(rule.exclude_from) : null;
                let exc_customers = rule.exc_customers;

                if(listCheckSrRes.success && listCheckSrRes.message) {
                    let listCheckSr = listCheckSrRes.message
                    if(!listCheckSr[index]) return;
                }

                if (excludeFrom === 1) {
                    if (excludeCustomerTags && excludeCustomerTags.length && customer.tags !== null) {
                        excludeCustomerTags = excludeCustomerTags.split(",").map(tag => tag.toLowerCase());
                        let customerTag = customer.tags.map(tag => tag.toLowerCase());
                        let checkArray = excludeCustomerTags.filter(tag => customerTag.includes(tag));
                        if (checkArray.length > 0) {
                            return
                        }
                    }
                }
                else if (excludeFrom === 2) {
                    if (exc_customers) {
                        if (exc_customers.includes(`${customer.id}`)) {
                            return
                        }
                    }
                }
                // if (applyTo == 0) {
                //
                // } else
                if (applyTo === 1) {
                    if (customer.id == null) {
                        return;
                    }
                }
                else if (applyTo === 2) {
                    if (customer.id !== null) {
                        return;
                    }
                }
                else if (applyTo === 3) {
                    if (customer.id == null) {
                        return;
                    } else {
                        customerIds = customerIds.split(',');
                        if (customerIds.indexOf(customer.id + "") === -1) {
                            return;
                        }
                    }
                }
                else if (applyTo === 4) {
                    if (customer.tags == null) {
                        return;
                    } else {
                        customerTagsInRule = customerTagsInRule.split(",").map(tag => tag.toLowerCase());
                        let customerTag = customer.tags.map(tag => tag.toLowerCase());
                        let checkArray = customerTagsInRule.filter(tag => customerTag.includes(tag));
                        if (checkArray.length === 0) {
                            return
                        }
                    }
                }

                let conditionType = rule.product_condition_type;
                let ruleTags = rule.product_tags ? rule.product_tags.split(",").map(tag => tag.toLowerCase()) : [];
                let specificProductIds = rule.product_ids ? rule.product_ids.split(",") : [];
                let ruleCollectionIds = rule.product_collections ? rule.product_collections.split(",") : [];

                productMap.map(item => {
                    let collections = item.collections  || [];
                    let tags = item && item.tags ? item.tags.map(tag => tag.toLowerCase()) : [];

                    if (conditionType === 0) {
                        appliedSrRule = rule;
                    } else if (conditionType === 1) {
                        if (specificProductIds.indexOf(item.id + "") !== -1) {
                            appliedSrRule = rule;
                        }
                    } else if (conditionType === 2) {
                        let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
                        if (checkArray.length > 0) {
                            appliedSrRule = rule;
                        }
                    } else if (conditionType === 3) {
                        let checkArray = ruleTags.filter(tag => tags.includes(tag));
                        if (checkArray.length > 0) {
                            appliedSrRule = rule
                        }
                    }
                });

                if (appliedSrRule) {
                    appliedRuleList.push(appliedSrRule);
                }
            })
        }
        return appliedRuleList;
    };

    BSS_B2B.sr.calculateShippingRate = async function (ruleList, productMap, customer, CPPricingList, CPAndQBPricingList, cartItem, cartOriginalTotalPrice, cartTotalWeight, rateMarket) {
        let appliedRuleList = await BSS_B2B.sr.getAppliedRules(ruleList, productMap, customer);
        let totalCartPrice = 0;
        let calculatedItem = [];

        let arrayCPAndQBPricingList = Array.from(CPAndQBPricingList.values())
        let arrayCPPricingList = Array.from(CPPricingList.values())

        if (CPAndQBPricingList.size || CPPricingList.size) {
            if (CPAndQBPricingList.size) {
                arrayCPAndQBPricingList.map(item => {
                    calculatedItem.push(item.key);
                    totalCartPrice += item.pricePerItemAfterApplyQB * item.quantity
                })
            }
            if (CPPricingList.size) {
                arrayCPPricingList.map(item => {
                    if (calculatedItem.indexOf(item.key) === -1) {
                        calculatedItem.push(item.key);
                        totalCartPrice += item.modifiedLineItemPrice
                    }
                })
            }
            productMap.map(item => {
                if (calculatedItem.indexOf(item.key) === -1) {
                    let productVariantsArr = cartItem.get(item.id);
                    if (productVariantsArr && productVariantsArr.length) {
                        productVariantsArr.map(variant => {
                            if (variant.key === item.key || variant.quantity > 0) {
                                let linePrice = variant.price * variant.quantity;
                                totalCartPrice += linePrice
                            }
                        })
                    }
                }
            })
        }
        else {
            totalCartPrice = cartOriginalTotalPrice;
        }
        totalCartPrice = totalCartPrice / rateMarket
        let shippingRate = BSS_B2B.sr.getCheapestShippingRateInCart(appliedRuleList, totalCartPrice, cartTotalWeight, productMap, cartItem);
        return shippingRate;
    };

    BSS_B2B.sr.calculateShippingRateForBuyItNow = async function (ruleList, customer, product, variant, totalPrice, quantity, rateMarket) {
        let productMap = product ? [product] : [];
        let appliedRuleList = await BSS_B2B.sr.getAppliedRules(ruleList, productMap, customer);
        let newTotalPrice = totalPrice / rateMarket
        let shippingRate = await BSS_B2B.sr.getCheapestShippingRate(appliedRuleList, newTotalPrice, quantity, product, variant);
        return shippingRate;
    }
}

// EXTERNAL MODULE: ./js/src/extra-fee/init-extra-fee.js
var init_extra_fee = __webpack_require__(15);

// CONCATENATED MODULE: ./js/src/cart/observingCartChange.js
class CartWatcher {
    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }

    async fetchCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    storeCart(cart) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }

    storedCart() {
        return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
        const findOnlyChange = (oldItems, newItems) => oldItems.filter(oldItem => !newItems.some(newItem => oldItem.key == newItem.key));

        let result = {
            added: findOnlyChange(newCart.items, oldCart.items),
            removed: findOnlyChange(oldCart.items, newCart.items),
        };

        oldCart.items.forEach(oldItem => {
            const newItem = newCart.items.find(item => item.key == oldItem.key && item.quantity != oldItem.quantity);
            if (!newItem) return;
            let quantity = newItem.quantity - oldItem.quantity;
            let item = { ...newItem };
            item.quantity = Math.abs(quantity);
            quantity > 0
                ? result.added.push(item)
                : result.removed.push(item)
        });

        return {
            ...result,
            isChangedQuantity: result.added.length > 0 || result.removed.length > 0
        };
    }

    async emitCartChanges() {
        const newCart = await this.fetchCart();
        const oldCart = this.storedCart();
        const changes = this.findCartChanges(oldCart, newCart);

        const event = new CustomEvent("cart_changed", { detail: changes });
        window.dispatchEvent(event);

        this.storeCart(newCart);
    }

    observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);
                if (isValidRequestType && isCartChangeRequest) {
                    this.emitCartChanges();
                }
            });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
    }
}
// CONCATENATED MODULE: ./js/src/init/runscript.js






















const runscript_Tax = __webpack_require__(1);

function bssB2BRunScript($, BSS_B2B, shopModules, shopData) {
    // eslint-disable-next-line no-console
    console.log('B2B script');
    /**
     * Initial shop modules
     */

    BSS_B2B.validateVatSuccess = false;

    var Shopify = {};
    Shopify.currency = {
        active: shopData.shop.currency,
        rate: '1',
    };

    if (window.Shopify) {
        Shopify = window.Shopify;

        if (!window.Shopify.currency) {
            Shopify.currency = {
                active: shopData.shop.currency,
                rate: '1',
            };
        }
        else {
            if (!window.Shopify.currency.active) {
                Shopify.currency.active = shopData.shop.currency;
            }

            if (!window.Shopify.currency.rate) {
                Shopify.currency.rate = '1';
            }
        }
    }

    formatMoney(shopData, BSS_B2B);

    if (shopModules === undefined || shopModules == null || shopModules.length === 0) {
        BSS_B2B.shopModules = [
            {code: 'cp', status: 1},
            {code: 'qb', status: 1},
            {code: 'form', status: 1},
            {code: 'mc', status: 0},
            {code: 'amo', status: 0},
            {code: 'tax_exempt', status: 0},
            {code: 'dc', status: 0},
            {code: 'cart_note', status: 0},
            {code: 'tax_display', status: 0},
            {code: 'bogo', status: 0},
        ];
        shopModules = BSS_B2B.shopModules;
    }
    let isEnableCP = true;
    let isEnableQB = true;
    let isEnableRg = true;
    let isEnableMc = false;
    let isEnableAMO = false;
    let isEnabledTE = false;
    let isEnableDC = false;
    let isEnableCartNote = false;
    let isEnableEF = false;
    let isEnabledTD = false;
    let isEnabledQI = false;
    let isEnableBOGO = true;
    let isEnableSr = false;

    shopModules.forEach(function(sm) {
        if (sm.code === 'cp') {
            isEnableCP = sm.status;
        }
        else if (sm.code === 'qb') {
            isEnableQB = sm.status;
        }
        else if (sm.code == 'form') {
            isEnableRg = sm.status;
        }
        else if (sm.code === 'mc') {
            isEnableMc = sm.status;
        }
        else if (sm.code === 'amo') {
            isEnableAMO = sm.status;
        }
        else if (sm.code === 'tax_exempt') {
            isEnabledTE = sm.status;
        } 
        else if (sm.code === 'dc') {
            isEnableDC = BSS_B2B.planCode === "pro" ? 0 : sm.status;
        } 
        else if (sm.code === 'ef') {
            isEnableEF = sm.status;
        }
        else if (sm.code === 'cart_note') {
            isEnableCartNote = sm.status;
        }
        else if (sm.code === 'tax_display') {
            isEnabledTD = sm.status;
        }
        else if (sm.code === 'qi') {
            isEnabledQI = sm.status;
        }
        else if (sm.code === 'sr') {
            isEnableSr = sm.status;
        }
        else if (sm.code === 'bogo') {
            isEnableBOGO = sm.status;
        }
    });
    // fix for dragonflybrand.com by hoaduong
    // fix for parkinfabrics by Leorio
    if ([437, 3787, 4497, 8553, 11500, 15743].indexOf(BSS_B2B.storeId) !== -1 && shopData.customer.id == null) {
        isEnableCP = false;
    }

    if ((BSS_B2B.configData && BSS_B2B.configData.length > 0) ||
        (BSS_B2B.plConfigData && BSS_B2B.plConfigData.length > 0)) {
        // for sample-shop0621 by mitri
        if (BSS_B2B.storeId === 3041) {
            if (window.location.pathname === '/cart') {
                $('.cart-wrapper__inner .card__section button[name="checkout"]').attr('disabled', true);
            }
        }
    }

    if (!BSS_B2B.vatSetting ||
        (BSS_B2B.vatSetting &&
            !BSS_B2B.vatSetting.enable_eu_vat &&
            !BSS_B2B.vatSetting.enable_uk_vat &&
            !BSS_B2B.vatSetting.enable_gst &&
            !BSS_B2B.vatSetting.enable_abn &&
            !BSS_B2B.vatSetting.enable_us_ein
        )
    ) {
        isEnabledTE = false;
    }

    BSS_B2B.debounce = runscript_debounce;
    Object(helper["a" /* default */])($, BSS_B2B, shopData, isEnableCP, Shopify);
    internal(BSS_B2B);

    // lang shop
    const registerForm = document.querySelector('#RegisterForm');
    const langShopConditionForRF = isEnableRg &&
        (BSS_B2B.page.isRegisterPage() || (BSS_B2B.page.isCustomPage() && registerForm != null));
    if (BSS_B2B.integrate.langShop.isStoreUsingLangShop) {
        BSS_B2B.integrate.langShop.determineTranslatedLanguage();
        if (langShopConditionForRF) {
            BSS_B2B.integrate.langShop.handleAllTranslation('rf');
        }
        if (isEnableAMO && BSS_B2B.amoRules && BSS_B2B.amoRules.length) {
            BSS_B2B.integrate.langShop.handleAllTranslation('amo');
        }
        if (isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length) {
            BSS_B2B.integrate.langShop.handleAllTranslation('qi');
        }
    }
    // lang shop

    initCustom(BSS_B2B, shopData);
    initCartHelper();
    initDC($, BSS_B2B, shopData, isEnableCP, isEnableQB);
    initSr(shopData, isEnableSr);
    initTD(BSS_B2B);

    const applyDiscountCode = async (isChangeQuantity = false) => {
        BSS_B2B.dc.showDiscountBox();
        await BSS_B2B.dc.getDiscountCodeApplied(isChangeQuantity);
        BSS_B2B.onDiscountCodeSubmit();
        BSS_B2B.handleCartCheckoutBtn(shopData)
    }
    let firstLoading = true;
    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();
    window.addEventListener("cart_changed", (e) => {
        if (isEnableDC && BSS_B2B.dcRules && BSS_B2B.dcRules.length > 0) {
            if (firstLoading) {
                if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length) {
                    document.addEventListener("bss_b2b_doneCheckQb", () => {applyDiscountCode(); firstLoading = false});
                } else if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                    if (![12388].includes(BSS_B2B.storeId)) {
                        document.addEventListener("bss_b2b_doneCheckCp",  () => {applyDiscountCode(); firstLoading = false});
                    } else {
                        document.addEventListener("bss_b2b_doneCheckCp",  runscript_debounce(() => {applyDiscountCode(); firstLoading = false;}, 200));
                    }
                } else {
                    applyDiscountCode();
                    firstLoading = false;
                }
            } else if (e.detail.isChangedQuantity) {
                if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length) {
                    document.addEventListener("bss_b2b_doneCheckQb", () => applyDiscountCode(true));
                } else if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) && (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                    document.addEventListener("bss_b2b_doneCheckCp", () => applyDiscountCode(true));
                } else {
                    applyDiscountCode(true);
                }
            }
        }
    });

    if (isEnableDC && BSS_B2B.page.isCartPage()) {
        if (BSS_B2B.storeId === 4945) {
            setTimeout(async function() {
                BSS_B2B.dc.showDiscountBox();
                await BSS_B2B.dc.getDiscountCodeApplied();
                BSS_B2B.onDiscountCodeSubmit();
            }, 2000);
            // fix for hardcore-nutrition-usa by AnhTV
        }
        else if (BSS_B2B.storeId === 5473) {
            setTimeout(async function() {
                BSS_B2B.dc.showDiscountBox();
                await BSS_B2B.dc.getDiscountCodeApplied();
                BSS_B2B.onDiscountCodeSubmit();
                BSS_B2B.handleCartCheckoutBtn(shopData);
            }, 2000);
        }
    }
    if (isEnableDC) {
        let pathUrl = window.location.pathname.replace(`/`, '');
        let ruleDc = BSS_B2B.dcRules.filter((rule) => (rule.share_link === pathUrl && rule.share_link_status === 1));
        if (ruleDc && ruleDc.length > 0 && (ruleDc.share_link !== undefined || ruleDc.share_link !== '')) {
            BSS_B2B.dc.checkDiscountCodeShareLink();
        }
    }
    if (isEnableDC && BSS_B2B.storeId === 11454) {
        setTimeout(() => {
            $('#t4s-mini_cart .bss-b2b-discount-code-wrapper').show();
        }, 1000);
    }

    let appliedCP = isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
        (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0);
    let appliedTD = isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length > 0;
    BSS_B2B.getCPRulesByCustomer(appliedCP, shopData.customer);
    let modules = {
        appliedCP,
        appliedTD,
    };

    BSS_B2B.onChangeVariant(modules);

    if ((BSS_B2B.planCode === 'null' || BSS_B2B.planCode === '' || BSS_B2B.planCode === 'undefined')) {
        const cartFallbackPriceStyles = `
            [bss-b2b-cart-item-key],
            [bss-b2b-product-id],
            [bss-b2b-variant-id],
            [bss-b2b-cart-item-key],
            [bss-b2b-cart-total-price],
            [bss-b2b-cart-total-discount],
            [data-cart-item-regular-price],
            [data-cart-subtotal],
            [bss-b2b-bcp-cart-subtotal-price],
            [bss-b2b-bcp-cart-total-price],
            .bss-b2b-bcp-new-line-item-price {
                visibility: visible !important;
            }
        `;

        const cartFallbackPriceStyle = document.createElement('style');
        cartFallbackPriceStyle.type = 'text/css';
        cartFallbackPriceStyle.id = 'cart-fallback-price-style';
        cartFallbackPriceStyle.innerText = cartFallbackPriceStyles;
        document.head.appendChild(cartFallbackPriceStyle);

        let ignoreEvent = new Event('bss.b2b.amo.doneCheckAMOByBSS');
        document.dispatchEvent(ignoreEvent);
        return;
    }

    let firstLoadProduct = true;

    BSS_B2B.addFallbackStylePrice = (isEnableQB) => {
        let isExistStylePrice = document.querySelector('#fallback-price-style');
        if (!isExistStylePrice) {
            let styles = `	
                [bss-b2b-cart-item-key],	
                [bss-b2b-product-id],	
                [bss-b2b-variant-id],	
                [bss-b2b-cart-item-key],	
                [bss-b2b-cart-total-price],	
                [bss-b2b-cart-total-discount],	
                [data-cart-item-regular-price],	
                [data-cart-subtotal] { visibility: visible !important; }	
                `;
            if (BSS_B2B.storeId === 11796) {
                styles += `.card-information .price,.price__container:has([bss-b2b-product-id]){display:block !important;}`;
            }
            // for compare with purchase-late of bcp by Leorio	
            if (!BSS_B2B.qbRules || BSS_B2B.qbRules.length === 0 || !isEnableQB) {
                styles += `	
                    [bss-b2b-bcp-cart-subtotal-price],	
                    [bss-b2b-bcp-cart-total-price],	
                    .bss-b2b-bcp-new-line-item-price { visibility: visible !important; }	
                    `;
            }

            const styleSheet = document.createElement('style');
            styleSheet.type = 'text/css';
            styleSheet.id = 'fallback-price-style';
            styleSheet.innerText = styles;
            document.head.appendChild(styleSheet);
            setTimeout(function() {
                if (BSS_B2B.storeId !== 12761) {
                    $('.shopify-payment-button__button, .shopify-payment-button__more-options').
                    addClass('bss-b2b-btn-buyitnow');
                }
            }, 1000);
        }
    };

    if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
        (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
        BSS_B2B.addFallbackStylePrice(isEnableQB);
    }

    let currencyConfig = BSS_B2B.currencyConfig;

    if (currencyConfig === undefined || currencyConfig == null) {
        isEnableMc = false;
    }
    else {
        const deviceWidth = $(window).width();
        const showOnMobile = currencyConfig.show_on_mobile;
        const showOnDesktop = currencyConfig.show_on_desktop;
        if (deviceWidth > 600) {
            //check for desktop
            if (!showOnDesktop) {
                isEnableMc = false;
            }
        }
        else {
            //check for mobile
            if (!showOnMobile) {
                isEnableMc = false;
            }
        }
    }

    // multi currency app
    let bssB2BLoadScript = function(url, callback) {
        let script = document.createElement('script');
        script.type = 'text/javascript';

        // If the browser is Internet Explorer.
        if (script.readyState) {
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        }
        else {
            script.onload = function() {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);

    };

    if (isEnableMc) {
        BSS_B2B.MC = {};
        bssB2BLoadScript('https://cdn.shopify.com/s/javascripts/currencies.js', function() {
            let currencyConfig = BSS_B2B.currencyConfig;
            let autoCurrencyLocation = currencyConfig.auto_location;
            if (!autoCurrencyLocation) {
                initMultiCurrency($, BSS_B2B, shopData, isEnableCP, isEnableQB);
            }
            else {
                $.ajax({
                    url: bssGeoServiceUrl + '/geoip/getCountryByIP',
                    data: JSON.stringify({domain: shopData.shop.permanent_domain, app: 'b2b'}),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    success: function(data) {
                        if (data.success) {
                            BSS_B2B.countryCode = data.countryCode;

                            if (typeof (Storage) !== 'undefined') {
                                sessionStorage.countryCode = data.countryCode;
                            }
                            initMultiCurrency($, BSS_B2B, shopData, isEnableCP, isEnableQB);
                        }
                        else {
                            // eslint-disable-next-line no-console
                            console.log('Could not get country by IP');
                            initMultiCurrency($, BSS_B2B, shopData, isEnableCP, isEnableQB);
                        }
                    },
                    error: function(err) {
                        // eslint-disable-next-line no-console
                        console.log('Could not get country by IP:', err);
                        initMultiCurrency($, BSS_B2B, shopData, isEnableCP, isEnableQB);
                    },
                });
            }
        });
    }

    if (isEnabledQI) {
        if (BSS_B2B.qiRules && BSS_B2B.qiRules.length > 0) {
            document.addEventListener('bss.b2b.qi.doneCheckQIByBSS', function() {
                const checkoutElement = [
                    'form[action*="/cart"] [name="checkout"]',
                    '#dropdown-cart button.btn.btn-checkout.show',
                    'a.button.checkout-button[href="/checkout"]',
                    'form[action*="/checkout"] .add_to_cart',
                    'form[action*="/cart"]#cart_form #checkout',
                    'form[action*="/cart"] button.Cart__Checkout',
                    'form[action*="/cart"] button.cart__checkout',
                    'a.btn.disabled.ttmodalbtn[href="/checkout"]',
                    'button#checkout.cart__checkout-button.button'];
                let disableCheckout = false;
                if (isEnableAMO && BSS_B2B.storeId === 6306) {
                    disableCheckout = true;
                }
                BSS_B2B.cart.handleDelayCheckout(checkoutElement, disableCheckout);
            });
        }
    }

    //Hide VAT - Tax Exempt form
    if (!isEnabledTE) {
        if ($('.bss-b2b-tax-ex-wrapper').length) {
            $('.bss-b2b-tax-ex-wrapper').remove();
        }
    }

    // Init filtered by country and rest of world tax overrides
    if (isEnabledTD) {
        let taxOverrides = BSS_B2B.taxOverrides ? BSS_B2B.taxOverrides : [];
        BSS_B2B.taxOverridesByCountryCode = taxOverrides.filter(
            (taxOverride) => taxOverride.country_code === BSS_B2B.countryCode);
        BSS_B2B.taxOverridesRestOfWorld = taxOverrides.filter((taxOverride) => taxOverride.country_code === '*');
    }

    handleCartPrice($, BSS_B2B, shopData, isEnableQB, isEnableCP, isEnableAMO, isEnableMc, isEnabledTD, isEnableEF,
        isEnabledTE, isEnableDC, isEnabledQI, isEnableBOGO);
    handle_ajax_cart_handleAjaxCart($, BSS_B2B, shopData, isEnableQB, isEnableDC, isEnabledTD, isEnableCP, isEnabledQI, isEnableAMO,
        isEnableEF);
    initCp($, BSS_B2B, shopData, firstLoadProduct, isEnableAMO, isEnableMc, isEnableQB);
    initQi($, BSS_B2B, shopData, isEnabledQI, isEnableCP);
    Object(bogo["a" /* default */])($, BSS_B2B, shopData, isEnableBOGO, isEnableCP, isEnabledTD);
    Object(qb["a" /* default */])($, BSS_B2B, shopData, Shopify, isEnableQB, isEnableCP, isEnableMc, isEnabledTD, isEnableBOGO, isEnableAMO);
    initAMO($, BSS_B2B, shopData, isEnableAMO, isEnableCP, isEnableQB, Shopify);
    Object(init_extra_fee["a" /* default */])($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableEF);
    initCheckout($, BSS_B2B, shopData, isEnableCP, isEnableQB, isEnableAMO, isEnableDC, isEnabledQI);

    if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length > 0) {
        // customize for bingltd.myshopify.com by Leorio
        if (BSS_B2B.storeId === 2851) {
            window.BSS_B2B.executeAction({tag: 'qb_design_table', storeId: 2851});
        }
        else {
            BSS_B2B.qb.settingTableQBOrAB();
        }
    }

    // handle generate QB Table when click button "Quick View" on Collection Page or Search Page
    if ((BSS_B2B.page.isHomePage() || BSS_B2B.page.isCollectionPage() || BSS_B2B.page.isSearchPage()) && isEnableQB && BSS_B2B.qbRules &&
        BSS_B2B.qbRules.length > 0
        && BSS_B2B.qbSettings.page_show_qb_table.includes('4')
    ) {
        BSS_B2B.qb.handleRunQbOnQuickView();
    }

    if (isEnableEF && BSS_B2B.efRules && BSS_B2B.efRules.length > 0) {
        BSS_B2B.ef.settingTableEF();
    }

    if ((!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
            (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0) || !isEnableQB || !BSS_B2B.qbRules ||
            (BSS_B2B.qbRules.length === 0))
        && ((isEnableAMO && BSS_B2B.amoRules && (BSS_B2B.amoRules.length > 0))
            || isEnableSr
            || isEnabledTE
            || (isEnableDC && BSS_B2B.dcRules && BSS_B2B.dcRules.length > 0)
            || (isEnabledTD && BSS_B2B.taxDisplayRules && BSS_B2B.taxDisplayRules.length)
        )
    ) {
        BSS_B2B.handleAjaxCart();
    }

    // fix for mystore-dddad9 by Leorio (and global)
    if (isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length) {
        BSS_B2B.handleAjaxCart();
    }
    // integrate with zapiet
    if (BSS_B2B.integration && BSS_B2B.integration.Zapiet) {
        BSS_B2B.integrate.zapiet.handleCart(shopData);
    }
    // customize for bingltd.myshopify.com by Leorio
    window.BSS_B2B.executeAction({tag: 'change_quantity', storeId: 2851, isEnableQB});

    if (isEnableAMO && BSS_B2B.amoRules && (BSS_B2B.amoRules.length > 0)) {
        let isCPApplied = isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
            (BSS_B2B.configData.length > 0 || BSS_B2B.plConfigData.length > 0);
        let isQBApplied = isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length > 0;
        if ((!isCPApplied && !isQBApplied) || isQBApplied) {
            BSS_B2B.cart.fixer(shopData, false, true);
        }
    }
    else {
        // for compare with nt of Portal
        let event = new Event('bss.b2b.amo.doneCheckAMOByBSS');
        document.dispatchEvent(event);
        // end
    }

    if (isEnabledQI && BSS_B2B.qiRules && (BSS_B2B.qiRules.length > 0)) {
        if (((!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
                (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0) || !isEnableCP)
            && (!BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0) || !isEnableQB)
        ) {
            BSS_B2B.cart.fixer(shopData, false, true);
        }
    }

    //fix for price in add to cart button
    if (isEnableCP && BSS_B2B.configData && BSS_B2B.configData.length) {
        if (BSS_B2B.page.isProductPage()) {
            if (BSS_B2B.storeId === 13922) {
                window.BSS_B2B.executeAction({tag: 'change_quantity', storeId: 13922, BSS_B2B: window.BSS_B2B, shopData});
            } else {
                let buttonChangeQuantity = $(BSS_B2B.cart.buttonChangeQuantity);
                if (buttonChangeQuantity.length) {
                    buttonChangeQuantity.on('click', function() {
                        setTimeout(() => {
                            BSS_B2B.cp.changeProductPrice(shopData, '[bss-b2b-button-price]', false);
                        }, 1500);
                    });
                }
            }
        }
    }

    let firstShowPriceTimeout = BSS_B2B.fix.initTimeout();
    setTimeout(function() {
        const modules = {
            cpStatus: isEnableCP,
            qbStatus: isEnableQB,
            bogoStatus: isEnableBOGO,
            teStatus: isEnabledTE,
            srStatus: isEnableSr,
            dcStatus: isEnableDC,
            efStatus: isEnableEF,
            mcStatus: isEnableMc,
            olStatus: isEnableAMO,
            qiStatus: isEnabledQI,
            tdStatus: isEnabledTD,
        };
        BSS_B2B.fix.handleSomething(modules, shopData);
    }, firstShowPriceTimeout);

    BSS_B2B.fix.handleChangeQuantity();
    setTimeout(() => {
        if (BSS_B2B.storeId === 1169) {
            let qtyButtonChange = $('select.circular-box[name="quantity"]');
            $(qtyButtonChange).on('change', function() {
                let clickedBtn = this;
                let qty = $(clickedBtn).val();
                let priceElement = $(clickedBtn).next();
                let priceElementParent = $(clickedBtn).closest('.product-detail');
                let priceElementHtml = null;
                if (priceElementParent.length) {
                    priceElementHtml = priceElementParent.find('#ProductPrice');
                    if (priceElementHtml.length) {
                        priceElementHtml = priceElementHtml.html().replace(/\D/g, '');
                        let price = parseFloat(priceElementHtml);
                        let newPrice = qty * price;
                        priceElement.html(BSS_B2B.formatMoney(newPrice));
                    }
                }
            });
        }
    }, firstShowPriceTimeout);

    if (BSS_B2B.page.isProductPage()) {
        if (isEnableAMO && BSS_B2B.amoRules && BSS_B2B.amoRules.length > 0 && BSS_B2B.amoSettings &&
            BSS_B2B.amoSettings.display_notify_message === 1) {
            let variantsEle = $('form[action*="/cart/add"] input[name="id"]');
            let variantId = variantsEle.val();
            if (BSS_B2B.storeId === 10438) {
                variantsEle = $('form[action*="/cart/add"]#add-to-cart-form input#quantity');
                variantId = variantsEle.attr('data-variant-product-id');
            }
            BSS_B2B.amo.showNotifyMessage(variantId);

            variantsEle.change(function() {
                $('#olNotifyMessageBSS').remove();
                BSS_B2B.amo.showNotifyMessage($(this).val());
            });
        }
    }

    if (BSS_B2B.page.isProductPage()) {
        if (isEnabledQI && BSS_B2B.qiRules && BSS_B2B.qiRules.length > 0 && BSS_B2B.qiSettings) {
            BSS_B2B.qi.handleSetupQuantity();
            BSS_B2B.qi.showNotifyMessage();
            let defaultProductContainer = '.product__info-container';
            let customProductContainer = '[bss-b2b-card-information]';
            let productCard = document.querySelector(defaultProductContainer) ||
                document.querySelector(customProductContainer);
            let changeVariantOption = productCard ? productCard.querySelectorAll('input[type="radio"]') : [];
            if (changeVariantOption.length > 0) {
                changeVariantOption.forEach(function(variant) {
                    variant.addEventListener('click', function() {
                        $(BSS_B2B.buttonIncreaseQuantity).css("pointer-events", "none");
                        $(BSS_B2B.buttonDecreaseQuantity).css("pointer-events", "none");
                        setTimeout(function() {
                            BSS_B2B.qi.handleSetupQuantity();
                        }, 1500);
                    });
                });
            }
            let buttonAddToCart = document.querySelector(BSS_B2B.buttonAddToCart);
            if(BSS_B2B.storeId === 15196) {
                buttonAddToCart = document.querySelector("button.button.product-selector__submit.no-js-hidden.button--filled.button--normalcase")
            }
            if (buttonAddToCart) {
                buttonAddToCart.addEventListener('click', (event) => {
                    BSS_B2B.qi.handleAddToCart(buttonAddToCart);
                    let invalidProductCheck = BSS_B2B.qi.invalidIncrementProducts;
                    let {isInvalid, currentValue} = invalidProductCheck;
                    if (isInvalid && isInvalid !== false) {
                        let qtyInputElement = getQuantityInputElement();
                        let qtyMinusElement = getQuantityMinusElement();
                        qtyInputElement.value = currentValue;
                        if (qtyInputElement.value > 1) {
                            qtyMinusElement.classList.remove('disabled');
                        }
                        if (isInvalid) {
                            event.preventDefault();
                        }
                        if (isInvalid !== false) {
                            event.preventDefault();
                        }
                        else {
                            event.stopPropagation();
                        }
                    } else if (isInvalid === false) {
                        setTimeout(() => BSS_B2B.qi.handleSetupQuantity(), 1500);
                    }
                });
            }
        }
    }

    setTimeout(function() {
        //Need to apply for multiple featured products with cart form, buy it now buttons

        if (((!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
                (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0) || !isEnableCP) &&
            (!BSS_B2B.qbRules || BSS_B2B.qbRules.length === 0 || !isEnableQB) && !isEnabledTE && !isEnableDC &&
            !isEnableEF) {
            if ((BSS_B2B.storeId === 5028 || BSS_B2B.storeId === 8412) && appliedTD && BSS_B2B.page.isProductPage()) {
                let parentLevel2 = $('section.entry-content.product-description-main-wrapper.variant-swatches-enabled');
                let cartForm = $('form#add-to-cart-form.shopify-product-form');
                if (cartForm.length) {
                    $(cartForm).find('div.swatch-element').on('click', function() {
                        BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm);
                        runscript_Tax.showProductPriceIncludedVat(BSS_B2B, shopData);
                    });
                }
            }
            else if (isEnableCartNote && $('.bss-b2b-custom-fields').length) {
                addCartField($, BSS_B2B, shopData);
            }
            return;
        }
        if (BSS_B2B.page.isCollectionPage() ||
            (BSS_B2B.page.isHomePage() && [5889, 12500].indexOf(BSS_B2B.storeId) !== -1) ||
            (BSS_B2B.page.isCustomPage() && [5328].indexOf(BSS_B2B.storeId) !== -1) || 
            (BSS_B2B.page.isSearchPage() && [12670].includes(BSS_B2B.storeId))) {
            setTimeout(function() {
                if (
                    isEnableQB &&
                    BSS_B2B.qbRules &&
                    BSS_B2B.qbRules.length &&
                    BSS_B2B.qbSettings.page_show_qb_table.includes('3')
                ) {
                    BSS_B2B.qb.generateTableOnCollectionPage();
                }
            }, 500);
        }

        if ($('.featured-product').length > 0 && isEnableQB && BSS_B2B.qbSettings.page_show_qb_table.includes('5')) {
            BSS_B2B.qb.generateTableOnFeatureProduct();
        }

        if (BSS_B2B.page.isProductPage() || 
            ([9817, 12349, 13655].includes(BSS_B2B.storeId) && BSS_B2B.page.isHomePage()) ||
            [11481].includes(BSS_B2B.storeId)
        ) {
            let customStore = [8412, 8411];
            if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                (BSS_B2B.configData.length || BSS_B2B.plConfigData.length) || customStore.includes(BSS_B2B.storeId)) {
                let cartForm = $(
                    'form[action*="/cart/add"], [data-options-selection], .product__controls-group.product__block,' +
                    '.product-variants, .rio-options, .product-info__variant-picker, .variants-selection, .product__infor.col-6,'
                    + 'variant-picker,' + '.halo-productView-right .productView-product.clearfix');
                let parentLevel2 = $(
                    'form[action*="/cart/add"], .data-product-details, .product-info__price .rating-with-text').
                    parent();
                let parentClass = parentLevel2.attr('class');
                if (parentClass === undefined) {
                    parentLevel2 = parentLevel2.parent();
                }
                let fixElement = BSS_B2B.fix.cp.fixDefineCartFormAndParent(cartForm, parentLevel2);
                cartForm = fixElement.cartForm;
                parentLevel2 = fixElement.parentLevel2;
                if (parentLevel2.find('[bss-b2b-product-parent-price]').length === 0) {
                    if ($('#shopify-section-product-template .product__content-main').length) {
                        parentLevel2 = $('#shopify-section-product-template .product__content-main');
                    }
                    if ($('#shopify-section-product-template').length) {
                        parentLevel2 = $('#shopify-section-product-template');
                    }
                    if ($('.Product__Info').length) {
                        parentLevel2 = $('.Product__Info');
                    }
                    if ($('.product-single__meta').length) {
                        parentLevel2 = $('.product-single__meta');
                    }
                    if ($('.product__info-container.product__info-container--sticky').length) {
                        parentLevel2 = $('.product__info-container.product__info-container--sticky');
                    }
                    if ($('.product-grid-container .product-information').length) {
                        parentLevel2 = $('.product-grid-container .product-information');
                    }
                    if ($('.product__infor.col-6').length) {
                        parentLevel2 = $('.product__infor.col-6');
                    }
                    if ($('.price__last .price-item.price-item--regular').length) {
                        parentLevel2 = $('.price__last .price-item.price-item--regular');
                    }
                }

                if (cartForm.length) {
                    let variantSelectSelector = $(cartForm).find('select:not([data-quantity-select]), ' +
                        'input.single-option-selector__radio,'
                        + 'input.product-form__single-selector,'
                        + '.gf_variants.single-option-selector.single-option-selector-product,'
                        + 'fieldset.product-form__input--dropdown .select select,'
                        + '.single-option-selector,'
                        + '.product-selectors,'
                        + '.relative .popover input[type="hidden"],'
                        + '.input-group input[type="radio"],'
                        + '.variant-picker__option input[type="radio"],'
                        + '.js.product-form__input.clearfix'
                        + BSS_B2B.getCssSelector('product_variant_option_input'),
                    );
                    let variantClickElement = $(cartForm).find('div.options-selection__option-value,'
                        + '.product-options .option-lists,'
                        + '#selectorTable',
                    );
                    if (BSS_B2B.storeId === 11290) {
                        variantClickElement = $(cartForm).find('.radio__label');
                    }
                    if(BSS_B2B.storeId === 16064){
                        variantSelectSelector = $('.product .product-info .variant-picker__option-values');
                    }
                    if (BSS_B2B.storeId === 8219) {
                        variantSelectSelector = $(cartForm).
                            closest('.product-information').
                            find('fieldset.product-form__input--dropdown .select select');
                    }
                    if (BSS_B2B.storeId === 8356) {
                        variantSelectSelector = $(cartForm).closest('.product-info').find('variant-radios');
                    }
                    if ([9363, 9817, 10128, 10748].includes(BSS_B2B.storeId)) {
                        variantSelectSelector = $(cartForm).find('input[name="id"]');
                    }
                    if (BSS_B2B.storeId === 9042) {
                        variantClickElement = $('form[action="/cart/add"] .product-options .option-label');
                    }
                    else if (BSS_B2B.storeId === 10799) {
                        variantClickElement = $('fieldset[data-option-input] label');
                    }
                    else if (BSS_B2B.storeId === 10548) {
                        variantSelectSelector = $('variant-selects select[id^=\'Option-template\']');
                    }

                    if (BSS_B2B.storeId === 9461) {
                        variantClickElement = $('variant-radios fieldset label.product-form__label[data-variant-id]');
                    }
                    else if ([12349, 8572].includes(BSS_B2B.storeId)) {
                        variantClickElement = $('.option-selector__btns .opt-label');
                    }
                    else if ([11520, 621].includes(BSS_B2B.storeId)) {
                        window.BSS_B2B.executeAction({tag: 'change_variant_when_rerender_elemnt', storeId: BSS_B2B.storeId, parentLevel2, cartForm})
                    }
                    else if (BSS_B2B.storeId === 11985) {
                        variantSelectSelector = $('.variations .select select');
                        variantClickElement = $('.variations fieldset label');
                    }
                    else if (BSS_B2B.storeId === 1056) {
                        variantClickElement = $(cartForm).find('.swatch__option');
                    } else if ([11481].includes(BSS_B2B.storeId)) {
                        window.BSS_B2B.executeAction({tag: 'change_variant', storeId: BSS_B2B.storeId, cartForm})
                    } else if(BSS_B2B.storeId === 10840) {
                        variantClickElement = [];
                    }

                    if (variantSelectSelector.length) {
                        let debounceTime = 100;
                        if(BSS_B2B.storeId === 9207) { 
                            debounceTime = 0; 
                        }
                        variantSelectSelector.on('change', runscript_debounce(function() {
                            if (BSS_B2B.storeId === 8411) {
                                runscript_Tax.showProductPriceIncludedVat(BSS_B2B, shopData);
                            } else if (BSS_B2B.storeId === 9207) {
                                let variantId = new URLSearchParams(new URL(window.location.href).search).get('variant');
                                runscript_Tax.bssB2BChangeVatPrice(variantId, shopData);
                            }
                            let cartFormClick = BSS_B2B.helper.detectCorrectCartForm(this)
                            if(BSS_B2B.storeId === 16064 ){
                                cartFormClick = $('.product-info .product-info__buy-buttons')
                            }
                            BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm, cartFormClick);
                        }, debounceTime));
                    }
                    if (variantClickElement.length) {
                        variantClickElement.on('click', function() {
                            const cartFormClick = BSS_B2B.helper.detectCorrectCartForm(this)
                            BSS_B2B.changeVariantOptionProductPage(parentLevel2, cartForm, cartFormClick);
                            if (BSS_B2B.storeId == 8412) {
                                runscript_Tax.showProductPriceIncludedVat(BSS_B2B, shopData);
                            }
                        });
                    }
                    BSS_B2B.fix.cp.fixChangeVariantAndAjaxCart(cartForm, parentLevel2, shopData);
                }
            }
            else {
                let isAppliedEF = isEnableEF && BSS_B2B.efRules && BSS_B2B.efRules.length;
                if (isAppliedEF) {
                    let cartForm = $('form[action*="/cart/add"]');
                    $(cartForm).find('button[name="add"]').on('click', function() {
                        BSS_B2B.calculateModules.get('EF').isDoneCalculate = false;
                        setTimeout(function() {
                            BSS_B2B.handleAjaxCart($, BSS_B2B, shopData);
                            BSS_B2B.makeChangesAfterClickAjaxCart(1200);
                        }, 1000);
                    });
                }
            }
            //QTY-BREAK table
            let timeOutLoad = 1000;
            // fix for claybournmanufacturing by CuongNVM
            if (BSS_B2B.storeId === 6315) {
                timeOutLoad = 2000;
            }
            setTimeout(function() {
                if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length &&
                    BSS_B2B.qbSettings.page_show_qb_table.includes('0')) {
                    BSS_B2B.qb.generateTableOnProductPage();
                }
                if (isEnableEF && BSS_B2B.efRules && BSS_B2B.efRules.length &&
                    BSS_B2B.efSettings.page_show_table.includes('0')) {
                    BSS_B2B.ef.generateTableOnProductPage();
                }

            }, timeOutLoad);

            //End

            if (BSS_B2B.storeId === 4557) {
                let addToCartButton = document.querySelector(
                    '.ProductForm__BuyButtons button[data-action="add-to-cart"]');
                if (addToCartButton) {
                    addToCartButton.addEventListener('click', function() {
                        let sideBarCheckTimes = 0;
                        let sideBarCheck = setInterval(function() {
                            let sideBar = document.querySelector('#sidebar-cart[aria-hidden="false"]');
                            if (sideBar || sideBarCheckTimes > 50) {
                                clearInterval(sideBarCheck);
                                if (sideBar) window.BSS_B2B.executeAction({tag: 'customize_validate_te', storeId: 4557, shopData});
                                return;
                            }
                            sideBarCheckTimes += 1;
                        }, 500);
                    });
                }
            }

            if ([4904, 4856, 8653, 9745, 7795, 10548, 11985, 12167, 2259, 12761].indexOf(BSS_B2B.storeId) !== -1) {
                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }

        }
        else {
            if ([9209].indexOf(BSS_B2B.storeId) !== -1 && isEnabledTD) {
                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }
            if (isEnableCP && (BSS_B2B.configData || BSS_B2B.plConfigData) &&
                (BSS_B2B.configData.length || BSS_B2B.plConfigData.length)) {
                BSS_B2B.applyChangePriceForMultiCartForm();
                // Fix for benkibrewingtools change variant in collection page
                // fix for organicthenewbeauty by vitu
                if ([13, 181, 2086, 8505].indexOf(BSS_B2B.storeId) !== -1) {
                    BSS_B2B.applyChangePriceForCollectionPage();
                }

                Object(quickview["a" /* default */])($, BSS_B2B, shopData);
            }
            else if (isEnabledTD) {
                if (BSS_B2B.storeId === 2087) {
                    $('.quick-product__btn').on('click', function() {
                        setTimeout(function() {
                            let cartForm = document.querySelector(
                                '.modal.modal--quick-shop.modal--is-active .product-single__meta');
                            if (cartForm) {
                                cartForm.querySelector(
                                    '.product-single__meta .product-block.product-block--price .product__price > span').
                                    removeAttribute('bss-b2b-product-active');
                                BSS_B2B.cp.changeProductPrice(shopData,
                                    '.modal.modal--quick-shop.modal--is-active .product-single__meta .product-block.product-block--price .product__price > span',
                                    cartForm, true);
                            }
                        }, 2500);
                        BSS_B2B.handleQuickview_2087();
                    });
                }
                if (BSS_B2B.storeId === 2988) {
                    let productElems = document.querySelectorAll(
                        '.product-section[data-section-type="product"]:not([data-modal="false"])');
                    if (productElems.length) {
                        BSS_B2B.cp.changeProductPrice(shopData,
                            '.product-section[data-section-type="product"]:not([data-modal="false"]) .product__price:not(product__price--compare) > span',
                            false);
                    }
                }
            }

            //QTY-BREAK table for quickview
            if (isEnableQB && BSS_B2B.qbRules && BSS_B2B.qbRules.length) {
                // customize for detecton
                if (BSS_B2B.storeId === 1778) {
                    const quickProducts = $('.grid-product__link.quick-product__btn');
                    quickProducts.on('click', function() {
                        const productId = $(this).attr('data-product-id');
                        let urlData = `/search?q=id:"${productId}"&view=bss.b2b`;
                        let encodeUrlData = encodeURI(urlData);
                        $.get(encodeUrlData, function(data) {
                            let responseProducts = [];
                            try {
                                responseProducts = JSON.parse(data);
                            } catch (e) {
                                // eslint-disable-next-line no-console
                                console.log('b2b: JSON parse returns no item');
                            }
                            if (responseProducts.length > 0) {
                                const productTags = responseProducts[0].tags;
                                BSS_B2B.qb.generateTableOnProductListingPage(productId, productTags);
                            }
                        });
                    });
                }
            }
            //End

        }

    }, 100);

    let detectShopifyPaymentTimes = 0;
    let detectShopifyPaymentInterval = setInterval(function() {
        if (detectShopifyPaymentTimes <= 12) {
            if (((!BSS_B2B.configData && !BSS_B2B.plConfigData) ||
                    (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0) || !isEnableCP) &&
                (!BSS_B2B.qbRules || BSS_B2B.qbRules.length === 0 || !isEnableQB) && !isEnabledTE && !isEnableSr &&
                !isEnableAMO && !isEnabledQI && !isEnableEF) {
                clearInterval(detectShopifyPaymentInterval);
                return;
            }
            let cartForms = $('form[action*="/cart/add"]'
                + BSS_B2B.getCssSelector('product_cart_form'),
            );
            let buyItNowBtn = $(
                '.shopify-payment-button__button:not([disabled]):not(.bss-b2b-cp-dynamic),' + '.btn-cart,'
                + '.shopify-payment-button__more-options:not([disabled]):not(.bss-b2b-cp-dynamic),'
                +
                '.shopify-payment-button__button.shopify-payment-button__button--unbranded:not([disabled]):not(.bss-b2b-cp-dynamic),'
                + '.button.button--primary.ctm-buynow_et:not([disabled]):not(.bss-b2b-cp-dynamic),'
                + 'form[action*="/cart/add"] button[data-checkout="checkout"]'
                + (BSS_B2B.getCssSelector('product_buy_it_now_btn') !== '' ? (BSS_B2B.getCssSelector(
                    'product_buy_it_now_btn') + ':not([disabled]):not(.bss-b2b-cp-dynamic)') : ''),
            );
            if (BSS_B2B.storeId ===1651) cartForms = $('form[action*="/cart/add"].product-form')
            if (cartForms.length && buyItNowBtn.length) {

                // fix for goodscollectiveco ny dongnv
                if (BSS_B2B.storeId === 4946 || BSS_B2B.storeId === 3628) {
                    setTimeout(() => {
                        for (let i = 0; i < cartForms.length; i++) {
                            BSS_B2B.makeCloneBuyItNow(cartForms[i]);
                        }
                    }, 1000);
                }
                else if ([5028, 4041, 5683].indexOf(BSS_B2B.storeId) !== -1 && BSS_B2B.cp.productAfterUseCP.length ===
                    0 && BSS_B2B.qb.appliedQbRuleForOneProduct === false) {
                    if ([4041, 5683].indexOf(BSS_B2B.storeId) !== -1) {
                        buyItNowBtn.attr('style', 'display: block !important');
                    }
                    clearInterval(detectShopifyPaymentInterval);
                    return;
                }
                else if (BSS_B2B.storeId === 9557) {
                    let customerTag = shopData.customer.tags ? shopData.customer.tags : [];
                    if (customerTag.includes('wholesale')) {
                        for (let i = 0; i < cartForms.length; i++) {
                            BSS_B2B.makeCloneBuyItNow(cartForms[i]);
                        }
                    }
                    else {
                        buyItNowBtn.attr('style', 'display: block !important');
                    }
                }
                else if (BSS_B2B.storeId === 12385) {
                    let customerTag = shopData.customer.tags ? shopData.customer.tags : [];
                    if (customerTag.includes('wholesale customer')) {
                        for (let i = 0; i < cartForms.length; i++) {
                            BSS_B2B.makeCloneBuyItNow(cartForms[i]);
                        }
                    }
                }
                else {
                    for (let i = 0; i < cartForms.length; i++) {
                        BSS_B2B.makeCloneBuyItNow(cartForms[i]);
                    }
                }
                clearInterval(detectShopifyPaymentInterval);

            }
        }
        else {
            clearInterval(detectShopifyPaymentInterval);
        }

        detectShopifyPaymentTimes++;
    }, 500);

    if (isEnabledTE) {
        runscript_Tax.handleVatExemptSelectedChange();
        runscript_Tax.handleVatExemptInputChange();
    }
    window.BSS_B2B.executeAction({tag: `ol_on_cart_page`, storeId: 13270, shopData});
}

function runscript_debounce(functionRun, delayTime) {
    let functionTimeout;

    return function() {
        // Receive arguments
        const args = arguments;
        const context = this;

        if (functionTimeout) clearTimeout(functionTimeout);

        functionTimeout = setTimeout(() => {
            functionRun.apply(context, args);
        }, delayTime);
    };
}

// EXTERNAL MODULE: ./js/src/form/utilities.js
var utilities = __webpack_require__(0);
var utilities_default = /*#__PURE__*/__webpack_require__.n(utilities);

// CONCATENATED MODULE: ./js/src/form/init-registration-form.js

function initRegistrationForm($, BSS_B2B, shopData, enableModule) {
    BSS_B2B.RF = {};
    BSS_B2B.RF.data = {};
    BSS_B2B.RF.getVatInputNumber = 0;
    BSS_B2B.RF.getABNInputNumber = 0;
    BSS_B2B.RF.getGSTInputNumber = 0;
    BSS_B2B.RF.getUKInputNumber = 0;
    BSS_B2B.RF.getUSEinInputNumber = 0;
    BSS_B2B.RF.requireFields = [];
    BSS_B2B.RF.oldBorderCSS =  $('#RegisterForm-FirstName').length ? $('#RegisterForm-FirstName').css('border') : $('input').css('border');
    BSS_B2B.RF.validateFieldMessages = new Map();
    BSS_B2B.RF.validateVATMessages = new Map();

    let rootRoute = '/';
    if(window.Shopify && window.Shopify.routes && window.Shopify.routes.root){
        rootRoute = window.Shopify.routes.root;
    }

    if (rootRoute.endsWith("/")) {
        BSS_B2B.redirect_url = rootRoute + BSS_B2B.redirect_url;
    } else {
        BSS_B2B.redirect_url = rootRoute + "/" + BSS_B2B.redirect_url;
    }
    
    const statusMessage = utilities_default.a.getStatusMessage();
    const keyRFSettingObject = utilities_default.a.getKeyRFSettingObject();

    utilities_default.a.rfCssStyles();

    BSS_B2B.RF.getAllProvinceViaCountry = function (countryCode) {
        let stateField = document.querySelector("#state-field");
        let label = document.querySelector("label[for='state-field']");
        if (countryCode.length >= 4) {
            let foundCountry = false;
            for (let i = 0; i < bssB2BArrayCountry.length; i++) {
                if (bssB2BArrayCountry[i].label.toLowerCase() === countryCode.trim().toLowerCase()) {
                    countryCode = bssB2BArrayCountry[i].value;
                    foundCountry = true;
                    break;
                }
            }
            if (!foundCountry && stateField) {
                stateField.classList.remove("state-field-show");
                label.classList.remove("state-field-show");
                return [];
            }
        } else if (countryCode.length > 2 && stateField) {
            stateField.classList.remove("state-field-show");
            label.classList.remove("state-field-show");
            return [];
        }
        let options = [];
        if ([3576, 9420, 11978, 10715, 11630].includes(BSS_B2B.storeId)) options.push({ 'label': '-- select state --', 'value': '' });
        let country = bssB2BArrayState[countryCode];
        if (country) {
            if (country.provinces) {
                options = [...options, ...country.provinces];
            }
        }
        if ((options.length > 0 && BSS_B2B.storeId !== 9420) || ([3576, 9420, 11978].includes(BSS_B2B.storeId) && options.length > 1)) {
            if (stateField && label) {
                stateField.classList.add("state-field-show");
                label.classList.add("state-field-show");
            }
        } else {
            if (stateField && label) {
                stateField.classList.remove("state-field-show");
                label.classList.remove("state-field-show");
            }
        }
        return options;
    };

    BSS_B2B.RF.isAccountPage = function () {
        let hrefArr = window.location.href.split("/");
        let isAccountPage = (hrefArr[hrefArr.length - 1] === "account");
        return isAccountPage;
    };

    BSS_B2B.RF.isEditFormPage = function (editFormUrl) {
        let hrefArr = window.location.href.split("/");
        let isCustomPage = (hrefArr[hrefArr.length - 2] === "pages");
        let isEditFormPage = false;
        if (isCustomPage) {
            let hrefEditArr = hrefArr[hrefArr.length - 1].split('?');
            if (hrefEditArr[0] === editFormUrl && hrefEditArr[1] === 'edit') {
                isEditFormPage = true;
            }
        }
        return isEditFormPage;
    };

    let passwordId = '';
    let checkPageAndID = (BSS_B2B.storeId === 8986 && !["/pages", "/account/register"].includes(window.location.pathname));
    if (window.location.pathname === '/account/login' || BSS_B2B.storeId === 5686 || checkPageAndID) {
        let url = new URL(window.location.href);
        let isBssLogin = url.searchParams.get('isBssLogin');
        if (BSS_B2B.rfGeneralSettings.registerPage_url) {
            const skipAnchorHrefTags = ["#recover"];
            if(skipAnchorHrefTags.indexOf($('#customer_login a:last').attr("href")) === -1) {
                $('#customer_login a:last').attr("href", BSS_B2B.rfGeneralSettings.registerPage_url);
            }
            // Fix for cosmic-hair-co by Devlin
            // Fix redirect register from for most customer by Devlin
            $('a[href="/account/register"]').attr("href", BSS_B2B.rfGeneralSettings.registerPage_url);
        }
        if (isBssLogin === 'true') {
            $("form[action='/account/login'] input[type='email']").val(window.localStorage.getItem('bssEmail'));
            $("form[action='/account/login'] input[type='submit']").off();

            $("form[action='/account/login'] input[type='submit']").click();
            window.localStorage.removeItem('bssEmail');
        }
        // fix for case form register in page /account/login by hoaduong (witchdoom.myshopify.com)
        let registerForm = $('#create_customer');
        if ([10788].includes(BSS_B2B.storeId)) {
            registerForm = $('#RegisterForm');
        }
        if (registerForm.length) {
            let isBSSCustomForm = $('[bss-b2b-is-email-field]').closest('form');
            let passwordField = $(isBSSCustomForm).find('input[type*="password"]');
            $(isBSSCustomForm).prepend('<div id="bss-b2b-registration-form-top"></div>');
            if (passwordField.length) {
                passwordId = $(passwordField[0]).attr('id');
                $(passwordField[0]).after('<div id="bss-b2b-registration-form-render"></div>');
            }
        }
        // fix portgroup by vitu
        if (BSS_B2B.storeId === 596) {
            let isBSSCustomForm = $('#create-customer form');
            $(isBSSCustomForm).removeAttr('novalidate');
            let passwordField = $(isBSSCustomForm).find('input[type*="password"]');

            if (passwordField.length) {
                passwordId = $(passwordField[0]).attr('id');
                // fix for stbjyoti by ThaBi
                if ($(passwordField[0]).parent().hasClass('field')) {
                    $(passwordField[0]).parent().after('<div id="bss-b2b-registration-form-render"></div>');
                } else {
                    $(passwordField[0]).after('<div id="bss-b2b-registration-form-render"></div>');
                }
            }
        }
    } else if (window.location.pathname.includes('/account/register') || BSS_B2B.storeId === 14244) {
        let isBSSCustomForm = $('[bss-b2b-is-email-field]').closest('form');

        // fix portgroup by vitu
        if (BSS_B2B.storeId === 596) {
            isBSSCustomForm = $('[bss-b2b-is-email-field]').closest('#customer-wrapper').find('#create-customer form');
        }
        // fix sleve-mobile-reseller-chile by XuTho, fix for manucurist-pro by mitri,fix for babak-leather materielelectriquemaroc by AnhTV
        //   fix for racer-australia  mydiysupplies by DongNV. theme Empire V2
        if ([2627, 1238, 5605, 4515, 5870, 5892, 1222, 1510, 6795, 6904, 6976, 7720, 8234, 8076, 8184, 9232, 9830, 12241].indexOf(BSS_B2B.storeId) !== -1) {
            isBSSCustomForm = $('form[action*="/account"]#create_customer');
        }
        if (BSS_B2B.storeId === 5294) {
            isBSSCustomForm = $('form[action*="/account"]#register-customer');
        }

        $(isBSSCustomForm).removeAttr('novalidate');
        $(isBSSCustomForm).prepend('<div id="bss-b2b-registration-form-top"></div>');
        let passwordField = $(isBSSCustomForm).find('input[type*="password"]');
        if ([10047, 11454, 9774].includes(BSS_B2B.storeId)) {
            passwordField = $(isBSSCustomForm).find('input[type*="password"]').parent();
        }
        // fix sleve-mobile-reseller-chile by XuTho
        if (BSS_B2B.storeId === 15065) {
            passwordField = $(isBSSCustomForm).find('.form-fields-columns')
        }
        if (BSS_B2B.storeId === 2627) {
            passwordField = $(isBSSCustomForm).find('.input-filed-password');
        }
        // fix for zakelijk by Devlin
        if (BSS_B2B.storeId === 4201) {
            passwordField = $(isBSSCustomForm).find('.input.password-field');
        }
        if (passwordField.length && BSS_B2B.created_account !== 0) {
            passwordId = $(passwordField[0]).attr('id');
            // fix for stbjyoti by ThaBi
            if ($(passwordField[0]).parent().hasClass('field')) {
                $(passwordField[0]).parent().after('<div id="bss-b2b-registration-form-render"></div>');
            } else if ($(passwordField[0]).parent().parent().hasClass('field')) {
                $(passwordField[0]).parent().parent().after('<div id="bss-b2b-registration-form-render"></div>');
            } else if ([3355, 4618, 2238, 4346, 5294, 6587, 8992, 9420, 9015, 9774,13578, 4201].indexOf(BSS_B2B.storeId) !== -1) {
                $(passwordField[0]).parent().after('<div id="bss-b2b-registration-form-render"></div>');
            } else {
                $(passwordField[0]).after('<div id="bss-b2b-registration-form-render"></div>');
            }
        } else {
            let emailField = $('[bss-b2b-is-email-field]');
            if ([12241].indexOf(BSS_B2B.storeId) !== -1) {
                emailField = $(isBSSCustomForm).find('input[type="email"]');
                if (emailField.parent().hasClass('field')) {
                    emailField.parent().parent().after('<div id="bss-b2b-registration-form-render"></div>');
                }
            }
            if (emailField.length) {
                if (emailField.parent().hasClass('field')) {
                    emailField.parent().after('<div id="bss-b2b-registration-form-render"></div>');
                } else {
                    emailField.after('<div id="bss-b2b-registration-form-render"></div>');
                }
            }
            if (BSS_B2B.storeId === 5294) {
                emailField = $(isBSSCustomForm).find('input[type="email"]');
                if (emailField.length) {
                    $(emailField[0]).parent().after('<div id="bss-b2b-registration-form-render"></div>');
                }
            }
        }
    } else if (window.location.pathname.endsWith('/account') || BSS_B2B.storeId == 8184) {
        if (shopData.customer && shopData.customer.id) {
            let data = {
                customerId: "gid://shopify/Customer/" + shopData.customer.id,
            };
            fetch(bssB2bApiServer + `/wholesaler/registration/customer-custom-field?domain=${shopData.shop.permanent_domain}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).then(response => response.json())
                .then(dataRes => {
                    if (dataRes.success) {
                        if ($('#bss-b2b-customer_info').length > 0) {
                            $('#bss-b2b-customer_info').remove();
                        }
                        if (dataRes.value) {
                            if (BSS_B2B.storeId === 14332) $('[bss-b2b-custom-info-field]').before($(`<p bss-email>Email: ${shopData.customer.email}</p>`).css("margin", "0"))
                            if(BSS_B2B.storeId === 13637) {
                                const pattern = /Adres:.*?<br\/>Postcode:.*?<br\/>Plaats:.*?<br\/>Land:.*?<br\/>/;
                                const replacedString  = dataRes.value.replace(pattern, "");
                                const match = dataRes.value.match(pattern);
                                const matchedText = match ? match[0] : "";
                                const pattern2 = /Ik ga akkoord met de Algemene voorwaarden:.*?<br\/>/;
                                const replacedString2  = replacedString.replace(pattern2, "");
                                $("[href='/account/addresses']").before(matchedText);
                                $('[bss-b2b-custom-info-field]').after(replacedString2);
                            } else {
                                $('[bss-b2b-custom-info-field]').after(dataRes.value); 
                            }
                        }
                        window.BSS_B2B.executeAction({tag: "custom_account_page", storeId: 15284, customerData: dataRes.value})
                    }
                });
        }
    } else {
        if (window.location.pathname.includes("/account/addresses")) {
            window.BSS_B2B.executeAction({tag: "custom_address_page", storeId: 13637, shopData})
        }
        // fix portgroup by vitu (form login in login to access page app)
        if (BSS_B2B.storeId === 596) {
            let isBSSCustomForm = $('#create-customer form');
            $(isBSSCustomForm).removeAttr('novalidate');
            let passwordField = $(isBSSCustomForm).find('input[type*="password"]');

            if (passwordField.length) {
                passwordId = $(passwordField[0]).attr('id');
                // fix for stbjyoti by ThaBi
                if ($(passwordField[0]).parent().hasClass('field')) {
                    $(passwordField[0]).parent().after('<div id="bss-b2b-registration-form-render"></div>');
                } else {
                    $(passwordField[0]).after('<div id="bss-b2b-registration-form-render"></div>');
                }
            }
        }
    }
   
    utilities_default.a.renderIconTogglePassword($);
 
    let fbRender = $('#bss-b2b-registration-form-render');
    let fbRenderTop = $('#bss-b2b-registration-form-top');
    // fix for login form on header by ThaBi
    let fbRenderTopHeader = $('#bss-b2b-registration-form-render-top-header');
    let fbRenderBottomHeader = $('#bss-b2b-registration-form-render-bottom-header');
    // end fix for login form on header by ThaBi
    let closestForm = $('#bss-b2b-registration-form-render').closest('form');
    if (closestForm) {
        closestForm.attr("novalidate", "novalidate");
    }
    let closestFormHeader = $('#bss-b2b-registration-form-render-bottom-header').closest('form');
    // fix by ThaBi: change setTimeout remove attribute onsubmit to setInterval
    setInterval(function () {
        $(closestForm).removeAttr('onsubmit');
        $(closestFormHeader).removeAttr('onsubmit');
    }, 2000);
    // end fix by ThaBi
    let status = BSS_B2B.status;

    BSS_B2B.RF.formatABN = function (number) {
        let rmSpaceNumber = number.replace(/\s/g, '');
        let numberArr = rmSpaceNumber.split('');
        if (numberArr.length === 11) {
            numberArr[1] = numberArr[1] + ' ';
            numberArr[4] = numberArr[4] + ' ';
            numberArr[7] = numberArr[7] + ' ';
        }
        let correctNumber = numberArr.join('');
        return correctNumber;
    };

    BSS_B2B.RF.getVatValidationInput = function () {
        BSS_B2B.RF.getVatInputNumber = BSS_B2B.RF.getVatInputNumber + 1;
        if (BSS_B2B.RF.getVatInputNumber === 3) {
            return;
        }
        if ($('#vat-validation').length) {
            $("#vat-validation").change(function () {
                BSS_B2B.RF.validationVatField($("#vat-validation").val());
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getVatValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getABNValidationInput = function () {
        BSS_B2B.RF.getABNInputNumber = BSS_B2B.RF.getABNInputNumber + 1;
        if (BSS_B2B.RF.getABNInputNumber === 3) {
            return;
        }
        if ($('#abn-validation').length) {
            let companyFields = $('#company-field');
            if (companyFields.length) {
                companyFields.attr("disabled", true);
            }
            $("#abn-validation").change(function () {
                BSS_B2B.RF.validationABNField($("#abn-validation").val());
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getABNValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getGSTValidationInput = function () {
        BSS_B2B.RF.getGSTInputNumber = BSS_B2B.RF.getGSTInputNumber + 1;
        if (BSS_B2B.RF.getGSTInputNumber === 3) {
            return;
        }
        if ($('#gst-validation').length) {
            $("#gst-validation").change(function () {
                BSS_B2B.RF.validationGSTField($("#gst-validation").val());
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getGSTValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getUKValidationInput = function () {
        BSS_B2B.RF.getUKInputNumber = BSS_B2B.RF.getUKInputNumber + 1;
        if (BSS_B2B.RF.getUKInputNumber === 3) {
            return;
        }
        if ($('#uk-validation').length) {
            $("#uk-validation").change(function () {
                BSS_B2B.RF.validationUKField($("#uk-validation").val());
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getUKValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getUSEinValidationInput = function () {
        BSS_B2B.RF.getUSEinInputNumber = BSS_B2B.RF.getUSEinInputNumber + 1;
        if (BSS_B2B.RF.getUSEinInputNumber === 3) {
            return;
        }
        if ($('#us-ein-validation').length) {
            $("#us-ein-validation").change(function () {
                BSS_B2B.RF.validationUSEinField($("#us-ein-validation").val());
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getUSEinValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.validationVatField = function (data) {
        utilities_default.a.removeAllMessage($);
        const newData = data.trim();
        const idVatElement = '#vat-validation';
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const vat_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.vat_not_valid, statusMessage.VAT_NOT_VALID);
        const vat_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.vat_valid, statusMessage.SUCCESS);
        if (newData !== "") {
            const countryCode = newData.substring(0, 2);
            $(loading_element).insertAfter(idVatElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/vat?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: { countryCode: countryCode, vatNumber: newData },
                success: function (result) {
                    utilities_default.a.removeAllMessage($);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idVatElement);
                        $(vat_valid_element).insertAfter(idVatElement);
                    } else {
                        $(vat_not_valid_element).insertAfter(idVatElement);
                        BSS_B2B.RF.validateVATMessages.set(idVatElement, vat_not_valid_element);
                        BSS_B2B.integrate.langShop.handleAllTranslation('rf', ['vat_not_valid']);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($);
                    $(vat_not_valid_element).insertAfter(idVatElement);
                    BSS_B2B.RF.validateVATMessages.set(idVatElement, vat_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idVatElement)
        }
    };

    BSS_B2B.RF.validationABNField = function (data) {
        utilities_default.a.removeAllMessage($);
        const newData = data.trim();
        const idABNElement = '#abn-validation';
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const abn_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.abn_not_valid, statusMessage.ABN_NOT_VALID);
        if (newData !== "") {
            $(loading_element).insertAfter(idABNElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/abn?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: { abn: newData },
                success: function (result) {
                    utilities_default.a.removeAllMessage($);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idABNElement);
                        const abn_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.abn_valid, statusMessage.ABN_VALID, '', result);
                        if ($('#company-field').length && BSS_B2B.storeId !== 9726) {
                            $('#company-field').val(result.name);
                            if (BSS_B2B.CL && BSS_B2B.CL.allowToUse && BSS_B2B.CL.customEvent) document.dispatchEvent(BSS_B2B.CL.customEvent);
                            if(BSS_B2B.storeId === 11769){
                                $('#company-field~label').addClass("handle-transition")
                            }
                        }
                        let abnFormat = BSS_B2B.RF.formatABN($(idABNElement).val());
                        $(idABNElement).val(abnFormat);
                        $(abn_valid_element).insertAfter(idABNElement);
                    } else {
                        $(abn_not_valid_element).insertAfter(idABNElement);
                        BSS_B2B.RF.validateVATMessages.set(idABNElement, abn_not_valid_element);
                        BSS_B2B.integrate.langShop.handleAllTranslation('rf', ['abn_not_valid']);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($);
                    BSS_B2B.RF.validateVATMessages.set(idABNElement, abn_not_valid_element);
                    $(abn_not_valid_element).insertAfter(idABNElement);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idABNElement)
        }
    };

    BSS_B2B.RF.validationGSTField = function (data) {
        utilities_default.a.removeAllMessage($);
        const newData = data.trim();
        const idGSTElement = '#gst-validation';
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const gst_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.gst_valid, statusMessage.SUCCESS);
        const gst_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.gst_not_valid, statusMessage.GST_NOT_VALID);
        if (newData !== "") {
            $(loading_element).insertAfter(idGSTElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/gst?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: { gstNumber: newData },
                success: function (result) {
                    utilities_default.a.removeAllMessage($);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idGSTElement);
                        $(gst_valid_element).insertAfter(idGSTElement);
                    } else {
                        $(gst_not_valid_element).insertAfter(idGSTElement);
                        BSS_B2B.RF.validateVATMessages.set(idGSTElement, gst_not_valid_element);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($);
                    $(gst_not_valid_element).insertAfter(idGSTElement);
                    BSS_B2B.RF.validateVATMessages.set(idGSTElement, gst_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idGSTElement);
        }
    };

    BSS_B2B.RF.validationUKField = function (data) {
        utilities_default.a.removeAllMessage($);
        const newData = data.trim();
        const idUkElement = '#uk-validation';
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const uk_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.uk_valid, statusMessage.SUCCESS);
        const uk_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.uk_not_valid, statusMessage.UK_NOT_VALID);
        if (newData !== "") {
            $(loading_element).insertAfter(idUkElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/uk-vat?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: { ukVatNumber: newData },
                success: function (result) {
                    utilities_default.a.removeAllMessage($);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idUkElement);
                        $(uk_valid_element).insertAfter(idUkElement);
                    } else {
                        $(uk_not_valid_element).insertAfter(idUkElement);
                        BSS_B2B.RF.validateVATMessages.set(idUkElement, uk_not_valid_element);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($);
                    $(uk_not_valid_element).insertAfter(idUkElement);
                    BSS_B2B.RF.validateVATMessages.set(idUkElement, uk_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idUkElement)
        }
    };

    BSS_B2B.RF.validationUSEinField = function (data) {
        utilities_default.a.removeAllMessage($);
        const newData = data.trim();
        const idUsEinElement = '#us-ein-validation';
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const us_ein_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.us_ein_not_valid, statusMessage.US_EIN_NOT_VALID);
        if (newData !== "") {
            $(loading_element).insertAfter(idUsEinElement);
            const pattern = /^(\d{2}-\d{7})$/;
            if (pattern.test(newData)) {
                fetch(bssB2bApiServer + `/wholesaler/valid/us-ein-vat?domain=${shopData.shop.permanent_domain}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ usEinNumber: data })
                })
                    .then(res => res.json())
                    .then((result) => {
                        utilities_default.a.removeAllMessage($);
                        if (result.success) {
                            BSS_B2B.RF.validateVATMessages.delete(idUsEinElement)
                            const us_ein_valid = utilities_default.a.getMessageRFSetting(keyRFSettingObject.us_ein_valid, statusMessage.US_EIN_VALID, '', result);
                            $(us_ein_valid).insertAfter(idUsEinElement);
                        } else {
                            $(us_ein_not_valid_element).insertAfter(idUsEinElement);
                            BSS_B2B.RF.validateVATMessages.set(idUsEinElement,us_ein_not_valid_element)
                        }
                    }).catch(error => {
                        // eslint-disable-next-line no-console
                        console.log(error)
                        utilities_default.a.removeAllMessage($);
                        $(us_ein_not_valid_element).insertAfter(idUsEinElement);
                        BSS_B2B.RF.validateVATMessages.set(idUsEinElement,us_ein_not_valid_element)
                    })
            } else {
                utilities_default.a.removeAllMessage($);
                $(us_ein_not_valid_element).insertAfter(idUsEinElement);
                BSS_B2B.RF.validateVATMessages.set(idUsEinElement,us_ein_not_valid_element);
            }
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idUsEinElement)
        }
    };

    BSS_B2B.RF.getRequireField = function () {
        // check Privacy Policy
        if (BSS_B2B.formPrivacyPolicyStatus) {
            let checkPrivacyPolicy = document.querySelector('#bss_rf_privacy_policy').checked;
            if (!checkPrivacyPolicy) {
                const privacyPolicyMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_privacy_policy, statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(`bss_rf_privacy_policy`, privacyPolicyMsgElement);
            }
        }
        // end check Privacy Policy

        let requiredField = $('.formbuilder-required');
        BSS_B2B.RF.requireFields = [];
        //eslint-disable-next-line
        const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
        const email_format_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.email_format, statusMessage.FAILED);
        requiredField.map((index, item) => {
            let existField = $(item).parent().parent();
            let allClassNameOfRequireField = existField.attr('class').split(' ');
            if (allClassNameOfRequireField[2] && !allClassNameOfRequireField.includes(`bss-b2b-rf-conditional-logic-hide`)) {
                let classNameRequireField = allClassNameOfRequireField[2].replace('field-', '');
                const valueInput = $('#' + classNameRequireField).val();
                const typeInput = $('#' + classNameRequireField).attr('type');
                if (typeInput === 'email' && valueInput !== '') {
                    if (!valueInput.match(mailFormat)) {
                        BSS_B2B.RF.validateFieldMessages.set(classNameRequireField, email_format_element)
                    }
                } else if (valueInput === '') {
                    if (BSS_B2B.RF.requireFields.indexOf(classNameRequireField) === -1) {
                        BSS_B2B.RF.requireFields.push(classNameRequireField);
                    }
                } else {
                    $('#' + classNameRequireField).css('border', BSS_B2B.RF.oldBorderCSS);
                }

                if ($(`input[id*=${classNameRequireField}][type="checkbox"]`).length > 0 && $(`[id*=${classNameRequireField}]`).attr("required") ) {
                    if (BSS_B2B.RF.requireFields.indexOf(classNameRequireField) === -1) {
                        BSS_B2B.RF.requireFields.push(classNameRequireField.replace(/-+\d*$/, '-0'));
                    }
                }
            }
        });

        const inputPassword = 'input[name="customer[password]"]';
        const inputEmail = 'input[name="customer[email]"]';
        const inputFirstName = 'input[name="customer[first_name]"]';
        if ($(closestForm).find(inputPassword).length && $(closestForm).find(inputPassword).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(closestForm).find(inputPassword).attr('id')) === -1) {
                BSS_B2B.RF.requireFields.push($(closestForm).find(inputPassword).attr('id'));
            }
        } else {
            $(closestForm).find(inputPassword).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(closestForm).find(inputEmail).length && $(closestForm).find(inputEmail).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(closestForm).find(inputEmail).attr('id')) === -1) {
                BSS_B2B.RF.requireFields.push($(closestForm).find(inputEmail).attr('id'));
            }
        } else {
            $(closestForm).find(inputEmail).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(closestForm).find(inputFirstName).length && $(closestForm).find(inputFirstName).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(closestForm).find(inputFirstName).attr('id')) === -1) {
                BSS_B2B.RF.requireFields.push($(closestForm).find(inputFirstName).attr('id'));
            }
        } else {
            $(closestForm).find(inputFirstName).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        // form header
        if ($(closestFormHeader).find(inputPassword).length && $(closestFormHeader).find(inputPassword).val() === '') {
            BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputPassword).attr('id'));
        } else {
            $(closestFormHeader).find(inputPassword).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(closestFormHeader).find(inputEmail).length && $(closestFormHeader).find(inputEmail).val() === '') {
            BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputEmail).attr('id'));
        } else {
            $(closestFormHeader).find(inputEmail).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(closestFormHeader).find(inputFirstName).length && $(closestFormHeader).find(inputFirstName).val() === '') {
            BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputFirstName).attr('id'));
        } else {
            $(closestFormHeader).find(inputFirstName).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if (BSS_B2B.storeId === 9420) {
            if ($(closestForm).find('select#state-field.state-field-show').length && $(closestForm).find('select#state-field.state-field-show').val() === '') {
                BSS_B2B.RF.requireFields.push($(closestForm).find('select#state-field.state-field-show').attr('id'));
            }
        }
    };

    BSS_B2B.RF.getAllCheckBoxField = function () {
        let checkboxFields = [];
        $("#bss-b2b-registration-form-render,#bss-b2b-registration-form-top").each(function () {
            let allInput = $(this).find(':input');
            allInput.map((index, item) => {
                const parentElement = item.closest(`.form-group`);
                if ($(item).attr('id').includes('checkbox-group') && !($(parentElement).hasClass(`bss-b2b-rf-conditional-logic-hide`))) {
                    let checkboxId = $(item).attr('id').split('-').splice(0, 3).join('-');
                    if (!checkboxFields.includes(checkboxId)) {
                        checkboxFields.push(checkboxId);
                    }
                }
            });
        });
        return checkboxFields;
    };

    BSS_B2B.RF.getAllFileValue = function (form) {
        let fileField = $(form).find("input[type='file']");
        let inputField = [];
        let errorFiled = [];
        const fileTypes = utilities_default.a.getFileTypes();
        if (fileField.length) {
            fileField.map((index, item) => {
                const parentElement = item.closest(`.form-group`);
                if (parentElement && !parentElement.classList.contains(`bss-b2b-rf-conditional-logic-hide`)) {
                    let errorElement = '';
                    let required = $(item).attr('required') === 'required' ? true : false;
                    if (item.files.length) {
                        for (let i = 0; i < item.files.length; i++) {
                            if (item.files[i].size > 10485760) {
                                errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_size, statusMessage.FILE_NOT_VALID, item.files[i].name);
                            }
                            if (fileTypes.indexOf(item.files[i].type) === -1) {
                                errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_type, statusMessage.FILE_NOT_VALID, item.files[i].name);
                            }
                            inputField.push({ id: item.id, file: item.files });
                        }
                    } else if (required) {
                        errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_required, statusMessage.REQUIRED); 
                    }
                    if (errorElement) {
                        BSS_B2B.RF.validateFieldMessages.set(item.id, errorElement);
                        errorFiled.push(0) // 0 = validate false
                    } else {
                        errorFiled.push(1) // 1 = pass validate
                    }
                }
            });
        }
        if (errorFiled.some(v => v === 0)) {
            return { fail: true };
        } else {
            return inputField;
        }
    };

    BSS_B2B.RF.getAllFieldValue = async function (inputArr, checkboxFields) {
        let correctInputArr = [];
        let correctCheck = new Map();
        checkboxFields.map((item) => {
            correctCheck.set(item + '[]', '');
        });
        //eslint-disable-next-line
        const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

        const requiredMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.required_field, statusMessage.REQUIRED);
        const emailFormatMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.email_format, statusMessage.FAILED);
        const passwordTooShortMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.password_too_short, statusMessage.FAILED);
        const phoneInvalidMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.phone_is_invalid, statusMessage.FAILED);
        const customerExistMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.customer_exist, statusMessage.FAILED);
        for (let i = 0; i < inputArr.length; i++) {
            if (inputArr[i].name.includes('password')) {
                if (BSS_B2B.created_account === 3 || BSS_B2B.created_account === 1) {
                    BSS_B2B.RF.data.wholesaler.password = inputArr[i].value;
                    correctInputArr.push({ name: 'password', value: inputArr[i].value });
                    if (inputArr[i].value.length < 5) {
                        BSS_B2B.RF.validateFieldMessages.set('RegisterForm-password', passwordTooShortMsgElement);
                    }
                    if(BSS_B2B.storeId === 14842 && inputArr[i].value.length < 6){
                        let passwordTooShortElement = utilities_default.a.getMessageRFSetting("6文字以上で入力してください。", statusMessage.FAILED);
                        BSS_B2B.RF.validateFieldMessages.set('RegisterForm-password', passwordTooShortElement);
                      }
                } else {
                    correctInputArr.push({ name: 'password', value: null });
                }
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('RegisterForm-password', requiredMsgElement);
                }
            } else if (inputArr[i].name.includes('last_name')) {
                correctInputArr.push({ name: 'last_name', value: inputArr[i].value });
                BSS_B2B.RF.data.wholesaler.last_name = inputArr[i].value;

                //custom require last name
                const customArr = [4927, 8481, 8951, 9831, 13261, 8603];
                if (customArr.includes(BSS_B2B.storeId)) {
                    if (inputArr[i].value == null || inputArr[i].value === '') {
                        BSS_B2B.RF.validateFieldMessages.set('RegisterForm-LastName', requiredMsgElement);
                    }
                }
            } else if (inputArr[i].name.includes('email')) {
                correctInputArr.push({ name: 'email', value: inputArr[i].value.trim() });
                BSS_B2B.RF.data.wholesaler.email = inputArr[i].value.trim();
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('RegisterForm-email', requiredMsgElement);
                } else if (!inputArr[i].value.match(mailFormat)) {
                    BSS_B2B.RF.validateFieldMessages.set('RegisterForm-email', emailFormatMsgElement);
                } else if (inputArr[i].value.trim()) {
                    const noPhoneField = false;
                    const messages = await BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm(noPhoneField);
                    if (messages.length) {
                        messages.map((v) => {
                            if (v.customer_exist) {
                                BSS_B2B.RF.validateFieldMessages.set('RegisterForm-email', customerExistMsgElement);
                            }
                        })
                    }
                }
            } else if (inputArr[i].name.includes('first_name')) {
                correctInputArr.push({ name: 'first_name', value: inputArr[i].value });
                BSS_B2B.RF.data.wholesaler.first_name = inputArr[i].value;
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('RegisterForm-FirstName', requiredMsgElement);
                }
            } else if (inputArr[i].name.includes('number')) {
                const inputElement = $(`input[name=${inputArr[i].name}]`);
                if (!inputElement.parent().hasClass(`bss-b2b-rf-conditional-logic-hide`)) {
                    const minValue = inputElement.attr('min');
                    const maxValue = inputElement.attr('max');
                    
                    if (minValue && !maxValue && (parseInt(inputArr[i].value) < parseInt(minValue)) && inputArr[i].value !== '') {
                        const largerThanElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.greater_than, statusMessage.NUMBER_IS_GREATER_THAN, minValue);
                        BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, largerThanElement);
                    } else if (!minValue && maxValue && (parseInt(inputArr[i].value) > parseInt(maxValue)) && inputArr[i].value !== '') {
                        const lessThanElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.less_than, statusMessage.NUMBER_IS_LESS_THAN, maxValue);
                        BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, lessThanElement);
                    } else if (minValue && maxValue && (parseInt(inputArr[i].value) > parseInt(maxValue) || parseInt(inputArr[i].value) < parseInt(minValue)) && inputArr[i].value !== '') {
                        const betweenElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.between, statusMessage.NUMBER_IS_BETWEEN, {min: minValue, max: maxValue});
                        BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, betweenElement);
                    } else {
                        correctInputArr.push({ name: inputArr[i].name, value: inputArr[i].value });
                    }
                }
            } else if (inputArr[i].name.includes('phone')) {
                const inputElement = $(`input[name=${inputArr[i].name}]`);
                if (!inputElement.parent().hasClass(`bss-b2b-rf-conditional-logic-hide`)) {
                    const hasPhoneField = true;
                    const messages = await BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm(hasPhoneField);
                    if (messages.length) {
                        messages.map((v) => {
                            if (v.phone_already_exists && BSS_B2B.storeId === 15246) {
                                const phoneAlreadyExistsMsgElement = utilities_default.a.getMessageRFSetting(`Number already exists`, statusMessage.FAILED);
                                BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, phoneAlreadyExistsMsgElement);
                            }
                            if (v.phone_is_invalid) {
                                BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, phoneInvalidMsgElement);
                            }
                            if (v.customer_exist) {
                                BSS_B2B.RF.validateFieldMessages.set('RegisterForm-email', customerExistMsgElement);
                            }
                        })
                    }
                    correctInputArr.push({ name: inputArr[i].name, value: inputArr[i].value });
                }
            } else {
                if (!inputArr[i].name.includes('utf8') && !inputArr[i].name.includes('form_type')) {
                    const element = $(`.field-${inputArr[i].name.replace(`[]`, ``)}`);
                    if (!element.hasClass(`bss-b2b-rf-conditional-logic-hide`)) {
                        if (inputArr[i].name.includes('checkbox-group')) {
                            let value = '';
                            if (correctCheck.get(inputArr[i].name)) {
                                value = correctCheck.get(inputArr[i].name) + ',' + inputArr[i].value;
                            } else {
                                value = inputArr[i].value;
                            }
                            correctCheck.set(inputArr[i].name, value);
                        } else {
                            correctInputArr.push(inputArr[i]);
                        }
                    }
                }
            }
        }
        correctCheck.forEach((value, index) => {
            correctInputArr.push({ name: index, value: value });
        });
        return correctInputArr;
    };

    BSS_B2B.RF.getPhoneFieldValue = function () {
        const phoneFields = $('#phone-field');
        const parentField = $('.field-phone-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && phoneFields.length) {
            return phoneFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getCompanyFieldValue = function () {
        const companyFields = $('#company-field');
        const parentField = $('.field-company-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && companyFields.length) {
            return companyFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getApartmentFieldValue = function () {
        const apartmentFields = $('#apartment-field');
        const parentField = $('.field-apartment-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && apartmentFields.length) {
            return apartmentFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getAddressFieldValue = function () {
        const addressFields = $('#address-field');
        const parentField = $('.field-address-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && addressFields.length) {
            return addressFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getCityFieldValue = function () {
        const cityFields = $('#city-field');
        const parentField = $('.field-city-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && cityFields.length) {
            return cityFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getStateCodeFieldValue = function () {
        const stateField = $('#state-field');
        const parentField = $('.field-state-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && stateField.length) {
            return stateField.val();
        }
        return ``;
    };

    BSS_B2B.RF.getStateNameFieldValue = function () {
        const stateField = $('#state-field');
        const parentField = $('.field-state-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && stateField.length) {
            return $('#state-field option:selected').text();
        }
        return ``;
    };

    BSS_B2B.RF.getCountryCodeFieldValue = function () {
        if ($(`.field-country-field`).length && !($(`.field-country-field`).hasClass(`bss-b2b-rf-conditional-logic-hide`))) {
            if ($('#country-field-input').length || $('#country-field').length) {
                let countryCodeValue = $('#country-field').val();
                if (typeof bssB2BArrayCountry !== 'undefined') {
                    for (let i = 0; i < bssB2BArrayCountry.length; i++) {
                        if (countryCodeValue === bssB2BArrayCountry[i].label) {
                            countryCodeValue = bssB2BArrayCountry[i].value;
                            return countryCodeValue;
                        }
                    }
                }
                return countryCodeValue;
            }
        }
        return ``;
    };

    BSS_B2B.RF.getCountryNameFieldValue = function () {
        if ($(`.field-country-field`).length && !($(`.field-country-field`).hasClass(`bss-b2b-rf-conditional-logic-hide`))) {
            if ($('#country-field-input').length) {
                return $('#country-field-input')[0].value;
            } else if ($('#country-field').length) {
                return $('#country-field option:selected').text();
            }
        }
        return ``;
    };

    BSS_B2B.RF.getZipFieldValue = function () {
        const zipFields = $('#zip-field');
        const parentField = $('.field-zip-field');
        if (parentField.length && !parentField.hasClass(`bss-b2b-rf-conditional-logic-hide`) && zipFields.length) {
            return zipFields[0].value;
        }
        return ``;
    };

    BSS_B2B.RF.getAcceptMarketingValue = function () {
        let acceptMarketingField = $('#accepts-marketing-0').is(":checked");
        return acceptMarketingField;
    };

    BSS_B2B.RF.renderReCAPCHA = function () {
        const dataSiteKey = BSS_B2B.CAPCHA_SITE_KEY;
        let submitBtn = $(closestForm).find('[type=submit]');
        //fix moosecreekscreenprintdesigns by hoaduong
        if (submitBtn.length === 0 && BSS_B2B.storeId === 4250) {
            submitBtn = $(closestForm).find('button');
        }
        if (submitBtn.length === 0) {
            let defaultForm = $('#bss-b2b-registration-form-render').closest('form#create_customer');
            if (defaultForm.length) {
                submitBtn = $(closestForm).find('button');
            }
        }
        if (submitBtn.length) {
            if (BSS_B2B.storeId === 3404) {
                $(submitBtn).parent().parent().before(`<div class="g-recaptcha" data-sitekey="${dataSiteKey}" data-callback="correctCaptcha"></div>`);
            } else {
                $(submitBtn).before(`<div class="g-recaptcha" data-sitekey="${dataSiteKey}" data-callback="correctCaptcha"></div>`);
            }
            let bssB2BLoadScript = function (url, callback) {
                let script = document.createElement("script");
                script.type = "text/javascript";
                // If the browser is Internet Explorer.
                if (script.readyState) {
                    script.onreadystatechange = function () {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            callback();
                        }
                    };
                    // For any other browser.
                } else {
                    script.onload = function () {
                        callback();
                    };
                }

                script.src = url;
                document.getElementsByTagName("head")[0].appendChild(script);

            };
            bssB2BLoadScript('https://www.google.com/recaptcha/api.js', function () {
                $(submitBtn).on('click', function (e) {
                    const storeId = BSS_B2B.storeId;
                    BSS_B2B.RF.validateFieldMessages.clear();
                    if (BSS_B2B.storeId === 3576) {
                        let storeGroupElem = document.getElementById('select-1648015104934');
                        if (storeGroupElem) {
                            if (storeGroupElem.value === 'option-1') storeGroupElem.value = '';
                        }
                        if (!$(closestForm)[0].checkValidity()) {
                            $(closestForm)[0].reportValidity();
                            return;
                        }
                    }
                    e.preventDefault();
                    const recaptchaRes = $('[name=g-recaptcha-response]').val();
                    utilities_default.a.removeAllMessage($);
                    if(sessionStorage.getItem("verifyCaptcha") && recaptchaRes) {
                        $(submitBtn).submit();
                    } else {
                        $.ajax({
                            type: "POST",
                            url: bssB2bApiServer + '/recapcha/verify',
                            dataType: 'JSON',
                            data: {
                                'domain': Shopify.shop,
                                'g-recaptcha-response': recaptchaRes,
                                'store_id': storeId
                            },
                            success: async function (result) {
                                utilities_default.a.removeAllMessage($);
                                if (result.success) {
                                    $('.reCAPCHA-err').remove();
                                    sessionStorage.setItem("verifyCaptcha", "true")
                                    setTimeout(() =>{
                                        sessionStorage.removeItem("verifyCaptcha")
                                    }, 50000)
                                    $(submitBtn).submit();
                                } else {
                                    const complete_reCapcha_task_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_reCapcha_task, statusMessage.FAILED);
                                    BSS_B2B.RF.data = {
                                        formId: BSS_B2B.formId ? BSS_B2B.formId : BSS_B2B.formIdDef,
                                        wholesaler: {
                                            email: null,
                                            first_name: null,
                                            last_name: null,
                                            custom_field: [],
                                            raw_form_data: '',
                                            edited_form_data: '',
                                            status: BSS_B2B.created_account !== 1 ? 0 : 1
                                        }
                                    };
                                    let { fileInputArr } = await utilities_default.a.validationAllFieldBeforeSubmitForm($, closestForm, false);
                                    // display all error message
                                    const keysValidateField = [...BSS_B2B.RF.validateFieldMessages.keys()];
                                    const keysValidateVat = [ ...BSS_B2B.RF.validateVATMessages.keys()];
                                    if (keysValidateField.length || keysValidateVat.length || fileInputArr.fail) {
                                        utilities_default.a.removeAllMessage($);
                                        utilities_default.a.displayValidateMessage(keysValidateField, keysValidateVat, submitBtn, closestForm);
                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $(closestForm).offset().top - 300
                                        }, 600);
                                        if (BSS_B2B.reCAPCHA && (typeof grecaptcha !== "undefined")) {
                                            //reset reCAPCHA
                                            grecaptcha.reset();
                                            $(submitBtn).before(`<div class="reCAPCHA-err">${complete_reCapcha_task_element}</div>`);
                                        }
                                        return;
                                    }
                                }
                            },
                            error: async function (XMLHttpRequest, textStatus, errorThrown) {
                                // eslint-disable-next-line no-console
                                console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                                utilities_default.a.removeAllMessage($);
                                const complete_reCapcha_task_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_reCapcha_task, statusMessage.FAILED);
                                $(submitBtn).before(`<div class="reCAPCHA-err">${complete_reCapcha_task_element}</div>`);
                            }
                        });
                    }
                });
                let correctCaptcha = function (response) {
                    if (response.length) {
                        $('.reCAPCHA-err').remove();
                    }
                };
                window.correctCaptcha = correctCaptcha;
            });
        }
    };

    BSS_B2B.RF.renderPrivacyPolicy = function () {
        let submitBtn = $(closestForm).find('[type=submit]');
        let formRenderBottom = $('#bss-b2b-registration-form-render');
        if (BSS_B2B.formPrivacyPolicyContent.length) {
            const content = `<div class='bss_rf_privacy_policy_container'><input type="checkbox" id="bss_rf_privacy_policy" name="bss_rf_privacy_policy"> <label for="bss_rf_privacy_policy">${BSS_B2B.formPrivacyPolicyContent}</label></div>`;
            if (submitBtn.length) {
                $(submitBtn).before(content);
            } else if (formRenderBottom.length) {
                $(formRenderBottom).after(content);
            }
        }
    };

    BSS_B2B.RF.handleSubmitFormDefault = function (form, formData) {
        formData.map(item => {
            if (item.name === "country-field") {
                item.values = [];
            }
        });
        let submitBtn = $(closestForm).find('[type=submit], button');
        $(form).submit(async function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            e.stopPropagation();
            submitBtn.attr('disabled', 'disabled');
            BSS_B2B.RF.validateFieldMessages.clear();
            utilities_default.a.removeAllMessage($);
            const loadingElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.LOADING);
            $(form).prepend(loadingElement);
            BSS_B2B.RF.data = {
                formId: BSS_B2B.formId ? BSS_B2B.formId : BSS_B2B.formIdDef,
                wholesaler: {
                    email: null,
                    first_name: null,
                    last_name: null,
                    custom_field: [],
                    raw_form_data: JSON.stringify(formData),
                    edited_form_data: JSON.stringify(formData),
                    status: BSS_B2B.created_account !== 1 ? 0 : 1
                }
            };

            let isEditForm = false;
            let queryString = new URLSearchParams(window.location.href.split('?')[1]);
            for (let pair of queryString.entries()) {
                if (pair[0] === "edit") {
                    isEditForm = true;
                }
            }
            if (window.location.pathname === '/account/register' || [5686, 8986, 10788].includes(BSS_B2B.storeId)) {
                BSS_B2B.formDataRender = BSS_B2B.formDataRender ? BSS_B2B.formDataRender : BSS_B2B.formDataRenderDefault;
            }

            let {correctInputArr, fileInputArr} = await utilities_default.a.validationAllFieldBeforeSubmitForm($, form, false);
            // display all error message
            const keysValidateField = [...BSS_B2B.RF.validateFieldMessages.keys()];
            const keysValidateVat = [ ...BSS_B2B.RF.validateVATMessages.keys()];
            if (keysValidateField.length || keysValidateVat.length || fileInputArr.fail) {
                utilities_default.a.removeAllMessage($);
                utilities_default.a.displayValidateMessage(keysValidateField, keysValidateVat, submitBtn, form);
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(form).offset().top - 300
                }, 600);
                if (BSS_B2B.reCAPCHA && (typeof grecaptcha !== "undefined")) {
                    //reset reCAPCHA
                    grecaptcha.reset();
                }
                return;
            }
            // end display

            // start sent request
            if ([6579, 6747].includes(BSS_B2B.storeId)) {
                const formSelectorCustom = [
                    // BSS_B2B.storeId = 6579
                    '.account-page-content form[action*="/contact#contact_form"]',
                    // BSS_B2B.storeId = 6747
                    'form[action*="/account"]#RegisterForm'
                ]
                $(formSelectorCustom.join(",")).prepend(loadingElement);
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(formSelectorCustom).offset().top - 15
                }, 600);
            } else if (![9849, 7207, 11143, 12079].includes(BSS_B2B.storeId)) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(form).offset().top - 15
                }, 600);
            }
            // start upload file
            if (fileInputArr.length && !keysValidateField.length && !keysValidateVat.length) {
                let listResJson = [];
                let isSuccess = false;
                await Promise.all(fileInputArr.map(async (item, index)=> {
                    if (item.file.length) {
                        let uploadFormData = new FormData();
                        uploadFormData.append('storeId', BSS_B2B.storeId);
                        uploadFormData.append('file', item.file[0]);
                        let res = await fetch(`${bssB2bApiServer}/upload_file?domain=${shopData.shop.permanent_domain}`, {
                            method: 'POST',
                            body: uploadFormData
                        });
                        let resJson = await res.json();
                        listResJson[index] = resJson;
                        isSuccess = isSuccess || resJson.success
                    }
                }));
                if(isSuccess) {
                    BSS_B2B.RF.data.wholesaler.aws_file_url = [];
                    BSS_B2B.RF.data.wholesaler.store_file_url = [];
                    fileInputArr.map((item, index)=> {
                        if (item.file.length && listResJson[index].success) {
                            listResJson[index].files.map(file => {
                                if (file.originalname === item.file[0].name) {
                                    BSS_B2B.RF.data.wholesaler.aws_file_url.push(({
                                        name: item.id,
                                        value: file.path
                                    }));
                                    correctInputArr.push({ name: item.id, value: file.path });
                                }
                            });
                            BSS_B2B.RF.data.wholesaler.store_file_url.push({
                                name: item.id,
                                value: listResJson[index].fileUrl
                            })
                        }
                    });
                } else {
                    utilities_default.a.removeAllMessage($);
                    const upload_file_fail_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.upload_file_to_server, statusMessage.FAILED);
                    $('form[action*="/account"]').prepend(upload_file_fail_element);
                    return;
                }
            }
            // end upload file
            BSS_B2B.RF.data.wholesaler.custom_field = JSON.stringify(correctInputArr);
            let customerNoteMap = new Map();
            BSS_B2B.formDataRender.map((item, idx) => {
                if (item.name !== 'email' && item.name !== 'password' && item.name !== 'first_name' && item.name !== 'last_name') {
                    customerNoteMap.set(item.name, item.label ? item.label.replace(new RegExp('&nbsp;', 'g'), '') : `${item.type}-${idx}`);
                }
            });
            let currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            let note = '';
            if (![6318, 8841].includes(BSS_B2B.storeId)) {
                note = `===start custom fields by bss-b2b-rf=== \n`;
            }
            if (![4798, 8841].includes(BSS_B2B.storeId)) {
                if (BSS_B2B.storeId === 6318) {
                    note = `${currentDate}\n`;sessionStorage.setItem("verifyCaptcha", "true")
                } else {
                    note += `---${currentDate}--- & \n`;
                }
            }
            let fileUploadNote = ``;
            JSON.parse(BSS_B2B.RF.data.wholesaler.custom_field).map(item => {
                if (customerNoteMap.get(item.name.replace('[]', '')) !== null && customerNoteMap.get(item.name.replace('[]', '')) !== undefined && item.value && (item.name.replace('[]', '') !== 'phone-field' && item.name.replace('[]', '') !== 'company-field' && item.name.replace('[]', '') !== 'apartment-field' && item.name.replace('[]', '') !== 'address-field' && item.name.replace('[]', '') !== 'city-field' && item.name.replace('[]', '') !== 'state-field' && item.name.replace('[]', '') !== 'country-field' && item.name.replace('[]', '') !== 'zip-field')) {
                    if (customerNoteMap.get(item.name.replace('[]', '')) !== '') {
                        if (item.name.includes('file-')) {
                            let rightFormatValue = item.value.replace(new RegExp('&', 'g'), '');
                            fileUploadNote += `${customerNoteMap.get(item.name.replace('[]', ''))}: <a href="${bssB2bApiServer}/upload_file/download_customer_file_from_url?filePath=${rightFormatValue}&downloadType=2&domain=${shopData.shop.permanent_domain}" target="_blank">${rightFormatValue}</a><br/> \n`;
                            note += `${customerNoteMap.get(item.name.replace('[]', ''))}: ${item.value.split('/').pop()} & \n`;
                        } else {
                            if (item.name.replace('[]', '') === "accepts-marketing") {
                                note += `${customerNoteMap.get(item.name.replace('[]', ''))} : Yes  &  \n`;
                            }else{
                                note += `${customerNoteMap.get(item.name.replace('[]', ''))}: ${item.value} & \n`;
                            }           
                        }
                    } else {
                        if (item.name.includes('file-')) {
                            let rightFormatValue = item.value.replace(new RegExp('&', 'g'), '');
                            fileUploadNote += `<a href="${bssB2bApiServer}/upload_file/download_customer_file_from_url?filePath=${rightFormatValue}&downloadType=2&domain=${shopData.shop.permanent_domain}" target="_blank">${rightFormatValue}</a><br/> \n`;
                            note += `${item.value.split('/').pop()} & \n`;
                        } else {
                            note += `${item.value} & \n`;
                        }
                    }
                    if (BSS_B2B.storeId === 1123) {
                        if (item.name === 'vat-validation') {
                            BSS_B2B.RF.data.wholesaler.custom_tag = "VAT-ID:" + item.value;
                        }
                    }
                }
                if ([9548].includes(BSS_B2B.storeId)) {
                    if (item.name == "company-field" || item.name == "phone-field") {
                        note += `${customerNoteMap.get(item.name.replace('[]', ''))}: ${item.value} & \n`;
                    }
                }
            })
            if (![6318, 8841].includes(BSS_B2B.storeId)) {
                note += `===end custom fields by bss-b2b-rf=== \n`;
            }
            // fix for metrio.eu by mitri
            if (BSS_B2B.storeId === 1445) {
                let euVat = note.match(/[A-Z]{2}\w+\d/);
                note = euVat && euVat.length ? euVat[0] : note;
            }
            if (BSS_B2B.storeId === 8537) {
                let euVat = note.match(/[A-Z]{2}\w+\d/);
                let nameVat = customerNoteMap.get('vat-validation'.replace('[]', ''));
                if (nameVat !== '') {
                    note = euVat && euVat.length ? `${nameVat} : ${euVat}` : note;
                } else {
                    note = euVat && euVat.length ? `VAT-ID : ${euVat}` : note;
                }
            }
            if ([11769, 5750].includes(BSS_B2B.storeId)) {
                note = ""
            }

            BSS_B2B.RF.data.wholesaler.note = note;
            BSS_B2B.RF.data.wholesaler.aws_file_url = JSON.stringify(BSS_B2B.RF.data.wholesaler.aws_file_url);
            BSS_B2B.RF.data.wholesaler.store_file_url = JSON.stringify(BSS_B2B.RF.data.wholesaler.store_file_url);
            BSS_B2B.RF.data.wholesaler.fileUploadNote = fileUploadNote;
            BSS_B2B.RF.data.wholesaler.tax_exempt = BSS_B2B.taxExempt;
            BSS_B2B.RF.data.wholesaler.phone = BSS_B2B.RF.getPhoneFieldValue();
            BSS_B2B.RF.data.wholesaler.company = BSS_B2B.RF.getCompanyFieldValue();
            BSS_B2B.RF.data.wholesaler.address = BSS_B2B.RF.getAddressFieldValue();
            BSS_B2B.RF.data.wholesaler.city = BSS_B2B.RF.getCityFieldValue();
            BSS_B2B.RF.data.wholesaler.state_code = BSS_B2B.RF.getStateCodeFieldValue();
            BSS_B2B.RF.data.wholesaler.apartment = BSS_B2B.RF.getApartmentFieldValue();
            BSS_B2B.RF.data.wholesaler.country_code = BSS_B2B.RF.getCountryCodeFieldValue();
            BSS_B2B.RF.data.wholesaler.state_name = BSS_B2B.RF.getStateNameFieldValue();
            BSS_B2B.RF.data.wholesaler.country_name = BSS_B2B.RF.getCountryNameFieldValue();
            BSS_B2B.RF.data.wholesaler.zip = BSS_B2B.RF.getZipFieldValue();
            BSS_B2B.RF.data.wholesaler.accepts_marketing = BSS_B2B.RF.getAcceptMarketingValue();
            BSS_B2B.RF.data.wholesaler.locale = window.Shopify.locale ? window.Shopify.locale : "";
            if (isEditForm) {
                utilities_default.a.updateWholesalerRegistration($, shopData.shop.permanent_domain, BSS_B2B.RF.data, submitBtn, keyRFSettingObject, statusMessage);
            } else {
                utilities_default.a.createWholesalerRegistration($, shopData.shop.permanent_domain, BSS_B2B.RF.data, submitBtn, keyRFSettingObject, statusMessage);
            }
        });
    };

    BSS_B2B.RF.appliedCustomerInformation = function () {
        $('.text-center .btn').attr('value', 'Save');
        let customerInformation = JSON.parse(localStorage.getItem('customerInformation'));
        let fileUploads = JSON.parse(localStorage.getItem('fileUploaded'));
        let inputElements = document.querySelectorAll("#RegisterForm input, #RegisterForm select, #RegisterForm textarea");
        $('#RegisterForm-email').css('display', 'none');
        $('#RegisterForm-password').css('display', 'none');
        $('label[for="RegisterForm-email"]').css('display', 'none');
        $('label[for="RegisterForm-password"]').css('display', 'none');
        $('#RegisterForm input[type="checkbox"]').prop('checked', false);
        if (inputElements && inputElements.length > 0 && customerInformation && customerInformation.length > 0) {
            inputElements.forEach((element) => {
                if (element.getAttribute('id') && element.getAttribute('id').includes('file')) {
                    if (element.getAttribute('id').includes('file')) {
                        if (fileUploads && fileUploads.length > 0) {
                            fileUploads.forEach(function (file) {
                                if (file.name === element.getAttribute('id')) {
                                    let fileNameArr = file.value.split('/');
                                    let fileName = fileNameArr[fileNameArr.length - 1];
                                    if (fileName) {
                                        $(element).after(`File Uploaded: ${fileName}`);
                                    }
                                }
                            });
                        }
                    }
                } else {
                    customerInformation.every(function (information) {
                        if ((element.getAttribute('name') && element.getAttribute('name').includes(information.name))
                            || (element.getAttribute('id') && element.getAttribute('id').includes(information.name))
                        ) {
                            if (element.getAttribute('id') === "country-field") {
                                if (bssB2BArrayCountry && bssB2BArrayCountry.length > 0) {
                                    bssB2BArrayCountry.map((country) => {
                                        if (country.value === information.value) {
                                            $('#country-field-input').val(country.label);
                                            $('#country-field').val(country.value);
                                        }
                                    });
                                }
                                let listWidth = $('.field-country-field').width();
                                let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($('#country-field').val());
                                let optionState = ``;
                                for (let i = 0; i < stateInCountry.length; i++) {
                                    optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
                                }
                                if ($('#state-field').length) {
                                    $('#state-field').html('');
                                    setTimeout(() => {
                                        $('#state-field').html(optionState);
                                    }, 100);
                                }
                                if ($('#country-field-list')) {
                                    $('#country-field-list').css({
                                        'display': 'block',
                                        'margin-top': '0px',
                                        'width': '' + listWidth + 'px',
                                        'overflow': 'auto'
                                    });
                                }
                                return false;
                            } else if (element.getAttribute('id') === "state-field") {
                                let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($('#country-field').val());
                                if (stateInCountry && stateInCountry.length > 0) {
                                    stateInCountry.every(function (state) {
                                        if (state.value === information.value) {
                                            setTimeout(function () {
                                                $(element).val(state.value);
                                            }, 1000);
                                            return false;
                                        }
                                        return true;
                                    });
                                }
                            } else if (element.getAttribute('id').includes("checkbox-group") || element.getAttribute('id').includes("radio-group") || element.getAttribute('id').includes("accepts-marketing")) {
                                if (information.value.includes(element.getAttribute('value'))) {
                                    let checkBoxValueArr = information.value.split(',');
                                    if (checkBoxValueArr && checkBoxValueArr.length > 0) {
                                        checkBoxValueArr.every((checkBoxValue) => {
                                            if (checkBoxValue === element.getAttribute('value')) {
                                                $(element).trigger('click');
                                                return false;
                                            }
                                            return true;
                                        });
                                    }
                                }
                            } else if (element.getAttribute('id').includes('validation') && information.value != "") {
                                element.value = information.value;
                                $(element).trigger('change');
                            } else {
                                element.value = information.value;
                            }
                            return false;
                        }
                        return true;
                    });
                }
            });
        }

    };

    if (enableModule) {
        if (fbRender.length && status !== 0 && fbRenderTop.length && (BSS_B2B.formDataRender || BSS_B2B.formDataRenderDefault)) {
            let formData = BSS_B2B.formDataRender ? BSS_B2B.formDataRender : BSS_B2B.formDataRenderDefault;
            let formRenderDataTop = [];
            let formRenderDataBottom = [];
            formData = formData.filter(item => {
                if (item.name === "us-ein-validation" && BSS_B2B.planCode !== "platinum") {
                    return false;
                } else {
                    return true;
                }
            });
            formData.map(item => {
                if (item.name === "country-field") {
                    item.values = bssB2BArrayCountry ? bssB2BArrayCountry : [];
                    if (BSS_B2B.storeId === 9605) {
                        if (window.location.pathname === '/pages/nederlands-verdelers') {
                            item.values = [{ label: "Nederland", value: "NL" }];
                        } else if (window.location.pathname === '/pages/belgische-verdelers') {
                            item.values = [{ label: "België", value: "BE" }];
                        }
                    } else if (BSS_B2B.storeId === 13525) {
                        item.values = [{ label: "Italia", value: "IT" }];
                    } else if (BSS_B2B.storeId === 14388) {
                        item.values = [{ label: "United States", value: "US" }];
                    } else if (BSS_B2B.storeId === 14458) {
                        item.values = [
                            { label: "United States", value: "US" },
                            { label: "Canada", value: "CA" }
                        ];
                    } else if (BSS_B2B.storeId === 15200 && window.countryCodeCustom) {
                        item.values = window.countryCodeCustom
                    }

                }
                if (item.name === "state-field") {
                    item.values = [];
                    item.required = false;
                }
                if (BSS_B2B.storeId === 9629 && item.type === 'select') {
                    item.values.map(itemSelect => {
                        if (itemSelect.selected) {
                            itemSelect.selected = false;
                        }
                    });
                    item.values.unshift({ label: "", value: "", selected: true });
                }
                if (item.placement === 'top') {
                    formRenderDataTop.push(item);
                } else {
                    formRenderDataBottom.push(item);
                }
            });


            if (BSS_B2B.storeId === 12292) {
                let label = null;      
                if (window.location.pathname === '/pages/begloss-registrierungsform') {
                    label = {
                        company: 'Firma',
                        phone: 'Telefon',
                        validation: 'EU Umsatzsteuer-ID',
                        apartment: 'Adresse',
                        address: 'Adresse',
                        zip: 'Postleitzahl',
                        city: 'Ort',
                        country: 'Land',
                        state: 'Bundesland',
                    };
                } else if (window.location.pathname === '/fr/pages/begloss-registrierungsform') {
                    label = {
                        company: 'Société',
                        phone: 'Téléphone',
                        validation: 'Numéro de TVA',
                        apartment: 'Adresse',
                        address: 'Adresse',
                        zip: 'Code postal',
                        city: 'Lieu',
                        country: 'Pays',
                        state: 'Département',
                    };
                }
                if(label) {
                    formData.map(item => {
                        switch (item.name) {
                            case "company-field":
                                item.label = label.company;
                                break;
                            case "phone-field":
                                item.label = label.phone;
                                break;
                            case "vat-validation":
                                item.label = label.validation;
                                break;
                            case "apartment-field":
                                item.label = label.address;
                                break;
                            case "address-field":
                                item.label = label.address;
                                break;
                            case "zip-field":
                                item.label = label.zip;
                                break;
                            case "city-field":
                                item.label = label.city;
                                break;
                            case "country-field":
                                item.label = label.country;
                                break;
                            case "state-field":
                                item.label = label.state;
                                break;
                            default:
                        }
                    });
                }
            }

            if (BSS_B2B.created_account === 0) {
                let passwordElement = $('form[action*="/account"] input[type*="password"]');
                if (BSS_B2B.storeId === 5686) {
                    passwordElement = $('.login-rowRight form[action*="/account"]  input[type*="password"],' + 'form[action*="/account"] label[for*="password"]');
                }
                if (BSS_B2B.storeId === 13036) {
                    passwordElement = $('#create_customer input[type*="password"]');
                    if (passwordElement.parent().parent().hasClass('form-row')) {
                        passwordElement.parent().parent().remove();
                    }
                }
                if (passwordElement.parent().hasClass('field')) {
                    passwordElement.parent().remove();
                } else {
                    passwordElement.remove();
                }
                if (passwordId) {
                    $('form[action*="/account"] label[for="' + passwordId + '"]').remove();
                }
                if (BSS_B2B.storeId === 3976 && $('form[action*="/account"] #password').length) {
                    $('form[action*="/account"] #password').remove();
                }
                if ([5294, 6605].indexOf(BSS_B2B.storeId) !== -1) {
                    let labelPassword = $('form[action*="/account"] label[for*="password"]');
                    if (labelPassword) {
                        labelPassword.parent().remove();
                    }
                }
            }
            if (BSS_B2B.created_account !== 2) {
                if (formRenderDataTop.length) {
                    $(fbRenderTop).formRender({
                        formData: formRenderDataTop,
                        dataType: 'json'
                    });
                }
                if([12793, 16086].includes(BSS_B2B.storeId) && ["/pages/combine-save-account-registration-v2", "/pages/patient-combine-save-account-registration-nz"].includes(window.location.pathname)) {
                    setTimeout(() => {
                        if (formRenderDataBottom.length) {
                            $(fbRender).formRender({
                                formData: formRenderDataBottom,
                                dataType: 'json'
                            });
                        }
                    }, 1500);
                } else {
                    if (formRenderDataBottom.length) {
                        $(fbRender).formRender({
                            formData: formRenderDataBottom,
                            dataType: 'json'
                        });
                    }
                }
                let timeout = 500;
                // fix koshani by vitu
                if (BSS_B2B.storeId === 1643) {
                    timeout = 1000;
                }
                BSS_B2B.CL.initFirstLoad();
                setTimeout(function () {
                    BSS_B2B.RF.getRequireField();
                }, timeout);
            }
            BSS_B2B.RF.getVatValidationInput();
            BSS_B2B.RF.getABNValidationInput();
            BSS_B2B.RF.getGSTValidationInput();
            BSS_B2B.RF.getUKValidationInput();
            BSS_B2B.RF.getUSEinValidationInput();
            if (BSS_B2B.created_account !== 2) {
                BSS_B2B.RF.handleSubmitFormDefault(closestForm, formData);
            }
            if (BSS_B2B.formPrivacyPolicyStatus) {
                BSS_B2B.RF.renderPrivacyPolicy();
            }
            if (BSS_B2B.reCAPCHA) {
                BSS_B2B.RF.renderReCAPCHA();
            }
        }

        // fix for login form on header by ThaBi
        if (fbRenderTopHeader.length && fbRenderBottomHeader.length && status !== 0 && BSS_B2B.formDataRender) {
            let formData = BSS_B2B.formDataRender;
            let formRenderDataTopHeader = [];
            let formRenderDataBottomHeader = [];

            formData.map(item => {
                if (item.name === "country-field") {
                    item.values = bssB2BArrayCountry;
                }
                if (item.name === "state-field") {
                    item.values = [];
                    item.require = false;
                }
                if (item.placement === 'top') {
                    formRenderDataTopHeader.push(item);
                } else {
                    formRenderDataBottomHeader.push(item);
                }
            });

            if (BSS_B2B.created_account === 0) {
                $('form[action*="/account"] input[type*="password"]').remove();
                $('form[action*="/account"] label[for="' + passwordId + '"]').remove();
            }
            if (BSS_B2B.created_account !== 2) {
                if (formRenderDataTopHeader.length) {
                    $(fbRenderTopHeader).formRender({
                        formData: formRenderDataTopHeader,
                        dataType: 'json'
                    });
                }
                if (formRenderDataBottomHeader.length) {
                    $(fbRenderBottomHeader).formRender({
                        formData: formRenderDataBottomHeader,
                        dataType: 'json'
                    });
                }
                BSS_B2B.CL.initFirstLoad();
                setTimeout(function () {
                    BSS_B2B.RF.getRequireField();
                }, 500);
            }
            BSS_B2B.RF.getVatValidationInput();
            if (BSS_B2B.created_account !== 2) {
                BSS_B2B.RF.handleSubmitFormDefault(closestFormHeader, formData);
            }
        }
        // end fix for login form on header by ThaBi

        if (BSS_B2B.RF.isEditFormPage(localStorage.getItem("bssPageHandler"))) {
            BSS_B2B.RF.appliedCustomerInformation();
        }
    } else {
        if (window.location.pathname !== '/account/register') {
            let isCustomForm = $('form[action*="/account"]').find('#bss-b2b-registration-form-render');
            if (isCustomForm.length) {
                $('form[action*="/account"]').remove();
            }
        } else {
            $('#bss-b2b-registration-form-render').remove();
        }

    }
    // get zip when change country
    if ($('#country-field-input').length) {
        const changeStateByCountry = () => {
            let listWidth = $('.field-country-field').width();
            let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($('#country-field').val());
            let optionState = ``;
            for (let i = 0; i < stateInCountry.length; i++) {
                optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
            }
            if ($('#state-field').length) {
                $('#state-field').html('');
                setTimeout(() => {
                    $('#state-field').html(optionState);
                }, 100);
            }
            if ($('#country-field-list')) {
                $('#country-field-list').css({
                    'display': 'block',
                    'margin-top': '0px',
                    'width': '' + listWidth + 'px',
                    'overflow': 'auto'
                });
            }
        };

        $('#country-field-input').on("click change", changeStateByCountry);
        $('#country-field-list').on("click mousedown", changeStateByCountry);
        $('#country-field-input').keyup(function (event) {
            // press enter
            const keyCode = (event.keyCode ? event.keyCode : event.which);
            if (keyCode === 13) {
                changeStateByCountry();
            }
        });

        // set default country
        if (BSS_B2B.storeId == 10585) {
            $('#country-field').val('US');
            $('#country-field-input').val('United States');
            changeStateByCountry();
        }
        if (BSS_B2B.storeId === 9605) {
            if (window.location.pathname === '/pages/nederlands-verdelers') {
                $('#country-field').val('NL');
                $('#country-field-input').val("Nederland");
                changeStateByCountry();
            } else if (window.location.pathname === '/pages/belgische-verdelers') {
                $('#country-field').val('BE');
                $('#country-field-input').val("België");
                changeStateByCountry();
            }
        }
    } else if ($('#country-field').length) {
        $('#country-field').change(function () {
            let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($(this).val());
            let optionState = ``;
            for (let i = 0; i < stateInCountry.length; i++) {
                optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
            }
            if ($('#state-field').length) {
                $('#state-field').html('');
                setTimeout(() => {
                    $('#state-field').html(optionState);
                }, 100);
            }
        });
        let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($('#country-field').val());
        let optionState = ``;
        for (let i = 0; i < stateInCountry.length; i++) {
            optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
        }
        if ($('#state-field').length) {
            $('#state-field').html('');
            setTimeout(() => {
                $('#state-field').html(optionState);
            }, 100);
        }
    } else {
        if ($('.field-state-field').length) {
            $('.field-state-field').remove();
        }
    }

    BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm = async function(hasPhoneField) {
        let messages = [];
        const phoneValue = BSS_B2B.RF.getPhoneFieldValue() ? BSS_B2B.RF.getPhoneFieldValue().trim() : '';
        if (!phoneValue && hasPhoneField)
            return messages
        BSS_B2B.RF.data.wholesaler.phone = phoneValue;
        const req = await fetch(bssB2bApiServer + `/wholesaler/valid/phone-number?domain=${shopData.shop.permanent_domain}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(BSS_B2B.RF.data)
        })

        const res = await req.json();
        if (res.success && res.messages.length) {
            res.messages.map(v => messages.push(v))
            return messages
        } else {
            return messages
        }
    }
}

// CONCATENATED MODULE: ./js/src/form/init-registration-mini-form.js

function initRegistrationMiniForm($, BSS_B2B, shopData, enableModule) {
    BSS_B2B.RF = {};
    BSS_B2B.RF.data = {};
    BSS_B2B.RF.getVatInputNumber = 0;
    BSS_B2B.RF.getABNInputNumber = 0;
    BSS_B2B.RF.getGSTInputNumber = 0;
    BSS_B2B.RF.getUKInputNumber = 0;
    BSS_B2B.RF.getUSEinInputNumber = 0;
    BSS_B2B.RF.requireFields = [];
    BSS_B2B.RF.oldBorderCSS =  $('#customer\\[first_name\\]').length ? $('#customer\\[first_name\\]').css('border') : $('input').css('border');
    BSS_B2B.RF.validateFieldMessages = new Map();
    BSS_B2B.RF.validateVATMessages = new Map();
    BSS_B2B.RF.allowContinueSubmit = true;
    
    let rootRoute = '/';
    if(window.Shopify && window.Shopify.routes && window.Shopify.routes.root){
        rootRoute = window.Shopify.routes.root;
    }

    if (rootRoute.endsWith("/")) {
        BSS_B2B.redirect_url = rootRoute + BSS_B2B.redirect_url;
    } else {
        BSS_B2B.redirect_url = rootRoute + "/" + BSS_B2B.redirect_url;
    }

    const statusMessage = utilities_default.a.getStatusMessage();
    const keyRFSettingObject = utilities_default.a.getKeyRFSettingObject();

    utilities_default.a.rfCssStyles();

    BSS_B2B.RF.getAllProvinceViaCountry = function (form, countryCode) {
        let options = [];
        if (BSS_B2B.storeId === 3576) options.push({ 'label': '-- select state --', 'value': '' });
        let country = bssB2BArrayState[countryCode];
        if (country) {
            if (country.provinces) {
                options = [...country.provinces];
            }
        }
        let stateField = form.querySelector("#state-field");
        let label = form.querySelector("label[for='state-field']");
        if (options.length > 0) {
            if (stateField && label) {
                if (
                    !stateField.classList.contains("state-field-show") &&
                    !label.classList.contains("state-field-show")
                ) {
                    stateField.classList.add("state-field-show");
                    label.classList.add("state-field-show");
                    // label.innerText = country.labels.province;
                }
            }
        } else {
            if (stateField && label) {
                if (
                    stateField.classList.contains("state-field-show") &&
                    label.classList.contains("state-field-show")
                ) {
                    stateField.classList.remove("state-field-show");
                    label.classList.remove("state-field-show");
                }
            }
        }
        return options;
    };
    let passwordId = '';

    function loadElement() {
        let isBSSCustomForm = $('[bss-b2b-is-email-field], input[name="customer[password]"]').closest('form[action="/account"]');

        // fix portgroup by vitu
        if (BSS_B2B.storeId === 596) {
            isBSSCustomForm = $('[bss-b2b-is-email-field]').closest('#customer-wrapper').find('#create-customer form');
        }

        $(isBSSCustomForm).removeAttr('novalidate');
        $(isBSSCustomForm).prepend('<div class="bss-b2b-registration-form-top"></div>');
        let passwordField = $(isBSSCustomForm).find('input[type*="password"]');

        if (passwordField.length && BSS_B2B.created_account !== 0) {
            passwordId = $(passwordField).attr('class');
            // fix for export.gam.eu by ducdn
            const customStore = [11037];
            if (customStore.length) {
                $(passwordField).parent().after('<div class="bss-b2b-registration-form-render"></div>');
            } else {
                $(passwordField).parent().after('<div class="bss-b2b-registration-form-render"></div>');
            }
        } else {
            if ($('[bss-b2b-is-email-field], form[action="/account"] input[type="email"]').length) {
                if ([9590].includes(BSS_B2B.storeId)){
                    $('[bss-b2b-is-email-field], form[action="/account"] input[type="email"]').parent().after('<div class="bss-b2b-registration-form-render"></div>');
                } else {
                    $('[bss-b2b-is-email-field], form[action="/account"] input[type="email"]').after('<div class="bss-b2b-registration-form-render"></div>');
                }
            }
        }
        // fix portgroup by vitu (form login in login to access page app)
        if (BSS_B2B.storeId === 596) {
            let isBSSCustomForm = $('#create-customer form');
            $(isBSSCustomForm).removeAttr('novalidate');
            let passwordField = $(isBSSCustomForm).find('input[type*="password"]');

            if (passwordField.length) {
                passwordId = $(passwordField[0]).attr('class');
                $(passwordField).after('<div class="bss-b2b-registration-form-render"></div>');
            }
        }
    }

    if (window.location.pathname === '/account/login') {
        let miniFormPageLogin = $(`form#create_customer, form[name="create"]`);
        if (miniFormPageLogin.length) {
            loadElement();
        }
        let url = new URL(window.location.href);
        let isBssLogin = url.searchParams.get('isBssLogin');
        if (isBssLogin === 'true') {
            $("form[action='/account/login'] input[type='email']").val(window.localStorage.getItem('bssEmail'));
            $("form[action='/account/login'] input[type='password']").val(window.localStorage.getItem('bssPassword'));
            $("form[action='/account/login'] input[type='submit']").off();

            $("form[action='/account/login'] [type='submit']").click();
            window.localStorage.removeItem('bssEmail');
            window.localStorage.removeItem('bssPassword');
        }

        // fix portgroup by vitu
        if (BSS_B2B.storeId === 596) {
            let isBSSCustomForm = $('#create-customer form');
            $(isBSSCustomForm).removeAttr('novalidate');
            let passwordField = $(isBSSCustomForm).find('input[type*="password"]');

            if (passwordField.length) {
                passwordId = $(passwordField[0]).attr('id');
                $(passwordField[0]).after('<div id="bss-b2b-registration-form-render"></div>');
            }
        }
    } else {
        loadElement();
    }

    utilities_default.a.renderIconTogglePassword($);
    let fbRender = $('.bss-b2b-registration-form-render');
    let fbRenderTop = $('.bss-b2b-registration-form-top');
    // fix for login form on header by ThaBi
    let fbRenderTopHeader = $('.bss-b2b-registration-form-render-top-header');
    let fbRenderBottomHeader = $('.bss-b2b-registration-form-render-bottom-header');
    // end fix for login form on header by ThaBi
    if (BSS_B2B.storeId === 11037) {
        fbRenderBottomHeader = $('.bss-b2b-registration-form-render');
        fbRenderTopHeader = $('.bss-b2b-registration-form-top');
    }
    let closestForm = $('.bss-b2b-registration-form-render').closest('form[action="/account"]');
    if(closestForm.length) {
        closestForm.attr('novalidate', 'novalidate')
    }
    let closestFormHeader = $('.bss-b2b-registration-form-render-bottom-header').closest('form[action="/account"]');
    if(closestFormHeader.length) {
        closestFormHeader.attr('novalidate', 'novalidate')
    }
    let timeIntervalForm = 0;
    let timeIntervalFormHeader = 0;
    // fix by ThaBi: change setTimeout remove attribute onsubmit to setInterval
    let removeAttrOnSubmitForm = setInterval(function () {
        if (timeIntervalForm === 5) {
            clearInterval(removeAttrOnSubmitForm);
        } else {
            $(closestForm).removeAttr('onsubmit');
            timeIntervalForm += 1;
        }
    }, 1000);

    let removeAttrOnSubmitFormHeader = setInterval(function () {
        if (timeIntervalFormHeader === 5) {
            clearInterval(removeAttrOnSubmitFormHeader);
        } else {
            $(closestFormHeader).removeAttr('onsubmit');
            timeIntervalFormHeader += 1;
        }
    }, 1000);
    if (closestForm.length) {
        setTimeout(() => {
            $(closestForm).removeAttr('onsubmit');
        }, 1000);
    }
    if (closestFormHeader.length) {
        setTimeout(() => {
            $(closestFormHeader).removeAttr('onsubmit');
        }, 1000);
    }
    let status = BSS_B2B.status;

    BSS_B2B.RF.formatABN = function (number) {
        let rmSpaceNumber = number.replace(/\s/g, '');
        let numberArr = rmSpaceNumber.split('');
        if (numberArr.length === 11) {
            numberArr[1] = numberArr[1] + ' ';
            numberArr[4] = numberArr[4] + ' ';
            numberArr[7] = numberArr[7] + ' ';
        }
        let correctNumber = numberArr.join('');
        return correctNumber;
    };

    BSS_B2B.RF.getVatValidationInput = function () {
        BSS_B2B.RF.getVatInputNumber = BSS_B2B.RF.getVatInputNumber + 1;
        if (BSS_B2B.RF.getInputNumber === 3) {
            return;
        }
        if ($('.vat-validation').length) {
            $('.vat-validation').each((index, element) => {
                const form = $(element).closest('form[action*="/account"]');
                $(element).change(() => BSS_B2B.RF.validationVatField($(element).val(), form))
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getVatValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getABNValidationInput = function () {
        BSS_B2B.RF.getABNInputNumber = BSS_B2B.RF.getABNInputNumber + 1;
        if (BSS_B2B.RF.getABNInputNumber === 3) {
            return;
        }
        if ($('.abn-validation').length) {
            let companyFields = $('.company-field');
            if (companyFields.length) {
                companyFields.attr("disabled", true);
            }
            $('.abn-validation').each((index, element) => {
                const form = $(element).closest('form[action*="/account"]');
                $(element).change(() => BSS_B2B.RF.validationABNField($(element).val(), form))
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getABNValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getGSTValidationInput = function () {
        BSS_B2B.RF.getGSTInputNumber = BSS_B2B.RF.getGSTInputNumber + 1;
        if (BSS_B2B.RF.getGSTInputNumber === 3) {
            return;
        }
        if ($('.gst-validation').length) {
            $('.gst-validation').each((index, element) => {
                const form = $(element).closest('form[action*="/account"]');
                $(element).change(() => BSS_B2B.RF.validationGSTField($(element).val(), form))
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getGSTValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getUKValidationInput = function () {
        BSS_B2B.RF.getUKInputNumber = BSS_B2B.RF.getUKInputNumber + 1;
        if (BSS_B2B.RF.getUKInputNumber === 3) {
            return;
        }
        if ($('.uk-validation').length) {
            $('.uk-validation').each((index, element) => {
                const form = $(element).closest('form[action*="/account"]');
                $(element).change(() => BSS_B2B.RF.validationUKField($(element).val(), form))
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getUKValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.getUSEinValidationInput = function () {
        BSS_B2B.RF.getUSEinInputNumber = BSS_B2B.RF.getUSEinInputNumber + 1;
        if (BSS_B2B.RF.getUSEinInputNumber === 3) {
            return;
        }
        if ($('.us-ein-validation').length) {
            $('.us-ein-validation').each((index, element) => {
                const form = $(element).closest('form[action*="/account"]');
                $(element).change(() => BSS_B2B.RF.validationUSEinField($(element).val(), form))
            });
        } else {
            setTimeout(() => {
                BSS_B2B.RF.getUSEinValidationInput();
            }, 1000);
        }
    };

    BSS_B2B.RF.validationVatField = function (data, form) {
        utilities_default.a.removeAllMessage($, form);
        const newData = data.trim();
        const idVatSelector = '#vat-validation';
        const vatElement = $(form).find(idVatSelector);
        const loadingElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const vat_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.vat_not_valid, statusMessage.VAT_NOT_VALID);
        const vat_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.vat_valid, statusMessage.SUCCESS);
        if (newData !== "") {
            const countryCode = newData.substring(0, 2);
            vatElement.after(loadingElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/vat?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: {countryCode: countryCode, vatNumber: newData},
                success: function (result) {
                    utilities_default.a.removeAllMessage($, form);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idVatSelector);
                        vatElement.after(vat_valid_element);
                    } else {
                        vatElement.after(vat_not_valid_element)
                        BSS_B2B.RF.validateVATMessages.set(idVatSelector, vat_not_valid_element);
                        BSS_B2B.integrate.langShop.handleAllTranslation('rf');
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($, form);
                    vatElement.after(vat_not_valid_element)
                    BSS_B2B.RF.validateVATMessages.set(idVatSelector, vat_not_valid_element);
                }
            });
        }  else {
            BSS_B2B.RF.validateVATMessages.delete(idVatSelector)
        }
    };

    BSS_B2B.RF.validationABNField = function (data, form) {
        utilities_default.a.removeAllMessage($, form);
        const newData = data.trim();
        const idABNSelector = '#abn-validation';
        const abnElement = $(form).find(idABNSelector);
        const loadingElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const abn_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.abn_not_valid, statusMessage.ABN_NOT_VALID);
        if (newData !== "") {
            abnElement.after(loadingElement);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/abn?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: {abn: newData},
                success: function (result) {
                    utilities_default.a.removeAllMessage($, form);
                    if (result.success) {
                     BSS_B2B.RF.validateVATMessages.delete(idABNSelector);
                        const abn_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.abn_valid, statusMessage.ABN_VALID, '', result);
                        if ($(form).find('#company-field').length) {
                            $(form).find('#company-field').val(result.name);
                        }
                        let abnFormat = BSS_B2B.RF.formatABN(abnElement.val());
                        abnElement.val(abnFormat);
                        abnElement.after(abn_valid_element);
                    } else {
                        abnElement.after(abn_not_valid_element);
                        BSS_B2B.RF.validateVATMessages.set(idABNSelector, abn_not_valid_element);
                        BSS_B2B.integrate.langShop.handleAllTranslation('rf');
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($, form);
                    BSS_B2B.RF.validateVATMessages.set(idABNSelector, abn_not_valid_element);
                    abnElement.after(abn_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idABNSelector);
        }
    };

    BSS_B2B.RF.validationGSTField = function (data, form) {
        utilities_default.a.removeAllMessage($, form);
        const newData = data.trim();
        const idGSTSelector = '#gst-validation';
        const gstElement = $(form).find(idGSTSelector);
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const gst_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.gst_valid, statusMessage.SUCCESS);
        const gst_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.gst_not_valid, statusMessage.GST_NOT_VALID);
        if (newData !== "") {
            gstElement.after(loading_element);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/gst?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: {gstNumber: newData},
                success: function (result) {
                    utilities_default.a.removeAllMessage($, form);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idGSTSelector);
                        gstElement.after(gst_valid_element);
                    } else {
                        gstElement.after(gst_not_valid_element);
                        BSS_B2B.RF.validateVATMessages.set(idGSTSelector, gst_not_valid_element);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($, form);
                    gstElement.after(gst_not_valid_element);
                    BSS_B2B.RF.validateVATMessages.set(idGSTSelector, gst_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idGSTSelector);
        }
    };

    BSS_B2B.RF.validationUKField = function (data, form) {
        utilities_default.a.removeAllMessage($, form);
        const newData = data.trim();
        const idUkSelector = '#uk-validation';
        const ukElement = $(form).find(idUkSelector);
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const uk_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.uk_valid, statusMessage.SUCCESS);
        const uk_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.uk_not_valid, statusMessage.UK_NOT_VALID);
        if (newData !== "") {
            ukElement.after(loading_element);
            $.ajax({
                type: "POST",
                url: bssB2bApiServer + `/wholesaler/valid/uk-vat?domain=${shopData.shop.permanent_domain}`,
                dataType: 'JSON',
                data: {ukNumber: newData},
                success: function (result) {
                    utilities_default.a.removeAllMessage($, form);
                    if (result.success) {
                        BSS_B2B.RF.validateVATMessages.delete(idUkSelector);
                        ukElement.after(uk_valid_element)
                    } else {
                        ukElement.after(uk_not_valid_element)
                        BSS_B2B.RF.validateVATMessages.set(idUkSelector, uk_not_valid_element);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    // eslint-disable-next-line no-console
                    console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                    utilities_default.a.removeAllMessage($, form);
                    ukElement.after(uk_not_valid_element)
                    BSS_B2B.RF.validateVATMessages.set(idUkSelector, uk_not_valid_element);
                }
            });
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idUkSelector)
        }
    };

    BSS_B2B.RF.validationUSEinField = function (data, form) {
        utilities_default.a.removeAllMessage($, form);
        const newData = data.trim();
        const idUsEinSelector = '#us-ein-validation';
        const usEinElement = $(form).find(idUsEinSelector);
        const loading_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.SUCCESS);
        const us_ein_not_valid_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.us_ein_not_valid, statusMessage.US_EIN_NOT_VALID);
        if (newData !== "") {
            usEinElement.after(loading_element);
            const pattern = /^(\d{2}-\d{7})$/;
            if (pattern.test(newData)) {
                fetch(bssB2bApiServer + `/wholesaler/valid/us-ein-vat?domain=${shopData.shop.permanent_domain}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ usEinNumber: newData })
                })
                    .then(res => res.json())
                    .then((result) => {
                        utilities_default.a.removeAllMessage($, form);
                        if (result.success) {
                            BSS_B2B.RF.validateVATMessages.delete(idUsEinSelector);
                            const us_ein_valid = utilities_default.a.getMessageRFSetting(keyRFSettingObject.us_ein_valid, statusMessage.US_EIN_VALID, '', result);
                            usEinElement.after(us_ein_valid);
                        } else {
                            usEinElement.after(us_ein_not_valid_element);
                            BSS_B2B.RF.validateVATMessages.set(idUsEinSelector,us_ein_not_valid_element)
                        }
                    }).catch(error => {
                        // eslint-disable-next-line no-console
                        console.log(error)
                        utilities_default.a.removeAllMessage($, form);
                        usEinElement.after(us_ein_not_valid_element);
                        BSS_B2B.RF.validateVATMessages.set(idUsEinSelector, us_ein_not_valid_element);
                    })
            } else {
                utilities_default.a.removeAllMessage($, form);
                usEinElement.after(us_ein_not_valid_element);
                BSS_B2B.RF.validateVATMessages.set(idUsEinSelector, us_ein_not_valid_element);
            }
        } else {
            BSS_B2B.RF.validateVATMessages.delete(idUsEinSelector);
        }
    };

    BSS_B2B.RF.getRequireField = function (form) {
        // check Privacy Policy
        if (BSS_B2B.formPrivacyPolicyStatus) {
            let checkPrivacyPolicy = false;
            if ($(form).find('input[id="bss_rf_privacy_policy"]').is(':checked')) {
                checkPrivacyPolicy = true;
            };
            if (!checkPrivacyPolicy) {
                const privacyPolicyMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_privacy_policy, statusMessage.FAILED);
                BSS_B2B.RF.validateFieldMessages.set(`bss_rf_privacy_policy`, privacyPolicyMsgElement);
            }
        }
        // end check Privacy Policy
        BSS_B2B.RF.requireFields = [];
        let requiredField = $(form).find('.formbuilder-required');
        //eslint-disable-next-line
        const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

        const email_format_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.email_format, statusMessage.FAILED);
        requiredField.map((index, item) => {
            let parentField = $(item).parent().parent();
            let allClassNameOfRequireField = parentField.attr('class').split(' ');
            if (allClassNameOfRequireField[2]) {
                let classNameRequireField = allClassNameOfRequireField[2].replace('field-', '');
                const valueInput = $('#' + classNameRequireField).val();
                const typeInput = $('#' + classNameRequireField).attr('type');
                if (typeInput === 'email' && valueInput !== '') {
                    if (!valueInput.match(mailFormat)) {
                        BSS_B2B.RF.validateFieldMessages.set(classNameRequireField, email_format_element)
                    }
                } else if (valueInput === '') {
                    if (BSS_B2B.RF.requireFields.indexOf(classNameRequireField) === -1) {
                        BSS_B2B.RF.requireFields.push(classNameRequireField);
                    }
                } else {
                    $('#' + classNameRequireField).css('border', BSS_B2B.RF.oldBorderCSS);
                }

                if ($(form).find(`input[id*=${classNameRequireField}][type="checkbox"]`).length > 0 && $(form).find(`[id*=${classNameRequireField}]`).attr("required") ) {
                    if (BSS_B2B.RF.requireFields.indexOf(classNameRequireField) === -1) {
                           BSS_B2B.RF.requireFields.push(classNameRequireField.replace(/-+\d*$/, '-0'));
                     }
                }
            }
        });

        const inputPassword = 'input[name="customer[password]"]';
        const inputEmail = 'input[name="customer[email]"]';
        const inputFirstName = 'input[name="customer[first_name]"]';
        if ($(form).find(inputPassword).length && $(form).find(inputPassword).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(form).find(inputPassword).attr('name')) === -1) {
                BSS_B2B.RF.requireFields.push($(form).find(inputPassword).attr('name'));
            }
        } else {
            $(form).find(inputPassword).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(form).find(inputEmail).length && $(form).find(inputEmail).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(form).find(inputEmail).attr('name')) === -1) {
                BSS_B2B.RF.requireFields.push($(form).find(inputEmail).attr('name'));
            }
        } else {
            $(form).find(inputEmail).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        if ($(form).find(inputFirstName).length && $(form).find(inputFirstName).val() === '') {
            if (BSS_B2B.RF.requireFields.indexOf($(form).find(inputFirstName).attr('name')) === -1) {
                BSS_B2B.RF.requireFields.push($(form).find(inputFirstName).attr('name'));
            }
        } else {
            $(form).find(inputFirstName).css('border', BSS_B2B.RF.oldBorderCSS);
        }
        // form header
        // if ($(closestFormHeader).find(inputPassword).length && $(closestFormHeader).find(inputPassword).val() === '') {
        //     BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputPassword).attr('name'));
        // } else {
        //     $(closestFormHeader).find(inputPassword).css('border', BSS_B2B.RF.oldBorderCSS);
        // }
        // if ($(closestFormHeader).find(inputEmail).length && $(closestFormHeader).find(inputEmail).val() === '') {
        //     BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputEmail).attr('name'));
        // } else {
        //     $(closestFormHeader).find(inputEmail).css('border', BSS_B2B.RF.oldBorderCSS);
        // }
        // if ($(closestFormHeader).find(inputFirstName).length && $(closestFormHeader).find(inputFirstName).val() === '') {
        //     BSS_B2B.RF.requireFields.push($(closestFormHeader).find(inputFirstName).attr('name'));
        // } else {
        //     $(closestFormHeader).find(inputFirstName).css('border', BSS_B2B.RF.oldBorderCSS);
        // }
    };

    BSS_B2B.RF.getAllCheckBoxField = function (form) {
        let checkboxFields = [];
        $(form).find(".bss-b2b-registration-form-render").each(function () {
            let allInput = $(this).find(':input');
            allInput.map((index, item) => {
                if ($(item).attr('id').includes('checkbox-group')) {
                    let checkboxId = $(item).attr('id').split('-').splice(0, 3).join('-');
                    if (!checkboxFields.includes(checkboxId)) {
                        checkboxFields.push(checkboxId);
                    }
                }
            });
        });
        return checkboxFields;
    };

    BSS_B2B.RF.getAllFileValue = function (form) {
        let fileField = $(form).find("input[type='file']");
        let inputField = [];
        let errorFiled = [];
        const fileTypes = utilities_default.a.getFileTypes();
        if (fileField.length) {
            fileField.map((index, item) => {
                let errorElement = '';
                let required = $(item).attr('required') === 'required' ? true : false;
                if (item.files.length) {
                    for (let i = 0; i < item.files.length; i++) {
                        if (item.files[i].size > 10485760) {
                            errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_size, statusMessage.FILE_NOT_VALID, item.files[i].name); 
                        }
                        if (fileTypes.indexOf(item.files[i].type) === -1) {
                            errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_type, statusMessage.FILE_NOT_VALID, item.files[i].name); 
                        }
                    }
                    inputField.push({ id: item.id, file: item.files });
                } else if (required) {
                    errorElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.file_required, statusMessage.REQUIRED); 
                }
                if (errorElement) {
                    BSS_B2B.RF.validateFieldMessages.set(item.id, errorElement);
                    errorFiled.push(0) // 0 = validate false
                } else {
                    errorFiled.push(1) // 1 = pass validate
                }
            });
        }
        if (errorFiled.some(v => v === 0)) {
            return { fail: true };
        } else {
            return inputField;
        }
    };

    BSS_B2B.RF.getAllFieldValue = async function (inputArr, checkboxFields, form) {
        let correctInputArr = [];
        let correctCheck = new Map();
        checkboxFields.map((item) => {
            correctCheck.set(item + '[]', '');
        });
        //eslint-disable-next-line
        const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
        const requiredMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.required_field, statusMessage.REQUIRED);
        const emailFormatMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.email_format, statusMessage.FAILED);
        const passwordTooShortMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.password_too_short, statusMessage.FAILED);
        const phoneInvalidMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.phone_is_invalid, statusMessage.FAILED);
        const customerExistMsgElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.customer_exist, statusMessage.FAILED);
        for (let i = 0; i < inputArr.length; i++) {
            if (inputArr[i].name.includes('password')) {
                if (BSS_B2B.created_account === 3 || BSS_B2B.created_account === 1) {
                    BSS_B2B.RF.data.wholesaler.password = inputArr[i].value;
                    correctInputArr.push({ name: 'password', value: inputArr[i].value });
                    if (inputArr[i].value.length < 5) {
                        BSS_B2B.RF.validateFieldMessages.set('customer[password]', passwordTooShortMsgElement);
                    }
                } else {
                    correctInputArr.push({ name: 'password', value: null });
                }
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('customer[password]', requiredMsgElement);
                }
            } else if (inputArr[i].name.includes('last_name')) {
                correctInputArr.push({ name: 'last_name', value: inputArr[i].value });
                BSS_B2B.RF.data.wholesaler.last_name = inputArr[i].value;

                //custom require last name
                const customArr = [4927];
                if (customArr.includes(BSS_B2B.storeId)) {
                    if (inputArr[i].value == null || inputArr[i].value === '') {
                        BSS_B2B.RF.validateFieldMessages.set('customer[last_name]', requiredMsgElement);
                    }
                }
            } else if (inputArr[i].name.includes('first_name')) {
                correctInputArr.push({ name: 'first_name', value: inputArr[i].value });
                BSS_B2B.RF.data.wholesaler.first_name = inputArr[i].value;
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('customer[first_name]', requiredMsgElement);
                }
            } else if (inputArr[i].name.includes('email')) {
                correctInputArr.push({ name: 'email', value: inputArr[i].value.trim() });
                BSS_B2B.RF.data.wholesaler.email = inputArr[i].value.trim();
                if (inputArr[i].value == null || inputArr[i].value === '') {
                    BSS_B2B.RF.validateFieldMessages.set('customer[email]', requiredMsgElement);
                } else if (!inputArr[i].value.match(mailFormat)) {
                    BSS_B2B.RF.validateFieldMessages.set('customer[email]', emailFormatMsgElement);
                } else if (inputArr[i].value.trim()) {
                    const noPhoneField = false;
                    const messages = await BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm(form, noPhoneField);
                    if (messages.length) {
                        messages.map((v) => {
                            if (v.customer_exist) {
                                BSS_B2B.RF.validateFieldMessages.set('customer[email]', customerExistMsgElement);
                            }
                        })
                    }
                }
            } else if (inputArr[i].name.includes('number')) {
                const inputElement = $(`input[name=${inputArr[i].name}]`);
                const minValue = inputElement.attr('min');
                const maxValue = inputElement.attr('max');
                
                if (minValue && !maxValue && (parseInt(inputArr[i].value) < parseInt(minValue)) && inputArr[i].value !== '') {
                    const largerThanElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.greater_than, statusMessage.NUMBER_IS_GREATER_THAN, minValue);
                    BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, largerThanElement);
                } else if (!minValue && maxValue && (parseInt(inputArr[i].value) > parseInt(maxValue)) && inputArr[i].value !== '') {
                    const lessThanElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.less_than, statusMessage.NUMBER_IS_LESS_THAN, maxValue);
                    BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, lessThanElement);
                } else if (minValue && maxValue && (parseInt(inputArr[i].value) > parseInt(maxValue) || parseInt(inputArr[i].value) < parseInt(minValue)) && inputArr[i].value !== '') {
                    const betweenElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.between, statusMessage.NUMBER_IS_BETWEEN, {min: minValue, max: maxValue});
                    BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, betweenElement);
                } else {
                    correctInputArr.push({ name: inputArr[i].name, value: inputArr[i].value });
                }
            } else if (inputArr[i].name.includes('phone')) {
                const hasPhoneField = true;
                const messages = await BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm(form, hasPhoneField);
                if (messages.length) {
                    messages.map((v) => {
                        if (v.phone_is_invalid) {
                            BSS_B2B.RF.validateFieldMessages.set(inputArr[i].name, phoneInvalidMsgElement);
                        }
                        if (v.customer_exist && !BSS_B2B.RF.validateFieldMessages.get('customer[password]')) {
                            BSS_B2B.RF.validateFieldMessages.set('customer[email]', customerExistMsgElement);
                        }
                    })
                }
                correctInputArr.push({ name: inputArr[i].name, value: inputArr[i].value });
            } else {
                if (!inputArr[i].name.includes('utf8') && !inputArr[i].name.includes('form_type')) {
                    if (inputArr[i].name.includes('checkbox-group')) {
                        let value = '';
                        if (correctCheck.get(inputArr[i].name) !== '') {
                            value = correctCheck.get(inputArr[i].name) + ',' + inputArr[i].value;
                        } else {
                            value = inputArr[i].value;
                        }
                        correctCheck.set(inputArr[i].name, value);
                    } else {
                        correctInputArr.push(inputArr[i]);
                    }
                }
            }
        }
        correctCheck.forEach((value, index) => {
            correctInputArr.push({ name: index, value: value });
        });
        return correctInputArr;
    };

    BSS_B2B.RF.getPhoneFieldValue = function (form) {
        let phoneFields = $(form).find('#phone-field');
        if (phoneFields.length) {
            return phoneFields[0].value;
        }
    };

    BSS_B2B.RF.getCompanyFieldValue = function (form) {
        let companyFields = $(form).find('#company-field');
        if (companyFields.length) {
            return companyFields[0].value;
        }
    };

    BSS_B2B.RF.getAddressFieldValue = function (form) {
        let addressFields = $(form).find('#address-field');
        if (addressFields.length) {
            return addressFields[0].value;
        }
    };

    BSS_B2B.RF.getCityFieldValue = function (form) {
        let cityFields = $(form).find('#city-field');
        if (cityFields.length) {
            return cityFields[0].value;
        }
    };

    BSS_B2B.RF.getStateCodeFieldValue = function (form) {
        if ($(form).find('#state-field').length) {
            return $(form).find('#state-field option:selected').val();
        }
    };

    BSS_B2B.RF.getCountryCodeFieldValue = function (form) {
        if ($(form).find('#country-field').length) {
            return $(form).find('#country-field option:selected').val();
        }
    };

    BSS_B2B.RF.getStateNameFieldValue = function (form) {
        if ($(form).find('#state-field').length) {
            return $(form).find('#state-field option:selected').text();
        }
    };

    BSS_B2B.RF.getCountryNameFieldValue = function (form) {
        if ($(form).find('#country-field').length) {
            return $(form).find('#country-field option:selected').text();
        }
    };

    BSS_B2B.RF.getZipFieldValue = function (form) {
        let zipFields = $(form).find('#zip-field');
        if (zipFields.length) {
            return zipFields[0].value;
        }
    };

    BSS_B2B.RF.getAcceptMarketingValue = function (form) {
        let acceptMarketingField = $(form).find('#accepts-marketing-0').is(":checked");
        return acceptMarketingField;
    };

    BSS_B2B.RF.renderReCAPCHA = function () {
        const dataSiteKey = BSS_B2B.CAPCHA_SITE_KEY;
        const storeId = BSS_B2B.storeId;
        let submitBtn = $(closestForm).find('[type=submit]');
        if (submitBtn.length) {
            $(submitBtn).before(`<div class="g-recaptcha" data-sitekey="${dataSiteKey}" data-callback="correctCaptcha"></div>`);
            let bssB2BLoadScript = function (url, callback) {
                let script = document.createElement("script");
                script.type = "text/javascript";
                // If the browser is Internet Explorer.
                if (script.readyState) {
                    script.onreadystatechange = function () {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            callback();
                        }
                    };
                    // For any other browser.
                } else {
                    script.onload = function () {
                        callback();
                    };
                }

                script.src = url;
                document.getElementsByTagName("head")[0].appendChild(script);

            };
            bssB2BLoadScript('https://www.google.com/recaptcha/api.js', function () {
                $(submitBtn).on('click', function (e) {
                    e.preventDefault();

                    BSS_B2B.RF.validateFieldMessages.clear();
                    let ButtonFormCLick = e.target;
                    if ($(this).closest('#create_customer').find('[type="submit"]').length) {
                        //mini form
                        closestForm = $(this).closest('#create_customer');
                    } else {
                        //main form
                        closestForm = $(this).closest('form[action*="/account"]');
                    }
                    utilities_default.a.removeAllMessage($, closestForm);
                    const recaptchaRes = $(closestForm).find('[name=g-recaptcha-response]').val();
                        $.ajax({
                            type: "POST",
                            url: bssB2bApiServer + '/recapcha/verify',
                            dataType: 'JSON',
                            data: {
                                'domain': Shopify.shop,
                                'g-recaptcha-response': recaptchaRes,
                                'store_id': storeId
                            },
                            success: async function (result) {
                                const complete_reCapcha_task_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_reCapcha_task, statusMessage.FAILED);
                                const loadingElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.LOADING);
                                $(closestForm).prepend(loadingElement);
                                BSS_B2B.RF.data = {
                                    formId: BSS_B2B.formId ? BSS_B2B.formId : BSS_B2B.formIdDef,
                                    wholesaler: {
                                        email: null,
                                        first_name: null,
                                        last_name: null,
                                        custom_field: [],
                                        raw_form_data: '',
                                        edited_form_data: '',
                                        status: BSS_B2B.created_account !== 1 ? 0 : 1
                                    }
                                };
                                let { fileInputArr } = await utilities_default.a.validationAllFieldBeforeSubmitForm($, closestForm, true);
                                // display all error message
                                const keysValidateField = [...BSS_B2B.RF.validateFieldMessages.keys()];
                                const keysValidateVat = [ ...BSS_B2B.RF.validateVATMessages.keys()];
                                if (keysValidateField.length || keysValidateVat.length || fileInputArr.fail) {
                                    utilities_default.a.removeAllMessage($, closestForm);
                                    utilities_default.a.displayValidateMessage(keysValidateField, keysValidateVat, ButtonFormCLick, closestForm);
                                    BSS_B2B.RF.allowContinueSubmit = false;
                                }
                                if (result.success) {
                                    BSS_B2B.RF.allowContinueSubmit = true;
                                } else {
                                    BSS_B2B.RF.allowContinueSubmit = false;
                                    if (BSS_B2B.reCAPCHA && (typeof grecaptcha !== "undefined")) {
                                        //reset reCAPCHA
                                        for (let i = 0; i < $('.g-recaptcha').length; i++)
                                            grecaptcha.reset(i);
                                        let scrollMiniForm = 0;
                                        if ($(closestForm).closest('#header-register-panel').length) {
                                            $(closestForm).closest('#header-register-panel').animate({
                                                scrollTop: scrollMiniForm
                                            }, 600);
                                        } else {
                                            $([document.documentElement, document.body]).animate({
                                                scrollTop: $(closestForm).offset().top - 300
                                            }, 600);
                                        }
                                        $(ButtonFormCLick).before(`<div class="reCAPCHA-err">${complete_reCapcha_task_element}</div>`);
                                    }
                                }
                                
                            },
                            error: async function (XMLHttpRequest, textStatus, errorThrown) {
                                // eslint-disable-next-line no-console
                                console.log(`${XMLHttpRequest.status} ${textStatus}: ${errorThrown}`);
                                utilities_default.a.removeAllMessage($, closestForm);
                                const complete_reCapcha_task_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.complete_reCapcha_task, statusMessage.FAILED);
                                $(ButtonFormCLick).before(`<div class="reCAPCHA-err">${complete_reCapcha_task_element}</div>`);
                            }
                        });

                });
                let correctCaptcha = function (response) {
                    if (response.length) {
                        $('.reCAPCHA-err').remove();
                    }
                };
                window.correctCaptcha = correctCaptcha;
            });
        }
    };

    BSS_B2B.RF.renderPrivacyPolicy = function () {
        let submitBtn = $(closestForm).find('[type=submit]');
        let formRenderBottom = $('#bss-b2b-registration-form-render');
        if (BSS_B2B.formPrivacyPolicyContent.length) {
            const content = `<div class='bss_rf_privacy_policy_container'><input type="checkbox" id="bss_rf_privacy_policy" name="bss_rf_privacy_policy"> <label for="bss_rf_privacy_policy">${BSS_B2B.formPrivacyPolicyContent}</label></div>`;
            if (submitBtn.length) {
                $(submitBtn).before(content);
            } else if (formRenderBottom.length) {
                $(formRenderBottom).after(content);
            }
        }
    };

    BSS_B2B.RF.submitForm = async function (form, correctInputArr, fileInputArr, submitBtn) {
       
        if (fileInputArr.length) {
            let listResJson = [];
            let isSuccess = false;
            await Promise.all(fileInputArr.map(async (item, index) => {
                if (item.file.length) {
                    let uploadFormData = new FormData();
                    uploadFormData.append('storeId', BSS_B2B.storeId);
                    uploadFormData.append('file', item.file[0]);
                    let res = await fetch(`${bssB2bApiServer}/upload_file?domain=${shopData.shop.permanent_domain}`, {
                        method: 'POST',
                        body: uploadFormData
                    });
                    let resJson = await res.json();
                    listResJson[index] = resJson;
                    isSuccess = isSuccess || resJson.success
                }
            }))
            if (isSuccess) {
                BSS_B2B.RF.data.wholesaler.aws_file_url = [];
                BSS_B2B.RF.data.wholesaler.store_file_url = [];
                fileInputArr.map((item, index)=> {
                    if (item.file.length && listResJson[index].success) {
                        listResJson[index].files.map(file => {
                            if (file.originalname === item.file[0].name) {
                                BSS_B2B.RF.data.wholesaler.aws_file_url.push(({
                                    name: item.id,
                                    value: file.path
                                }));
                                correctInputArr.push({ name: item.id, value: file.path });
                            }
                        });
                        BSS_B2B.RF.data.wholesaler.store_file_url.push({
                            name: item.id,
                            value: listResJson[index].fileUrl
                        })
                    }
                });
            } else {
                utilities_default.a.removeAllMessage($, form);
                const upload_file_fail_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.upload_file_to_server, statusMessage.FAILED);
                $(form).prepend(upload_file_fail_element);
                return;
            }
        } 

        BSS_B2B.RF.data.wholesaler.custom_field = JSON.stringify(correctInputArr);
        let customerNoteMap = new Map();
        BSS_B2B.formDataRender.map((item, idx) => {
            if (item.name !== 'email' && item.name !== 'password' && item.name !== 'first_name' && item.name !== 'last_name') {
                customerNoteMap.set(item.name, item.label ? item.label.replace(new RegExp('&nbsp;', 'g'), '') : `${item.type}-${idx}`);
            }
        });
        let currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
        let note = `---${currentDate}--- \n`;
        let fileUploadNote = ``;
        JSON.parse(BSS_B2B.RF.data.wholesaler.custom_field).map(item => {
            if (customerNoteMap.get(item.name.replace('[]', '')) !== null && customerNoteMap.get(item.name.replace('[]', '')) !== undefined && item.value && (item.name.replace('[]', '') !== 'phone-field' && item.name.replace('[]', '') !== 'company-field' && item.name.replace('[]', '') !== 'address-field' && item.name.replace('[]', '') !== 'city-field' && item.name.replace('[]', '') !== 'state-field' && item.name.replace('[]', '') !== 'country-field' && item.name.replace('[]', '') !== 'zip-field')) {
                if (customerNoteMap.get(item.name.replace('[]', '')) !== '') {
                    if (item.name.includes('file-')) {
                        let rightFormatValue = item.value.replace(new RegExp('&', 'g'), '');
                        fileUploadNote += `${customerNoteMap.get(item.name.replace('[]', ''))}: <a href="${bssB2bApiServer}/upload_file/download_customer_file_from_url?filePath=${rightFormatValue}&downloadType=2&domain=${shopData.shop.permanent_domain}" target="_blank">${rightFormatValue}</a><br/> \n`;
                        note += `${customerNoteMap.get(item.name.replace('[]', ''))}: ${item.value.split('/').pop()} \n`;
                    } else {
                        if (item.name.replace('[]', '') === "accepts-marketing") {
                            note += `${customerNoteMap.get(item.name.replace('[]', ''))}: Yes & \n`;
                        }else{
                            note += `${customerNoteMap.get(item.name.replace('[]', ''))}: ${item.value} & \n`;
                        }
                    }
                } else {
                    if (item.name.includes('file-')) {
                        let rightFormatValue = item.value.replace(new RegExp('&', 'g'), '');
                        fileUploadNote += `<a href="${bssB2bApiServer}/upload_file/download_customer_file_from_url?filePath=${rightFormatValue}&downloadType=2&domain=${shopData.shop.permanent_domain}" target="_blank">${rightFormatValue}</a><br/> \n`;
                        note += `${item.value.split('/').pop()} \n`;
                    } else {
                        note += `${item.value} \n`;
                    }
                }
            }
        });

        BSS_B2B.RF.data.wholesaler.note = note;
        BSS_B2B.RF.data.wholesaler.aws_file_url = JSON.stringify(BSS_B2B.RF.data.wholesaler.aws_file_url);
        BSS_B2B.RF.data.wholesaler.store_file_url = JSON.stringify(BSS_B2B.RF.data.wholesaler.store_file_url);
        BSS_B2B.RF.data.wholesaler.fileUploadNote = fileUploadNote;
        BSS_B2B.RF.data.wholesaler.tax_exempt = BSS_B2B.taxExempt;
        BSS_B2B.RF.data.wholesaler.phone = BSS_B2B.RF.getPhoneFieldValue(form);
        BSS_B2B.RF.data.wholesaler.company = BSS_B2B.RF.getCompanyFieldValue(form);
        BSS_B2B.RF.data.wholesaler.address = BSS_B2B.RF.getAddressFieldValue(form);
        BSS_B2B.RF.data.wholesaler.city = BSS_B2B.RF.getCityFieldValue(form);
        BSS_B2B.RF.data.wholesaler.state_code = BSS_B2B.RF.getStateCodeFieldValue(form);
        BSS_B2B.RF.data.wholesaler.country_code = BSS_B2B.RF.getCountryCodeFieldValue(form);
        BSS_B2B.RF.data.wholesaler.state_name = BSS_B2B.RF.getStateNameFieldValue(form);
        BSS_B2B.RF.data.wholesaler.country_name = BSS_B2B.RF.getCountryNameFieldValue(form);
        BSS_B2B.RF.data.wholesaler.zip = BSS_B2B.RF.getZipFieldValue(form);
        BSS_B2B.RF.data.wholesaler.accepts_marketing = BSS_B2B.RF.getAcceptMarketingValue(form);
        BSS_B2B.RF.data.wholesaler.locale = window.Shopify.locale ? window.Shopify.locale : "";
        $.ajax({
            type: "POST",
            url: `${bssB2bApiServer}/wholesaler/registration/${(BSS_B2B.created_account !== 1 ? 'b2b' : 'b2b-and-shopify')}?domain=${shopData.shop.permanent_domain}`,
            dataType: 'JSON',
            data: BSS_B2B.RF.data,
            success: function (result) {
                submitBtn.removeAttr('disabled', 'disabled');
                utilities_default.a.removeAllMessage($, form);
                sessionStorage.removeItem("verifyCaptcha");
                if (result.success) {
                    const form_success_notification_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.form_success_notification, statusMessage.SUCCESS, '', result.message);
                    $(form).prepend(form_success_notification_element);
                    if (BSS_B2B.created_account === 1) {
                        window.localStorage.setItem('bssEmail', BSS_B2B.RF.data.wholesaler.email);
                        window.location.href = window.location.origin + '/account/login' + '?return_url=' + encodeURI(BSS_B2B.redirect_url) + '&&isBssLogin=true';
                    } else {
                        // fix for miamata by ThaBi
                        if (BSS_B2B.storeId === 1023 && BSS_B2B.created_account === 3) {
                            let pathnameRedirect = BSS_B2B.redirect_url.includes("/thank-you-page") ? "/thankyoupage" : BSS_B2B.redirect_url;
                            window.location.href = 'https://miamata.it' + pathnameRedirect;
                        } else {
                            setTimeout(() => {
                                window.location.href = window.location.origin + BSS_B2B.redirect_url;
                            }, 3000)
                        }
                    }
                } else {
                    const form_fail_notification_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.form_fail_notification, statusMessage.FAILED);
                    $(form).prepend(form_fail_notification_element);
                    BSS_B2B.integrate.langShop.handleAllTranslation('rf');
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                // eslint-disable-next-line no-console
                console.log("Could not create registration from in function initRegistrationMiniForm.BSS_B2B.RF.submitForm:", errorThrown);
                utilities_default.a.removeAllMessage($, form);
                sessionStorage.removeItem("verifyCaptcha")
                const error_element = utilities_default.a.getMessageRFSetting(keyRFSettingObject.error_created_account_on_shopify, statusMessage.FAILED);
                $(form).prepend(error_element);
            }
        });
    };

    BSS_B2B.RF.handleSubmitForm = function (form, formData, isMiniForm) {
        formData.map(item => {
            if (item.name === "country-field") {
                item.values = [];
            }
        });
        let submitBtn = $(form).find('[type="submit"], button');
        submitBtn.on("click", async function (e) {
            e.preventDefault();
            if (BSS_B2B.reCAPCHA) {
                //await handle capcha after run click submit form
                await new Promise((resolve) => {
                    setTimeout(() => {
                        resolve()
                    }, 3500)
                })
            }         
            if (BSS_B2B.RF.allowContinueSubmit) {
                submitBtn.attr('disabled', 'disabled');
                BSS_B2B.RF.validateFieldMessages.clear();
                utilities_default.a.removeAllMessage($, form);

                const loadingElement = utilities_default.a.getMessageRFSetting(keyRFSettingObject.loadingForm, statusMessage.LOADING);
                $(form).prepend(loadingElement);
                BSS_B2B.RF.data = {
                    domain: shopData.shop.permanent_domain,
                    formId: isMiniForm ? BSS_B2B.formIdDef : BSS_B2B.formId,
                    wholesaler: {
                        email: null,
                        first_name: null,
                        last_name: null,
                        custom_field: [],
                        raw_form_data: JSON.stringify(formData),
                        edited_form_data: JSON.stringify(formData),
                        status: BSS_B2B.created_account !== 1 ? 0 : 1
                    }
                };
    
                let { correctInputArr, fileInputArr } = await utilities_default.a.validationAllFieldBeforeSubmitForm($, form, true);
                // display all error message
                const keysValidateField = [...BSS_B2B.RF.validateFieldMessages.keys()];
                const keysValidateVat = [...BSS_B2B.RF.validateVATMessages.keys()];
                if (keysValidateField.length || keysValidateVat.length || fileInputArr.fail) {
                    utilities_default.a.removeAllMessage($, form);
                    utilities_default.a.displayValidateMessage(keysValidateField, keysValidateVat, submitBtn, form);
                    let scrollMiniForm = 0;
                    if ($(form).closest('#header-register-panel').length) {
                        $(form).closest('#header-register-panel').animate({
                            scrollTop: scrollMiniForm
                        }, 600);
                    } else {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(form).offset().top - 300
                        }, 600);
                    }
                    if (BSS_B2B.reCAPCHA && (typeof grecaptcha !== "undefined")) {
                        //reset reCAPCHA
                        for (let i = 0; i < $('.g-recaptcha').length; i++)
                            grecaptcha.reset(i);
                    }
                    return;
                }
                let scrollMiniForm = 0;
                if ($(form).closest('#header-register-panel').length) {
                    $(form).closest('#header-register-panel').animate({
                        scrollTop: scrollMiniForm
                    }, 600);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(form).offset().top - 300
                    }, 600);
                }
                // end display
                
                // start sent request
                await BSS_B2B.RF.submitForm(form, correctInputArr, fileInputArr, submitBtn);
            }
        })
    };

    if (enableModule) {
        if (fbRender.length && status !== 0 && fbRenderTop.length && (BSS_B2B.formDataRender || BSS_B2B.formDataRenderDefault)) {
            let formData = [];
            let formDataMiniDefault = [];

            let formMain = $("#main .bss-b2b-registration-form-render").closest('form[action="/account"]');
            let formHeader = $('#header-register-panel .bss-b2b-registration-form-render').closest('form[action="/account"]');

            if (BSS_B2B.formDataRender) {
                formData = BSS_B2B.formDataRender;
            } else {
                BSS_B2B.formDataRender = [];
            }

            BSS_B2B.formDataRenderDefault.map(item => {
                if (item.name === "country-field") {
                    item.values = bssB2BArrayCountry;
                }
                if (item.name === "state-field") {
                    item.values = [];
                    item.require = false;
                }
                formDataMiniDefault.push(item);
            });
            let formRenderDataTop = [];
            let formRenderDataBottom = [];
            let formRenderDataMiniTop = [];
            let formRenderDataMiniBottom = [];
            formData.map(item => {
                if (item.name === "country-field") {
                    item.values = bssB2BArrayCountry;
                }
                if (item.name === "state-field") {
                    item.values = [];
                    item.require = false;
                }
                if (item.placement === 'top') {
                    formRenderDataTop.push(item);
                } else {
                    formRenderDataBottom.push(item);
                }
            });
            formDataMiniDefault.map(item => {
                if (item.placement === 'top') {
                    formRenderDataMiniTop.push(item);
                } else {
                    formRenderDataMiniBottom.push(item);
                }
            });
            if (BSS_B2B.created_account === 0) {
                let formRegistration = $('form[action*="/account"]').not('form[action*="/account/login"]');
                if ($(formRegistration).find('input[type*="password"]').length) {
                    $(formRegistration).find('input[type*="password"]').remove();
                }
                if ($(formRegistration).find('label[for="' + passwordId + '"]').length) {
                    $(formRegistration).find('label[for="' + passwordId + '"]').remove();
                }
                if ($(formRegistration).find('label[for="register-customer[password]"]').length) {
                    $(formRegistration).find('label[for="register-customer[password]"]').remove();
                }
                if ($(formRegistration).find('label[for="customer[password]"]').length) {
                    $(formRegistration).find('label[for="customer[password]"]').remove();
                }
                if ($('form[action*="/account/login"]').find('label[for="login-customer[password]"]').length) {
                    $('form[action*="/account/login"]').find('label[for="login-customer[password]"]').css('display', 'block');
                }
            }

            if (($('#header-register-panel').length) && $('#header-register-panel').find('.bss-b2b-registration-form-render').length && formRenderDataMiniTop.length) {
                $('#header-register-panel').find('.bss-b2b-registration-form-top').formRender({
                    formData: formRenderDataMiniTop,
                    dataType: 'json'
                });
            }
            if (($('#header-register-panel').length) && $('#header-register-panel').find('.bss-b2b-registration-form-render').length && formRenderDataMiniBottom.length) {
                // fix for rf form stetsomstore.com
                if (BSS_B2B.storeId !== 5683) {
                    $('#header-register-panel').find('.bss-b2b-registration-form-render').formRender({
                        formData: formRenderDataMiniBottom,
                        dataType: 'json'
                    });
                }
            }

            if (BSS_B2B.created_account !== 2) {
                if (formRenderDataTop.length) {
                    $(fbRenderTop).formRender({
                        formData: formRenderDataTop,
                        dataType: 'json'
                    });
                }
                if (formRenderDataBottom.length && formMain.length) {
                    $(formMain).find(fbRender).formRender({
                        formData: formRenderDataBottom,
                        dataType: 'json'
                    });
                }
            }
            BSS_B2B.RF.getVatValidationInput();
            BSS_B2B.RF.getABNValidationInput();
            BSS_B2B.RF.getGSTValidationInput();
            BSS_B2B.RF.getUKValidationInput();
            BSS_B2B.RF.getUSEinValidationInput();
            if (BSS_B2B.created_account !== 2) {
                if (($('#header-register-panel').length) && $('#header-register-panel').find('.bss-b2b-registration-form-render').length) {
                    BSS_B2B.RF.handleSubmitForm(formHeader, formDataMiniDefault, true);
                }
                BSS_B2B.RF.handleSubmitForm(formMain, formData, false);
            }
            if (BSS_B2B.formPrivacyPolicyStatus) {
                BSS_B2B.RF.renderPrivacyPolicy();
            }
            if (BSS_B2B.reCAPCHA) {
                BSS_B2B.RF.renderReCAPCHA();
            }
        }

        // fix for login form on header by ThaBi
        if (fbRenderTopHeader.length && fbRenderBottomHeader.length && status !== 0 && BSS_B2B.formDataRender) {
            let formData = BSS_B2B.formDataRender;
            let formRenderDataTopHeader = [];
            let formRenderDataBottomHeader = [];

            formData.map(item => {
                if (item.name === "country-field") {
                    item.values = bssB2BArrayCountry;
                }
                if (item.name === "state-field") {
                    item.values = [];
                    item.require = false;
                }
                if (item.placement === 'top') {
                    formRenderDataTopHeader.push(item);
                } else {
                    formRenderDataBottomHeader.push(item);
                }
            });

            if (BSS_B2B.created_account === 0) {
                let formRegistrationMain = $('form[action*="/account"]').not('form[action*="/account/login"]');
                if ($(formRegistrationMain).find('input[type*="password"]').length) {
                    $(formRegistrationMain).find('input[type*="password"]').remove();
                }
                if ($(formRegistrationMain).find('label[for="' + passwordId + '"]').length) {
                    $(formRegistrationMain).find('label[for="' + passwordId + '"]').remove();
                }
                if ($(formRegistrationMain).find('label[for="register-customer[password]"]').length) {
                    $(formRegistrationMain).find('label[for="register-customer[password]"]').remove();
                }
                if ($(formRegistrationMain).find('label[for="customer[password]"]').length) {
                    $(formRegistrationMain).find('label[for="customer[password]"]').remove();
                }
                if ($('form[action*="/account/login"]').find('label[for="login-customer[password]"]').length) {
                    $('form[action*="/account/login"]').find('label[for="login-customer[password]"]').css('display', 'block');
                }
            }
            if (BSS_B2B.created_account !== 2) {
                if (formRenderDataTopHeader.length) {
                    $(fbRenderTopHeader).formRender({
                        formData: formRenderDataTopHeader,
                        dataType: 'json'
                    });
                }
                if (formRenderDataBottomHeader.length) {
                    $(fbRenderBottomHeader).formRender({
                        formData: formRenderDataBottomHeader,
                        dataType: 'json'
                    });
                }
            }
            BSS_B2B.RF.getVatValidationInput();
            BSS_B2B.RF.getABNValidationInput();
            BSS_B2B.RF.getGSTValidationInput();
            BSS_B2B.RF.getUKValidationInput();
            BSS_B2B.RF.getUSEinValidationInput();
            if (BSS_B2B.created_account !== 2) {
                BSS_B2B.RF.handleSubmitForm(closestForm, formData);
            }
        }
        // end fix for login form on header by ThaBi
    } else {
        let formAppRender = $('form[action*="/account"]').closest('#main, .main-content, .main, main');
        if (window.location.pathname.indexOf('/pages/') !== -1 && $(formAppRender).length) {
            let isCustomForm = $(formAppRender).find('.bss-b2b-registration-form-render');
            if (isCustomForm.length) {
                $(formAppRender).remove();
            }
        }
        if ($('.bss-b2b-registration-form-render').length) {
            $('.bss-b2b-registration-form-render').remove();
        }
    }
    // get zip when change country
    if ($('input[id="country-field-input"]').length) {
        const changeStateByCountry = (form) => {
            const countryCodeElement = form.querySelector('#country-field');
            const countryCode = countryCodeElement ? countryCodeElement.value : null;
            let listWidth = form.querySelector('.field-country-field').clientWidth;
            let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry(form, countryCode);
            let optionState = ``;
            for (let i = 0; i < stateInCountry.length; i++) {
                optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
            }
            if (form.querySelector('#state-field')) {
                form.querySelector('#state-field').innerHTML = '';
                setTimeout(() => {
                    form.querySelector('#state-field').innerHTML = optionState;
                }, 100);
            }
            let countryFieldList = form.querySelector('#country-field-list');
            if (countryFieldList) {
                countryFieldList.style.display = 'block';
                countryFieldList.style.marginTop = '0px';
                countryFieldList.style.width = listWidth + 'px';
                countryFieldList.style.overflow = 'auto';
            }
        };

        document.querySelectorAll('input[id="country-field-input"]').forEach((element) => {
            const form = element.closest('form');
            element.addEventListener("click", () => changeStateByCountry(form));
            element.addEventListener("change", () => changeStateByCountry(form));
            element.addEventListener("keyup", function(event) {
                // press enter
                const keyCode = (event.keyCode ? event.keyCode : event.which);
                if (keyCode === 13) {
                    changeStateByCountry(form);
                }
            });
        });
        document.querySelectorAll('input[id="country-field-list"]').forEach((element) => {
            const form = element.closest('form');
            element.addEventListener("click", () => changeStateByCountry(form));
            element.addEventListener("mousedown", () => changeStateByCountry(form));
        });
    // } else if ($('#country-field').length) {
    //     $('#country-field').change(function () {
    //         let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($(this).val());
    //         let optionState = ``;
    //         for (let i = 0; i < stateInCountry.length; i++) {
    //             optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
    //         }
    //         if ($('#state-field').length) {
    //             $('#state-field').html('');
    //             setTimeout(() => {
    //                 $('#state-field').html(optionState);
    //             }, 100);
    //         }
    //     });
    //     let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry($('#country-field').val());
    //     let optionState = ``;
    //     for (let i = 0; i < stateInCountry.length; i++) {
    //         optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
    //     }
    //     if ($('#state-field').length) {
    //         $('#state-field').html('');
    //         setTimeout(() => {
    //             $('#state-field').html(optionState);
    //         }, 100);
    //     }
    } else {
        if ($('.field-state-field').length) {
            $('.field-state-field').remove();
        }
    }
    // mini form
    if (($('#header-register-panel').length) && $('#header-register-panel').find('.bss-b2b-registration-form-render').length) {
        let countryFiledMini = $('#header-register-panel #country-field, .header-register-panel #country-field');
        let stateFiledMini = $('#header-register-panel #state-field, .header-register-panel #state-field');
        if ($(countryFiledMini).length) {
            const formHeader = document.querySelector('#header-register-panel .bss-b2b-registration-form-render').closest('form');
            $(countryFiledMini).change(function () {
                let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry(formHeader, $(this).val());
                let optionState = ``;
                for (let i = 0; i < stateInCountry.length - 1; i++) {
                    optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
                }
                if ($(stateFiledMini).length) {
                    $(stateFiledMini).html('');
                    setTimeout(() => {
                        $(stateFiledMini).html(optionState);
                    }, 100);
                }
            });
            let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry(formHeader, $(countryFiledMini).val());
            let optionState = ``;
            for (let i = 0; i < stateInCountry.length; i++) {
                optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
            }
            if ($(stateFiledMini).length) {
                $(stateFiledMini).html('');
                setTimeout(() => {
                    $(stateFiledMini).html(optionState);
                }, 100);
            }
        }
    }
    // form page
    let countryFiledMain = $('#main #country-field, .main-content #country-field, .main #country-field, main #country-field');
    let stateFiledMain = $('#main #state-field, .main-content #state-field, .main #state-field, main #state-field');
    if (countryFiledMain.length) {
        const formMain = document.querySelector('#main .bss-b2b-registration-form-render').closest('form');
        $(countryFiledMain).change(function () {
            let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry(formMain, $(this).val());
            let optionState = ``;
            for (let i = 0; i < stateInCountry.length; i++) {
                optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
            }
            if ($(stateFiledMain).length) {
                $(stateFiledMain).html('');
                setTimeout(() => {
                    $(stateFiledMain).html(optionState);
                }, 100);
            }
        });
        let stateInCountry = BSS_B2B.RF.getAllProvinceViaCountry(formMain, $(countryFiledMain).val());
        let optionState = ``;
        for (let i = 0; i < stateInCountry.length; i++) {
            optionState += `<option value="${stateInCountry[i].value}" id="state-field-${i}">${stateInCountry[i].label}</option>`;
        }
        if ($(stateFiledMain).length) {
            $(stateFiledMain).html('');
            setTimeout(() => {
                $(stateFiledMain).html(optionState);
            }, 100);
        }
    }

    BSS_B2B.RF.validationPhoneNumberBeforeSubmitForm = async function(form, hasPhoneField) {
        let messages = [];
        // Custom store
        const phoneValue = BSS_B2B.RF.getPhoneFieldValue(form) ? BSS_B2B.RF.getPhoneFieldValue(form).trim() : '';
        if (!phoneValue && hasPhoneField)
            return messages
        BSS_B2B.RF.data.wholesaler.phone = phoneValue;
        const req = await fetch(bssB2bApiServer + `/wholesaler/valid/phone-number?domain=${shopData.shop.permanent_domain}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(BSS_B2B.RF.data)
        })

        const res = await req.json();
        if (res.success && res.messages.length) {
            res.messages.map(v => messages.push(v))
            return messages
        } else {
            return messages
        }
    };
}

// CONCATENATED MODULE: ./js/src/form/init-conditional-logic.js
function initConditionalLogic(BSS_B2B, isEnableRF) {
    BSS_B2B.CL = {};
    BSS_B2B.CL.allowToUse = false;
    const CONDITION = Object.freeze({
        DISPLAY: {
            SHOW: 1,
            HIDE: 0
        },
        APPLY: {
            ALL: 1,
            ANY: 0
        }
    })
    const FIELD_CONDITION = Object.freeze({
        IS: 1,
        IS_NOT: 2,
        CONTAINS: 3,
        NOT_CONTAINS: 4,
        STARTS_WITH: 5,
        NOT_STARTS_WITH: 6,
        GREATER_THAN: 7,
        SMALLER_THAN: 8,
        GREATER_THAN_OR_EQUALS: 9,
        SMALLER_THAN_OR_EQUALS: 10,
        IS_TYPE: 11,
        IS_SELECTED: 12
    })

    BSS_B2B.CL.getFormData = () => {
        const data = [];
        let form = document.querySelector(`#bss-b2b-registration-form-render, .bss-b2b-registration-form-render`).closest(`form`);
        
        if (form) {
            const formDataRenderMap = new Map(BSS_B2B.formDataRender.map(item => [item.name, item]));
            const formData = new FormData(form);
            for (const [name, value] of formData.entries()) {
                if (name && name !== `form_type` && name !== `utf8` && !name.includes(`file-`)) {
                    const fieldData = formDataRenderMap.get(name.replace(`[]`, ``));
                    let isExist = false;
                    for (const item of data) {
                        if (name.replace(`[]`, ``) === item.name) {
                            isExist = true;
                            fieldData.values.forEach(option => {
                                if (option.value === value) item.value = item.value + `,` + option.label;
                            });
                            break;
                        }
                    }
                    if (!isExist) {
                        if (fieldData && [`checkbox-group`, `radio-group`, `select`].includes(fieldData.type) && ![`accepts-marketing`, `state-field`].includes(fieldData.name)) {
                            let fieldValue = ``;
                            if (value !== `` && fieldData.values && fieldData.values.length) {
                                fieldData.values.forEach(option => {
                                    if (option.value === value) fieldValue = option.label;
                                });
                            }
                            data.push({ name: name.replace(`[]`, ``), value: fieldValue });
                        } else {
                            data.push({ name: name.replace(`[]`, ``), value: (value || ``).toString() });
                        }
                    }
                }
            }
            const isExistCompanyField = data.some(item => item.name === `company-field`);
            const companyField = form.querySelector(`#company-field`);
            if (!isExistCompanyField && companyField) {
                data.push({ name: `company-field`, value: companyField.value || `` });
            }
        }
        return data;
    };

    BSS_B2B.CL.executeLogic = (formDataMap, stateFieldShow, applyFieldArray = [], conditionFieldArray = []) => {
        let formRender = document.querySelector(`#bss-b2b-registration-form-render`);
        if (!formRender) {
            formRender = document.querySelector(`.bss-b2b-registration-form-render`);
        }
        
        let form = formRender.closest(`form`);
        BSS_B2B.conditionalLogic.forEach(item => {
            applyFieldArray.push(item.name);
            const applyField = form.querySelector(`.field-${item.name}`);
            const isStateField = item.name === `state-field`;
            const result = [];
            item.conditions.forEach(condition => {
                conditionFieldArray.push(condition.fieldName);
                let conditionField = form.querySelector(`.field-${condition.fieldName}`);
                if ([`customer[first_name]`, `customer[last_name]`, `customer[email]`, `customer[password]`].includes(condition.fieldName)) {
                    conditionField = form.querySelector(`input[name="${condition.fieldName}"]`).closest(`.field`);
                }
                if (conditionField) {
                    if (conditionField.classList.contains(`bss-b2b-rf-conditional-logic-hide`)) {
                        result.push(false);
                    } else {
                        const conditionValue = condition.value;
                        let conditionFieldValue = formDataMap.get(condition.fieldName) || ``;
                        if (condition.fieldName === `country-field` && conditionFieldValue !== ``) {
                            const country = bssB2BArrayCountry.filter(item => item.value === conditionFieldValue);
                            if (country.length) conditionFieldValue = country[0].label;
                            else conditionFieldValue = ``;
                        } else if (condition.fieldName === `state-field` && conditionFieldValue !== ``) {
                            const countryCode = formDataMap.get(`country-field`);
                            if (countryCode) {
                                const allProvinces = BSS_B2B.RF.getAllProvinceViaCountry(countryCode);
                                if (allProvinces && allProvinces.length) {
                                    const state = allProvinces.filter(item => item.value === conditionFieldValue);
                                    if (state.length) conditionFieldValue = state[0].label;
                                    else conditionFieldValue = ``;
                                }
                            }
                        }
                        switch (condition.condition) {
                            case FIELD_CONDITION.IS:
                                result.push(conditionFieldValue === conditionValue);
                                break;
                            case FIELD_CONDITION.IS_NOT:
                                result.push(conditionFieldValue !== `` ? conditionFieldValue !== conditionValue : false);
                                break;
                            case FIELD_CONDITION.CONTAINS:
                                result.push(conditionFieldValue !== `` ? conditionFieldValue.includes(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.NOT_CONTAINS:
                                result.push(conditionFieldValue !== `` ? !conditionFieldValue.includes(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.STARTS_WITH:
                                result.push(conditionFieldValue !== `` ? conditionFieldValue.startsWith(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.NOT_STARTS_WITH:
                                result.push(conditionFieldValue !== `` ? !conditionFieldValue.startsWith(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.GREATER_THAN:
                                result.push(conditionFieldValue !== `` ? Number(conditionFieldValue) > Number(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.SMALLER_THAN:
                                result.push(conditionFieldValue !== `` ? Number(conditionFieldValue) < Number(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.GREATER_THAN_OR_EQUALS:
                                result.push(conditionFieldValue !== `` ? Number(conditionFieldValue) >= Number(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.SMALLER_THAN_OR_EQUALS:
                                result.push(conditionFieldValue !== `` ? Number(conditionFieldValue) <= Number(conditionValue) : false);
                                break;
                            case FIELD_CONDITION.IS_SELECTED:
                                result.push(conditionValue.toLowerCase() === `yes` ? !!conditionFieldValue : !conditionFieldValue);
                                break;
                            default:
                                break;
                        }
                    }
                }
            });

            if (
                (item.apply === CONDITION.APPLY.ALL && (!result.length || result.includes(false))) ||
                (item.apply === CONDITION.APPLY.ANY && (!result.length || !result.includes(true)))
            ) {
                if (item.display === CONDITION.DISPLAY.SHOW) {
                    applyField.classList.add(`bss-b2b-rf-conditional-logic-hide`);
                    if (isStateField) stateFieldShow = false;
                    if (applyField.nextElementSibling) {
                        const isErrorMessage = applyField.nextElementSibling.classList.contains('bss-error-msg');
                        if(isErrorMessage) applyField.nextElementSibling.style.display = 'none';
                    }
                }
                if (item.display === CONDITION.DISPLAY.HIDE) {
                    applyField.classList.remove(`bss-b2b-rf-conditional-logic-hide`);
                    if (isStateField) stateFieldShow = true;
                    if (applyField.nextElementSibling) {
                        const isErrorMessage = applyField.nextElementSibling.classList.contains('bss-error-msg');
                        if(isErrorMessage) applyField.nextElementSibling.style.display = 'block';
                    }
                }
            } else if (
                (item.apply === CONDITION.APPLY.ALL && (result.length && !result.includes(false))) ||
                (item.apply === CONDITION.APPLY.ANY && (result.length && result.includes(true)))
            ) {
                if (item.display === CONDITION.DISPLAY.SHOW) {
                    applyField.classList.remove(`bss-b2b-rf-conditional-logic-hide`);
                    if (isStateField) stateFieldShow = true;
                    if (applyField.nextElementSibling) {
                        const isErrorMessage = applyField.nextElementSibling.classList.contains('bss-error-msg');
                        if(isErrorMessage) applyField.nextElementSibling.style.display = 'block';
                    }
                }
                if (item.display === CONDITION.DISPLAY.HIDE) {
                    applyField.classList.add(`bss-b2b-rf-conditional-logic-hide`);
                    if (isStateField) stateFieldShow = false;
                    if (applyField.nextElementSibling) {
                        const isErrorMessage = applyField.nextElementSibling.classList.contains('bss-error-msg');
                        if(isErrorMessage) applyField.nextElementSibling.style.display = 'none';
                    }
                }
            }
            if (applyField.classList.contains(`field-abn-validation`)) {
                const companyField = form.querySelector(`#company-field`);
                if (companyField) {
                    if (applyField.classList.contains(`bss-b2b-rf-conditional-logic-hide`)) companyField.removeAttribute(`disabled`);
                    else companyField.setAttribute(`disabled`, `disabled`);
                }
            }
        });
        const countryField = form.querySelector(`.field-country-field`);
        if (countryField) {
            const stateField = form.querySelector(`.field-state-field`);
            if (stateField) {
                if (countryField.classList.contains(`bss-b2b-rf-conditional-logic-hide`)) {
                    stateField.classList.add(`bss-b2b-rf-conditional-logic-hide`);
                } else {
                    if (stateFieldShow) stateField.classList.remove(`bss-b2b-rf-conditional-logic-hide`);
                }
            }
        }
    }

    BSS_B2B.CL.checkConditionalLogic = () => {
        const formData = BSS_B2B.CL.getFormData();
        const formDataMap = new Map(formData.map(item => [item.name, item.value]));
        let stateFieldShow = true;
        const applyFieldArray = [];
        const conditionFieldArray = [];
        let recheck = 0;
        BSS_B2B.CL.executeLogic(formDataMap, stateFieldShow, applyFieldArray, conditionFieldArray)
        conditionFieldArray.forEach(item => {
            if (applyFieldArray.includes(item)) recheck += 1;
        })
        for (let i = 0; i < recheck; i++) {
            BSS_B2B.CL.executeLogic(formDataMap, stateFieldShow);
        }
    };

    BSS_B2B.CL.initFirstLoad = () => {
        let rfFormRender = document.querySelector(`#bss-b2b-registration-form-render, .bss-b2b-registration-form-render`);

        const form = rfFormRender ? rfFormRender.closest(`form`) : null;
        if (BSS_B2B.conditionalLogic && BSS_B2B.conditionalLogic.length && isEnableRF && BSS_B2B.planCode === `platinum` && form) {
            BSS_B2B.CL.allowToUse = true;
            BSS_B2B.CL.customEvent = new Event(`BSS_condition_field_change`);
            const conditionFields = [];
            BSS_B2B.conditionalLogic.forEach(item => {
                const applyField = form.querySelector(`.field-${item.name}`);
                if (applyField) {
                    if (item.display === CONDITION.DISPLAY.SHOW) {
                        applyField.classList.add(`bss-b2b-rf-conditional-logic-hide`);
                        if (applyField.classList.contains(`field-abn-validation`)) {
                            const companyField = form.querySelector(`#company-field`);
                            if (companyField) {
                                setTimeout(() => {
                                    companyField.removeAttribute(`disabled`);
                                }, 200)
                            }
                        }
                    }
                }
                if (item.conditions && item.conditions.length) {
                    item.conditions.forEach(condition => {
                        if (!conditionFields.includes(condition.fieldName)) conditionFields.push(condition.fieldName);
                    });
                }
            });
            if (conditionFields.length) {
                let conditionElements = [];
                conditionFields.forEach(name => {
                    if ([`customer[first_name]`, `customer[last_name]`, `customer[email]`, `customer[password]`].includes(name)) {
                        const field = form.querySelector(`input[name="${name}"]`);
                        if (field) conditionElements.push(field);
                    } else {
                        const field = form.querySelector(`.field-${name}`);
                        if (field) conditionElements = [...conditionElements, ...field.querySelectorAll(`input, select, textarea`)];
                    }
                    if (conditionElements.length) {
                        conditionElements.forEach(element => {
                            element.addEventListener(`change`, () => {
                                if (element.classList.contains(`country-field`)) {
                                    setTimeout(() => {
                                        document.dispatchEvent(BSS_B2B.CL.customEvent);
                                    }, 100)
                                } else {
                                    document.dispatchEvent(BSS_B2B.CL.customEvent);
                                }
                            });
                            if (element.classList.contains(`country-field`)) {
                                form.querySelectorAll(`#country-field-list li`).forEach(item => {
                                    item.addEventListener(`click`, () => {
                                        setTimeout(() => {
                                            document.dispatchEvent(BSS_B2B.CL.customEvent);
                                        }, 100)
                                    })
                                })
                            }
                        });
                    }
                });
                BSS_B2B.CL.checkConditionalLogic();
                document.addEventListener(`BSS_condition_field_change`, BSS_B2B.CL.checkConditionalLogic);
            }
        }
    }
}
// CONCATENATED MODULE: ./js/src/merge-init.js






function MergeInitFunction(jQueryObj) {
    let shopModules = BSS_B2B.shopModules;
    if (shopModules === undefined || shopModules == null || shopModules.length === 0) {
        BSS_B2B.shopModules = [
            { code: "cp", status: 1 },
            { code: "qb", status: 1 },
            { code: "form", status: 1 },
            { code: "tax_exempt", status: 0 },
            { code: "tax_display", status: 0 }
        ];
        shopModules = BSS_B2B.shopModules;
    }
    let isEnableCP = true;
    let isEnableQB = true;
    let isEnableRg = true;
    let isEnabledTE = false;
    let isEnabledTD = false;

    shopModules.forEach(function (sm) {
        if (sm.code === "cp") {
            isEnableCP = sm.status;
        } else if (sm.code === "qb") {
            isEnableQB = sm.status;
        } else if (sm.code === "form") {
            isEnableRg = sm.status;
        } else if (sm.code === "tax_exempt") {
            isEnabledTE = sm.status;
        } else if (sm.code === "tax_display") {
            isEnabledTD = sm.status;
        }
    });

    if (BSS_B2B.planCode === "null" || BSS_B2B.planCode === "" || BSS_B2B.planCode === "undefined") {
        isEnableRg = false;
    }

    if (isEnableRg) {
        if (jQueryObj('#RegisterForm').length) {
            jQueryObj('#RegisterForm').fadeIn(500)
        }
    } else if (window.location.pathname === '/account/register') {
        if (jQueryObj('#RegisterForm').length) {
            jQueryObj('#RegisterForm').fadeIn(500)
        }
    }
    let shopData = {};

    if (jQueryObj('#bss-b2b-store-data').length) {
        shopData = JSON.parse(jQueryObj('#bss-b2b-store-data').html());
        BSS_B2B.shopData = shopData;
    }
    // fix for dragonflybrand.com by hoaduong
    // fix for parkinfabrics by Leorio
    if ([437, 3787, 4497, 8553, 11500, 15743].indexOf(BSS_B2B.storeId) !== -1 && shopData.customer.id == null) {
        isEnableCP = false
    }
    if (isEnableCP & [11790, 3321].includes(BSS_B2B.storeId)) {
        isEnableCP = window.BSS_B2B.executeFilter({
            tag: `optimize_cp_by_customer`, 
            storeId: false, val: isEnableCP,
            cpRules: BSS_B2B.configData,
            plRules: BSS_B2B.plConfigData,
            customer: shopData.customer
        });
    }
    // fix for watc-studio by CuongNVM
    if (BSS_B2B.storeId === 3879) {
        sessionStorage.removeItem('bssB2BCountryTax');
        sessionStorage.removeItem('bssB2BCountryCode');
    }
    // init registration form

    let urlArr = window.location.href.split("/");
    let isCartPage = (urlArr[urlArr.length - 1] === "cart" || (urlArr[urlArr.length - 1].includes("cart") && urlArr[urlArr.length - 2] !== "products") && urlArr[urlArr.length - 2] !== "collections");

    setTimeout(function () {
        //Must detect country and vat first time
        let countryCode = '';
        let countryTax = 0;
        if (typeof (Storage) !== "undefined") {
            countryCode = Shopify.country;
            const country = BSS_B2B.allVatCountries ? BSS_B2B.allVatCountries.find((country) => country.code === countryCode) : null;
            countryTax = country && country.tax ? country.tax : sessionStorage.bssB2BCountryTax ? sessionStorage.bssB2BCountryTax : 0;
            sessionStorage.bssB2BCountryCode = countryCode;
            sessionStorage.bssB2BCountryTax = countryTax;
        }
        if (!isEnabledTD) {
            let cartVatStyle = document.querySelectorAll("#bss-b2b-cart-vat-style");
            let productVatStyle = document.querySelectorAll("#bss-b2b-tax-inc-excl");
            let collectionVatItemsStyle = document.querySelectorAll('[class^="bss-b2b-collection-item-vat-style"]');
            if (productVatStyle) {
                productVatStyle.forEach(e => {
                    e.remove();
                })
            }
            if (collectionVatItemsStyle) {
                collectionVatItemsStyle.forEach(e => {
                    e.remove();
                })
            }
            if (cartVatStyle) {
                cartVatStyle.forEach((item) => {
                    item.remove()
                });
            }
        }
        let appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCollectionPage(BSS_B2B, shopData);
        if (isCartPage) {
            appliedDisplayRule = taxDisplayRules_default.a.getAppliedRuleCartPage(BSS_B2B, shopData);
        } else {
            //fix remove vat style minicart for fancybeans by trung dd
            if ([10927, 8930].includes(BSS_B2B.storeId)) {
                taxDisplayRules_default.a.getAppliedRuleCartPage(BSS_B2B, shopData)
            }
        }

        if (countryCode === '' && (isEnabledTE || isEnabledTD)) {
            let data = {
                domain: Shopify.shop,
                app: 'b2b'
            };
            fetch(bssB2bApiServer + `/te/get-tax-based-country?domain=${Shopify.shop}`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(function (data) {
                    if (data.success) {
                        BSS_B2B.countryCode = data.countryCode;
                        BSS_B2B.countryTax = data.tax || 0;

                        if (typeof (Storage) !== "undefined") {
                            sessionStorage.bssB2BCountryCode = data.countryCode;
                            sessionStorage.bssB2BCountryTax = data.tax;
                            // eslint-disable-next-line no-console
                            console.log("SR country code & Tax:", sessionStorage.bssB2BCountryCode, sessionStorage.bssB2BCountryTax);
                        } else {
                            // eslint-disable-next-line no-console
                            console.log("Country Code & Tax:", BSS_B2B.countryCode, BSS_B2B.countryTax);
                        }

                    } else {
                        // eslint-disable-next-line no-console
                        console.log("Could not get country by IP")
                    }
                    bssB2BRunScript(jQueryObj, BSS_B2B, shopModules, shopData);
                    if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) || (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
                        if (isCartPage) {
                            tax_default.a.bssB2BCartChangeAllVatPriceWithoutCP(shopData, appliedDisplayRule);
                            tax_default.a.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedDisplayRule);
                        } else {
                            tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                            tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                        }
                    } else {
                        if (BSS_B2B.storeId !== 3879) {
                            tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                        }
                    }
                });
        } else {
            BSS_B2B.countryCode = countryCode;
            BSS_B2B.countryTax = countryTax;
            bssB2BRunScript(jQueryObj, BSS_B2B, shopModules, shopData);
            if (!isEnableQB || !BSS_B2B.qbRules || (BSS_B2B.qbRules.length === 0)) {
                if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) || (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
                    if (isCartPage) {
                        let delayTime = 0;
                        if ([6445, 7577].includes(BSS_B2B.storeId)) {
                            delayTime = 3000;
                        }
                        if ([8949].includes(BSS_B2B.storeId)) {
                            delayTime = 1500;
                        }
                        setTimeout(() => {
                            tax_default.a.bssB2BCartChangeAllVatPriceWithoutCP(shopData, appliedDisplayRule);
                            tax_default.a.bssB2BCartChangeAllVatPriceQtyChangeWithoutCP(shopData, appliedDisplayRule);
                        }, delayTime)

                        let breakInterval = 0;
                        let interval = setInterval(function () {
                            if (breakInterval > 10) {
                                window.clearInterval(interval)
                            }
                            let featuredCollection = document.querySelectorAll(
                                'ul.product-grid li.grid__item .card-information .bss-b2b-collection-item-vat,'
                                + 'ul.grid li.grid__item .grid-view-item .bss-b2b-collection-item-vat,' +'.grid-item.grid-product .grid-item__content'
                            );
                            if (featuredCollection.length) {
                                tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                                tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                                window.clearInterval(interval);
                            }

                            ++breakInterval;
                        }, 500)

                        //fix segers-fabriker by hoaduong
                        if ([3663, 4852].includes(BSS_B2B.storeId)) {
                            let delayTime = 0;
                            if (BSS_B2B.storeId === 4852) { delayTime = 500 }
                            setTimeout(function () {
                                tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                                tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                            }, delayTime)
                        }
                    } else {
                        // fix gadgetmania by DongNV
                        let delayTime = 0;

                        if (BSS_B2B.page.isProductPage()) {
                            if (BSS_B2B.storeId === 3663) { delayTime = 500 }
                            if (BSS_B2B.storeId === 4880) { delayTime = 2000 }
                        }
                        if ([4852, 11975].includes(BSS_B2B.storeId)) { delayTime = 1000 }
                        setTimeout(function () {
                            tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                            tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                        }, delayTime)

                        let breakInterval = 0;
                        let interval = setInterval(function () {
                            if (breakInterval > 10) {
                                window.clearInterval(interval)
                            }
                            let featuredCollection = document.querySelectorAll(
                                'ul.product-grid li.grid__item .card-information .bss-b2b-collection-item-vat,'
                                + 'ul.grid li.grid__item .grid-view-item .bss-b2b-collection-item-vat,'
                                + 'ul.product-section--content .productitem--info .bss-b2b-collection-item-vat'
                            );
                            if (featuredCollection.length) {
                                tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                                tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                                window.clearInterval(interval);
                            }

                            ++breakInterval;
                        }, 500)
                    }
                } else {
                    tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                    if (BSS_B2B.storeId === 11985) {
                        tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                    }
                    // fix for storeID 6888
                    window.BSS_B2B.executeAction({
                        tag: `price_feature_product`,
                        storeId: 6888,
                        BSS_B2B: window.BSS_B2B,
                        shopData: shopData,
                        appliedTD: isEnabledTD
                    }); 
                }
            } else {
                if (!isEnableCP || (!BSS_B2B.configData && !BSS_B2B.plConfigData) || (BSS_B2B.configData.length === 0 && BSS_B2B.plConfigData.length === 0)) {
                    if ((BSS_B2B.page.isProductPage() && BSS_B2B.storeId === 4153) || (BSS_B2B.storeId === 14608)) {
                        setTimeout(function () {
                            tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                            tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                        }, 3500)
                    }
                    tax_default.a.showProductPriceIncludedVat(BSS_B2B, shopData);
                    tax_default.a.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
                }
            }
        }
        //Custom store 3402
        if (isEnableCP && BSS_B2B.storeId === 3402) {
            BSS_B2B.cp.changeProductPrice(shopData, false, false)
        }
    }, 500);

    if (!isCartPage && isEnableRg) {
        initConditionalLogic(BSS_B2B, isEnableRg)
        let timeoutRenderForm = 0;
        if ([8927, 1123].includes(BSS_B2B.storeId)) {
            timeoutRenderForm = 2000;
        }
        if ([11625, 14244].includes(BSS_B2B.storeId)) {
            timeoutRenderForm = 3000;
        }
        var miniForm = jQueryObj(`header form[action="/account"]`);
        if (BSS_B2B.storeId === 11037) {
            miniForm = jQueryObj(`.drawer__inner .banner__form #create_customer`)
        }
        if (miniForm.length) {
            // eslint-disable-next-line no-console
            console.log('init registration mini form');
            setTimeout(() => {
                initRegistrationMiniForm(jQueryObj, BSS_B2B, shopData, isEnableRg)
            }, timeoutRenderForm)
        }
        else {
            // eslint-disable-next-line no-console
            console.log('init registration form');
            setTimeout(() => { 
                initRegistrationForm(jQueryObj, BSS_B2B, shopData, isEnableRg);
                window.BSS_B2B.executeAction({ tag: `handle_register_popup`, storeId: 15447, jQueryObj, BSS_B2B, shopData, isEnableRg, initRegistrationForm: initRegistrationForm});
            }, timeoutRenderForm);
        }
    }
    // end init registration form
}








// CONCATENATED MODULE: ./js/src/hook.js
window.BSS_B2B = window.BSS_B2B || {};

function initializeHooks() {
    // window.BSS_B2B.executeAction("example.logger", "initializeHooks");
}

window.BSS_B2B.executeAction = ({tag, storeId, async, ...args}) => {
    if (typeof window.bssB2BHooks !== "undefined" && window.bssB2BHooks.actions && window.bssB2BHooks.actions[tag] && typeof window.bssB2BHooks.actions[tag] === "function") {
        if (tag && ((storeId && storeId === window.BSS_B2B.storeId) || !storeId)) {
            const callback = window.bssB2BHooks.actions[tag];
            if (typeof callback === "function") {
                if (async) {
                    return Promise.resolve(callback({ ...args }));
                } else {
                    callback({ ...args });
                }
            }
        }
    }
}

window.BSS_B2B.executeFilter = ({tag, storeId, val, async, ...args}) => {
    let result = val;
    if (typeof window.bssB2BHooks !== "undefined" && window.bssB2BHooks.filters && window.bssB2BHooks.filters[tag] && typeof window.bssB2BHooks.filters[tag] === "function") {
        if (tag && ((storeId && storeId === window.BSS_B2B.storeId) || !storeId)) {
            const callback = window.bssB2BHooks.filters[tag];
            if (typeof callback === "function") {
                if (async) {
                    Promise.resolve(callback({ ...args })).then((value) => {
                        return value
                    });
                } else {
                    result = callback({ ...args });
                }
            }
        }
    }
    return result;
}

// CONCATENATED MODULE: ./js/src/index.js



function compareVersion(v1, v2) {
    initializeHooks();
    if (typeof v1 !== 'string') return false;
    if (typeof v2 !== 'string') return false;
    v1 = v1.split('.');
    v2 = v2.split('.');
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        v1[i] = parseInt(v1[i], 10);
        v2[i] = parseInt(v2[i], 10);
        if (v1[i] > v2[i]) return 1;
        if (v1[i] < v2[i]) return -1;
    }
    return v1.length == v2.length ? 0 : (v1.length < v2.length ? -1 : 1);
}

if ((typeof jQuery === 'undefined') || (compareVersion(jQuery.fn.jquery, "1.7") == -1)) {
    // eslint-disable-next-line no-console
    console.log("Load form render");

    let jquery341 = jQuery.noConflict(true);
    window.jQuery = jquery341;
    MergeInitFunction(jquery341);

} else {
    if ([3351, 15411].includes(BSS_B2B.storeId) && window.location.pathname.includes("/pages/")) {
        window.initRF = () => { 
            // eslint-disable-next-line
            addFormRender();
            MergeInitFunction(jQuery);
        }
    }
    else MergeInitFunction(jQuery);
}


/***/ })
/******/ ]);